(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.hq.eh === region.gu.eh)
	{
		return 'on line ' + region.hq.eh;
	}
	return 'on lines ' + region.hq.eh + ' through ' + region.gu.eh;
}



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.mm,
		impl.or,
		impl.nZ,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'outerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		fq: func(record.fq),
		ht: record.ht,
		hb: record.hb
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.fq;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.ht;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.hb) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.mm,
		impl.or,
		impl.nZ,
		function(sendToApp, initialModel) {
			var view = impl.eG;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.mm,
		impl.or,
		impl.nZ,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.hn && impl.hn(sendToApp)
			var view = impl.eG;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.aA);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.oi) && (_VirtualDom_doc.title = title = doc.oi);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.m3;
	var onUrlRequest = impl.m4;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		hn: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.es === next.es
							&& curr.fi === next.fi
							&& curr.er.a === next.er.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		mm: function(flags)
		{
			return A3(impl.mm, flags, _Browser_getUrl(), key);
		},
		eG: impl.eG,
		or: impl.or,
		nZ: impl.nZ
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { mb: 'hidden', lb: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { mb: 'mozHidden', lb: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { mb: 'msHidden', lb: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { mb: 'webkitHidden', lb: 'webkitvisibilitychange' }
		: { mb: 'hidden', lb: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		jW: _Browser_getScene(),
		kx: {
			ay: _Browser_window.pageXOffset,
			bg: _Browser_window.pageYOffset,
			oy: _Browser_doc.documentElement.clientWidth,
			iK: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		oy: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		iK: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			jW: {
				oy: node.scrollWidth,
				iK: node.scrollHeight
			},
			kx: {
				ay: node.scrollLeft,
				bg: node.scrollTop,
				oy: node.clientWidth,
				iK: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			jW: _Browser_getScene(),
			kx: {
				ay: x,
				bg: y,
				oy: _Browser_doc.documentElement.clientWidth,
				iK: _Browser_doc.documentElement.clientHeight
			},
			as: {
				ay: x + rect.left,
				bg: y + rect.top,
				oy: rect.width,
				iK: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.mM) { flags += 'm'; }
	if (options.la) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}

// BYTES

function _Bytes_width(bytes)
{
	return bytes.byteLength;
}

var _Bytes_getHostEndianness = F2(function(le, be)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(new Uint8Array(new Uint32Array([1]))[0] === 1 ? le : be));
	});
});


// ENCODERS

function _Bytes_encode(encoder)
{
	var mutableBytes = new DataView(new ArrayBuffer($elm$bytes$Bytes$Encode$getWidth(encoder)));
	$elm$bytes$Bytes$Encode$write(encoder)(mutableBytes)(0);
	return mutableBytes;
}


// SIGNED INTEGERS

var _Bytes_write_i8  = F3(function(mb, i, n) { mb.setInt8(i, n); return i + 1; });
var _Bytes_write_i16 = F4(function(mb, i, n, isLE) { mb.setInt16(i, n, isLE); return i + 2; });
var _Bytes_write_i32 = F4(function(mb, i, n, isLE) { mb.setInt32(i, n, isLE); return i + 4; });


// UNSIGNED INTEGERS

var _Bytes_write_u8  = F3(function(mb, i, n) { mb.setUint8(i, n); return i + 1 ;});
var _Bytes_write_u16 = F4(function(mb, i, n, isLE) { mb.setUint16(i, n, isLE); return i + 2; });
var _Bytes_write_u32 = F4(function(mb, i, n, isLE) { mb.setUint32(i, n, isLE); return i + 4; });


// FLOATS

var _Bytes_write_f32 = F4(function(mb, i, n, isLE) { mb.setFloat32(i, n, isLE); return i + 4; });
var _Bytes_write_f64 = F4(function(mb, i, n, isLE) { mb.setFloat64(i, n, isLE); return i + 8; });


// BYTES

var _Bytes_write_bytes = F3(function(mb, offset, bytes)
{
	for (var i = 0, len = bytes.byteLength, limit = len - 4; i <= limit; i += 4)
	{
		mb.setUint32(offset + i, bytes.getUint32(i));
	}
	for (; i < len; i++)
	{
		mb.setUint8(offset + i, bytes.getUint8(i));
	}
	return offset + len;
});


// STRINGS

function _Bytes_getStringWidth(string)
{
	for (var width = 0, i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		width +=
			(code < 0x80) ? 1 :
			(code < 0x800) ? 2 :
			(code < 0xD800 || 0xDBFF < code) ? 3 : (i++, 4);
	}
	return width;
}

var _Bytes_write_string = F3(function(mb, offset, string)
{
	for (var i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		offset +=
			(code < 0x80)
				? (mb.setUint8(offset, code)
				, 1
				)
				:
			(code < 0x800)
				? (mb.setUint16(offset, 0xC080 /* 0b1100000010000000 */
					| (code >>> 6 & 0x1F /* 0b00011111 */) << 8
					| code & 0x3F /* 0b00111111 */)
				, 2
				)
				:
			(code < 0xD800 || 0xDBFF < code)
				? (mb.setUint16(offset, 0xE080 /* 0b1110000010000000 */
					| (code >>> 12 & 0xF /* 0b00001111 */) << 8
					| code >>> 6 & 0x3F /* 0b00111111 */)
				, mb.setUint8(offset + 2, 0x80 /* 0b10000000 */
					| code & 0x3F /* 0b00111111 */)
				, 3
				)
				:
			(code = (code - 0xD800) * 0x400 + string.charCodeAt(++i) - 0xDC00 + 0x10000
			, mb.setUint32(offset, 0xF0808080 /* 0b11110000100000001000000010000000 */
				| (code >>> 18 & 0x7 /* 0b00000111 */) << 24
				| (code >>> 12 & 0x3F /* 0b00111111 */) << 16
				| (code >>> 6 & 0x3F /* 0b00111111 */) << 8
				| code & 0x3F /* 0b00111111 */)
			, 4
			);
	}
	return offset;
});


// DECODER

var _Bytes_decode = F2(function(decoder, bytes)
{
	try {
		return $elm$core$Maybe$Just(A2(decoder, bytes, 0).b);
	} catch(e) {
		return $elm$core$Maybe$Nothing;
	}
});

var _Bytes_read_i8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getInt8(offset)); });
var _Bytes_read_i16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getInt16(offset, isLE)); });
var _Bytes_read_i32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getInt32(offset, isLE)); });
var _Bytes_read_u8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getUint8(offset)); });
var _Bytes_read_u16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getUint16(offset, isLE)); });
var _Bytes_read_u32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getUint32(offset, isLE)); });
var _Bytes_read_f32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getFloat32(offset, isLE)); });
var _Bytes_read_f64 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 8, bytes.getFloat64(offset, isLE)); });

var _Bytes_read_bytes = F3(function(len, bytes, offset)
{
	return _Utils_Tuple2(offset + len, new DataView(bytes.buffer, bytes.byteOffset + offset, len));
});

var _Bytes_read_string = F3(function(len, bytes, offset)
{
	var string = '';
	var end = offset + len;
	for (; offset < end;)
	{
		var byte = bytes.getUint8(offset++);
		string +=
			(byte < 128)
				? String.fromCharCode(byte)
				:
			((byte & 0xE0 /* 0b11100000 */) === 0xC0 /* 0b11000000 */)
				? String.fromCharCode((byte & 0x1F /* 0b00011111 */) << 6 | bytes.getUint8(offset++) & 0x3F /* 0b00111111 */)
				:
			((byte & 0xF0 /* 0b11110000 */) === 0xE0 /* 0b11100000 */)
				? String.fromCharCode(
					(byte & 0xF /* 0b00001111 */) << 12
					| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
					| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
				)
				:
				(byte =
					((byte & 0x7 /* 0b00000111 */) << 18
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 12
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
						| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
					) - 0x10000
				, String.fromCharCode(Math.floor(byte / 0x400) + 0xD800, byte % 0x400 + 0xDC00)
				);
	}
	return _Utils_Tuple2(offset, string);
});

var _Bytes_decodeFailure = F2(function() { throw 0; });



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.aJ.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.aJ.b, xhr)); });
		$elm$core$Maybe$isJust(request.aU) && _Http_track(router, xhr, request.aU.a);

		try {
			xhr.open(request.aO, request.aW, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.aW));
		}

		_Http_configureRequest(xhr, request);

		request.aA.a && xhr.setRequestHeader('Content-Type', request.aA.a);
		xhr.send(request.aA.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.aK; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.aS.a || 0;
	xhr.responseType = request.aJ.d;
	xhr.withCredentials = request.kM;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		aW: xhr.responseURL,
		kf: xhr.status,
		nT: xhr.statusText,
		aK: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			nK: event.loaded,
			bB: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			nn: event.loaded,
			bB: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}


function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}

var $author$project$Main$UrlChanged = function (a) {
	return {$: 40, a: a};
};
var $author$project$Main$UserClickedLink = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$List$cons = _List_cons;
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.x) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.F),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.F);
		} else {
			var treeLen = builder.x * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.L) : builder.L;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.x);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.F) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.F);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{L: nodeList, x: (len / $elm$core$Array$branchFactor) | 0, F: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {iF: fragment, fi: host, ne: path, er: port_, es: protocol, he: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $author$project$Main$GotSecurityMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Main$Initializing = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$Security$Security$AuthenticatedWithoutToken = function (a) {
	return {$: 2, a: a};
};
var $author$project$Security$Security$Failed = function (a) {
	return {$: 5, a: a};
};
var $author$project$Security$Security$SystemGotToken = function (a) {
	return {$: 1, a: a};
};
var $author$project$Security$Security$Unauthenticated = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $RomanErnst$erl$Erl$extractProtocol = function (str) {
	var parts = A2($elm$core$String$split, '://', str);
	var _v0 = $elm$core$List$length(parts);
	if (_v0 === 1) {
		return '';
	} else {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(parts));
	}
};
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {ml: index, jb: match, bX: number, nY: submatches};
	});
var $elm$regex$Regex$findAtMost = _Regex_findAtMost;
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{la: false, mM: false},
		string);
};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $RomanErnst$erl$Erl$extractPort = function (str) {
	var res = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (rx) {
				return A3($elm$regex$Regex$findAtMost, 1, rx, str);
			},
			$elm$regex$Regex$fromString(':\\d+')));
	return function (result) {
		if (!result.$) {
			var port_ = result.a;
			return port_;
		} else {
			var _v1 = $RomanErnst$erl$Erl$extractProtocol(str);
			switch (_v1) {
				case 'http':
					return 80;
				case 'https':
					return 443;
				case 'ftp':
					return 21;
				case 'sftp':
					return 22;
				default:
					return 0;
			}
		}
	}(
		$elm$core$String$toInt(
			A2(
				$elm$core$String$dropLeft,
				1,
				A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm$core$List$head(
						A2(
							$elm$core$List$map,
							function ($) {
								return $.jb;
							},
							res))))));
};
var $elm$regex$Regex$contains = _Regex_contains;
var $RomanErnst$erl$Erl$leftFromOrSame = F2(
	function (delimiter, str) {
		var parts = A2($elm$core$String$split, delimiter, str);
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(parts));
	});
var $RomanErnst$erl$Erl$rightFromOrSame = F2(
	function (delimiter, str) {
		var parts = A2($elm$core$String$split, delimiter, str);
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(
				$elm$core$List$reverse(parts)));
	});
var $RomanErnst$erl$Erl$extractHost = function (str) {
	if (A2($elm$core$String$contains, '//', str)) {
		return A2(
			$RomanErnst$erl$Erl$leftFromOrSame,
			':',
			A2(
				$RomanErnst$erl$Erl$leftFromOrSame,
				'/',
				A2($RomanErnst$erl$Erl$rightFromOrSame, '//', str)));
	} else {
		var matches = function (s) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (rx) {
						return A3($elm$regex$Regex$findAtMost, 1, rx, s);
					},
					$elm$regex$Regex$fromString('((\\w|-)+\\.)+(\\w|-)+')));
		};
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.jb;
				},
				$elm$core$List$head(
					matches(
						A2(
							$RomanErnst$erl$Erl$leftFromOrSame,
							'/',
							A2($RomanErnst$erl$Erl$rightFromOrSame, '//', str))))));
	}
};
var $elm$regex$Regex$replaceAtMost = _Regex_replaceAtMost;
var $RomanErnst$erl$Erl$extractPath = function (str) {
	var replace = F2(
		function (maybeRegex, s) {
			return A2(
				$elm$core$Maybe$withDefault,
				s,
				A2(
					$elm$core$Maybe$map,
					function (rx) {
						return A4(
							$elm$regex$Regex$replaceAtMost,
							1,
							rx,
							function (_v0) {
								return '';
							},
							s);
					},
					maybeRegex));
		});
	var host_ = $RomanErnst$erl$Erl$extractHost(str);
	return A2(
		replace,
		$elm$regex$Regex$fromString(':\\d+'),
		A2(
			replace,
			$elm$regex$Regex$fromString(host_),
			A2(
				$RomanErnst$erl$Erl$leftFromOrSame,
				'#',
				A2(
					$RomanErnst$erl$Erl$leftFromOrSame,
					'?',
					A2($RomanErnst$erl$Erl$rightFromOrSame, '//', str)))));
};
var $RomanErnst$erl$Erl$hasLeadingSlashFromAll = function (str) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (rx) {
				return A2(
					$elm$regex$Regex$contains,
					rx,
					$RomanErnst$erl$Erl$extractPath(str));
			},
			$elm$regex$Regex$fromString('^/')));
};
var $RomanErnst$erl$Erl$hasTrailingSlashFromAll = function (str) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (rx) {
				return A2(
					$elm$regex$Regex$contains,
					rx,
					$RomanErnst$erl$Erl$extractPath(str));
			},
			$elm$regex$Regex$fromString('/$')));
};
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $RomanErnst$erl$Erl$extractHash = function (str) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(
			A2(
				$elm$core$List$drop,
				1,
				A2($elm$core$String$split, '#', str))));
};
var $RomanErnst$erl$Erl$hashFromAll = function (str) {
	return $RomanErnst$erl$Erl$extractHash(str);
};
var $RomanErnst$erl$Erl$parseHost = function (str) {
	return A2($elm$core$String$split, '.', str);
};
var $RomanErnst$erl$Erl$host = function (str) {
	return $RomanErnst$erl$Erl$parseHost(
		$RomanErnst$erl$Erl$extractHost(str));
};
var $elm$core$Basics$not = _Basics_not;
var $RomanErnst$erl$Erl$notEmpty = function (str) {
	return !$elm$core$String$isEmpty(str);
};
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $RomanErnst$erl$Erl$parsePath = function (str) {
	return A2(
		$elm$core$List$map,
		$elm$core$Maybe$withDefault(''),
		A2(
			$elm$core$List$map,
			$elm$url$Url$percentDecode,
			A2(
				$elm$core$List$filter,
				$RomanErnst$erl$Erl$notEmpty,
				A2($elm$core$String$split, '/', str))));
};
var $RomanErnst$erl$Erl$pathFromAll = function (str) {
	return $RomanErnst$erl$Erl$parsePath(
		$RomanErnst$erl$Erl$extractPath(str));
};
var $RomanErnst$erl$Erl$extractQuery = function (str) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(
			A2(
				$elm$core$String$split,
				'#',
				A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm$core$List$head(
						A2(
							$elm$core$List$drop,
							1,
							A2($elm$core$String$split, '?', str)))))));
};
var $RomanErnst$erl$Erl$queryStringElementToTuple = function (element) {
	var splitted = A2($elm$core$String$split, '=', element);
	var second = A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(
			A2($elm$core$List$drop, 1, splitted)));
	var secondDecoded = A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$url$Url$percentDecode(second));
	var first = A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(splitted));
	var firstDecoded = A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$url$Url$percentDecode(first));
	return _Utils_Tuple2(firstDecoded, secondDecoded);
};
var $RomanErnst$erl$Erl$parseQuery = function (queryString) {
	var splitted = A2($elm$core$String$split, '&', queryString);
	return $elm$core$String$isEmpty(queryString) ? _List_Nil : A2($elm$core$List$map, $RomanErnst$erl$Erl$queryStringElementToTuple, splitted);
};
var $RomanErnst$erl$Erl$queryFromAll = function (all) {
	return $RomanErnst$erl$Erl$parseQuery(
		$RomanErnst$erl$Erl$extractQuery(all));
};
var $RomanErnst$erl$Erl$parse = function (str) {
	return {
		fg: $RomanErnst$erl$Erl$hasLeadingSlashFromAll(str),
		fh: $RomanErnst$erl$Erl$hasTrailingSlashFromAll(str),
		ee: $RomanErnst$erl$Erl$hashFromAll(str),
		fi: $RomanErnst$erl$Erl$host(str),
		ha: '',
		ne: $RomanErnst$erl$Erl$pathFromAll(str),
		er: $RomanErnst$erl$Erl$extractPort(str),
		es: $RomanErnst$erl$Erl$extractProtocol(str),
		he: $RomanErnst$erl$Erl$queryFromAll(str),
		os: ''
	};
};
var $RomanErnst$erl$Erl$hashToString = function (url) {
	return $elm$core$String$isEmpty(url.ee) ? '' : ('#' + url.ee);
};
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $RomanErnst$erl$Erl$hostComponent = function (url) {
	return $elm$url$Url$percentEncode(
		A2($elm$core$String$join, '.', url.fi));
};
var $RomanErnst$erl$Erl$pathComponent = function (url) {
	var leadingSlash = (($RomanErnst$erl$Erl$hostComponent(url) !== '') || url.fg) ? '/' : '';
	var encoded = A2($elm$core$List$map, $elm$url$Url$percentEncode, url.ne);
	return (!$elm$core$List$length(url.ne)) ? '' : _Utils_ap(
		leadingSlash,
		A2($elm$core$String$join, '/', encoded));
};
var $RomanErnst$erl$Erl$portComponent = function (url) {
	var _v0 = url.er;
	switch (_v0) {
		case 0:
			return '';
		case 80:
			return '';
		default:
			return ':' + $elm$core$String$fromInt(url.er);
	}
};
var $RomanErnst$erl$Erl$protocolComponent = function (url) {
	var _v0 = url.es;
	if (_v0 === '') {
		return '';
	} else {
		return url.es + '://';
	}
};
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $RomanErnst$erl$Erl$queryToString = function (url) {
	var encodedTuples = A2(
		$elm$core$List$map,
		function (_v1) {
			var x = _v1.a;
			var y = _v1.b;
			return _Utils_Tuple2(
				$elm$url$Url$percentEncode(x),
				$elm$url$Url$percentEncode(y));
		},
		url.he);
	var parts = A2(
		$elm$core$List$map,
		function (_v0) {
			var a = _v0.a;
			var b = _v0.b;
			return a + ('=' + b);
		},
		encodedTuples);
	return $elm$core$List$isEmpty(url.he) ? '' : ('?' + A2($elm$core$String$join, '&', parts));
};
var $RomanErnst$erl$Erl$trailingSlashComponent = function (url) {
	return url.fh ? '/' : '';
};
var $RomanErnst$erl$Erl$toString = function (url) {
	var trailingSlash_ = $RomanErnst$erl$Erl$trailingSlashComponent(url);
	var query_ = $RomanErnst$erl$Erl$queryToString(url);
	var protocol_ = $RomanErnst$erl$Erl$protocolComponent(url);
	var port_ = $RomanErnst$erl$Erl$portComponent(url);
	var path_ = $RomanErnst$erl$Erl$pathComponent(url);
	var host_ = $RomanErnst$erl$Erl$hostComponent(url);
	var hash = $RomanErnst$erl$Erl$hashToString(url);
	return _Utils_ap(
		protocol_,
		_Utils_ap(
			host_,
			_Utils_ap(
				port_,
				_Utils_ap(
					path_,
					_Utils_ap(
						trailingSlash_,
						_Utils_ap(query_, hash))))));
};
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.es;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.iF,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.he,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.er,
					_Utils_ap(http, url.fi)),
				url.ne)));
};
var $author$project$Security$Security$cleanedUrl = function (url) {
	var notCodeNorState = function (name) {
		return (name !== 'code') && (name !== 'state');
	};
	return A2(
		$elm$core$Maybe$withDefault,
		url,
		$elm$url$Url$fromString(
			$RomanErnst$erl$Erl$toString(
				function (original) {
					var query = original.he;
					return _Utils_update(
						original,
						{
							he: A2(
								$elm$core$List$filter,
								A2($elm$core$Basics$composeR, $elm$core$Tuple$first, notCodeNorState),
								query)
						});
				}(
					$RomanErnst$erl$Erl$parse(
						$elm$url$Url$toString(url))))));
};
var $author$project$Security$Security$ClientId = $elm$core$Basics$identity;
var $author$project$Security$Security$Config = F5(
	function (authenticationUrl, logoutUrl, tokenUrl, clientId, securityCodes) {
		return {hV: authenticationUrl, lf: clientId, i6: logoutUrl, hk: securityCodes, kq: tokenUrl};
	});
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $elm$json$Json$Decode$field = _Json_decodeField;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt = F3(
	function (path, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$at, path, valDecoder),
			decoder);
	});
var $author$project$Security$Security$SecurityCodes = F2(
	function (statePrefix, codeVerifier) {
		return {c0: codeVerifier, kc: statePrefix};
	});
var $chelovek0v$bbase64$Base64$Decode$Decoder = $elm$core$Basics$identity;
var $elm$bytes$Bytes$Encode$getWidth = function (builder) {
	switch (builder.$) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 4;
		case 3:
			return 1;
		case 4:
			return 2;
		case 5:
			return 4;
		case 6:
			return 4;
		case 7:
			return 8;
		case 8:
			var w = builder.a;
			return w;
		case 9:
			var w = builder.a;
			return w;
		default:
			var bs = builder.a;
			return _Bytes_width(bs);
	}
};
var $elm$bytes$Bytes$LE = 0;
var $elm$bytes$Bytes$Encode$write = F3(
	function (builder, mb, offset) {
		switch (builder.$) {
			case 0:
				var n = builder.a;
				return A3(_Bytes_write_i8, mb, offset, n);
			case 1:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i16, mb, offset, n, !e);
			case 2:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i32, mb, offset, n, !e);
			case 3:
				var n = builder.a;
				return A3(_Bytes_write_u8, mb, offset, n);
			case 4:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u16, mb, offset, n, !e);
			case 5:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u32, mb, offset, n, !e);
			case 6:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f32, mb, offset, n, !e);
			case 7:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f64, mb, offset, n, !e);
			case 8:
				var bs = builder.b;
				return A3($elm$bytes$Bytes$Encode$writeSequence, bs, mb, offset);
			case 9:
				var s = builder.b;
				return A3(_Bytes_write_string, mb, offset, s);
			default:
				var bs = builder.a;
				return A3(_Bytes_write_bytes, mb, offset, bs);
		}
	});
var $elm$bytes$Bytes$Encode$writeSequence = F3(
	function (builders, mb, offset) {
		writeSequence:
		while (true) {
			if (!builders.b) {
				return offset;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$builders = bs,
					$temp$mb = mb,
					$temp$offset = A3($elm$bytes$Bytes$Encode$write, b, mb, offset);
				builders = $temp$builders;
				mb = $temp$mb;
				offset = $temp$offset;
				continue writeSequence;
			}
		}
	});
var $elm$bytes$Bytes$Encode$encode = _Bytes_encode;
var $elm$bytes$Bytes$Encode$Seq = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$getWidths = F2(
	function (width, builders) {
		getWidths:
		while (true) {
			if (!builders.b) {
				return width;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$width = width + $elm$bytes$Bytes$Encode$getWidth(b),
					$temp$builders = bs;
				width = $temp$width;
				builders = $temp$builders;
				continue getWidths;
			}
		}
	});
var $elm$bytes$Bytes$Encode$sequence = function (builders) {
	return A2(
		$elm$bytes$Bytes$Encode$Seq,
		A2($elm$bytes$Bytes$Encode$getWidths, 0, builders),
		builders);
};
var $chelovek0v$bbase64$Base64$Decode$encodeBytes = function (encoders) {
	return $elm$bytes$Bytes$Encode$encode(
		$elm$bytes$Bytes$Encode$sequence(
			$elm$core$List$reverse(encoders)));
};
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $chelovek0v$bbase64$Base64$Table$charToCodeMap = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('A', 0),
			_Utils_Tuple2('B', 1),
			_Utils_Tuple2('C', 2),
			_Utils_Tuple2('D', 3),
			_Utils_Tuple2('E', 4),
			_Utils_Tuple2('F', 5),
			_Utils_Tuple2('G', 6),
			_Utils_Tuple2('H', 7),
			_Utils_Tuple2('I', 8),
			_Utils_Tuple2('J', 9),
			_Utils_Tuple2('K', 10),
			_Utils_Tuple2('L', 11),
			_Utils_Tuple2('M', 12),
			_Utils_Tuple2('N', 13),
			_Utils_Tuple2('O', 14),
			_Utils_Tuple2('P', 15),
			_Utils_Tuple2('Q', 16),
			_Utils_Tuple2('R', 17),
			_Utils_Tuple2('S', 18),
			_Utils_Tuple2('T', 19),
			_Utils_Tuple2('U', 20),
			_Utils_Tuple2('V', 21),
			_Utils_Tuple2('W', 22),
			_Utils_Tuple2('X', 23),
			_Utils_Tuple2('Y', 24),
			_Utils_Tuple2('Z', 25),
			_Utils_Tuple2('a', 26),
			_Utils_Tuple2('b', 27),
			_Utils_Tuple2('c', 28),
			_Utils_Tuple2('d', 29),
			_Utils_Tuple2('e', 30),
			_Utils_Tuple2('f', 31),
			_Utils_Tuple2('g', 32),
			_Utils_Tuple2('h', 33),
			_Utils_Tuple2('i', 34),
			_Utils_Tuple2('j', 35),
			_Utils_Tuple2('k', 36),
			_Utils_Tuple2('l', 37),
			_Utils_Tuple2('m', 38),
			_Utils_Tuple2('n', 39),
			_Utils_Tuple2('o', 40),
			_Utils_Tuple2('p', 41),
			_Utils_Tuple2('q', 42),
			_Utils_Tuple2('r', 43),
			_Utils_Tuple2('s', 44),
			_Utils_Tuple2('t', 45),
			_Utils_Tuple2('u', 46),
			_Utils_Tuple2('v', 47),
			_Utils_Tuple2('w', 48),
			_Utils_Tuple2('x', 49),
			_Utils_Tuple2('y', 50),
			_Utils_Tuple2('z', 51),
			_Utils_Tuple2('0', 52),
			_Utils_Tuple2('1', 53),
			_Utils_Tuple2('2', 54),
			_Utils_Tuple2('3', 55),
			_Utils_Tuple2('4', 56),
			_Utils_Tuple2('5', 57),
			_Utils_Tuple2('6', 58),
			_Utils_Tuple2('7', 59),
			_Utils_Tuple2('8', 60),
			_Utils_Tuple2('9', 61),
			_Utils_Tuple2('+', 62),
			_Utils_Tuple2('/', 63)
		]));
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $chelovek0v$bbase64$Base64$Table$decode = function (_char) {
	return A2(
		$elm$core$Dict$get,
		$elm$core$String$fromChar(_char),
		$chelovek0v$bbase64$Base64$Table$charToCodeMap);
};
var $chelovek0v$bbase64$Base64$Shift$Shift2 = 1;
var $chelovek0v$bbase64$Base64$Shift$Shift4 = 2;
var $chelovek0v$bbase64$Base64$Shift$Shift6 = 3;
var $chelovek0v$bbase64$Base64$Shift$Shift0 = 0;
var $chelovek0v$bbase64$Base64$Shift$decodeNext = function (shift) {
	switch (shift) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		default:
			return 0;
	}
};
var $elm$core$Bitwise$or = _Bitwise_or;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $chelovek0v$bbase64$Base64$Shift$toInt = function (shift) {
	switch (shift) {
		case 0:
			return 0;
		case 1:
			return 2;
		case 2:
			return 4;
		default:
			return 6;
	}
};
var $chelovek0v$bbase64$Base64$Shift$shiftRightZfBy = F2(
	function (shift, value) {
		return value >>> $chelovek0v$bbase64$Base64$Shift$toInt(shift);
	});
var $chelovek0v$bbase64$Base64$Decode$finishPartialByte = F3(
	function (shift, sextet, partialByte) {
		return partialByte | A2($chelovek0v$bbase64$Base64$Shift$shiftRightZfBy, shift, sextet);
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $chelovek0v$bbase64$Base64$Shift$shiftLeftBy = F2(
	function (shift, value) {
		return value << $chelovek0v$bbase64$Base64$Shift$toInt(shift);
	});
var $elm$bytes$Bytes$Encode$U8 = function (a) {
	return {$: 3, a: a};
};
var $elm$bytes$Bytes$Encode$unsignedInt8 = $elm$bytes$Bytes$Encode$U8;
var $chelovek0v$bbase64$Base64$Decode$decodeStep = F2(
	function (sextet, _v0) {
		var shift = _v0.a;
		var partialByte = _v0.b;
		var deferredEncoders = _v0.c;
		var nextBlankByte = function () {
			switch (shift) {
				case 0:
					return A2($chelovek0v$bbase64$Base64$Shift$shiftLeftBy, 1, sextet);
				case 1:
					return A2($chelovek0v$bbase64$Base64$Shift$shiftLeftBy, 2, sextet);
				case 2:
					return A2($chelovek0v$bbase64$Base64$Shift$shiftLeftBy, 3, sextet);
				default:
					return 0;
			}
		}();
		var finishedByte = function () {
			switch (shift) {
				case 0:
					return $elm$core$Maybe$Nothing;
				case 1:
					return $elm$core$Maybe$Just(
						A3($chelovek0v$bbase64$Base64$Decode$finishPartialByte, 2, sextet, partialByte));
				case 2:
					return $elm$core$Maybe$Just(
						A3($chelovek0v$bbase64$Base64$Decode$finishPartialByte, 1, sextet, partialByte));
				default:
					return $elm$core$Maybe$Just(partialByte | sextet);
			}
		}();
		var nextDeferredDecoders = function () {
			if (!finishedByte.$) {
				var byte_ = finishedByte.a;
				return A2(
					$elm$core$List$cons,
					$elm$bytes$Bytes$Encode$unsignedInt8(byte_),
					deferredEncoders);
			} else {
				return deferredEncoders;
			}
		}();
		return _Utils_Tuple3(
			$chelovek0v$bbase64$Base64$Shift$decodeNext(shift),
			nextBlankByte,
			nextDeferredDecoders);
	});
var $elm$core$String$foldl = _String_foldl;
var $chelovek0v$bbase64$Base64$Decode$initialState = _Utils_Tuple3(0, 0, _List_Nil);
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $elm$core$String$endsWith = _String_endsWith;
var $chelovek0v$bbase64$Base64$Decode$strip = function (input) {
	return A2($elm$core$String$endsWith, '==', input) ? $elm$core$Result$Ok(
		A2($elm$core$String$dropRight, 2, input)) : (A2($elm$core$String$endsWith, '=', input) ? $elm$core$Result$Ok(
		A2($elm$core$String$dropRight, 1, input)) : $elm$core$Result$Ok(input));
};
var $chelovek0v$bbase64$Base64$Decode$ValidationError = 0;
var $elm$regex$Regex$never = _Regex_never;
var $chelovek0v$bbase64$Base64$Decode$validate = function (input) {
	var regex = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('^[A-Za-z0-9\\/+]*$'));
	return A2($elm$regex$Regex$contains, regex, input) ? $elm$core$Result$Ok(input) : $elm$core$Result$Err(0);
};
var $chelovek0v$bbase64$Base64$Decode$tryDecode = function (input) {
	return A2(
		$elm$core$Result$map,
		A2(
			$elm$core$String$foldl,
			F2(
				function (_char, state) {
					return A2(
						$elm$core$Maybe$withDefault,
						state,
						A2(
							$elm$core$Maybe$map,
							function (sextet) {
								return A2($chelovek0v$bbase64$Base64$Decode$decodeStep, sextet, state);
							},
							$chelovek0v$bbase64$Base64$Table$decode(_char)));
				}),
			$chelovek0v$bbase64$Base64$Decode$initialState),
		A2(
			$elm$core$Result$andThen,
			$chelovek0v$bbase64$Base64$Decode$validate,
			$chelovek0v$bbase64$Base64$Decode$strip(input)));
};
var $chelovek0v$bbase64$Base64$Decode$bytes = function (input) {
	var _v0 = $chelovek0v$bbase64$Base64$Decode$tryDecode(input);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var deferredEncoders = _v1.c;
		return $elm$core$Result$Ok(
			$chelovek0v$bbase64$Base64$Decode$encodeBytes(deferredEncoders));
	} else {
		var e = _v0.a;
		return $elm$core$Result$Err(e);
	}
};
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$CodeVerifier = $elm$core$Basics$identity;
var $chelovek0v$bbase64$Base64$Encode$BytesEncoder = function (a) {
	return {$: 1, a: a};
};
var $chelovek0v$bbase64$Base64$Encode$bytes = function (input) {
	return $chelovek0v$bbase64$Base64$Encode$BytesEncoder(input);
};
var $elm$bytes$Bytes$width = _Bytes_width;
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$codeVerifierFromBytes = function (bytes) {
	return (($elm$bytes$Bytes$width(bytes) < 32) || ($elm$bytes$Bytes$width(bytes) > 90)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		$chelovek0v$bbase64$Base64$Encode$bytes(bytes));
};
var $chelovek0v$bbase64$Base64$Decode$decode = F2(
	function (_v0, input) {
		var decoder = _v0;
		return decoder(input);
	});
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Security$Security$codeVerifierDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (base64String) {
		var _v0 = A2($chelovek0v$bbase64$Base64$Decode$decode, $chelovek0v$bbase64$Base64$Decode$bytes, base64String);
		if (!_v0.$) {
			var bytes = _v0.a;
			var _v1 = $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$codeVerifierFromBytes(bytes);
			if (!_v1.$) {
				var codeVerifier = _v1.a;
				return $elm$json$Json$Decode$succeed(codeVerifier);
			} else {
				return $elm$json$Json$Decode$fail('unable to convert bytes to code verifier. Wrong number of bytes?');
			}
		} else {
			if (!_v0.a) {
				var _v2 = _v0.a;
				return $elm$json$Json$Decode$fail('cannot convert invalid string to code verifier');
			} else {
				var _v3 = _v0.a;
				return $elm$json$Json$Decode$fail('cannot convert invalid byte sequence to code verifier');
			}
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Security$Security$securityCodesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'code',
	$author$project$Security$Security$codeVerifierDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'statePrefix',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Security$Security$SecurityCodes)));
var $author$project$Api$Uri$urlDecoder = function () {
	var convert = function (raw) {
		var _v0 = $elm$url$Url$fromString(raw);
		if (!_v0.$) {
			var url = _v0.a;
			return $elm$json$Json$Decode$succeed(url);
		} else {
			return $elm$json$Json$Decode$fail('Unrecognizable Url');
		}
	};
	return A2($elm$json$Json$Decode$andThen, convert, $elm$json$Json$Decode$string);
}();
var $author$project$Security$Security$configDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'securityCodes',
	$author$project$Security$Security$securityCodesDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'clientId',
		A2(
			$elm$json$Json$Decode$andThen,
			A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $elm$core$Basics$identity),
			$elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['uris', 'token']),
			$author$project$Api$Uri$urlDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['uris', 'logout']),
				$author$project$Api$Uri$urlDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['uris', 'authentication']),
					$author$project$Api$Uri$urlDecoder,
					$elm$json$Json$Decode$succeed($author$project$Security$Security$Config))))));
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $author$project$Portal$Message$Error = function (a) {
	return {$: 0, a: a};
};
var $author$project$Portal$Message$error = F2(
	function (m, details) {
		return $author$project$Portal$Message$Error(
			{lE: details, fq: m});
	});
var $truqu$elm_oauth2$OAuth$errorCodeToString = function (err) {
	switch (err.$) {
		case 0:
			return 'invalid_request';
		case 1:
			return 'unauthorized_client';
		case 2:
			return 'access_denied';
		case 3:
			return 'unsupported_response_type';
		case 4:
			return 'invalid_scope';
		case 5:
			return 'server_error';
		case 6:
			return 'temporarily_unavailable';
		default:
			var str = err.a;
			return str;
	}
};
var $author$project$Security$ApplicationState$ApplicationState = $elm$core$Basics$identity;
var $chelovek0v$bbase64$Base64$Decode$InvalidByteSequence = 1;
var $elm$bytes$Bytes$Decode$decode = F2(
	function (_v0, bs) {
		var decoder = _v0;
		return A2(_Bytes_decode, decoder, bs);
	});
var $elm$bytes$Bytes$Decode$Decoder = $elm$core$Basics$identity;
var $elm$bytes$Bytes$Decode$string = function (n) {
	return _Bytes_read_string(n);
};
var $chelovek0v$bbase64$Base64$Decode$tryToString = function (input) {
	var _v0 = A2(
		$elm$bytes$Bytes$Decode$decode,
		$elm$bytes$Bytes$Decode$string(
			$elm$bytes$Bytes$width(input)),
		input);
	if (!_v0.$) {
		var str = _v0.a;
		return $elm$core$Result$Ok(str);
	} else {
		return $elm$core$Result$Err(1);
	}
};
var $chelovek0v$bbase64$Base64$Decode$string = function (input) {
	var _v0 = $chelovek0v$bbase64$Base64$Decode$tryDecode(input);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var deferredEncoders = _v1.c;
		return $chelovek0v$bbase64$Base64$Decode$tryToString(
			$chelovek0v$bbase64$Base64$Decode$encodeBytes(deferredEncoders));
	} else {
		var e = _v0.a;
		return $elm$core$Result$Err(e);
	}
};
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$String$trimRight = _String_trimRight;
var $author$project$Security$ApplicationState$fromEncrypted = F2(
	function (_v0, encryptedState) {
		var statePrefix = _v0.kc;
		return A2($elm$core$String$startsWith, statePrefix, encryptedState) ? function (base64String) {
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$identity,
				A2(
					$elm$core$Maybe$map,
					$elm$core$String$trimRight,
					$elm$core$Result$toMaybe(
						A2($chelovek0v$bbase64$Base64$Decode$decode, $chelovek0v$bbase64$Base64$Decode$string, base64String))));
		}(
			A2(
				$elm$core$String$dropLeft,
				$elm$core$String$length(statePrefix),
				encryptedState)) : $elm$core$Maybe$Nothing;
	});
var $author$project$Security$ApplicationState$fromUrl = function (url) {
	return A2($elm$core$Maybe$withDefault, '', url.iF);
};
var $truqu$elm_oauth2$OAuth$AuthorizationCode = {$: 0};
var $truqu$elm_oauth2$Internal$AuthenticationSuccess = F4(
	function (token, refreshToken, expiresIn, scope) {
		return {gx: expiresIn, bv: refreshToken, hj: scope, aT: token};
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $truqu$elm_oauth2$Internal$expiresInDecoder = $elm$json$Json$Decode$maybe(
	A2($elm$json$Json$Decode$field, 'expires_in', $elm$json$Json$Decode$int));
var $elm$json$Json$Decode$map4 = _Json_map4;
var $truqu$elm_oauth2$Internal$decoderFromJust = function (msg) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
		$elm$core$Maybe$withDefault(
			$elm$json$Json$Decode$fail(msg)));
};
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $truqu$elm_oauth2$Extra$Maybe$andThen2 = F3(
	function (fn, ma, mb) {
		return A2(
			$elm$core$Maybe$andThen,
			$elm$core$Basics$identity,
			A3($elm$core$Maybe$map2, fn, ma, mb));
	});
var $truqu$elm_oauth2$OAuth$Bearer = $elm$core$Basics$identity;
var $elm$core$String$toLower = _String_toLower;
var $truqu$elm_oauth2$OAuth$tryMakeToken = F2(
	function (tokenType, token) {
		var _v0 = $elm$core$String$toLower(tokenType);
		if (_v0 === 'bearer') {
			return $elm$core$Maybe$Just(token);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $truqu$elm_oauth2$OAuth$makeRefreshToken = F2(
	function (tokenType, mToken) {
		var _v0 = _Utils_Tuple2(
			mToken,
			A3(
				$truqu$elm_oauth2$Extra$Maybe$andThen2,
				$truqu$elm_oauth2$OAuth$tryMakeToken,
				$elm$core$Maybe$Just(tokenType),
				mToken));
		if (_v0.a.$ === 1) {
			var _v1 = _v0.a;
			return $elm$core$Maybe$Just($elm$core$Maybe$Nothing);
		} else {
			if (!_v0.b.$) {
				var token = _v0.b.a;
				return $elm$core$Maybe$Just(
					$elm$core$Maybe$Just(token));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $truqu$elm_oauth2$Internal$refreshTokenDecoder = A2(
	$elm$json$Json$Decode$andThen,
	$truqu$elm_oauth2$Internal$decoderFromJust('missing or invalid \'refresh_token\' / \'token_type\''),
	A3(
		$elm$json$Json$Decode$map2,
		$truqu$elm_oauth2$OAuth$makeRefreshToken,
		A2($elm$json$Json$Decode$field, 'token_type', $elm$json$Json$Decode$string),
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'refresh_token', $elm$json$Json$Decode$string))));
var $elm$json$Json$Decode$list = _Json_decodeList;
var $truqu$elm_oauth2$Internal$scopeDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Maybe$withDefault(_List_Nil),
	$elm$json$Json$Decode$maybe(
		A2(
			$elm$json$Json$Decode$field,
			'scope',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string))));
var $truqu$elm_oauth2$OAuth$makeToken = $truqu$elm_oauth2$Extra$Maybe$andThen2($truqu$elm_oauth2$OAuth$tryMakeToken);
var $truqu$elm_oauth2$Internal$tokenDecoder = A2(
	$elm$json$Json$Decode$andThen,
	$truqu$elm_oauth2$Internal$decoderFromJust('missing or invalid \'access_token\' / \'token_type\''),
	A3(
		$elm$json$Json$Decode$map2,
		$truqu$elm_oauth2$OAuth$makeToken,
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$Just,
			A2($elm$json$Json$Decode$field, 'token_type', $elm$json$Json$Decode$string)),
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$Just,
			A2($elm$json$Json$Decode$field, 'access_token', $elm$json$Json$Decode$string))));
var $truqu$elm_oauth2$Internal$authenticationSuccessDecoder = A5($elm$json$Json$Decode$map4, $truqu$elm_oauth2$Internal$AuthenticationSuccess, $truqu$elm_oauth2$Internal$tokenDecoder, $truqu$elm_oauth2$Internal$refreshTokenDecoder, $truqu$elm_oauth2$Internal$expiresInDecoder, $truqu$elm_oauth2$Internal$scopeDecoder);
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$defaultAuthenticationSuccessDecoder = $truqu$elm_oauth2$Internal$authenticationSuccessDecoder;
var $elm$bytes$Bytes$Encode$Utf8 = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$string = function (str) {
	return A2(
		$elm$bytes$Bytes$Encode$Utf8,
		_Bytes_getStringWidth(str),
		str);
};
var $elm$bytes$Bytes$Decode$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$bytes$Bytes$Decode$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $chelovek0v$bbase64$Base64$Shift$and = F2(
	function (shift, value) {
		switch (shift) {
			case 0:
				return value;
			case 1:
				return 3 & value;
			case 2:
				return 15 & value;
			default:
				return 63 & value;
		}
	});
var $chelovek0v$bbase64$Base64$Table$codeToCharMap = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(0, 'A'),
			_Utils_Tuple2(1, 'B'),
			_Utils_Tuple2(2, 'C'),
			_Utils_Tuple2(3, 'D'),
			_Utils_Tuple2(4, 'E'),
			_Utils_Tuple2(5, 'F'),
			_Utils_Tuple2(6, 'G'),
			_Utils_Tuple2(7, 'H'),
			_Utils_Tuple2(8, 'I'),
			_Utils_Tuple2(9, 'J'),
			_Utils_Tuple2(10, 'K'),
			_Utils_Tuple2(11, 'L'),
			_Utils_Tuple2(12, 'M'),
			_Utils_Tuple2(13, 'N'),
			_Utils_Tuple2(14, 'O'),
			_Utils_Tuple2(15, 'P'),
			_Utils_Tuple2(16, 'Q'),
			_Utils_Tuple2(17, 'R'),
			_Utils_Tuple2(18, 'S'),
			_Utils_Tuple2(19, 'T'),
			_Utils_Tuple2(20, 'U'),
			_Utils_Tuple2(21, 'V'),
			_Utils_Tuple2(22, 'W'),
			_Utils_Tuple2(23, 'X'),
			_Utils_Tuple2(24, 'Y'),
			_Utils_Tuple2(25, 'Z'),
			_Utils_Tuple2(26, 'a'),
			_Utils_Tuple2(27, 'b'),
			_Utils_Tuple2(28, 'c'),
			_Utils_Tuple2(29, 'd'),
			_Utils_Tuple2(30, 'e'),
			_Utils_Tuple2(31, 'f'),
			_Utils_Tuple2(32, 'g'),
			_Utils_Tuple2(33, 'h'),
			_Utils_Tuple2(34, 'i'),
			_Utils_Tuple2(35, 'j'),
			_Utils_Tuple2(36, 'k'),
			_Utils_Tuple2(37, 'l'),
			_Utils_Tuple2(38, 'm'),
			_Utils_Tuple2(39, 'n'),
			_Utils_Tuple2(40, 'o'),
			_Utils_Tuple2(41, 'p'),
			_Utils_Tuple2(42, 'q'),
			_Utils_Tuple2(43, 'r'),
			_Utils_Tuple2(44, 's'),
			_Utils_Tuple2(45, 't'),
			_Utils_Tuple2(46, 'u'),
			_Utils_Tuple2(47, 'v'),
			_Utils_Tuple2(48, 'w'),
			_Utils_Tuple2(49, 'x'),
			_Utils_Tuple2(50, 'y'),
			_Utils_Tuple2(51, 'z'),
			_Utils_Tuple2(52, '0'),
			_Utils_Tuple2(53, '1'),
			_Utils_Tuple2(54, '2'),
			_Utils_Tuple2(55, '3'),
			_Utils_Tuple2(56, '4'),
			_Utils_Tuple2(57, '5'),
			_Utils_Tuple2(58, '6'),
			_Utils_Tuple2(59, '7'),
			_Utils_Tuple2(60, '8'),
			_Utils_Tuple2(61, '9'),
			_Utils_Tuple2(62, '+'),
			_Utils_Tuple2(63, '/')
		]));
var $chelovek0v$bbase64$Base64$Table$encode = function (code) {
	var _v0 = A2($elm$core$Dict$get, code, $chelovek0v$bbase64$Base64$Table$codeToCharMap);
	if (!_v0.$) {
		var char_ = _v0.a;
		return char_;
	} else {
		return '';
	}
};
var $chelovek0v$bbase64$Base64$Shift$next = function (shift) {
	switch (shift) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		default:
			return 1;
	}
};
var $chelovek0v$bbase64$Base64$Encode$sixtet = F2(
	function (octet, _v0) {
		var shift = _v0.a;
		var sixtet_ = _v0.b;
		var strAcc = _v0.c;
		switch (shift) {
			case 0:
				return A2($chelovek0v$bbase64$Base64$Shift$shiftRightZfBy, 1, octet);
			case 1:
				return A2($chelovek0v$bbase64$Base64$Shift$shiftLeftBy, 2, sixtet_) | A2($chelovek0v$bbase64$Base64$Shift$shiftRightZfBy, 2, octet);
			case 2:
				return A2($chelovek0v$bbase64$Base64$Shift$shiftLeftBy, 1, sixtet_) | A2($chelovek0v$bbase64$Base64$Shift$shiftRightZfBy, 3, octet);
			default:
				return sixtet_;
		}
	});
var $chelovek0v$bbase64$Base64$Encode$encodeStep = F2(
	function (octet, encodeState) {
		var shift = encodeState.a;
		var strAcc = encodeState.c;
		var nextSixtet = function () {
			switch (shift) {
				case 0:
					return A2($chelovek0v$bbase64$Base64$Shift$and, 1, octet);
				case 1:
					return A2($chelovek0v$bbase64$Base64$Shift$and, 2, octet);
				case 2:
					return A2($chelovek0v$bbase64$Base64$Shift$and, 3, octet);
				default:
					return A2($chelovek0v$bbase64$Base64$Shift$and, 1, octet);
			}
		}();
		var currentSixtet = A2($chelovek0v$bbase64$Base64$Encode$sixtet, octet, encodeState);
		var base64Char = function () {
			if (shift === 3) {
				return _Utils_ap(
					$chelovek0v$bbase64$Base64$Table$encode(currentSixtet),
					$chelovek0v$bbase64$Base64$Table$encode(
						A2($chelovek0v$bbase64$Base64$Shift$shiftRightZfBy, 1, octet)));
			} else {
				return $chelovek0v$bbase64$Base64$Table$encode(currentSixtet);
			}
		}();
		return _Utils_Tuple3(
			$chelovek0v$bbase64$Base64$Shift$next(shift),
			nextSixtet,
			_Utils_ap(strAcc, base64Char));
	});
var $elm$bytes$Bytes$Decode$map = F2(
	function (func, _v0) {
		var decodeA = _v0;
		return F2(
			function (bites, offset) {
				var _v1 = A2(decodeA, bites, offset);
				var aOffset = _v1.a;
				var a = _v1.b;
				return _Utils_Tuple2(
					aOffset,
					func(a));
			});
	});
var $elm$bytes$Bytes$Decode$succeed = function (a) {
	return F2(
		function (_v0, offset) {
			return _Utils_Tuple2(offset, a);
		});
};
var $chelovek0v$bbase64$Base64$Encode$decodeStep = F2(
	function (octetDecoder, _v0) {
		var n = _v0.a;
		var encodeState = _v0.b;
		return (n <= 0) ? $elm$bytes$Bytes$Decode$succeed(
			$elm$bytes$Bytes$Decode$Done(encodeState)) : A2(
			$elm$bytes$Bytes$Decode$map,
			function (octet) {
				return $elm$bytes$Bytes$Decode$Loop(
					_Utils_Tuple2(
						n - 1,
						A2($chelovek0v$bbase64$Base64$Encode$encodeStep, octet, encodeState)));
			},
			octetDecoder);
	});
var $chelovek0v$bbase64$Base64$Encode$finalize = function (_v0) {
	var shift = _v0.a;
	var sixtet_ = _v0.b;
	var strAcc = _v0.c;
	switch (shift) {
		case 3:
			return _Utils_ap(
				strAcc,
				$chelovek0v$bbase64$Base64$Table$encode(sixtet_));
		case 2:
			return strAcc + ($chelovek0v$bbase64$Base64$Table$encode(
				A2($chelovek0v$bbase64$Base64$Shift$shiftLeftBy, 1, sixtet_)) + '=');
		case 1:
			return strAcc + ($chelovek0v$bbase64$Base64$Table$encode(
				A2($chelovek0v$bbase64$Base64$Shift$shiftLeftBy, 2, sixtet_)) + '==');
		default:
			return strAcc;
	}
};
var $chelovek0v$bbase64$Base64$Encode$initialEncodeState = _Utils_Tuple3(0, 0, '');
var $elm$bytes$Bytes$Decode$loopHelp = F4(
	function (state, callback, bites, offset) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var decoder = _v0;
			var _v1 = A2(decoder, bites, offset);
			var newOffset = _v1.a;
			var step = _v1.b;
			if (!step.$) {
				var newState = step.a;
				var $temp$state = newState,
					$temp$callback = callback,
					$temp$bites = bites,
					$temp$offset = newOffset;
				state = $temp$state;
				callback = $temp$callback;
				bites = $temp$bites;
				offset = $temp$offset;
				continue loopHelp;
			} else {
				var result = step.a;
				return _Utils_Tuple2(newOffset, result);
			}
		}
	});
var $elm$bytes$Bytes$Decode$loop = F2(
	function (state, callback) {
		return A2($elm$bytes$Bytes$Decode$loopHelp, state, callback);
	});
var $elm$bytes$Bytes$Decode$unsignedInt8 = _Bytes_read_u8;
var $chelovek0v$bbase64$Base64$Encode$tryEncode = function (input) {
	var decoderInitialState = _Utils_Tuple2(
		$elm$bytes$Bytes$width(input),
		$chelovek0v$bbase64$Base64$Encode$initialEncodeState);
	var base64Decoder = A2(
		$elm$bytes$Bytes$Decode$loop,
		decoderInitialState,
		$chelovek0v$bbase64$Base64$Encode$decodeStep($elm$bytes$Bytes$Decode$unsignedInt8));
	return A2(
		$elm$core$Maybe$map,
		$chelovek0v$bbase64$Base64$Encode$finalize,
		A2($elm$bytes$Bytes$Decode$decode, base64Decoder, input));
};
var $chelovek0v$bbase64$Base64$Encode$encode = function (encoder) {
	if (!encoder.$) {
		var input = encoder.a;
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			$chelovek0v$bbase64$Base64$Encode$tryEncode(
				$elm$bytes$Bytes$Encode$encode(
					$elm$bytes$Bytes$Encode$string(input))));
	} else {
		var input = encoder.a;
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			$chelovek0v$bbase64$Base64$Encode$tryEncode(input));
	}
};
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$base64UrlEncode = A2(
	$elm$core$Basics$composeR,
	$chelovek0v$bbase64$Base64$Encode$encode,
	A2(
		$elm$core$Basics$composeR,
		A2($elm$core$String$replace, '=', ''),
		A2(
			$elm$core$Basics$composeR,
			A2($elm$core$String$replace, '+', '-'),
			A2($elm$core$String$replace, '/', '_'))));
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$codeVerifierToString = function (_v0) {
	var str = _v0;
	return $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$base64UrlEncode(str);
};
var $truqu$elm_oauth2$OAuth$grantTypeToString = function (g) {
	switch (g.$) {
		case 0:
			return 'authorization_code';
		case 1:
			return 'password';
		case 2:
			return 'client_credentials';
		case 3:
			return 'refresh_token';
		default:
			var str = g.a;
			return str;
	}
};
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $chelovek0v$bbase64$Base64$Encode$StringEncoder = function (a) {
	return {$: 0, a: a};
};
var $chelovek0v$bbase64$Base64$Encode$string = function (input) {
	return $chelovek0v$bbase64$Base64$Encode$StringEncoder(input);
};
var $truqu$elm_oauth2$Internal$makeHeaders = function (credentials) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (s) {
				return _List_fromArray(
					[
						A2($elm$http$Http$header, 'Authorization', 'Basic ' + s)
					]);
			},
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var clientId = _v0.lf;
					var secret = _v0.nG;
					return $chelovek0v$bbase64$Base64$Encode$encode(
						$chelovek0v$bbase64$Base64$Encode$string(clientId + (':' + secret)));
				},
				credentials)));
};
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $truqu$elm_oauth2$Internal$protocolToString = function (protocol) {
	if (!protocol) {
		return 'http';
	} else {
		return 'https';
	}
};
var $truqu$elm_oauth2$Internal$makeRedirectUri = function (url) {
	return $elm$core$String$concat(
		_List_fromArray(
			[
				$truqu$elm_oauth2$Internal$protocolToString(url.es),
				'://',
				url.fi,
				A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function (i) {
						return ':' + $elm$core$String$fromInt(i);
					},
					url.er)),
				url.ne,
				A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function (q) {
						return '?' + q;
					},
					url.he))
			]));
};
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.kf));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $elm$http$Http$stringBody = _Http_pair;
var $truqu$elm_oauth2$Internal$makeRequest = F5(
	function (decoder, toMsg, url, headers, body) {
		return {
			aA: A2($elm$http$Http$stringBody, 'application/x-www-form-urlencoded', body),
			aJ: A2($elm$http$Http$expectJson, toMsg, decoder),
			aK: headers,
			aO: 'POST',
			aS: $elm$core$Maybe$Nothing,
			aU: $elm$core$Maybe$Nothing,
			aW: $elm$url$Url$toString(url)
		};
	});
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $truqu$elm_oauth2$Internal$urlAddExtraFields = F2(
	function (extraFields, zero) {
		return A3(
			$elm$core$Dict$foldr,
			F3(
				function (k, v, qs) {
					return A2(
						$elm$core$List$cons,
						A2($elm$url$Url$Builder$string, k, v),
						qs);
				}),
			zero,
			extraFields);
	});
var $truqu$elm_oauth2$OAuth$AuthorizationCode$makeTokenRequestWith = F5(
	function (grantType, decoder, extraFields, toMsg, _v0) {
		var credentials = _v0.lt;
		var code = _v0.ge;
		var url = _v0.aW;
		var redirectUri = _v0.jM;
		var headers = $truqu$elm_oauth2$Internal$makeHeaders(
			function () {
				var _v1 = credentials.nG;
				if (_v1.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var secret = _v1.a;
					return $elm$core$Maybe$Just(
						{lf: credentials.lf, nG: secret});
				}
			}());
		var body = A2(
			$elm$core$String$dropLeft,
			1,
			$elm$url$Url$Builder$toQuery(
				A2(
					$truqu$elm_oauth2$Internal$urlAddExtraFields,
					extraFields,
					_List_fromArray(
						[
							A2(
							$elm$url$Url$Builder$string,
							'grant_type',
							$truqu$elm_oauth2$OAuth$grantTypeToString(grantType)),
							A2($elm$url$Url$Builder$string, 'client_id', credentials.lf),
							A2(
							$elm$url$Url$Builder$string,
							'redirect_uri',
							$truqu$elm_oauth2$Internal$makeRedirectUri(redirectUri)),
							A2($elm$url$Url$Builder$string, 'code', code)
						]))));
		return A5($truqu$elm_oauth2$Internal$makeRequest, decoder, toMsg, url, headers, body);
	});
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$makeTokenRequestWith = F5(
	function (grantType, decoder, extraFields, toMsg, _v0) {
		var credentials = _v0.lt;
		var code = _v0.ge;
		var codeVerifier = _v0.c0;
		var url = _v0.aW;
		var redirectUri = _v0.jM;
		var extraInternalFields = $elm$core$Dict$fromList(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'code_verifier',
					$truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$codeVerifierToString(codeVerifier))
				]));
		return A5(
			$truqu$elm_oauth2$OAuth$AuthorizationCode$makeTokenRequestWith,
			grantType,
			decoder,
			A2($elm$core$Dict$union, extraFields, extraInternalFields),
			toMsg,
			{ge: code, lt: credentials, jM: redirectUri, aW: url});
	});
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$makeTokenRequest = A3($truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$makeTokenRequestWith, $truqu$elm_oauth2$OAuth$AuthorizationCode, $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$defaultAuthenticationSuccessDecoder, $elm$core$Dict$empty);
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {jQ: reqs, ki: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.aU;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.jQ));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.ki)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					kM: r.kM,
					aA: r.aA,
					aJ: A2(_Http_mapExpect, func, r.aJ),
					aK: r.aK,
					aO: r.aO,
					aS: r.aS,
					aU: r.aU,
					aW: r.aW
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{kM: false, aA: r.aA, aJ: r.aJ, aK: r.aK, aO: r.aO, aS: r.aS, aU: r.aU, aW: r.aW}));
};
var $author$project$Security$Security$getTokenCmd = F4(
	function (_v0, redirectUri, code, toMsg) {
		var tokenUrl = _v0.kq;
		var clientId = _v0.lf;
		var securityCodes = _v0.hk;
		var _v1 = clientId;
		var clId = _v1;
		return $elm$http$Http$request(
			A2(
				$truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$makeTokenRequest,
				toMsg,
				{
					ge: code,
					c0: securityCodes.c0,
					lt: {lf: clId, nG: $elm$core$Maybe$Nothing},
					jM: redirectUri,
					aW: tokenUrl
				}));
	});
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $truqu$elm_oauth2$Internal$AuthorizationError = F4(
	function (error, errorDescription, errorUri, state) {
		return {lP: error, lQ: errorDescription, iz: errorUri, b4: state};
	});
var $elm$url$Url$Parser$Internal$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$Query$custom = F2(
	function (key, func) {
		return function (dict) {
			return func(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Dict$get, key, dict)));
		};
	});
var $elm$url$Url$Parser$Query$string = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$Maybe$Just(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $truqu$elm_oauth2$Internal$errorDescriptionParser = $elm$url$Url$Parser$Query$string('error_description');
var $truqu$elm_oauth2$Internal$errorUriParser = $elm$url$Url$Parser$Query$string('error_uri');
var $elm$url$Url$Parser$Query$map3 = F4(
	function (func, _v0, _v1, _v2) {
		var a = _v0;
		var b = _v1;
		var c = _v2;
		return function (dict) {
			return A3(
				func,
				a(dict),
				b(dict),
				c(dict));
		};
	});
var $truqu$elm_oauth2$Internal$stateParser = $elm$url$Url$Parser$Query$string('state');
var $truqu$elm_oauth2$Internal$authorizationErrorParser = function (errorCode) {
	return A4(
		$elm$url$Url$Parser$Query$map3,
		$truqu$elm_oauth2$Internal$AuthorizationError(errorCode),
		$truqu$elm_oauth2$Internal$errorDescriptionParser,
		$truqu$elm_oauth2$Internal$errorUriParser,
		$truqu$elm_oauth2$Internal$stateParser);
};
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$defaultAuthorizationErrorParser = $truqu$elm_oauth2$Internal$authorizationErrorParser;
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$AuthorizationSuccess = F2(
	function (code, state) {
		return {ge: code, b4: state};
	});
var $elm$url$Url$Parser$Query$map = F2(
	function (func, _v0) {
		var a = _v0;
		return function (dict) {
			return func(
				a(dict));
		};
	});
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$defaultAuthorizationSuccessParser = function (code) {
	return A2(
		$elm$url$Url$Parser$Query$map,
		$truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$AuthorizationSuccess(code),
		$truqu$elm_oauth2$Internal$stateParser);
};
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$defaultCodeParser = $elm$url$Url$Parser$Query$string('code');
var $truqu$elm_oauth2$OAuth$AccessDenied = {$: 2};
var $truqu$elm_oauth2$OAuth$Custom = function (a) {
	return {$: 7, a: a};
};
var $truqu$elm_oauth2$OAuth$InvalidRequest = {$: 0};
var $truqu$elm_oauth2$OAuth$InvalidScope = {$: 4};
var $truqu$elm_oauth2$OAuth$ServerError = {$: 5};
var $truqu$elm_oauth2$OAuth$TemporarilyUnavailable = {$: 6};
var $truqu$elm_oauth2$OAuth$UnauthorizedClient = {$: 1};
var $truqu$elm_oauth2$OAuth$UnsupportedResponseType = {$: 3};
var $truqu$elm_oauth2$OAuth$errorCodeFromString = function (str) {
	switch (str) {
		case 'invalid_request':
			return $truqu$elm_oauth2$OAuth$InvalidRequest;
		case 'unauthorized_client':
			return $truqu$elm_oauth2$OAuth$UnauthorizedClient;
		case 'access_denied':
			return $truqu$elm_oauth2$OAuth$AccessDenied;
		case 'unsupported_response_type':
			return $truqu$elm_oauth2$OAuth$UnsupportedResponseType;
		case 'invalid_scope':
			return $truqu$elm_oauth2$OAuth$InvalidScope;
		case 'server_error':
			return $truqu$elm_oauth2$OAuth$ServerError;
		case 'temporarily_unavailable':
			return $truqu$elm_oauth2$OAuth$TemporarilyUnavailable;
		default:
			return $truqu$elm_oauth2$OAuth$Custom(str);
	}
};
var $truqu$elm_oauth2$Internal$errorParser = function (errorCodeFromString) {
	return A2(
		$elm$url$Url$Parser$Query$map,
		$elm$core$Maybe$map(errorCodeFromString),
		$elm$url$Url$Parser$Query$string('error'));
};
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$defaultErrorParser = $truqu$elm_oauth2$Internal$errorParser($truqu$elm_oauth2$OAuth$errorCodeFromString);
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$defaultParsers = {f7: $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$defaultAuthorizationErrorParser, f8: $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$defaultAuthorizationSuccessParser, gf: $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$defaultCodeParser, gv: $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$defaultErrorParser};
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$Empty = {$: 0};
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$Error = function (a) {
	return {$: 1, a: a};
};
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$Success = function (a) {
	return {$: 2, a: a};
};
var $truqu$elm_oauth2$OAuth$AuthorizationCode$Empty = {$: 0};
var $truqu$elm_oauth2$OAuth$AuthorizationCode$Error = function (a) {
	return {$: 1, a: a};
};
var $truqu$elm_oauth2$OAuth$AuthorizationCode$Success = function (a) {
	return {$: 2, a: a};
};
var $elm$url$Url$Parser$Query$map2 = F3(
	function (func, _v0, _v1) {
		var a = _v0;
		var b = _v1;
		return function (dict) {
			return A2(
				func,
				a(dict),
				b(dict));
		};
	});
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {cn: frag, cw: params, b8: unvisited, kt: value, cR: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.b8;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.kt);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.kt);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.ne),
					$elm$url$Url$Parser$prepareQuery(url.he),
					url.iF,
					$elm$core$Basics$identity)));
	});
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$query = function (_v0) {
	var queryParser = _v0;
	return function (_v1) {
		var visited = _v1.cR;
		var unvisited = _v1.b8;
		var params = _v1.cw;
		var frag = _v1.cn;
		var value = _v1.kt;
		return _List_fromArray(
			[
				A5(
				$elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					queryParser(params)))
			]);
	};
};
var $truqu$elm_oauth2$Internal$parseUrlQuery = F3(
	function (url, def, parser) {
		return A2(
			$elm$core$Maybe$withDefault,
			def,
			A2(
				$elm$url$Url$Parser$parse,
				$elm$url$Url$Parser$query(parser),
				url));
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$questionMark = F2(
	function (parser, queryParser) {
		return A2(
			$elm$url$Url$Parser$slash,
			parser,
			$elm$url$Url$Parser$query(queryParser));
	});
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $truqu$elm_oauth2$OAuth$AuthorizationCode$parseCodeWith = F2(
	function (_v0, url_) {
		var codeParser = _v0.gf;
		var errorParser = _v0.gv;
		var authorizationSuccessParser = _v0.f8;
		var authorizationErrorParser = _v0.f7;
		var url = _Utils_update(
			url_,
			{ne: '/'});
		var _v1 = A2(
			$elm$url$Url$Parser$parse,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$top,
				A3($elm$url$Url$Parser$Query$map2, $elm$core$Tuple$pair, codeParser, errorParser)),
			url);
		_v1$2:
		while (true) {
			if (!_v1.$) {
				if (!_v1.a.a.$) {
					var _v2 = _v1.a;
					var code = _v2.a.a;
					return A3(
						$truqu$elm_oauth2$Internal$parseUrlQuery,
						url,
						$truqu$elm_oauth2$OAuth$AuthorizationCode$Empty,
						A2(
							$elm$url$Url$Parser$Query$map,
							$truqu$elm_oauth2$OAuth$AuthorizationCode$Success,
							authorizationSuccessParser(code)));
				} else {
					if (!_v1.a.b.$) {
						var _v3 = _v1.a;
						var error = _v3.b.a;
						return A3(
							$truqu$elm_oauth2$Internal$parseUrlQuery,
							url,
							$truqu$elm_oauth2$OAuth$AuthorizationCode$Empty,
							A2(
								$elm$url$Url$Parser$Query$map,
								$truqu$elm_oauth2$OAuth$AuthorizationCode$Error,
								authorizationErrorParser(error)));
					} else {
						break _v1$2;
					}
				}
			} else {
				break _v1$2;
			}
		}
		return $truqu$elm_oauth2$OAuth$AuthorizationCode$Empty;
	});
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$parseCodeWith = F2(
	function (parsers, url) {
		var _v0 = A2($truqu$elm_oauth2$OAuth$AuthorizationCode$parseCodeWith, parsers, url);
		switch (_v0.$) {
			case 0:
				return $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$Empty;
			case 2:
				var s = _v0.a;
				return $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$Success(s);
			default:
				var e = _v0.a;
				return $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$Error(e);
		}
	});
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$parseCode = $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$parseCodeWith($truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$defaultParsers);
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Ports$refreshSecurityCodes = _Platform_outgoingPort(
	'refreshSecurityCodes',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Security$Security$signInStep1 = $author$project$Ports$refreshSecurityCodes(0);
var $author$project$Security$ApplicationState$urlUpdatedWith = F2(
	function (_v0, url) {
		var state = _v0;
		return _Utils_update(
			url,
			{
				iF: $elm$core$Maybe$Just(state)
			});
	});
var $author$project$Security$Security$init = F2(
	function (flags, url) {
		var redirectUri = _Utils_update(
			url,
			{iF: $elm$core$Maybe$Nothing, he: $elm$core$Maybe$Nothing});
		var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Security$Security$configDecoder, flags);
		if (!_v0.$) {
			var config = _v0.a;
			var uris = {f6: config.hV, gQ: config.i6, fH: redirectUri};
			var _v1 = $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$parseCode(url);
			switch (_v1.$) {
				case 0:
					return _Utils_Tuple3(
						$author$project$Security$Security$Unauthenticated(
							{
								lf: config.lf,
								b4: $author$project$Security$ApplicationState$fromUrl(url),
								Z: uris
							}),
						$author$project$Security$Security$signInStep1,
						url);
				case 2:
					var code = _v1.a.ge;
					var state = _v1.a.b4;
					var _v2 = A2(
						$elm$core$Maybe$andThen,
						$author$project$Security$ApplicationState$fromEncrypted(config.hk),
						state);
					if (!_v2.$) {
						var applicationState = _v2.a;
						return _Utils_Tuple3(
							$author$project$Security$Security$AuthenticatedWithoutToken(
								{lf: config.lf, Z: uris}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A4($author$project$Security$Security$getTokenCmd, config, redirectUri, code, $author$project$Security$Security$SystemGotToken)
									])),
							A2(
								$author$project$Security$ApplicationState$urlUpdatedWith,
								applicationState,
								$author$project$Security$Security$cleanedUrl(url)));
					} else {
						return _Utils_Tuple3(
							$author$project$Security$Security$Failed(
								A2(
									$author$project$Portal$Message$error,
									'Er is een security probleem! Gegevens inladen onmogelijk.',
									$elm$core$Maybe$Just('Applicatie status ongeldig.'))),
							$elm$core$Platform$Cmd$none,
							url);
					}
				default:
					var error = _v1.a.lP;
					var errorDescription = _v1.a.lQ;
					return _Utils_Tuple3(
						$author$project$Security$Security$Failed(
							A2(
								$author$project$Portal$Message$error,
								'Kan het security token niet uitlezen',
								$elm$core$Maybe$Just(
									$truqu$elm_oauth2$OAuth$errorCodeToString(error) + (' ' + A2($elm$core$Maybe$withDefault, '', errorDescription))))),
						$elm$core$Platform$Cmd$none,
						url);
			}
		} else {
			var error = _v0.a;
			return _Utils_Tuple3(
				$author$project$Security$Security$Failed(
					A2(
						$author$project$Portal$Message$error,
						'Slechte configuratie! Gegevens inladen onmogelijk.',
						$elm$core$Maybe$Just(
							$elm$json$Json$Decode$errorToString(error)))),
				$elm$core$Platform$Cmd$none,
				url);
		}
	});
var $elm$core$Platform$Cmd$map = _Platform_map;
var $elm$browser$Browser$Navigation$replaceUrl = _Browser_replaceUrl;
var $author$project$Main$init = F3(
	function (flags, url, key) {
		return function (_v0) {
			var s = _v0.a;
			var securityCmd = _v0.b;
			var newUrl = _v0.c;
			return _Utils_Tuple2(
				$author$project$Main$Initializing(
					{iC: flags, iY: key, et: s, aW: newUrl}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, $author$project$Main$GotSecurityMsg, securityCmd),
							A2(
							$elm$browser$Browser$Navigation$replaceUrl,
							key,
							$elm$url$Url$toString(newUrl))
						])));
		}(
			A2($author$project$Security$Security$init, flags, url));
	});
var $author$project$Main$GotApplicantsMsg = function (a) {
	return {$: 34, a: a};
};
var $author$project$Main$GotApproveCompensationMsg = function (a) {
	return {$: 27, a: a};
};
var $author$project$Main$GotDayPlanningMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Main$GotDelayMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Main$GotDelivererRouteDetailMsg = function (a) {
	return {$: 33, a: a};
};
var $author$project$Main$GotRouteDetailMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Main$GotSequenceMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Sequence$Plan$SystemGotEditMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Lists$RouteDetail$Deliverer$SystemGotSequenceEditMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Main$UserResizedWindow = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$map = _Platform_map;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $elm$browser$Browser$Events$Window = 1;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {jx: pids, ki: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {iA: event, iY: key};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.jx,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.iY;
		var event = _v0.iA;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.ki);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onResize = function (func) {
	return A3(
		$elm$browser$Browser$Events$on,
		1,
		'resize',
		A2(
			$elm$json$Json$Decode$field,
			'target',
			A3(
				$elm$json$Json$Decode$map2,
				func,
				A2($elm$json$Json$Decode$field, 'innerWidth', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'innerHeight', $elm$json$Json$Decode$int))));
};
var $author$project$Portal$Share$security = function (_v0) {
	var model = _v0;
	return model.et;
};
var $author$project$Lists$RouteDetail$Deliverer$sequenceEditModelOf = function (model) {
	if (model.$ === 1) {
		var display = model.a.N;
		if (display.$ === 2) {
			var edit = display.b;
			return $elm$core$Maybe$Just(edit);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Applicant$Overview$GotRememberedValue = function (a) {
	return {$: 12, a: a};
};
var $author$project$Ports$gotRememberedValue = _Platform_incomingPort(
	'gotRememberedValue',
	A2(
		$elm$json$Json$Decode$andThen,
		function (value) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (key) {
					return $elm$json$Json$Decode$succeed(
						{iY: key, kt: value});
				},
				A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$string)));
var $author$project$Applicant$Overview$subscriptions = $author$project$Ports$gotRememberedValue($author$project$Applicant$Overview$GotRememberedValue);
var $author$project$Compensation$Approve$UserEnteredRejectReason = function (a) {
	return {$: 8, a: a};
};
var $author$project$Compensation$Approve$UserPressedKey = function (a) {
	return {$: 12, a: a};
};
var $author$project$Compensation$Approve$Enter = 0;
var $author$project$Compensation$Approve$Escape = 1;
var $author$project$Compensation$Approve$NonClosingKey = 2;
var $author$project$Compensation$Approve$inputClosingKeyFor = function (string) {
	switch (string) {
		case 'Enter':
			return 0;
		case 'Escape':
			return 1;
		default:
			return 2;
	}
};
var $author$project$Compensation$Approve$inputClosingKeyDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Compensation$Approve$inputClosingKeyFor,
	A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
var $author$project$Compensation$Approve$A = 3;
var $author$project$Compensation$Approve$Down = 1;
var $author$project$Compensation$Approve$G = 2;
var $author$project$Compensation$Approve$Other = 4;
var $author$project$Compensation$Approve$Up = 0;
var $author$project$Compensation$Approve$directionFor = function (string) {
	switch (string) {
		case 'ArrowUp':
			return 0;
		case 'ArrowDown':
			return 1;
		case 'g':
			return 2;
		case 'a':
			return 3;
		default:
			return 4;
	}
};
var $author$project$Compensation$Approve$keyDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Compensation$Approve$directionFor,
	A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$onKeyDown = A2($elm$browser$Browser$Events$on, 0, 'keydown');
var $author$project$Compensation$Approve$subscriptions = function (model) {
	if (model.$ === 1) {
		var selected = model.a.nI;
		var focus = model.a.db;
		var _v1 = _Utils_Tuple2(selected, focus);
		if (!_v1.b) {
			if (!_v1.a.$) {
				var rejectState = _v1.a.a.bw;
				var _v2 = _v1.b;
				if (!rejectState.$) {
					return $elm$browser$Browser$Events$onKeyDown(
						A2($elm$json$Json$Decode$map, $author$project$Compensation$Approve$UserPressedKey, $author$project$Compensation$Approve$keyDecoder));
				} else {
					return $elm$browser$Browser$Events$onKeyDown(
						A2($elm$json$Json$Decode$map, $author$project$Compensation$Approve$UserEnteredRejectReason, $author$project$Compensation$Approve$inputClosingKeyDecoder));
				}
			} else {
				var _v4 = _v1.b;
				return $elm$browser$Browser$Events$onKeyDown(
					A2($elm$json$Json$Decode$map, $author$project$Compensation$Approve$UserPressedKey, $author$project$Compensation$Approve$keyDecoder));
			}
		} else {
			return $elm$core$Platform$Sub$none;
		}
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Delay$Delay$SystemRetrievedNow = function (a) {
	return {$: 13, a: a};
};
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {jI: processes, km: taggers};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 1) {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.jI;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.km);
		if (_v0.$ === 1) {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $author$project$Delay$Delay$subscriptions = A2($elm$time$Time$every, 60 * 1000, $author$project$Delay$Delay$SystemRetrievedNow);
var $author$project$Lists$RouteDetail$Deliverer$SystemGotRememberedValue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Lists$RouteDetail$Deliverer$subscriptions = function (_v0) {
	return $author$project$Ports$gotRememberedValue($author$project$Lists$RouteDetail$Deliverer$SystemGotRememberedValue);
};
var $author$project$Lists$RouteDetail$RouteDetail$Tick = function (a) {
	return {$: 10, a: a};
};
var $author$project$Lists$RouteDetail$RouteDetail$subscriptions = A2($elm$time$Time$every, 1000, $author$project$Lists$RouteDetail$RouteDetail$Tick);
var $author$project$Plan$DayPlanning$GotSupplyMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Plan$DayPlanning$SystemOpenedPopup = function (a) {
	return {$: 22, a: a};
};
var $author$project$Plan$DayPlanning$UserClickedWhenPopupOpen = {$: 23};
var $elm$browser$Browser$AnimationManager$Time = function (a) {
	return {$: 0, a: a};
};
var $elm$browser$Browser$AnimationManager$State = F3(
	function (subs, request, oldTime) {
		return {g1: oldTime, jR: request, ki: subs};
	});
var $elm$browser$Browser$AnimationManager$init = $elm$core$Task$succeed(
	A3($elm$browser$Browser$AnimationManager$State, _List_Nil, $elm$core$Maybe$Nothing, 0));
var $elm$browser$Browser$AnimationManager$now = _Browser_now(0);
var $elm$browser$Browser$AnimationManager$rAF = _Browser_rAF(0);
var $elm$browser$Browser$AnimationManager$onEffects = F3(
	function (router, subs, _v0) {
		var request = _v0.jR;
		var oldTime = _v0.g1;
		var _v1 = _Utils_Tuple2(request, subs);
		if (_v1.a.$ === 1) {
			if (!_v1.b.b) {
				var _v2 = _v1.a;
				return $elm$browser$Browser$AnimationManager$init;
			} else {
				var _v4 = _v1.a;
				return A2(
					$elm$core$Task$andThen,
					function (pid) {
						return A2(
							$elm$core$Task$andThen,
							function (time) {
								return $elm$core$Task$succeed(
									A3(
										$elm$browser$Browser$AnimationManager$State,
										subs,
										$elm$core$Maybe$Just(pid),
										time));
							},
							$elm$browser$Browser$AnimationManager$now);
					},
					$elm$core$Process$spawn(
						A2(
							$elm$core$Task$andThen,
							$elm$core$Platform$sendToSelf(router),
							$elm$browser$Browser$AnimationManager$rAF)));
			}
		} else {
			if (!_v1.b.b) {
				var pid = _v1.a.a;
				return A2(
					$elm$core$Task$andThen,
					function (_v3) {
						return $elm$browser$Browser$AnimationManager$init;
					},
					$elm$core$Process$kill(pid));
			} else {
				return $elm$core$Task$succeed(
					A3($elm$browser$Browser$AnimationManager$State, subs, request, oldTime));
			}
		}
	});
var $elm$browser$Browser$AnimationManager$onSelfMsg = F3(
	function (router, newTime, _v0) {
		var subs = _v0.ki;
		var oldTime = _v0.g1;
		var send = function (sub) {
			if (!sub.$) {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(
						$elm$time$Time$millisToPosix(newTime)));
			} else {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(newTime - oldTime));
			}
		};
		return A2(
			$elm$core$Task$andThen,
			function (pid) {
				return A2(
					$elm$core$Task$andThen,
					function (_v1) {
						return $elm$core$Task$succeed(
							A3(
								$elm$browser$Browser$AnimationManager$State,
								subs,
								$elm$core$Maybe$Just(pid),
								newTime));
					},
					$elm$core$Task$sequence(
						A2($elm$core$List$map, send, subs)));
			},
			$elm$core$Process$spawn(
				A2(
					$elm$core$Task$andThen,
					$elm$core$Platform$sendToSelf(router),
					$elm$browser$Browser$AnimationManager$rAF)));
	});
var $elm$browser$Browser$AnimationManager$Delta = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$AnimationManager$subMap = F2(
	function (func, sub) {
		if (!sub.$) {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Time(
				A2($elm$core$Basics$composeL, func, tagger));
		} else {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Delta(
				A2($elm$core$Basics$composeL, func, tagger));
		}
	});
_Platform_effectManagers['Browser.AnimationManager'] = _Platform_createManager($elm$browser$Browser$AnimationManager$init, $elm$browser$Browser$AnimationManager$onEffects, $elm$browser$Browser$AnimationManager$onSelfMsg, 0, $elm$browser$Browser$AnimationManager$subMap);
var $elm$browser$Browser$AnimationManager$subscription = _Platform_leaf('Browser.AnimationManager');
var $elm$browser$Browser$AnimationManager$onAnimationFrame = function (tagger) {
	return $elm$browser$Browser$AnimationManager$subscription(
		$elm$browser$Browser$AnimationManager$Time(tagger));
};
var $elm$browser$Browser$Events$onAnimationFrame = $elm$browser$Browser$AnimationManager$onAnimationFrame;
var $elm$browser$Browser$Events$onClick = A2($elm$browser$Browser$Events$on, 0, 'click');
var $author$project$Plan$DayPlanning$Supply$NotDragging = {$: 0};
var $author$project$Plan$DayPlanning$Supply$SystemAnimatesScrollingSupplyView = function (a) {
	return {$: 35, a: a};
};
var $author$project$Plan$DayPlanning$Supply$UserStopsDragging = {$: 33};
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $author$project$Plan$DayPlanning$Supply$SystemGotDragError = function (a) {
	return {$: 32, a: a};
};
var $author$project$Plan$DayPlanning$Supply$DragInfo = F3(
	function (cursor, beacons, scrollBeacons) {
		return {f9: beacons, bJ: cursor, jX: scrollBeacons};
	});
var $author$project$Plan$DayPlanning$Supply$UserMovesDraggedItem = function (a) {
	return {$: 31, a: a};
};
var $author$project$Plan$Supply$Id = $elm$core$Basics$identity;
var $author$project$Plan$Supply$idDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $elm$core$Basics$identity),
	$elm$json$Json$Decode$int);
var $author$project$Plan$Supply$After = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$Supply$AppendTo = function (a) {
	return {$: 4, a: a};
};
var $author$project$Plan$Supply$AppendedIn = function (a) {
	return {$: 3, a: a};
};
var $author$project$Plan$Supply$Before = function (a) {
	return {$: 0, a: a};
};
var $author$project$Plan$Supply$PrependedIn = function (a) {
	return {$: 2, a: a};
};
var $author$project$Plan$DayPlanning$Supply$toPosition = function (_v0) {
	var position = _v0.a;
	var id = _v0.b;
	switch (position) {
		case 'before':
			return $elm$json$Json$Decode$succeed(
				$author$project$Plan$Supply$Before(id));
		case 'after':
			return $elm$json$Json$Decode$succeed(
				$author$project$Plan$Supply$After(id));
		case 'prepended-in':
			return $elm$json$Json$Decode$succeed(
				$author$project$Plan$Supply$PrependedIn(id));
		case 'appended-in':
			return $elm$json$Json$Decode$succeed(
				$author$project$Plan$Supply$AppendedIn(id));
		case 'append-to':
			return $elm$json$Json$Decode$succeed(
				$author$project$Plan$Supply$AppendTo(id));
		default:
			return $elm$json$Json$Decode$fail('Unknown position: ' + position);
	}
};
var $author$project$Plan$DayPlanning$Supply$positionDecoder = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$Plan$DayPlanning$Supply$toPosition,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$Tuple$pair,
		A2($elm$json$Json$Decode$field, 'position', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'item', $author$project$Plan$Supply$idDecoder)));
var $author$project$Plan$DayPlanning$Supply$BeaconRect = F4(
	function (x, y, width, height) {
		return {iK: height, oy: width, ay: x, bg: y};
	});
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$Plan$DayPlanning$Supply$rectDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Plan$DayPlanning$Supply$BeaconRect,
	A2($elm$json$Json$Decode$field, 'x', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'y', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$float));
var $author$project$Plan$DayPlanning$Supply$beaconDecoder = A3(
	$elm$json$Json$Decode$map2,
	$elm$core$Tuple$pair,
	A2($elm$json$Json$Decode$field, 'id', $author$project$Plan$DayPlanning$Supply$positionDecoder),
	$author$project$Plan$DayPlanning$Supply$rectDecoder);
var $author$project$Plan$DayPlanning$Supply$CursorCoordinates = F2(
	function (x, y) {
		return {ay: x, bg: y};
	});
var $author$project$Plan$DayPlanning$Supply$coordsDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Plan$DayPlanning$Supply$CursorCoordinates,
	A2($elm$json$Json$Decode$field, 'x', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'y', $elm$json$Json$Decode$float));
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$Plan$DayPlanning$Supply$ScrollBottomEdge = 1;
var $author$project$Plan$DayPlanning$Supply$ScrollTopEdge = 0;
var $author$project$Plan$DayPlanning$Supply$scrollBeaconPositionDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		if (str === 'top') {
			return $elm$json$Json$Decode$succeed(0);
		} else {
			return $elm$json$Json$Decode$succeed(1);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Plan$DayPlanning$Supply$scrollBeaconDecoder = A3(
	$elm$json$Json$Decode$map2,
	$elm$core$Tuple$pair,
	A2($elm$json$Json$Decode$field, 'id', $author$project$Plan$DayPlanning$Supply$scrollBeaconPositionDecoder),
	$author$project$Plan$DayPlanning$Supply$rectDecoder);
var $author$project$Plan$DayPlanning$Supply$msgDecoder = A4(
	$elm$json$Json$Decode$map3,
	F3(
		function (cursor, beacons, scrollBeacons) {
			return $author$project$Plan$DayPlanning$Supply$UserMovesDraggedItem(
				A3($author$project$Plan$DayPlanning$Supply$DragInfo, cursor, beacons, scrollBeacons));
		}),
	A2($elm$json$Json$Decode$field, 'cursor', $author$project$Plan$DayPlanning$Supply$coordsDecoder),
	A2(
		$elm$json$Json$Decode$field,
		'beacons',
		$elm$json$Json$Decode$list($author$project$Plan$DayPlanning$Supply$beaconDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'scrollBeacons',
		$elm$json$Json$Decode$list($author$project$Plan$DayPlanning$Supply$scrollBeaconDecoder)));
var $author$project$Plan$DayPlanning$Supply$decodeDragEvents = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Plan$DayPlanning$Supply$msgDecoder, value);
	if (!_v0.$) {
		var msg = _v0.a;
		return msg;
	} else {
		var err = _v0.a;
		return $author$project$Plan$DayPlanning$Supply$SystemGotDragError(err);
	}
};
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $author$project$Plan$DayPlanning$Supply$dragEvents = _Platform_incomingPort('dragEvents', $elm$json$Json$Decode$value);
var $elm$core$Basics$ge = _Utils_ge;
var $elm$browser$Browser$Events$onMouseUp = A2($elm$browser$Browser$Events$on, 0, 'mouseup');
var $author$project$Plan$DayPlanning$Supply$subIf = F2(
	function (predicate, sub) {
		return predicate ? sub : $elm$core$Platform$Sub$none;
	});
var $author$project$Plan$DayPlanning$Supply$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$author$project$Plan$DayPlanning$Supply$subIf,
				$elm$core$Basics$abs(model.cA) >= 1.0,
				$elm$browser$Browser$Events$onAnimationFrame($author$project$Plan$DayPlanning$Supply$SystemAnimatesScrollingSupplyView)),
				A2(
				$author$project$Plan$DayPlanning$Supply$subIf,
				!_Utils_eq(model.C, $author$project$Plan$DayPlanning$Supply$NotDragging),
				$elm$browser$Browser$Events$onMouseUp(
					$elm$json$Json$Decode$succeed($author$project$Plan$DayPlanning$Supply$UserStopsDragging))),
				$author$project$Plan$DayPlanning$Supply$dragEvents($author$project$Plan$DayPlanning$Supply$decodeDragEvents)
			]));
};
var $author$project$Plan$DayPlanning$subscriptions = function (model) {
	var popupRelated = function () {
		var _v0 = model.b_;
		switch (_v0.$) {
			case 1:
				var popupState = _v0.a;
				return $elm$browser$Browser$Events$onAnimationFrame(
					function (_v1) {
						return $author$project$Plan$DayPlanning$SystemOpenedPopup(popupState);
					});
			case 0:
				return $elm$core$Platform$Sub$none;
			default:
				return $elm$browser$Browser$Events$onClick(
					$elm$json$Json$Decode$succeed($author$project$Plan$DayPlanning$UserClickedWhenPopupOpen));
		}
	}();
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				popupRelated,
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Plan$DayPlanning$GotSupplyMsg,
				$author$project$Plan$DayPlanning$Supply$subscriptions(model.z))
			]));
};
var $author$project$Security$Security$SystemRefreshedCodesForSignIn = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ports$securityCodesRefreshed = _Platform_incomingPort('securityCodesRefreshed', $elm$json$Json$Decode$value);
var $author$project$Security$Security$subscriptions = function (_v0) {
	return $author$project$Ports$securityCodesRefreshed($author$project$Security$Security$SystemRefreshedCodesForSignIn);
};
var $author$project$Sequence$Edit$DroppedItem = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Sequence$Edit$GotDnDMsg = function (a) {
	return {$: 1, a: a};
};
var $ir4y$elm_dnd$DnD$Draggable = $elm$core$Basics$identity;
var $ir4y$elm_dnd$DnD$DragStart = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $ir4y$elm_dnd$DnD$MousePosition = F2(
	function (x, y) {
		return {ay: x, bg: y};
	});
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $elm$html$Html$div = _VirtualDom_node('div');
var $ir4y$elm_dnd$DnD$pageX = A2($elm$json$Json$Decode$field, 'pageX', $elm$json$Json$Decode$int);
var $ir4y$elm_dnd$DnD$pageY = A2($elm$json$Json$Decode$field, 'pageY', $elm$json$Json$Decode$int);
var $ir4y$elm_dnd$DnD$draggable = F4(
	function (wrap, meta, attrs, html) {
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$Events$custom,
						'mousedown',
						A2(
							$elm$json$Json$Decode$map,
							function (m) {
								return {fq: m, hb: true, ht: true};
							},
							A2(
								$elm$json$Json$Decode$map,
								A2(
									$elm$core$Basics$composeL,
									wrap,
									$ir4y$elm_dnd$DnD$DragStart(meta)),
								A3($elm$json$Json$Decode$map2, $ir4y$elm_dnd$DnD$MousePosition, $ir4y$elm_dnd$DnD$pageX, $ir4y$elm_dnd$DnD$pageY))))
					]),
				attrs),
			html);
	});
var $ir4y$elm_dnd$DnD$EnterDroppable = function (a) {
	return {$: 3, a: a};
};
var $ir4y$elm_dnd$DnD$LeaveDroppable = {$: 4};
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onMouseEnter = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseenter',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseLeave = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseleave',
		$elm$json$Json$Decode$succeed(msg));
};
var $ir4y$elm_dnd$DnD$droppable = F4(
	function (wrap, dropMeta, attrs, html) {
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				attrs,
				_List_fromArray(
					[
						$elm$html$Html$Events$onMouseEnter(
						wrap(
							$ir4y$elm_dnd$DnD$EnterDroppable(dropMeta))),
						$elm$html$Html$Events$onMouseLeave(
						wrap($ir4y$elm_dnd$DnD$LeaveDroppable))
					])),
			html);
	});
var $ir4y$elm_dnd$DnD$DragEnd = function (a) {
	return {$: 2, a: a};
};
var $ir4y$elm_dnd$DnD$Dragging = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Events$onMouseMove = A2($elm$browser$Browser$Events$on, 0, 'mousemove');
var $ir4y$elm_dnd$DnD$subscriptions = F3(
	function (wrap, onDrop, _v0) {
		var model = _v0;
		if (model.$ === 1) {
			return $elm$core$Platform$Sub$none;
		} else {
			var drag = model.a;
			var _v2 = drag.d4;
			if (!_v2.$) {
				var dropMeta = _v2.a;
				return $elm$core$Platform$Sub$batch(
					_List_fromArray(
						[
							$elm$browser$Browser$Events$onMouseMove(
							A2(
								$elm$json$Json$Decode$map,
								wrap,
								A2(
									$elm$json$Json$Decode$map,
									$ir4y$elm_dnd$DnD$Dragging,
									A3($elm$json$Json$Decode$map2, $ir4y$elm_dnd$DnD$MousePosition, $ir4y$elm_dnd$DnD$pageX, $ir4y$elm_dnd$DnD$pageY)))),
							$elm$browser$Browser$Events$onMouseUp(
							$elm$json$Json$Decode$succeed(
								A2(onDrop, dropMeta, drag.e7))),
							$elm$browser$Browser$Events$onMouseUp(
							A2(
								$elm$json$Json$Decode$map,
								wrap,
								A2(
									$elm$json$Json$Decode$map,
									$ir4y$elm_dnd$DnD$DragEnd,
									A3($elm$json$Json$Decode$map2, $ir4y$elm_dnd$DnD$MousePosition, $ir4y$elm_dnd$DnD$pageX, $ir4y$elm_dnd$DnD$pageY))))
						]));
			} else {
				return $elm$core$Platform$Sub$batch(
					_List_fromArray(
						[
							$elm$browser$Browser$Events$onMouseMove(
							A2(
								$elm$json$Json$Decode$map,
								wrap,
								A2(
									$elm$json$Json$Decode$map,
									$ir4y$elm_dnd$DnD$Dragging,
									A3($elm$json$Json$Decode$map2, $ir4y$elm_dnd$DnD$MousePosition, $ir4y$elm_dnd$DnD$pageX, $ir4y$elm_dnd$DnD$pageY)))),
							$elm$browser$Browser$Events$onMouseUp(
							A2(
								$elm$json$Json$Decode$map,
								wrap,
								A2(
									$elm$json$Json$Decode$map,
									$ir4y$elm_dnd$DnD$DragEnd,
									A3($elm$json$Json$Decode$map2, $ir4y$elm_dnd$DnD$MousePosition, $ir4y$elm_dnd$DnD$pageX, $ir4y$elm_dnd$DnD$pageY))))
						]));
			}
		}
	});
var $ir4y$elm_dnd$DnD$init = F2(
	function (wrap, onDrop) {
		return {
			bo: $ir4y$elm_dnd$DnD$draggable(wrap),
			iq: $ir4y$elm_dnd$DnD$droppable(wrap),
			mL: $elm$core$Maybe$Nothing,
			nZ: A2($ir4y$elm_dnd$DnD$subscriptions, wrap, onDrop)
		};
	});
var $author$project$Sequence$Edit$dnd = A2($ir4y$elm_dnd$DnD$init, $author$project$Sequence$Edit$GotDnDMsg, $author$project$Sequence$Edit$DroppedItem);
var $author$project$Sequence$Edit$subscriptions = function (model) {
	return $author$project$Sequence$Edit$dnd.nZ(model.bo);
};
var $author$project$Main$subscriptions = function (model) {
	if (!model.$) {
		var security = model.a.et;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Main$GotSecurityMsg,
			$author$project$Security$Security$subscriptions(security));
	} else {
		var page = model.a.cv;
		var share = model.a.fQ;
		return $elm$core$Platform$Sub$batch(
			A2(
				$elm$core$List$cons,
				function () {
					switch (page.$) {
						case 10:
							var detail = page.a.lD;
							if (detail.$ === 1) {
								var edit = detail.a;
								return A2(
									$elm$core$Platform$Sub$map,
									A2($elm$core$Basics$composeL, $author$project$Main$GotSequenceMsg, $author$project$Sequence$Plan$SystemGotEditMsg),
									$author$project$Sequence$Edit$subscriptions(edit));
							} else {
								return $elm$core$Platform$Sub$none;
							}
						case 14:
							return A2($elm$core$Platform$Sub$map, $author$project$Main$GotDelayMsg, $author$project$Delay$Delay$subscriptions);
						case 32:
							return A2($elm$core$Platform$Sub$map, $author$project$Main$GotApplicantsMsg, $author$project$Applicant$Overview$subscriptions);
						case 9:
							return A2($elm$core$Platform$Sub$map, $author$project$Main$GotRouteDetailMsg, $author$project$Lists$RouteDetail$RouteDetail$subscriptions);
						case 15:
							var pageModel = page.a;
							return $elm$core$Platform$Sub$batch(
								_List_fromArray(
									[
										A2(
										$elm$core$Platform$Sub$map,
										$author$project$Main$GotDelivererRouteDetailMsg,
										$author$project$Lists$RouteDetail$Deliverer$subscriptions(pageModel)),
										function () {
										var _v3 = $author$project$Lists$RouteDetail$Deliverer$sequenceEditModelOf(pageModel);
										if (!_v3.$) {
											var edit = _v3.a;
											return A2(
												$elm$core$Platform$Sub$map,
												A2($elm$core$Basics$composeL, $author$project$Main$GotDelivererRouteDetailMsg, $author$project$Lists$RouteDetail$Deliverer$SystemGotSequenceEditMsg),
												$author$project$Sequence$Edit$subscriptions(edit));
										} else {
											return $elm$core$Platform$Sub$none;
										}
									}()
									]));
						case 2:
							var pageModel = page.a;
							return A2(
								$elm$core$Platform$Sub$map,
								$author$project$Main$GotDayPlanningMsg,
								$author$project$Plan$DayPlanning$subscriptions(pageModel));
						case 20:
							var pageModel = page.a;
							return A2(
								$elm$core$Platform$Sub$map,
								$author$project$Main$GotApproveCompensationMsg,
								$author$project$Compensation$Approve$subscriptions(pageModel));
						default:
							return $elm$core$Platform$Sub$none;
					}
				}(),
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$Main$GotSecurityMsg,
						$author$project$Security$Security$subscriptions(
							$author$project$Portal$Share$security(share))),
						$elm$browser$Browser$Events$onResize($author$project$Main$UserResizedWindow)
					])));
	}
};
var $author$project$Main$Initialized = function (a) {
	return {$: 1, a: a};
};
var $author$project$Portal$Route$NotFound = {$: 39};
var $Fresheyeball$elm_return$Return$command = F2(
	function (cmd, _v0) {
		var model = _v0.a;
		var cmd_ = _v0.b;
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[cmd, cmd_])));
	});
var $author$project$Portal$Route$AccountAdd = {$: 22};
var $author$project$Portal$Route$AccountEdit = function (a) {
	return {$: 21, a: a};
};
var $author$project$Portal$Route$Accounts = {$: 20};
var $author$project$Portal$Route$Applicants = {$: 33};
var $author$project$Portal$Route$ApproveCompensations = {$: 27};
var $author$project$Portal$Route$ClosingCalendar = {$: 36};
var $author$project$Portal$Route$Compensations = {$: 24};
var $author$project$Portal$Route$ComplaintFeedback = function (a) {
	return {$: 35, a: a};
};
var $author$project$Portal$Route$ComplaintHandle = {$: 34};
var $author$project$Portal$Route$Count = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Portal$Route$CreateCompensation = F2(
	function (a, b) {
		return {$: 25, a: a, b: b};
	});
var $author$project$Portal$Route$CreateDeliverer = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Portal$Route$CreatePlan = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Portal$Route$Dashboard = {$: 0};
var $author$project$Portal$Route$DayPlanning = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Portal$Route$DayPlanningToday = function (a) {
	return {$: 2, a: a};
};
var $author$project$Portal$Route$Delay = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Portal$Route$DelivererRouteDetail = function (a) {
	return {$: 17, a: a};
};
var $author$project$Portal$Route$DelivererRouteDetailPage = F3(
	function (a, b, c) {
		return {$: 18, a: a, b: b, c: c};
	});
var $author$project$Portal$Route$DistributionList = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Portal$Route$DistributionListB = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Portal$Route$DistributorValidate = {$: 37};
var $author$project$Portal$Route$Documents = {$: 19};
var $author$project$Portal$Route$EditCompensation = function (a) {
	return {$: 26, a: a};
};
var $author$project$Portal$Route$EditDeliverer = function (a) {
	return {$: 14, a: a};
};
var $author$project$Portal$Route$HubPackList = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Portal$Route$Messages = {$: 23};
var $author$project$Portal$Route$PaymentsArchive = {$: 32};
var $author$project$Portal$Route$PaymentsDistributionPointOverview = function (a) {
	return {$: 29, a: a};
};
var $author$project$Portal$Route$PaymentsSummaryAnnualDetail = function (a) {
	return {$: 31, a: a};
};
var $author$project$Portal$Route$PaymentsSummaryDetail = F2(
	function (a, b) {
		return {$: 30, a: a, b: b};
	});
var $author$project$Portal$Route$PaymentsSummaryOverview = {$: 28};
var $author$project$Portal$Route$PlansNotFinalized = {$: 5};
var $author$project$Portal$Route$PreSupplyList = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Portal$Route$Publications = function (a) {
	return {$: 1, a: a};
};
var $author$project$Portal$Route$ReceivedCheckList = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Portal$Route$Report = {$: 38};
var $author$project$Portal$Route$RouteDetail = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Portal$Route$SequenceDetail = F4(
	function (a, b, c, d) {
		return {$: 12, a: a, b: b, c: c, d: d};
	});
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.cR;
			var unvisited = _v0.b8;
			var params = _v0.cw;
			var frag = _v0.cn;
			var value = _v0.kt;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $author$project$Accounts$Account$Id = $elm$core$Basics$identity;
var $danyx23$elm_uuid$Uuid$Uuid = $elm$core$Basics$identity;
var $danyx23$elm_uuid$Uuid$Barebones$uuidRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[0-9A-Fa-f]{8,8}-[0-9A-Fa-f]{4,4}-[1-5][0-9A-Fa-f]{3,3}-[8-9A-Ba-b][0-9A-Fa-f]{3,3}-[0-9A-Fa-f]{12,12}$'));
var $danyx23$elm_uuid$Uuid$Barebones$isValidUuid = function (uuidAsString) {
	return A2($elm$regex$Regex$contains, $danyx23$elm_uuid$Uuid$Barebones$uuidRegex, uuidAsString);
};
var $danyx23$elm_uuid$Uuid$fromString = function (text) {
	return $danyx23$elm_uuid$Uuid$Barebones$isValidUuid(text) ? $elm$core$Maybe$Just(
		$elm$core$String$toLower(text)) : $elm$core$Maybe$Nothing;
};
var $author$project$Accounts$Account$idFromString = A2(
	$elm$core$Basics$composeR,
	$danyx23$elm_uuid$Uuid$fromString,
	$elm$core$Maybe$map($elm$core$Basics$identity));
var $author$project$Api$UrlParser$accountId = A2($elm$url$Url$Parser$custom, 'ACCID', $author$project$Accounts$Account$idFromString);
var $author$project$Date$DeliveryDate$DeliveryDate = $elm$core$Basics$identity;
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $author$project$Date$DeliveryDate$toMonth = function (str) {
	switch (str) {
		case '01':
			return $elm$core$Maybe$Just(0);
		case '02':
			return $elm$core$Maybe$Just(1);
		case '03':
			return $elm$core$Maybe$Just(2);
		case '04':
			return $elm$core$Maybe$Just(3);
		case '05':
			return $elm$core$Maybe$Just(4);
		case '06':
			return $elm$core$Maybe$Just(5);
		case '07':
			return $elm$core$Maybe$Just(6);
		case '08':
			return $elm$core$Maybe$Just(7);
		case '09':
			return $elm$core$Maybe$Just(8);
		case '10':
			return $elm$core$Maybe$Just(9);
		case '11':
			return $elm$core$Maybe$Just(10);
		case '12':
			return $elm$core$Maybe$Just(11);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Date$DeliveryDate$fromString = function (dateStr) {
	var _v0 = A2($elm$core$String$split, '-', dateStr);
	if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
		var yearStr = _v0.a;
		var _v1 = _v0.b;
		var monthStr = _v1.a;
		var _v2 = _v1.b;
		var dayStr = _v2.a;
		var _v3 = _Utils_Tuple3(
			$elm$core$String$toInt(yearStr),
			$author$project$Date$DeliveryDate$toMonth(monthStr),
			$elm$core$String$toInt(dayStr));
		if (((!_v3.a.$) && (!_v3.b.$)) && (!_v3.c.$)) {
			var year = _v3.a.a;
			var month = _v3.b.a;
			var day = _v3.c.a;
			return $elm$core$Maybe$Just(
				{a2: day, a5: month, kC: year});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$UrlParser$date = A2($elm$url$Url$Parser$custom, 'DATE', $author$project$Date$DeliveryDate$fromString);
var $author$project$Deliverer$Deliverer$Id = $elm$core$Basics$identity;
var $author$project$Deliverer$Deliverer$idFromString = A2(
	$elm$core$Basics$composeR,
	$danyx23$elm_uuid$Uuid$fromString,
	$elm$core$Maybe$map($elm$core$Basics$identity));
var $author$project$Api$UrlParser$delivererId = A2($elm$url$Url$Parser$custom, 'DELID', $author$project$Deliverer$Deliverer$idFromString);
var $author$project$DistributionPoint$DistributionPoint$idFromString = $danyx23$elm_uuid$Uuid$fromString;
var $author$project$Api$UrlParser$dpId = A2($elm$url$Url$Parser$custom, 'DPID', $author$project$DistributionPoint$DistributionPoint$idFromString);
var $author$project$Compensation$Compensation$Id = $elm$core$Basics$identity;
var $author$project$Compensation$Compensation$idParser = A2(
	$elm$url$Url$Parser$custom,
	'COMPENSATIONID',
	function (str) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$identity,
			$danyx23$elm_uuid$Uuid$fromString(str));
	});
var $author$project$Deliverer$Deliverer$idParser = A2(
	$elm$url$Url$Parser$custom,
	'DELIVERERID',
	function (str) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$identity,
			$danyx23$elm_uuid$Uuid$fromString(str));
	});
var $elm$url$Url$Parser$int = A2($elm$url$Url$Parser$custom, 'NUMBER', $elm$core$String$toInt);
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.cR;
		var unvisited = _v0.b8;
		var params = _v0.cw;
		var frag = _v0.cn;
		var value = _v0.kt;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.cR;
			var unvisited = _v1.b8;
			var params = _v1.cw;
			var frag = _v1.cn;
			var value = _v1.kt;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $author$project$Cluster$Number$ClusterNumber = $elm$core$Basics$identity;
var $author$project$Cluster$Number$parser = A2(
	$elm$url$Url$Parser$custom,
	'CLUSTERID',
	function (str) {
		var _v0 = $elm$core$String$toInt(str);
		if (!_v0.$) {
			var number = _v0.a;
			return $elm$core$Maybe$Just(number);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Lists$RouteDetail$Route$Aggregated = 0;
var $author$project$Lists$RouteDetail$Route$Complaints = 4;
var $author$project$Lists$RouteDetail$Route$Mutations = 3;
var $author$project$Lists$RouteDetail$Route$Orders = 1;
var $author$project$Lists$RouteDetail$Route$routeViewFromString = function (routeView) {
	switch (routeView) {
		case 'aggregated':
			return $elm$core$Maybe$Just(0);
		case 'mutations':
			return $elm$core$Maybe$Just(3);
		case 'complaints':
			return $elm$core$Maybe$Just(4);
		case 'orders':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Lists$RouteDetail$Route$parser = A2($elm$url$Url$Parser$custom, 'ROUTEVIEW', $author$project$Lists$RouteDetail$Route$routeViewFromString);
var $author$project$Portal$Route$paymentsRoot = 'payments';
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.cR;
		var unvisited = _v0.b8;
		var params = _v0.cw;
		var frag = _v0.cn;
		var value = _v0.kt;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $author$project$Portal$Route$parser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, $author$project$Portal$Route$Dashboard, $elm$url$Url$Parser$top),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$Publications,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('publications'),
				$author$project$Api$UrlParser$date)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$Documents,
			$elm$url$Url$Parser$s('documents')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$Accounts,
			$elm$url$Url$Parser$s('accounts')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$AccountAdd,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('accounts'),
				$elm$url$Url$Parser$s('add'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$AccountEdit,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('accounts'),
				$author$project$Api$UrlParser$accountId)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$Messages,
			$elm$url$Url$Parser$s('messages')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$CreateDeliverer,
			A2(
				$elm$url$Url$Parser$slash,
				$author$project$Api$UrlParser$dpId,
				A2(
					$elm$url$Url$Parser$slash,
					$author$project$Api$UrlParser$date,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('deliverer'),
						$elm$url$Url$Parser$s('create'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$EditDeliverer,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('deliverer'),
				$author$project$Api$UrlParser$delivererId)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$CreatePlan,
			A2(
				$elm$url$Url$Parser$slash,
				$author$project$Api$UrlParser$dpId,
				A2(
					$elm$url$Url$Parser$slash,
					$author$project$Api$UrlParser$date,
					$elm$url$Url$Parser$s('create')))),
			A2($elm$url$Url$Parser$map, $author$project$Portal$Route$DayPlanningToday, $author$project$Api$UrlParser$dpId),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$DayPlanning,
			A2($elm$url$Url$Parser$slash, $author$project$Api$UrlParser$dpId, $author$project$Api$UrlParser$date)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$DayPlanning,
			A2(
				$elm$url$Url$Parser$slash,
				$author$project$Api$UrlParser$dpId,
				A2(
					$elm$url$Url$Parser$slash,
					$author$project$Api$UrlParser$date,
					$elm$url$Url$Parser$s('dayplanning')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$PlansNotFinalized,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('plans'),
				$elm$url$Url$Parser$s('not-finalized'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$DistributionList,
			A2(
				$elm$url$Url$Parser$slash,
				$author$project$Api$UrlParser$dpId,
				A2(
					$elm$url$Url$Parser$slash,
					$author$project$Api$UrlParser$date,
					$elm$url$Url$Parser$s('distributionlist')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$DistributionListB,
			A2(
				$elm$url$Url$Parser$slash,
				$author$project$Api$UrlParser$dpId,
				A2(
					$elm$url$Url$Parser$slash,
					$author$project$Api$UrlParser$date,
					$elm$url$Url$Parser$s('distributionlistb')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$PreSupplyList,
			A2(
				$elm$url$Url$Parser$slash,
				$author$project$Api$UrlParser$dpId,
				A2(
					$elm$url$Url$Parser$slash,
					$author$project$Api$UrlParser$date,
					$elm$url$Url$Parser$s('presupplylist')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$DelivererRouteDetail,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('deliverer'),
				A2(
					$elm$url$Url$Parser$slash,
					$author$project$Api$UrlParser$date,
					$elm$url$Url$Parser$s('routedetail')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$DelivererRouteDetailPage,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('deliverer'),
				A2(
					$elm$url$Url$Parser$slash,
					$author$project$Api$UrlParser$date,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('routedetail'),
						A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$int, $author$project$Lists$RouteDetail$Route$parser))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$HubPackList,
			A2(
				$elm$url$Url$Parser$slash,
				$author$project$Api$UrlParser$dpId,
				A2(
					$elm$url$Url$Parser$slash,
					$author$project$Api$UrlParser$date,
					$elm$url$Url$Parser$s('hubpacklist')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$Count,
			A2(
				$elm$url$Url$Parser$slash,
				$author$project$Api$UrlParser$dpId,
				A2(
					$elm$url$Url$Parser$slash,
					$author$project$Api$UrlParser$date,
					$elm$url$Url$Parser$s('count')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$Delay,
			A2(
				$elm$url$Url$Parser$slash,
				$author$project$Api$UrlParser$dpId,
				A2(
					$elm$url$Url$Parser$slash,
					$author$project$Api$UrlParser$date,
					$elm$url$Url$Parser$s('delay')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$ReceivedCheckList,
			A2(
				$elm$url$Url$Parser$slash,
				$author$project$Api$UrlParser$dpId,
				A2(
					$elm$url$Url$Parser$slash,
					$author$project$Api$UrlParser$date,
					$elm$url$Url$Parser$s('receivedchecklist')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$RouteDetail,
			A2(
				$elm$url$Url$Parser$slash,
				$author$project$Api$UrlParser$dpId,
				A2(
					$elm$url$Url$Parser$slash,
					$author$project$Api$UrlParser$date,
					$elm$url$Url$Parser$s('routedetail')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$SequenceDetail,
			A2(
				$elm$url$Url$Parser$slash,
				$author$project$Api$UrlParser$dpId,
				A2(
					$elm$url$Url$Parser$slash,
					$author$project$Api$UrlParser$date,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('sequencedetail'),
						A2($elm$url$Url$Parser$slash, $author$project$Deliverer$Deliverer$idParser, $author$project$Cluster$Number$parser))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$ApproveCompensations,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('compensations'),
				$elm$url$Url$Parser$s('approve'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$Compensations,
			$elm$url$Url$Parser$s('compensations')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$CreateCompensation,
			A2(
				$elm$url$Url$Parser$slash,
				$author$project$Api$UrlParser$dpId,
				A2(
					$elm$url$Url$Parser$slash,
					$author$project$Api$UrlParser$date,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('compensation'),
						$elm$url$Url$Parser$s('create'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$EditCompensation,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('compensations'),
				$author$project$Compensation$Compensation$idParser)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$PaymentsSummaryOverview,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Portal$Route$paymentsRoot),
				$elm$url$Url$Parser$s('documents'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$PaymentsSummaryDetail,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Portal$Route$paymentsRoot),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('details'),
					A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$int, $elm$url$Url$Parser$int)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$PaymentsSummaryAnnualDetail,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Portal$Route$paymentsRoot),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('details'),
					$elm$url$Url$Parser$int))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$PaymentsDistributionPointOverview,
			A2(
				$elm$url$Url$Parser$slash,
				$author$project$Api$UrlParser$dpId,
				$elm$url$Url$Parser$s($author$project$Portal$Route$paymentsRoot))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$PaymentsArchive,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Portal$Route$paymentsRoot),
				$elm$url$Url$Parser$s('archive'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$Applicants,
			$elm$url$Url$Parser$s('applicants')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$ComplaintHandle,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('complaints'),
				$elm$url$Url$Parser$s('handle'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$ComplaintFeedback,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('complaints'),
				A2(
					$elm$url$Url$Parser$slash,
					$author$project$Api$UrlParser$date,
					$elm$url$Url$Parser$s('feedback')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$Report,
			$elm$url$Url$Parser$s('reports')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$ClosingCalendar,
			$elm$url$Url$Parser$s('closing-calendar')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Portal$Route$DistributorValidate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('distributor'),
				$elm$url$Url$Parser$s('validate')))
		]));
var $author$project$Portal$Route$fromUrl = function (url) {
	return A2(
		$elm$url$Url$Parser$parse,
		$author$project$Portal$Route$parser,
		_Utils_update(
			url,
			{
				iF: $elm$core$Maybe$Nothing,
				ne: A2($elm$core$Maybe$withDefault, '', url.iF)
			}));
};
var $author$project$Main$GotPageMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Portal$Pages$Redirect = {$: 0};
var $author$project$Main$SystemLoadedMessages = function (a) {
	return {$: 42, a: a};
};
var $author$project$Api$Request$Untracked = {$: 0};
var $author$project$Portal$Page$BackendRespondedDistributionPoints = function (a) {
	return {$: 0, a: a};
};
var $author$project$Portal$Page$Folded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Portal$Page$Loading = {$: 0};
var $justinmimbs$date$Date$Months = 1;
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $elm$core$Basics$modBy = _Basics_modBy;
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {a2: d, a5: m, kC: y};
			}
		}
	});
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		g5: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		kC: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.kC, 0, date.g5);
};
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0;
		switch (unit) {
			case 0:
				return A3($justinmimbs$date$Date$add, 1, 12 * n, rd);
			case 1:
				var date = $justinmimbs$date$Date$toCalendarDate(rd);
				var wholeMonths = ((12 * (date.kC - 1)) + ($justinmimbs$date$Date$monthToNumber(date.a5) - 1)) + n;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
					$elm$core$Basics$min,
					date.a2,
					A2($justinmimbs$date$Date$daysInMonth, y, m));
			case 2:
				return rd + (7 * n);
			default:
				return rd + n;
		}
	});
var $author$project$Portal$Init$Model = $elm$core$Basics$identity;
var $author$project$Portal$Init$empty = function (share) {
	return {aC: _List_Nil, iY: 0, fQ: share};
};
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.a2;
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.a5;
	});
var $author$project$Date$DeliveryDate$fromDate = function (date) {
	return {
		a2: $justinmimbs$date$Date$day(date),
		a5: $justinmimbs$date$Date$month(date),
		kC: $justinmimbs$date$Date$year(date)
	};
};
var $danyx23$elm_uuid$Uuid$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		var _v0 = $danyx23$elm_uuid$Uuid$fromString(string);
		if (!_v0.$) {
			var uuid = _v0.a;
			return $elm$json$Json$Decode$succeed(uuid);
		} else {
			return $elm$json$Json$Decode$fail('Not a valid UUID');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$DistributionPoint$DistributionPoint$idDecoder = $danyx23$elm_uuid$Uuid$decoder;
var $PaackEng$elm_ui_dropdown$Dropdown$State = $elm$core$Basics$identity;
var $PaackEng$elm_ui_dropdown$Dropdown$init = function (id) {
	return {fb: '', br: 0, eg: id, K: false};
};
var $author$project$DistributionPoint$DistributionPoint$DistributionPointNameAndRegion = F3(
	function (id, name, region) {
		return {eg: id, ft: name, nq: region};
	});
var $author$project$DistributionPoint$DistributionPoint$Region = F2(
	function (number, name) {
		return {ft: name, bX: number};
	});
var $author$project$DistributionPoint$DistributionPoint$distributionPointOnlyNameDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'region',
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$DistributionPoint$DistributionPoint$Region,
		A2($elm$json$Json$Decode$field, 'number', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$author$project$DistributionPoint$DistributionPoint$idDecoder,
			$elm$json$Json$Decode$succeed($author$project$DistributionPoint$DistributionPoint$DistributionPointNameAndRegion))));
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $author$project$Date$DeliveryDate$viewDay = function (day) {
	return A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(day));
};
var $author$project$Date$DeliveryDate$viewMonth = function (month) {
	return A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			$justinmimbs$date$Date$monthToNumber(month)));
};
var $author$project$Date$DeliveryDate$viewYear = function (year) {
	return A3(
		$elm$core$String$padLeft,
		4,
		'0',
		$elm$core$String$fromInt(year));
};
var $author$project$Date$DeliveryDate$encodeForUrl = function (_v0) {
	var year = _v0.kC;
	var month = _v0.a5;
	var day = _v0.a2;
	return A2(
		$elm$core$String$join,
		'-',
		_List_fromArray(
			[
				$author$project$Date$DeliveryDate$viewYear(year),
				$author$project$Date$DeliveryDate$viewMonth(month),
				$author$project$Date$DeliveryDate$viewDay(day)
			]));
};
var $elm$url$Url$Builder$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$Api$Uri$for = F2(
	function (pathSegments, parameters) {
		return A2(
			$elm$url$Url$Builder$absolute,
			A2($elm$core$List$cons, 'api', pathSegments),
			parameters);
	});
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $truqu$elm_oauth2$OAuth$tokenToString = function (_v0) {
	var t = _v0;
	return 'Bearer ' + t;
};
var $truqu$elm_oauth2$OAuth$useToken = function (token) {
	return $elm$core$List$cons(
		A2(
			$elm$http$Http$header,
			'Authorization',
			$truqu$elm_oauth2$OAuth$tokenToString(token)));
};
var $author$project$Api$Request$headers = function (maybeToken) {
	if (!maybeToken.$) {
		var token = maybeToken.a;
		return A2($truqu$elm_oauth2$OAuth$useToken, token, _List_Nil);
	} else {
		return _List_Nil;
	}
};
var $author$project$Api$Request$trackingFor = function (t) {
	if (!t.$) {
		return $elm$core$Maybe$Nothing;
	} else {
		var tracker = t.a;
		return $elm$core$Maybe$Just(tracker);
	}
};
var $author$project$Api$Request$get = F5(
	function (token, toMsg, url, decoder, tracker) {
		return $elm$http$Http$request(
			{
				aA: $elm$http$Http$emptyBody,
				aJ: A2($elm$http$Http$expectJson, toMsg, decoder),
				aK: $author$project$Api$Request$headers(token),
				aO: 'GET',
				aS: $elm$core$Maybe$Nothing,
				aU: $author$project$Api$Request$trackingFor(tracker),
				aW: url
			});
	});
var $author$project$DistributionPoint$DistributionPoint$loadNamesAndRegions = F3(
	function (token, toMsg, date) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['distributionpoints']),
			_List_fromArray(
				[
					A2(
					$elm$url$Url$Builder$string,
					'validon',
					$author$project$Date$DeliveryDate$encodeForUrl(date))
				]));
		return A4(
			$author$project$Api$Request$get,
			token,
			toMsg,
			uri,
			$elm$json$Json$Decode$list($author$project$DistributionPoint$DistributionPoint$distributionPointOnlyNameDecoder));
	});
var $author$project$Portal$Waiting$Id = F2(
	function (scope, id) {
		return {eg: id, hj: scope};
	});
var $author$project$Portal$Page$actionIdFor = function (id) {
	return A2($author$project$Portal$Waiting$Id, 'page', id);
};
var $author$project$Portal$Waiting$SingleAction = $elm$core$Basics$identity;
var $author$project$Portal$Waiting$singleAction = $elm$core$Basics$identity;
var $author$project$Portal$Page$singleAction = function (id) {
	return $author$project$Portal$Waiting$singleAction(
		$author$project$Portal$Page$actionIdFor(id));
};
var $author$project$Portal$Page$loadingDPs = function (_v0) {
	return $author$project$Portal$Page$singleAction('loadingDPs');
};
var $author$project$Portal$Page$Unfolded = {$: 0};
var $author$project$Portal$Page$menuStatusDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'folded':
				return $elm$json$Json$Decode$succeed(
					$author$project$Portal$Page$Folded(
						{bt: $elm$core$Maybe$Nothing}));
			case 'unfolded':
				return $elm$json$Json$Decode$succeed($author$project$Portal$Page$Unfolded);
			default:
				return $elm$json$Json$Decode$fail('Ongeldige menu status');
		}
	},
	$elm$json$Json$Decode$string);
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $author$project$Date$DeliveryDate$toDate = function (_v0) {
	var year = _v0.kC;
	var month = _v0.a5;
	var day = _v0.a2;
	return A3($justinmimbs$date$Date$fromCalendarDate, year, month, day);
};
var $author$project$Portal$Share$today = function (_v0) {
	var model = _v0;
	return model.fX;
};
var $author$project$Security$Security$tokenOf = function (model) {
	switch (model.$) {
		case 3:
			var token = model.a.aT;
			return $elm$core$Maybe$Just(token);
		case 4:
			var token = model.a.aT;
			return $elm$core$Maybe$Just(token);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Portal$Share$token = function (_v0) {
	var model = _v0;
	return $author$project$Security$Security$tokenOf(model.et);
};
var $elm_community$maybe_extra$Maybe$Extra$unwrap = F3(
	function (_default, f, m) {
		if (m.$ === 1) {
			return _default;
		} else {
			var a = m.a;
			return f(a);
		}
	});
var $author$project$Api$Request$Tracked = function (a) {
	return {$: 1, a: a};
};
var $author$project$Portal$Waiting$id = function (_v0) {
	var i = _v0;
	return i;
};
var $author$project$Portal$Waiting$name = function (action) {
	return function (i) {
		return i.hj + ('|' + i.eg);
	}(
		$author$project$Portal$Waiting$id(action));
};
var $author$project$Portal$Init$tracked = function (action) {
	return $author$project$Api$Request$Tracked(
		$author$project$Portal$Waiting$name(action));
};
var $author$project$Portal$Share$Model = $elm$core$Basics$identity;
var $author$project$Portal$Waiting$actionsOf = function (status) {
	if (!status.$) {
		return _List_Nil;
	} else {
		var actions = status.a;
		return actions;
	}
};
var $elm$core$List$partition = F2(
	function (pred, list) {
		var step = F2(
			function (x, _v0) {
				var trues = _v0.a;
				var falses = _v0.b;
				return pred(x) ? _Utils_Tuple2(
					A2($elm$core$List$cons, x, trues),
					falses) : _Utils_Tuple2(
					trues,
					A2($elm$core$List$cons, x, falses));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(_List_Nil, _List_Nil),
			list);
	});
var $elm_community$list_extra$List$Extra$gatherWith = F2(
	function (testFn, list) {
		var helper = F2(
			function (scattered, gathered) {
				helper:
				while (true) {
					if (!scattered.b) {
						return $elm$core$List$reverse(gathered);
					} else {
						var toGather = scattered.a;
						var population = scattered.b;
						var _v1 = A2(
							$elm$core$List$partition,
							testFn(toGather),
							population);
						var gathering = _v1.a;
						var remaining = _v1.b;
						var $temp$scattered = remaining,
							$temp$gathered = A2(
							$elm$core$List$cons,
							_Utils_Tuple2(toGather, gathering),
							gathered);
						scattered = $temp$scattered;
						gathered = $temp$gathered;
						continue helper;
					}
				}
			});
		return A2(helper, list, _List_Nil);
	});
var $author$project$Portal$Waiting$combine = function (actions) {
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$first,
		A2(
			$elm_community$list_extra$List$Extra$gatherWith,
			F2(
				function (a1, a2) {
					return _Utils_eq(
						$author$project$Portal$Waiting$id(a1),
						$author$project$Portal$Waiting$id(a2));
				}),
			actions));
};
var $author$project$Portal$Waiting$Idle = {$: 0};
var $author$project$Portal$Waiting$Waiting = function (a) {
	return {$: 1, a: a};
};
var $author$project$Portal$Waiting$statusFrom = function (actions) {
	if (!actions.b) {
		return $author$project$Portal$Waiting$Idle;
	} else {
		return $author$project$Portal$Waiting$Waiting(actions);
	}
};
var $author$project$Portal$Waiting$withActions = F2(
	function (actions, status) {
		return $author$project$Portal$Waiting$statusFrom(
			$author$project$Portal$Waiting$combine(
				_Utils_ap(
					$author$project$Portal$Waiting$actionsOf(status),
					actions)));
	});
var $author$project$Portal$Waiting$withAction = function (action) {
	return $author$project$Portal$Waiting$withActions(
		_List_fromArray(
			[action]));
};
var $author$project$Portal$Share$withWaitingAction = F2(
	function (action, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				bf: A2($author$project$Portal$Waiting$withAction, action, model.bf)
			});
	});
var $author$project$Portal$Init$addTrackedCommand = F3(
	function (toAction, cmd, _v0) {
		var share = _v0.fQ;
		var key = _v0.iY;
		var commands = _v0.aC;
		var action = toAction(key);
		return {
			aC: A2(
				$elm$core$List$cons,
				cmd(
					$author$project$Portal$Init$tracked(action)),
				commands),
			iY: key,
			fQ: A2($author$project$Portal$Share$withWaitingAction, action, share)
		};
	});
var $author$project$Portal$Init$withCommand = $author$project$Portal$Init$addTrackedCommand;
var $author$project$Portal$Share$withDistributionPointIdOfHeader = F2(
	function (dpId, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				gn: $elm$core$Maybe$Just(dpId)
			});
	});
var $author$project$Portal$Init$withModel = F2(
	function (model, _v0) {
		var share = _v0.fQ;
		var commands = _v0.aC;
		return _Utils_Tuple3(
			share,
			model,
			$elm$core$Platform$Cmd$batch(commands));
	});
var $author$project$Portal$Page$init = F2(
	function (flags, share) {
		var today = $author$project$Portal$Share$today(share);
		var rememberedDistributionPointId = $elm$core$Result$toMaybe(
			A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$field, 'selectedDP', $author$project$DistributionPoint$DistributionPoint$idDecoder),
				flags));
		var dateIncludingRecentlyStoppedDepots = $author$project$Date$DeliveryDate$fromDate(
			A3(
				$justinmimbs$date$Date$add,
				1,
				-1,
				$author$project$Date$DeliveryDate$toDate(today)));
		return A2(
			$author$project$Portal$Init$withModel,
			{
				lx: today,
				A: $author$project$Portal$Page$Loading,
				d2: $PaackEng$elm_ui_dropdown$Dropdown$init('header-dps'),
				ai: A2(
					$elm$core$Maybe$withDefault,
					$author$project$Portal$Page$Folded(
						{bt: $elm$core$Maybe$Nothing}),
					$elm$core$Result$toMaybe(
						A2(
							$elm$json$Json$Decode$decodeValue,
							A2($elm$json$Json$Decode$field, 'menuStatus', $author$project$Portal$Page$menuStatusDecoder),
							flags))),
				fJ: rememberedDistributionPointId
			},
			A3(
				$author$project$Portal$Init$withCommand,
				$author$project$Portal$Page$loadingDPs,
				A3(
					$author$project$DistributionPoint$DistributionPoint$loadNamesAndRegions,
					$author$project$Portal$Share$token(share),
					$author$project$Portal$Page$BackendRespondedDistributionPoints,
					dateIncludingRecentlyStoppedDepots),
				$author$project$Portal$Init$empty(
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						share,
						function (dpId) {
							return A2($author$project$Portal$Share$withDistributionPointIdOfHeader, dpId, share);
						},
						rememberedDistributionPointId))));
	});
var $author$project$Portal$Share$Stable = function (a) {
	return {$: 0, a: a};
};
var $author$project$Portal$ShareData$empty = function (date) {
	return {k: $elm$core$Maybe$Nothing, lx: date, e4: $elm$core$Maybe$Nothing, id: $elm$core$Maybe$Nothing, bn: $elm$core$Maybe$Nothing, A: $elm$core$Maybe$Nothing, Y: $elm$core$Maybe$Nothing, fA: $elm$core$Maybe$Nothing, jy: $elm$core$Maybe$Nothing, bu: $elm$core$Maybe$Nothing};
};
var $justinmimbs$timezone_data$TimeZone$Specification$DateTime = F5(
	function (year, month, day, time, clock) {
		return {bH: clock, a2: day, a5: month, dG: time, kC: year};
	});
var $justinmimbs$timezone_data$TimeZone$Specification$Rules = function (a) {
	return {$: 1, a: a};
};
var $justinmimbs$timezone_data$TimeZone$Specification$Save = function (a) {
	return {$: 0, a: a};
};
var $justinmimbs$timezone_data$TimeZone$Specification$WallClock = 2;
var $justinmimbs$timezone_data$TimeZone$Specification$Zone = F2(
	function (history, current) {
		return {h9: current, aL: history};
	});
var $justinmimbs$timezone_data$TimeZone$Specification$ZoneState = F2(
	function (standardOffset, zoneRules) {
		return {hp: standardOffset, hM: zoneRules};
	});
var $justinmimbs$timezone_data$TimeZone$maxYear = 2037;
var $justinmimbs$timezone_data$TimeZone$minYear = 1970;
var $justinmimbs$timezone_data$TimeZone$Specification$Universal = 0;
var $justinmimbs$timezone_data$TimeZone$Specification$dropChangesBeforeEpoch = function (_v0) {
	dropChangesBeforeEpoch:
	while (true) {
		var initial = _v0.a;
		var changes = _v0.b;
		if (changes.b) {
			var change = changes.a;
			var rest = changes.b;
			if (change.hq <= 0) {
				var $temp$_v0 = _Utils_Tuple2(change.c, rest);
				_v0 = $temp$_v0;
				continue dropChangesBeforeEpoch;
			} else {
				return _Utils_Tuple2(initial, changes);
			}
		} else {
			return _Utils_Tuple2(initial, _List_Nil);
		}
	}
};
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $justinmimbs$timezone_data$RataDie$weekdayNumber = function (rd) {
	var _v0 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v0) {
		return 7;
	} else {
		var n = _v0;
		return n;
	}
};
var $justinmimbs$timezone_data$RataDie$weekdayToNumber = function (wd) {
	switch (wd) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$timezone_data$RataDie$floorWeekday = F2(
	function (weekday, rd) {
		var daysSincePreviousWeekday = A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$timezone_data$RataDie$weekdayNumber(rd) + 7) - $justinmimbs$timezone_data$RataDie$weekdayToNumber(weekday));
		return rd - daysSincePreviousWeekday;
	});
var $justinmimbs$timezone_data$RataDie$ceilingWeekday = F2(
	function (weekday, rd) {
		var floored = A2($justinmimbs$timezone_data$RataDie$floorWeekday, weekday, rd);
		return _Utils_eq(rd, floored) ? rd : (floored + 7);
	});
var $justinmimbs$timezone_data$RataDie$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$timezone_data$RataDie$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$timezone_data$RataDie$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$timezone_data$RataDie$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
	return (365 * y) + leapYears;
};
var $justinmimbs$timezone_data$RataDie$dayOfMonth = F3(
	function (y, m, d) {
		return ($justinmimbs$timezone_data$RataDie$daysBeforeYear(y) + A2($justinmimbs$timezone_data$RataDie$daysBeforeMonth, y, m)) + d;
	});
var $justinmimbs$timezone_data$RataDie$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$timezone_data$RataDie$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$timezone_data$RataDie$lastOfMonth = F2(
	function (y, m) {
		return ($justinmimbs$timezone_data$RataDie$daysBeforeYear(y) + A2($justinmimbs$timezone_data$RataDie$daysBeforeMonth, y, m)) + A2($justinmimbs$timezone_data$RataDie$daysInMonth, y, m);
	});
var $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie = function (rd) {
	return (rd - 719163) * 1440;
};
var $elm$core$List$sortBy = _List_sortBy;
var $justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment = F2(
	function (clock, _v0) {
		var standard = _v0.b3;
		var save = _v0.ad;
		switch (clock) {
			case 0:
				return 0;
			case 1:
				return 0 - standard;
			default:
				return 0 - (standard + save);
		}
	});
var $justinmimbs$timezone_data$TimeZone$Specification$minutesFromDateTime = function (_v0) {
	var year = _v0.kC;
	var month = _v0.a5;
	var day = _v0.a2;
	var time = _v0.dG;
	return $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie(
		A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, month, day)) + time;
};
var $justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime = F2(
	function (offset, datetime) {
		return $justinmimbs$timezone_data$TimeZone$Specification$minutesFromDateTime(datetime) + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, datetime.bH, offset);
	});
var $justinmimbs$timezone_data$TimeZone$Specification$rulesToOffsetChanges = F5(
	function (previousOffset, start, until, standardOffset, rules) {
		var transitions = A2(
			$elm$core$List$concatMap,
			function (year) {
				return A2(
					$elm$core$List$sortBy,
					function ($) {
						return $.hq;
					},
					A2(
						$elm$core$List$map,
						function (rule) {
							return {
								bH: rule.bH,
								ad: rule.ad,
								hq: $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie(
									function () {
										var _v2 = rule.a2;
										switch (_v2.$) {
											case 0:
												var day = _v2.a;
												return A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.a5, day);
											case 1:
												var weekday = _v2.a;
												var after = _v2.b;
												return A2(
													$justinmimbs$timezone_data$RataDie$ceilingWeekday,
													weekday,
													A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.a5, after));
											case 2:
												var weekday = _v2.a;
												var before = _v2.b;
												return A2(
													$justinmimbs$timezone_data$RataDie$floorWeekday,
													weekday,
													A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.a5, before));
											default:
												var weekday = _v2.a;
												return A2(
													$justinmimbs$timezone_data$RataDie$floorWeekday,
													weekday,
													A2($justinmimbs$timezone_data$RataDie$lastOfMonth, year, rule.a5));
										}
									}()) + rule.dG
							};
						},
						A2(
							$elm$core$List$filter,
							function (rule) {
								return (_Utils_cmp(rule.l2, year) < 1) && (_Utils_cmp(year, rule.oj) < 1);
							},
							rules)));
			},
			A2($elm$core$List$range, start.kC - 1, until.kC));
		var initialOffset = {ad: 0, b3: standardOffset};
		var initialChange = {
			c: standardOffset,
			hq: A2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, previousOffset, start)
		};
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (transition, _v1) {
					var currentOffset = _v1.a;
					var changes = _v1.b;
					var newOffset = {ad: transition.ad, b3: standardOffset};
					if (_Utils_cmp(
						transition.hq + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.bH, previousOffset),
						initialChange.hq) < 1) {
						var updatedInitialChange = {c: standardOffset + transition.ad, hq: initialChange.hq};
						return _Utils_Tuple2(
							newOffset,
							_List_fromArray(
								[updatedInitialChange]));
					} else {
						if (_Utils_cmp(
							transition.hq + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.bH, currentOffset),
							A2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, currentOffset, until)) < 0) {
							var change = {
								c: standardOffset + transition.ad,
								hq: transition.hq + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.bH, currentOffset)
							};
							return _Utils_Tuple2(
								newOffset,
								A2($elm$core$List$cons, change, changes));
						} else {
							return _Utils_Tuple2(currentOffset, changes);
						}
					}
				}),
			_Utils_Tuple2(
				initialOffset,
				_List_fromArray(
					[initialChange])),
			transitions);
		var nextOffset = _v0.a;
		var descendingChanges = _v0.b;
		return _Utils_Tuple2(
			$elm$core$List$reverse(descendingChanges),
			nextOffset);
	});
var $justinmimbs$timezone_data$TimeZone$Specification$stateToOffsetChanges = F4(
	function (previousOffset, start, until, _v0) {
		var standardOffset = _v0.hp;
		var zoneRules = _v0.hM;
		if (!zoneRules.$) {
			var save = zoneRules.a;
			return _Utils_Tuple2(
				_List_fromArray(
					[
						{
						c: standardOffset + save,
						hq: A2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, previousOffset, start)
					}
					]),
				{ad: save, b3: standardOffset});
		} else {
			var rules = zoneRules.a;
			return A5($justinmimbs$timezone_data$TimeZone$Specification$rulesToOffsetChanges, previousOffset, start, until, standardOffset, rules);
		}
	});
var $justinmimbs$timezone_data$TimeZone$Specification$stripDuplicatesByHelp = F4(
	function (f, a, rev, list) {
		stripDuplicatesByHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$List$reverse(rev);
			} else {
				var x = list.a;
				var xs = list.b;
				var b = f(x);
				var rev_ = (!_Utils_eq(a, b)) ? A2($elm$core$List$cons, x, rev) : rev;
				var $temp$f = f,
					$temp$a = b,
					$temp$rev = rev_,
					$temp$list = xs;
				f = $temp$f;
				a = $temp$a;
				rev = $temp$rev;
				list = $temp$list;
				continue stripDuplicatesByHelp;
			}
		}
	});
var $justinmimbs$timezone_data$TimeZone$Specification$zoneToRanges = F3(
	function (zoneStart, zoneUntil, zone) {
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, _v2) {
					var state = _v1.a;
					var nextStart = _v1.b;
					var start = _v2.a;
					var ranges = _v2.b;
					return _Utils_Tuple2(
						nextStart,
						A2(
							$elm$core$List$cons,
							_Utils_Tuple3(start, state, nextStart),
							ranges));
				}),
			_Utils_Tuple2(zoneStart, _List_Nil),
			zone.aL);
		var currentStart = _v0.a;
		var historyRanges = _v0.b;
		return $elm$core$List$reverse(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple3(currentStart, zone.h9, zoneUntil),
				historyRanges));
	});
var $justinmimbs$timezone_data$TimeZone$Specification$toOffsets = F3(
	function (minYear, maxYear, zone) {
		var initialState = function () {
			var _v5 = zone.aL;
			if (_v5.b) {
				var _v6 = _v5.a;
				var earliest = _v6.a;
				return earliest;
			} else {
				return zone.h9;
			}
		}();
		var initialOffset = {
			ad: function () {
				var _v4 = initialState.hM;
				if (!_v4.$) {
					var save = _v4.a;
					return save;
				} else {
					return 0;
				}
			}(),
			b3: initialState.hp
		};
		var ascendingChanges = A4(
			$justinmimbs$timezone_data$TimeZone$Specification$stripDuplicatesByHelp,
			function ($) {
				return $.c;
			},
			initialOffset.b3 + initialOffset.ad,
			_List_Nil,
			A3(
				$elm$core$List$foldl,
				F2(
					function (_v1, _v2) {
						var start = _v1.a;
						var state = _v1.b;
						var until = _v1.c;
						var prevOffset = _v2.a;
						var prevChanges = _v2.b;
						var _v3 = A4($justinmimbs$timezone_data$TimeZone$Specification$stateToOffsetChanges, prevOffset, start, until, state);
						var nextChanges = _v3.a;
						var nextOffset = _v3.b;
						return _Utils_Tuple2(
							nextOffset,
							_Utils_ap(prevChanges, nextChanges));
					}),
				_Utils_Tuple2(initialOffset, _List_Nil),
				A3(
					$justinmimbs$timezone_data$TimeZone$Specification$zoneToRanges,
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, minYear, 0, 1, 0, 0),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, maxYear + 1, 0, 1, 0, 0),
					zone)).b);
		var _v0 = $justinmimbs$timezone_data$TimeZone$Specification$dropChangesBeforeEpoch(
			_Utils_Tuple2(initialOffset.b3 + initialOffset.ad, ascendingChanges));
		var initial = _v0.a;
		var ascending = _v0.b;
		return _Utils_Tuple2(
			$elm$core$List$reverse(ascending),
			initial);
	});
var $justinmimbs$timezone_data$TimeZone$fromSpecification = function (zone) {
	var _v0 = A3($justinmimbs$timezone_data$TimeZone$Specification$toOffsets, $justinmimbs$timezone_data$TimeZone$minYear, $justinmimbs$timezone_data$TimeZone$maxYear, zone);
	var descending = _v0.a;
	var bottom = _v0.b;
	return A2($elm$time$Time$customZone, bottom, descending);
};
var $justinmimbs$timezone_data$TimeZone$Specification$Day = function (a) {
	return {$: 0, a: a};
};
var $justinmimbs$timezone_data$TimeZone$Specification$Last = function (a) {
	return {$: 3, a: a};
};
var $justinmimbs$timezone_data$TimeZone$Specification$Next = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $justinmimbs$timezone_data$TimeZone$Specification$Rule = F7(
	function (from, to, month, day, time, clock, save) {
		return {bH: clock, a2: day, l2: from, a5: month, ad: save, dG: time, oj: to};
	});
var $elm$time$Time$Sun = 6;
var $justinmimbs$timezone_data$TimeZone$rules_EU = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		60,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__amsterdam = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $author$project$Portal$Environment$Unknown = function (a) {
	return {$: 5, a: a};
};
var $author$project$Portal$Environment$Beta = {$: 2};
var $author$project$Portal$Environment$Demo = {$: 1};
var $author$project$Portal$Environment$Development = {$: 4};
var $author$project$Portal$Environment$Production = {$: 0};
var $author$project$Portal$Environment$Test = {$: 3};
var $author$project$Portal$Environment$byJsonValue = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('prod', $author$project$Portal$Environment$Production),
			_Utils_Tuple2('demo', $author$project$Portal$Environment$Demo),
			_Utils_Tuple2('beta', $author$project$Portal$Environment$Beta),
			_Utils_Tuple2('test', $author$project$Portal$Environment$Test),
			_Utils_Tuple2('dev', $author$project$Portal$Environment$Development)
		]));
var $author$project$Portal$Environment$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Decode$fail('Invalid Environment'),
			A2(
				$elm$core$Maybe$map,
				$elm$json$Json$Decode$succeed,
				A2($elm$core$Dict$get, s, $author$project$Portal$Environment$byJsonValue)));
	},
	$elm$json$Json$Decode$string);
var $author$project$Portal$Environment$fromFlags = function (flags) {
	var decode = A2($elm$json$Json$Decode$field, 'environment', $author$project$Portal$Environment$decoder);
	var _v0 = A2($elm$json$Json$Decode$decodeValue, decode, flags);
	if (!_v0.$) {
		var environment = _v0.a;
		return environment;
	} else {
		var error = _v0.a;
		return $author$project$Portal$Environment$Unknown(error);
	}
};
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.hq, posixMinutes) < 0) {
					return posixMinutes + era.c;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		a2: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		a5: month,
		kC: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).a2;
	});
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).a5;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).kC;
	});
var $author$project$Date$DeliveryDate$fromPosix = F2(
	function (zone, posix) {
		return {
			a2: A2($elm$time$Time$toDay, zone, posix),
			a5: A2($elm$time$Time$toMonth, zone, posix),
			kC: A2($elm$time$Time$toYear, zone, posix)
		};
	});
var $author$project$Portal$Waiting$init = $author$project$Portal$Waiting$Idle;
var $author$project$UI$Window$Window = F2(
	function (height, width) {
		return {iK: height, oy: width};
	});
var $author$project$UI$Window$decoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$UI$Window$Window,
	A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$int));
var $author$project$Portal$Share$NormalHeader = 0;
var $mdgriffith$elm_ui$Element$BigDesktop = 3;
var $mdgriffith$elm_ui$Element$Desktop = 2;
var $mdgriffith$elm_ui$Element$Landscape = 1;
var $mdgriffith$elm_ui$Element$Phone = 0;
var $mdgriffith$elm_ui$Element$Portrait = 0;
var $mdgriffith$elm_ui$Element$Tablet = 1;
var $mdgriffith$elm_ui$Element$classifyDevice = function (window) {
	return {
		le: function () {
			var shortSide = A2($elm$core$Basics$min, window.oy, window.iK);
			var longSide = A2($elm$core$Basics$max, window.oy, window.iK);
			return (shortSide < 600) ? 0 : ((longSide <= 1200) ? 1 : (((longSide > 1200) && (longSide <= 1920)) ? 2 : 3));
		}(),
		m9: (_Utils_cmp(window.oy, window.iK) < 0) ? 0 : 1
	};
};
var $author$project$Portal$Share$uiForWindow = function (window) {
	return {
		lF: $mdgriffith$elm_ui$Element$classifyDevice(window),
		l9: 0,
		oz: window
	};
};
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$Portal$Share$initUI = function (flags) {
	return $author$project$Portal$Share$uiForWindow(
		A2(
			$elm$core$Result$withDefault,
			A2($author$project$UI$Window$Window, 0, 0),
			A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$field, 'window', $author$project$UI$Window$decoder),
				flags)));
};
var $author$project$Portal$Share$init = F2(
	function (s, flags) {
		var tz = $justinmimbs$timezone_data$TimeZone$europe__amsterdam(0);
		var moment = A2(
			$elm$core$Maybe$withDefault,
			1612306800000,
			$elm$core$Result$toMaybe(
				A2(
					$elm$json$Json$Decode$decodeValue,
					A2($elm$json$Json$Decode$field, 'moment', $elm$json$Json$Decode$int),
					flags)));
		var t = A2(
			$author$project$Date$DeliveryDate$fromPosix,
			tz,
			$elm$time$Time$millisToPosix(moment));
		return {
			cf: $author$project$Portal$ShareData$empty(t),
			gn: $elm$core$Maybe$Nothing,
			iy: $author$project$Portal$Environment$fromFlags(flags),
			fu: _List_Nil,
			bW: _List_Nil,
			fL: $author$project$Portal$Share$Stable(
				{h9: $author$project$Portal$Route$NotFound, nk: $elm$core$Maybe$Nothing}),
			et: s,
			ko: tz,
			fX: t,
			dI: $author$project$Portal$Share$initUI(flags),
			eA: _List_Nil,
			bf: $author$project$Portal$Waiting$init
		};
	});
var $author$project$Message$Message$Message = F6(
	function (showDuring, title, text, formatted, messageType, permissions) {
		return {ec: formatted, dh: messageType, fz: permissions, bA: showDuring, n3: text, oi: title};
	});
var $author$project$Message$Message$News = 1;
var $author$project$Message$Message$Notification = 0;
var $author$project$Message$Message$messageTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (t) {
		switch (t) {
			case 'notification':
				return $elm$json$Json$Decode$succeed(0);
			case 'news':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Unknown message type');
		}
	},
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (path, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					return A2(
						$elm$json$Json$Decode$at,
						path,
						nullOr(valDecoder));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				_List_fromArray(
					[key]),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Message$Message$Period = F2(
	function (from, to) {
		return {l2: from, oj: to};
	});
var $author$project$Message$Message$timeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$succeed),
	$elm$json$Json$Decode$int);
var $author$project$Message$Message$periodDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'to',
	$author$project$Message$Message$timeDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'from',
		$author$project$Message$Message$timeDecoder,
		$elm$json$Json$Decode$succeed($author$project$Message$Message$Period)));
var $author$project$Message$Message$Deliverer = 0;
var $author$project$Message$Message$RegionDistributor = 1;
var $author$project$Message$Message$RegionManager = 2;
var $author$project$Message$Message$permissionDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (permission) {
		switch (permission) {
			case 'vdm':
				return $elm$json$Json$Decode$succeed(0);
			case 'vrm':
				return $elm$json$Json$Decode$succeed(1);
			case 'vmm':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Unknown permission');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Message$Message$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'permissions',
	$elm$json$Json$Decode$list($author$project$Message$Message$permissionDecoder),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'kind',
		$author$project$Message$Message$messageTypeDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'formatted',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'text',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'title',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'showDuring',
						$author$project$Message$Message$periodDecoder,
						$elm$json$Json$Decode$succeed($author$project$Message$Message$Message)))))));
var $author$project$Message$Message$loadCmd = F2(
	function (token, toMsg) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['messages']),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'validon', 'now')
				]));
		return A4(
			$author$project$Api$Request$get,
			token,
			toMsg,
			uri,
			$elm$json$Json$Decode$list($author$project$Message$Message$decoder));
	});
var $author$project$Portal$Pages$AccountAdd = function (a) {
	return {$: 29, a: a};
};
var $author$project$Portal$Pages$AccountEdit = function (a) {
	return {$: 28, a: a};
};
var $author$project$Portal$Pages$Accounts = function (a) {
	return {$: 27, a: a};
};
var $author$project$Portal$Pages$AnnualPaymentDetail = function (a) {
	return {$: 24, a: a};
};
var $author$project$Portal$Pages$Applicants = function (a) {
	return {$: 32, a: a};
};
var $author$project$Portal$Pages$ApproveCompensations = function (a) {
	return {$: 20, a: a};
};
var $author$project$Portal$Pages$ClosingCalendar = function (a) {
	return {$: 36, a: a};
};
var $author$project$Portal$Pages$Compensations = function (a) {
	return {$: 17, a: a};
};
var $author$project$Portal$Pages$ComplaintFeedback = function (a) {
	return {$: 34, a: a};
};
var $author$project$Portal$Pages$ComplaintHandle = function (a) {
	return {$: 33, a: a};
};
var $author$project$Portal$Pages$Count = function (a) {
	return {$: 13, a: a};
};
var $author$project$Portal$Pages$CreateCompensation = function (a) {
	return {$: 18, a: a};
};
var $author$project$Portal$Pages$CreateDeliverer = function (a) {
	return {$: 30, a: a};
};
var $author$project$Portal$Pages$CreatePlan = function (a) {
	return {$: 1, a: a};
};
var $author$project$Portal$Pages$Dashboard = function (a) {
	return {$: 11, a: a};
};
var $author$project$Portal$Pages$DayPlanning = function (a) {
	return {$: 2, a: a};
};
var $author$project$Portal$Pages$Delay = function (a) {
	return {$: 14, a: a};
};
var $author$project$Portal$Pages$DelivererRouteDetail = function (a) {
	return {$: 15, a: a};
};
var $author$project$Portal$Pages$DistributionList = function (a) {
	return {$: 4, a: a};
};
var $author$project$Portal$Pages$DistributionListB = function (a) {
	return {$: 5, a: a};
};
var $author$project$Portal$Pages$DistributorValidate = function (a) {
	return {$: 37, a: a};
};
var $author$project$Portal$Pages$Documents = function (a) {
	return {$: 26, a: a};
};
var $author$project$Portal$Pages$EditCompensation = function (a) {
	return {$: 19, a: a};
};
var $author$project$Portal$Pages$EditDeliverer = function (a) {
	return {$: 31, a: a};
};
var $author$project$Main$GotAccountAddMsg = function (a) {
	return {$: 21, a: a};
};
var $author$project$Main$GotAccountEditMsg = function (a) {
	return {$: 22, a: a};
};
var $author$project$Main$GotAccountsMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Main$GotAnnualPaymentDetailMsg = function (a) {
	return {$: 31, a: a};
};
var $author$project$Main$GotClosingCalendarMsg = function (a) {
	return {$: 38, a: a};
};
var $author$project$Main$GotCompensationOverviewMsg = function (a) {
	return {$: 24, a: a};
};
var $author$project$Main$GotComplaintFeedbackMsg = function (a) {
	return {$: 36, a: a};
};
var $author$project$Main$GotComplaintHandleMsg = function (a) {
	return {$: 35, a: a};
};
var $author$project$Main$GotCountMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Main$GotCreateCompensationMsg = function (a) {
	return {$: 25, a: a};
};
var $author$project$Main$GotCreateDelivererMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Main$GotCreatePlanMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Main$GotDashboardMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Main$GotDistributionListMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Main$GotDistributorValidateMsg = function (a) {
	return {$: 39, a: a};
};
var $author$project$Main$GotDocumentsMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Main$GotEditCompensationMsg = function (a) {
	return {$: 26, a: a};
};
var $author$project$Main$GotEditDelivererMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Main$GotMessageMsg = function (a) {
	return {$: 23, a: a};
};
var $author$project$Main$GotPaymentArchiveMsg = function (a) {
	return {$: 32, a: a};
};
var $author$project$Main$GotPaymentDelivererOverviewMsg = function (a) {
	return {$: 28, a: a};
};
var $author$project$Main$GotPaymentDetailMsg = function (a) {
	return {$: 30, a: a};
};
var $author$project$Main$GotPaymentDistributionPointOverviewMsg = function (a) {
	return {$: 29, a: a};
};
var $author$project$Main$GotPlanNotFinalizedMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Main$GotPreSupplyListMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Main$GotPublicationsMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Main$GotReceivedCheckListMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Main$GotReportMsg = function (a) {
	return {$: 37, a: a};
};
var $author$project$Portal$Pages$HubPackList = function (a) {
	return {$: 7, a: a};
};
var $author$project$Portal$Pages$Messages = function (a) {
	return {$: 16, a: a};
};
var $author$project$Portal$Pages$PaymentArchive = function (a) {
	return {$: 25, a: a};
};
var $author$project$Portal$Pages$PaymentDelivererOverview = function (a) {
	return {$: 21, a: a};
};
var $author$project$Portal$Pages$PaymentDetail = function (a) {
	return {$: 23, a: a};
};
var $author$project$Portal$Pages$PaymentDistributionPointOverview = function (a) {
	return {$: 22, a: a};
};
var $author$project$Portal$Pages$PlansNotFinalized = function (a) {
	return {$: 3, a: a};
};
var $author$project$Portal$Pages$PreSupplyList = function (a) {
	return {$: 6, a: a};
};
var $author$project$Portal$Pages$Publications = function (a) {
	return {$: 12, a: a};
};
var $author$project$Portal$Pages$ReceivedCheckList = function (a) {
	return {$: 8, a: a};
};
var $author$project$Portal$Pages$Report = function (a) {
	return {$: 35, a: a};
};
var $author$project$Portal$Pages$RouteDetail = function (a) {
	return {$: 9, a: a};
};
var $author$project$Portal$Pages$SequenceDetail = function (a) {
	return {$: 10, a: a};
};
var $elm$http$Http$cancel = function (tracker) {
	return $elm$http$Http$command(
		$elm$http$Http$Cancel(tracker));
};
var $author$project$Portal$Waiting$map = F3(
	function (idleValue, fct, status) {
		if (!status.$) {
			return idleValue;
		} else {
			var actions = status.a;
			return fct(actions);
		}
	});
var $author$project$Portal$Waiting$cancelCmd = function (status) {
	return $elm$core$Platform$Cmd$batch(
		A3(
			$author$project$Portal$Waiting$map,
			_List_Nil,
			$elm$core$List$map(
				A2($elm$core$Basics$composeL, $elm$http$Http$cancel, $author$project$Portal$Waiting$name)),
			status));
};
var $author$project$Portal$Route$context = function (route) {
	switch (route.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 3:
			var dpId = route.a;
			var date = route.b;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(dpId, date));
		case 2:
			return $elm$core$Maybe$Nothing;
		case 4:
			var dpId = route.a;
			var date = route.b;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(dpId, date));
		case 5:
			return $elm$core$Maybe$Nothing;
		case 6:
			var dpId = route.a;
			var date = route.b;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(dpId, date));
		case 7:
			var dpId = route.a;
			var date = route.b;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(dpId, date));
		case 8:
			var dpId = route.a;
			var date = route.b;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(dpId, date));
		case 9:
			var dpId = route.a;
			var date = route.b;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(dpId, date));
		case 10:
			var dpId = route.a;
			var date = route.b;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(dpId, date));
		case 11:
			var dpId = route.a;
			var date = route.b;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(dpId, date));
		case 12:
			var dpId = route.a;
			var date = route.b;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(dpId, date));
		case 13:
			var dpId = route.a;
			var date = route.b;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(dpId, date));
		case 14:
			return $elm$core$Maybe$Nothing;
		case 15:
			var dpId = route.a;
			var date = route.b;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(dpId, date));
		case 16:
			var dpId = route.a;
			var date = route.b;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(dpId, date));
		case 17:
			return $elm$core$Maybe$Nothing;
		case 18:
			return $elm$core$Maybe$Nothing;
		case 19:
			return $elm$core$Maybe$Nothing;
		case 20:
			return $elm$core$Maybe$Nothing;
		case 22:
			return $elm$core$Maybe$Nothing;
		case 21:
			return $elm$core$Maybe$Nothing;
		case 23:
			return $elm$core$Maybe$Nothing;
		case 24:
			return $elm$core$Maybe$Nothing;
		case 25:
			var dpId = route.a;
			var date = route.b;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(dpId, date));
		case 26:
			return $elm$core$Maybe$Nothing;
		case 27:
			return $elm$core$Maybe$Nothing;
		case 28:
			return $elm$core$Maybe$Nothing;
		case 30:
			return $elm$core$Maybe$Nothing;
		case 31:
			return $elm$core$Maybe$Nothing;
		case 29:
			return $elm$core$Maybe$Nothing;
		case 32:
			return $elm$core$Maybe$Nothing;
		case 33:
			return $elm$core$Maybe$Nothing;
		case 34:
			return $elm$core$Maybe$Nothing;
		case 35:
			return $elm$core$Maybe$Nothing;
		case 38:
			return $elm$core$Maybe$Nothing;
		case 36:
			return $elm$core$Maybe$Nothing;
		case 37:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Portal$Share$currentRoute = function (_v0) {
	var model = _v0;
	var _v1 = model.fL;
	if (!_v1.$) {
		var s = _v1.a;
		return s.h9;
	} else {
		var s = _v1.b;
		return s.h9;
	}
};
var $author$project$DistributionPoint$DistributionPoint$idOf = function (_v0) {
	var dp = _v0;
	return dp.eg;
};
var $author$project$Portal$ShareData$for = F3(
	function (dpId, date, model) {
		var _v0 = model.bn;
		if (!_v0.$) {
			var dp = _v0.a;
			return (_Utils_eq(
				dpId,
				$author$project$DistributionPoint$DistributionPoint$idOf(dp)) && _Utils_eq(date, model.lx)) ? model : $author$project$Portal$ShareData$empty(date);
		} else {
			return $author$project$Portal$ShareData$empty(date);
		}
	});
var $author$project$Portal$Share$filterData = F3(
	function (dpId, date, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				cf: A3($author$project$Portal$ShareData$for, dpId, date, model.cf)
			});
	});
var $author$project$Accounts$Add$init = function (share) {
	return A2(
		$author$project$Portal$Init$withModel,
		{d5: '', f_: _List_Nil},
		$author$project$Portal$Init$empty(share));
};
var $author$project$Accounts$Edit$BackendRespondedDistributionPoints = function (a) {
	return {$: 1, a: a};
};
var $author$project$Accounts$Edit$Loading = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Accounts$Edit$SystemGotAccount = function (a) {
	return {$: 0, a: a};
};
var $author$project$Accounts$Edit$SystemGotAuthorizations = function (a) {
	return {$: 2, a: a};
};
var $danyx23$elm_uuid$Uuid$toString = function (_v0) {
	var internalString = _v0;
	return internalString;
};
var $author$project$Accounts$Account$encodeForUrl = function (_v0) {
	var accountId = _v0;
	return $danyx23$elm_uuid$Uuid$toString(accountId);
};
var $author$project$Accounts$Account$Account = F6(
	function (id, username, email, phone, status, enabled) {
		return {d5: email, lN: enabled, eg: id, eq: phone, nS: status, os: username};
	});
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $author$project$Accounts$Account$idDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $danyx23$elm_uuid$Uuid$decoder);
var $author$project$Accounts$Account$AccountNeedsPasswordChange = {$: 0};
var $author$project$Accounts$Account$ExternalUser = {$: 2};
var $author$project$Accounts$Account$InternalUser = {$: 1};
var $author$project$Accounts$Account$UnknownStatus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Accounts$Account$statusDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (accountStatus) {
		switch (accountStatus) {
			case 'FORCE_CHANGE_PASSWORD':
				return $elm$json$Json$Decode$succeed($author$project$Accounts$Account$AccountNeedsPasswordChange);
			case 'CONFIRMED':
				return $elm$json$Json$Decode$succeed($author$project$Accounts$Account$ExternalUser);
			case 'EXTERNAL_PROVIDER':
				return $elm$json$Json$Decode$succeed($author$project$Accounts$Account$InternalUser);
			default:
				var unknown = accountStatus;
				return $elm$json$Json$Decode$succeed(
					$author$project$Accounts$Account$UnknownStatus(unknown));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Accounts$Account$userDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'enabled',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'status',
		$author$project$Accounts$Account$statusDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'phone',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'email',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'username',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$author$project$Accounts$Account$idDecoder,
						$elm$json$Json$Decode$succeed($author$project$Accounts$Account$Account)))))));
var $author$project$Accounts$Account$getAccountCmd = F3(
	function (token, accountId, toMsg) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'accounts',
					$author$project$Accounts$Account$encodeForUrl(accountId)
				]),
			_List_Nil);
		return A4($author$project$Api$Request$get, token, toMsg, uri, $author$project$Accounts$Account$userDecoder);
	});
var $author$project$Accounts$Authorization$Authorization = F2(
	function (from, roles) {
		return {l2: from, ny: roles};
	});
var $author$project$Date$DeliveryDate$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		var _v0 = $author$project$Date$DeliveryDate$fromString(str);
		if (!_v0.$) {
			var date = _v0.a;
			return $elm$json$Json$Decode$succeed(date);
		} else {
			return $elm$json$Json$Decode$fail('Ongeldige datum');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Accounts$Authorization$AccountManager = {$: 4};
var $author$project$Accounts$Authorization$Admin = {$: 7};
var $author$project$Accounts$Authorization$AssistantDistributor = function (a) {
	return {$: 2, a: a};
};
var $author$project$Accounts$Authorization$Counter = function (a) {
	return {$: 3, a: a};
};
var $author$project$Accounts$Authorization$Deliverer = function (a) {
	return {$: 8, a: a};
};
var $author$project$Accounts$Authorization$Entrepreneur = function (a) {
	return {$: 1, a: a};
};
var $author$project$Accounts$Authorization$FinancialAdministrator = {$: 10};
var $author$project$Accounts$Authorization$LaborMarketCommunicator = {$: 13};
var $author$project$Accounts$Authorization$LogisticsSupporter = {$: 5};
var $author$project$Accounts$Authorization$OperationalManager = {$: 9};
var $author$project$Accounts$Authorization$Preparer = {$: 11};
var $author$project$Accounts$Authorization$Recruiter = {$: 12};
var $author$project$Accounts$Authorization$RegionDistributor = function (a) {
	return {$: 0, a: a};
};
var $author$project$Accounts$Authorization$RegionManager = {$: 6};
var $author$project$Deliverer$Deliverer$idDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (id) {
		return $elm$json$Json$Decode$succeed(id);
	},
	$danyx23$elm_uuid$Uuid$decoder);
var $author$project$Accounts$Authorization$roleDecoder = function () {
	var withDpDecoder = function (fn) {
		return A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'distributionPoints',
			$elm$json$Json$Decode$list($author$project$DistributionPoint$DistributionPoint$idDecoder),
			_List_Nil,
			$elm$json$Json$Decode$succeed(fn));
	};
	return A2(
		$elm$json$Json$Decode$andThen,
		function (role) {
			switch (role) {
				case 'regionDistributor':
					return withDpDecoder($author$project$Accounts$Authorization$RegionDistributor);
				case 'entrepreneur':
					return withDpDecoder($author$project$Accounts$Authorization$Entrepreneur);
				case 'assistantDistributor':
					return withDpDecoder($author$project$Accounts$Authorization$AssistantDistributor);
				case 'counter':
					return withDpDecoder($author$project$Accounts$Authorization$Counter);
				case 'accountManager':
					return $elm$json$Json$Decode$succeed($author$project$Accounts$Authorization$AccountManager);
				case 'logisticsSupporter':
					return $elm$json$Json$Decode$succeed($author$project$Accounts$Authorization$LogisticsSupporter);
				case 'regionManager':
					return $elm$json$Json$Decode$succeed($author$project$Accounts$Authorization$RegionManager);
				case 'admin':
					return $elm$json$Json$Decode$succeed($author$project$Accounts$Authorization$Admin);
				case 'deliverer':
					return A2(
						$elm$json$Json$Decode$andThen,
						A2($elm$core$Basics$composeR, $author$project$Accounts$Authorization$Deliverer, $elm$json$Json$Decode$succeed),
						A2($elm$json$Json$Decode$field, 'deliverer', $author$project$Deliverer$Deliverer$idDecoder));
				case 'operationalManager':
					return $elm$json$Json$Decode$succeed($author$project$Accounts$Authorization$OperationalManager);
				case 'financialAdministrator':
					return $elm$json$Json$Decode$succeed($author$project$Accounts$Authorization$FinancialAdministrator);
				case 'preparer':
					return $elm$json$Json$Decode$succeed($author$project$Accounts$Authorization$Preparer);
				case 'recruiter':
					return $elm$json$Json$Decode$succeed($author$project$Accounts$Authorization$Recruiter);
				case 'laborMarketCommunicator':
					return $elm$json$Json$Decode$succeed($author$project$Accounts$Authorization$LaborMarketCommunicator);
				default:
					return $elm$json$Json$Decode$fail('Trying to decode role, but \'' + (role + '\' is not supported.'));
			}
		},
		A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
}();
var $author$project$Accounts$Authorization$authorizationDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'roles',
	$elm$json$Json$Decode$list($author$project$Accounts$Authorization$roleDecoder),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'from',
		$author$project$Date$DeliveryDate$decoder,
		$elm$json$Json$Decode$succeed($author$project$Accounts$Authorization$Authorization)));
var $author$project$Accounts$Authorization$getAuthorizationsCmd = F4(
	function (token, accountId, date, toMsg) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'accounts',
					$author$project$Accounts$Account$encodeForUrl(accountId),
					$author$project$Date$DeliveryDate$encodeForUrl(date),
					'authorizations'
				]),
			_List_Nil);
		return A4(
			$author$project$Api$Request$get,
			token,
			toMsg,
			uri,
			$elm$json$Json$Decode$list($author$project$Accounts$Authorization$authorizationDecoder));
	});
var $author$project$Portal$Share$data = function (_v0) {
	var model = _v0;
	return model.cf;
};
var $author$project$Portal$Init$data = function (_v0) {
	var share = _v0.fQ;
	return $author$project$Portal$Share$data(share);
};
var $author$project$Portal$Init$ifNothing = F4(
	function (accessor, toAction, cmd, model) {
		var _v0 = accessor(
			$author$project$Portal$Init$data(model));
		if (!_v0.$) {
			return model;
		} else {
			return A3($author$project$Portal$Init$addTrackedCommand, toAction, cmd, model);
		}
	});
var $author$project$Portal$Init$keyed = F2(
	function (share, key) {
		return {aC: _List_Nil, iY: key, fQ: share};
	});
var $author$project$Accounts$Account$print = function (_v0) {
	var accountId = _v0;
	return $danyx23$elm_uuid$Uuid$toString(accountId);
};
var $author$project$Accounts$Account$comparable = $author$project$Accounts$Account$print;
var $author$project$Accounts$Edit$actionIdFor = F2(
	function (id, accountId) {
		return A2($author$project$Portal$Waiting$Id, 'accounts' + accountId, id);
	});
var $author$project$Accounts$Edit$singleAction = F2(
	function (id, accountId) {
		return $author$project$Portal$Waiting$singleAction(
			A2($author$project$Accounts$Edit$actionIdFor, id, accountId));
	});
var $author$project$Accounts$Edit$loadingAccount = A2(
	$elm$core$Basics$composeR,
	$author$project$Accounts$Account$comparable,
	$author$project$Accounts$Edit$singleAction('loadingAccount'));
var $author$project$Accounts$Edit$loadingAuthorizations = A2(
	$elm$core$Basics$composeR,
	$author$project$Accounts$Account$comparable,
	$author$project$Accounts$Edit$singleAction('loadingAuthorizations'));
var $author$project$Accounts$Edit$loadingDPs = A2(
	$elm$core$Basics$composeR,
	$author$project$Accounts$Account$comparable,
	$author$project$Accounts$Edit$singleAction('loadingDPs'));
var $author$project$Portal$Init$withModelFromData = F2(
	function (toModel, model) {
		return A2(
			$author$project$Portal$Init$withModel,
			toModel(
				$author$project$Portal$Init$data(model)),
			model);
	});
var $author$project$Accounts$Edit$init = F2(
	function (share, accountId) {
		var token = $author$project$Portal$Share$token(share);
		return A2(
			$author$project$Portal$Init$withModelFromData,
			function (shareData) {
				return A2(
					$author$project$Accounts$Edit$Loading,
					accountId,
					{ca: $elm$core$Maybe$Nothing, az: $elm$core$Maybe$Nothing, A: shareData.A});
			},
			A4(
				$author$project$Portal$Init$ifNothing,
				function ($) {
					return $.A;
				},
				$author$project$Accounts$Edit$loadingDPs,
				A3(
					$author$project$DistributionPoint$DistributionPoint$loadNamesAndRegions,
					token,
					$author$project$Accounts$Edit$BackendRespondedDistributionPoints,
					$author$project$Portal$Share$today(share)),
				A3(
					$author$project$Portal$Init$withCommand,
					$author$project$Accounts$Edit$loadingAuthorizations,
					A4(
						$author$project$Accounts$Authorization$getAuthorizationsCmd,
						token,
						accountId,
						$author$project$Portal$Share$today(share),
						$author$project$Accounts$Edit$SystemGotAuthorizations),
					A3(
						$author$project$Portal$Init$withCommand,
						$author$project$Accounts$Edit$loadingAccount,
						A3($author$project$Accounts$Account$getAccountCmd, token, accountId, $author$project$Accounts$Edit$SystemGotAccount),
						A2($author$project$Portal$Init$keyed, share, accountId)))));
	});
var $author$project$Accounts$Overview$NoAccountSearched = function (a) {
	return {$: 0, a: a};
};
var $author$project$Accounts$Overview$init = function (share) {
	return A2(
		$author$project$Portal$Init$withModel,
		$author$project$Accounts$Overview$NoAccountSearched(
			{
				aj: {dC: '', f_: _List_Nil}
			}),
		$author$project$Portal$Init$empty(share));
};
var $author$project$Applicant$Overview$BackendRespondedApplicants = function (a) {
	return {$: 1, a: a};
};
var $author$project$Applicant$Overview$BackendRespondedDistributionPoints = function (a) {
	return {$: 3, a: a};
};
var $author$project$Applicant$Overview$Loading = function (a) {
	return {$: 0, a: a};
};
var $Gizra$elm_all_set$EverySet$EverySet = $elm$core$Basics$identity;
var $pzp1997$assoc_list$AssocList$D = $elm$core$Basics$identity;
var $pzp1997$assoc_list$AssocList$empty = _List_Nil;
var $Gizra$elm_all_set$EverySet$empty = $pzp1997$assoc_list$AssocList$empty;
var $author$project$Applicant$Applicant$Card = F8(
	function (id, name, bornOn, phone, availability, status, distributionPointId, assessment) {
		return {dQ: assessment, cY: availability, c$: bornOn, c2: distributionPointId, eg: id, ft: name, eq: phone, nS: status};
	});
var $author$project$Applicant$Applicant$NotAssessed = 1;
var $author$project$Date$DaysInTheWeek$DaysInTheWeek = $elm$core$Basics$identity;
var $author$project$Date$DaysInTheWeek$Grey = 0;
var $author$project$Date$DaysInTheWeek$Normal = 0;
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $author$project$Date$DaysInTheWeek$deliveryDays = _List_fromArray(
	[0, 1, 2, 3, 4, 5]);
var $pzp1997$assoc_list$AssocList$remove = F2(
	function (targetKey, _v0) {
		var alist = _v0;
		return A2(
			$elm$core$List$filter,
			function (_v1) {
				var key = _v1.a;
				return !_Utils_eq(key, targetKey);
			},
			alist);
	});
var $pzp1997$assoc_list$AssocList$insert = F3(
	function (key, value, dict) {
		var _v0 = A2($pzp1997$assoc_list$AssocList$remove, key, dict);
		var alteredAlist = _v0;
		return A2(
			$elm$core$List$cons,
			_Utils_Tuple2(key, value),
			alteredAlist);
	});
var $Gizra$elm_all_set$EverySet$insert = F2(
	function (k, _v0) {
		var d = _v0;
		return A3($pzp1997$assoc_list$AssocList$insert, k, 0, d);
	});
var $Gizra$elm_all_set$EverySet$fromList = function (xs) {
	return A3($elm$core$List$foldl, $Gizra$elm_all_set$EverySet$insert, $Gizra$elm_all_set$EverySet$empty, xs);
};
var $author$project$Date$DaysInTheWeek$everyDeliveryDay = {
	e1: $Gizra$elm_all_set$EverySet$fromList($author$project$Date$DaysInTheWeek$deliveryDays),
	da: 0,
	bB: 0
};
var $author$project$Date$DaysInTheWeek$allDays = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6]);
var $author$project$Date$DaysInTheWeek$dayIndex = function (day) {
	switch (day) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		default:
			return 6;
	}
};
var $author$project$Date$DaysInTheWeek$fromBitmask = function (mask) {
	var maskFor = function (day) {
		return 1 << $author$project$Date$DaysInTheWeek$dayIndex(day);
	};
	return {
		e1: $Gizra$elm_all_set$EverySet$fromList(
			A2(
				$elm$core$List$filter,
				function (d) {
					return !(!(maskFor(d) & mask));
				},
				$author$project$Date$DaysInTheWeek$allDays)),
		da: 0,
		bB: 0
	};
};
var $author$project$Date$DaysInTheWeek$emptyIsEveryDeliveryDayDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (i) {
		return $elm$json$Json$Decode$succeed(
			(!i) ? $author$project$Date$DaysInTheWeek$everyDeliveryDay : $author$project$Date$DaysInTheWeek$fromBitmask(i));
	},
	$elm$json$Json$Decode$int);
var $author$project$Applicant$Applicant$Id = $elm$core$Basics$identity;
var $author$project$Applicant$Applicant$idDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $danyx23$elm_uuid$Uuid$decoder);
var $author$project$Applicant$Applicant$Passed = 0;
var $author$project$Applicant$Applicant$passedAssessmentDecoder = function (b) {
	if (b) {
		return $elm$json$Json$Decode$succeed(0);
	} else {
		return $elm$json$Json$Decode$succeed(1);
	}
};
var $author$project$Applicant$Applicant$Canceled = {$: 19};
var $author$project$Applicant$Applicant$CanceledDueToPay = {$: 17};
var $author$project$Applicant$Applicant$CanceledOtherJob = {$: 18};
var $author$project$Applicant$Applicant$ContractAtApplicant = {$: 6};
var $author$project$Applicant$Applicant$ContractAtDPG = {$: 8};
var $author$project$Applicant$Applicant$ContractAtDistributor = {$: 5};
var $author$project$Applicant$Applicant$ContractAtParent = {$: 7};
var $author$project$Applicant$Applicant$ContractFullySigned = {$: 9};
var $author$project$Applicant$Applicant$DeniedDueToAge = {$: 12};
var $author$project$Applicant$Applicant$DeniedNoLotAvailable = {$: 14};
var $author$project$Applicant$Applicant$DeniedNotLegitimate = {$: 13};
var $author$project$Applicant$Applicant$DeniedNotSuitable = {$: 16};
var $author$project$Applicant$Applicant$DeniedOutsideOfDistributionArea = {$: 15};
var $author$project$Applicant$Applicant$Duplicate = {$: 20};
var $author$project$Applicant$Applicant$NotReachedYet = {$: 1};
var $author$project$Applicant$Applicant$OnWaitingList = {$: 4};
var $author$project$Applicant$Applicant$Registered = {$: 0};
var $author$project$Applicant$Applicant$Scheduled = {$: 2};
var $author$project$Applicant$Applicant$Starting = {$: 10};
var $author$project$Applicant$Applicant$TwvRequested = {$: 3};
var $author$project$Applicant$Applicant$UnknownStatus = function (a) {
	return {$: 21, a: a};
};
var $author$project$Applicant$Applicant$Unreachable = {$: 11};
var $author$project$Applicant$Applicant$statusFromString = function (string) {
	switch (string) {
		case 'Aanmelding':
			return $author$project$Applicant$Applicant$Registered;
		case 'Nog niet bereikt':
			return $author$project$Applicant$Applicant$NotReachedYet;
		case 'Gesprek':
			return $author$project$Applicant$Applicant$Scheduled;
		case 'TWV aanvraag':
			return $author$project$Applicant$Applicant$TwvRequested;
		case 'Wachtlijst':
			return $author$project$Applicant$Applicant$OnWaitingList;
		case 'Contract needs signing by distributor':
			return $author$project$Applicant$Applicant$ContractAtDistributor;
		case 'Contract needs signing by applicant':
			return $author$project$Applicant$Applicant$ContractAtApplicant;
		case 'Contract needs signing by parent':
			return $author$project$Applicant$Applicant$ContractAtParent;
		case 'Contract needs signing by DPG':
			return $author$project$Applicant$Applicant$ContractAtDPG;
		case 'Contract signed by everyone':
			return $author$project$Applicant$Applicant$ContractFullySigned;
		case 'Start':
			return $author$project$Applicant$Applicant$Starting;
		case 'Niet bereikt':
			return $author$project$Applicant$Applicant$Unreachable;
		case 'Afwijzing: Leeftijd':
			return $author$project$Applicant$Applicant$DeniedDueToAge;
		case 'Afwijzing: Niet Serieus':
			return $author$project$Applicant$Applicant$DeniedNotLegitimate;
		case 'Afwijzing: Geen wijk':
			return $author$project$Applicant$Applicant$DeniedNoLotAvailable;
		case 'Afwijzing: Bezorggebied':
			return $author$project$Applicant$Applicant$DeniedOutsideOfDistributionArea;
		case 'Afwijzing: Niet geschikt':
			return $author$project$Applicant$Applicant$DeniedNotSuitable;
		case 'Afgehaakt: Vergoeding':
			return $author$project$Applicant$Applicant$CanceledDueToPay;
		case 'Afgehaakt: Ander werk':
			return $author$project$Applicant$Applicant$CanceledOtherJob;
		case 'Afgehaakt: Overig':
			return $author$project$Applicant$Applicant$Canceled;
		case 'Dubbele aanmelding':
			return $author$project$Applicant$Applicant$Duplicate;
		default:
			var unknown = string;
			return $author$project$Applicant$Applicant$UnknownStatus(unknown);
	}
};
var $author$project$Applicant$Applicant$statusDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $author$project$Applicant$Applicant$statusFromString, $elm$json$Json$Decode$succeed),
	$elm$json$Json$Decode$string);
var $author$project$Applicant$Applicant$cardDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'passedAssessment',
	A2($elm$json$Json$Decode$andThen, $author$project$Applicant$Applicant$passedAssessmentDecoder, $elm$json$Json$Decode$bool),
	1,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'dp',
		$author$project$DistributionPoint$DistributionPoint$idDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$author$project$Applicant$Applicant$statusDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'availability',
				$author$project$Date$DaysInTheWeek$emptyIsEveryDeliveryDayDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'primaryPhoneNumber',
					$elm$json$Json$Decode$string,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'dateOfBirth',
						$elm$json$Json$Decode$maybe($author$project$Date$DeliveryDate$decoder),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'name',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$author$project$Applicant$Applicant$idDecoder,
								$elm$json$Json$Decode$succeed($author$project$Applicant$Applicant$Card)))))))));
var $elm$json$Json$Encode$string = _Json_wrap;
var $danyx23$elm_uuid$Uuid$encode = A2($elm$core$Basics$composeR, $danyx23$elm_uuid$Uuid$toString, $elm$json$Json$Encode$string);
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$DistributionPoint$DistributionPoint$encodeDistributionPoints = A2(
	$elm$core$Basics$composeL,
	$elm$json$Json$Encode$list($danyx23$elm_uuid$Uuid$encode),
	$elm$core$List$map(
		function ($) {
			return $.eg;
		}));
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Api$Request$post = F6(
	function (token, toMsg, url, body, decoder, tracker) {
		return $elm$http$Http$request(
			{
				aA: body,
				aJ: A2($elm$http$Http$expectJson, toMsg, decoder),
				aK: $author$project$Api$Request$headers(token),
				aO: 'POST',
				aS: $elm$core$Maybe$Nothing,
				aU: $author$project$Api$Request$trackingFor(tracker),
				aW: url
			});
	});
var $author$project$Applicant$Applicant$loadApplicantsCmd = F3(
	function (token, toMsg, distributionPoints) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['applicants', 'find-for-overview']),
			_List_Nil);
		return A5(
			$author$project$Api$Request$post,
			token,
			toMsg,
			uri,
			$elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'dpIds',
							$author$project$DistributionPoint$DistributionPoint$encodeDistributionPoints(distributionPoints))
						]))),
			$elm$json$Json$Decode$list($author$project$Applicant$Applicant$cardDecoder));
	});
var $author$project$Applicant$Applicant$idForUrl = function (_v0) {
	var id = _v0;
	return $danyx23$elm_uuid$Uuid$toString(id);
};
var $author$project$Applicant$Overview$actionIdFor = F2(
	function (id, applicantId) {
		if (!applicantId.$) {
			var aId = applicantId.a;
			return A2(
				$author$project$Portal$Waiting$Id,
				'applicants' + $author$project$Applicant$Applicant$idForUrl(aId),
				id);
		} else {
			return A2($author$project$Portal$Waiting$Id, 'applicants', id);
		}
	});
var $author$project$Applicant$Overview$singleAction = F2(
	function (id, applicantId) {
		return $author$project$Portal$Waiting$singleAction(
			A2($author$project$Applicant$Overview$actionIdFor, id, applicantId));
	});
var $author$project$Applicant$Overview$loadingApplicants = function (_v0) {
	return A2($author$project$Applicant$Overview$singleAction, 'loadingApplicants', $elm$core$Maybe$Nothing);
};
var $author$project$Applicant$Overview$loadingDPs = function (_v0) {
	return A2($author$project$Applicant$Overview$singleAction, 'loadingDPs', $elm$core$Maybe$Nothing);
};
var $author$project$Ports$rememberedValue = _Platform_outgoingPort('rememberedValue', $elm$json$Json$Encode$string);
var $author$project$Portal$Init$addUntrackedCommand = F2(
	function (cmd, _v0) {
		var share = _v0.fQ;
		var key = _v0.iY;
		var commands = _v0.aC;
		return {
			aC: A2(
				$elm$core$List$cons,
				cmd($author$project$Api$Request$Untracked),
				commands),
			iY: key,
			fQ: share
		};
	});
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $author$project$Portal$Init$withBackgroundCommand = F2(
	function (cmd, model) {
		return A2(
			$author$project$Portal$Init$addUntrackedCommand,
			$elm$core$Basics$always(cmd),
			model);
	});
var $author$project$Applicant$Overview$init = function (share) {
	var _v0 = $author$project$Portal$Share$data(share).A;
	if (!_v0.$) {
		var distributionPoints = _v0.a;
		return A2(
			$author$project$Portal$Init$withModel,
			$author$project$Applicant$Overview$Loading($Gizra$elm_all_set$EverySet$empty),
			A2(
				$author$project$Portal$Init$withBackgroundCommand,
				$author$project$Ports$rememberedValue('applicant-dp-filter'),
				A3(
					$author$project$Portal$Init$withCommand,
					$author$project$Applicant$Overview$loadingApplicants,
					A3(
						$author$project$Applicant$Applicant$loadApplicantsCmd,
						$author$project$Portal$Share$token(share),
						$author$project$Applicant$Overview$BackendRespondedApplicants,
						distributionPoints),
					$author$project$Portal$Init$empty(share))));
	} else {
		return A2(
			$author$project$Portal$Init$withModel,
			$author$project$Applicant$Overview$Loading($Gizra$elm_all_set$EverySet$empty),
			A2(
				$author$project$Portal$Init$withBackgroundCommand,
				$author$project$Ports$rememberedValue('applicant-dp-filter'),
				A3(
					$author$project$Portal$Init$withCommand,
					$author$project$Applicant$Overview$loadingDPs,
					A3(
						$author$project$DistributionPoint$DistributionPoint$loadNamesAndRegions,
						$author$project$Portal$Share$token(share),
						$author$project$Applicant$Overview$BackendRespondedDistributionPoints,
						$author$project$Portal$Share$today(share)),
					$author$project$Portal$Init$empty(share))));
	}
};
var $author$project$Compensation$Add$BackendRespondedDistributionPoint = function (a) {
	return {$: 1, a: a};
};
var $author$project$Compensation$Add$Loading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Compensation$Add$SystemGotPlanLoaderMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Portal$Subheader$Hidden = function (a) {
	return {$: 0, a: a};
};
var $author$project$Portal$Subheader$initCalendarState = $author$project$Portal$Subheader$Hidden(
	{fT: $elm$core$Maybe$Nothing});
var $author$project$Plan$Plan$Id = F2(
	function (distributionPointID, date) {
		return {lx: date, gm: distributionPointID};
	});
var $author$project$Plan$PlanLoader$Loaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Plan$PlanLoader$LoadingDeliverers = function (a) {
	return {$: 0, a: a};
};
var $author$project$Plan$PlanLoader$initModel = F4(
	function (share, convert, dpId, date) {
		var shareData = $author$project$Portal$Share$data(share);
		var _v0 = _Utils_Tuple2(shareData.id, shareData.fA);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var d = _v0.a.a;
			var p = _v0.b.a;
			return $author$project$Plan$PlanLoader$Loaded(
				convert(
					{e4: d, fA: p}));
		} else {
			return $author$project$Plan$PlanLoader$LoadingDeliverers(
				{
					a8: A2($author$project$Plan$Plan$Id, dpId, date),
					aQ: $elm$core$Maybe$Nothing,
					aV: $elm$core$Maybe$Nothing
				});
		}
	});
var $author$project$DistributionPoint$DistributionPoint$DistributionPoint = $elm$core$Basics$identity;
var $author$project$DistributionPoint$DistributionPoint$DistributionPointInfo = function (id) {
	return function (name) {
		return function (address) {
			return function (segments) {
				return function (preSupplies) {
					return function (assistantPositions) {
						return function (inserterPositions) {
							return function (subDistributionPoints) {
								return function (tags) {
									return function (region) {
										return {f1: address, hT: assistantPositions, eg: id, iS: inserterPositions, ft: name, jA: preSupplies, nq: region, bb: segments, hw: subDistributionPoints, kn: tags};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$DistributionPoint$DistributionPoint$assistantPositionIdDecoder = $danyx23$elm_uuid$Uuid$decoder;
var $author$project$Address$Address$Address = F6(
	function (municipal, street, zipCode, houseNumber, countryCode, location) {
		return {h8: countryCode, bs: houseNumber, i3: location, bU: municipal, b5: street, cT: zipCode};
	});
var $author$project$Address$Address$HouseNumber = F2(
	function (number, suffix) {
		return {bX: number, dE: suffix};
	});
var $author$project$Address$Address$Unknown = 3;
var $author$project$Address$Address$BE = 1;
var $author$project$Address$Address$DE = 2;
var $author$project$Address$Address$NL = 0;
var $author$project$Address$Address$countryCodeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		var _v0 = $elm$core$String$toLower(string);
		switch (_v0) {
			case 'nl':
				return $elm$json$Json$Decode$succeed(0);
			case 'be':
				return $elm$json$Json$Decode$succeed(1);
			case 'de':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$succeed(3);
		}
	},
	$elm$json$Json$Decode$string);
var $mgold$elm_geojson$GeoJson$decodeBbox = $elm$json$Json$Decode$list($elm$json$Json$Decode$float);
var $mgold$elm_geojson$GeoJson$Feature = function (a) {
	return {$: 1, a: a};
};
var $mgold$elm_geojson$GeoJson$FeatureCollection = function (a) {
	return {$: 2, a: a};
};
var $mgold$elm_geojson$GeoJson$Geometry = function (a) {
	return {$: 0, a: a};
};
var $mgold$elm_geojson$GeoJson$FeatureObject = F3(
	function (geometry, properties, id) {
		return {l4: geometry, eg: id, jK: properties};
	});
var $mgold$elm_geojson$GeoJson$GeometryCollection = function (a) {
	return {$: 6, a: a};
};
var $mgold$elm_geojson$GeoJson$LineString = function (a) {
	return {$: 2, a: a};
};
var $mgold$elm_geojson$GeoJson$MultiLineString = function (a) {
	return {$: 3, a: a};
};
var $mgold$elm_geojson$GeoJson$MultiPoint = function (a) {
	return {$: 1, a: a};
};
var $mgold$elm_geojson$GeoJson$MultiPolygon = function (a) {
	return {$: 5, a: a};
};
var $mgold$elm_geojson$GeoJson$Point = function (a) {
	return {$: 0, a: a};
};
var $mgold$elm_geojson$GeoJson$Polygon = function (a) {
	return {$: 4, a: a};
};
var $mgold$elm_geojson$GeoJson$decodePosition = function () {
	var errorString = function (adj) {
		return 'Array has too ' + (adj + ' numbers to make a position');
	};
	var listToTuple = function (ps) {
		if (!ps.b) {
			return $elm$json$Json$Decode$fail(
				errorString('few'));
		} else {
			if (!ps.b.b) {
				return $elm$json$Json$Decode$fail(
					errorString('few'));
			} else {
				if (!ps.b.b.b) {
					var p1 = ps.a;
					var _v1 = ps.b;
					var p2 = _v1.a;
					return $elm$json$Json$Decode$succeed(
						_Utils_Tuple3(p1, p2, 0));
				} else {
					if (!ps.b.b.b.b) {
						var p1 = ps.a;
						var _v2 = ps.b;
						var p2 = _v2.a;
						var _v3 = _v2.b;
						var p3 = _v3.a;
						return $elm$json$Json$Decode$succeed(
							_Utils_Tuple3(p1, p2, p3));
					} else {
						return $elm$json$Json$Decode$fail(
							errorString('many'));
					}
				}
			}
		}
	};
	return A2(
		$elm$json$Json$Decode$andThen,
		listToTuple,
		$elm$json$Json$Decode$list($elm$json$Json$Decode$float));
}();
function $mgold$elm_geojson$GeoJson$cyclic$decodeGeometry() {
	var helper = function (tipe) {
		switch (tipe) {
			case 'Point':
				return A2(
					$elm$json$Json$Decode$map,
					$mgold$elm_geojson$GeoJson$Point,
					A2($elm$json$Json$Decode$field, 'coordinates', $mgold$elm_geojson$GeoJson$decodePosition));
			case 'MultiPoint':
				return A2(
					$elm$json$Json$Decode$map,
					$mgold$elm_geojson$GeoJson$MultiPoint,
					A2(
						$elm$json$Json$Decode$field,
						'coordinates',
						$elm$json$Json$Decode$list($mgold$elm_geojson$GeoJson$decodePosition)));
			case 'LineString':
				return A2(
					$elm$json$Json$Decode$map,
					$mgold$elm_geojson$GeoJson$LineString,
					A2(
						$elm$json$Json$Decode$field,
						'coordinates',
						$elm$json$Json$Decode$list($mgold$elm_geojson$GeoJson$decodePosition)));
			case 'MultiLineString':
				return A2(
					$elm$json$Json$Decode$map,
					$mgold$elm_geojson$GeoJson$MultiLineString,
					A2(
						$elm$json$Json$Decode$field,
						'coordinates',
						$elm$json$Json$Decode$list(
							$elm$json$Json$Decode$list($mgold$elm_geojson$GeoJson$decodePosition))));
			case 'Polygon':
				return A2(
					$elm$json$Json$Decode$map,
					$mgold$elm_geojson$GeoJson$Polygon,
					A2(
						$elm$json$Json$Decode$field,
						'coordinates',
						$elm$json$Json$Decode$list(
							$elm$json$Json$Decode$list($mgold$elm_geojson$GeoJson$decodePosition))));
			case 'MultiPolygon':
				return A2(
					$elm$json$Json$Decode$map,
					$mgold$elm_geojson$GeoJson$MultiPolygon,
					A2(
						$elm$json$Json$Decode$field,
						'coordinates',
						$elm$json$Json$Decode$list(
							$elm$json$Json$Decode$list(
								$elm$json$Json$Decode$list($mgold$elm_geojson$GeoJson$decodePosition)))));
			case 'GeometryCollection':
				return A2(
					$elm$json$Json$Decode$map,
					$mgold$elm_geojson$GeoJson$GeometryCollection,
					A2(
						$elm$json$Json$Decode$field,
						'geometries',
						$elm$json$Json$Decode$list(
							$mgold$elm_geojson$GeoJson$cyclic$decodeGeometry())));
			default:
				return $elm$json$Json$Decode$fail('Unrecognized \'type\': ' + tipe);
		}
	};
	return A2(
		$elm$json$Json$Decode$andThen,
		helper,
		A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
}
var $mgold$elm_geojson$GeoJson$decodeGeometry = $mgold$elm_geojson$GeoJson$cyclic$decodeGeometry();
$mgold$elm_geojson$GeoJson$cyclic$decodeGeometry = function () {
	return $mgold$elm_geojson$GeoJson$decodeGeometry;
};
var $mgold$elm_geojson$GeoJson$decodeFeature = A4(
	$elm$json$Json$Decode$map3,
	$mgold$elm_geojson$GeoJson$FeatureObject,
	A2(
		$elm$json$Json$Decode$field,
		'geometry',
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $mgold$elm_geojson$GeoJson$decodeGeometry)
				]))),
	A2($elm$json$Json$Decode$field, 'properties', $elm$json$Json$Decode$value),
	$elm$json$Json$Decode$maybe(
		A2(
			$elm$json$Json$Decode$field,
			'id',
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						$elm$json$Json$Decode$string,
						A2($elm$json$Json$Decode$map, $elm$core$String$fromInt, $elm$json$Json$Decode$int)
					])))));
var $mgold$elm_geojson$GeoJson$decodeGeoJson = function () {
	var helper = function (h_tipe) {
		switch (h_tipe) {
			case 'Feature':
				return A2($elm$json$Json$Decode$map, $mgold$elm_geojson$GeoJson$Feature, $mgold$elm_geojson$GeoJson$decodeFeature);
			case 'FeatureCollection':
				return A2(
					$elm$json$Json$Decode$map,
					$mgold$elm_geojson$GeoJson$FeatureCollection,
					A2(
						$elm$json$Json$Decode$field,
						'features',
						$elm$json$Json$Decode$list($mgold$elm_geojson$GeoJson$decodeFeature)));
			default:
				return A2($elm$json$Json$Decode$map, $mgold$elm_geojson$GeoJson$Geometry, $mgold$elm_geojson$GeoJson$decodeGeometry);
		}
	};
	return A2(
		$elm$json$Json$Decode$andThen,
		helper,
		A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
}();
var $mgold$elm_geojson$GeoJson$decoder = A3(
	$elm$json$Json$Decode$map2,
	$elm$core$Tuple$pair,
	$mgold$elm_geojson$GeoJson$decodeGeoJson,
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'bbox', $mgold$elm_geojson$GeoJson$decodeBbox)));
var $elm$json$Json$Decode$index = _Json_decodeIndex;
var $author$project$Address$Address$houseNumberDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$andThen,
			function (i) {
				return $elm$json$Json$Decode$succeed(
					A2($author$project$Address$Address$HouseNumber, i, $elm$core$Maybe$Nothing));
			},
			$elm$json$Json$Decode$int),
			A3(
			$elm$json$Json$Decode$map2,
			$author$project$Address$Address$HouseNumber,
			A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$int),
			A2(
				$elm$json$Json$Decode$index,
				1,
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string))),
			A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'suffix',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'number',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Address$Address$HouseNumber))),
			A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'numberAdditions',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'number',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Address$Address$HouseNumber)))
		]));
var $author$project$Address$Address$decoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'location',
			$elm$json$Json$Decode$maybe($mgold$elm_geojson$GeoJson$decoder),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'countryCode',
				$author$project$Address$Address$countryCodeDecoder,
				3,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'houseNumber',
					$author$project$Address$Address$houseNumberDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'zipCode',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'street',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'municipal',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Address$Address$Address))))))),
			A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'location',
			$elm$json$Json$Decode$maybe($mgold$elm_geojson$GeoJson$decoder),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'countryCode',
				$author$project$Address$Address$countryCodeDecoder,
				3,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'suffix',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'number',
							$elm$json$Json$Decode$int,
							$elm$json$Json$Decode$succeed($author$project$Address$Address$HouseNumber))),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'zipCode',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'street',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'municipal',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Address$Address$Address))))))),
			A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'location',
			$elm$json$Json$Decode$maybe($mgold$elm_geojson$GeoJson$decoder),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'countryCode',
				$author$project$Address$Address$countryCodeDecoder,
				3,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'number',
					$author$project$Address$Address$houseNumberDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'postcode',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'street',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'municipal',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Address$Address$Address)))))))
		]));
var $author$project$Reference$Reference = F3(
	function (id, name, tags) {
		return {eg: id, ft: name, kn: tags};
	});
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $author$project$Reference$decoder = function (idDec) {
	return A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'tags',
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
		$elm$core$Dict$empty,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				idDec,
				$elm$json$Json$Decode$succeed($author$project$Reference$Reference))));
};
var $author$project$DistributionPoint$DistributionPoint$inserterPositionIdDecoder = $danyx23$elm_uuid$Uuid$decoder;
var $author$project$DistributionPoint$DistributionPoint$preSupplyIdDecoder = $danyx23$elm_uuid$Uuid$decoder;
var $author$project$DistributionPoint$DistributionPoint$Individual = 0;
var $author$project$DistributionPoint$DistributionPoint$WithGeometry = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$DistributionPoint$DistributionPoint$WithoutGeometry = function (a) {
	return {$: 1, a: a};
};
var $author$project$DistributionPoint$DistributionPoint$Bundled = 1;
var $author$project$DistributionPoint$DistributionPoint$orderTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		if (str === 'bundled') {
			return $elm$json$Json$Decode$succeed(1);
		} else {
			return $elm$json$Json$Decode$fail('Invalid OrderType');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$DistributionPoint$DistributionPoint$segmentIdDecoder = $danyx23$elm_uuid$Uuid$decoder;
var $author$project$DistributionPoint$DistributionPoint$Bicycle = 0;
var $author$project$DistributionPoint$DistributionPoint$Car = 2;
var $author$project$DistributionPoint$DistributionPoint$Stint = 1;
var $author$project$DistributionPoint$DistributionPoint$vehicleDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'bicycle':
				return $elm$json$Json$Decode$succeed(0);
			case 'stint':
				return $elm$json$Json$Decode$succeed(1);
			case 'car':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Ongeldig voertuig');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$DistributionPoint$DistributionPoint$segmentDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'tags',
	$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
	$elm$core$Dict$empty,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'duration',
		$elm$json$Json$Decode$int,
		0,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'orderType',
			$author$project$DistributionPoint$DistributionPoint$orderTypeDecoder,
			0,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'defaultVehicle',
				$elm$json$Json$Decode$maybe($author$project$DistributionPoint$DistributionPoint$vehicleDecoder),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					$elm$json$Json$Decode$string,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'contour',
						$elm$json$Json$Decode$maybe($mgold$elm_geojson$GeoJson$decoder),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$author$project$DistributionPoint$DistributionPoint$segmentIdDecoder,
							$elm$json$Json$Decode$succeed(
								F7(
									function (id, contour, name, defaultVehicle, orderType, duration, tags) {
										if (!contour.$) {
											var c = contour.a;
											return A2(
												$author$project$DistributionPoint$DistributionPoint$WithGeometry,
												c,
												{e2: defaultVehicle, e8: duration, eg: id, ft: name, g4: orderType, kn: tags});
										} else {
											return $author$project$DistributionPoint$DistributionPoint$WithoutGeometry(
												{e2: defaultVehicle, e8: duration, eg: id, ft: name, g4: orderType, kn: tags});
										}
									})))))))));
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom);
var $author$project$DistributionPoint$DistributionPoint$subDistributionPointDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
		A2($author$project$DistributionPoint$DistributionPoint$Region, 0, ''),
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			$elm$core$Dict$empty,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
				_List_Nil,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
					_List_Nil,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
						_List_Nil,
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
							_List_Nil,
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
								_List_Nil,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'address',
									$author$project$Address$Address$decoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'name',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$author$project$DistributionPoint$DistributionPoint$idDecoder,
											$elm$json$Json$Decode$succeed($author$project$DistributionPoint$DistributionPoint$DistributionPointInfo))))))))))));
var $author$project$DistributionPoint$DistributionPoint$distributionPointDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'region',
		A3(
			$elm$json$Json$Decode$map2,
			$author$project$DistributionPoint$DistributionPoint$Region,
			A2($elm$json$Json$Decode$field, 'number', $elm$json$Json$Decode$int),
			A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string)),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'tags',
			$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
			$elm$core$Dict$empty,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'distributionPoints',
				$elm$json$Json$Decode$list($author$project$DistributionPoint$DistributionPoint$subDistributionPointDecoder),
				_List_Nil,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'inserting',
					$elm$json$Json$Decode$list(
						$author$project$Reference$decoder($author$project$DistributionPoint$DistributionPoint$inserterPositionIdDecoder)),
					_List_Nil,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'assisting',
						$elm$json$Json$Decode$list(
							$author$project$Reference$decoder($author$project$DistributionPoint$DistributionPoint$assistantPositionIdDecoder)),
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'preSupplies',
							$elm$json$Json$Decode$list(
								$author$project$Reference$decoder($author$project$DistributionPoint$DistributionPoint$preSupplyIdDecoder)),
							_List_Nil,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'segments',
								$elm$json$Json$Decode$list($author$project$DistributionPoint$DistributionPoint$segmentDecoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'address',
									$author$project$Address$Address$decoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'name',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$author$project$DistributionPoint$DistributionPoint$idDecoder,
											$elm$json$Json$Decode$succeed($author$project$DistributionPoint$DistributionPoint$DistributionPointInfo))))))))))));
var $author$project$DistributionPoint$DistributionPoint$encodeIdForUrl = A2($elm$core$Basics$composeR, $danyx23$elm_uuid$Uuid$toString, $elm$core$String$toLower);
var $author$project$DistributionPoint$DistributionPoint$loadCmd = F4(
	function (token, toMsg, dpId, date) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'distributionpoints',
					$author$project$DistributionPoint$DistributionPoint$encodeIdForUrl(dpId),
					'segments',
					$author$project$Date$DeliveryDate$encodeForUrl(date)
				]),
			_List_Nil);
		return A4($author$project$Api$Request$get, token, toMsg, uri, $author$project$DistributionPoint$DistributionPoint$distributionPointDecoder);
	});
var $author$project$DistributionPoint$DistributionPoint$comparableId = $danyx23$elm_uuid$Uuid$toString;
var $author$project$Date$DeliveryDate$oldestFirst = function (_v0) {
	var date = _v0;
	return A2(
		$elm$core$String$join,
		'-',
		_List_fromArray(
			[
				$author$project$Date$DeliveryDate$viewYear(date.kC),
				$author$project$Date$DeliveryDate$viewMonth(date.a5),
				$author$project$Date$DeliveryDate$viewDay(date.a2)
			]));
};
var $author$project$Compensation$Add$actionIdFor = F2(
	function (id, _v0) {
		var dpId = _v0.a;
		var date = _v0.b;
		return A2(
			$author$project$Portal$Waiting$Id,
			'compensation' + ($author$project$DistributionPoint$DistributionPoint$comparableId(dpId) + $author$project$Date$DeliveryDate$oldestFirst(date)),
			id);
	});
var $author$project$Compensation$Add$singleAction = F2(
	function (id, unique) {
		return $author$project$Portal$Waiting$singleAction(
			A2($author$project$Compensation$Add$actionIdFor, id, unique));
	});
var $author$project$Compensation$Add$loadingDP = $author$project$Compensation$Add$singleAction('loadingDP');
var $author$project$Compensation$Add$loadingPlan = F2(
	function (key, stage) {
		return A2($author$project$Compensation$Add$singleAction, 'loadingPlan' + stage, key);
	});
var $author$project$Compensation$Add$Failed = function (a) {
	return {$: 3, a: a};
};
var $author$project$Compensation$Add$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Compensation$Add$NoConfirmation = {$: 0};
var $author$project$Compensation$Add$NoPlan = function (a) {
	return {$: 2, a: a};
};
var $author$project$Compensation$Form$CompensationForSegment = 0;
var $author$project$Compensation$Type$TaxIncluded = 0;
var $timo_weike$generic_collections$ManualDict$Dict = $elm$core$Basics$identity;
var $timo_weike$generic_collections$ManualDict$empty = $elm$core$Dict$empty;
var $author$project$Deliverer$TypedDict$empty = $timo_weike$generic_collections$ManualDict$empty;
var $timo_weike$generic_collections$ManualDict$foldr = F3(
	function (f, start, _v0) {
		var dict = _v0;
		var combine = F3(
			function (_v1, _v2, prev) {
				var key = _v2.a;
				var value = _v2.b;
				return A3(f, key, value, prev);
			});
		return A3($elm$core$Dict$foldr, combine, start, dict);
	});
var $timo_weike$generic_collections$ManualDict$insert = F4(
	function (f, key, value, _v0) {
		var dict = _v0;
		return A3(
			$elm$core$Dict$insert,
			f(key),
			_Utils_Tuple2(key, value),
			dict);
	});
var $author$project$Deliverer$Deliverer$comparableId = function (_v0) {
	var id = _v0;
	return $danyx23$elm_uuid$Uuid$toString(id);
};
var $author$project$Deliverer$Colors$Blue = 0;
var $author$project$Deliverer$Deliverer$Deliverer = F9(
	function (id, firstName, lastName, color, tags, preferredProduct, homeLocationId, locations, supplyPeriods) {
		return {eS: color, fc: firstName, md: homeLocationId, eg: id, fo: lastName, i4: locations, nj: preferredProduct, kk: supplyPeriods, kn: tags};
	});
var $author$project$Deliverer$Deliverer$LocationId = $elm$core$Basics$identity;
var $author$project$Deliverer$Deliverer$locationIdFromString = function (id) {
	return id;
};
var $author$project$Deliverer$Deliverer$fromTyped = function (typedDeliverer) {
	switch (typedDeliverer.$) {
		case 0:
			var deliverer = typedDeliverer.a;
			return deliverer;
		case 1:
			if (!typedDeliverer.b.$) {
				var deliverer = typedDeliverer.b.a;
				return deliverer;
			} else {
				var id = typedDeliverer.a;
				var _v1 = typedDeliverer.b;
				return A9(
					$author$project$Deliverer$Deliverer$Deliverer,
					id,
					'',
					'',
					0,
					$elm$core$Dict$empty,
					$elm$core$Maybe$Nothing,
					$author$project$Deliverer$Deliverer$locationIdFromString(''),
					_List_Nil,
					_List_Nil);
			}
		default:
			var deliverer = typedDeliverer.a;
			return deliverer;
	}
};
var $author$project$Deliverer$Deliverer$idFromTyped = A2(
	$elm$core$Basics$composeR,
	$author$project$Deliverer$Deliverer$fromTyped,
	function ($) {
		return $.eg;
	});
var $author$project$Deliverer$TypedDict$toComparable = A2($elm$core$Basics$composeR, $author$project$Deliverer$Deliverer$idFromTyped, $author$project$Deliverer$Deliverer$comparableId);
var $author$project$Deliverer$TypedDict$insert = $timo_weike$generic_collections$ManualDict$insert($author$project$Deliverer$TypedDict$toComparable);
var $author$project$Deliverer$TypedDict$filterMap = F2(
	function (f, dict) {
		return A3(
			$timo_weike$generic_collections$ManualDict$foldr,
			F3(
				function (k, v, curr) {
					var _v0 = A2(f, k, v);
					if (!_v0.$) {
						var w = _v0.a;
						return A3($author$project$Deliverer$TypedDict$insert, k, w, curr);
					} else {
						return curr;
					}
				}),
			$author$project$Deliverer$TypedDict$empty,
			dict);
	});
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $author$project$DistributionPoint$DistributionPoint$segmentId = function (segment) {
	if (!segment.$) {
		var info = segment.b;
		return info.eg;
	} else {
		var info = segment.a;
		return info.eg;
	}
};
var $author$project$DistributionPoint$DistributionPoint$findSegmentOnId = F2(
	function (_v0, sId) {
		var distributionPoint = _v0;
		return A2(
			$elm_community$list_extra$List$Extra$find,
			function (s) {
				return _Utils_eq(
					$author$project$DistributionPoint$DistributionPoint$segmentId(s),
					sId);
			},
			distributionPoint.bb);
	});
var $author$project$Plan$Supply$delivererOf = function (supplyItem) {
	switch (supplyItem.$) {
		case 0:
			var deliverer = supplyItem.a.bl;
			return $elm$core$Maybe$Just(deliverer);
		case 1:
			var deliverer = supplyItem.a.bl;
			return $elm$core$Maybe$Just(deliverer);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Plan$Supply$flatten = function (items) {
	return A2(
		$elm$core$List$concatMap,
		function (item) {
			switch (item.$) {
				case 1:
					return _List_fromArray(
						[item]);
				case 0:
					var car = item;
					var supplies = car.a.n0;
					return A2(
						$elm$core$List$cons,
						car,
						$author$project$Plan$Supply$flatten(supplies));
				default:
					return _List_fromArray(
						[item]);
			}
		},
		items);
};
var $author$project$Plan$Supply$findByDeliverer = F2(
	function (id, items) {
		return A2(
			$elm$core$List$filter,
			function (i) {
				var _v0 = $author$project$Plan$Supply$delivererOf(i);
				if (!_v0.$) {
					var d = _v0.a;
					return _Utils_eq(
						$author$project$Deliverer$Deliverer$idFromTyped(d),
						id);
				} else {
					return false;
				}
			},
			$author$project$Plan$Supply$flatten(items));
	});
var $author$project$Plan$Supply$ownClustersOf = function (item) {
	switch (item.$) {
		case 2:
			return _List_Nil;
		case 0:
			var cluster = item.a.H;
			return _List_fromArray(
				[cluster]);
		default:
			var clusters = item.a.k;
			return clusters;
	}
};
var $author$project$Plan$Supply$firstSegmentOf = F2(
	function (items, deliverer) {
		return A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.bb;
				},
				$elm$core$List$head),
			A2(
				$elm$core$Maybe$andThen,
				A2($elm$core$Basics$composeR, $author$project$Plan$Supply$ownClustersOf, $elm$core$List$head),
				$elm$core$List$head(
					A2(
						$author$project$Plan$Supply$findByDeliverer,
						$author$project$Deliverer$Deliverer$idFromTyped(deliverer),
						items))));
	});
var $timo_weike$generic_collections$ManualDict$fromList = F2(
	function (f, list) {
		return $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (t) {
					return _Utils_Tuple2(
						f(t.a),
						t);
				},
				list));
	});
var $author$project$Deliverer$TypedDict$fromList = $timo_weike$generic_collections$ManualDict$fromList($author$project$Deliverer$TypedDict$toComparable);
var $author$project$Compensation$Form$activeDeliverersFirstSegmentFrom = F3(
	function (dp, _v0, deliverers) {
		var items = _v0.gL;
		return A2(
			$author$project$Deliverer$TypedDict$filterMap,
			F2(
				function (_v1, segId) {
					return A2($author$project$DistributionPoint$DistributionPoint$findSegmentOnId, dp, segId);
				}),
			$author$project$Deliverer$TypedDict$fromList(
				A2(
					$elm$core$List$filterMap,
					function (d) {
						return A2(
							$elm$core$Maybe$map,
							$elm$core$Tuple$pair(d),
							A2($author$project$Plan$Supply$firstSegmentOf, items, d));
					},
					deliverers)));
	});
var $author$project$Compensation$Compensation$maxReasonCharacters = 254;
var $author$project$Compensation$Form$empty = F3(
	function (distributionPoint, deliverers, plan) {
		return {
			cV: A3($author$project$Compensation$Form$activeDeliverersFirstSegmentFrom, distributionPoint, plan, deliverers),
			f4: deliverers,
			aa: '',
			ap: $elm$core$Maybe$Nothing,
			dW: $PaackEng$elm_ui_dropdown$Dropdown$init('compensation-create-type-distribution-point'),
			c1: $PaackEng$elm_ui_dropdown$Dropdown$init('compensation-create-type-segment'),
			bl: $PaackEng$elm_ui_dropdown$Dropdown$init('compensation-create-deliverer'),
			d1: $elm$core$Maybe$Nothing,
			e3: _List_Nil,
			bn: distributionPoint,
			fA: plan,
			jL: '',
			fG: $author$project$Compensation$Compensation$maxReasonCharacters,
			fO: $PaackEng$elm_ui_dropdown$Dropdown$init('compensation-create-element'),
			b1: $elm$core$Maybe$Nothing,
			bc: $elm$core$Maybe$Nothing,
			cF: $elm$core$Maybe$Nothing,
			ak: $Gizra$elm_all_set$EverySet$empty,
			eu: $elm$core$Maybe$Nothing,
			al: 0,
			ae: 0,
			f_: _List_Nil
		};
	});
var $author$project$Deliverer$Deliverer$onlyRegistered = function (deliverer) {
	if (!deliverer.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $timo_weike$generic_collections$ManualDict$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$values(dict);
};
var $timo_weike$generic_collections$ManualDict$values = function (dict) {
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$second,
		$timo_weike$generic_collections$ManualDict$toList(dict));
};
var $author$project$Deliverer$IdDict$values = $timo_weike$generic_collections$ManualDict$values;
var $author$project$Compensation$Add$next = function (model) {
	if (!model.$) {
		var distributionPointId = model.a.c2;
		var currentDate = model.a.t;
		var calendarState = model.a.r;
		var distributionPoint = model.a.bn;
		var planAndDeliverers = model.a.fB;
		var _v1 = _Utils_Tuple2(distributionPoint, planAndDeliverers);
		_v1$3:
		while (true) {
			switch (_v1.b.$) {
				case 3:
					if (!_v1.a.$) {
						var dp = _v1.a.a;
						var plan = _v1.b.a.fA;
						var deliverers = _v1.b.a.e4;
						var registeredDeliverers = A2(
							$elm$core$List$filter,
							$author$project$Deliverer$Deliverer$onlyRegistered,
							$author$project$Deliverer$IdDict$values(deliverers));
						return $author$project$Compensation$Add$Loaded(
							{
								r: calendarState,
								eW: $author$project$Compensation$Add$NoConfirmation,
								t: currentDate,
								e4: registeredDeliverers,
								bn: dp,
								bO: A3($author$project$Compensation$Form$empty, dp, registeredDeliverers, plan),
								fA: plan
							});
					} else {
						break _v1$3;
					}
				case 4:
					if ((_v1.b.a.$ === 3) && (_v1.b.a.a === 404)) {
						return $author$project$Compensation$Add$NoPlan(
							{r: calendarState, t: currentDate, c2: distributionPointId});
					} else {
						return $author$project$Compensation$Add$Failed(
							{r: calendarState, t: currentDate, c2: distributionPointId});
					}
				default:
					break _v1$3;
			}
		}
		return model;
	} else {
		return model;
	}
};
var $author$project$Portal$Init$addCommands = F2(
	function (cmds, _v0) {
		var share = _v0.fQ;
		var key = _v0.iY;
		var commands = _v0.aC;
		return {
			aC: _Utils_ap(cmds, commands),
			iY: key,
			fQ: share
		};
	});
var $author$project$Plan$PlanLoader$LoadDeliverers = 0;
var $author$project$Plan$PlanLoader$LoadUnregistered = 1;
var $author$project$Plan$PlanLoader$SystemLoadedRegistered = function (a) {
	return {$: 0, a: a};
};
var $author$project$Plan$PlanLoader$SystemLoadedUnregistered = function (a) {
	return {$: 1, a: a};
};
var $author$project$Deliverer$Colors$Brown = 5;
var $author$project$Deliverer$Colors$Cyan = 9;
var $author$project$Deliverer$Colors$DarkBlue = 10;
var $author$project$Deliverer$Colors$DarkBrown = 15;
var $author$project$Deliverer$Colors$DarkCyan = 17;
var $author$project$Deliverer$Colors$DarkGreen = 12;
var $author$project$Deliverer$Colors$DarkGrey = 19;
var $author$project$Deliverer$Colors$DarkOrange = 11;
var $author$project$Deliverer$Colors$DarkPink = 16;
var $author$project$Deliverer$Colors$DarkPurple = 14;
var $author$project$Deliverer$Colors$DarkRed = 13;
var $author$project$Deliverer$Colors$DarkYellow = 18;
var $author$project$Deliverer$Colors$Green = 2;
var $author$project$Deliverer$Colors$Grey = 7;
var $author$project$Deliverer$Colors$Orange = 1;
var $author$project$Deliverer$Colors$Pink = 6;
var $author$project$Deliverer$Colors$Purple = 4;
var $author$project$Deliverer$Colors$Red = 3;
var $author$project$Deliverer$Colors$Yellow = 8;
var $author$project$Deliverer$Colors$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'pink':
				return $elm$json$Json$Decode$succeed(6);
			case 'red':
				return $elm$json$Json$Decode$succeed(3);
			case 'brown':
				return $elm$json$Json$Decode$succeed(5);
			case 'orange':
				return $elm$json$Json$Decode$succeed(1);
			case 'yellow':
				return $elm$json$Json$Decode$succeed(8);
			case 'green':
				return $elm$json$Json$Decode$succeed(2);
			case 'cyan':
				return $elm$json$Json$Decode$succeed(9);
			case 'blue':
				return $elm$json$Json$Decode$succeed(0);
			case 'purple':
				return $elm$json$Json$Decode$succeed(4);
			case 'grey':
				return $elm$json$Json$Decode$succeed(7);
			case 'darkPink':
				return $elm$json$Json$Decode$succeed(16);
			case 'darkRed':
				return $elm$json$Json$Decode$succeed(13);
			case 'darkBrown':
				return $elm$json$Json$Decode$succeed(15);
			case 'darkOrange':
				return $elm$json$Json$Decode$succeed(11);
			case 'darkYellow':
				return $elm$json$Json$Decode$succeed(18);
			case 'darkGreen':
				return $elm$json$Json$Decode$succeed(12);
			case 'darkCyan':
				return $elm$json$Json$Decode$succeed(17);
			case 'darkBlue':
				return $elm$json$Json$Decode$succeed(10);
			case 'darkPurple':
				return $elm$json$Json$Decode$succeed(14);
			case 'darkGrey':
				return $elm$json$Json$Decode$succeed(19);
			default:
				return $elm$json$Json$Decode$fail('Invalid color name: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Deliverer$Deliverer$Location = F4(
	function (id, name, address, comment) {
		return {f1: address, gg: comment, eg: id, ft: name};
	});
var $author$project$Deliverer$Deliverer$locationIdDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		return $elm$json$Json$Decode$succeed(string);
	},
	$elm$json$Json$Decode$string);
var $author$project$Deliverer$Deliverer$locationDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'comment',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'address',
		$author$project$Address$Address$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$author$project$Deliverer$Deliverer$locationIdDecoder,
				$elm$json$Json$Decode$succeed($author$project$Deliverer$Deliverer$Location)))));
var $author$project$Deliverer$Deliverer$SupplyPeriod = F2(
	function (at, from) {
		return {f5: at, l2: from};
	});
var $author$project$Deliverer$Deliverer$supplyPeriodDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'from',
	$author$project$Date$DeliveryDate$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'at',
		$author$project$Deliverer$Deliverer$locationIdDecoder,
		$elm$json$Json$Decode$succeed($author$project$Deliverer$Deliverer$SupplyPeriod)));
var $author$project$Deliverer$Deliverer$delivererDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'supplyPeriods',
	$elm$json$Json$Decode$list($author$project$Deliverer$Deliverer$supplyPeriodDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'locations',
		$elm$json$Json$Decode$list($author$project$Deliverer$Deliverer$locationDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'homeLocationId',
			$author$project$Deliverer$Deliverer$locationIdDecoder,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'preferredProduct',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'tags',
					$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
					$elm$core$Dict$empty,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'color',
						$author$project$Deliverer$Colors$decoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'lastName',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'firstName',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$author$project$Deliverer$Deliverer$idDecoder,
									$elm$json$Json$Decode$succeed($author$project$Deliverer$Deliverer$Deliverer))))))))));
var $author$project$Deliverer$Deliverer$loadByPlan = F4(
	function (token, toMsg, dpId, date) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['deliverers']),
			_List_fromArray(
				[
					A2(
					$elm$url$Url$Builder$string,
					'dpid',
					$author$project$DistributionPoint$DistributionPoint$encodeIdForUrl(dpId)),
					A2(
					$elm$url$Url$Builder$string,
					'validon',
					$author$project$Date$DeliveryDate$encodeForUrl(date)),
					A2($elm$url$Url$Builder$string, 'omitAvailabilities', 'true')
				]));
		return A4(
			$author$project$Api$Request$get,
			token,
			toMsg,
			uri,
			$elm$json$Json$Decode$list($author$project$Deliverer$Deliverer$delivererDecoder));
	});
var $author$project$Deliverer$Unregistered$unregisteredDelivererDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
	_List_Nil,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
		_List_Nil,
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			$author$project$Deliverer$Deliverer$locationIdFromString(''),
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
				$elm$core$Maybe$Nothing,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
					$elm$core$Dict$empty,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'color',
						$author$project$Deliverer$Colors$decoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'lastName',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'firstName',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$author$project$Deliverer$Deliverer$idDecoder,
									$elm$json$Json$Decode$succeed($author$project$Deliverer$Deliverer$Deliverer))))))))));
var $author$project$Deliverer$Unregistered$delivererWithPotentialIdsDecoder = A3(
	$elm$json$Json$Decode$map2,
	$elm$core$Tuple$pair,
	$author$project$Deliverer$Unregistered$unregisteredDelivererDecoder,
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault(_List_Nil),
		$elm$json$Json$Decode$maybe(
			A2(
				$elm$json$Json$Decode$field,
				'potentialIds',
				$elm$json$Json$Decode$list($author$project$Deliverer$Deliverer$idDecoder)))));
var $author$project$Deliverer$Unregistered$loadCmd = F4(
	function (token, toMsg, dpId, date) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['unregistered-deliverers']),
			_List_fromArray(
				[
					A2(
					$elm$url$Url$Builder$string,
					'dpid',
					$author$project$DistributionPoint$DistributionPoint$encodeIdForUrl(dpId)),
					A2(
					$elm$url$Url$Builder$string,
					'validon',
					$author$project$Date$DeliveryDate$encodeForUrl(date))
				]));
		return A4(
			$author$project$Api$Request$get,
			token,
			toMsg,
			uri,
			$elm$json$Json$Decode$list($author$project$Deliverer$Unregistered$delivererWithPotentialIdsDecoder));
	});
var $author$project$Plan$PlanLoader$toWaitingAction = F2(
	function (mapper, action) {
		return mapper(
			function () {
				switch (action) {
					case 0:
						return 'deliverers';
					case 1:
						return 'unregistered';
					case 2:
						return 'plan';
					default:
						return 'expired';
				}
			}());
	});
var $author$project$Plan$PlanLoader$tracked = A2($elm$core$Basics$composeR, $author$project$Portal$Waiting$name, $author$project$Api$Request$Tracked);
var $author$project$Portal$Share$withWaitingActions = F2(
	function (actions, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				bf: A3($elm$core$List$foldl, $author$project$Portal$Waiting$withAction, model.bf, actions)
			});
	});
var $author$project$Plan$PlanLoader$init = F4(
	function (share, toAction, dpId, date) {
		var token = $author$project$Portal$Share$token(share);
		var shareData = $author$project$Portal$Share$data(share);
		var _v0 = _Utils_Tuple2(shareData.id, shareData.fA);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			return _Utils_Tuple2(share, _List_Nil);
		} else {
			var unregisteredAction = A2($author$project$Plan$PlanLoader$toWaitingAction, toAction, 1);
			var delivererAction = A2($author$project$Plan$PlanLoader$toWaitingAction, toAction, 0);
			return _Utils_Tuple2(
				A2(
					$author$project$Portal$Share$withWaitingActions,
					_List_fromArray(
						[delivererAction, unregisteredAction]),
					share),
				_List_fromArray(
					[
						A5(
						$author$project$Deliverer$Deliverer$loadByPlan,
						token,
						$author$project$Plan$PlanLoader$SystemLoadedRegistered,
						dpId,
						date,
						$author$project$Plan$PlanLoader$tracked(delivererAction)),
						A5(
						$author$project$Deliverer$Unregistered$loadCmd,
						token,
						$author$project$Plan$PlanLoader$SystemLoadedUnregistered,
						dpId,
						date,
						$author$project$Plan$PlanLoader$tracked(unregisteredAction))
					]));
		}
	});
var $author$project$Portal$Init$withShare = F2(
	function (share, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{fQ: share});
	});
var $author$project$Portal$Init$withPlanLoader = F5(
	function (toAction, dpId, date, mapper, model) {
		var share = model.fQ;
		var key = model.iY;
		var _v0 = A4(
			$author$project$Plan$PlanLoader$init,
			share,
			toAction(key),
			dpId,
			date);
		var shareWithWaitingFromPlanLoader = _v0.a;
		var planCmds = _v0.b;
		return A2(
			$author$project$Portal$Init$addCommands,
			A2(
				$elm$core$List$map,
				$elm$core$Platform$Cmd$map(mapper),
				planCmds),
			A2($author$project$Portal$Init$withShare, shareWithWaitingFromPlanLoader, model));
	});
var $author$project$Compensation$Add$init = F3(
	function (share, dpId, date) {
		var token = $author$project$Portal$Share$token(share);
		return A2(
			$author$project$Portal$Init$withModelFromData,
			function (shareData) {
				return $author$project$Compensation$Add$next(
					$author$project$Compensation$Add$Loading(
						{
							r: $author$project$Portal$Subheader$initCalendarState,
							t: date,
							bn: shareData.bn,
							c2: dpId,
							fB: A4($author$project$Plan$PlanLoader$initModel, share, $elm$core$Basics$identity, dpId, date)
						}));
			},
			A5(
				$author$project$Portal$Init$withPlanLoader,
				$author$project$Compensation$Add$loadingPlan,
				dpId,
				date,
				$author$project$Compensation$Add$SystemGotPlanLoaderMsg,
				A4(
					$author$project$Portal$Init$ifNothing,
					function ($) {
						return $.bn;
					},
					$author$project$Compensation$Add$loadingDP,
					A4($author$project$DistributionPoint$DistributionPoint$loadCmd, token, $author$project$Compensation$Add$BackendRespondedDistributionPoint, dpId, date),
					A2(
						$author$project$Portal$Init$keyed,
						share,
						_Utils_Tuple2(dpId, date)))));
	});
var $author$project$Compensation$Approve$BackendRespondedCompensations = function (a) {
	return {$: 0, a: a};
};
var $author$project$Compensation$Approve$Loading = {$: 0};
var $author$project$Compensation$Compensation$AmountOnBulk = function (a) {
	return {$: 2, a: a};
};
var $author$project$Compensation$Compensation$AmountOnBulkInfo = F9(
	function (id, distributionPoint, on, deliverers, amountForOneDeliverer, compensationType, reason, status, log) {
		return {cW: amountForOneDeliverer, M: compensationType, e4: deliverers, bn: distributionPoint, eg: id, V: log, g2: on, jL: reason, nS: status};
	});
var $author$project$Compensation$Compensation$AmountOnDistributionPoint = function (a) {
	return {$: 0, a: a};
};
var $author$project$Compensation$Compensation$AmountOnDistributionPointInfo = F9(
	function (id, distributionPoint, on, deliverer, amount, compensationType, reason, status, log) {
		return {aa: amount, M: compensationType, bl: deliverer, bn: distributionPoint, eg: id, V: log, g2: on, jL: reason, nS: status};
	});
var $author$project$Compensation$Compensation$AmountOnSegment = function (a) {
	return {$: 1, a: a};
};
var $author$project$Compensation$Compensation$AmountOnSegmentInfo = function (id) {
	return function (distributionPoint) {
		return function (on) {
			return function (deliverer) {
				return function (segment) {
					return function (amount) {
						return function (compensationType) {
							return function (reason) {
								return function (status) {
									return function (log) {
										return {aa: amount, M: compensationType, bl: deliverer, bn: distributionPoint, eg: id, V: log, g2: on, jL: reason, fO: segment, nS: status};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Compensation$Compensation$delivererWithSegmentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'segment',
	$author$project$Reference$decoder($author$project$DistributionPoint$DistributionPoint$segmentIdDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'deliverer',
		$author$project$Reference$decoder($author$project$Deliverer$Deliverer$idDecoder),
		$elm$json$Json$Decode$succeed($elm$core$Tuple$pair)));
var $author$project$Compensation$Compensation$DistributionPoint = F4(
	function (id, name, tags, region) {
		return {eg: id, ft: name, nq: region, kn: tags};
	});
var $author$project$Compensation$Compensation$distributionPointDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'region',
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$DistributionPoint$DistributionPoint$Region,
		A2($elm$json$Json$Decode$field, 'number', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string)),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'tags',
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
		$elm$core$Dict$empty,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$author$project$DistributionPoint$DistributionPoint$idDecoder,
				$elm$json$Json$Decode$succeed($author$project$Compensation$Compensation$DistributionPoint)))));
var $author$project$Compensation$Money$TenThousandth = $elm$core$Basics$identity;
var $author$project$Compensation$Money$euroCent = function (amount) {
	return 100 * amount;
};
var $author$project$Compensation$Money$euroCentDecoder = A2($elm$json$Json$Decode$map, $author$project$Compensation$Money$euroCent, $elm$json$Json$Decode$int);
var $author$project$Compensation$Type$DeprecatedForDP = 4;
var $author$project$Compensation$Type$ActionBonusForDP = 1;
var $author$project$Compensation$Type$ExtraCompensationForDP = 0;
var $author$project$Compensation$Type$OtherForDP = 2;
var $author$project$Compensation$Type$UntaxedAlternativeTransportForDP = 3;
var $author$project$Compensation$Type$forDistributionPoint = _List_fromArray(
	[0, 1, 2, 3]);
var $author$project$Compensation$Type$Info = F3(
	function (code, description, taxInclusion) {
		return {ge: code, ig: description, ae: taxInclusion};
	});
var $author$project$Compensation$Type$TaxExcluded = 1;
var $author$project$Compensation$Type$infoOfForDistributionPoint = function (compensationType) {
	switch (compensationType) {
		case 0:
			return A3($author$project$Compensation$Type$Info, 303, 'Extra vergoeding', 0);
		case 1:
			return A3($author$project$Compensation$Type$Info, 308, 'Bonus', 0);
		case 2:
			return A3($author$project$Compensation$Type$Info, 402, 'Overige onkosten', 1);
		case 3:
			return A3($author$project$Compensation$Type$Info, 474, 'Alternatief vervoer onbelast', 1);
		default:
			return A3($author$project$Compensation$Type$Info, 999, 'Vergoedingscode verouderd', 1);
	}
};
var $author$project$Compensation$Type$forCodeForDistributionPoint = function (code) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Compensation$Type$infoOfForDistributionPoint,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ge;
					},
					$elm$core$Basics$eq(code))),
			$author$project$Compensation$Type$forDistributionPoint));
};
var $author$project$Compensation$Type$forDistributionPointDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Compensation$Type$forCodeForDistributionPoint,
		A2(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$elm$json$Json$Decode$succeed(4),
			$elm$json$Json$Decode$succeed)),
	$elm$json$Json$Decode$int);
var $author$project$Compensation$Type$DeprecatedForSegment = 8;
var $author$project$Compensation$Type$ActionBonusForSegment = 1;
var $author$project$Compensation$Type$ExtraCompensationForSegment = 0;
var $author$project$Compensation$Type$IssueCompensationForSegment = 4;
var $author$project$Compensation$Type$OtherForSegment = 6;
var $author$project$Compensation$Type$StartupBonusForSegment = 2;
var $author$project$Compensation$Type$SubstituteForSegment = 5;
var $author$project$Compensation$Type$UntaxedExtraCompensationForSegment = 7;
var $author$project$Compensation$Type$VDRForSegment = 3;
var $author$project$Compensation$Type$forSegment = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7]);
var $author$project$Compensation$Type$infoOfForSegment = function (compensationType) {
	switch (compensationType) {
		case 0:
			return A3($author$project$Compensation$Type$Info, 303, 'Extra vergoeding', 0);
		case 1:
			return A3($author$project$Compensation$Type$Info, 308, 'Bonus', 0);
		case 2:
			return A3($author$project$Compensation$Type$Info, 313, 'Start- en aanbrengpremie', 0);
		case 3:
			return A3($author$project$Compensation$Type$Info, 326, 'VDR bezorgen op vrijdag', 0);
		case 4:
			return A3($author$project$Compensation$Type$Info, 362, 'Vergoeding cala', 0);
		case 5:
			return A3($author$project$Compensation$Type$Info, 363, 'Invalvergoeding', 0);
		case 6:
			return A3($author$project$Compensation$Type$Info, 402, 'Overige onkosten', 1);
		case 7:
			return A3($author$project$Compensation$Type$Info, 403, 'KM vergoeding onbelast', 1);
		default:
			return A3($author$project$Compensation$Type$Info, 999, 'Vergoedingscode verouderd', 1);
	}
};
var $author$project$Compensation$Type$forCodeForSegment = function (code) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Compensation$Type$infoOfForSegment,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ge;
					},
					$elm$core$Basics$eq(code))),
			$author$project$Compensation$Type$forSegment));
};
var $author$project$Compensation$Type$forSegmentDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Compensation$Type$forCodeForSegment,
		A2(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$elm$json$Json$Decode$succeed(8),
			$elm$json$Json$Decode$succeed)),
	$elm$json$Json$Decode$int);
var $author$project$Deliverer$ReferenceDict$toComparable = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.eg;
	},
	$author$project$Deliverer$Deliverer$comparableId);
var $author$project$Deliverer$ReferenceDict$fromList = $timo_weike$generic_collections$ManualDict$fromList($author$project$Deliverer$ReferenceDict$toComparable);
var $author$project$Compensation$Compensation$idDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $danyx23$elm_uuid$Uuid$decoder);
var $author$project$Compensation$Compensation$LogItem = F2(
	function (action, at) {
		return {dN: action, f5: at};
	});
var $author$project$Compensation$Compensation$Approve = function (a) {
	return {$: 3, a: a};
};
var $author$project$Compensation$Compensation$AutomaticallyValidate = {$: 2};
var $author$project$Compensation$Compensation$Reject = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Compensation$Compensation$Submit = function (a) {
	return {$: 0, a: a};
};
var $author$project$Compensation$Compensation$Validate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Compensation$Compensation$User = F2(
	function (id, name) {
		return {eg: id, ft: name};
	});
var $author$project$Compensation$Compensation$userDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$author$project$Accounts$Account$idDecoder,
		$elm$json$Json$Decode$succeed($author$project$Compensation$Compensation$User)));
var $author$project$Compensation$Compensation$actionDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (actionStr) {
		switch (actionStr) {
			case 'submit':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Compensation$Compensation$Submit,
					A2($elm$json$Json$Decode$field, 'user', $author$project$Compensation$Compensation$userDecoder));
			case 'automaticVerify':
				return $elm$json$Json$Decode$succeed($author$project$Compensation$Compensation$AutomaticallyValidate);
			case 'validate':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Compensation$Compensation$Validate,
					A2($elm$json$Json$Decode$field, 'user', $author$project$Compensation$Compensation$userDecoder));
			case 'approve':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Compensation$Compensation$Approve,
					A2($elm$json$Json$Decode$field, 'user', $author$project$Compensation$Compensation$userDecoder));
			case 'reject':
				return A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'description',
					$elm$json$Json$Decode$string,
					'',
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'user',
						$author$project$Compensation$Compensation$userDecoder,
						$elm$json$Json$Decode$succeed($author$project$Compensation$Compensation$Reject)));
			default:
				return $elm$json$Json$Decode$fail('invalid action: ' + actionStr);
		}
	},
	A2($elm$json$Json$Decode$field, 'action', $elm$json$Json$Decode$string));
var $author$project$Compensation$Compensation$timeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$succeed),
	$elm$json$Json$Decode$int);
var $author$project$Compensation$Compensation$logItemDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Compensation$Compensation$LogItem,
	$author$project$Compensation$Compensation$actionDecoder,
	A2($elm$json$Json$Decode$field, 'at', $author$project$Compensation$Compensation$timeDecoder));
var $author$project$Compensation$Compensation$Approved = 2;
var $author$project$Compensation$Compensation$Pending = 0;
var $author$project$Compensation$Compensation$Rejected = 3;
var $author$project$Compensation$Compensation$Validated = 1;
var $author$project$Compensation$Compensation$statusDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (compensationStatus) {
		switch (compensationStatus) {
			case 'pending':
				return $elm$json$Json$Decode$succeed(0);
			case 'validated':
				return $elm$json$Json$Decode$succeed(1);
			case 'approved':
				return $elm$json$Json$Decode$succeed(2);
			case 'rejected':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('invalid status: ' + compensationStatus);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Compensation$Compensation$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (elementType) {
		switch (elementType) {
			case 'Segment':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Compensation$Compensation$AmountOnSegment,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'log',
						$elm$json$Json$Decode$list($author$project$Compensation$Compensation$logItemDecoder),
						_List_Nil,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'status',
							$author$project$Compensation$Compensation$statusDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'description',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'code',
									$author$project$Compensation$Type$forSegmentDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'amountInEuroCent',
										$author$project$Compensation$Money$euroCentDecoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'segment',
											$author$project$Reference$decoder($author$project$DistributionPoint$DistributionPoint$segmentIdDecoder),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'deliverer',
												$author$project$Reference$decoder($author$project$Deliverer$Deliverer$idDecoder),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'performedOn',
													$author$project$Date$DeliveryDate$decoder,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'distributionPoint',
														$author$project$Compensation$Compensation$distributionPointDecoder,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'id',
															$elm$json$Json$Decode$maybe($author$project$Compensation$Compensation$idDecoder),
															$elm$json$Json$Decode$succeed($author$project$Compensation$Compensation$AmountOnSegmentInfo))))))))))));
			case 'DistributionPoint':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Compensation$Compensation$AmountOnDistributionPoint,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'log',
						$elm$json$Json$Decode$list($author$project$Compensation$Compensation$logItemDecoder),
						_List_Nil,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'status',
							$author$project$Compensation$Compensation$statusDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'description',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'code',
									$author$project$Compensation$Type$forDistributionPointDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'amountInEuroCent',
										$author$project$Compensation$Money$euroCentDecoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'deliverer',
											$author$project$Reference$decoder($author$project$Deliverer$Deliverer$idDecoder),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'performedOn',
												$author$project$Date$DeliveryDate$decoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'distributionPoint',
													$author$project$Compensation$Compensation$distributionPointDecoder,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'id',
														$elm$json$Json$Decode$maybe($author$project$Compensation$Compensation$idDecoder),
														$elm$json$Json$Decode$succeed($author$project$Compensation$Compensation$AmountOnDistributionPointInfo)))))))))));
			case 'Bulk':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Compensation$Compensation$AmountOnBulk,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'log',
						$elm$json$Json$Decode$list($author$project$Compensation$Compensation$logItemDecoder),
						_List_Nil,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'status',
							$author$project$Compensation$Compensation$statusDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'description',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'code',
									$author$project$Compensation$Type$forSegmentDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'amountInEuroCent',
										$author$project$Compensation$Money$euroCentDecoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'multi',
											A2(
												$elm$json$Json$Decode$map,
												$author$project$Deliverer$ReferenceDict$fromList,
												$elm$json$Json$Decode$list($author$project$Compensation$Compensation$delivererWithSegmentDecoder)),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'performedOn',
												$author$project$Date$DeliveryDate$decoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'distributionPoint',
													$author$project$Compensation$Compensation$distributionPointDecoder,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'id',
														$elm$json$Json$Decode$maybe($author$project$Compensation$Compensation$idDecoder),
														$elm$json$Json$Decode$succeed($author$project$Compensation$Compensation$AmountOnBulkInfo)))))))))));
			default:
				return $elm$json$Json$Decode$fail('unknown element type');
		}
	},
	A2($elm$json$Json$Decode$field, 'elementType', $elm$json$Json$Decode$string));
var $author$project$Compensation$Compensation$loadTodoCmd = F2(
	function (token, toMsg) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['compensations']),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'process_by', 'me')
				]));
		return A4(
			$author$project$Api$Request$get,
			token,
			toMsg,
			uri,
			$elm$json$Json$Decode$list($author$project$Compensation$Compensation$decoder));
	});
var $author$project$Compensation$Approve$actionIdFor = function (id) {
	return A2($author$project$Portal$Waiting$Id, 'approveCompensation', id);
};
var $author$project$Compensation$Approve$singleAction = function (id) {
	return $author$project$Portal$Waiting$singleAction(
		$author$project$Compensation$Approve$actionIdFor(id));
};
var $author$project$Compensation$Approve$loadingCompensations = $author$project$Compensation$Approve$singleAction('loadingCompensations');
var $author$project$Compensation$Approve$init = function (share) {
	var token = $author$project$Portal$Share$token(share);
	return A2(
		$author$project$Portal$Init$withModel,
		$author$project$Compensation$Approve$Loading,
		A3(
			$author$project$Portal$Init$withCommand,
			$elm$core$Basics$always($author$project$Compensation$Approve$loadingCompensations),
			A2($author$project$Compensation$Compensation$loadTodoCmd, token, $author$project$Compensation$Approve$BackendRespondedCompensations),
			$author$project$Portal$Init$empty(share)));
};
var $author$project$Compensation$Edit$BackendRespondedCompensation = function (a) {
	return {$: 1, a: a};
};
var $author$project$Compensation$Edit$Loading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Compensation$Compensation$encodeForUrl = function (_v0) {
	var id = _v0;
	return $danyx23$elm_uuid$Uuid$toString(id);
};
var $author$project$Compensation$Compensation$loadCmd = F3(
	function (token, toMsg, id) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'compensations',
					$author$project$Compensation$Compensation$encodeForUrl(id)
				]),
			_List_Nil);
		return A4($author$project$Api$Request$get, token, toMsg, uri, $author$project$Compensation$Compensation$decoder);
	});
var $author$project$Compensation$Compensation$comparable = function (_v0) {
	var id = _v0;
	return $danyx23$elm_uuid$Uuid$toString(id);
};
var $author$project$Compensation$Edit$actionIdFor = F2(
	function (id, compensationId) {
		return A2(
			$author$project$Portal$Waiting$Id,
			'editCompensation' + $author$project$Compensation$Compensation$comparable(compensationId),
			id);
	});
var $author$project$Compensation$Edit$singleAction = F2(
	function (id, unique) {
		return $author$project$Portal$Waiting$singleAction(
			A2($author$project$Compensation$Edit$actionIdFor, id, unique));
	});
var $author$project$Compensation$Edit$loadingCompensation = $author$project$Compensation$Edit$singleAction('loadingCompensation');
var $author$project$Compensation$Edit$Failed = function (a) {
	return {$: 3, a: a};
};
var $author$project$Compensation$Edit$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Compensation$Edit$NoConfirmation = {$: 0};
var $author$project$Compensation$Edit$NoPlan = function (a) {
	return {$: 2, a: a};
};
var $author$project$Compensation$Edit$compensationIdOf = function (model) {
	switch (model.$) {
		case 0:
			var compensationId = model.a.ap;
			return compensationId;
		case 1:
			var compensationId = model.a.ap;
			return compensationId;
		case 2:
			var compensationId = model.a.ap;
			return compensationId;
		default:
			var compensationId = model.a.ap;
			return compensationId;
	}
};
var $author$project$Compensation$Form$CompensationForBulk = 2;
var $author$project$Compensation$Form$CompensationForDistributionPoint = 1;
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $timo_weike$generic_collections$ManualDict$filter = F2(
	function (pred, _v0) {
		var dict = _v0;
		var predicate = F2(
			function (_v1, _v2) {
				var key = _v2.a;
				var value = _v2.b;
				return A2(pred, key, value);
			});
		return A2($elm$core$Dict$filter, predicate, dict);
	});
var $author$project$Deliverer$TypedDict$filter = $timo_weike$generic_collections$ManualDict$filter;
var $timo_weike$generic_collections$ManualDict$keys = function (dict) {
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$first,
		$timo_weike$generic_collections$ManualDict$toList(dict));
};
var $author$project$Deliverer$ReferenceDict$keys = $timo_weike$generic_collections$ManualDict$keys;
var $author$project$Deliverer$TypedDict$keys = $timo_weike$generic_collections$ManualDict$keys;
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Compensation$Compensation$reasonOf = function (compensation) {
	switch (compensation.$) {
		case 0:
			var reason = compensation.a.jL;
			return reason;
		case 1:
			var reason = compensation.a.jL;
			return reason;
		default:
			var reason = compensation.a.jL;
			return reason;
	}
};
var $author$project$Compensation$Money$ShowCents = 1;
var $author$project$Compensation$Money$tenThousandthToCent = function (i) {
	return (i < 0) ? (((i - 50) / 100) | 0) : (((i + 50) / 100) | 0);
};
var $author$project$Compensation$Money$view = F2(
	function (options, _v0) {
		var tenThousandth = _v0;
		var sign = (tenThousandth < 0) ? '-' : '';
		var euros = ($elm$core$Basics$abs(tenThousandth) / 10000) | 0;
		var tenThousandths = $elm$core$Basics$abs(tenThousandth) - (10000 * euros);
		switch (options) {
			case 0:
				return '€' + (sign + $elm$core$String$fromInt(euros));
			case 1:
				return '€' + (sign + ($elm$core$String$fromInt(euros) + (',' + A3(
					$elm$core$String$padLeft,
					2,
					'0',
					$elm$core$String$fromInt(
						$author$project$Compensation$Money$tenThousandthToCent(tenThousandths))))));
			default:
				return '€' + (sign + ($elm$core$String$fromInt(euros) + (',' + A3(
					$elm$core$String$padLeft,
					4,
					'0',
					$elm$core$String$fromInt(tenThousandths)))));
		}
	});
var $author$project$Compensation$Form$moneyView = $author$project$Compensation$Money$view(1);
var $author$project$Compensation$Form$withAmount = F2(
	function (amount, model) {
		return _Utils_update(
			model,
			{
				aa: A2(
					$elm$core$String$dropLeft,
					1,
					$author$project$Compensation$Form$moneyView(amount))
			});
	});
var $author$project$Compensation$Form$withReason = F2(
	function (reason, model) {
		return _Utils_update(
			model,
			{
				jL: reason,
				fG: $author$project$Compensation$Compensation$maxReasonCharacters - $elm$core$String$length(reason)
			});
	});
var $author$project$Plan$Supply$clustersByDeliverer = F2(
	function (byDeliverer, items) {
		var collectClusters = F2(
			function (item, soFar) {
				switch (item.$) {
					case 0:
						var deliverer = item.a.bl;
						var cluster = item.a.H;
						var supplies = item.a.n0;
						return (_Utils_eq(byDeliverer, deliverer) ? $elm$core$List$cons(cluster) : $elm$core$Basics$identity)(
							A3($elm$core$List$foldl, collectClusters, soFar, supplies));
					case 1:
						var deliverer = item.a.bl;
						var clusters = item.a.k;
						return _Utils_eq(byDeliverer, deliverer) ? _Utils_ap(clusters, soFar) : soFar;
					default:
						return soFar;
				}
			});
		return A3($elm$core$List$foldl, collectClusters, _List_Nil, items);
	});
var $author$project$DistributionPoint$DistributionPoint$findSegmentsOnId = F2(
	function (_v0, segmentIds) {
		var distributionPoint = _v0;
		return A2(
			$elm$core$List$filter,
			function (s) {
				return A2(
					$elm$core$List$member,
					$author$project$DistributionPoint$DistributionPoint$segmentId(s),
					segmentIds);
			},
			distributionPoint.bb);
	});
var $author$project$Compensation$Form$withSelectedDeliverer = F2(
	function (selected, model) {
		var plan = model.fA;
		var distributionPoint = model.bn;
		var segments = function () {
			if (selected.$ === 1) {
				return _List_Nil;
			} else {
				var deliverer = selected.a;
				return A2(
					$author$project$DistributionPoint$DistributionPoint$findSegmentsOnId,
					distributionPoint,
					A2(
						$elm$core$List$concatMap,
						function ($) {
							return $.bb;
						},
						A2($author$project$Plan$Supply$clustersByDeliverer, deliverer, plan.gL)));
			}
		}();
		return _Utils_update(
			model,
			{e3: segments, cF: selected});
	});
var $author$project$Plan$Supply$findBySegment = F2(
	function (segmentId, items) {
		var find = F2(
			function (item, soFar) {
				if (!soFar.$) {
					var i = soFar.a;
					return $elm$core$Maybe$Just(i);
				} else {
					switch (item.$) {
						case 0:
							var cluster = item.a.H;
							var supplies = item.a.n0;
							return A2($elm$core$List$member, segmentId, cluster.bb) ? $elm$core$Maybe$Just(item) : A3($elm$core$List$foldl, find, $elm$core$Maybe$Nothing, supplies);
						case 1:
							var clusters = item.a.k;
							return A2(
								$elm$core$List$any,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.bb;
									},
									$elm$core$List$member(segmentId)),
								clusters) ? $elm$core$Maybe$Just(item) : $elm$core$Maybe$Nothing;
						default:
							return $elm$core$Maybe$Nothing;
					}
				}
			});
		return A3($elm$core$List$foldl, find, $elm$core$Maybe$Nothing, items);
	});
var $author$project$Compensation$Form$withSelectedSegment = F2(
	function (selected, model) {
		var plan = model.fA;
		var delivererOfSegment = function () {
			if (!selected.$) {
				var segment = selected.a;
				return A2(
					$elm$core$Maybe$andThen,
					$author$project$Plan$Supply$delivererOf,
					A2(
						$author$project$Plan$Supply$findBySegment,
						$author$project$DistributionPoint$DistributionPoint$segmentId(segment),
						plan.gL));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return function (m) {
			var _v0 = m.cF;
			if (_v0.$ === 1) {
				return A2($author$project$Compensation$Form$withSelectedDeliverer, model.d1, m);
			} else {
				return m;
			}
		}(
			_Utils_update(
				model,
				{d1: delivererOfSegment, eu: selected}));
	});
var $author$project$Compensation$Form$forCompensation = F4(
	function (distributionPoint, deliverers, plan, compensation) {
		return A2(
			$author$project$Compensation$Form$withReason,
			$author$project$Compensation$Compensation$reasonOf(compensation),
			function (m) {
				switch (compensation.$) {
					case 1:
						var id = compensation.a.eg;
						var amount = compensation.a.aa;
						var compensationType = compensation.a.M;
						var deliverer = compensation.a.bl;
						var segment = compensation.a.fO;
						return A2(
							$author$project$Compensation$Form$withAmount,
							amount,
							A2(
								$author$project$Compensation$Form$withSelectedSegment,
								A2($author$project$DistributionPoint$DistributionPoint$findSegmentOnId, distributionPoint, segment.eg),
								A2(
									$author$project$Compensation$Form$withSelectedDeliverer,
									A2(
										$elm_community$list_extra$List$Extra$find,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Deliverer$Deliverer$idFromTyped,
											$elm$core$Basics$eq(deliverer.eg)),
										deliverers),
									_Utils_update(
										m,
										{
											ap: id,
											bc: $elm$core$Maybe$Just(compensationType),
											al: 0,
											ae: $author$project$Compensation$Type$infoOfForSegment(compensationType).ae
										}))));
					case 0:
						var id = compensation.a.eg;
						var amount = compensation.a.aa;
						var compensationType = compensation.a.M;
						var deliverer = compensation.a.bl;
						return A2(
							$author$project$Compensation$Form$withAmount,
							amount,
							A2(
								$author$project$Compensation$Form$withSelectedDeliverer,
								A2(
									$elm_community$list_extra$List$Extra$find,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Deliverer$Deliverer$idFromTyped,
										$elm$core$Basics$eq(deliverer.eg)),
									deliverers),
								_Utils_update(
									m,
									{
										ap: id,
										b1: $elm$core$Maybe$Just(compensationType),
										al: 1,
										ae: $author$project$Compensation$Type$infoOfForDistributionPoint(compensationType).ae
									})));
					default:
						var info = compensation.a;
						var id = info.eg;
						var amountForOneDeliverer = info.cW;
						var compensationType = info.M;
						return A2(
							$author$project$Compensation$Form$withAmount,
							amountForOneDeliverer,
							_Utils_update(
								m,
								{
									ap: id,
									bc: $elm$core$Maybe$Just(compensationType),
									ak: function () {
										var delivererIds = A2(
											$elm$core$List$map,
											function ($) {
												return $.eg;
											},
											$author$project$Deliverer$ReferenceDict$keys(info.e4));
										return $Gizra$elm_all_set$EverySet$fromList(
											$author$project$Deliverer$TypedDict$keys(
												A2(
													$author$project$Deliverer$TypedDict$filter,
													F2(
														function (d, _v1) {
															return A2(
																$elm$core$List$member,
																$author$project$Deliverer$Deliverer$idFromTyped(d),
																delivererIds);
														}),
													m.cV)));
									}(),
									al: 2,
									ae: $author$project$Compensation$Type$infoOfForSegment(compensationType).ae
								}));
				}
			}(
				A3($author$project$Compensation$Form$empty, distributionPoint, deliverers, plan)));
	});
var $author$project$Compensation$Edit$next = function (model) {
	if (!model.$) {
		var compensationId = model.a.ap;
		var compensation = model.a.ao;
		var calendarState = model.a.r;
		var distributionPoint = model.a.bn;
		var planAndDeliverers = model.a.fB;
		var _v1 = _Utils_Tuple3(compensation, distributionPoint, planAndDeliverers);
		_v1$3:
		while (true) {
			if (!_v1.c.$) {
				switch (_v1.c.a.$) {
					case 3:
						if ((!_v1.a.$) && (!_v1.b.$)) {
							var c = _v1.a.a;
							var dp = _v1.b.a;
							var plan = _v1.c.a.a.fA;
							var deliverers = _v1.c.a.a.e4;
							var registeredDeliverers = A2(
								$elm$core$List$filter,
								$author$project$Deliverer$Deliverer$onlyRegistered,
								$author$project$Deliverer$IdDict$values(deliverers));
							return $author$project$Compensation$Edit$Loaded(
								{
									r: calendarState,
									ap: compensationId,
									eW: $author$project$Compensation$Edit$NoConfirmation,
									e4: registeredDeliverers,
									bn: dp,
									bO: A4($author$project$Compensation$Form$forCompensation, dp, registeredDeliverers, plan, c),
									el: c,
									fA: plan
								});
						} else {
							break _v1$3;
						}
					case 4:
						if (((!_v1.a.$) && (_v1.c.a.a.$ === 3)) && (_v1.c.a.a.a === 404)) {
							var c = _v1.a.a;
							return $author$project$Compensation$Edit$NoPlan(
								{r: calendarState, ao: c, ap: compensationId});
						} else {
							return $author$project$Compensation$Edit$Failed(
								{
									r: calendarState,
									ap: $author$project$Compensation$Edit$compensationIdOf(model)
								});
						}
					default:
						break _v1$3;
				}
			} else {
				break _v1$3;
			}
		}
		return model;
	} else {
		return model;
	}
};
var $author$project$Compensation$Edit$init = F2(
	function (share, compensationId) {
		var token = $author$project$Portal$Share$token(share);
		return A2(
			$author$project$Portal$Init$withModelFromData,
			function (_v0) {
				return $author$project$Compensation$Edit$next(
					$author$project$Compensation$Edit$Loading(
						{r: $author$project$Portal$Subheader$initCalendarState, ao: $elm$core$Maybe$Nothing, ap: compensationId, bn: $elm$core$Maybe$Nothing, fB: $elm$core$Maybe$Nothing}));
			},
			A3(
				$author$project$Portal$Init$withCommand,
				$author$project$Compensation$Edit$loadingCompensation,
				A3($author$project$Compensation$Compensation$loadCmd, token, $author$project$Compensation$Edit$BackendRespondedCompensation, compensationId),
				A2($author$project$Portal$Init$keyed, share, compensationId)));
	});
var $author$project$Compensation$Overview$BackendRespondedCompensations = function (a) {
	return {$: 0, a: a};
};
var $author$project$Compensation$Overview$Loading = {$: 0};
var $author$project$Compensation$Compensation$loadSubmittedByMeCmd = F2(
	function (token, toMsg) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['compensations']),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'submitted_by', 'me'),
					A2($elm$url$Url$Builder$string, 'wage_periods', '3')
				]));
		return A4(
			$author$project$Api$Request$get,
			token,
			toMsg,
			uri,
			$elm$json$Json$Decode$list($author$project$Compensation$Compensation$decoder));
	});
var $author$project$Compensation$Overview$actionIdFor = function (id) {
	return A2($author$project$Portal$Waiting$Id, 'compensation', id);
};
var $author$project$Compensation$Overview$singleAction = function (id) {
	return $author$project$Portal$Waiting$singleAction(
		$author$project$Compensation$Overview$actionIdFor(id));
};
var $author$project$Compensation$Overview$loadingCompensations = $author$project$Compensation$Overview$singleAction('loadingCompensations');
var $author$project$Compensation$Overview$init = function (share) {
	var token = $author$project$Portal$Share$token(share);
	return A2(
		$author$project$Portal$Init$withModel,
		$author$project$Compensation$Overview$Loading,
		A3(
			$author$project$Portal$Init$withCommand,
			$elm$core$Basics$always($author$project$Compensation$Overview$loadingCompensations),
			A2($author$project$Compensation$Compensation$loadSubmittedByMeCmd, token, $author$project$Compensation$Overview$BackendRespondedCompensations),
			$author$project$Portal$Init$empty(share)));
};
var $author$project$Complaint$Feedback$Collapsed = 1;
var $author$project$Complaint$Feedback$Loading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Complaint$Feedback$SystemGotComplaints = function (a) {
	return {$: 1, a: a};
};
var $author$project$Complaint$Complaint$Complaint = function (id) {
	return function (code) {
		return function (date) {
			return function (lot) {
				return function (distributionPoint) {
					return function (segment) {
						return function (order) {
							return function (feedback) {
								return function (comments) {
									return function (frequency) {
										return {ge: code, ln: comments, lx: date, bn: distributionPoint, lW: feedback, l1: frequency, eg: id, i7: lot, m8: order, fO: segment};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Complaint$Complaint$Id = $elm$core$Basics$identity;
var $author$project$Complaint$Complaint$None = 0;
var $author$project$Complaint$Complaint$DamagedNewspaper = 0;
var $author$project$Complaint$Complaint$Incomplete = 4;
var $author$project$Complaint$Complaint$NotDelivered = 7;
var $author$project$Complaint$Complaint$NotDeliveredDuringDelay = 8;
var $author$project$Complaint$Complaint$PersonBehaviour = 3;
var $author$project$Complaint$Complaint$PersonCausedDamage = 2;
var $author$project$Complaint$Complaint$StickingOut = 1;
var $author$project$Complaint$Complaint$TooLate = 9;
var $author$project$Complaint$Complaint$WrongBox = 5;
var $author$project$Complaint$Complaint$WrongNewspaper = 6;
var $author$project$Complaint$Complaint$codeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (code) {
		switch (code) {
			case 'DELIVERY.DAMAGED':
				return $elm$json$Json$Decode$succeed(0);
			case 'DELIVERY.STICKING_OUT_OF_LETTER_BOX':
				return $elm$json$Json$Decode$succeed(1);
			case 'DELIVERY_PERSON.CAUSED_DAMAGE':
				return $elm$json$Json$Decode$succeed(2);
			case 'DELIVERY_PERSON.BEHAVIOUR':
				return $elm$json$Json$Decode$succeed(3);
			case 'DELIVERY.INCOMPLETE':
				return $elm$json$Json$Decode$succeed(4);
			case 'DELIVERY.WRONG_LETTER_BOX':
				return $elm$json$Json$Decode$succeed(5);
			case 'DELIVERY.WRONG_PRODUCT':
				return $elm$json$Json$Decode$succeed(6);
			case 'DELIVERY.NOT_DELIVERED':
				return $elm$json$Json$Decode$succeed(7);
			case 'DELIVERY.NOT_DELIVERED_DURING_DELAY':
				return $elm$json$Json$Decode$succeed(8);
			case 'DELIVERY.RECEIVED_BUT_DELIVERED_LATER_THAN_EXPECTED':
				return $elm$json$Json$Decode$succeed(9);
			default:
				return $elm$json$Json$Decode$fail('Unknown status');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Complaint$Complaint$Comment = F2(
	function (author, body) {
		return {kU: author, aA: body};
	});
var $author$project$Complaint$Complaint$commentDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'body',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'author',
		$elm$json$Json$Decode$string,
		'',
		$elm$json$Json$Decode$succeed($author$project$Complaint$Complaint$Comment)));
var $author$project$Complaint$Complaint$emptyLot = {eg: '', ft: 'Onbekend', kn: $elm$core$Dict$empty};
var $author$project$Complaint$Complaint$emptyOrder = {
	f1: {
		h8: 3,
		bs: {bX: 0, dE: $elm$core$Maybe$Nothing},
		i3: $elm$core$Maybe$Nothing,
		bU: '',
		b5: '',
		cT: ''
	},
	ir: '',
	jJ: ''
};
var $author$project$Complaint$Complaint$emptySegment = {ft: 'Onbekend', kn: $elm$core$Dict$empty};
var $author$project$Complaint$Complaint$AddressUnreachable = 1;
var $author$project$Complaint$Complaint$DelivererDelayed = 2;
var $author$project$Complaint$Complaint$DelivererShortage = 11;
var $author$project$Complaint$Complaint$InternAtCustomer = 5;
var $author$project$Complaint$Complaint$Mutation = 7;
var $author$project$Complaint$Complaint$NewBuilding = 8;
var $author$project$Complaint$Complaint$NewDeliverer = 9;
var $author$project$Complaint$Complaint$SubstituteDeliverer = 6;
var $author$project$Complaint$Complaint$Theft = 4;
var $author$project$Complaint$Complaint$UnclearDeliveryLocation = 3;
var $author$project$Complaint$Complaint$UnsafeDeliverySituation = 10;
var $author$project$Complaint$Complaint$Weather = 12;
var $author$project$Complaint$Complaint$feedbackCodeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (code) {
		switch (code) {
			case 'address unreachable':
				return $elm$json$Json$Decode$succeed(1);
			case 'deliverer delayed':
				return $elm$json$Json$Decode$succeed(2);
			case 'unclear delivery location':
				return $elm$json$Json$Decode$succeed(3);
			case 'theft':
				return $elm$json$Json$Decode$succeed(4);
			case 'intern at customer':
				return $elm$json$Json$Decode$succeed(5);
			case 'substitute deliverer':
				return $elm$json$Json$Decode$succeed(6);
			case 'mutation':
				return $elm$json$Json$Decode$succeed(7);
			case 'new building':
				return $elm$json$Json$Decode$succeed(8);
			case 'new deliverer':
				return $elm$json$Json$Decode$succeed(9);
			case 'unsafe delivery situation':
				return $elm$json$Json$Decode$succeed(10);
			case 'deliverer shortage':
				return $elm$json$Json$Decode$succeed(11);
			case 'weather':
				return $elm$json$Json$Decode$succeed(12);
			case '':
				return $elm$json$Json$Decode$succeed(0);
			default:
				return $elm$json$Json$Decode$succeed(0);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Complaint$Complaint$Lot = F3(
	function (id, name, tags) {
		return {eg: id, ft: name, kn: tags};
	});
var $author$project$Complaint$Complaint$lotDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'tags',
	$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
	$elm$core$Dict$empty,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Complaint$Complaint$Lot))));
var $author$project$Complaint$Complaint$Order = F3(
	function (address, product, edition) {
		return {f1: address, ir: edition, jJ: product};
	});
var $author$project$Complaint$Complaint$addressDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'countryCode',
	$author$project$Address$Address$countryCodeDecoder,
	3,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'numberAdditions',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'number',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'postcode',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'street',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'municipal',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed(
							F6(
								function (municipal, street, zipCode, number, suffix, countryCode) {
									return A6(
										$author$project$Address$Address$Address,
										municipal,
										street,
										zipCode,
										{bX: number, dE: suffix},
										countryCode,
										$elm$core$Maybe$Nothing);
								}))))))));
var $author$project$Complaint$Complaint$orderDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'edition',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'product',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'address',
			$author$project$Complaint$Complaint$addressDecoder,
			$elm$json$Json$Decode$succeed($author$project$Complaint$Complaint$Order))));
var $author$project$Complaint$Complaint$Segment = F2(
	function (name, tags) {
		return {ft: name, kn: tags};
	});
var $author$project$Complaint$Complaint$segmentDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'tags',
	$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
	$elm$core$Dict$empty,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Complaint$Complaint$Segment)));
var $author$project$Complaint$Complaint$decode = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'frequency',
	$elm$json$Json$Decode$int,
	1,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'comments',
		$elm$json$Json$Decode$list($author$project$Complaint$Complaint$commentDecoder),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'feedback',
			$author$project$Complaint$Complaint$feedbackCodeDecoder,
			0,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'order',
				$author$project$Complaint$Complaint$orderDecoder,
				$author$project$Complaint$Complaint$emptyOrder,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'segment',
					$author$project$Complaint$Complaint$segmentDecoder,
					$author$project$Complaint$Complaint$emptySegment,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'distributionPointID',
						$elm$json$Json$Decode$maybe($author$project$DistributionPoint$DistributionPoint$idDecoder),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'lot',
							$author$project$Complaint$Complaint$lotDecoder,
							$author$project$Complaint$Complaint$emptyLot,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'date',
								$author$project$Date$DeliveryDate$decoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'type',
									$author$project$Complaint$Complaint$codeDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										A2(
											$elm$json$Json$Decode$andThen,
											A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$succeed),
											$danyx23$elm_uuid$Uuid$decoder),
										$elm$json$Json$Decode$succeed($author$project$Complaint$Complaint$Complaint)))))))))));
var $author$project$Complaint$Feedback$loadCmd = F3(
	function (token, toMsg, date) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'complaint',
					'feedback-needed',
					$author$project$Date$DeliveryDate$encodeForUrl(date)
				]),
			_List_Nil);
		return A4(
			$author$project$Api$Request$get,
			token,
			toMsg,
			uri,
			$elm$json$Json$Decode$list($author$project$Complaint$Complaint$decode));
	});
var $author$project$Complaint$Feedback$actionIdFor = F2(
	function (id, date) {
		return A2(
			$author$project$Portal$Waiting$Id,
			'complaints' + $author$project$Date$DeliveryDate$oldestFirst(date),
			id);
	});
var $author$project$Complaint$Feedback$singleAction = F2(
	function (id, unique) {
		return $author$project$Portal$Waiting$singleAction(
			A2($author$project$Complaint$Feedback$actionIdFor, id, unique));
	});
var $author$project$Complaint$Feedback$loadingComplaints = $author$project$Complaint$Feedback$singleAction('loadingComplaints');
var $author$project$Complaint$Feedback$init = F2(
	function (share, date) {
		var token = $author$project$Portal$Share$token(share);
		return A2(
			$author$project$Portal$Init$withModel,
			$author$project$Complaint$Feedback$Loading(
				{
					r: $author$project$Portal$Subheader$initCalendarState,
					t: date,
					aj: {cd: 1, aB: _List_Nil, bN: false, aN: _List_Nil}
				}),
			A3(
				$author$project$Portal$Init$withCommand,
				$author$project$Complaint$Feedback$loadingComplaints,
				A3($author$project$Complaint$Feedback$loadCmd, token, $author$project$Complaint$Feedback$SystemGotComplaints, date),
				A2($author$project$Portal$Init$keyed, share, date)));
	});
var $author$project$Complaint$Handle$BackendRespondedDistributionPoints = function (a) {
	return {$: 0, a: a};
};
var $author$project$Complaint$Handle$Failed = {$: 2};
var $author$project$Complaint$Handle$Loading = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Complaint$Handle$SystemGotComplaints = function (a) {
	return {$: 1, a: a};
};
var $author$project$DistributionPoint$DistributionPoint$encodeId = $danyx23$elm_uuid$Uuid$encode;
var $author$project$Complaint$Handle$roleToString = function (role) {
	if (!role) {
		return 'distributor';
	} else {
		return 'relation-manager';
	}
};
var $author$project$Complaint$Handle$encodeRole = function (role) {
	return $elm$json$Json$Encode$string(
		$author$project$Complaint$Handle$roleToString(role));
};
var $author$project$Complaint$Handle$loadComplaintsCmd = F4(
	function (dps, role, token, toMsg) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['complaint', 'find']),
			_List_Nil);
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'role',
						$author$project$Complaint$Handle$encodeRole(role)),
						_Utils_Tuple2(
						'dps',
						A2(
							$elm$json$Json$Encode$list,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.eg;
								},
								$author$project$DistributionPoint$DistributionPoint$encodeId),
							dps))
					])));
		return A5(
			$author$project$Api$Request$post,
			token,
			toMsg,
			uri,
			body,
			$elm$json$Json$Decode$list($author$project$Complaint$Complaint$decode));
	});
var $author$project$Complaint$Handle$actionIdFor = function (id) {
	return A2($author$project$Portal$Waiting$Id, 'complaints', id);
};
var $author$project$Complaint$Handle$singleAction = F2(
	function (id, _v0) {
		return $author$project$Portal$Waiting$singleAction(
			$author$project$Complaint$Handle$actionIdFor(id));
	});
var $author$project$Complaint$Handle$loadingComplaints = $author$project$Complaint$Handle$singleAction('loadingComplaints');
var $author$project$Complaint$Handle$loadingDPs = $author$project$Complaint$Handle$singleAction('loadingDPs');
var $author$project$Complaint$Handle$Distributor = 0;
var $author$project$Security$Security$HandleDistributorComplaints = {$: 14};
var $author$project$Security$Security$HandleRelationManagerComplaints = {$: 15};
var $author$project$Complaint$Handle$RelationManager = 1;
var $author$project$Security$Security$can = F2(
	function (permission, model) {
		if (model.$ === 4) {
			var permissions = model.a.fz;
			return A2($elm$core$List$member, permission, permissions);
		} else {
			return false;
		}
	});
var $author$project$Complaint$Handle$toRole = function (security) {
	var _v0 = _Utils_Tuple2(
		A2($author$project$Security$Security$can, $author$project$Security$Security$HandleRelationManagerComplaints, security),
		A2($author$project$Security$Security$can, $author$project$Security$Security$HandleDistributorComplaints, security));
	if (!_v0.a) {
		if (!_v0.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Just(0);
		}
	} else {
		if (!_v0.b) {
			return $elm$core$Maybe$Just(1);
		} else {
			return $elm$core$Maybe$Just(1);
		}
	}
};
var $author$project$Complaint$Handle$init = function (share) {
	var token = $author$project$Portal$Share$token(share);
	var today = $author$project$Portal$Share$today(share);
	var security = $author$project$Portal$Share$security(share);
	var _v0 = _Utils_Tuple2(
		$author$project$Portal$Share$data(share).A,
		$author$project$Complaint$Handle$toRole(security));
	if (_v0.b.$ === 1) {
		var _v1 = _v0.b;
		return A2(
			$author$project$Portal$Init$withModel,
			$author$project$Complaint$Handle$Failed,
			$author$project$Portal$Init$empty(share));
	} else {
		if (_v0.a.$ === 1) {
			var _v2 = _v0.a;
			var role = _v0.b.a;
			return A2(
				$author$project$Portal$Init$withModel,
				A2($author$project$Complaint$Handle$Loading, $elm$core$Maybe$Nothing, role),
				A4(
					$author$project$Portal$Init$ifNothing,
					function ($) {
						return $.A;
					},
					$author$project$Complaint$Handle$loadingDPs,
					A3($author$project$DistributionPoint$DistributionPoint$loadNamesAndRegions, token, $author$project$Complaint$Handle$BackendRespondedDistributionPoints, today),
					$author$project$Portal$Init$empty(share)));
		} else {
			var dps = _v0.a.a;
			var role = _v0.b.a;
			return A2(
				$author$project$Portal$Init$withModel,
				A2(
					$author$project$Complaint$Handle$Loading,
					$elm$core$Maybe$Just(dps),
					role),
				A3(
					$author$project$Portal$Init$withCommand,
					$author$project$Complaint$Handle$loadingComplaints,
					A4($author$project$Complaint$Handle$loadComplaintsCmd, dps, role, token, $author$project$Complaint$Handle$SystemGotComplaints),
					$author$project$Portal$Init$empty(share)));
		}
	}
};
var $author$project$Count$Count$BackendRespondedDemandSummary = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Count$Count$HideZero = 0;
var $author$project$Demand$Bundle$OnlyIndividuals = {$: 1};
var $author$project$Count$Count$SystemGotLoaderMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Count$Count$SystemLoadedDistributionPoint = function (a) {
	return {$: 0, a: a};
};
var $author$project$Count$Count$SystemLoadedOrders = function (a) {
	return {$: 2, a: a};
};
var $author$project$Count$Count$SystemLoadedProducts = function (a) {
	return {$: 4, a: a};
};
var $author$project$DistributionPoint$IdDict$empty = $timo_weike$generic_collections$ManualDict$empty;
var $author$project$Portal$Share$withData = F2(
	function (d, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{cf: d});
	});
var $author$project$Portal$Return$ensureDataShared = F2(
	function (toData, _v0) {
		var model = _v0.a;
		var pageModel = _v0.b;
		var pageMsg = _v0.c;
		return _Utils_Tuple3(
			A2(
				$author$project$Portal$Share$withData,
				toData(pageModel),
				model),
			pageModel,
			pageMsg);
	});
var $author$project$DistributionPoint$DistributionPoint$getSubDistributionPoints = function (_v0) {
	var distributionPoint = _v0;
	return distributionPoint.hw;
};
var $author$project$Demand$Summary$DistributionPoint = F3(
	function (dpId, amountsByProduct, products) {
		return {kO: amountsByProduct, lK: dpId, bu: products};
	});
var $author$project$Demand$Demand$typeToString = function (demandType) {
	switch (demandType) {
		case 0:
			return 'Abo';
		case 1:
			return 'Lvk';
		case 2:
			return 'Extra';
		case 3:
			return 'Eigen';
		case 4:
			return 'Dp';
		default:
			return 'Segment';
	}
};
var $author$project$Demand$TypeDict$toComparable = $author$project$Demand$Demand$typeToString;
var $timo_weike$generic_collections$ManualDict$update = F4(
	function (f, key, updateFunc, _v0) {
		var dict = _v0;
		var updater = function (tuple) {
			return A2(
				$elm$core$Maybe$map,
				function (value) {
					return _Utils_Tuple2(key, value);
				},
				updateFunc(
					A2($elm$core$Maybe$map, $elm$core$Tuple$second, tuple)));
		};
		return A3(
			$elm$core$Dict$update,
			f(key),
			updater,
			dict);
	});
var $author$project$Demand$TypeDict$update = $timo_weike$generic_collections$ManualDict$update($author$project$Demand$TypeDict$toComparable);
var $author$project$Demand$TypeDict$decodeDictFromTuples = F2(
	function (keyDecoder, tuples) {
		if (!tuples.b) {
			return $elm$json$Json$Decode$succeed($timo_weike$generic_collections$ManualDict$empty);
		} else {
			var _v1 = tuples.a;
			var strKey = _v1.a;
			var value = _v1.b;
			var rest = tuples.b;
			var _v2 = A2(
				$elm$json$Json$Decode$decodeString,
				keyDecoder,
				A2(
					$elm$json$Json$Encode$encode,
					0,
					$elm$json$Json$Encode$string(strKey)));
			if (!_v2.$) {
				var key = _v2.a;
				return A2(
					$elm$json$Json$Decode$andThen,
					A2(
						$elm$core$Basics$composeR,
						A2(
							$author$project$Demand$TypeDict$update,
							key,
							function (oldValue) {
								if (!oldValue.$) {
									var a = oldValue.a;
									return $elm$core$Maybe$Just(a + value);
								} else {
									return $elm$core$Maybe$Just(value);
								}
							}),
						$elm$json$Json$Decode$succeed),
					A2($author$project$Demand$TypeDict$decodeDictFromTuples, keyDecoder, rest));
			} else {
				var error = _v2.a;
				return $elm$json$Json$Decode$fail(
					$elm$json$Json$Decode$errorToString(error));
			}
		}
	});
var $author$project$Demand$Demand$Extra = 2;
var $author$project$Demand$Demand$Sale = 1;
var $author$project$Demand$Demand$Subscription = 0;
var $author$project$Demand$Demand$demandTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'sub':
				return $elm$json$Json$Decode$succeed(0);
			case 'subscription':
				return $elm$json$Json$Decode$succeed(0);
			case 'sale':
				return $elm$json$Json$Decode$succeed(1);
			case 'extra':
				return $elm$json$Json$Decode$succeed(2);
			case 'own':
				return $elm$json$Json$Decode$succeed(2);
			case 'dp':
				return $elm$json$Json$Decode$succeed(2);
			case 'segment':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Invalid DemandType: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Demand$TypeDict$decoder = function (valueDecoder) {
	return A2(
		$elm$json$Json$Decode$andThen,
		$author$project$Demand$TypeDict$decodeDictFromTuples($author$project$Demand$Demand$demandTypeDecoder),
		$elm$json$Json$Decode$keyValuePairs(valueDecoder));
};
var $author$project$Demand$Summary$amountPerDemandTypeDecoder = $author$project$Demand$TypeDict$decoder($elm$json$Json$Decode$int);
var $author$project$Demand$Summary$amountsByProductDecoder = $elm$json$Json$Decode$dict($author$project$Demand$Summary$amountPerDemandTypeDecoder);
var $author$project$Demand$Demand$Product = F5(
	function (id, name, packSize, mass, inserts) {
		return {eg: id, iT: inserts, ja: mass, ft: name, E: packSize};
	});
var $author$project$Demand$Demand$Insert = F5(
	function (id, name, packSize, mass, demandTypes) {
		return {$8: demandTypes, eg: id, ja: mass, ft: name, E: packSize};
	});
var $author$project$Api$Request$int = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			$elm$json$Json$Decode$int,
			A2(
			$elm$json$Json$Decode$andThen,
			function (string) {
				var _v0 = $elm$core$String$toInt(string);
				if (!_v0.$) {
					var value = _v0.a;
					return $elm$json$Json$Decode$succeed(value);
				} else {
					return $elm$json$Json$Decode$fail('Invalid int: ' + string);
				}
			},
			$elm$json$Json$Decode$string)
		]));
var $ianmackenzie$elm_units$Quantity$Quantity = $elm$core$Basics$identity;
var $ianmackenzie$elm_units$Mass$kilograms = function (numKilograms) {
	return numKilograms;
};
var $ianmackenzie$elm_units$Mass$grams = function (numGrams) {
	return $ianmackenzie$elm_units$Mass$kilograms(0.001 * numGrams);
};
var $author$project$Demand$Demand$massInGrams = A2(
	$elm$json$Json$Decode$andThen,
	function (_int) {
		return $elm$json$Json$Decode$succeed(
			$ianmackenzie$elm_units$Mass$grams(_int));
	},
	$author$project$Api$Request$int);
var $author$project$Demand$Demand$insertDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'demandTypes',
	$elm$json$Json$Decode$list($author$project$Demand$Demand$demandTypeDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'weight',
		$author$project$Demand$Demand$massInGrams,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'packSize',
			$author$project$Api$Request$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Demand$Demand$Insert))))));
var $author$project$Demand$Demand$productDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'inserts',
	$elm$json$Json$Decode$list($author$project$Demand$Demand$insertDecoder),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'weight',
		$author$project$Demand$Demand$massInGrams,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'packSize',
			$author$project$Api$Request$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Demand$Demand$Product))))));
var $author$project$Demand$Summary$distributionPointDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'products',
	$elm$json$Json$Decode$list($author$project$Demand$Demand$productDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'aggregatedOrders',
		$author$project$Demand$Summary$amountsByProductDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$author$project$DistributionPoint$DistributionPoint$idDecoder,
			$elm$json$Json$Decode$succeed($author$project$Demand$Summary$DistributionPoint))));
var $author$project$Demand$Summary$loadForDPCmd = F5(
	function (token, toMsg, dpId, date, tracker) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'distributionpoints',
					$author$project$DistributionPoint$DistributionPoint$encodeIdForUrl(dpId),
					'orders',
					$author$project$Date$DeliveryDate$encodeForUrl(date),
					'aggregated'
				]),
			_List_Nil);
		return A5($author$project$Api$Request$get, token, toMsg, uri, $author$project$Demand$Summary$distributionPointDecoder, tracker);
	});
var $author$project$Demand$Demand$SegmentOrders = F2(
	function (segmentId, orders) {
		return {Y: orders, jZ: segmentId};
	});
var $author$project$Demand$Demand$Order = function (productId) {
	return function (address) {
		return function (name) {
			return function (demandType) {
				return function (amount) {
					return function (info) {
						return function (validDays) {
							return function (label) {
								return function (mutation) {
									return function (additionalAddressInfo) {
										return {f0: additionalAddressInfo, f1: address, aa: amount, lB: demandType, iP: info, mD: label, mN: mutation, ft: name, av: productId, hD: validDays};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Demand$Demand$InfoChanged = 2;
var $author$project$Demand$Demand$Start = 0;
var $author$project$Demand$Demand$Stop = 1;
var $author$project$Demand$Demand$mutationDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'start':
				return $elm$json$Json$Decode$succeed(0);
			case 'stop':
				return $elm$json$Json$Decode$succeed(1);
			case 'infochanged':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Invalid OrderMutation');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Demand$Demand$prodDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'DG RL':
				return $elm$json$Json$Decode$succeed('DG VA');
			case 'DG RN':
				return $elm$json$Json$Decode$succeed('DG NY');
			default:
				return $elm$json$Json$Decode$succeed(string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Demand$Demand$orderDecoder = function () {
	var addressDecoder = A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'location',
		$elm$json$Json$Decode$maybe($mgold$elm_geojson$GeoJson$decoder),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'country',
			$author$project$Address$Address$countryCodeDecoder,
			3,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'address',
				A2($elm$json$Json$Decode$index, 1, $author$project$Address$Address$houseNumberDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'address',
					A2($elm$json$Json$Decode$index, 2, $elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'address',
						A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'address',
							A2($elm$json$Json$Decode$index, 3, $elm$json$Json$Decode$string),
							$elm$json$Json$Decode$succeed($author$project$Address$Address$Address)))))));
	return A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'additionalAddressInfo',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'mutation',
			$elm$json$Json$Decode$maybe($author$project$Demand$Demand$mutationDecoder),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'label',
				$elm$json$Json$Decode$bool,
				false,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'validDays',
					$author$project$Date$DaysInTheWeek$emptyIsEveryDeliveryDayDecoder,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'info',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'amount',
							$author$project$Api$Request$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'type',
								$author$project$Demand$Demand$demandTypeDecoder,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'name',
									$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
									$elm$core$Maybe$Nothing,
									A2(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
										addressDecoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'prod',
											$author$project$Demand$Demand$prodDecoder,
											$elm$json$Json$Decode$succeed($author$project$Demand$Demand$Order)))))))))));
}();
var $author$project$Demand$Demand$segmentOrdersDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'orders',
	$elm$json$Json$Decode$list($author$project$Demand$Demand$orderDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'segmentId',
		$author$project$DistributionPoint$DistributionPoint$segmentIdDecoder,
		$elm$json$Json$Decode$succeed($author$project$Demand$Demand$SegmentOrders)));
var $author$project$Demand$Demand$subPath = F3(
	function (dpId, _for, date) {
		return _List_fromArray(
			[
				'distributionpoints',
				$author$project$DistributionPoint$DistributionPoint$encodeIdForUrl(dpId),
				_for,
				$author$project$Date$DeliveryDate$encodeForUrl(date)
			]);
	});
var $author$project$Demand$Demand$loadOrdersCmd = F4(
	function (token, toMsg, dpId, date) {
		var uri = A2(
			$author$project$Api$Uri$for,
			A3($author$project$Demand$Demand$subPath, dpId, 'orders', date),
			_List_Nil);
		return A4(
			$author$project$Api$Request$get,
			token,
			toMsg,
			uri,
			$elm$json$Json$Decode$list($author$project$Demand$Demand$segmentOrdersDecoder));
	});
var $author$project$Demand$Demand$loadProductsCmd = F4(
	function (token, toMsg, dpId, date) {
		var uri = A2(
			$author$project$Api$Uri$for,
			A3($author$project$Demand$Demand$subPath, dpId, 'products', date),
			_List_Nil);
		return A4(
			$author$project$Api$Request$get,
			token,
			toMsg,
			uri,
			$elm$json$Json$Decode$list($author$project$Demand$Demand$productDecoder));
	});
var $author$project$Date$DeliveryDate$monthToString = function (month) {
	switch (month) {
		case 0:
			return 'Jan';
		case 1:
			return 'Feb';
		case 2:
			return 'Mar';
		case 3:
			return 'Apr';
		case 4:
			return 'Mei';
		case 5:
			return 'Jun';
		case 6:
			return 'Jul';
		case 7:
			return 'Aug';
		case 8:
			return 'Sep';
		case 9:
			return 'Okt';
		case 10:
			return 'Nov';
		default:
			return 'Dec';
	}
};
var $author$project$Date$DeliveryDate$viewWeekday = function (weekday) {
	switch (weekday) {
		case 0:
			return 'Ma';
		case 1:
			return 'Di';
		case 2:
			return 'Wo';
		case 3:
			return 'Do';
		case 4:
			return 'Vr';
		case 5:
			return 'Za';
		default:
			return 'Zo';
	}
};
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		default:
			return 6;
	}
};
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $author$project$Date$DeliveryDate$view = function (deliveryDate) {
	var date = $author$project$Date$DeliveryDate$toDate(deliveryDate);
	return A2(
		$elm$core$String$join,
		' ',
		_List_fromArray(
			[
				$elm$core$String$toLower(
				$author$project$Date$DeliveryDate$viewWeekday(
					$justinmimbs$date$Date$weekday(date))),
				$elm$core$String$fromInt(
				$justinmimbs$date$Date$day(date)),
				$elm$core$String$toLower(
				$author$project$Date$DeliveryDate$monthToString(
					$justinmimbs$date$Date$month(date))),
				$elm$core$String$fromInt(
				$justinmimbs$date$Date$year(date))
			]));
};
var $author$project$Plan$Plan$comparableId = function (id) {
	return _Utils_ap(
		$author$project$DistributionPoint$DistributionPoint$comparableId(id.gm),
		$author$project$Date$DeliveryDate$view(id.lx));
};
var $author$project$Count$Count$actionIdFor = F2(
	function (id, planId) {
		return A2(
			$author$project$Portal$Waiting$Id,
			'count' + $author$project$Plan$Plan$comparableId(planId),
			id);
	});
var $author$project$Count$Count$singleAction = F2(
	function (id, planId) {
		return $author$project$Portal$Waiting$singleAction(
			A2($author$project$Count$Count$actionIdFor, id, planId));
	});
var $author$project$Count$Count$loadingDP = $author$project$Count$Count$singleAction('loadingDP');
var $author$project$Count$Count$loadingOrders = $author$project$Count$Count$singleAction('loadingOrders');
var $author$project$Count$Count$loadingPlan = F2(
	function (key, stage) {
		return A2($author$project$Count$Count$singleAction, 'loadingPlan' + stage, key);
	});
var $author$project$Count$Count$loadingProducts = $author$project$Count$Count$singleAction('loadingProducts');
var $author$project$Count$Count$loadingSummaries = F2(
	function (key, index) {
		return A2(
			$author$project$Count$Count$singleAction,
			'loadingSummaries' + $elm$core$String$fromInt(index),
			key);
	});
var $elm$core$List$unzip = function (pairs) {
	var step = F2(
		function (_v0, _v1) {
			var x = _v0.a;
			var y = _v0.b;
			var xs = _v1.a;
			var ys = _v1.b;
			return _Utils_Tuple2(
				A2($elm$core$List$cons, x, xs),
				A2($elm$core$List$cons, y, ys));
		});
	return A3(
		$elm$core$List$foldr,
		step,
		_Utils_Tuple2(_List_Nil, _List_Nil),
		pairs);
};
var $author$project$Portal$Init$addTrackedCommands = F3(
	function (toAction, toCmds, _v0) {
		var share = _v0.fQ;
		var key = _v0.iY;
		var commands = _v0.aC;
		return function (_v1) {
			var actions = _v1.a;
			var cmds = _v1.b;
			return {
				aC: _Utils_ap(cmds, commands),
				iY: key,
				fQ: A2($author$project$Portal$Share$withWaitingActions, actions, share)
			};
		}(
			$elm$core$List$unzip(
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, toCmd) {
							var action = A2(toAction, key, index);
							return _Utils_Tuple2(
								action,
								A2(
									toCmd,
									index,
									$author$project$Portal$Init$tracked(action)));
						}),
					toCmds)));
	});
var $author$project$Portal$Init$multiIfJust = F4(
	function (accessor, toAction, toCmds, model) {
		var _v0 = accessor(
			$author$project$Portal$Init$data(model));
		if (!_v0.$) {
			var d = _v0.a;
			return A3(
				$author$project$Portal$Init$addTrackedCommands,
				toAction,
				toCmds(d),
				model);
		} else {
			return model;
		}
	});
var $author$project$Count$Count$AmountsLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Count$Count$LoadingAmounts = function (a) {
	return {$: 0, a: a};
};
var $author$project$Count$Count$NoProductsFound = function (a) {
	return {$: 3, a: a};
};
var $author$project$Count$Count$ShowingAmount = function (a) {
	return {$: 0, a: a};
};
var $author$project$DistributionPoint$DistributionPoint$containsSegmentWithId = F2(
	function (segments, sId) {
		return A3(
			$elm$core$Basics$composeR,
			$elm$core$List$isEmpty,
			$elm$core$Basics$not,
			A2(
				$elm$core$List$filter,
				function (s) {
					return _Utils_eq(
						$author$project$DistributionPoint$DistributionPoint$segmentId(s),
						sId);
				},
				segments));
	});
var $author$project$Count$Count$filterOrdersOnCluster = F2(
	function (cluster, segmentOrders) {
		switch (cluster.$) {
			case 0:
				var segments = cluster.a.bb;
				return A2(
					$elm$core$List$filter,
					function (o) {
						return A2($author$project$DistributionPoint$DistributionPoint$containsSegmentWithId, segments, o.jZ);
					},
					segmentOrders);
			case 1:
				var segments = cluster.a.bb;
				return A2(
					$elm$core$List$filter,
					function (o) {
						return A2($author$project$DistributionPoint$DistributionPoint$containsSegmentWithId, segments, o.jZ);
					},
					segmentOrders);
			default:
				return _List_Nil;
		}
	});
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $elm_community$list_extra$List$Extra$gatherEqualsBy = F2(
	function (extract, list) {
		return A2(
			$elm_community$list_extra$List$Extra$gatherWith,
			F2(
				function (a, b) {
					return _Utils_eq(
						extract(a),
						extract(b));
				}),
			list);
	});
var $author$project$Demand$Bundle$Bundle = $elm$core$Basics$identity;
var $author$project$Demand$Bundle$combine = F2(
	function (b, o) {
		var bundle = b;
		var other = o;
		return (!_Utils_eq(bundle.E, other.E)) ? _Utils_Tuple2(
			b,
			$elm$core$Maybe$Just(o)) : _Utils_Tuple2(
			{aM: bundle.aM + other.aM, E: bundle.E, dl: bundle.dl + other.dl},
			$elm$core$Maybe$Nothing);
	});
var $author$project$Count$Count$mergeClustersAndBundles = F2(
	function (left, right) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (c) {
					return function (b) {
						return _Utils_update(
							c,
							{G: b});
					}(
						A3(
							$elm$core$List$foldl,
							F2(
								function (cluster, cummul) {
									return A2($author$project$Demand$Bundle$combine, cummul, cluster.G).a;
								}),
							c.G,
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.H;
									},
									$elm$core$Basics$eq(c.H)),
								right)));
				},
				left),
			A2(
				$elm$core$List$filter,
				function (c) {
					return _Utils_eq(
						A2(
							$elm_community$list_extra$List$Extra$find,
							function (cluster) {
								return _Utils_eq(c.H, cluster.H);
							},
							left),
						$elm$core$Maybe$Nothing);
				},
				right));
	});
var $author$project$Demand$Bundle$make = F2(
	function (_v0, amount) {
		var packSize = _v0.E;
		var packs = (amount / packSize) | 0;
		var individual = amount % packSize;
		return {aM: individual, E: packSize, dl: packs};
	});
var $author$project$Demand$Bundle$total = function (_v0) {
	var individual = _v0.aM;
	var packs = _v0.dl;
	var packSize = _v0.E;
	return individual + (packs * packSize);
};
var $author$project$Demand$Bundle$repack = function (b) {
	var bundle = b;
	return A2(
		$author$project$Demand$Bundle$make,
		bundle,
		$author$project$Demand$Bundle$total(b));
};
var $author$project$Count$Count$mergeSameIds = function (numbersById) {
	var merge = F2(
		function (left, right) {
			return A2(
				$elm$core$List$map,
				function (_v3) {
					var cluster = _v3.H;
					var bundle = _v3.G;
					return {
						G: $author$project$Demand$Bundle$repack(bundle),
						H: cluster
					};
				},
				A2($author$project$Count$Count$mergeClustersAndBundles, left, right));
		});
	return A2(
		$elm$core$List$map,
		function (_v0) {
			var _v1 = _v0.a;
			var id = _v1.a;
			var amount = _v1.b;
			var sameIdAmounts = _v0.b;
			return _Utils_Tuple2(
				id,
				A3(
					$elm$core$List$foldl,
					F2(
						function (_v2, cumm) {
							var a = _v2.b;
							return _Utils_update(
								cumm,
								{
									k: A2(merge, a.k, cumm.k)
								});
						}),
					amount,
					sameIdAmounts));
		},
		A2($elm_community$list_extra$List$Extra$gatherEqualsBy, $elm$core$Tuple$first, numbersById));
};
var $author$project$Count$Count$onlyOrdersWhere = F2(
	function (satisfy, listOfSegmentOrders) {
		return A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Y;
				},
				A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)),
			A2(
				$elm$core$List$map,
				function (segmentOrders) {
					return _Utils_update(
						segmentOrders,
						{
							Y: A2($elm$core$List$filter, satisfy, segmentOrders.Y)
						});
				},
				listOfSegmentOrders));
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $author$project$Demand$Demand$totalAmountOf = function (orders) {
	return $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			function ($) {
				return $.aa;
			},
			A2(
				$elm$core$List$concatMap,
				function ($) {
					return $.Y;
				},
				orders)));
};
var $author$project$Count$Count$toBundles = function (os) {
	return function (cs) {
		return {k: cs, E: os.E};
	}(
		A2(
			$elm$core$List$map,
			function (c) {
				return {
					G: A2(
						$author$project$Demand$Bundle$make,
						os,
						$author$project$Demand$Demand$totalAmountOf(c.Y)),
					H: c.H
				};
			},
			os.k));
};
var $author$project$Count$Count$amountByProductOrInsertBasedOnOrders = F3(
	function (clusters, orders, products) {
		var nonStopOrders = A2(
			$author$project$Count$Count$onlyOrdersWhere,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.mN;
				},
				$elm$core$Basics$neq(
					$elm$core$Maybe$Just(1))),
			orders);
		return $elm$core$Dict$fromList(
			$author$project$Count$Count$mergeSameIds(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$second,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.k;
							},
							A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not))),
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$mapSecond($author$project$Count$Count$toBundles),
						A2(
							$elm$core$List$concatMap,
							function (_v0) {
								var p = _v0.a;
								var cs = _v0.b;
								return A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										p.eg,
										{k: cs, E: p.E}),
									A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$Tuple$second,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.k;
												},
												A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not))),
										A2(
											$elm$core$List$map,
											function (i) {
												return _Utils_Tuple2(
													i.eg,
													{
														k: A2(
															$elm$core$List$map,
															function (cl) {
																return _Utils_update(
																	cl,
																	{
																		Y: A2(
																			$author$project$Count$Count$onlyOrdersWhere,
																			function (o) {
																				return A2($elm$core$List$member, o.lB, i.$8);
																			},
																			cl.Y)
																	});
															},
															cs),
														E: i.E
													});
											},
											p.iT)));
							},
							A2(
								$elm$core$List$map,
								$elm$core$Tuple$mapSecond(
									function (so) {
										return A2(
											$elm$core$List$map,
											function (c) {
												return {
													H: c,
													Y: A2($author$project$Count$Count$filterOrdersOnCluster, c, so)
												};
											},
											clusters);
									}),
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$Tuple$second,
										A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)),
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_Tuple2(
												p,
												A2(
													$author$project$Count$Count$onlyOrdersWhere,
													A2(
														$elm$core$Basics$composeR,
														function ($) {
															return $.av;
														},
														$elm$core$Basics$eq(p.eg)),
													nonStopOrders));
										},
										products))))))));
	});
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $author$project$Demand$Bundle$visibleAmount = F2(
	function (config, bundle) {
		var individual = bundle.aM;
		var packs = bundle.dl;
		switch (config.$) {
			case 0:
				return packs;
			case 1:
				return individual;
			default:
				return $author$project$Demand$Bundle$total(bundle);
		}
	});
var $author$project$Count$Count$amountsFilterFor = F2(
	function (_v0, bundle) {
		var bundleConfig = _v0.ag;
		var zeroVisibility = _v0.eH;
		if (zeroVisibility === 1) {
			return true;
		} else {
			return !(!A2($author$project$Demand$Bundle$visibleAmount, bundleConfig, bundle));
		}
	});
var $author$project$Count$Count$validIndexesFor = F2(
	function (options, _v0) {
		var clusters = _v0.k;
		return A2(
			$elm$core$List$map,
			$elm$core$Tuple$first,
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$second,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.G;
						},
						$author$project$Count$Count$amountsFilterFor(options))),
				A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, clusters)));
	});
var $author$project$Count$Count$firstValidIndex = F2(
	function (options, clusters) {
		return $elm$core$List$head(
			A2($author$project$Count$Count$validIndexesFor, options, clusters));
	});
var $timo_weike$generic_collections$ManualDict$foldl = F3(
	function (f, start, _v0) {
		var dict = _v0;
		var combine = F3(
			function (_v1, _v2, prev) {
				var key = _v2.a;
				var value = _v2.b;
				return A3(f, key, value, prev);
			});
		return A3($elm$core$Dict$foldl, combine, start, dict);
	});
var $author$project$DistributionPoint$IdDict$foldl = $timo_weike$generic_collections$ManualDict$foldl;
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $author$project$Count$Count$mergeAmountsByProductOrInsert = F2(
	function (amounts, otherAmounts) {
		return A6(
			$elm$core$Dict$merge,
			F2(
				function (id, amount) {
					return A2($elm$core$Dict$insert, id, amount);
				}),
			F3(
				function (id, amount, otherAmount) {
					return _Utils_eq(amount.E, otherAmount.E) ? A2(
						$elm$core$Dict$insert,
						id,
						_Utils_update(
							amount,
							{
								k: A2($author$project$Count$Count$mergeClustersAndBundles, amount.k, otherAmount.k)
							})) : A2(
						$elm$core$Basics$composeR,
						A2($elm$core$Dict$insert, id, amount),
						A2($elm$core$Dict$insert, id, otherAmount));
				}),
			F2(
				function (id, amount) {
					return A2($elm$core$Dict$insert, id, amount);
				}),
			amounts,
			otherAmounts,
			$elm$core$Dict$empty);
	});
var $author$project$Plan$Supply$findFirstClusterOfDeliverers = F2(
	function (items, deliverers) {
		return A2(
			$elm$core$List$filterMap,
			function (deliverer) {
				var _v0 = A2($author$project$Plan$Supply$findByDeliverer, deliverer.eg, items);
				if (_v0.b) {
					var head = _v0.a;
					var _v1 = $author$project$Plan$Supply$ownClustersOf(head);
					if (_v1.b) {
						var cluster = _v1.a;
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(deliverer, cluster));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			deliverers);
	});
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {h3: col, dp: problem, dv: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.dv, p.h3, p.dp);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{h3: 1, g: _List_Nil, l: 1, c: 0, dv: 1, ka: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.ka);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.c, offset) < 0,
					0,
					{h3: col, g: s0.g, l: s0.l, c: offset, dv: row, ka: s0.ka});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.c, s.dv, s.h3, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.c, s1.c, s0.ka),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $author$project$Demand$Demand$titleParser = $elm$parser$Parser$getChompedString(
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed(0),
		$elm$parser$Parser$chompWhile($elm$core$Char$isAlpha)));
var $author$project$Demand$Demand$titleOf = function (productId) {
	var _v0 = A2($elm$parser$Parser$run, $author$project$Demand$Demand$titleParser, productId);
	if (!_v0.$) {
		var title = _v0.a;
		return title;
	} else {
		return productId;
	}
};
var $author$project$Demand$Extra$orderChangedToExistingProduct = F2(
	function (products, order) {
		var _v0 = A2(
			$elm_community$list_extra$List$Extra$find,
			function (p) {
				return _Utils_eq(p.eg, order.av);
			},
			products);
		if (!_v0.$) {
			return order;
		} else {
			var title = $author$project$Demand$Demand$titleOf(order.av);
			var _v1 = A2(
				$elm$core$List$filter,
				function (p) {
					return _Utils_eq(
						$author$project$Demand$Demand$titleOf(p.eg),
						title);
				},
				products);
			if (_v1.b && (!_v1.b.b)) {
				var product = _v1.a;
				return _Utils_update(
					order,
					{av: product.eg});
			} else {
				return order;
			}
		}
	});
var $author$project$Payment$Company$dpgMedia = {
	f1: {
		h8: 0,
		bs: A2($author$project$Address$Address$HouseNumber, 43, $elm$core$Maybe$Nothing),
		i3: $elm$core$Maybe$Nothing,
		bU: 'Amsterdam-Duivendrecht',
		b5: 'Joan Muyskenweg',
		cT: '1114 AN'
	},
	hY: {hX: 'NL95 ABNA 0404 5724 64', ft: 'ABN AMRO'},
	d5: 'dpdfm.adminfin@dpgmedia.nl',
	i_: {bU: 'Amsterdam', bX: '33010500'},
	ft: 'DPG Distributie',
	eq: '020-5623030',
	nh: {
		h8: 0,
		bs: A2($author$project$Address$Address$HouseNumber, 2104, $elm$core$Maybe$Nothing),
		i3: $elm$core$Maybe$Nothing,
		bU: 'Amsterdam',
		b5: 'Postbus',
		cT: '1000 CC'
	},
	kv: 'NL005096765 B01'
};
var $author$project$Demand$Extra$extraOrderFromProductId = function (productId) {
	return {f0: _List_Nil, f1: $author$project$Payment$Company$dpgMedia.f1, aa: 1, lB: 2, iP: $elm$core$Maybe$Nothing, mD: false, mN: $elm$core$Maybe$Nothing, ft: $elm$core$Maybe$Nothing, av: productId, hD: $author$project$Date$DaysInTheWeek$everyDeliveryDay};
};
var $author$project$Demand$Extra$toExtraSegmentOrder = F2(
	function (segmentId, productId) {
		return A2(
			$author$project$Demand$Demand$SegmentOrders,
			segmentId,
			_List_fromArray(
				[
					$author$project$Demand$Extra$extraOrderFromProductId(productId)
				]));
	});
var $author$project$Demand$Extra$orders = F3(
	function (items, deliverers, products) {
		return A2(
			$elm$core$List$map,
			function (so) {
				return _Utils_update(
					so,
					{
						Y: A2(
							$elm$core$List$map,
							$author$project$Demand$Extra$orderChangedToExistingProduct(products),
							so.Y)
					});
			},
			A2(
				$elm$core$List$filterMap,
				function (_v0) {
					var d = _v0.a;
					var c = _v0.b;
					return A3(
						$elm$core$Maybe$map2,
						$author$project$Demand$Extra$toExtraSegmentOrder,
						$elm$core$List$head(c.bb),
						d.nj);
				},
				A2($author$project$Plan$Supply$findFirstClusterOfDeliverers, items, deliverers)));
	});
var $author$project$Portal$ShareData$noChange = function (model) {
	return model;
};
var $author$project$Portal$ShareData$withDistributionPoint = F2(
	function (distributionPoint, model) {
		return _Utils_update(
			model,
			{
				bn: $elm$core$Maybe$Just(distributionPoint)
			});
	});
var $author$project$Portal$ShareData$withOrders = F2(
	function (orders, model) {
		return _Utils_update(
			model,
			{
				Y: $elm$core$Maybe$Just(orders)
			});
	});
var $author$project$Portal$ShareData$withPlan = F2(
	function (plan, model) {
		return _Utils_update(
			model,
			{
				fA: $elm$core$Maybe$Just(plan)
			});
	});
var $author$project$Portal$ShareData$withProducts = F2(
	function (products, model) {
		return _Utils_update(
			model,
			{
				bu: $elm$core$Maybe$Just(products)
			});
	});
var $author$project$Portal$ShareData$withTypedDeliverers = F2(
	function (deliverersTyped, model) {
		return _Utils_update(
			model,
			{
				id: $elm$core$Maybe$Just(deliverersTyped)
			});
	});
var $author$project$Count$Count$shareFrom = F6(
	function (date, distributionPoint, plan, deliverers, orders, products) {
		return A3(
			$elm$core$Basics$composeR,
			A2(
				$elm$core$Maybe$withDefault,
				$author$project$Portal$ShareData$noChange,
				A2($elm$core$Maybe$map, $author$project$Portal$ShareData$withDistributionPoint, distributionPoint)),
			A2(
				$elm$core$Basics$composeR,
				A2(
					$elm$core$Maybe$withDefault,
					$author$project$Portal$ShareData$noChange,
					A2($elm$core$Maybe$map, $author$project$Portal$ShareData$withTypedDeliverers, deliverers)),
				A2(
					$elm$core$Basics$composeR,
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Portal$ShareData$noChange,
						A2($elm$core$Maybe$map, $author$project$Portal$ShareData$withPlan, plan)),
					A2(
						$elm$core$Basics$composeR,
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Portal$ShareData$noChange,
							A2($elm$core$Maybe$map, $author$project$Portal$ShareData$withOrders, orders)),
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Portal$ShareData$noChange,
							A2($elm$core$Maybe$map, $author$project$Portal$ShareData$withProducts, products))))),
			$author$project$Portal$ShareData$empty(date));
	});
var $author$project$Count$Count$SubDistributionPoint = function (a) {
	return {$: 2, a: a};
};
var $author$project$Demand$Demand$DistributionPoint = 4;
var $author$project$Demand$Demand$Own = 3;
var $author$project$Demand$Demand$Segment = 5;
var $author$project$Demand$Demand$extraDemandTypes = _List_fromArray(
	[3, 4, 5]);
var $author$project$Demand$Demand$allTypes = _Utils_ap(
	_List_fromArray(
		[0, 1, 2]),
	$author$project$Demand$Demand$extraDemandTypes);
var $author$project$Demand$TypeDict$filter = $timo_weike$generic_collections$ManualDict$filter;
var $author$project$DistributionPoint$DistributionPoint$findSubDistributionPointOnId = F2(
	function (_v0, distributionPointId) {
		var distributionPoint = _v0;
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (d) {
					return _Utils_eq(
						$author$project$DistributionPoint$DistributionPoint$idOf(d),
						distributionPointId);
				},
				distributionPoint.hw));
	});
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $author$project$Demand$TypeDict$values = $timo_weike$generic_collections$ManualDict$values;
var $author$project$Count$Count$subDistributionPointAmountByProductOrInsert = F2(
	function (distributionPoint, _v0) {
		var dpId = _v0.lK;
		var amountsByProduct = _v0.kO;
		var products = _v0.bu;
		var packsOf = F3(
			function (productOrInsert, a, demandTypes) {
				return A2(
					$author$project$Demand$Bundle$make,
					productOrInsert,
					$elm$core$List$sum(
						$author$project$Demand$TypeDict$values(
							A2(
								$author$project$Demand$TypeDict$filter,
								F2(
									function (demandType, _v4) {
										return A2($elm$core$List$member, demandType, demandTypes);
									}),
								a))));
			});
		var cluster = $author$project$Count$Count$SubDistributionPoint(
			A2(
				$elm$core$Result$fromMaybe,
				dpId,
				A2($author$project$DistributionPoint$DistributionPoint$findSubDistributionPointOnId, distributionPoint, dpId)));
		return $elm$core$Dict$fromList(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$second,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.k;
						},
						A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not))),
				A2(
					$elm$core$List$concatMap,
					function (_v3) {
						var product = _v3.a;
						var amountsByDemandType = _v3.b;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								product.eg,
								{
									k: _List_fromArray(
										[
											{
											G: A3(packsOf, product, amountsByDemandType, $author$project$Demand$Demand$allTypes),
											H: cluster
										}
										]),
									E: product.E
								}),
							A2(
								$elm$core$List$map,
								function (i) {
									return _Utils_Tuple2(
										i.eg,
										{
											k: _List_fromArray(
												[
													{
													G: A3(packsOf, i, amountsByDemandType, i.$8),
													H: cluster
												}
												]),
											E: i.E
										});
								},
								product.iT));
					},
					A2(
						$elm$core$List$filterMap,
						function (_v1) {
							var pId = _v1.a;
							var a = _v1.b;
							var _v2 = A2(
								$elm_community$list_extra$List$Extra$find,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.eg;
									},
									$elm$core$Basics$eq(pId)),
								products);
							if (!_v2.$) {
								var product = _v2.a;
								return $elm$core$Maybe$Just(
									_Utils_Tuple2(product, a));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						},
						$elm$core$Dict$toList(amountsByProduct)))));
	});
var $author$project$Count$Count$Bike = function (a) {
	return {$: 1, a: a};
};
var $author$project$Count$Count$Car = function (a) {
	return {$: 0, a: a};
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $author$project$Count$Count$toCluster = F2(
	function (distributionPoint, item) {
		var getSegments = F2(
			function (_v1, ids) {
				var dp = _v1;
				return A2(
					$elm$core$List$filter,
					function (s) {
						return A2(
							$elm$core$List$member,
							$author$project$DistributionPoint$DistributionPoint$segmentId(s),
							ids);
					},
					dp.bb);
			});
		switch (item.$) {
			case 0:
				var deliverer = item.a.bl;
				var cluster = item.a.H;
				return $elm$core$List$singleton(
					$author$project$Count$Count$Car(
						{
							bl: $author$project$Deliverer$Deliverer$fromTyped(deliverer),
							eg: cluster.bX,
							bb: A2(getSegments, distributionPoint, cluster.bb)
						}));
			case 1:
				var deliverer = item.a.bl;
				var clusters = item.a.k;
				return A2(
					$elm$core$List$map,
					function (c) {
						return $author$project$Count$Count$Bike(
							{
								bl: $author$project$Deliverer$Deliverer$fromTyped(deliverer),
								eg: c.bX,
								bb: A2(getSegments, distributionPoint, c.bb)
							});
					},
					clusters);
			default:
				var dpId = item.a.lK;
				return $elm$core$List$singleton(
					$author$project$Count$Count$SubDistributionPoint(
						A2(
							$elm$core$Result$fromMaybe,
							dpId,
							A2($author$project$DistributionPoint$DistributionPoint$findSubDistributionPointOnId, distributionPoint, dpId))));
		}
	});
var $elm_community$list_extra$List$Extra$findIndexHelp = F3(
	function (index, predicate, list) {
		findIndexHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					return $elm$core$Maybe$Just(index);
				} else {
					var $temp$index = index + 1,
						$temp$predicate = predicate,
						$temp$list = xs;
					index = $temp$index;
					predicate = $temp$predicate;
					list = $temp$list;
					continue findIndexHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$findIndex = $elm_community$list_extra$List$Extra$findIndexHelp(0);
var $author$project$Count$Count$withSortedClusters = F2(
	function (correctOrderedClusters, clusterPacks) {
		return _Utils_update(
			clusterPacks,
			{
				k: A2(
					$elm$core$List$sortBy,
					function (c) {
						return A2(
							$elm$core$Maybe$withDefault,
							-1,
							A2(
								$elm_community$list_extra$List$Extra$findIndex,
								$elm$core$Basics$eq(c.H),
								correctOrderedClusters));
					},
					clusterPacks.k)
			});
	});
var $author$project$Count$Count$convert = F3(
	function (date, options, _v0) {
		var distributionPoint = _v0.bn;
		var deliverers = _v0.e4;
		var plan = _v0.fA;
		var orders = _v0.Y;
		var demandSummaryBySubDPId = _v0.bm;
		var subDPDemandSummaryErrors = _v0.b6;
		var products = _v0.bu;
		var countClusters = A2(
			$elm$core$List$concatMap,
			$author$project$Count$Count$toCluster(distributionPoint),
			$author$project$Plan$Supply$flatten(plan.gL));
		var allOrders = _Utils_ap(
			orders,
			A3(
				$author$project$Demand$Extra$orders,
				plan.gL,
				A2(
					$elm$core$List$map,
					$author$project$Deliverer$Deliverer$fromTyped,
					$author$project$Deliverer$IdDict$values(deliverers)),
				products));
		var amountByProductOrInsert = A2(
			$elm$core$Dict$map,
			F2(
				function (_v3, a) {
					return A2($author$project$Count$Count$withSortedClusters, countClusters, a);
				}),
			A3(
				$author$project$DistributionPoint$IdDict$foldl,
				F3(
					function (_v2, demandSummary, cummul) {
						return A2(
							$author$project$Count$Count$mergeAmountsByProductOrInsert,
							cummul,
							A2($author$project$Count$Count$subDistributionPointAmountByProductOrInsert, distributionPoint, demandSummary));
					}),
				A3($author$project$Count$Count$amountByProductOrInsertBasedOnOrders, countClusters, allOrders, products),
				demandSummaryBySubDPId));
		var _v1 = $elm$core$Dict$keys(amountByProductOrInsert);
		if (!_v1.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var firstProductId = _v1.a;
			return $elm$core$Maybe$Just(
				{
					aY: amountByProductOrInsert,
					bm: demandSummaryBySubDPId,
					bn: distributionPoint,
					a3: $elm$core$Set$empty,
					fQ: A6(
						$author$project$Count$Count$shareFrom,
						date,
						$elm$core$Maybe$Just(distributionPoint),
						$elm$core$Maybe$Just(plan),
						$elm$core$Maybe$Just(deliverers),
						$elm$core$Maybe$Just(orders),
						$elm$core$Maybe$Just(products)),
					y: $author$project$Count$Count$ShowingAmount(
						{
							v: A2(
								$elm$core$Maybe$andThen,
								$author$project$Count$Count$firstValidIndex(options),
								A2($elm$core$Dict$get, firstProductId, amountByProductOrInsert)),
							av: firstProductId
						}),
					b6: subDPDemandSummaryErrors
				});
		}
	});
var $author$project$Plan$PlanLoader$loadedOf = function (model) {
	if (model.$ === 3) {
		var loaded = model.a;
		return $elm$core$Maybe$Just(loaded);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $timo_weike$generic_collections$ManualDict$size = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$size(dict);
};
var $author$project$DistributionPoint$IdDict$size = $timo_weike$generic_collections$ManualDict$size;
var $author$project$Count$Count$next = F3(
	function (date, options, original) {
		var distributionPoint = original.bn;
		var planAndDeliverers = original.fB;
		var orders = original.Y;
		var demandSummaryBySubDPId = original.bm;
		var subDPDemandSummaryErrors = original.b6;
		var products = original.bu;
		var _v0 = _Utils_Tuple2(
			distributionPoint,
			$author$project$Plan$PlanLoader$loadedOf(planAndDeliverers));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var dp = _v0.a.a;
			var p = _v0.b.a;
			var numSubDPs = $elm$core$List$length(
				$author$project$DistributionPoint$DistributionPoint$getSubDistributionPoints(dp));
			var subDPSummariesLoadingComplete = _Utils_eq(
				numSubDPs,
				$author$project$DistributionPoint$IdDict$size(demandSummaryBySubDPId) + $elm$core$List$length(subDPDemandSummaryErrors));
			var _v1 = _Utils_Tuple2(
				_Utils_Tuple2(orders, subDPSummariesLoadingComplete),
				products);
			if (((!_v1.a.a.$) && _v1.a.b) && (!_v1.b.$)) {
				var _v2 = _v1.a;
				var o = _v2.a.a;
				var justProducts = _v1.b.a;
				var _v3 = A3(
					$author$project$Count$Count$convert,
					date,
					options,
					{e4: p.e4, bm: demandSummaryBySubDPId, bn: dp, Y: o, fA: p.fA, bu: justProducts, b6: subDPDemandSummaryErrors});
				if (_v3.$ === 1) {
					return $author$project$Count$Count$NoProductsFound(
						{
							bn: dp,
							fQ: A6(
								$author$project$Count$Count$shareFrom,
								date,
								distributionPoint,
								$elm$core$Maybe$Just(p.fA),
								$elm$core$Maybe$Just(p.e4),
								orders,
								products)
						});
				} else {
					var converted = _v3.a;
					return $author$project$Count$Count$AmountsLoaded(converted);
				}
			} else {
				return $author$project$Count$Count$LoadingAmounts(original);
			}
		} else {
			return $author$project$Count$Count$LoadingAmounts(original);
		}
	});
var $author$project$Count$Count$shareDataFromModel = function (model) {
	var _v0 = model.j;
	switch (_v0.$) {
		case 0:
			var distributionPoint = _v0.a.bn;
			var planAndDeliverers = _v0.a.fB;
			var orders = _v0.a.Y;
			var products = _v0.a.bu;
			var _v1 = $author$project$Plan$PlanLoader$loadedOf(planAndDeliverers);
			if (!_v1.$) {
				var p = _v1.a;
				return A6(
					$author$project$Count$Count$shareFrom,
					model.a8.lx,
					distributionPoint,
					$elm$core$Maybe$Just(p.fA),
					$elm$core$Maybe$Just(p.e4),
					orders,
					products);
			} else {
				return A6($author$project$Count$Count$shareFrom, model.a8.lx, distributionPoint, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, orders, products);
			}
		case 1:
			var share = _v0.a.fQ;
			return share;
		case 3:
			var share = _v0.a.fQ;
			return share;
		default:
			return $author$project$Portal$ShareData$empty(model.a8.lx);
	}
};
var $author$project$Count$Count$init = F3(
	function (share, dpId, date) {
		var token = $author$project$Portal$Share$token(share);
		var planId = A2($author$project$Plan$Plan$Id, dpId, date);
		var defaultOptions = {ag: $author$project$Demand$Bundle$OnlyIndividuals, eH: 0};
		return A2(
			$author$project$Portal$Return$ensureDataShared,
			$author$project$Count$Count$shareDataFromModel,
			A2(
				$author$project$Portal$Init$withModelFromData,
				function (shareData) {
					return {
						r: $author$project$Portal$Subheader$initCalendarState,
						m7: defaultOptions,
						j: A3(
							$author$project$Count$Count$next,
							date,
							defaultOptions,
							{
								bm: $author$project$DistributionPoint$IdDict$empty,
								bn: shareData.bn,
								Y: shareData.Y,
								fB: A4($author$project$Plan$PlanLoader$initModel, share, $elm$core$Basics$identity, dpId, date),
								bu: shareData.bu,
								b6: _List_Nil
							}),
						a8: planId
					};
				},
				A4(
					$author$project$Portal$Init$ifNothing,
					function ($) {
						return $.bu;
					},
					$author$project$Count$Count$loadingProducts,
					A4($author$project$Demand$Demand$loadProductsCmd, token, $author$project$Count$Count$SystemLoadedProducts, dpId, date),
					A4(
						$author$project$Portal$Init$multiIfJust,
						function ($) {
							return $.bn;
						},
						$author$project$Count$Count$loadingSummaries,
						A2(
							$elm$core$Basics$composeR,
							$author$project$DistributionPoint$DistributionPoint$getSubDistributionPoints,
							$elm$core$List$map(
								F2(
									function (subDP, i) {
										return A4(
											$author$project$Demand$Summary$loadForDPCmd,
											token,
											$author$project$Count$Count$BackendRespondedDemandSummary(i),
											$author$project$DistributionPoint$DistributionPoint$idOf(subDP),
											date);
									}))),
						A4(
							$author$project$Portal$Init$ifNothing,
							function ($) {
								return $.Y;
							},
							$author$project$Count$Count$loadingOrders,
							A4($author$project$Demand$Demand$loadOrdersCmd, token, $author$project$Count$Count$SystemLoadedOrders, dpId, date),
							A5(
								$author$project$Portal$Init$withPlanLoader,
								$author$project$Count$Count$loadingPlan,
								dpId,
								date,
								$author$project$Count$Count$SystemGotLoaderMsg,
								A4(
									$author$project$Portal$Init$ifNothing,
									function ($) {
										return $.bn;
									},
									$author$project$Count$Count$loadingDP,
									A4($author$project$DistributionPoint$DistributionPoint$loadCmd, token, $author$project$Count$Count$SystemLoadedDistributionPoint, dpId, date),
									A2($author$project$Portal$Init$keyed, share, planId))))))));
	});
var $author$project$Dashboard$Dashboard$Dashboard = function (a) {
	return {$: 0, a: a};
};
var $author$project$Dashboard$Dashboard$SystemGotActiveBanner = function (a) {
	return {$: 0, a: a};
};
var $author$project$Dashboard$Dashboard$Banner = F3(
	function (publication, filename, url) {
		return {cl: filename, hd: publication, aW: url};
	});
var $elm_community$json_extra$Json$Decode$Extra$fromMaybe = F2(
	function (error, val) {
		if (!val.$) {
			var v = val.a;
			return $elm$json$Json$Decode$succeed(v);
		} else {
			return $elm$json$Json$Decode$fail(error);
		}
	});
var $author$project$Dashboard$Dashboard$bannerDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'url',
	A2(
		$elm$json$Json$Decode$andThen,
		A2(
			$elm$core$Basics$composeR,
			$elm$url$Url$fromString,
			$elm_community$json_extra$Json$Decode$Extra$fromMaybe('failed to decode url')),
		$elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'filename',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'publication',
			A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int),
			$elm$json$Json$Decode$succeed($author$project$Dashboard$Dashboard$Banner))));
var $author$project$Dashboard$Dashboard$loadActiveBannerCmd = F2(
	function (token, toMsg) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['assets', 'banners', 'active']),
			_List_Nil);
		return A4($author$project$Api$Request$get, token, toMsg, uri, $author$project$Dashboard$Dashboard$bannerDecoder);
	});
var $author$project$Dashboard$Dashboard$actionIdFor = function (id) {
	return A2($author$project$Portal$Waiting$Id, 'dashboard', id);
};
var $author$project$Dashboard$Dashboard$singleAction = function (id) {
	return $author$project$Portal$Waiting$singleAction(
		$author$project$Dashboard$Dashboard$actionIdFor(id));
};
var $author$project$Dashboard$Dashboard$loadingActiveBanner = $author$project$Dashboard$Dashboard$singleAction('loadingActiveBanner');
var $author$project$Dashboard$Dashboard$init = function (share) {
	var token = $author$project$Portal$Share$token(share);
	return A2(
		$author$project$Portal$Init$withModel,
		$author$project$Dashboard$Dashboard$Dashboard($elm$core$Maybe$Nothing),
		A3(
			$author$project$Portal$Init$withCommand,
			$elm$core$Basics$always($author$project$Dashboard$Dashboard$loadingActiveBanner),
			A2($author$project$Dashboard$Dashboard$loadActiveBannerCmd, token, $author$project$Dashboard$Dashboard$SystemGotActiveBanner),
			$author$project$Portal$Init$empty(share)));
};
var $author$project$Delay$Delay$Loading = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Delay$Delay$SystemGotDistributionPoint = function (a) {
	return {$: 8, a: a};
};
var $author$project$Delay$Delay$SystemGotLoaderMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Delay$Delay$actionIdFor = F2(
	function (id, _v0) {
		var dpId = _v0.a;
		var date = _v0.b;
		return A2(
			$author$project$Portal$Waiting$Id,
			'delay' + ($author$project$DistributionPoint$DistributionPoint$comparableId(dpId) + $author$project$Date$DeliveryDate$view(date)),
			id);
	});
var $author$project$Delay$Delay$singleAction = F2(
	function (id, unique) {
		return $author$project$Portal$Waiting$singleAction(
			A2($author$project$Delay$Delay$actionIdFor, id, unique));
	});
var $author$project$Delay$Delay$loadingDP = $author$project$Delay$Delay$singleAction('loadingDP');
var $author$project$Delay$Delay$loadingPlan = F2(
	function (key, stage) {
		return A2($author$project$Delay$Delay$singleAction, 'loadingPlan' + stage, key);
	});
var $author$project$Delay$Delay$shareDataFromModel = F2(
	function (date, model) {
		return function () {
			if (!model.$) {
				var m = model.b;
				return A2(
					$elm$core$Basics$composeR,
					function () {
						var _v1 = m.bn;
						if (!_v1.$) {
							var distributionPoint = _v1.a;
							return $author$project$Portal$ShareData$withDistributionPoint(distributionPoint);
						} else {
							return $author$project$Portal$ShareData$noChange;
						}
					}(),
					function () {
						var _v2 = $author$project$Plan$PlanLoader$loadedOf(m.fB);
						if (!_v2.$) {
							var plan = _v2.a.fA;
							var deliverers = _v2.a.e4;
							return A2(
								$elm$core$Basics$composeR,
								$author$project$Portal$ShareData$withTypedDeliverers(deliverers),
								$author$project$Portal$ShareData$withPlan(plan));
						} else {
							return $author$project$Portal$ShareData$noChange;
						}
					}());
			} else {
				return $author$project$Portal$ShareData$noChange;
			}
		}()(
			$author$project$Portal$ShareData$empty(date));
	});
var $author$project$Portal$ShareData$withoutPlan = function (model) {
	return _Utils_update(
		model,
		{fA: $elm$core$Maybe$Nothing});
};
var $author$project$Delay$Delay$init = F3(
	function (share, dpId, date) {
		var token = $author$project$Portal$Share$token(share);
		var shareWithoutPlan = A3(
			$elm$core$Basics$apR,
			$author$project$Portal$ShareData$withoutPlan(
				$author$project$Portal$Share$data(share)),
			$author$project$Portal$Share$withData,
			share);
		return A2(
			$author$project$Portal$Return$ensureDataShared,
			$author$project$Delay$Delay$shareDataFromModel(date),
			A2(
				$author$project$Portal$Init$withModelFromData,
				function (shareData) {
					return A2(
						$author$project$Delay$Delay$Loading,
						{lx: date, c2: dpId},
						{
							ah: $elm$core$Maybe$Nothing,
							bn: shareData.bn,
							W: $elm$core$Maybe$Nothing,
							fB: A4($author$project$Plan$PlanLoader$initModel, shareWithoutPlan, $elm$core$Basics$identity, dpId, date)
						});
				},
				A2(
					$author$project$Portal$Init$withBackgroundCommand,
					A2($elm$core$Task$perform, $author$project$Delay$Delay$SystemRetrievedNow, $elm$time$Time$now),
					A5(
						$author$project$Portal$Init$withPlanLoader,
						$author$project$Delay$Delay$loadingPlan,
						dpId,
						date,
						$author$project$Delay$Delay$SystemGotLoaderMsg,
						A4(
							$author$project$Portal$Init$ifNothing,
							function ($) {
								return $.bn;
							},
							$author$project$Delay$Delay$loadingDP,
							A4($author$project$DistributionPoint$DistributionPoint$loadCmd, token, $author$project$Delay$Delay$SystemGotDistributionPoint, dpId, date),
							A2(
								$author$project$Portal$Init$keyed,
								shareWithoutPlan,
								_Utils_Tuple2(dpId, date)))))));
	});
var $author$project$Deliverer$Create$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Deliverer$Create$Loading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Deliverer$Create$SystemLoadedDistributionPoint = function (a) {
	return {$: 0, a: a};
};
var $author$project$Date$DeliveryDate$encodeForDateInput = function (_v0) {
	var year = _v0.kC;
	var month = _v0.a5;
	var day = _v0.a2;
	return A2(
		$elm$core$String$join,
		'-',
		_List_fromArray(
			[
				$author$project$Date$DeliveryDate$viewYear(year),
				$author$project$Date$DeliveryDate$viewMonth(month),
				$author$project$Date$DeliveryDate$viewDay(day)
			]));
};
var $author$project$Deliverer$Create$formInit = function (date) {
	return {
		d9: '',
		l2: $author$project$Date$DeliveryDate$encodeForDateInput(date),
		ed: '',
		f_: _List_Nil
	};
};
var $author$project$Deliverer$Create$actionIdFor = function (id) {
	return A2($author$project$Portal$Waiting$Id, 'createDeliverer', id);
};
var $author$project$Deliverer$Create$singleAction = F2(
	function (id, _v0) {
		return $author$project$Portal$Waiting$singleAction(
			$author$project$Deliverer$Create$actionIdFor(id));
	});
var $author$project$Deliverer$Create$loadingDP = $author$project$Deliverer$Create$singleAction('loadingDP');
var $author$project$Deliverer$Create$shareDataFromModel = function (model) {
	return function () {
		var _v0 = model.bn;
		if (_v0.$ === 1) {
			var distributionPoint = _v0.a;
			return $author$project$Portal$ShareData$withDistributionPoint(distributionPoint);
		} else {
			return $author$project$Portal$ShareData$noChange;
		}
	}()(
		$author$project$Portal$ShareData$empty(model.lx));
};
var $author$project$Deliverer$Create$init = F3(
	function (share, dpId, date) {
		var token = $author$project$Portal$Share$token(share);
		return A2(
			$author$project$Portal$Return$ensureDataShared,
			$author$project$Deliverer$Create$shareDataFromModel,
			A2(
				$author$project$Portal$Init$withModelFromData,
				function (shareData) {
					return {
						lx: date,
						bn: A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$author$project$Deliverer$Create$Loading(dpId),
							$author$project$Deliverer$Create$Loaded,
							shareData.bn),
						eC: $author$project$Deliverer$Create$formInit(date)
					};
				},
				A4(
					$author$project$Portal$Init$ifNothing,
					function ($) {
						return $.bn;
					},
					$author$project$Deliverer$Create$loadingDP,
					A4($author$project$DistributionPoint$DistributionPoint$loadCmd, token, $author$project$Deliverer$Create$SystemLoadedDistributionPoint, dpId, date),
					$author$project$Portal$Init$empty(share))));
	});
var $author$project$Deliverer$Edit$Loading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Deliverer$Edit$None = {$: 0};
var $author$project$Deliverer$Edit$SystemLoadedCommunicationLog = function (a) {
	return {$: 30, a: a};
};
var $author$project$Deliverer$Edit$SystemLoadedDeliverer = function (a) {
	return {$: 21, a: a};
};
var $author$project$Deliverer$Deliverer$encodeIdForUrl = function (_v0) {
	var id = _v0;
	return $danyx23$elm_uuid$Uuid$toString(id);
};
var $author$project$Deliverer$Deliverer$loadById = F3(
	function (token, toMsg, id) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'deliverers',
					$author$project$Deliverer$Deliverer$encodeIdForUrl(id)
				]),
			_List_Nil);
		return A4($author$project$Api$Request$get, token, toMsg, uri, $author$project$Deliverer$Deliverer$delivererDecoder);
	});
var $author$project$Deliverer$Deliverer$CommunicationLog = F2(
	function (id, items) {
		return {eg: id, gL: items};
	});
var $author$project$Deliverer$Deliverer$FreeMessage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Deliverer$Deliverer$IntentionToStop = function (a) {
	return {$: 0, a: a};
};
var $author$project$Deliverer$Deliverer$Reply = function (a) {
	return {$: 2, a: a};
};
var $author$project$Deliverer$Deliverer$timeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$succeed),
	$elm$json$Json$Decode$int);
var $author$project$Deliverer$Deliverer$communicationDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (cType) {
		switch (cType) {
			case 'IntensionToStop':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'reason',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'stopOn',
						$author$project$Date$DeliveryDate$decoder,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'repliedOn',
							$elm$json$Json$Decode$maybe($author$project$Deliverer$Deliverer$timeDecoder),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'on',
								$author$project$Deliverer$Deliverer$timeDecoder,
								$elm$json$Json$Decode$succeed(
									F4(
										function (on, repliedOn, stopOn, reason) {
											return $author$project$Deliverer$Deliverer$IntentionToStop(
												{a$: on, jL: reason, jO: repliedOn, hs: stopOn});
										}))))));
			case 'FreeMessage':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'message',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'on',
						$author$project$Deliverer$Deliverer$timeDecoder,
						$elm$json$Json$Decode$succeed(
							F2(
								function (on, message) {
									return $author$project$Deliverer$Deliverer$FreeMessage(
										{a$: on, fq: message});
								}))));
			case 'Reply':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'message',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'replyTo',
						$author$project$Deliverer$Deliverer$timeDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'on',
							$author$project$Deliverer$Deliverer$timeDecoder,
							$elm$json$Json$Decode$succeed(
								F3(
									function (on, replyTo, message) {
										return $author$project$Deliverer$Deliverer$Reply(
											{a$: on, fq: message, jP: replyTo});
									})))));
			default:
				return $elm$json$Json$Decode$fail('Invalid Communication');
		}
	},
	A2($elm$json$Json$Decode$field, 'cType', $elm$json$Json$Decode$string));
var $author$project$Deliverer$Deliverer$communicationLogDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'items',
	$elm$json$Json$Decode$list($author$project$Deliverer$Deliverer$communicationDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'delivererId',
		$author$project$Deliverer$Deliverer$idDecoder,
		$elm$json$Json$Decode$succeed($author$project$Deliverer$Deliverer$CommunicationLog)));
var $author$project$Deliverer$Deliverer$loadCommunicationLogById = F3(
	function (token, toMsg, id) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'deliverers',
					$author$project$Deliverer$Deliverer$encodeIdForUrl(id),
					'communications'
				]),
			_List_Nil);
		return A4($author$project$Api$Request$get, token, toMsg, uri, $author$project$Deliverer$Deliverer$communicationLogDecoder);
	});
var $author$project$Deliverer$Edit$actionIdFor = F2(
	function (id, delivererId) {
		return A2(
			$author$project$Portal$Waiting$Id,
			'editDeliverer' + $author$project$Deliverer$Deliverer$comparableId(delivererId),
			id);
	});
var $author$project$Deliverer$Edit$singleAction = F2(
	function (id, delivererId) {
		return $author$project$Portal$Waiting$singleAction(
			A2($author$project$Deliverer$Edit$actionIdFor, id, delivererId));
	});
var $author$project$Deliverer$Edit$loadingCommunicationLog = $author$project$Deliverer$Edit$singleAction('loadingCommunicationLog');
var $author$project$Deliverer$Edit$loadingDeliverer = $author$project$Deliverer$Edit$singleAction('loadingDeliverer');
var $author$project$Portal$ShareData$withoutDeliverers = function (model) {
	return _Utils_update(
		model,
		{e4: $elm$core$Maybe$Nothing});
};
var $author$project$Deliverer$Edit$shareDataFromModel = F2(
	function (shareData, _v0) {
		return $author$project$Portal$ShareData$withoutDeliverers(shareData);
	});
var $author$project$Deliverer$Edit$init = F2(
	function (share, delivererId) {
		var token = $author$project$Portal$Share$token(share);
		return A2(
			$author$project$Portal$Return$ensureDataShared,
			$author$project$Deliverer$Edit$shareDataFromModel(
				$author$project$Portal$Share$data(share)),
			A2(
				$author$project$Portal$Init$withModel,
				{
					bi: $author$project$Deliverer$Edit$Loading(delivererId),
					bl: $author$project$Deliverer$Edit$Loading(delivererId),
					ax: $author$project$Deliverer$Edit$None
				},
				A3(
					$author$project$Portal$Init$withCommand,
					$author$project$Deliverer$Edit$loadingCommunicationLog,
					A3($author$project$Deliverer$Deliverer$loadCommunicationLogById, token, $author$project$Deliverer$Edit$SystemLoadedCommunicationLog, delivererId),
					A3(
						$author$project$Portal$Init$withCommand,
						$author$project$Deliverer$Edit$loadingDeliverer,
						A3($author$project$Deliverer$Deliverer$loadById, token, $author$project$Deliverer$Edit$SystemLoadedDeliverer, delivererId),
						A2($author$project$Portal$Init$keyed, share, delivererId)))));
	});
var $author$project$Distributor$Validate$Selecting = function (a) {
	return {$: 0, a: a};
};
var $author$project$Distributor$Validate$init = function (share) {
	return A2(
		$author$project$Portal$Init$withModel,
		$author$project$Distributor$Validate$Selecting(
			{d3: '', ej: '', f_: _List_Nil}),
		$author$project$Portal$Init$empty(share));
};
var $author$project$Documents$Documents$Loading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Documents$Documents$SystemGotDocuments = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Security$Security$ViewDelivererDocuments = {$: 8};
var $author$project$Security$Security$ViewRegionDistributorDocuments = {$: 9};
var $author$project$Security$Security$ViewRegionManagerDocuments = {$: 10};
var $elm_community$maybe_extra$Maybe$Extra$cons = F2(
	function (item, list) {
		if (!item.$) {
			var v = item.a;
			return A2($elm$core$List$cons, v, list);
		} else {
			return list;
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$values = A2($elm$core$List$foldr, $elm_community$maybe_extra$Maybe$Extra$cons, _List_Nil);
var $author$project$Documents$Documents$foldersFor = function (security) {
	var iff = F2(
		function (permission, f) {
			return A2($author$project$Security$Security$can, permission, security) ? $elm$core$Maybe$Just(f) : $elm$core$Maybe$Nothing;
		});
	return $elm_community$maybe_extra$Maybe$Extra$values(
		_List_fromArray(
			[
				A2(iff, $author$project$Security$Security$ViewDelivererDocuments, 'deliverers'),
				A2(iff, $author$project$Security$Security$ViewRegionDistributorDocuments, 'distributors'),
				A2(iff, $author$project$Security$Security$ViewRegionManagerDocuments, 'region-managers')
			]));
};
var $author$project$Documents$Documents$extensionSeparated = function (path) {
	return function (l) {
		if (l.b && l.b.b) {
			var ext = l.a;
			var rest = l.b;
			return _Utils_Tuple2(
				A2(
					$elm$core$String$join,
					'.',
					$elm$core$List$reverse(rest)),
				$elm$core$Maybe$Just(
					$elm$core$String$toLower(ext)));
		} else {
			return _Utils_Tuple2(path, $elm$core$Maybe$Nothing);
		}
	}(
		$elm$core$List$reverse(
			A2($elm$core$String$split, '.', path)));
};
var $author$project$Documents$Documents$documentDecoder = function () {
	var doc = F2(
		function (name, url) {
			var _v0 = $author$project$Documents$Documents$extensionSeparated(name);
			var withoutExtension = _v0.a;
			var extension = _v0.b;
			return {e9: extension, ft: withoutExtension, aW: url};
		});
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'url',
		$author$project$Api$Uri$urlDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed(doc)));
}();
var $author$project$Documents$Documents$Folder = $elm$core$Basics$identity;
var $author$project$Documents$Documents$folder = F3(
	function (name, folders, documents) {
		return {$9: documents, fe: folders, ft: name};
	});
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(0));
};
function $author$project$Documents$Documents$cyclic$folderDecoder() {
	return A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'documents',
		$elm$json$Json$Decode$list($author$project$Documents$Documents$documentDecoder),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'folders',
			$elm$json$Json$Decode$list(
				$elm$json$Json$Decode$lazy(
					function (_v0) {
						return $author$project$Documents$Documents$cyclic$folderDecoder();
					})),
			_List_Nil,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Documents$Documents$folder))));
}
var $author$project$Documents$Documents$folderDecoder = $author$project$Documents$Documents$cyclic$folderDecoder();
$author$project$Documents$Documents$cyclic$folderDecoder = function () {
	return $author$project$Documents$Documents$folderDecoder;
};
var $author$project$Documents$Documents$loadCmd = F4(
	function (token, toMsg, folderName, index) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['documents', folderName]),
			_List_Nil);
		return A4(
			$author$project$Api$Request$get,
			token,
			toMsg(index),
			uri,
			$author$project$Documents$Documents$folderDecoder);
	});
var $author$project$Documents$Documents$actionIdFor = function (id) {
	return A2($author$project$Portal$Waiting$Id, 'documents', id);
};
var $author$project$Documents$Documents$singleAction = F2(
	function (id, _v0) {
		return $author$project$Portal$Waiting$singleAction(
			$author$project$Documents$Documents$actionIdFor(id));
	});
var $author$project$Documents$Documents$loadingDocuments = F2(
	function (key, index) {
		return A2(
			$author$project$Documents$Documents$singleAction,
			'loadingDocuments-' + $elm$core$String$fromInt(index),
			key);
	});
var $author$project$Portal$Init$withCommands = $author$project$Portal$Init$addTrackedCommands;
var $author$project$Documents$Documents$init = function (share) {
	var token = $author$project$Portal$Share$token(share);
	var folders = $author$project$Documents$Documents$foldersFor(
		$author$project$Portal$Share$security(share));
	return A2(
		$author$project$Portal$Init$withModel,
		$author$project$Documents$Documents$Loading(
			_Utils_Tuple2(
				$elm$core$List$length(folders),
				_List_Nil)),
		A3(
			$author$project$Portal$Init$withCommands,
			$author$project$Documents$Documents$loadingDocuments,
			A2(
				$elm$core$List$map,
				A2($author$project$Documents$Documents$loadCmd, token, $author$project$Documents$Documents$SystemGotDocuments),
				folders),
			$author$project$Portal$Init$empty(share)));
};
var $author$project$Lists$Distribution$DistributionList$DistributionPointLoaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Lists$Distribution$DistributionList$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Lists$Distribution$DistributionList$Loading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Lists$Distribution$DistributionList$OrdersLoaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Lists$Distribution$DistributionList$ProductsLoaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$Lists$Distribution$DistributionList$SystemGotLoaderMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Lists$Distribution$DistributionList$SystemGotSubDPDemandSummary = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Lists$Distribution$DistributionList$actionIdFor = F2(
	function (id, _v0) {
		var dpId = _v0.a;
		var date = _v0.b;
		return A2(
			$author$project$Portal$Waiting$Id,
			'distributionList' + ($author$project$DistributionPoint$DistributionPoint$comparableId(dpId) + $author$project$Date$DeliveryDate$view(date)),
			id);
	});
var $author$project$Lists$Distribution$DistributionList$singleAction = F2(
	function (id, unique) {
		return $author$project$Portal$Waiting$singleAction(
			A2($author$project$Lists$Distribution$DistributionList$actionIdFor, id, unique));
	});
var $author$project$Lists$Distribution$DistributionList$loadingDP = $author$project$Lists$Distribution$DistributionList$singleAction('loadingDP');
var $author$project$Lists$Distribution$DistributionList$loadingOrders = $author$project$Lists$Distribution$DistributionList$singleAction('loadingOrders');
var $author$project$Lists$Distribution$DistributionList$loadingPlan = F2(
	function (key, stage) {
		return A2($author$project$Lists$Distribution$DistributionList$singleAction, 'loadingPlan' + stage, key);
	});
var $author$project$Lists$Distribution$DistributionList$loadingProducts = $author$project$Lists$Distribution$DistributionList$singleAction('loadingProducts');
var $author$project$Lists$Distribution$DistributionList$loadingSummaries = F2(
	function (key, index) {
		return A2(
			$author$project$Lists$Distribution$DistributionList$singleAction,
			'loadingSummaries' + $elm$core$String$fromInt(index),
			key);
	});
var $author$project$Lists$Distribution$DistributionList$shareDataFromModel = function (model) {
	return function () {
		var _v3 = model.bu;
		if (_v3.$ === 1) {
			var products = _v3.a;
			return $author$project$Portal$ShareData$withProducts(products);
		} else {
			return $author$project$Portal$ShareData$noChange;
		}
	}()(
		function () {
			var _v2 = model.Y;
			if (_v2.$ === 1) {
				var orders = _v2.a;
				return $author$project$Portal$ShareData$withOrders(orders);
			} else {
				return $author$project$Portal$ShareData$noChange;
			}
		}()(
			function () {
				var _v1 = $author$project$Plan$PlanLoader$loadedOf(model.fB);
				if (!_v1.$) {
					var plan = _v1.a.fA;
					var deliverers = _v1.a.e4;
					return A2(
						$elm$core$Basics$composeR,
						$author$project$Portal$ShareData$withTypedDeliverers(deliverers),
						$author$project$Portal$ShareData$withPlan(plan));
				} else {
					return $author$project$Portal$ShareData$noChange;
				}
			}()(
				function () {
					var _v0 = model.bn;
					if (_v0.$ === 1) {
						var distributionPoint = _v0.a;
						return $author$project$Portal$ShareData$withDistributionPoint(distributionPoint);
					} else {
						return $author$project$Portal$ShareData$noChange;
					}
				}()(
					$author$project$Portal$ShareData$empty(model.lx)))));
};
var $author$project$Lists$Distribution$DistributionList$init = F3(
	function (share, dpId, date) {
		var token = $author$project$Portal$Share$token(share);
		return A2(
			$author$project$Portal$Return$ensureDataShared,
			$author$project$Lists$Distribution$DistributionList$shareDataFromModel,
			A2(
				$author$project$Portal$Init$withModelFromData,
				function (shareData) {
					return {
						lx: date,
						bm: $author$project$DistributionPoint$IdDict$empty,
						bn: A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$author$project$Lists$Distribution$DistributionList$Loading(dpId),
							$author$project$Lists$Distribution$DistributionList$Loaded,
							shareData.bn),
						Y: A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$author$project$Lists$Distribution$DistributionList$Loading(dpId),
							$author$project$Lists$Distribution$DistributionList$Loaded,
							shareData.Y),
						fB: A4($author$project$Plan$PlanLoader$initModel, share, $elm$core$Basics$identity, dpId, date),
						bu: A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$author$project$Lists$Distribution$DistributionList$Loading(dpId),
							$author$project$Lists$Distribution$DistributionList$Loaded,
							shareData.bu)
					};
				},
				A4(
					$author$project$Portal$Init$ifNothing,
					function ($) {
						return $.bu;
					},
					$author$project$Lists$Distribution$DistributionList$loadingProducts,
					A4($author$project$Demand$Demand$loadProductsCmd, token, $author$project$Lists$Distribution$DistributionList$ProductsLoaded, dpId, date),
					A4(
						$author$project$Portal$Init$ifNothing,
						function ($) {
							return $.Y;
						},
						$author$project$Lists$Distribution$DistributionList$loadingOrders,
						A4($author$project$Demand$Demand$loadOrdersCmd, token, $author$project$Lists$Distribution$DistributionList$OrdersLoaded, dpId, date),
						A5(
							$author$project$Portal$Init$withPlanLoader,
							$author$project$Lists$Distribution$DistributionList$loadingPlan,
							dpId,
							date,
							$author$project$Lists$Distribution$DistributionList$SystemGotLoaderMsg,
							A4(
								$author$project$Portal$Init$multiIfJust,
								function ($) {
									return $.bn;
								},
								$author$project$Lists$Distribution$DistributionList$loadingSummaries,
								A2(
									$elm$core$Basics$composeR,
									$author$project$DistributionPoint$DistributionPoint$getSubDistributionPoints,
									$elm$core$List$map(
										F2(
											function (dp, i) {
												return A4(
													$author$project$Demand$Summary$loadForDPCmd,
													token,
													$author$project$Lists$Distribution$DistributionList$SystemGotSubDPDemandSummary(i),
													$author$project$DistributionPoint$DistributionPoint$idOf(dp),
													date);
											}))),
								A4(
									$author$project$Portal$Init$ifNothing,
									function ($) {
										return $.bn;
									},
									$author$project$Lists$Distribution$DistributionList$loadingDP,
									A4($author$project$DistributionPoint$DistributionPoint$loadCmd, token, $author$project$Lists$Distribution$DistributionList$DistributionPointLoaded, dpId, date),
									A2(
										$author$project$Portal$Init$keyed,
										share,
										_Utils_Tuple2(dpId, date)))))))));
	});
var $author$project$Lists$Distribution$PreSupplyList$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Lists$Distribution$PreSupplyList$Loading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Lists$Distribution$PreSupplyList$SystemGotLoaderMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Lists$Distribution$PreSupplyList$SystemGotSubDPDemandSummary = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Lists$Distribution$PreSupplyList$SystemRespondedDistributionPoint = function (a) {
	return {$: 0, a: a};
};
var $author$project$Lists$Distribution$PreSupplyList$SystemRespondedOrders = function (a) {
	return {$: 2, a: a};
};
var $author$project$Lists$Distribution$PreSupplyList$SystemRespondedProducts = function (a) {
	return {$: 4, a: a};
};
var $author$project$Lists$Distribution$PreSupplyList$actionIdFor = F2(
	function (id, _v0) {
		var dpId = _v0.a;
		var date = _v0.b;
		return A2(
			$author$project$Portal$Waiting$Id,
			'preSupplyList' + ($author$project$DistributionPoint$DistributionPoint$comparableId(dpId) + $author$project$Date$DeliveryDate$view(date)),
			id);
	});
var $author$project$Lists$Distribution$PreSupplyList$singleAction = F2(
	function (id, unique) {
		return $author$project$Portal$Waiting$singleAction(
			A2($author$project$Lists$Distribution$PreSupplyList$actionIdFor, id, unique));
	});
var $author$project$Lists$Distribution$PreSupplyList$loadingDP = $author$project$Lists$Distribution$PreSupplyList$singleAction('loadingDP');
var $author$project$Lists$Distribution$PreSupplyList$loadingOrders = $author$project$Lists$Distribution$PreSupplyList$singleAction('loadingOrders');
var $author$project$Lists$Distribution$PreSupplyList$loadingPlan = F2(
	function (key, stage) {
		return A2($author$project$Lists$Distribution$PreSupplyList$singleAction, 'loadingPlan' + stage, key);
	});
var $author$project$Lists$Distribution$PreSupplyList$loadingProducts = $author$project$Lists$Distribution$PreSupplyList$singleAction('loadingProducts');
var $author$project$Lists$Distribution$PreSupplyList$loadingSummaries = F2(
	function (key, index) {
		return A2(
			$author$project$Lists$Distribution$PreSupplyList$singleAction,
			'loadingSummaries' + $elm$core$String$fromInt(index),
			key);
	});
var $author$project$Lists$Distribution$PreSupplyList$shareDataFromModel = function (model) {
	return function () {
		var _v3 = model.bu;
		if (_v3.$ === 1) {
			var products = _v3.a;
			return $author$project$Portal$ShareData$withProducts(products);
		} else {
			return $author$project$Portal$ShareData$noChange;
		}
	}()(
		function () {
			var _v2 = model.Y;
			if (_v2.$ === 1) {
				var orders = _v2.a;
				return $author$project$Portal$ShareData$withOrders(orders);
			} else {
				return $author$project$Portal$ShareData$noChange;
			}
		}()(
			function () {
				var _v1 = $author$project$Plan$PlanLoader$loadedOf(model.fB);
				if (!_v1.$) {
					var plan = _v1.a.fA;
					var deliverers = _v1.a.e4;
					return A2(
						$elm$core$Basics$composeR,
						$author$project$Portal$ShareData$withTypedDeliverers(deliverers),
						$author$project$Portal$ShareData$withPlan(plan));
				} else {
					return $author$project$Portal$ShareData$noChange;
				}
			}()(
				function () {
					var _v0 = model.bn;
					if (_v0.$ === 1) {
						var distributionPoint = _v0.a;
						return $author$project$Portal$ShareData$withDistributionPoint(distributionPoint);
					} else {
						return $author$project$Portal$ShareData$noChange;
					}
				}()(
					$author$project$Portal$ShareData$empty(model.lx)))));
};
var $author$project$Lists$Distribution$PreSupplyList$init = F3(
	function (share, dpId, date) {
		var token = $author$project$Portal$Share$token(share);
		return A2(
			$author$project$Portal$Return$ensureDataShared,
			$author$project$Lists$Distribution$PreSupplyList$shareDataFromModel,
			A2(
				$author$project$Portal$Init$withModelFromData,
				function (shareData) {
					return {
						lx: date,
						bm: $author$project$DistributionPoint$IdDict$empty,
						bn: A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$author$project$Lists$Distribution$PreSupplyList$Loading(dpId),
							$author$project$Lists$Distribution$PreSupplyList$Loaded,
							shareData.bn),
						Y: A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$author$project$Lists$Distribution$PreSupplyList$Loading(dpId),
							$author$project$Lists$Distribution$PreSupplyList$Loaded,
							shareData.Y),
						fB: A4($author$project$Plan$PlanLoader$initModel, share, $elm$core$Basics$identity, dpId, date),
						bu: A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$author$project$Lists$Distribution$PreSupplyList$Loading(dpId),
							$author$project$Lists$Distribution$PreSupplyList$Loaded,
							shareData.bu)
					};
				},
				A4(
					$author$project$Portal$Init$ifNothing,
					function ($) {
						return $.bu;
					},
					$author$project$Lists$Distribution$PreSupplyList$loadingProducts,
					A4($author$project$Demand$Demand$loadProductsCmd, token, $author$project$Lists$Distribution$PreSupplyList$SystemRespondedProducts, dpId, date),
					A4(
						$author$project$Portal$Init$ifNothing,
						function ($) {
							return $.Y;
						},
						$author$project$Lists$Distribution$PreSupplyList$loadingOrders,
						A4($author$project$Demand$Demand$loadOrdersCmd, token, $author$project$Lists$Distribution$PreSupplyList$SystemRespondedOrders, dpId, date),
						A5(
							$author$project$Portal$Init$withPlanLoader,
							$author$project$Lists$Distribution$PreSupplyList$loadingPlan,
							dpId,
							date,
							$author$project$Lists$Distribution$PreSupplyList$SystemGotLoaderMsg,
							A4(
								$author$project$Portal$Init$multiIfJust,
								function ($) {
									return $.bn;
								},
								$author$project$Lists$Distribution$PreSupplyList$loadingSummaries,
								A2(
									$elm$core$Basics$composeR,
									$author$project$DistributionPoint$DistributionPoint$getSubDistributionPoints,
									$elm$core$List$map(
										F2(
											function (dp, i) {
												return A4(
													$author$project$Demand$Summary$loadForDPCmd,
													token,
													$author$project$Lists$Distribution$PreSupplyList$SystemGotSubDPDemandSummary(i),
													$author$project$DistributionPoint$DistributionPoint$idOf(dp),
													date);
											}))),
								A4(
									$author$project$Portal$Init$ifNothing,
									function ($) {
										return $.bn;
									},
									$author$project$Lists$Distribution$PreSupplyList$loadingDP,
									A4($author$project$DistributionPoint$DistributionPoint$loadCmd, token, $author$project$Lists$Distribution$PreSupplyList$SystemRespondedDistributionPoint, dpId, date),
									A2(
										$author$project$Portal$Init$keyed,
										share,
										_Utils_Tuple2(dpId, date)))))))));
	});
var $author$project$Lists$Received$CheckList$BackendRespondedAggregatedOrders = function (a) {
	return {$: 1, a: a};
};
var $author$project$Lists$Received$CheckList$BackendRespondedDistributionPoint = function (a) {
	return {$: 0, a: a};
};
var $author$project$Lists$Received$CheckList$BackendRespondedSubDPAggregatedOrders = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Lists$Received$CheckList$Loading = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Lists$Received$CheckList$Parameters = F2(
	function (planId, distributionPointId) {
		return {c2: distributionPointId, a8: planId};
	});
var $author$project$Demand$Demand$demandTypeDecoderWithExtraTypes = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'sub':
				return $elm$json$Json$Decode$succeed(0);
			case 'subscription':
				return $elm$json$Json$Decode$succeed(0);
			case 'sale':
				return $elm$json$Json$Decode$succeed(1);
			case 'extra':
				return $elm$json$Json$Decode$succeed(2);
			case 'own':
				return $elm$json$Json$Decode$succeed(3);
			case 'dp':
				return $elm$json$Json$Decode$succeed(4);
			case 'segment':
				return $elm$json$Json$Decode$succeed(5);
			default:
				return $elm$json$Json$Decode$fail('Invalid DemandType: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Demand$TypeDict$decoderWithExtraDemandTypes = function (valueDecoder) {
	return A2(
		$elm$json$Json$Decode$andThen,
		$author$project$Demand$TypeDict$decodeDictFromTuples($author$project$Demand$Demand$demandTypeDecoderWithExtraTypes),
		$elm$json$Json$Decode$keyValuePairs(valueDecoder));
};
var $author$project$Lists$Received$CheckList$amountPerDemandTypeDecoder = $author$project$Demand$TypeDict$decoderWithExtraDemandTypes($elm$json$Json$Decode$int);
var $author$project$Lists$Received$CheckList$amountsByProductDecoder = $elm$json$Json$Decode$dict($author$project$Lists$Received$CheckList$amountPerDemandTypeDecoder);
var $author$project$Demand$Demand$addOtherExtraDemandTypes = function (list) {
	return A2($elm$core$List$member, 2, list) ? _Utils_ap(list, $author$project$Demand$Demand$extraDemandTypes) : list;
};
var $author$project$Demand$Demand$productsWithExtraDemandTypes = function (products) {
	return A2(
		$elm$core$List$map,
		function (p) {
			return _Utils_update(
				p,
				{
					iT: A2(
						$elm$core$List$map,
						function (i) {
							return _Utils_update(
								i,
								{
									$8: $author$project$Demand$Demand$addOtherExtraDemandTypes(i.$8)
								});
						},
						p.iT)
				});
		},
		products);
};
var $author$project$Lists$Received$CheckList$distributionPointDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'products',
	A2(
		$elm$json$Json$Decode$map,
		$author$project$Demand$Demand$productsWithExtraDemandTypes,
		$elm$json$Json$Decode$list($author$project$Demand$Demand$productDecoder)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'aggregatedOrders',
		$author$project$Lists$Received$CheckList$amountsByProductDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$author$project$DistributionPoint$DistributionPoint$idDecoder,
			$elm$json$Json$Decode$succeed($author$project$Demand$Summary$DistributionPoint))));
var $author$project$Lists$Received$CheckList$loadForDPCmd = F5(
	function (token, toMsg, dpId, date, tracker) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'distributionpoints',
					$author$project$DistributionPoint$DistributionPoint$encodeIdForUrl(dpId),
					'orders',
					$author$project$Date$DeliveryDate$encodeForUrl(date),
					'aggregated'
				]),
			_List_Nil);
		return A5($author$project$Api$Request$get, token, toMsg, uri, $author$project$Lists$Received$CheckList$distributionPointDecoder, tracker);
	});
var $author$project$Lists$Received$CheckList$actionIdFor = F2(
	function (id, planId) {
		return A2(
			$author$project$Portal$Waiting$Id,
			'receivedCheckList' + $author$project$Plan$Plan$comparableId(planId),
			id);
	});
var $author$project$Lists$Received$CheckList$singleAction = function (id) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Lists$Received$CheckList$actionIdFor(id),
		$author$project$Portal$Waiting$singleAction);
};
var $author$project$Lists$Received$CheckList$loadingDP = $author$project$Lists$Received$CheckList$singleAction('loadingDP');
var $author$project$Lists$Received$CheckList$loadingSubDPSummaries = F2(
	function (key, index) {
		return A2(
			$author$project$Lists$Received$CheckList$singleAction,
			'loadingSubDPSummaries' + $elm$core$String$fromInt(index),
			key);
	});
var $author$project$Lists$Received$CheckList$loadingSummary = $author$project$Lists$Received$CheckList$singleAction('loadingSummary');
var $author$project$Lists$Received$CheckList$Loaded = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Demand$TypeDict$toList = $timo_weike$generic_collections$ManualDict$toList;
var $author$project$Lists$Summary$fromDemandSummaries = function (demandSummaries) {
	return A2(
		$elm$core$List$concatMap,
		function (_v0) {
			var amountsByProduct = _v0.kO;
			var products = _v0.bu;
			return A2(
				$elm$core$List$filterMap,
				function (_v1) {
					var pId = _v1.a;
					var amountPerDemandTypes = _v1.b;
					return A2(
						$elm$core$Maybe$map,
						function (p) {
							return {
								hR: A2(
									$elm$core$List$map,
									function (_v2) {
										var demandType = _v2.a;
										var amount = _v2.b;
										return {aa: amount, lB: demandType};
									},
									$author$project$Demand$TypeDict$toList(amountPerDemandTypes)),
								jJ: p
							};
						},
						A2(
							$elm_community$list_extra$List$Extra$find,
							function (p) {
								return _Utils_eq(p.eg, pId);
							},
							products));
				},
				$elm$core$Dict$toList(amountsByProduct));
		},
		demandSummaries);
};
var $timo_weike$generic_collections$ManualDict$get = F3(
	function (f, key, _v0) {
		var dict = _v0;
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			A2(
				$elm$core$Dict$get,
				f(key),
				dict));
	});
var $author$project$DistributionPoint$IdDict$toComparable = $author$project$DistributionPoint$DistributionPoint$comparableId;
var $author$project$DistributionPoint$IdDict$get = $timo_weike$generic_collections$ManualDict$get($author$project$DistributionPoint$IdDict$toComparable);
var $author$project$Lists$Received$CheckList$isLoaded = F2(
	function (distributionPoint, dpDemandSummaries) {
		if (!distributionPoint.$) {
			var dp = distributionPoint.a;
			var _v1 = _Utils_Tuple2(
				_Utils_eq(
					1 + $elm$core$List$length(
						$author$project$DistributionPoint$DistributionPoint$getSubDistributionPoints(dp)),
					$author$project$DistributionPoint$IdDict$size(dpDemandSummaries)),
				A2(
					$author$project$DistributionPoint$IdDict$get,
					$author$project$DistributionPoint$DistributionPoint$idOf(dp),
					dpDemandSummaries));
			if (_v1.a && (!_v1.b.$)) {
				var dpDemandSummary = _v1.b.a;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(dp, dpDemandSummary));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Lists$Received$CheckList$allUniqueProductsOf = function (summaries) {
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$first,
		A2(
			$elm_community$list_extra$List$Extra$gatherEqualsBy,
			function ($) {
				return $.eg;
			},
			A2(
				$elm$core$List$map,
				function ($) {
					return $.jJ;
				},
				summaries)));
};
var $author$project$Demand$TypeDict$empty = $timo_weike$generic_collections$ManualDict$empty;
var $author$project$Lists$Received$CheckList$extraInsertOrdersForDP = F3(
	function (insertId, product, extraOrdersForDP) {
		var _v0 = A2(
			$elm$core$Dict$get,
			insertId,
			$elm$core$Dict$fromList(
				A2(
					$elm$core$List$map,
					function (insert) {
						return _Utils_Tuple2(insert.eg, insert);
					},
					product.iT)));
		if (!_v0.$) {
			var insert = _v0.a;
			return A2($elm$core$List$member, 4, insert.$8) ? extraOrdersForDP : 0;
		} else {
			return 0;
		}
	});
var $author$project$Demand$TypeDict$get = $timo_weike$generic_collections$ManualDict$get($author$project$Demand$TypeDict$toComparable);
var $author$project$Lists$Received$CheckList$insertToBundle = F2(
	function (amounts, insert) {
		var filteredAmounts = A2(
			$elm$core$List$filter,
			function (_v0) {
				var demandType = _v0.lB;
				var amount = _v0.aa;
				return A2($elm$core$List$member, demandType, insert.$8);
			},
			amounts);
		return _Utils_Tuple2(
			insert,
			A2(
				$author$project$Demand$Bundle$make,
				insert,
				$elm$core$List$sum(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.aa;
						},
						filteredAmounts))));
	});
var $author$project$Lists$Received$CheckList$updateInsertToBundle = F2(
	function (_v0, dict) {
		var insert = _v0.a;
		var bundle1 = _v0.b;
		return A3(
			$elm$core$Dict$update,
			insert.eg,
			function (t) {
				if (t.$ === 1) {
					return $elm$core$Maybe$Just(
						$author$project$Demand$Bundle$repack(bundle1));
				} else {
					var bundle2 = t.a;
					return $elm$core$Maybe$Just(
						$author$project$Demand$Bundle$repack(
							A2($author$project$Demand$Bundle$combine, bundle1, bundle2).a));
				}
			},
			dict);
	});
var $author$project$Lists$Received$CheckList$toCheckList = F2(
	function (dpAmountsByProduct, summaries) {
		return A2(
			$elm$core$List$concatMap,
			function (amountsByProduct) {
				return A2(
					$elm$core$List$cons,
					{
						G: amountsByProduct.G,
						c7: amountsByProduct.c7,
						ft: amountsByProduct.jJ.eg,
						dH: $author$project$Demand$Bundle$total(amountsByProduct.G)
					},
					A2(
						$elm$core$List$map,
						function (_v1) {
							var id = _v1.a;
							var _v2 = _v1.b;
							var bundle = _v2.a;
							var extra = _v2.b;
							return {
								G: bundle,
								c7: extra,
								ft: id,
								dH: $author$project$Demand$Bundle$total(bundle)
							};
						},
						A2(
							$elm$core$List$sortBy,
							$elm$core$Tuple$first,
							$elm$core$Dict$toList(amountsByProduct.iT))));
			},
			A2(
				$elm$core$List$sortBy,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.jJ;
					},
					function ($) {
						return $.eg;
					}),
				A2(
					$elm$core$List$map,
					function (p) {
						var productSummaries = A2(
							$elm$core$List$filter,
							function (s) {
								return _Utils_eq(s.jJ.eg, p.eg);
							},
							summaries);
						var extraForDP = A2(
							$elm$core$Maybe$withDefault,
							0,
							A2(
								$author$project$Demand$TypeDict$get,
								4,
								A2(
									$elm$core$Maybe$withDefault,
									$author$project$Demand$TypeDict$empty,
									A2($elm$core$Dict$get, p.eg, dpAmountsByProduct))));
						return {
							G: A2(
								$author$project$Demand$Bundle$make,
								p,
								$elm$core$List$sum(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.aa;
										},
										A2(
											$elm$core$List$concatMap,
											function ($) {
												return $.hR;
											},
											productSummaries)))),
							c7: extraForDP,
							iT: A2(
								$elm$core$Dict$map,
								F2(
									function (insertId, bundle) {
										return _Utils_Tuple2(
											bundle,
											A3($author$project$Lists$Received$CheckList$extraInsertOrdersForDP, insertId, p, extraForDP));
									}),
								A3(
									$elm$core$List$foldl,
									$author$project$Lists$Received$CheckList$updateInsertToBundle,
									$elm$core$Dict$empty,
									A2(
										$elm$core$List$concatMap,
										function (_v0) {
											var product = _v0.jJ;
											var amounts = _v0.hR;
											return A2(
												$elm$core$List$map,
												$author$project$Lists$Received$CheckList$insertToBundle(amounts),
												product.iT);
										},
										productSummaries))),
							jJ: p
						};
					},
					$author$project$Lists$Received$CheckList$allUniqueProductsOf(summaries))));
	});
var $author$project$DistributionPoint$IdDict$values = $timo_weike$generic_collections$ManualDict$values;
var $author$project$Lists$Received$CheckList$next = function (model) {
	if (!model.$) {
		var p = model.a;
		var distributionPoint = model.b.bn;
		var dpDemandSummaries = model.b.c3;
		var _v1 = A2($author$project$Lists$Received$CheckList$isLoaded, distributionPoint, dpDemandSummaries);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var dp = _v2.a;
			var dpDemandSummary = _v2.b;
			return function (s) {
				return A2(
					$author$project$Lists$Received$CheckList$Loaded,
					p,
					{h0: s, bn: dp});
			}(
				A2(
					$author$project$Lists$Received$CheckList$toCheckList,
					dpDemandSummary.kO,
					$author$project$Lists$Summary$fromDemandSummaries(
						$author$project$DistributionPoint$IdDict$values(dpDemandSummaries))));
		} else {
			return model;
		}
	} else {
		return model;
	}
};
var $author$project$Lists$Received$CheckList$init = F3(
	function (share, dpId, date) {
		var token = $author$project$Portal$Share$token(share);
		var planId = A2($author$project$Plan$Plan$Id, dpId, date);
		return A2(
			$author$project$Portal$Init$withModelFromData,
			function (dataShare) {
				return $author$project$Lists$Received$CheckList$next(
					A2(
						$author$project$Lists$Received$CheckList$Loading,
						A2($author$project$Lists$Received$CheckList$Parameters, planId, dpId),
						{bn: dataShare.bn, c3: $author$project$DistributionPoint$IdDict$empty}));
			},
			A4(
				$author$project$Portal$Init$multiIfJust,
				function ($) {
					return $.bn;
				},
				$author$project$Lists$Received$CheckList$loadingSubDPSummaries,
				A2(
					$elm$core$Basics$composeR,
					$author$project$DistributionPoint$DistributionPoint$getSubDistributionPoints,
					$elm$core$List$map(
						F2(
							function (subDP, i) {
								return A4(
									$author$project$Lists$Received$CheckList$loadForDPCmd,
									token,
									$author$project$Lists$Received$CheckList$BackendRespondedSubDPAggregatedOrders(i),
									$author$project$DistributionPoint$DistributionPoint$idOf(subDP),
									date);
							}))),
				A3(
					$author$project$Portal$Init$withCommand,
					$author$project$Lists$Received$CheckList$loadingSummary,
					A4($author$project$Lists$Received$CheckList$loadForDPCmd, token, $author$project$Lists$Received$CheckList$BackendRespondedAggregatedOrders, dpId, date),
					A4(
						$author$project$Portal$Init$ifNothing,
						function ($) {
							return $.bn;
						},
						$author$project$Lists$Received$CheckList$loadingDP,
						A4($author$project$DistributionPoint$DistributionPoint$loadCmd, token, $author$project$Lists$Received$CheckList$BackendRespondedDistributionPoint, dpId, date),
						A2($author$project$Portal$Init$keyed, share, planId)))));
	});
var $author$project$Lists$RouteDetail$Deliverer$Loading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Lists$RouteDetail$Deliverer$Print = {$: 1};
var $author$project$Lists$RouteDetail$Deliverer$SystemGotRouteDetail = function (a) {
	return {$: 0, a: a};
};
var $author$project$Portal$Share$device = function (_v0) {
	var model = _v0;
	return $mdgriffith$elm_ui$Element$classifyDevice(model.dI.oz);
};
var $author$project$Deliverer$Deliverer$Registered = function (a) {
	return {$: 0, a: a};
};
var $author$project$Lists$RouteDetail$Deliverer$RouteDetail = F8(
	function (distributionPoint, items, complaints, products, orders, subOrders, deliverers, sequences) {
		return {m: complaints, e4: deliverers, bn: distributionPoint, gL: items, Y: orders, bu: products, hm: sequences, hx: subOrders};
	});
var $author$project$Demand$Demand$Complaint = function (madeOn) {
	return function (segmentId) {
		return function (complaintType) {
			return function (severity) {
				return function (demandType) {
					return function (productId) {
						return function (name) {
							return function (street) {
								return function (houseNumber) {
									return function (municipal) {
										return function (validDays) {
											return {lo: complaintType, lB: demandType, bs: houseNumber, i8: madeOn, bU: municipal, ft: name, av: productId, jZ: segmentId, nL: severity, b5: street, hD: validDays};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Demand$Demand$Incidental = 0;
var $author$project$Demand$Demand$Repetition = 1;
var $author$project$Demand$Demand$Severe = 2;
var $author$project$Demand$Demand$severityDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'incidental':
				return $elm$json$Json$Decode$succeed(0);
			case 'repetition':
				return $elm$json$Json$Decode$succeed(1);
			case 'severe':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Invalid Severity');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Demand$Demand$complaintDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'validDays',
	$author$project$Date$DaysInTheWeek$emptyIsEveryDeliveryDayDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'municipal',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'houseNumber',
			$author$project$Address$Address$houseNumberDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'street',
				$elm$json$Json$Decode$string,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'name',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'productId',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'demandType',
							$author$project$Demand$Demand$demandTypeDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'severity',
								$author$project$Demand$Demand$severityDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'complaintType',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'segmentId',
										$author$project$DistributionPoint$DistributionPoint$segmentIdDecoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'madeOn',
											$author$project$Date$DeliveryDate$decoder,
											$elm$json$Json$Decode$succeed($author$project$Demand$Demand$Complaint))))))))))));
var $author$project$Cluster$Cluster$Cluster = F2(
	function (number, segments) {
		return {bX: number, bb: segments};
	});
var $author$project$Deliverer$Deliverer$Expired = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Plan$Supply$NotPreSupplied = {$: 0};
var $author$project$Plan$Supply$PreSuppliedBy = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$Supply$Bike = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$Supply$bikeItem = F4(
	function (id, deliverer, clusters, preSupply) {
		return $author$project$Plan$Supply$Bike(
			{k: clusters, bl: deliverer, eg: id, ni: preSupply});
	});
var $author$project$Cluster$Number$decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $elm$core$Basics$identity),
	$elm$json$Json$Decode$int);
var $author$project$Cluster$Cluster$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'segments',
	$elm$json$Json$Decode$list($author$project$DistributionPoint$DistributionPoint$segmentIdDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'number',
		$author$project$Cluster$Number$decoder,
		$elm$json$Json$Decode$succeed($author$project$Cluster$Cluster$Cluster)));
var $author$project$Plan$Supply$firstId = 0;
var $author$project$Deliverer$IdDict$toComparable = $author$project$Deliverer$Deliverer$comparableId;
var $author$project$Deliverer$IdDict$get = $timo_weike$generic_collections$ManualDict$get($author$project$Deliverer$IdDict$toComparable);
var $author$project$Plan$Supply$bikeDecoder = function (deliverers) {
	return A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'preSupplyId',
		A2(
			$elm$json$Json$Decode$andThen,
			A2($elm$core$Basics$composeR, $author$project$Plan$Supply$PreSuppliedBy, $elm$json$Json$Decode$succeed),
			$author$project$DistributionPoint$DistributionPoint$preSupplyIdDecoder),
		$author$project$Plan$Supply$NotPreSupplied,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'clusters',
			$elm$json$Json$Decode$list($author$project$Cluster$Cluster$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'deliverer',
				$author$project$Deliverer$Deliverer$idDecoder,
				$elm$json$Json$Decode$succeed(
					F3(
						function (delivererId, clusters, preSupply) {
							var deliverer = function () {
								var _v0 = A2($author$project$Deliverer$IdDict$get, delivererId, deliverers);
								if (!_v0.$) {
									var d = _v0.a;
									return d;
								} else {
									return A2($author$project$Deliverer$Deliverer$Expired, delivererId, $elm$core$Maybe$Nothing);
								}
							}();
							return A4($author$project$Plan$Supply$bikeItem, $author$project$Plan$Supply$firstId, deliverer, clusters, preSupply);
						})))));
};
var $author$project$Plan$Supply$Car = function (a) {
	return {$: 0, a: a};
};
var $author$project$Plan$Supply$carItem = F5(
	function (id, deliverer, cluster, supplies, preSupply) {
		return $author$project$Plan$Supply$Car(
			{H: cluster, bl: deliverer, eg: id, ni: preSupply, n0: supplies});
	});
var $elm$core$List$sort = function (xs) {
	return A2($elm$core$List$sortBy, $elm$core$Basics$identity, xs);
};
var $author$project$Cluster$Number$generate = function (clusters) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (i, soFar) {
				return _Utils_eq(i, soFar) ? (soFar + 1) : soFar;
			}),
		0,
		A2(
			$elm$core$List$cons,
			0,
			$elm$core$List$sort(
				A2(
					$elm$core$List$map,
					function (_v0) {
						var cId = _v0;
						return cId;
					},
					A2(
						$elm$core$List$map,
						function ($) {
							return $.bX;
						},
						clusters)))));
};
var $author$project$Plan$Supply$SubDistributionPoint = function (a) {
	return {$: 2, a: a};
};
var $author$project$Plan$Supply$subDistributionPointItem = F3(
	function (id, dpId, preSupply) {
		return $author$project$Plan$Supply$SubDistributionPoint(
			{lK: dpId, eg: id, ni: preSupply});
	});
var $author$project$Plan$Supply$subDistributionPointDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'preSupplyId',
	A2(
		$elm$json$Json$Decode$andThen,
		A2($elm$core$Basics$composeR, $author$project$Plan$Supply$PreSuppliedBy, $elm$json$Json$Decode$succeed),
		$author$project$DistributionPoint$DistributionPoint$preSupplyIdDecoder),
	$author$project$Plan$Supply$NotPreSupplied,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'distributionPoint',
		$author$project$DistributionPoint$DistributionPoint$idDecoder,
		$elm$json$Json$Decode$succeed(
			$author$project$Plan$Supply$subDistributionPointItem($author$project$Plan$Supply$firstId))));
var $author$project$Plan$Supply$carDecoder = function (deliverers) {
	return A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'preSupplyId',
		A2(
			$elm$json$Json$Decode$andThen,
			A2($elm$core$Basics$composeR, $author$project$Plan$Supply$PreSuppliedBy, $elm$json$Json$Decode$succeed),
			$author$project$DistributionPoint$DistributionPoint$preSupplyIdDecoder),
		$author$project$Plan$Supply$NotPreSupplied,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'supplies',
			$elm$json$Json$Decode$list(
				$author$project$Plan$Supply$decoder(deliverers)),
			_List_Nil,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'clusters',
				$elm$json$Json$Decode$list($author$project$Cluster$Cluster$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'deliverer',
					$author$project$Deliverer$Deliverer$idDecoder,
					$elm$json$Json$Decode$succeed(
						F4(
							function (delivererId, clusters, supplies, preSupply) {
								var deliverer = function () {
									var _v1 = A2($author$project$Deliverer$IdDict$get, delivererId, deliverers);
									if (!_v1.$) {
										var d = _v1.a;
										return d;
									} else {
										return A2($author$project$Deliverer$Deliverer$Expired, delivererId, $elm$core$Maybe$Nothing);
									}
								}();
								var cluster = A2(
									$elm$core$Maybe$withDefault,
									A2(
										$author$project$Cluster$Cluster$Cluster,
										$author$project$Cluster$Number$generate(_List_Nil),
										_List_Nil),
									$elm$core$List$head(clusters));
								return A5($author$project$Plan$Supply$carItem, $author$project$Plan$Supply$firstId, deliverer, cluster, supplies, preSupply);
							}))))));
};
var $author$project$Plan$Supply$decoder = function (deliverers) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (itemType) {
			switch (itemType) {
				case 'ride':
					return $author$project$Plan$Supply$carDecoder(deliverers);
				case 'bike':
					return $author$project$Plan$Supply$bikeDecoder(deliverers);
				case 'distributionPoint':
					return $author$project$Plan$Supply$subDistributionPointDecoder;
				default:
					return $elm$json$Json$Decode$fail('Trying to decode type, but \'' + (itemType + '\' is not supported.'));
			}
		},
		A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
};
var $author$project$Deliverer$IdDict$fromList = $timo_weike$generic_collections$ManualDict$fromList($author$project$Deliverer$IdDict$toComparable);
var $author$project$Sequence$Sequence$Sequence = F3(
	function (delivererId, segmentIds, items) {
		return {lA: delivererId, gL: items, nH: segmentIds};
	});
var $author$project$Sequence$Sequence$Item = F4(
	function (direction, joinability, cutPoint, streetParts) {
		return {e0: cutPoint, cg: direction, mC: joinability, aR: streetParts};
	});
var $author$project$Sequence$Sequence$Unknown = 2;
var $author$project$Sequence$StreetPart$Ascending = 0;
var $author$project$Sequence$StreetPart$Descending = 1;
var $author$project$Sequence$StreetPart$directionDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'Ascending':
				return $elm$json$Json$Decode$succeed(0);
			case 'Descending':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Invalid StreetPartDirection');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Sequence$StreetPart$StreetPart = F5(
	function (countryCode, zipCode, municipal, street, postalAddresses) {
		return {h8: countryCode, bU: municipal, fD: postalAddresses, b5: street, cT: zipCode};
	});
var $author$project$Address$Address$PostalAddress = F2(
	function (number, coordinates) {
		return {h7: coordinates, bX: number};
	});
var $author$project$Address$Address$Coordinates = F2(
	function (latitude, longitude) {
		return {gO: latitude, gR: longitude};
	});
var $author$project$Address$Address$coordinatesDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'longitude',
			$elm$json$Json$Decode$float,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'latitude',
				$elm$json$Json$Decode$float,
				$elm$json$Json$Decode$succeed($author$project$Address$Address$Coordinates))),
			A2(
			$elm$json$Json$Decode$andThen,
			function (l) {
				if ((l.b && l.b.b) && (!l.b.b.b)) {
					var longitude = l.a;
					var _v1 = l.b;
					var latitude = _v1.a;
					return $elm$json$Json$Decode$succeed(
						A2($author$project$Address$Address$Coordinates, latitude, longitude));
				} else {
					return $elm$json$Json$Decode$fail('List does not contain the right amount of items for coordinates');
				}
			},
			$elm$json$Json$Decode$list($elm$json$Json$Decode$float))
		]));
var $author$project$Address$Address$postalAddressDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Address$Address$PostalAddress,
	$author$project$Address$Address$houseNumberDecoder,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['location', 'coordinates']),
		$author$project$Address$Address$coordinatesDecoder));
var $author$project$Sequence$StreetPart$streetPartDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'houses',
	$elm$json$Json$Decode$list($author$project$Address$Address$postalAddressDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'street',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'municipal',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'zipCode',
				$elm$json$Json$Decode$string,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'countryCode',
					$author$project$Address$Address$countryCodeDecoder,
					3,
					$elm$json$Json$Decode$succeed($author$project$Sequence$StreetPart$StreetPart))))));
var $author$project$Sequence$Sequence$itemDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'streetParts',
	$elm$json$Json$Decode$list($author$project$Sequence$StreetPart$streetPartDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'cutPoint',
		$elm$json$Json$Decode$bool,
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			2,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'direction',
				$author$project$Sequence$StreetPart$directionDecoder,
				$elm$json$Json$Decode$succeed($author$project$Sequence$Sequence$Item)))));
var $author$project$Sequence$Sequence$sequenceSegmentDecoder = A2($elm$json$Json$Decode$field, 'id', $author$project$DistributionPoint$DistributionPoint$segmentIdDecoder);
var $author$project$Sequence$Sequence$sequenceDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'items',
	$elm$json$Json$Decode$list($author$project$Sequence$Sequence$itemDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'segments',
		$elm$json$Json$Decode$list($author$project$Sequence$Sequence$sequenceSegmentDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['deliverer', 'id']),
			$author$project$Deliverer$Deliverer$idDecoder,
			$elm$json$Json$Decode$succeed($author$project$Sequence$Sequence$Sequence))));
var $author$project$Lists$RouteDetail$Deliverer$routeDetailDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (deliverers) {
		var deliverersById = $author$project$Deliverer$IdDict$fromList(
			A2(
				$elm$core$List$map,
				function (d) {
					return _Utils_Tuple2(
						d.eg,
						$author$project$Deliverer$Deliverer$Registered(d));
				},
				deliverers));
		return A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'sequences',
			$elm$json$Json$Decode$list($author$project$Sequence$Sequence$sequenceDecoder),
			_List_Nil,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
				deliverers,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'aggregatedOrders',
					$elm$json$Json$Decode$list($author$project$Demand$Summary$distributionPointDecoder),
					_List_Nil,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'orders',
						$elm$json$Json$Decode$list($author$project$Demand$Demand$segmentOrdersDecoder),
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'products',
							$elm$json$Json$Decode$list($author$project$Demand$Demand$productDecoder),
							_List_Nil,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'complaints',
								$elm$json$Json$Decode$list($author$project$Demand$Demand$complaintDecoder),
								_List_Nil,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'items',
									$elm$json$Json$Decode$list(
										$author$project$Plan$Supply$decoder(deliverersById)),
									_List_Nil,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'distributionpoint',
										$author$project$DistributionPoint$DistributionPoint$distributionPointDecoder,
										$elm$json$Json$Decode$succeed($author$project$Lists$RouteDetail$Deliverer$RouteDetail)))))))));
	},
	A2(
		$elm$json$Json$Decode$field,
		'deliverers',
		$elm$json$Json$Decode$list($author$project$Deliverer$Deliverer$delivererDecoder)));
var $author$project$Lists$RouteDetail$Deliverer$loadCmd = F3(
	function (token, toMsg, date) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'routedetails',
					$author$project$Date$DeliveryDate$encodeForUrl(date)
				]),
			_List_Nil);
		return A4(
			$author$project$Api$Request$get,
			token,
			toMsg,
			uri,
			$elm$json$Json$Decode$list($author$project$Lists$RouteDetail$Deliverer$routeDetailDecoder));
	});
var $author$project$Lists$RouteDetail$Deliverer$actionIdFor = F2(
	function (id, date) {
		return A2(
			$author$project$Portal$Waiting$Id,
			'routeDetailDeliverer' + $author$project$Date$DeliveryDate$oldestFirst(date),
			id);
	});
var $author$project$Lists$RouteDetail$Deliverer$singleAction = F2(
	function (id, unique) {
		return $author$project$Portal$Waiting$singleAction(
			A2($author$project$Lists$RouteDetail$Deliverer$actionIdFor, id, unique));
	});
var $author$project$Lists$RouteDetail$Deliverer$loadingRouteDetail = $author$project$Lists$RouteDetail$Deliverer$singleAction('loadingRouteDetail');
var $author$project$Lists$RouteDetail$Deliverer$EditSequence = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Lists$RouteDetail$Deliverer$Mobile = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$UI$Swipe$None = {$: 0};
var $author$project$UI$Swipe$blanco = $author$project$UI$Swipe$None;
var $author$project$Lists$RouteDetail$Deliverer$updateDisplay = F2(
	function (device, current) {
		var _v0 = _Utils_Tuple2(device.le, current);
		_v0$1:
		while (true) {
			if (!_v0.a) {
				switch (_v0.b.$) {
					case 0:
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						var m = _v2.a;
						var s = _v2.b;
						return A2($author$project$Lists$RouteDetail$Deliverer$Mobile, m, s);
					case 2:
						break _v0$1;
					default:
						break _v0$1;
				}
			} else {
				if (_v0.b.$ === 2) {
					var _v4 = _v0.b;
					var item = _v4.a;
					var edit = _v4.b;
					return A2($author$project$Lists$RouteDetail$Deliverer$EditSequence, item, edit);
				} else {
					return $author$project$Lists$RouteDetail$Deliverer$Print;
				}
			}
		}
		var _v3 = _v0.a;
		return A2($author$project$Lists$RouteDetail$Deliverer$Mobile, $elm$core$Maybe$Nothing, $author$project$UI$Swipe$blanco);
	});
var $author$project$Lists$RouteDetail$Deliverer$init = F4(
	function (share, date, cluster, page) {
		var token = $author$project$Portal$Share$token(share);
		return A2(
			$author$project$Portal$Init$withModel,
			$author$project$Lists$RouteDetail$Deliverer$Loading(
				{
					r: $author$project$Portal$Subheader$initCalendarState,
					H: cluster,
					lx: date,
					N: A2(
						$author$project$Lists$RouteDetail$Deliverer$updateDisplay,
						$author$project$Portal$Share$device(share),
						$author$project$Lists$RouteDetail$Deliverer$Print),
					cv: page,
					cO: _List_Nil
				}),
			A3(
				$author$project$Portal$Init$withCommand,
				$author$project$Lists$RouteDetail$Deliverer$loadingRouteDetail,
				A3($author$project$Lists$RouteDetail$Deliverer$loadCmd, token, $author$project$Lists$RouteDetail$Deliverer$SystemGotRouteDetail, date),
				A2($author$project$Portal$Init$keyed, share, date)));
	});
var $author$project$Lists$RouteDetail$RouteDetail$BackendRespondedDemandSummary = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Lists$RouteDetail$RouteDetail$ComplaintsLoaded = function (a) {
	return {$: 7, a: a};
};
var $author$project$Lists$RouteDetail$RouteDetail$DistributionPointLoaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Lists$RouteDetail$RouteDetail$Loading = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Lists$RouteDetail$RouteDetail$OrdersLoaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$Lists$RouteDetail$RouteDetail$ProductsLoaded = function (a) {
	return {$: 6, a: a};
};
var $author$project$Lists$RouteDetail$RouteDetail$SequencesLoaded = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Lists$RouteDetail$RouteDetail$SystemGotLoaderMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Lists$RouteDetail$RouteDetail$CountDownFinished = {$: 3};
var $author$project$Lists$RouteDetail$RouteDetail$CountDownInProgress = function (a) {
	return {$: 1, a: a};
};
var $author$project$Lists$RouteDetail$RouteDetail$CountDownPending = {$: 0};
var $author$project$Lists$RouteDetail$RouteDetail$CountDownZero = {$: 2};
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $author$project$Lists$RouteDetail$RouteDetail$countDownClock = F2(
	function (zone, timeLeft) {
		var _v0 = A2(
			$elm$core$Basics$compare,
			$elm$time$Time$posixToMillis(timeLeft),
			0);
		switch (_v0) {
			case 2:
				var startWithDaysLeft = 100;
				var data = {
					gj: ($elm$time$Time$posixToMillis(timeLeft) / (((24 * 60) * 60) * 1000)) | 0,
					me: A2($elm$time$Time$toHour, zone, timeLeft),
					mH: A2($elm$time$Time$toMinute, zone, timeLeft),
					nF: A2($elm$time$Time$toSecond, zone, timeLeft)
				};
				return (_Utils_cmp(data.gj, startWithDaysLeft) < 0) ? $author$project$Lists$RouteDetail$RouteDetail$CountDownInProgress(data) : $author$project$Lists$RouteDetail$RouteDetail$CountDownPending;
			case 1:
				return $author$project$Lists$RouteDetail$RouteDetail$CountDownZero;
			default:
				return $author$project$Lists$RouteDetail$RouteDetail$CountDownFinished;
		}
	});
var $author$project$Lists$RouteDetail$RouteDetail$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Lists$RouteDetail$RouteDetail$ensureCorrectStatus = function (model) {
	var _v0 = model.h;
	if (!_v0.$) {
		var planInfo = _v0.b;
		var loadedAllSummaries = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$eq(
					$author$project$DistributionPoint$IdDict$size(planInfo.bm)),
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeR, $author$project$DistributionPoint$DistributionPoint$getSubDistributionPoints, $elm$core$List$length),
					planInfo.bn)));
		var _v1 = _Utils_Tuple3(
			_Utils_Tuple3(
				planInfo.bn,
				$author$project$Plan$PlanLoader$loadedOf(planInfo.fB),
				planInfo.hm),
			_Utils_Tuple3(planInfo.Y, planInfo.bu, planInfo.m),
			loadedAllSummaries);
		if (((((((!_v1.a.a.$) && (!_v1.a.b.$)) && (!_v1.a.c.a)) && (!_v1.b.a.$)) && (!_v1.b.b.$)) && (!_v1.b.c.$)) && _v1.c) {
			var _v2 = _v1.a;
			var distributionPoint = _v2.a.a;
			var p = _v2.b.a;
			var _v3 = _v2.c;
			var sequences = _v3.b;
			var _v4 = _v1.b;
			var orders = _v4.a.a;
			var products = _v4.b.a;
			var complaints = _v4.c.a;
			return _Utils_update(
				model,
				{
					h: $author$project$Lists$RouteDetail$RouteDetail$Loaded(
						{m: complaints, lx: planInfo.lx, e4: p.e4, bm: planInfo.bm, bn: distributionPoint, Y: orders, fA: p.fA, bu: products, hm: sequences})
				});
		} else {
			return model;
		}
	} else {
		return model;
	}
};
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $elm_community$list_extra$List$Extra$greedyGroupsOfWithStep = F3(
	function (size, step, list) {
		if ((size <= 0) || (step <= 0)) {
			return _List_Nil;
		} else {
			var go = F2(
				function (xs, acc) {
					go:
					while (true) {
						if ($elm$core$List$isEmpty(xs)) {
							return $elm$core$List$reverse(acc);
						} else {
							var $temp$xs = A2($elm$core$List$drop, step, xs),
								$temp$acc = A2(
								$elm$core$List$cons,
								A2($elm$core$List$take, size, xs),
								acc);
							xs = $temp$xs;
							acc = $temp$acc;
							continue go;
						}
					}
				});
			return A2(go, list, _List_Nil);
		}
	});
var $elm_community$list_extra$List$Extra$greedyGroupsOf = F2(
	function (size, xs) {
		return A3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, size, xs);
	});
var $author$project$Lists$RouteDetail$PrintSelection$AllSubscriptions = 0;
var $author$project$Lists$RouteDetail$PrintSelection$ShowComplaints = 0;
var $author$project$Lists$RouteDetail$PrintSelection$ShowKioskList = 0;
var $author$project$Lists$RouteDetail$PrintSelection$ShowMutations = 0;
var $author$project$Lists$RouteDetail$PrintSelection$ShowRouteList = 0;
var $author$project$Print$Option$SingleSided = 0;
var $author$project$Lists$RouteDetail$ClusterSelection$ClusterSelection = $elm$core$Basics$identity;
var $author$project$Lists$RouteDetail$ClusterSelection$empty = $elm$core$Set$empty;
var $author$project$Lists$RouteDetail$PrintSelection$defaults = {h6: 0, fn: 0, jj: 0, nl: 0, fK: 0, s: $author$project$Lists$RouteDetail$ClusterSelection$empty, dy: $elm$core$Set$empty, ev: 0};
var $author$project$Lists$RouteDetail$PrintSelection$init = $author$project$Lists$RouteDetail$PrintSelection$defaults;
var $author$project$Demand$Demand$loadComplaintsCmd = F4(
	function (token, toMsg, dpId, date) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['complaints']),
			_List_fromArray(
				[
					A2(
					$elm$url$Url$Builder$string,
					'dpid',
					$author$project$DistributionPoint$DistributionPoint$encodeIdForUrl(dpId)),
					A2(
					$elm$url$Url$Builder$string,
					'validon',
					$author$project$Date$DeliveryDate$encodeForUrl(date))
				]));
		return A4(
			$author$project$Api$Request$get,
			token,
			toMsg,
			uri,
			$elm$json$Json$Decode$list($author$project$Demand$Demand$complaintDecoder));
	});
var $author$project$Date$DeliveryDate$encode = function (date) {
	return $elm$json$Json$Encode$string(
		$author$project$Date$DeliveryDate$encodeForUrl(date));
};
var $author$project$Deliverer$Deliverer$encodeId = function (_v0) {
	var id = _v0;
	return $danyx23$elm_uuid$Uuid$encode(id);
};
var $author$project$DistributionPoint$DistributionPoint$encodeSegmentId = $danyx23$elm_uuid$Uuid$encode;
var $author$project$Sequence$Sequence$encodeSequenceWithoutItems = function (_v0) {
	var date = _v0.a;
	var delivererId = _v0.b;
	var segmentIds = _v0.c;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'delivererId',
				$author$project$Deliverer$Deliverer$encodeId(delivererId)),
				_Utils_Tuple2(
				'segmentIds',
				A2($elm$json$Json$Encode$list, $author$project$DistributionPoint$DistributionPoint$encodeSegmentId, segmentIds)),
				_Utils_Tuple2(
				'validOn',
				$author$project$Date$DeliveryDate$encode(date))
			]));
};
var $author$project$Sequence$Sequence$loadSequencesCmd = F3(
	function (token, toMsg, requests) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['sequences', 'find']),
			_List_Nil);
		var body = $elm$http$Http$jsonBody(
			A2($elm$json$Json$Encode$list, $author$project$Sequence$Sequence$encodeSequenceWithoutItems, requests));
		return A5(
			$author$project$Api$Request$post,
			token,
			toMsg,
			uri,
			body,
			$elm$json$Json$Decode$list($author$project$Sequence$Sequence$sequenceDecoder));
	});
var $author$project$Lists$RouteDetail$RouteDetail$actionIdFor = F2(
	function (id, planId) {
		return A2(
			$author$project$Portal$Waiting$Id,
			'routeDetail' + $author$project$Plan$Plan$comparableId(planId),
			id);
	});
var $author$project$Lists$RouteDetail$RouteDetail$singleAction = function (id) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Lists$RouteDetail$RouteDetail$actionIdFor(id),
		$author$project$Portal$Waiting$singleAction);
};
var $author$project$Lists$RouteDetail$RouteDetail$loadingComplaints = $author$project$Lists$RouteDetail$RouteDetail$singleAction('loadingComplaints');
var $author$project$Lists$RouteDetail$RouteDetail$loadingDP = $author$project$Lists$RouteDetail$RouteDetail$singleAction('loadingDP');
var $author$project$Lists$RouteDetail$RouteDetail$loadingOrders = $author$project$Lists$RouteDetail$RouteDetail$singleAction('loadingOrders');
var $author$project$Lists$RouteDetail$RouteDetail$loadingPlan = F2(
	function (key, stage) {
		return A2($author$project$Lists$RouteDetail$RouteDetail$singleAction, 'loadingPlan' + stage, key);
	});
var $author$project$Lists$RouteDetail$RouteDetail$loadingProducts = $author$project$Lists$RouteDetail$RouteDetail$singleAction('loadingProducts');
var $author$project$Lists$RouteDetail$RouteDetail$loadingSequences = F2(
	function (key, index) {
		return A2(
			$author$project$Lists$RouteDetail$RouteDetail$singleAction,
			'loadingSequences' + $elm$core$String$fromInt(index),
			key);
	});
var $author$project$Lists$RouteDetail$RouteDetail$loadingSummaries = F2(
	function (key, index) {
		return A2(
			$author$project$Lists$RouteDetail$RouteDetail$singleAction,
			'loadingSummaries' + $elm$core$String$fromInt(index),
			key);
	});
var $author$project$Lists$RouteDetail$RouteDetail$segmentsByDelivererIdOf = function (items) {
	var segmentsByDelivererId = function (item) {
		switch (item.$) {
			case 0:
				var deliverer = item.a.bl;
				var cluster = item.a.H;
				var supplies = item.a.n0;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						$author$project$Deliverer$Deliverer$idFromTyped(deliverer),
						cluster.bb),
					A2($elm$core$List$concatMap, segmentsByDelivererId, supplies));
			case 1:
				var deliverer = item.a.bl;
				var clusters = item.a.k;
				return A2(
					$elm$core$List$map,
					function (c) {
						return _Utils_Tuple2(
							$author$project$Deliverer$Deliverer$idFromTyped(deliverer),
							c.bb);
					},
					clusters);
			default:
				return _List_Nil;
		}
	};
	return A2(
		$elm$core$List$filter,
		function (_v1) {
			var segments = _v1.b;
			return $elm$core$List$length(segments) > 0;
		},
		A2($elm$core$List$concatMap, segmentsByDelivererId, items));
};
var $author$project$Lists$RouteDetail$RouteDetail$shareDataFromModel = function (model) {
	var _v0 = model.h;
	switch (_v0.$) {
		case 1:
			var planInfo = _v0.a;
			return A3(
				$elm$core$Basics$composeR,
				$author$project$Portal$ShareData$withDistributionPoint(planInfo.bn),
				A2(
					$elm$core$Basics$composeR,
					$author$project$Portal$ShareData$withTypedDeliverers(planInfo.e4),
					A2(
						$elm$core$Basics$composeR,
						$author$project$Portal$ShareData$withPlan(planInfo.fA),
						A2(
							$elm$core$Basics$composeR,
							$author$project$Portal$ShareData$withOrders(planInfo.Y),
							$author$project$Portal$ShareData$withProducts(planInfo.bu)))),
				$author$project$Portal$ShareData$empty(planInfo.lx));
		case 0:
			var date = _v0.b.lx;
			return $author$project$Portal$ShareData$empty(date);
		default:
			var date = _v0.b;
			return $author$project$Portal$ShareData$empty(date);
	}
};
var $author$project$Portal$Share$timeZone = function (_v0) {
	var model = _v0;
	return model.ko;
};
var $author$project$Lists$RouteDetail$RouteDetail$withDateFirst = F2(
	function (date, segmentsByDeliverer) {
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var dId = _v0.a;
				var segments = _v0.b;
				return _Utils_Tuple3(date, dId, segments);
			},
			segmentsByDeliverer);
	});
var $author$project$Lists$RouteDetail$RouteDetail$init = F3(
	function (share, dpId, date) {
		var token = $author$project$Portal$Share$token(share);
		var planId = A2($author$project$Plan$Plan$Id, dpId, date);
		var planAndDeliverers = A4($author$project$Plan$PlanLoader$initModel, share, $elm$core$Basics$identity, dpId, date);
		var sequencesCmds = function () {
			var _v0 = $author$project$Plan$PlanLoader$loadedOf(planAndDeliverers);
			if (_v0.$ === 1) {
				return _List_Nil;
			} else {
				var p = _v0.a;
				return A2(
					$elm$core$List$map,
					F2(
						function (seq, i) {
							return A3(
								$author$project$Sequence$Sequence$loadSequencesCmd,
								token,
								$author$project$Lists$RouteDetail$RouteDetail$SequencesLoaded(i),
								seq);
						}),
					A2(
						$elm_community$list_extra$List$Extra$greedyGroupsOf,
						5,
						A2(
							$author$project$Lists$RouteDetail$RouteDetail$withDateFirst,
							date,
							$author$project$Lists$RouteDetail$RouteDetail$segmentsByDelivererIdOf(p.fA.gL))));
			}
		}();
		return A2(
			$author$project$Portal$Return$ensureDataShared,
			$author$project$Lists$RouteDetail$RouteDetail$shareDataFromModel,
			A2(
				$author$project$Portal$Init$withModelFromData,
				function (shareData) {
					return $author$project$Lists$RouteDetail$RouteDetail$ensureCorrectStatus(
						{
							e$: A2(
								$author$project$Lists$RouteDetail$RouteDetail$countDownClock,
								$author$project$Portal$Share$timeZone(share),
								$elm$time$Time$millisToPosix(0)),
							h: A2(
								$author$project$Lists$RouteDetail$RouteDetail$Loading,
								dpId,
								{
									m: $elm$core$Maybe$Nothing,
									lx: date,
									bm: $author$project$DistributionPoint$IdDict$empty,
									bn: shareData.bn,
									c2: dpId,
									Y: shareData.Y,
									fB: planAndDeliverers,
									bu: shareData.bu,
									hm: _Utils_Tuple2(
										$elm$core$List$length(sequencesCmds),
										_List_Nil)
								}),
							$7: $author$project$Lists$RouteDetail$PrintSelection$init
						});
				},
				A3(
					$author$project$Portal$Init$withCommands,
					$author$project$Lists$RouteDetail$RouteDetail$loadingSequences,
					sequencesCmds,
					A3(
						$author$project$Portal$Init$withCommand,
						$author$project$Lists$RouteDetail$RouteDetail$loadingComplaints,
						A4($author$project$Demand$Demand$loadComplaintsCmd, token, $author$project$Lists$RouteDetail$RouteDetail$ComplaintsLoaded, dpId, date),
						A4(
							$author$project$Portal$Init$ifNothing,
							function ($) {
								return $.bu;
							},
							$author$project$Lists$RouteDetail$RouteDetail$loadingProducts,
							A4($author$project$Demand$Demand$loadProductsCmd, token, $author$project$Lists$RouteDetail$RouteDetail$ProductsLoaded, dpId, date),
							A4(
								$author$project$Portal$Init$ifNothing,
								function ($) {
									return $.Y;
								},
								$author$project$Lists$RouteDetail$RouteDetail$loadingOrders,
								A4($author$project$Demand$Demand$loadOrdersCmd, token, $author$project$Lists$RouteDetail$RouteDetail$OrdersLoaded, dpId, date),
								A5(
									$author$project$Portal$Init$withPlanLoader,
									$author$project$Lists$RouteDetail$RouteDetail$loadingPlan,
									dpId,
									date,
									$author$project$Lists$RouteDetail$RouteDetail$SystemGotLoaderMsg,
									A4(
										$author$project$Portal$Init$multiIfJust,
										function ($) {
											return $.bn;
										},
										$author$project$Lists$RouteDetail$RouteDetail$loadingSummaries,
										A2(
											$elm$core$Basics$composeR,
											$author$project$DistributionPoint$DistributionPoint$getSubDistributionPoints,
											$elm$core$List$map(
												F2(
													function (subDP, i) {
														return A4(
															$author$project$Demand$Summary$loadForDPCmd,
															token,
															$author$project$Lists$RouteDetail$RouteDetail$BackendRespondedDemandSummary(i),
															$author$project$DistributionPoint$DistributionPoint$idOf(subDP),
															date);
													}))),
										A4(
											$author$project$Portal$Init$ifNothing,
											function ($) {
												return $.bn;
											},
											$author$project$Lists$RouteDetail$RouteDetail$loadingDP,
											A4($author$project$DistributionPoint$DistributionPoint$loadCmd, token, $author$project$Lists$RouteDetail$RouteDetail$DistributionPointLoaded, dpId, date),
											A2($author$project$Portal$Init$keyed, share, planId))))))))));
	});
var $author$project$Message$Message$BackendRespondedMessages = function (a) {
	return {$: 1, a: a};
};
var $author$project$Message$Message$Loading = {$: 0};
var $author$project$Message$Message$NoMessageForm = {$: 0};
var $author$project$Message$Message$SystemRetrievedNow = function (a) {
	return {$: 0, a: a};
};
var $author$project$Message$Message$idDecoder = A2($elm$json$Json$Decode$field, 'id', $danyx23$elm_uuid$Uuid$decoder);
var $author$project$Message$Message$messageIdAndMessageDecoder = A3($elm$json$Json$Decode$map2, $elm$core$Tuple$pair, $author$project$Message$Message$idDecoder, $author$project$Message$Message$decoder);
var $author$project$Message$Message$loadLastMonthCmd = F2(
	function (token, toMsg) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['messages']),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'validfrom', 'last_month')
				]));
		return A4(
			$author$project$Api$Request$get,
			token,
			toMsg,
			uri,
			$elm$json$Json$Decode$list($author$project$Message$Message$messageIdAndMessageDecoder));
	});
var $author$project$Message$Message$actionIdFor = function (id) {
	return A2($author$project$Portal$Waiting$Id, 'messages', id);
};
var $author$project$Message$Message$singleAction = F2(
	function (id, _v0) {
		return $author$project$Portal$Waiting$singleAction(
			$author$project$Message$Message$actionIdFor(id));
	});
var $author$project$Message$Message$loadingMessages = $author$project$Message$Message$singleAction('loadingMessages');
var $author$project$Message$Message$init = function (share) {
	return A2(
		$author$project$Portal$Init$withModel,
		{ac: $author$project$Message$Message$NoMessageForm, di: $author$project$Message$Message$Loading, W: $elm$core$Maybe$Nothing},
		A2(
			$author$project$Portal$Init$withBackgroundCommand,
			A2($elm$core$Task$perform, $author$project$Message$Message$SystemRetrievedNow, $elm$time$Time$now),
			A3(
				$author$project$Portal$Init$withCommand,
				$author$project$Message$Message$loadingMessages,
				A2(
					$author$project$Message$Message$loadLastMonthCmd,
					$author$project$Portal$Share$token(share),
					$author$project$Message$Message$BackendRespondedMessages),
				$author$project$Portal$Init$empty(share))));
};
var $author$project$Payment$AnnualDetail$Loading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Payment$AnnualDetail$SystemGotAnnualDetail = $elm$core$Basics$identity;
var $author$project$Payment$Payment$AnnualStatement = F5(
	function (id, amount, year, source, deliverer) {
		return {aa: amount, bl: deliverer, eg: id, nO: source, kC: year};
	});
var $author$project$Payment$Payment$DelivererForStatement = F7(
	function (bsn, birthDate, initials, prefix, lastName, address, tags) {
		return {f1: address, kZ: birthDate, gd: bsn, gI: initials, fo: lastName, fF: prefix, kn: tags};
	});
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {h3: col, lq: contextStack, dp: problem, dv: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.dv, s.h3, x, s.g));
	});
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.c, s.ka);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{h3: 1, g: s.g, l: s.l, c: s.c + 1, dv: s.dv + 1, ka: s.ka}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{h3: s.h3 + 1, g: s.g, l: s.l, c: newOffset, dv: s.dv, ka: s.ka}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $justinmimbs$date$Date$deadEndToString = function (_v0) {
	var problem = _v0.dp;
	if (problem.$ === 12) {
		var message = problem.a;
		return message;
	} else {
		return 'Expected a date in ISO 8601 format';
	}
};
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.ka),
			s.c) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $justinmimbs$date$Date$MonthAndDay = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $justinmimbs$date$Date$OrdinalDay = function (a) {
	return {$: 2, a: a};
};
var $justinmimbs$date$Date$WeekAndWeekday = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$Advanced$commit = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, true, a, s);
	};
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
var $justinmimbs$date$Date$int1 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$elm$parser$Parser$chompIf($elm$core$Char$isDigit));
var $justinmimbs$date$Date$int2 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int3 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.c, s.dv, s.h3, s.ka);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{h3: newCol, g: s.g, l: s.l, c: newOffset, dv: newRow, ka: s.ka});
	};
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$token('-')),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable(
						A2(
							$elm$parser$Parser$andThen,
							$elm$parser$Parser$commit,
							A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int2),
									$elm$parser$Parser$succeed(1)
								]))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
								$elm$parser$Parser$token('W')),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int1),
									$elm$parser$Parser$succeed(1)
								])))
					]))),
			$elm$parser$Parser$backtrackable(
			A2(
				$elm$parser$Parser$andThen,
				$elm$parser$Parser$commit,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
						$justinmimbs$date$Date$int2),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$justinmimbs$date$Date$int2,
								$elm$parser$Parser$succeed(1)
							]))))),
			A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
					$elm$parser$Parser$token('W')),
				$justinmimbs$date$Date$int2),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$justinmimbs$date$Date$int1,
						$elm$parser$Parser$succeed(1)
					]))),
			$elm$parser$Parser$succeed(
			$justinmimbs$date$Date$OrdinalDay(1))
		]));
var $justinmimbs$date$Date$isBetweenInt = F3(
	function (a, b, x) {
		return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
	});
var $justinmimbs$date$Date$fromCalendarParts = F3(
	function (y, mn, d) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn) && A3(
			$justinmimbs$date$Date$isBetweenInt,
			1,
			A2(
				$justinmimbs$date$Date$daysInMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn)),
			d)) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2(
				$justinmimbs$date$Date$daysBeforeMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn))) + d) : $elm$core$Result$Err(
			'Invalid calendar date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(mn) + (', ' + ($elm$core$String$fromInt(d) + ')'))))));
	});
var $justinmimbs$date$Date$fromOrdinalParts = F2(
	function (y, od) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 365, od) || ((od === 366) && $justinmimbs$date$Date$isLeapYear(y))) ? $elm$core$Result$Ok(
			$justinmimbs$date$Date$daysBeforeYear(y) + od) : $elm$core$Result$Err(
			'Invalid ordinal date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(od) + ')'))));
	});
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
};
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
};
var $justinmimbs$date$Date$is53WeekYear = function (y) {
	var wdnJan1 = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$firstOfYear(y));
	return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
};
var $justinmimbs$date$Date$fromWeekParts = F3(
	function (wy, wn, wdn) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn) && (A3($justinmimbs$date$Date$isBetweenInt, 1, 52, wn) || ((wn === 53) && $justinmimbs$date$Date$is53WeekYear(wy)))) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn) : $elm$core$Result$Err(
			'Invalid week date (' + ($elm$core$String$fromInt(wy) + (', ' + ($elm$core$String$fromInt(wn) + (', ' + ($elm$core$String$fromInt(wdn) + ')'))))));
	});
var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
	var y = _v0.a;
	var doy = _v0.b;
	switch (doy.$) {
		case 0:
			var mn = doy.a;
			var d = doy.b;
			return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
		case 1:
			var wn = doy.a;
			var wdn = doy.b;
			return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
		default:
			var od = doy.a;
			return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
	}
};
var $justinmimbs$date$Date$int4 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(0),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$chompIf(
									function (c) {
										return c === '-';
									}),
									$elm$parser$Parser$succeed(0)
								]))),
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $justinmimbs$date$Date$resultToParser = function (result) {
	if (!result.$) {
		var x = result.a;
		return $elm$parser$Parser$succeed(x);
	} else {
		var message = result.a;
		return $elm$parser$Parser$problem(message);
	}
};
var $justinmimbs$date$Date$parser = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser),
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Tuple$pair),
			$justinmimbs$date$Date$int4),
		$justinmimbs$date$Date$dayOfYear));
var $justinmimbs$date$Date$fromIsoString = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run(
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$ignorer,
				$justinmimbs$date$Date$parser,
				A2(
					$elm$parser$Parser$andThen,
					$justinmimbs$date$Date$resultToParser,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
								A2(
								$elm$parser$Parser$map,
								$elm$core$Basics$always(
									$elm$core$Result$Err('Expected a date only, not a date and time')),
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$eq('T'))),
								$elm$parser$Parser$succeed(
								$elm$core$Result$Err('Expected a date only'))
							])))))),
	$elm$core$Result$mapError(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($justinmimbs$date$Date$deadEndToString),
				$elm$core$Maybe$withDefault('')))));
var $author$project$Date$Extra$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		var _v0 = $justinmimbs$date$Date$fromIsoString(str);
		if (!_v0.$) {
			var date = _v0.a;
			return $elm$json$Json$Decode$succeed(date);
		} else {
			var error = _v0.a;
			return $elm$json$Json$Decode$fail('Ongeldige datum: ' + error);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Payment$Payment$delivererForStatementDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'tags',
	$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
	$elm$core$Dict$empty,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'address',
		$author$project$Address$Address$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'lastName',
			$elm$json$Json$Decode$string,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'prefix',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'initials',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'birthDate',
						$author$project$Date$Extra$decoder,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'bsn',
							$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							$elm$json$Json$Decode$succeed($author$project$Payment$Payment$DelivererForStatement))))))));
var $author$project$Compensation$Money$euro = function (amount) {
	return 10000 * amount;
};
var $author$project$Compensation$Money$euroDecoder = A2($elm$json$Json$Decode$map, $author$project$Compensation$Money$euro, $elm$json$Json$Decode$int);
var $author$project$Payment$Payment$Source = F5(
	function (id, name, address, municipal, zipCode) {
		return {f1: address, eg: id, bU: municipal, ft: name, cT: zipCode};
	});
var $author$project$Payment$Payment$sourceDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'zipCode',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'municipal',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'address',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Payment$Payment$Source))))));
var $author$project$Payment$Payment$annualStatementDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'deliverer',
	$author$project$Payment$Payment$delivererForStatementDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'source',
		$author$project$Payment$Payment$sourceDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'year',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'amount',
				$author$project$Compensation$Money$euroDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Payment$Payment$AnnualStatement))))));
var $author$project$Payment$Payment$loadAnnualCmd = F3(
	function (token, year, toMsg) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'statements',
					$elm$core$String$fromInt(year)
				]),
			_List_Nil);
		return A4($author$project$Api$Request$get, token, toMsg, uri, $author$project$Payment$Payment$annualStatementDecoder);
	});
var $author$project$Payment$AnnualDetail$actionIdFor = function (annualDetailId) {
	return A2($author$project$Portal$Waiting$Id, 'annualDetail', annualDetailId);
};
var $author$project$Payment$AnnualDetail$singleAction = function (annualDetailId) {
	return $author$project$Portal$Waiting$singleAction(
		$author$project$Payment$AnnualDetail$actionIdFor(annualDetailId));
};
var $author$project$Payment$AnnualDetail$loadingAnnualDetail = $author$project$Payment$AnnualDetail$singleAction('loadingAnnualDetail');
var $author$project$Payment$AnnualDetail$init = F2(
	function (share, id) {
		var token = $author$project$Portal$Share$token(share);
		return A2(
			$author$project$Portal$Init$withModel,
			$author$project$Payment$AnnualDetail$Loading(id),
			A3(
				$author$project$Portal$Init$withCommand,
				$elm$core$Basics$always($author$project$Payment$AnnualDetail$loadingAnnualDetail),
				A3($author$project$Payment$Payment$loadAnnualCmd, token, id, $elm$core$Basics$identity),
				A2($author$project$Portal$Init$keyed, share, id)));
	});
var $author$project$Payment$Archive$NoDeliverersSearched = {$: 0};
var $author$project$Payment$Archive$init = function (share) {
	return A2(
		$author$project$Portal$Init$withModel,
		{
			cC: {n3: '', f_: _List_Nil},
			nS: $author$project$Payment$Archive$NoDeliverersSearched
		},
		$author$project$Portal$Init$empty(share));
};
var $author$project$Payment$DelivererOverview$BackendRespondedAnnualSummaries = function (a) {
	return {$: 1, a: a};
};
var $author$project$Payment$DelivererOverview$BackendRespondedSummaries = function (a) {
	return {$: 0, a: a};
};
var $author$project$Payment$DelivererOverview$Loading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Payment$Payment$loadAnnualSummariesCmd = F2(
	function (token, toMsg) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['statements', 'limit', '2']),
			_List_Nil);
		return A4(
			$author$project$Api$Request$get,
			token,
			toMsg,
			uri,
			$elm$json$Json$Decode$list($author$project$Payment$Payment$annualStatementDecoder));
	});
var $author$project$Payment$Payment$MonthlySummary = F2(
	function (wagePeriod, total) {
		return {dH: total, dK: wagePeriod};
	});
var $author$project$Compensation$WagePeriod$WagePeriod = F4(
	function (year, period, from, to) {
		return {l2: from, jv: period, oj: to, kC: year};
	});
var $author$project$Compensation$WagePeriod$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'to',
	$author$project$Date$DeliveryDate$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'from',
		$author$project$Date$DeliveryDate$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'period',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'year',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Compensation$WagePeriod$WagePeriod)))));
var $author$project$Payment$Payment$monthlySummaryDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'payable',
	$author$project$Compensation$Money$euroCentDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'wagePeriod',
		$author$project$Compensation$WagePeriod$decoder,
		$elm$json$Json$Decode$succeed($author$project$Payment$Payment$MonthlySummary)));
var $author$project$Payment$Payment$loadDelivererWagePeriodsCmd = F2(
	function (token, toMsg) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['wageperiods', 'limit', '26']),
			_List_Nil);
		return A4(
			$author$project$Api$Request$get,
			token,
			toMsg,
			uri,
			$elm$json$Json$Decode$list($author$project$Payment$Payment$monthlySummaryDecoder));
	});
var $author$project$Payment$DelivererOverview$actionIdFor = function (id) {
	return A2($author$project$Portal$Waiting$Id, 'summaries', id);
};
var $author$project$Payment$DelivererOverview$singleAction = function (id) {
	return $author$project$Portal$Waiting$singleAction(
		$author$project$Payment$DelivererOverview$actionIdFor(id));
};
var $author$project$Payment$DelivererOverview$loadingAnnualSummaries = $author$project$Payment$DelivererOverview$singleAction('loadingAnnualSummaries');
var $author$project$Payment$DelivererOverview$loadingSummaries = $author$project$Payment$DelivererOverview$singleAction('loadingSummaries');
var $author$project$Payment$DelivererOverview$init = function (share) {
	var token = $author$project$Portal$Share$token(share);
	return A2(
		$author$project$Portal$Init$withModel,
		$author$project$Payment$DelivererOverview$Loading(
			{cX: $elm$core$Maybe$Nothing, cK: $elm$core$Maybe$Nothing}),
		A3(
			$author$project$Portal$Init$withCommand,
			$elm$core$Basics$always($author$project$Payment$DelivererOverview$loadingAnnualSummaries),
			A2($author$project$Payment$Payment$loadAnnualSummariesCmd, token, $author$project$Payment$DelivererOverview$BackendRespondedAnnualSummaries),
			A3(
				$author$project$Portal$Init$withCommand,
				$elm$core$Basics$always($author$project$Payment$DelivererOverview$loadingSummaries),
				A2($author$project$Payment$Payment$loadDelivererWagePeriodsCmd, token, $author$project$Payment$DelivererOverview$BackendRespondedSummaries),
				$author$project$Portal$Init$empty(share))));
};
var $author$project$Payment$Detail$Loading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Payment$Detail$SystemGotCompensationDetail = $elm$core$Basics$identity;
var $author$project$Payment$Payment$Version2021 = function (a) {
	return {$: 0, a: a};
};
var $author$project$Payment$Payment$Version2023 = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Payment$Payment$Payment = F5(
	function (iban, totals, wagePeriod, deliverer, details) {
		return {bl: deliverer, lE: details, gE: iban, bD: totals, dK: wagePeriod};
	});
var $author$project$Payment$Payment$Directly = function (a) {
	return {$: 0, a: a};
};
var $author$project$Payment$Payment$Firm = function (a) {
	return {$: 2, a: a};
};
var $author$project$Payment$Payment$Personnel = function (a) {
	return {$: 1, a: a};
};
var $author$project$Payment$Payment$DelivererInfo = F8(
	function (bsn, salutation, firstName, surname, lastName, address, tags, birthDate) {
		return {f1: address, kZ: birthDate, gd: bsn, fc: firstName, fo: lastName, hi: salutation, kl: surname, kn: tags};
	});
var $author$project$Payment$Payment$delivererInfoDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'birthDate',
	$elm$json$Json$Decode$maybe($author$project$Date$DeliveryDate$decoder),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'tags',
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
		$elm$core$Dict$empty,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'address',
			$author$project$Address$Address$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'lastName',
				$elm$json$Json$Decode$string,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'surname',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'firstName',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'salutation',
							$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'bsn',
								$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								$elm$json$Json$Decode$succeed($author$project$Payment$Payment$DelivererInfo)))))))));
var $author$project$Payment$Payment$FirmInfo = F5(
	function (vatNumber, companyType, companyName, address, tags) {
		return {f1: address, eU: companyName, h5: companyType, kn: tags, ou: vatNumber};
	});
var $author$project$Payment$Payment$firmInfoDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'tags',
	$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
	$elm$core$Dict$empty,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'address',
		$author$project$Address$Address$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'lastName',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'salutation',
				$elm$json$Json$Decode$string,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'vatNumber',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					$elm$json$Json$Decode$succeed($author$project$Payment$Payment$FirmInfo))))));
var $author$project$Payment$Payment$delivererDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (t) {
		switch (t) {
			case 1:
				return A2($elm$json$Json$Decode$map, $author$project$Payment$Payment$Directly, $author$project$Payment$Payment$delivererInfoDecoder);
			case 2:
				return A2($elm$json$Json$Decode$map, $author$project$Payment$Payment$Personnel, $author$project$Payment$Payment$delivererInfoDecoder);
			case 3:
				return A2($elm$json$Json$Decode$map, $author$project$Payment$Payment$Firm, $author$project$Payment$Payment$firmInfoDecoder);
			default:
				return $elm$json$Json$Decode$fail('unknown deliverer payment type');
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$int));
var $author$project$Payment$Payment$Detail = F5(
	function (from, to, total, element, compensations) {
		return {aD: compensations, as: element, l2: from, oj: to, dH: total};
	});
var $author$project$Payment$Payment$Compensation = F5(
	function (code, description, quantity, unitPrice, amount) {
		return {aa: amount, ge: code, ig: description, nm: quantity, oo: unitPrice};
	});
var $author$project$Compensation$Money$euroTenThousandthDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$int);
var $author$project$Payment$Payment$compensationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'amount',
	$author$project$Compensation$Money$euroCentDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'unitPrice',
		$author$project$Compensation$Money$euroTenThousandthDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'quantity',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'description',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'code',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Payment$Payment$Compensation))))));
var $author$project$Payment$Payment$Segment = F4(
	function (number, elementType, name, region) {
		return {iu: elementType, ft: name, bX: number, nq: region};
	});
var $author$project$Payment$Payment$Region = F2(
	function (number, name) {
		return {ft: name, bX: number};
	});
var $author$project$Payment$Payment$regionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'number',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Payment$Payment$Region)));
var $author$project$Payment$Payment$elementDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'region',
	$elm$json$Json$Decode$maybe($author$project$Payment$Payment$regionDecoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'type',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'number',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Payment$Payment$Segment)))));
var $author$project$Payment$Payment$detailDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'compensations',
	$elm$json$Json$Decode$list($author$project$Payment$Payment$compensationDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'element',
		$author$project$Payment$Payment$elementDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'total',
			$author$project$Compensation$Money$euroCentDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'to',
				$author$project$Date$DeliveryDate$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'from',
					$author$project$Date$DeliveryDate$decoder,
					$elm$json$Json$Decode$succeed($author$project$Payment$Payment$Detail))))));
var $author$project$Payment$Payment$Totals = F7(
	function (net, compensation, reimbursement, cleared, vat, inclVat, payable) {
		return {h1: cleared, ao: compensation, mk: inclVat, g_: net, ju: payable, nt: reimbursement, ot: vat};
	});
var $author$project$Payment$Payment$totalsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'payable',
	$author$project$Compensation$Money$euroCentDecoder,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'inclVat',
		$elm$json$Json$Decode$maybe($author$project$Compensation$Money$euroCentDecoder),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'vat',
			$elm$json$Json$Decode$maybe($author$project$Compensation$Money$euroCentDecoder),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'cleared',
				$elm$json$Json$Decode$maybe($author$project$Compensation$Money$euroCentDecoder),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'reimbursement',
					$elm$json$Json$Decode$maybe($author$project$Compensation$Money$euroCentDecoder),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'compensation',
						$author$project$Compensation$Money$euroCentDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'net',
							$author$project$Compensation$Money$euroCentDecoder,
							$elm$json$Json$Decode$succeed($author$project$Payment$Payment$Totals))))))));
var $author$project$Payment$Payment$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'details',
	$elm$json$Json$Decode$list($author$project$Payment$Payment$detailDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'deliverer',
		$author$project$Payment$Payment$delivererDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'wagePeriod',
			$author$project$Compensation$WagePeriod$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'totals',
				$author$project$Payment$Payment$totalsDecoder,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'iban',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					$elm$json$Json$Decode$succeed($author$project$Payment$Payment$Payment))))));
var $author$project$Payment$Payment$Summary = F2(
	function (totals, groups) {
		return {l8: groups, bD: totals};
	});
var $author$project$Payment$Payment$Group = F4(
	function (id, description, amount, payments) {
		return {aa: amount, ig: description, eg: id, ep: payments};
	});
var $author$project$Payment$Payment$GroupedPayment = F3(
	function (code, description, amount) {
		return {aa: amount, ge: code, ig: description};
	});
var $author$project$Payment$Payment$groupedPaymentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'amountInEurocent',
	$author$project$Compensation$Money$euroCentDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'code',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Payment$Payment$GroupedPayment))));
var $author$project$Payment$Payment$groupDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'payments',
	$elm$json$Json$Decode$list($author$project$Payment$Payment$groupedPaymentDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'amountInEurocent',
		$author$project$Compensation$Money$euroCentDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'description',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Payment$Payment$Group)))));
var $author$project$Payment$Payment$SummaryTotals = F4(
	function (orders, inserts, incidentals, amount) {
		return {aa: amount, iO: incidentals, iT: inserts, Y: orders};
	});
var $author$project$Payment$Payment$summaryTotalsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'amount',
	$author$project$Compensation$Money$euroCentDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'incidentals',
		$author$project$Compensation$Money$euroCentDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'inserts',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'orders',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Payment$Payment$SummaryTotals)))));
var $author$project$Payment$Payment$summaryDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
	_List_fromArray(
		['summary', 'groups']),
	$elm$json$Json$Decode$list($author$project$Payment$Payment$groupDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['summary', 'totals']),
		$author$project$Payment$Payment$summaryTotalsDecoder,
		$elm$json$Json$Decode$succeed($author$project$Payment$Payment$Summary)));
var $author$project$Payment$Payment$slipDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (version) {
		if (version.$ === 1) {
			return A2($elm$json$Json$Decode$map, $author$project$Payment$Payment$Version2021, $author$project$Payment$Payment$decoder);
		} else {
			switch (version.a) {
				case 'v2023':
					return A3($elm$json$Json$Decode$map2, $author$project$Payment$Payment$Version2023, $author$project$Payment$Payment$decoder, $author$project$Payment$Payment$summaryDecoder);
				case 'v2021':
					return A2($elm$json$Json$Decode$map, $author$project$Payment$Payment$Version2021, $author$project$Payment$Payment$decoder);
				default:
					return $elm$json$Json$Decode$fail('Invalid version');
			}
		}
	},
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'version', $elm$json$Json$Decode$string)));
var $author$project$Payment$Payment$loadCmd = F3(
	function (token, _v0, toMsg) {
		var year = _v0.kC;
		var period = _v0.jv;
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'payments',
					$elm$core$String$fromInt(year),
					$elm$core$String$fromInt(period)
				]),
			_List_Nil);
		return A4($author$project$Api$Request$get, token, toMsg, uri, $author$project$Payment$Payment$slipDecoder);
	});
var $author$project$Payment$Detail$comparableId = function (_v0) {
	var year = _v0.kC;
	var period = _v0.jv;
	return $elm$core$String$fromInt(year) + ('-' + $elm$core$String$fromInt(period));
};
var $author$project$Payment$Detail$actionIdFor = F2(
	function (id, compensationDetailId) {
		return A2($author$project$Portal$Waiting$Id, 'compensationDetail' + compensationDetailId, id);
	});
var $author$project$Payment$Detail$singleAction = F2(
	function (id, compensationDetailId) {
		return $author$project$Portal$Waiting$singleAction(
			A2($author$project$Payment$Detail$actionIdFor, id, compensationDetailId));
	});
var $author$project$Payment$Detail$loadingCompensationDetail = A2(
	$elm$core$Basics$composeR,
	$author$project$Payment$Detail$comparableId,
	$author$project$Payment$Detail$singleAction('loadingCompensationDetail'));
var $author$project$Payment$Detail$init = F2(
	function (share, id) {
		var token = $author$project$Portal$Share$token(share);
		return A2(
			$author$project$Portal$Init$withModel,
			$author$project$Payment$Detail$Loading(id),
			A3(
				$author$project$Portal$Init$withCommand,
				$author$project$Payment$Detail$loadingCompensationDetail,
				A3($author$project$Payment$Payment$loadCmd, token, id, $elm$core$Basics$identity),
				A2($author$project$Portal$Init$keyed, share, id)));
	});
var $author$project$Payment$DistributionPointOverview$BackendRespondedWagePeriods = function (a) {
	return {$: 0, a: a};
};
var $author$project$Payment$DistributionPointOverview$LoadingWagePeriods = function (a) {
	return {$: 0, a: a};
};
var $author$project$DistributionPoint$DistributionPoint$loadLatestWagePeriodsCmd = F3(
	function (token, toMsg, dpId) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'distributionpoints',
					$author$project$DistributionPoint$DistributionPoint$encodeIdForUrl(dpId),
					'payments',
					'wageperiods'
				]),
			_List_Nil);
		return A4(
			$author$project$Api$Request$get,
			token,
			toMsg,
			uri,
			$elm$json$Json$Decode$list($author$project$Compensation$WagePeriod$decoder));
	});
var $author$project$Payment$DistributionPointOverview$actionIdFor = F2(
	function (id, dpId) {
		return A2(
			$author$project$Portal$Waiting$Id,
			'payment-dp-overview-' + $author$project$DistributionPoint$DistributionPoint$comparableId(dpId),
			id);
	});
var $author$project$Payment$DistributionPointOverview$singleAction = F2(
	function (id, unique) {
		return $author$project$Portal$Waiting$singleAction(
			A2($author$project$Payment$DistributionPointOverview$actionIdFor, id, unique));
	});
var $author$project$Payment$DistributionPointOverview$loadingWagePeriods = $author$project$Payment$DistributionPointOverview$singleAction('loadingWagePeriods');
var $author$project$Payment$DistributionPointOverview$init = F2(
	function (share, dpId) {
		var token = $author$project$Portal$Share$token(share);
		return A2(
			$author$project$Portal$Init$withModel,
			$author$project$Payment$DistributionPointOverview$LoadingWagePeriods(
				{lK: dpId}),
			A3(
				$author$project$Portal$Init$withCommand,
				$author$project$Payment$DistributionPointOverview$loadingWagePeriods,
				A3($author$project$DistributionPoint$DistributionPoint$loadLatestWagePeriodsCmd, token, $author$project$Payment$DistributionPointOverview$BackendRespondedWagePeriods, dpId),
				A2($author$project$Portal$Init$keyed, share, dpId)));
	});
var $author$project$Plan$CreatePlan$BackendRespondedDistributionPoint = function (a) {
	return {$: 0, a: a};
};
var $author$project$Plan$CreatePlan$BackendRespondedPlanStatuses = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$CreatePlan$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$CreatePlan$Loading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Plan$CreatePlan$SystemGotLoaderMsg = function (a) {
	return {$: 2, a: a};
};
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0;
	return rd;
};
var $author$project$Date$Dict$toComparable = $justinmimbs$date$Date$toRataDie;
var $author$project$Date$Dict$insert = $timo_weike$generic_collections$ManualDict$insert($author$project$Date$Dict$toComparable);
var $author$project$Date$Dict$decodeDictFromTuples = function (tuples) {
	if (!tuples.b) {
		return $elm$json$Json$Decode$succeed($timo_weike$generic_collections$ManualDict$empty);
	} else {
		var _v1 = tuples.a;
		var strKey = _v1.a;
		var value = _v1.b;
		var rest = tuples.b;
		var _v2 = $justinmimbs$date$Date$fromIsoString(strKey);
		if (!_v2.$) {
			var key = _v2.a;
			return A2(
				$elm$json$Json$Decode$andThen,
				A2(
					$elm$core$Basics$composeR,
					A2($author$project$Date$Dict$insert, key, value),
					$elm$json$Json$Decode$succeed),
				$author$project$Date$Dict$decodeDictFromTuples(rest));
		} else {
			var error = _v2.a;
			return $elm$json$Json$Decode$fail(error);
		}
	}
};
var $author$project$Date$Dict$decoder = function (valueDecoder) {
	return A2(
		$elm$json$Json$Decode$andThen,
		$author$project$Date$Dict$decodeDictFromTuples,
		$elm$json$Json$Decode$keyValuePairs(valueDecoder));
};
var $author$project$Plan$Plan$Delivering = 1;
var $author$project$Plan$Plan$Draft = 0;
var $author$project$Plan$Plan$Final = 2;
var $author$project$Plan$Plan$statusDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'draft':
				return $elm$json$Json$Decode$succeed(0);
			case 'delivering':
				return $elm$json$Json$Decode$succeed(1);
			case 'exported':
				return $elm$json$Json$Decode$succeed(2);
			case 'final':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Invalid Status');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Plan$Plan$statusesDictDecoder = $author$project$Date$Dict$decoder($author$project$Plan$Plan$statusDecoder);
var $author$project$Plan$Plan$subPath = function (dpId) {
	return _List_fromArray(
		[
			'distributionpoints',
			$author$project$DistributionPoint$DistributionPoint$encodeIdForUrl(dpId),
			'plans'
		]);
};
var $author$project$Plan$Plan$loadStatusesCmd = F4(
	function (token, toMsg, dpId, _v0) {
		var start = _v0.hq;
		var end = _v0.gu;
		var uri = A2(
			$author$project$Api$Uri$for,
			$author$project$Plan$Plan$subPath(dpId),
			_List_fromArray(
				[
					A2(
					$elm$url$Url$Builder$string,
					'start',
					$author$project$Date$DeliveryDate$encodeForUrl(start)),
					A2(
					$elm$url$Url$Builder$string,
					'end',
					$author$project$Date$DeliveryDate$encodeForUrl(end))
				]));
		return A4($author$project$Api$Request$get, token, toMsg, uri, $author$project$Plan$Plan$statusesDictDecoder);
	});
var $justinmimbs$date$Date$max = F2(
	function (dateA, dateB) {
		var a = dateA;
		var b = dateB;
		return (_Utils_cmp(a, b) < 0) ? dateB : dateA;
	});
var $author$project$Plan$Plan$visibleRange = function (today) {
	var date = $author$project$Date$DeliveryDate$toDate(today);
	return {
		gu: $author$project$Date$DeliveryDate$fromDate(
			A2(
				$justinmimbs$date$Date$max,
				A3($justinmimbs$date$Date$fromCalendarDate, 2023, 8, 9),
				A3($justinmimbs$date$Date$add, 1, 3, date))),
		hq: $author$project$Date$DeliveryDate$fromDate(
			A3($justinmimbs$date$Date$add, 1, -2, date))
	};
};
var $author$project$Plan$Plan$loadStatusesAroundTodayCmd = F4(
	function (token, toMsg, dpId, today) {
		return A4(
			$author$project$Plan$Plan$loadStatusesCmd,
			token,
			toMsg,
			dpId,
			$author$project$Plan$Plan$visibleRange(today));
	});
var $author$project$Plan$CreatePlan$actionIdFor = F2(
	function (id, _v0) {
		var dpId = _v0.a;
		var date = _v0.b;
		return A2(
			$author$project$Portal$Waiting$Id,
			'createPlan' + ($author$project$DistributionPoint$DistributionPoint$comparableId(dpId) + $author$project$Date$DeliveryDate$view(date)),
			id);
	});
var $author$project$Plan$CreatePlan$singleAction = F2(
	function (id, unique) {
		return $author$project$Portal$Waiting$singleAction(
			A2($author$project$Plan$CreatePlan$actionIdFor, id, unique));
	});
var $author$project$Plan$CreatePlan$loadingDP = $author$project$Plan$CreatePlan$singleAction('loadingDP');
var $author$project$Plan$CreatePlan$loadingPlan = F2(
	function (key, stage) {
		return A2($author$project$Plan$CreatePlan$singleAction, 'loadingPlan' + stage, key);
	});
var $author$project$Plan$CreatePlan$loadingStatuses = $author$project$Plan$CreatePlan$singleAction('loadingStatuses');
var $author$project$Plan$CreatePlan$shareDataFromModel = function (model) {
	return function () {
		var _v1 = $author$project$Plan$PlanLoader$loadedOf(model.fB);
		if (!_v1.$) {
			var plan = _v1.a.fA;
			var deliverers = _v1.a.e4;
			return A2(
				$elm$core$Basics$composeR,
				$author$project$Portal$ShareData$withTypedDeliverers(deliverers),
				$author$project$Portal$ShareData$withPlan(plan));
		} else {
			return $author$project$Portal$ShareData$noChange;
		}
	}()(
		function () {
			var _v0 = model.bn;
			if (_v0.$ === 1) {
				var distributionPoint = _v0.a;
				return $author$project$Portal$ShareData$withDistributionPoint(distributionPoint);
			} else {
				return $author$project$Portal$ShareData$noChange;
			}
		}()(
			$author$project$Portal$ShareData$empty(model.aE)));
};
var $author$project$Plan$CreatePlan$init = F3(
	function (share, dpId, currentPlanDate) {
		var token = $author$project$Portal$Share$token(share);
		return A2(
			$author$project$Portal$Return$ensureDataShared,
			$author$project$Plan$CreatePlan$shareDataFromModel,
			A2(
				$author$project$Portal$Init$withModelFromData,
				function (shareData) {
					return {
						r: $author$project$Portal$Subheader$initCalendarState,
						aE: currentPlanDate,
						bn: A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$author$project$Plan$CreatePlan$Loading(dpId),
							$author$project$Plan$CreatePlan$Loaded,
							shareData.bn),
						ck: $author$project$Plan$CreatePlan$Loading(0),
						fB: A4($author$project$Plan$PlanLoader$initModel, share, $elm$core$Basics$identity, dpId, currentPlanDate),
						dx: $author$project$Date$DeliveryDate$toDate(currentPlanDate)
					};
				},
				A5(
					$author$project$Portal$Init$withPlanLoader,
					$author$project$Plan$CreatePlan$loadingPlan,
					dpId,
					currentPlanDate,
					$author$project$Plan$CreatePlan$SystemGotLoaderMsg,
					A3(
						$author$project$Portal$Init$withCommand,
						$author$project$Plan$CreatePlan$loadingStatuses,
						A4(
							$author$project$Plan$Plan$loadStatusesAroundTodayCmd,
							token,
							$author$project$Plan$CreatePlan$BackendRespondedPlanStatuses,
							dpId,
							$author$project$Portal$Share$today(share)),
						A4(
							$author$project$Portal$Init$ifNothing,
							function ($) {
								return $.bn;
							},
							$author$project$Plan$CreatePlan$loadingDP,
							A4($author$project$DistributionPoint$DistributionPoint$loadCmd, token, $author$project$Plan$CreatePlan$BackendRespondedDistributionPoint, dpId, currentPlanDate),
							A2(
								$author$project$Portal$Init$keyed,
								share,
								_Utils_Tuple2(dpId, currentPlanDate)))))));
	});
var $author$project$Plan$DayPlanning$DistributionPointLoaded = function (a) {
	return {$: 6, a: a};
};
var $author$project$Plan$DayPlanning$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$DayPlanning$Loading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Plan$DayPlanning$NoPopup = {$: 0};
var $author$project$Plan$DayPlanning$OrdersLoaded = function (a) {
	return {$: 7, a: a};
};
var $author$project$Plan$DayPlanning$SystemGotLoaderMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$DayPlanning$SystemGotSubDpPlanStatus = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Plan$Plan$NotFound = function (a) {
	return {$: 0, a: a};
};
var $author$project$Plan$Plan$StatusHttpError = function (a) {
	return {$: 1, a: a};
};
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $author$project$Plan$Plan$distributionPointIdOfStatusUrl = function (url) {
	var statusParser = A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$string,
		A2(
			$elm$url$Url$Parser$slash,
			$elm$url$Url$Parser$s('distributionpoints'),
			A2(
				$elm$url$Url$Parser$slash,
				$author$project$Api$UrlParser$dpId,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('plans'),
					A2(
						$elm$url$Url$Parser$slash,
						$author$project$Api$UrlParser$date,
						$elm$url$Url$Parser$s('status'))))));
	return A2(
		$elm$core$Maybe$andThen,
		$elm$url$Url$Parser$parse(
			A2(
				$elm$url$Url$Parser$map,
				F3(
					function (_v0, dpId, _v1) {
						return dpId;
					}),
				statusParser)),
		$elm$url$Url$fromString(url));
};
var $author$project$Api$Request$getWithCustomError = F5(
	function (token, toMsg, toError, url, tracker) {
		return $elm$http$Http$request(
			{
				aA: $elm$http$Http$emptyBody,
				aJ: A2($elm$http$Http$expectStringResponse, toMsg, toError),
				aK: $author$project$Api$Request$headers(token),
				aO: 'GET',
				aS: $elm$core$Maybe$Nothing,
				aU: $author$project$Api$Request$trackingFor(tracker),
				aW: url
			});
	});
var $author$project$Plan$Plan$planStatusDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$author$project$Plan$Plan$statusDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'distributionPoint',
		$author$project$DistributionPoint$DistributionPoint$idDecoder,
		$elm$json$Json$Decode$succeed(
			F2(
				function (id, status) {
					return _Utils_Tuple2(id, status);
				}))));
var $author$project$Plan$Plan$subPathWithDateAndSuffix = F3(
	function (dpId, date, suffix) {
		return A2(
			$elm$core$List$cons,
			'distributionpoints',
			A2(
				$elm$core$List$cons,
				$author$project$DistributionPoint$DistributionPoint$encodeIdForUrl(dpId),
				A2(
					$elm$core$List$cons,
					'plans',
					A2(
						$elm$core$List$cons,
						$author$project$Date$DeliveryDate$encodeForUrl(date),
						_List_fromArray(
							[suffix])))));
	});
var $author$project$Plan$Plan$loadStatusCmd = F4(
	function (token, toMsg, date, dpId) {
		var uri = A2(
			$author$project$Api$Uri$for,
			A3($author$project$Plan$Plan$subPathWithDateAndSuffix, dpId, date, 'status'),
			_List_Nil);
		var toError = function (response) {
			switch (response.$) {
				case 0:
					var url = response.a;
					return $elm$core$Result$Err(
						$author$project$Plan$Plan$StatusHttpError(
							$elm$http$Http$BadUrl(url)));
				case 1:
					return $elm$core$Result$Err(
						$author$project$Plan$Plan$StatusHttpError($elm$http$Http$Timeout));
				case 2:
					return $elm$core$Result$Err(
						$author$project$Plan$Plan$StatusHttpError($elm$http$Http$NetworkError));
				case 3:
					var metadata = response.a;
					return $elm$core$Result$Err(
						function () {
							var _v1 = metadata.kf;
							if (_v1 === 404) {
								var _v2 = $author$project$Plan$Plan$distributionPointIdOfStatusUrl(metadata.aW);
								if (!_v2.$) {
									var i = _v2.a;
									return $author$project$Plan$Plan$NotFound(i);
								} else {
									return $author$project$Plan$Plan$StatusHttpError(
										$elm$http$Http$BadBody('could not recognize url'));
								}
							} else {
								return $author$project$Plan$Plan$StatusHttpError(
									$elm$http$Http$BadStatus(metadata.kf));
							}
						}());
				default:
					var b = response.b;
					var _v3 = A2($elm$json$Json$Decode$decodeString, $author$project$Plan$Plan$planStatusDecoder, b);
					if (!_v3.$) {
						var p = _v3.a;
						return $elm$core$Result$Ok(p);
					} else {
						var err = _v3.a;
						return $elm$core$Result$Err(
							$author$project$Plan$Plan$StatusHttpError(
								$elm$http$Http$BadBody(
									$elm$json$Json$Decode$errorToString(err))));
					}
			}
		};
		return A4($author$project$Api$Request$getWithCustomError, token, toMsg, toError, uri);
	});
var $author$project$Plan$DayPlanning$cmdToLoadSubDPStatus = F4(
	function (token, deliveryDate, subDistributionPoint, index) {
		return A4(
			$author$project$Plan$Plan$loadStatusCmd,
			token,
			$author$project$Plan$DayPlanning$SystemGotSubDpPlanStatus(index),
			deliveryDate,
			$author$project$DistributionPoint$DistributionPoint$idOf(subDistributionPoint));
	});
var $author$project$Plan$DayPlanning$convert = function (_v0) {
	var deliverers = _v0.e4;
	var plan = _v0.fA;
	return {e4: deliverers, fA: plan};
};
var $author$project$UI$Util$Minimized = 0;
var $author$project$Plan$DayPlanning$Supply$MinimizedDetail = {$: 0};
var $author$project$Plan$Selection$NoDeliverer = {$: 0};
var $author$project$Plan$DayPlanning$Supply$None = {$: 0};
var $author$project$Deliverer$IdDict$empty = $timo_weike$generic_collections$ManualDict$empty;
var $author$project$UI$Util$Maximized = 1;
var $pzp1997$assoc_list$AssocList$get = F2(
	function (targetKey, _v0) {
		get:
		while (true) {
			var alist = _v0;
			if (!alist.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v2 = alist.a;
				var key = _v2.a;
				var value = _v2.b;
				var rest = alist.b;
				if (_Utils_eq(key, targetKey)) {
					return $elm$core$Maybe$Just(value);
				} else {
					var $temp$targetKey = targetKey,
						$temp$_v0 = rest;
					targetKey = $temp$targetKey;
					_v0 = $temp$_v0;
					continue get;
				}
			}
		}
	});
var $pzp1997$assoc_list$AssocList$member = F2(
	function (targetKey, dict) {
		var _v0 = A2($pzp1997$assoc_list$AssocList$get, targetKey, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $pzp1997$assoc_list$AssocList$diff = F2(
	function (_v0, rightDict) {
		var leftAlist = _v0;
		return A2(
			$elm$core$List$filter,
			function (_v1) {
				var key = _v1.a;
				return !A2($pzp1997$assoc_list$AssocList$member, key, rightDict);
			},
			leftAlist);
	});
var $Gizra$elm_all_set$EverySet$diff = F2(
	function (_v0, _v1) {
		var d1 = _v0;
		var d2 = _v1;
		return A2($pzp1997$assoc_list$AssocList$diff, d1, d2);
	});
var $author$project$Plan$Plan$deliverersNotInPlan = F2(
	function (plan, deliverersById) {
		return A2(
			$Gizra$elm_all_set$EverySet$diff,
			$Gizra$elm_all_set$EverySet$fromList(
				$author$project$Deliverer$IdDict$values(deliverersById)),
			$Gizra$elm_all_set$EverySet$fromList(
				A2(
					$elm$core$List$filterMap,
					$author$project$Plan$Supply$delivererOf,
					$author$project$Plan$Supply$flatten(plan.gL))));
	});
var $pzp1997$assoc_list$AssocList$filter = F2(
	function (isGood, _v0) {
		var alist = _v0;
		return A2(
			$elm$core$List$filter,
			function (_v1) {
				var key = _v1.a;
				var value = _v1.b;
				return A2(isGood, key, value);
			},
			alist);
	});
var $Gizra$elm_all_set$EverySet$filter = F2(
	function (p, _v0) {
		var d = _v0;
		return A2(
			$pzp1997$assoc_list$AssocList$filter,
			F2(
				function (k, _v1) {
					return p(k);
				}),
			d);
	});
var $pzp1997$assoc_list$AssocList$size = function (_v0) {
	var alist = _v0;
	return $elm$core$List$length(alist);
};
var $Gizra$elm_all_set$EverySet$size = function (_v0) {
	var d = _v0;
	return $pzp1997$assoc_list$AssocList$size(d);
};
var $author$project$Plan$DayPlanning$Supply$ensureMaximizedWhenUnregisteredReserve = F3(
	function (plan, deliverers, model) {
		var onlyUnregistered = function (typedDeliverer) {
			if (typedDeliverer.$ === 2) {
				return true;
			} else {
				return false;
			}
		};
		var numberOfUnregisteredReserve = $Gizra$elm_all_set$EverySet$size(
			A2(
				$Gizra$elm_all_set$EverySet$filter,
				onlyUnregistered,
				A2($author$project$Plan$Plan$deliverersNotInPlan, plan, deliverers)));
		if (!numberOfUnregisteredReserve) {
			return model;
		} else {
			return _Utils_update(
				model,
				{dt: 1});
		}
	});
var $author$project$Plan$DayPlanning$Supply$init = function (planAndDeliverers) {
	var model = {lD: $author$project$Plan$DayPlanning$Supply$MinimizedDetail, C: $author$project$Plan$DayPlanning$Supply$NotDragging, dt: 0, cA: 0, nI: $author$project$Plan$Selection$NoDeliverer, bz: $author$project$Deliverer$IdDict$empty, ax: $author$project$Plan$DayPlanning$Supply$None};
	if (!planAndDeliverers.$) {
		var plan = planAndDeliverers.a.fA;
		var deliverers = planAndDeliverers.a.e4;
		return A3($author$project$Plan$DayPlanning$Supply$ensureMaximizedWhenUnregisteredReserve, plan, deliverers, model);
	} else {
		return model;
	}
};
var $author$project$Plan$DayPlanning$actionIdFor = F2(
	function (id, _v0) {
		var dpId = _v0.a;
		var date = _v0.b;
		return A2(
			$author$project$Portal$Waiting$Id,
			'dayPlanning' + ($author$project$DistributionPoint$DistributionPoint$comparableId(dpId) + $author$project$Date$DeliveryDate$view(date)),
			id);
	});
var $author$project$Plan$DayPlanning$singleAction = F2(
	function (id, unique) {
		return $author$project$Portal$Waiting$singleAction(
			A2($author$project$Plan$DayPlanning$actionIdFor, id, unique));
	});
var $author$project$Plan$DayPlanning$loadingDP = $author$project$Plan$DayPlanning$singleAction('loadingDP');
var $author$project$Plan$DayPlanning$loadingOrders = $author$project$Plan$DayPlanning$singleAction('loadingOrders');
var $author$project$Plan$DayPlanning$loadingPlan = F2(
	function (key, stage) {
		return A2($author$project$Plan$DayPlanning$singleAction, 'loadingPlan' + stage, key);
	});
var $author$project$Plan$DayPlanning$loadingSubDPStatuses = F2(
	function (key, index) {
		return A2(
			$author$project$Plan$DayPlanning$singleAction,
			'loadingSubDPStatuses' + $elm$core$String$fromInt(index),
			key);
	});
var $author$project$Plan$DayPlanning$shareDataFromModel = function (model) {
	return function () {
		var _v2 = model.Y;
		if (_v2.$ === 1) {
			var orders = _v2.a;
			return $author$project$Portal$ShareData$withOrders(orders);
		} else {
			return $author$project$Portal$ShareData$noChange;
		}
	}()(
		function () {
			var _v1 = $author$project$Plan$PlanLoader$loadedOf(model.fB);
			if (!_v1.$) {
				var plan = _v1.a.fA;
				var deliverers = _v1.a.e4;
				return A2(
					$elm$core$Basics$composeR,
					$author$project$Portal$ShareData$withTypedDeliverers(deliverers),
					$author$project$Portal$ShareData$withPlan(plan));
			} else {
				return $author$project$Portal$ShareData$noChange;
			}
		}()(
			function () {
				var _v0 = model.bn;
				if (_v0.$ === 1) {
					var distributionPoint = _v0.a;
					return $author$project$Portal$ShareData$withDistributionPoint(distributionPoint);
				} else {
					return $author$project$Portal$ShareData$noChange;
				}
			}()(
				$author$project$Portal$ShareData$empty(model.lx))));
};
var $author$project$Plan$DayPlanning$init = F3(
	function (share, dpId, date) {
		var token = $author$project$Portal$Share$token(share);
		return A2(
			$author$project$Portal$Return$ensureDataShared,
			$author$project$Plan$DayPlanning$shareDataFromModel,
			A2(
				$author$project$Portal$Init$withModelFromData,
				function (shareData) {
					return {
						r: $author$project$Portal$Subheader$initCalendarState,
						lx: date,
						bn: A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$author$project$Plan$DayPlanning$Loading(dpId),
							$author$project$Plan$DayPlanning$Loaded,
							shareData.bn),
						dc: $elm$core$Maybe$Nothing,
						de: $elm$core$Maybe$Nothing,
						Y: A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$author$project$Plan$DayPlanning$Loading(dpId),
							$author$project$Plan$DayPlanning$Loaded,
							shareData.Y),
						fB: A4($author$project$Plan$PlanLoader$initModel, share, $author$project$Plan$DayPlanning$convert, dpId, date),
						b_: $author$project$Plan$DayPlanning$NoPopup,
						cJ: $author$project$DistributionPoint$IdDict$empty,
						z: $author$project$Plan$DayPlanning$Supply$init($elm$core$Maybe$Nothing)
					};
				},
				A4(
					$author$project$Portal$Init$ifNothing,
					function ($) {
						return $.Y;
					},
					$author$project$Plan$DayPlanning$loadingOrders,
					A4($author$project$Demand$Demand$loadOrdersCmd, token, $author$project$Plan$DayPlanning$OrdersLoaded, dpId, date),
					A5(
						$author$project$Portal$Init$withPlanLoader,
						$author$project$Plan$DayPlanning$loadingPlan,
						dpId,
						date,
						$author$project$Plan$DayPlanning$SystemGotLoaderMsg,
						A4(
							$author$project$Portal$Init$multiIfJust,
							function ($) {
								return $.bn;
							},
							$author$project$Plan$DayPlanning$loadingSubDPStatuses,
							A2(
								$elm$core$Basics$composeR,
								$author$project$DistributionPoint$DistributionPoint$getSubDistributionPoints,
								$elm$core$List$map(
									function (dp) {
										return A3($author$project$Plan$DayPlanning$cmdToLoadSubDPStatus, token, date, dp);
									})),
							A4(
								$author$project$Portal$Init$ifNothing,
								function ($) {
									return $.bn;
								},
								$author$project$Plan$DayPlanning$loadingDP,
								A4($author$project$DistributionPoint$DistributionPoint$loadCmd, token, $author$project$Plan$DayPlanning$DistributionPointLoaded, dpId, date),
								A2(
									$author$project$Portal$Init$keyed,
									share,
									_Utils_Tuple2(dpId, date))))))));
	});
var $author$project$Plan$NotFinalized$BackendRespondedDistributionPoints = function (a) {
	return {$: 2, a: a};
};
var $author$project$Plan$NotFinalized$Idle = {$: 3};
var $author$project$Plan$NotFinalized$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$NotFinalized$Loading = {$: 0};
var $author$project$Plan$NotFinalized$emptyForm = {gu: '', hq: '', f_: _List_Nil};
var $author$project$Plan$NotFinalized$actionIdFor = function (id) {
	return A2($author$project$Portal$Waiting$Id, 'notFinalized', id);
};
var $author$project$Plan$NotFinalized$singleAction = F2(
	function (id, _v0) {
		return $author$project$Portal$Waiting$singleAction(
			$author$project$Plan$NotFinalized$actionIdFor(id));
	});
var $author$project$Plan$NotFinalized$loadingDPs = $author$project$Plan$NotFinalized$singleAction('loadingDPs');
var $author$project$Plan$NotFinalized$init = function (share) {
	var token = $author$project$Portal$Share$token(share);
	return A2(
		$author$project$Portal$Init$withModelFromData,
		function (shareData) {
			return {
				A: A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$Plan$NotFinalized$Loading, $author$project$Plan$NotFinalized$Loaded, shareData.A),
				cs: $author$project$Plan$NotFinalized$Idle,
				aj: $author$project$Plan$NotFinalized$emptyForm
			};
		},
		A4(
			$author$project$Portal$Init$ifNothing,
			function ($) {
				return $.A;
			},
			$author$project$Plan$NotFinalized$loadingDPs,
			A3(
				$author$project$DistributionPoint$DistributionPoint$loadNamesAndRegions,
				token,
				$author$project$Plan$NotFinalized$BackendRespondedDistributionPoints,
				$author$project$Portal$Share$today(share)),
			$author$project$Portal$Init$empty(share)));
};
var $author$project$Publications$ClosingCalendar$NoneSelected = {$: 0};
var $author$project$Publications$ClosingCalendar$NotEditing = {$: 0};
var $author$project$Publications$ClosingCalendar$init = function (share) {
	return A2(
		$author$project$Portal$Init$withModel,
		{bM: _List_Nil, P: $author$project$Publications$ClosingCalendar$NotEditing, nI: $author$project$Publications$ClosingCalendar$NoneSelected},
		$author$project$Portal$Init$empty(share));
};
var $author$project$Publications$Publications$Loading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Publications$Publications$SystemGotPublications = function (a) {
	return {$: 5, a: a};
};
var $author$project$Publications$Publications$Publication = F6(
	function (title, updatesIn, status, statistics, statisticsPerEdition, files) {
		return {fa: files, kd: statistics, ke: statisticsPerEdition, nS: status, oi: title, eD: updatesIn};
	});
var $author$project$Publications$Publications$File = F2(
	function (fileType, downloadedOn) {
		return {gp: downloadedOn, c9: fileType};
	});
var $author$project$Publications$Publications$NotDownloaded = {$: 0};
var $author$project$Publications$Publications$Downloaded = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$round = _Basics_round;
var $elm$core$String$toFloat = _String_toFloat;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (!_v0.$) {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$core$String$append = _String_append;
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (!_v0.$) {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
										$elm$parser$Parser$succeed(0)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $elm_community$json_extra$Json$Decode$Extra$datetime = A2(
	$elm$json$Json$Decode$andThen,
	function (dateString) {
		var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(dateString);
		if (!_v0.$) {
			var v = _v0.a;
			return $elm$json$Json$Decode$succeed(v);
		} else {
			return $elm$json$Json$Decode$fail('Expecting an ISO-8601 formatted date+time string');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Publications$Publications$downloadStatusDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $author$project$Publications$Publications$Downloaded, $elm$json$Json$Decode$succeed),
	$elm_community$json_extra$Json$Decode$Extra$datetime);
var $author$project$Publications$Publications$BD = 6;
var $author$project$Publications$Publications$BPost = 2;
var $author$project$Publications$Publications$DI = 4;
var $author$project$Publications$Publications$HF = 0;
var $author$project$Publications$Publications$LF = 1;
var $author$project$Publications$Publications$Oplage = 7;
var $author$project$Publications$Publications$PPP = 3;
var $author$project$Publications$Publications$WA = 5;
var $author$project$Publications$Publications$fileTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		switch (s) {
			case 'L':
				return $elm$json$Json$Decode$succeed(1);
			case 'H':
				return $elm$json$Json$Decode$succeed(0);
			case 'AM':
				return $elm$json$Json$Decode$succeed(2);
			case 'DI':
				return $elm$json$Json$Decode$succeed(4);
			case 'PPP':
				return $elm$json$Json$Decode$succeed(3);
			case 'WA':
				return $elm$json$Json$Decode$succeed(5);
			case 'BL':
				return $elm$json$Json$Decode$succeed(6);
			case 'Oplage':
				return $elm$json$Json$Decode$succeed(7);
			default:
				return $elm$json$Json$Decode$fail('unrecognized file type');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Publications$Publications$fileDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'downloadedOn',
	$author$project$Publications$Publications$downloadStatusDecoder,
	$author$project$Publications$Publications$NotDownloaded,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'fileType',
		$author$project$Publications$Publications$fileTypeDecoder,
		$elm$json$Json$Decode$succeed($author$project$Publications$Publications$File)));
var $author$project$Publications$Publications$Statistics = F5(
	function (starts, stops, mutations, orders, prints) {
		return {jk: mutations, Y: orders, jG: prints, kb: starts, nW: stops};
	});
var $author$project$Publications$Publications$statisticsDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'prints',
	$elm$json$Json$Decode$int,
	0,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'orders',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'mutations',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'stops',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'starts',
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed($author$project$Publications$Publications$Statistics))))));
var $author$project$Publications$Publications$statisticsPerEditionDecoder = $elm$json$Json$Decode$dict($author$project$Publications$Publications$statisticsDecoder);
var $author$project$Publications$Publications$Complete = 1;
var $author$project$Publications$Publications$Expected = 0;
var $author$project$Publications$Publications$Late = 2;
var $author$project$Publications$Publications$VeryLate = 3;
var $author$project$Publications$Publications$statusFromString = function (string) {
	switch (string) {
		case 'expected':
			return $elm$core$Maybe$Just(0);
		case 'complete':
			return $elm$core$Maybe$Just(1);
		case 'late':
			return $elm$core$Maybe$Just(2);
		case 'veryLate':
			return $elm$core$Maybe$Just(3);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Publications$Publications$statusDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (status) {
		var _v0 = $author$project$Publications$Publications$statusFromString(status);
		if (!_v0.$) {
			var s = _v0.a;
			return $elm$json$Json$Decode$succeed(s);
		} else {
			return $elm$json$Json$Decode$fail('Unknown status');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Publications$Publications$PublishingTitle = F3(
	function (name, abbreviation, editions) {
		return {cU: abbreviation, it: editions, ft: name};
	});
var $author$project$Publications$Publications$titleDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'editions',
	$elm$json$Json$Decode$list(
		A2($elm$json$Json$Decode$field, 'abbreviation', $elm$json$Json$Decode$string)),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'abbreviation',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Publications$Publications$PublishingTitle))));
var $author$project$Publications$Publications$updatesInDecoder = $elm_community$json_extra$Json$Decode$Extra$datetime;
var $author$project$Publications$Publications$publicationDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'files',
	$elm$json$Json$Decode$list($author$project$Publications$Publications$fileDecoder),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'statisticsPerEdition',
		$author$project$Publications$Publications$statisticsPerEditionDecoder,
		$elm$core$Dict$empty,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'statistics',
			$author$project$Publications$Publications$statisticsDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				$author$project$Publications$Publications$statusDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'updatesIn',
					$author$project$Publications$Publications$updatesInDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'title',
						$author$project$Publications$Publications$titleDecoder,
						$elm$json$Json$Decode$succeed($author$project$Publications$Publications$Publication)))))));
var $author$project$Publications$Publications$loadCmd = F3(
	function (token, toMsg, date) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'publication-info',
					$author$project$Date$DeliveryDate$encodeForUrl(date)
				]),
			_List_Nil);
		return A4(
			$author$project$Api$Request$get,
			token,
			toMsg,
			uri,
			$elm$json$Json$Decode$list($author$project$Publications$Publications$publicationDecoder));
	});
var $author$project$Publications$Publications$actionIdFor = F2(
	function (id, date) {
		return A2(
			$author$project$Portal$Waiting$Id,
			'Publications' + $author$project$Date$DeliveryDate$oldestFirst(date),
			id);
	});
var $author$project$Publications$Publications$singleAction = F2(
	function (id, unique) {
		return $author$project$Portal$Waiting$singleAction(
			A2($author$project$Publications$Publications$actionIdFor, id, unique));
	});
var $author$project$Publications$Publications$loadingPublications = $author$project$Publications$Publications$singleAction('loadingPublications');
var $author$project$Publications$Publications$init = F2(
	function (share, date) {
		var token = $author$project$Portal$Share$token(share);
		return A2(
			$author$project$Portal$Init$withModel,
			$author$project$Publications$Publications$Loading(
				{
					r: $author$project$Portal$Subheader$initCalendarState,
					t: date,
					aj: {dC: ''}
				}),
			A3(
				$author$project$Portal$Init$withCommand,
				$author$project$Publications$Publications$loadingPublications,
				A3($author$project$Publications$Publications$loadCmd, token, $author$project$Publications$Publications$SystemGotPublications, date),
				A2($author$project$Portal$Init$keyed, share, date)));
	});
var $author$project$Report$Report$Unavailable = {$: 1};
var $author$project$Report$Report$init = function (share) {
	return A2(
		$author$project$Portal$Init$withModel,
		{
			dY: $author$project$Report$Report$Unavailable,
			ea: $author$project$Report$Report$Unavailable,
			bO: {eE: '', eF: '', f_: _List_Nil},
			ew: $author$project$Report$Report$Unavailable
		},
		$author$project$Portal$Init$empty(share));
};
var $author$project$Sequence$Plan$DistributionPointLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Sequence$Plan$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Sequence$Plan$Loading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Sequence$Plan$OrdersLoaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Sequence$Plan$SystemGotLoaderMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Sequence$Plan$Unique = F4(
	function (distributionPointId, date, delivererId, clusterId) {
		return {ll: clusterId, lx: date, lA: delivererId, c2: distributionPointId};
	});
var $author$project$Portal$Init$ifNothingInBackground = F3(
	function (accessor, cmd, model) {
		var _v0 = accessor(
			$author$project$Portal$Init$data(model));
		if (!_v0.$) {
			return model;
		} else {
			return A2($author$project$Portal$Init$addUntrackedCommand, cmd, model);
		}
	});
var $author$project$Sequence$Plan$SequenceLoaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Sequence$Plan$loadSingleSequenceCmdMsg = F5(
	function (token, date, delivererId, clusterId, items) {
		return A3(
			$author$project$Sequence$Sequence$loadSequencesCmd,
			token,
			$author$project$Sequence$Plan$SequenceLoaded,
			_List_fromArray(
				[
					_Utils_Tuple3(
					date,
					delivererId,
					A2(
						$elm$core$List$concatMap,
						function ($) {
							return $.bb;
						},
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.bX;
								},
								$elm$core$Basics$eq(clusterId)),
							A2(
								$elm$core$List$concatMap,
								$author$project$Plan$Supply$ownClustersOf,
								A2($author$project$Plan$Supply$findByDeliverer, delivererId, items)))))
				]));
	});
var $author$project$Cluster$Number$print = function (_v0) {
	var clusterId = _v0;
	return $elm$core$String$fromInt(clusterId);
};
var $author$project$Cluster$Number$comparable = $author$project$Cluster$Number$print;
var $author$project$Sequence$Plan$actionIdFor = F2(
	function (id, unique) {
		return A2(
			$author$project$Portal$Waiting$Id,
			'sequence' + ($author$project$DistributionPoint$DistributionPoint$comparableId(unique.c2) + ($author$project$Date$DeliveryDate$view(unique.lx) + ($author$project$Deliverer$Deliverer$comparableId(unique.lA) + $author$project$Cluster$Number$comparable(unique.ll)))),
			id);
	});
var $author$project$Sequence$Plan$singleAction = F2(
	function (id, unique) {
		return $author$project$Portal$Waiting$singleAction(
			A2($author$project$Sequence$Plan$actionIdFor, id, unique));
	});
var $author$project$Sequence$Plan$loadingDP = $author$project$Sequence$Plan$singleAction('loadingDP');
var $author$project$Sequence$Plan$loadingPlan = F2(
	function (key, stage) {
		return A2($author$project$Sequence$Plan$singleAction, 'loadingPlan' + stage, key);
	});
var $author$project$Sequence$Plan$loadingSequence = $author$project$Sequence$Plan$singleAction('loadingPlan');
var $author$project$Sequence$Plan$init = F5(
	function (share, dpId, date, delivererId, clusterId) {
		var token = $author$project$Portal$Share$token(share);
		var planAndDeliverers = A4($author$project$Plan$PlanLoader$initModel, share, $elm$core$Basics$identity, dpId, date);
		return A2(
			$author$project$Portal$Init$withModelFromData,
			function (shareData) {
				return {
					dU: clusterId,
					lx: date,
					lD: $author$project$Sequence$Plan$Loading(delivererId),
					bn: A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						$author$project$Sequence$Plan$Loading(dpId),
						$author$project$Sequence$Plan$Loaded,
						shareData.bn),
					Y: A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						$author$project$Sequence$Plan$Loading(
							_Utils_Tuple2(dpId, date)),
						$author$project$Sequence$Plan$Loaded,
						shareData.Y),
					fB: planAndDeliverers
				};
			},
			function () {
				var _v0 = $author$project$Plan$PlanLoader$loadedOf(planAndDeliverers);
				if (!_v0.$) {
					var p = _v0.a;
					return A2(
						$author$project$Portal$Init$withCommand,
						$author$project$Sequence$Plan$loadingSequence,
						A5($author$project$Sequence$Plan$loadSingleSequenceCmdMsg, token, date, delivererId, clusterId, p.fA.gL));
				} else {
					return $elm$core$Basics$identity;
				}
			}()(
				A3(
					$author$project$Portal$Init$ifNothingInBackground,
					function ($) {
						return $.Y;
					},
					A4($author$project$Demand$Demand$loadOrdersCmd, token, $author$project$Sequence$Plan$OrdersLoaded, dpId, date),
					A5(
						$author$project$Portal$Init$withPlanLoader,
						$author$project$Sequence$Plan$loadingPlan,
						dpId,
						date,
						$author$project$Sequence$Plan$SystemGotLoaderMsg,
						A4(
							$author$project$Portal$Init$ifNothing,
							function ($) {
								return $.bn;
							},
							$author$project$Sequence$Plan$loadingDP,
							A4($author$project$DistributionPoint$DistributionPoint$loadCmd, token, $author$project$Sequence$Plan$DistributionPointLoaded, dpId, date),
							A2(
								$author$project$Portal$Init$keyed,
								share,
								A4($author$project$Sequence$Plan$Unique, dpId, date, delivererId, clusterId)))))));
	});
var $author$project$Main$map = F4(
	function (model, toMsg, toPage, _v0) {
		var s = _v0.a;
		var p = _v0.b;
		var msg = _v0.c;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					cv: toPage(p),
					fQ: s
				}),
			A2($elm$core$Platform$Cmd$map, toMsg, msg));
	});
var $author$project$Lists$RouteDetail$Route$routeViewToString = function (routeView) {
	switch (routeView) {
		case 0:
			return 'aggregated';
		case 3:
			return 'mutations';
		case 4:
			return 'complaints';
		case 1:
			return 'orders';
		default:
			return 'orders';
	}
};
var $author$project$Portal$Route$toStrings = F3(
	function (dpId, date, suffixes) {
		return A2(
			$elm$core$List$cons,
			$author$project$DistributionPoint$DistributionPoint$encodeIdForUrl(dpId),
			A2(
				$elm$core$List$cons,
				$author$project$Date$DeliveryDate$encodeForUrl(date),
				suffixes));
	});
var $author$project$Portal$Route$toString = function (route) {
	var pieces = function () {
		switch (route.$) {
			case 0:
				return _List_Nil;
			case 1:
				var date = route.a;
				return _List_fromArray(
					[
						'publications',
						$author$project$Date$DeliveryDate$encodeForUrl(date)
					]);
			case 3:
				var dpId = route.a;
				var date = route.b;
				return A3(
					$author$project$Portal$Route$toStrings,
					dpId,
					date,
					_List_fromArray(
						['create']));
			case 2:
				var dpId = route.a;
				return _List_fromArray(
					[
						$author$project$DistributionPoint$DistributionPoint$encodeIdForUrl(dpId)
					]);
			case 4:
				var dpId = route.a;
				var date = route.b;
				return A3(
					$author$project$Portal$Route$toStrings,
					dpId,
					date,
					_List_fromArray(
						['dayplanning']));
			case 5:
				return _List_fromArray(
					['plans', 'not-finalized']);
			case 6:
				var dpId = route.a;
				var date = route.b;
				return A3(
					$author$project$Portal$Route$toStrings,
					dpId,
					date,
					_List_fromArray(
						['distributionlist']));
			case 7:
				var dpId = route.a;
				var date = route.b;
				return A3(
					$author$project$Portal$Route$toStrings,
					dpId,
					date,
					_List_fromArray(
						['distributionlistb']));
			case 8:
				var dpId = route.a;
				var date = route.b;
				return A3(
					$author$project$Portal$Route$toStrings,
					dpId,
					date,
					_List_fromArray(
						['presupplylist']));
			case 9:
				var dpId = route.a;
				var date = route.b;
				return A3(
					$author$project$Portal$Route$toStrings,
					dpId,
					date,
					_List_fromArray(
						['hubpacklist']));
			case 10:
				var dpId = route.a;
				var date = route.b;
				return A3(
					$author$project$Portal$Route$toStrings,
					dpId,
					date,
					_List_fromArray(
						['receivedchecklist']));
			case 11:
				var dpId = route.a;
				var date = route.b;
				return A3(
					$author$project$Portal$Route$toStrings,
					dpId,
					date,
					_List_fromArray(
						['routedetail']));
			case 12:
				var dpId = route.a;
				var date = route.b;
				var delivererId = route.c;
				var clusterId = route.d;
				return A3(
					$author$project$Portal$Route$toStrings,
					dpId,
					date,
					_List_fromArray(
						[
							'sequencedetail',
							$author$project$Deliverer$Deliverer$encodeIdForUrl(delivererId),
							$author$project$Cluster$Number$print(clusterId)
						]));
			case 17:
				var date = route.a;
				return _List_fromArray(
					[
						'deliverer',
						$author$project$Date$DeliveryDate$encodeForUrl(date),
						'routedetail'
					]);
			case 18:
				var date = route.a;
				var cluster = route.b;
				var page = route.c;
				return _List_fromArray(
					[
						'deliverer',
						$author$project$Date$DeliveryDate$encodeForUrl(date),
						'routedetail',
						$elm$core$String$fromInt(cluster),
						$author$project$Lists$RouteDetail$Route$routeViewToString(page)
					]);
			case 13:
				var dpId = route.a;
				var date = route.b;
				return A3(
					$author$project$Portal$Route$toStrings,
					dpId,
					date,
					_List_fromArray(
						['deliverer', 'create']));
			case 14:
				var delivererId = route.a;
				return _List_fromArray(
					[
						'deliverer',
						$author$project$Deliverer$Deliverer$encodeIdForUrl(delivererId)
					]);
			case 15:
				var dpId = route.a;
				var date = route.b;
				return A3(
					$author$project$Portal$Route$toStrings,
					dpId,
					date,
					_List_fromArray(
						['count']));
			case 16:
				var dpId = route.a;
				var date = route.b;
				return A3(
					$author$project$Portal$Route$toStrings,
					dpId,
					date,
					_List_fromArray(
						['delay']));
			case 19:
				return _List_fromArray(
					['documents']);
			case 20:
				return _List_fromArray(
					['accounts']);
			case 22:
				return _List_fromArray(
					['accounts', 'add']);
			case 21:
				var id = route.a;
				return _List_fromArray(
					[
						'accounts',
						$author$project$Accounts$Account$encodeForUrl(id)
					]);
			case 23:
				return _List_fromArray(
					['messages']);
			case 24:
				return _List_fromArray(
					['compensations']);
			case 25:
				var dpId = route.a;
				var date = route.b;
				return A3(
					$author$project$Portal$Route$toStrings,
					dpId,
					date,
					_List_fromArray(
						['compensation', 'create']));
			case 26:
				var compensationId = route.a;
				return _List_fromArray(
					[
						'compensations',
						$author$project$Compensation$Compensation$encodeForUrl(compensationId)
					]);
			case 27:
				return _List_fromArray(
					['compensations', 'approve']);
			case 28:
				return _List_fromArray(
					[$author$project$Portal$Route$paymentsRoot, 'documents']);
			case 30:
				var year = route.a;
				var period = route.b;
				return _List_fromArray(
					[
						$author$project$Portal$Route$paymentsRoot,
						'details',
						$elm$core$String$fromInt(year),
						$elm$core$String$fromInt(period)
					]);
			case 31:
				var year = route.a;
				return _List_fromArray(
					[
						$author$project$Portal$Route$paymentsRoot,
						'details',
						$elm$core$String$fromInt(year)
					]);
			case 29:
				var dpId = route.a;
				return _List_fromArray(
					[
						$author$project$DistributionPoint$DistributionPoint$encodeIdForUrl(dpId),
						$author$project$Portal$Route$paymentsRoot
					]);
			case 32:
				return _List_fromArray(
					[$author$project$Portal$Route$paymentsRoot, 'archive']);
			case 33:
				return _List_fromArray(
					['applicants']);
			case 34:
				return _List_fromArray(
					['complaints', 'handle']);
			case 35:
				var date = route.a;
				return _List_fromArray(
					[
						'complaints',
						$author$project$Date$DeliveryDate$encodeForUrl(date),
						'feedback'
					]);
			case 38:
				return _List_fromArray(
					['reports']);
			case 36:
				return _List_fromArray(
					['closing-calendar']);
			case 37:
				return _List_fromArray(
					['distributor', 'validate']);
			default:
				return _List_fromArray(
					['404']);
		}
	}();
	return '#/' + A2($elm$core$String$join, '/', pieces);
};
var $author$project$Portal$Route$replaceUrl = F2(
	function (key, route) {
		return A2(
			$elm$browser$Browser$Navigation$replaceUrl,
			key,
			$author$project$Portal$Route$toString(route));
	});
var $rielas$measurement$Parameter$DocumentPath = function (a) {
	return {$: 32, a: a};
};
var $author$project$Main$GotGoogleAnalyticsMsg = function (a) {
	return {$: 7, a: a};
};
var $rielas$measurement$HitType$Pageview = 0;
var $elm$http$Http$post = function (r) {
	return $elm$http$Http$request(
		{aA: r.aA, aJ: r.aJ, aK: _List_Nil, aO: 'POST', aS: $elm$core$Maybe$Nothing, aU: $elm$core$Maybe$Nothing, aW: r.aW});
};
var $rielas$measurement$Measurement$Measured = $elm$core$Basics$identity;
var $elm$http$Http$expectBytesResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'arraybuffer',
			_Http_toDataView,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$expectWhatever = function (toMsg) {
	return A2(
		$elm$http$Http$expectBytesResponse,
		toMsg,
		$elm$http$Http$resolve(
			function (_v0) {
				return $elm$core$Result$Ok(0);
			}));
};
var $rielas$measurement$Parameter$ClientID = function (a) {
	return {$: 6, a: a};
};
var $rielas$measurement$Parameter$Hittype = function (a) {
	return {$: 28, a: a};
};
var $rielas$measurement$Parameter$ProtocolVersion = function (a) {
	return {$: 0, a: a};
};
var $rielas$measurement$Parameter$TrackingID = function (a) {
	return {$: 1, a: a};
};
var $rielas$measurement$Query$boolToInt = function (bool) {
	return bool ? 1 : 0;
};
var $elm$url$Url$Builder$int = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$core$String$fromInt(value));
	});
var $rielas$measurement$Currency$toString = function (currency) {
	var string = currency;
	return string;
};
var $rielas$measurement$Query$toString = function (hitType) {
	switch (hitType) {
		case 0:
			return 'pageview';
		case 1:
			return 'screenview';
		case 2:
			return 'event';
		case 3:
			return 'transaction';
		case 4:
			return 'item';
		case 5:
			return 'social';
		case 6:
			return 'exception';
		default:
			return 'timing';
	}
};
var $rielas$measurement$Query$toQuery = function (param) {
	switch (param.$) {
		case 0:
			var version = param.a;
			return A2($elm$url$Url$Builder$string, 'v', version);
		case 1:
			var id = param.a;
			return A2($elm$url$Url$Builder$string, 'tid', id);
		case 2:
			var anonymize = param.a;
			return A2(
				$elm$url$Url$Builder$int,
				'aip',
				$rielas$measurement$Query$boolToInt(anonymize));
		case 3:
			var source = param.a;
			return A2($elm$url$Url$Builder$string, 'ds', source);
		case 4:
			var time = param.a;
			return A2($elm$url$Url$Builder$int, 'qt', time);
		case 5:
			var cache = param.a;
			return A2($elm$url$Url$Builder$string, 'z', cache);
		case 6:
			var id = param.a;
			return A2($elm$url$Url$Builder$string, 'cid', id);
		case 7:
			var id = param.a;
			return A2($elm$url$Url$Builder$string, 'uid', id);
		case 8:
			var control = param.a;
			return A2($elm$url$Url$Builder$string, 'sc', control);
		case 9:
			var ip = param.a;
			return A2($elm$url$Url$Builder$string, 'uip', ip);
		case 10:
			var agent = param.a;
			return A2($elm$url$Url$Builder$string, 'ua', agent);
		case 11:
			var geo = param.a;
			return A2($elm$url$Url$Builder$string, 'geoid', geo);
		case 12:
			var referrer = param.a;
			return A2($elm$url$Url$Builder$string, 'dr', referrer);
		case 13:
			var name = param.a;
			return A2($elm$url$Url$Builder$string, 'cn', name);
		case 14:
			var source = param.a;
			return A2($elm$url$Url$Builder$string, 'cs', source);
		case 15:
			var medium = param.a;
			return A2($elm$url$Url$Builder$string, 'cm', medium);
		case 16:
			var keyword = param.a;
			return A2($elm$url$Url$Builder$string, 'ck', keyword);
		case 17:
			var content = param.a;
			return A2($elm$url$Url$Builder$string, 'cc', content);
		case 18:
			var id = param.a;
			return A2($elm$url$Url$Builder$string, 'ci', id);
		case 19:
			var id = param.a;
			return A2($elm$url$Url$Builder$string, 'gclid', id);
		case 20:
			var id = param.a;
			return A2($elm$url$Url$Builder$string, 'dclid', id);
		case 21:
			var resolution = param.a;
			return A2($elm$url$Url$Builder$string, 'sr', resolution);
		case 22:
			var size = param.a;
			return A2($elm$url$Url$Builder$string, 'vp', size);
		case 23:
			var encoding = param.a;
			return A2($elm$url$Url$Builder$string, 'de', encoding);
		case 24:
			var colors = param.a;
			return A2($elm$url$Url$Builder$string, 'sd', colors);
		case 25:
			var lang = param.a;
			return A2($elm$url$Url$Builder$string, 'ul', lang);
		case 26:
			var enabled = param.a;
			return A2(
				$elm$url$Url$Builder$int,
				'je',
				$rielas$measurement$Query$boolToInt(enabled));
		case 27:
			var version = param.a;
			return A2($elm$url$Url$Builder$string, 'fl', version);
		case 28:
			var type_ = param.a;
			return A2(
				$elm$url$Url$Builder$string,
				't',
				$rielas$measurement$Query$toString(type_));
		case 29:
			var hit = param.a;
			return A2(
				$elm$url$Url$Builder$int,
				'ni',
				$rielas$measurement$Query$boolToInt(hit));
		case 30:
			var url = param.a;
			return A2($elm$url$Url$Builder$string, 'dl', url);
		case 31:
			var name = param.a;
			return A2($elm$url$Url$Builder$string, 'dh', name);
		case 32:
			var path = param.a;
			return A2($elm$url$Url$Builder$string, 'dp', path);
		case 33:
			var title = param.a;
			return A2($elm$url$Url$Builder$string, 'dt', title);
		case 34:
			var name = param.a;
			return A2($elm$url$Url$Builder$string, 'cd', name);
		case 35:
			var groupIndex = param.a;
			var group = param.b;
			return A2(
				$elm$url$Url$Builder$string,
				'cg' + $elm$core$String$fromInt(groupIndex),
				group);
		case 36:
			var id = param.a;
			return A2($elm$url$Url$Builder$string, 'linkid', id);
		case 37:
			var name = param.a;
			return A2($elm$url$Url$Builder$string, 'an', name);
		case 38:
			var id = param.a;
			return A2($elm$url$Url$Builder$string, 'aid', id);
		case 39:
			var version = param.a;
			return A2($elm$url$Url$Builder$string, 'av', version);
		case 40:
			var id = param.a;
			return A2($elm$url$Url$Builder$string, 'aiid', id);
		case 41:
			var category = param.a;
			return A2($elm$url$Url$Builder$string, 'ec', category);
		case 42:
			var action = param.a;
			return A2($elm$url$Url$Builder$string, 'ea', action);
		case 43:
			var label = param.a;
			return A2($elm$url$Url$Builder$string, 'el', label);
		case 44:
			var value = param.a;
			return A2($elm$url$Url$Builder$int, 'ev', value);
		case 45:
			var id = param.a;
			return A2($elm$url$Url$Builder$string, 'ti', id);
		case 46:
			var affilation = param.a;
			return A2($elm$url$Url$Builder$string, 'ta', affilation);
		case 47:
			var revenue = param.a;
			return A2(
				$elm$url$Url$Builder$string,
				'tr',
				$rielas$measurement$Currency$toString(revenue));
		case 48:
			var shipping = param.a;
			return A2(
				$elm$url$Url$Builder$string,
				'ts',
				$rielas$measurement$Currency$toString(shipping));
		case 49:
			var tax = param.a;
			return A2(
				$elm$url$Url$Builder$string,
				'tt',
				$rielas$measurement$Currency$toString(tax));
		case 50:
			var name = param.a;
			return A2($elm$url$Url$Builder$string, 'in', name);
		case 51:
			var price = param.a;
			return A2(
				$elm$url$Url$Builder$string,
				'ip',
				$rielas$measurement$Currency$toString(price));
		case 52:
			var quantity = param.a;
			return A2($elm$url$Url$Builder$int, 'iq', quantity);
		case 53:
			var code = param.a;
			return A2($elm$url$Url$Builder$string, 'ic', code);
		case 54:
			var category = param.a;
			return A2($elm$url$Url$Builder$string, 'iv', category);
		case 55:
			var productIndex = param.a;
			var sku = param.b;
			return A2(
				$elm$url$Url$Builder$string,
				'pr' + ($elm$core$String$fromInt(productIndex) + 'id'),
				sku);
		case 56:
			var productIndex = param.a;
			var name = param.b;
			return A2(
				$elm$url$Url$Builder$string,
				'pr' + ($elm$core$String$fromInt(productIndex) + 'nm'),
				name);
		case 57:
			var productIndex = param.a;
			var brand = param.b;
			return A2(
				$elm$url$Url$Builder$string,
				'pr' + ($elm$core$String$fromInt(productIndex) + 'br'),
				brand);
		case 58:
			var productIndex = param.a;
			var category = param.b;
			return A2(
				$elm$url$Url$Builder$string,
				'pr' + ($elm$core$String$fromInt(productIndex) + 'ca'),
				category);
		case 59:
			var productIndex = param.a;
			var variant = param.b;
			return A2(
				$elm$url$Url$Builder$string,
				'pr' + ($elm$core$String$fromInt(productIndex) + 'va'),
				variant);
		case 60:
			var productIndex = param.a;
			var price = param.b;
			return A2(
				$elm$url$Url$Builder$string,
				'pr' + ($elm$core$String$fromInt(productIndex) + 'pr'),
				$rielas$measurement$Currency$toString(price));
		case 61:
			var productIndex = param.a;
			var quantity = param.b;
			return A2(
				$elm$url$Url$Builder$int,
				'pr' + ($elm$core$String$fromInt(productIndex) + 'qt'),
				quantity);
		case 62:
			var productIndex = param.a;
			var code = param.b;
			return A2(
				$elm$url$Url$Builder$string,
				'pr' + ($elm$core$String$fromInt(productIndex) + 'cc'),
				code);
		case 63:
			var productIndex = param.a;
			var position = param.b;
			return A2(
				$elm$url$Url$Builder$int,
				'pr' + ($elm$core$String$fromInt(productIndex) + 'ps'),
				position);
		case 64:
			var productIndex = param.a;
			var dimensionIndex = param.b;
			var dimension = param.c;
			return A2(
				$elm$url$Url$Builder$string,
				'pr' + ($elm$core$String$fromInt(productIndex) + ('cd' + $elm$core$String$fromInt(dimensionIndex))),
				dimension);
		case 65:
			var productIndex = param.a;
			var metricIndex = param.b;
			var metric = param.c;
			return A2(
				$elm$url$Url$Builder$int,
				'pr' + ($elm$core$String$fromInt(productIndex) + ('cm' + $elm$core$String$fromInt(metricIndex))),
				metric);
		case 66:
			var listIndex = param.a;
			var name = param.b;
			return A2(
				$elm$url$Url$Builder$string,
				'il' + ($elm$core$String$fromInt(listIndex) + 'nm'),
				name);
		case 67:
			var listIndex = param.a;
			var productIndex = param.b;
			var sku = param.c;
			return A2(
				$elm$url$Url$Builder$string,
				'il' + ($elm$core$String$fromInt(listIndex) + ('pi' + ($elm$core$String$fromInt(productIndex) + 'id'))),
				sku);
		case 68:
			var listIndex = param.a;
			var productIndex = param.b;
			var name = param.c;
			return A2(
				$elm$url$Url$Builder$string,
				'il' + ($elm$core$String$fromInt(listIndex) + ('pi' + ($elm$core$String$fromInt(productIndex) + 'nm'))),
				name);
		case 69:
			var listIndex = param.a;
			var productIndex = param.b;
			var brand = param.c;
			return A2(
				$elm$url$Url$Builder$string,
				'il' + ($elm$core$String$fromInt(listIndex) + ('pi' + ($elm$core$String$fromInt(productIndex) + 'br'))),
				brand);
		case 70:
			var listIndex = param.a;
			var productIndex = param.b;
			var category = param.c;
			return A2(
				$elm$url$Url$Builder$string,
				'il' + ($elm$core$String$fromInt(listIndex) + ('pi' + ($elm$core$String$fromInt(productIndex) + 'ca'))),
				category);
		case 71:
			var listIndex = param.a;
			var productIndex = param.b;
			var variant = param.c;
			return A2(
				$elm$url$Url$Builder$string,
				'il' + ($elm$core$String$fromInt(listIndex) + ('pi' + ($elm$core$String$fromInt(productIndex) + 'va'))),
				variant);
		case 72:
			var listIndex = param.a;
			var productIndex = param.b;
			var position = param.c;
			return A2(
				$elm$url$Url$Builder$int,
				'il' + ($elm$core$String$fromInt(listIndex) + ('pi' + ($elm$core$String$fromInt(productIndex) + 'ps'))),
				position);
		case 73:
			var listIndex = param.a;
			var productIndex = param.b;
			var price = param.c;
			return A2(
				$elm$url$Url$Builder$string,
				'il' + ($elm$core$String$fromInt(listIndex) + ('pi' + ($elm$core$String$fromInt(productIndex) + 'pr'))),
				$rielas$measurement$Currency$toString(price));
		case 74:
			var listIndex = param.a;
			var productIndex = param.b;
			var dimensionIndex = param.c;
			var dimension = param.d;
			return A2(
				$elm$url$Url$Builder$string,
				'il' + ($elm$core$String$fromInt(listIndex) + ('pi' + ($elm$core$String$fromInt(productIndex) + ('cd' + $elm$core$String$fromInt(dimensionIndex))))),
				dimension);
		case 75:
			var listIndex = param.a;
			var productIndex = param.b;
			var metricIndex = param.c;
			var metric = param.d;
			return A2(
				$elm$url$Url$Builder$int,
				'il' + ($elm$core$String$fromInt(listIndex) + ('pi' + ($elm$core$String$fromInt(productIndex) + ('cm' + $elm$core$String$fromInt(metricIndex))))),
				metric);
		case 76:
			var action = param.a;
			return A2($elm$url$Url$Builder$string, 'pa', action);
		case 77:
			var affilation = param.a;
			return A2($elm$url$Url$Builder$string, 'ta', affilation);
		case 78:
			var revenue = param.a;
			return A2(
				$elm$url$Url$Builder$string,
				'tr',
				$rielas$measurement$Currency$toString(revenue));
		case 79:
			var tax = param.a;
			return A2(
				$elm$url$Url$Builder$string,
				'tt',
				$rielas$measurement$Currency$toString(tax));
		case 80:
			var shipping = param.a;
			return A2(
				$elm$url$Url$Builder$string,
				'ts',
				$rielas$measurement$Currency$toString(shipping));
		case 81:
			var code = param.a;
			return A2($elm$url$Url$Builder$string, 'tcc', code);
		case 82:
			var list = param.a;
			return A2($elm$url$Url$Builder$string, 'pal', list);
		case 83:
			var step = param.a;
			return A2($elm$url$Url$Builder$int, 'cos', step);
		case 84:
			var option = param.a;
			return A2($elm$url$Url$Builder$string, 'col', option);
		case 85:
			var promoIndex = param.a;
			var id = param.b;
			return A2(
				$elm$url$Url$Builder$string,
				'promo' + ($elm$core$String$fromInt(promoIndex) + 'id'),
				id);
		case 86:
			var promoIndex = param.a;
			var name = param.b;
			return A2(
				$elm$url$Url$Builder$string,
				'promo' + ($elm$core$String$fromInt(promoIndex) + 'nm'),
				name);
		case 87:
			var promoIndex = param.a;
			var creative = param.b;
			return A2(
				$elm$url$Url$Builder$string,
				'promo' + ($elm$core$String$fromInt(promoIndex) + 'cr'),
				creative);
		case 88:
			var promoIndex = param.a;
			var position = param.b;
			return A2(
				$elm$url$Url$Builder$string,
				'promo' + ($elm$core$String$fromInt(promoIndex) + 'ps'),
				position);
		case 89:
			var action = param.a;
			return A2($elm$url$Url$Builder$string, 'promoa', action);
		case 90:
			var code = param.a;
			return A2($elm$url$Url$Builder$string, 'cu', code);
		case 91:
			var network = param.a;
			return A2($elm$url$Url$Builder$string, 'sn', network);
		case 92:
			var action = param.a;
			return A2($elm$url$Url$Builder$string, 'sa', action);
		case 93:
			var target = param.a;
			return A2($elm$url$Url$Builder$string, 'st', target);
		case 94:
			var category = param.a;
			return A2($elm$url$Url$Builder$string, 'utc', category);
		case 95:
			var name = param.a;
			return A2($elm$url$Url$Builder$string, 'utv', name);
		case 96:
			var time = param.a;
			return A2($elm$url$Url$Builder$int, 'utt', time);
		case 97:
			var label = param.a;
			return A2($elm$url$Url$Builder$string, 'utl', label);
		case 98:
			var time = param.a;
			return A2($elm$url$Url$Builder$int, 'plt', time);
		case 99:
			var time = param.a;
			return A2($elm$url$Url$Builder$int, 'dns', time);
		case 100:
			var time = param.a;
			return A2($elm$url$Url$Builder$int, 'pdt', time);
		case 101:
			var time = param.a;
			return A2($elm$url$Url$Builder$int, 'rrt', time);
		case 102:
			var time = param.a;
			return A2($elm$url$Url$Builder$int, 'tcp', time);
		case 103:
			var time = param.a;
			return A2($elm$url$Url$Builder$int, 'srt', time);
		case 104:
			var time = param.a;
			return A2($elm$url$Url$Builder$int, 'dit', time);
		case 105:
			var time = param.a;
			return A2($elm$url$Url$Builder$int, 'clt', time);
		case 106:
			var description = param.a;
			return A2($elm$url$Url$Builder$string, 'exd', description);
		case 107:
			var fatal = param.a;
			return A2(
				$elm$url$Url$Builder$int,
				'exf',
				$rielas$measurement$Query$boolToInt(fatal));
		case 108:
			var dimension = param.a;
			var value = param.b;
			return A2(
				$elm$url$Url$Builder$string,
				'cd' + $elm$core$String$fromInt(dimension),
				value);
		default:
			var metric = param.a;
			var value = param.b;
			return A2(
				$elm$url$Url$Builder$string,
				'cm' + $elm$core$String$fromInt(metric),
				value);
	}
};
var $rielas$measurement$Measurement$payloadToQuery = function (hit) {
	var payload = _Utils_ap(
		_List_fromArray(
			[
				$rielas$measurement$Query$toQuery(
				$rielas$measurement$Parameter$ProtocolVersion('1')),
				$rielas$measurement$Query$toQuery(
				$rielas$measurement$Parameter$TrackingID(hit.om)),
				$rielas$measurement$Query$toQuery(
				$rielas$measurement$Parameter$ClientID(hit.lf)),
				$rielas$measurement$Query$toQuery(
				$rielas$measurement$Parameter$Hittype(hit.mc))
			]),
		A2(
			$elm$core$List$map,
			function (param) {
				return $rielas$measurement$Query$toQuery(param);
			},
			hit.nf));
	return A2(
		$elm$core$String$dropLeft,
		1,
		$elm$url$Url$Builder$toQuery(payload));
};
var $rielas$measurement$Measurement$post = function (hit) {
	return {
		aA: A2(
			$elm$http$Http$stringBody,
			'',
			$rielas$measurement$Measurement$payloadToQuery(hit)),
		aJ: $elm$http$Http$expectWhatever($elm$core$Basics$identity),
		aW: 'https://www.google-analytics.com/collect'
	};
};
var $author$project$Main$trackingForRoute = function (route) {
	return A2(
		$elm$core$Platform$Cmd$map,
		$author$project$Main$GotGoogleAnalyticsMsg,
		$elm$http$Http$post(
			$rielas$measurement$Measurement$post(
				{
					lf: '555',
					mc: 0,
					nf: _List_fromArray(
						[
							$rielas$measurement$Parameter$DocumentPath(
							A2(
								$elm$core$String$dropLeft,
								1,
								$author$project$Portal$Route$toString(route)))
						]),
					om: 'G-TE4WK3MTBB'
				})));
};
var $author$project$Portal$Share$waitingStatus = function (_v0) {
	var model = _v0;
	return model.bf;
};
var $author$project$Portal$Share$withStableRoute = F2(
	function (s, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				fL: $author$project$Portal$Share$Stable(s)
			});
	});
var $author$project$Portal$Share$withoutWaitingActions = function (_v0) {
	var model = _v0;
	return _Utils_update(
		model,
		{bf: $author$project$Portal$Waiting$init});
};
var $author$project$Main$replaceRouteTo = F2(
	function (oldModel, maybeRoute) {
		return A3($author$project$Main$routeTo, $author$project$Portal$Route$replaceUrl, maybeRoute, oldModel);
	});
var $author$project$Main$routeTo = F3(
	function (pushOrReplaceUrl, newRoute, oldModel) {
		var oldRoute = $author$project$Portal$Share$currentRoute(oldModel.fQ);
		if (_Utils_eq(oldRoute, newRoute)) {
			return _Utils_Tuple2(oldModel, $elm$core$Platform$Cmd$none);
		} else {
			var model = function (s) {
				return _Utils_update(
					oldModel,
					{fQ: s});
			}(
				A4(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $author$project$Portal$Share$withDistributionPointIdOfHeader),
					$author$project$Portal$Route$context(newRoute),
					$author$project$Portal$Share$withoutWaitingActions(
						A2(
							$author$project$Portal$Share$withStableRoute,
							{
								h9: newRoute,
								nk: $elm$core$Maybe$Just(oldRoute)
							},
							oldModel.fQ))));
			var updateUrl = $Fresheyeball$elm_return$Return$command(
				A2(pushOrReplaceUrl, model.iY, newRoute));
			var cancelRunningRequests = $author$project$Portal$Waiting$cancelCmd(
				$author$project$Portal$Share$waitingStatus(oldModel.fQ));
			var addTracking = function (_v1) {
				var m = _v1.a;
				var c = _v1.b;
				return _Utils_Tuple2(
					m,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								c,
								$author$project$Main$trackingForRoute(newRoute)
							])));
			};
			var to = F2(
				function (toMsg, toPage) {
					return A2(
						$elm$core$Basics$composeR,
						A3($author$project$Main$map, model, toMsg, toPage),
						A2($elm$core$Basics$composeR, updateUrl, addTracking));
				});
			return A2(
				$Fresheyeball$elm_return$Return$command,
				cancelRunningRequests,
				function () {
					switch (newRoute.$) {
						case 0:
							return A3(
								to,
								$author$project$Main$GotDashboardMsg,
								$author$project$Portal$Pages$Dashboard,
								$author$project$Dashboard$Dashboard$init(model.fQ));
						case 1:
							var date = newRoute.a;
							return A3(
								to,
								$author$project$Main$GotPublicationsMsg,
								$author$project$Portal$Pages$Publications,
								A2($author$project$Publications$Publications$init, model.fQ, date));
						case 3:
							var dpId = newRoute.a;
							var date = newRoute.b;
							return A3(
								to,
								$author$project$Main$GotCreatePlanMsg,
								$author$project$Portal$Pages$CreatePlan,
								A3(
									$author$project$Plan$CreatePlan$init,
									A3($author$project$Portal$Share$filterData, dpId, date, model.fQ),
									dpId,
									date));
						case 2:
							var dpId = newRoute.a;
							return A2(
								$author$project$Main$replaceRouteTo,
								model,
								A2(
									$author$project$Portal$Route$DayPlanning,
									dpId,
									$author$project$Portal$Share$today(model.fQ)));
						case 4:
							var dpId = newRoute.a;
							var date = newRoute.b;
							return A3(
								to,
								$author$project$Main$GotDayPlanningMsg,
								$author$project$Portal$Pages$DayPlanning,
								A3(
									$author$project$Plan$DayPlanning$init,
									A3($author$project$Portal$Share$filterData, dpId, date, model.fQ),
									dpId,
									date));
						case 5:
							return A3(
								to,
								$author$project$Main$GotPlanNotFinalizedMsg,
								$author$project$Portal$Pages$PlansNotFinalized,
								$author$project$Plan$NotFinalized$init(model.fQ));
						case 6:
							var dpId = newRoute.a;
							var date = newRoute.b;
							return A3(
								to,
								$author$project$Main$GotDistributionListMsg,
								$author$project$Portal$Pages$DistributionList,
								A3(
									$author$project$Lists$Distribution$DistributionList$init,
									A3($author$project$Portal$Share$filterData, dpId, date, model.fQ),
									dpId,
									date));
						case 7:
							var dpId = newRoute.a;
							var date = newRoute.b;
							return A3(
								to,
								$author$project$Main$GotDistributionListMsg,
								$author$project$Portal$Pages$DistributionListB,
								A3(
									$author$project$Lists$Distribution$DistributionList$init,
									A3($author$project$Portal$Share$filterData, dpId, date, model.fQ),
									dpId,
									date));
						case 8:
							var dpId = newRoute.a;
							var date = newRoute.b;
							return A3(
								to,
								$author$project$Main$GotPreSupplyListMsg,
								$author$project$Portal$Pages$PreSupplyList,
								A3(
									$author$project$Lists$Distribution$PreSupplyList$init,
									A3($author$project$Portal$Share$filterData, dpId, date, model.fQ),
									dpId,
									date));
						case 9:
							var dpId = newRoute.a;
							var date = newRoute.b;
							return A3(
								to,
								$author$project$Main$GotCountMsg,
								$author$project$Portal$Pages$HubPackList,
								A3(
									$author$project$Count$Count$init,
									A3($author$project$Portal$Share$filterData, dpId, date, model.fQ),
									dpId,
									date));
						case 10:
							var dpId = newRoute.a;
							var date = newRoute.b;
							return A3(
								to,
								$author$project$Main$GotReceivedCheckListMsg,
								$author$project$Portal$Pages$ReceivedCheckList,
								A3(
									$author$project$Lists$Received$CheckList$init,
									A3($author$project$Portal$Share$filterData, dpId, date, model.fQ),
									dpId,
									date));
						case 11:
							var dpId = newRoute.a;
							var date = newRoute.b;
							return A3(
								to,
								$author$project$Main$GotRouteDetailMsg,
								$author$project$Portal$Pages$RouteDetail,
								A3(
									$author$project$Lists$RouteDetail$RouteDetail$init,
									A3($author$project$Portal$Share$filterData, dpId, date, model.fQ),
									dpId,
									date));
						case 12:
							var dpId = newRoute.a;
							var date = newRoute.b;
							var delivererId = newRoute.c;
							var clusterId = newRoute.d;
							return A3(
								to,
								$author$project$Main$GotSequenceMsg,
								$author$project$Portal$Pages$SequenceDetail,
								A5(
									$author$project$Sequence$Plan$init,
									A3($author$project$Portal$Share$filterData, dpId, date, model.fQ),
									dpId,
									date,
									delivererId,
									clusterId));
						case 13:
							var dpId = newRoute.a;
							var date = newRoute.b;
							return A3(
								to,
								$author$project$Main$GotCreateDelivererMsg,
								$author$project$Portal$Pages$CreateDeliverer,
								A3(
									$author$project$Deliverer$Create$init,
									A3($author$project$Portal$Share$filterData, dpId, date, model.fQ),
									dpId,
									date));
						case 14:
							var delivererId = newRoute.a;
							return A3(
								to,
								$author$project$Main$GotEditDelivererMsg,
								$author$project$Portal$Pages$EditDeliverer,
								A2($author$project$Deliverer$Edit$init, model.fQ, delivererId));
						case 15:
							var dpId = newRoute.a;
							var date = newRoute.b;
							return A3(
								to,
								$author$project$Main$GotCountMsg,
								$author$project$Portal$Pages$Count,
								A3(
									$author$project$Count$Count$init,
									A3($author$project$Portal$Share$filterData, dpId, date, model.fQ),
									dpId,
									date));
						case 16:
							var dpId = newRoute.a;
							var date = newRoute.b;
							return A3(
								to,
								$author$project$Main$GotDelayMsg,
								$author$project$Portal$Pages$Delay,
								A3(
									$author$project$Delay$Delay$init,
									A3($author$project$Portal$Share$filterData, dpId, date, model.fQ),
									dpId,
									date));
						case 17:
							var date = newRoute.a;
							return A3(
								to,
								$author$project$Main$GotDelivererRouteDetailMsg,
								$author$project$Portal$Pages$DelivererRouteDetail,
								A4($author$project$Lists$RouteDetail$Deliverer$init, model.fQ, date, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
						case 18:
							var date = newRoute.a;
							var cluster = newRoute.b;
							var page = newRoute.c;
							return A3(
								to,
								$author$project$Main$GotDelivererRouteDetailMsg,
								$author$project$Portal$Pages$DelivererRouteDetail,
								A4(
									$author$project$Lists$RouteDetail$Deliverer$init,
									model.fQ,
									date,
									$elm$core$Maybe$Just(cluster),
									$elm$core$Maybe$Just(page)));
						case 19:
							return A3(
								to,
								$author$project$Main$GotDocumentsMsg,
								$author$project$Portal$Pages$Documents,
								$author$project$Documents$Documents$init(model.fQ));
						case 20:
							return A3(
								to,
								$author$project$Main$GotAccountsMsg,
								$author$project$Portal$Pages$Accounts,
								$author$project$Accounts$Overview$init(model.fQ));
						case 21:
							var id = newRoute.a;
							return A3(
								to,
								$author$project$Main$GotAccountEditMsg,
								$author$project$Portal$Pages$AccountEdit,
								A2($author$project$Accounts$Edit$init, model.fQ, id));
						case 22:
							return A3(
								to,
								$author$project$Main$GotAccountAddMsg,
								$author$project$Portal$Pages$AccountAdd,
								$author$project$Accounts$Add$init(model.fQ));
						case 23:
							return A3(
								to,
								$author$project$Main$GotMessageMsg,
								$author$project$Portal$Pages$Messages,
								$author$project$Message$Message$init(model.fQ));
						case 24:
							return A3(
								to,
								$author$project$Main$GotCompensationOverviewMsg,
								$author$project$Portal$Pages$Compensations,
								$author$project$Compensation$Overview$init(model.fQ));
						case 25:
							var dpId = newRoute.a;
							var date = newRoute.b;
							return A3(
								to,
								$author$project$Main$GotCreateCompensationMsg,
								$author$project$Portal$Pages$CreateCompensation,
								A3(
									$author$project$Compensation$Add$init,
									A3($author$project$Portal$Share$filterData, dpId, date, model.fQ),
									dpId,
									date));
						case 26:
							var compensationId = newRoute.a;
							return A3(
								to,
								$author$project$Main$GotEditCompensationMsg,
								$author$project$Portal$Pages$EditCompensation,
								A2($author$project$Compensation$Edit$init, model.fQ, compensationId));
						case 27:
							return A3(
								to,
								$author$project$Main$GotApproveCompensationMsg,
								$author$project$Portal$Pages$ApproveCompensations,
								$author$project$Compensation$Approve$init(model.fQ));
						case 28:
							return A3(
								to,
								$author$project$Main$GotPaymentDelivererOverviewMsg,
								$author$project$Portal$Pages$PaymentDelivererOverview,
								$author$project$Payment$DelivererOverview$init(model.fQ));
						case 30:
							var year = newRoute.a;
							var period = newRoute.b;
							return A3(
								to,
								$author$project$Main$GotPaymentDetailMsg,
								$author$project$Portal$Pages$PaymentDetail,
								A2(
									$author$project$Payment$Detail$init,
									model.fQ,
									{jv: period, kC: year}));
						case 31:
							var year = newRoute.a;
							return A3(
								to,
								$author$project$Main$GotAnnualPaymentDetailMsg,
								$author$project$Portal$Pages$AnnualPaymentDetail,
								A2($author$project$Payment$AnnualDetail$init, model.fQ, year));
						case 29:
							var dpId = newRoute.a;
							return A3(
								to,
								$author$project$Main$GotPaymentDistributionPointOverviewMsg,
								$author$project$Portal$Pages$PaymentDistributionPointOverview,
								A2($author$project$Payment$DistributionPointOverview$init, model.fQ, dpId));
						case 32:
							return A3(
								to,
								$author$project$Main$GotPaymentArchiveMsg,
								$author$project$Portal$Pages$PaymentArchive,
								$author$project$Payment$Archive$init(model.fQ));
						case 33:
							return A3(
								to,
								$author$project$Main$GotApplicantsMsg,
								$author$project$Portal$Pages$Applicants,
								$author$project$Applicant$Overview$init(model.fQ));
						case 34:
							return A3(
								to,
								$author$project$Main$GotComplaintHandleMsg,
								$author$project$Portal$Pages$ComplaintHandle,
								$author$project$Complaint$Handle$init(model.fQ));
						case 35:
							var date = newRoute.a;
							return A3(
								to,
								$author$project$Main$GotComplaintFeedbackMsg,
								$author$project$Portal$Pages$ComplaintFeedback,
								A2($author$project$Complaint$Feedback$init, model.fQ, date));
						case 38:
							return A3(
								to,
								$author$project$Main$GotReportMsg,
								$author$project$Portal$Pages$Report,
								$author$project$Report$Report$init(model.fQ));
						case 36:
							return A3(
								to,
								$author$project$Main$GotClosingCalendarMsg,
								$author$project$Portal$Pages$ClosingCalendar,
								$author$project$Publications$ClosingCalendar$init(model.fQ));
						case 37:
							return A3(
								to,
								$author$project$Main$GotDistributorValidateMsg,
								$author$project$Portal$Pages$DistributorValidate,
								$author$project$Distributor$Validate$init(model.fQ));
						default:
							return A3(
								to,
								$author$project$Main$GotDashboardMsg,
								$author$project$Portal$Pages$Dashboard,
								$author$project$Dashboard$Dashboard$init(model.fQ));
					}
				}());
		}
	});
var $author$project$Main$initializeFinished = F4(
	function (flags, key, route, security) {
		var _v0 = A2(
			$author$project$Portal$Page$init,
			flags,
			A2($author$project$Portal$Share$init, security, flags));
		var share = _v0.a;
		var pageModel = _v0.b;
		var pageCmd = _v0.c;
		var model = {iY: key, cv: $author$project$Portal$Pages$Redirect, eo: pageModel, fQ: share};
		return A2(
			$Fresheyeball$elm_return$Return$command,
			A2($elm$core$Platform$Cmd$map, $author$project$Main$GotPageMsg, pageCmd),
			A2(
				$Fresheyeball$elm_return$Return$command,
				A3(
					$author$project$Message$Message$loadCmd,
					$author$project$Portal$Share$token(share),
					$author$project$Main$SystemLoadedMessages,
					$author$project$Api$Request$Untracked),
				A2($author$project$Main$replaceRouteTo, model, route)));
	});
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $author$project$Portal$Route$pushUrl = F2(
	function (key, route) {
		return A2(
			$elm$browser$Browser$Navigation$pushUrl,
			key,
			$author$project$Portal$Route$toString(route));
	});
var $author$project$Main$changeRouteTo = F2(
	function (maybeRoute, oldModel) {
		return A3($author$project$Main$routeTo, $author$project$Portal$Route$pushUrl, maybeRoute, oldModel);
	});
var $author$project$Portal$Share$ResignIn = 0;
var $author$project$Security$Security$doesErrorNeedResignIn = function (error) {
	return _Utils_eq(
		error,
		$elm$http$Http$BadStatus(401));
};
var $author$project$Portal$Message$Info = function (a) {
	return {$: 1, a: a};
};
var $author$project$Portal$Message$Unformatted = function (a) {
	return {$: 1, a: a};
};
var $author$project$Portal$Message$info = F2(
	function (title, text) {
		return $author$project$Portal$Message$Info(
			{
				n3: $author$project$Portal$Message$Unformatted(text),
				oi: title
			});
	});
var $author$project$Portal$Message$fromHttpError = function (e) {
	var timeout = A2(
		$author$project$Portal$Message$error,
		'Er heeft zich een fout voorgedaan bij het inladen van de gegevens.',
		$elm$core$Maybe$Just('De aanvraag kon niet op tijd afgehandeld worden, u kunt het nogmaals proberen.\n' + 'Als de fout aanhoudt wordt deze doorgestuurd naar onze IT afdeling en wij zullen dit zo spoedig mogelijk oplossen. '));
	var dependentServiceError = A2(
		$author$project$Portal$Message$error,
		'Er heeft zich een fout voorgedaan bij het inladen van de gegevens.',
		$elm$core$Maybe$Just('De data kon niet ingeladen worden door een fout, u kunt het nogmaals proberen.\n' + 'Als de fout aanhoudt wordt deze doorgestuurd naar onze IT afdeling en wij zullen dit zo spoedig mogelijk oplossen. '));
	switch (e.$) {
		case 0:
			var urlString = e.a;
			return A2(
				$author$project$Portal$Message$error,
				'Er is een onverwachte fout opgetreden. Gelieve je regio manager to contacteren.',
				$elm$core$Maybe$Just('BadUrl ' + urlString));
		case 1:
			return A2(
				$author$project$Portal$Message$error,
				'Je laatste wijziging werd niet geregistreerd, omdat de servers niet op tijd reageren.\n' + 'Wij raden aan de pagina te verversen.',
				$elm$core$Maybe$Just('Timeout'));
		case 2:
			return A2(
				$author$project$Portal$Message$error,
				'Er kan geen verbinding gemaakt worden met de servers.\n' + ('Hierdoor is uw laatste wijziging waarschijnlijk niet geregistreerd.\n' + 'Wij raden aan de pagina te verversen om de verbinding te herstellen.\n'),
				$elm$core$Maybe$Just('NetworkError'));
		case 3:
			switch (e.a) {
				case 400:
					return A2(
						$author$project$Portal$Message$error,
						'Probleem met het inladen van de gegevens.',
						$elm$core$Maybe$Just('Controleer de datum waarvoor de pagina geopend wordt. Het kan zijn dat de datum te ver in het verleden is (meer dan 3 maanden geleden).'));
				case 401:
					return A2($author$project$Portal$Message$info, 'Je sessie is verlopen', 'Log opnieuw in om verder te werken.');
				case 403:
					return A2(
						$author$project$Portal$Message$error,
						'Je hebt onvoldoende rechten om deze functie uit te voeren.',
						$elm$core$Maybe$Just('BadStatus 403'));
				case 404:
					return A2($author$project$Portal$Message$error, 'De gevraagde gegevens konden niet worden gevonden.', $elm$core$Maybe$Nothing);
				case 408:
					return timeout;
				case 409:
					return A2(
						$author$project$Portal$Message$error,
						'Verouderd plan, wijziging geannuleerd.',
						$elm$core$Maybe$Just('Uw laatste wijziging kon niet worden doorgevoerd omdat de versie van het plan op deze pagina verouderd was.\n' + ('Het plan is zojuist bijgewerkt met de meest recente versie.\n' + 'U kunt nu nogmaals uw laatste wijziging doorvoeren.')));
				case 422:
					return A2(
						$author$project$Portal$Message$error,
						'Er heeft zich een fout voorgedaan bij het inladen van de gegevens.',
						$elm$core$Maybe$Just('Deze melding is doorgestuurd naar onze IT afdeling en wij zullen dit zo spoedig mogelijk oplossen.'));
				case 424:
					return dependentServiceError;
				case 503:
					return dependentServiceError;
				case 599:
					return timeout;
				default:
					var statusCode = e.a;
					return A2(
						$author$project$Portal$Message$error,
						'Je laatste wijziging werd niet geregistreerd, omdat de servers een foutmelding gaven.',
						$elm$core$Maybe$Just(
							'Foutmelding: BadStatus ' + $elm$core$String$fromInt(statusCode)));
			}
		default:
			var debugMessage = e.a;
			return A2(
				$author$project$Portal$Message$error,
				'Er is een onverwachte fout opgetreden.\nGelieve je regio manager to contacteren.',
				$elm$core$Maybe$Just('Foutmelding: BadBody ' + debugMessage));
	}
};
var $elm_community$list_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$List$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$List$cons, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$uniqueBy = F2(
	function (f, list) {
		return A4($elm_community$list_extra$List$Extra$uniqueHelp, f, _List_Nil, list, _List_Nil);
	});
var $author$project$Portal$Message$textOf = function (text) {
	if (!text.$) {
		var t = text.a;
		return t;
	} else {
		var t = text.a;
		return t;
	}
};
var $author$project$Portal$Message$uniqueness = function (msg) {
	if (!msg.$) {
		var message = msg.a.fq;
		var details = msg.a.lE;
		return _Utils_Tuple3(
			1,
			message,
			A2($elm$core$Maybe$withDefault, '', details));
	} else {
		var title = msg.a.oi;
		var text = msg.a.n3;
		return _Utils_Tuple3(
			2,
			title,
			$author$project$Portal$Message$textOf(text));
	}
};
var $author$project$Portal$Message$unique = function (messages) {
	return A2($elm_community$list_extra$List$Extra$uniqueBy, $author$project$Portal$Message$uniqueness, messages);
};
var $author$project$Portal$Share$withNotification = F2(
	function (message, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				bW: $author$project$Portal$Message$unique(
					A2($elm$core$List$cons, message, model.bW))
			});
	});
var $author$project$Portal$Share$withHttpError = F2(
	function (error, _v0) {
		var model = _v0;
		return A2(
			$author$project$Portal$Share$withNotification,
			$author$project$Portal$Message$fromHttpError(error),
			$author$project$Security$Security$doesErrorNeedResignIn(error) ? _Utils_update(
				model,
				{
					eA: A2($elm$core$List$cons, 0, model.eA)
				}) : model);
	});
var $author$project$Portal$Share$withSecurity = F2(
	function (s, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{et: s});
	});
var $author$project$Main$mapSecurity = F3(
	function (model, toMsg, _v0) {
		var impact = _v0.a;
		var security = _v0.b;
		var msg = _v0.c;
		return _Utils_Tuple2(
			function (s) {
				return _Utils_update(
					model,
					{fQ: s});
			}(
				function () {
					switch (impact.$) {
						case 0:
							return $elm$core$Basics$identity;
						case 1:
							var error = impact.a;
							return $author$project$Portal$Share$withHttpError(error);
						default:
							var error = impact.a;
							return $author$project$Portal$Share$withNotification(
								A2(
									$author$project$Portal$Message$error,
									'Configuratiefout',
									$elm$core$Maybe$Just(
										$elm$json$Json$Decode$errorToString(error))));
					}
				}()(
					A2($author$project$Portal$Share$withSecurity, security, model.fQ))),
			A2($elm$core$Platform$Cmd$map, toMsg, msg));
	});
var $author$project$Dashboard$News$News = F3(
	function (from, title, text) {
		return {l2: from, n3: text, oi: title};
	});
var $author$project$Message$Message$newsOf = function () {
	var toNews = function (_v1) {
		var messageType = _v1.dh;
		var showDuring = _v1.bA;
		var title = _v1.oi;
		var formatted = _v1.ec;
		if (messageType === 1) {
			return $elm$core$Maybe$Just(
				A3($author$project$Dashboard$News$News, showDuring.l2, title, formatted));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	return $elm$core$List$filterMap(toNews);
}();
var $author$project$Portal$Message$Formatted = function (a) {
	return {$: 0, a: a};
};
var $author$project$Message$Message$notificationsOf = function () {
	var toNotification = function (_v1) {
		var messageType = _v1.dh;
		var title = _v1.oi;
		var formatted = _v1.ec;
		if (!messageType) {
			return $elm$core$Maybe$Just(
				$author$project$Portal$Message$Info(
					{
						n3: $author$project$Portal$Message$Formatted(formatted),
						oi: title
					}));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	return $elm$core$List$filterMap(toNotification);
}();
var $elm$core$Tuple$mapBoth = F3(
	function (funcA, funcB, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			funcA(x),
			funcB(y));
	});
var $author$project$Security$ApplicationState$fromDecrypted = $elm$core$Basics$identity;
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $author$project$Security$Security$signOut = function (model) {
	var toUnauthenticated = function (_v3) {
		var uris = _v3.Z;
		var clientId = _v3.lf;
		return $author$project$Security$Security$Unauthenticated(
			{
				lf: clientId,
				b4: $author$project$Security$ApplicationState$fromDecrypted(''),
				Z: uris
			});
	};
	var logoutCmd = function (_v2) {
		var uris = _v2.Z;
		var clientId = _v2.lf;
		var _v1 = clientId;
		var clId = _v1;
		return $elm$browser$Browser$Navigation$load(
			_Utils_ap(
				$elm$url$Url$toString(uris.gQ),
				$elm$url$Url$Builder$toQuery(
					_List_fromArray(
						[
							A2($elm$url$Url$Builder$string, 'client_id', clId),
							A2(
							$elm$url$Url$Builder$string,
							'logout_uri',
							$elm$url$Url$toString(uris.fH))
						]))));
	};
	var returnFor = function (a) {
		return _Utils_Tuple2(
			toUnauthenticated(a),
			logoutCmd(a));
	};
	switch (model.$) {
		case 0:
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		case 1:
			var a = model.a;
			return returnFor(a);
		case 2:
			var a = model.a;
			return returnFor(a);
		case 3:
			var a = model.a;
			return returnFor(a);
		case 4:
			var a = model.a;
			return returnFor(a);
		default:
			var message = model.a;
			return _Utils_Tuple2(
				$author$project$Security$Security$Failed(message),
				$elm$core$Platform$Cmd$none);
	}
};
var $author$project$Main$signOut = function (model) {
	var share = model.fQ;
	return A3(
		$elm$core$Tuple$mapBoth,
		function (security) {
			return _Utils_update(
				model,
				{
					fQ: A2($author$project$Portal$Share$withSecurity, security, share)
				});
		},
		$elm$core$Platform$Cmd$map($author$project$Main$GotSecurityMsg),
		$author$project$Security$Security$signOut(
			$author$project$Portal$Share$security(share)));
};
var $Fresheyeball$elm_return$Return$singleton = function (a) {
	return _Utils_Tuple2(a, $elm$core$Platform$Cmd$none);
};
var $author$project$Main$stateFromRoute = function (route) {
	return $author$project$Security$ApplicationState$fromDecrypted(
		A2(
			$elm$core$String$dropLeft,
			1,
			$author$project$Portal$Route$toString(route)));
};
var $author$project$Accounts$Add$SystemCreatedAccount = function (a) {
	return {$: 3, a: a};
};
var $author$project$Accounts$Account$addCmd = F3(
	function (token, email, toMsg) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['accounts']),
			_List_Nil);
		return A5(
			$author$project$Api$Request$post,
			token,
			toMsg,
			uri,
			$elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'email',
							$elm$json$Json$Encode$string(email))
						]))),
			$author$project$Accounts$Account$userDecoder);
	});
var $author$project$Accounts$Add$actionIdFor = function (id) {
	return A2($author$project$Portal$Waiting$Id, 'accounts', id);
};
var $author$project$Accounts$Add$singleAction = function (id) {
	return $author$project$Portal$Waiting$singleAction(
		$author$project$Accounts$Add$actionIdFor(id));
};
var $author$project$Accounts$Add$createAccount = $author$project$Accounts$Add$singleAction('createAccount');
var $author$project$Accounts$Add$Invalid = $elm$core$Basics$identity;
var $author$project$UI$Validation$Email$NoAtSign = 0;
var $author$project$UI$Validation$Email$TooManyAtSign = 1;
var $arowM$elm_form_decoder$Form$Decoder$Decoder = $elm$core$Basics$identity;
var $arowM$elm_form_decoder$Form$Decoder$custom = $elm$core$Basics$identity;
var $elm$core$String$trim = _String_trim;
var $author$project$UI$Validation$Email$InvalidDomain = 5;
var $author$project$UI$Validation$Email$NoDomain = 3;
var $author$project$UI$Validation$Email$NoDotInDomain = 4;
var $author$project$UI$Validation$Email$validateDomain = function (domain) {
	var _v0 = _Utils_Tuple3(
		domain,
		A2($elm$core$String$contains, '.', domain),
		A2(
			$elm$core$List$member,
			'',
			A2($elm$core$String$split, '.', domain)));
	if (_v0.a === '') {
		return _List_fromArray(
			[3]);
	} else {
		if (!_v0.b) {
			return _List_fromArray(
				[4]);
		} else {
			if (_v0.c) {
				return _List_fromArray(
					[5]);
			} else {
				return _List_Nil;
			}
		}
	}
};
var $author$project$UI$Validation$Email$ContainsSpaces = 6;
var $author$project$UI$Validation$Email$NoLocal = 2;
var $author$project$UI$Validation$Email$validateLocal = function (local) {
	var _v0 = _Utils_Tuple2(
		local,
		A2($elm$core$String$contains, ' ', local));
	if (_v0.a === '') {
		return _List_fromArray(
			[2]);
	} else {
		if (_v0.b) {
			return _List_fromArray(
				[6]);
		} else {
			return _List_Nil;
		}
	}
};
var $author$project$UI$Validation$Email$decoder = $arowM$elm_form_decoder$Form$Decoder$custom(
	function (email) {
		var _v0 = A2(
			$elm$core$String$split,
			'@',
			$elm$core$String$trim(email));
		_v0$2:
		while (true) {
			if (_v0.b) {
				if (!_v0.b.b) {
					return $elm$core$Result$Err(
						_List_fromArray(
							[0]));
				} else {
					if (!_v0.b.b.b) {
						var local = _v0.a;
						var _v1 = _v0.b;
						var domain = _v1.a;
						var _v2 = _Utils_ap(
							$author$project$UI$Validation$Email$validateLocal(local),
							$author$project$UI$Validation$Email$validateDomain(domain));
						if (!_v2.b) {
							return $elm$core$Result$Ok(email);
						} else {
							var errs = _v2;
							return $elm$core$Result$Err(errs);
						}
					} else {
						break _v0$2;
					}
				}
			} else {
				break _v0$2;
			}
		}
		return $elm$core$Result$Err(
			_List_fromArray(
				[1]));
	});
var $arowM$elm_form_decoder$Form$Decoder$mapError = F2(
	function (f, _v0) {
		var g = _v0;
		return $arowM$elm_form_decoder$Form$Decoder$custom(
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Result$mapError(
					$elm$core$List$map(f)),
				g));
	});
var $author$project$Accounts$Add$decodeEmail = A2($arowM$elm_form_decoder$Form$Decoder$mapError, $elm$core$Basics$identity, $author$project$UI$Validation$Email$decoder);
var $arowM$elm_form_decoder$Form$Decoder$run = F2(
	function (_v0, a) {
		var f = _v0;
		return f(a);
	});
var $author$project$Portal$Return$withCommand = F3(
	function (action, cmd, _v0) {
		var s = _v0.a;
		var m = _v0.b;
		var c = _v0.c;
		return _Utils_Tuple3(
			A2($author$project$Portal$Share$withWaitingAction, action, s),
			m,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmd(
						$author$project$Api$Request$Tracked(
							$author$project$Portal$Waiting$name(action))),
						c
					])));
	});
var $author$project$Portal$Return$withMessage = F2(
	function (message, _v0) {
		var s = _v0.a;
		var m = _v0.b;
		var c = _v0.c;
		return _Utils_Tuple3(
			A2($author$project$Portal$Share$withNotification, message, s),
			m,
			c);
	});
var $author$project$Portal$Share$ChangeRequested = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Portal$Share$withNewRoute = F2(
	function (route, _v0) {
		var model = _v0;
		var _v1 = model.fL;
		if (!_v1.$) {
			var s = _v1.a;
			return _Utils_update(
				model,
				{
					fL: A2($author$project$Portal$Share$ChangeRequested, route, s)
				});
		} else {
			var s = _v1.b;
			return _Utils_update(
				model,
				{
					fL: A2($author$project$Portal$Share$ChangeRequested, route, s)
				});
		}
	});
var $author$project$Portal$Waiting$sameAs = function (action) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Portal$Waiting$id,
		$elm$core$Basics$eq(
			$author$project$Portal$Waiting$id(action)));
};
var $author$project$Portal$Waiting$withoutAction = F2(
	function (action, status) {
		return $author$project$Portal$Waiting$statusFrom(
			$author$project$Portal$Waiting$combine(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$not,
						$author$project$Portal$Waiting$sameAs(action)),
					$author$project$Portal$Waiting$actionsOf(status))));
	});
var $author$project$Portal$Share$withoutWaitingAction = F2(
	function (action, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				bf: A2($author$project$Portal$Waiting$withoutAction, action, model.bf)
			});
	});
var $author$project$Accounts$Add$update = F3(
	function (msg, share, model) {
		var token = $author$project$Portal$Share$token(share);
		var to = function (route) {
			return _Utils_Tuple3(
				A2($author$project$Portal$Share$withNewRoute, route, share),
				model,
				$elm$core$Platform$Cmd$none);
		};
		var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		var modelChange = function (m) {
			return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
		};
		var err = F3(
			function (action, error, m) {
				return _Utils_Tuple3(
					A2(
						$author$project$Portal$Share$withHttpError,
						error,
						A2($author$project$Portal$Share$withoutWaitingAction, action, share)),
					m,
					$elm$core$Platform$Cmd$none);
			});
		switch (msg.$) {
			case 0:
				return to($author$project$Portal$Route$Accounts);
			case 1:
				var input = msg.a;
				return modelChange(
					_Utils_update(
						model,
						{d5: input}));
			case 2:
				var _v1 = A2($arowM$elm_form_decoder$Form$Decoder$run, $author$project$Accounts$Add$decodeEmail, model.d5);
				if (!_v1.$) {
					var email = _v1.a;
					return A3(
						$author$project$Portal$Return$withCommand,
						$author$project$Accounts$Add$createAccount,
						A3($author$project$Accounts$Account$addCmd, token, email, $author$project$Accounts$Add$SystemCreatedAccount),
						noChange);
				} else {
					var errors = _v1.a;
					return modelChange(
						_Utils_update(
							model,
							{f_: errors}));
				}
			default:
				if (!msg.a.$) {
					var account = msg.a.a;
					return to(
						$author$project$Portal$Route$AccountEdit(account.eg));
				} else {
					if ((msg.a.a.$ === 3) && (msg.a.a.a === 409)) {
						return A2(
							$author$project$Portal$Return$withMessage,
							A2($author$project$Portal$Message$info, 'Deze gebruiker bestaat al.', 'Het ingevoerde email adres is al in gebruik.'),
							noChange);
					} else {
						var error = msg.a.a;
						return A3(err, $author$project$Accounts$Add$createAccount, error, model);
					}
				}
		}
	});
var $author$project$Accounts$Edit$AddingRole = function (a) {
	return {$: 1, a: a};
};
var $author$project$Accounts$Edit$EditingRole = function (a) {
	return {$: 2, a: a};
};
var $author$project$Accounts$Edit$Failed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Accounts$Edit$NoInput = {$: 0};
var $author$project$Accounts$Edit$RevokeRole = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Accounts$Edit$Submitting = function (a) {
	return {$: 4, a: a};
};
var $author$project$Accounts$Edit$SystemHandledRoleSave = function (a) {
	return {$: 11, a: a};
};
var $author$project$Accounts$Authorization$distributionPointsOf = function (role) {
	switch (role.$) {
		case 0:
			var dps = role.a;
			return dps;
		case 1:
			var dps = role.a;
			return dps;
		case 2:
			var dps = role.a;
			return dps;
		case 3:
			var dps = role.a;
			return dps;
		default:
			return _List_Nil;
	}
};
var $author$project$Accounts$Edit$grantRole = A2(
	$elm$core$Basics$composeR,
	$author$project$Accounts$Account$comparable,
	$author$project$Accounts$Edit$singleAction('grantRole'));
var $author$project$Accounts$Authorization$stringValueFor = function (role) {
	switch (role.$) {
		case 0:
			return 'regionDistributor';
		case 1:
			return 'entrepreneur';
		case 2:
			return 'assistantDistributor';
		case 3:
			return 'counter';
		case 4:
			return 'accountManager';
		case 5:
			return 'logisticsSupporter';
		case 6:
			return 'regionManager';
		case 7:
			return 'admin';
		case 8:
			return 'deliverer';
		case 9:
			return 'operationalManager';
		case 10:
			return 'financialAdministrator';
		case 11:
			return 'preparer';
		case 12:
			return 'recruiter';
		default:
			return 'laborMarketCommunicator';
	}
};
var $author$project$Accounts$Authorization$encodeRole = function (role) {
	var typeField = _Utils_Tuple2(
		'type',
		$elm$json$Json$Encode$string(
			$author$project$Accounts$Authorization$stringValueFor(role)));
	switch (role.$) {
		case 0:
			var uuids = role.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						typeField,
						_Utils_Tuple2(
						'distributionPoints',
						A2($elm$json$Json$Encode$list, $author$project$DistributionPoint$DistributionPoint$encodeId, uuids))
					]));
		case 1:
			var uuids = role.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						typeField,
						_Utils_Tuple2(
						'distributionPoints',
						A2($elm$json$Json$Encode$list, $author$project$DistributionPoint$DistributionPoint$encodeId, uuids))
					]));
		case 2:
			var uuids = role.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						typeField,
						_Utils_Tuple2(
						'distributionPoints',
						A2($elm$json$Json$Encode$list, $author$project$DistributionPoint$DistributionPoint$encodeId, uuids))
					]));
		case 3:
			var uuids = role.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						typeField,
						_Utils_Tuple2(
						'distributionPoints',
						A2($elm$json$Json$Encode$list, $author$project$DistributionPoint$DistributionPoint$encodeId, uuids))
					]));
		case 8:
			var delivererId = role.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						typeField,
						_Utils_Tuple2(
						'deliverer',
						$author$project$Deliverer$Deliverer$encodeId(delivererId))
					]));
		default:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[typeField]));
	}
};
var $author$project$Accounts$Authorization$grantRoleCmd = F5(
	function (token, accountId, date, role, toMsg) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'accounts',
					$author$project$Accounts$Account$encodeForUrl(accountId),
					$author$project$Date$DeliveryDate$encodeForUrl(date),
					'roles'
				]),
			_List_Nil);
		return A5(
			$author$project$Api$Request$post,
			token,
			toMsg,
			uri,
			$elm$http$Http$jsonBody(
				$author$project$Accounts$Authorization$encodeRole(role)),
			$author$project$Accounts$Authorization$authorizationDecoder);
	});
var $author$project$Accounts$Edit$revokeRole = A2(
	$elm$core$Basics$composeR,
	$author$project$Accounts$Account$comparable,
	$author$project$Accounts$Edit$singleAction('revokeRole'));
var $author$project$Api$Request$delete = F6(
	function (token, toMsg, url, body, decoder, tracker) {
		return $elm$http$Http$request(
			{
				aA: body,
				aJ: A2($elm$http$Http$expectJson, toMsg, decoder),
				aK: $author$project$Api$Request$headers(token),
				aO: 'DELETE',
				aS: $elm$core$Maybe$Nothing,
				aU: $author$project$Api$Request$trackingFor(tracker),
				aW: url
			});
	});
var $author$project$Accounts$Authorization$revokeRoleCmd = F5(
	function (token, accountId, date, role, toMsg) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'accounts',
					$author$project$Accounts$Account$encodeForUrl(accountId),
					$author$project$Date$DeliveryDate$encodeForUrl(date),
					'roles',
					$author$project$Accounts$Authorization$stringValueFor(role)
				]),
			_List_Nil);
		return A5(
			$author$project$Api$Request$delete,
			token,
			toMsg,
			uri,
			$elm$http$Http$jsonBody(
				$author$project$Accounts$Authorization$encodeRole(role)),
			$author$project$Accounts$Authorization$authorizationDecoder);
	});
var $arowM$elm_form_decoder$Form$Decoder$field = F2(
	function (_v0, _v1) {
		var f = _v0;
		var g = _v1;
		return $arowM$elm_form_decoder$Form$Decoder$custom(
			function (i) {
				var _v2 = _Utils_Tuple2(
					g(i),
					f(i));
				if (!_v2.a.$) {
					var h = _v2.a.a;
					var res = _v2.b;
					return A2($elm$core$Result$map, h, res);
				} else {
					if (_v2.b.$ === 1) {
						var gErr = _v2.a.a;
						var fErr = _v2.b.a;
						return $elm$core$Result$Err(
							_Utils_ap(gErr, fErr));
					} else {
						var gErr = _v2.a.a;
						return $elm$core$Result$Err(gErr);
					}
				}
			});
	});
var $arowM$elm_form_decoder$Form$Decoder$lift = F2(
	function (f, _v0) {
		var g = _v0;
		return $arowM$elm_form_decoder$Form$Decoder$custom(
			A2($elm$core$Basics$composeL, g, f));
	});
var $author$project$Accounts$Edit$roleAddDpsDecoder = $arowM$elm_form_decoder$Form$Decoder$custom($elm$core$Result$Ok);
var $author$project$Accounts$Edit$DateInPast = 0;
var $justinmimbs$date$Date$compare = F2(
	function (_v0, _v1) {
		var a = _v0;
		var b = _v1;
		return A2($elm$core$Basics$compare, a, b);
	});
var $author$project$Accounts$Edit$roleAddFromDecoder = function (date) {
	return $arowM$elm_form_decoder$Form$Decoder$custom(
		A2(
			$elm$core$Basics$composeL,
			$elm$core$Result$fromMaybe(
				_List_fromArray(
					[0])),
			A2(
				$elm$core$Basics$composeR,
				$author$project$Date$DeliveryDate$fromString,
				$elm$core$Maybe$andThen(
					function (input) {
						var _v0 = A2(
							$justinmimbs$date$Date$compare,
							$author$project$Date$DeliveryDate$toDate(input),
							date);
						if (!_v0) {
							return $elm$core$Maybe$Nothing;
						} else {
							return $elm$core$Maybe$Just(input);
						}
					}))));
};
var $author$project$Accounts$Edit$RoleRequired = 1;
var $author$project$Accounts$Edit$roleAddRoleDecoder = $arowM$elm_form_decoder$Form$Decoder$custom(
	$elm$core$Result$fromMaybe(
		_List_fromArray(
			[1])));
var $arowM$elm_form_decoder$Form$Decoder$top = function (f) {
	return $arowM$elm_form_decoder$Form$Decoder$custom(
		function (_v0) {
			return $elm$core$Result$Ok(f);
		});
};
var $author$project$Accounts$Authorization$withDistributionPoints = F2(
	function (dps, role) {
		switch (role.$) {
			case 0:
				return $author$project$Accounts$Authorization$RegionDistributor(dps);
			case 1:
				return $author$project$Accounts$Authorization$Entrepreneur(dps);
			case 2:
				return $author$project$Accounts$Authorization$AssistantDistributor(dps);
			case 3:
				return $author$project$Accounts$Authorization$Counter(dps);
			case 4:
				return $author$project$Accounts$Authorization$AccountManager;
			case 5:
				return $author$project$Accounts$Authorization$LogisticsSupporter;
			case 6:
				return $author$project$Accounts$Authorization$RegionManager;
			case 7:
				return $author$project$Accounts$Authorization$Admin;
			case 8:
				var delivererId = role.a;
				return $author$project$Accounts$Authorization$Deliverer(delivererId);
			case 9:
				return $author$project$Accounts$Authorization$OperationalManager;
			case 10:
				return $author$project$Accounts$Authorization$FinancialAdministrator;
			case 11:
				return $author$project$Accounts$Authorization$Preparer;
			case 12:
				return $author$project$Accounts$Authorization$Recruiter;
			default:
				return $author$project$Accounts$Authorization$LaborMarketCommunicator;
		}
	});
var $author$project$Accounts$Edit$roleFormDecoder = function (date) {
	return A2(
		$arowM$elm_form_decoder$Form$Decoder$field,
		A2(
			$arowM$elm_form_decoder$Form$Decoder$lift,
			function ($) {
				return $.A;
			},
			$author$project$Accounts$Edit$roleAddDpsDecoder),
		A2(
			$arowM$elm_form_decoder$Form$Decoder$field,
			A2(
				$arowM$elm_form_decoder$Form$Decoder$lift,
				function ($) {
					return $.cz;
				},
				$author$project$Accounts$Edit$roleAddRoleDecoder),
			A2(
				$arowM$elm_form_decoder$Form$Decoder$field,
				A2(
					$arowM$elm_form_decoder$Form$Decoder$lift,
					function ($) {
						return $.l2;
					},
					$author$project$Accounts$Edit$roleAddFromDecoder(date)),
				$arowM$elm_form_decoder$Form$Decoder$top(
					F3(
						function (d, role, dps) {
							return _Utils_Tuple2(
								d,
								A2($author$project$Accounts$Authorization$withDistributionPoints, dps, role));
						})))));
};
var $author$project$Accounts$Edit$RevokeDateInPast = 0;
var $author$project$Accounts$Edit$roleRevokeFromDecoder = function (date) {
	return $arowM$elm_form_decoder$Form$Decoder$custom(
		A2(
			$elm$core$Basics$composeL,
			$elm$core$Result$fromMaybe(
				_List_fromArray(
					[0])),
			A2(
				$elm$core$Basics$composeR,
				$author$project$Date$DeliveryDate$fromString,
				$elm$core$Maybe$andThen(
					function (input) {
						var _v0 = A2(
							$justinmimbs$date$Date$compare,
							$author$project$Date$DeliveryDate$toDate(input),
							date);
						if (!_v0) {
							return $elm$core$Maybe$Nothing;
						} else {
							return $elm$core$Maybe$Just(input);
						}
					}))));
};
var $author$project$Accounts$Edit$roleRevokeFormDecoder = function (date) {
	return A2(
		$arowM$elm_form_decoder$Form$Decoder$field,
		A2(
			$arowM$elm_form_decoder$Form$Decoder$lift,
			function ($) {
				return $.l2;
			},
			$author$project$Accounts$Edit$roleRevokeFromDecoder(date)),
		$arowM$elm_form_decoder$Form$Decoder$top(
			function (d) {
				return d;
			}));
};
var $author$project$Accounts$Edit$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Accounts$Edit$next = function (model) {
	if (!model.$) {
		var account = model.b.ca;
		var authorizations = model.b.az;
		var distributionPoints = model.b.A;
		var _v1 = _Utils_Tuple3(account, authorizations, distributionPoints);
		if (((!_v1.a.$) && (!_v1.b.$)) && (!_v1.c.$)) {
			var acc = _v1.a.a;
			var a = _v1.b.a;
			var d = _v1.c.a;
			return $author$project$Accounts$Edit$Loaded(
				{ca: acc, az: a, A: d, ax: $author$project$Accounts$Edit$NoInput});
		} else {
			return model;
		}
	} else {
		return model;
	}
};
var $author$project$Accounts$Edit$withAccount = F2(
	function (account, model) {
		return $author$project$Accounts$Edit$next(
			function () {
				switch (model.$) {
					case 0:
						var id = model.a;
						var m = model.b;
						return A2(
							$author$project$Accounts$Edit$Loading,
							id,
							_Utils_update(
								m,
								{
									ca: $elm$core$Maybe$Just(account)
								}));
					case 1:
						var m = model.a;
						return $author$project$Accounts$Edit$Loaded(
							_Utils_update(
								m,
								{ca: account}));
					default:
						var id = model.a;
						return $author$project$Accounts$Edit$Failed(id);
				}
			}());
	});
var $elm_community$list_extra$List$Extra$updateAt = F3(
	function (index, fn, list) {
		if (index < 0) {
			return list;
		} else {
			var tail = A2($elm$core$List$drop, index, list);
			if (tail.b) {
				var x = tail.a;
				var xs = tail.b;
				return _Utils_ap(
					A2($elm$core$List$take, index, list),
					A2(
						$elm$core$List$cons,
						fn(x),
						xs));
			} else {
				return list;
			}
		}
	});
var $elm_community$list_extra$List$Extra$setAt = F2(
	function (index, value) {
		return A2(
			$elm_community$list_extra$List$Extra$updateAt,
			index,
			$elm$core$Basics$always(value));
	});
var $author$project$Accounts$Edit$withAuthorization = F2(
	function (authorization, model) {
		if (model.$ === 1) {
			var m = model.a;
			var _v1 = A2(
				$elm_community$list_extra$List$Extra$findIndex,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.l2;
					},
					$elm$core$Basics$eq(authorization.l2)),
				m.az);
			if (!_v1.$) {
				var index = _v1.a;
				return $author$project$Accounts$Edit$Loaded(
					_Utils_update(
						m,
						{
							az: A3($elm_community$list_extra$List$Extra$setAt, index, authorization, m.az)
						}));
			} else {
				return $author$project$Accounts$Edit$Loaded(
					_Utils_update(
						m,
						{
							az: _Utils_ap(
								m.az,
								_List_fromArray(
									[authorization]))
						}));
			}
		} else {
			return model;
		}
	});
var $author$project$Accounts$Edit$withAuthorizations = F2(
	function (authorizations, model) {
		return $author$project$Accounts$Edit$next(
			function () {
				switch (model.$) {
					case 0:
						var id = model.a;
						var m = model.b;
						return A2(
							$author$project$Accounts$Edit$Loading,
							id,
							_Utils_update(
								m,
								{
									az: $elm$core$Maybe$Just(authorizations)
								}));
					case 1:
						var m = model.a;
						return $author$project$Accounts$Edit$Loaded(
							_Utils_update(
								m,
								{az: authorizations}));
					default:
						var id = model.a;
						return $author$project$Accounts$Edit$Failed(id);
				}
			}());
	});
var $author$project$Accounts$Edit$withDistributionPoints = F2(
	function (dps, model) {
		return $author$project$Accounts$Edit$next(
			function () {
				switch (model.$) {
					case 0:
						var id = model.a;
						var m = model.b;
						return A2(
							$author$project$Accounts$Edit$Loading,
							id,
							_Utils_update(
								m,
								{
									A: $elm$core$Maybe$Just(dps)
								}));
					case 1:
						var m = model.a;
						return $author$project$Accounts$Edit$Loaded(
							_Utils_update(
								m,
								{A: dps}));
					default:
						var id = model.a;
						return $author$project$Accounts$Edit$Failed(id);
				}
			}());
	});
var $author$project$Accounts$Edit$withFrom = F2(
	function (from, userInput) {
		switch (userInput.$) {
			case 1:
				var form = userInput.a;
				return $author$project$Accounts$Edit$AddingRole(
					_Utils_update(
						form,
						{l2: from}));
			case 2:
				var form = userInput.a;
				return $author$project$Accounts$Edit$EditingRole(
					_Utils_update(
						form,
						{l2: from}));
			case 3:
				var role = userInput.a;
				var form = userInput.b;
				return A2(
					$author$project$Accounts$Edit$RevokeRole,
					role,
					_Utils_update(
						form,
						{l2: from}));
			default:
				return userInput;
		}
	});
var $author$project$Accounts$Edit$withRevokeValidationErrors = F2(
	function (errors, userInput) {
		if (userInput.$ === 3) {
			var role = userInput.a;
			var form = userInput.b;
			return A2(
				$author$project$Accounts$Edit$RevokeRole,
				role,
				_Utils_update(
					form,
					{f_: errors}));
		} else {
			return userInput;
		}
	});
var $author$project$Accounts$Edit$withRole = F2(
	function (role, userInput) {
		if (userInput.$ === 1) {
			var form = userInput.a;
			return $author$project$Accounts$Edit$AddingRole(
				_Utils_update(
					form,
					{
						cz: $elm$core$Maybe$Just(role)
					}));
		} else {
			return userInput;
		}
	});
var $author$project$Accounts$Edit$withSelectedDistributionPoint = F3(
	function (dpId, checked, userInput) {
		var addRemoveDP = function (dpIds) {
			if (checked) {
				return A2(
					$elm$core$List$append,
					dpIds,
					_List_fromArray(
						[dpId]));
			} else {
				return A2(
					$elm$core$List$filter,
					$elm$core$Basics$neq(dpId),
					dpIds);
			}
		};
		switch (userInput.$) {
			case 1:
				var form = userInput.a;
				return $author$project$Accounts$Edit$AddingRole(
					_Utils_update(
						form,
						{
							A: addRemoveDP(form.A)
						}));
			case 2:
				var form = userInput.a;
				return $author$project$Accounts$Edit$EditingRole(
					_Utils_update(
						form,
						{
							A: addRemoveDP(form.A)
						}));
			default:
				return userInput;
		}
	});
var $author$project$Accounts$Edit$withUserInput = F2(
	function (userInput, model) {
		return $author$project$Accounts$Edit$next(
			function () {
				if (model.$ === 1) {
					var m = model.a;
					return $author$project$Accounts$Edit$Loaded(
						_Utils_update(
							m,
							{ax: userInput}));
				} else {
					return model;
				}
			}());
	});
var $author$project$Accounts$Edit$withValidationErrors = F2(
	function (errors, userInput) {
		switch (userInput.$) {
			case 1:
				var form = userInput.a;
				return $author$project$Accounts$Edit$AddingRole(
					_Utils_update(
						form,
						{f_: errors}));
			case 2:
				var form = userInput.a;
				return $author$project$Accounts$Edit$EditingRole(
					_Utils_update(
						form,
						{f_: errors}));
			default:
				return userInput;
		}
	});
var $author$project$Portal$Return$withoutAction = F2(
	function (action, _v0) {
		var s = _v0.a;
		var m = _v0.b;
		var c = _v0.c;
		return _Utils_Tuple3(
			A2($author$project$Portal$Share$withoutWaitingAction, action, s),
			m,
			c);
	});
var $author$project$Accounts$Edit$update = F3(
	function (msg, share, model) {
		var userId = function () {
			switch (model.$) {
				case 0:
					var id = model.a;
					return id;
				case 1:
					var account = model.a.ca;
					return account.eg;
				default:
					var id = model.a;
					return id;
			}
		}();
		var withCommand = function (toAction) {
			return $author$project$Portal$Return$withCommand(
				toAction(userId));
		};
		var withoutAction = function (action) {
			return $author$project$Portal$Return$withoutAction(
				action(userId));
		};
		var token = $author$project$Portal$Share$token(share);
		var today = $author$project$Portal$Share$today(share);
		var to = function (route) {
			return _Utils_Tuple3(
				A2($author$project$Portal$Share$withNewRoute, route, share),
				model,
				$elm$core$Platform$Cmd$none);
		};
		var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		var modelChange = function (m) {
			return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
		};
		var err = F3(
			function (action, error, m) {
				return _Utils_Tuple3(
					A2(
						$author$project$Portal$Share$withHttpError,
						error,
						A2(
							$author$project$Portal$Share$withoutWaitingAction,
							action(userId),
							share)),
					m,
					$elm$core$Platform$Cmd$none);
			});
		var _v0 = _Utils_Tuple2(msg, model);
		_v0$17:
		while (true) {
			switch (_v0.a.$) {
				case 1:
					if (!_v0.a.a.$) {
						var distributionPoints = _v0.a.a.a;
						return A2(
							withoutAction,
							$author$project$Accounts$Edit$loadingDPs,
							modelChange(
								A2($author$project$Accounts$Edit$withDistributionPoints, distributionPoints, model)));
					} else {
						var error = _v0.a.a.a;
						return A3(
							err,
							$author$project$Accounts$Edit$loadingDPs,
							error,
							$author$project$Accounts$Edit$Failed(userId));
					}
				case 2:
					if (!_v0.a.a.$) {
						var authorizations = _v0.a.a.a;
						return A2(
							withoutAction,
							$author$project$Accounts$Edit$loadingAuthorizations,
							modelChange(
								A2($author$project$Accounts$Edit$withAuthorizations, authorizations, model)));
					} else {
						var error = _v0.a.a.a;
						return A3(
							err,
							$author$project$Accounts$Edit$loadingAuthorizations,
							error,
							$author$project$Accounts$Edit$Failed(userId));
					}
				case 0:
					if (!_v0.a.a.$) {
						var account = _v0.a.a.a;
						return A2(
							withoutAction,
							$author$project$Accounts$Edit$loadingAccount,
							modelChange(
								A2($author$project$Accounts$Edit$withAccount, account, model)));
					} else {
						var error = _v0.a.a.a;
						return A3(
							err,
							$author$project$Accounts$Edit$loadingAccount,
							error,
							$author$project$Accounts$Edit$Failed(userId));
					}
				case 3:
					var _v1 = _v0.a;
					return modelChange(
						A2(
							$author$project$Accounts$Edit$withUserInput,
							$author$project$Accounts$Edit$AddingRole(
								{
									A: _List_Nil,
									l2: $author$project$Date$DeliveryDate$encodeForDateInput(today),
									cz: $elm$core$Maybe$Nothing,
									f_: _List_Nil
								}),
							model));
				case 4:
					if (_v0.b.$ === 1) {
						var date = _v0.a.a;
						var m = _v0.b.a;
						return modelChange(
							A2(
								$author$project$Accounts$Edit$withUserInput,
								A2(
									$author$project$Accounts$Edit$withValidationErrors,
									_List_Nil,
									A2($author$project$Accounts$Edit$withFrom, date, m.ax)),
								model));
					} else {
						break _v0$17;
					}
				case 5:
					if (_v0.b.$ === 1) {
						var role = _v0.a.a;
						var m = _v0.b.a;
						return modelChange(
							A2(
								$author$project$Accounts$Edit$withUserInput,
								A2(
									$author$project$Accounts$Edit$withValidationErrors,
									_List_Nil,
									A2($author$project$Accounts$Edit$withRole, role, m.ax)),
								model));
					} else {
						break _v0$17;
					}
				case 8:
					if (_v0.b.$ === 1) {
						var _v2 = _v0.a;
						var distributionPointId = _v2.a;
						var checked = _v2.b;
						var m = _v0.b.a;
						return modelChange(
							A2(
								$author$project$Accounts$Edit$withUserInput,
								A2(
									$author$project$Accounts$Edit$withValidationErrors,
									_List_Nil,
									A3($author$project$Accounts$Edit$withSelectedDistributionPoint, distributionPointId, checked, m.ax)),
								model));
					} else {
						break _v0$17;
					}
				case 6:
					var _v3 = _v0.a;
					var role = _v3.a;
					var date = _v3.b;
					return modelChange(
						A2(
							$author$project$Accounts$Edit$withUserInput,
							$author$project$Accounts$Edit$EditingRole(
								{
									A: $author$project$Accounts$Authorization$distributionPointsOf(role),
									l2: $author$project$Date$DeliveryDate$encodeForDateInput(date),
									cz: $elm$core$Maybe$Just(role),
									f_: _List_Nil
								}),
							model));
				case 7:
					var _v4 = _v0.a;
					var role = _v4.a;
					var date = _v4.b;
					return modelChange(
						A2(
							$author$project$Accounts$Edit$withUserInput,
							A2(
								$author$project$Accounts$Edit$RevokeRole,
								role,
								{
									l2: $author$project$Date$DeliveryDate$encodeForDateInput(date),
									f_: _List_Nil
								}),
							model));
				case 9:
					var _v5 = _v0.a;
					return modelChange(
						A2($author$project$Accounts$Edit$withUserInput, $author$project$Accounts$Edit$NoInput, model));
				case 10:
					if (_v0.b.$ === 1) {
						var _v6 = _v0.a;
						var m = _v0.b.a;
						var revoke = F2(
							function (role, form) {
								var _v10 = A2(
									$arowM$elm_form_decoder$Form$Decoder$run,
									$author$project$Accounts$Edit$roleRevokeFormDecoder(
										$author$project$Date$DeliveryDate$toDate(today)),
									form);
								if (!_v10.$) {
									var date = _v10.a;
									return A3(
										withCommand,
										$author$project$Accounts$Edit$revokeRole,
										A5($author$project$Accounts$Authorization$revokeRoleCmd, token, userId, date, role, $author$project$Accounts$Edit$SystemHandledRoleSave),
										modelChange(
											A2(
												$author$project$Accounts$Edit$withUserInput,
												$author$project$Accounts$Edit$Submitting(m.ax),
												model)));
								} else {
									var errors = _v10.a;
									return modelChange(
										A2(
											$author$project$Accounts$Edit$withUserInput,
											A2($author$project$Accounts$Edit$withRevokeValidationErrors, errors, m.ax),
											model));
								}
							});
						var grant = function (form) {
							var _v8 = A2(
								$arowM$elm_form_decoder$Form$Decoder$run,
								$author$project$Accounts$Edit$roleFormDecoder(
									$author$project$Date$DeliveryDate$toDate(today)),
								form);
							if (!_v8.$) {
								var _v9 = _v8.a;
								var date = _v9.a;
								var role = _v9.b;
								return A3(
									withCommand,
									$author$project$Accounts$Edit$grantRole,
									A5($author$project$Accounts$Authorization$grantRoleCmd, token, userId, date, role, $author$project$Accounts$Edit$SystemHandledRoleSave),
									modelChange(
										A2(
											$author$project$Accounts$Edit$withUserInput,
											$author$project$Accounts$Edit$Submitting(m.ax),
											model)));
							} else {
								var errors = _v8.a;
								return modelChange(
									A2(
										$author$project$Accounts$Edit$withUserInput,
										A2($author$project$Accounts$Edit$withValidationErrors, errors, m.ax),
										model));
							}
						};
						var _v7 = m.ax;
						switch (_v7.$) {
							case 1:
								var form = _v7.a;
								return grant(form);
							case 2:
								var form = _v7.a;
								return grant(form);
							case 3:
								var role = _v7.a;
								var form = _v7.b;
								return A2(revoke, role, form);
							default:
								return noChange;
						}
					} else {
						break _v0$17;
					}
				case 11:
					if (!_v0.a.a.$) {
						var authorization = _v0.a.a.a;
						return A2(
							withoutAction,
							$author$project$Accounts$Edit$grantRole,
							modelChange(
								A2(
									$author$project$Accounts$Edit$withUserInput,
									$author$project$Accounts$Edit$NoInput,
									A2($author$project$Accounts$Edit$withAuthorization, authorization, model))));
					} else {
						if (_v0.b.$ === 1) {
							var error = _v0.a.a.a;
							var m = _v0.b.a;
							return A3(
								err,
								$author$project$Accounts$Edit$grantRole,
								error,
								function () {
									var _v11 = m.ax;
									if (_v11.$ === 4) {
										var u = _v11.a;
										return A2($author$project$Accounts$Edit$withUserInput, u, model);
									} else {
										return model;
									}
								}());
						} else {
							break _v0$17;
						}
					}
				default:
					var _v12 = _v0.a;
					return to($author$project$Portal$Route$Accounts);
			}
		}
		return noChange;
	});
var $author$project$Security$AccessRight$AccessDenied = 1;
var $author$project$Accounts$Overview$AccountEditing = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Accounts$Overview$AccountSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Accounts$Overview$Failed = function (a) {
	return {$: 3, a: a};
};
var $author$project$Accounts$Overview$Loaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Accounts$Overview$Loading = function (a) {
	return {$: 1, a: a};
};
var $author$project$Accounts$Overview$NoAccountSelected = {$: 0};
var $author$project$Accounts$Overview$ServerUpdatedAccount = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Accounts$Overview$SystemDisabledAccount = function (a) {
	return {$: 4, a: a};
};
var $author$project$Accounts$Overview$SystemEnabledAccount = function (a) {
	return {$: 2, a: a};
};
var $author$project$Accounts$Overview$SystemGotAccounts = function (a) {
	return {$: 0, a: a};
};
var $author$project$Accounts$Overview$SystemResendActivationAccount = function (a) {
	return {$: 10, a: a};
};
var $author$project$Security$AccessRight$AccessAllowed = 0;
var $author$project$Portal$Share$allowed = F3(
	function (fct, msg, _v0) {
		var model = _v0;
		return A3(
			$author$project$Portal$Waiting$map,
			0,
			function (_v1) {
				return fct(msg);
			},
			model.bf);
	});
var $author$project$Sorting$Accounts$byStatus = function (a) {
	var _v0 = a.nS;
	if (_v0.$ === 1) {
		return 1;
	} else {
		return 0;
	}
};
var $author$project$Sorting$Accounts$byStatusAndName = function (account) {
	return _Utils_Tuple2(
		$author$project$Sorting$Accounts$byStatus(account),
		$elm$core$String$toLower(account.os));
};
var $author$project$Accounts$Overview$StartsWithMinimalThreeRequired = 0;
var $arowM$elm_form_decoder$Form$Decoder$assert = F2(
	function (v, _v0) {
		var f = _v0;
		return $arowM$elm_form_decoder$Form$Decoder$custom(
			function (a) {
				return A2(
					$elm$core$Result$andThen,
					function (x) {
						return A2(
							$elm$core$Result$map,
							function (_v1) {
								return x;
							},
							A2($arowM$elm_form_decoder$Form$Decoder$run, v, x));
					},
					f(a));
			});
	});
var $arowM$elm_form_decoder$Form$Decoder$identity = $arowM$elm_form_decoder$Form$Decoder$custom($elm$core$Result$Ok);
var $arowM$elm_form_decoder$Form$Decoder$minLength = F2(
	function (err, bound) {
		return $arowM$elm_form_decoder$Form$Decoder$custom(
			function (str) {
				return (_Utils_cmp(
					$elm$core$String$length(str),
					bound) > -1) ? $elm$core$Result$Ok(0) : $elm$core$Result$Err(
					_List_fromArray(
						[err]));
			});
	});
var $author$project$Accounts$Overview$decodeStartsWith = A2(
	$arowM$elm_form_decoder$Form$Decoder$assert,
	A2($arowM$elm_form_decoder$Form$Decoder$minLength, 0, 3),
	$arowM$elm_form_decoder$Form$Decoder$identity);
var $author$project$Accounts$Overview$actionIdFor = function (id) {
	return A2($author$project$Portal$Waiting$Id, 'accounts', id);
};
var $author$project$Accounts$Overview$singleAction = function (id) {
	return $author$project$Portal$Waiting$singleAction(
		$author$project$Accounts$Overview$actionIdFor(id));
};
var $author$project$Accounts$Overview$disableAccount = $author$project$Accounts$Overview$singleAction('disableAccount');
var $author$project$Api$Request$patchWithoutResponse = F5(
	function (token, toMsg, url, body, tracker) {
		return $elm$http$Http$request(
			{
				aA: body,
				aJ: $elm$http$Http$expectWhatever(toMsg),
				aK: $author$project$Api$Request$headers(token),
				aO: 'PATCH',
				aS: $elm$core$Maybe$Nothing,
				aU: $author$project$Api$Request$trackingFor(tracker),
				aW: url
			});
	});
var $author$project$Accounts$Account$disableCmd = F3(
	function (token, _v0, toMsg) {
		var id = _v0.eg;
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'accounts',
					$author$project$Accounts$Account$encodeForUrl(id),
					'disable'
				]),
			_List_Nil);
		return A4(
			$author$project$Api$Request$patchWithoutResponse,
			token,
			toMsg,
			uri,
			A2($elm$http$Http$stringBody, 'text/plain', ''));
	});
var $author$project$Accounts$Overview$enableAccount = $author$project$Accounts$Overview$singleAction('enableAccount');
var $author$project$Accounts$Account$enableCmd = F3(
	function (token, _v0, toMsg) {
		var id = _v0.eg;
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'accounts',
					$author$project$Accounts$Account$encodeForUrl(id),
					'enable'
				]),
			_List_Nil);
		return A4(
			$author$project$Api$Request$patchWithoutResponse,
			token,
			toMsg,
			uri,
			A2($elm$http$Http$stringBody, 'text/plain', ''));
	});
var $arowM$elm_form_decoder$Form$Decoder$errors = F2(
	function (d, a) {
		var _v0 = A2($arowM$elm_form_decoder$Form$Decoder$run, d, a);
		if (!_v0.$) {
			return _List_Nil;
		} else {
			var errs = _v0.a;
			return errs;
		}
	});
var $elm$core$String$filter = _String_filter;
var $author$project$Accounts$Account$formFrom = function (_v0) {
	var email = _v0.d5;
	var phone = _v0.eq;
	return {d5: email, iv: _List_Nil, eq: phone, jw: _List_Nil};
};
var $author$project$Accounts$Account$getAccountsCmd = F3(
	function (token, startsWith, toMsg) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['accounts']),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'starts-with', startsWith)
				]));
		return A4(
			$author$project$Api$Request$get,
			token,
			toMsg,
			uri,
			$elm$json$Json$Decode$list($author$project$Accounts$Account$userDecoder));
	});
var $author$project$Accounts$Overview$loadingAccounts = $author$project$Accounts$Overview$singleAction('loadingAccounts');
var $author$project$Accounts$Overview$resendActivation = $author$project$Accounts$Overview$singleAction('resendActivation');
var $author$project$Api$Request$postWithoutResponse = F5(
	function (token, toMsg, url, body, tracker) {
		return $elm$http$Http$request(
			{
				aA: body,
				aJ: $elm$http$Http$expectWhatever(toMsg),
				aK: $author$project$Api$Request$headers(token),
				aO: 'POST',
				aS: $elm$core$Maybe$Nothing,
				aU: $author$project$Api$Request$trackingFor(tracker),
				aW: url
			});
	});
var $author$project$Accounts$Account$resendActivationCmd = F3(
	function (token, _v0, toMsg) {
		var id = _v0.eg;
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'accounts',
					$author$project$Accounts$Account$encodeForUrl(id)
				]),
			_List_Nil);
		return A4($author$project$Api$Request$postWithoutResponse, token, toMsg, uri, $elm$http$Http$emptyBody);
	});
var $author$project$Accounts$Overview$searchIn = function (model) {
	switch (model.$) {
		case 0:
			var search = model.a.aj;
			return search;
		case 1:
			var search = model.a.aj;
			return search;
		case 2:
			var search = model.a.aj;
			return search;
		default:
			var search = model.a.aj;
			return search;
	}
};
var $author$project$Accounts$Account$updateCmd = F3(
	function (token, _v0, toMsg) {
		var id = _v0.eg;
		var email = _v0.d5;
		var phone = _v0.eq;
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'accounts',
					$author$project$Accounts$Account$encodeForUrl(id)
				]),
			_List_Nil);
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'email',
						$elm$json$Json$Encode$string(email)),
						_Utils_Tuple2(
						'phone',
						$elm$json$Json$Encode$string(phone))
					])));
		return A4($author$project$Api$Request$patchWithoutResponse, token, toMsg, uri, body);
	});
var $author$project$Accounts$Overview$updatingAccount = $author$project$Accounts$Overview$singleAction('updatingAccount');
var $author$project$Accounts$Overview$validEmailCharacter = function (c) {
	return !A2(
		$elm$core$List$member,
		c,
		_List_fromArray(
			['\\', ' ']));
};
var $author$project$Accounts$Account$PhoneInvalidFormat = 2;
var $author$project$Accounts$Account$PhoneTooLong = 1;
var $author$project$Accounts$Account$PhoneTooShort = 0;
var $author$project$Accounts$Account$maxLength = 16;
var $arowM$elm_form_decoder$Form$Decoder$maxLength = F2(
	function (err, bound) {
		return $arowM$elm_form_decoder$Form$Decoder$custom(
			function (str) {
				return (_Utils_cmp(
					$elm$core$String$length(str),
					bound) < 1) ? $elm$core$Result$Ok(0) : $elm$core$Result$Err(
					_List_fromArray(
						[err]));
			});
	});
var $author$project$Accounts$Account$minLength = 9;
var $author$project$Accounts$Account$parser = $elm$parser$Parser$getChompedString(
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('+'))),
			$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)),
		$elm$parser$Parser$end));
var $author$project$Accounts$Account$validatePhone = function (phone) {
	var _v0 = A2(
		$arowM$elm_form_decoder$Form$Decoder$run,
		A2(
			$arowM$elm_form_decoder$Form$Decoder$assert,
			A2($arowM$elm_form_decoder$Form$Decoder$maxLength, 1, $author$project$Accounts$Account$maxLength),
			A2(
				$arowM$elm_form_decoder$Form$Decoder$assert,
				A2($arowM$elm_form_decoder$Form$Decoder$minLength, 0, $author$project$Accounts$Account$minLength),
				$arowM$elm_form_decoder$Form$Decoder$identity)),
		phone);
	if (!_v0.$) {
		var _v1 = A2($elm$parser$Parser$run, $author$project$Accounts$Account$parser, phone);
		if (!_v1.$) {
			var result = _v1.a;
			return $elm$core$Result$Ok(result);
		} else {
			return $elm$core$Result$Err(
				_List_fromArray(
					[2]));
		}
	} else {
		var errors = _v0.a;
		var _v2 = A2($elm$parser$Parser$run, $author$project$Accounts$Account$parser, phone);
		if (!_v2.$) {
			return $elm$core$Result$Err(errors);
		} else {
			return $elm$core$Result$Err(
				A2($elm$core$List$cons, 2, errors));
		}
	}
};
var $author$project$Accounts$Overview$whenWaiting = function (msg) {
	switch (msg.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 0;
		case 3:
			return 1;
		case 4:
			return 0;
		case 5:
			return 1;
		case 6:
			return 1;
		case 7:
			return 0;
		case 8:
			return 1;
		case 9:
			return 1;
		case 10:
			return 0;
		case 11:
			return 1;
		case 12:
			return 1;
		case 13:
			return 1;
		case 14:
			return 1;
		case 15:
			return 0;
		case 16:
			return 1;
		default:
			return 0;
	}
};
var $author$project$Accounts$Overview$withSearch = F2(
	function (search, model) {
		switch (model.$) {
			case 0:
				var n = model.a;
				return $author$project$Accounts$Overview$NoAccountSearched(
					_Utils_update(
						n,
						{aj: search}));
			case 1:
				var l = model.a;
				return $author$project$Accounts$Overview$Loading(
					_Utils_update(
						l,
						{aj: search}));
			case 2:
				var l = model.a;
				return $author$project$Accounts$Overview$Loaded(
					_Utils_update(
						l,
						{aj: search}));
			default:
				var f = model.a;
				return $author$project$Accounts$Overview$Failed(
					_Utils_update(
						f,
						{aj: search}));
		}
	});
var $elm_community$list_extra$List$Extra$updateIf = F3(
	function (predicate, update, list) {
		return A2(
			$elm$core$List$map,
			function (item) {
				return predicate(item) ? update(item) : item;
			},
			list);
	});
var $author$project$Accounts$Overview$withUpdatedSelected = F2(
	function (updated, loaded) {
		var updatedAccounts = A3(
			$elm_community$list_extra$List$Extra$updateIf,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.eg;
				},
				$elm$core$Basics$eq(updated.eg)),
			$elm$core$Basics$always(updated),
			loaded.dM);
		return _Utils_update(
			loaded,
			{
				dM: updatedAccounts,
				nI: $author$project$Accounts$Overview$AccountSelected(updated)
			});
	});
var $author$project$Accounts$Overview$update = F3(
	function (msg, share, model) {
		if (A3($author$project$Portal$Share$allowed, $author$project$Accounts$Overview$whenWaiting, msg, share) === 1) {
			return _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		} else {
			var token = $author$project$Portal$Share$token(share);
			var to = function (route) {
				return _Utils_Tuple3(
					A2($author$project$Portal$Share$withNewRoute, route, share),
					model,
					$elm$core$Platform$Cmd$none);
			};
			var search = $author$project$Accounts$Overview$searchIn(model);
			var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
			var onLoaded = function (f) {
				if (model.$ === 2) {
					var loaded = model.a;
					return f(loaded);
				} else {
					return noChange;
				}
			};
			var onEditing = function (f) {
				return onLoaded(
					function (loaded) {
						var selected = loaded.nI;
						switch (selected.$) {
							case 0:
								return noChange;
							case 1:
								return noChange;
							default:
								var a = selected.a;
								var form = selected.b;
								return A3(f, loaded, a, form);
						}
					});
			};
			var onSelected = function (f) {
				return onLoaded(
					function (loaded) {
						var selected = loaded.nI;
						switch (selected.$) {
							case 0:
								return noChange;
							case 1:
								var a = selected.a;
								return A2(f, loaded, a);
							default:
								var a = selected.a;
								return A2(f, loaded, a);
						}
					});
			};
			var modelChange = function (m) {
				return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
			};
			var selectedChange = function (s) {
				return onLoaded(
					function (l) {
						return modelChange(
							$author$project$Accounts$Overview$Loaded(
								_Utils_update(
									l,
									{nI: s})));
					});
			};
			var err = F3(
				function (action, error, m) {
					return _Utils_Tuple3(
						A2(
							$author$project$Portal$Share$withHttpError,
							error,
							A2($author$project$Portal$Share$withoutWaitingAction, action, share)),
						m,
						$elm$core$Platform$Cmd$none);
				});
			var command = F2(
				function (action, cmd) {
					return A3(
						$author$project$Portal$Return$withCommand,
						action,
						cmd,
						_Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none));
				});
			switch (msg.$) {
				case 0:
					if (!msg.a.$) {
						var accounts = msg.a.a;
						var sortedAccounts = A2($elm$core$List$sortBy, $author$project$Sorting$Accounts$byStatusAndName, accounts);
						return A2(
							$author$project$Portal$Return$withoutAction,
							$author$project$Accounts$Overview$loadingAccounts,
							modelChange(
								$author$project$Accounts$Overview$Loaded(
									{
										dM: sortedAccounts,
										aj: search,
										nI: A3(
											$elm_community$maybe_extra$Maybe$Extra$unwrap,
											$author$project$Accounts$Overview$NoAccountSelected,
											$author$project$Accounts$Overview$AccountSelected,
											$elm$core$List$head(sortedAccounts))
									})));
					} else {
						var error = msg.a.a;
						return A3(
							err,
							$author$project$Accounts$Overview$loadingAccounts,
							error,
							$author$project$Accounts$Overview$Failed(
								{aj: search}));
					}
				case 1:
					return onSelected(
						F2(
							function (_v1, selected) {
								return A2(
									command,
									$author$project$Accounts$Overview$enableAccount,
									A3($author$project$Accounts$Account$enableCmd, token, selected, $author$project$Accounts$Overview$SystemEnabledAccount));
							}));
				case 2:
					if (!msg.a.$) {
						return A2(
							$author$project$Portal$Return$withoutAction,
							$author$project$Accounts$Overview$enableAccount,
							onSelected(
								F2(
									function (loaded, selected) {
										return modelChange(
											$author$project$Accounts$Overview$Loaded(
												A2(
													$author$project$Accounts$Overview$withUpdatedSelected,
													_Utils_update(
														selected,
														{lN: true}),
													loaded)));
									})));
					} else {
						var error = msg.a.a;
						return A3(err, $author$project$Accounts$Overview$enableAccount, error, model);
					}
				case 3:
					return onSelected(
						F2(
							function (_v2, selected) {
								return A2(
									command,
									$author$project$Accounts$Overview$disableAccount,
									A3($author$project$Accounts$Account$disableCmd, token, selected, $author$project$Accounts$Overview$SystemDisabledAccount));
							}));
				case 4:
					if (!msg.a.$) {
						return A2(
							$author$project$Portal$Return$withoutAction,
							$author$project$Accounts$Overview$disableAccount,
							onSelected(
								F2(
									function (loaded, selected) {
										return modelChange(
											$author$project$Accounts$Overview$Loaded(
												A2(
													$author$project$Accounts$Overview$withUpdatedSelected,
													_Utils_update(
														selected,
														{lN: false}),
													loaded)));
									})));
					} else {
						var error = msg.a.a;
						return A3(err, $author$project$Accounts$Overview$disableAccount, error, model);
					}
				case 5:
					return onSelected(
						F2(
							function (_v3, selected) {
								return to(
									$author$project$Portal$Route$AccountEdit(selected.eg));
							}));
				case 6:
					return to($author$project$Portal$Route$AccountAdd);
				case 7:
					var value = msg.a;
					return modelChange(
						A2(
							$author$project$Accounts$Overview$withSearch,
							_Utils_update(
								search,
								{
									dC: A2($elm$core$String$filter, $author$project$Accounts$Overview$validEmailCharacter, value)
								}),
							model));
				case 8:
					var _v4 = A2($arowM$elm_form_decoder$Form$Decoder$run, $author$project$Accounts$Overview$decodeStartsWith, search.dC);
					if (!_v4.$) {
						return A3(
							$author$project$Portal$Return$withCommand,
							$author$project$Accounts$Overview$loadingAccounts,
							A3($author$project$Accounts$Account$getAccountsCmd, token, search.dC, $author$project$Accounts$Overview$SystemGotAccounts),
							modelChange(
								$author$project$Accounts$Overview$Loading(
									{
										aj: _Utils_update(
											search,
											{f_: _List_Nil})
									})));
					} else {
						var errors = _v4.a;
						return modelChange(
							A2(
								$author$project$Accounts$Overview$withSearch,
								_Utils_update(
									search,
									{f_: errors}),
								model));
					}
				case 9:
					return onSelected(
						F2(
							function (_v5, selected) {
								return A2(
									command,
									$author$project$Accounts$Overview$resendActivation,
									A3($author$project$Accounts$Account$resendActivationCmd, token, selected, $author$project$Accounts$Overview$SystemResendActivationAccount));
							}));
				case 10:
					if (!msg.a.$) {
						return onSelected(
							F2(
								function (_v6, selected) {
									return A2(
										$author$project$Portal$Return$withoutAction,
										$author$project$Accounts$Overview$resendActivation,
										A2(
											$author$project$Portal$Return$withMessage,
											A2($author$project$Portal$Message$info, 'Verstuurd', 'Verificatie mail verstuurd naar ' + selected.d5),
											noChange));
								}));
					} else {
						var error = msg.a.a;
						return A3(err, $author$project$Accounts$Overview$resendActivation, error, model);
					}
				case 11:
					var account = msg.a;
					return selectedChange(
						$author$project$Accounts$Overview$AccountSelected(account));
				case 12:
					return onSelected(
						F2(
							function (_v7, selected) {
								return selectedChange(
									A2(
										$author$project$Accounts$Overview$AccountEditing,
										selected,
										$author$project$Accounts$Account$formFrom(selected)));
							}));
				case 13:
					var email = msg.a;
					return onEditing(
						F3(
							function (_v8, selected, form) {
								return selectedChange(
									A2(
										$author$project$Accounts$Overview$AccountEditing,
										selected,
										_Utils_update(
											form,
											{
												d5: email,
												iv: A2($arowM$elm_form_decoder$Form$Decoder$errors, $author$project$UI$Validation$Email$decoder, email)
											})));
							}));
				case 14:
					var phone = msg.a;
					return onEditing(
						function () {
							var _v9 = $author$project$Accounts$Account$validatePhone(phone);
							if (!_v9.$) {
								var number = _v9.a;
								return F3(
									function (_v10, selected, form) {
										return selectedChange(
											A2(
												$author$project$Accounts$Overview$AccountEditing,
												selected,
												_Utils_update(
													form,
													{eq: number, jw: _List_Nil})));
									});
							} else {
								var errors = _v9.a;
								return F3(
									function (_v11, selected, form) {
										return selectedChange(
											A2(
												$author$project$Accounts$Overview$AccountEditing,
												selected,
												_Utils_update(
													form,
													{eq: phone, jw: errors})));
									});
							}
						}());
				case 15:
					return onEditing(
						F3(
							function (_v12, selected, _v13) {
								return selectedChange(
									$author$project$Accounts$Overview$AccountSelected(selected));
							}));
				case 16:
					return onEditing(
						F3(
							function (_v14, selected, form) {
								var updated = _Utils_update(
									selected,
									{d5: form.d5, eq: form.eq});
								return A3(
									$author$project$Portal$Return$withCommand,
									$author$project$Accounts$Overview$updatingAccount,
									A3(
										$author$project$Accounts$Account$updateCmd,
										token,
										updated,
										$author$project$Accounts$Overview$ServerUpdatedAccount(updated)),
									noChange);
							}));
				default:
					if (!msg.b.$) {
						var account = msg.a;
						return A2(
							$author$project$Portal$Return$withoutAction,
							$author$project$Accounts$Overview$updatingAccount,
							onLoaded(
								function (loaded) {
									return modelChange(
										$author$project$Accounts$Overview$Loaded(
											A2($author$project$Accounts$Overview$withUpdatedSelected, account, loaded)));
								}));
					} else {
						var error = msg.b.a;
						return A3(err, $author$project$Accounts$Overview$updatingAccount, error, model);
					}
			}
		}
	});
var $author$project$Applicant$Overview$AutocompleteFailed = 2;
var $author$project$Applicant$Overview$Autocompleted = 1;
var $author$project$Applicant$Overview$BackendRespondedAddress = function (a) {
	return {$: 2, a: a};
};
var $author$project$Applicant$Overview$BackendRespondedApplicant = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Applicant$Overview$BackendRespondedMinStart = function (a) {
	return {$: 4, a: a};
};
var $author$project$Applicant$Overview$BackendRespondedToCheckVatId = function (a) {
	return {$: 10, a: a};
};
var $author$project$Applicant$Overview$BackendRespondedToCreate = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Applicant$Overview$BackendRespondedToSendContract = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Applicant$Overview$BackendRespondedToUpdate = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Applicant$Overview$BackendRespondedToUpdateStatusAndDP = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Applicant$Overview$BackendRespondedToVoidContract = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Applicant$Overview$Changing = function (a) {
	return {$: 2, a: a};
};
var $author$project$Applicant$Overview$Failed = {$: 2};
var $author$project$Applicant$Overview$LoadedOverview = function (a) {
	return {$: 1, a: a};
};
var $author$project$Applicant$Overview$NoAutocomplete = 0;
var $author$project$Applicant$Overview$NoneSelected = {$: 2};
var $author$project$Applicant$Overview$Selected = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Applicant$Overview$SendingContract = function (a) {
	return {$: 3, a: a};
};
var $author$project$Applicant$Overview$UpdateStatusAndDP = function (a) {
	return {$: 1, a: a};
};
var $author$project$Applicant$Overview$VatIdInvalidAfterValidation = 1;
var $author$project$Applicant$Overview$Viewing = {$: 0};
var $author$project$Applicant$Overview$VoidingContract = function (a) {
	return {$: 4, a: a};
};
var $author$project$Applicant$Overview$rangeHouseNumber = F3(
	function (err, min, max) {
		return $arowM$elm_form_decoder$Form$Decoder$custom(
			function (input) {
				var _v0 = A2(
					$elm$core$Maybe$map,
					function (_int) {
						return (_Utils_cmp(_int, min) > 0) && (_Utils_cmp(_int, max) < 0);
					},
					$elm$core$String$toInt(input));
				if ((!_v0.$) && _v0.a) {
					return $elm$core$Result$Ok(0);
				} else {
					return $elm$core$Result$Err(
						_List_fromArray(
							[err]));
				}
			});
	});
var $author$project$Applicant$Overview$addressHouseNumberDecoder = A2(
	$arowM$elm_form_decoder$Form$Decoder$assert,
	A3($author$project$Applicant$Overview$rangeHouseNumber, 0, 0, 10000),
	A2(
		$arowM$elm_form_decoder$Form$Decoder$assert,
		A2($arowM$elm_form_decoder$Form$Decoder$minLength, 0, 1),
		$arowM$elm_form_decoder$Form$Decoder$identity));
var $justinmimbs$date$Date$Years = 0;
var $justinmimbs$date$Date$toMonths = function (rd) {
	var date = $justinmimbs$date$Date$toCalendarDate(rd);
	var wholeMonths = (12 * (date.kC - 1)) + ($justinmimbs$date$Date$monthToNumber(date.a5) - 1);
	return wholeMonths + (date.a2 / 100);
};
var $elm$core$Basics$truncate = _Basics_truncate;
var $justinmimbs$date$Date$diff = F3(
	function (unit, _v0, _v1) {
		var rd1 = _v0;
		var rd2 = _v1;
		switch (unit) {
			case 0:
				return ((($justinmimbs$date$Date$toMonths(rd2) - $justinmimbs$date$Date$toMonths(rd1)) | 0) / 12) | 0;
			case 1:
				return ($justinmimbs$date$Date$toMonths(rd2) - $justinmimbs$date$Date$toMonths(rd1)) | 0;
			case 2:
				return ((rd2 - rd1) / 7) | 0;
			default:
				return rd2 - rd1;
		}
	});
var $author$project$Date$DeliveryDate$age = F2(
	function (ageOn, bornOn) {
		return A3(
			$justinmimbs$date$Date$diff,
			0,
			$author$project$Date$DeliveryDate$toDate(bornOn),
			$author$project$Date$DeliveryDate$toDate(ageOn));
	});
var $author$project$Applicant$Nationality$Afghanistan = 0;
var $author$project$Applicant$Nationality$Albania = 1;
var $author$project$Applicant$Nationality$Algeria = 2;
var $author$project$Applicant$Nationality$Andorra = 3;
var $author$project$Applicant$Nationality$Angola = 4;
var $author$project$Applicant$Nationality$AntiguaAndBarbuda = 5;
var $author$project$Applicant$Nationality$Argentina = 6;
var $author$project$Applicant$Nationality$Armenia = 7;
var $author$project$Applicant$Nationality$Australia = 8;
var $author$project$Applicant$Nationality$Austria = 9;
var $author$project$Applicant$Nationality$Azerbaijan = 10;
var $author$project$Applicant$Nationality$Bahamas = 11;
var $author$project$Applicant$Nationality$Bahrain = 12;
var $author$project$Applicant$Nationality$Bangladesh = 13;
var $author$project$Applicant$Nationality$Barbados = 14;
var $author$project$Applicant$Nationality$Belarus = 15;
var $author$project$Applicant$Nationality$Belgium = 16;
var $author$project$Applicant$Nationality$Belize = 17;
var $author$project$Applicant$Nationality$Benin = 18;
var $author$project$Applicant$Nationality$Bermuda = 19;
var $author$project$Applicant$Nationality$Bhutan = 20;
var $author$project$Applicant$Nationality$Bolivia = 21;
var $author$project$Applicant$Nationality$BosniaHerzegovina = 22;
var $author$project$Applicant$Nationality$Botswana = 23;
var $author$project$Applicant$Nationality$Brazil = 24;
var $author$project$Applicant$Nationality$BruneiDarussalam = 25;
var $author$project$Applicant$Nationality$Bulgaria = 26;
var $author$project$Applicant$Nationality$BurkinaFaso = 27;
var $author$project$Applicant$Nationality$Burundi = 28;
var $author$project$Applicant$Nationality$Cambodia = 29;
var $author$project$Applicant$Nationality$Cameroon = 30;
var $author$project$Applicant$Nationality$Canada = 31;
var $author$project$Applicant$Nationality$CapeVerdeIslands = 32;
var $author$project$Applicant$Nationality$CentralAfricanRepublic = 33;
var $author$project$Applicant$Nationality$Chad = 34;
var $author$project$Applicant$Nationality$Chile = 35;
var $author$project$Applicant$Nationality$China = 36;
var $author$project$Applicant$Nationality$Colombia = 37;
var $author$project$Applicant$Nationality$ComoroIslands = 38;
var $author$project$Applicant$Nationality$Congo = 39;
var $author$project$Applicant$Nationality$CongoDemocraticRepublic = 40;
var $author$project$Applicant$Nationality$CostaRica = 41;
var $author$project$Applicant$Nationality$CoteDIvoire = 46;
var $author$project$Applicant$Nationality$Croatia = 42;
var $author$project$Applicant$Nationality$Cuba = 43;
var $author$project$Applicant$Nationality$Cyprus = 44;
var $author$project$Applicant$Nationality$CzechRepublic = 45;
var $author$project$Applicant$Nationality$Denmark = 47;
var $author$project$Applicant$Nationality$Djibouti = 48;
var $author$project$Applicant$Nationality$Dominica = 49;
var $author$project$Applicant$Nationality$DominicanRepublic = 50;
var $author$project$Applicant$Nationality$Ecuador = 51;
var $author$project$Applicant$Nationality$Egypt = 52;
var $author$project$Applicant$Nationality$ElSalvador = 53;
var $author$project$Applicant$Nationality$EquatorialGuinea = 54;
var $author$project$Applicant$Nationality$Eritrea = 55;
var $author$project$Applicant$Nationality$Estonia = 56;
var $author$project$Applicant$Nationality$Ethiopia = 57;
var $author$project$Applicant$Nationality$Fiji = 58;
var $author$project$Applicant$Nationality$Finland = 59;
var $author$project$Applicant$Nationality$France = 60;
var $author$project$Applicant$Nationality$Gabon = 61;
var $author$project$Applicant$Nationality$Georgia = 62;
var $author$project$Applicant$Nationality$Germany = 63;
var $author$project$Applicant$Nationality$Ghana = 64;
var $author$project$Applicant$Nationality$Greece = 65;
var $author$project$Applicant$Nationality$Grenada = 66;
var $author$project$Applicant$Nationality$Guatemala = 67;
var $author$project$Applicant$Nationality$Guinea = 68;
var $author$project$Applicant$Nationality$GuineaBissau = 69;
var $author$project$Applicant$Nationality$Guyana = 70;
var $author$project$Applicant$Nationality$Haiti = 71;
var $author$project$Applicant$Nationality$Honduras = 72;
var $author$project$Applicant$Nationality$HongKong = 73;
var $author$project$Applicant$Nationality$Hungary = 74;
var $author$project$Applicant$Nationality$Iceland = 75;
var $author$project$Applicant$Nationality$India = 76;
var $author$project$Applicant$Nationality$Indonesia = 77;
var $author$project$Applicant$Nationality$Iran = 78;
var $author$project$Applicant$Nationality$Iraq = 79;
var $author$project$Applicant$Nationality$Ireland = 80;
var $author$project$Applicant$Nationality$Israel = 81;
var $author$project$Applicant$Nationality$Italy = 82;
var $author$project$Applicant$Nationality$Jamaica = 83;
var $author$project$Applicant$Nationality$Japan = 84;
var $author$project$Applicant$Nationality$Jordan = 85;
var $author$project$Applicant$Nationality$Kazakhstan = 86;
var $author$project$Applicant$Nationality$Kenya = 87;
var $author$project$Applicant$Nationality$Kiribati = 88;
var $author$project$Applicant$Nationality$Kosovo = 91;
var $author$project$Applicant$Nationality$Kuwait = 92;
var $author$project$Applicant$Nationality$Kyrgyzstan = 93;
var $author$project$Applicant$Nationality$Laos = 94;
var $author$project$Applicant$Nationality$Latvia = 95;
var $author$project$Applicant$Nationality$Lebanon = 96;
var $author$project$Applicant$Nationality$Lesotho = 97;
var $author$project$Applicant$Nationality$Liberia = 98;
var $author$project$Applicant$Nationality$Libya = 99;
var $author$project$Applicant$Nationality$Liechtenstein = 100;
var $author$project$Applicant$Nationality$Lithuania = 101;
var $author$project$Applicant$Nationality$Luxembourg = 102;
var $author$project$Applicant$Nationality$Macao = 103;
var $author$project$Applicant$Nationality$Madagascar = 105;
var $author$project$Applicant$Nationality$Malawi = 106;
var $author$project$Applicant$Nationality$Malaysia = 107;
var $author$project$Applicant$Nationality$Maldives = 108;
var $author$project$Applicant$Nationality$Mali = 109;
var $author$project$Applicant$Nationality$Malta = 110;
var $author$project$Applicant$Nationality$MarshallIslands = 111;
var $author$project$Applicant$Nationality$Mauritania = 112;
var $author$project$Applicant$Nationality$Mauritius = 113;
var $author$project$Applicant$Nationality$Mexico = 114;
var $author$project$Applicant$Nationality$Micronesia = 115;
var $author$project$Applicant$Nationality$Moldova = 116;
var $author$project$Applicant$Nationality$Monaco = 117;
var $author$project$Applicant$Nationality$Mongolia = 118;
var $author$project$Applicant$Nationality$Montenegro = 119;
var $author$project$Applicant$Nationality$Montserrat = 120;
var $author$project$Applicant$Nationality$Morocco = 121;
var $author$project$Applicant$Nationality$Mozambique = 122;
var $author$project$Applicant$Nationality$Myanmar = 123;
var $author$project$Applicant$Nationality$Namibia = 124;
var $author$project$Applicant$Nationality$Nauru = 125;
var $author$project$Applicant$Nationality$Nepal = 127;
var $author$project$Applicant$Nationality$Netherlands = 126;
var $author$project$Applicant$Nationality$NewZealand = 128;
var $author$project$Applicant$Nationality$Nicaragua = 129;
var $author$project$Applicant$Nationality$Niger = 130;
var $author$project$Applicant$Nationality$Nigeria = 131;
var $author$project$Applicant$Nationality$NorthKorea = 89;
var $author$project$Applicant$Nationality$NorthMacedonia = 104;
var $author$project$Applicant$Nationality$Norway = 132;
var $author$project$Applicant$Nationality$Oman = 133;
var $author$project$Applicant$Nationality$Pakistan = 134;
var $author$project$Applicant$Nationality$PalauIslands = 135;
var $author$project$Applicant$Nationality$PalestinianTerritory = 136;
var $author$project$Applicant$Nationality$Panama = 137;
var $author$project$Applicant$Nationality$PapuaNewGuinea = 138;
var $author$project$Applicant$Nationality$Paraguay = 139;
var $author$project$Applicant$Nationality$Peru = 140;
var $author$project$Applicant$Nationality$Philippines = 141;
var $author$project$Applicant$Nationality$Poland = 142;
var $author$project$Applicant$Nationality$Portugal = 143;
var $author$project$Applicant$Nationality$Qatar = 144;
var $author$project$Applicant$Nationality$Romania = 145;
var $author$project$Applicant$Nationality$RussianFederation = 146;
var $author$project$Applicant$Nationality$Rwanda = 147;
var $author$project$Applicant$Nationality$SaintKittsAndNevis = 148;
var $author$project$Applicant$Nationality$SaintLucia = 149;
var $author$project$Applicant$Nationality$SaintVincentAndTheGrenadines = 150;
var $author$project$Applicant$Nationality$Samoa = 151;
var $author$project$Applicant$Nationality$SanMarino = 152;
var $author$project$Applicant$Nationality$SaoTomeAndPrincipe = 153;
var $author$project$Applicant$Nationality$SaudiArabia = 154;
var $author$project$Applicant$Nationality$Senegal = 155;
var $author$project$Applicant$Nationality$Serbia = 156;
var $author$project$Applicant$Nationality$Seychelles = 157;
var $author$project$Applicant$Nationality$SierraLeone = 158;
var $author$project$Applicant$Nationality$Singapore = 159;
var $author$project$Applicant$Nationality$Slovakia = 160;
var $author$project$Applicant$Nationality$Slovenia = 161;
var $author$project$Applicant$Nationality$SolomonIslands = 162;
var $author$project$Applicant$Nationality$Somalia = 163;
var $author$project$Applicant$Nationality$SouthAfrica = 164;
var $author$project$Applicant$Nationality$SouthKorea = 90;
var $author$project$Applicant$Nationality$SouthSudan = 165;
var $author$project$Applicant$Nationality$Spain = 166;
var $author$project$Applicant$Nationality$SriLanka = 167;
var $author$project$Applicant$Nationality$Sudan = 168;
var $author$project$Applicant$Nationality$Suriname = 169;
var $author$project$Applicant$Nationality$Swaziland = 170;
var $author$project$Applicant$Nationality$Sweden = 171;
var $author$project$Applicant$Nationality$Switzerland = 172;
var $author$project$Applicant$Nationality$Syria = 173;
var $author$project$Applicant$Nationality$Taiwan = 174;
var $author$project$Applicant$Nationality$Tajikistan = 175;
var $author$project$Applicant$Nationality$Tanzania = 176;
var $author$project$Applicant$Nationality$Thailand = 177;
var $author$project$Applicant$Nationality$TheGambia = 178;
var $author$project$Applicant$Nationality$TimorLeste = 179;
var $author$project$Applicant$Nationality$Togo = 180;
var $author$project$Applicant$Nationality$Tonga = 181;
var $author$project$Applicant$Nationality$TrinidadAndTobago = 182;
var $author$project$Applicant$Nationality$Tunisia = 183;
var $author$project$Applicant$Nationality$Turkey = 184;
var $author$project$Applicant$Nationality$Turkmenistan = 185;
var $author$project$Applicant$Nationality$Tuvalu = 186;
var $author$project$Applicant$Nationality$Uganda = 187;
var $author$project$Applicant$Nationality$Ukraine = 188;
var $author$project$Applicant$Nationality$UnitedArabEmirates = 189;
var $author$project$Applicant$Nationality$UnitedKingdom = 190;
var $author$project$Applicant$Nationality$UnitedStates = 191;
var $author$project$Applicant$Nationality$Uruguay = 192;
var $author$project$Applicant$Nationality$Uzbekistan = 193;
var $author$project$Applicant$Nationality$Vanuatu = 194;
var $author$project$Applicant$Nationality$VaticanCity = 195;
var $author$project$Applicant$Nationality$Venezuela = 196;
var $author$project$Applicant$Nationality$Vietnam = 197;
var $author$project$Applicant$Nationality$Yemen = 198;
var $author$project$Applicant$Nationality$Zambia = 199;
var $author$project$Applicant$Nationality$Zimbabwe = 200;
var $author$project$Applicant$Nationality$all = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200]);
var $author$project$Applicant$Nationality$dutch = 126;
var $author$project$Applicant$Applicant$defaultNationality = $author$project$Applicant$Nationality$dutch;
var $elm_community$list_extra$List$Extra$reverseAppend = F2(
	function (list1, list2) {
		return A3($elm$core$List$foldl, $elm$core$List$cons, list2, list1);
	});
var $elm_community$list_extra$List$Extra$removeHelp = F4(
	function (list, x, xs, previousElements) {
		removeHelp:
		while (true) {
			if (!xs.b) {
				return list;
			} else {
				var y = xs.a;
				var ys = xs.b;
				if (_Utils_eq(x, y)) {
					return A2($elm_community$list_extra$List$Extra$reverseAppend, previousElements, ys);
				} else {
					var $temp$list = list,
						$temp$x = x,
						$temp$xs = ys,
						$temp$previousElements = A2($elm$core$List$cons, y, previousElements);
					list = $temp$list;
					x = $temp$x;
					xs = $temp$xs;
					previousElements = $temp$previousElements;
					continue removeHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$remove = F2(
	function (x, xs) {
		return A4($elm_community$list_extra$List$Extra$removeHelp, xs, x, xs, _List_Nil);
	});
var $author$project$Applicant$Nationality$view = function (nationality) {
	switch (nationality) {
		case 0:
			return 'Afghaans';
		case 1:
			return 'Albanees';
		case 2:
			return 'Algerijns';
		case 3:
			return 'Andorrees';
		case 4:
			return 'Angolees';
		case 5:
			return 'Antiguaans en Barbudiaans';
		case 6:
			return 'Argentijns';
		case 7:
			return 'Armeens';
		case 8:
			return 'Australisch';
		case 9:
			return 'Oostenrijks';
		case 10:
			return 'Azerbeidzjaans';
		case 11:
			return 'Bahamiaans';
		case 12:
			return 'Bahreins';
		case 13:
			return 'Bengaals';
		case 14:
			return 'Barbadiaans';
		case 15:
			return 'Wit-Russisch';
		case 16:
			return 'Belgisch';
		case 17:
			return 'Beliziaans';
		case 18:
			return 'Benins';
		case 19:
			return 'Bermudiaans';
		case 20:
			return 'Bhutanees';
		case 21:
			return 'Boliviaans';
		case 22:
			return 'Bosnisch';
		case 23:
			return 'Botswaans';
		case 24:
			return 'Braziliaans';
		case 25:
			return 'Bruneiaans';
		case 26:
			return 'Bulgaars';
		case 27:
			return 'Burkinees';
		case 28:
			return 'Burundees';
		case 29:
			return 'Cambodjaans';
		case 30:
			return 'Kameroens';
		case 31:
			return 'Canadees';
		case 32:
			return 'Kaapverdisch';
		case 33:
			return 'Centraal-Afrikaans';
		case 34:
			return 'Tsjadisch';
		case 35:
			return 'Chileens';
		case 36:
			return 'Chinees';
		case 37:
			return 'Colombiaans';
		case 38:
			return 'Comorees';
		case 39:
			return 'Congolees';
		case 40:
			return 'Congolees';
		case 41:
			return 'Costa Ricaans';
		case 42:
			return 'Kroatisch';
		case 43:
			return 'Cubaans';
		case 44:
			return 'Cypriotisch';
		case 45:
			return 'Tsjechisch';
		case 46:
			return 'Ivoriaans';
		case 47:
			return 'Deens';
		case 48:
			return 'Djiboutiaans';
		case 49:
			return 'Dominicaans';
		case 50:
			return 'Dominicaans';
		case 51:
			return 'Ecuadoraans';
		case 52:
			return 'Egyptisch';
		case 53:
			return 'Salvadoraans';
		case 54:
			return 'Equatoriaal-Guinees';
		case 55:
			return 'Eritrees';
		case 56:
			return 'Ests';
		case 57:
			return 'Ethiopisch';
		case 58:
			return 'Fijisch';
		case 59:
			return 'Fins';
		case 60:
			return 'Frans';
		case 61:
			return 'Gabonees';
		case 62:
			return 'Georgisch';
		case 63:
			return 'Duits';
		case 64:
			return 'Ghanees';
		case 65:
			return 'Grieks';
		case 66:
			return 'Grenadiaans';
		case 67:
			return 'Guatemalteeks';
		case 68:
			return 'Guinees';
		case 69:
			return 'Guinee-Bissau';
		case 70:
			return 'Guyanees';
		case 71:
			return 'Haïtiaans';
		case 72:
			return 'Hondurees';
		case 73:
			return 'Hongkongs';
		case 74:
			return 'Hongaars';
		case 75:
			return 'IJslands';
		case 76:
			return 'Indiaas';
		case 77:
			return 'Indonesisch';
		case 78:
			return 'Iraans';
		case 79:
			return 'Iraaks';
		case 80:
			return 'Iers';
		case 81:
			return 'Israëlisch';
		case 82:
			return 'Italiaans';
		case 83:
			return 'Jamaicaans';
		case 84:
			return 'Japans';
		case 85:
			return 'Jordanees';
		case 86:
			return 'Kazachs';
		case 87:
			return 'Keniaans';
		case 88:
			return 'Kiribatisch';
		case 89:
			return 'Noord-Koreaans';
		case 90:
			return 'Zuid-Koreaans';
		case 91:
			return 'Kosovaars';
		case 92:
			return 'Koeweits';
		case 93:
			return 'Kirgizisch';
		case 94:
			return 'Laotiaans';
		case 95:
			return 'Lets';
		case 96:
			return 'Libanees';
		case 97:
			return 'Lesothaans';
		case 98:
			return 'Liberiaans';
		case 99:
			return 'Libisch';
		case 100:
			return 'Liechtensteins';
		case 101:
			return 'Litouws';
		case 102:
			return 'Luxemburgs';
		case 103:
			return 'Macaus';
		case 104:
			return 'Macedonisch';
		case 105:
			return 'Malagassisch';
		case 106:
			return 'Malawisch';
		case 107:
			return 'Maleisisch';
		case 108:
			return 'Maldivisch';
		case 109:
			return 'Malinees';
		case 110:
			return 'Maltees';
		case 111:
			return 'Marshallees';
		case 112:
			return 'Mauritaans';
		case 113:
			return 'Mauritiaans';
		case 114:
			return 'Mexicaans';
		case 115:
			return 'Micronesisch';
		case 116:
			return 'Moldavisch';
		case 117:
			return 'Monegaskisch';
		case 118:
			return 'Mongools';
		case 119:
			return 'Montenegrijns';
		case 120:
			return 'Montserrataans';
		case 121:
			return 'Marokkaans';
		case 122:
			return 'Mozambikaans';
		case 123:
			return 'Myanmarees';
		case 124:
			return 'Namibisch';
		case 125:
			return 'Nauruaans';
		case 126:
			return 'Nederlands';
		case 127:
			return 'Nepalees';
		case 128:
			return 'Nieuw-Zeelands';
		case 129:
			return 'Nicaraguaans';
		case 130:
			return 'Nigerees';
		case 131:
			return 'Nigeriaans';
		case 132:
			return 'Noors';
		case 133:
			return 'Omaans';
		case 134:
			return 'Pakistaans';
		case 135:
			return 'Palaus';
		case 136:
			return 'Palestijns';
		case 137:
			return 'Panamees';
		case 138:
			return 'Papoea-Nieuw-Guinees';
		case 139:
			return 'Paraguayaans';
		case 140:
			return 'Peruviaans';
		case 141:
			return 'Filipijns';
		case 142:
			return 'Pools';
		case 143:
			return 'Portugees';
		case 144:
			return 'Qatarees';
		case 145:
			return 'Roemeens';
		case 146:
			return 'Russisch';
		case 147:
			return 'Rwandees';
		case 148:
			return 'Kittiaans of Nevisiaans';
		case 149:
			return 'Saint-Luciaan';
		case 150:
			return 'Saint Vincentiaan en de Grenadines';
		case 151:
			return 'Samoaan';
		case 152:
			return 'San Marinees';
		case 153:
			return 'Sao Tomé en Principe';
		case 154:
			return 'Saoedi-Arabisch';
		case 155:
			return 'Senegalees';
		case 156:
			return 'Servisch';
		case 157:
			return 'Seychels';
		case 158:
			return 'Sierra Leoons';
		case 159:
			return 'Singaporees';
		case 160:
			return 'Slowaaks';
		case 161:
			return 'Sloveens';
		case 162:
			return 'Solomonseilands';
		case 163:
			return 'Somalisch';
		case 164:
			return 'Zuid-Afrikaans';
		case 165:
			return 'Zuid-Soedanees';
		case 166:
			return 'Spaans';
		case 167:
			return 'Sri Lankaans';
		case 168:
			return 'Soedanees';
		case 169:
			return 'Surinaams';
		case 170:
			return 'Swazisch';
		case 171:
			return 'Zweeds';
		case 172:
			return 'Zwitsers';
		case 173:
			return 'Syrisch';
		case 174:
			return 'Taiwanees';
		case 175:
			return 'Tadzjieks';
		case 176:
			return 'Tanzaniaans';
		case 177:
			return 'Thais';
		case 178:
			return 'Gambiaans';
		case 179:
			return 'Oost-Timorees';
		case 180:
			return 'Togolees';
		case 181:
			return 'Tongaans';
		case 182:
			return 'Trinidadiaans en Tobagaan';
		case 183:
			return 'Tunesisch';
		case 184:
			return 'Turks';
		case 185:
			return 'Turkmenistaans';
		case 186:
			return 'Tuvaluaans';
		case 187:
			return 'Oegandees';
		case 188:
			return 'Oekraïens';
		case 189:
			return 'Emiratisch';
		case 190:
			return 'Brits';
		case 191:
			return 'Amerikaans';
		case 192:
			return 'Uruguayaans';
		case 193:
			return 'Oezbeeks';
		case 194:
			return 'Vanuatuaans';
		case 195:
			return 'Vaticaans';
		case 196:
			return 'Venezolaans';
		case 197:
			return 'Vietnamees';
		case 198:
			return 'Jemenitisch';
		case 199:
			return 'Zambiaans';
		default:
			return 'Zimbabwaans';
	}
};
var $author$project$Applicant$Applicant$availableNationalities = function (identificationType) {
	if (!identificationType.$) {
		switch (identificationType.a) {
			case 0:
				var _v1 = identificationType.a;
				return _List_fromArray(
					[$author$project$Applicant$Nationality$dutch]);
			case 1:
				var _v2 = identificationType.a;
				return _List_fromArray(
					[$author$project$Applicant$Nationality$dutch]);
			case 2:
				var _v3 = identificationType.a;
				return A2(
					$elm$core$List$sortBy,
					$author$project$Applicant$Nationality$view,
					A2($elm_community$list_extra$List$Extra$remove, $author$project$Applicant$Nationality$dutch, $author$project$Applicant$Nationality$all));
			default:
				var _v4 = identificationType.a;
				return A2(
					$elm$core$List$sortBy,
					$author$project$Applicant$Nationality$view,
					A2($elm_community$list_extra$List$Extra$remove, $author$project$Applicant$Nationality$dutch, $author$project$Applicant$Nationality$all));
		}
	} else {
		return _List_fromArray(
			[$author$project$Applicant$Applicant$defaultNationality]);
	}
};
var $author$project$Applicant$Applicant$checkVatId = F3(
	function (token, toMsg, vatId) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['applicants', 'check-vat-number']),
			_List_Nil);
		return A4(
			$author$project$Api$Request$postWithoutResponse,
			token,
			toMsg,
			uri,
			$elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'vatNumber',
							$elm$json$Json$Encode$string(
								A2($elm$core$String$dropLeft, 2, vatId)))
						]))));
	});
var $author$project$Applicant$Applicant$contractSendStatus = $author$project$Applicant$Applicant$ContractAtDistributor;
var $author$project$Applicant$Applicant$contractVoidStatus = $author$project$Applicant$Applicant$Registered;
var $author$project$Applicant$Applicant$Applicant = function (id) {
	return function (salutation) {
		return function (initials) {
			return function (firstName) {
				return function (prefix) {
					return function (lastName) {
						return function (companyName) {
							return function (bornOn) {
								return function (email) {
									return function (phone) {
										return function (nationality) {
											return function (bestReachable) {
												return function (address) {
													return function (addedOn) {
														return function (availability) {
															return function (distributionPointId) {
																return function (closestDPs) {
																	return function (status) {
																		return function (comment) {
																			return function (iban) {
																				return function (bsn) {
																					return function (vatId) {
																						return function (kvkNumber) {
																							return function (parentName) {
																								return function (parentEmailAddress) {
																									return function (contractType) {
																										return function (identificationType) {
																											return function (identificationNumber) {
																												return function (identificationExpiryDate) {
																													return function (assessment) {
																														return {hP: addedOn, f1: address, dQ: assessment, cY: availability, ga: bestReachable, c$: bornOn, gd: bsn, h2: closestDPs, gg: comment, eU: companyName, gh: contractType, c2: distributionPointId, d5: email, fc: firstName, gE: iban, eg: id, gF: identificationExpiryDate, gG: identificationNumber, gH: identificationType, gI: initials, gM: kvkNumber, fo: lastName, gZ: nationality, g7: parentEmailAddress, g8: parentName, eq: phone, fF: prefix, hi: salutation, nS: status, hF: vatId};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Applicant$Applicant$Phone = 1;
var $author$project$Applicant$Applicant$Regular = 0;
var $author$project$Applicant$Applicant$Availability = F2(
	function (start, days) {
		return {e1: days, hq: start};
	});
var $author$project$Date$DaysInTheWeek$empty = {e1: $Gizra$elm_all_set$EverySet$empty, da: 0, bB: 0};
var $author$project$Date$DaysInTheWeek$insert = F2(
	function (day, _v0) {
		var d = _v0;
		return _Utils_update(
			d,
			{
				e1: A2($Gizra$elm_all_set$EverySet$insert, day, d.e1)
			});
	});
var $author$project$Date$DaysInTheWeek$weekdayDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		switch (s) {
			case 'monday':
				return $elm$json$Json$Decode$succeed(0);
			case 'tuesday':
				return $elm$json$Json$Decode$succeed(1);
			case 'wednesday':
				return $elm$json$Json$Decode$succeed(2);
			case 'thursday':
				return $elm$json$Json$Decode$succeed(3);
			case 'friday':
				return $elm$json$Json$Decode$succeed(4);
			case 'saturday':
				return $elm$json$Json$Decode$succeed(5);
			case 'sunday':
				return $elm$json$Json$Decode$succeed(6);
			default:
				return $elm$json$Json$Decode$fail('Invalid Weekday: ' + s);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Applicant$Applicant$availabilityDecoder = function (today) {
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'days',
		A2(
			$elm$json$Json$Decode$map,
			A2($elm$core$List$foldl, $author$project$Date$DaysInTheWeek$insert, $author$project$Date$DaysInTheWeek$empty),
			$elm$json$Json$Decode$list($author$project$Date$DaysInTheWeek$weekdayDecoder)),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'start',
			$author$project$Date$DeliveryDate$decoder,
			today,
			$elm$json$Json$Decode$succeed($author$project$Applicant$Applicant$Availability)));
};
var $author$project$Applicant$Applicant$Email = 2;
var $author$project$Applicant$Applicant$WhatsApp = 0;
var $author$project$Applicant$Applicant$bestReachableDecoder = function (s) {
	switch (s) {
		case '':
			return $elm$json$Json$Decode$succeed(1);
		case 'Whatsapp':
			return $elm$json$Json$Decode$succeed(0);
		case 'Bellen':
			return $elm$json$Json$Decode$succeed(1);
		case 'E-mail':
			return $elm$json$Json$Decode$succeed(2);
		default:
			return $elm$json$Json$Decode$fail('unrecognized bestReachable');
	}
};
var $author$project$Applicant$Applicant$Company = 3;
var $author$project$Applicant$Applicant$Fictive = 1;
var $author$project$Applicant$Applicant$ParentalSigning = 2;
var $author$project$Applicant$Applicant$contractTypeDecoder = function (s) {
	switch (s) {
		case 'Regular':
			return $elm$json$Json$Decode$succeed(0);
		case 'Fictive':
			return $elm$json$Json$Decode$succeed(1);
		case 'Parental signing':
			return $elm$json$Json$Decode$succeed(2);
		case 'Company':
			return $elm$json$Json$Decode$succeed(3);
		default:
			return $elm$json$Json$Decode$fail('unrecognized contract type');
	}
};
var $author$project$Applicant$Nationality$decoder = function (nationality) {
	switch (nationality) {
		case 'AF':
			return $elm$json$Json$Decode$succeed(0);
		case 'AL':
			return $elm$json$Json$Decode$succeed(1);
		case 'DZ':
			return $elm$json$Json$Decode$succeed(2);
		case 'AS':
			return $elm$json$Json$Decode$succeed(151);
		case 'AD':
			return $elm$json$Json$Decode$succeed(3);
		case 'AO':
			return $elm$json$Json$Decode$succeed(4);
		case 'AG':
			return $elm$json$Json$Decode$succeed(5);
		case 'AR':
			return $elm$json$Json$Decode$succeed(6);
		case 'AM':
			return $elm$json$Json$Decode$succeed(7);
		case 'AU':
			return $elm$json$Json$Decode$succeed(8);
		case 'AT':
			return $elm$json$Json$Decode$succeed(9);
		case 'AZ':
			return $elm$json$Json$Decode$succeed(10);
		case 'BS':
			return $elm$json$Json$Decode$succeed(11);
		case 'BH':
			return $elm$json$Json$Decode$succeed(12);
		case 'BD':
			return $elm$json$Json$Decode$succeed(13);
		case 'BB':
			return $elm$json$Json$Decode$succeed(14);
		case 'BY':
			return $elm$json$Json$Decode$succeed(15);
		case 'BE':
			return $elm$json$Json$Decode$succeed(16);
		case 'BZ':
			return $elm$json$Json$Decode$succeed(17);
		case 'BJ':
			return $elm$json$Json$Decode$succeed(18);
		case 'BM':
			return $elm$json$Json$Decode$succeed(19);
		case 'BT':
			return $elm$json$Json$Decode$succeed(20);
		case 'BO':
			return $elm$json$Json$Decode$succeed(21);
		case 'BA':
			return $elm$json$Json$Decode$succeed(22);
		case 'BW':
			return $elm$json$Json$Decode$succeed(23);
		case 'BR':
			return $elm$json$Json$Decode$succeed(24);
		case 'BN':
			return $elm$json$Json$Decode$succeed(25);
		case 'BG':
			return $elm$json$Json$Decode$succeed(26);
		case 'BF':
			return $elm$json$Json$Decode$succeed(27);
		case 'BI':
			return $elm$json$Json$Decode$succeed(28);
		case 'KH':
			return $elm$json$Json$Decode$succeed(29);
		case 'CM':
			return $elm$json$Json$Decode$succeed(30);
		case 'CA':
			return $elm$json$Json$Decode$succeed(31);
		case 'CV':
			return $elm$json$Json$Decode$succeed(32);
		case 'CF':
			return $elm$json$Json$Decode$succeed(33);
		case 'TD':
			return $elm$json$Json$Decode$succeed(34);
		case 'CL':
			return $elm$json$Json$Decode$succeed(35);
		case 'CN':
			return $elm$json$Json$Decode$succeed(36);
		case 'CO':
			return $elm$json$Json$Decode$succeed(37);
		case 'KM':
			return $elm$json$Json$Decode$succeed(38);
		case 'CG':
			return $elm$json$Json$Decode$succeed(39);
		case 'CD':
			return $elm$json$Json$Decode$succeed(40);
		case 'CR':
			return $elm$json$Json$Decode$succeed(41);
		case 'HR':
			return $elm$json$Json$Decode$succeed(42);
		case 'CU':
			return $elm$json$Json$Decode$succeed(43);
		case 'CY':
			return $elm$json$Json$Decode$succeed(44);
		case 'CZ':
			return $elm$json$Json$Decode$succeed(45);
		case 'CI':
			return $elm$json$Json$Decode$succeed(46);
		case 'DK':
			return $elm$json$Json$Decode$succeed(47);
		case 'DJ':
			return $elm$json$Json$Decode$succeed(48);
		case 'DM':
			return $elm$json$Json$Decode$succeed(49);
		case 'DO':
			return $elm$json$Json$Decode$succeed(50);
		case 'EC':
			return $elm$json$Json$Decode$succeed(51);
		case 'EG':
			return $elm$json$Json$Decode$succeed(52);
		case 'SV':
			return $elm$json$Json$Decode$succeed(53);
		case 'GQ':
			return $elm$json$Json$Decode$succeed(54);
		case 'ER':
			return $elm$json$Json$Decode$succeed(55);
		case 'EE':
			return $elm$json$Json$Decode$succeed(56);
		case 'ET':
			return $elm$json$Json$Decode$succeed(57);
		case 'FJ':
			return $elm$json$Json$Decode$succeed(58);
		case 'FI':
			return $elm$json$Json$Decode$succeed(59);
		case 'FR':
			return $elm$json$Json$Decode$succeed(60);
		case 'GA':
			return $elm$json$Json$Decode$succeed(61);
		case 'GE':
			return $elm$json$Json$Decode$succeed(62);
		case 'DE':
			return $elm$json$Json$Decode$succeed(63);
		case 'GH':
			return $elm$json$Json$Decode$succeed(64);
		case 'GR':
			return $elm$json$Json$Decode$succeed(65);
		case 'GD':
			return $elm$json$Json$Decode$succeed(66);
		case 'GT':
			return $elm$json$Json$Decode$succeed(67);
		case 'GN':
			return $elm$json$Json$Decode$succeed(68);
		case 'GW':
			return $elm$json$Json$Decode$succeed(69);
		case 'GY':
			return $elm$json$Json$Decode$succeed(70);
		case 'HT':
			return $elm$json$Json$Decode$succeed(71);
		case 'HN':
			return $elm$json$Json$Decode$succeed(72);
		case 'HK':
			return $elm$json$Json$Decode$succeed(73);
		case 'HU':
			return $elm$json$Json$Decode$succeed(74);
		case 'IS':
			return $elm$json$Json$Decode$succeed(75);
		case 'IN':
			return $elm$json$Json$Decode$succeed(76);
		case 'ID':
			return $elm$json$Json$Decode$succeed(77);
		case 'IR':
			return $elm$json$Json$Decode$succeed(78);
		case 'IQ':
			return $elm$json$Json$Decode$succeed(79);
		case 'IE':
			return $elm$json$Json$Decode$succeed(80);
		case 'IL':
			return $elm$json$Json$Decode$succeed(81);
		case 'IT':
			return $elm$json$Json$Decode$succeed(82);
		case 'JM':
			return $elm$json$Json$Decode$succeed(83);
		case 'JP':
			return $elm$json$Json$Decode$succeed(84);
		case 'JO':
			return $elm$json$Json$Decode$succeed(85);
		case 'KZ':
			return $elm$json$Json$Decode$succeed(86);
		case 'KE':
			return $elm$json$Json$Decode$succeed(87);
		case 'KI':
			return $elm$json$Json$Decode$succeed(88);
		case 'KP':
			return $elm$json$Json$Decode$succeed(89);
		case 'KR':
			return $elm$json$Json$Decode$succeed(90);
		case 'XK':
			return $elm$json$Json$Decode$succeed(91);
		case 'KW':
			return $elm$json$Json$Decode$succeed(92);
		case 'KG':
			return $elm$json$Json$Decode$succeed(93);
		case 'LA':
			return $elm$json$Json$Decode$succeed(94);
		case 'LV':
			return $elm$json$Json$Decode$succeed(95);
		case 'LB':
			return $elm$json$Json$Decode$succeed(96);
		case 'LS':
			return $elm$json$Json$Decode$succeed(97);
		case 'LR':
			return $elm$json$Json$Decode$succeed(98);
		case 'LY':
			return $elm$json$Json$Decode$succeed(99);
		case 'LI':
			return $elm$json$Json$Decode$succeed(100);
		case 'LT':
			return $elm$json$Json$Decode$succeed(101);
		case 'LU':
			return $elm$json$Json$Decode$succeed(102);
		case 'MO':
			return $elm$json$Json$Decode$succeed(103);
		case 'MG':
			return $elm$json$Json$Decode$succeed(105);
		case 'MW':
			return $elm$json$Json$Decode$succeed(106);
		case 'MY':
			return $elm$json$Json$Decode$succeed(107);
		case 'MV':
			return $elm$json$Json$Decode$succeed(108);
		case 'ML':
			return $elm$json$Json$Decode$succeed(109);
		case 'MT':
			return $elm$json$Json$Decode$succeed(110);
		case 'MH':
			return $elm$json$Json$Decode$succeed(111);
		case 'MQ':
			return $elm$json$Json$Decode$succeed(112);
		case 'MR':
			return $elm$json$Json$Decode$succeed(113);
		case 'MU':
			return $elm$json$Json$Decode$succeed(113);
		case 'MX':
			return $elm$json$Json$Decode$succeed(114);
		case 'FM':
			return $elm$json$Json$Decode$succeed(115);
		case 'MD':
			return $elm$json$Json$Decode$succeed(116);
		case 'MC':
			return $elm$json$Json$Decode$succeed(117);
		case 'MN':
			return $elm$json$Json$Decode$succeed(118);
		case 'ME':
			return $elm$json$Json$Decode$succeed(119);
		case 'MS':
			return $elm$json$Json$Decode$succeed(120);
		case 'MA':
			return $elm$json$Json$Decode$succeed(121);
		case 'MZ':
			return $elm$json$Json$Decode$succeed(122);
		case 'MM':
			return $elm$json$Json$Decode$succeed(123);
		case 'NA':
			return $elm$json$Json$Decode$succeed(124);
		case 'NR':
			return $elm$json$Json$Decode$succeed(125);
		case 'NL':
			return $elm$json$Json$Decode$succeed(126);
		case 'NP':
			return $elm$json$Json$Decode$succeed(127);
		case 'NZ':
			return $elm$json$Json$Decode$succeed(128);
		case 'NI':
			return $elm$json$Json$Decode$succeed(129);
		case 'NE':
			return $elm$json$Json$Decode$succeed(130);
		case 'NG':
			return $elm$json$Json$Decode$succeed(131);
		case 'NO':
			return $elm$json$Json$Decode$succeed(132);
		case 'MK':
			return $elm$json$Json$Decode$succeed(104);
		case 'OM':
			return $elm$json$Json$Decode$succeed(133);
		case 'PK':
			return $elm$json$Json$Decode$succeed(134);
		case 'PS':
			return $elm$json$Json$Decode$succeed(136);
		case 'PA':
			return $elm$json$Json$Decode$succeed(137);
		case 'PG':
			return $elm$json$Json$Decode$succeed(138);
		case 'PY':
			return $elm$json$Json$Decode$succeed(139);
		case 'PE':
			return $elm$json$Json$Decode$succeed(140);
		case 'PH':
			return $elm$json$Json$Decode$succeed(141);
		case 'PL':
			return $elm$json$Json$Decode$succeed(142);
		case 'PT':
			return $elm$json$Json$Decode$succeed(143);
		case 'QA':
			return $elm$json$Json$Decode$succeed(144);
		case 'RO':
			return $elm$json$Json$Decode$succeed(145);
		case 'RU':
			return $elm$json$Json$Decode$succeed(146);
		case 'RW':
			return $elm$json$Json$Decode$succeed(147);
		case 'KN':
			return $elm$json$Json$Decode$succeed(148);
		case 'LC':
			return $elm$json$Json$Decode$succeed(149);
		case 'VC':
			return $elm$json$Json$Decode$succeed(150);
		case 'WS':
			return $elm$json$Json$Decode$succeed(151);
		case 'SM':
			return $elm$json$Json$Decode$succeed(152);
		case 'ST':
			return $elm$json$Json$Decode$succeed(153);
		case 'SA':
			return $elm$json$Json$Decode$succeed(154);
		case 'SN':
			return $elm$json$Json$Decode$succeed(155);
		case 'RS':
			return $elm$json$Json$Decode$succeed(156);
		case 'SC':
			return $elm$json$Json$Decode$succeed(157);
		case 'SL':
			return $elm$json$Json$Decode$succeed(158);
		case 'SG':
			return $elm$json$Json$Decode$succeed(159);
		case 'SK':
			return $elm$json$Json$Decode$succeed(160);
		case 'SI':
			return $elm$json$Json$Decode$succeed(161);
		case 'SB':
			return $elm$json$Json$Decode$succeed(162);
		case 'SO':
			return $elm$json$Json$Decode$succeed(163);
		case 'ZA':
			return $elm$json$Json$Decode$succeed(164);
		case 'SS':
			return $elm$json$Json$Decode$succeed(165);
		case 'ES':
			return $elm$json$Json$Decode$succeed(166);
		case 'LK':
			return $elm$json$Json$Decode$succeed(167);
		case 'SD':
			return $elm$json$Json$Decode$succeed(168);
		case 'SR':
			return $elm$json$Json$Decode$succeed(169);
		case 'SZ':
			return $elm$json$Json$Decode$succeed(170);
		case 'SE':
			return $elm$json$Json$Decode$succeed(171);
		case 'CH':
			return $elm$json$Json$Decode$succeed(172);
		case 'SY':
			return $elm$json$Json$Decode$succeed(173);
		case 'TW':
			return $elm$json$Json$Decode$succeed(174);
		case 'TJ':
			return $elm$json$Json$Decode$succeed(175);
		case 'TZ':
			return $elm$json$Json$Decode$succeed(176);
		case 'TH':
			return $elm$json$Json$Decode$succeed(177);
		case 'GM':
			return $elm$json$Json$Decode$succeed(178);
		case 'TL':
			return $elm$json$Json$Decode$succeed(179);
		case 'TG':
			return $elm$json$Json$Decode$succeed(180);
		case 'TO':
			return $elm$json$Json$Decode$succeed(181);
		case 'TT':
			return $elm$json$Json$Decode$succeed(182);
		case 'TN':
			return $elm$json$Json$Decode$succeed(183);
		case 'TR':
			return $elm$json$Json$Decode$succeed(184);
		case 'TM':
			return $elm$json$Json$Decode$succeed(185);
		case 'TV':
			return $elm$json$Json$Decode$succeed(186);
		case 'UG':
			return $elm$json$Json$Decode$succeed(187);
		case 'UA':
			return $elm$json$Json$Decode$succeed(188);
		case 'AE':
			return $elm$json$Json$Decode$succeed(189);
		case 'GB':
			return $elm$json$Json$Decode$succeed(190);
		case 'US':
			return $elm$json$Json$Decode$succeed(191);
		case 'UY':
			return $elm$json$Json$Decode$succeed(192);
		case 'UZ':
			return $elm$json$Json$Decode$succeed(193);
		case 'VU':
			return $elm$json$Json$Decode$succeed(194);
		case 'VA':
			return $elm$json$Json$Decode$succeed(195);
		case 'VE':
			return $elm$json$Json$Decode$succeed(196);
		case 'VN':
			return $elm$json$Json$Decode$succeed(197);
		case 'YE':
			return $elm$json$Json$Decode$succeed(198);
		case 'ZM':
			return $elm$json$Json$Decode$succeed(199);
		case 'ZW':
			return $elm$json$Json$Decode$succeed(200);
		default:
			return $elm$json$Json$Decode$fail('unrecognized nationality');
	}
};
var $author$project$Applicant$Applicant$DPWithDistance = F3(
	function (id, name, distance) {
		return {lG: distance, eg: id, ft: name};
	});
var $author$project$Applicant$Applicant$dpWithDistanceDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'distance',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$author$project$DistributionPoint$DistributionPoint$idDecoder,
			$elm$json$Json$Decode$succeed($author$project$Applicant$Applicant$DPWithDistance))));
var $author$project$Applicant$Applicant$DutchAlienDocument = 2;
var $author$project$Applicant$Applicant$DutchIdentityCard = 1;
var $author$project$Applicant$Applicant$DutchPassport = 0;
var $author$project$Applicant$Applicant$ForeignEERIdentification = 3;
var $author$project$Applicant$Applicant$identificationTypeDecoder = function (s) {
	switch (s) {
		case '':
			return $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
		case 'Passport':
			return $elm$json$Json$Decode$succeed(
				$elm$core$Maybe$Just(0));
		case 'Dutch identity card':
			return $elm$json$Json$Decode$succeed(
				$elm$core$Maybe$Just(1));
		case 'Dutch alien registration document':
			return $elm$json$Json$Decode$succeed(
				$elm$core$Maybe$Just(2));
		case 'Foreign passport or identity card from an EER country':
			return $elm$json$Json$Decode$succeed(
				$elm$core$Maybe$Just(3));
		default:
			return $elm$json$Json$Decode$fail('unrecognized identification type');
	}
};
var $author$project$Applicant$Applicant$Female = 1;
var $author$project$Applicant$Applicant$Firm = 2;
var $author$project$Applicant$Applicant$Male = 0;
var $author$project$Applicant$Applicant$salutationDecoder = function (s) {
	switch (s) {
		case '':
			return $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
		case 'male':
			return $elm$json$Json$Decode$succeed(
				$elm$core$Maybe$Just(0));
		case 'female':
			return $elm$json$Json$Decode$succeed(
				$elm$core$Maybe$Just(1));
		case 'firm':
			return $elm$json$Json$Decode$succeed(
				$elm$core$Maybe$Just(2));
		default:
			return $elm$json$Json$Decode$fail('unrecognized identification type');
	}
};
var $author$project$Applicant$Applicant$decoder = F2(
	function (today, timezone) {
		return A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'passedAssessment',
			A2($elm$json$Json$Decode$andThen, $author$project$Applicant$Applicant$passedAssessmentDecoder, $elm$json$Json$Decode$bool),
			1,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'identificationExpiryDate',
				$elm$json$Json$Decode$maybe($author$project$Date$DeliveryDate$decoder),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'identificationNumber',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'identificationType',
						A2($elm$json$Json$Decode$andThen, $author$project$Applicant$Applicant$identificationTypeDecoder, $elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'contractType',
							A2($elm$json$Json$Decode$andThen, $author$project$Applicant$Applicant$contractTypeDecoder, $elm$json$Json$Decode$string),
							0,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'parentEmailAddress',
								$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'parentName',
									$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'kvkNumber',
										$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'vatID',
											$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
											$elm$core$Maybe$Nothing,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'bsn',
												$elm$json$Json$Decode$string,
												'',
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'iban',
													$elm$json$Json$Decode$string,
													'',
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'comment',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'status',
															$author$project$Applicant$Applicant$statusDecoder,
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'closestDPs',
																$elm$json$Json$Decode$list($author$project$Applicant$Applicant$dpWithDistanceDecoder),
																_List_Nil,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'distributionPointId',
																	$author$project$DistributionPoint$DistributionPoint$idDecoder,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'availability',
																		$author$project$Applicant$Applicant$availabilityDecoder(today),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'createdDate',
																			A2(
																				$elm$json$Json$Decode$map,
																				$author$project$Date$DeliveryDate$fromPosix(timezone),
																				$elm_community$json_extra$Json$Decode$Extra$datetime),
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'address',
																				$author$project$Address$Address$decoder,
																				A4(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																					'bestReachable',
																					A2($elm$json$Json$Decode$andThen, $author$project$Applicant$Applicant$bestReachableDecoder, $elm$json$Json$Decode$string),
																					1,
																					A4(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																						'nationality',
																						A2($elm$json$Json$Decode$andThen, $author$project$Applicant$Nationality$decoder, $elm$json$Json$Decode$string),
																						$author$project$Applicant$Applicant$defaultNationality,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'primaryPhoneNumber',
																							$elm$json$Json$Decode$string,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'emailAddress',
																								$elm$json$Json$Decode$string,
																								A4(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																									'dateOfBirth',
																									$elm$json$Json$Decode$maybe($author$project$Date$DeliveryDate$decoder),
																									$elm$core$Maybe$Nothing,
																									A4(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																										'companyName',
																										$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
																										$elm$core$Maybe$Nothing,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'lastName',
																											$elm$json$Json$Decode$string,
																											A4(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																												'prefix',
																												$elm$json$Json$Decode$string,
																												'',
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'firstName',
																													$elm$json$Json$Decode$string,
																													A4(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																														'initials',
																														$elm$json$Json$Decode$string,
																														'',
																														A4(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																															'gender',
																															A2($elm$json$Json$Decode$andThen, $author$project$Applicant$Applicant$salutationDecoder, $elm$json$Json$Decode$string),
																															$elm$core$Maybe$Nothing,
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'id',
																																$elm$json$Json$Decode$maybe($author$project$Applicant$Applicant$idDecoder),
																																$elm$json$Json$Decode$succeed($author$project$Applicant$Applicant$Applicant)))))))))))))))))))))))))))))));
	});
var $pzp1997$assoc_list$AssocList$keys = function (_v0) {
	var alist = _v0;
	return A2($elm$core$List$map, $elm$core$Tuple$first, alist);
};
var $Gizra$elm_all_set$EverySet$toList = function (_v0) {
	var d = _v0;
	return $pzp1997$assoc_list$AssocList$keys(d);
};
var $author$project$Date$DaysInTheWeek$encode = function (_v0) {
	var days = _v0.e1;
	return A2(
		$elm$json$Json$Encode$list,
		$elm$json$Json$Encode$string,
		A2(
			$elm$core$List$map,
			function (d) {
				switch (d) {
					case 0:
						return 'monday';
					case 1:
						return 'tuesday';
					case 2:
						return 'wednesday';
					case 3:
						return 'thursday';
					case 4:
						return 'friday';
					case 5:
						return 'saturday';
					default:
						return 'sunday';
				}
			},
			A2(
				$elm$core$List$sortBy,
				function (d) {
					switch (d) {
						case 0:
							return 0;
						case 1:
							return 1;
						case 2:
							return 2;
						case 3:
							return 3;
						case 4:
							return 4;
						case 5:
							return 5;
						default:
							return 6;
					}
				},
				$Gizra$elm_all_set$EverySet$toList(days))));
};
var $author$project$Applicant$Applicant$availabilityEncoder = function (_v0) {
	var start = _v0.hq;
	var days = _v0.e1;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'start',
				$author$project$Date$DeliveryDate$encode(start)),
				_Utils_Tuple2(
				'days',
				$author$project$Date$DaysInTheWeek$encode(days))
			]));
};
var $author$project$Applicant$Applicant$bestReachableToString = function (bestReachable) {
	switch (bestReachable) {
		case 0:
			return 'WhatsApp';
		case 1:
			return 'Bellen';
		default:
			return 'E-mail';
	}
};
var $author$project$Applicant$Applicant$contractTypeToString = function (contractType) {
	switch (contractType) {
		case 0:
			return 'Regular';
		case 1:
			return 'Fictive';
		case 2:
			return 'Parental signing';
		default:
			return 'Company';
	}
};
var $elm$json$Json$Encode$float = _Json_wrap;
var $mgold$elm_geojson$GeoJson$encodeBbox = function (bbox) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (b) {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'bbox',
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$float, b))
					]);
			},
			bbox));
};
var $mgold$elm_geojson$GeoJson$encodePosition = function (_v0) {
	var a = _v0.a;
	var b = _v0.b;
	var c = _v0.c;
	var coordinates = (!c) ? _List_fromArray(
		[a, b]) : _List_fromArray(
		[a, b, c]);
	return A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$float, coordinates);
};
var $mgold$elm_geojson$GeoJson$encodeGeometry = function (geom) {
	switch (geom.$) {
		case 0:
			var data = geom.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Point')),
					_Utils_Tuple2(
					'coordinates',
					$mgold$elm_geojson$GeoJson$encodePosition(data))
				]);
		case 1:
			var data = geom.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('MultiPoint')),
					_Utils_Tuple2(
					'coordinates',
					A2($elm$json$Json$Encode$list, $mgold$elm_geojson$GeoJson$encodePosition, data))
				]);
		case 2:
			var data = geom.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('LineString')),
					_Utils_Tuple2(
					'coordinates',
					A2($elm$json$Json$Encode$list, $mgold$elm_geojson$GeoJson$encodePosition, data))
				]);
		case 3:
			var data = geom.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('MultiLineString')),
					_Utils_Tuple2(
					'coordinates',
					A2(
						$elm$json$Json$Encode$list,
						$elm$json$Json$Encode$list($mgold$elm_geojson$GeoJson$encodePosition),
						data))
				]);
		case 4:
			var data = geom.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Polygon')),
					_Utils_Tuple2(
					'coordinates',
					A2(
						$elm$json$Json$Encode$list,
						$elm$json$Json$Encode$list($mgold$elm_geojson$GeoJson$encodePosition),
						data))
				]);
		case 5:
			var data = geom.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('MultiPolygon')),
					_Utils_Tuple2(
					'coordinates',
					A2(
						$elm$json$Json$Encode$list,
						$elm$json$Json$Encode$list(
							$elm$json$Json$Encode$list($mgold$elm_geojson$GeoJson$encodePosition)),
						data))
				]);
		default:
			var data = geom.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('GeometryCollection')),
					_Utils_Tuple2(
					'geometries',
					A2(
						$elm$json$Json$Encode$list,
						A2($elm$core$Basics$composeR, $mgold$elm_geojson$GeoJson$encodeGeometry, $elm$json$Json$Encode$object),
						data))
				]);
	}
};
var $mgold$elm_geojson$GeoJson$encodeFeature = function (_v0) {
	var geometry = _v0.l4;
	var properties = _v0.jK;
	var id = _v0.eg;
	var encodedId = function () {
		if (id.$ === 1) {
			return _List_Nil;
		} else {
			var theId = id.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(theId))
				]);
		}
	}();
	return _Utils_ap(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Feature')),
				_Utils_Tuple2(
				'geometry',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, $mgold$elm_geojson$GeoJson$encodeGeometry, $elm$json$Json$Encode$object),
						geometry))),
				_Utils_Tuple2('properties', properties)
			]),
		encodedId);
};
var $mgold$elm_geojson$GeoJson$encodeGeoJson = function (geojson) {
	switch (geojson.$) {
		case 1:
			var feature = geojson.a;
			return $mgold$elm_geojson$GeoJson$encodeFeature(feature);
		case 2:
			var features = geojson.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('FeatureCollection')),
					_Utils_Tuple2(
					'features',
					A2(
						$elm$json$Json$Encode$list,
						A2($elm$core$Basics$composeR, $mgold$elm_geojson$GeoJson$encodeFeature, $elm$json$Json$Encode$object),
						features))
				]);
		default:
			var geometry = geojson.a;
			return $mgold$elm_geojson$GeoJson$encodeGeometry(geometry);
	}
};
var $mgold$elm_geojson$GeoJson$encode = function (_v0) {
	var geojson = _v0.a;
	var bbox = _v0.b;
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			$mgold$elm_geojson$GeoJson$encodeGeoJson(geojson),
			$mgold$elm_geojson$GeoJson$encodeBbox(bbox)));
};
var $author$project$Address$Address$encodeCountryCode = function (countryCode) {
	switch (countryCode) {
		case 0:
			return $elm$json$Json$Encode$string('NL');
		case 1:
			return $elm$json$Json$Encode$string('BE');
		case 2:
			return $elm$json$Json$Encode$string('DE');
		default:
			return $elm$json$Json$Encode$null;
	}
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$Address$Address$encodeHouseNumber = function (houseNumber) {
	var _v0 = houseNumber.dE;
	if (!_v0.$) {
		var suffix = _v0.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'number',
					$elm$json$Json$Encode$int(houseNumber.bX)),
					_Utils_Tuple2(
					'suffix',
					$elm$json$Json$Encode$string(suffix))
				]));
	} else {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'number',
					$elm$json$Json$Encode$int(houseNumber.bX))
				]));
	}
};
var $elm_community$json_extra$Json$Encode$Extra$maybe = function (encoder) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(encoder),
		$elm$core$Maybe$withDefault($elm$json$Json$Encode$null));
};
var $author$project$Address$Address$encode = function (address) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'municipal',
				$elm$json$Json$Encode$string(address.bU)),
				_Utils_Tuple2(
				'street',
				$elm$json$Json$Encode$string(address.b5)),
				_Utils_Tuple2(
				'zipCode',
				$elm$json$Json$Encode$string(address.cT)),
				_Utils_Tuple2(
				'houseNumber',
				$author$project$Address$Address$encodeHouseNumber(address.bs)),
				_Utils_Tuple2(
				'countryCode',
				$author$project$Address$Address$encodeCountryCode(address.h8)),
				_Utils_Tuple2(
				'location',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $mgold$elm_geojson$GeoJson$encode, address.i3))
			]));
};
var $author$project$Applicant$Nationality$encoder = function (country) {
	switch (country) {
		case 0:
			return 'AF';
		case 1:
			return 'AL';
		case 2:
			return 'DZ';
		case 3:
			return 'AD';
		case 4:
			return 'AO';
		case 5:
			return 'AG';
		case 6:
			return 'AR';
		case 7:
			return 'AM';
		case 8:
			return 'AU';
		case 9:
			return 'AT';
		case 10:
			return 'AZ';
		case 11:
			return 'BS';
		case 12:
			return 'BH';
		case 13:
			return 'BD';
		case 14:
			return 'BB';
		case 15:
			return 'BY';
		case 16:
			return 'BE';
		case 17:
			return 'BZ';
		case 18:
			return 'BJ';
		case 19:
			return 'BM';
		case 20:
			return 'BT';
		case 21:
			return 'BO';
		case 22:
			return 'BA';
		case 23:
			return 'BW';
		case 24:
			return 'BR';
		case 25:
			return 'BN';
		case 26:
			return 'BG';
		case 27:
			return 'BF';
		case 28:
			return 'BI';
		case 29:
			return 'KH';
		case 30:
			return 'CM';
		case 31:
			return 'CA';
		case 32:
			return 'CV';
		case 33:
			return 'CF';
		case 34:
			return 'TD';
		case 35:
			return 'CL';
		case 36:
			return 'CN';
		case 37:
			return 'CO';
		case 38:
			return 'KM';
		case 39:
			return 'CG';
		case 40:
			return 'CD';
		case 41:
			return 'CR';
		case 42:
			return 'HR';
		case 43:
			return 'CU';
		case 44:
			return 'CY';
		case 45:
			return 'CZ';
		case 46:
			return 'CI';
		case 47:
			return 'DK';
		case 48:
			return 'DJ';
		case 49:
			return 'DM';
		case 50:
			return 'DO';
		case 51:
			return 'EC';
		case 52:
			return 'EG';
		case 53:
			return 'SV';
		case 54:
			return 'GQ';
		case 55:
			return 'ER';
		case 56:
			return 'EE';
		case 57:
			return 'ET';
		case 58:
			return 'FJ';
		case 59:
			return 'FI';
		case 60:
			return 'FR';
		case 61:
			return 'GA';
		case 62:
			return 'GE';
		case 63:
			return 'DE';
		case 64:
			return 'GH';
		case 65:
			return 'GR';
		case 66:
			return 'GD';
		case 67:
			return 'GT';
		case 68:
			return 'GN';
		case 69:
			return 'GW';
		case 70:
			return 'GY';
		case 71:
			return 'HT';
		case 72:
			return 'HN';
		case 73:
			return 'HK';
		case 74:
			return 'HU';
		case 75:
			return 'IS';
		case 76:
			return 'IN';
		case 77:
			return 'ID';
		case 78:
			return 'IR';
		case 79:
			return 'IQ';
		case 80:
			return 'IE';
		case 81:
			return 'IL';
		case 82:
			return 'IT';
		case 83:
			return 'JM';
		case 84:
			return 'JP';
		case 85:
			return 'JO';
		case 86:
			return 'KZ';
		case 87:
			return 'KE';
		case 88:
			return 'KI';
		case 89:
			return 'KP';
		case 90:
			return 'KR';
		case 91:
			return 'XK';
		case 92:
			return 'KW';
		case 93:
			return 'KG';
		case 94:
			return 'LA';
		case 95:
			return 'LV';
		case 96:
			return 'LB';
		case 97:
			return 'LS';
		case 98:
			return 'LR';
		case 99:
			return 'LY';
		case 100:
			return 'LI';
		case 101:
			return 'LT';
		case 102:
			return 'LU';
		case 103:
			return 'MO';
		case 105:
			return 'MG';
		case 106:
			return 'MW';
		case 107:
			return 'MY';
		case 108:
			return 'MV';
		case 109:
			return 'ML';
		case 110:
			return 'MT';
		case 111:
			return 'MH';
		case 112:
			return 'MR';
		case 113:
			return 'MU';
		case 114:
			return 'MX';
		case 115:
			return 'FM';
		case 116:
			return 'MD';
		case 117:
			return 'MC';
		case 118:
			return 'MN';
		case 119:
			return 'ME';
		case 120:
			return 'MS';
		case 121:
			return 'MA';
		case 122:
			return 'MZ';
		case 123:
			return 'MM';
		case 124:
			return 'NA';
		case 125:
			return 'NR';
		case 126:
			return 'NL';
		case 127:
			return 'NP';
		case 128:
			return 'NZ';
		case 129:
			return 'NI';
		case 130:
			return 'NE';
		case 131:
			return 'NG';
		case 104:
			return 'MK';
		case 132:
			return 'NO';
		case 133:
			return 'OM';
		case 134:
			return 'PK';
		case 135:
			return 'PW';
		case 136:
			return 'PS';
		case 137:
			return 'PA';
		case 138:
			return 'PG';
		case 139:
			return 'PY';
		case 140:
			return 'PE';
		case 141:
			return 'PH';
		case 142:
			return 'PL';
		case 143:
			return 'PT';
		case 144:
			return 'QA';
		case 145:
			return 'RO';
		case 146:
			return 'RU';
		case 147:
			return 'RW';
		case 148:
			return 'KN';
		case 149:
			return 'LC';
		case 150:
			return 'VC';
		case 151:
			return 'WS';
		case 152:
			return 'SM';
		case 153:
			return 'ST';
		case 154:
			return 'SA';
		case 155:
			return 'SN';
		case 156:
			return 'RS';
		case 157:
			return 'SC';
		case 158:
			return 'SL';
		case 159:
			return 'SG';
		case 160:
			return 'SK';
		case 161:
			return 'SI';
		case 162:
			return 'SB';
		case 163:
			return 'SO';
		case 164:
			return 'ZA';
		case 165:
			return 'SS';
		case 166:
			return 'ES';
		case 167:
			return 'LK';
		case 168:
			return 'SD';
		case 169:
			return 'SR';
		case 170:
			return 'SZ';
		case 171:
			return 'SE';
		case 172:
			return 'CH';
		case 173:
			return 'SY';
		case 174:
			return 'TW';
		case 175:
			return 'TJ';
		case 176:
			return 'TZ';
		case 177:
			return 'TH';
		case 178:
			return 'GM';
		case 179:
			return 'TL';
		case 180:
			return 'TG';
		case 181:
			return 'TO';
		case 182:
			return 'TT';
		case 183:
			return 'TN';
		case 184:
			return 'TR';
		case 185:
			return 'TM';
		case 186:
			return 'TV';
		case 187:
			return 'UG';
		case 188:
			return 'UA';
		case 189:
			return 'AE';
		case 190:
			return 'GB';
		case 191:
			return 'US';
		case 192:
			return 'UY';
		case 193:
			return 'UZ';
		case 194:
			return 'VU';
		case 195:
			return 'VA';
		case 196:
			return 'VE';
		case 197:
			return 'VN';
		case 198:
			return 'YE';
		case 199:
			return 'ZM';
		default:
			return 'ZW';
	}
};
var $author$project$Applicant$Applicant$idEncoder = function (_v0) {
	var id = _v0;
	return $danyx23$elm_uuid$Uuid$encode(id);
};
var $author$project$Applicant$Applicant$identificationTypeToString = function (identificationType) {
	if (!identificationType.$) {
		switch (identificationType.a) {
			case 0:
				var _v1 = identificationType.a;
				return 'Passport';
			case 1:
				var _v2 = identificationType.a;
				return 'Dutch identity card';
			case 2:
				var _v3 = identificationType.a;
				return 'Dutch alien registration document';
			default:
				var _v4 = identificationType.a;
				return 'Foreign passport or identity card from an EER country';
		}
	} else {
		return '';
	}
};
var $author$project$Applicant$Applicant$salutationToString = function (salutation) {
	if (!salutation.$) {
		switch (salutation.a) {
			case 0:
				var _v1 = salutation.a;
				return 'male';
			case 1:
				var _v2 = salutation.a;
				return 'female';
			default:
				var _v3 = salutation.a;
				return 'firm';
		}
	} else {
		return '';
	}
};
var $author$project$Applicant$Applicant$statusView = function (status) {
	switch (status.$) {
		case 0:
			return 'Aanmelding';
		case 1:
			return 'Nog niet bereikt';
		case 2:
			return 'Gesprek';
		case 3:
			return 'TWV aanvraag';
		case 4:
			return 'Wachtlijst';
		case 5:
			return 'Bij distributeur';
		case 6:
			return 'Bij kandidaat';
		case 7:
			return 'Bij ouder/voogd';
		case 8:
			return 'Bij DPG';
		case 9:
			return 'Ondertekend door allen';
		case 10:
			return 'Start';
		case 11:
			return 'Niet bereikt';
		case 12:
			return 'Afwijzing: Leeftijd';
		case 13:
			return 'Afwijzing: Niet Serieus';
		case 14:
			return 'Afwijzing: Geen wijk';
		case 15:
			return 'Afwijzing: Bezorggebied';
		case 16:
			return 'Afwijzing: Niet geschikt';
		case 17:
			return 'Afgehaakt: Vergoeding';
		case 18:
			return 'Afgehaakt: Ander werk';
		case 19:
			return 'Afgehaakt: Overig';
		case 20:
			return 'Dubbele aanmelding';
		default:
			var unknown = status.a;
			return unknown;
	}
};
var $author$project$Applicant$Applicant$encode = function (applicant) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$json$Json$Encode$string(''),
					$author$project$Applicant$Applicant$idEncoder,
					applicant.eg)),
				_Utils_Tuple2(
				'initials',
				$elm$json$Json$Encode$string(applicant.gI)),
				_Utils_Tuple2(
				'firstName',
				$elm$json$Json$Encode$string(applicant.fc)),
				_Utils_Tuple2(
				'prefix',
				$elm$json$Json$Encode$string(applicant.fF)),
				_Utils_Tuple2(
				'lastname',
				$elm$json$Json$Encode$string(applicant.fo)),
				_Utils_Tuple2(
				'companyName',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, applicant.eU)),
				_Utils_Tuple2(
				'gender',
				$elm$json$Json$Encode$string(
					$author$project$Applicant$Applicant$salutationToString(applicant.hi))),
				_Utils_Tuple2(
				'dateOfBirth',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $author$project$Date$DeliveryDate$encode, applicant.c$)),
				_Utils_Tuple2(
				'emailAddress',
				$elm$json$Json$Encode$string(applicant.d5)),
				_Utils_Tuple2(
				'primaryPhoneNumber',
				$elm$json$Json$Encode$string(applicant.eq)),
				_Utils_Tuple2(
				'nationality',
				$elm$json$Json$Encode$string(
					$author$project$Applicant$Nationality$encoder(applicant.gZ))),
				_Utils_Tuple2(
				'bestReachable',
				$elm$json$Json$Encode$string(
					$author$project$Applicant$Applicant$bestReachableToString(applicant.ga))),
				_Utils_Tuple2(
				'address',
				$author$project$Address$Address$encode(applicant.f1)),
				_Utils_Tuple2(
				'availability',
				$author$project$Applicant$Applicant$availabilityEncoder(applicant.cY)),
				_Utils_Tuple2(
				'status',
				$elm$json$Json$Encode$string(
					$author$project$Applicant$Applicant$statusView(applicant.nS))),
				_Utils_Tuple2(
				'comment',
				$elm$json$Json$Encode$string(applicant.gg)),
				_Utils_Tuple2(
				'distributionPointId',
				$author$project$DistributionPoint$DistributionPoint$encodeId(applicant.c2)),
				_Utils_Tuple2(
				'iban',
				$elm$json$Json$Encode$string(applicant.gE)),
				_Utils_Tuple2(
				'bsn',
				$elm$json$Json$Encode$string(applicant.gd)),
				_Utils_Tuple2(
				'vatId',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, applicant.hF)),
				_Utils_Tuple2(
				'kvkNumber',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, applicant.gM)),
				_Utils_Tuple2(
				'parentName',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, applicant.g8)),
				_Utils_Tuple2(
				'parentEmailAddress',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, applicant.g7)),
				_Utils_Tuple2(
				'contractType',
				$elm$json$Json$Encode$string(
					$author$project$Applicant$Applicant$contractTypeToString(applicant.gh))),
				_Utils_Tuple2(
				'identificationType',
				$elm$json$Json$Encode$string(
					$author$project$Applicant$Applicant$identificationTypeToString(applicant.gH))),
				_Utils_Tuple2(
				'identificationNumber',
				$elm$json$Json$Encode$string(applicant.gG)),
				_Utils_Tuple2(
				'identificationExpiryDate',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $author$project$Date$DeliveryDate$encode, applicant.gF))
			]));
};
var $author$project$Applicant$Applicant$createCmd = F5(
	function (token, toMsg, applicant, timezone, today) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['applicants']),
			_List_Nil);
		var body = $elm$http$Http$jsonBody(
			$author$project$Applicant$Applicant$encode(applicant));
		return A5(
			$author$project$Api$Request$post,
			token,
			toMsg,
			uri,
			body,
			A2($author$project$Applicant$Applicant$decoder, today, timezone));
	});
var $author$project$Applicant$Overview$creating = function (_v0) {
	return A2($author$project$Applicant$Overview$singleAction, 'create', $elm$core$Maybe$Nothing);
};
var $author$project$Applicant$Overview$decodeRememberedDpFilter = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $Gizra$elm_all_set$EverySet$fromList, $elm$json$Json$Decode$succeed),
	$elm$json$Json$Decode$list($author$project$DistributionPoint$DistributionPoint$idDecoder));
var $author$project$Applicant$Overview$GotDistributionPointDropdownMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Applicant$Overview$UserSelectedDistributionPointInDropdown = function (a) {
	return {$: 53, a: a};
};
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$autocomplete = function (bool) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $mdgriffith$elm_ui$Internal$Model$AlignX = function (a) {
	return {$: 6, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$Right = 2;
var $mdgriffith$elm_ui$Element$alignRight = $mdgriffith$elm_ui$Internal$Model$AlignX(2);
var $mdgriffith$elm_ui$Internal$Model$Class = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$classes = {eI: 'a', f$: 'atv', kF: 'ab', kG: 'cx', kH: 'cy', kI: 'acb', kJ: 'accx', kK: 'accy', kL: 'acr', hQ: 'al', eJ: 'ar', eK: 'at', f2: 'ah', f3: 'av', kQ: 's', kY: 'bh', eM: 'b', k$: 'w7', k2: 'bd', k3: 'bdt', eO: 'bn', k4: 'bs', eQ: 'cpe', lg: 'cp', lh: 'cpx', li: 'cpy', dV: 'c', eX: 'ctr', eY: 'cb', eZ: 'ccx', bI: 'ccy', dZ: 'cl', e_: 'cr', lp: 'ct', lv: 'cptr', lw: 'ctxt', db: 'fcs', iE: 'focus-within', l3: 'fs', l7: 'g', gB: 'hbh', gC: 'hc', iL: 'he', gD: 'hf', iM: 'hfp', mf: 'hv', mh: 'ic', mj: 'fr', fk: 'lbl', mn: 'iml', mo: 'imlf', mp: 'imlp', mq: 'implw', mr: 'it', mu: 'i', i1: 'lnk', dj: 'nb', jm: 'notxt', m$: 'ol', m1: 'or', cu: 'oq', na: 'oh', cv: 'pg', jt: 'p', nd: 'ppe', nz: 'ui', dv: 'r', nB: 'sb', nC: 'sbx', nD: 'sby', nE: 'sbt', nM: 'e', nN: 'cap', nQ: 'sev', nX: 'sk', n3: 't', n4: 'tc', n5: 'w8', n6: 'w2', n7: 'w9', n8: 'tj', fV: 'tja', n9: 'tl', oa: 'w3', ob: 'w5', oc: 'w4', od: 'tr', oe: 'w6', of: 'w1', og: 'tun', ks: 'ts', cN: 'clr', on: 'u', hI: 'wc', kA: 'we', hJ: 'wf', kB: 'wfp', hL: 'wrp'};
var $mdgriffith$elm_ui$Internal$Flag$Flag = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$Second = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$flag = function (i) {
	return (i > 31) ? $mdgriffith$elm_ui$Internal$Flag$Second(1 << (i - 32)) : $mdgriffith$elm_ui$Internal$Flag$Flag(1 << i);
};
var $mdgriffith$elm_ui$Internal$Flag$overflow = $mdgriffith$elm_ui$Internal$Flag$flag(20);
var $mdgriffith$elm_ui$Element$clipX = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$overflow, $mdgriffith$elm_ui$Internal$Style$classes.lh);
var $mdgriffith$elm_ui$Internal$Model$Colored = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $mdgriffith$elm_ui$Internal$Model$StyleClass = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$bgColor = $mdgriffith$elm_ui$Internal$Flag$flag(8);
var $mdgriffith$elm_ui$Internal$Model$floatClass = function (x) {
	return $elm$core$String$fromInt(
		$elm$core$Basics$round(x * 255));
};
var $mdgriffith$elm_ui$Internal$Model$formatColorClass = function (_v0) {
	var red = _v0.a;
	var green = _v0.b;
	var blue = _v0.c;
	var alpha = _v0.d;
	return $mdgriffith$elm_ui$Internal$Model$floatClass(red) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(green) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(blue) + ('-' + $mdgriffith$elm_ui$Internal$Model$floatClass(alpha))))));
};
var $mdgriffith$elm_ui$Element$Background$color = function (clr) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$bgColor,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Colored,
			'bg-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(clr),
			'background-color',
			clr));
};
var $mdgriffith$elm_ui$Internal$Flag$borderColor = $mdgriffith$elm_ui$Internal$Flag$flag(28);
var $mdgriffith$elm_ui$Element$Border$color = function (clr) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$borderColor,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Colored,
			'bc-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(clr),
			'border-color',
			clr));
};
var $mdgriffith$elm_ui$Internal$Flag$fontColor = $mdgriffith$elm_ui$Internal$Flag$flag(14);
var $mdgriffith$elm_ui$Element$Font$color = function (fontColor) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$fontColor,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Colored,
			'fc-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(fontColor),
			'color',
			fontColor));
};
var $mdgriffith$elm_ui$Internal$Model$Rgba = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $mdgriffith$elm_ui$Element$rgb255 = F3(
	function (red, green, blue) {
		return A4($mdgriffith$elm_ui$Internal$Model$Rgba, red / 255, green / 255, blue / 255, 1);
	});
var $tesk9$palette$Internal$Color$RGBA = function (a) {
	return {$: 1, a: a};
};
var $tesk9$palette$Internal$RGBA$Color = $elm$core$Basics$identity;
var $tesk9$palette$Internal$RGBA$fromChannels = function (_v0) {
	var red = _v0.no;
	var green = _v0.l6;
	var blue = _v0.k_;
	var alpha = _v0.kN;
	return {
		kN: alpha,
		k_: A3($elm$core$Basics$clamp, 0, 255, blue),
		l6: A3($elm$core$Basics$clamp, 0, 255, green),
		no: A3($elm$core$Basics$clamp, 0, 255, red)
	};
};
var $tesk9$palette$Internal$RGBA$fromHSLA = function (hsl) {
	var hue = hsl.iN;
	var alpha = hsl.kN;
	var saturation = hsl.jV / 100;
	var lightness = hsl.i0 / 100;
	var hueIsBetween = F2(
		function (lowerBound, upperBound) {
			return (_Utils_cmp(lowerBound, hue) < 1) && (_Utils_cmp(hue, upperBound) < 1);
		});
	var chroma = (1 - $elm$core$Basics$abs((2 * lightness) - 1)) * saturation;
	var lightnessModifier = lightness - (chroma / 2);
	var zigUp = function (xIntercept) {
		return (chroma * (hue - xIntercept)) / 60;
	};
	var zigDown = function (xIntercept) {
		return (-1) * zigUp(xIntercept);
	};
	var _v0 = A2(hueIsBetween, 0, 60) ? _Utils_Tuple3(
		chroma,
		zigUp(0),
		0) : (A2(hueIsBetween, 60, 120) ? _Utils_Tuple3(
		zigDown(120),
		chroma,
		0) : (A2(hueIsBetween, 120, 180) ? _Utils_Tuple3(
		0,
		chroma,
		zigUp(120)) : (A2(hueIsBetween, 180, 240) ? _Utils_Tuple3(
		0,
		zigDown(240),
		chroma) : (A2(hueIsBetween, 240, 300) ? _Utils_Tuple3(
		zigUp(240),
		0,
		chroma) : _Utils_Tuple3(
		chroma,
		0,
		zigDown(360))))));
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	return $tesk9$palette$Internal$RGBA$fromChannels(
		{kN: alpha, k_: (b + lightnessModifier) * 255, l6: (g + lightnessModifier) * 255, no: (r + lightnessModifier) * 255});
};
var $tesk9$palette$Internal$HSLA$toChannels = function (_v0) {
	var values = _v0;
	return values;
};
var $tesk9$palette$Internal$Color$convertHSLToRGBA = function (color) {
	return $tesk9$palette$Internal$Color$RGBA(
		$tesk9$palette$Internal$RGBA$fromHSLA(
			$tesk9$palette$Internal$HSLA$toChannels(color)));
};
var $tesk9$palette$Internal$Color$asRGBA = function (color) {
	asRGBA:
	while (true) {
		if (color.$ === 1) {
			var values = color.a;
			return values;
		} else {
			var hslValues = color.a;
			var $temp$color = $tesk9$palette$Internal$Color$convertHSLToRGBA(hslValues);
			color = $temp$color;
			continue asRGBA;
		}
	}
};
var $tesk9$palette$Internal$RGBA$toChannels = function (_v0) {
	var values = _v0;
	return values;
};
var $tesk9$palette$SolidColor$toRGB = function (_v0) {
	var color = _v0;
	var _v1 = $tesk9$palette$Internal$RGBA$toChannels(
		$tesk9$palette$Internal$Color$asRGBA(color));
	var red = _v1.no;
	var green = _v1.l6;
	var blue = _v1.k_;
	return _Utils_Tuple3(red, green, blue);
};
var $author$project$UI$Element$colorFor = function (color) {
	var _v0 = $tesk9$palette$SolidColor$toRGB(color);
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	return A3(
		$mdgriffith$elm_ui$Element$rgb255,
		$elm$core$Basics$round(r),
		$elm$core$Basics$round(g),
		$elm$core$Basics$round(b));
};
var $author$project$UI$Element$colors = function (c) {
	return _List_fromArray(
		[
			$mdgriffith$elm_ui$Element$Background$color(
			$author$project$UI$Element$colorFor(c.kV)),
			$mdgriffith$elm_ui$Element$Border$color(
			$author$project$UI$Element$colorFor(c.k0)),
			$mdgriffith$elm_ui$Element$Font$color(
			$author$project$UI$Element$colorFor(c.lZ))
		]);
};
var $mdgriffith$elm_ui$Internal$Model$Unkeyed = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$AsEl = 2;
var $mdgriffith$elm_ui$Internal$Model$asEl = 2;
var $mdgriffith$elm_ui$Internal$Model$Generic = {$: 0};
var $mdgriffith$elm_ui$Internal$Model$div = $mdgriffith$elm_ui$Internal$Model$Generic;
var $mdgriffith$elm_ui$Internal$Model$NoNearbyChildren = {$: 0};
var $mdgriffith$elm_ui$Internal$Model$columnClass = $mdgriffith$elm_ui$Internal$Style$classes.kQ + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.dV);
var $mdgriffith$elm_ui$Internal$Model$gridClass = $mdgriffith$elm_ui$Internal$Style$classes.kQ + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.l7);
var $mdgriffith$elm_ui$Internal$Model$pageClass = $mdgriffith$elm_ui$Internal$Style$classes.kQ + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.cv);
var $mdgriffith$elm_ui$Internal$Model$paragraphClass = $mdgriffith$elm_ui$Internal$Style$classes.kQ + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.jt);
var $mdgriffith$elm_ui$Internal$Model$rowClass = $mdgriffith$elm_ui$Internal$Style$classes.kQ + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.dv);
var $mdgriffith$elm_ui$Internal$Model$singleClass = $mdgriffith$elm_ui$Internal$Style$classes.kQ + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.nM);
var $mdgriffith$elm_ui$Internal$Model$contextClasses = function (context) {
	switch (context) {
		case 0:
			return $mdgriffith$elm_ui$Internal$Model$rowClass;
		case 1:
			return $mdgriffith$elm_ui$Internal$Model$columnClass;
		case 2:
			return $mdgriffith$elm_ui$Internal$Model$singleClass;
		case 3:
			return $mdgriffith$elm_ui$Internal$Model$gridClass;
		case 4:
			return $mdgriffith$elm_ui$Internal$Model$paragraphClass;
		default:
			return $mdgriffith$elm_ui$Internal$Model$pageClass;
	}
};
var $mdgriffith$elm_ui$Internal$Model$Keyed = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$NoStyleSheet = {$: 0};
var $mdgriffith$elm_ui$Internal$Model$Styled = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$Unstyled = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$addChildren = F2(
	function (existing, nearbyChildren) {
		switch (nearbyChildren.$) {
			case 0:
				return existing;
			case 1:
				var behind = nearbyChildren.a;
				return _Utils_ap(behind, existing);
			case 2:
				var inFront = nearbyChildren.a;
				return _Utils_ap(existing, inFront);
			default:
				var behind = nearbyChildren.a;
				var inFront = nearbyChildren.b;
				return _Utils_ap(
					behind,
					_Utils_ap(existing, inFront));
		}
	});
var $mdgriffith$elm_ui$Internal$Model$addKeyedChildren = F3(
	function (key, existing, nearbyChildren) {
		switch (nearbyChildren.$) {
			case 0:
				return existing;
			case 1:
				var behind = nearbyChildren.a;
				return _Utils_ap(
					A2(
						$elm$core$List$map,
						function (x) {
							return _Utils_Tuple2(key, x);
						},
						behind),
					existing);
			case 2:
				var inFront = nearbyChildren.a;
				return _Utils_ap(
					existing,
					A2(
						$elm$core$List$map,
						function (x) {
							return _Utils_Tuple2(key, x);
						},
						inFront));
			default:
				var behind = nearbyChildren.a;
				var inFront = nearbyChildren.b;
				return _Utils_ap(
					A2(
						$elm$core$List$map,
						function (x) {
							return _Utils_Tuple2(key, x);
						},
						behind),
					_Utils_ap(
						existing,
						A2(
							$elm$core$List$map,
							function (x) {
								return _Utils_Tuple2(key, x);
							},
							inFront)));
		}
	});
var $mdgriffith$elm_ui$Internal$Model$AsParagraph = 4;
var $mdgriffith$elm_ui$Internal$Model$asParagraph = 4;
var $mdgriffith$elm_ui$Internal$Flag$alignBottom = $mdgriffith$elm_ui$Internal$Flag$flag(41);
var $mdgriffith$elm_ui$Internal$Flag$alignRight = $mdgriffith$elm_ui$Internal$Flag$flag(40);
var $mdgriffith$elm_ui$Internal$Flag$centerX = $mdgriffith$elm_ui$Internal$Flag$flag(42);
var $mdgriffith$elm_ui$Internal$Flag$centerY = $mdgriffith$elm_ui$Internal$Flag$flag(43);
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $mdgriffith$elm_ui$Internal$Model$lengthClassName = function (x) {
	switch (x.$) {
		case 0:
			var px = x.a;
			return $elm$core$String$fromInt(px) + 'px';
		case 1:
			return 'auto';
		case 2:
			var i = x.a;
			return $elm$core$String$fromInt(i) + 'fr';
		case 3:
			var min = x.a;
			var len = x.b;
			return 'min' + ($elm$core$String$fromInt(min) + $mdgriffith$elm_ui$Internal$Model$lengthClassName(len));
		default:
			var max = x.a;
			var len = x.b;
			return 'max' + ($elm$core$String$fromInt(max) + $mdgriffith$elm_ui$Internal$Model$lengthClassName(len));
	}
};
var $mdgriffith$elm_ui$Internal$Model$transformClass = function (transform) {
	switch (transform.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var _v1 = transform.a;
			var x = _v1.a;
			var y = _v1.b;
			var z = _v1.c;
			return $elm$core$Maybe$Just(
				'mv-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(x) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(y) + ('-' + $mdgriffith$elm_ui$Internal$Model$floatClass(z))))));
		default:
			var _v2 = transform.a;
			var tx = _v2.a;
			var ty = _v2.b;
			var tz = _v2.c;
			var _v3 = transform.b;
			var sx = _v3.a;
			var sy = _v3.b;
			var sz = _v3.c;
			var _v4 = transform.c;
			var ox = _v4.a;
			var oy = _v4.b;
			var oz = _v4.c;
			var angle = transform.d;
			return $elm$core$Maybe$Just(
				'tfrm-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(tx) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(ty) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(tz) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(sx) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(sy) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(sz) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(ox) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(oy) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(oz) + ('-' + $mdgriffith$elm_ui$Internal$Model$floatClass(angle))))))))))))))))))));
	}
};
var $mdgriffith$elm_ui$Internal$Model$getStyleName = function (style) {
	switch (style.$) {
		case 13:
			var name = style.a;
			return name;
		case 12:
			var name = style.a;
			var o = style.b;
			return name;
		case 0:
			var _class = style.a;
			return _class;
		case 1:
			var name = style.a;
			return name;
		case 2:
			var i = style.a;
			return 'font-size-' + $elm$core$String$fromInt(i);
		case 3:
			var _class = style.a;
			return _class;
		case 4:
			var _class = style.a;
			return _class;
		case 5:
			var cls = style.a;
			var x = style.b;
			var y = style.c;
			return cls;
		case 7:
			var cls = style.a;
			var top = style.b;
			var right = style.c;
			var bottom = style.d;
			var left = style.e;
			return cls;
		case 6:
			var cls = style.a;
			var top = style.b;
			var right = style.c;
			var bottom = style.d;
			var left = style.e;
			return cls;
		case 8:
			var template = style.a;
			return 'grid-rows-' + (A2(
				$elm$core$String$join,
				'-',
				A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$lengthClassName, template.nA)) + ('-cols-' + (A2(
				$elm$core$String$join,
				'-',
				A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$lengthClassName, template.eT)) + ('-space-x-' + ($mdgriffith$elm_ui$Internal$Model$lengthClassName(template.j9.a) + ('-space-y-' + $mdgriffith$elm_ui$Internal$Model$lengthClassName(template.j9.b)))))));
		case 9:
			var pos = style.a;
			return 'gp grid-pos-' + ($elm$core$String$fromInt(pos.dv) + ('-' + ($elm$core$String$fromInt(pos.h3) + ('-' + ($elm$core$String$fromInt(pos.oy) + ('-' + $elm$core$String$fromInt(pos.iK)))))));
		case 11:
			var selector = style.a;
			var subStyle = style.b;
			var name = function () {
				switch (selector) {
					case 0:
						return 'fs';
					case 1:
						return 'hv';
					default:
						return 'act';
				}
			}();
			return A2(
				$elm$core$String$join,
				' ',
				A2(
					$elm$core$List$map,
					function (sty) {
						var _v1 = $mdgriffith$elm_ui$Internal$Model$getStyleName(sty);
						if (_v1 === '') {
							return '';
						} else {
							var styleName = _v1;
							return styleName + ('-' + name);
						}
					},
					subStyle));
		default:
			var x = style.a;
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				$mdgriffith$elm_ui$Internal$Model$transformClass(x));
	}
};
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $mdgriffith$elm_ui$Internal$Model$reduceStyles = F2(
	function (style, nevermind) {
		var cache = nevermind.a;
		var existing = nevermind.b;
		var styleName = $mdgriffith$elm_ui$Internal$Model$getStyleName(style);
		return A2($elm$core$Set$member, styleName, cache) ? nevermind : _Utils_Tuple2(
			A2($elm$core$Set$insert, styleName, cache),
			A2($elm$core$List$cons, style, existing));
	});
var $mdgriffith$elm_ui$Internal$Model$Property = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$Style = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$dot = function (c) {
	return '.' + c;
};
var $elm$core$String$fromFloat = _String_fromNumber;
var $mdgriffith$elm_ui$Internal$Model$formatColor = function (_v0) {
	var red = _v0.a;
	var green = _v0.b;
	var blue = _v0.c;
	var alpha = _v0.d;
	return 'rgba(' + ($elm$core$String$fromInt(
		$elm$core$Basics$round(red * 255)) + ((',' + $elm$core$String$fromInt(
		$elm$core$Basics$round(green * 255))) + ((',' + $elm$core$String$fromInt(
		$elm$core$Basics$round(blue * 255))) + (',' + ($elm$core$String$fromFloat(alpha) + ')')))));
};
var $mdgriffith$elm_ui$Internal$Model$formatBoxShadow = function (shadow) {
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					shadow.iU ? $elm$core$Maybe$Just('inset') : $elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just(
					$elm$core$String$fromFloat(shadow.c.a) + 'px'),
					$elm$core$Maybe$Just(
					$elm$core$String$fromFloat(shadow.c.b) + 'px'),
					$elm$core$Maybe$Just(
					$elm$core$String$fromFloat(shadow.c_) + 'px'),
					$elm$core$Maybe$Just(
					$elm$core$String$fromFloat(shadow.bB) + 'px'),
					$elm$core$Maybe$Just(
					$mdgriffith$elm_ui$Internal$Model$formatColor(shadow.eS))
				])));
};
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $mdgriffith$elm_ui$Internal$Model$renderFocusStyle = function (focus) {
	return _List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Internal$Model$Style,
			$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iE) + ':focus-within',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						function (color) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'border-color',
								$mdgriffith$elm_ui$Internal$Model$formatColor(color));
						},
						focus.k1),
						A2(
						$elm$core$Maybe$map,
						function (color) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'background-color',
								$mdgriffith$elm_ui$Internal$Model$formatColor(color));
						},
						focus.kW),
						A2(
						$elm$core$Maybe$map,
						function (shadow) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'box-shadow',
								$mdgriffith$elm_ui$Internal$Model$formatBoxShadow(
									{
										c_: shadow.c_,
										eS: shadow.eS,
										iU: false,
										c: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$Basics$toFloat,
											A2($elm$core$Tuple$mapFirst, $elm$core$Basics$toFloat, shadow.c)),
										bB: shadow.bB
									}));
						},
						focus.j2),
						$elm$core$Maybe$Just(
						A2($mdgriffith$elm_ui$Internal$Model$Property, 'outline', 'none'))
					]))),
			A2(
			$mdgriffith$elm_ui$Internal$Model$Style,
			($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kQ) + ':focus .focusable, ') + (($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kQ) + '.focusable:focus, ') + ('.ui-slide-bar:focus + ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kQ) + ' .focusable-thumb'))),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						function (color) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'border-color',
								$mdgriffith$elm_ui$Internal$Model$formatColor(color));
						},
						focus.k1),
						A2(
						$elm$core$Maybe$map,
						function (color) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'background-color',
								$mdgriffith$elm_ui$Internal$Model$formatColor(color));
						},
						focus.kW),
						A2(
						$elm$core$Maybe$map,
						function (shadow) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'box-shadow',
								$mdgriffith$elm_ui$Internal$Model$formatBoxShadow(
									{
										c_: shadow.c_,
										eS: shadow.eS,
										iU: false,
										c: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$Basics$toFloat,
											A2($elm$core$Tuple$mapFirst, $elm$core$Basics$toFloat, shadow.c)),
										bB: shadow.bB
									}));
						},
						focus.j2),
						$elm$core$Maybe$Just(
						A2($mdgriffith$elm_ui$Internal$Model$Property, 'outline', 'none'))
					])))
		]);
};
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlJson(value));
	});
var $mdgriffith$elm_ui$Internal$Style$AllChildren = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Batch = function (a) {
	return {$: 6, a: a};
};
var $mdgriffith$elm_ui$Internal$Style$Child = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Class = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Descriptor = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Left = 3;
var $mdgriffith$elm_ui$Internal$Style$Prop = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Right = 2;
var $mdgriffith$elm_ui$Internal$Style$Self = $elm$core$Basics$identity;
var $mdgriffith$elm_ui$Internal$Style$Supports = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Content = $elm$core$Basics$identity;
var $mdgriffith$elm_ui$Internal$Style$Bottom = 1;
var $mdgriffith$elm_ui$Internal$Style$CenterX = 4;
var $mdgriffith$elm_ui$Internal$Style$CenterY = 5;
var $mdgriffith$elm_ui$Internal$Style$Top = 0;
var $mdgriffith$elm_ui$Internal$Style$alignments = _List_fromArray(
	[0, 1, 2, 3, 4, 5]);
var $mdgriffith$elm_ui$Internal$Style$contentName = function (desc) {
	switch (desc) {
		case 0:
			var _v1 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.lp);
		case 1:
			var _v2 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eY);
		case 2:
			var _v3 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.e_);
		case 3:
			var _v4 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dZ);
		case 4:
			var _v5 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eZ);
		default:
			var _v6 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.bI);
	}
};
var $mdgriffith$elm_ui$Internal$Style$selfName = function (desc) {
	switch (desc) {
		case 0:
			var _v1 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eK);
		case 1:
			var _v2 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kF);
		case 2:
			var _v3 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eJ);
		case 3:
			var _v4 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hQ);
		case 4:
			var _v5 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kG);
		default:
			var _v6 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kH);
	}
};
var $mdgriffith$elm_ui$Internal$Style$describeAlignment = function (values) {
	var createDescription = function (alignment) {
		var _v0 = values(alignment);
		var content = _v0.a;
		var indiv = _v0.b;
		return _List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$contentName(alignment),
				content),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kQ),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$selfName(alignment),
						indiv)
					]))
			]);
	};
	return $mdgriffith$elm_ui$Internal$Style$Batch(
		A2($elm$core$List$concatMap, createDescription, $mdgriffith$elm_ui$Internal$Style$alignments));
};
var $mdgriffith$elm_ui$Internal$Style$elDescription = _List_fromArray(
	[
		A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
		A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'column'),
		A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre'),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Descriptor,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gB),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '0'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kY),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '-1')
					]))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Descriptor,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nE),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.n3),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gD),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hJ),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'auto !important')
							]))
					]))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gC),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', 'auto')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gD),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '100000')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hJ),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kB),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hI),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
			])),
		$mdgriffith$elm_ui$Internal$Style$describeAlignment(
		function (alignment) {
			switch (alignment) {
				case 0:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-start')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', '0 !important')
							]));
				case 1:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-end')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', '0 !important')
							]));
				case 2:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-end')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-end')
							]));
				case 3:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-start')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
							]));
				case 4:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'center')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'center')
							]));
				default:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kQ),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto')
									]))
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important')
							]));
			}
		})
	]);
var $mdgriffith$elm_ui$Internal$Style$gridAlignments = function (values) {
	var createDescription = function (alignment) {
		return _List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kQ),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$selfName(alignment),
						values(alignment))
					]))
			]);
	};
	return $mdgriffith$elm_ui$Internal$Style$Batch(
		A2($elm$core$List$concatMap, createDescription, $mdgriffith$elm_ui$Internal$Style$alignments));
};
var $mdgriffith$elm_ui$Internal$Style$Above = 0;
var $mdgriffith$elm_ui$Internal$Style$Behind = 5;
var $mdgriffith$elm_ui$Internal$Style$Below = 1;
var $mdgriffith$elm_ui$Internal$Style$OnLeft = 3;
var $mdgriffith$elm_ui$Internal$Style$OnRight = 2;
var $mdgriffith$elm_ui$Internal$Style$Within = 4;
var $mdgriffith$elm_ui$Internal$Style$locations = function () {
	var loc = 0;
	var _v0 = function () {
		switch (loc) {
			case 0:
				return 0;
			case 1:
				return 0;
			case 2:
				return 0;
			case 3:
				return 0;
			case 4:
				return 0;
			default:
				return 0;
		}
	}();
	return _List_fromArray(
		[0, 1, 2, 3, 4, 5]);
}();
var $mdgriffith$elm_ui$Internal$Style$baseSheet = _List_fromArray(
	[
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		'html,body',
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'padding', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		_Utils_ap(
			$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kQ),
			_Utils_ap(
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nM),
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.mh))),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'block'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gD),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'img',
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'max-height', '100%'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'object-fit', 'cover')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hJ),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'img',
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'max-width', '100%'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'object-fit', 'cover')
							]))
					]))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kQ) + ':focus',
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'outline', 'none')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nz),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', 'auto'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'min-height', '100%'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '0'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				_Utils_ap(
					$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kQ),
					$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gD)),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gD),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.mj),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dj),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'fixed'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20')
							]))
					]))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dj),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'relative'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border', 'none'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'row'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nM),
				$mdgriffith$elm_ui$Internal$Style$elDescription),
				$mdgriffith$elm_ui$Internal$Style$Batch(
				function (fn) {
					return A2($elm$core$List$map, fn, $mdgriffith$elm_ui$Internal$Style$locations);
				}(
					function (loc) {
						switch (loc) {
							case 0:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eI),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'bottom', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gD),
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', 'auto')
												])),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hJ),
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
												])),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
							case 1:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eM),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'bottom', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												])),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gD),
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', 'auto')
												]))
										]));
							case 2:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.m1),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
							case 3:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.m$),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'right', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
							case 4:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.mj),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
							default:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kY),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
						}
					}))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kQ),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'relative'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border', 'none'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'row'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'resize', 'none'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-feature-settings', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'box-sizing', 'border-box'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'padding', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-width', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-style', 'solid'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-size', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'color', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-family', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'line-height', '1'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration', 'none'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-style', 'inherit'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hL),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-wrap', 'wrap')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jm),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, '-moz-user-select', 'none'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, '-webkit-user-select', 'none'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, '-ms-user-select', 'none'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'user-select', 'none')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.lv),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'cursor', 'pointer')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.lw),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'cursor', 'text')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nd),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none !important')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eQ),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto !important')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cN),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cu),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.mf, $mdgriffith$elm_ui$Internal$Style$classes.cN)) + ':hover',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.mf, $mdgriffith$elm_ui$Internal$Style$classes.cu)) + ':hover',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.db, $mdgriffith$elm_ui$Internal$Style$classes.cN)) + ':focus',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.db, $mdgriffith$elm_ui$Internal$Style$classes.cu)) + ':focus',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.f$, $mdgriffith$elm_ui$Internal$Style$classes.cN)) + ':active',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.f$, $mdgriffith$elm_ui$Internal$Style$classes.cu)) + ':active',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ks),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Prop,
						'transition',
						A2(
							$elm$core$String$join,
							', ',
							A2(
								$elm$core$List$map,
								function (x) {
									return x + ' 160ms';
								},
								_List_fromArray(
									['transform', 'opacity', 'filter', 'background-color', 'color', 'font-size']))))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nB),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow', 'auto'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nC),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-x', 'auto'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dv),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '1')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nD),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-y', 'auto'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dV),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '1')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nM),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '1')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.lg),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow', 'hidden')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.lh),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-x', 'hidden')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.li),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-y', 'hidden')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hI),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', 'auto')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eO),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-width', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.k2),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-style', 'dashed')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.k3),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-style', 'dotted')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.k4),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-style', 'solid')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.n3),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline-block')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.mr),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'line-height', '1.05'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'background', 'transparent'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'inherit')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nM),
				$mdgriffith$elm_ui$Internal$Style$elDescription),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dv),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'row'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kQ),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', '0%'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kA),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.i1),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gD),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'stretch !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iM),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'stretch !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hJ),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '100000')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eX),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'stretch')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'u:first-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.kL,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:first-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.kJ,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kG),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-left', 'auto !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:last-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.kJ,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kG),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-right', 'auto !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:only-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.kJ,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kH),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:last-of-type.' + ($mdgriffith$elm_ui$Internal$Style$classes.kJ + ' ~ u'),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'u:first-of-type.' + ($mdgriffith$elm_ui$Internal$Style$classes.kL + (' ~ s.' + $mdgriffith$elm_ui$Internal$Style$classes.kJ)),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						$mdgriffith$elm_ui$Internal$Style$describeAlignment(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-start')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
											]));
								case 1:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-end')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-end')
											]));
								case 2:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-end')
											]),
										_List_Nil);
								case 3:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-start')
											]),
										_List_Nil);
								case 4:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'center')
											]),
										_List_Nil);
								default:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'center')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'center')
											]));
							}
						}),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nQ),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'space-between')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fk),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'baseline')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dV),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'column'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kQ),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', '0px'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'min-height', 'min-content'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iL),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gD),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '100000')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hJ),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kB),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hI),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'u:first-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.kI,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:first-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.kK,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kH),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', '0 !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:last-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.kK,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kH),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', '0 !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:only-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.kK,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kH),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:last-of-type.' + ($mdgriffith$elm_ui$Internal$Style$classes.kK + ' ~ u'),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'u:first-of-type.' + ($mdgriffith$elm_ui$Internal$Style$classes.kI + (' ~ s.' + $mdgriffith$elm_ui$Internal$Style$classes.kK)),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						$mdgriffith$elm_ui$Internal$Style$describeAlignment(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-start')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto')
											]));
								case 1:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-end')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto')
											]));
								case 2:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-end')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-end')
											]));
								case 3:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-start')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
											]));
								case 4:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'center')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'center')
											]));
								default:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'center')
											]),
										_List_Nil);
							}
						}),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eX),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'stretch !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nQ),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'space-between')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.l7),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', '-ms-grid'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'.gp',
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kQ),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Supports,
						_Utils_Tuple2('display', 'grid'),
						_List_fromArray(
							[
								_Utils_Tuple2('display', 'grid')
							])),
						$mdgriffith$elm_ui$Internal$Style$gridAlignments(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-start')
										]);
								case 1:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-end')
										]);
								case 2:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-end')
										]);
								case 3:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-start')
										]);
								case 4:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'center')
										]);
								default:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'center')
										]);
							}
						})
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cv),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'block'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kQ + ':first-child'),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot(
							$mdgriffith$elm_ui$Internal$Style$classes.kQ + ($mdgriffith$elm_ui$Internal$Style$selfName(3) + (':first-child + .' + $mdgriffith$elm_ui$Internal$Style$classes.kQ))),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot(
							$mdgriffith$elm_ui$Internal$Style$classes.kQ + ($mdgriffith$elm_ui$Internal$Style$selfName(2) + (':first-child + .' + $mdgriffith$elm_ui$Internal$Style$classes.kQ))),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important')
							])),
						$mdgriffith$elm_ui$Internal$Style$describeAlignment(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								case 1:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								case 2:
									return _Utils_Tuple2(
										_List_Nil,
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'float', 'right'),
												A2(
												$mdgriffith$elm_ui$Internal$Style$Descriptor,
												'::after',
												_List_fromArray(
													[
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'content', '\"\"'),
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'table'),
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'clear', 'both')
													]))
											]));
								case 3:
									return _Utils_Tuple2(
										_List_Nil,
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'float', 'left'),
												A2(
												$mdgriffith$elm_ui$Internal$Style$Descriptor,
												'::after',
												_List_fromArray(
													[
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'content', '\"\"'),
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'table'),
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'clear', 'both')
													]))
											]));
								case 4:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								default:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
							}
						})
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.mn),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre-wrap !important'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'background-color', 'transparent')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.mq),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nM),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.mp),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre-wrap !important'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'cursor', 'text'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.mo),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre-wrap !important'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'color', 'transparent')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jt),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'block'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'normal'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-wrap', 'break-word'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gB),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '0'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kY),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '-1')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$AllChildren,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.n3),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'normal')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$AllChildren,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jt),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								'::after',
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'content', 'none')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								'::before',
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'content', 'none')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$AllChildren,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nM),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'normal'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kA),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline-block')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.mj),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kY),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eI),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eM),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.m1),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.m$),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.n3),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'normal')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dv),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dV),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline-flex')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.l7),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline-grid')
							])),
						$mdgriffith$elm_ui$Internal$Style$describeAlignment(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								case 1:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								case 2:
									return _Utils_Tuple2(
										_List_Nil,
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'float', 'right')
											]));
								case 3:
									return _Utils_Tuple2(
										_List_Nil,
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'float', 'left')
											]));
								case 4:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								default:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
							}
						})
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				'.hidden',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'none')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.of),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '100')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.n6),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '200')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.oa),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '300')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.oc),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '400')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ob),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '500')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.oe),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '600')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.k$),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '700')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.n5),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '800')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.n7),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '900')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.mu),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-style', 'italic')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nX),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration', 'line-through')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.on),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration', 'underline'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration-skip-ink', 'auto'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration-skip', 'ink')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				_Utils_ap(
					$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.on),
					$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nX)),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration', 'line-through underline'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration-skip-ink', 'auto'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration-skip', 'ink')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.og),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-style', 'normal')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.n8),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'justify')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fV),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'justify-all')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.n4),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'center')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.od),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'right')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.n9),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'left')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				'.modal',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'fixed'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none')
					]))
			]))
	]);
var $mdgriffith$elm_ui$Internal$Style$fontVariant = function (_var) {
	return _List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Internal$Style$Class,
			'.v-' + _var,
			_List_fromArray(
				[
					A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-feature-settings', '\"' + (_var + '\"'))
				])),
			A2(
			$mdgriffith$elm_ui$Internal$Style$Class,
			'.v-' + (_var + '-off'),
			_List_fromArray(
				[
					A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-feature-settings', '\"' + (_var + '\" 0'))
				]))
		]);
};
var $mdgriffith$elm_ui$Internal$Style$commonValues = $elm$core$List$concat(
	_List_fromArray(
		[
			A2(
			$elm$core$List$map,
			function (x) {
				return A2(
					$mdgriffith$elm_ui$Internal$Style$Class,
					'.border-' + $elm$core$String$fromInt(x),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Style$Prop,
							'border-width',
							$elm$core$String$fromInt(x) + 'px')
						]));
			},
			A2($elm$core$List$range, 0, 6)),
			A2(
			$elm$core$List$map,
			function (i) {
				return A2(
					$mdgriffith$elm_ui$Internal$Style$Class,
					'.font-size-' + $elm$core$String$fromInt(i),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Style$Prop,
							'font-size',
							$elm$core$String$fromInt(i) + 'px')
						]));
			},
			A2($elm$core$List$range, 8, 32)),
			A2(
			$elm$core$List$map,
			function (i) {
				return A2(
					$mdgriffith$elm_ui$Internal$Style$Class,
					'.p-' + $elm$core$String$fromInt(i),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Style$Prop,
							'padding',
							$elm$core$String$fromInt(i) + 'px')
						]));
			},
			A2($elm$core$List$range, 0, 24)),
			_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Internal$Style$Class,
				'.v-smcp',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-variant', 'small-caps')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Class,
				'.v-smcp-off',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-variant', 'normal')
					]))
			]),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('zero'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('onum'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('liga'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('dlig'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('ordn'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('tnum'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('afrc'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('frac')
		]));
var $mdgriffith$elm_ui$Internal$Style$explainer = '\n.explain {\n    border: 6px solid rgb(174, 121, 15) !important;\n}\n.explain > .' + ($mdgriffith$elm_ui$Internal$Style$classes.kQ + (' {\n    border: 4px dashed rgb(0, 151, 167) !important;\n}\n\n.ctr {\n    border: none !important;\n}\n.explain > .ctr > .' + ($mdgriffith$elm_ui$Internal$Style$classes.kQ + ' {\n    border: 4px dashed rgb(0, 151, 167) !important;\n}\n\n')));
var $mdgriffith$elm_ui$Internal$Style$inputTextReset = '\ninput[type="search"],\ninput[type="search"]::-webkit-search-decoration,\ninput[type="search"]::-webkit-search-cancel-button,\ninput[type="search"]::-webkit-search-results-button,\ninput[type="search"]::-webkit-search-results-decoration {\n  -webkit-appearance:none;\n}\n';
var $mdgriffith$elm_ui$Internal$Style$sliderReset = '\ninput[type=range] {\n  -webkit-appearance: none; \n  background: transparent;\n  position:absolute;\n  left:0;\n  top:0;\n  z-index:10;\n  width: 100%;\n  outline: dashed 1px;\n  height: 100%;\n  opacity: 0;\n}\n';
var $mdgriffith$elm_ui$Internal$Style$thumbReset = '\ninput[type=range]::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range]::-moz-range-thumb {\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range]::-ms-thumb {\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range][orient=vertical]{\n    writing-mode: bt-lr; /* IE */\n    -webkit-appearance: slider-vertical;  /* WebKit */\n}\n';
var $mdgriffith$elm_ui$Internal$Style$trackReset = '\ninput[type=range]::-moz-range-track {\n    background: transparent;\n    cursor: pointer;\n}\ninput[type=range]::-ms-track {\n    background: transparent;\n    cursor: pointer;\n}\ninput[type=range]::-webkit-slider-runnable-track {\n    background: transparent;\n    cursor: pointer;\n}\n';
var $mdgriffith$elm_ui$Internal$Style$overrides = '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kQ) + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dv) + (' > ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kQ) + (' { flex-basis: auto !important; } ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kQ) + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dv) + (' > ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kQ) + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eX) + (' { flex-basis: auto !important; }}' + ($mdgriffith$elm_ui$Internal$Style$inputTextReset + ($mdgriffith$elm_ui$Internal$Style$sliderReset + ($mdgriffith$elm_ui$Internal$Style$trackReset + ($mdgriffith$elm_ui$Internal$Style$thumbReset + $mdgriffith$elm_ui$Internal$Style$explainer)))))))))))))));
var $mdgriffith$elm_ui$Internal$Style$Intermediate = $elm$core$Basics$identity;
var $mdgriffith$elm_ui$Internal$Style$emptyIntermediate = F2(
	function (selector, closing) {
		return {eR: closing, R: _List_Nil, b0: _List_Nil, bd: selector};
	});
var $mdgriffith$elm_ui$Internal$Style$renderRules = F2(
	function (_v0, rulesToRender) {
		var parent = _v0;
		var generateIntermediates = F2(
			function (rule, rendered) {
				switch (rule.$) {
					case 0:
						var name = rule.a;
						var val = rule.b;
						return _Utils_update(
							rendered,
							{
								b0: A2(
									$elm$core$List$cons,
									_Utils_Tuple2(name, val),
									rendered.b0)
							});
					case 3:
						var _v2 = rule.a;
						var prop = _v2.a;
						var value = _v2.b;
						var props = rule.b;
						return _Utils_update(
							rendered,
							{
								R: A2(
									$elm$core$List$cons,
									{eR: '\n}', R: _List_Nil, b0: props, bd: '@supports (' + (prop + (':' + (value + (') {' + parent.bd))))},
									rendered.R)
							});
					case 5:
						var selector = rule.a;
						var adjRules = rule.b;
						return _Utils_update(
							rendered,
							{
								R: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, parent.bd + (' + ' + selector), ''),
										adjRules),
									rendered.R)
							});
					case 1:
						var child = rule.a;
						var childRules = rule.b;
						return _Utils_update(
							rendered,
							{
								R: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, parent.bd + (' > ' + child), ''),
										childRules),
									rendered.R)
							});
					case 2:
						var child = rule.a;
						var childRules = rule.b;
						return _Utils_update(
							rendered,
							{
								R: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, parent.bd + (' ' + child), ''),
										childRules),
									rendered.R)
							});
					case 4:
						var descriptor = rule.a;
						var descriptorRules = rule.b;
						return _Utils_update(
							rendered,
							{
								R: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2(
											$mdgriffith$elm_ui$Internal$Style$emptyIntermediate,
											_Utils_ap(parent.bd, descriptor),
											''),
										descriptorRules),
									rendered.R)
							});
					default:
						var batched = rule.a;
						return _Utils_update(
							rendered,
							{
								R: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, parent.bd, ''),
										batched),
									rendered.R)
							});
				}
			});
		return A3($elm$core$List$foldr, generateIntermediates, parent, rulesToRender);
	});
var $mdgriffith$elm_ui$Internal$Style$renderCompact = function (styleClasses) {
	var renderValues = function (values) {
		return $elm$core$String$concat(
			A2(
				$elm$core$List$map,
				function (_v3) {
					var x = _v3.a;
					var y = _v3.b;
					return x + (':' + (y + ';'));
				},
				values));
	};
	var renderClass = function (rule) {
		var _v2 = rule.b0;
		if (!_v2.b) {
			return '';
		} else {
			return rule.bd + ('{' + (renderValues(rule.b0) + (rule.eR + '}')));
		}
	};
	var renderIntermediate = function (_v0) {
		var rule = _v0;
		return _Utils_ap(
			renderClass(rule),
			$elm$core$String$concat(
				A2($elm$core$List$map, renderIntermediate, rule.R)));
	};
	return $elm$core$String$concat(
		A2(
			$elm$core$List$map,
			renderIntermediate,
			A3(
				$elm$core$List$foldr,
				F2(
					function (_v1, existing) {
						var name = _v1.a;
						var styleRules = _v1.b;
						return A2(
							$elm$core$List$cons,
							A2(
								$mdgriffith$elm_ui$Internal$Style$renderRules,
								A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, name, ''),
								styleRules),
							existing);
					}),
				_List_Nil,
				styleClasses)));
};
var $mdgriffith$elm_ui$Internal$Style$rules = _Utils_ap(
	$mdgriffith$elm_ui$Internal$Style$overrides,
	$mdgriffith$elm_ui$Internal$Style$renderCompact(
		_Utils_ap($mdgriffith$elm_ui$Internal$Style$baseSheet, $mdgriffith$elm_ui$Internal$Style$commonValues)));
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $mdgriffith$elm_ui$Internal$Model$staticRoot = function (opts) {
	var _v0 = opts.mK;
	switch (_v0) {
		case 0:
			return A3(
				$elm$virtual_dom$VirtualDom$node,
				'div',
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$elm$virtual_dom$VirtualDom$node,
						'style',
						_List_Nil,
						_List_fromArray(
							[
								$elm$virtual_dom$VirtualDom$text($mdgriffith$elm_ui$Internal$Style$rules)
							]))
					]));
		case 1:
			return $elm$virtual_dom$VirtualDom$text('');
		default:
			return A3(
				$elm$virtual_dom$VirtualDom$node,
				'elm-ui-static-rules',
				_List_fromArray(
					[
						A2(
						$elm$virtual_dom$VirtualDom$property,
						'rules',
						$elm$json$Json$Encode$string($mdgriffith$elm_ui$Internal$Style$rules))
					]),
				_List_Nil);
	}
};
var $mdgriffith$elm_ui$Internal$Model$fontName = function (font) {
	switch (font.$) {
		case 0:
			return 'serif';
		case 1:
			return 'sans-serif';
		case 2:
			return 'monospace';
		case 3:
			var name = font.a;
			return '\"' + (name + '\"');
		case 4:
			var name = font.a;
			var url = font.b;
			return '\"' + (name + '\"');
		default:
			var name = font.a.ft;
			return '\"' + (name + '\"');
	}
};
var $mdgriffith$elm_ui$Internal$Model$isSmallCaps = function (_var) {
	switch (_var.$) {
		case 0:
			var name = _var.a;
			return name === 'smcp';
		case 1:
			var name = _var.a;
			return false;
		default:
			var name = _var.a;
			var index = _var.b;
			return (name === 'smcp') && (index === 1);
	}
};
var $mdgriffith$elm_ui$Internal$Model$hasSmallCaps = function (typeface) {
	if (typeface.$ === 5) {
		var font = typeface.a;
		return A2($elm$core$List$any, $mdgriffith$elm_ui$Internal$Model$isSmallCaps, font.ku);
	} else {
		return false;
	}
};
var $mdgriffith$elm_ui$Internal$Model$renderProps = F3(
	function (force, _v0, existing) {
		var key = _v0.a;
		var val = _v0.b;
		return force ? (existing + ('\n  ' + (key + (': ' + (val + ' !important;'))))) : (existing + ('\n  ' + (key + (': ' + (val + ';')))));
	});
var $mdgriffith$elm_ui$Internal$Model$renderStyle = F4(
	function (options, maybePseudo, selector, props) {
		if (maybePseudo.$ === 1) {
			return _List_fromArray(
				[
					selector + ('{' + (A3(
					$elm$core$List$foldl,
					$mdgriffith$elm_ui$Internal$Model$renderProps(false),
					'',
					props) + '\n}'))
				]);
		} else {
			var pseudo = maybePseudo.a;
			switch (pseudo) {
				case 1:
					var _v2 = options.mf;
					switch (_v2) {
						case 0:
							return _List_Nil;
						case 2:
							return _List_fromArray(
								[
									selector + ('-hv {' + (A3(
									$elm$core$List$foldl,
									$mdgriffith$elm_ui$Internal$Model$renderProps(true),
									'',
									props) + '\n}'))
								]);
						default:
							return _List_fromArray(
								[
									selector + ('-hv:hover {' + (A3(
									$elm$core$List$foldl,
									$mdgriffith$elm_ui$Internal$Model$renderProps(false),
									'',
									props) + '\n}'))
								]);
					}
				case 0:
					var renderedProps = A3(
						$elm$core$List$foldl,
						$mdgriffith$elm_ui$Internal$Model$renderProps(false),
						'',
						props);
					return _List_fromArray(
						[
							selector + ('-fs:focus {' + (renderedProps + '\n}')),
							('.' + ($mdgriffith$elm_ui$Internal$Style$classes.kQ + (':focus ' + (selector + '-fs  {')))) + (renderedProps + '\n}'),
							(selector + '-fs:focus-within {') + (renderedProps + '\n}'),
							('.ui-slide-bar:focus + ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kQ) + (' .focusable-thumb' + (selector + '-fs {')))) + (renderedProps + '\n}')
						]);
				default:
					return _List_fromArray(
						[
							selector + ('-act:active {' + (A3(
							$elm$core$List$foldl,
							$mdgriffith$elm_ui$Internal$Model$renderProps(false),
							'',
							props) + '\n}'))
						]);
			}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$renderVariant = function (_var) {
	switch (_var.$) {
		case 0:
			var name = _var.a;
			return '\"' + (name + '\"');
		case 1:
			var name = _var.a;
			return '\"' + (name + '\" 0');
		default:
			var name = _var.a;
			var index = _var.b;
			return '\"' + (name + ('\" ' + $elm$core$String$fromInt(index)));
	}
};
var $mdgriffith$elm_ui$Internal$Model$renderVariants = function (typeface) {
	if (typeface.$ === 5) {
		var font = typeface.a;
		return $elm$core$Maybe$Just(
			A2(
				$elm$core$String$join,
				', ',
				A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$renderVariant, font.ku)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $mdgriffith$elm_ui$Internal$Model$transformValue = function (transform) {
	switch (transform.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var _v1 = transform.a;
			var x = _v1.a;
			var y = _v1.b;
			var z = _v1.c;
			return $elm$core$Maybe$Just(
				'translate3d(' + ($elm$core$String$fromFloat(x) + ('px, ' + ($elm$core$String$fromFloat(y) + ('px, ' + ($elm$core$String$fromFloat(z) + 'px)'))))));
		default:
			var _v2 = transform.a;
			var tx = _v2.a;
			var ty = _v2.b;
			var tz = _v2.c;
			var _v3 = transform.b;
			var sx = _v3.a;
			var sy = _v3.b;
			var sz = _v3.c;
			var _v4 = transform.c;
			var ox = _v4.a;
			var oy = _v4.b;
			var oz = _v4.c;
			var angle = transform.d;
			var translate = 'translate3d(' + ($elm$core$String$fromFloat(tx) + ('px, ' + ($elm$core$String$fromFloat(ty) + ('px, ' + ($elm$core$String$fromFloat(tz) + 'px)')))));
			var scale = 'scale3d(' + ($elm$core$String$fromFloat(sx) + (', ' + ($elm$core$String$fromFloat(sy) + (', ' + ($elm$core$String$fromFloat(sz) + ')')))));
			var rotate = 'rotate3d(' + ($elm$core$String$fromFloat(ox) + (', ' + ($elm$core$String$fromFloat(oy) + (', ' + ($elm$core$String$fromFloat(oz) + (', ' + ($elm$core$String$fromFloat(angle) + 'rad)')))))));
			return $elm$core$Maybe$Just(translate + (' ' + (scale + (' ' + rotate))));
	}
};
var $mdgriffith$elm_ui$Internal$Model$renderStyleRule = F3(
	function (options, rule, maybePseudo) {
		switch (rule.$) {
			case 0:
				var selector = rule.a;
				var props = rule.b;
				return A4($mdgriffith$elm_ui$Internal$Model$renderStyle, options, maybePseudo, selector, props);
			case 13:
				var name = rule.a;
				var prop = rule.b;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.' + name,
					_List_fromArray(
						[
							A2($mdgriffith$elm_ui$Internal$Model$Property, 'box-shadow', prop)
						]));
			case 12:
				var name = rule.a;
				var transparency = rule.b;
				var opacity = A2(
					$elm$core$Basics$max,
					0,
					A2($elm$core$Basics$min, 1, 1 - transparency));
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.' + name,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							'opacity',
							$elm$core$String$fromFloat(opacity))
						]));
			case 2:
				var i = rule.a;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.font-size-' + $elm$core$String$fromInt(i),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							'font-size',
							$elm$core$String$fromInt(i) + 'px')
						]));
			case 1:
				var name = rule.a;
				var typefaces = rule.b;
				var features = A2(
					$elm$core$String$join,
					', ',
					A2($elm$core$List$filterMap, $mdgriffith$elm_ui$Internal$Model$renderVariants, typefaces));
				var families = _List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Model$Property,
						'font-family',
						A2(
							$elm$core$String$join,
							', ',
							A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$fontName, typefaces))),
						A2($mdgriffith$elm_ui$Internal$Model$Property, 'font-feature-settings', features),
						A2(
						$mdgriffith$elm_ui$Internal$Model$Property,
						'font-variant',
						A2($elm$core$List$any, $mdgriffith$elm_ui$Internal$Model$hasSmallCaps, typefaces) ? 'small-caps' : 'normal')
					]);
				return A4($mdgriffith$elm_ui$Internal$Model$renderStyle, options, maybePseudo, '.' + name, families);
			case 3:
				var _class = rule.a;
				var prop = rule.b;
				var val = rule.c;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.' + _class,
					_List_fromArray(
						[
							A2($mdgriffith$elm_ui$Internal$Model$Property, prop, val)
						]));
			case 4:
				var _class = rule.a;
				var prop = rule.b;
				var color = rule.c;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.' + _class,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							prop,
							$mdgriffith$elm_ui$Internal$Model$formatColor(color))
						]));
			case 5:
				var cls = rule.a;
				var x = rule.b;
				var y = rule.c;
				var yPx = $elm$core$String$fromInt(y) + 'px';
				var xPx = $elm$core$String$fromInt(x) + 'px';
				var single = '.' + $mdgriffith$elm_ui$Internal$Style$classes.nM;
				var row = '.' + $mdgriffith$elm_ui$Internal$Style$classes.dv;
				var wrappedRow = '.' + ($mdgriffith$elm_ui$Internal$Style$classes.hL + row);
				var right = '.' + $mdgriffith$elm_ui$Internal$Style$classes.eJ;
				var paragraph = '.' + $mdgriffith$elm_ui$Internal$Style$classes.jt;
				var page = '.' + $mdgriffith$elm_ui$Internal$Style$classes.cv;
				var left = '.' + $mdgriffith$elm_ui$Internal$Style$classes.hQ;
				var halfY = $elm$core$String$fromFloat(y / 2) + 'px';
				var halfX = $elm$core$String$fromFloat(x / 2) + 'px';
				var column = '.' + $mdgriffith$elm_ui$Internal$Style$classes.dV;
				var _class = '.' + cls;
				var any = '.' + $mdgriffith$elm_ui$Internal$Style$classes.kQ;
				return $elm$core$List$concat(
					_List_fromArray(
						[
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (row + (' > ' + (any + (' + ' + any)))),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-left', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (wrappedRow + (' > ' + any)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin', halfY + (' ' + halfX))
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (column + (' > ' + (any + (' + ' + any)))),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-top', yPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (page + (' > ' + (any + (' + ' + any)))),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-top', yPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (page + (' > ' + left)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-right', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (page + (' > ' + right)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-left', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_Utils_ap(_class, paragraph),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'line-height',
									'calc(1em + ' + ($elm$core$String$fromInt(y) + 'px)'))
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							'textarea' + (any + _class),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'line-height',
									'calc(1em + ' + ($elm$core$String$fromInt(y) + 'px)')),
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'height',
									'calc(100% + ' + ($elm$core$String$fromInt(y) + 'px)'))
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (paragraph + (' > ' + left)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-right', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (paragraph + (' > ' + right)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-left', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (paragraph + '::after'),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'content', '\'\''),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'display', 'block'),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'height', '0'),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'width', '0'),
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'margin-top',
									$elm$core$String$fromInt((-1) * ((y / 2) | 0)) + 'px')
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (paragraph + '::before'),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'content', '\'\''),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'display', 'block'),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'height', '0'),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'width', '0'),
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'margin-bottom',
									$elm$core$String$fromInt((-1) * ((y / 2) | 0)) + 'px')
								]))
						]));
			case 7:
				var cls = rule.a;
				var top = rule.b;
				var right = rule.c;
				var bottom = rule.d;
				var left = rule.e;
				var _class = '.' + cls;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					_class,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							'padding',
							$elm$core$String$fromFloat(top) + ('px ' + ($elm$core$String$fromFloat(right) + ('px ' + ($elm$core$String$fromFloat(bottom) + ('px ' + ($elm$core$String$fromFloat(left) + 'px')))))))
						]));
			case 6:
				var cls = rule.a;
				var top = rule.b;
				var right = rule.c;
				var bottom = rule.d;
				var left = rule.e;
				var _class = '.' + cls;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					_class,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							'border-width',
							$elm$core$String$fromInt(top) + ('px ' + ($elm$core$String$fromInt(right) + ('px ' + ($elm$core$String$fromInt(bottom) + ('px ' + ($elm$core$String$fromInt(left) + 'px')))))))
						]));
			case 8:
				var template = rule.a;
				var toGridLengthHelper = F3(
					function (minimum, maximum, x) {
						toGridLengthHelper:
						while (true) {
							switch (x.$) {
								case 0:
									var px = x.a;
									return $elm$core$String$fromInt(px) + 'px';
								case 1:
									var _v2 = _Utils_Tuple2(minimum, maximum);
									if (_v2.a.$ === 1) {
										if (_v2.b.$ === 1) {
											var _v3 = _v2.a;
											var _v4 = _v2.b;
											return 'max-content';
										} else {
											var _v6 = _v2.a;
											var maxSize = _v2.b.a;
											return 'minmax(max-content, ' + ($elm$core$String$fromInt(maxSize) + 'px)');
										}
									} else {
										if (_v2.b.$ === 1) {
											var minSize = _v2.a.a;
											var _v5 = _v2.b;
											return 'minmax(' + ($elm$core$String$fromInt(minSize) + ('px, ' + 'max-content)'));
										} else {
											var minSize = _v2.a.a;
											var maxSize = _v2.b.a;
											return 'minmax(' + ($elm$core$String$fromInt(minSize) + ('px, ' + ($elm$core$String$fromInt(maxSize) + 'px)')));
										}
									}
								case 2:
									var i = x.a;
									var _v7 = _Utils_Tuple2(minimum, maximum);
									if (_v7.a.$ === 1) {
										if (_v7.b.$ === 1) {
											var _v8 = _v7.a;
											var _v9 = _v7.b;
											return $elm$core$String$fromInt(i) + 'fr';
										} else {
											var _v11 = _v7.a;
											var maxSize = _v7.b.a;
											return 'minmax(max-content, ' + ($elm$core$String$fromInt(maxSize) + 'px)');
										}
									} else {
										if (_v7.b.$ === 1) {
											var minSize = _v7.a.a;
											var _v10 = _v7.b;
											return 'minmax(' + ($elm$core$String$fromInt(minSize) + ('px, ' + ($elm$core$String$fromInt(i) + ('fr' + 'fr)'))));
										} else {
											var minSize = _v7.a.a;
											var maxSize = _v7.b.a;
											return 'minmax(' + ($elm$core$String$fromInt(minSize) + ('px, ' + ($elm$core$String$fromInt(maxSize) + 'px)')));
										}
									}
								case 3:
									var m = x.a;
									var len = x.b;
									var $temp$minimum = $elm$core$Maybe$Just(m),
										$temp$maximum = maximum,
										$temp$x = len;
									minimum = $temp$minimum;
									maximum = $temp$maximum;
									x = $temp$x;
									continue toGridLengthHelper;
								default:
									var m = x.a;
									var len = x.b;
									var $temp$minimum = minimum,
										$temp$maximum = $elm$core$Maybe$Just(m),
										$temp$x = len;
									minimum = $temp$minimum;
									maximum = $temp$maximum;
									x = $temp$x;
									continue toGridLengthHelper;
							}
						}
					});
				var toGridLength = function (x) {
					return A3(toGridLengthHelper, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, x);
				};
				var xSpacing = toGridLength(template.j9.a);
				var ySpacing = toGridLength(template.j9.b);
				var rows = function (x) {
					return 'grid-template-rows: ' + (x + ';');
				}(
					A2(
						$elm$core$String$join,
						' ',
						A2($elm$core$List$map, toGridLength, template.nA)));
				var msRows = function (x) {
					return '-ms-grid-rows: ' + (x + ';');
				}(
					A2(
						$elm$core$String$join,
						ySpacing,
						A2($elm$core$List$map, toGridLength, template.eT)));
				var msColumns = function (x) {
					return '-ms-grid-columns: ' + (x + ';');
				}(
					A2(
						$elm$core$String$join,
						ySpacing,
						A2($elm$core$List$map, toGridLength, template.eT)));
				var gapY = 'grid-row-gap:' + (toGridLength(template.j9.b) + ';');
				var gapX = 'grid-column-gap:' + (toGridLength(template.j9.a) + ';');
				var columns = function (x) {
					return 'grid-template-columns: ' + (x + ';');
				}(
					A2(
						$elm$core$String$join,
						' ',
						A2($elm$core$List$map, toGridLength, template.eT)));
				var _class = '.grid-rows-' + (A2(
					$elm$core$String$join,
					'-',
					A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$lengthClassName, template.nA)) + ('-cols-' + (A2(
					$elm$core$String$join,
					'-',
					A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$lengthClassName, template.eT)) + ('-space-x-' + ($mdgriffith$elm_ui$Internal$Model$lengthClassName(template.j9.a) + ('-space-y-' + $mdgriffith$elm_ui$Internal$Model$lengthClassName(template.j9.b)))))));
				var modernGrid = _class + ('{' + (columns + (rows + (gapX + (gapY + '}')))));
				var supports = '@supports (display:grid) {' + (modernGrid + '}');
				var base = _class + ('{' + (msColumns + (msRows + '}')));
				return _List_fromArray(
					[base, supports]);
			case 9:
				var position = rule.a;
				var msPosition = A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						[
							'-ms-grid-row: ' + ($elm$core$String$fromInt(position.dv) + ';'),
							'-ms-grid-row-span: ' + ($elm$core$String$fromInt(position.iK) + ';'),
							'-ms-grid-column: ' + ($elm$core$String$fromInt(position.h3) + ';'),
							'-ms-grid-column-span: ' + ($elm$core$String$fromInt(position.oy) + ';')
						]));
				var modernPosition = A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						[
							'grid-row: ' + ($elm$core$String$fromInt(position.dv) + (' / ' + ($elm$core$String$fromInt(position.dv + position.iK) + ';'))),
							'grid-column: ' + ($elm$core$String$fromInt(position.h3) + (' / ' + ($elm$core$String$fromInt(position.h3 + position.oy) + ';')))
						]));
				var _class = '.grid-pos-' + ($elm$core$String$fromInt(position.dv) + ('-' + ($elm$core$String$fromInt(position.h3) + ('-' + ($elm$core$String$fromInt(position.oy) + ('-' + $elm$core$String$fromInt(position.iK)))))));
				var modernGrid = _class + ('{' + (modernPosition + '}'));
				var supports = '@supports (display:grid) {' + (modernGrid + '}');
				var base = _class + ('{' + (msPosition + '}'));
				return _List_fromArray(
					[base, supports]);
			case 11:
				var _class = rule.a;
				var styles = rule.b;
				var renderPseudoRule = function (style) {
					return A3(
						$mdgriffith$elm_ui$Internal$Model$renderStyleRule,
						options,
						style,
						$elm$core$Maybe$Just(_class));
				};
				return A2($elm$core$List$concatMap, renderPseudoRule, styles);
			default:
				var transform = rule.a;
				var val = $mdgriffith$elm_ui$Internal$Model$transformValue(transform);
				var _class = $mdgriffith$elm_ui$Internal$Model$transformClass(transform);
				var _v12 = _Utils_Tuple2(_class, val);
				if ((!_v12.a.$) && (!_v12.b.$)) {
					var cls = _v12.a.a;
					var v = _v12.b.a;
					return A4(
						$mdgriffith$elm_ui$Internal$Model$renderStyle,
						options,
						maybePseudo,
						'.' + cls,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Model$Property, 'transform', v)
							]));
				} else {
					return _List_Nil;
				}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$encodeStyles = F2(
	function (options, stylesheet) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$map,
				function (style) {
					var styled = A3($mdgriffith$elm_ui$Internal$Model$renderStyleRule, options, style, $elm$core$Maybe$Nothing);
					return _Utils_Tuple2(
						$mdgriffith$elm_ui$Internal$Model$getStyleName(style),
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, styled));
				},
				stylesheet));
	});
var $mdgriffith$elm_ui$Internal$Model$bracket = F2(
	function (selector, rules) {
		var renderPair = function (_v0) {
			var name = _v0.a;
			var val = _v0.b;
			return name + (': ' + (val + ';'));
		};
		return selector + (' {' + (A2(
			$elm$core$String$join,
			'',
			A2($elm$core$List$map, renderPair, rules)) + '}'));
	});
var $mdgriffith$elm_ui$Internal$Model$fontRule = F3(
	function (name, modifier, _v0) {
		var parentAdj = _v0.a;
		var textAdjustment = _v0.b;
		return _List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Model$bracket, '.' + (name + ('.' + (modifier + (', ' + ('.' + (name + (' .' + modifier))))))), parentAdj),
				A2($mdgriffith$elm_ui$Internal$Model$bracket, '.' + (name + ('.' + (modifier + ('> .' + ($mdgriffith$elm_ui$Internal$Style$classes.n3 + (', .' + (name + (' .' + (modifier + (' > .' + $mdgriffith$elm_ui$Internal$Style$classes.n3)))))))))), textAdjustment)
			]);
	});
var $mdgriffith$elm_ui$Internal$Model$renderFontAdjustmentRule = F3(
	function (fontToAdjust, _v0, otherFontName) {
		var full = _v0.a;
		var capital = _v0.b;
		var name = _Utils_eq(fontToAdjust, otherFontName) ? fontToAdjust : (otherFontName + (' .' + fontToAdjust));
		return A2(
			$elm$core$String$join,
			' ',
			_Utils_ap(
				A3($mdgriffith$elm_ui$Internal$Model$fontRule, name, $mdgriffith$elm_ui$Internal$Style$classes.nN, capital),
				A3($mdgriffith$elm_ui$Internal$Model$fontRule, name, $mdgriffith$elm_ui$Internal$Style$classes.l3, full)));
	});
var $mdgriffith$elm_ui$Internal$Model$renderNullAdjustmentRule = F2(
	function (fontToAdjust, otherFontName) {
		var name = _Utils_eq(fontToAdjust, otherFontName) ? fontToAdjust : (otherFontName + (' .' + fontToAdjust));
		return A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Internal$Model$bracket,
					'.' + (name + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.nN + (', ' + ('.' + (name + (' .' + $mdgriffith$elm_ui$Internal$Style$classes.nN))))))),
					_List_fromArray(
						[
							_Utils_Tuple2('line-height', '1')
						])),
					A2(
					$mdgriffith$elm_ui$Internal$Model$bracket,
					'.' + (name + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.nN + ('> .' + ($mdgriffith$elm_ui$Internal$Style$classes.n3 + (', .' + (name + (' .' + ($mdgriffith$elm_ui$Internal$Style$classes.nN + (' > .' + $mdgriffith$elm_ui$Internal$Style$classes.n3)))))))))),
					_List_fromArray(
						[
							_Utils_Tuple2('vertical-align', '0'),
							_Utils_Tuple2('line-height', '1')
						]))
				]));
	});
var $mdgriffith$elm_ui$Internal$Model$adjust = F3(
	function (size, height, vertical) {
		return {iK: height / size, bB: size, kw: vertical};
	});
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$List$minimum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$min, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $mdgriffith$elm_ui$Internal$Model$convertAdjustment = function (adjustment) {
	var lines = _List_fromArray(
		[adjustment.k9, adjustment.kX, adjustment.lC, adjustment.mF]);
	var lineHeight = 1.5;
	var normalDescender = (lineHeight - 1) / 2;
	var oldMiddle = lineHeight / 2;
	var descender = A2(
		$elm$core$Maybe$withDefault,
		adjustment.lC,
		$elm$core$List$minimum(lines));
	var newBaseline = A2(
		$elm$core$Maybe$withDefault,
		adjustment.kX,
		$elm$core$List$minimum(
			A2(
				$elm$core$List$filter,
				function (x) {
					return !_Utils_eq(x, descender);
				},
				lines)));
	var base = lineHeight;
	var ascender = A2(
		$elm$core$Maybe$withDefault,
		adjustment.k9,
		$elm$core$List$maximum(lines));
	var capitalSize = 1 / (ascender - newBaseline);
	var capitalVertical = 1 - ascender;
	var fullSize = 1 / (ascender - descender);
	var fullVertical = 1 - ascender;
	var newCapitalMiddle = ((ascender - newBaseline) / 2) + newBaseline;
	var newFullMiddle = ((ascender - descender) / 2) + descender;
	return {
		k9: A3($mdgriffith$elm_ui$Internal$Model$adjust, capitalSize, ascender - newBaseline, capitalVertical),
		iG: A3($mdgriffith$elm_ui$Internal$Model$adjust, fullSize, ascender - descender, fullVertical)
	};
};
var $mdgriffith$elm_ui$Internal$Model$fontAdjustmentRules = function (converted) {
	return _Utils_Tuple2(
		_List_fromArray(
			[
				_Utils_Tuple2('display', 'block')
			]),
		_List_fromArray(
			[
				_Utils_Tuple2('display', 'inline-block'),
				_Utils_Tuple2(
				'line-height',
				$elm$core$String$fromFloat(converted.iK)),
				_Utils_Tuple2(
				'vertical-align',
				$elm$core$String$fromFloat(converted.kw) + 'em'),
				_Utils_Tuple2(
				'font-size',
				$elm$core$String$fromFloat(converted.bB) + 'em')
			]));
};
var $mdgriffith$elm_ui$Internal$Model$typefaceAdjustment = function (typefaces) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (face, found) {
				if (found.$ === 1) {
					if (face.$ === 5) {
						var _with = face.a;
						var _v2 = _with.kE;
						if (_v2.$ === 1) {
							return found;
						} else {
							var adjustment = _v2.a;
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$mdgriffith$elm_ui$Internal$Model$fontAdjustmentRules(
										function ($) {
											return $.iG;
										}(
											$mdgriffith$elm_ui$Internal$Model$convertAdjustment(adjustment))),
									$mdgriffith$elm_ui$Internal$Model$fontAdjustmentRules(
										function ($) {
											return $.k9;
										}(
											$mdgriffith$elm_ui$Internal$Model$convertAdjustment(adjustment)))));
						}
					} else {
						return found;
					}
				} else {
					return found;
				}
			}),
		$elm$core$Maybe$Nothing,
		typefaces);
};
var $mdgriffith$elm_ui$Internal$Model$renderTopLevelValues = function (rules) {
	var withImport = function (font) {
		if (font.$ === 4) {
			var url = font.b;
			return $elm$core$Maybe$Just('@import url(\'' + (url + '\');'));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	var fontImports = function (_v2) {
		var name = _v2.a;
		var typefaces = _v2.b;
		var imports = A2(
			$elm$core$String$join,
			'\n',
			A2($elm$core$List$filterMap, withImport, typefaces));
		return imports;
	};
	var allNames = A2($elm$core$List$map, $elm$core$Tuple$first, rules);
	var fontAdjustments = function (_v1) {
		var name = _v1.a;
		var typefaces = _v1.b;
		var _v0 = $mdgriffith$elm_ui$Internal$Model$typefaceAdjustment(typefaces);
		if (_v0.$ === 1) {
			return A2(
				$elm$core$String$join,
				'',
				A2(
					$elm$core$List$map,
					$mdgriffith$elm_ui$Internal$Model$renderNullAdjustmentRule(name),
					allNames));
		} else {
			var adjustment = _v0.a;
			return A2(
				$elm$core$String$join,
				'',
				A2(
					$elm$core$List$map,
					A2($mdgriffith$elm_ui$Internal$Model$renderFontAdjustmentRule, name, adjustment),
					allNames));
		}
	};
	return _Utils_ap(
		A2(
			$elm$core$String$join,
			'\n',
			A2($elm$core$List$map, fontImports, rules)),
		A2(
			$elm$core$String$join,
			'\n',
			A2($elm$core$List$map, fontAdjustments, rules)));
};
var $mdgriffith$elm_ui$Internal$Model$topLevelValue = function (rule) {
	if (rule.$ === 1) {
		var name = rule.a;
		var typefaces = rule.b;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(name, typefaces));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $mdgriffith$elm_ui$Internal$Model$toStyleSheetString = F2(
	function (options, stylesheet) {
		var combine = F2(
			function (style, rendered) {
				return {
					fM: _Utils_ap(
						rendered.fM,
						A3($mdgriffith$elm_ui$Internal$Model$renderStyleRule, options, style, $elm$core$Maybe$Nothing)),
					ey: function () {
						var _v1 = $mdgriffith$elm_ui$Internal$Model$topLevelValue(style);
						if (_v1.$ === 1) {
							return rendered.ey;
						} else {
							var topLevel = _v1.a;
							return A2($elm$core$List$cons, topLevel, rendered.ey);
						}
					}()
				};
			});
		var _v0 = A3(
			$elm$core$List$foldl,
			combine,
			{fM: _List_Nil, ey: _List_Nil},
			stylesheet);
		var topLevel = _v0.ey;
		var rules = _v0.fM;
		return _Utils_ap(
			$mdgriffith$elm_ui$Internal$Model$renderTopLevelValues(topLevel),
			$elm$core$String$concat(rules));
	});
var $mdgriffith$elm_ui$Internal$Model$toStyleSheet = F2(
	function (options, styleSheet) {
		var _v0 = options.mK;
		switch (_v0) {
			case 0:
				return A3(
					$elm$virtual_dom$VirtualDom$node,
					'div',
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$elm$virtual_dom$VirtualDom$node,
							'style',
							_List_Nil,
							_List_fromArray(
								[
									$elm$virtual_dom$VirtualDom$text(
									A2($mdgriffith$elm_ui$Internal$Model$toStyleSheetString, options, styleSheet))
								]))
						]));
			case 1:
				return A3(
					$elm$virtual_dom$VirtualDom$node,
					'div',
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$elm$virtual_dom$VirtualDom$node,
							'style',
							_List_Nil,
							_List_fromArray(
								[
									$elm$virtual_dom$VirtualDom$text(
									A2($mdgriffith$elm_ui$Internal$Model$toStyleSheetString, options, styleSheet))
								]))
						]));
			default:
				return A3(
					$elm$virtual_dom$VirtualDom$node,
					'elm-ui-rules',
					_List_fromArray(
						[
							A2(
							$elm$virtual_dom$VirtualDom$property,
							'rules',
							A2($mdgriffith$elm_ui$Internal$Model$encodeStyles, options, styleSheet))
						]),
					_List_Nil);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$embedKeyed = F4(
	function (_static, opts, styles, children) {
		var dynamicStyleSheet = A2(
			$mdgriffith$elm_ui$Internal$Model$toStyleSheet,
			opts,
			A3(
				$elm$core$List$foldl,
				$mdgriffith$elm_ui$Internal$Model$reduceStyles,
				_Utils_Tuple2(
					$elm$core$Set$empty,
					$mdgriffith$elm_ui$Internal$Model$renderFocusStyle(opts.db)),
				styles).b);
		return _static ? A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'static-stylesheet',
				$mdgriffith$elm_ui$Internal$Model$staticRoot(opts)),
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2('dynamic-stylesheet', dynamicStyleSheet),
				children)) : A2(
			$elm$core$List$cons,
			_Utils_Tuple2('dynamic-stylesheet', dynamicStyleSheet),
			children);
	});
var $mdgriffith$elm_ui$Internal$Model$embedWith = F4(
	function (_static, opts, styles, children) {
		var dynamicStyleSheet = A2(
			$mdgriffith$elm_ui$Internal$Model$toStyleSheet,
			opts,
			A3(
				$elm$core$List$foldl,
				$mdgriffith$elm_ui$Internal$Model$reduceStyles,
				_Utils_Tuple2(
					$elm$core$Set$empty,
					$mdgriffith$elm_ui$Internal$Model$renderFocusStyle(opts.db)),
				styles).b);
		return _static ? A2(
			$elm$core$List$cons,
			$mdgriffith$elm_ui$Internal$Model$staticRoot(opts),
			A2($elm$core$List$cons, dynamicStyleSheet, children)) : A2($elm$core$List$cons, dynamicStyleSheet, children);
	});
var $mdgriffith$elm_ui$Internal$Flag$heightBetween = $mdgriffith$elm_ui$Internal$Flag$flag(45);
var $mdgriffith$elm_ui$Internal$Flag$heightFill = $mdgriffith$elm_ui$Internal$Flag$flag(37);
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$p = _VirtualDom_node('p');
var $mdgriffith$elm_ui$Internal$Flag$present = F2(
	function (myFlag, _v0) {
		var fieldOne = _v0.a;
		var fieldTwo = _v0.b;
		if (!myFlag.$) {
			var first = myFlag.a;
			return _Utils_eq(first & fieldOne, first);
		} else {
			var second = myFlag.a;
			return _Utils_eq(second & fieldTwo, second);
		}
	});
var $elm$html$Html$s = _VirtualDom_node('s');
var $elm$html$Html$u = _VirtualDom_node('u');
var $mdgriffith$elm_ui$Internal$Flag$widthBetween = $mdgriffith$elm_ui$Internal$Flag$flag(44);
var $mdgriffith$elm_ui$Internal$Flag$widthFill = $mdgriffith$elm_ui$Internal$Flag$flag(39);
var $mdgriffith$elm_ui$Internal$Model$finalizeNode = F6(
	function (has, node, attributes, children, embedMode, parentContext) {
		var createNode = F2(
			function (nodeName, attrs) {
				if (children.$ === 1) {
					var keyed = children.a;
					return A3(
						$elm$virtual_dom$VirtualDom$keyedNode,
						nodeName,
						attrs,
						function () {
							switch (embedMode.$) {
								case 0:
									return keyed;
								case 2:
									var opts = embedMode.a;
									var styles = embedMode.b;
									return A4($mdgriffith$elm_ui$Internal$Model$embedKeyed, false, opts, styles, keyed);
								default:
									var opts = embedMode.a;
									var styles = embedMode.b;
									return A4($mdgriffith$elm_ui$Internal$Model$embedKeyed, true, opts, styles, keyed);
							}
						}());
				} else {
					var unkeyed = children.a;
					return A2(
						function () {
							switch (nodeName) {
								case 'div':
									return $elm$html$Html$div;
								case 'p':
									return $elm$html$Html$p;
								default:
									return $elm$virtual_dom$VirtualDom$node(nodeName);
							}
						}(),
						attrs,
						function () {
							switch (embedMode.$) {
								case 0:
									return unkeyed;
								case 2:
									var opts = embedMode.a;
									var styles = embedMode.b;
									return A4($mdgriffith$elm_ui$Internal$Model$embedWith, false, opts, styles, unkeyed);
								default:
									var opts = embedMode.a;
									var styles = embedMode.b;
									return A4($mdgriffith$elm_ui$Internal$Model$embedWith, true, opts, styles, unkeyed);
							}
						}());
				}
			});
		var html = function () {
			switch (node.$) {
				case 0:
					return A2(createNode, 'div', attributes);
				case 1:
					var nodeName = node.a;
					return A2(createNode, nodeName, attributes);
				default:
					var nodeName = node.a;
					var internal = node.b;
					return A3(
						$elm$virtual_dom$VirtualDom$node,
						nodeName,
						attributes,
						_List_fromArray(
							[
								A2(
								createNode,
								internal,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class($mdgriffith$elm_ui$Internal$Style$classes.kQ + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.nM))
									]))
							]));
			}
		}();
		switch (parentContext) {
			case 0:
				return (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$widthFill, has) && (!A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$widthBetween, has))) ? html : (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$alignRight, has) ? A2(
					$elm$html$Html$u,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[$mdgriffith$elm_ui$Internal$Style$classes.kQ, $mdgriffith$elm_ui$Internal$Style$classes.nM, $mdgriffith$elm_ui$Internal$Style$classes.eX, $mdgriffith$elm_ui$Internal$Style$classes.bI, $mdgriffith$elm_ui$Internal$Style$classes.kL])))
						]),
					_List_fromArray(
						[html])) : (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$centerX, has) ? A2(
					$elm$html$Html$s,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[$mdgriffith$elm_ui$Internal$Style$classes.kQ, $mdgriffith$elm_ui$Internal$Style$classes.nM, $mdgriffith$elm_ui$Internal$Style$classes.eX, $mdgriffith$elm_ui$Internal$Style$classes.bI, $mdgriffith$elm_ui$Internal$Style$classes.kJ])))
						]),
					_List_fromArray(
						[html])) : html));
			case 1:
				return (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$heightFill, has) && (!A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$heightBetween, has))) ? html : (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$centerY, has) ? A2(
					$elm$html$Html$s,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[$mdgriffith$elm_ui$Internal$Style$classes.kQ, $mdgriffith$elm_ui$Internal$Style$classes.nM, $mdgriffith$elm_ui$Internal$Style$classes.eX, $mdgriffith$elm_ui$Internal$Style$classes.kK])))
						]),
					_List_fromArray(
						[html])) : (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$alignBottom, has) ? A2(
					$elm$html$Html$u,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[$mdgriffith$elm_ui$Internal$Style$classes.kQ, $mdgriffith$elm_ui$Internal$Style$classes.nM, $mdgriffith$elm_ui$Internal$Style$classes.eX, $mdgriffith$elm_ui$Internal$Style$classes.kI])))
						]),
					_List_fromArray(
						[html])) : html));
			default:
				return html;
		}
	});
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $mdgriffith$elm_ui$Internal$Model$textElementClasses = $mdgriffith$elm_ui$Internal$Style$classes.kQ + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.n3 + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.hI + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.gC)))));
var $mdgriffith$elm_ui$Internal$Model$textElement = function (str) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class($mdgriffith$elm_ui$Internal$Model$textElementClasses)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $mdgriffith$elm_ui$Internal$Model$textElementFillClasses = $mdgriffith$elm_ui$Internal$Style$classes.kQ + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.n3 + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.hJ + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.gD)))));
var $mdgriffith$elm_ui$Internal$Model$textElementFill = function (str) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class($mdgriffith$elm_ui$Internal$Model$textElementFillClasses)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $mdgriffith$elm_ui$Internal$Model$createElement = F3(
	function (context, children, rendered) {
		var gatherKeyed = F2(
			function (_v8, _v9) {
				var key = _v8.a;
				var child = _v8.b;
				var htmls = _v9.a;
				var existingStyles = _v9.b;
				switch (child.$) {
					case 0:
						var html = child.a;
						return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									html(context)),
								htmls),
							existingStyles) : _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									html(context)),
								htmls),
							existingStyles);
					case 1:
						var styled = child.a;
						return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									A2(styled.ef, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context)),
								htmls),
							$elm$core$List$isEmpty(existingStyles) ? styled.kh : _Utils_ap(styled.kh, existingStyles)) : _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									A2(styled.ef, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context)),
								htmls),
							$elm$core$List$isEmpty(existingStyles) ? styled.kh : _Utils_ap(styled.kh, existingStyles));
					case 2:
						var str = child.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									_Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asEl) ? $mdgriffith$elm_ui$Internal$Model$textElementFill(str) : $mdgriffith$elm_ui$Internal$Model$textElement(str)),
								htmls),
							existingStyles);
					default:
						return _Utils_Tuple2(htmls, existingStyles);
				}
			});
		var gather = F2(
			function (child, _v6) {
				var htmls = _v6.a;
				var existingStyles = _v6.b;
				switch (child.$) {
					case 0:
						var html = child.a;
						return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								html(context),
								htmls),
							existingStyles) : _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								html(context),
								htmls),
							existingStyles);
					case 1:
						var styled = child.a;
						return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								A2(styled.ef, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context),
								htmls),
							$elm$core$List$isEmpty(existingStyles) ? styled.kh : _Utils_ap(styled.kh, existingStyles)) : _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								A2(styled.ef, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context),
								htmls),
							$elm$core$List$isEmpty(existingStyles) ? styled.kh : _Utils_ap(styled.kh, existingStyles));
					case 2:
						var str = child.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asEl) ? $mdgriffith$elm_ui$Internal$Model$textElementFill(str) : $mdgriffith$elm_ui$Internal$Model$textElement(str),
								htmls),
							existingStyles);
					default:
						return _Utils_Tuple2(htmls, existingStyles);
				}
			});
		if (children.$ === 1) {
			var keyedChildren = children.a;
			var _v1 = A3(
				$elm$core$List$foldr,
				gatherKeyed,
				_Utils_Tuple2(_List_Nil, _List_Nil),
				keyedChildren);
			var keyed = _v1.a;
			var styles = _v1.b;
			var newStyles = $elm$core$List$isEmpty(styles) ? rendered.kh : _Utils_ap(rendered.kh, styles);
			if (!newStyles.b) {
				return $mdgriffith$elm_ui$Internal$Model$Unstyled(
					A5(
						$mdgriffith$elm_ui$Internal$Model$finalizeNode,
						rendered.cq,
						rendered.jn,
						rendered.cb,
						$mdgriffith$elm_ui$Internal$Model$Keyed(
							A3($mdgriffith$elm_ui$Internal$Model$addKeyedChildren, 'nearby-element-pls', keyed, rendered.ld)),
						$mdgriffith$elm_ui$Internal$Model$NoStyleSheet));
			} else {
				var allStyles = newStyles;
				return $mdgriffith$elm_ui$Internal$Model$Styled(
					{
						ef: A4(
							$mdgriffith$elm_ui$Internal$Model$finalizeNode,
							rendered.cq,
							rendered.jn,
							rendered.cb,
							$mdgriffith$elm_ui$Internal$Model$Keyed(
								A3($mdgriffith$elm_ui$Internal$Model$addKeyedChildren, 'nearby-element-pls', keyed, rendered.ld))),
						kh: allStyles
					});
			}
		} else {
			var unkeyedChildren = children.a;
			var _v3 = A3(
				$elm$core$List$foldr,
				gather,
				_Utils_Tuple2(_List_Nil, _List_Nil),
				unkeyedChildren);
			var unkeyed = _v3.a;
			var styles = _v3.b;
			var newStyles = $elm$core$List$isEmpty(styles) ? rendered.kh : _Utils_ap(rendered.kh, styles);
			if (!newStyles.b) {
				return $mdgriffith$elm_ui$Internal$Model$Unstyled(
					A5(
						$mdgriffith$elm_ui$Internal$Model$finalizeNode,
						rendered.cq,
						rendered.jn,
						rendered.cb,
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							A2($mdgriffith$elm_ui$Internal$Model$addChildren, unkeyed, rendered.ld)),
						$mdgriffith$elm_ui$Internal$Model$NoStyleSheet));
			} else {
				var allStyles = newStyles;
				return $mdgriffith$elm_ui$Internal$Model$Styled(
					{
						ef: A4(
							$mdgriffith$elm_ui$Internal$Model$finalizeNode,
							rendered.cq,
							rendered.jn,
							rendered.cb,
							$mdgriffith$elm_ui$Internal$Model$Unkeyed(
								A2($mdgriffith$elm_ui$Internal$Model$addChildren, unkeyed, rendered.ld))),
						kh: allStyles
					});
			}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$Single = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $mdgriffith$elm_ui$Internal$Model$Transform = function (a) {
	return {$: 10, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$add = F2(
	function (myFlag, _v0) {
		var one = _v0.a;
		var two = _v0.b;
		if (!myFlag.$) {
			var first = myFlag.a;
			return A2($mdgriffith$elm_ui$Internal$Flag$Field, first | one, two);
		} else {
			var second = myFlag.a;
			return A2($mdgriffith$elm_ui$Internal$Flag$Field, one, second | two);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$ChildrenBehind = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$ChildrenInFront = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$nearbyElement = F2(
	function (location, elem) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					function () {
						switch (location) {
							case 0:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.dj, $mdgriffith$elm_ui$Internal$Style$classes.nM, $mdgriffith$elm_ui$Internal$Style$classes.eI]));
							case 1:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.dj, $mdgriffith$elm_ui$Internal$Style$classes.nM, $mdgriffith$elm_ui$Internal$Style$classes.eM]));
							case 2:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.dj, $mdgriffith$elm_ui$Internal$Style$classes.nM, $mdgriffith$elm_ui$Internal$Style$classes.m1]));
							case 3:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.dj, $mdgriffith$elm_ui$Internal$Style$classes.nM, $mdgriffith$elm_ui$Internal$Style$classes.m$]));
							case 4:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.dj, $mdgriffith$elm_ui$Internal$Style$classes.nM, $mdgriffith$elm_ui$Internal$Style$classes.mj]));
							default:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.dj, $mdgriffith$elm_ui$Internal$Style$classes.nM, $mdgriffith$elm_ui$Internal$Style$classes.kY]));
						}
					}())
				]),
			_List_fromArray(
				[
					function () {
					switch (elem.$) {
						case 3:
							return $elm$virtual_dom$VirtualDom$text('');
						case 2:
							var str = elem.a;
							return $mdgriffith$elm_ui$Internal$Model$textElement(str);
						case 0:
							var html = elem.a;
							return html($mdgriffith$elm_ui$Internal$Model$asEl);
						default:
							var styled = elem.a;
							return A2(styled.ef, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, $mdgriffith$elm_ui$Internal$Model$asEl);
					}
				}()
				]));
	});
var $mdgriffith$elm_ui$Internal$Model$addNearbyElement = F3(
	function (location, elem, existing) {
		var nearby = A2($mdgriffith$elm_ui$Internal$Model$nearbyElement, location, elem);
		switch (existing.$) {
			case 0:
				if (location === 5) {
					return $mdgriffith$elm_ui$Internal$Model$ChildrenBehind(
						_List_fromArray(
							[nearby]));
				} else {
					return $mdgriffith$elm_ui$Internal$Model$ChildrenInFront(
						_List_fromArray(
							[nearby]));
				}
			case 1:
				var existingBehind = existing.a;
				if (location === 5) {
					return $mdgriffith$elm_ui$Internal$Model$ChildrenBehind(
						A2($elm$core$List$cons, nearby, existingBehind));
				} else {
					return A2(
						$mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront,
						existingBehind,
						_List_fromArray(
							[nearby]));
				}
			case 2:
				var existingInFront = existing.a;
				if (location === 5) {
					return A2(
						$mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront,
						_List_fromArray(
							[nearby]),
						existingInFront);
				} else {
					return $mdgriffith$elm_ui$Internal$Model$ChildrenInFront(
						A2($elm$core$List$cons, nearby, existingInFront));
				}
			default:
				var existingBehind = existing.a;
				var existingInFront = existing.b;
				if (location === 5) {
					return A2(
						$mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront,
						A2($elm$core$List$cons, nearby, existingBehind),
						existingInFront);
				} else {
					return A2(
						$mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront,
						existingBehind,
						A2($elm$core$List$cons, nearby, existingInFront));
				}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$Embedded = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$NodeName = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$addNodeName = F2(
	function (newNode, old) {
		switch (old.$) {
			case 0:
				return $mdgriffith$elm_ui$Internal$Model$NodeName(newNode);
			case 1:
				var name = old.a;
				return A2($mdgriffith$elm_ui$Internal$Model$Embedded, name, newNode);
			default:
				var x = old.a;
				var y = old.b;
				return A2($mdgriffith$elm_ui$Internal$Model$Embedded, x, y);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$alignXName = function (align) {
	switch (align) {
		case 0:
			return $mdgriffith$elm_ui$Internal$Style$classes.f2 + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.hQ);
		case 2:
			return $mdgriffith$elm_ui$Internal$Style$classes.f2 + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.eJ);
		default:
			return $mdgriffith$elm_ui$Internal$Style$classes.f2 + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.kG);
	}
};
var $mdgriffith$elm_ui$Internal$Model$alignYName = function (align) {
	switch (align) {
		case 0:
			return $mdgriffith$elm_ui$Internal$Style$classes.f3 + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.eK);
		case 2:
			return $mdgriffith$elm_ui$Internal$Style$classes.f3 + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.kF);
		default:
			return $mdgriffith$elm_ui$Internal$Style$classes.f3 + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.kH);
	}
};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $mdgriffith$elm_ui$Internal$Model$FullTransform = F4(
	function (a, b, c, d) {
		return {$: 2, a: a, b: b, c: c, d: d};
	});
var $mdgriffith$elm_ui$Internal$Model$Moved = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$composeTransformation = F2(
	function (transform, component) {
		switch (transform.$) {
			case 0:
				switch (component.$) {
					case 0:
						var x = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(x, 0, 0));
					case 1:
						var y = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(0, y, 0));
					case 2:
						var z = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(0, 0, z));
					case 3:
						var xyz = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(xyz);
					case 4:
						var xyz = component.a;
						var angle = component.b;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(0, 0, 0),
							_Utils_Tuple3(1, 1, 1),
							xyz,
							angle);
					default:
						var xyz = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(0, 0, 0),
							xyz,
							_Utils_Tuple3(0, 0, 1),
							0);
				}
			case 1:
				var moved = transform.a;
				var x = moved.a;
				var y = moved.b;
				var z = moved.c;
				switch (component.$) {
					case 0:
						var newX = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(newX, y, z));
					case 1:
						var newY = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(x, newY, z));
					case 2:
						var newZ = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(x, y, newZ));
					case 3:
						var xyz = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(xyz);
					case 4:
						var xyz = component.a;
						var angle = component.b;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							moved,
							_Utils_Tuple3(1, 1, 1),
							xyz,
							angle);
					default:
						var scale = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							moved,
							scale,
							_Utils_Tuple3(0, 0, 1),
							0);
				}
			default:
				var moved = transform.a;
				var x = moved.a;
				var y = moved.b;
				var z = moved.c;
				var scaled = transform.b;
				var origin = transform.c;
				var angle = transform.d;
				switch (component.$) {
					case 0:
						var newX = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(newX, y, z),
							scaled,
							origin,
							angle);
					case 1:
						var newY = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(x, newY, z),
							scaled,
							origin,
							angle);
					case 2:
						var newZ = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(x, y, newZ),
							scaled,
							origin,
							angle);
					case 3:
						var newMove = component.a;
						return A4($mdgriffith$elm_ui$Internal$Model$FullTransform, newMove, scaled, origin, angle);
					case 4:
						var newOrigin = component.a;
						var newAngle = component.b;
						return A4($mdgriffith$elm_ui$Internal$Model$FullTransform, moved, scaled, newOrigin, newAngle);
					default:
						var newScale = component.a;
						return A4($mdgriffith$elm_ui$Internal$Model$FullTransform, moved, newScale, origin, angle);
				}
		}
	});
var $mdgriffith$elm_ui$Internal$Flag$height = $mdgriffith$elm_ui$Internal$Flag$flag(7);
var $mdgriffith$elm_ui$Internal$Flag$heightContent = $mdgriffith$elm_ui$Internal$Flag$flag(36);
var $mdgriffith$elm_ui$Internal$Flag$merge = F2(
	function (_v0, _v1) {
		var one = _v0.a;
		var two = _v0.b;
		var three = _v1.a;
		var four = _v1.b;
		return A2($mdgriffith$elm_ui$Internal$Flag$Field, one | three, two | four);
	});
var $mdgriffith$elm_ui$Internal$Flag$none = A2($mdgriffith$elm_ui$Internal$Flag$Field, 0, 0);
var $mdgriffith$elm_ui$Internal$Model$renderHeight = function (h) {
	switch (h.$) {
		case 0:
			var px = h.a;
			var val = $elm$core$String$fromInt(px);
			var name = 'height-px-' + val;
			return _Utils_Tuple3(
				$mdgriffith$elm_ui$Internal$Flag$none,
				$mdgriffith$elm_ui$Internal$Style$classes.iL + (' ' + name),
				_List_fromArray(
					[
						A3($mdgriffith$elm_ui$Internal$Model$Single, name, 'height', val + 'px')
					]));
		case 1:
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightContent, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.gC,
				_List_Nil);
		case 2:
			var portion = h.a;
			return (portion === 1) ? _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightFill, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.gD,
				_List_Nil) : _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightFill, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.iM + (' height-fill-' + $elm$core$String$fromInt(portion)),
				_List_fromArray(
					[
						A3(
						$mdgriffith$elm_ui$Internal$Model$Single,
						$mdgriffith$elm_ui$Internal$Style$classes.kQ + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.dV + (' > ' + $mdgriffith$elm_ui$Internal$Style$dot(
							'height-fill-' + $elm$core$String$fromInt(portion))))),
						'flex-grow',
						$elm$core$String$fromInt(portion * 100000))
					]));
		case 3:
			var minSize = h.a;
			var len = h.b;
			var cls = 'min-height-' + $elm$core$String$fromInt(minSize);
			var style = A3(
				$mdgriffith$elm_ui$Internal$Model$Single,
				cls,
				'min-height',
				$elm$core$String$fromInt(minSize) + 'px !important');
			var _v1 = $mdgriffith$elm_ui$Internal$Model$renderHeight(len);
			var newFlag = _v1.a;
			var newAttrs = _v1.b;
			var newStyle = _v1.c;
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightBetween, newFlag),
				cls + (' ' + newAttrs),
				A2($elm$core$List$cons, style, newStyle));
		default:
			var maxSize = h.a;
			var len = h.b;
			var cls = 'max-height-' + $elm$core$String$fromInt(maxSize);
			var style = A3(
				$mdgriffith$elm_ui$Internal$Model$Single,
				cls,
				'max-height',
				$elm$core$String$fromInt(maxSize) + 'px');
			var _v2 = $mdgriffith$elm_ui$Internal$Model$renderHeight(len);
			var newFlag = _v2.a;
			var newAttrs = _v2.b;
			var newStyle = _v2.c;
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightBetween, newFlag),
				cls + (' ' + newAttrs),
				A2($elm$core$List$cons, style, newStyle));
	}
};
var $mdgriffith$elm_ui$Internal$Flag$widthContent = $mdgriffith$elm_ui$Internal$Flag$flag(38);
var $mdgriffith$elm_ui$Internal$Model$renderWidth = function (w) {
	switch (w.$) {
		case 0:
			var px = w.a;
			return _Utils_Tuple3(
				$mdgriffith$elm_ui$Internal$Flag$none,
				$mdgriffith$elm_ui$Internal$Style$classes.kA + (' width-px-' + $elm$core$String$fromInt(px)),
				_List_fromArray(
					[
						A3(
						$mdgriffith$elm_ui$Internal$Model$Single,
						'width-px-' + $elm$core$String$fromInt(px),
						'width',
						$elm$core$String$fromInt(px) + 'px')
					]));
		case 1:
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthContent, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.hI,
				_List_Nil);
		case 2:
			var portion = w.a;
			return (portion === 1) ? _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthFill, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.hJ,
				_List_Nil) : _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthFill, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.kB + (' width-fill-' + $elm$core$String$fromInt(portion)),
				_List_fromArray(
					[
						A3(
						$mdgriffith$elm_ui$Internal$Model$Single,
						$mdgriffith$elm_ui$Internal$Style$classes.kQ + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.dv + (' > ' + $mdgriffith$elm_ui$Internal$Style$dot(
							'width-fill-' + $elm$core$String$fromInt(portion))))),
						'flex-grow',
						$elm$core$String$fromInt(portion * 100000))
					]));
		case 3:
			var minSize = w.a;
			var len = w.b;
			var cls = 'min-width-' + $elm$core$String$fromInt(minSize);
			var style = A3(
				$mdgriffith$elm_ui$Internal$Model$Single,
				cls,
				'min-width',
				$elm$core$String$fromInt(minSize) + 'px');
			var _v1 = $mdgriffith$elm_ui$Internal$Model$renderWidth(len);
			var newFlag = _v1.a;
			var newAttrs = _v1.b;
			var newStyle = _v1.c;
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthBetween, newFlag),
				cls + (' ' + newAttrs),
				A2($elm$core$List$cons, style, newStyle));
		default:
			var maxSize = w.a;
			var len = w.b;
			var cls = 'max-width-' + $elm$core$String$fromInt(maxSize);
			var style = A3(
				$mdgriffith$elm_ui$Internal$Model$Single,
				cls,
				'max-width',
				$elm$core$String$fromInt(maxSize) + 'px');
			var _v2 = $mdgriffith$elm_ui$Internal$Model$renderWidth(len);
			var newFlag = _v2.a;
			var newAttrs = _v2.b;
			var newStyle = _v2.c;
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthBetween, newFlag),
				cls + (' ' + newAttrs),
				A2($elm$core$List$cons, style, newStyle));
	}
};
var $mdgriffith$elm_ui$Internal$Flag$borderWidth = $mdgriffith$elm_ui$Internal$Flag$flag(27);
var $mdgriffith$elm_ui$Internal$Model$skippable = F2(
	function (flag, style) {
		if (_Utils_eq(flag, $mdgriffith$elm_ui$Internal$Flag$borderWidth)) {
			if (style.$ === 3) {
				var val = style.c;
				switch (val) {
					case '0px':
						return true;
					case '1px':
						return true;
					case '2px':
						return true;
					case '3px':
						return true;
					case '4px':
						return true;
					case '5px':
						return true;
					case '6px':
						return true;
					default:
						return false;
				}
			} else {
				return false;
			}
		} else {
			switch (style.$) {
				case 2:
					var i = style.a;
					return (i >= 8) && (i <= 32);
				case 7:
					var name = style.a;
					var t = style.b;
					var r = style.c;
					var b = style.d;
					var l = style.e;
					return _Utils_eq(t, b) && (_Utils_eq(t, r) && (_Utils_eq(t, l) && ((t >= 0) && (t <= 24))));
				default:
					return false;
			}
		}
	});
var $mdgriffith$elm_ui$Internal$Flag$width = $mdgriffith$elm_ui$Internal$Flag$flag(6);
var $mdgriffith$elm_ui$Internal$Flag$xAlign = $mdgriffith$elm_ui$Internal$Flag$flag(30);
var $mdgriffith$elm_ui$Internal$Flag$yAlign = $mdgriffith$elm_ui$Internal$Flag$flag(29);
var $mdgriffith$elm_ui$Internal$Model$gatherAttrRecursive = F8(
	function (classes, node, has, transform, styles, attrs, children, elementAttrs) {
		gatherAttrRecursive:
		while (true) {
			if (!elementAttrs.b) {
				var _v1 = $mdgriffith$elm_ui$Internal$Model$transformClass(transform);
				if (_v1.$ === 1) {
					return {
						cb: A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class(classes),
							attrs),
						ld: children,
						cq: has,
						jn: node,
						kh: styles
					};
				} else {
					var _class = _v1.a;
					return {
						cb: A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class(classes + (' ' + _class)),
							attrs),
						ld: children,
						cq: has,
						jn: node,
						kh: A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$Transform(transform),
							styles)
					};
				}
			} else {
				var attribute = elementAttrs.a;
				var remaining = elementAttrs.b;
				switch (attribute.$) {
					case 0:
						var $temp$classes = classes,
							$temp$node = node,
							$temp$has = has,
							$temp$transform = transform,
							$temp$styles = styles,
							$temp$attrs = attrs,
							$temp$children = children,
							$temp$elementAttrs = remaining;
						classes = $temp$classes;
						node = $temp$node;
						has = $temp$has;
						transform = $temp$transform;
						styles = $temp$styles;
						attrs = $temp$attrs;
						children = $temp$children;
						elementAttrs = $temp$elementAttrs;
						continue gatherAttrRecursive;
					case 3:
						var flag = attribute.a;
						var exactClassName = attribute.b;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, flag, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							var $temp$classes = exactClassName + (' ' + classes),
								$temp$node = node,
								$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, flag, has),
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						}
					case 1:
						var actualAttribute = attribute.a;
						var $temp$classes = classes,
							$temp$node = node,
							$temp$has = has,
							$temp$transform = transform,
							$temp$styles = styles,
							$temp$attrs = A2($elm$core$List$cons, actualAttribute, attrs),
							$temp$children = children,
							$temp$elementAttrs = remaining;
						classes = $temp$classes;
						node = $temp$node;
						has = $temp$has;
						transform = $temp$transform;
						styles = $temp$styles;
						attrs = $temp$attrs;
						children = $temp$children;
						elementAttrs = $temp$elementAttrs;
						continue gatherAttrRecursive;
					case 4:
						var flag = attribute.a;
						var style = attribute.b;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, flag, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							if (A2($mdgriffith$elm_ui$Internal$Model$skippable, flag, style)) {
								var $temp$classes = $mdgriffith$elm_ui$Internal$Model$getStyleName(style) + (' ' + classes),
									$temp$node = node,
									$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, flag, has),
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							} else {
								var $temp$classes = $mdgriffith$elm_ui$Internal$Model$getStyleName(style) + (' ' + classes),
									$temp$node = node,
									$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, flag, has),
									$temp$transform = transform,
									$temp$styles = A2($elm$core$List$cons, style, styles),
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							}
						}
					case 10:
						var flag = attribute.a;
						var component = attribute.b;
						var $temp$classes = classes,
							$temp$node = node,
							$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, flag, has),
							$temp$transform = A2($mdgriffith$elm_ui$Internal$Model$composeTransformation, transform, component),
							$temp$styles = styles,
							$temp$attrs = attrs,
							$temp$children = children,
							$temp$elementAttrs = remaining;
						classes = $temp$classes;
						node = $temp$node;
						has = $temp$has;
						transform = $temp$transform;
						styles = $temp$styles;
						attrs = $temp$attrs;
						children = $temp$children;
						elementAttrs = $temp$elementAttrs;
						continue gatherAttrRecursive;
					case 7:
						var width = attribute.a;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$width, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							switch (width.$) {
								case 0:
									var px = width.a;
									var $temp$classes = ($mdgriffith$elm_ui$Internal$Style$classes.kA + (' width-px-' + $elm$core$String$fromInt(px))) + (' ' + classes),
										$temp$node = node,
										$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has),
										$temp$transform = transform,
										$temp$styles = A2(
										$elm$core$List$cons,
										A3(
											$mdgriffith$elm_ui$Internal$Model$Single,
											'width-px-' + $elm$core$String$fromInt(px),
											'width',
											$elm$core$String$fromInt(px) + 'px'),
										styles),
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								case 1:
									var $temp$classes = classes + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.hI),
										$temp$node = node,
										$temp$has = A2(
										$mdgriffith$elm_ui$Internal$Flag$add,
										$mdgriffith$elm_ui$Internal$Flag$widthContent,
										A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has)),
										$temp$transform = transform,
										$temp$styles = styles,
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								case 2:
									var portion = width.a;
									if (portion === 1) {
										var $temp$classes = classes + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.hJ),
											$temp$node = node,
											$temp$has = A2(
											$mdgriffith$elm_ui$Internal$Flag$add,
											$mdgriffith$elm_ui$Internal$Flag$widthFill,
											A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has)),
											$temp$transform = transform,
											$temp$styles = styles,
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									} else {
										var $temp$classes = classes + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.kB + (' width-fill-' + $elm$core$String$fromInt(portion)))),
											$temp$node = node,
											$temp$has = A2(
											$mdgriffith$elm_ui$Internal$Flag$add,
											$mdgriffith$elm_ui$Internal$Flag$widthFill,
											A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has)),
											$temp$transform = transform,
											$temp$styles = A2(
											$elm$core$List$cons,
											A3(
												$mdgriffith$elm_ui$Internal$Model$Single,
												$mdgriffith$elm_ui$Internal$Style$classes.kQ + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.dv + (' > ' + $mdgriffith$elm_ui$Internal$Style$dot(
													'width-fill-' + $elm$core$String$fromInt(portion))))),
												'flex-grow',
												$elm$core$String$fromInt(portion * 100000)),
											styles),
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									}
								default:
									var _v4 = $mdgriffith$elm_ui$Internal$Model$renderWidth(width);
									var addToFlags = _v4.a;
									var newClass = _v4.b;
									var newStyles = _v4.c;
									var $temp$classes = classes + (' ' + newClass),
										$temp$node = node,
										$temp$has = A2(
										$mdgriffith$elm_ui$Internal$Flag$merge,
										addToFlags,
										A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has)),
										$temp$transform = transform,
										$temp$styles = _Utils_ap(newStyles, styles),
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
							}
						}
					case 8:
						var height = attribute.a;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$height, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							switch (height.$) {
								case 0:
									var px = height.a;
									var val = $elm$core$String$fromInt(px) + 'px';
									var name = 'height-px-' + val;
									var $temp$classes = $mdgriffith$elm_ui$Internal$Style$classes.iL + (' ' + (name + (' ' + classes))),
										$temp$node = node,
										$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has),
										$temp$transform = transform,
										$temp$styles = A2(
										$elm$core$List$cons,
										A3($mdgriffith$elm_ui$Internal$Model$Single, name, 'height ', val),
										styles),
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								case 1:
									var $temp$classes = $mdgriffith$elm_ui$Internal$Style$classes.gC + (' ' + classes),
										$temp$node = node,
										$temp$has = A2(
										$mdgriffith$elm_ui$Internal$Flag$add,
										$mdgriffith$elm_ui$Internal$Flag$heightContent,
										A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has)),
										$temp$transform = transform,
										$temp$styles = styles,
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								case 2:
									var portion = height.a;
									if (portion === 1) {
										var $temp$classes = $mdgriffith$elm_ui$Internal$Style$classes.gD + (' ' + classes),
											$temp$node = node,
											$temp$has = A2(
											$mdgriffith$elm_ui$Internal$Flag$add,
											$mdgriffith$elm_ui$Internal$Flag$heightFill,
											A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has)),
											$temp$transform = transform,
											$temp$styles = styles,
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									} else {
										var $temp$classes = classes + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.iM + (' height-fill-' + $elm$core$String$fromInt(portion)))),
											$temp$node = node,
											$temp$has = A2(
											$mdgriffith$elm_ui$Internal$Flag$add,
											$mdgriffith$elm_ui$Internal$Flag$heightFill,
											A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has)),
											$temp$transform = transform,
											$temp$styles = A2(
											$elm$core$List$cons,
											A3(
												$mdgriffith$elm_ui$Internal$Model$Single,
												$mdgriffith$elm_ui$Internal$Style$classes.kQ + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.dV + (' > ' + $mdgriffith$elm_ui$Internal$Style$dot(
													'height-fill-' + $elm$core$String$fromInt(portion))))),
												'flex-grow',
												$elm$core$String$fromInt(portion * 100000)),
											styles),
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									}
								default:
									var _v6 = $mdgriffith$elm_ui$Internal$Model$renderHeight(height);
									var addToFlags = _v6.a;
									var newClass = _v6.b;
									var newStyles = _v6.c;
									var $temp$classes = classes + (' ' + newClass),
										$temp$node = node,
										$temp$has = A2(
										$mdgriffith$elm_ui$Internal$Flag$merge,
										addToFlags,
										A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has)),
										$temp$transform = transform,
										$temp$styles = _Utils_ap(newStyles, styles),
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
							}
						}
					case 2:
						var description = attribute.a;
						switch (description.$) {
							case 0:
								var $temp$classes = classes,
									$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'main', node),
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 1:
								var $temp$classes = classes,
									$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'nav', node),
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 2:
								var $temp$classes = classes,
									$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'footer', node),
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 3:
								var $temp$classes = classes,
									$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'aside', node),
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 4:
								var i = description.a;
								if (i <= 1) {
									var $temp$classes = classes,
										$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'h1', node),
										$temp$has = has,
										$temp$transform = transform,
										$temp$styles = styles,
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								} else {
									if (i < 7) {
										var $temp$classes = classes,
											$temp$node = A2(
											$mdgriffith$elm_ui$Internal$Model$addNodeName,
											'h' + $elm$core$String$fromInt(i),
											node),
											$temp$has = has,
											$temp$transform = transform,
											$temp$styles = styles,
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									} else {
										var $temp$classes = classes,
											$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'h6', node),
											$temp$has = has,
											$temp$transform = transform,
											$temp$styles = styles,
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									}
								}
							case 9:
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 8:
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = A2(
									$elm$core$List$cons,
									A2($elm$virtual_dom$VirtualDom$attribute, 'role', 'button'),
									attrs),
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 5:
								var label = description.a;
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = A2(
									$elm$core$List$cons,
									A2($elm$virtual_dom$VirtualDom$attribute, 'aria-label', label),
									attrs),
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 6:
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = A2(
									$elm$core$List$cons,
									A2($elm$virtual_dom$VirtualDom$attribute, 'aria-live', 'polite'),
									attrs),
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							default:
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = A2(
									$elm$core$List$cons,
									A2($elm$virtual_dom$VirtualDom$attribute, 'aria-live', 'assertive'),
									attrs),
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
						}
					case 9:
						var location = attribute.a;
						var elem = attribute.b;
						var newStyles = function () {
							switch (elem.$) {
								case 3:
									return styles;
								case 2:
									var str = elem.a;
									return styles;
								case 0:
									var html = elem.a;
									return styles;
								default:
									var styled = elem.a;
									return _Utils_ap(styles, styled.kh);
							}
						}();
						var $temp$classes = classes,
							$temp$node = node,
							$temp$has = has,
							$temp$transform = transform,
							$temp$styles = newStyles,
							$temp$attrs = attrs,
							$temp$children = A3($mdgriffith$elm_ui$Internal$Model$addNearbyElement, location, elem, children),
							$temp$elementAttrs = remaining;
						classes = $temp$classes;
						node = $temp$node;
						has = $temp$has;
						transform = $temp$transform;
						styles = $temp$styles;
						attrs = $temp$attrs;
						children = $temp$children;
						elementAttrs = $temp$elementAttrs;
						continue gatherAttrRecursive;
					case 6:
						var x = attribute.a;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$xAlign, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							var $temp$classes = $mdgriffith$elm_ui$Internal$Model$alignXName(x) + (' ' + classes),
								$temp$node = node,
								$temp$has = function (flags) {
								switch (x) {
									case 1:
										return A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$centerX, flags);
									case 2:
										return A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$alignRight, flags);
									default:
										return flags;
								}
							}(
								A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$xAlign, has)),
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						}
					default:
						var y = attribute.a;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$yAlign, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							var $temp$classes = $mdgriffith$elm_ui$Internal$Model$alignYName(y) + (' ' + classes),
								$temp$node = node,
								$temp$has = function (flags) {
								switch (y) {
									case 1:
										return A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$centerY, flags);
									case 2:
										return A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$alignBottom, flags);
									default:
										return flags;
								}
							}(
								A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$yAlign, has)),
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						}
				}
			}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$Untransformed = {$: 0};
var $mdgriffith$elm_ui$Internal$Model$untransformed = $mdgriffith$elm_ui$Internal$Model$Untransformed;
var $mdgriffith$elm_ui$Internal$Model$element = F4(
	function (context, node, attributes, children) {
		return A3(
			$mdgriffith$elm_ui$Internal$Model$createElement,
			context,
			children,
			A8(
				$mdgriffith$elm_ui$Internal$Model$gatherAttrRecursive,
				$mdgriffith$elm_ui$Internal$Model$contextClasses(context),
				node,
				$mdgriffith$elm_ui$Internal$Flag$none,
				$mdgriffith$elm_ui$Internal$Model$untransformed,
				_List_Nil,
				_List_Nil,
				$mdgriffith$elm_ui$Internal$Model$NoNearbyChildren,
				$elm$core$List$reverse(attributes)));
	});
var $mdgriffith$elm_ui$Internal$Model$Height = function (a) {
	return {$: 8, a: a};
};
var $mdgriffith$elm_ui$Element$height = $mdgriffith$elm_ui$Internal$Model$Height;
var $mdgriffith$elm_ui$Internal$Model$Content = {$: 1};
var $mdgriffith$elm_ui$Element$shrink = $mdgriffith$elm_ui$Internal$Model$Content;
var $mdgriffith$elm_ui$Internal$Model$Width = function (a) {
	return {$: 7, a: a};
};
var $mdgriffith$elm_ui$Element$width = $mdgriffith$elm_ui$Internal$Model$Width;
var $mdgriffith$elm_ui$Element$el = F2(
	function (attrs, child) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
					attrs)),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(
				_List_fromArray(
					[child])));
	});
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $icidasset$elm_material_icons$Material$Icons$Internal$f = $elm$svg$Svg$Attributes$fill;
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $avh4$elm_color$Color$toCssString = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	var roundTo = function (x) {
		return $elm$core$Basics$round(x * 1000) / 1000;
	};
	var pct = function (x) {
		return $elm$core$Basics$round(x * 10000) / 100;
	};
	return $elm$core$String$concat(
		_List_fromArray(
			[
				'rgba(',
				$elm$core$String$fromFloat(
				pct(r)),
				'%,',
				$elm$core$String$fromFloat(
				pct(g)),
				'%,',
				$elm$core$String$fromFloat(
				pct(b)),
				'%,',
				$elm$core$String$fromFloat(
				roundTo(a)),
				')'
			]));
};
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $icidasset$elm_material_icons$Material$Icons$Internal$icon = F4(
	function (attributes, nodes, size, coloring) {
		var sizeAsString = $elm$core$String$fromInt(size);
		return A2(
			$elm$svg$Svg$svg,
			_Utils_ap(
				attributes,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$height(sizeAsString),
						$elm$svg$Svg$Attributes$width(sizeAsString)
					])),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							function () {
							if (!coloring.$) {
								var color = coloring.a;
								return $elm$svg$Svg$Attributes$fill(
									$avh4$elm_color$Color$toCssString(color));
							} else {
								return $elm$svg$Svg$Attributes$fill('currentColor');
							}
						}()
						]),
					nodes)
				]));
	});
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $icidasset$elm_material_icons$Material$Icons$Internal$p = $elm$svg$Svg$path;
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $icidasset$elm_material_icons$Material$Icons$Internal$v = $elm$svg$Svg$Attributes$viewBox;
var $icidasset$elm_material_icons$Material$Icons$expand_less = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z')
				]),
			_List_Nil)
		]));
var $icidasset$elm_material_icons$Material$Icons$expand_more = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z')
				]),
			_List_Nil)
		]));
var $mdgriffith$elm_ui$Internal$Model$Fill = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Element$fill = $mdgriffith$elm_ui$Internal$Model$Fill(1);
var $PaackEng$elm_ui_dropdown$Dropdown$Config = $elm$core$Basics$identity;
var $PaackEng$elm_ui_dropdown$Dropdown$Filterable = 1;
var $PaackEng$elm_ui_dropdown$Dropdown$OnSelectSingleItem = function (a) {
	return {$: 0, a: a};
};
var $PaackEng$elm_ui_dropdown$Dropdown$SingleItem = function (a) {
	return {$: 0, a: a};
};
var $PaackEng$elm_ui_dropdown$Dropdown$SingleItemToPrompt = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$Empty = {$: 3};
var $mdgriffith$elm_ui$Element$none = $mdgriffith$elm_ui$Internal$Model$Empty;
var $mdgriffith$elm_ui$Internal$Model$Text = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Element$text = function (content) {
	return $mdgriffith$elm_ui$Internal$Model$Text(content);
};
var $PaackEng$elm_ui_dropdown$Dropdown$filterable = function (_v0) {
	var itemsFromModel = _v0.mA;
	var selectionFromModel = _v0.nJ;
	var dropdownMsg = _v0.lM;
	var onSelectMsg = _v0.m2;
	var itemToPrompt = _v0.mx;
	var itemToElement = _v0.mw;
	var itemToText = _v0.my;
	return {
		lj: $mdgriffith$elm_ui$Element$text('▲'),
		ce: _List_Nil,
		lM: dropdownMsg,
		aI: 1,
		cj: $mdgriffith$elm_ui$Element$none,
		cm: $elm$core$Maybe$Just('Filter values'),
		mw: itemToElement,
		my: itemToText,
		mA: itemsFromModel,
		bQ: _List_Nil,
		ct: $elm$core$Maybe$Nothing,
		m2: $PaackEng$elm_ui_dropdown$Dropdown$OnSelectSingleItem(onSelectMsg),
		m6: $mdgriffith$elm_ui$Element$text('▼'),
		b$: A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			$mdgriffith$elm_ui$Element$text('-- Select --')),
		cB: _List_Nil,
		cD: _List_Nil,
		nJ: A2($elm$core$Basics$composeR, selectionFromModel, $PaackEng$elm_ui_dropdown$Dropdown$SingleItem),
		dA: $PaackEng$elm_ui_dropdown$Dropdown$SingleItemToPrompt(itemToPrompt)
	};
};
var $tesk9$palette$SolidColor$Color = $elm$core$Basics$identity;
var $tesk9$palette$Internal$Color$fromRGBA = function (values) {
	return $tesk9$palette$Internal$Color$RGBA(
		$tesk9$palette$Internal$RGBA$fromChannels(values));
};
var $tesk9$palette$Internal$Opacity$Opacity = $elm$core$Basics$identity;
var $tesk9$palette$Internal$Opacity$custom = A2(
	$elm$core$Basics$composeL,
	$elm$core$Basics$identity,
	A2($elm$core$Basics$clamp, 0, 1.0));
var $tesk9$palette$Internal$Opacity$opaque = $tesk9$palette$Internal$Opacity$custom(1.0);
var $tesk9$palette$SolidColor$fromRGB = function (_v0) {
	var red = _v0.a;
	var green = _v0.b;
	var blue = _v0.c;
	return $tesk9$palette$Internal$Color$fromRGBA(
		{kN: $tesk9$palette$Internal$Opacity$opaque, k_: blue, l6: green, no: red});
};
var $author$project$UI$Palette$base1 = $tesk9$palette$SolidColor$fromRGB(
	_Utils_Tuple3(224, 230, 238));
var $author$project$UI$Dropdown$highlightedItemAttrs = function (highlighted) {
	return highlighted ? _List_fromArray(
		[
			$mdgriffith$elm_ui$Element$Background$color(
			$author$project$UI$Element$colorFor($author$project$UI$Palette$base1))
		]) : _List_Nil;
};
var $icidasset$elm_material_icons$Material$Icons$Types$Inherit = {$: 1};
var $mdgriffith$elm_ui$Internal$Model$unstyled = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Unstyled, $elm$core$Basics$always);
var $mdgriffith$elm_ui$Element$html = $mdgriffith$elm_ui$Internal$Model$unstyled;
var $mdgriffith$elm_ui$Internal$Model$PaddingStyle = F5(
	function (a, b, c, d, e) {
		return {$: 7, a: a, b: b, c: c, d: d, e: e};
	});
var $mdgriffith$elm_ui$Internal$Flag$padding = $mdgriffith$elm_ui$Internal$Flag$flag(2);
var $mdgriffith$elm_ui$Internal$Model$paddingName = F4(
	function (top, right, bottom, left) {
		return 'pad-' + ($elm$core$String$fromInt(top) + ('-' + ($elm$core$String$fromInt(right) + ('-' + ($elm$core$String$fromInt(bottom) + ('-' + $elm$core$String$fromInt(left)))))));
	});
var $mdgriffith$elm_ui$Element$paddingEach = function (_v0) {
	var top = _v0.ol;
	var right = _v0.nx;
	var bottom = _v0.k5;
	var left = _v0.mE;
	if (_Utils_eq(top, right) && (_Utils_eq(top, bottom) && _Utils_eq(top, left))) {
		var topFloat = top;
		return A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$padding,
			A5(
				$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
				'p-' + $elm$core$String$fromInt(top),
				topFloat,
				topFloat,
				topFloat,
				topFloat));
	} else {
		return A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$padding,
			A5(
				$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
				A4($mdgriffith$elm_ui$Internal$Model$paddingName, top, right, bottom, left),
				top,
				right,
				bottom,
				left));
	}
};
var $author$project$UI$Element$iconFor = function (icon) {
	return A2(
		$mdgriffith$elm_ui$Element$el,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$paddingEach(
				{k5: 2, mE: 0, nx: 0, ol: 0})
			]),
		$mdgriffith$elm_ui$Element$html(
			icon($icidasset$elm_material_icons$Material$Icons$Types$Inherit)));
};
var $author$project$UI$Palette$base02 = $tesk9$palette$SolidColor$fromRGB(
	_Utils_Tuple3(7, 61, 103));
var $author$project$UI$Palette$base03 = $tesk9$palette$SolidColor$fromRGB(
	_Utils_Tuple3(31, 39, 52));
var $author$project$UI$Palette$base2 = $tesk9$palette$SolidColor$fromRGB(
	_Utils_Tuple3(255, 255, 255));
var $author$project$UI$Dropdown$itemColors = {kV: $author$project$UI$Palette$base2, k0: $author$project$UI$Palette$base02, lZ: $author$project$UI$Palette$base03};
var $author$project$UI$Dropdown$itemMouseOverColors = {kV: $author$project$UI$Palette$base02, k0: $author$project$UI$Palette$base02, lZ: $author$project$UI$Palette$base2};
var $mdgriffith$elm_ui$Internal$Model$Max = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $mdgriffith$elm_ui$Element$maximum = F2(
	function (i, l) {
		return A2($mdgriffith$elm_ui$Internal$Model$Max, i, l);
	});
var $mdgriffith$elm_ui$Internal$Model$Hover = 1;
var $mdgriffith$elm_ui$Internal$Model$PseudoSelector = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$hover = $mdgriffith$elm_ui$Internal$Flag$flag(33);
var $mdgriffith$elm_ui$Internal$Model$AlignY = function (a) {
	return {$: 5, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$Attr = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$Describe = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$Nearby = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$NoAttribute = {$: 0};
var $mdgriffith$elm_ui$Internal$Model$TransformComponent = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $mdgriffith$elm_ui$Internal$Model$map = F2(
	function (fn, el) {
		switch (el.$) {
			case 1:
				var styled = el.a;
				return $mdgriffith$elm_ui$Internal$Model$Styled(
					{
						ef: F2(
							function (add, context) {
								return A2(
									$elm$virtual_dom$VirtualDom$map,
									fn,
									A2(styled.ef, add, context));
							}),
						kh: styled.kh
					});
			case 0:
				var html = el.a;
				return $mdgriffith$elm_ui$Internal$Model$Unstyled(
					A2(
						$elm$core$Basics$composeL,
						$elm$virtual_dom$VirtualDom$map(fn),
						html));
			case 2:
				var str = el.a;
				return $mdgriffith$elm_ui$Internal$Model$Text(str);
			default:
				return $mdgriffith$elm_ui$Internal$Model$Empty;
		}
	});
var $elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
var $mdgriffith$elm_ui$Internal$Model$mapAttrFromStyle = F2(
	function (fn, attr) {
		switch (attr.$) {
			case 0:
				return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
			case 2:
				var description = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$Describe(description);
			case 6:
				var x = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$AlignX(x);
			case 5:
				var y = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$AlignY(y);
			case 7:
				var x = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$Width(x);
			case 8:
				var x = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$Height(x);
			case 3:
				var x = attr.a;
				var y = attr.b;
				return A2($mdgriffith$elm_ui$Internal$Model$Class, x, y);
			case 4:
				var flag = attr.a;
				var style = attr.b;
				return A2($mdgriffith$elm_ui$Internal$Model$StyleClass, flag, style);
			case 9:
				var location = attr.a;
				var elem = attr.b;
				return A2(
					$mdgriffith$elm_ui$Internal$Model$Nearby,
					location,
					A2($mdgriffith$elm_ui$Internal$Model$map, fn, elem));
			case 1:
				var htmlAttr = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$Attr(
					A2($elm$virtual_dom$VirtualDom$mapAttribute, fn, htmlAttr));
			default:
				var fl = attr.a;
				var trans = attr.b;
				return A2($mdgriffith$elm_ui$Internal$Model$TransformComponent, fl, trans);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$removeNever = function (style) {
	return A2($mdgriffith$elm_ui$Internal$Model$mapAttrFromStyle, $elm$core$Basics$never, style);
};
var $mdgriffith$elm_ui$Internal$Model$unwrapDecsHelper = F2(
	function (attr, _v0) {
		var styles = _v0.a;
		var trans = _v0.b;
		var _v1 = $mdgriffith$elm_ui$Internal$Model$removeNever(attr);
		switch (_v1.$) {
			case 4:
				var style = _v1.b;
				return _Utils_Tuple2(
					A2($elm$core$List$cons, style, styles),
					trans);
			case 10:
				var flag = _v1.a;
				var component = _v1.b;
				return _Utils_Tuple2(
					styles,
					A2($mdgriffith$elm_ui$Internal$Model$composeTransformation, trans, component));
			default:
				return _Utils_Tuple2(styles, trans);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$unwrapDecorations = function (attrs) {
	var _v0 = A3(
		$elm$core$List$foldl,
		$mdgriffith$elm_ui$Internal$Model$unwrapDecsHelper,
		_Utils_Tuple2(_List_Nil, $mdgriffith$elm_ui$Internal$Model$Untransformed),
		attrs);
	var styles = _v0.a;
	var transform = _v0.b;
	return A2(
		$elm$core$List$cons,
		$mdgriffith$elm_ui$Internal$Model$Transform(transform),
		styles);
};
var $mdgriffith$elm_ui$Element$mouseOver = function (decs) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$hover,
		A2(
			$mdgriffith$elm_ui$Internal$Model$PseudoSelector,
			1,
			$mdgriffith$elm_ui$Internal$Model$unwrapDecorations(decs)));
};
var $mdgriffith$elm_ui$Element$padding = function (x) {
	var f = x;
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$padding,
		A5(
			$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
			'p-' + $elm$core$String$fromInt(x),
			f,
			f,
			f,
			f));
};
var $mdgriffith$elm_ui$Internal$Model$Paragraph = {$: 9};
var $mdgriffith$elm_ui$Internal$Model$SpacingStyle = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $mdgriffith$elm_ui$Internal$Flag$spacing = $mdgriffith$elm_ui$Internal$Flag$flag(3);
var $mdgriffith$elm_ui$Internal$Model$spacingName = F2(
	function (x, y) {
		return 'spacing-' + ($elm$core$String$fromInt(x) + ('-' + $elm$core$String$fromInt(y)));
	});
var $mdgriffith$elm_ui$Element$spacing = function (x) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$spacing,
		A3(
			$mdgriffith$elm_ui$Internal$Model$SpacingStyle,
			A2($mdgriffith$elm_ui$Internal$Model$spacingName, x, x),
			x,
			x));
};
var $mdgriffith$elm_ui$Element$paragraph = F2(
	function (attrs, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asParagraph,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$Describe($mdgriffith$elm_ui$Internal$Model$Paragraph),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$spacing(5),
						attrs))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
	});
var $mdgriffith$elm_ui$Internal$Flag$borderRound = $mdgriffith$elm_ui$Internal$Flag$flag(17);
var $mdgriffith$elm_ui$Element$Border$rounded = function (radius) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$borderRound,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Single,
			'br-' + $elm$core$String$fromInt(radius),
			'border-radius',
			$elm$core$String$fromInt(radius) + 'px'));
};
var $mdgriffith$elm_ui$Element$scrollbarY = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$overflow, $mdgriffith$elm_ui$Internal$Style$classes.nD);
var $author$project$UI$Dropdown$selectedItemAttrs = function (selected) {
	return selected ? $author$project$UI$Element$colors($author$project$UI$Dropdown$itemMouseOverColors) : _List_Nil;
};
var $author$project$UI$Palette$base0 = $tesk9$palette$SolidColor$fromRGB(
	_Utils_Tuple3(205, 216, 227));
var $author$project$UI$Dropdown$softColors = {
	cr: {kV: $author$project$UI$Palette$base2, k0: $author$project$UI$Palette$base0, lZ: $author$project$UI$Palette$base03},
	cx: {kV: $author$project$UI$Palette$base0, k0: $author$project$UI$Palette$base02, lZ: $author$project$UI$Palette$base03}
};
var $mdgriffith$elm_ui$Internal$Model$BorderWidth = F5(
	function (a, b, c, d, e) {
		return {$: 6, a: a, b: b, c: c, d: d, e: e};
	});
var $mdgriffith$elm_ui$Element$Border$width = function (v) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$borderWidth,
		A5(
			$mdgriffith$elm_ui$Internal$Model$BorderWidth,
			'b-' + $elm$core$String$fromInt(v),
			v,
			v,
			v,
			v));
};
var $PaackEng$elm_ui_dropdown$Dropdown$withContainerAttributes = F2(
	function (attrs, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{ce: attrs});
	});
var $PaackEng$elm_ui_dropdown$Dropdown$withFilterPlaceholder = F2(
	function (placeholderString, _v0) {
		var config = _v0;
		var placeholder = $elm$core$String$isEmpty(placeholderString) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(placeholderString);
		return _Utils_update(
			config,
			{cm: placeholder});
	});
var $PaackEng$elm_ui_dropdown$Dropdown$withListAttributes = F2(
	function (attrs, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{bQ: attrs});
	});
var $PaackEng$elm_ui_dropdown$Dropdown$withOpenCloseButtons = F2(
	function (_v0, _v1) {
		var openButton = _v0.m6;
		var closeButton = _v0.lj;
		var config = _v1;
		return _Utils_update(
			config,
			{lj: closeButton, m6: openButton});
	});
var $PaackEng$elm_ui_dropdown$Dropdown$withPromptElement = F2(
	function (promptElement, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{b$: promptElement});
	});
var $PaackEng$elm_ui_dropdown$Dropdown$withSearchAttributes = F2(
	function (attrs, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{cB: attrs});
	});
var $PaackEng$elm_ui_dropdown$Dropdown$withSelectAttributes = F2(
	function (attrs, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{cD: attrs});
	});
var $author$project$UI$Dropdown$config = F2(
	function (attrs, _v0) {
		var itemsFromModel = _v0.mA;
		var selectionFromModel = _v0.nJ;
		var toMsg = _v0.hz;
		var itemPickedMsg = _v0.mv;
		var itemView = _v0.mz;
		return A2(
			$PaackEng$elm_ui_dropdown$Dropdown$withListAttributes,
			_Utils_ap(
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$height(
						A2($mdgriffith$elm_ui$Element$maximum, 600, $mdgriffith$elm_ui$Element$fill)),
						$mdgriffith$elm_ui$Element$scrollbarY,
						$mdgriffith$elm_ui$Element$clipX,
						$mdgriffith$elm_ui$Element$Border$rounded(3),
						$mdgriffith$elm_ui$Element$Border$width(1)
					]),
				$author$project$UI$Element$colors($author$project$UI$Dropdown$itemColors)),
			A2(
				$PaackEng$elm_ui_dropdown$Dropdown$withOpenCloseButtons,
				{
					lj: $author$project$UI$Element$iconFor(
						$icidasset$elm_material_icons$Material$Icons$expand_less(24)),
					m6: $author$project$UI$Element$iconFor(
						$icidasset$elm_material_icons$Material$Icons$expand_more(24))
				},
				A2(
					$PaackEng$elm_ui_dropdown$Dropdown$withSearchAttributes,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$padding(2)
						]),
					A2(
						$PaackEng$elm_ui_dropdown$Dropdown$withSelectAttributes,
						attrs,
						A2(
							$PaackEng$elm_ui_dropdown$Dropdown$withFilterPlaceholder,
							'',
							A2(
								$PaackEng$elm_ui_dropdown$Dropdown$withPromptElement,
								A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
										]),
									$mdgriffith$elm_ui$Element$none),
								A2(
									$PaackEng$elm_ui_dropdown$Dropdown$withContainerAttributes,
									_Utils_ap(
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$Border$rounded(3),
												$mdgriffith$elm_ui$Element$Border$width(1),
												$mdgriffith$elm_ui$Element$alignRight
											]),
										$author$project$UI$Element$colors($author$project$UI$Dropdown$softColors.cr)),
									$PaackEng$elm_ui_dropdown$Dropdown$filterable(
										{
											lM: toMsg,
											mw: F3(
												function (selected, highlighted, item) {
													return A2(
														$mdgriffith$elm_ui$Element$el,
														_Utils_ap(
															_List_fromArray(
																[
																	$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
																	$mdgriffith$elm_ui$Element$padding(11),
																	$mdgriffith$elm_ui$Element$mouseOver(
																	$author$project$UI$Element$colors($author$project$UI$Dropdown$itemMouseOverColors))
																]),
															_Utils_ap(
																$author$project$UI$Dropdown$highlightedItemAttrs(highlighted),
																$author$project$UI$Dropdown$selectedItemAttrs(selected))),
														$mdgriffith$elm_ui$Element$text(
															itemView(item)));
												}),
											mx: A2(
												$elm$core$Basics$composeL,
												A2(
													$elm$core$Basics$composeL,
													A2(
														$elm$core$Basics$composeL,
														$mdgriffith$elm_ui$Element$paragraph(
															_List_fromArray(
																[
																	$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
																])),
														$elm$core$List$singleton),
													$mdgriffith$elm_ui$Element$text),
												itemView),
											my: itemView,
											mA: itemsFromModel,
											m2: itemPickedMsg,
											nJ: selectionFromModel
										}))))))));
	});
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $author$project$Applicant$Overview$dpIdNotInClosestDPs = F2(
	function (dpId, closestDPs) {
		return A2(
			$elm$core$List$all,
			function (_v0) {
				var id = _v0.eg;
				return !_Utils_eq(dpId, id);
			},
			closestDPs);
	});
var $author$project$Applicant$Overview$filterClosestDPs = function (closestDPs) {
	return $elm$core$List$filter(
		function (_v0) {
			var dpId = _v0.a;
			return A2($author$project$Applicant$Overview$dpIdNotInClosestDPs, dpId, closestDPs);
		});
};
var $author$project$Applicant$Overview$nameAndDistanceView = function (_v0) {
	var name = _v0.ft;
	var distance = _v0.lG;
	var _v1 = distance > 1000;
	if (_v1) {
		return name + (' (' + ($elm$core$String$fromInt((distance / 1000) | 0) + ' km)'));
	} else {
		return name + (' (' + ($elm$core$String$fromInt(distance) + ' m)'));
	}
};
var $author$project$Applicant$Overview$dpItems = F2(
	function (closestDPs, dps) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (dp) {
					return _Utils_Tuple2(
						dp.eg,
						$author$project$Applicant$Overview$nameAndDistanceView(dp));
				},
				closestDPs),
			A2(
				$elm$core$List$sortBy,
				$elm$core$Tuple$second,
				A2($author$project$Applicant$Overview$filterClosestDPs, closestDPs, dps)));
	});
var $mdgriffith$elm_ui$Element$htmlAttribute = $mdgriffith$elm_ui$Internal$Model$Attr;
var $mdgriffith$elm_ui$Internal$Model$Px = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Element$px = $mdgriffith$elm_ui$Internal$Model$Px;
var $author$project$Applicant$Overview$dpDDConfig = A2(
	$PaackEng$elm_ui_dropdown$Dropdown$withSearchAttributes,
	_List_fromArray(
		[
			$mdgriffith$elm_ui$Element$htmlAttribute(
			$elm$html$Html$Attributes$autocomplete(false))
		]),
	A2(
		$author$project$UI$Dropdown$config,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$padding(8),
				$mdgriffith$elm_ui$Element$width(
				$mdgriffith$elm_ui$Element$px(300))
			]),
		{
			mv: $author$project$Applicant$Overview$UserSelectedDistributionPointInDropdown,
			mz: $elm$core$Tuple$second,
			mA: function (_v0) {
				var closestDPs = _v0.h2;
				var dps = _v0.e6;
				return A2($author$project$Applicant$Overview$dpItems, closestDPs, dps);
			},
			nJ: function ($) {
				return $.cE;
			},
			hz: $author$project$Applicant$Overview$GotDistributionPointDropdownMsg
		}));
var $author$project$Applicant$Overview$encodeRememberedDpFilter = function (dpFilter) {
	return A2(
		$elm$json$Json$Encode$list,
		$author$project$DistributionPoint$DistributionPoint$encodeId,
		$Gizra$elm_all_set$EverySet$toList(dpFilter));
};
var $author$project$Applicant$Overview$LoadingSelected = function (a) {
	return {$: 0, a: a};
};
var $pzp1997$assoc_list$AssocList$isEmpty = function (dict) {
	return _Utils_eq(dict, _List_Nil);
};
var $Gizra$elm_all_set$EverySet$isEmpty = function (_v0) {
	var d = _v0;
	return $pzp1997$assoc_list$AssocList$isEmpty(d);
};
var $Gizra$elm_all_set$EverySet$member = F2(
	function (k, _v0) {
		var d = _v0;
		return A2($pzp1997$assoc_list$AssocList$member, k, d);
	});
var $elm_community$list_extra$List$Extra$unique = function (list) {
	return A4($elm_community$list_extra$List$Extra$uniqueHelp, $elm$core$Basics$identity, _List_Nil, list, _List_Nil);
};
var $author$project$Applicant$Applicant$statusesIn = function (applicants) {
	return $elm_community$list_extra$List$Extra$unique(
		A2(
			$elm$core$List$map,
			function ($) {
				return $.nS;
			},
			applicants));
};
var $author$project$Applicant$Overview$filter = function (loaded) {
	var statuses = $author$project$Applicant$Applicant$statusesIn(loaded.aX);
	var idFromSelection = function () {
		var _v2 = loaded.nI;
		switch (_v2.$) {
			case 0:
				var id = _v2.a;
				return $elm$core$Maybe$Just(id);
			case 1:
				var id = _v2.a.eg;
				return id;
			default:
				return $elm$core$Maybe$Nothing;
		}
	}();
	var filtered = A2(
		$elm$core$List$filter,
		function (a) {
			return A2($Gizra$elm_all_set$EverySet$member, a.nS, loaded.J.nS) && ($Gizra$elm_all_set$EverySet$isEmpty(loaded.J.w) || A2($Gizra$elm_all_set$EverySet$member, a.c2, loaded.J.w));
		},
		loaded.aX);
	var preSelected = function () {
		var _v1 = $elm$core$List$head(filtered);
		if (!_v1.$) {
			var id = _v1.a.eg;
			return $author$project$Applicant$Overview$LoadingSelected(id);
		} else {
			return $author$project$Applicant$Overview$NoneSelected;
		}
	}();
	return _Utils_update(
		loaded,
		{
			eb: filtered,
			nI: A2(
				$elm$core$List$any,
				function (_v0) {
					var id = _v0.eg;
					return _Utils_eq(
						$elm$core$Maybe$Just(id),
						idFromSelection);
				},
				filtered) ? loaded.nI : preSelected,
			fT: statuses
		});
};
var $author$project$Address$Address$HttpError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Address$Address$NotFound = function (a) {
	return {$: 0, a: a};
};
var $author$project$Address$Address$find = F4(
	function (token, toMsg, zipCode, houseNumber) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'addresses',
					'zipcode',
					zipCode,
					$elm$core$String$fromInt(houseNumber.bX)
				]),
			_List_Nil);
		var toError = function (response) {
			switch (response.$) {
				case 0:
					var url = response.a;
					return $elm$core$Result$Err(
						$author$project$Address$Address$HttpError(
							$elm$http$Http$BadUrl(url)));
				case 1:
					return $elm$core$Result$Err(
						$author$project$Address$Address$HttpError($elm$http$Http$Timeout));
				case 2:
					return $elm$core$Result$Err(
						$author$project$Address$Address$HttpError($elm$http$Http$NetworkError));
				case 3:
					var metadata = response.a;
					var b = response.b;
					return $elm$core$Result$Err(
						function () {
							var _v1 = metadata.kf;
							if (_v1 === 404) {
								var _v2 = A2($elm$json$Json$Decode$decodeString, $author$project$Address$Address$decoder, b);
								if (!_v2.$) {
									var address = _v2.a;
									return $author$project$Address$Address$NotFound(address);
								} else {
									var err = _v2.a;
									return $author$project$Address$Address$HttpError(
										$elm$http$Http$BadBody(
											$elm$json$Json$Decode$errorToString(err)));
								}
							} else {
								return $author$project$Address$Address$HttpError(
									$elm$http$Http$BadStatus(metadata.kf));
							}
						}());
				default:
					var b = response.b;
					var _v3 = A2($elm$json$Json$Decode$decodeString, $author$project$Address$Address$decoder, b);
					if (!_v3.$) {
						var p = _v3.a;
						return $elm$core$Result$Ok(p);
					} else {
						var err = _v3.a;
						return $elm$core$Result$Err(
							$author$project$Address$Address$HttpError(
								$elm$http$Http$BadBody(
									$elm$json$Json$Decode$errorToString(err))));
					}
			}
		};
		return A4($author$project$Api$Request$getWithCustomError, token, toMsg, toError, uri);
	});
var $author$project$DistributionPoint$DistributionPoint$toIdAndName = $elm$core$List$map(
	function (_v0) {
		var id = _v0.eg;
		var name = _v0.ft;
		return _Utils_Tuple2(id, name);
	});
var $author$project$Applicant$Overview$initDPModel = F3(
	function (selectedDPId, closestDPs, dps) {
		return {
			h2: closestDPs,
			w: $PaackEng$elm_ui_dropdown$Dropdown$init('dpId-update-element'),
			e6: $author$project$DistributionPoint$DistributionPoint$toIdAndName(dps),
			cE: $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						$elm$core$Basics$eq(selectedDPId)),
					A2(
						$author$project$Applicant$Overview$dpItems,
						closestDPs,
						$author$project$DistributionPoint$DistributionPoint$toIdAndName(dps))))
		};
	});
var $author$project$Security$Security$ManageContracts = {$: 29};
var $author$project$Applicant$Applicant$New = 0;
var $author$project$Applicant$Applicant$allStatuses = _List_fromArray(
	[$author$project$Applicant$Applicant$Registered, $author$project$Applicant$Applicant$NotReachedYet, $author$project$Applicant$Applicant$Scheduled, $author$project$Applicant$Applicant$TwvRequested, $author$project$Applicant$Applicant$OnWaitingList, $author$project$Applicant$Applicant$ContractAtDistributor, $author$project$Applicant$Applicant$ContractAtApplicant, $author$project$Applicant$Applicant$ContractAtParent, $author$project$Applicant$Applicant$ContractAtDPG, $author$project$Applicant$Applicant$ContractFullySigned, $author$project$Applicant$Applicant$Starting, $author$project$Applicant$Applicant$Unreachable, $author$project$Applicant$Applicant$Duplicate, $author$project$Applicant$Applicant$DeniedDueToAge, $author$project$Applicant$Applicant$DeniedNotLegitimate, $author$project$Applicant$Applicant$DeniedNoLotAvailable, $author$project$Applicant$Applicant$DeniedOutsideOfDistributionArea, $author$project$Applicant$Applicant$DeniedNotSuitable, $author$project$Applicant$Applicant$CanceledDueToPay, $author$project$Applicant$Applicant$CanceledOtherJob, $author$project$Applicant$Applicant$Canceled]);
var $author$project$Applicant$Applicant$Handled = 3;
var $author$project$Applicant$Applicant$Pending = 1;
var $author$project$Applicant$Applicant$Signing = 2;
var $author$project$Applicant$Applicant$phaseOf = function (status) {
	switch (status.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 1;
		case 3:
			return 1;
		case 4:
			return 1;
		case 5:
			return 2;
		case 6:
			return 2;
		case 7:
			return 2;
		case 8:
			return 2;
		case 9:
			return 3;
		case 10:
			return 3;
		case 11:
			return 3;
		case 12:
			return 3;
		case 13:
			return 3;
		case 14:
			return 3;
		case 15:
			return 3;
		case 16:
			return 3;
		case 17:
			return 3;
		case 18:
			return 3;
		case 19:
			return 3;
		case 20:
			return 3;
		default:
			return 3;
	}
};
var $author$project$Applicant$Applicant$allNewStatuses = A2(
	$elm$core$List$filter,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Applicant$Applicant$phaseOf,
		$elm$core$Basics$eq(0)),
	$author$project$Applicant$Applicant$allStatuses);
var $author$project$Applicant$Overview$initLoaded = F3(
	function (share, all, dpFilter) {
		return $author$project$Applicant$Overview$filter(
			{
				aX: all,
				dS: A2(
					$author$project$Security$Security$can,
					$author$project$Security$Security$ManageContracts,
					$author$project$Portal$Share$security(share)),
				A: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$elm$core$List$sortBy(
							function ($) {
								return $.ft;
							}),
						$author$project$Portal$Share$data(share).A)),
				J: {
					w: dpFilter,
					aj: '',
					nS: $Gizra$elm_all_set$EverySet$fromList($author$project$Applicant$Applicant$allNewStatuses)
				},
				eb: _List_Nil,
				fr: $author$project$Portal$Share$today(share),
				nI: $author$project$Applicant$Overview$NoneSelected,
				fT: _List_Nil,
				fX: $author$project$Portal$Share$today(share)
			});
	});
var $author$project$Applicant$Applicant$loadCmd = F5(
	function (token, toMsg, id, timezone, today) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'applicants',
					$author$project$Applicant$Applicant$idForUrl(id)
				]),
			_List_Nil);
		return A4(
			$author$project$Api$Request$get,
			token,
			toMsg,
			uri,
			A2($author$project$Applicant$Applicant$decoder, today, timezone));
	});
var $justinmimbs$time_extra$Time$Extra$dateToMillis = function (date) {
	var daysSinceEpoch = $justinmimbs$date$Date$toRataDie(date) - 719163;
	return daysSinceEpoch * 86400000;
};
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $justinmimbs$time_extra$Time$Extra$timeFromClock = F4(
	function (hour, minute, second, millisecond) {
		return (((hour * 3600000) + (minute * 60000)) + (second * 1000)) + millisecond;
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $justinmimbs$time_extra$Time$Extra$timeFromPosix = F2(
	function (zone, posix) {
		return A4(
			$justinmimbs$time_extra$Time$Extra$timeFromClock,
			A2($elm$time$Time$toHour, zone, posix),
			A2($elm$time$Time$toMinute, zone, posix),
			A2($elm$time$Time$toSecond, zone, posix),
			A2($elm$time$Time$toMillis, zone, posix));
	});
var $justinmimbs$time_extra$Time$Extra$toOffset = F2(
	function (zone, posix) {
		var millis = $elm$time$Time$posixToMillis(posix);
		var localMillis = $justinmimbs$time_extra$Time$Extra$dateToMillis(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix);
		return ((localMillis - millis) / 60000) | 0;
	});
var $justinmimbs$time_extra$Time$Extra$posixFromDateTime = F3(
	function (zone, date, time) {
		var millis = $justinmimbs$time_extra$Time$Extra$dateToMillis(date) + time;
		var offset0 = A2(
			$justinmimbs$time_extra$Time$Extra$toOffset,
			zone,
			$elm$time$Time$millisToPosix(millis));
		var posix1 = $elm$time$Time$millisToPosix(millis - (offset0 * 60000));
		var offset1 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix1);
		if (_Utils_eq(offset0, offset1)) {
			return posix1;
		} else {
			var posix2 = $elm$time$Time$millisToPosix(millis - (offset1 * 60000));
			var offset2 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix2);
			return _Utils_eq(offset1, offset2) ? posix2 : posix1;
		}
	});
var $justinmimbs$time_extra$Time$Extra$partsToPosix = F2(
	function (zone, _v0) {
		var year = _v0.kC;
		var month = _v0.a5;
		var day = _v0.a2;
		var hour = _v0.me;
		var minute = _v0.mH;
		var second = _v0.nF;
		var millisecond = _v0.mG;
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A3($justinmimbs$date$Date$fromCalendarDate, year, month, day),
			A4(
				$justinmimbs$time_extra$Time$Extra$timeFromClock,
				A3($elm$core$Basics$clamp, 0, 23, hour),
				A3($elm$core$Basics$clamp, 0, 59, minute),
				A3($elm$core$Basics$clamp, 0, 59, second),
				A3($elm$core$Basics$clamp, 0, 999, millisecond)));
	});
var $author$project$Date$DeliveryDate$toPosix = F3(
	function (zone, _v0, _v1) {
		var hour = _v0.me;
		var minute = _v0.mH;
		var date = _v1;
		return A2(
			$justinmimbs$time_extra$Time$Extra$partsToPosix,
			zone,
			{a2: date.a2, me: hour, mG: 0, mH: minute, a5: date.a5, nF: 0, kC: date.kC});
	});
var $author$project$Applicant$Applicant$loadMinStartCmd = F4(
	function (token, toMsg, zone, today) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'wageperiods',
					'start',
					$elm$core$String$fromInt(
					$elm$time$Time$posixToMillis(
						A3(
							$author$project$Date$DeliveryDate$toPosix,
							zone,
							{me: 12, mH: 0},
							today)))
				]),
			_List_Nil);
		return A4(
			$author$project$Api$Request$get,
			token,
			toMsg,
			uri,
			A2($elm$json$Json$Decode$field, 'validOn', $author$project$Date$DeliveryDate$decoder));
	});
var $author$project$Applicant$Overview$loadingApplicant = function (id) {
	return A2(
		$author$project$Applicant$Overview$singleAction,
		'loadingApplicant',
		$elm$core$Maybe$Just(id));
};
var $author$project$Applicant$Overview$loadingMinStart = function (_v0) {
	return A2($author$project$Applicant$Overview$singleAction, 'loadingMinStart', $elm$core$Maybe$Nothing);
};
var $author$project$Applicant$Applicant$newApplicant = F3(
	function (contractType, today, dpId) {
		return {
			hP: today,
			f1: {
				h8: 0,
				bs: {bX: 0, dE: $elm$core$Maybe$Nothing},
				i3: $elm$core$Maybe$Nothing,
				bU: '',
				b5: '',
				cT: ''
			},
			dQ: 1,
			cY: {e1: $author$project$Date$DaysInTheWeek$everyDeliveryDay, hq: today},
			ga: 1,
			c$: $elm$core$Maybe$Nothing,
			gd: '',
			h2: _List_Nil,
			gg: '',
			eU: $elm$core$Maybe$Nothing,
			gh: contractType,
			c2: dpId,
			d5: '',
			fc: '',
			gE: '',
			eg: $elm$core$Maybe$Nothing,
			gF: $elm$core$Maybe$Nothing,
			gG: '',
			gH: $elm$core$Maybe$Nothing,
			gI: '',
			gM: $elm$core$Maybe$Nothing,
			fo: '',
			gZ: $author$project$Applicant$Applicant$defaultNationality,
			g7: $elm$core$Maybe$Nothing,
			g8: $elm$core$Maybe$Nothing,
			eq: '',
			fF: '',
			hi: $elm$core$Maybe$Nothing,
			nS: $author$project$Applicant$Applicant$Registered,
			hF: $elm$core$Maybe$Nothing
		};
	});
var $author$project$Ports$rememberValue = _Platform_outgoingPort(
	'rememberValue',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'key',
					$elm$json$Json$Encode$string($.iY)),
					_Utils_Tuple2(
					'value',
					$elm$json$Json$Encode$string($.kt))
				]));
	});
var $Gizra$elm_all_set$EverySet$remove = F2(
	function (k, _v0) {
		var d = _v0;
		return A2($pzp1997$assoc_list$AssocList$remove, k, d);
	});
var $author$project$Date$DaysInTheWeek$remove = F2(
	function (day, _v0) {
		var d = _v0;
		return _Utils_update(
			d,
			{
				e1: A2($Gizra$elm_all_set$EverySet$remove, day, d.e1)
			});
	});
var $author$project$Applicant$Applicant$sendContractCmd = F4(
	function (token, toMsg, id, _v0) {
		var distributorName = _v0.lI;
		var distributorEmail = _v0.lH;
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'applicants',
					$author$project$Applicant$Applicant$idForUrl(id),
					'contract'
				]),
			_List_Nil);
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'distributorName',
						$elm$json$Json$Encode$string(distributorName)),
						_Utils_Tuple2(
						'distributorEmail',
						$elm$json$Json$Encode$string(distributorEmail))
					])));
		return A4($author$project$Api$Request$postWithoutResponse, token, toMsg, uri, body);
	});
var $author$project$Applicant$Overview$sendingContract = function (id) {
	return A2(
		$author$project$Applicant$Overview$singleAction,
		'sendingContract',
		$elm$core$Maybe$Just(id));
};
var $elm$core$String$toUpper = _String_toUpper;
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $PaackEng$elm_ui_dropdown$Dropdown$performEffect = function (effect) {
	if (!effect.$) {
		var msg = effect.a;
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$identity,
			$elm$core$Task$succeed(msg));
	} else {
		var msg = effect.a;
		var id = effect.b;
		return A2(
			$elm$core$Task$attempt,
			msg,
			$elm$browser$Browser$Dom$focus(id));
	}
};
var $PaackEng$elm_ui_dropdown$Dropdown$DomFocus = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $PaackEng$elm_ui_dropdown$Dropdown$Loopback = function (a) {
	return {$: 0, a: a};
};
var $PaackEng$elm_ui_dropdown$Dropdown$OnDomFocus = function (a) {
	return {$: 0, a: a};
};
var $PaackEng$elm_ui_dropdown$Dropdown$closeOnlyIfNotMultiSelect = F2(
	function (config, state) {
		var _v0 = config.aI;
		if (_v0 === 2) {
			return state.K;
		} else {
			return false;
		}
	});
var $PaackEng$elm_ui_dropdown$Dropdown$modifySelectedItems = F3(
	function (dropdownType, selectedItem, selectedItemsOld) {
		if (dropdownType === 2) {
			return A2(
				$elm$core$List$any,
				$elm$core$Basics$eq(selectedItem),
				selectedItemsOld) ? A2(
				$elm$core$List$filter,
				$elm$core$Basics$neq(selectedItem),
				selectedItemsOld) : A2($elm$core$List$cons, selectedItem, selectedItemsOld);
		} else {
			return _List_fromArray(
				[selectedItem]);
		}
	});
var $PaackEng$elm_ui_dropdown$Dropdown$selectedItemsAsList = F2(
	function (config, model) {
		var _v0 = config.nJ(model);
		if (!_v0.$) {
			var maybeItem = _v0.a;
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, $elm$core$List$singleton, maybeItem));
		} else {
			var listItems = _v0.a;
			return listItems;
		}
	});
var $PaackEng$elm_ui_dropdown$Dropdown$findFocusedItem = F4(
	function (itemToText, filterText, focusedIndex, items) {
		var loweredFilter = $elm$core$String$toLower(filterText);
		var maybeFocusedItemFold = F2(
			function (list, i) {
				maybeFocusedItemFold:
				while (true) {
					if (list.b) {
						var item = list.a;
						var tail = list.b;
						if (A2(
							$elm$core$String$contains,
							loweredFilter,
							$elm$core$String$toLower(
								itemToText(item)))) {
							return _Utils_eq(i, focusedIndex) ? $elm$core$Maybe$Just(item) : A2(maybeFocusedItemFold, tail, i + 1);
						} else {
							var $temp$list = tail,
								$temp$i = i;
							list = $temp$list;
							i = $temp$i;
							continue maybeFocusedItemFold;
						}
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}
			});
		return A2(maybeFocusedItemFold, items, 0);
	});
var $PaackEng$elm_ui_dropdown$Dropdown$updateSelectedItemsCommand = F2(
	function (onSelectMsg, selectedItemsNew) {
		var onSelectMsgWithItems = function () {
			if (!onSelectMsg.$) {
				var itemToMsg = onSelectMsg.a;
				return itemToMsg(
					$elm$core$List$head(selectedItemsNew));
			} else {
				var itemsToMsg = onSelectMsg.a;
				return itemsToMsg(selectedItemsNew);
			}
		}();
		return _List_fromArray(
			[
				$PaackEng$elm_ui_dropdown$Dropdown$Loopback(onSelectMsgWithItems)
			]);
	});
var $PaackEng$elm_ui_dropdown$Dropdown$updateKeyDown = F4(
	function (config, key, model, state) {
		var items = config.mA(model);
		var clampIndex = function (i) {
			return A3(
				$elm$core$Basics$clamp,
				0,
				$elm$core$List$length(items) - 1,
				i);
		};
		switch (key) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{
							br: clampIndex(state.br + 1),
							K: true
						}),
					_List_Nil);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{
							br: clampIndex(state.br - 1),
							K: true
						}),
					_List_Nil);
			case 2:
				return (!state.K) ? _Utils_Tuple2(
					_Utils_update(
						state,
						{K: true}),
					_List_Nil) : _Utils_Tuple2(
					_Utils_update(
						state,
						{K: false}),
					function () {
						var _v1 = A4($PaackEng$elm_ui_dropdown$Dropdown$findFocusedItem, config.my, state.fb, state.br, items);
						if (!_v1.$) {
							var focusedItem = _v1.a;
							return A2(
								$PaackEng$elm_ui_dropdown$Dropdown$updateSelectedItemsCommand,
								config.m2,
								A3(
									$PaackEng$elm_ui_dropdown$Dropdown$modifySelectedItems,
									config.aI,
									focusedItem,
									A2($PaackEng$elm_ui_dropdown$Dropdown$selectedItemsAsList, config, model)));
						} else {
							return _List_Nil;
						}
					}());
			default:
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{K: false}),
					_List_Nil);
		}
	});
var $PaackEng$elm_ui_dropdown$Dropdown$updateWithoutPerform = F4(
	function (_v0, msg, model, untouchedState) {
		var config = _v0;
		var state = untouchedState;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(untouchedState, _List_Nil);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{
							K: A2($PaackEng$elm_ui_dropdown$Dropdown$closeOnlyIfNotMultiSelect, config, state)
						}),
					_List_Nil);
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{K: false}),
					_List_Nil);
			case 2:
				var isOpen = !state.K;
				var effect = isOpen ? _List_fromArray(
					[
						A2(
						$PaackEng$elm_ui_dropdown$Dropdown$DomFocus,
						A2($elm$core$Basics$composeR, $PaackEng$elm_ui_dropdown$Dropdown$OnDomFocus, config.lM),
						state.eg + 'input-search')
					]) : _List_Nil;
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{fb: '', br: 0, K: isOpen}),
					effect);
			case 3:
				var item = msg.a;
				var selectedItemsNew = A3(
					$PaackEng$elm_ui_dropdown$Dropdown$modifySelectedItems,
					config.aI,
					item,
					A2($PaackEng$elm_ui_dropdown$Dropdown$selectedItemsAsList, config, model));
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{
							K: A2($PaackEng$elm_ui_dropdown$Dropdown$closeOnlyIfNotMultiSelect, config, state)
						}),
					A2($PaackEng$elm_ui_dropdown$Dropdown$updateSelectedItemsCommand, config.m2, selectedItemsNew));
			case 4:
				var val = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{fb: val}),
					function () {
						var _v2 = config.ct;
						if (_v2.$ === 1) {
							return _List_Nil;
						} else {
							var onFilterChange = _v2.a;
							return _List_fromArray(
								[
									$PaackEng$elm_ui_dropdown$Dropdown$Loopback(
									onFilterChange(val))
								]);
						}
					}());
			default:
				var key = msg.a;
				return A4($PaackEng$elm_ui_dropdown$Dropdown$updateKeyDown, config, key, model, state);
		}
	});
var $PaackEng$elm_ui_dropdown$Dropdown$update = F4(
	function (config, msg, model, state) {
		return A2(
			$elm$core$Tuple$mapSecond,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map($PaackEng$elm_ui_dropdown$Dropdown$performEffect),
				$elm$core$Platform$Cmd$batch),
			A4($PaackEng$elm_ui_dropdown$Dropdown$updateWithoutPerform, config, msg, model, state));
	});
var $author$project$Api$Request$put = F5(
	function (token, toMsg, url, body, tracker) {
		return $elm$http$Http$request(
			{
				aA: body,
				aJ: A2(
					$elm$http$Http$expectStringResponse,
					toMsg,
					function (response) {
						switch (response.$) {
							case 0:
								var badUrl = response.a;
								return $elm$core$Result$Err(
									$elm$http$Http$BadUrl(badUrl));
							case 1:
								return $elm$core$Result$Err($elm$http$Http$Timeout);
							case 2:
								return $elm$core$Result$Err($elm$http$Http$NetworkError);
							case 3:
								var metadata = response.a;
								return $elm$core$Result$Err(
									$elm$http$Http$BadStatus(metadata.kf));
							default:
								return $elm$core$Result$Ok(0);
						}
					}),
				aK: $author$project$Api$Request$headers(token),
				aO: 'PUT',
				aS: $elm$core$Maybe$Nothing,
				aU: $author$project$Api$Request$trackingFor(tracker),
				aW: url
			});
	});
var $author$project$Applicant$Applicant$updateCmd = F4(
	function (token, toMsg, id, applicant) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'applicants',
					$author$project$Applicant$Applicant$idForUrl(id)
				]),
			_List_Nil);
		var body = $elm$http$Http$jsonBody(
			$author$project$Applicant$Applicant$encode(applicant));
		return A4($author$project$Api$Request$put, token, toMsg, uri, body);
	});
var $author$project$Applicant$Applicant$availableContractTypes = function (age) {
	if ((!age.$) && (age.a === 15)) {
		return _List_fromArray(
			[2]);
	} else {
		return _List_fromArray(
			[0, 1]);
	}
};
var $author$project$Applicant$Applicant$updateContractType = F2(
	function (contractType, age) {
		var _v0 = _Utils_Tuple2(
			contractType,
			$author$project$Applicant$Applicant$availableContractTypes(age));
		_v0$0:
		while (true) {
			if (!_v0.b.b) {
				if (_v0.a === 3) {
					break _v0$0;
				} else {
					return contractType;
				}
			} else {
				if (_v0.a === 3) {
					break _v0$0;
				} else {
					var _v2 = _v0.b;
					var head = _v2.a;
					var tail = _v2.b;
					return A2(
						$elm$core$List$member,
						contractType,
						A2($elm$core$List$cons, head, tail)) ? contractType : head;
				}
			}
		}
		var _v1 = _v0.a;
		return contractType;
	});
var $author$project$Applicant$Overview$updating = function (id) {
	return A2(
		$author$project$Applicant$Overview$singleAction,
		'update',
		$elm$core$Maybe$Just(id));
};
var $author$project$Applicant$Overview$updatingStatusAndDP = function (id) {
	return A2(
		$author$project$Applicant$Overview$singleAction,
		'updatingStatusAndDP',
		$elm$core$Maybe$Just(id));
};
var $author$project$Date$DaysInTheWeek$isEmpty = function (_v0) {
	var days = _v0.e1;
	return $Gizra$elm_all_set$EverySet$isEmpty(days);
};
var $author$project$Applicant$Overview$validateAvailability = F2(
	function (days, errors) {
		return $author$project$Date$DaysInTheWeek$isEmpty(days) ? _Utils_update(
			errors,
			{
				cc: _List_fromArray(
					[0])
			}) : _Utils_update(
			errors,
			{cc: _List_Nil});
	});
var $author$project$Applicant$Overview$BSNInvalidCharacters = {$: 1};
var $author$project$Applicant$Overview$BSNInvalidChecksum = {$: 2};
var $author$project$Applicant$Overview$BSNInvalidLength = function (a) {
	return {$: 0, a: a};
};
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $author$project$Applicant$Overview$bsnChecksum = function (bsn) {
	return !A2(
		$elm$core$Basics$modBy,
		11,
		$elm$core$List$sum(
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (i, d) {
						if (i === 8) {
							return -d;
						} else {
							return (9 - i) * d;
						}
					}),
				A2(
					$elm$core$List$filterMap,
					A2($elm$core$Basics$composeL, $elm$core$String$toInt, $elm$core$String$fromChar),
					$elm$core$String$toList(bsn)))));
};
var $author$project$Applicant$Overview$LengthTooLong = function (a) {
	return {$: 1, a: a};
};
var $author$project$Applicant$Overview$LengthTooShort = function (a) {
	return {$: 0, a: a};
};
var $author$project$Applicant$Overview$lengthDecoder = F2(
	function (min, max) {
		return A2(
			$arowM$elm_form_decoder$Form$Decoder$assert,
			A2(
				$arowM$elm_form_decoder$Form$Decoder$maxLength,
				$author$project$Applicant$Overview$LengthTooLong(max),
				max),
			A2(
				$arowM$elm_form_decoder$Form$Decoder$assert,
				A2(
					$arowM$elm_form_decoder$Form$Decoder$minLength,
					$author$project$Applicant$Overview$LengthTooShort(min),
					min),
				$arowM$elm_form_decoder$Form$Decoder$identity));
	});
var $author$project$Applicant$Overview$validateLength = F3(
	function (min, max, input) {
		var _v0 = A2(
			$arowM$elm_form_decoder$Form$Decoder$run,
			A2($author$project$Applicant$Overview$lengthDecoder, min, max),
			input);
		if (!_v0.$) {
			return _List_Nil;
		} else {
			var errors = _v0.a;
			return errors;
		}
	});
var $author$project$Applicant$Overview$validateBSN = function (bsn) {
	return _Utils_ap(
		A2(
			$elm$core$List$map,
			$author$project$Applicant$Overview$BSNInvalidLength,
			A3($author$project$Applicant$Overview$validateLength, 9, 9, bsn)),
		_Utils_ap(
			A2(
				$elm$core$List$all,
				$elm$core$Char$isDigit,
				$elm$core$String$toList(bsn)) ? _List_Nil : _List_fromArray(
				[$author$project$Applicant$Overview$BSNInvalidCharacters]),
			$author$project$Applicant$Overview$bsnChecksum(bsn) ? _List_Nil : _List_fromArray(
				[$author$project$Applicant$Overview$BSNInvalidChecksum])));
};
var $author$project$Applicant$Overview$BornOnTooOld = 1;
var $author$project$Applicant$Overview$BornOnTooYoung = 0;
var $arowM$elm_form_decoder$Form$Decoder$maxBound = F2(
	function (err, bound) {
		return $arowM$elm_form_decoder$Form$Decoder$custom(
			function (n) {
				return (_Utils_cmp(n, bound) < 1) ? $elm$core$Result$Ok(0) : $elm$core$Result$Err(
					_List_fromArray(
						[err]));
			});
	});
var $author$project$Applicant$Overview$maximumAge = 100;
var $arowM$elm_form_decoder$Form$Decoder$minBound = F2(
	function (err, bound) {
		return $arowM$elm_form_decoder$Form$Decoder$custom(
			function (n) {
				return (_Utils_cmp(n, bound) > -1) ? $elm$core$Result$Ok(0) : $elm$core$Result$Err(
					_List_fromArray(
						[err]));
			});
	});
var $author$project$Applicant$Overview$minimumAge = 15;
var $author$project$Applicant$Overview$bornOnDecoder = A2(
	$arowM$elm_form_decoder$Form$Decoder$assert,
	A2($arowM$elm_form_decoder$Form$Decoder$maxBound, 1, $author$project$Applicant$Overview$maximumAge),
	A2(
		$arowM$elm_form_decoder$Form$Decoder$assert,
		A2($arowM$elm_form_decoder$Form$Decoder$minBound, 0, $author$project$Applicant$Overview$minimumAge),
		$arowM$elm_form_decoder$Form$Decoder$identity));
var $author$project$Applicant$Overview$validateBornOn = F2(
	function (age, errors) {
		var _v0 = A2(
			$elm$core$Maybe$map,
			$arowM$elm_form_decoder$Form$Decoder$run($author$project$Applicant$Overview$bornOnDecoder),
			age);
		if (!_v0.$) {
			if (_v0.a.$ === 1) {
				var bornOnErrors = _v0.a.a;
				return _Utils_update(
					errors,
					{c$: bornOnErrors});
			} else {
				return _Utils_update(
					errors,
					{c$: _List_Nil});
			}
		} else {
			return _Utils_update(
				errors,
				{c$: _List_Nil});
		}
	});
var $author$project$Applicant$Overview$validateFirstName = A2($author$project$Applicant$Overview$validateLength, 1, 30);
var $author$project$Applicant$Overview$IBANInvalidCheckDigits = {$: 2};
var $author$project$Applicant$Overview$IBANInvalidCountryCode = {$: 1};
var $author$project$Applicant$Overview$IBANInvalidDutchChecksum = {$: 4};
var $author$project$Applicant$Overview$IBANInvalidDutchFormat = {$: 3};
var $author$project$Applicant$Overview$IBANInvalidLength = function (a) {
	return {$: 0, a: a};
};
var $author$project$Applicant$Overview$bigIntModBy = F2(
	function (by, bigInt) {
		return A2(
			$elm$core$Basics$modBy,
			by,
			A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					function (s) {
						return _Utils_ap(
							s,
							A2($elm$core$String$dropLeft, 16, bigInt));
					}(
						$elm$core$String$fromInt(
							A2(
								$elm$core$Basics$modBy,
								by,
								A2(
									$elm$core$Maybe$withDefault,
									0,
									$elm$core$String$toInt(
										A2($elm$core$String$left, 16, bigInt)))))))));
	});
var $author$project$Applicant$Overview$ibanDutchChecksum = function (iban) {
	return 1 === A2(
		$author$project$Applicant$Overview$bigIntModBy,
		97,
		A3(
			$elm$core$List$foldl,
			F2(
				function (a, b) {
					return _Utils_ap(
						b,
						$elm$core$Char$isDigit(a) ? $elm$core$String$fromChar(a) : $elm$core$String$fromInt(
							$elm$core$Char$toCode(a) - 55));
				}),
			'',
			$elm$core$String$toList(
				$elm$core$String$toUpper(
					_Utils_ap(
						A2($elm$core$String$dropLeft, 4, iban),
						A2($elm$core$String$left, 4, iban))))));
};
var $author$project$Applicant$Nationality$isCountryCode = function (countryCode) {
	return A2(
		$elm$core$List$member,
		countryCode,
		A2($elm$core$List$map, $author$project$Applicant$Nationality$encoder, $author$project$Applicant$Nationality$all));
};
var $author$project$Applicant$Overview$validateIBAN = function (iban) {
	var _v0 = A2($elm$core$String$left, 2, iban);
	switch (_v0) {
		case '':
			return _List_Nil;
		case 'NL':
			return _Utils_ap(
				A2(
					$elm$core$List$map,
					$author$project$Applicant$Overview$IBANInvalidLength,
					A3($author$project$Applicant$Overview$validateLength, 18, 18, iban)),
				_Utils_ap(
					(A2(
						$elm$core$Basics$composeR,
						A2($elm$core$String$slice, 2, 4),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$String$toList,
							$elm$core$List$all($elm$core$Char$isDigit)))(iban) && (A2(
						$elm$core$Basics$composeR,
						A2($elm$core$String$slice, 4, 8),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$String$toList,
							$elm$core$List$all($elm$core$Char$isAlpha)))(iban) && A2(
						$elm$core$Basics$composeR,
						A2($elm$core$String$slice, 8, 18),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$String$toList,
							$elm$core$List$all($elm$core$Char$isDigit)))(iban))) ? _List_Nil : _List_fromArray(
						[$author$project$Applicant$Overview$IBANInvalidDutchFormat]),
					$author$project$Applicant$Overview$ibanDutchChecksum(iban) ? _List_Nil : _List_fromArray(
						[$author$project$Applicant$Overview$IBANInvalidDutchChecksum])));
		default:
			var countryCode = _v0;
			return _Utils_ap(
				A2(
					$elm$core$List$map,
					$author$project$Applicant$Overview$IBANInvalidLength,
					A3($author$project$Applicant$Overview$validateLength, 15, 34, iban)),
				_Utils_ap(
					$author$project$Applicant$Nationality$isCountryCode(countryCode) ? _List_Nil : _List_fromArray(
						[$author$project$Applicant$Overview$IBANInvalidCountryCode]),
					A2(
						$elm$core$Basics$composeR,
						A2($elm$core$String$slice, 2, 4),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$String$toList,
							$elm$core$List$all($elm$core$Char$isDigit)))(iban) ? _List_Nil : _List_fromArray(
						[$author$project$Applicant$Overview$IBANInvalidCheckDigits])));
	}
};
var $author$project$Applicant$Overview$validateIdentificationExpiryDate = function (_v0) {
	var expiryDate = _v0.bq;
	var startDate = _v0.fR;
	var todayDate = _v0.fY;
	var today = $author$project$Date$DeliveryDate$toDate(todayDate);
	var start = $author$project$Date$DeliveryDate$toDate(startDate);
	var _v1 = A2($elm$core$Maybe$map, $author$project$Date$DeliveryDate$toDate, expiryDate);
	if (!_v1.$) {
		var expiry = _v1.a;
		var _v2 = _Utils_Tuple2(
			A2($justinmimbs$date$Date$compare, expiry, start),
			A2($justinmimbs$date$Date$compare, expiry, today));
		switch (_v2.a) {
			case 0:
				var _v3 = _v2.a;
				return _List_fromArray(
					[0]);
			case 1:
				var _v4 = _v2.a;
				return _List_fromArray(
					[0]);
			default:
				if (!_v2.b) {
					var _v5 = _v2.b;
					return _List_fromArray(
						[0]);
				} else {
					return _List_Nil;
				}
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Applicant$Overview$KVKInvalidCharacters = {$: 1};
var $author$project$Applicant$Overview$KVKInvalidLength = function (a) {
	return {$: 0, a: a};
};
var $author$project$Applicant$Overview$validateKVKNumber = function (kvkNumber) {
	return _Utils_ap(
		A2(
			$elm$core$List$map,
			$author$project$Applicant$Overview$KVKInvalidLength,
			A3($author$project$Applicant$Overview$validateLength, 8, 8, kvkNumber)),
		A2(
			$elm$core$List$all,
			$elm$core$Char$isDigit,
			$elm$core$String$toList(kvkNumber)) ? _List_Nil : _List_fromArray(
			[$author$project$Applicant$Overview$KVKInvalidCharacters]));
};
var $author$project$Applicant$Overview$validateLastName = A2($author$project$Applicant$Overview$validateLength, 1, 60);
var $author$project$Applicant$Overview$PhoneInvalidCharacters = {$: 1};
var $author$project$Applicant$Overview$PhoneInvalidLength = function (a) {
	return {$: 0, a: a};
};
var $author$project$Applicant$Overview$phoneParser = function () {
	var allowedChars = function (_char) {
		return $elm$core$Char$isDigit(_char) || ((_char === '-') || ((_char === '(') || ((_char === ')') || ((_char === '/') || (_char === '.')))));
	};
	return A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf(
					function (_char) {
						return (_char === '+') || allowedChars(_char);
					})),
			$elm$parser$Parser$chompWhile(allowedChars)),
		$elm$parser$Parser$end);
}();
var $author$project$Applicant$Overview$validatePhone = function (phone) {
	return _Utils_ap(
		A2(
			$elm$core$List$map,
			$author$project$Applicant$Overview$PhoneInvalidLength,
			A3($author$project$Applicant$Overview$validateLength, 9, 19, phone)),
		function () {
			var _v0 = A2($elm$parser$Parser$run, $author$project$Applicant$Overview$phoneParser, phone);
			if (!_v0.$) {
				return _List_Nil;
			} else {
				return _List_fromArray(
					[$author$project$Applicant$Overview$PhoneInvalidCharacters]);
			}
		}());
};
var $author$project$Applicant$Overview$validatePrefix = A2($author$project$Applicant$Overview$validateLength, 0, 10);
var $author$project$Applicant$Overview$VatIdInvalidPrefix = 0;
var $author$project$Applicant$Overview$validateVatId = function (vatId) {
	var _v0 = A2($elm$core$String$left, 2, vatId);
	switch (_v0) {
		case '':
			return _List_Nil;
		case 'NL':
			return _List_Nil;
		default:
			return _List_fromArray(
				[0]);
	}
};
var $author$project$Applicant$Overview$validatingVatId = function (_v0) {
	return A2($author$project$Applicant$Overview$singleAction, 'validatingVatId', $elm$core$Maybe$Nothing);
};
var $author$project$Applicant$Applicant$voidContractCmd = F4(
	function (token, toMsg, id, reason) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'applicants',
					$author$project$Applicant$Applicant$idForUrl(id),
					'void-envelope'
				]),
			_List_Nil);
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'voidedReason',
						$elm$json$Json$Encode$string(reason))
					])));
		return A4($author$project$Api$Request$put, token, toMsg, uri, body);
	});
var $author$project$Applicant$Overview$voidingContract = function (id) {
	return A2(
		$author$project$Applicant$Overview$singleAction,
		'voidingContract',
		$elm$core$Maybe$Just(id));
};
var $author$project$Applicant$Overview$whenWaiting = function (msg) {
	switch (msg.$) {
		case 0:
			return 0;
		case 1:
			return 0;
		case 2:
			return 0;
		case 3:
			return 0;
		case 4:
			return 0;
		case 5:
			return 0;
		case 6:
			return 0;
		case 7:
			return 0;
		case 8:
			return 0;
		case 9:
			return 0;
		case 10:
			return 0;
		case 11:
			return 0;
		case 13:
			return 1;
		case 14:
			return 0;
		case 15:
			return 1;
		case 16:
			return 0;
		case 17:
			return 0;
		case 18:
			return 1;
		case 19:
			return 1;
		case 20:
			return 1;
		case 21:
			return 0;
		case 22:
			return 1;
		case 23:
			return 0;
		case 24:
			return 0;
		case 27:
			return 0;
		case 28:
			return 0;
		case 29:
			return 0;
		case 30:
			return 0;
		case 31:
			return 0;
		case 32:
			return 0;
		case 33:
			return 0;
		case 34:
			return 0;
		case 35:
			return 0;
		case 36:
			return 0;
		case 37:
			return 0;
		case 38:
			return 0;
		case 39:
			return 0;
		case 40:
			return 0;
		case 41:
			return 0;
		case 42:
			return 0;
		case 43:
			return 0;
		case 44:
			return 0;
		case 45:
			return 0;
		case 46:
			return 0;
		case 47:
			return 0;
		case 48:
			return 0;
		case 49:
			return 0;
		case 50:
			return 0;
		case 51:
			return 0;
		case 52:
			return 0;
		case 25:
			return 0;
		case 26:
			return 0;
		case 53:
			return 0;
		case 54:
			return 0;
		case 55:
			return 0;
		case 56:
			return 0;
		case 57:
			return 0;
		case 58:
			return 0;
		case 59:
			return 0;
		case 60:
			return 0;
		case 61:
			return 0;
		default:
			return 0;
	}
};
var $author$project$Portal$Return$withBackgroundCommand = F2(
	function (cmd, _v0) {
		var s = _v0.a;
		var m = _v0.b;
		var c = _v0.c;
		return _Utils_Tuple3(
			s,
			m,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[cmd, c])));
	});
var $author$project$Applicant$Applicant$nameView = function (_v0) {
	var firstName = _v0.fc;
	var prefix = _v0.fF;
	var lastName = _v0.fo;
	var companyName = _v0.eU;
	if (!companyName.$) {
		var name = companyName.a;
		return name;
	} else {
		return A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
				_List_fromArray(
					[firstName, prefix, lastName])));
	}
};
var $author$project$Applicant$Applicant$cardFrom = F2(
	function (id, applicant) {
		var phone = applicant.eq;
		var bornOn = applicant.c$;
		var availability = applicant.cY;
		var status = applicant.nS;
		var distributionPointId = applicant.c2;
		var assessment = applicant.dQ;
		return {
			dQ: assessment,
			cY: availability.e1,
			c$: bornOn,
			c2: distributionPointId,
			eg: id,
			ft: $author$project$Applicant$Applicant$nameView(applicant),
			eq: phone,
			nS: status
		};
	});
var $elm_community$list_extra$List$Extra$setIf = F3(
	function (predicate, replacement, list) {
		return A3(
			$elm_community$list_extra$List$Extra$updateIf,
			predicate,
			$elm$core$Basics$always(replacement),
			list);
	});
var $author$project$Applicant$Overview$withChanged = F3(
	function (id, changed, loaded) {
		return $author$project$Applicant$Overview$filter(
			_Utils_update(
				loaded,
				{
					aX: A3(
						$elm_community$list_extra$List$Extra$setIf,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.eg;
							},
							$elm$core$Basics$eq(id)),
						A2($author$project$Applicant$Applicant$cardFrom, id, changed),
						loaded.aX)
				}));
	});
var $author$project$Applicant$Overview$withCreated = F3(
	function (id, created, loaded) {
		return $author$project$Applicant$Overview$filter(
			_Utils_update(
				loaded,
				{
					aX: A2(
						$elm$core$List$cons,
						A2($author$project$Applicant$Applicant$cardFrom, id, created),
						loaded.aX)
				}));
	});
var $author$project$Portal$ShareData$withDistributionPoints = F2(
	function (distributionPoints, model) {
		return _Utils_update(
			model,
			{
				A: $elm$core$Maybe$Just(distributionPoints)
			});
	});
var $author$project$Portal$Share$withDistributionPoints = F2(
	function (distributionPoints, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				cf: A2($author$project$Portal$ShareData$withDistributionPoints, distributionPoints, model.cf)
			});
	});
var $author$project$Applicant$Overview$ParsedZipCode = F2(
	function (digits, area) {
		return {hS: area, ii: digits};
	});
var $elm$parser$Parser$Advanced$spaces = $elm$parser$Parser$Advanced$chompWhile(
	function (c) {
		return (c === ' ') || ((c === '\n') || (c === '\r'));
	});
var $elm$parser$Parser$spaces = $elm$parser$Parser$Advanced$spaces;
var $author$project$Applicant$Overview$zipCodeArea = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $elm$core$String$toUpper, $elm$parser$Parser$succeed),
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)),
			$elm$parser$Parser$chompIf($elm$core$Char$isAlpha))));
var $author$project$Applicant$Overview$zipCodeNumber = $elm$parser$Parser$getChompedString(
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$chompIf(
						function (_char) {
							return $elm$core$Char$isDigit(_char) && (!(_char === '0'));
						})),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $author$project$Applicant$Overview$zipCodeParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($author$project$Applicant$Overview$ParsedZipCode),
		A2($elm$parser$Parser$ignorer, $author$project$Applicant$Overview$zipCodeNumber, $elm$parser$Parser$spaces)),
	A2($elm$parser$Parser$ignorer, $author$project$Applicant$Overview$zipCodeArea, $elm$parser$Parser$end));
var $author$project$Applicant$Overview$update = F3(
	function (msg, share, model) {
		var zone = $author$project$Portal$Share$timeZone(share);
		var withoutAction = function (action) {
			return $author$project$Portal$Return$withoutAction(
				action(0));
		};
		var withCommand = F2(
			function (toAction, id) {
				return $author$project$Portal$Return$withCommand(
					toAction(id));
			});
		var token = $author$project$Portal$Share$token(share);
		var today = $author$project$Portal$Share$today(share);
		var withCommandIfLoadingSelected = function (loaded) {
			var _v40 = loaded.nI;
			if (!_v40.$) {
				var id = _v40.a;
				return A3(
					withCommand,
					$author$project$Applicant$Overview$loadingApplicant,
					id,
					A5(
						$author$project$Applicant$Applicant$loadCmd,
						token,
						$author$project$Applicant$Overview$BackendRespondedApplicant(id),
						id,
						zone,
						today));
			} else {
				return $elm$core$Basics$identity;
			}
		};
		var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		var onLoaded = function (f) {
			if (model.$ === 1) {
				var loaded = model.a;
				return f(loaded);
			} else {
				return noChange;
			}
		};
		var onChange = function (f) {
			return onLoaded(
				function (loaded) {
					var selected = loaded.nI;
					if ((selected.$ === 1) && (selected.b.$ === 2)) {
						var applicant = selected.a;
						var changeModel = selected.b.a;
						return A3(f, loaded, applicant, changeModel);
					} else {
						return noChange;
					}
				});
		};
		var onLoadedWithoutAction = F2(
			function (toAction, id) {
				return onLoaded(
					function (loaded) {
						return function () {
							var _v37 = loaded.nI;
							if (!_v37.$) {
								var loadId = _v37.a;
								return A3(
									withCommand,
									$author$project$Applicant$Overview$loadingApplicant,
									loadId,
									A5(
										$author$project$Applicant$Applicant$loadCmd,
										token,
										$author$project$Applicant$Overview$BackendRespondedApplicant(loadId),
										loadId,
										zone,
										today));
							} else {
								return $elm$core$Basics$identity;
							}
						}()(
							A2(
								$author$project$Portal$Return$withoutAction,
								toAction(id),
								noChange));
					});
			});
		var modelChange = function (m) {
			return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
		};
		var selectedChange = function (f) {
			return onLoaded(
				function (loaded) {
					var selected = loaded.nI;
					if (selected.$ === 1) {
						var applicant = selected.a;
						return modelChange(
							$author$project$Applicant$Overview$LoadedOverview(
								A2(f, loaded, applicant)));
					} else {
						return noChange;
					}
				});
		};
		var sendingContractChange = function (f) {
			return onLoaded(
				function (loaded) {
					var selected = loaded.nI;
					if ((selected.$ === 1) && (selected.b.$ === 3)) {
						var applicant = selected.a;
						var distributor = selected.b.a;
						return modelChange(
							$author$project$Applicant$Overview$LoadedOverview(
								A3(f, loaded, applicant, distributor)));
					} else {
						return noChange;
					}
				});
		};
		var errWithId = F4(
			function (action, id, error, m) {
				return _Utils_Tuple3(
					A2(
						$author$project$Portal$Share$withHttpError,
						error,
						A2(
							$author$project$Portal$Share$withoutWaitingAction,
							action(id),
							share)),
					m,
					$elm$core$Platform$Cmd$none);
			});
		var err = F3(
			function (action, error, m) {
				return _Utils_Tuple3(
					A2(
						$author$project$Portal$Share$withHttpError,
						error,
						A2(
							$author$project$Portal$Share$withoutWaitingAction,
							action(0),
							share)),
					m,
					$elm$core$Platform$Cmd$none);
			});
		var changeApplicant = function (f) {
			return onLoaded(
				function (loaded) {
					var selected = loaded.nI;
					if ((selected.$ === 1) && (selected.b.$ === 2)) {
						var applicant = selected.a;
						var changeModel = selected.b.a;
						return modelChange(
							$author$project$Applicant$Overview$LoadedOverview(
								A3(f, loaded, applicant, changeModel)));
					} else {
						return noChange;
					}
				});
		};
		if (A3($author$project$Portal$Share$allowed, $author$project$Applicant$Overview$whenWaiting, msg, share) === 1) {
			return noChange;
		} else {
			_v0$25:
			while (true) {
				_v0$31:
				while (true) {
					switch (msg.$) {
						case 0:
							if (!msg.b.$) {
								var id = msg.a;
								var applicant = msg.b.a;
								return onLoaded(
									function (loaded) {
										return A2(
											$author$project$Portal$Return$withoutAction,
											$author$project$Applicant$Overview$loadingApplicant(id),
											modelChange(
												$author$project$Applicant$Overview$LoadedOverview(
													_Utils_update(
														loaded,
														{
															nI: A2($author$project$Applicant$Overview$Selected, applicant, $author$project$Applicant$Overview$Viewing)
														}))));
									});
							} else {
								var id = msg.a;
								var error = msg.b.a;
								return A4(errWithId, $author$project$Applicant$Overview$loadingApplicant, id, error, $author$project$Applicant$Overview$Failed);
							}
						case 1:
							if (!msg.a.$) {
								var all = msg.a.a;
								var loaded = function () {
									switch (model.$) {
										case 0:
											var dpFilter = model.a;
											return A3($author$project$Applicant$Overview$initLoaded, share, all, dpFilter);
										case 1:
											var filterOn = model.a.J;
											return A3($author$project$Applicant$Overview$initLoaded, share, all, filterOn.w);
										default:
											return A3($author$project$Applicant$Overview$initLoaded, share, all, $Gizra$elm_all_set$EverySet$empty);
									}
								}();
								var withCommandsIfCanManageContracts = loaded.dS ? A3(
									withCommand,
									$author$project$Applicant$Overview$loadingMinStart,
									0,
									A4($author$project$Applicant$Applicant$loadMinStartCmd, token, $author$project$Applicant$Overview$BackendRespondedMinStart, zone, today)) : $elm$core$Basics$identity;
								return A2(
									withCommandIfLoadingSelected,
									loaded,
									withCommandsIfCanManageContracts(
										A2(
											withoutAction,
											$author$project$Applicant$Overview$loadingApplicants,
											modelChange(
												$author$project$Applicant$Overview$LoadedOverview(loaded)))));
							} else {
								if ((msg.a.a.$ === 3) && (msg.a.a.a === 404)) {
									return A2(
										withoutAction,
										$author$project$Applicant$Overview$loadingApplicants,
										modelChange(
											$author$project$Applicant$Overview$LoadedOverview(
												A3($author$project$Applicant$Overview$initLoaded, share, _List_Nil, $Gizra$elm_all_set$EverySet$empty))));
								} else {
									var error = msg.a.a;
									return A3(err, $author$project$Applicant$Overview$loadingApplicants, error, $author$project$Applicant$Overview$Failed);
								}
							}
						case 2:
							if (!msg.a.$) {
								var address = msg.a.a;
								return changeApplicant(
									F3(
										function (loaded, applicant, changeModel) {
											var changed = changeModel.a;
											var errors = changeModel.b;
											var newAddress = changeModel.a.f1;
											var _v2 = _Utils_Tuple2(
												$elm$core$String$isEmpty(address.b5),
												$elm$core$String$isEmpty(address.bU));
											if ((!_v2.a) && (!_v2.b)) {
												return _Utils_update(
													loaded,
													{
														nI: A2(
															$author$project$Applicant$Overview$Selected,
															applicant,
															$author$project$Applicant$Overview$Changing(
																_Utils_update(
																	changeModel,
																	{
																		an: 1,
																		a: _Utils_update(
																			changed,
																			{
																				f1: _Utils_update(
																					newAddress,
																					{bU: address.bU, b5: address.b5})
																			}),
																		b: _Utils_update(
																			errors,
																			{bU: _List_Nil, b5: _List_Nil})
																	})))
													});
											} else {
												return _Utils_update(
													loaded,
													{
														nI: A2(
															$author$project$Applicant$Overview$Selected,
															applicant,
															$author$project$Applicant$Overview$Changing(
																_Utils_update(
																	changeModel,
																	{an: 0})))
													});
											}
										}));
							} else {
								if (!msg.a.a.$) {
									return changeApplicant(
										F3(
											function (loaded, applicant, changeModel) {
												return _Utils_update(
													loaded,
													{
														nI: A2(
															$author$project$Applicant$Overview$Selected,
															applicant,
															$author$project$Applicant$Overview$Changing(
																_Utils_update(
																	changeModel,
																	{an: 2})))
													});
											}));
								} else {
									if (msg.a.a.a.$ === 4) {
										return changeApplicant(
											F3(
												function (loaded, applicant, changeModel) {
													return _Utils_update(
														loaded,
														{
															nI: A2(
																$author$project$Applicant$Overview$Selected,
																applicant,
																$author$project$Applicant$Overview$Changing(
																	_Utils_update(
																		changeModel,
																		{an: 2})))
														});
												}));
									} else {
										return noChange;
									}
								}
							}
						case 3:
							if (!msg.a.$) {
								var distributionPoints = msg.a.a;
								return A4(
									withCommand,
									$author$project$Applicant$Overview$loadingApplicants,
									0,
									A3(
										$author$project$Applicant$Applicant$loadApplicantsCmd,
										$author$project$Portal$Share$token(share),
										$author$project$Applicant$Overview$BackendRespondedApplicants,
										distributionPoints),
									A2(
										withoutAction,
										$author$project$Applicant$Overview$loadingDPs,
										_Utils_Tuple3(
											A2($author$project$Portal$Share$withDistributionPoints, distributionPoints, share),
											model,
											$elm$core$Platform$Cmd$none)));
							} else {
								var error = msg.a.a;
								return A3(err, $author$project$Applicant$Overview$loadingDPs, error, $author$project$Applicant$Overview$Failed);
							}
						case 4:
							if (!msg.a.$) {
								var minStart = msg.a.a;
								return onLoaded(
									function (loaded) {
										return A2(
											withoutAction,
											$author$project$Applicant$Overview$loadingMinStart,
											modelChange(
												$author$project$Applicant$Overview$LoadedOverview(
													_Utils_update(
														loaded,
														{fr: minStart}))));
									});
							} else {
								var error = msg.a.a;
								return A3(err, $author$project$Applicant$Overview$loadingMinStart, error, $author$project$Applicant$Overview$Failed);
							}
						case 5:
							if (!msg.b.$) {
								var created = msg.b.a;
								var _v3 = created.eg;
								if (!_v3.$) {
									var id = _v3.a;
									return onLoaded(
										function (loaded) {
											return A2(
												withoutAction,
												$author$project$Applicant$Overview$creating,
												modelChange(
													$author$project$Applicant$Overview$LoadedOverview(
														A3(
															$author$project$Applicant$Overview$withCreated,
															id,
															created,
															_Utils_update(
																loaded,
																{
																	nI: A2($author$project$Applicant$Overview$Selected, created, $author$project$Applicant$Overview$Viewing)
																})))));
										});
								} else {
									return A2(withoutAction, $author$project$Applicant$Overview$creating, noChange);
								}
							} else {
								if ((msg.b.a.$ === 3) && (msg.b.a.a === 409)) {
									var firstName = msg.a.fc;
									var lastName = msg.a.fo;
									var phone = msg.a.eq;
									return _Utils_Tuple3(
										A2(
											$author$project$Portal$Share$withNotification,
											A2(
												$author$project$Portal$Message$info,
												'Deze kandidaat is reeds aangemaakt.',
												A2(
													$elm$core$String$join,
													' ',
													_List_fromArray(
														['In de afgelopen 24 uur is er al een kandidaat aangemaakt met naam', firstName, lastName, 'en telefoonnummer', phone + '.', 'Het kan zijn dat deze kandidaat is toegewezen bij een ander depot.', 'Neem contact op met onze IT afdeling en wij zullen dit zo spoedig mogelijk oplossen.']))),
											A2(
												$author$project$Portal$Share$withoutWaitingAction,
												$author$project$Applicant$Overview$creating(0),
												share)),
										model,
										$elm$core$Platform$Cmd$none);
								} else {
									var error = msg.b.a;
									return A3(err, $author$project$Applicant$Overview$creating, error, $author$project$Applicant$Overview$Failed);
								}
							}
						case 6:
							if (!msg.b.$) {
								var id = msg.a;
								return A2(onLoadedWithoutAction, $author$project$Applicant$Overview$updating, id);
							} else {
								if ((msg.b.a.$ === 3) && (msg.b.a.a === 422)) {
									var id = msg.a;
									return _Utils_Tuple3(
										A2(
											$author$project$Portal$Share$withNotification,
											A2($author$project$Portal$Message$info, 'Deze kandidaat mag niet worden aangepast. ', 'De kandidaat zit al in het ondertekeningsproces of heeft al een ondertekend contract.'),
											A2(
												$author$project$Portal$Share$withoutWaitingAction,
												$author$project$Applicant$Overview$updating(id),
												share)),
										model,
										$elm$core$Platform$Cmd$none);
								} else {
									var id = msg.a;
									var error = msg.b.a;
									return A4(errWithId, $author$project$Applicant$Overview$updating, id, error, $author$project$Applicant$Overview$Failed);
								}
							}
						case 7:
							if (!msg.b.$) {
								var id = msg.a;
								return A2(onLoadedWithoutAction, $author$project$Applicant$Overview$updatingStatusAndDP, id);
							} else {
								if ((msg.b.a.$ === 3) && (msg.b.a.a === 422)) {
									var id = msg.a;
									return _Utils_Tuple3(
										A2(
											$author$project$Portal$Share$withNotification,
											A2($author$project$Portal$Message$info, 'Deze kandidaat mag niet worden aangepast. ', 'De kandidaat zit al in het ondertekeningsproces of heeft al een ondertekend contract.'),
											A2(
												$author$project$Portal$Share$withoutWaitingAction,
												$author$project$Applicant$Overview$updatingStatusAndDP(id),
												share)),
										model,
										$elm$core$Platform$Cmd$none);
								} else {
									var id = msg.a;
									var error = msg.b.a;
									return A4(errWithId, $author$project$Applicant$Overview$updatingStatusAndDP, id, error, $author$project$Applicant$Overview$Failed);
								}
							}
						case 8:
							if (!msg.b.$) {
								var id = msg.a;
								return A2(onLoadedWithoutAction, $author$project$Applicant$Overview$sendingContract, id);
							} else {
								if (msg.b.a.$ === 3) {
									switch (msg.b.a.a) {
										case 412:
											var id = msg.a;
											return _Utils_Tuple3(
												A2(
													$author$project$Portal$Share$withNotification,
													A2($author$project$Portal$Message$info, 'Ongeldig email adres', 'Een ontvanger van het contract heeft een ongeldig email adres.'),
													A2(
														$author$project$Portal$Share$withoutWaitingAction,
														$author$project$Applicant$Overview$sendingContract(id),
														share)),
												model,
												$elm$core$Platform$Cmd$none);
										case 422:
											var id = msg.a;
											return _Utils_Tuple3(
												A2(
													$author$project$Portal$Share$withNotification,
													A2($author$project$Portal$Message$info, 'Er is al een contract aangemaakt voor deze kandidaat. ', 'De kandidaat zit al in het ondertekeningsproces of heeft al een ondertekend contract.'),
													A2(
														$author$project$Portal$Share$withoutWaitingAction,
														$author$project$Applicant$Overview$sendingContract(id),
														share)),
												model,
												$elm$core$Platform$Cmd$none);
										default:
											break _v0$25;
									}
								} else {
									break _v0$25;
								}
							}
						case 9:
							if (!msg.b.$) {
								var id = msg.a;
								return A2(onLoadedWithoutAction, $author$project$Applicant$Overview$voidingContract, id);
							} else {
								var id = msg.a;
								var error = msg.b.a;
								return A4(errWithId, $author$project$Applicant$Overview$voidingContract, id, error, $author$project$Applicant$Overview$Failed);
							}
						case 10:
							if (!msg.a.$) {
								return A2(
									$author$project$Portal$Return$withoutAction,
									$author$project$Applicant$Overview$validatingVatId(0),
									changeApplicant(
										F3(
											function (loaded, applicant, changeModel) {
												var changed = changeModel.a;
												var errors = changeModel.b;
												return _Utils_update(
													loaded,
													{
														nI: A2(
															$author$project$Applicant$Overview$Selected,
															applicant,
															$author$project$Applicant$Overview$Changing(
																_Utils_update(
																	changeModel,
																	{
																		bh: false,
																		b: _Utils_update(
																			errors,
																			{hF: _List_Nil})
																	})))
													});
											})));
							} else {
								if (msg.a.a.$ === 3) {
									switch (msg.a.a.a) {
										case 400:
											return A2(
												$author$project$Portal$Return$withoutAction,
												$author$project$Applicant$Overview$validatingVatId(0),
												changeApplicant(
													F3(
														function (loaded, applicant, changeModel) {
															var changed = changeModel.a;
															var errors = changeModel.b;
															return _Utils_update(
																loaded,
																{
																	nI: A2(
																		$author$project$Applicant$Overview$Selected,
																		applicant,
																		$author$project$Applicant$Overview$Changing(
																			_Utils_update(
																				changeModel,
																				{
																					bh: false,
																					b: _Utils_update(
																						errors,
																						{
																							hF: _List_fromArray(
																								[1])
																						})
																				})))
																});
														})));
										case 404:
											return A2(
												$author$project$Portal$Return$withoutAction,
												$author$project$Applicant$Overview$validatingVatId(0),
												changeApplicant(
													F3(
														function (loaded, applicant, changeModel) {
															var changed = changeModel.a;
															var errors = changeModel.b;
															return _Utils_update(
																loaded,
																{
																	nI: A2(
																		$author$project$Applicant$Overview$Selected,
																		applicant,
																		$author$project$Applicant$Overview$Changing(
																			_Utils_update(
																				changeModel,
																				{
																					bh: false,
																					b: _Utils_update(
																						errors,
																						{
																							hF: _List_fromArray(
																								[1])
																						})
																				})))
																});
														})));
										default:
											break _v0$31;
									}
								} else {
									break _v0$31;
								}
							}
						case 13:
							var id = msg.a.eg;
							return A4(
								withCommand,
								$author$project$Applicant$Overview$loadingApplicant,
								id,
								A5(
									$author$project$Applicant$Applicant$loadCmd,
									token,
									$author$project$Applicant$Overview$BackendRespondedApplicant(id),
									id,
									zone,
									today),
								noChange);
						case 24:
							var day = msg.a;
							var checked = msg.b;
							return changeApplicant(
								F3(
									function (loaded, applicant, changeModel) {
										var changed = changeModel.a;
										var errors = changeModel.b;
										var availability = changed.cY;
										var changedAvailability = _Utils_update(
											availability,
											{
												e1: checked ? A2($author$project$Date$DaysInTheWeek$insert, day, availability.e1) : A2($author$project$Date$DaysInTheWeek$remove, day, availability.e1)
											});
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$Changing(
														_Utils_update(
															changeModel,
															{
																a: _Utils_update(
																	changed,
																	{cY: changedAvailability}),
																b: A2($author$project$Applicant$Overview$validateAvailability, changedAvailability.e1, errors)
															})))
											});
									}));
						case 54:
							var status = msg.a;
							var checked = msg.b;
							return onLoaded(
								function (loaded) {
									var change = function (filterOn) {
										return _Utils_update(
											filterOn,
											{
												nS: checked ? A2($Gizra$elm_all_set$EverySet$insert, status, filterOn.nS) : A2($Gizra$elm_all_set$EverySet$remove, status, filterOn.nS)
											});
									};
									var newLoaded = $author$project$Applicant$Overview$filter(
										_Utils_update(
											loaded,
											{
												J: change(loaded.J)
											}));
									return A2(
										withCommandIfLoadingSelected,
										newLoaded,
										modelChange(
											$author$project$Applicant$Overview$LoadedOverview(newLoaded)));
								});
						case 55:
							var search = msg.a;
							return onLoaded(
								function (loaded) {
									var change = function (filterOn) {
										return _Utils_update(
											filterOn,
											{aj: search});
									};
									var newLoaded = $author$project$Applicant$Overview$filter(
										_Utils_update(
											loaded,
											{
												J: change(loaded.J)
											}));
									return A2(
										withCommandIfLoadingSelected,
										newLoaded,
										modelChange(
											$author$project$Applicant$Overview$LoadedOverview(newLoaded)));
								});
						case 56:
							var dp = msg.a;
							var checked = msg.b;
							return onLoaded(
								function (loaded) {
									var change = function (filterOn) {
										return _Utils_update(
											filterOn,
											{
												w: checked ? A2($Gizra$elm_all_set$EverySet$insert, dp, filterOn.w) : A2($Gizra$elm_all_set$EverySet$remove, dp, filterOn.w)
											});
									};
									var newLoaded = $author$project$Applicant$Overview$filter(
										_Utils_update(
											loaded,
											{
												J: change(loaded.J)
											}));
									return A2(
										$author$project$Portal$Return$withBackgroundCommand,
										$author$project$Ports$rememberValue(
											{
												iY: 'applicant-dp-filter',
												kt: A2(
													$elm$json$Json$Encode$encode,
													0,
													$author$project$Applicant$Overview$encodeRememberedDpFilter(newLoaded.J.w))
											}),
										A2(
											withCommandIfLoadingSelected,
											newLoaded,
											modelChange(
												$author$project$Applicant$Overview$LoadedOverview(newLoaded))));
								});
						case 14:
							var contractType = msg.a;
							var _v4 = msg.b;
							var dpId = _v4.a;
							return onLoaded(
								function (loaded) {
									return modelChange(
										function () {
											var _new = A3($author$project$Applicant$Applicant$newApplicant, contractType, today, dpId);
											var errors = {cc: _List_Nil, c$: _List_Nil, gd: _List_Nil, d5: _List_Nil, fc: _List_Nil, bs: _List_Nil, gE: _List_Nil, gF: _List_Nil, gG: _List_Nil, gI: _List_Nil, gM: _List_Nil, fo: _List_Nil, bU: _List_Nil, g7: _List_Nil, g8: _List_Nil, eq: _List_Nil, fF: _List_Nil, b5: _List_Nil, dE: _List_Nil, hF: _List_Nil, cT: _List_Nil};
											return $author$project$Applicant$Overview$LoadedOverview(
												_Utils_update(
													loaded,
													{
														nI: A2(
															$author$project$Applicant$Overview$Selected,
															_new,
															$author$project$Applicant$Overview$Changing(
																{
																	an: 0,
																	c$: A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $author$project$Date$DeliveryDate$encodeForDateInput, _new.c$),
																	a: _new,
																	bh: false,
																	I: A3($author$project$Applicant$Overview$initDPModel, dpId, _List_Nil, loaded.A),
																	b: errors,
																	bq: A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $author$project$Date$DeliveryDate$encodeForDateInput, _new.gF),
																	hq: $author$project$Date$DeliveryDate$encodeForDateInput(_new.cY.hq)
																}))
													}));
										}());
								});
						case 15:
							return selectedChange(
								F2(
									function (loaded, applicant) {
										var errors = {
											cc: _List_Nil,
											c$: _List_Nil,
											gd: _List_Nil,
											d5: _List_Nil,
											fc: $author$project$Applicant$Overview$validateFirstName(applicant.fc),
											bs: _List_Nil,
											gE: _List_Nil,
											gF: $author$project$Applicant$Overview$validateIdentificationExpiryDate(
												{bq: applicant.gF, fR: applicant.cY.hq, fY: today}),
											gG: _List_Nil,
											gI: _List_Nil,
											gM: _List_Nil,
											fo: $author$project$Applicant$Overview$validateLastName(applicant.fo),
											bU: _List_Nil,
											g7: _List_Nil,
											g8: _List_Nil,
											eq: _List_Nil,
											fF: $author$project$Applicant$Overview$validatePrefix(applicant.fF),
											b5: _List_Nil,
											dE: _List_Nil,
											hF: _List_Nil,
											cT: _List_Nil
										};
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$Changing(
														{
															an: 0,
															c$: A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $author$project$Date$DeliveryDate$encodeForDateInput, applicant.c$),
															a: applicant,
															bh: false,
															I: A3($author$project$Applicant$Overview$initDPModel, applicant.c2, applicant.h2, loaded.A),
															b: errors,
															bq: A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $author$project$Date$DeliveryDate$encodeForDateInput, applicant.gF),
															hq: $author$project$Date$DeliveryDate$encodeForDateInput(applicant.cY.hq)
														}))
											});
									}));
						case 16:
							return selectedChange(
								F2(
									function (loaded, applicant) {
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$UpdateStatusAndDP(
														{
															gg: '',
															I: A3($author$project$Applicant$Overview$initDPModel, applicant.c2, applicant.h2, loaded.A),
															nS: applicant.nS
														}))
											});
									}));
						case 17:
							return onLoaded(
								function (loaded) {
									var selected = loaded.nI;
									if (selected.$ === 1) {
										var applicant = selected.a;
										var _v6 = _Utils_Tuple2(
											applicant.eg,
											$elm$core$List$reverse(loaded.eb));
										if (!_v6.a.$) {
											return modelChange(
												$author$project$Applicant$Overview$LoadedOverview(
													_Utils_update(
														loaded,
														{
															nI: A2($author$project$Applicant$Overview$Selected, applicant, $author$project$Applicant$Overview$Viewing)
														})));
										} else {
											if (!_v6.b.b) {
												var _v7 = _v6.a;
												return modelChange(
													$author$project$Applicant$Overview$LoadedOverview(
														_Utils_update(
															loaded,
															{nI: $author$project$Applicant$Overview$NoneSelected})));
											} else {
												var _v8 = _v6.a;
												var _v9 = _v6.b;
												var head = _v9.a;
												return A4(
													withCommand,
													$author$project$Applicant$Overview$loadingApplicant,
													head.eg,
													A5(
														$author$project$Applicant$Applicant$loadCmd,
														token,
														$author$project$Applicant$Overview$BackendRespondedApplicant(head.eg),
														head.eg,
														zone,
														today),
													modelChange(
														$author$project$Applicant$Overview$LoadedOverview(
															_Utils_update(
																loaded,
																{nI: $author$project$Applicant$Overview$NoneSelected}))));
											}
										}
									} else {
										return noChange;
									}
								});
						case 18:
							var applicantId = msg.a;
							return onChange(
								F3(
									function (loaded, _v10, _v11) {
										var changed = _v11.a;
										if (!applicantId.$) {
											var id = applicantId.a;
											return A3(
												$author$project$Portal$Return$withCommand,
												$author$project$Applicant$Overview$updating(id),
												A4(
													$author$project$Applicant$Applicant$updateCmd,
													token,
													$author$project$Applicant$Overview$BackendRespondedToUpdate(id),
													id,
													changed),
												modelChange(
													$author$project$Applicant$Overview$LoadedOverview(
														A3(
															$author$project$Applicant$Overview$withChanged,
															id,
															changed,
															_Utils_update(
																loaded,
																{
																	nI: A2($author$project$Applicant$Overview$Selected, changed, $author$project$Applicant$Overview$Viewing)
																})))));
										} else {
											return A4(
												withCommand,
												$author$project$Applicant$Overview$creating,
												0,
												A5(
													$author$project$Applicant$Applicant$createCmd,
													token,
													$author$project$Applicant$Overview$BackendRespondedToCreate(changed),
													changed,
													zone,
													today),
												modelChange(
													$author$project$Applicant$Overview$LoadedOverview(
														_Utils_update(
															loaded,
															{nI: $author$project$Applicant$Overview$NoneSelected}))));
										}
									}));
						case 19:
							var id = msg.a;
							return onLoaded(
								function (loaded) {
									var selected = loaded.nI;
									if ((selected.$ === 1) && (selected.b.$ === 1)) {
										var applicant = selected.a;
										var status = selected.b.a.nS;
										var comment = selected.b.a.gg;
										var dpModel = selected.b.a.I;
										var changed = _Utils_update(
											applicant,
											{
												gg: comment,
												c2: A2(
													$elm$core$Maybe$withDefault,
													applicant.c2,
													A2($elm$core$Maybe$map, $elm$core$Tuple$first, dpModel.cE)),
												nS: status
											});
										return A4(
											withCommand,
											$author$project$Applicant$Overview$updatingStatusAndDP,
											id,
											A4(
												$author$project$Applicant$Applicant$updateCmd,
												token,
												$author$project$Applicant$Overview$BackendRespondedToUpdateStatusAndDP(id),
												id,
												changed),
											modelChange(
												$author$project$Applicant$Overview$LoadedOverview(
													A3(
														$author$project$Applicant$Overview$withChanged,
														id,
														changed,
														_Utils_update(
															loaded,
															{
																nI: A2($author$project$Applicant$Overview$Selected, changed, $author$project$Applicant$Overview$Viewing)
															})))));
									} else {
										return noChange;
									}
								});
						case 20:
							var id = msg.a;
							return onLoaded(
								function (loaded) {
									var selected = loaded.nI;
									if ((selected.$ === 1) && (selected.b.$ === 3)) {
										var applicant = selected.a;
										var distributor = selected.b.a;
										return A4(
											withCommand,
											$author$project$Applicant$Overview$sendingContract,
											id,
											A4(
												$author$project$Applicant$Applicant$sendContractCmd,
												token,
												$author$project$Applicant$Overview$BackendRespondedToSendContract(id),
												id,
												distributor),
											A3(
												$elm$core$Basics$composeL,
												modelChange,
												$author$project$Applicant$Overview$LoadedOverview,
												A3(
													$author$project$Applicant$Overview$withChanged,
													id,
													_Utils_update(
														applicant,
														{nS: $author$project$Applicant$Applicant$contractSendStatus}),
													_Utils_update(
														loaded,
														{
															nI: A2(
																$author$project$Applicant$Overview$Selected,
																_Utils_update(
																	applicant,
																	{nS: $author$project$Applicant$Applicant$contractSendStatus}),
																$author$project$Applicant$Overview$Viewing)
														}))));
									} else {
										return noChange;
									}
								});
						case 21:
							return selectedChange(
								F2(
									function (loaded, applicant) {
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$SendingContract(
														{lH: '', lI: ''}))
											});
									}));
						case 22:
							var id = msg.a;
							return onLoaded(
								function (loaded) {
									var selected = loaded.nI;
									if ((selected.$ === 1) && (selected.b.$ === 4)) {
										var applicant = selected.a;
										var reason = selected.b.a;
										return A4(
											withCommand,
											$author$project$Applicant$Overview$voidingContract,
											id,
											A4(
												$author$project$Applicant$Applicant$voidContractCmd,
												token,
												$author$project$Applicant$Overview$BackendRespondedToVoidContract(id),
												id,
												reason),
											A3(
												$elm$core$Basics$composeL,
												modelChange,
												$author$project$Applicant$Overview$LoadedOverview,
												A3(
													$author$project$Applicant$Overview$withChanged,
													id,
													_Utils_update(
														applicant,
														{nS: $author$project$Applicant$Applicant$contractVoidStatus}),
													_Utils_update(
														loaded,
														{
															nI: A2(
																$author$project$Applicant$Overview$Selected,
																_Utils_update(
																	applicant,
																	{nS: $author$project$Applicant$Applicant$contractVoidStatus}),
																$author$project$Applicant$Overview$Viewing)
														}))));
									} else {
										return noChange;
									}
								});
						case 27:
							var newSalutation = msg.a;
							return changeApplicant(
								F3(
									function (loaded, applicant, changeModel) {
										var changed = changeModel.a;
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$Changing(
														_Utils_update(
															changeModel,
															{
																a: _Utils_update(
																	changed,
																	{hi: newSalutation})
															})))
											});
									}));
						case 23:
							return selectedChange(
								F2(
									function (loaded, applicant) {
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$VoidingContract(''))
											});
									}));
						case 28:
							var newInitials = msg.a;
							return changeApplicant(
								F3(
									function (loaded, applicant, changeModel) {
										var changed = changeModel.a;
										var errors = changeModel.b;
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$Changing(
														_Utils_update(
															changeModel,
															{
																a: _Utils_update(
																	changed,
																	{
																		gI: $elm$core$String$toUpper(newInitials)
																	}),
																b: _Utils_update(
																	errors,
																	{
																		gI: A3($author$project$Applicant$Overview$validateLength, 0, 10, newInitials)
																	})
															})))
											});
									}));
						case 29:
							var newFirstName = msg.a;
							return changeApplicant(
								F3(
									function (loaded, applicant, changeModel) {
										var changed = changeModel.a;
										var errors = changeModel.b;
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$Changing(
														_Utils_update(
															changeModel,
															{
																a: _Utils_update(
																	changed,
																	{fc: newFirstName}),
																b: _Utils_update(
																	errors,
																	{
																		fc: $author$project$Applicant$Overview$validateFirstName(newFirstName)
																	})
															})))
											});
									}));
						case 30:
							var newPrefix = msg.a;
							return changeApplicant(
								F3(
									function (loaded, applicant, changeModel) {
										var changed = changeModel.a;
										var errors = changeModel.b;
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$Changing(
														_Utils_update(
															changeModel,
															{
																a: _Utils_update(
																	changed,
																	{fF: newPrefix}),
																b: _Utils_update(
																	errors,
																	{
																		fF: $author$project$Applicant$Overview$validatePrefix(newPrefix)
																	})
															})))
											});
									}));
						case 31:
							var newLastName = msg.a;
							return changeApplicant(
								F3(
									function (loaded, applicant, changeModel) {
										var changed = changeModel.a;
										var errors = changeModel.b;
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$Changing(
														_Utils_update(
															changeModel,
															{
																a: _Utils_update(
																	changed,
																	{fo: newLastName}),
																b: _Utils_update(
																	errors,
																	{
																		fo: $author$project$Applicant$Overview$validateLastName(newLastName)
																	})
															})))
											});
									}));
						case 32:
							var companyName = msg.a;
							return changeApplicant(
								F3(
									function (loaded, applicant, changeModel) {
										var changed = changeModel.a;
										var errors = changeModel.b;
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$Changing(
														_Utils_update(
															changeModel,
															{
																a: _Utils_update(
																	changed,
																	{
																		eU: $elm$core$Maybe$Just(companyName)
																	}),
																b: errors
															})))
											});
									}));
						case 33:
							var newZipCode = msg.a;
							return changeApplicant(
								F3(
									function (loaded, applicant, changeModel) {
										var changed = changeModel.a;
										var errors = changeModel.b;
										var address = changed.f1;
										var _v16 = function () {
											var _v17 = A2($elm$parser$Parser$run, $author$project$Applicant$Overview$zipCodeParser, newZipCode);
											if (!_v17.$) {
												var digits = _v17.a.ii;
												var area = _v17.a.hS;
												return _Utils_Tuple2(
													_Utils_ap(digits, area),
													_List_Nil);
											} else {
												return _Utils_Tuple2(
													newZipCode,
													_List_fromArray(
														[0]));
											}
										}();
										var zipCode = _v16.a;
										var zipCodeErrors = _v16.b;
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$Changing(
														_Utils_update(
															changeModel,
															{
																a: _Utils_update(
																	changed,
																	{
																		f1: _Utils_update(
																			address,
																			{cT: zipCode})
																	}),
																b: _Utils_update(
																	errors,
																	{cT: zipCodeErrors})
															})))
											});
									}));
						case 34:
							var number = msg.a;
							return changeApplicant(
								F3(
									function (loaded, applicant, changeModel) {
										var changed = changeModel.a;
										var errors = changeModel.b;
										var houseNumberErrors = function () {
											var _v18 = A2($arowM$elm_form_decoder$Form$Decoder$run, $author$project$Applicant$Overview$addressHouseNumberDecoder, number);
											if (!_v18.$) {
												return _List_Nil;
											} else {
												return _List_fromArray(
													[0]);
											}
										}();
										var address = changed.f1;
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$Changing(
														_Utils_update(
															changeModel,
															{
																a: _Utils_update(
																	changed,
																	{
																		f1: _Utils_update(
																			address,
																			{
																				bs: {
																					bX: A2(
																						$elm$core$Maybe$withDefault,
																						0,
																						$elm$core$String$toInt(number)),
																					dE: address.bs.dE
																				}
																			})
																	}),
																b: _Utils_update(
																	errors,
																	{bs: houseNumberErrors})
															})))
											});
									}));
						case 35:
							var newSuffix = msg.a;
							return changeApplicant(
								F3(
									function (loaded, applicant, changeModel) {
										var changed = changeModel.a;
										var errors = changeModel.b;
										var address = changed.f1;
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$Changing(
														_Utils_update(
															changeModel,
															{
																a: _Utils_update(
																	changed,
																	{
																		f1: _Utils_update(
																			address,
																			{
																				bs: {
																					bX: address.bs.bX,
																					dE: $elm$core$Maybe$Just(newSuffix)
																				}
																			})
																	}),
																b: _Utils_update(
																	errors,
																	{
																		dE: A3($author$project$Applicant$Overview$validateLength, 0, 5, newSuffix)
																	})
															})))
											});
									}));
						case 36:
							var newStreet = msg.a;
							return changeApplicant(
								F3(
									function (loaded, applicant, changeModel) {
										var changed = changeModel.a;
										var errors = changeModel.b;
										var address = changed.f1;
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$Changing(
														_Utils_update(
															changeModel,
															{
																an: 0,
																a: _Utils_update(
																	changed,
																	{
																		f1: _Utils_update(
																			address,
																			{b5: newStreet})
																	}),
																b: _Utils_update(
																	errors,
																	{
																		b5: A3($author$project$Applicant$Overview$validateLength, 2, 80, newStreet)
																	})
															})))
											});
									}));
						case 37:
							var newMunicipal = msg.a;
							return changeApplicant(
								F3(
									function (loaded, applicant, changeModel) {
										var changed = changeModel.a;
										var errors = changeModel.b;
										var address = changed.f1;
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$Changing(
														_Utils_update(
															changeModel,
															{
																an: 0,
																a: _Utils_update(
																	changed,
																	{
																		f1: _Utils_update(
																			address,
																			{bU: newMunicipal})
																	}),
																b: _Utils_update(
																	errors,
																	{
																		bU: A3($author$project$Applicant$Overview$validateLength, 2, 80, newMunicipal)
																	})
															})))
											});
									}));
						case 38:
							var newPhone = msg.a;
							return changeApplicant(
								F3(
									function (loaded, applicant, changeModel) {
										var changed = changeModel.a;
										var errors = changeModel.b;
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$Changing(
														_Utils_update(
															changeModel,
															{
																a: _Utils_update(
																	changed,
																	{eq: newPhone}),
																b: _Utils_update(
																	errors,
																	{
																		eq: $author$project$Applicant$Overview$validatePhone(newPhone)
																	})
															})))
											});
									}));
						case 39:
							var newEmail = msg.a;
							return changeApplicant(
								F3(
									function (loaded, applicant, changeModel) {
										var changed = changeModel.a;
										var errors = changeModel.b;
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$Changing(
														_Utils_update(
															changeModel,
															{
																a: _Utils_update(
																	changed,
																	{d5: newEmail}),
																b: _Utils_update(
																	errors,
																	{
																		d5: A2($arowM$elm_form_decoder$Form$Decoder$errors, $author$project$UI$Validation$Email$decoder, newEmail)
																	})
															})))
											});
									}));
						case 40:
							var bornOn = msg.a;
							return changeApplicant(
								F3(
									function (loaded, applicant, changeModel) {
										var changed = changeModel.a;
										var errors = changeModel.b;
										var newBornOn = $author$project$Date$DeliveryDate$fromString(bornOn);
										var ageWhenStarting = A2(
											$elm$core$Maybe$map,
											$author$project$Date$DeliveryDate$age(changed.cY.hq),
											newBornOn);
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$Changing(
														_Utils_update(
															changeModel,
															{
																c$: bornOn,
																a: _Utils_update(
																	changed,
																	{
																		c$: newBornOn,
																		gh: A2($author$project$Applicant$Applicant$updateContractType, changed.gh, ageWhenStarting)
																	}),
																b: A2($author$project$Applicant$Overview$validateBornOn, ageWhenStarting, errors)
															})))
											});
									}));
						case 41:
							var start = msg.a;
							return changeApplicant(
								F3(
									function (loaded, applicant, changeModel) {
										var changed = changeModel.a;
										var availability = changed.cY;
										var newStart = A2(
											$elm$core$Maybe$withDefault,
											availability.hq,
											$author$project$Date$DeliveryDate$fromString(start));
										var ageWhenStarting = A2(
											$elm$core$Maybe$map,
											$author$project$Date$DeliveryDate$age(newStart),
											changed.c$);
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$Changing(
														_Utils_update(
															changeModel,
															{
																a: _Utils_update(
																	changed,
																	{
																		cY: _Utils_update(
																			availability,
																			{hq: newStart}),
																		gh: A2($author$project$Applicant$Applicant$updateContractType, changed.gh, ageWhenStarting)
																	}),
																hq: start
															})))
											});
									}));
						case 42:
							var newContractType = msg.a;
							return changeApplicant(
								F3(
									function (loaded, applicant, changeModel) {
										var changed = changeModel.a;
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$Changing(
														_Utils_update(
															changeModel,
															{
																a: _Utils_update(
																	changed,
																	{gh: newContractType})
															})))
											});
									}));
						case 43:
							var newName = msg.a;
							return changeApplicant(
								F3(
									function (loaded, applicant, changeModel) {
										var changed = changeModel.a;
										var errors = changeModel.b;
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$Changing(
														_Utils_update(
															changeModel,
															{
																a: _Utils_update(
																	changed,
																	{
																		g8: $elm$core$Maybe$Just(newName)
																	}),
																b: _Utils_update(
																	errors,
																	{
																		g8: A3($author$project$Applicant$Overview$validateLength, 2, 30, newName)
																	})
															})))
											});
									}));
						case 44:
							var newEmail = msg.a;
							return changeApplicant(
								F3(
									function (loaded, applicant, changeModel) {
										var changed = changeModel.a;
										var errors = changeModel.b;
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$Changing(
														_Utils_update(
															changeModel,
															{
																a: _Utils_update(
																	changed,
																	{
																		g7: $elm$core$Maybe$Just(newEmail)
																	}),
																b: _Utils_update(
																	errors,
																	{
																		g7: A2($arowM$elm_form_decoder$Form$Decoder$errors, $author$project$UI$Validation$Email$decoder, newEmail)
																	})
															})))
											});
									}));
						case 45:
							var newBSN = msg.a;
							return changeApplicant(
								F3(
									function (loaded, applicant, editedModel) {
										var changed = editedModel.a;
										var errors = editedModel.b;
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$Changing(
														_Utils_update(
															editedModel,
															{
																a: _Utils_update(
																	changed,
																	{gd: newBSN}),
																b: _Utils_update(
																	errors,
																	{
																		gd: $author$project$Applicant$Overview$validateBSN(newBSN)
																	})
															})))
											});
									}));
						case 46:
							var kvkNumber = msg.a;
							return changeApplicant(
								F3(
									function (loaded, applicant, editedModel) {
										var changed = editedModel.a;
										var errors = editedModel.b;
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$Changing(
														_Utils_update(
															editedModel,
															{
																a: _Utils_update(
																	changed,
																	{
																		gM: $elm$core$Maybe$Just(kvkNumber)
																	}),
																b: _Utils_update(
																	errors,
																	{
																		gM: $author$project$Applicant$Overview$validateKVKNumber(kvkNumber)
																	})
															})))
											});
									}));
						case 47:
							var newVatId = msg.a;
							var vatId = $elm$core$String$toUpper(newVatId);
							var vatIdErrors = $author$project$Applicant$Overview$validateVatId(vatId);
							return changeApplicant(
								F3(
									function (loaded, applicant, editedModel) {
										var changed = editedModel.a;
										var errors = editedModel.b;
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$Changing(
														_Utils_update(
															editedModel,
															{
																a: _Utils_update(
																	changed,
																	{
																		hF: $elm$core$Maybe$Just(vatId)
																	}),
																bh: (!$elm$core$String$isEmpty(vatId)) && $elm$core$List$isEmpty(vatIdErrors),
																b: _Utils_update(
																	errors,
																	{hF: vatIdErrors})
															})))
											});
									}));
						case 48:
							var newIBAN = msg.a;
							return changeApplicant(
								F3(
									function (loaded, applicant, changeModel) {
										var changed = changeModel.a;
										var errors = changeModel.b;
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$Changing(
														_Utils_update(
															changeModel,
															{
																a: _Utils_update(
																	changed,
																	{
																		gE: $elm$core$String$toUpper(newIBAN)
																	}),
																b: _Utils_update(
																	errors,
																	{
																		gE: $author$project$Applicant$Overview$validateIBAN(newIBAN)
																	})
															})))
											});
									}));
						case 49:
							var newIdentificationType = msg.a;
							return changeApplicant(
								F3(
									function (loaded, applicant, changeModel) {
										var changed = changeModel.a;
										var nationalities = $author$project$Applicant$Applicant$availableNationalities(newIdentificationType);
										var nationality = A2($elm$core$List$member, applicant.gZ, nationalities) ? applicant.gZ : A2(
											$elm$core$Maybe$withDefault,
											$author$project$Applicant$Applicant$defaultNationality,
											$elm$core$List$head(nationalities));
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$Changing(
														_Utils_update(
															changeModel,
															{
																a: _Utils_update(
																	changed,
																	{gH: newIdentificationType, gZ: nationality})
															})))
											});
									}));
						case 50:
							var newNationality = msg.a;
							return changeApplicant(
								F3(
									function (loaded, applicant, changeModel) {
										var changed = changeModel.a;
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$Changing(
														_Utils_update(
															changeModel,
															{
																a: _Utils_update(
																	changed,
																	{gZ: newNationality})
															})))
											});
									}));
						case 51:
							var newIdentificationNumber = msg.a;
							return changeApplicant(
								F3(
									function (loaded, applicant, changeModel) {
										var changed = changeModel.a;
										var errors = changeModel.b;
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$Changing(
														_Utils_update(
															changeModel,
															{
																a: _Utils_update(
																	changed,
																	{
																		gG: $elm$core$String$toUpper(newIdentificationNumber)
																	}),
																b: _Utils_update(
																	errors,
																	{
																		gG: A3($author$project$Applicant$Overview$validateLength, 0, 30, newIdentificationNumber)
																	})
															})))
											});
									}));
						case 52:
							var expiryDate = msg.a;
							return changeApplicant(
								F3(
									function (loaded, applicant, changeModel) {
										var changed = changeModel.a;
										var errors = changeModel.b;
										var newExpiryDate = $author$project$Date$DeliveryDate$fromString(expiryDate);
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$Changing(
														_Utils_update(
															changeModel,
															{
																a: _Utils_update(
																	changed,
																	{
																		gF: $author$project$Date$DeliveryDate$fromString(expiryDate)
																	}),
																b: _Utils_update(
																	errors,
																	{
																		gF: $author$project$Applicant$Overview$validateIdentificationExpiryDate(
																			{bq: newExpiryDate, fR: changed.cY.hq, fY: today})
																	}),
																bq: expiryDate
															})))
											});
									}));
						case 25:
							var newStatus = msg.a;
							return onLoaded(
								function (loaded) {
									var selected = loaded.nI;
									_v19$2:
									while (true) {
										if (selected.$ === 1) {
											switch (selected.b.$) {
												case 2:
													var applicant = selected.a;
													var changeModel = selected.b.a;
													var changed = changeModel.a;
													return modelChange(
														$author$project$Applicant$Overview$LoadedOverview(
															_Utils_update(
																loaded,
																{
																	nI: A2(
																		$author$project$Applicant$Overview$Selected,
																		applicant,
																		$author$project$Applicant$Overview$Changing(
																			_Utils_update(
																				changeModel,
																				{
																					a: _Utils_update(
																						changed,
																						{nS: newStatus})
																				})))
																})));
												case 1:
													var applicant = selected.a;
													var statusAndDPModel = selected.b.a;
													return modelChange(
														$author$project$Applicant$Overview$LoadedOverview(
															_Utils_update(
																loaded,
																{
																	nI: A2(
																		$author$project$Applicant$Overview$Selected,
																		applicant,
																		$author$project$Applicant$Overview$UpdateStatusAndDP(
																			_Utils_update(
																				statusAndDPModel,
																				{nS: newStatus})))
																})));
												default:
													break _v19$2;
											}
										} else {
											break _v19$2;
										}
									}
									return noChange;
								});
						case 26:
							var newComment = msg.a;
							return onLoaded(
								function (loaded) {
									var selected = loaded.nI;
									_v20$2:
									while (true) {
										if (selected.$ === 1) {
											switch (selected.b.$) {
												case 2:
													var applicant = selected.a;
													var changeModel = selected.b.a;
													var changed = changeModel.a;
													return modelChange(
														$author$project$Applicant$Overview$LoadedOverview(
															_Utils_update(
																loaded,
																{
																	nI: A2(
																		$author$project$Applicant$Overview$Selected,
																		applicant,
																		$author$project$Applicant$Overview$Changing(
																			_Utils_update(
																				changeModel,
																				{
																					a: _Utils_update(
																						changed,
																						{gg: newComment})
																				})))
																})));
												case 1:
													var applicant = selected.a;
													var statusAndDPModel = selected.b.a;
													return modelChange(
														$author$project$Applicant$Overview$LoadedOverview(
															_Utils_update(
																loaded,
																{
																	nI: A2(
																		$author$project$Applicant$Overview$Selected,
																		applicant,
																		$author$project$Applicant$Overview$UpdateStatusAndDP(
																			_Utils_update(
																				statusAndDPModel,
																				{gg: newComment})))
																})));
												default:
													break _v20$2;
											}
										} else {
											break _v20$2;
										}
									}
									return noChange;
								});
						case 57:
							var name = msg.a;
							return sendingContractChange(
								F3(
									function (loaded, applicant, distributor) {
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$SendingContract(
														_Utils_update(
															distributor,
															{lI: name})))
											});
									}));
						case 58:
							var email = msg.a;
							return sendingContractChange(
								F3(
									function (loaded, applicant, distributor) {
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$SendingContract(
														_Utils_update(
															distributor,
															{lH: email})))
											});
									}));
						case 59:
							var reason = msg.a;
							return selectedChange(
								F2(
									function (loaded, applicant) {
										return _Utils_update(
											loaded,
											{
												nI: A2(
													$author$project$Applicant$Overview$Selected,
													applicant,
													$author$project$Applicant$Overview$VoidingContract(reason))
											});
									}));
						case 60:
							return onLoaded(
								function (loaded) {
									var _v21 = loaded.nI;
									if ((_v21.$ === 1) && (_v21.b.$ === 2)) {
										var applicant = _v21.a;
										var changeModel = _v21.b.a;
										var changed = changeModel.a;
										var autocomplete = changeModel.an;
										var errors = changeModel.b;
										var _v22 = _Utils_Tuple2(
											$elm$core$List$isEmpty(errors.cT) && $elm$core$List$isEmpty(errors.bs),
											autocomplete);
										if (_v22.a) {
											return A2(
												$author$project$Portal$Return$withBackgroundCommand,
												A5($author$project$Address$Address$find, token, $author$project$Applicant$Overview$BackendRespondedAddress, changed.f1.cT, changed.f1.bs, $author$project$Api$Request$Untracked),
												noChange);
										} else {
											if (_v22.b === 1) {
												var _v23 = _v22.b;
												return modelChange(
													$author$project$Applicant$Overview$LoadedOverview(
														_Utils_update(
															loaded,
															{
																nI: A2(
																	$author$project$Applicant$Overview$Selected,
																	applicant,
																	$author$project$Applicant$Overview$Changing(
																		_Utils_update(
																			changeModel,
																			{an: 0})))
															})));
											} else {
												return noChange;
											}
										}
									} else {
										return noChange;
									}
								});
						case 11:
							var dropdownMsg = msg.a;
							if (model.$ === 1) {
								var loaded = model.a;
								var selected = loaded.nI;
								_v25$2:
								while (true) {
									if (selected.$ === 1) {
										switch (selected.b.$) {
											case 2:
												var applicant = selected.a;
												var changeModel = selected.b.a;
												var dpModel = changeModel.I;
												return function (_v26) {
													var state = _v26.a;
													var cmd = _v26.b;
													return _Utils_Tuple3(
														share,
														$author$project$Applicant$Overview$LoadedOverview(
															_Utils_update(
																loaded,
																{
																	nI: A2(
																		$author$project$Applicant$Overview$Selected,
																		applicant,
																		$author$project$Applicant$Overview$Changing(
																			_Utils_update(
																				changeModel,
																				{
																					I: _Utils_update(
																						dpModel,
																						{w: state})
																				})))
																})),
														cmd);
												}(
													A4($PaackEng$elm_ui_dropdown$Dropdown$update, $author$project$Applicant$Overview$dpDDConfig, dropdownMsg, dpModel, dpModel.w));
											case 1:
												var applicant = selected.a;
												var statusAndDPModel = selected.b.a;
												var dpModel = statusAndDPModel.I;
												return function (_v27) {
													var state = _v27.a;
													var cmd = _v27.b;
													return _Utils_Tuple3(
														share,
														$author$project$Applicant$Overview$LoadedOverview(
															_Utils_update(
																loaded,
																{
																	nI: A2(
																		$author$project$Applicant$Overview$Selected,
																		applicant,
																		$author$project$Applicant$Overview$UpdateStatusAndDP(
																			_Utils_update(
																				statusAndDPModel,
																				{
																					I: _Utils_update(
																						dpModel,
																						{w: state})
																				})))
																})),
														cmd);
												}(
													A4($PaackEng$elm_ui_dropdown$Dropdown$update, $author$project$Applicant$Overview$dpDDConfig, dropdownMsg, dpModel, dpModel.w));
											default:
												break _v25$2;
										}
									} else {
										break _v25$2;
									}
								}
								return noChange;
							} else {
								return noChange;
							}
						case 53:
							var selectedDP = msg.a;
							return onLoaded(
								function (loaded) {
									var selected = loaded.nI;
									_v28$2:
									while (true) {
										if (selected.$ === 1) {
											switch (selected.b.$) {
												case 2:
													var applicant = selected.a;
													var changeModel = selected.b.a;
													var changed = changeModel.a;
													var dpModel = changeModel.I;
													if (!selectedDP.$) {
														var dp = selectedDP.a;
														return modelChange(
															$author$project$Applicant$Overview$LoadedOverview(
																_Utils_update(
																	loaded,
																	{
																		nI: A2(
																			$author$project$Applicant$Overview$Selected,
																			applicant,
																			$author$project$Applicant$Overview$Changing(
																				_Utils_update(
																					changeModel,
																					{
																						a: _Utils_update(
																							changed,
																							{c2: dp.a}),
																						I: _Utils_update(
																							dpModel,
																							{cE: selectedDP})
																					})))
																	})));
													} else {
														return modelChange(
															$author$project$Applicant$Overview$LoadedOverview(
																_Utils_update(
																	loaded,
																	{
																		nI: A2(
																			$author$project$Applicant$Overview$Selected,
																			applicant,
																			$author$project$Applicant$Overview$Changing(
																				_Utils_update(
																					changeModel,
																					{
																						I: _Utils_update(
																							dpModel,
																							{cE: selectedDP})
																					})))
																	})));
													}
												case 1:
													var applicant = selected.a;
													var statusAndDPModel = selected.b.a;
													var dpModel = statusAndDPModel.I;
													return modelChange(
														$author$project$Applicant$Overview$LoadedOverview(
															_Utils_update(
																loaded,
																{
																	nI: A2(
																		$author$project$Applicant$Overview$Selected,
																		applicant,
																		$author$project$Applicant$Overview$UpdateStatusAndDP(
																			_Utils_update(
																				statusAndDPModel,
																				{
																					I: _Utils_update(
																						dpModel,
																						{cE: selectedDP})
																				})))
																})));
												default:
													break _v28$2;
											}
										} else {
											break _v28$2;
										}
									}
									return noChange;
								});
						case 61:
							return onLoaded(
								function (loaded) {
									var _v30 = loaded.nI;
									if ((_v30.$ === 1) && (_v30.b.$ === 2)) {
										var changed = _v30.b.a.a;
										var checkVatIdRequired = _v30.b.a.bh;
										var _v31 = _Utils_Tuple2(changed.hF, checkVatIdRequired);
										if ((!_v31.a.$) && _v31.b) {
											var vatId = _v31.a.a;
											return A2(
												$author$project$Portal$Return$withBackgroundCommand,
												A4($author$project$Applicant$Applicant$checkVatId, token, $author$project$Applicant$Overview$BackendRespondedToCheckVatId, vatId, $author$project$Api$Request$Untracked),
												noChange);
										} else {
											return noChange;
										}
									} else {
										return noChange;
									}
								});
						default:
							var key = msg.a.iY;
							var value = msg.a.kt;
							var _v32 = A2($elm$json$Json$Decode$decodeString, $author$project$Applicant$Overview$decodeRememberedDpFilter, value);
							if (!_v32.$) {
								var dpFilter = _v32.a;
								switch (model.$) {
									case 0:
										return modelChange(
											$author$project$Applicant$Overview$Loading(dpFilter));
									case 1:
										var loaded = model.a;
										var filterOn = loaded.J;
										var newLoaded = $author$project$Applicant$Overview$filter(
											_Utils_update(
												loaded,
												{
													J: _Utils_update(
														filterOn,
														{w: dpFilter})
												}));
										return A2(
											withCommandIfLoadingSelected,
											newLoaded,
											modelChange(
												$author$project$Applicant$Overview$LoadedOverview(newLoaded)));
									default:
										return noChange;
								}
							} else {
								return noChange;
							}
					}
				}
				var error = msg.a.a;
				return A4(errWithId, $author$project$Applicant$Overview$validatingVatId, 0, error, $author$project$Applicant$Overview$Failed);
			}
			var id = msg.a;
			var error = msg.b.a;
			return A4(errWithId, $author$project$Applicant$Overview$sendingContract, id, error, $author$project$Applicant$Overview$Failed);
		}
	});
var $author$project$Compensation$Add$BackendRespondedCompensationCreated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Compensation$Add$CreateConfirmation = function (a) {
	return {$: 1, a: a};
};
var $author$project$Compensation$Add$GotSubHeaderMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Compensation$Add$SystemGotFormMsg = function (a) {
	return {$: 3, a: a};
};
var $arowM$elm_form_decoder$Form$Decoder$always = function (a) {
	return $arowM$elm_form_decoder$Form$Decoder$custom(
		function (_v0) {
			return $elm$core$Result$Ok(a);
		});
};
var $author$project$Compensation$Form$AmountInvalid = 5;
var $author$project$Compensation$Form$AmountRequired = 4;
var $author$project$Compensation$Form$AmountTooBig = 6;
var $author$project$Compensation$Form$AmountTooNegative = 7;
var $author$project$Compensation$Money$negate = function (_v0) {
	var m = _v0;
	return -m;
};
var $author$project$Compensation$Money$fractionParser = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		var _v0 = $elm$core$String$length(str);
		switch (_v0) {
			case 1:
				return $elm$parser$Parser$succeed(
					10 * A2(
						$elm$core$Maybe$withDefault,
						0,
						$elm$core$String$toInt(str)));
			case 2:
				return $elm$parser$Parser$succeed(
					A2(
						$elm$core$Maybe$withDefault,
						0,
						$elm$core$String$toInt(str)));
			default:
				return $elm$parser$Parser$problem('too many fractional digits');
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $author$project$Compensation$Money$unitParser = A2(
	$elm$parser$Parser$andThen,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$toInt,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$withDefault(0),
			$elm$parser$Parser$succeed)),
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $author$project$Compensation$Money$positiveParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed(
			F2(
				function (units, fractions) {
					return (units * 10000) + (fractions * 100);
				})),
		$author$project$Compensation$Money$unitParser),
	$elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$symbol(','),
								$elm$parser$Parser$symbol('.')
							]))),
				$author$project$Compensation$Money$fractionParser),
				$elm$parser$Parser$succeed(0)
			])));
var $author$project$Compensation$Money$parser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$spaces),
	$elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($author$project$Compensation$Money$negate),
					$elm$parser$Parser$symbol('-')),
				$author$project$Compensation$Money$positiveParser),
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$symbol('+')),
				$author$project$Compensation$Money$positiveParser),
				$author$project$Compensation$Money$positiveParser
			])));
var $author$project$Compensation$Money$onlyParser = A2(
	$elm$parser$Parser$keeper,
	$elm$parser$Parser$succeed($elm$core$Basics$identity),
	A2($elm$parser$Parser$ignorer, $author$project$Compensation$Money$parser, $elm$parser$Parser$end));
var $author$project$Compensation$Money$formDecoder = function (err) {
	return $arowM$elm_form_decoder$Form$Decoder$custom(
		A2(
			$elm$core$Basics$composeL,
			$elm$core$Result$mapError(
				$elm$core$Basics$always(
					_List_fromArray(
						[err]))),
			$elm$parser$Parser$run($author$project$Compensation$Money$onlyParser)));
};
var $author$project$Compensation$Compensation$maxAmount = $author$project$Compensation$Money$euro(2500);
var $author$project$Compensation$Money$maxBound = F2(
	function (err, _v0) {
		var bound = _v0;
		return $arowM$elm_form_decoder$Form$Decoder$custom(
			function (_v1) {
				var m = _v1;
				return (_Utils_cmp(m, bound) < 1) ? $elm$core$Result$Ok(0) : $elm$core$Result$Err(
					_List_fromArray(
						[err]));
			});
	});
var $author$project$Compensation$Compensation$minAmount = $author$project$Compensation$Money$negate($author$project$Compensation$Compensation$maxAmount);
var $author$project$Compensation$Money$minBound = F2(
	function (err, _v0) {
		var bound = _v0;
		return $arowM$elm_form_decoder$Form$Decoder$custom(
			function (_v1) {
				var m = _v1;
				return (_Utils_cmp(bound, m) < 1) ? $elm$core$Result$Ok(0) : $elm$core$Result$Err(
					_List_fromArray(
						[err]));
			});
	});
var $author$project$Compensation$Money$notZero = function (err) {
	return $arowM$elm_form_decoder$Form$Decoder$custom(
		function (_v0) {
			var m = _v0;
			return (!(!m)) ? $elm$core$Result$Ok(0) : $elm$core$Result$Err(
				_List_fromArray(
					[err]));
		});
};
var $arowM$elm_form_decoder$Form$Decoder$pass = F2(
	function (d, _v0) {
		var g = _v0;
		return $arowM$elm_form_decoder$Form$Decoder$custom(
			function (a) {
				var _v1 = g(a);
				if (_v1.$ === 1) {
					var err = _v1.a;
					return $elm$core$Result$Err(err);
				} else {
					var b = _v1.a;
					return A2($arowM$elm_form_decoder$Form$Decoder$run, d, b);
				}
			});
	});
var $author$project$Compensation$Form$amountFormDecoder = A2(
	$arowM$elm_form_decoder$Form$Decoder$assert,
	$author$project$Compensation$Money$notZero(4),
	A2(
		$arowM$elm_form_decoder$Form$Decoder$assert,
		A2($author$project$Compensation$Money$minBound, 7, $author$project$Compensation$Compensation$minAmount),
		A2(
			$arowM$elm_form_decoder$Form$Decoder$assert,
			A2($author$project$Compensation$Money$maxBound, 6, $author$project$Compensation$Compensation$maxAmount),
			A2(
				$arowM$elm_form_decoder$Form$Decoder$pass,
				$author$project$Compensation$Money$formDecoder(5),
				A2(
					$arowM$elm_form_decoder$Form$Decoder$assert,
					A2($arowM$elm_form_decoder$Form$Decoder$minLength, 4, 1),
					$arowM$elm_form_decoder$Form$Decoder$identity)))));
var $author$project$Compensation$Form$CompensationTypeRequired = 3;
var $author$project$Compensation$Form$compensationTypeForSegmentFormDecoder = $arowM$elm_form_decoder$Form$Decoder$custom(
	A2(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		$elm$core$Result$Err(
			_List_fromArray(
				[3])),
		$elm$core$Result$Ok));
var $author$project$Compensation$Form$DelivererRequired = 0;
var $author$project$Reference$from = function (_v0) {
	var id = _v0.eg;
	var name = _v0.ft;
	var tags = _v0.kn;
	return {eg: id, ft: name, kn: tags};
};
var $author$project$Deliverer$ReferenceDict$empty = $timo_weike$generic_collections$ManualDict$empty;
var $author$project$Deliverer$TypedDict$foldl = $timo_weike$generic_collections$ManualDict$foldl;
var $author$project$Deliverer$ReferenceDict$insert = $timo_weike$generic_collections$ManualDict$insert($author$project$Deliverer$ReferenceDict$toComparable);
var $author$project$Deliverer$Deliverer$nameView = function (deliverer) {
	return deliverer.fc + (' ' + deliverer.fo);
};
var $author$project$Deliverer$Deliverer$reference = A2(
	$elm$core$Basics$composeR,
	$author$project$Deliverer$Deliverer$fromTyped,
	function (d) {
		return A3(
			$author$project$Reference$Reference,
			d.eg,
			$author$project$Deliverer$Deliverer$nameView(d),
			d.kn);
	});
var $author$project$Deliverer$ReferenceDict$fromTypedDict = A2(
	$author$project$Deliverer$TypedDict$foldl,
	F2(
		function (deliverer, value) {
			return A2(
				$author$project$Deliverer$ReferenceDict$insert,
				$author$project$Deliverer$Deliverer$reference(deliverer),
				value);
		}),
	$author$project$Deliverer$ReferenceDict$empty);
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $timo_weike$generic_collections$ManualDict$isEmpty = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$isEmpty(dict);
};
var $author$project$Deliverer$ReferenceDict$isEmpty = $timo_weike$generic_collections$ManualDict$isEmpty;
var $timo_weike$generic_collections$ManualDict$map = F2(
	function (updateFunc, _v0) {
		var dict = _v0;
		var updater = F2(
			function (_v1, _v2) {
				var key = _v2.a;
				var value = _v2.b;
				return _Utils_Tuple2(
					key,
					A2(updateFunc, key, value));
			});
		return A2($elm$core$Dict$map, updater, dict);
	});
var $author$project$Deliverer$ReferenceDict$map = $timo_weike$generic_collections$ManualDict$map;
var $author$project$DistributionPoint$DistributionPoint$segmentInfo = function (segment) {
	if (!segment.$) {
		var info = segment.b;
		return info;
	} else {
		var info = segment.a;
		return info;
	}
};
var $author$project$Compensation$Form$deliverersDecoder = A2(
	$arowM$elm_form_decoder$Form$Decoder$assert,
	$arowM$elm_form_decoder$Form$Decoder$custom(
		function (dels) {
			return $author$project$Deliverer$ReferenceDict$isEmpty(dels) ? $elm$core$Result$Err(
				_List_fromArray(
					[0])) : $elm$core$Result$Ok(0);
		}),
	A2(
		$arowM$elm_form_decoder$Form$Decoder$field,
		A2(
			$arowM$elm_form_decoder$Form$Decoder$lift,
			function ($) {
				return $.ak;
			},
			$arowM$elm_form_decoder$Form$Decoder$identity),
		A2(
			$arowM$elm_form_decoder$Form$Decoder$field,
			A2(
				$arowM$elm_form_decoder$Form$Decoder$lift,
				function ($) {
					return $.cV;
				},
				$arowM$elm_form_decoder$Form$Decoder$identity),
			$arowM$elm_form_decoder$Form$Decoder$top(
				F2(
					function (active, selected) {
						return A2(
							$author$project$Deliverer$ReferenceDict$map,
							$elm$core$Basics$always(
								A2($elm$core$Basics$composeR, $author$project$DistributionPoint$DistributionPoint$segmentInfo, $author$project$Reference$from)),
							$author$project$Deliverer$ReferenceDict$fromTypedDict(
								A2(
									$author$project$Deliverer$TypedDict$filter,
									F2(
										function (deliverer, _v0) {
											return A2($Gizra$elm_all_set$EverySet$member, deliverer, selected);
										}),
									active)));
					})))));
var $author$project$DistributionPoint$DistributionPoint$nameOf = function (_v0) {
	var dp = _v0;
	return dp.ft;
};
var $author$project$DistributionPoint$DistributionPoint$regionOf = function (_v0) {
	var dp = _v0;
	return dp.nq;
};
var $author$project$DistributionPoint$DistributionPoint$tagsOf = function (_v0) {
	var dp = _v0;
	return dp.kn;
};
var $author$project$Compensation$Form$distributionPointReferenceDecoder = A2(
	$arowM$elm_form_decoder$Form$Decoder$field,
	A2(
		$arowM$elm_form_decoder$Form$Decoder$lift,
		function ($) {
			return $.bn;
		},
		$arowM$elm_form_decoder$Form$Decoder$identity),
	$arowM$elm_form_decoder$Form$Decoder$top(
		function (d) {
			return A4(
				$author$project$Compensation$Compensation$DistributionPoint,
				$author$project$DistributionPoint$DistributionPoint$idOf(d),
				$author$project$DistributionPoint$DistributionPoint$nameOf(d),
				$author$project$DistributionPoint$DistributionPoint$tagsOf(d),
				$author$project$DistributionPoint$DistributionPoint$regionOf(d));
		}));
var $author$project$Compensation$Form$ReasonRequired = 8;
var $author$project$Compensation$Form$ReasonTooLong = 9;
var $author$project$Compensation$Compensation$minReasonCharacters = 5;
var $author$project$Compensation$Form$reasonFormDecoder = A2(
	$arowM$elm_form_decoder$Form$Decoder$assert,
	A2($arowM$elm_form_decoder$Form$Decoder$maxLength, 9, $author$project$Compensation$Compensation$maxReasonCharacters),
	A2(
		$arowM$elm_form_decoder$Form$Decoder$assert,
		A2($arowM$elm_form_decoder$Form$Decoder$minLength, 8, $author$project$Compensation$Compensation$minReasonCharacters),
		$arowM$elm_form_decoder$Form$Decoder$identity));
var $author$project$Compensation$Form$amountOnBulkInfoDecoder = function (on) {
	return A2(
		$arowM$elm_form_decoder$Form$Decoder$field,
		$arowM$elm_form_decoder$Form$Decoder$always(_List_Nil),
		A2(
			$arowM$elm_form_decoder$Form$Decoder$field,
			$arowM$elm_form_decoder$Form$Decoder$always(0),
			A2(
				$arowM$elm_form_decoder$Form$Decoder$field,
				A2(
					$arowM$elm_form_decoder$Form$Decoder$lift,
					function ($) {
						return $.jL;
					},
					$author$project$Compensation$Form$reasonFormDecoder),
				A2(
					$arowM$elm_form_decoder$Form$Decoder$field,
					A2(
						$arowM$elm_form_decoder$Form$Decoder$lift,
						function ($) {
							return $.bc;
						},
						$author$project$Compensation$Form$compensationTypeForSegmentFormDecoder),
					A2(
						$arowM$elm_form_decoder$Form$Decoder$field,
						A2(
							$arowM$elm_form_decoder$Form$Decoder$lift,
							function ($) {
								return $.aa;
							},
							$author$project$Compensation$Form$amountFormDecoder),
						A2(
							$arowM$elm_form_decoder$Form$Decoder$field,
							$author$project$Compensation$Form$deliverersDecoder,
							A2(
								$arowM$elm_form_decoder$Form$Decoder$field,
								$arowM$elm_form_decoder$Form$Decoder$always(on),
								A2(
									$arowM$elm_form_decoder$Form$Decoder$field,
									$author$project$Compensation$Form$distributionPointReferenceDecoder,
									A2(
										$arowM$elm_form_decoder$Form$Decoder$field,
										A2(
											$arowM$elm_form_decoder$Form$Decoder$lift,
											function ($) {
												return $.ap;
											},
											$arowM$elm_form_decoder$Form$Decoder$identity),
										$arowM$elm_form_decoder$Form$Decoder$top($author$project$Compensation$Compensation$AmountOnBulkInfo))))))))));
};
var $author$project$Compensation$Form$compensationTypeForDistributionPointFormDecoder = $arowM$elm_form_decoder$Form$Decoder$custom(
	A2(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		$elm$core$Result$Err(
			_List_fromArray(
				[3])),
		$elm$core$Result$Ok));
var $author$project$Compensation$Form$delivererFormDecoder = $arowM$elm_form_decoder$Form$Decoder$custom(
	A2(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		$elm$core$Result$Err(
			_List_fromArray(
				[0])),
		$elm$core$Result$Ok));
var $author$project$Compensation$Form$delivererReferenceDecoder = A2(
	$arowM$elm_form_decoder$Form$Decoder$field,
	A2(
		$arowM$elm_form_decoder$Form$Decoder$lift,
		function ($) {
			return $.cF;
		},
		$author$project$Compensation$Form$delivererFormDecoder),
	$arowM$elm_form_decoder$Form$Decoder$top(
		function (d) {
			return A3(
				$author$project$Reference$Reference,
				$author$project$Deliverer$Deliverer$idFromTyped(d),
				$author$project$Deliverer$Deliverer$nameView(
					$author$project$Deliverer$Deliverer$fromTyped(d)),
				$author$project$Deliverer$Deliverer$fromTyped(d).kn);
		}));
var $author$project$Compensation$Form$amountOnDistributionPointInfoDecoder = function (on) {
	return A2(
		$arowM$elm_form_decoder$Form$Decoder$field,
		$arowM$elm_form_decoder$Form$Decoder$always(_List_Nil),
		A2(
			$arowM$elm_form_decoder$Form$Decoder$field,
			$arowM$elm_form_decoder$Form$Decoder$always(0),
			A2(
				$arowM$elm_form_decoder$Form$Decoder$field,
				A2(
					$arowM$elm_form_decoder$Form$Decoder$lift,
					function ($) {
						return $.jL;
					},
					$author$project$Compensation$Form$reasonFormDecoder),
				A2(
					$arowM$elm_form_decoder$Form$Decoder$field,
					A2(
						$arowM$elm_form_decoder$Form$Decoder$lift,
						function ($) {
							return $.b1;
						},
						$author$project$Compensation$Form$compensationTypeForDistributionPointFormDecoder),
					A2(
						$arowM$elm_form_decoder$Form$Decoder$field,
						A2(
							$arowM$elm_form_decoder$Form$Decoder$lift,
							function ($) {
								return $.aa;
							},
							$author$project$Compensation$Form$amountFormDecoder),
						A2(
							$arowM$elm_form_decoder$Form$Decoder$field,
							$author$project$Compensation$Form$delivererReferenceDecoder,
							A2(
								$arowM$elm_form_decoder$Form$Decoder$field,
								$arowM$elm_form_decoder$Form$Decoder$always(on),
								A2(
									$arowM$elm_form_decoder$Form$Decoder$field,
									$author$project$Compensation$Form$distributionPointReferenceDecoder,
									A2(
										$arowM$elm_form_decoder$Form$Decoder$field,
										A2(
											$arowM$elm_form_decoder$Form$Decoder$lift,
											function ($) {
												return $.ap;
											},
											$arowM$elm_form_decoder$Form$Decoder$identity),
										$arowM$elm_form_decoder$Form$Decoder$top($author$project$Compensation$Compensation$AmountOnDistributionPointInfo))))))))));
};
var $author$project$Compensation$Form$SegmentRequired = 2;
var $author$project$Compensation$Form$segmentFormDecoder = $arowM$elm_form_decoder$Form$Decoder$custom(
	A2(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		$elm$core$Result$Err(
			_List_fromArray(
				[2])),
		$elm$core$Result$Ok));
var $author$project$Compensation$Form$segmentReferenceDecoder = A2(
	$arowM$elm_form_decoder$Form$Decoder$field,
	A2(
		$arowM$elm_form_decoder$Form$Decoder$lift,
		function ($) {
			return $.eu;
		},
		$author$project$Compensation$Form$segmentFormDecoder),
	$arowM$elm_form_decoder$Form$Decoder$top(
		A2($elm$core$Basics$composeR, $author$project$DistributionPoint$DistributionPoint$segmentInfo, $author$project$Reference$from)));
var $author$project$Compensation$Form$amountOnSegmentInfoDecoder = function (on) {
	return A2(
		$arowM$elm_form_decoder$Form$Decoder$field,
		$arowM$elm_form_decoder$Form$Decoder$always(_List_Nil),
		A2(
			$arowM$elm_form_decoder$Form$Decoder$field,
			$arowM$elm_form_decoder$Form$Decoder$always(0),
			A2(
				$arowM$elm_form_decoder$Form$Decoder$field,
				A2(
					$arowM$elm_form_decoder$Form$Decoder$lift,
					function ($) {
						return $.jL;
					},
					$author$project$Compensation$Form$reasonFormDecoder),
				A2(
					$arowM$elm_form_decoder$Form$Decoder$field,
					A2(
						$arowM$elm_form_decoder$Form$Decoder$lift,
						function ($) {
							return $.bc;
						},
						$author$project$Compensation$Form$compensationTypeForSegmentFormDecoder),
					A2(
						$arowM$elm_form_decoder$Form$Decoder$field,
						A2(
							$arowM$elm_form_decoder$Form$Decoder$lift,
							function ($) {
								return $.aa;
							},
							$author$project$Compensation$Form$amountFormDecoder),
						A2(
							$arowM$elm_form_decoder$Form$Decoder$field,
							$author$project$Compensation$Form$segmentReferenceDecoder,
							A2(
								$arowM$elm_form_decoder$Form$Decoder$field,
								$author$project$Compensation$Form$delivererReferenceDecoder,
								A2(
									$arowM$elm_form_decoder$Form$Decoder$field,
									$arowM$elm_form_decoder$Form$Decoder$always(on),
									A2(
										$arowM$elm_form_decoder$Form$Decoder$field,
										$author$project$Compensation$Form$distributionPointReferenceDecoder,
										A2(
											$arowM$elm_form_decoder$Form$Decoder$field,
											A2(
												$arowM$elm_form_decoder$Form$Decoder$lift,
												function ($) {
													return $.ap;
												},
												$arowM$elm_form_decoder$Form$Decoder$identity),
											$arowM$elm_form_decoder$Form$Decoder$top($author$project$Compensation$Compensation$AmountOnSegmentInfo)))))))))));
};
var $arowM$elm_form_decoder$Form$Decoder$map = F2(
	function (f, _v0) {
		var g = _v0;
		return $arowM$elm_form_decoder$Form$Decoder$custom(
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Result$map(f),
				g));
	});
var $arowM$elm_form_decoder$Form$Decoder$with = function (f) {
	return $arowM$elm_form_decoder$Form$Decoder$custom(
		function (a) {
			return A2(
				$arowM$elm_form_decoder$Form$Decoder$run,
				f(a),
				a);
		});
};
var $author$project$Compensation$Form$decoder = function (on) {
	return $arowM$elm_form_decoder$Form$Decoder$with(
		function (form) {
			var _v0 = form.al;
			switch (_v0) {
				case 0:
					return A2(
						$arowM$elm_form_decoder$Form$Decoder$map,
						$author$project$Compensation$Compensation$AmountOnSegment,
						$author$project$Compensation$Form$amountOnSegmentInfoDecoder(on));
				case 1:
					return A2(
						$arowM$elm_form_decoder$Form$Decoder$map,
						$author$project$Compensation$Compensation$AmountOnDistributionPoint,
						$author$project$Compensation$Form$amountOnDistributionPointInfoDecoder(on));
				default:
					return A2(
						$arowM$elm_form_decoder$Form$Decoder$map,
						$author$project$Compensation$Compensation$AmountOnBulk,
						$author$project$Compensation$Form$amountOnBulkInfoDecoder(on));
			}
		});
};
var $author$project$Plan$PlanLoader$mapCommand = F2(
	function (mapper, _v0) {
		var share = _v0.a;
		var model = _v0.b;
		var cmd = _v0.c;
		return _Utils_Tuple3(
			share,
			model,
			mapper(cmd));
	});
var $author$project$Plan$PlanLoader$mapModel = F2(
	function (mapper, _v0) {
		var share = _v0.a;
		var model = _v0.b;
		var cmd = _v0.c;
		return _Utils_Tuple3(
			share,
			mapper(model),
			cmd);
	});
var $author$project$Plan$PlanLoader$registerErrorOnFailedExcept = F2(
	function (except, origin) {
		var share = origin.a;
		var model = origin.b;
		var cmd = origin.c;
		if (model.$ === 4) {
			var err = model.a;
			return _Utils_eq(err, except) ? origin : _Utils_Tuple3(
				A2($author$project$Portal$Share$withHttpError, err, share),
				model,
				cmd);
		} else {
			return origin;
		}
	});
var $elm$json$Json$Encode$dict = F3(
	function (toKey, toValue, dictionary) {
		return _Json_wrap(
			A3(
				$elm$core$Dict$foldl,
				F3(
					function (key, value, obj) {
						return A3(
							_Json_addField,
							toKey(key),
							toValue(value),
							obj);
					}),
				_Json_emptyObject(0),
				dictionary));
	});
var $author$project$Reference$encode = F2(
	function (encodeId, _v0) {
		var id = _v0.eg;
		var name = _v0.ft;
		var tags = _v0.kn;
		return $elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						encodeId(id)),
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string(name))
					]),
				$elm$core$Dict$isEmpty(tags) ? _List_Nil : _List_fromArray(
					[
						_Utils_Tuple2(
						'tags',
						A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$json$Json$Encode$string, tags))
					])));
	});
var $author$project$Compensation$Compensation$encodeDelivererWithSegment = function (_v0) {
	var deliverer = _v0.a;
	var segment = _v0.b;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'deliverer',
				A2($author$project$Reference$encode, $author$project$Deliverer$Deliverer$encodeId, deliverer)),
				_Utils_Tuple2(
				'segment',
				A2($author$project$Reference$encode, $author$project$DistributionPoint$DistributionPoint$encodeSegmentId, segment))
			]));
};
var $author$project$Compensation$Compensation$encodeDistributionPoint = function (_v0) {
	var id = _v0.eg;
	var name = _v0.ft;
	var tags = _v0.kn;
	var region = _v0.nq;
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$author$project$DistributionPoint$DistributionPoint$encodeId(id)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(name))
				]),
			_Utils_ap(
				$elm$core$Dict$isEmpty(tags) ? _List_Nil : _List_fromArray(
					[
						_Utils_Tuple2(
						'tags',
						A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$json$Json$Encode$string, tags))
					]),
				_List_fromArray(
					[
						_Utils_Tuple2(
						'region',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'number',
									$elm$json$Json$Encode$int(region.bX)),
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string(region.ft))
								])))
					]))));
};
var $author$project$Compensation$Money$encodeInEuroCent = function (_v0) {
	var m = _v0;
	return $elm$json$Json$Encode$int(
		$author$project$Compensation$Money$tenThousandthToCent(m));
};
var $author$project$Deliverer$ReferenceDict$toList = $timo_weike$generic_collections$ManualDict$toList;
var $author$project$Compensation$Compensation$encodeCompensation = function (compensation) {
	return $elm$json$Json$Encode$object(
		function () {
			switch (compensation.$) {
				case 0:
					var distributionPoint = compensation.a.bn;
					var on = compensation.a.g2;
					var deliverer = compensation.a.bl;
					var reason = compensation.a.jL;
					var amount = compensation.a.aa;
					var compensationType = compensation.a.M;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'distributionPoint',
							$author$project$Compensation$Compensation$encodeDistributionPoint(distributionPoint)),
							_Utils_Tuple2(
							'performedOn',
							$author$project$Date$DeliveryDate$encode(on)),
							_Utils_Tuple2(
							'deliverer',
							A2($author$project$Reference$encode, $author$project$Deliverer$Deliverer$encodeId, deliverer)),
							_Utils_Tuple2(
							'description',
							$elm$json$Json$Encode$string(reason)),
							_Utils_Tuple2(
							'amountInEuroCent',
							$author$project$Compensation$Money$encodeInEuroCent(amount)),
							_Utils_Tuple2(
							'code',
							$elm$json$Json$Encode$int(
								$author$project$Compensation$Type$infoOfForDistributionPoint(compensationType).ge)),
							_Utils_Tuple2(
							'elementType',
							$elm$json$Json$Encode$string('DistributionPoint'))
						]);
				case 1:
					var distributionPoint = compensation.a.bn;
					var on = compensation.a.g2;
					var deliverer = compensation.a.bl;
					var reason = compensation.a.jL;
					var amount = compensation.a.aa;
					var compensationType = compensation.a.M;
					var segment = compensation.a.fO;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'distributionPoint',
							$author$project$Compensation$Compensation$encodeDistributionPoint(distributionPoint)),
							_Utils_Tuple2(
							'performedOn',
							$author$project$Date$DeliveryDate$encode(on)),
							_Utils_Tuple2(
							'deliverer',
							A2($author$project$Reference$encode, $author$project$Deliverer$Deliverer$encodeId, deliverer)),
							_Utils_Tuple2(
							'description',
							$elm$json$Json$Encode$string(reason)),
							_Utils_Tuple2(
							'amountInEuroCent',
							$author$project$Compensation$Money$encodeInEuroCent(amount)),
							_Utils_Tuple2(
							'code',
							$elm$json$Json$Encode$int(
								$author$project$Compensation$Type$infoOfForSegment(compensationType).ge)),
							_Utils_Tuple2(
							'elementType',
							$elm$json$Json$Encode$string('Segment')),
							_Utils_Tuple2(
							'segment',
							A2($author$project$Reference$encode, $author$project$DistributionPoint$DistributionPoint$encodeSegmentId, segment))
						]);
				default:
					var distributionPoint = compensation.a.bn;
					var on = compensation.a.g2;
					var deliverers = compensation.a.e4;
					var amountForOneDeliverer = compensation.a.cW;
					var compensationType = compensation.a.M;
					var reason = compensation.a.jL;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'distributionPoint',
							$author$project$Compensation$Compensation$encodeDistributionPoint(distributionPoint)),
							_Utils_Tuple2(
							'performedOn',
							$author$project$Date$DeliveryDate$encode(on)),
							_Utils_Tuple2(
							'multi',
							A2(
								$elm$json$Json$Encode$list,
								$author$project$Compensation$Compensation$encodeDelivererWithSegment,
								$author$project$Deliverer$ReferenceDict$toList(deliverers))),
							_Utils_Tuple2(
							'description',
							$elm$json$Json$Encode$string(reason)),
							_Utils_Tuple2(
							'amountInEuroCent',
							$author$project$Compensation$Money$encodeInEuroCent(amountForOneDeliverer)),
							_Utils_Tuple2(
							'code',
							$elm$json$Json$Encode$int(
								$author$project$Compensation$Type$infoOfForSegment(compensationType).ge)),
							_Utils_Tuple2(
							'elementType',
							$elm$json$Json$Encode$string('Bulk'))
						]);
			}
		}());
};
var $author$project$Compensation$Compensation$idOf = function (compensation) {
	switch (compensation.$) {
		case 0:
			var id = compensation.a.eg;
			return id;
		case 1:
			var id = compensation.a.eg;
			return id;
		default:
			var id = compensation.a.eg;
			return id;
	}
};
var $author$project$Api$Request$patch = F6(
	function (token, toMsg, url, body, decoder, tracker) {
		return $elm$http$Http$request(
			{
				aA: body,
				aJ: A2($elm$http$Http$expectJson, toMsg, decoder),
				aK: $author$project$Api$Request$headers(token),
				aO: 'PATCH',
				aS: $elm$core$Maybe$Nothing,
				aU: $author$project$Api$Request$trackingFor(tracker),
				aW: url
			});
	});
var $author$project$Compensation$Compensation$submitCmd = F3(
	function (token, toMsg, compensation) {
		var _v0 = $author$project$Compensation$Compensation$idOf(compensation);
		if (!_v0.$) {
			var id = _v0.a;
			var uri = A2(
				$author$project$Api$Uri$for,
				_List_fromArray(
					[
						'compensations',
						$author$project$Compensation$Compensation$encodeForUrl(id)
					]),
				_List_Nil);
			return A5(
				$author$project$Api$Request$patch,
				token,
				toMsg,
				uri,
				$elm$http$Http$jsonBody(
					$author$project$Compensation$Compensation$encodeCompensation(compensation)),
				$author$project$Compensation$Compensation$decoder);
		} else {
			var uri = A2(
				$author$project$Api$Uri$for,
				_List_fromArray(
					['compensations']),
				_List_Nil);
			return A5(
				$author$project$Api$Request$post,
				token,
				toMsg,
				uri,
				$elm$http$Http$jsonBody(
					$author$project$Compensation$Compensation$encodeCompensation(compensation)),
				$author$project$Compensation$Compensation$decoder);
		}
	});
var $author$project$Compensation$Add$submittingCompensation = $author$project$Compensation$Add$singleAction('submittingCompensation');
var $author$project$Compensation$Add$toContext = function (model) {
	switch (model.$) {
		case 0:
			var distributionPointId = model.a.c2;
			var currentDate = model.a.t;
			var calendarState = model.a.r;
			return {r: calendarState, t: currentDate, c2: distributionPointId};
		case 1:
			var distributionPoint = model.a.bn;
			var currentDate = model.a.t;
			var calendarState = model.a.r;
			return {
				r: calendarState,
				t: currentDate,
				c2: $author$project$DistributionPoint$DistributionPoint$idOf(distributionPoint)
			};
		case 2:
			var distributionPointId = model.a.c2;
			var currentDate = model.a.t;
			var calendarState = model.a.r;
			return {r: calendarState, t: currentDate, c2: distributionPointId};
		default:
			var distributionPointId = model.a.c2;
			var currentDate = model.a.t;
			var calendarState = model.a.r;
			return {r: calendarState, t: currentDate, c2: distributionPointId};
	}
};
var $author$project$Compensation$Form$GotCompensationTypeForDistributionPointDropdownMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Compensation$Form$UserSelectedCompensationTypeForDistributionPointInDropdown = function (a) {
	return {$: 12, a: a};
};
var $author$project$Compensation$Form$compensationTypeForDistributionPointDDConfig = A2(
	$author$project$UI$Dropdown$config,
	_List_fromArray(
		[
			$mdgriffith$elm_ui$Element$width(
			$mdgriffith$elm_ui$Element$px(300)),
			$mdgriffith$elm_ui$Element$padding(1)
		]),
	{
		mv: $author$project$Compensation$Form$UserSelectedCompensationTypeForDistributionPointInDropdown,
		mz: A2(
			$elm$core$Basics$composeR,
			$author$project$Compensation$Type$infoOfForDistributionPoint,
			function (_v0) {
				var code = _v0.ge;
				var description = _v0.ig;
				return $elm$core$String$fromInt(code) + (' ' + description);
			}),
		mA: function (m) {
			return A2(
				$elm$core$List$filter,
				function (t) {
					return _Utils_eq(
						$author$project$Compensation$Type$infoOfForDistributionPoint(t).ae,
						m.ae);
				},
				$author$project$Compensation$Type$forDistributionPoint);
		},
		nJ: function ($) {
			return $.b1;
		},
		hz: $author$project$Compensation$Form$GotCompensationTypeForDistributionPointDropdownMsg
	});
var $author$project$Compensation$Form$GotCompensationTypeForSegmentDropdownMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Compensation$Form$UserSelectedCompensationTypeForSegmentInDropdown = function (a) {
	return {$: 10, a: a};
};
var $author$project$Compensation$Form$compensationTypeForSegmentDDConfig = A2(
	$author$project$UI$Dropdown$config,
	_List_fromArray(
		[
			$mdgriffith$elm_ui$Element$width(
			$mdgriffith$elm_ui$Element$px(300)),
			$mdgriffith$elm_ui$Element$padding(1)
		]),
	{
		mv: $author$project$Compensation$Form$UserSelectedCompensationTypeForSegmentInDropdown,
		mz: A2(
			$elm$core$Basics$composeR,
			$author$project$Compensation$Type$infoOfForSegment,
			function (_v0) {
				var code = _v0.ge;
				var description = _v0.ig;
				return $elm$core$String$fromInt(code) + (' ' + description);
			}),
		mA: function (m) {
			return A2(
				$elm$core$List$filter,
				function (t) {
					return _Utils_eq(
						$author$project$Compensation$Type$infoOfForSegment(t).ae,
						m.ae);
				},
				$author$project$Compensation$Type$forSegment);
		},
		nJ: function ($) {
			return $.bc;
		},
		hz: $author$project$Compensation$Form$GotCompensationTypeForSegmentDropdownMsg
	});
var $author$project$Compensation$Form$GotDelivererDropdownMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Compensation$Form$UserSelectedDelivererInDropdown = function (a) {
	return {$: 2, a: a};
};
var $author$project$Sorting$Deliverers$byName = function (deliverer) {
	return _Utils_Tuple2(deliverer.fo, deliverer.fc);
};
var $author$project$UI$Paradise$tagName = 'ParadiseId';
var $author$project$UI$Paradise$nameAndIdView = function (_v0) {
	var name = _v0.ft;
	var tags = _v0.kn;
	var _v1 = A2($elm$core$Dict$get, $author$project$UI$Paradise$tagName, tags);
	if (!_v1.$) {
		var pId = _v1.a;
		return name + (' (' + (pId + ')'));
	} else {
		return name;
	}
};
var $author$project$Deliverer$Deliverer$nameAndIdView = function (deliverer) {
	return $author$project$UI$Paradise$nameAndIdView(
		{
			ft: $author$project$Deliverer$Deliverer$nameView(deliverer),
			kn: deliverer.kn
		});
};
var $author$project$Compensation$Form$delivererDDConfig = A2(
	$author$project$UI$Dropdown$config,
	_List_fromArray(
		[
			$mdgriffith$elm_ui$Element$width(
			$mdgriffith$elm_ui$Element$px(300)),
			$mdgriffith$elm_ui$Element$padding(1)
		]),
	{
		mv: $author$project$Compensation$Form$UserSelectedDelivererInDropdown,
		mz: A2($elm$core$Basics$composeR, $author$project$Deliverer$Deliverer$fromTyped, $author$project$Deliverer$Deliverer$nameAndIdView),
		mA: A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.f4;
			},
			$elm$core$List$sortBy(
				A2($elm$core$Basics$composeR, $author$project$Deliverer$Deliverer$fromTyped, $author$project$Sorting$Deliverers$byName))),
		nJ: function ($) {
			return $.cF;
		},
		hz: $author$project$Compensation$Form$GotDelivererDropdownMsg
	});
var $author$project$Compensation$Form$GotSegmentDropdownMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Compensation$Form$UserSelectedSegmentInDropdown = function (a) {
	return {$: 5, a: a};
};
var $author$project$DistributionPoint$DistributionPoint$segmentsOf = function (_v0) {
	var dp = _v0;
	return dp.bb;
};
var $author$project$Compensation$Form$segmentDDConfig = A2(
	$author$project$UI$Dropdown$config,
	_List_fromArray(
		[
			$mdgriffith$elm_ui$Element$width(
			$mdgriffith$elm_ui$Element$px(300)),
			$mdgriffith$elm_ui$Element$padding(1)
		]),
	{
		mv: $author$project$Compensation$Form$UserSelectedSegmentInDropdown,
		mz: A2($elm$core$Basics$composeR, $author$project$DistributionPoint$DistributionPoint$segmentInfo, $author$project$UI$Paradise$nameAndIdView),
		mA: A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.bn;
			},
			A2(
				$elm$core$Basics$composeR,
				$author$project$DistributionPoint$DistributionPoint$segmentsOf,
				$elm$core$List$sortBy(
					A2(
						$elm$core$Basics$composeR,
						$author$project$DistributionPoint$DistributionPoint$segmentInfo,
						function ($) {
							return $.ft;
						})))),
		nJ: function ($) {
			return $.eu;
		},
		hz: $author$project$Compensation$Form$GotSegmentDropdownMsg
	});
var $author$project$Compensation$Form$update = F2(
	function (msg, model) {
		var modelChange = function (m) {
			return _Utils_Tuple2(m, $elm$core$Platform$Cmd$none);
		};
		switch (msg.$) {
			case 0:
				var selection = msg.a;
				return modelChange(
					_Utils_update(
						model,
						{al: selection}));
			case 1:
				var dropdownMsg = msg.a;
				return function (_v1) {
					var state = _v1.a;
					var cmd = _v1.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bl: state}),
						cmd);
				}(
					A4($PaackEng$elm_ui_dropdown$Dropdown$update, $author$project$Compensation$Form$delivererDDConfig, dropdownMsg, model, model.bl));
			case 2:
				var selected = msg.a;
				return modelChange(
					A2($author$project$Compensation$Form$withSelectedDeliverer, selected, model));
			case 3:
				var selected = msg.a;
				return modelChange(
					A2(
						$author$project$Compensation$Form$withSelectedSegment,
						$elm$core$Maybe$Just(selected),
						model));
			case 4:
				var dropdownMsg = msg.a;
				return function (_v2) {
					var state = _v2.a;
					var cmd = _v2.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{fO: state}),
						cmd);
				}(
					A4($PaackEng$elm_ui_dropdown$Dropdown$update, $author$project$Compensation$Form$segmentDDConfig, dropdownMsg, model, model.fO));
			case 5:
				var selected = msg.a;
				return modelChange(
					A2($author$project$Compensation$Form$withSelectedSegment, selected, model));
			case 6:
				var checked = msg.a;
				return modelChange(
					_Utils_update(
						model,
						{
							ak: checked ? $Gizra$elm_all_set$EverySet$fromList(
								$author$project$Deliverer$TypedDict$keys(model.cV)) : $Gizra$elm_all_set$EverySet$empty
						}));
			case 7:
				var deliverer = msg.a;
				var checked = msg.b;
				return modelChange(
					_Utils_update(
						model,
						{
							ak: checked ? A2($Gizra$elm_all_set$EverySet$insert, deliverer, model.ak) : A2($Gizra$elm_all_set$EverySet$remove, deliverer, model.ak)
						}));
			case 8:
				var taxInclusion = msg.a;
				return modelChange(
					function (m) {
						var _v3 = m.al;
						switch (_v3) {
							case 0:
								return _Utils_update(
									m,
									{bc: $elm$core$Maybe$Nothing});
							case 1:
								return _Utils_update(
									m,
									{b1: $elm$core$Maybe$Nothing});
							default:
								return _Utils_update(
									m,
									{bc: $elm$core$Maybe$Nothing});
						}
					}(
						_Utils_update(
							model,
							{ae: taxInclusion})));
			case 9:
				var dropdownMsg = msg.a;
				return function (_v4) {
					var state = _v4.a;
					var cmd = _v4.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{c1: state}),
						cmd);
				}(
					A4($PaackEng$elm_ui_dropdown$Dropdown$update, $author$project$Compensation$Form$compensationTypeForSegmentDDConfig, dropdownMsg, model, model.c1));
			case 10:
				var selected = msg.a;
				return modelChange(
					_Utils_update(
						model,
						{bc: selected}));
			case 11:
				var dropdownMsg = msg.a;
				return function (_v5) {
					var state = _v5.a;
					var cmd = _v5.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{dW: state}),
						cmd);
				}(
					A4($PaackEng$elm_ui_dropdown$Dropdown$update, $author$project$Compensation$Form$compensationTypeForDistributionPointDDConfig, dropdownMsg, model, model.dW));
			case 12:
				var selected = msg.a;
				return modelChange(
					_Utils_update(
						model,
						{b1: selected}));
			case 13:
				var amount = msg.a;
				return modelChange(
					_Utils_update(
						model,
						{aa: amount}));
			case 14:
				var reason = msg.a;
				return modelChange(
					A2($author$project$Compensation$Form$withReason, reason, model));
			case 15:
				var oneOrMoreDeliverers = msg.a;
				return modelChange(
					function () {
						var _v6 = _Utils_Tuple2(oneOrMoreDeliverers, model.b1);
						if (_v6.a === 1) {
							var _v7 = _v6.a;
							return _Utils_update(
								model,
								{al: 2});
						} else {
							if (!_v6.b.$) {
								var _v8 = _v6.a;
								return _Utils_update(
									model,
									{al: 1});
							} else {
								var _v9 = _v6.a;
								var _v10 = _v6.b;
								return _Utils_update(
									model,
									{al: 0});
							}
						}
					}());
			default:
				var deliverer = msg.a;
				var checked = msg.b;
				return modelChange(
					function () {
						if (checked) {
							return _Utils_update(
								model,
								{
									ak: A2($Gizra$elm_all_set$EverySet$insert, deliverer, model.ak)
								});
						} else {
							return _Utils_update(
								model,
								{
									ak: A2($Gizra$elm_all_set$EverySet$remove, deliverer, model.ak)
								});
						}
					}());
		}
	});
var $author$project$Plan$PlanLoader$Failed = function (a) {
	return {$: 4, a: a};
};
var $author$project$Plan$PlanLoader$LoadExpired = 3;
var $author$project$Plan$PlanLoader$LoadPlan = 2;
var $author$project$Plan$Plan$withItems = F2(
	function (items, plan) {
		return _Utils_update(
			plan,
			{gL: items});
	});
var $author$project$Plan$PlanLoader$addMissingDeliverersToPlan = F2(
	function (deliverers, plan) {
		var updateDeliverer = function (deliverer) {
			if (deliverer.$ === 1) {
				var id = deliverer.a;
				var _v2 = A2($author$project$Deliverer$IdDict$get, id, deliverers);
				if (!_v2.$) {
					var d = _v2.a;
					return A2(
						$author$project$Deliverer$Deliverer$Expired,
						id,
						$elm$core$Maybe$Just(
							$author$project$Deliverer$Deliverer$fromTyped(d)));
				} else {
					return A2($author$project$Deliverer$Deliverer$Expired, id, $elm$core$Maybe$Nothing);
				}
			} else {
				return deliverer;
			}
		};
		var updateItem = function (item) {
			switch (item.$) {
				case 0:
					var car = item.a;
					return $author$project$Plan$Supply$Car(
						_Utils_update(
							car,
							{
								bl: updateDeliverer(car.bl),
								n0: A2($elm$core$List$map, updateItem, car.n0)
							}));
				case 1:
					var bike = item.a;
					return $author$project$Plan$Supply$Bike(
						_Utils_update(
							bike,
							{
								bl: updateDeliverer(bike.bl)
							}));
				default:
					return item;
			}
		};
		return A2(
			$author$project$Plan$Plan$withItems,
			A2($elm$core$List$map, updateItem, plan.gL),
			plan);
	});
var $author$project$Plan$PlanLoader$LoadingExpired = function (a) {
	return {$: 2, a: a};
};
var $author$project$Plan$PlanLoader$LoadingPlan = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$PlanLoader$SystemLoadedExpired = function (a) {
	return {$: 3, a: a};
};
var $author$project$Plan$PlanLoader$SystemLoadedPlan = function (a) {
	return {$: 2, a: a};
};
var $author$project$Plan$PlanLoader$findMissingDelivererIds = function (plan) {
	return A2(
		$elm$core$List$filterMap,
		function (i) {
			var _v0 = $author$project$Plan$Supply$delivererOf(i);
			if (!_v0.$) {
				var d = _v0.a;
				if (d.$ === 1) {
					var id = d.a;
					return $elm$core$Maybe$Just(id);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		$author$project$Plan$Supply$flatten(plan.gL));
};
var $author$project$Deliverer$Deliverer$loadByIds = F3(
	function (token, toMsg, delivererIds) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['deliverers']),
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Deliverer$Deliverer$encodeIdForUrl,
					$elm$url$Url$Builder$string('id')),
				delivererIds));
		return A4(
			$author$project$Api$Request$get,
			token,
			toMsg,
			uri,
			$elm$json$Json$Decode$list($author$project$Deliverer$Deliverer$delivererDecoder));
	});
var $author$project$Plan$Plan$Plan = F9(
	function (id, version, status, nextItemId, items, preSupply, assistants, inserters, missedChange) {
		return {kT: assistants, eg: id, ms: inserters, gL: items, mI: missedChange, ei: nextItemId, ni: preSupply, nS: status, ov: version};
	});
var $author$project$Plan$Plan$Assignment = F2(
	function (id, deliverer) {
		return {bl: deliverer, eg: id};
	});
var $author$project$Plan$Plan$assignmentDecoder = F2(
	function (idDecoder, deliverers) {
		return A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'deliverer',
			A2(
				$elm$json$Json$Decode$andThen,
				function (delivererId) {
					return $elm$json$Json$Decode$succeed(
						A2(
							$elm$core$Maybe$withDefault,
							A2($author$project$Deliverer$Deliverer$Expired, delivererId, $elm$core$Maybe$Nothing),
							A2($author$project$Deliverer$IdDict$get, delivererId, deliverers)));
				},
				$author$project$Deliverer$Deliverer$idDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				idDecoder,
				$elm$json$Json$Decode$succeed($author$project$Plan$Plan$Assignment)));
	});
var $author$project$Plan$Supply$nextId = function (_v0) {
	var id = _v0;
	return id + 1;
};
var $author$project$Plan$Supply$withId = F2(
	function (id, item) {
		switch (item.$) {
			case 0:
				var car = item.a;
				return $author$project$Plan$Supply$Car(
					_Utils_update(
						car,
						{eg: id}));
			case 1:
				var bike = item.a;
				return $author$project$Plan$Supply$Bike(
					_Utils_update(
						bike,
						{eg: id}));
			default:
				var subDP = item.a;
				return $author$project$Plan$Supply$SubDistributionPoint(
					_Utils_update(
						subDP,
						{eg: id}));
		}
	});
var $author$project$Plan$Supply$withIds = function (_v0) {
	var items = _v0.a;
	var id = _v0.b;
	if (!items.b) {
		return _Utils_Tuple2(items, id);
	} else {
		var item = items.a;
		var tail = items.b;
		if (!item.$) {
			var car = item.a;
			var _v3 = $author$project$Plan$Supply$withIds(
				_Utils_Tuple2(car.n0, id));
			var supplies = _v3.a;
			var newId = _v3.b;
			return A2(
				$elm$core$Tuple$mapFirst,
				$elm$core$List$cons(
					A2(
						$author$project$Plan$Supply$withId,
						newId,
						$author$project$Plan$Supply$Car(
							_Utils_update(
								car,
								{n0: supplies})))),
				$author$project$Plan$Supply$withIds(
					_Utils_Tuple2(
						tail,
						$author$project$Plan$Supply$nextId(newId))));
		} else {
			return A2(
				$elm$core$Tuple$mapFirst,
				$elm$core$List$cons(
					A2($author$project$Plan$Supply$withId, id, item)),
				$author$project$Plan$Supply$withIds(
					_Utils_Tuple2(
						tail,
						$author$project$Plan$Supply$nextId(id))));
		}
	}
};
var $author$project$Plan$Supply$listDecoder = F2(
	function (deliverers, id) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (items) {
				return $elm$json$Json$Decode$succeed(
					$author$project$Plan$Supply$withIds(
						_Utils_Tuple2(items, id)));
			},
			$elm$json$Json$Decode$list(
				$author$project$Plan$Supply$decoder(deliverers)));
	});
var $author$project$Plan$Plan$NotPreSupplied = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$Plan$PreSupplied = function (a) {
	return {$: 0, a: a};
};
var $author$project$Plan$Plan$preSupplyDecoder = function (deliverers) {
	return A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'assignments',
		$elm$json$Json$Decode$list(
			A2($author$project$Plan$Plan$assignmentDecoder, $author$project$DistributionPoint$DistributionPoint$preSupplyIdDecoder, deliverers)),
		_List_Nil,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'enabled',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed(
				F2(
					function (enabled, assignments) {
						return enabled ? $author$project$Plan$Plan$PreSupplied(assignments) : $author$project$Plan$Plan$NotPreSupplied(assignments);
					}))));
};
var $author$project$Plan$Plan$Version = $elm$core$Basics$identity;
var $author$project$Plan$Plan$versionDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $elm$core$Basics$identity),
	$elm$json$Json$Decode$int);
var $author$project$Plan$Plan$decoder = function (deliverers) {
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'missedChange',
		$elm$json$Json$Decode$bool,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'inserting',
			$elm$json$Json$Decode$list(
				A2($author$project$Plan$Plan$assignmentDecoder, $author$project$DistributionPoint$DistributionPoint$inserterPositionIdDecoder, deliverers)),
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'assisting',
				$elm$json$Json$Decode$list(
					A2($author$project$Plan$Plan$assignmentDecoder, $author$project$DistributionPoint$DistributionPoint$assistantPositionIdDecoder, deliverers)),
				_List_Nil,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'preSupply',
					$author$project$Plan$Plan$preSupplyDecoder(deliverers),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'items',
						A2($author$project$Plan$Supply$listDecoder, deliverers, $author$project$Plan$Supply$firstId),
						_Utils_Tuple2(_List_Nil, $author$project$Plan$Supply$firstId),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'status',
							$author$project$Plan$Plan$statusDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'version',
								$author$project$Plan$Plan$versionDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'validOn',
									$author$project$Date$DeliveryDate$decoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'distributionPoint',
										$author$project$DistributionPoint$DistributionPoint$idDecoder,
										$elm$json$Json$Decode$succeed(
											F5(
												function (dpId, date, version, status, _v0) {
													var items = _v0.a;
													var nextId = _v0.b;
													return A5(
														$author$project$Plan$Plan$Plan,
														A2($author$project$Plan$Plan$Id, dpId, date),
														version,
														status,
														nextId,
														items);
												})))))))))));
};
var $author$project$Plan$Plan$subPathWithDate = F2(
	function (dpId, date) {
		return A2(
			$elm$core$List$cons,
			'distributionpoints',
			A2(
				$elm$core$List$cons,
				$author$project$DistributionPoint$DistributionPoint$encodeIdForUrl(dpId),
				A2(
					$elm$core$List$cons,
					'plans',
					_List_fromArray(
						[
							$author$project$Date$DeliveryDate$encodeForUrl(date)
						]))));
	});
var $author$project$Plan$Plan$loadCmd = F5(
	function (token, toMsg, dpId, date, deliverers) {
		var uri = A2(
			$author$project$Api$Uri$for,
			A2($author$project$Plan$Plan$subPathWithDate, dpId, date),
			_List_Nil);
		return A4(
			$author$project$Api$Request$get,
			token,
			toMsg,
			uri,
			$author$project$Plan$Plan$decoder(deliverers));
	});
var $author$project$Deliverer$Deliverer$Unregistered = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $timo_weike$generic_collections$ManualDict$union = F3(
	function (f, dict1, dict2) {
		var newDict = A2(
			$timo_weike$generic_collections$ManualDict$fromList,
			f,
			$timo_weike$generic_collections$ManualDict$toList(dict2));
		return A3(
			$timo_weike$generic_collections$ManualDict$foldl,
			$timo_weike$generic_collections$ManualDict$insert(f),
			newDict,
			dict1);
	});
var $author$project$Deliverer$IdDict$union = $timo_weike$generic_collections$ManualDict$union($author$project$Deliverer$IdDict$toComparable);
var $author$project$Plan$PlanLoader$toTypedDeliverersById = function (_v0) {
	var registered = _v0.aQ;
	var unregistered = _v0.aV;
	var expired = _v0.gw;
	var registeredById = $author$project$Deliverer$IdDict$fromList(
		A2(
			$elm$core$List$map,
			function (r) {
				return _Utils_Tuple2(
					r.eg,
					$author$project$Deliverer$Deliverer$Registered(r));
			},
			registered));
	var unregisteredToTyped = function (_v1) {
		var u = _v1.a;
		var potentials = _v1.b;
		return A2(
			$author$project$Deliverer$Deliverer$Unregistered,
			u,
			A2(
				$elm$core$List$map,
				$author$project$Deliverer$Deliverer$fromTyped,
				A2(
					$elm$core$List$filterMap,
					function (p) {
						return A2($author$project$Deliverer$IdDict$get, p, registeredById);
					},
					potentials)));
	};
	var unregisteredById = $author$project$Deliverer$IdDict$fromList(
		A2(
			$elm$core$List$map,
			function (u) {
				return _Utils_Tuple2(
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						function ($) {
							return $.eg;
						})(u),
					unregisteredToTyped(u));
			},
			unregistered));
	var expiredById = $author$project$Deliverer$IdDict$fromList(
		A2(
			$elm$core$List$map,
			function (e) {
				return _Utils_Tuple2(
					e.eg,
					A2(
						$author$project$Deliverer$Deliverer$Expired,
						e.eg,
						$elm$core$Maybe$Just(e)));
			},
			expired));
	return A2(
		$author$project$Deliverer$IdDict$union,
		expiredById,
		A2($author$project$Deliverer$IdDict$union, unregisteredById, registeredById));
};
var $author$project$Plan$PlanLoader$next = F6(
	function (convert, share, token, toAction, model, _v0) {
		var planId = _v0.a8;
		var registered = _v0.aQ;
		var unregistered = _v0.aV;
		var deliverers = _v0.e4;
		var plan = _v0.fA;
		var _v1 = _Utils_Tuple2(
			_Utils_Tuple3(registered, unregistered, deliverers),
			_Utils_Tuple2(planId, plan));
		_v1$1:
		while (true) {
			if (!_v1.b.a.$) {
				if ((!_v1.a.a.$) && (!_v1.a.b.$)) {
					var _v2 = _v1.a;
					var r = _v2.a.a;
					var u = _v2.b.a;
					var _v3 = _v1.b;
					var id = _v3.a.a;
					var deliverersTyped = $author$project$Plan$PlanLoader$toTypedDeliverersById(
						{gw: _List_Nil, aQ: r, aV: u});
					var action = A2($author$project$Plan$PlanLoader$toWaitingAction, toAction, 2);
					return _Utils_Tuple3(
						A2($author$project$Portal$Share$withWaitingAction, action, share),
						$author$project$Plan$PlanLoader$LoadingPlan(
							{e4: deliverersTyped, a8: id}),
						A6(
							$author$project$Plan$Plan$loadCmd,
							token,
							$author$project$Plan$PlanLoader$SystemLoadedPlan,
							id.gm,
							id.lx,
							deliverersTyped,
							$author$project$Plan$PlanLoader$tracked(action)));
				} else {
					if ((!_v1.a.c.$) && (!_v1.b.b.$)) {
						break _v1$1;
					} else {
						var _v7 = _v1.b;
						var id = _v7.a.a;
						return _Utils_Tuple3(
							share,
							$author$project$Plan$PlanLoader$LoadingDeliverers(
								{a8: id, aQ: registered, aV: unregistered}),
							$elm$core$Platform$Cmd$none);
					}
				}
			} else {
				if ((!_v1.a.c.$) && (!_v1.b.b.$)) {
					break _v1$1;
				} else {
					return _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
				}
			}
		}
		var _v4 = _v1.a;
		var d = _v4.c.a;
		var _v5 = _v1.b;
		var p = _v5.b.a;
		var _v6 = $author$project$Plan$PlanLoader$findMissingDelivererIds(p);
		if (!_v6.b) {
			return _Utils_Tuple3(
				share,
				$author$project$Plan$PlanLoader$Loaded(
					convert(
						{e4: d, fA: p})),
				$elm$core$Platform$Cmd$none);
		} else {
			var expiredDelivererIds = _v6;
			var action = A2($author$project$Plan$PlanLoader$toWaitingAction, toAction, 3);
			return _Utils_Tuple3(
				A2($author$project$Portal$Share$withWaitingAction, action, share),
				$author$project$Plan$PlanLoader$LoadingExpired(
					{e4: d, fA: p}),
				A4(
					$author$project$Deliverer$Deliverer$loadByIds,
					token,
					$author$project$Plan$PlanLoader$SystemLoadedExpired,
					expiredDelivererIds,
					$author$project$Plan$PlanLoader$tracked(action)));
		}
	});
var $author$project$Plan$PlanLoader$update = F6(
	function (share, token, toAction, convert, msg, model) {
		var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		var next_ = F2(
			function (action, intermediate) {
				return A6(
					$author$project$Plan$PlanLoader$next,
					convert,
					A2(
						$author$project$Portal$Share$withoutWaitingAction,
						A2($author$project$Plan$PlanLoader$toWaitingAction, toAction, action),
						share),
					token,
					toAction,
					model,
					intermediate);
			});
		var modelChange = function (m) {
			return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
		};
		var err = F2(
			function (stage, error) {
				return _Utils_Tuple3(
					A2(
						$author$project$Portal$Share$withoutWaitingAction,
						A2($author$project$Plan$PlanLoader$toWaitingAction, toAction, stage),
						share),
					$author$project$Plan$PlanLoader$Failed(error),
					$elm$core$Platform$Cmd$none);
			});
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var registered = msg.a.a;
					if (!model.$) {
						var unregistered = model.a.aV;
						var planId = model.a.a8;
						return A2(
							next_,
							0,
							{
								e4: $elm$core$Maybe$Nothing,
								fA: $elm$core$Maybe$Nothing,
								a8: $elm$core$Maybe$Just(planId),
								aQ: $elm$core$Maybe$Just(registered),
								aV: unregistered
							});
					} else {
						return noChange;
					}
				} else {
					var error = msg.a.a;
					return A2(err, 0, error);
				}
			case 1:
				if (!msg.a.$) {
					var unregistered = msg.a.a;
					if (!model.$) {
						var planId = model.a.a8;
						var registered = model.a.aQ;
						return A2(
							next_,
							1,
							{
								e4: $elm$core$Maybe$Nothing,
								fA: $elm$core$Maybe$Nothing,
								a8: $elm$core$Maybe$Just(planId),
								aQ: registered,
								aV: $elm$core$Maybe$Just(unregistered)
							});
					} else {
						return noChange;
					}
				} else {
					var error = msg.a.a;
					return A2(err, 1, error);
				}
			case 2:
				if (!msg.a.$) {
					var plan = msg.a.a;
					if (model.$ === 1) {
						var deliverers = model.a.e4;
						return A2(
							next_,
							2,
							{
								e4: $elm$core$Maybe$Just(deliverers),
								fA: $elm$core$Maybe$Just(plan),
								a8: $elm$core$Maybe$Nothing,
								aQ: $elm$core$Maybe$Nothing,
								aV: $elm$core$Maybe$Nothing
							});
					} else {
						return noChange;
					}
				} else {
					var error = msg.a.a;
					return A2(err, 2, error);
				}
			default:
				if (!msg.a.$) {
					var expired = msg.a.a;
					return A2(
						$author$project$Portal$Return$withoutAction,
						A2($author$project$Plan$PlanLoader$toWaitingAction, toAction, 3),
						function () {
							if (model.$ === 2) {
								var deliverers = model.a.e4;
								var plan = model.a.fA;
								var allDeliverers = A2(
									$author$project$Deliverer$IdDict$union,
									deliverers,
									$author$project$Plan$PlanLoader$toTypedDeliverersById(
										{gw: expired, aQ: _List_Nil, aV: _List_Nil}));
								return modelChange(
									$author$project$Plan$PlanLoader$Loaded(
										convert(
											{
												e4: allDeliverers,
												fA: A2($author$project$Plan$PlanLoader$addMissingDeliverersToPlan, allDeliverers, plan)
											})));
							} else {
								return noChange;
							}
						}());
				} else {
					var error = msg.a.a;
					return A2(err, 3, error);
				}
		}
	});
var $author$project$Portal$Subheader$FailedLoadingPlanStatuses = {$: 3};
var $author$project$Portal$Subheader$LoadedPlanStatuses = function (a) {
	return {$: 2, a: a};
};
var $author$project$Portal$Subheader$LoadingPlanStatuses = function (a) {
	return {$: 1, a: a};
};
var $author$project$Portal$Subheader$NoAction = {$: 0};
var $author$project$Portal$Subheader$Open = function (a) {
	return {$: 1, a: a};
};
var $author$project$Portal$Subheader$SystemRespondedPlanStatuses = function (a) {
	return {$: 7, a: a};
};
var $author$project$Date$Dict$empty = $timo_weike$generic_collections$ManualDict$empty;
var $author$project$Portal$Subheader$actionIdFor = function (id) {
	return A2($author$project$Portal$Waiting$Id, 'planSubHeader', id);
};
var $author$project$Portal$Subheader$singleAction = function (id) {
	return $author$project$Portal$Waiting$singleAction(
		$author$project$Portal$Subheader$actionIdFor(id));
};
var $author$project$Portal$Subheader$loadingPlanStatuses = $author$project$Portal$Subheader$singleAction('loadingPlanStatuses');
var $justinmimbs$date$Date$Days = 3;
var $author$project$Date$DeliveryDate$move = F2(
	function (date, daysToMove) {
		return $author$project$Date$DeliveryDate$fromDate(
			A3($justinmimbs$date$Date$add, 3, daysToMove, date));
	});
var $author$project$Date$DeliveryDate$nextBusinessDay = function (deliveryDate) {
	var date = $author$project$Date$DeliveryDate$toDate(deliveryDate);
	var _v0 = $justinmimbs$date$Date$weekday(date);
	if (_v0 === 5) {
		return A2($author$project$Date$DeliveryDate$move, date, 2);
	} else {
		return A2($author$project$Date$DeliveryDate$move, date, 1);
	}
};
var $author$project$Date$DeliveryDate$nextCalendarDate = function (date) {
	return A2(
		$author$project$Date$DeliveryDate$move,
		$author$project$Date$DeliveryDate$toDate(date),
		1);
};
var $author$project$Date$DeliveryDate$previousBusinessDay = function (deliveryDate) {
	var date = $author$project$Date$DeliveryDate$toDate(deliveryDate);
	var _v0 = $justinmimbs$date$Date$weekday(date);
	if (!_v0) {
		return A2($author$project$Date$DeliveryDate$move, date, -2);
	} else {
		return A2($author$project$Date$DeliveryDate$move, date, -1);
	}
};
var $author$project$Date$DeliveryDate$previousCalendarDate = function (date) {
	return A2(
		$author$project$Date$DeliveryDate$move,
		$author$project$Date$DeliveryDate$toDate(date),
		-1);
};
var $author$project$Portal$Subheader$statusesOf = function (calendarState) {
	switch (calendarState.$) {
		case 0:
			var statuses = calendarState.a.fT;
			return statuses;
		case 2:
			var statuses = calendarState.a.fT;
			return $elm$core$Maybe$Just(statuses);
		case 1:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Portal$Subheader$update = F5(
	function (msg, share, dpId, current, calendarState) {
		var withoutCalendarAction = function (_v13) {
			var s = _v13.a;
			var m = _v13.b;
			var cmd = _v13.c;
			return _Utils_Tuple2(
				$author$project$Portal$Subheader$NoAction,
				_Utils_Tuple3(s, m, cmd));
		};
		var withAction = F2(
			function (action, _v12) {
				var s = _v12.a;
				var m = _v12.b;
				var cmd = _v12.c;
				return _Utils_Tuple2(
					action,
					_Utils_Tuple3(s, m, cmd));
			});
		var token = $author$project$Portal$Share$token(share);
		var stateChange = function (c) {
			return _Utils_Tuple3(share, c, $elm$core$Platform$Cmd$none);
		};
		var toHidden = stateChange(
			$author$project$Portal$Subheader$Hidden(
				{
					fT: $author$project$Portal$Subheader$statusesOf(calendarState)
				}));
		var noChange = _Utils_Tuple3(share, calendarState, $elm$core$Platform$Cmd$none);
		var _v0 = _Utils_Tuple2(msg, calendarState);
		switch (_v0.a.$) {
			case 0:
				var week = _v0.a.a;
				if (!week) {
					return A2(
						withAction,
						$author$project$Portal$Subheader$Open(
							$author$project$Date$DeliveryDate$nextBusinessDay(current)),
						noChange);
				} else {
					return A2(
						withAction,
						$author$project$Portal$Subheader$Open(
							$author$project$Date$DeliveryDate$nextCalendarDate(current)),
						noChange);
				}
			case 1:
				var week = _v0.a.a;
				if (!week) {
					return A2(
						withAction,
						$author$project$Portal$Subheader$Open(
							$author$project$Date$DeliveryDate$previousBusinessDay(current)),
						noChange);
				} else {
					return A2(
						withAction,
						$author$project$Portal$Subheader$Open(
							$author$project$Date$DeliveryDate$previousCalendarDate(current)),
						noChange);
				}
			case 2:
				if (!_v0.b.$) {
					var _v3 = _v0.a;
					var statuses = _v0.b.a.fT;
					return withoutCalendarAction(
						function () {
							var _v4 = _Utils_Tuple2(statuses, dpId);
							if (!_v4.a.$) {
								var s = _v4.a.a;
								return stateChange(
									$author$project$Portal$Subheader$LoadedPlanStatuses(
										{
											nI: $author$project$Date$DeliveryDate$toDate(current),
											fT: s
										}));
							} else {
								if (!_v4.b.$) {
									var _v5 = _v4.a;
									var distributionPointId = _v4.b.a;
									return A3(
										$author$project$Portal$Return$withCommand,
										$author$project$Portal$Subheader$loadingPlanStatuses,
										A4(
											$author$project$Plan$Plan$loadStatusesAroundTodayCmd,
											token,
											$author$project$Portal$Subheader$SystemRespondedPlanStatuses,
											distributionPointId,
											$author$project$Portal$Share$today(share)),
										stateChange(
											$author$project$Portal$Subheader$LoadingPlanStatuses(
												{
													nI: $author$project$Date$DeliveryDate$toDate(current)
												})));
								} else {
									var _v6 = _v4.a;
									var _v7 = _v4.b;
									return stateChange(
										$author$project$Portal$Subheader$LoadedPlanStatuses(
											{
												nI: $author$project$Date$DeliveryDate$toDate(current),
												fT: $author$project$Date$Dict$empty
											}));
								}
							}
						}());
				} else {
					var _v8 = _v0.a;
					return withoutCalendarAction(toHidden);
				}
			case 3:
				switch (_v0.b.$) {
					case 1:
						var selected = _v0.a.a;
						var state = _v0.b.a;
						return withoutCalendarAction(
							stateChange(
								$author$project$Portal$Subheader$LoadingPlanStatuses(
									_Utils_update(
										state,
										{nI: selected}))));
					case 2:
						var selected = _v0.a.a;
						var state = _v0.b.a;
						return withoutCalendarAction(
							stateChange(
								$author$project$Portal$Subheader$LoadedPlanStatuses(
									_Utils_update(
										state,
										{nI: selected}))));
					default:
						return withoutCalendarAction(noChange);
				}
			case 4:
				var _v9 = _v0.a;
				return withoutCalendarAction(toHidden);
			case 5:
				var _v10 = _v0.a;
				return withoutCalendarAction(noChange);
			case 6:
				var calendarAction = _v0.a.a;
				return A2(withAction, calendarAction, noChange);
			default:
				if (!_v0.a.a.$) {
					if (_v0.b.$ === 1) {
						var statuses = _v0.a.a.a;
						var selected = _v0.b.a.nI;
						return withoutCalendarAction(
							A2(
								$author$project$Portal$Return$withoutAction,
								$author$project$Portal$Subheader$loadingPlanStatuses,
								stateChange(
									$author$project$Portal$Subheader$LoadedPlanStatuses(
										{nI: selected, fT: statuses}))));
					} else {
						var statuses = _v0.a.a.a;
						return withoutCalendarAction(
							A2(
								$author$project$Portal$Return$withoutAction,
								$author$project$Portal$Subheader$loadingPlanStatuses,
								stateChange(
									$author$project$Portal$Subheader$LoadedPlanStatuses(
										{
											nI: $author$project$Date$DeliveryDate$toDate(current),
											fT: statuses
										}))));
					}
				} else {
					var error = _v0.a.a.a;
					return withoutCalendarAction(
						function (_v11) {
							var s = _v11.a;
							var d = _v11.b;
							var cmd = _v11.c;
							return _Utils_Tuple3(
								A2(
									$author$project$Portal$Share$withHttpError,
									error,
									A2($author$project$Portal$Share$withoutWaitingAction, $author$project$Portal$Subheader$loadingPlanStatuses, s)),
								d,
								cmd);
						}(
							stateChange($author$project$Portal$Subheader$FailedLoadingPlanStatuses)));
				}
		}
	});
var $author$project$Compensation$Add$whenWaiting = function (msg) {
	switch (msg.$) {
		case 0:
			return 0;
		case 1:
			return 0;
		case 2:
			return 0;
		case 3:
			return 1;
		case 4:
			return 0;
		case 5:
			return 1;
		default:
			return 0;
	}
};
var $author$project$Compensation$Add$withCalendarState = F2(
	function (calendarState, model) {
		switch (model.$) {
			case 0:
				var loading = model.a;
				return $author$project$Compensation$Add$Loading(
					_Utils_update(
						loading,
						{r: calendarState}));
			case 1:
				var loaded = model.a;
				return $author$project$Compensation$Add$Loaded(
					_Utils_update(
						loaded,
						{r: calendarState}));
			case 2:
				var failed = model.a;
				return $author$project$Compensation$Add$NoPlan(
					_Utils_update(
						failed,
						{r: calendarState}));
			default:
				var failed = model.a;
				return $author$project$Compensation$Add$Failed(
					_Utils_update(
						failed,
						{r: calendarState}));
		}
	});
var $author$project$Compensation$Add$update = F3(
	function (msg, share, model) {
		if (A3($author$project$Portal$Share$allowed, $author$project$Compensation$Add$whenWaiting, msg, share) === 1) {
			return _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		} else {
			var token = $author$project$Portal$Share$token(share);
			var to = function (route) {
				return _Utils_Tuple3(
					A2($author$project$Portal$Share$withNewRoute, route, share),
					model,
					$elm$core$Platform$Cmd$none);
			};
			var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
			var modelChange = function (m) {
				return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
			};
			var context = $author$project$Compensation$Add$toContext(model);
			var actionKey = _Utils_Tuple2(context.c2, context.t);
			var err = F3(
				function (toAction, error, m) {
					return _Utils_Tuple3(
						A2(
							$author$project$Portal$Share$withHttpError,
							error,
							A2(
								$author$project$Portal$Share$withoutWaitingAction,
								toAction(actionKey),
								share)),
						m,
						$elm$core$Platform$Cmd$none);
				});
			var withCommand = function (toAction) {
				return $author$project$Portal$Return$withCommand(
					toAction(actionKey));
			};
			var withoutAction = function (toAction) {
				return $author$project$Portal$Return$withoutAction(
					toAction(actionKey));
			};
			switch (msg.$) {
				case 0:
					var subHeaderMsg = msg.a;
					var _v1 = A5(
						$author$project$Portal$Subheader$update,
						subHeaderMsg,
						share,
						$elm$core$Maybe$Just(context.c2),
						context.t,
						context.r);
					switch (_v1.a.$) {
						case 0:
							var _v2 = _v1.a;
							var _v3 = _v1.b;
							var s = _v3.a;
							var m = _v3.b;
							var cmd = _v3.c;
							return _Utils_Tuple3(
								s,
								A2($author$project$Compensation$Add$withCalendarState, m, model),
								A2($elm$core$Platform$Cmd$map, $author$project$Compensation$Add$GotSubHeaderMsg, cmd));
						case 1:
							var date = _v1.a.a;
							return to(
								A2($author$project$Portal$Route$CreateCompensation, context.c2, date));
						case 2:
							var date = _v1.a.a;
							return to(
								A2($author$project$Portal$Route$CreateCompensation, context.c2, date));
						default:
							return noChange;
					}
				case 1:
					if (!msg.a.$) {
						var distributionPoint = msg.a.a;
						return A2(
							withoutAction,
							$author$project$Compensation$Add$loadingDP,
							function () {
								if (!model.$) {
									var loading = model.a;
									return modelChange(
										$author$project$Compensation$Add$next(
											$author$project$Compensation$Add$Loading(
												_Utils_update(
													loading,
													{
														bn: $elm$core$Maybe$Just(distributionPoint)
													}))));
								} else {
									return noChange;
								}
							}());
					} else {
						if ((msg.a.a.$ === 3) && (msg.a.a.a === 404)) {
							var error = msg.a.a;
							return _Utils_eq(
								context.t,
								$author$project$Portal$Share$today(share)) ? A3(
								err,
								$author$project$Compensation$Add$loadingDP,
								error,
								$author$project$Compensation$Add$Failed(context)) : A2(
								$author$project$Portal$Return$withMessage,
								A2($author$project$Portal$Message$info, 'Ongeldige datum', 'Het distributiepunt is niet geldig op de gevraagde datum. We hebben je daarom naar vandaag doorgewezen.'),
								A2(
									withoutAction,
									$author$project$Compensation$Add$loadingDP,
									to(
										A2(
											$author$project$Portal$Route$CreateCompensation,
											context.c2,
											$author$project$Portal$Share$today(share)))));
						} else {
							var error = msg.a.a;
							return A3(
								err,
								$author$project$Compensation$Add$loadingDP,
								error,
								$author$project$Compensation$Add$Failed(context));
						}
					}
				case 2:
					var planLoaderMsg = msg.a;
					if (!model.$) {
						var loading = model.a;
						return A2(
							$author$project$Plan$PlanLoader$mapModel,
							function (pAndD) {
								return $author$project$Compensation$Add$next(
									$author$project$Compensation$Add$Loading(
										_Utils_update(
											loading,
											{fB: pAndD})));
							},
							A2(
								$author$project$Plan$PlanLoader$registerErrorOnFailedExcept,
								$elm$http$Http$BadStatus(404),
								A2(
									$author$project$Plan$PlanLoader$mapCommand,
									$elm$core$Platform$Cmd$map($author$project$Compensation$Add$SystemGotPlanLoaderMsg),
									A6(
										$author$project$Plan$PlanLoader$update,
										share,
										token,
										$author$project$Compensation$Add$loadingPlan(actionKey),
										$elm$core$Basics$identity,
										planLoaderMsg,
										loading.fB))));
					} else {
						return noChange;
					}
				case 3:
					var formMsg = msg.a;
					if (model.$ === 1) {
						var loaded = model.a;
						var form = loaded.bO;
						return function (_v7) {
							var f = _v7.a;
							var cmd = _v7.b;
							return A2(
								$author$project$Portal$Return$withBackgroundCommand,
								A2($elm$core$Platform$Cmd$map, $author$project$Compensation$Add$SystemGotFormMsg, cmd),
								modelChange(
									$author$project$Compensation$Add$Loaded(
										_Utils_update(
											loaded,
											{bO: f}))));
						}(
							A2($author$project$Compensation$Form$update, formMsg, form));
					} else {
						return noChange;
					}
				case 4:
					return to($author$project$Portal$Route$Compensations);
				case 5:
					if (model.$ === 1) {
						var loadedModel = model.a;
						var form = loadedModel.bO;
						var distributionPoint = loadedModel.bn;
						var deliverers = loadedModel.e4;
						var plan = loadedModel.fA;
						var currentDate = loadedModel.t;
						var _v9 = A2(
							$arowM$elm_form_decoder$Form$Decoder$run,
							$author$project$Compensation$Form$decoder(currentDate),
							form);
						if (!_v9.$) {
							var compensation = _v9.a;
							return A3(
								withCommand,
								$author$project$Compensation$Add$submittingCompensation,
								A3($author$project$Compensation$Compensation$submitCmd, token, $author$project$Compensation$Add$BackendRespondedCompensationCreated, compensation),
								modelChange(
									$author$project$Compensation$Add$Loaded(
										_Utils_update(
											loadedModel,
											{
												bO: A3($author$project$Compensation$Form$empty, distributionPoint, deliverers, plan)
											}))));
						} else {
							var validationErrors = _v9.a;
							return modelChange(
								$author$project$Compensation$Add$Loaded(
									_Utils_update(
										loadedModel,
										{
											bO: _Utils_update(
												form,
												{f_: validationErrors})
										})));
						}
					} else {
						return noChange;
					}
				default:
					if (!msg.a.$) {
						var compensation = msg.a.a;
						return A2(
							withoutAction,
							$author$project$Compensation$Add$submittingCompensation,
							function () {
								if (model.$ === 1) {
									var loadedModel = model.a;
									return modelChange(
										$author$project$Compensation$Add$Loaded(
											_Utils_update(
												loadedModel,
												{
													eW: $author$project$Compensation$Add$CreateConfirmation(compensation)
												})));
								} else {
									return noChange;
								}
							}());
					} else {
						var error = msg.a.a;
						return A3(err, $author$project$Compensation$Add$submittingCompensation, error, model);
					}
			}
		}
	});
var $author$project$Compensation$Approve$Failed = {$: 2};
var $author$project$Compensation$Approve$FocusNotOnTextFilter = 0;
var $author$project$Compensation$Approve$FocusOnTextFilter = 1;
var $author$project$Compensation$Approve$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Compensation$Approve$NotRejecting = {$: 0};
var $author$project$Compensation$Approve$Rejecting = function (a) {
	return {$: 1, a: a};
};
var $author$project$Compensation$Approve$BackendRespondedApproved = function (a) {
	return {$: 10, a: a};
};
var $author$project$Compensation$Compensation$approveCmd = F3(
	function (token, toMsg, id) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'compensations',
					$author$project$Compensation$Compensation$encodeForUrl(id),
					'approve'
				]),
			_List_Nil);
		return A5($author$project$Api$Request$post, token, toMsg, uri, $elm$http$Http$emptyBody, $author$project$Compensation$Compensation$decoder);
	});
var $author$project$Compensation$Approve$approvingCompensation = $author$project$Compensation$Approve$singleAction('approvingCompensation');
var $author$project$Compensation$Compensation$statusOf = function (compensation) {
	switch (compensation.$) {
		case 0:
			var status = compensation.a.nS;
			return status;
		case 1:
			var status = compensation.a.nS;
			return status;
		default:
			var status = compensation.a.nS;
			return status;
	}
};
var $author$project$Compensation$Approve$approve = F3(
	function (share, loaded, _v0) {
		var compensation = _v0.ao;
		return function () {
			var _v1 = _Utils_Tuple2(
				$author$project$Compensation$Compensation$idOf(compensation),
				$author$project$Compensation$Compensation$statusOf(compensation));
			if ((!_v1.a.$) && (_v1.b === 1)) {
				var id = _v1.a.a;
				var _v2 = _v1.b;
				return A2(
					$author$project$Portal$Return$withCommand,
					$author$project$Compensation$Approve$approvingCompensation,
					A3(
						$author$project$Compensation$Compensation$approveCmd,
						$author$project$Portal$Share$token(share),
						$author$project$Compensation$Approve$BackendRespondedApproved,
						id));
			} else {
				return $elm$core$Basics$identity;
			}
		}()(
			_Utils_Tuple3(
				share,
				$author$project$Compensation$Approve$Loaded(loaded),
				$elm$core$Platform$Cmd$none));
	});
var $author$project$Security$Security$ApproveCompensations = {$: 20};
var $author$project$Compensation$Approve$CanApprove = 1;
var $author$project$Compensation$Approve$CanDoNothing = 2;
var $author$project$Compensation$Approve$CanValidate = 0;
var $author$project$Security$Security$ValidateCompensations = {$: 19};
var $author$project$Compensation$Approve$can = F2(
	function (security, status) {
		var _v0 = _Utils_Tuple3(
			status,
			A2($author$project$Security$Security$can, $author$project$Security$Security$ValidateCompensations, security),
			A2($author$project$Security$Security$can, $author$project$Security$Security$ApproveCompensations, security));
		_v0$2:
		while (true) {
			switch (_v0.a) {
				case 0:
					if (_v0.b) {
						var _v1 = _v0.a;
						return 0;
					} else {
						break _v0$2;
					}
				case 1:
					if (_v0.c) {
						var _v2 = _v0.a;
						return 1;
					} else {
						break _v0$2;
					}
				default:
					break _v0$2;
			}
		}
		return 2;
	});
var $author$project$Compensation$Compensation$chronological = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.f5;
	},
	$elm$time$Time$posixToMillis);
var $author$project$Compensation$Compensation$isSubmitLogItem = function (_v0) {
	var action = _v0.dN;
	if (!action.$) {
		return true;
	} else {
		return false;
	}
};
var $elm_community$list_extra$List$Extra$last = function (items) {
	last:
	while (true) {
		if (!items.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!items.b.b) {
				var x = items.a;
				return $elm$core$Maybe$Just(x);
			} else {
				var rest = items.b;
				var $temp$items = rest;
				items = $temp$items;
				continue last;
			}
		}
	}
};
var $author$project$Compensation$Compensation$lastLogItem = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$sortBy($author$project$Compensation$Compensation$chronological),
	$elm_community$list_extra$List$Extra$last);
var $author$project$Compensation$Compensation$lastSubmitted = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$filter($author$project$Compensation$Compensation$isSubmitLogItem),
	$author$project$Compensation$Compensation$lastLogItem);
var $author$project$Compensation$Compensation$logOf = function (compensation) {
	switch (compensation.$) {
		case 0:
			var log = compensation.a.V;
			return log;
		case 1:
			var log = compensation.a.V;
			return log;
		default:
			var log = compensation.a.V;
			return log;
	}
};
var $author$project$Portal$Return$mapModel = F2(
	function (mapper, _v0) {
		var s = _v0.a;
		var m = _v0.b;
		var c = _v0.c;
		return _Utils_Tuple3(
			s,
			mapper(
				_Utils_Tuple3(s, m, c)),
			c);
	});
var $author$project$Compensation$Approve$BackendRespondedRejected = function (a) {
	return {$: 11, a: a};
};
var $author$project$Compensation$Compensation$rejectCmd = F4(
	function (token, toMsg, id, reason) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'compensations',
					$author$project$Compensation$Compensation$encodeForUrl(id),
					'reject'
				]),
			_List_Nil);
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'reason',
						$elm$json$Json$Encode$string(reason))
					])));
		return A5($author$project$Api$Request$post, token, toMsg, uri, body, $author$project$Compensation$Compensation$decoder);
	});
var $author$project$Compensation$Approve$rejectingCompensation = $author$project$Compensation$Approve$singleAction('rejectingCompensation');
var $author$project$Compensation$Approve$reject = F3(
	function (share, loaded, _v0) {
		var compensation = _v0.ao;
		var rejectState = _v0.bw;
		return function () {
			var _v1 = _Utils_Tuple3(
				$author$project$Compensation$Compensation$idOf(compensation),
				$author$project$Compensation$Compensation$statusOf(compensation),
				rejectState);
			_v1$2:
			while (true) {
				if ((!_v1.a.$) && (_v1.c.$ === 1)) {
					switch (_v1.b) {
						case 0:
							var id = _v1.a.a;
							var _v2 = _v1.b;
							var reason = _v1.c.a;
							return A2(
								$author$project$Portal$Return$withCommand,
								$author$project$Compensation$Approve$rejectingCompensation,
								A4(
									$author$project$Compensation$Compensation$rejectCmd,
									$author$project$Portal$Share$token(share),
									$author$project$Compensation$Approve$BackendRespondedRejected,
									id,
									reason));
						case 1:
							var id = _v1.a.a;
							var _v3 = _v1.b;
							var reason = _v1.c.a;
							return A2(
								$author$project$Portal$Return$withCommand,
								$author$project$Compensation$Approve$rejectingCompensation,
								A4(
									$author$project$Compensation$Compensation$rejectCmd,
									$author$project$Portal$Share$token(share),
									$author$project$Compensation$Approve$BackendRespondedRejected,
									id,
									reason));
						default:
							break _v1$2;
					}
				} else {
					break _v1$2;
				}
			}
			return $elm$core$Basics$identity;
		}()(
			_Utils_Tuple3(
				share,
				$author$project$Compensation$Approve$Loaded(loaded),
				$elm$core$Platform$Cmd$none));
	});
var $author$project$Compensation$Approve$SystemFocusedElement = function (a) {
	return {$: 13, a: a};
};
var $author$project$Compensation$Approve$rejectingNodeId = 'compensation-reject-reason';
var $author$project$Compensation$Approve$rejecting = F3(
	function (share, loaded, selected) {
		return _Utils_Tuple3(
			share,
			$author$project$Compensation$Approve$Loaded(
				_Utils_update(
					loaded,
					{
						nI: $elm$core$Maybe$Just(
							_Utils_update(
								selected,
								{
									bw: $author$project$Compensation$Approve$Rejecting('')
								}))
					})),
			A2(
				$elm$core$Task$attempt,
				$author$project$Compensation$Approve$SystemFocusedElement,
				$elm$browser$Browser$Dom$focus($author$project$Compensation$Approve$rejectingNodeId)));
	});
var $author$project$Compensation$Filter$NoAmountRestriction = {$: 0};
var $author$project$Compensation$Filter$NoTypeRestriction = {$: 0};
var $author$project$Compensation$Filter$empty = {aa: $author$project$Compensation$Filter$NoAmountRestriction, kR: _List_Nil, M: $author$project$Compensation$Filter$NoTypeRestriction};
var $author$project$Compensation$Filter$isWhitespace = function (_char) {
	return (_char === ' ') || ((_char === '\t') || ((_char === '\n') || (_char === '\u000D')));
};
var $author$project$Compensation$Filter$spaces = $elm$parser$Parser$chompWhile($author$project$Compensation$Filter$isWhitespace);
var $author$project$Compensation$Filter$AmountEqualTo = function (a) {
	return {$: 4, a: a};
};
var $author$project$Compensation$Filter$AmountAbove = function (a) {
	return {$: 1, a: a};
};
var $author$project$Compensation$Filter$AmountBetween = function (a) {
	return {$: 3, a: a};
};
var $author$project$Compensation$Money$largest = F2(
	function (_v0, _v1) {
		var _this = _v0;
		var that = _v1;
		return (_Utils_cmp(_this, that) > 0) ? _this : that;
	});
var $author$project$Compensation$Money$smallest = F2(
	function (_v0, _v1) {
		var _this = _v0;
		var that = _v1;
		return (_Utils_cmp(_this, that) < 0) ? _this : that;
	});
var $author$project$Compensation$Filter$amountBetween = F2(
	function (_this, that) {
		return _Utils_eq(_this, that) ? $author$project$Compensation$Filter$AmountEqualTo(_this) : $author$project$Compensation$Filter$AmountBetween(
			{
				eI: A2($author$project$Compensation$Money$smallest, _this, that),
				eM: A2($author$project$Compensation$Money$largest, _this, that)
			});
	});
var $author$project$Compensation$Filter$addAboveAmount = F2(
	function (above, model) {
		var amount = model.aa;
		return function (a) {
			return _Utils_update(
				model,
				{aa: a});
		}(
			function () {
				switch (amount.$) {
					case 2:
						var current = amount.a;
						return A2($author$project$Compensation$Filter$amountBetween, current, above);
					case 1:
						var current = amount.a;
						return $author$project$Compensation$Filter$AmountAbove(
							A2($author$project$Compensation$Money$largest, current, above));
					case 3:
						var current = amount.a;
						return A2(
							$author$project$Compensation$Filter$amountBetween,
							A2($author$project$Compensation$Money$largest, current.eI, above),
							current.eM);
					case 0:
						return $author$project$Compensation$Filter$AmountAbove(above);
					default:
						return amount;
				}
			}());
	});
var $author$project$Compensation$Filter$AmountBelow = function (a) {
	return {$: 2, a: a};
};
var $author$project$Compensation$Filter$addBelowAmount = F2(
	function (below, model) {
		var amount = model.aa;
		return function (a) {
			return _Utils_update(
				model,
				{aa: a});
		}(
			function () {
				switch (amount.$) {
					case 2:
						var current = amount.a;
						return $author$project$Compensation$Filter$AmountBelow(
							A2($author$project$Compensation$Money$smallest, current, below));
					case 1:
						var current = amount.a;
						return A2($author$project$Compensation$Filter$amountBetween, current, below);
					case 3:
						var current = amount.a;
						return A2(
							$author$project$Compensation$Filter$amountBetween,
							current.eI,
							A2($author$project$Compensation$Money$smallest, below, current.eM));
					case 0:
						return $author$project$Compensation$Filter$AmountBelow(below);
					default:
						return amount;
				}
			}());
	});
var $author$project$Compensation$Filter$TypeEqualToDistributionPointType = function (a) {
	return {$: 2, a: a};
};
var $author$project$Compensation$Filter$TypeEqualToSegmentType = function (a) {
	return {$: 1, a: a};
};
var $author$project$Compensation$Filter$addWord = F2(
	function (word, model) {
		var anyWords = model.kR;
		return _Utils_update(
			model,
			{
				kR: A2($elm$core$List$cons, word, anyWords)
			});
	});
var $author$project$Compensation$Filter$addCompensationCode = F2(
	function (code, model) {
		var _v0 = _Utils_Tuple2(
			$author$project$Compensation$Type$forCodeForSegment(code),
			$author$project$Compensation$Type$forCodeForDistributionPoint(code));
		if (!_v0.a.$) {
			var compensationType = _v0.a.a;
			return _Utils_update(
				model,
				{
					M: $author$project$Compensation$Filter$TypeEqualToSegmentType(compensationType)
				});
		} else {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var compensationType = _v0.b.a;
				return _Utils_update(
					model,
					{
						M: $author$project$Compensation$Filter$TypeEqualToDistributionPointType(compensationType)
					});
			} else {
				var _v2 = _v0.a;
				var _v3 = _v0.b;
				return A2(
					$author$project$Compensation$Filter$addWord,
					$elm$core$String$fromInt(code),
					model);
			}
		}
	});
var $elm$parser$Parser$Advanced$chompUntilEndOr = function (str) {
	return function (s) {
		var _v0 = A5(_Parser_findSubString, str, s.c, s.dv, s.h3, s.ka);
		var newOffset = _v0.a;
		var newRow = _v0.b;
		var newCol = _v0.c;
		var adjustedOffset = (newOffset < 0) ? $elm$core$String$length(s.ka) : newOffset;
		return A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.c, adjustedOffset) < 0,
			0,
			{h3: newCol, g: s.g, l: s.l, c: adjustedOffset, dv: newRow, ka: s.ka});
	};
};
var $elm$parser$Parser$chompUntilEndOr = $elm$parser$Parser$Advanced$chompUntilEndOr;
var $elm$parser$Parser$ExpectingInt = {$: 1};
var $elm$parser$Parser$Advanced$consumeBase = _Parser_consumeBase;
var $elm$parser$Parser$Advanced$consumeBase16 = _Parser_consumeBase16;
var $elm$parser$Parser$Advanced$bumpOffset = F2(
	function (newOffset, s) {
		return {h3: s.h3 + (newOffset - s.c), g: s.g, l: s.l, c: newOffset, dv: s.dv, ka: s.ka};
	});
var $elm$parser$Parser$Advanced$chompBase10 = _Parser_chompBase10;
var $elm$parser$Parser$Advanced$isAsciiCode = _Parser_isAsciiCode;
var $elm$parser$Parser$Advanced$consumeExp = F2(
	function (offset, src) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 101, offset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 69, offset, src)) {
			var eOffset = offset + 1;
			var expOffset = (A3($elm$parser$Parser$Advanced$isAsciiCode, 43, eOffset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 45, eOffset, src)) ? (eOffset + 1) : eOffset;
			var newOffset = A2($elm$parser$Parser$Advanced$chompBase10, expOffset, src);
			return _Utils_eq(expOffset, newOffset) ? (-newOffset) : newOffset;
		} else {
			return offset;
		}
	});
var $elm$parser$Parser$Advanced$consumeDotAndExp = F2(
	function (offset, src) {
		return A3($elm$parser$Parser$Advanced$isAsciiCode, 46, offset, src) ? A2(
			$elm$parser$Parser$Advanced$consumeExp,
			A2($elm$parser$Parser$Advanced$chompBase10, offset + 1, src),
			src) : A2($elm$parser$Parser$Advanced$consumeExp, offset, src);
	});
var $elm$parser$Parser$Advanced$finalizeInt = F5(
	function (invalid, handler, startOffset, _v0, s) {
		var endOffset = _v0.a;
		var n = _v0.b;
		if (handler.$ === 1) {
			var x = handler.a;
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		} else {
			var toValue = handler.a;
			return _Utils_eq(startOffset, endOffset) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				_Utils_cmp(s.c, startOffset) < 0,
				A2($elm$parser$Parser$Advanced$fromState, s, invalid)) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				toValue(n),
				A2($elm$parser$Parser$Advanced$bumpOffset, endOffset, s));
		}
	});
var $elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
	});
var $elm$parser$Parser$Advanced$finalizeFloat = F6(
	function (invalid, expecting, intSettings, floatSettings, intPair, s) {
		var intOffset = intPair.a;
		var floatOffset = A2($elm$parser$Parser$Advanced$consumeDotAndExp, intOffset, s.ka);
		if (floatOffset < 0) {
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A4($elm$parser$Parser$Advanced$fromInfo, s.dv, s.h3 - (floatOffset + s.c), invalid, s.g));
		} else {
			if (_Utils_eq(s.c, floatOffset)) {
				return A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, expecting));
			} else {
				if (_Utils_eq(intOffset, floatOffset)) {
					return A5($elm$parser$Parser$Advanced$finalizeInt, invalid, intSettings, s.c, intPair, s);
				} else {
					if (floatSettings.$ === 1) {
						var x = floatSettings.a;
						return A2(
							$elm$parser$Parser$Advanced$Bad,
							true,
							A2($elm$parser$Parser$Advanced$fromState, s, invalid));
					} else {
						var toValue = floatSettings.a;
						var _v1 = $elm$core$String$toFloat(
							A3($elm$core$String$slice, s.c, floatOffset, s.ka));
						if (_v1.$ === 1) {
							return A2(
								$elm$parser$Parser$Advanced$Bad,
								true,
								A2($elm$parser$Parser$Advanced$fromState, s, invalid));
						} else {
							var n = _v1.a;
							return A3(
								$elm$parser$Parser$Advanced$Good,
								true,
								toValue(n),
								A2($elm$parser$Parser$Advanced$bumpOffset, floatOffset, s));
						}
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$number = function (c) {
	return function (s) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 48, s.c, s.ka)) {
			var zeroOffset = s.c + 1;
			var baseOffset = zeroOffset + 1;
			return A3($elm$parser$Parser$Advanced$isAsciiCode, 120, zeroOffset, s.ka) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.mt,
				c.ma,
				baseOffset,
				A2($elm$parser$Parser$Advanced$consumeBase16, baseOffset, s.ka),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 111, zeroOffset, s.ka) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.mt,
				c.jo,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 8, baseOffset, s.ka),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 98, zeroOffset, s.ka) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.mt,
				c.h_,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 2, baseOffset, s.ka),
				s) : A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.mt,
				c.iB,
				c.iV,
				c.iD,
				_Utils_Tuple2(zeroOffset, 0),
				s)));
		} else {
			return A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.mt,
				c.iB,
				c.iV,
				c.iD,
				A3($elm$parser$Parser$Advanced$consumeBase, 10, s.c, s.ka),
				s);
		}
	};
};
var $elm$parser$Parser$Advanced$int = F2(
	function (expecting, invalid) {
		return $elm$parser$Parser$Advanced$number(
			{
				h_: $elm$core$Result$Err(invalid),
				iB: expecting,
				iD: $elm$core$Result$Err(invalid),
				ma: $elm$core$Result$Err(invalid),
				iV: $elm$core$Result$Ok($elm$core$Basics$identity),
				mt: invalid,
				jo: $elm$core$Result$Err(invalid)
			});
	});
var $elm$parser$Parser$int = A2($elm$parser$Parser$Advanced$int, $elm$parser$Parser$ExpectingInt, $elm$parser$Parser$ExpectingInt);
var $author$project$Compensation$Filter$words = A2(
	$elm$parser$Parser$loop,
	$author$project$Compensation$Filter$empty,
	function (model) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					$elm$parser$Parser$succeed(
						function (code) {
							return $elm$parser$Parser$Loop(
								A2($author$project$Compensation$Filter$addCompensationCode, code, model));
						}),
					A2($elm$parser$Parser$ignorer, $elm$parser$Parser$int, $author$project$Compensation$Filter$spaces)),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(
							function (amount) {
								return $elm$parser$Parser$Loop(
									_Utils_update(
										model,
										{
											aa: $author$project$Compensation$Filter$AmountEqualTo(amount)
										}));
							}),
						$elm$parser$Parser$token('=')),
					A2($elm$parser$Parser$ignorer, $author$project$Compensation$Money$parser, $author$project$Compensation$Filter$spaces)),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(
							function (amount) {
								return $elm$parser$Parser$Loop(
									A2($author$project$Compensation$Filter$addAboveAmount, amount, model));
							}),
						$elm$parser$Parser$token('>')),
					A2($elm$parser$Parser$ignorer, $author$project$Compensation$Money$parser, $author$project$Compensation$Filter$spaces)),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(
							function (amount) {
								return $elm$parser$Parser$Loop(
									A2($author$project$Compensation$Filter$addBelowAmount, amount, model));
							}),
						$elm$parser$Parser$token('<')),
					A2($elm$parser$Parser$ignorer, $author$project$Compensation$Money$parser, $author$project$Compensation$Filter$spaces)),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(
							function (word) {
								return $elm$parser$Parser$Loop(
									A2($author$project$Compensation$Filter$addWord, word, model));
							}),
						$elm$parser$Parser$token('\"')),
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$getChompedString(
							$elm$parser$Parser$chompUntilEndOr('\"')),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$end,
									A2(
									$elm$parser$Parser$ignorer,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(0),
										$elm$parser$Parser$token('\"')),
									$author$project$Compensation$Filter$spaces)
								])))),
					A2(
					$elm$parser$Parser$keeper,
					$elm$parser$Parser$succeed(
						function (word) {
							return $elm$parser$Parser$Loop(
								A2($author$project$Compensation$Filter$addWord, word, model));
						}),
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$getChompedString(
							A2(
								$elm$parser$Parser$ignorer,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed(0),
									$elm$parser$Parser$chompIf(
										function (c) {
											return (!$author$project$Compensation$Filter$isWhitespace(c)) && (c !== '\"');
										})),
								$elm$parser$Parser$chompWhile(
									function (c) {
										return (!$author$project$Compensation$Filter$isWhitespace(c)) && (c !== '\"');
									}))),
						$author$project$Compensation$Filter$spaces)),
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return $elm$parser$Parser$Done(
							_Utils_update(
								model,
								{
									kR: $elm$core$List$reverse(model.kR)
								}));
					},
					$elm$parser$Parser$end)
				]));
	});
var $author$project$Compensation$Filter$paddedWords = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$author$project$Compensation$Filter$spaces),
	$author$project$Compensation$Filter$words);
var $elm$core$String$words = _String_words;
var $author$project$Compensation$Filter$from = function (text) {
	var _v0 = A2($elm$parser$Parser$run, $author$project$Compensation$Filter$paddedWords, text);
	if (!_v0.$) {
		var ws = _v0.a;
		return ws;
	} else {
		return _Utils_update(
			$author$project$Compensation$Filter$empty,
			{
				kR: $elm$core$String$words(text)
			});
	}
};
var $author$project$Deliverer$ReferenceDict$any = F2(
	function (f, dict) {
		return A2(
			$elm$core$List$any,
			function (_v0) {
				var k = _v0.a;
				var v = _v0.b;
				return A2(f, k, v);
			},
			$author$project$Deliverer$ReferenceDict$toList(dict));
	});
var $elm_community$dict_extra$Dict$Extra$any = F2(
	function (predicate, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, acc) {
					return acc ? acc : (A2(predicate, k, v) ? true : false);
				}),
			false,
			dict);
	});
var $author$project$Reference$hasText = F2(
	function (text, _v0) {
		var name = _v0.ft;
		var tags = _v0.kn;
		var lowered = $elm$core$String$toLower(text);
		return A2(
			$elm$core$String$contains,
			lowered,
			$elm$core$String$toLower(name)) || A2(
			$elm_community$dict_extra$Dict$Extra$any,
			F2(
				function (_v1, value) {
					return A2(
						$elm$core$String$contains,
						lowered,
						$elm$core$String$toLower(value));
				}),
			tags);
	});
var $author$project$Compensation$Compensation$userOf = function (action) {
	switch (action.$) {
		case 0:
			var user = action.a;
			return $elm$core$Maybe$Just(user);
		case 1:
			var user = action.a;
			return $elm$core$Maybe$Just(user);
		case 2:
			return $elm$core$Maybe$Nothing;
		case 3:
			var user = action.a;
			return $elm$core$Maybe$Just(user);
		default:
			var user = action.a;
			return $elm$core$Maybe$Just(user);
	}
};
var $author$project$Compensation$Compensation$submitterHasText = F2(
	function (text, log) {
		var lowered = $elm$core$String$toLower(text);
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			false,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.ft;
				},
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$toLower,
					$elm$core$String$contains(lowered))),
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.dN;
					},
					$author$project$Compensation$Compensation$userOf),
				$author$project$Compensation$Compensation$lastSubmitted(log)));
	});
var $author$project$Compensation$Compensation$hasText = F2(
	function (text, compensation) {
		switch (compensation.$) {
			case 0:
				var deliverer = compensation.a.bl;
				var distributionPoint = compensation.a.bn;
				var log = compensation.a.V;
				return A2($author$project$Reference$hasText, text, deliverer) || (A2($author$project$Reference$hasText, text, distributionPoint) || A2($author$project$Compensation$Compensation$submitterHasText, text, log));
			case 1:
				var deliverer = compensation.a.bl;
				var distributionPoint = compensation.a.bn;
				var segment = compensation.a.fO;
				var log = compensation.a.V;
				return A2($author$project$Reference$hasText, text, deliverer) || (A2($author$project$Reference$hasText, text, distributionPoint) || (A2($author$project$Reference$hasText, text, segment) || A2($author$project$Compensation$Compensation$submitterHasText, text, log)));
			default:
				var distributionPoint = compensation.a.bn;
				var deliverers = compensation.a.e4;
				var log = compensation.a.V;
				return A2($author$project$Reference$hasText, text, distributionPoint) || (A2(
					$author$project$Deliverer$ReferenceDict$any,
					F2(
						function (deliverer, segment) {
							return A2($author$project$Reference$hasText, text, deliverer) || A2($author$project$Reference$hasText, text, segment);
						}),
					deliverers) || A2($author$project$Compensation$Compensation$submitterHasText, text, log));
		}
	});
var $author$project$Compensation$Compensation$hasAnyWord = F2(
	function (words, compensation) {
		if (!words.b) {
			return true;
		} else {
			return A2(
				$elm$core$List$any,
				function (word) {
					return A2($author$project$Compensation$Compensation$hasText, word, compensation);
				},
				words);
		}
	});
var $author$project$Compensation$Compensation$hasType = F2(
	function (typeFilter, compensation) {
		var _v0 = _Utils_Tuple2(typeFilter, compensation);
		_v0$4:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					var _v1 = _v0.a;
					return true;
				case 1:
					switch (_v0.b.$) {
						case 1:
							var expected = _v0.a.a;
							var compensationType = _v0.b.a.M;
							return _Utils_eq(expected, compensationType);
						case 2:
							var expected = _v0.a.a;
							var compensationType = _v0.b.a.M;
							return _Utils_eq(expected, compensationType);
						default:
							break _v0$4;
					}
				default:
					if (!_v0.b.$) {
						var expected = _v0.a.a;
						var compensationType = _v0.b.a.M;
						return _Utils_eq(expected, compensationType);
					} else {
						break _v0$4;
					}
			}
		}
		return false;
	});
var $author$project$Compensation$Filter$onAmount = F2(
	function (amountFilter, amount) {
		switch (amountFilter.$) {
			case 0:
				return true;
			case 1:
				var above = amountFilter.a;
				return _Utils_eq(
					A2($author$project$Compensation$Money$smallest, above, amount),
					above);
			case 2:
				var below = amountFilter.a;
				return _Utils_eq(
					A2($author$project$Compensation$Money$largest, amount, below),
					below);
			case 3:
				var above = amountFilter.a.eI;
				var below = amountFilter.a.eM;
				return _Utils_eq(
					A2($author$project$Compensation$Money$smallest, above, amount),
					above) && _Utils_eq(
					A2($author$project$Compensation$Money$largest, amount, below),
					below);
			default:
				var equalTo = amountFilter.a;
				return _Utils_eq(amount, equalTo);
		}
	});
var $author$project$Compensation$Compensation$onFilter = F2(
	function (_v0, compensation) {
		var anyWords = _v0.kR;
		var amount = _v0.aa;
		var compensationType = _v0.M;
		var amountInCompensation = function () {
			switch (compensation.$) {
				case 0:
					var info = compensation.a;
					return info.aa;
				case 1:
					var info = compensation.a;
					return info.aa;
				default:
					var amountForOneDeliverer = compensation.a.cW;
					return amountForOneDeliverer;
			}
		}();
		return A2($author$project$Compensation$Filter$onAmount, amount, amountInCompensation) && (A2($author$project$Compensation$Compensation$hasType, compensationType, compensation) && A2($author$project$Compensation$Compensation$hasAnyWord, anyWords, compensation));
	});
var $author$project$Compensation$Compensation$filter = F2(
	function (filterString, compensations) {
		if (filterString === '') {
			return compensations;
		} else {
			return function (f) {
				return A2(
					$elm$core$List$filter,
					$author$project$Compensation$Compensation$onFilter(f),
					compensations);
			}(
				$author$project$Compensation$Filter$from(filterString));
		}
	});
var $author$project$Compensation$Compensation$updatedFilter = F3(
	function (allCompensations, textFilter, filtered) {
		var on = filtered.g2;
		return _Utils_update(
			filtered,
			{
				aD: A2($author$project$Compensation$Compensation$filter, textFilter, allCompensations),
				g2: textFilter
			});
	});
var $author$project$Compensation$Approve$withCompensations = F2(
	function (compensations, loaded) {
		var filtered = loaded.eb;
		return _Utils_update(
			loaded,
			{
				aD: compensations,
				eb: A3($author$project$Compensation$Compensation$updatedFilter, compensations, filtered.g2, filtered)
			});
	});
var $author$project$Compensation$Approve$replace = F2(
	function (compensation, loaded) {
		var compensations = loaded.aD;
		return A2(
			$author$project$Compensation$Approve$withCompensations,
			A3(
				$elm_community$list_extra$List$Extra$setIf,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Compensation$Compensation$idOf,
					$elm$core$Basics$eq(
						$author$project$Compensation$Compensation$idOf(compensation))),
				compensation,
				compensations),
			loaded);
	});
var $author$project$Compensation$Approve$SystemScrolledSelectedCardElementIntoView = function (a) {
	return {$: 14, a: a};
};
var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
var $elm$browser$Browser$Dom$getViewportOf = _Browser_getViewportOf;
var $elm$core$Task$map3 = F4(
	function (func, taskA, taskB, taskC) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return A2(
							$elm$core$Task$andThen,
							function (c) {
								return $elm$core$Task$succeed(
									A3(func, a, b, c));
							},
							taskC);
					},
					taskB);
			},
			taskA);
	});
var $author$project$Compensation$Compensation$selectedCardNodeId = 'compensation-card-selected';
var $elm$browser$Browser$Dom$setViewportOf = _Browser_setViewportOf;
var $author$project$Compensation$Approve$todoColumnNodeId = 'compensation-todo';
var $author$project$Compensation$Approve$scrollSelectedCardIntoView = A2(
	$elm$core$Task$andThen,
	A2(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		$elm$core$Task$succeed(0),
		A2($elm$browser$Browser$Dom$setViewportOf, $author$project$Compensation$Approve$todoColumnNodeId, 0)),
	A4(
		$elm$core$Task$map3,
		F3(
			function (parent, selectedCard, viewport) {
				var padding = 15;
				return (_Utils_cmp(selectedCard.as.bg, parent.as.bg) < 0) ? $elm$core$Maybe$Just(((viewport.kx.bg + selectedCard.as.bg) - parent.as.bg) - padding) : ((_Utils_cmp(selectedCard.as.bg + selectedCard.as.iK, parent.as.bg + parent.as.iK) > 0) ? $elm$core$Maybe$Just(((((viewport.kx.bg + selectedCard.as.bg) + selectedCard.as.iK) - parent.as.bg) - parent.as.iK) + padding) : $elm$core$Maybe$Nothing);
			}),
		$elm$browser$Browser$Dom$getElement($author$project$Compensation$Approve$todoColumnNodeId),
		$elm$browser$Browser$Dom$getElement($author$project$Compensation$Compensation$selectedCardNodeId),
		$elm$browser$Browser$Dom$getViewportOf($author$project$Compensation$Approve$todoColumnNodeId)));
var $author$project$Compensation$Approve$withSelected = F2(
	function (selected, loaded) {
		return _Utils_Tuple2(
			$author$project$Compensation$Approve$Loaded(
				_Utils_update(
					loaded,
					{
						nI: A2(
							$elm$core$Maybe$map,
							function (c) {
								return {ao: c, bw: $author$project$Compensation$Approve$NotRejecting};
							},
							selected)
					})),
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				$elm$core$Platform$Cmd$none,
				$elm$core$Basics$always(
					A2($elm$core$Task$attempt, $author$project$Compensation$Approve$SystemScrolledSelectedCardElementIntoView, $author$project$Compensation$Approve$scrollSelectedCardIntoView)),
				selected));
	});
var $author$project$Compensation$Approve$selectNext = function (loadedModel) {
	var filtered = loadedModel.eb;
	var selected = loadedModel.nI;
	var compensations = filtered.aD;
	if (selected.$ === 1) {
		return A2(
			$author$project$Compensation$Approve$withSelected,
			$elm$core$List$head(compensations),
			loadedModel);
	} else {
		var id = A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.ao;
				},
				$author$project$Compensation$Compensation$idOf),
			selected);
		return function (c) {
			return A2($author$project$Compensation$Approve$withSelected, c, loadedModel);
		}(
			A3(
				$elm$core$List$foldl,
				F2(
					function (c, _v1) {
						var take = _v1.a;
						var cumm = _v1.b;
						return take ? _Utils_Tuple2(
							false,
							$elm$core$Maybe$Just(c)) : _Utils_Tuple2(
							_Utils_eq(
								$author$project$Compensation$Compensation$idOf(c),
								id),
							cumm);
					}),
				_Utils_Tuple2(false, $elm$core$Maybe$Nothing),
				compensations).b);
	}
};
var $author$project$Compensation$Approve$selectPrevious = function (loadedModel) {
	var filtered = loadedModel.eb;
	var selected = loadedModel.nI;
	var compensations = filtered.aD;
	if (selected.$ === 1) {
		return A2(
			$author$project$Compensation$Approve$withSelected,
			$elm_community$list_extra$List$Extra$last(compensations),
			loadedModel);
	} else {
		var id = A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.ao;
				},
				$author$project$Compensation$Compensation$idOf),
			selected);
		return function (c) {
			return A2($author$project$Compensation$Approve$withSelected, c, loadedModel);
		}(
			A3(
				$elm$core$List$foldr,
				F2(
					function (c, _v1) {
						var take = _v1.a;
						var cumm = _v1.b;
						return take ? _Utils_Tuple2(
							false,
							$elm$core$Maybe$Just(c)) : _Utils_Tuple2(
							_Utils_eq(
								$author$project$Compensation$Compensation$idOf(c),
								id),
							cumm);
					}),
				_Utils_Tuple2(false, $elm$core$Maybe$Nothing),
				compensations).b);
	}
};
var $author$project$Compensation$Approve$unselectWhenFilteredOut = function (_v0) {
	var model = _v0.b;
	if (model.$ === 1) {
		var loaded = model.a;
		var selected = loaded.nI;
		var filtered = loaded.eb;
		return $author$project$Compensation$Approve$Loaded(
			function () {
				if (!selected.$) {
					var s = selected.a;
					return A2($elm$core$List$member, s.ao, filtered.aD) ? loaded : _Utils_update(
						loaded,
						{nI: $elm$core$Maybe$Nothing});
				} else {
					return loaded;
				}
			}());
	} else {
		return model;
	}
};
var $author$project$Compensation$Approve$BackendRespondedValidated = function (a) {
	return {$: 9, a: a};
};
var $author$project$Compensation$Compensation$validateCmd = F3(
	function (token, toMsg, id) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'compensations',
					$author$project$Compensation$Compensation$encodeForUrl(id),
					'validate'
				]),
			_List_Nil);
		return A5($author$project$Api$Request$post, token, toMsg, uri, $elm$http$Http$emptyBody, $author$project$Compensation$Compensation$decoder);
	});
var $author$project$Compensation$Approve$validatingCompensation = $author$project$Compensation$Approve$singleAction('validatingCompensations');
var $author$project$Compensation$Approve$validate = F3(
	function (share, loaded, _v0) {
		var compensation = _v0.ao;
		return function () {
			var _v1 = _Utils_Tuple2(
				$author$project$Compensation$Compensation$idOf(compensation),
				$author$project$Compensation$Compensation$statusOf(compensation));
			if ((!_v1.a.$) && (!_v1.b)) {
				var id = _v1.a.a;
				var _v2 = _v1.b;
				return A2(
					$author$project$Portal$Return$withCommand,
					$author$project$Compensation$Approve$validatingCompensation,
					A3(
						$author$project$Compensation$Compensation$validateCmd,
						$author$project$Portal$Share$token(share),
						$author$project$Compensation$Approve$BackendRespondedValidated,
						id));
			} else {
				return $elm$core$Basics$identity;
			}
		}()(
			_Utils_Tuple3(
				share,
				$author$project$Compensation$Approve$Loaded(loaded),
				$elm$core$Platform$Cmd$none));
	});
var $author$project$Compensation$Approve$whenWaiting = function (msg) {
	switch (msg.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 1;
		case 3:
			return 1;
		case 4:
			return 1;
		case 9:
			return 0;
		case 10:
			return 0;
		case 11:
			return 0;
		case 12:
			return 1;
		case 5:
			return 1;
		case 6:
			return 1;
		case 7:
			return 1;
		case 8:
			return 1;
		case 13:
			return 0;
		case 14:
			return 0;
		case 15:
			return 0;
		case 16:
			return 0;
		default:
			return 0;
	}
};
var $author$project$Portal$Return$withShare = F2(
	function (s, _v0) {
		var m = _v0.a;
		var c = _v0.b;
		return _Utils_Tuple3(s, m, c);
	});
var $author$project$Compensation$Approve$update = F3(
	function (msg, share, model) {
		if (A3($author$project$Portal$Share$allowed, $author$project$Compensation$Approve$whenWaiting, msg, share) === 1) {
			return _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		} else {
			var security = $author$project$Portal$Share$security(share);
			var notification = F3(
				function (action, message, m) {
					return _Utils_Tuple3(
						A2(
							$author$project$Portal$Share$withNotification,
							message,
							A2($author$project$Portal$Share$withoutWaitingAction, action, share)),
						m,
						$elm$core$Platform$Cmd$none);
				});
			var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
			var onLoaded = function (f) {
				switch (model.$) {
					case 1:
						var loaded = model.a;
						return f(loaded);
					case 0:
						return noChange;
					default:
						return noChange;
				}
			};
			var onSelected = function (f) {
				return onLoaded(
					function (loaded) {
						var selected = loaded.nI;
						if (!selected.$) {
							var s = selected.a;
							return A2(f, loaded, s);
						} else {
							return noChange;
						}
					});
			};
			var modelChange = function (m) {
				return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
			};
			var err = F3(
				function (toAction, error, m) {
					return _Utils_Tuple3(
						A2(
							$author$project$Portal$Share$withHttpError,
							error,
							A2($author$project$Portal$Share$withoutWaitingAction, toAction, share)),
						m,
						$elm$core$Platform$Cmd$none);
				});
			return A2(
				$author$project$Portal$Return$mapModel,
				$author$project$Compensation$Approve$unselectWhenFilteredOut,
				function () {
					switch (msg.$) {
						case 0:
							if (!msg.a.$) {
								var compensations = msg.a.a;
								var sortedCompensations = A2(
									$elm$core$List$sortBy,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Compensation$Compensation$logOf,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Compensation$Compensation$lastSubmitted,
											A2($elm_community$maybe_extra$Maybe$Extra$unwrap, 0, $author$project$Compensation$Compensation$chronological))),
									compensations);
								return A2(
									$author$project$Portal$Return$withoutAction,
									$author$project$Compensation$Approve$loadingCompensations,
									modelChange(
										$author$project$Compensation$Approve$Loaded(
											{
												aD: sortedCompensations,
												eb: {aD: sortedCompensations, g2: ''},
												db: 0,
												nI: A2(
													$elm$core$Maybe$map,
													function (c) {
														return {ao: c, bw: $author$project$Compensation$Approve$NotRejecting};
													},
													$elm$core$List$head(sortedCompensations))
											})));
							} else {
								var error = msg.a.a;
								return A3(err, $author$project$Compensation$Approve$loadingCompensations, error, $author$project$Compensation$Approve$Failed);
							}
						case 1:
							var compensation = msg.a;
							return onLoaded(
								function (loaded) {
									return A2(
										$author$project$Portal$Return$withShare,
										share,
										A2(
											$author$project$Compensation$Approve$withSelected,
											$elm$core$Maybe$Just(compensation),
											loaded));
								});
						case 2:
							return onSelected(
								$author$project$Compensation$Approve$validate(share));
						case 3:
							return onSelected(
								$author$project$Compensation$Approve$approve(share));
						case 4:
							return onSelected(
								$author$project$Compensation$Approve$rejecting(share));
						case 5:
							var reason = msg.a;
							return onSelected(
								F2(
									function (loaded, selected) {
										return modelChange(
											$author$project$Compensation$Approve$Loaded(
												_Utils_update(
													loaded,
													{
														nI: $elm$core$Maybe$Just(
															_Utils_update(
																selected,
																{
																	bw: $author$project$Compensation$Approve$Rejecting(reason)
																}))
													})));
									}));
						case 7:
							return onSelected(
								$author$project$Compensation$Approve$reject(share));
						case 6:
							return onSelected(
								F2(
									function (loaded, selected) {
										return modelChange(
											$author$project$Compensation$Approve$Loaded(
												_Utils_update(
													loaded,
													{
														nI: $elm$core$Maybe$Just(
															_Utils_update(
																selected,
																{bw: $author$project$Compensation$Approve$NotRejecting}))
													})));
									}));
						case 8:
							switch (msg.a) {
								case 0:
									var _v1 = msg.a;
									return onSelected(
										$author$project$Compensation$Approve$reject(share));
								case 1:
									var _v2 = msg.a;
									return onSelected(
										F2(
											function (loaded, selected) {
												return modelChange(
													$author$project$Compensation$Approve$Loaded(
														_Utils_update(
															loaded,
															{
																nI: $elm$core$Maybe$Just(
																	_Utils_update(
																		selected,
																		{bw: $author$project$Compensation$Approve$NotRejecting}))
															})));
											}));
								default:
									var _v3 = msg.a;
									return noChange;
							}
						case 9:
							if (!msg.a.$) {
								var compensation = msg.a.a;
								return A2(
									$author$project$Portal$Return$withoutAction,
									$author$project$Compensation$Approve$validatingCompensation,
									onLoaded(
										function (loaded) {
											return A2(
												$author$project$Portal$Return$withShare,
												share,
												$author$project$Compensation$Approve$selectNext(
													A2($author$project$Compensation$Approve$replace, compensation, loaded)));
										}));
							} else {
								if ((msg.a.a.$ === 3) && (msg.a.a.a === 404)) {
									return A3(
										notification,
										$author$project$Compensation$Approve$validatingCompensation,
										A2($author$project$Portal$Message$info, 'Vergoeding is reeds aangepast of verwijderd.', 'Ververs het vergoedingenoverzicht.'),
										model);
								} else {
									var error = msg.a.a;
									return A3(err, $author$project$Compensation$Approve$validatingCompensation, error, model);
								}
							}
						case 10:
							if (!msg.a.$) {
								var compensation = msg.a.a;
								return A2(
									$author$project$Portal$Return$withoutAction,
									$author$project$Compensation$Approve$approvingCompensation,
									onLoaded(
										function (loaded) {
											return A2(
												$author$project$Portal$Return$withShare,
												share,
												$author$project$Compensation$Approve$selectNext(
													A2($author$project$Compensation$Approve$replace, compensation, loaded)));
										}));
							} else {
								if ((msg.a.a.$ === 3) && (msg.a.a.a === 404)) {
									return A3(
										notification,
										$author$project$Compensation$Approve$approvingCompensation,
										A2($author$project$Portal$Message$info, 'Vergoeding is reeds aangepast of verwijderd.', 'Ververs het vergoedingenoverzicht.'),
										model);
								} else {
									var error = msg.a.a;
									return A3(err, $author$project$Compensation$Approve$approvingCompensation, error, model);
								}
							}
						case 11:
							if (!msg.a.$) {
								var compensation = msg.a.a;
								return A2(
									$author$project$Portal$Return$withoutAction,
									$author$project$Compensation$Approve$rejectingCompensation,
									onLoaded(
										function (loaded) {
											return A2(
												$author$project$Portal$Return$withShare,
												share,
												$author$project$Compensation$Approve$selectNext(
													A2($author$project$Compensation$Approve$replace, compensation, loaded)));
										}));
							} else {
								if ((msg.a.a.$ === 3) && (msg.a.a.a === 404)) {
									return A3(
										notification,
										$author$project$Compensation$Approve$rejectingCompensation,
										A2($author$project$Portal$Message$info, 'Vergoeding is reeds aangepast of verwijderd.', 'Ververs het vergoedingenoverzicht.'),
										model);
								} else {
									var error = msg.a.a;
									return A3(err, $author$project$Compensation$Approve$rejectingCompensation, error, model);
								}
							}
						case 12:
							switch (msg.a) {
								case 1:
									var _v4 = msg.a;
									return onLoaded(
										function (loaded) {
											return A2(
												$author$project$Portal$Return$withShare,
												share,
												$author$project$Compensation$Approve$selectNext(loaded));
										});
								case 0:
									var _v5 = msg.a;
									return onLoaded(
										function (loaded) {
											return A2(
												$author$project$Portal$Return$withShare,
												share,
												$author$project$Compensation$Approve$selectPrevious(loaded));
										});
								case 2:
									var _v6 = msg.a;
									return onSelected(
										F2(
											function (loaded, selected) {
												var compensation = selected.ao;
												var _v7 = A2(
													$author$project$Compensation$Approve$can,
													security,
													$author$project$Compensation$Compensation$statusOf(compensation));
												switch (_v7) {
													case 0:
														return A3($author$project$Compensation$Approve$validate, share, loaded, selected);
													case 1:
														return A3($author$project$Compensation$Approve$approve, share, loaded, selected);
													default:
														return noChange;
												}
											}));
								case 3:
									var _v8 = msg.a;
									return onSelected(
										F2(
											function (loaded, selected) {
												var compensation = selected.ao;
												var _v9 = A2(
													$author$project$Compensation$Approve$can,
													security,
													$author$project$Compensation$Compensation$statusOf(compensation));
												switch (_v9) {
													case 0:
														return A3($author$project$Compensation$Approve$rejecting, share, loaded, selected);
													case 1:
														return A3($author$project$Compensation$Approve$rejecting, share, loaded, selected);
													default:
														return noChange;
												}
											}));
								default:
									var _v10 = msg.a;
									return noChange;
							}
						case 13:
							return noChange;
						case 14:
							return noChange;
						case 15:
							return onLoaded(
								function (loaded) {
									return modelChange(
										$author$project$Compensation$Approve$Loaded(
											_Utils_update(
												loaded,
												{db: 1})));
								});
						case 16:
							var text = msg.a;
							return onLoaded(
								function (loaded) {
									var compensations = loaded.aD;
									var filtered = loaded.eb;
									return modelChange(
										$author$project$Compensation$Approve$Loaded(
											_Utils_update(
												loaded,
												{
													eb: A3($author$project$Compensation$Compensation$updatedFilter, compensations, text, filtered)
												})));
								});
						default:
							return onLoaded(
								function (loaded) {
									return modelChange(
										$author$project$Compensation$Approve$Loaded(
											_Utils_update(
												loaded,
												{db: 0})));
								});
					}
				}());
		}
	});
var $author$project$Compensation$Edit$BackendRespondedCompensationEdited = function (a) {
	return {$: 7, a: a};
};
var $author$project$Compensation$Edit$EditConfirmation = function (a) {
	return {$: 1, a: a};
};
var $author$project$Compensation$Edit$GotSubHeaderMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Compensation$Edit$SystemGotFormMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Compensation$Edit$SystemGotPlanLoaderMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Compensation$Edit$calendarStateOf = function (model) {
	switch (model.$) {
		case 0:
			var calendarState = model.a.r;
			return calendarState;
		case 1:
			var calendarState = model.a.r;
			return calendarState;
		case 2:
			var calendarState = model.a.r;
			return calendarState;
		default:
			var calendarState = model.a.r;
			return calendarState;
	}
};
var $author$project$Compensation$Edit$compensationOf = function (model) {
	switch (model.$) {
		case 0:
			var compensation = model.a.ao;
			return compensation;
		case 1:
			var originalCompensation = model.a.el;
			return $elm$core$Maybe$Just(originalCompensation);
		case 2:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Compensation$Compensation$onOf = function (compensation) {
	switch (compensation.$) {
		case 0:
			var on = compensation.a.g2;
			return on;
		case 1:
			var on = compensation.a.g2;
			return on;
		default:
			var on = compensation.a.g2;
			return on;
	}
};
var $author$project$Compensation$Edit$dateOf = F2(
	function (share, model) {
		switch (model.$) {
			case 0:
				var compensation = model.a.ao;
				return A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$author$project$Portal$Share$today(share),
					$author$project$Compensation$Compensation$onOf,
					compensation);
			case 1:
				var originalCompensation = model.a.el;
				return $author$project$Compensation$Compensation$onOf(originalCompensation);
			case 2:
				var compensation = model.a.ao;
				return $author$project$Compensation$Compensation$onOf(compensation);
			default:
				return $author$project$Portal$Share$today(share);
		}
	});
var $author$project$Compensation$Compensation$distributionPointOf = function (compensation) {
	switch (compensation.$) {
		case 0:
			var distributionPoint = compensation.a.bn;
			return distributionPoint;
		case 1:
			var distributionPoint = compensation.a.bn;
			return distributionPoint;
		default:
			var distributionPoint = compensation.a.bn;
			return distributionPoint;
	}
};
var $author$project$Compensation$Edit$failed = function (model) {
	return $author$project$Compensation$Edit$Failed(
		{
			r: $author$project$Compensation$Edit$calendarStateOf(model),
			ap: $author$project$Compensation$Edit$compensationIdOf(model)
		});
};
var $author$project$Compensation$Edit$BackendRespondedDistributionPoint = function (a) {
	return {$: 2, a: a};
};
var $author$project$Compensation$Edit$loadingDP = $author$project$Compensation$Edit$singleAction('loadingDP');
var $author$project$Compensation$Edit$loadingPlan = F2(
	function (key, stage) {
		return A2($author$project$Compensation$Edit$singleAction, 'loadingPlan' + stage, key);
	});
var $author$project$Compensation$Edit$loadDistributionPointAndPlanOf = F4(
	function (share, calendarState, compensationId, compensation) {
		var on = $author$project$Compensation$Compensation$onOf(compensation);
		var dp = $author$project$Compensation$Compensation$distributionPointOf(compensation);
		return A3(
			$author$project$Portal$Return$withCommand,
			$author$project$Compensation$Edit$loadingDP(compensationId),
			A4(
				$author$project$DistributionPoint$DistributionPoint$loadCmd,
				$author$project$Portal$Share$token(share),
				$author$project$Compensation$Edit$BackendRespondedDistributionPoint,
				dp.eg,
				on),
			function (_v0) {
				var s = _v0.a;
				var cmds = _v0.b;
				return _Utils_Tuple3(
					s,
					$author$project$Compensation$Edit$Loading(
						{
							r: calendarState,
							ao: $elm$core$Maybe$Just(compensation),
							ap: compensationId,
							bn: $elm$core$Maybe$Nothing,
							fB: $elm$core$Maybe$Just(
								A4($author$project$Plan$PlanLoader$initModel, s, $elm$core$Basics$identity, dp.eg, on))
						}),
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$map,
							$elm$core$Platform$Cmd$map($author$project$Compensation$Edit$SystemGotPlanLoaderMsg),
							cmds)));
			}(
				A4(
					$author$project$Plan$PlanLoader$init,
					share,
					$author$project$Compensation$Edit$loadingPlan(compensationId),
					dp.eg,
					on)));
	});
var $author$project$Compensation$Edit$submittingCompensation = $author$project$Compensation$Edit$singleAction('submittingCompensation');
var $author$project$Compensation$Edit$whenWaiting = function (msg) {
	switch (msg.$) {
		case 0:
			return 0;
		case 1:
			return 0;
		case 2:
			return 0;
		case 3:
			return 0;
		case 4:
			return 1;
		case 5:
			return 1;
		case 6:
			return 1;
		case 7:
			return 0;
		default:
			return 0;
	}
};
var $author$project$Compensation$Edit$withCalendarState = F2(
	function (calendarState, model) {
		switch (model.$) {
			case 0:
				var loading = model.a;
				return $author$project$Compensation$Edit$Loading(
					_Utils_update(
						loading,
						{r: calendarState}));
			case 1:
				var loaded = model.a;
				return $author$project$Compensation$Edit$Loaded(
					_Utils_update(
						loaded,
						{r: calendarState}));
			case 2:
				var f = model.a;
				return $author$project$Compensation$Edit$NoPlan(
					_Utils_update(
						f,
						{r: calendarState}));
			default:
				var f = model.a;
				return $author$project$Compensation$Edit$Failed(
					_Utils_update(
						f,
						{r: calendarState}));
		}
	});
var $author$project$Compensation$Edit$update = F3(
	function (msg, share, model) {
		if (A3($author$project$Portal$Share$allowed, $author$project$Compensation$Edit$whenWaiting, msg, share) === 1) {
			return _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		} else {
			var token = $author$project$Portal$Share$token(share);
			var to = function (route) {
				return _Utils_Tuple3(
					A2($author$project$Portal$Share$withNewRoute, route, share),
					model,
					$elm$core$Platform$Cmd$none);
			};
			var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
			var onLoading = function (f) {
				if (!model.$) {
					var loading = model.a;
					return f(loading);
				} else {
					return noChange;
				}
			};
			var modelChange = function (m) {
				return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
			};
			var actionKey = $author$project$Compensation$Edit$compensationIdOf(model);
			var err = F3(
				function (toAction, error, m) {
					return _Utils_Tuple3(
						A2(
							$author$project$Portal$Share$withHttpError,
							error,
							A2(
								$author$project$Portal$Share$withoutWaitingAction,
								toAction(actionKey),
								share)),
						m,
						$elm$core$Platform$Cmd$none);
				});
			var withCommand = function (toAction) {
				return $author$project$Portal$Return$withCommand(
					toAction(actionKey));
			};
			var withoutAction = function (toAction) {
				return $author$project$Portal$Return$withoutAction(
					toAction(actionKey));
			};
			switch (msg.$) {
				case 0:
					var subHeaderMsg = msg.a;
					var _v1 = $author$project$Compensation$Edit$compensationOf(model);
					if (!_v1.$) {
						var compensation = _v1.a;
						var dpId = $author$project$Compensation$Compensation$distributionPointOf(compensation).eg;
						var _v2 = A5(
							$author$project$Portal$Subheader$update,
							subHeaderMsg,
							share,
							$elm$core$Maybe$Just(dpId),
							A2($author$project$Compensation$Edit$dateOf, share, model),
							$author$project$Compensation$Edit$calendarStateOf(model));
						switch (_v2.a.$) {
							case 0:
								var _v3 = _v2.a;
								var _v4 = _v2.b;
								var s = _v4.a;
								var m = _v4.b;
								var cmd = _v4.c;
								return _Utils_Tuple3(
									s,
									A2($author$project$Compensation$Edit$withCalendarState, m, model),
									A2($elm$core$Platform$Cmd$map, $author$project$Compensation$Edit$GotSubHeaderMsg, cmd));
							case 1:
								var date = _v2.a.a;
								return to(
									A2($author$project$Portal$Route$CreateCompensation, dpId, date));
							case 2:
								var date = _v2.a.a;
								return to(
									A2($author$project$Portal$Route$CreateCompensation, dpId, date));
							default:
								return noChange;
						}
					} else {
						return noChange;
					}
				case 1:
					if (!msg.a.$) {
						var compensation = msg.a.a;
						return A2(
							withoutAction,
							$author$project$Compensation$Edit$loadingCompensation,
							onLoading(
								function (_v5) {
									var calendarState = _v5.r;
									return A4(
										$author$project$Compensation$Edit$loadDistributionPointAndPlanOf,
										share,
										calendarState,
										$author$project$Compensation$Edit$compensationIdOf(model),
										compensation);
								}));
					} else {
						var error = msg.a.a;
						return A3(
							err,
							$author$project$Compensation$Edit$loadingCompensation,
							error,
							$author$project$Compensation$Edit$failed(model));
					}
				case 2:
					if (!msg.a.$) {
						var distributionPoint = msg.a.a;
						return A2(
							withoutAction,
							$author$project$Compensation$Edit$loadingDP,
							function () {
								if (!model.$) {
									var loading = model.a;
									return modelChange(
										$author$project$Compensation$Edit$next(
											$author$project$Compensation$Edit$Loading(
												_Utils_update(
													loading,
													{
														bn: $elm$core$Maybe$Just(distributionPoint)
													}))));
								} else {
									return noChange;
								}
							}());
					} else {
						var error = msg.a.a;
						return A3(
							err,
							$author$project$Compensation$Edit$loadingDP,
							error,
							$author$project$Compensation$Edit$failed(model));
					}
				case 3:
					var planLoaderMsg = msg.a;
					if (!model.$) {
						var loading = model.a;
						var planAndDeliverers = loading.fB;
						if (!planAndDeliverers.$) {
							var pAndD = planAndDeliverers.a;
							return A2(
								$author$project$Plan$PlanLoader$mapModel,
								function (pd) {
									return $author$project$Compensation$Edit$next(
										$author$project$Compensation$Edit$Loading(
											_Utils_update(
												loading,
												{
													fB: $elm$core$Maybe$Just(pd)
												})));
								},
								A2(
									$author$project$Plan$PlanLoader$mapCommand,
									$elm$core$Platform$Cmd$map($author$project$Compensation$Edit$SystemGotPlanLoaderMsg),
									A6(
										$author$project$Plan$PlanLoader$update,
										share,
										token,
										$author$project$Compensation$Edit$loadingPlan(actionKey),
										$elm$core$Basics$identity,
										planLoaderMsg,
										pAndD)));
						} else {
							return noChange;
						}
					} else {
						return noChange;
					}
				case 4:
					var formMsg = msg.a;
					if (model.$ === 1) {
						var loaded = model.a;
						var form = loaded.bO;
						return function (_v10) {
							var f = _v10.a;
							var cmd = _v10.b;
							return A2(
								$author$project$Portal$Return$withBackgroundCommand,
								A2($elm$core$Platform$Cmd$map, $author$project$Compensation$Edit$SystemGotFormMsg, cmd),
								modelChange(
									$author$project$Compensation$Edit$Loaded(
										_Utils_update(
											loaded,
											{bO: f}))));
						}(
							A2($author$project$Compensation$Form$update, formMsg, form));
					} else {
						return noChange;
					}
				case 5:
					return to($author$project$Portal$Route$Compensations);
				case 6:
					if (model.$ === 1) {
						var loadedModel = model.a;
						var form = loadedModel.bO;
						var distributionPoint = loadedModel.bn;
						var deliverers = loadedModel.e4;
						var plan = loadedModel.fA;
						var _v12 = A2(
							$arowM$elm_form_decoder$Form$Decoder$run,
							$author$project$Compensation$Form$decoder(
								A2($author$project$Compensation$Edit$dateOf, share, model)),
							form);
						if (!_v12.$) {
							var compensation = _v12.a;
							return A3(
								withCommand,
								$author$project$Compensation$Edit$submittingCompensation,
								A3($author$project$Compensation$Compensation$submitCmd, token, $author$project$Compensation$Edit$BackendRespondedCompensationEdited, compensation),
								noChange);
						} else {
							var validationErrors = _v12.a;
							return modelChange(
								$author$project$Compensation$Edit$Loaded(
									_Utils_update(
										loadedModel,
										{
											bO: _Utils_update(
												form,
												{f_: validationErrors})
										})));
						}
					} else {
						return noChange;
					}
				case 7:
					if (!msg.a.$) {
						var compensation = msg.a.a;
						return A2(
							withoutAction,
							$author$project$Compensation$Edit$submittingCompensation,
							function () {
								if (model.$ === 1) {
									var loadedModel = model.a;
									return modelChange(
										$author$project$Compensation$Edit$Loaded(
											_Utils_update(
												loadedModel,
												{
													eW: $author$project$Compensation$Edit$EditConfirmation(compensation)
												})));
								} else {
									return noChange;
								}
							}());
					} else {
						var error = msg.a.a;
						return A3(err, $author$project$Compensation$Edit$submittingCompensation, error, model);
					}
				default:
					return to($author$project$Portal$Route$Compensations);
			}
		}
	});
var $author$project$Compensation$Overview$BackendRespondedApprovedOwn = function (a) {
	return {$: 10, a: a};
};
var $author$project$Compensation$Overview$BackendRespondedCompensationDeleted = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Compensation$Overview$Deleting = 1;
var $author$project$Compensation$Overview$Failed = {$: 2};
var $author$project$Compensation$Overview$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Compensation$Overview$NotDeleting = 0;
var $author$project$Compensation$Compensation$approveOwnCmd = F3(
	function (token, toMsg, id) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'compensations',
					$author$project$Compensation$Compensation$encodeForUrl(id),
					'approve-own'
				]),
			_List_Nil);
		return A5($author$project$Api$Request$post, token, toMsg, uri, $elm$http$Http$emptyBody, $author$project$Compensation$Compensation$decoder);
	});
var $author$project$Compensation$Overview$approvingOwnCompensation = $author$project$Compensation$Overview$singleAction('approvingOwnCompensation');
var $author$project$Api$Request$deleteWithoutResponse = F5(
	function (token, toMsg, url, body, tracker) {
		return $elm$http$Http$request(
			{
				aA: body,
				aJ: $elm$http$Http$expectWhatever(toMsg),
				aK: $author$project$Api$Request$headers(token),
				aO: 'DELETE',
				aS: $elm$core$Maybe$Nothing,
				aU: $author$project$Api$Request$trackingFor(tracker),
				aW: url
			});
	});
var $author$project$Compensation$Compensation$deleteCmd = F3(
	function (token, toMsg, id) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'compensations',
					$author$project$Compensation$Compensation$encodeForUrl(id)
				]),
			_List_Nil);
		return A4($author$project$Api$Request$deleteWithoutResponse, token, toMsg, uri, $elm$http$Http$emptyBody);
	});
var $author$project$Compensation$Overview$deletingCompensation = $author$project$Compensation$Overview$singleAction('deletingCompensation');
var $author$project$Portal$Share$distributionPointIdOfHeader = function (_v0) {
	var model = _v0;
	return model.gn;
};
var $author$project$Compensation$Overview$filterCompensation = function (compensation) {
	return $elm$core$List$filter(
		A2(
			$elm$core$Basics$composeR,
			$author$project$Compensation$Compensation$idOf,
			$elm$core$Basics$neq(
				$author$project$Compensation$Compensation$idOf(compensation))));
};
var $author$project$Portal$Return$mapShare = F2(
	function (mapper, _v0) {
		var s = _v0.a;
		var m = _v0.b;
		var c = _v0.c;
		return _Utils_Tuple3(
			mapper(
				_Utils_Tuple3(s, m, c)),
			m,
			c);
	});
var $author$project$Compensation$Overview$unselectWhenFilteredOut = function (_v0) {
	var model = _v0.b;
	if (model.$ === 1) {
		var loaded = model.a;
		var selected = loaded.nI;
		var filtered = loaded.eb;
		return $author$project$Compensation$Overview$Loaded(
			function () {
				if (!selected.$) {
					var compensation = selected.a.ao;
					return A2($elm$core$List$member, compensation, filtered.aD) ? loaded : _Utils_update(
						loaded,
						{nI: $elm$core$Maybe$Nothing});
				} else {
					return loaded;
				}
			}());
	} else {
		return model;
	}
};
var $author$project$Compensation$Overview$whenWaiting = function (msg) {
	switch (msg.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 1;
		case 3:
			return 1;
		case 4:
			return 1;
		case 5:
			return 1;
		case 6:
			return 1;
		case 7:
			return 1;
		case 8:
			return 1;
		case 9:
			return 1;
		case 10:
			return 0;
		default:
			return 0;
	}
};
var $author$project$Compensation$Overview$withCompensations = F2(
	function (compensations, loaded) {
		var filtered = loaded.eb;
		var selected = loaded.nI;
		return _Utils_update(
			loaded,
			{
				aD: compensations,
				eb: A3($author$project$Compensation$Compensation$updatedFilter, compensations, filtered.g2, filtered)
			});
	});
var $author$project$Compensation$Overview$update = F3(
	function (msg, share, model) {
		if (A3($author$project$Portal$Share$allowed, $author$project$Compensation$Overview$whenWaiting, msg, share) === 1) {
			return _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		} else {
			var to = function (route) {
				return _Utils_Tuple3(
					A2($author$project$Portal$Share$withNewRoute, route, share),
					model,
					$elm$core$Platform$Cmd$none);
			};
			var notification = F3(
				function (action, message, m) {
					return _Utils_Tuple3(
						A2(
							$author$project$Portal$Share$withNotification,
							message,
							A2($author$project$Portal$Share$withoutWaitingAction, action, share)),
						m,
						$elm$core$Platform$Cmd$none);
				});
			var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
			var onLoaded = function (f) {
				switch (model.$) {
					case 1:
						var loaded = model.a;
						return f(loaded);
					case 0:
						return noChange;
					default:
						return noChange;
				}
			};
			var onSelected = function (f) {
				return onLoaded(
					function (loaded) {
						var selected = loaded.nI;
						if (!selected.$) {
							var s = selected.a;
							return A2(f, loaded, s);
						} else {
							return noChange;
						}
					});
			};
			var modelChange = function (m) {
				return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
			};
			var err = F3(
				function (toAction, error, m) {
					return _Utils_Tuple3(
						A2(
							$author$project$Portal$Share$withHttpError,
							error,
							A2($author$project$Portal$Share$withoutWaitingAction, toAction, share)),
						m,
						$elm$core$Platform$Cmd$none);
				});
			return A2(
				$author$project$Portal$Return$mapModel,
				$author$project$Compensation$Overview$unselectWhenFilteredOut,
				function () {
					switch (msg.$) {
						case 0:
							if (!msg.a.$) {
								var compensations = msg.a.a;
								return A2(
									$author$project$Portal$Return$withoutAction,
									$author$project$Compensation$Overview$loadingCompensations,
									modelChange(
										$author$project$Compensation$Overview$Loaded(
											{
												aD: compensations,
												eb: {aD: compensations, g2: ''},
												nI: $elm$core$Maybe$Nothing
											})));
							} else {
								var error = msg.a.a;
								return A3(err, $author$project$Compensation$Overview$loadingCompensations, error, $author$project$Compensation$Overview$Failed);
							}
						case 1:
							var _v1 = $author$project$Portal$Share$distributionPointIdOfHeader(share);
							if (!_v1.$) {
								var dpId = _v1.a;
								return to(
									A2(
										$author$project$Portal$Route$CreateCompensation,
										dpId,
										$author$project$Portal$Share$today(share)));
							} else {
								return A2(
									$author$project$Portal$Return$mapShare,
									function (_v2) {
										var s = _v2.a;
										return A2(
											$author$project$Portal$Share$withNotification,
											A2($author$project$Portal$Message$info, 'Distributiepunt kiezen', 'Kies eerst een distributiepunt voordat je een incidentele vergadering aanmaakt.'),
											s);
									},
									noChange);
							}
						case 2:
							return to($author$project$Portal$Route$ApproveCompensations);
						case 3:
							var compensation = msg.a;
							return onLoaded(
								function (loaded) {
									return modelChange(
										$author$project$Compensation$Overview$Loaded(
											_Utils_update(
												loaded,
												{
													nI: $elm$core$Maybe$Just(
														{ao: compensation, d0: 0})
												})));
								});
						case 4:
							var text = msg.a;
							return onLoaded(
								function (loaded) {
									var compensations = loaded.aD;
									var filtered = loaded.eb;
									return modelChange(
										$author$project$Compensation$Overview$Loaded(
											_Utils_update(
												loaded,
												{
													eb: A3($author$project$Compensation$Compensation$updatedFilter, compensations, text, filtered)
												})));
								});
						case 5:
							return onSelected(
								F2(
									function (_v3, _v4) {
										var compensation = _v4.ao;
										var _v5 = _Utils_Tuple2(
											$author$project$Compensation$Compensation$idOf(compensation),
											$author$project$Compensation$Compensation$statusOf(compensation));
										if ((!_v5.a.$) && (!_v5.b)) {
											var id = _v5.a.a;
											var _v6 = _v5.b;
											return A3(
												$author$project$Portal$Return$withCommand,
												$author$project$Compensation$Overview$approvingOwnCompensation,
												A3(
													$author$project$Compensation$Compensation$approveOwnCmd,
													$author$project$Portal$Share$token(share),
													$author$project$Compensation$Overview$BackendRespondedApprovedOwn,
													id),
												noChange);
										} else {
											return noChange;
										}
									}));
						case 6:
							return onSelected(
								F2(
									function (_v7, _v8) {
										var compensation = _v8.ao;
										return A3(
											$elm_community$maybe_extra$Maybe$Extra$unwrap,
											noChange,
											A2($elm$core$Basics$composeL, to, $author$project$Portal$Route$EditCompensation),
											$author$project$Compensation$Compensation$idOf(compensation));
									}));
						case 7:
							return onSelected(
								F2(
									function (loaded, selected) {
										return modelChange(
											$author$project$Compensation$Overview$Loaded(
												_Utils_update(
													loaded,
													{
														nI: $elm$core$Maybe$Just(
															_Utils_update(
																selected,
																{d0: 1}))
													})));
									}));
						case 8:
							return onSelected(
								F2(
									function (_v9, _v10) {
										var compensation = _v10.ao;
										var _v11 = $author$project$Compensation$Compensation$idOf(compensation);
										if (!_v11.$) {
											var id = _v11.a;
											return A3(
												$author$project$Portal$Return$withCommand,
												$author$project$Compensation$Overview$deletingCompensation,
												A3(
													$author$project$Compensation$Compensation$deleteCmd,
													$author$project$Portal$Share$token(share),
													$author$project$Compensation$Overview$BackendRespondedCompensationDeleted(compensation),
													id),
												noChange);
										} else {
											return noChange;
										}
									}));
						case 9:
							return onSelected(
								F2(
									function (loaded, selected) {
										return modelChange(
											$author$project$Compensation$Overview$Loaded(
												_Utils_update(
													loaded,
													{
														nI: $elm$core$Maybe$Just(
															_Utils_update(
																selected,
																{d0: 0}))
													})));
									}));
						case 10:
							if (!msg.a.$) {
								var compensation = msg.a.a;
								return onLoaded(
									function (loaded) {
										var compensations = loaded.aD;
										return A2(
											$author$project$Portal$Return$withoutAction,
											$author$project$Compensation$Overview$approvingOwnCompensation,
											modelChange(
												$author$project$Compensation$Overview$Loaded(
													A2(
														$author$project$Compensation$Overview$withCompensations,
														A2(
															$elm$core$List$cons,
															compensation,
															A2($author$project$Compensation$Overview$filterCompensation, compensation, compensations)),
														_Utils_update(
															loaded,
															{
																nI: $elm$core$Maybe$Just(
																	{ao: compensation, d0: 0})
															})))));
									});
							} else {
								var error = msg.a.a;
								return A3(err, $author$project$Compensation$Overview$approvingOwnCompensation, error, model);
							}
						default:
							if (!msg.b.$) {
								var compensation = msg.a;
								return onLoaded(
									function (loaded) {
										var compensations = loaded.aD;
										return A2(
											$author$project$Portal$Return$withoutAction,
											$author$project$Compensation$Overview$deletingCompensation,
											modelChange(
												$author$project$Compensation$Overview$Loaded(
													A2(
														$author$project$Compensation$Overview$withCompensations,
														A2($author$project$Compensation$Overview$filterCompensation, compensation, compensations),
														loaded))));
									});
							} else {
								if ((msg.b.a.$ === 3) && (msg.b.a.a === 404)) {
									return A3(
										notification,
										$author$project$Compensation$Overview$deletingCompensation,
										A2($author$project$Portal$Message$info, 'Vergoeding is reeds aangepast of verwijderd.', 'Ververs het vergoedingenoverzicht.'),
										model);
								} else {
									var error = msg.b.a;
									return A3(err, $author$project$Compensation$Overview$deletingCompensation, error, model);
								}
							}
					}
				}());
		}
	});
var $author$project$Complaint$Feedback$Expanded = 0;
var $author$project$Complaint$Feedback$Failed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Complaint$Feedback$GotSubHeaderMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Complaint$Feedback$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Complaint$Feedback$NotSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Complaint$Feedback$Selected = function (a) {
	return {$: 0, a: a};
};
var $author$project$Complaint$Feedback$SystemRespondedToSendingFeedback = function (a) {
	return {$: 9, a: a};
};
var $author$project$Complaint$Feedback$complaintOf = function (s) {
	if (!s.$) {
		var c = s.a;
		return c;
	} else {
		var c = s.a;
		return c;
	}
};
var $author$project$Complaint$Feedback$deliveryDateOf = function (model) {
	switch (model.$) {
		case 1:
			var m = model.a;
			return m.t;
		case 0:
			var context = model.a;
			return context.t;
		default:
			var context = model.a;
			return context.t;
	}
};
var $author$project$Complaint$Feedback$CodeRequired = 0;
var $author$project$Complaint$Feedback$ComplaintsRequired = 1;
var $author$project$Complaint$Feedback$complaintsFormDecoder = $arowM$elm_form_decoder$Form$Decoder$custom(
	function (complaints) {
		if (!complaints.b) {
			return $elm$core$Result$Err(
				_List_fromArray(
					[1]));
		} else {
			return $elm$core$Result$Ok(
				A2(
					$elm$core$List$filterMap,
					function (s) {
						if (!s.$) {
							var c = s.a;
							return $elm$core$Maybe$Just(c);
						} else {
							return $elm$core$Maybe$Nothing;
						}
					},
					complaints));
		}
	});
var $author$project$Complaint$Feedback$feedbackFormDecoder = A2(
	$arowM$elm_form_decoder$Form$Decoder$field,
	A2(
		$arowM$elm_form_decoder$Form$Decoder$lift,
		function ($) {
			return $.gg;
		},
		$arowM$elm_form_decoder$Form$Decoder$identity),
	A2(
		$arowM$elm_form_decoder$Form$Decoder$field,
		A2(
			$arowM$elm_form_decoder$Form$Decoder$lift,
			function ($) {
				return $.lW;
			},
			$arowM$elm_form_decoder$Form$Decoder$custom(
				$elm$core$Result$fromMaybe(
					_List_fromArray(
						[0])))),
		A2(
			$arowM$elm_form_decoder$Form$Decoder$field,
			A2(
				$arowM$elm_form_decoder$Form$Decoder$lift,
				function ($) {
					return $.m;
				},
				$author$project$Complaint$Feedback$complaintsFormDecoder),
			$arowM$elm_form_decoder$Form$Decoder$top(
				F3(
					function (complaints, code, comment) {
						return _Utils_Tuple3(complaints, code, comment);
					})))));
var $author$project$Complaint$Feedback$searchIn = function (model) {
	switch (model.$) {
		case 0:
			var search = model.a.aj;
			return search;
		case 1:
			var search = model.a.aj;
			return search;
		default:
			var search = model.a.aj;
			return search;
	}
};
var $author$project$Complaint$Feedback$selectAll = function (selection) {
	return A2(
		$elm$core$List$map,
		A2($elm$core$Basics$composeR, $author$project$Complaint$Feedback$complaintOf, $author$project$Complaint$Feedback$Selected),
		selection);
};
var $author$project$Complaint$Complaint$encodeFeedbackCode = function (code) {
	return $elm$json$Json$Encode$string(
		function () {
			switch (code) {
				case 1:
					return 'address unreachable';
				case 2:
					return 'deliverer delayed';
				case 3:
					return 'unclear delivery location';
				case 4:
					return 'theft';
				case 5:
					return 'intern at customer';
				case 6:
					return 'substitute deliverer';
				case 7:
					return 'mutation';
				case 8:
					return 'new building';
				case 9:
					return 'new deliverer';
				case 10:
					return 'unsafe delivery situation';
				case 11:
					return 'deliverer shortage';
				case 12:
					return 'weather';
				default:
					return '';
			}
		}());
};
var $author$project$Complaint$Complaint$encodeId = function (_v0) {
	var id = _v0;
	return $danyx23$elm_uuid$Uuid$encode(id);
};
var $author$project$Complaint$Feedback$encodeFeedbackForm = F3(
	function (code, comment, complaints) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'feedback',
					$author$project$Complaint$Complaint$encodeFeedbackCode(code)),
					_Utils_Tuple2(
					'comment',
					$elm$json$Json$Encode$string(comment)),
					_Utils_Tuple2(
					'complaints',
					A2(
						$elm$json$Json$Encode$list,
						$author$project$Complaint$Complaint$encodeId,
						A2(
							$elm$core$List$map,
							function ($) {
								return $.eg;
							},
							complaints)))
				]));
	});
var $author$project$Complaint$Feedback$setFeedbackCmd = F5(
	function (token, code, comment, complaints, toMsg) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['complaint', 'feedback']),
			_List_Nil);
		var body = $elm$http$Http$jsonBody(
			A3($author$project$Complaint$Feedback$encodeFeedbackForm, code, comment, complaints));
		return A4($author$project$Api$Request$postWithoutResponse, token, toMsg, uri, body);
	});
var $author$project$Complaint$Feedback$settingFeedback = $author$project$Complaint$Feedback$singleAction('settingFeedback');
var $author$project$Complaint$Feedback$toContext = function (model) {
	switch (model.$) {
		case 0:
			var context = model.a;
			return context;
		case 1:
			var currentDate = model.a.t;
			var calendarState = model.a.r;
			var search = model.a.aj;
			return {r: calendarState, t: currentDate, aj: search};
		default:
			var context = model.a;
			return context;
	}
};
var $author$project$Complaint$Feedback$unSelectAll = function (selection) {
	return A2(
		$elm$core$List$map,
		A2($elm$core$Basics$composeR, $author$project$Complaint$Feedback$complaintOf, $author$project$Complaint$Feedback$NotSelected),
		selection);
};
var $author$project$Complaint$Feedback$whenWaiting = function (msg) {
	switch (msg.$) {
		case 0:
			return 0;
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 1;
		case 4:
			return 1;
		case 5:
			return 1;
		case 6:
			return 1;
		case 7:
			return 1;
		case 8:
			return 1;
		case 10:
			return 1;
		case 11:
			return 1;
		case 12:
			return 1;
		case 9:
			return 0;
		default:
			return 1;
	}
};
var $author$project$Complaint$Feedback$withCalendarState = F2(
	function (calendar, model) {
		switch (model.$) {
			case 0:
				var loading = model.a;
				return $author$project$Complaint$Feedback$Loading(
					_Utils_update(
						loading,
						{r: calendar}));
			case 1:
				var loaded = model.a;
				return $author$project$Complaint$Feedback$Loaded(
					_Utils_update(
						loaded,
						{r: calendar}));
			default:
				var failed = model.a;
				return $author$project$Complaint$Feedback$Failed(
					_Utils_update(
						failed,
						{r: calendar}));
		}
	});
var $author$project$Complaint$Feedback$withFeedbackSet = function (model) {
	if (model.$ === 1) {
		var l = model.a;
		var complaints = l.m;
		var feedback = l.lW;
		var _v1 = feedback.lW;
		if (!_v1.$) {
			var code = _v1.a;
			return $author$project$Complaint$Feedback$Loaded(
				_Utils_update(
					l,
					{
						m: A2(
							$elm$core$List$map,
							function (c) {
								var _v2 = A2(
									$elm_community$list_extra$List$Extra$find,
									$elm$core$Basics$eq(
										$author$project$Complaint$Feedback$Selected(c)),
									feedback.m);
								if (!_v2.$) {
									return _Utils_update(
										c,
										{
											ln: _Utils_ap(
												c.ln,
												_List_fromArray(
													[
														{kU: 'distribution', aA: feedback.gg}
													])),
											lW: code
										});
								} else {
									return c;
								}
							},
							complaints)
					}));
		} else {
			return model;
		}
	} else {
		return model;
	}
};
var $author$project$Complaint$Feedback$withFilteredComplaints = function (model) {
	if (model.$ === 1) {
		var l = model.a;
		var feedback = l.lW;
		var search = l.aj;
		var filterOnLot = function (complaints) {
			var _v2 = search.aN;
			if (!_v2.b) {
				return complaints;
			} else {
				return A2(
					$elm$core$List$filter,
					function (c) {
						return A2($elm$core$List$member, c.i7, search.aN);
					},
					complaints);
			}
		};
		var filterOnCode = function (complaints) {
			var _v1 = search.aB;
			if (!_v1.b) {
				return complaints;
			} else {
				return A2(
					$elm$core$List$filter,
					function (c) {
						return A2($elm$core$List$member, c.ge, search.aB);
					},
					complaints);
			}
		};
		return $author$project$Complaint$Feedback$Loaded(
			_Utils_update(
				l,
				{
					lW: _Utils_update(
						feedback,
						{
							m: A2(
								$elm$core$List$map,
								$author$project$Complaint$Feedback$NotSelected,
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.lW;
										},
										A2(
											$elm$core$Basics$composeR,
											$elm$core$Basics$eq(0),
											$elm$core$Basics$neq(search.bN))),
									filterOnCode(
										filterOnLot(l.m))))
						})
				}));
	} else {
		return model;
	}
};
var $author$project$Complaint$Feedback$withSearch = F2(
	function (search, model) {
		switch (model.$) {
			case 0:
				var l = model.a;
				return $author$project$Complaint$Feedback$Loading(
					_Utils_update(
						l,
						{aj: search}));
			case 1:
				var l = model.a;
				return $author$project$Complaint$Feedback$Loaded(
					_Utils_update(
						l,
						{aj: search}));
			default:
				var f = model.a;
				return $author$project$Complaint$Feedback$Failed(
					_Utils_update(
						f,
						{aj: search}));
		}
	});
var $author$project$Complaint$Feedback$update = F3(
	function (msg, share, model) {
		var token = $author$project$Portal$Share$token(share);
		var to = function (route) {
			return _Utils_Tuple3(
				A2($author$project$Portal$Share$withNewRoute, route, share),
				model,
				$elm$core$Platform$Cmd$none);
		};
		var search = $author$project$Complaint$Feedback$searchIn(model);
		var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		var modelChange = function (m) {
			return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
		};
		var context = $author$project$Complaint$Feedback$toContext(model);
		var withoutAction = function (toAction) {
			return $author$project$Portal$Return$withoutAction(
				toAction(context.t));
		};
		var actionKey = $author$project$Complaint$Feedback$deliveryDateOf(model);
		var withCommand = function (toAction) {
			return $author$project$Portal$Return$withCommand(
				toAction(actionKey));
		};
		if (A3($author$project$Portal$Share$allowed, $author$project$Complaint$Feedback$whenWaiting, msg, share) === 1) {
			return noChange;
		} else {
			switch (msg.$) {
				case 0:
					var subHeaderMsg = msg.a;
					var _v1 = A5($author$project$Portal$Subheader$update, subHeaderMsg, share, $elm$core$Maybe$Nothing, context.t, context.r);
					switch (_v1.a.$) {
						case 0:
							var _v2 = _v1.a;
							var _v3 = _v1.b;
							var s = _v3.a;
							var m = _v3.b;
							var cmd = _v3.c;
							return _Utils_Tuple3(
								s,
								A2($author$project$Complaint$Feedback$withCalendarState, m, model),
								A2($elm$core$Platform$Cmd$map, $author$project$Complaint$Feedback$GotSubHeaderMsg, cmd));
						case 1:
							var date = _v1.a.a;
							return to(
								$author$project$Portal$Route$ComplaintFeedback(date));
						case 2:
							var date = _v1.a.a;
							return to(
								$author$project$Portal$Route$ComplaintFeedback(date));
						default:
							return noChange;
					}
				case 1:
					if (!msg.a.$) {
						var complaints = msg.a.a;
						return A2(
							withoutAction,
							$author$project$Complaint$Feedback$loadingComplaints,
							modelChange(
								$author$project$Complaint$Feedback$withFilteredComplaints(
									$author$project$Complaint$Feedback$Loaded(
										{
											r: context.r,
											m: complaints,
											t: context.t,
											lW: {gg: '', m: _List_Nil, lW: $elm$core$Maybe$Nothing, f_: _List_Nil},
											aj: search,
											b7: $elm$core$Maybe$Nothing
										}))));
					} else {
						if ((msg.a.a.$ === 3) && (msg.a.a.a === 404)) {
							return _Utils_Tuple3(
								A2(
									$author$project$Portal$Share$withoutWaitingAction,
									$author$project$Complaint$Feedback$loadingComplaints(context.t),
									share),
								$author$project$Complaint$Feedback$Loaded(
									{
										r: context.r,
										m: _List_Nil,
										t: context.t,
										lW: {gg: '', m: _List_Nil, lW: $elm$core$Maybe$Nothing, f_: _List_Nil},
										aj: search,
										b7: $elm$core$Maybe$Nothing
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							var error = msg.a.a;
							return _Utils_Tuple3(
								A2(
									$author$project$Portal$Share$withHttpError,
									error,
									A2(
										$author$project$Portal$Share$withoutWaitingAction,
										$author$project$Complaint$Feedback$loadingComplaints(context.t),
										share)),
								$author$project$Complaint$Feedback$Failed(
									{r: context.r, t: context.t, aj: search}),
								$elm$core$Platform$Cmd$none);
						}
					}
				case 2:
					var lot = msg.a;
					var _v4 = A2($elm$core$List$member, lot, search.aN);
					if (_v4) {
						return _Utils_Tuple3(
							share,
							$author$project$Complaint$Feedback$withFilteredComplaints(
								A2(
									$author$project$Complaint$Feedback$withSearch,
									_Utils_update(
										search,
										{
											aN: A2(
												$elm$core$List$filter,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.eg;
													},
													$elm$core$Basics$neq(lot.eg)),
												search.aN)
										}),
									model)),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple3(
							share,
							$author$project$Complaint$Feedback$withFilteredComplaints(
								A2(
									$author$project$Complaint$Feedback$withSearch,
									_Utils_update(
										search,
										{
											aN: _Utils_ap(
												search.aN,
												_List_fromArray(
													[lot]))
										}),
									model)),
							$elm$core$Platform$Cmd$none);
					}
				case 3:
					return _Utils_Tuple3(
						share,
						A2(
							$author$project$Complaint$Feedback$withSearch,
							_Utils_update(
								search,
								{
									cd: function () {
										var _v5 = search.cd;
										if (_v5 === 1) {
											return 0;
										} else {
											return 1;
										}
									}()
								}),
							model),
						$elm$core$Platform$Cmd$none);
				case 4:
					var code = msg.a;
					var enabled = msg.b;
					return _Utils_Tuple3(
						share,
						$author$project$Complaint$Feedback$withFilteredComplaints(
							A2(
								$author$project$Complaint$Feedback$withSearch,
								function () {
									if (enabled) {
										return _Utils_update(
											search,
											{
												aB: _Utils_ap(
													search.aB,
													_List_fromArray(
														[code]))
											});
									} else {
										return _Utils_update(
											search,
											{
												aB: A2(
													$elm$core$List$filter,
													$elm$core$Basics$neq(code),
													search.aB)
											});
									}
								}(),
								model)),
						$elm$core$Platform$Cmd$none);
				case 5:
					var feedbackGiven = msg.a;
					return _Utils_Tuple3(
						share,
						$author$project$Complaint$Feedback$withFilteredComplaints(
							A2(
								$author$project$Complaint$Feedback$withSearch,
								_Utils_update(
									search,
									{bN: feedbackGiven}),
								model)),
						$elm$core$Platform$Cmd$none);
				case 6:
					var code = msg.a;
					return _Utils_Tuple3(
						share,
						function () {
							if (model.$ === 1) {
								var l = model.a;
								var feedback = l.lW;
								return $author$project$Complaint$Feedback$Loaded(
									_Utils_update(
										l,
										{
											lW: _Utils_update(
												feedback,
												{
													gg: '',
													lW: $elm$core$Maybe$Just(code)
												})
										}));
							} else {
								return model;
							}
						}(),
						$elm$core$Platform$Cmd$none);
				case 7:
					var comment = msg.a;
					return _Utils_Tuple3(
						share,
						function () {
							if (model.$ === 1) {
								var l = model.a;
								var feedback = l.lW;
								return $author$project$Complaint$Feedback$Loaded(
									_Utils_update(
										l,
										{
											lW: _Utils_update(
												feedback,
												{gg: comment})
										}));
							} else {
								return model;
							}
						}(),
						$elm$core$Platform$Cmd$none);
				case 10:
					var bool = msg.a;
					var _v9 = _Utils_Tuple2(model, bool);
					if (_v9.a.$ === 1) {
						if (_v9.b) {
							var l = _v9.a.a;
							var feedback = l.lW;
							return modelChange(
								$author$project$Complaint$Feedback$Loaded(
									_Utils_update(
										l,
										{
											lW: _Utils_update(
												feedback,
												{
													m: $author$project$Complaint$Feedback$selectAll(feedback.m)
												})
										})));
						} else {
							var l = _v9.a.a;
							var feedback = l.lW;
							return modelChange(
								$author$project$Complaint$Feedback$Loaded(
									_Utils_update(
										l,
										{
											lW: _Utils_update(
												feedback,
												{
													m: $author$project$Complaint$Feedback$unSelectAll(feedback.m)
												})
										})));
						}
					} else {
						return noChange;
					}
				case 11:
					var complaint = msg.a;
					var bool = msg.b;
					var _v10 = _Utils_Tuple2(model, bool);
					if (_v10.a.$ === 1) {
						if (_v10.b) {
							var l = _v10.a.a;
							var feedback = l.lW;
							return modelChange(
								$author$project$Complaint$Feedback$Loaded(
									_Utils_update(
										l,
										{
											lW: _Utils_update(
												feedback,
												{
													m: A3(
														$elm_community$list_extra$List$Extra$setIf,
														A2(
															$elm$core$Basics$composeR,
															$author$project$Complaint$Feedback$complaintOf,
															A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.eg;
																},
																$elm$core$Basics$eq(complaint.eg))),
														$author$project$Complaint$Feedback$Selected(complaint),
														feedback.m)
												})
										})));
						} else {
							var l = _v10.a.a;
							var feedback = l.lW;
							return modelChange(
								$author$project$Complaint$Feedback$Loaded(
									_Utils_update(
										l,
										{
											lW: _Utils_update(
												feedback,
												{
													m: A3(
														$elm_community$list_extra$List$Extra$setIf,
														A2(
															$elm$core$Basics$composeR,
															$author$project$Complaint$Feedback$complaintOf,
															A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.eg;
																},
																$elm$core$Basics$eq(complaint.eg))),
														$author$project$Complaint$Feedback$NotSelected(complaint),
														feedback.m)
												})
										})));
						}
					} else {
						return noChange;
					}
				case 12:
					var complaint = msg.a;
					if (model.$ === 1) {
						var l = model.a;
						var unfolded = l.b7;
						var _v12 = _Utils_Tuple2(
							unfolded,
							_Utils_eq(
								unfolded,
								$elm$core$Maybe$Just(complaint)));
						if (!_v12.a.$) {
							if (_v12.b) {
								return modelChange(
									$author$project$Complaint$Feedback$Loaded(
										_Utils_update(
											l,
											{b7: $elm$core$Maybe$Nothing})));
							} else {
								return modelChange(
									$author$project$Complaint$Feedback$Loaded(
										_Utils_update(
											l,
											{
												b7: $elm$core$Maybe$Just(complaint)
											})));
							}
						} else {
							var _v13 = _v12.a;
							return modelChange(
								$author$project$Complaint$Feedback$Loaded(
									_Utils_update(
										l,
										{
											b7: $elm$core$Maybe$Just(complaint)
										})));
						}
					} else {
						return noChange;
					}
				case 8:
					if (model.$ === 1) {
						var l = model.a;
						var feedback = l.lW;
						var _v15 = A2($arowM$elm_form_decoder$Form$Decoder$run, $author$project$Complaint$Feedback$feedbackFormDecoder, l.lW);
						if (!_v15.$) {
							var _v16 = _v15.a;
							var complaints = _v16.a;
							var code = _v16.b;
							var comment = _v16.c;
							return A3(
								withCommand,
								$author$project$Complaint$Feedback$settingFeedback,
								A5($author$project$Complaint$Feedback$setFeedbackCmd, token, code, comment, complaints, $author$project$Complaint$Feedback$SystemRespondedToSendingFeedback),
								modelChange(
									$author$project$Complaint$Feedback$Loaded(
										_Utils_update(
											l,
											{
												lW: _Utils_update(
													feedback,
													{f_: _List_Nil})
											}))));
						} else {
							var errors = _v15.a;
							return modelChange(
								$author$project$Complaint$Feedback$Loaded(
									_Utils_update(
										l,
										{
											lW: _Utils_update(
												feedback,
												{f_: errors})
										})));
						}
					} else {
						return noChange;
					}
				case 9:
					if (!msg.a.$) {
						return A2(
							$author$project$Portal$Return$withMessage,
							A2($author$project$Portal$Message$info, 'De terugkoppeling is verzonden', 'De terugkoppeling is verzonden en het overzicht bijgewerkt.'),
							A2(
								withoutAction,
								$author$project$Complaint$Feedback$settingFeedback,
								modelChange(
									$author$project$Complaint$Feedback$withFilteredComplaints(
										A2(
											$author$project$Complaint$Feedback$withSearch,
											{cd: 1, aB: _List_Nil, bN: false, aN: _List_Nil},
											$author$project$Complaint$Feedback$withFeedbackSet(model))))));
					} else {
						var error = msg.a.a;
						return _Utils_Tuple3(
							A2(
								$author$project$Portal$Share$withHttpError,
								error,
								A2(
									$author$project$Portal$Share$withoutWaitingAction,
									$author$project$Complaint$Feedback$settingFeedback(context.t),
									share)),
							model,
							$elm$core$Platform$Cmd$none);
					}
				default:
					return noChange;
			}
		}
	});
var $author$project$Complaint$Handle$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Complaint$Handle$SystemRespondedToHandlingComplaints = function (a) {
	return {$: 5, a: a};
};
var $author$project$Complaint$Handle$handleComplaintsCmd = F4(
	function (selected, role, token, toMsg) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'complaint',
					'handle',
					$author$project$Complaint$Handle$roleToString(role)
				]),
			_List_Nil);
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'complaints',
						A2(
							$elm$json$Json$Encode$list,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.eg;
								},
								$author$project$Complaint$Complaint$encodeId),
							selected))
					])));
		return A4($author$project$Api$Request$postWithoutResponse, token, toMsg, uri, body);
	});
var $author$project$Complaint$Handle$handlingComplaints = $author$project$Complaint$Handle$singleAction('loadingComplaints');
var $author$project$Complaint$Handle$selectedComplaints = function (structured) {
	return A2(
		$elm$core$List$filterMap,
		function (_v0) {
			var state = _v0.b4;
			var complaint = _v0.dX;
			var earlier = _v0.gr;
			if (state === 1) {
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(complaint, earlier));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		$elm$core$List$concat(
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$second,
				$elm$core$List$concat(
					A2($elm$core$List$map, $elm$core$Tuple$second, structured)))));
};
var $author$project$DistributionPoint$IdDict$fromList = $timo_weike$generic_collections$ManualDict$fromList($author$project$DistributionPoint$IdDict$toComparable);
var $elm_community$list_extra$List$Extra$groupWhile = F2(
	function (isSameGroup, items) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					if (!acc.b) {
						return _List_fromArray(
							[
								_Utils_Tuple2(x, _List_Nil)
							]);
					} else {
						var _v1 = acc.a;
						var y = _v1.a;
						var restOfGroup = _v1.b;
						var groups = acc.b;
						return A2(isSameGroup, x, y) ? A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								x,
								A2($elm$core$List$cons, y, restOfGroup)),
							groups) : A2(
							$elm$core$List$cons,
							_Utils_Tuple2(x, _List_Nil),
							acc);
					}
				}),
			_List_Nil,
			items);
	});
var $author$project$Address$Address$houseNumberView = function (_v0) {
	var number = _v0.bX;
	var suffix = _v0.dE;
	if (suffix.$ === 1) {
		return $elm$core$String$fromInt(number);
	} else {
		if (suffix.a === '') {
			return $elm$core$String$fromInt(number);
		} else {
			var s = suffix.a;
			return $elm$core$String$fromInt(number) + (' ' + s);
		}
	}
};
var $author$project$Complaint$Handle$sortComplaints = F2(
	function (_v0, _v1) {
		var dp1 = _v0.a;
		var complaint1 = _v0.b;
		var dp2 = _v1.a;
		var complaint2 = _v1.b;
		var toComparable = F2(
			function (dp, complaint) {
				return A2(
					$elm$core$String$join,
					'',
					_List_fromArray(
						[
							dp,
							complaint.fO.ft,
							complaint.m8.f1.bU,
							complaint.m8.f1.b5,
							$author$project$Address$Address$houseNumberView(complaint.m8.f1.bs)
						]));
			});
		var _v2 = A2(
			$elm$core$Basics$compare,
			A2(toComparable, dp1, complaint1),
			A2(toComparable, dp2, complaint2));
		if (_v2 === 1) {
			return A2(
				$justinmimbs$date$Date$compare,
				$author$project$Date$DeliveryDate$toDate(complaint2.lx),
				$author$project$Date$DeliveryDate$toDate(complaint1.lx));
		} else {
			var other = _v2;
			return other;
		}
	});
var $elm$core$List$sortWith = _List_sortWith;
var $author$project$Complaint$Handle$Selectable = 0;
var $author$project$Complaint$Handle$toSelectable = function (_v0) {
	var complaint = _v0.a;
	var earlier = _v0.b;
	return {dX: complaint, gr: earlier, b4: 0};
};
var $author$project$Complaint$Handle$toStructuredComplaints = F2(
	function (dps, complaints) {
		var toComparable = function (c) {
			return A2(
				$elm$core$String$join,
				'',
				_List_fromArray(
					[
						c.m8.f1.bU,
						c.m8.f1.b5,
						c.m8.f1.cT,
						$author$project$Address$Address$houseNumberView(c.m8.f1.bs),
						c.m8.jJ,
						c.m8.ir
					]));
		};
		var dpDict = $author$project$DistributionPoint$IdDict$fromList(
			$author$project$DistributionPoint$DistributionPoint$toIdAndName(dps));
		var withDP = function (c) {
			var _v4 = c.bn;
			if (!_v4.$) {
				var dpId = _v4.a;
				var _v5 = A2($author$project$DistributionPoint$IdDict$get, dpId, dpDict);
				if (!_v5.$) {
					var dp = _v5.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(dp, c));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		var withDpName = function (cmplnts) {
			return $elm_community$maybe_extra$Maybe$Extra$values(
				A2($elm$core$List$map, withDP, cmplnts));
		};
		return A2(
			$elm$core$List$map,
			function (_v2) {
				var head = _v2.a;
				var rest = _v2.b;
				return _Utils_Tuple2(
					head.a,
					A2(
						$elm$core$List$map,
						function (_v3) {
							var h = _v3.a;
							var r = _v3.b;
							return _Utils_Tuple2(
								h.fO,
								A2(
									$elm$core$List$map,
									$author$project$Complaint$Handle$toSelectable,
									A2(
										$elm_community$list_extra$List$Extra$groupWhile,
										F2(
											function (a, b) {
												return _Utils_eq(
													toComparable(a),
													toComparable(b));
											}),
										A2($elm$core$List$cons, h, r))));
						},
						A2(
							$elm_community$list_extra$List$Extra$groupWhile,
							F2(
								function (a, b) {
									return _Utils_eq(a.fO.ft, b.fO.ft);
								}),
							A2(
								$elm$core$List$map,
								$elm$core$Tuple$second,
								A2($elm$core$List$cons, head, rest)))));
			},
			A2(
				$elm_community$list_extra$List$Extra$groupWhile,
				F2(
					function (_v0, _v1) {
						var dp1 = _v0.a;
						var dp2 = _v1.a;
						return _Utils_eq(dp1, dp2);
					}),
				A2(
					$elm$core$List$sortWith,
					$author$project$Complaint$Handle$sortComplaints,
					withDpName(complaints))));
	});
var $author$project$Complaint$Handle$Selected = 1;
var $author$project$Complaint$Handle$withoutSelectedComplaints = function (structured) {
	return A2(
		$elm$core$List$filterMap,
		function (_v0) {
			var dp = _v0.a;
			var segmentComplaints = _v0.b;
			var _v1 = A2(
				$elm$core$List$filterMap,
				function (_v2) {
					var segment = _v2.a;
					var complaints = _v2.b;
					var _v3 = A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.b4;
							},
							$elm$core$Basics$neq(1)),
						complaints);
					if (!_v3.b) {
						return $elm$core$Maybe$Nothing;
					} else {
						var nonSelectedComplaints = _v3;
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(segment, nonSelectedComplaints));
					}
				},
				segmentComplaints);
			if (!_v1.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var withComplaints = _v1;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(dp, withComplaints));
			}
		},
		structured);
};
var $author$project$Complaint$Handle$update = F3(
	function (msg, share, model) {
		var withCommand = function (toAction) {
			return $author$project$Portal$Return$withCommand(
				toAction(0));
		};
		var token = $author$project$Portal$Share$token(share);
		var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		var modelChange = function (m) {
			return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
		};
		var err = F3(
			function (action, error, m) {
				return _Utils_Tuple3(
					A2(
						$author$project$Portal$Share$withHttpError,
						error,
						A2($author$project$Portal$Share$withoutWaitingAction, action, share)),
					m,
					$elm$core$Platform$Cmd$none);
			});
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var dps = msg.a.a;
					if (!model.$) {
						var role = model.b;
						return A3(
							withCommand,
							$author$project$Complaint$Handle$loadingComplaints,
							A4($author$project$Complaint$Handle$loadComplaintsCmd, dps, role, token, $author$project$Complaint$Handle$SystemGotComplaints),
							A2(
								$author$project$Portal$Return$withoutAction,
								$author$project$Complaint$Handle$loadingDPs(0),
								modelChange(
									A2(
										$author$project$Complaint$Handle$Loading,
										$elm$core$Maybe$Just(dps),
										role))));
					} else {
						return noChange;
					}
				} else {
					var error = msg.a.a;
					return A3(
						err,
						$author$project$Complaint$Handle$loadingDPs(0),
						error,
						$author$project$Complaint$Handle$Failed);
				}
			case 1:
				if (!msg.a.$) {
					var complaints = msg.a.a;
					if ((!model.$) && (!model.a.$)) {
						var dps = model.a.a;
						var role = model.b;
						return A2(
							$author$project$Portal$Return$withoutAction,
							$author$project$Complaint$Handle$loadingComplaints(0),
							modelChange(
								$author$project$Complaint$Handle$Loaded(
									{
										m: A2($author$project$Complaint$Handle$toStructuredComplaints, dps, complaints),
										cz: role
									})));
					} else {
						return noChange;
					}
				} else {
					if ((msg.a.a.$ === 3) && (msg.a.a.a === 404)) {
						if ((!model.$) && (!model.a.$)) {
							var role = model.b;
							return A2(
								$author$project$Portal$Return$withoutAction,
								$author$project$Complaint$Handle$loadingComplaints(0),
								modelChange(
									$author$project$Complaint$Handle$Loaded(
										{m: _List_Nil, cz: role})));
						} else {
							return noChange;
						}
					} else {
						var error = msg.a.a;
						return A3(
							err,
							$author$project$Complaint$Handle$loadingComplaints(0),
							error,
							$author$project$Complaint$Handle$Failed);
					}
				}
			case 2:
				var state = msg.a;
				var complaint = msg.b;
				if (model.$ === 1) {
					var complaints = model.a.m;
					var role = model.a.cz;
					var setComplaintState = function (complaintWithState) {
						return _Utils_eq(complaint.eg, complaintWithState.dX.eg) ? _Utils_update(
							complaintWithState,
							{b4: state}) : complaintWithState;
					};
					var setSegmentComplaints = function (_v6) {
						var segment = _v6.a;
						var cs = _v6.b;
						return _Utils_Tuple2(
							segment,
							A2($elm$core$List$map, setComplaintState, cs));
					};
					var setDpComplaintState = function (_v5) {
						var dp = _v5.a;
						var complaintsPerSegment = _v5.b;
						return _Utils_Tuple2(
							dp,
							A2($elm$core$List$map, setSegmentComplaints, complaintsPerSegment));
					};
					return modelChange(
						$author$project$Complaint$Handle$Loaded(
							{
								m: A2($elm$core$List$map, setDpComplaintState, complaints),
								cz: role
							}));
				} else {
					return noChange;
				}
			case 3:
				var state = msg.a;
				var segment = msg.b;
				if (model.$ === 1) {
					var complaints = model.a.m;
					var role = model.a.cz;
					var setSegmentComplaints = function (_v9) {
						var s = _v9.a;
						var complaintsWithState = _v9.b;
						return _Utils_eq(segment.ft, s.ft) ? _Utils_Tuple2(
							s,
							A2(
								$elm$core$List$map,
								function (complaintWithState) {
									return _Utils_update(
										complaintWithState,
										{b4: state});
								},
								complaintsWithState)) : _Utils_Tuple2(s, complaintsWithState);
					};
					var setDpComplaintState = function (_v8) {
						var dp = _v8.a;
						var complaintsPerSegment = _v8.b;
						return _Utils_Tuple2(
							dp,
							A2($elm$core$List$map, setSegmentComplaints, complaintsPerSegment));
					};
					return modelChange(
						$author$project$Complaint$Handle$Loaded(
							{
								m: A2($elm$core$List$map, setDpComplaintState, complaints),
								cz: role
							}));
				} else {
					return noChange;
				}
			case 4:
				if (model.$ === 1) {
					var complaints = model.a.m;
					var role = model.a.cz;
					var selected = $elm$core$List$concat(
						A2(
							$elm$core$List$map,
							function (_v11) {
								var complaint = _v11.a;
								var earlierComplaints = _v11.b;
								return A2($elm$core$List$cons, complaint, earlierComplaints);
							},
							$author$project$Complaint$Handle$selectedComplaints(complaints)));
					return A3(
						withCommand,
						$author$project$Complaint$Handle$handlingComplaints,
						A4($author$project$Complaint$Handle$handleComplaintsCmd, selected, role, token, $author$project$Complaint$Handle$SystemRespondedToHandlingComplaints),
						noChange);
				} else {
					return noChange;
				}
			case 5:
				if (!msg.a.$) {
					if (model.$ === 1) {
						var complaints = model.a.m;
						var role = model.a.cz;
						return A2(
							$author$project$Portal$Return$withoutAction,
							$author$project$Complaint$Handle$handlingComplaints(0),
							modelChange(
								$author$project$Complaint$Handle$Loaded(
									{
										m: $author$project$Complaint$Handle$withoutSelectedComplaints(complaints),
										cz: role
									})));
					} else {
						return noChange;
					}
				} else {
					var error = msg.a.a;
					return A3(
						err,
						$author$project$Complaint$Handle$handlingComplaints(0),
						error,
						model);
				}
			default:
				return noChange;
		}
	});
var $author$project$Count$Count$AmountsLoadFailed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Count$Count$GotSubHeaderMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Count$Count$ShowingProducts = function (a) {
	return {$: 1, a: a};
};
var $author$project$Count$Count$amountsShowing = function (orderAmounts) {
	if (orderAmounts.$ === 1) {
		var l = orderAmounts.a;
		var showing = l.y;
		var amountByProductOrInsert = l.aY;
		if (!showing.$) {
			var a = showing.a;
			var _v2 = A2($elm$core$Dict$get, a.av, amountByProductOrInsert);
			if (!_v2.$) {
				var amounts = _v2.a;
				return $elm$core$Maybe$Just(
					_Utils_Tuple3(l, a, amounts));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$DistributionPoint$IdDict$insert = $timo_weike$generic_collections$ManualDict$insert($author$project$DistributionPoint$IdDict$toComparable);
var $author$project$Count$Count$insertInto = F4(
	function (done, bundleConfig, id, index) {
		switch (bundleConfig.$) {
			case 0:
				return A2(
					$elm$core$Set$insert,
					_Utils_Tuple3(id, index, 0),
					done);
			case 2:
				return A2(
					$elm$core$Set$insert,
					_Utils_Tuple3(id, index, 1),
					A2(
						$elm$core$Set$insert,
						_Utils_Tuple3(id, index, 0),
						done));
			default:
				return A2(
					$elm$core$Set$insert,
					_Utils_Tuple3(id, index, 1),
					done);
		}
	});
var $author$project$Count$Count$isDone = F4(
	function (done, config, id, index) {
		switch (config.$) {
			case 0:
				return A2(
					$elm$core$Set$member,
					_Utils_Tuple3(id, index, 0),
					done);
			case 2:
				return A2(
					$elm$core$Set$member,
					_Utils_Tuple3(id, index, 0),
					done) && A2(
					$elm$core$Set$member,
					_Utils_Tuple3(id, index, 1),
					done);
			default:
				return A2(
					$elm$core$Set$member,
					_Utils_Tuple3(id, index, 1),
					done);
		}
	});
var $author$project$DistributionPoint$IdDict$isEmpty = $timo_weike$generic_collections$ManualDict$isEmpty;
var $author$project$Count$Count$nextIndex = F3(
	function (options, clusters, index) {
		var _v0 = A2(
			$elm$core$List$partition,
			function (i) {
				return _Utils_cmp(i, index) < 1;
			},
			A2($author$project$Count$Count$validIndexesFor, options, clusters));
		if (_v0.b.b) {
			var _v1 = _v0.b;
			var head = _v1.a;
			return $elm$core$Maybe$Just(head);
		} else {
			if (_v0.a.b) {
				var _v2 = _v0.a;
				var head = _v2.a;
				return $elm$core$Maybe$Just(head);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$Count$Count$previousIndex = F3(
	function (options, clusters, index) {
		var _v0 = A2(
			$elm$core$List$partition,
			function (i) {
				return _Utils_cmp(i, index) > -1;
			},
			$elm$core$List$reverse(
				A2($author$project$Count$Count$validIndexesFor, options, clusters)));
		if (_v0.b.b) {
			var _v1 = _v0.b;
			var head = _v1.a;
			return $elm$core$Maybe$Just(head);
		} else {
			if (_v0.a.b) {
				var _v2 = _v0.a;
				var head = _v2.a;
				return $elm$core$Maybe$Just(head);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$Plan$PlanLoader$registerErrorOnFailed = function (origin) {
	var share = origin.a;
	var model = origin.b;
	var cmd = origin.c;
	if (model.$ === 4) {
		var err = model.a;
		return _Utils_Tuple3(
			A2($author$project$Portal$Share$withHttpError, err, share),
			model,
			cmd);
	} else {
		return origin;
	}
};
var $elm$core$Set$remove = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$remove, key, dict);
	});
var $author$project$Count$Count$removeFrom = F4(
	function (done, bundleConfig, id, index) {
		switch (bundleConfig.$) {
			case 0:
				return A2(
					$elm$core$Set$remove,
					_Utils_Tuple3(id, index, 0),
					done);
			case 2:
				return A2(
					$elm$core$Set$remove,
					_Utils_Tuple3(id, index, 1),
					A2(
						$elm$core$Set$remove,
						_Utils_Tuple3(id, index, 0),
						done));
			default:
				return A2(
					$elm$core$Set$remove,
					_Utils_Tuple3(id, index, 1),
					done);
		}
	});
var $author$project$Count$Count$whenWaiting = function (msg) {
	switch (msg.$) {
		case 0:
			return 0;
		case 1:
			return 0;
		case 2:
			return 0;
		case 3:
			return 0;
		case 4:
			return 0;
		case 5:
			return 1;
		case 6:
			return 0;
		case 7:
			return 1;
		case 8:
			return 1;
		case 9:
			return 1;
		case 10:
			return 1;
		case 11:
			return 1;
		case 12:
			return 1;
		case 13:
			return 1;
		case 14:
			return 1;
		case 15:
			return 1;
		default:
			return 0;
	}
};
var $author$project$Portal$Return$withCommands = F3(
	function (toAction, toCmds, _v0) {
		var s = _v0.a;
		var m = _v0.b;
		var c = _v0.c;
		return function (_v1) {
			var actions = _v1.a;
			var cmds = _v1.b;
			return _Utils_Tuple3(
				A2($author$project$Portal$Share$withWaitingActions, actions, s),
				m,
				$elm$core$Platform$Cmd$batch(
					A2($elm$core$List$cons, c, cmds)));
		}(
			$elm$core$List$unzip(
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, toCmd) {
							var action = toAction(index);
							return _Utils_Tuple2(
								action,
								A2(
									toCmd,
									index,
									$author$project$Api$Request$Tracked(
										$author$project$Portal$Waiting$name(action))));
						}),
					toCmds)));
	});
var $author$project$Count$Count$withOptions = F2(
	function (options, model) {
		var orderAmounts = model.j;
		var _v0 = $author$project$Count$Count$amountsShowing(orderAmounts);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var loaded = _v1.a;
			var showing = loaded.y;
			var selectedAmount = _v1.b;
			var clusterIndex = selectedAmount.v;
			var amounts = _v1.c;
			if (!clusterIndex.$) {
				var i = clusterIndex.a;
				return A2(
					$elm$core$List$member,
					i,
					A2($author$project$Count$Count$validIndexesFor, options, amounts)) ? _Utils_update(
					model,
					{m7: options}) : _Utils_update(
					model,
					{
						m7: options,
						j: $author$project$Count$Count$AmountsLoaded(
							_Utils_update(
								loaded,
								{
									y: $author$project$Count$Count$ShowingAmount(
										_Utils_update(
											selectedAmount,
											{
												v: A3($author$project$Count$Count$previousIndex, options, amounts, i)
											}))
								}))
					});
			} else {
				return _Utils_update(
					model,
					{
						m7: options,
						j: $author$project$Count$Count$AmountsLoaded(
							_Utils_update(
								loaded,
								{
									y: $author$project$Count$Count$ShowingAmount(
										_Utils_update(
											selectedAmount,
											{
												v: A2($author$project$Count$Count$firstValidIndex, options, amounts)
											}))
								}))
					});
			}
		} else {
			return _Utils_update(
				model,
				{m7: options});
		}
	});
var $author$project$Count$Count$update = F3(
	function (msg, share, model) {
		var planId = model.a8;
		var options = model.m7;
		var orderAmounts = model.j;
		return A2(
			$author$project$Portal$Return$ensureDataShared,
			$author$project$Count$Count$shareDataFromModel,
			function () {
				var withoutIndexedAction = F2(
					function (toAction, index) {
						return $author$project$Portal$Return$withoutAction(
							A2(toAction, planId, index));
					});
				var withoutAction = function (toAction) {
					return $author$project$Portal$Return$withoutAction(
						toAction(planId));
				};
				var withCommands = function (toAction) {
					return $author$project$Portal$Return$withCommands(
						toAction(planId));
				};
				var token = $author$project$Portal$Share$token(share);
				var to = function (route) {
					return _Utils_Tuple3(
						A2($author$project$Portal$Share$withNewRoute, route, share),
						model,
						$elm$core$Platform$Cmd$none);
				};
				var nxt = A2($author$project$Count$Count$next, planId.lx, options);
				var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
				var modelChange = function (m) {
					return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
				};
				var errIndexed = F4(
					function (action, index, error, m) {
						return _Utils_Tuple3(
							A2(
								$author$project$Portal$Share$withHttpError,
								error,
								A2(
									$author$project$Portal$Share$withoutWaitingAction,
									A2(action, planId, index),
									share)),
							m,
							$elm$core$Platform$Cmd$none);
					});
				var err = F3(
					function (toAction, error, m) {
						return _Utils_Tuple3(
							A2(
								$author$project$Portal$Share$withHttpError,
								error,
								A2(
									$author$project$Portal$Share$withoutWaitingAction,
									toAction(planId),
									share)),
							m,
							$elm$core$Platform$Cmd$none);
					});
				if (A3($author$project$Portal$Share$allowed, $author$project$Count$Count$whenWaiting, msg, share) === 1) {
					return noChange;
				} else {
					switch (msg.$) {
						case 0:
							if (!msg.a.$) {
								var distributionPoint = msg.a.a;
								return A2(
									withoutAction,
									$author$project$Count$Count$loadingDP,
									function () {
										if (!orderAmounts.$) {
											var loadState = orderAmounts.a;
											return function () {
												var _v2 = _Utils_Tuple2(
													$author$project$DistributionPoint$IdDict$isEmpty(loadState.bm),
													$author$project$DistributionPoint$DistributionPoint$getSubDistributionPoints(distributionPoint));
												if (_v2.a && _v2.b.b) {
													var subDPs = _v2.b;
													return A2(
														withCommands,
														$author$project$Count$Count$loadingSummaries,
														A2(
															$elm$core$List$map,
															F2(
																function (subDP, i) {
																	return A4(
																		$author$project$Demand$Summary$loadForDPCmd,
																		token,
																		$author$project$Count$Count$BackendRespondedDemandSummary(i),
																		$author$project$DistributionPoint$DistributionPoint$idOf(subDP),
																		model.a8.lx);
																}),
															subDPs));
												} else {
													return $elm$core$Basics$identity;
												}
											}()(
												modelChange(
													_Utils_update(
														model,
														{
															j: nxt(
																_Utils_update(
																	loadState,
																	{
																		bn: $elm$core$Maybe$Just(distributionPoint)
																	}))
														})));
										} else {
											return noChange;
										}
									}());
							} else {
								var error = msg.a.a;
								return A3(
									err,
									$author$project$Count$Count$loadingDP,
									error,
									_Utils_update(
										model,
										{
											j: $author$project$Count$Count$AmountsLoadFailed(error)
										}));
							}
						case 1:
							var planLoaderMsg = msg.a;
							if (!orderAmounts.$) {
								var loadState = orderAmounts.a;
								return A2(
									$author$project$Plan$PlanLoader$mapModel,
									function (pAndD) {
										return _Utils_update(
											model,
											{
												j: nxt(
													_Utils_update(
														loadState,
														{fB: pAndD}))
											});
									},
									$author$project$Plan$PlanLoader$registerErrorOnFailed(
										A2(
											$author$project$Plan$PlanLoader$mapCommand,
											$elm$core$Platform$Cmd$map($author$project$Count$Count$SystemGotLoaderMsg),
											A6(
												$author$project$Plan$PlanLoader$update,
												share,
												token,
												$author$project$Count$Count$loadingPlan(model.a8),
												$elm$core$Basics$identity,
												planLoaderMsg,
												loadState.fB))));
							} else {
								return noChange;
							}
						case 2:
							if (!msg.a.$) {
								var orders = msg.a.a;
								return A2(
									withoutAction,
									$author$project$Count$Count$loadingOrders,
									function () {
										if (!orderAmounts.$) {
											var loadState = orderAmounts.a;
											return modelChange(
												_Utils_update(
													model,
													{
														j: nxt(
															_Utils_update(
																loadState,
																{
																	Y: $elm$core$Maybe$Just(orders)
																}))
													}));
										} else {
											return noChange;
										}
									}());
							} else {
								var error = msg.a.a;
								return A3(
									err,
									$author$project$Count$Count$loadingOrders,
									error,
									_Utils_update(
										model,
										{
											j: $author$project$Count$Count$AmountsLoadFailed(error)
										}));
							}
						case 4:
							if (!msg.a.$) {
								var products = msg.a.a;
								return A2(
									withoutAction,
									$author$project$Count$Count$loadingProducts,
									function () {
										if (!orderAmounts.$) {
											var loadState = orderAmounts.a;
											return modelChange(
												_Utils_update(
													model,
													{
														j: nxt(
															_Utils_update(
																loadState,
																{
																	bu: $elm$core$Maybe$Just(products)
																}))
													}));
										} else {
											return noChange;
										}
									}());
							} else {
								var error = msg.a.a;
								return A3(
									err,
									$author$project$Count$Count$loadingProducts,
									error,
									_Utils_update(
										model,
										{
											j: $author$project$Count$Count$AmountsLoadFailed(error)
										}));
							}
						case 3:
							if (!msg.b.$) {
								var index = msg.a;
								var demandSummaryForDP = msg.b.a;
								return A3(
									withoutIndexedAction,
									$author$project$Count$Count$loadingSummaries,
									index,
									function () {
										if (!orderAmounts.$) {
											var loadState = orderAmounts.a;
											return modelChange(
												function (s) {
													return _Utils_update(
														model,
														{
															j: nxt(
																_Utils_update(
																	loadState,
																	{bm: s}))
														});
												}(
													A3($author$project$DistributionPoint$IdDict$insert, demandSummaryForDP.lK, demandSummaryForDP, loadState.bm)));
										} else {
											return noChange;
										}
									}());
							} else {
								var index = msg.a;
								var error = msg.b.a;
								if ((error.$ === 3) && (error.a === 404)) {
									return A3(
										withoutIndexedAction,
										$author$project$Count$Count$loadingSummaries,
										index,
										function () {
											if (!orderAmounts.$) {
												var loadState = orderAmounts.a;
												return modelChange(
													function (ls) {
														return _Utils_update(
															model,
															{
																j: nxt(ls)
															});
													}(
														_Utils_update(
															loadState,
															{
																b6: A2($elm$core$List$cons, error, loadState.b6)
															})));
											} else {
												return noChange;
											}
										}());
								} else {
									return A4(
										errIndexed,
										$author$project$Count$Count$loadingSummaries,
										index,
										error,
										_Utils_update(
											model,
											{
												j: $author$project$Count$Count$AmountsLoadFailed(error)
											}));
								}
							}
						case 5:
							var dpId = msg.a;
							return to(
								A2($author$project$Portal$Route$CreatePlan, dpId, model.a8.lx));
						case 6:
							var subHeaderMsg = msg.a;
							var _v9 = A5(
								$author$project$Portal$Subheader$update,
								subHeaderMsg,
								share,
								$elm$core$Maybe$Just(planId.gm),
								planId.lx,
								model.r);
							switch (_v9.a.$) {
								case 0:
									var _v10 = _v9.a;
									var _v11 = _v9.b;
									var s = _v11.a;
									var m = _v11.b;
									var cmd = _v11.c;
									return _Utils_Tuple3(
										s,
										_Utils_update(
											model,
											{r: m}),
										A2($elm$core$Platform$Cmd$map, $author$project$Count$Count$GotSubHeaderMsg, cmd));
								case 1:
									var date = _v9.a.a;
									return to(
										A2($author$project$Portal$Route$Count, planId.gm, date));
								default:
									return noChange;
							}
						case 8:
							var _v12 = $author$project$Count$Count$amountsShowing(orderAmounts);
							if (!_v12.$) {
								var _v13 = _v12.a;
								var loaded = _v13.a;
								var showing = loaded.y;
								var amountByProductOrInsert = loaded.aY;
								var done = loaded.a3;
								var amount = _v13.b;
								var amounts = _v13.c;
								return modelChange(
									_Utils_update(
										model,
										{
											j: $author$project$Count$Count$AmountsLoaded(
												_Utils_update(
													loaded,
													{
														a3: A2(
															$elm$core$Maybe$withDefault,
															done,
															A2(
																$elm$core$Maybe$map,
																A3($author$project$Count$Count$insertInto, done, options.ag, amount.av),
																amount.v)),
														y: $author$project$Count$Count$ShowingAmount(
															_Utils_update(
																amount,
																{
																	v: A2(
																		$elm$core$Maybe$andThen,
																		A2($author$project$Count$Count$nextIndex, options, amounts),
																		amount.v)
																}))
													}))
										}));
							} else {
								return noChange;
							}
						case 7:
							var _v14 = $author$project$Count$Count$amountsShowing(orderAmounts);
							if (!_v14.$) {
								var _v15 = _v14.a;
								var loaded = _v15.a;
								var showing = loaded.y;
								var amountByProductOrInsert = loaded.aY;
								var done = loaded.a3;
								var amount = _v15.b;
								var amounts = _v15.c;
								return modelChange(
									_Utils_update(
										model,
										{
											j: $author$project$Count$Count$AmountsLoaded(
												_Utils_update(
													loaded,
													{
														a3: A2(
															$elm$core$Maybe$withDefault,
															done,
															A2(
																$elm$core$Maybe$map,
																A3($author$project$Count$Count$insertInto, done, options.ag, amount.av),
																amount.v)),
														y: $author$project$Count$Count$ShowingAmount(
															_Utils_update(
																amount,
																{
																	v: A2(
																		$elm$core$Maybe$andThen,
																		A2($author$project$Count$Count$previousIndex, options, amounts),
																		amount.v)
																}))
													}))
										}));
							} else {
								return noChange;
							}
						case 9:
							var _v16 = $author$project$Count$Count$amountsShowing(orderAmounts);
							if (!_v16.$) {
								var _v17 = _v16.a;
								var loaded = _v17.a;
								var showing = loaded.y;
								var amountByProductOrInsert = loaded.aY;
								var done = loaded.a3;
								var amount = _v17.b;
								var amounts = _v17.c;
								return modelChange(
									_Utils_update(
										model,
										{
											j: $author$project$Count$Count$AmountsLoaded(
												_Utils_update(
													loaded,
													{
														y: $author$project$Count$Count$ShowingAmount(
															_Utils_update(
																amount,
																{
																	v: A2(
																		$elm$core$Maybe$andThen,
																		A2($author$project$Count$Count$nextIndex, options, amounts),
																		amount.v)
																}))
													}))
										}));
							} else {
								return noChange;
							}
						case 10:
							var _v18 = $author$project$Count$Count$amountsShowing(orderAmounts);
							if (!_v18.$) {
								var _v19 = _v18.a;
								var loaded = _v19.a;
								var showing = loaded.y;
								var amountByProductOrInsert = loaded.aY;
								var done = loaded.a3;
								var amount = _v19.b;
								var amounts = _v19.c;
								return modelChange(
									_Utils_update(
										model,
										{
											j: $author$project$Count$Count$AmountsLoaded(
												_Utils_update(
													loaded,
													{
														y: $author$project$Count$Count$ShowingAmount(
															_Utils_update(
																amount,
																{
																	v: A2(
																		$elm$core$Maybe$andThen,
																		A2($author$project$Count$Count$previousIndex, options, amounts),
																		amount.v)
																}))
													}))
										}));
							} else {
								return noChange;
							}
						case 12:
							if (orderAmounts.$ === 1) {
								var loaded = orderAmounts.a;
								var showing = loaded.y;
								if (!showing.$) {
									var amount = showing.a;
									return modelChange(
										_Utils_update(
											model,
											{
												j: $author$project$Count$Count$AmountsLoaded(
													_Utils_update(
														loaded,
														{
															y: $author$project$Count$Count$ShowingProducts(amount)
														}))
											}));
								} else {
									return noChange;
								}
							} else {
								return noChange;
							}
						case 13:
							var id = msg.a;
							if (orderAmounts.$ === 1) {
								var loaded = orderAmounts.a;
								var _v23 = A2($elm$core$Dict$get, id, loaded.aY);
								if (!_v23.$) {
									var amounts = _v23.a;
									return modelChange(
										_Utils_update(
											model,
											{
												j: $author$project$Count$Count$AmountsLoaded(
													_Utils_update(
														loaded,
														{
															y: $author$project$Count$Count$ShowingAmount(
																{
																	v: A2($author$project$Count$Count$firstValidIndex, options, amounts),
																	av: id
																})
														}))
											}));
								} else {
									return modelChange(
										_Utils_update(
											model,
											{
												j: $author$project$Count$Count$AmountsLoaded(
													_Utils_update(
														loaded,
														{
															y: $author$project$Count$Count$ShowingAmount(
																{v: $elm$core$Maybe$Nothing, av: id})
														}))
											}));
								}
							} else {
								return noChange;
							}
						case 14:
							var packsOrIndividual = msg.a;
							return modelChange(
								A2(
									$author$project$Count$Count$withOptions,
									_Utils_update(
										options,
										{ag: packsOrIndividual}),
									model));
						case 15:
							var zeroVisibility = msg.a;
							return modelChange(
								A2(
									$author$project$Count$Count$withOptions,
									_Utils_update(
										options,
										{eH: zeroVisibility}),
									model));
						case 11:
							var _v24 = $author$project$Count$Count$amountsShowing(orderAmounts);
							if (!_v24.$) {
								var _v25 = _v24.a;
								var loaded = _v25.a;
								var showing = loaded.y;
								var amountByProductOrInsert = loaded.aY;
								var done = loaded.a3;
								var amount = _v25.b;
								var calculatedDone = function () {
									var _v26 = amount.v;
									if (!_v26.$) {
										var i = _v26.a;
										return A4($author$project$Count$Count$isDone, done, options.ag, amount.av, i) ? A4($author$project$Count$Count$removeFrom, done, options.ag, amount.av, i) : A4($author$project$Count$Count$insertInto, done, options.ag, amount.av, i);
									} else {
										return done;
									}
								}();
								return modelChange(
									_Utils_update(
										model,
										{
											j: $author$project$Count$Count$AmountsLoaded(
												_Utils_update(
													loaded,
													{a3: calculatedDone}))
										}));
							} else {
								return noChange;
							}
						default:
							return to(
								A2($author$project$Portal$Route$DayPlanning, planId.gm, planId.lx));
					}
				}
			}());
	});
var $author$project$Dashboard$Dashboard$ConfirmingDelete = function (a) {
	return {$: 1, a: a};
};
var $author$project$Dashboard$Dashboard$Deleting = function (a) {
	return {$: 2, a: a};
};
var $author$project$Dashboard$Dashboard$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Dashboard$Dashboard$Loading = {$: 0};
var $author$project$Dashboard$Dashboard$Manage = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Dashboard$Dashboard$NotDeleting = {$: 0};
var $author$project$Dashboard$Dashboard$SystemCreatedBanner = function (a) {
	return {$: 13, a: a};
};
var $author$project$Dashboard$Dashboard$SystemDeletedBanner = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Dashboard$Dashboard$SystemGotBanners = function (a) {
	return {$: 3, a: a};
};
var $author$project$Dashboard$Dashboard$UserSelectedFile = function (a) {
	return {$: 9, a: a};
};
var $author$project$Dashboard$Dashboard$FileRequired = 0;
var $author$project$Dashboard$Dashboard$fileDecoder = $arowM$elm_form_decoder$Form$Decoder$custom(
	$elm$core$Result$fromMaybe(
		_List_fromArray(
			[0])));
var $author$project$Dashboard$Dashboard$defaultTimeZone = $justinmimbs$timezone_data$TimeZone$europe__amsterdam(0);
var $arowM$elm_form_decoder$Form$Decoder$map2 = F3(
	function (f, d1, d2) {
		return A2(
			$arowM$elm_form_decoder$Form$Decoder$field,
			d2,
			A2(
				$arowM$elm_form_decoder$Form$Decoder$field,
				d1,
				$arowM$elm_form_decoder$Form$Decoder$top(f)));
	});
var $author$project$Dashboard$Dashboard$DateRequired = 2;
var $author$project$Dashboard$Dashboard$publicationDateDecoder = $arowM$elm_form_decoder$Form$Decoder$custom(
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Result$fromMaybe(
			_List_fromArray(
				[2])),
		$author$project$Date$DeliveryDate$fromString));
var $author$project$Dashboard$Dashboard$TimeRequired = 1;
var $author$project$Date$TimeInDay$checkHour = function (hour) {
	return ((hour >= 0) && (hour < 24)) ? $elm$parser$Parser$succeed(hour) : $elm$parser$Parser$problem('een uur is een waarde van 0 tot en met 23');
};
var $author$project$Date$TimeInDay$checkMinute = function (minute) {
	return ((minute >= 0) && (minute < 60)) ? $elm$parser$Parser$succeed(minute) : $elm$parser$Parser$problem('een minuut is een waarde van 0 tot en met 59');
};
var $author$project$Date$TimeInDay$oneOrTwoDigits = A2(
	$elm$parser$Parser$andThen,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$toInt,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$parser$Parser$succeed),
			$elm$core$Maybe$withDefault(
				$elm$parser$Parser$problem('een of twee getallen worden verwacht')))),
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$chompIf($elm$core$Char$isDigit),
						$elm$parser$Parser$succeed(0)
					])))));
var $author$project$Date$TimeInDay$twoDigits = A2(
	$elm$parser$Parser$andThen,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$toInt,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$parser$Parser$succeed),
			$elm$core$Maybe$withDefault(
				$elm$parser$Parser$problem('twee getallen worden verwacht')))),
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit))));
var $author$project$Date$TimeInDay$parser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed(
			F2(
				function (h, m) {
					return {me: h, mH: m};
				})),
		A2(
			$elm$parser$Parser$ignorer,
			A2($elm$parser$Parser$andThen, $author$project$Date$TimeInDay$checkHour, $author$project$Date$TimeInDay$oneOrTwoDigits),
			$elm$parser$Parser$symbol(':'))),
	A2(
		$elm$parser$Parser$ignorer,
		A2($elm$parser$Parser$andThen, $author$project$Date$TimeInDay$checkMinute, $author$project$Date$TimeInDay$twoDigits),
		$elm$parser$Parser$end));
var $author$project$Dashboard$Dashboard$publicationTimeDecoder = $arowM$elm_form_decoder$Form$Decoder$custom(
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Result$mapError(
			$elm$core$Basics$always(
				_List_fromArray(
					[1]))),
		$elm$parser$Parser$run($author$project$Date$TimeInDay$parser)));
var $author$project$Dashboard$Dashboard$publicationDecoder = A3(
	$arowM$elm_form_decoder$Form$Decoder$map2,
	F2(
		function (date, time) {
			return A3($author$project$Date$DeliveryDate$toPosix, $author$project$Dashboard$Dashboard$defaultTimeZone, time, date);
		}),
	A2(
		$arowM$elm_form_decoder$Form$Decoder$lift,
		function ($) {
			return $.lx;
		},
		$author$project$Dashboard$Dashboard$publicationDateDecoder),
	A2(
		$arowM$elm_form_decoder$Form$Decoder$lift,
		function ($) {
			return $.dG;
		},
		$author$project$Dashboard$Dashboard$publicationTimeDecoder));
var $author$project$Dashboard$Dashboard$bannerFormDecoder = A2(
	$arowM$elm_form_decoder$Form$Decoder$field,
	$author$project$Dashboard$Dashboard$publicationDecoder,
	A2(
		$arowM$elm_form_decoder$Form$Decoder$field,
		A2(
			$arowM$elm_form_decoder$Form$Decoder$lift,
			function ($) {
				return $.c8;
			},
			$author$project$Dashboard$Dashboard$fileDecoder),
		$arowM$elm_form_decoder$Form$Decoder$top($elm$core$Tuple$pair)));
var $elm$http$Http$fileBody = _Http_pair('');
var $elm$file$File$mime = _File_mime;
var $elm$file$File$name = _File_name;
var $author$project$Dashboard$Dashboard$createBannerCmd = F5(
	function (token, file, publication, toMsg, _v0) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['assets', 'banners']),
			_List_fromArray(
				[
					A2(
					$elm$url$Url$Builder$int,
					'publication',
					$elm$time$Time$posixToMillis(publication)),
					A2(
					$elm$url$Url$Builder$string,
					'filename',
					$elm$file$File$name(file))
				]));
		var header = function () {
			if (!token.$) {
				var t = token.a;
				return A2(
					$truqu$elm_oauth2$OAuth$useToken,
					t,
					_List_fromArray(
						[
							A2(
							$elm$http$Http$header,
							'Content-type',
							$elm$file$File$mime(file))
						]));
			} else {
				return _List_Nil;
			}
		}();
		var body = $elm$http$Http$fileBody(file);
		return $elm$http$Http$request(
			{
				aA: body,
				aJ: A2($elm$http$Http$expectJson, toMsg, $author$project$Dashboard$Dashboard$bannerDecoder),
				aK: header,
				aO: 'POST',
				aS: $elm$core$Maybe$Nothing,
				aU: $elm$core$Maybe$Nothing,
				aW: uri
			});
	});
var $author$project$Dashboard$Dashboard$creatingBanner = $author$project$Dashboard$Dashboard$singleAction('creatingBanner');
var $author$project$Dashboard$Dashboard$deleteBannerCmd = F3(
	function (token, b, toMsg) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['assets', 'banners', b.cl]),
			_List_Nil);
		return A4($author$project$Api$Request$deleteWithoutResponse, token, toMsg, uri, $elm$http$Http$emptyBody);
	});
var $author$project$Dashboard$Dashboard$deletingBanner = $author$project$Dashboard$Dashboard$singleAction('deletingBanner');
var $elm$file$File$Select$file = F2(
	function (mimes, toMsg) {
		return A2(
			$elm$core$Task$perform,
			toMsg,
			_File_uploadOne(mimes));
	});
var $author$project$Dashboard$Dashboard$loadBannersCmd = F2(
	function (token, toMsg) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['assets', 'banners']),
			_List_Nil);
		return A4(
			$author$project$Api$Request$get,
			token,
			toMsg,
			uri,
			$elm$json$Json$Decode$list($author$project$Dashboard$Dashboard$bannerDecoder));
	});
var $author$project$Dashboard$Dashboard$loadingBanners = $author$project$Dashboard$Dashboard$singleAction('loadingBanners');
var $author$project$Dashboard$Dashboard$update = F3(
	function (msg, share, model) {
		var withoutWaitingAction = F2(
			function (a, _v15) {
				var s = _v15.a;
				var m = _v15.b;
				var cmds = _v15.c;
				return _Utils_Tuple3(
					A2($author$project$Portal$Share$withoutWaitingAction, a, s),
					m,
					cmds);
			});
		var token = $author$project$Portal$Share$token(share);
		var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		var modelChange = function (m) {
			return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
		};
		var activeBanner = function () {
			if (!model.$) {
				var b = model.a;
				return b;
			} else {
				var b = model.a;
				return b;
			}
		}();
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var b = msg.a.a;
					if (!model.$) {
						return A2(
							withoutWaitingAction,
							$author$project$Dashboard$Dashboard$loadingActiveBanner,
							modelChange(
								$author$project$Dashboard$Dashboard$Dashboard(
									$elm$core$Maybe$Just(b))));
					} else {
						var m = model.b;
						return A2(
							withoutWaitingAction,
							$author$project$Dashboard$Dashboard$loadingActiveBanner,
							modelChange(
								A2(
									$author$project$Dashboard$Dashboard$Manage,
									$elm$core$Maybe$Just(b),
									m)));
					}
				} else {
					if ((msg.a.a.$ === 3) && (msg.a.a.a === 404)) {
						if (!model.$) {
							return A2(
								withoutWaitingAction,
								$author$project$Dashboard$Dashboard$loadingActiveBanner,
								modelChange(
									$author$project$Dashboard$Dashboard$Dashboard($elm$core$Maybe$Nothing)));
						} else {
							var m = model.b;
							return A2(
								withoutWaitingAction,
								$author$project$Dashboard$Dashboard$loadingActiveBanner,
								modelChange(
									A2($author$project$Dashboard$Dashboard$Manage, $elm$core$Maybe$Nothing, m)));
						}
					} else {
						var error = msg.a.a;
						return _Utils_Tuple3(
							A2(
								$author$project$Portal$Share$withHttpError,
								error,
								A2($author$project$Portal$Share$withoutWaitingAction, $author$project$Dashboard$Dashboard$loadingBanners, share)),
							model,
							$elm$core$Platform$Cmd$none);
					}
				}
			case 1:
				return A3(
					$author$project$Portal$Return$withCommand,
					$author$project$Dashboard$Dashboard$loadingBanners,
					A2($author$project$Dashboard$Dashboard$loadBannersCmd, token, $author$project$Dashboard$Dashboard$SystemGotBanners),
					modelChange(
						A2($author$project$Dashboard$Dashboard$Manage, activeBanner, $author$project$Dashboard$Dashboard$Loading)));
			case 2:
				return modelChange(
					$author$project$Dashboard$Dashboard$Dashboard(activeBanner));
			case 3:
				if (!msg.a.$) {
					var banners = msg.a.a;
					return A2(
						withoutWaitingAction,
						$author$project$Dashboard$Dashboard$loadingBanners,
						modelChange(
							A2(
								$author$project$Dashboard$Dashboard$Manage,
								activeBanner,
								$author$project$Dashboard$Dashboard$Loaded(
									{
										cZ: banners,
										bK: $author$project$Dashboard$Dashboard$NotDeleting,
										bO: {lx: '', c8: $elm$core$Maybe$Nothing, dG: '', f_: _List_Nil}
									}))));
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						A2(
							$author$project$Portal$Share$withHttpError,
							error,
							A2($author$project$Portal$Share$withoutWaitingAction, $author$project$Dashboard$Dashboard$loadingBanners, share)),
						model,
						$elm$core$Platform$Cmd$none);
				}
			case 4:
				var b = msg.a;
				if ((model.$ === 1) && (model.b.$ === 1)) {
					var manage = model.b.a;
					var deleting = manage.bK;
					return modelChange(
						A2(
							$author$project$Dashboard$Dashboard$Manage,
							activeBanner,
							$author$project$Dashboard$Dashboard$Loaded(
								_Utils_update(
									manage,
									{
										bK: $author$project$Dashboard$Dashboard$ConfirmingDelete(b)
									}))));
				} else {
					return noChange;
				}
			case 5:
				var b = msg.a;
				if ((model.$ === 1) && (model.b.$ === 1)) {
					var manage = model.b.a;
					var deleting = manage.bK;
					return A3(
						$author$project$Portal$Return$withCommand,
						$author$project$Dashboard$Dashboard$deletingBanner,
						A3(
							$author$project$Dashboard$Dashboard$deleteBannerCmd,
							token,
							b,
							$author$project$Dashboard$Dashboard$SystemDeletedBanner(b)),
						modelChange(
							A2(
								$author$project$Dashboard$Dashboard$Manage,
								activeBanner,
								$author$project$Dashboard$Dashboard$Loaded(
									_Utils_update(
										manage,
										{
											bK: $author$project$Dashboard$Dashboard$Deleting(b)
										})))));
				} else {
					return noChange;
				}
			case 6:
				if (!msg.b.$) {
					var b = msg.a;
					if ((model.$ === 1) && (model.b.$ === 1)) {
						var manage = model.b.a;
						var banners = manage.cZ;
						return A2(
							withoutWaitingAction,
							$author$project$Dashboard$Dashboard$deletingBanner,
							modelChange(
								A2(
									$author$project$Dashboard$Dashboard$Manage,
									activeBanner,
									$author$project$Dashboard$Dashboard$Loaded(
										_Utils_update(
											manage,
											{
												cZ: A2(
													$elm$core$List$filter,
													function (bb) {
														return !_Utils_eq(b.cl, bb.cl);
													},
													banners)
											})))));
					} else {
						return noChange;
					}
				} else {
					var error = msg.b.a;
					return _Utils_Tuple3(
						A2(
							$author$project$Portal$Share$withHttpError,
							error,
							A2($author$project$Portal$Share$withoutWaitingAction, $author$project$Dashboard$Dashboard$deletingBanner, share)),
						model,
						$elm$core$Platform$Cmd$none);
				}
			case 7:
				if ((model.$ === 1) && (model.b.$ === 1)) {
					var manage = model.b.a;
					return modelChange(
						A2(
							$author$project$Dashboard$Dashboard$Manage,
							activeBanner,
							$author$project$Dashboard$Dashboard$Loaded(
								_Utils_update(
									manage,
									{bK: $author$project$Dashboard$Dashboard$NotDeleting}))));
				} else {
					return noChange;
				}
			case 8:
				return A2(
					$author$project$Portal$Return$withBackgroundCommand,
					A2(
						$elm$file$File$Select$file,
						_List_fromArray(
							['image/jpeg', 'image/png']),
						$author$project$Dashboard$Dashboard$UserSelectedFile),
					noChange);
			case 9:
				var file = msg.a;
				if ((model.$ === 1) && (model.b.$ === 1)) {
					var manage = model.b.a;
					var form = manage.bO;
					return modelChange(
						A2(
							$author$project$Dashboard$Dashboard$Manage,
							activeBanner,
							$author$project$Dashboard$Dashboard$Loaded(
								_Utils_update(
									manage,
									{
										bO: _Utils_update(
											form,
											{
												c8: $elm$core$Maybe$Just(file)
											})
									}))));
				} else {
					return noChange;
				}
			case 10:
				var date = msg.a;
				if ((model.$ === 1) && (model.b.$ === 1)) {
					var manage = model.b.a;
					var form = manage.bO;
					return modelChange(
						A2(
							$author$project$Dashboard$Dashboard$Manage,
							activeBanner,
							$author$project$Dashboard$Dashboard$Loaded(
								_Utils_update(
									manage,
									{
										bO: _Utils_update(
											form,
											{lx: date})
									}))));
				} else {
					return noChange;
				}
			case 11:
				var time = msg.a;
				if ((model.$ === 1) && (model.b.$ === 1)) {
					var manage = model.b.a;
					var form = manage.bO;
					return modelChange(
						A2(
							$author$project$Dashboard$Dashboard$Manage,
							activeBanner,
							$author$project$Dashboard$Dashboard$Loaded(
								_Utils_update(
									manage,
									{
										bO: _Utils_update(
											form,
											{dG: time})
									}))));
				} else {
					return noChange;
				}
			case 12:
				if ((model.$ === 1) && (model.b.$ === 1)) {
					var manage = model.b.a;
					var form = manage.bO;
					var _v11 = A2($arowM$elm_form_decoder$Form$Decoder$run, $author$project$Dashboard$Dashboard$bannerFormDecoder, form);
					if (!_v11.$) {
						var _v12 = _v11.a;
						var file = _v12.a;
						var publication = _v12.b;
						return A3(
							$author$project$Portal$Return$withCommand,
							$author$project$Dashboard$Dashboard$creatingBanner,
							A4($author$project$Dashboard$Dashboard$createBannerCmd, token, file, publication, $author$project$Dashboard$Dashboard$SystemCreatedBanner),
							modelChange(
								A2(
									$author$project$Dashboard$Dashboard$Manage,
									activeBanner,
									$author$project$Dashboard$Dashboard$Loaded(
										_Utils_update(
											manage,
											{
												bO: _Utils_update(
													form,
													{f_: _List_Nil})
											})))));
					} else {
						var errors = _v11.a;
						return modelChange(
							A2(
								$author$project$Dashboard$Dashboard$Manage,
								activeBanner,
								$author$project$Dashboard$Dashboard$Loaded(
									_Utils_update(
										manage,
										{
											bO: _Utils_update(
												form,
												{f_: errors})
										}))));
					}
				} else {
					return noChange;
				}
			default:
				if (!msg.a.$) {
					var b = msg.a.a;
					if ((model.$ === 1) && (model.b.$ === 1)) {
						var banners = model.b.a.cZ;
						return A2(
							withoutWaitingAction,
							$author$project$Dashboard$Dashboard$creatingBanner,
							modelChange(
								A2(
									$author$project$Dashboard$Dashboard$Manage,
									activeBanner,
									$author$project$Dashboard$Dashboard$Loaded(
										{
											cZ: _Utils_ap(
												banners,
												_List_fromArray(
													[b])),
											bK: $author$project$Dashboard$Dashboard$NotDeleting,
											bO: {lx: '', c8: $elm$core$Maybe$Nothing, dG: '', f_: _List_Nil}
										}))));
					} else {
						return noChange;
					}
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						A2(
							$author$project$Portal$Share$withHttpError,
							error,
							A2($author$project$Portal$Share$withoutWaitingAction, $author$project$Dashboard$Dashboard$creatingBanner, share)),
						model,
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Delay$Delay$Adding = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Delay$Delay$Editing = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Delay$Delay$Failed = function (a) {
	return {$: 3, a: a};
};
var $author$project$Delay$Delay$Late = $elm$core$Basics$identity;
var $author$project$Delay$Delay$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Delay$Delay$LoadedWithoutPlan = function (a) {
	return {$: 2, a: a};
};
var $author$project$Delay$Delay$NotEditing = {$: 0};
var $author$project$Delay$Delay$SelectingCluster = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Delay$Delay$SystemCreatedDelay = function (a) {
	return {$: 11, a: a};
};
var $author$project$Delay$Delay$SystemGotDelays = function (a) {
	return {$: 10, a: a};
};
var $author$project$Delay$Delay$SystemUpdatedDelay = function (a) {
	return {$: 12, a: a};
};
var $author$project$Delay$Delay$Cluster = function (a) {
	return {$: 1, a: a};
};
var $author$project$Contour$Contour$Contour = $elm$core$Basics$identity;
var $author$project$Contour$Contour$decodeContour = function (json) {
	var _v0 = json.a;
	switch (_v0.$) {
		case 0:
			var geom = _v0.a;
			return $elm$json$Json$Decode$succeed(geom);
		case 1:
			return $elm$json$Json$Decode$fail('unexpected geometry type: feature');
		default:
			return $elm$json$Json$Decode$fail('unexpected geometry type: feature collection');
	}
};
var $author$project$Contour$Contour$decode = A2($elm$json$Json$Decode$andThen, $author$project$Contour$Contour$decodeContour, $mgold$elm_geojson$GeoJson$decoder);
var $author$project$Delay$Delay$delivererDecoder = function (deliverers) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (id) {
			var _v0 = A2($author$project$Deliverer$IdDict$get, id, deliverers);
			if (!_v0.$) {
				var d = _v0.a;
				return $elm$json$Json$Decode$succeed(d);
			} else {
				return $elm$json$Json$Decode$fail('Deliverer not found');
			}
		},
		$author$project$Deliverer$Deliverer$idDecoder);
};
var $author$project$Contour$Contour$empty = $mgold$elm_geojson$GeoJson$Polygon(_List_Nil);
var $jxxcarlson$elm_typed_time$TypedTime$Minutes = 2;
var $elm$parser$Parser$ExpectingFloat = {$: 5};
var $elm$parser$Parser$Advanced$float = F2(
	function (expecting, invalid) {
		return $elm$parser$Parser$Advanced$number(
			{
				h_: $elm$core$Result$Err(invalid),
				iB: expecting,
				iD: $elm$core$Result$Ok($elm$core$Basics$identity),
				ma: $elm$core$Result$Err(invalid),
				iV: $elm$core$Result$Ok($elm$core$Basics$toFloat),
				mt: invalid,
				jo: $elm$core$Result$Err(invalid)
			});
	});
var $elm$parser$Parser$float = A2($elm$parser$Parser$Advanced$float, $elm$parser$Parser$ExpectingFloat, $elm$parser$Parser$ExpectingFloat);
var $jxxcarlson$elm_typed_time$TypedTime$Hours = 3;
var $jxxcarlson$elm_typed_time$TypedTime$TypedTime = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $jxxcarlson$elm_typed_time$TypedTime$hours = function (t) {
	return A2($jxxcarlson$elm_typed_time$TypedTime$TypedTime, 3, 3600000 * t);
};
var $jxxcarlson$elm_typed_time$TypedTime$hParser = A2($elm$parser$Parser$map, $jxxcarlson$elm_typed_time$TypedTime$hours, $elm$parser$Parser$float);
var $jxxcarlson$elm_typed_time$TypedTime$HMRecord = F2(
	function (hours, minutes) {
		return {bP: hours, jh: minutes};
	});
var $jxxcarlson$elm_typed_time$TypedTime$altIntParser = A2(
	$elm$parser$Parser$andThen,
	function (_v0) {
		return $elm$parser$Parser$int;
	},
	$elm$parser$Parser$symbol('0'));
var $jxxcarlson$elm_typed_time$TypedTime$ord = function (u) {
	switch (u) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $jxxcarlson$elm_typed_time$TypedTime$Milliseconds = 0;
var $jxxcarlson$elm_typed_time$TypedTime$Seconds = 1;
var $jxxcarlson$elm_typed_time$TypedTime$unit = function (k) {
	var _v0 = A2($elm$core$Basics$modBy, 4, k);
	switch (_v0) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		default:
			return 0;
	}
};
var $jxxcarlson$elm_typed_time$TypedTime$common = F2(
	function (u, v) {
		return $jxxcarlson$elm_typed_time$TypedTime$unit(
			A2(
				$elm$core$Basics$min,
				$jxxcarlson$elm_typed_time$TypedTime$ord(u),
				$jxxcarlson$elm_typed_time$TypedTime$ord(v)));
	});
var $jxxcarlson$elm_typed_time$TypedTime$map2 = F3(
	function (f, _v0, _v1) {
		var u1 = _v0.a;
		var t1 = _v0.b;
		var u2 = _v1.a;
		var t2 = _v1.b;
		var u3 = A2($jxxcarlson$elm_typed_time$TypedTime$common, u1, u2);
		var t3 = A2(f, t1, t2);
		return A2($jxxcarlson$elm_typed_time$TypedTime$TypedTime, u3, t3);
	});
var $jxxcarlson$elm_typed_time$TypedTime$add = F2(
	function (s, t) {
		return A3($jxxcarlson$elm_typed_time$TypedTime$map2, $elm$core$Basics$add, s, t);
	});
var $jxxcarlson$elm_typed_time$TypedTime$minutes = function (t) {
	return A2($jxxcarlson$elm_typed_time$TypedTime$TypedTime, 2, 60000 * t);
};
var $jxxcarlson$elm_typed_time$TypedTime$typedTimeFromHMRecord = function (r) {
	return A2(
		$jxxcarlson$elm_typed_time$TypedTime$add,
		$jxxcarlson$elm_typed_time$TypedTime$hours(r.bP),
		$jxxcarlson$elm_typed_time$TypedTime$minutes(r.jh));
};
var $jxxcarlson$elm_typed_time$TypedTime$hmParser = A2(
	$elm$parser$Parser$map,
	$jxxcarlson$elm_typed_time$TypedTime$typedTimeFromHMRecord,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($jxxcarlson$elm_typed_time$TypedTime$HMRecord),
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$jxxcarlson$elm_typed_time$TypedTime$altIntParser, $elm$parser$Parser$int])),
				$elm$parser$Parser$symbol(':'))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[$jxxcarlson$elm_typed_time$TypedTime$altIntParser, $elm$parser$Parser$int]))));
var $jxxcarlson$elm_typed_time$TypedTime$HMSRecord = F3(
	function (hours, minutes, seconds) {
		return {bP: hours, jh: minutes, jY: seconds};
	});
var $jxxcarlson$elm_typed_time$TypedTime$seconds = function (t) {
	return A2($jxxcarlson$elm_typed_time$TypedTime$TypedTime, 1, 1000 * t);
};
var $jxxcarlson$elm_typed_time$TypedTime$toMilliseconds = function (_v0) {
	var t = _v0.b;
	return t;
};
var $jxxcarlson$elm_typed_time$TypedTime$sum = function (timeList) {
	return A2(
		$jxxcarlson$elm_typed_time$TypedTime$TypedTime,
		0,
		$elm$core$List$sum(
			A2($elm$core$List$map, $jxxcarlson$elm_typed_time$TypedTime$toMilliseconds, timeList)));
};
var $jxxcarlson$elm_typed_time$TypedTime$typedTimeFromHMSRecord = function (r) {
	return $jxxcarlson$elm_typed_time$TypedTime$sum(
		_List_fromArray(
			[
				$jxxcarlson$elm_typed_time$TypedTime$hours(r.bP),
				$jxxcarlson$elm_typed_time$TypedTime$minutes(r.jh),
				$jxxcarlson$elm_typed_time$TypedTime$seconds(r.jY)
			]));
};
var $jxxcarlson$elm_typed_time$TypedTime$hmsParser = A2(
	$elm$parser$Parser$map,
	$jxxcarlson$elm_typed_time$TypedTime$typedTimeFromHMSRecord,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed($jxxcarlson$elm_typed_time$TypedTime$HMSRecord),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[$jxxcarlson$elm_typed_time$TypedTime$altIntParser, $elm$parser$Parser$int])),
					$elm$parser$Parser$symbol(':'))),
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$jxxcarlson$elm_typed_time$TypedTime$altIntParser, $elm$parser$Parser$int])),
				$elm$parser$Parser$symbol(':'))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[$jxxcarlson$elm_typed_time$TypedTime$altIntParser, $elm$parser$Parser$int]))));
var $jxxcarlson$elm_typed_time$TypedTime$mParser = A2($elm$parser$Parser$map, $jxxcarlson$elm_typed_time$TypedTime$minutes, $elm$parser$Parser$float);
var $jxxcarlson$elm_typed_time$TypedTime$milliseconds = function (t) {
	return A2($jxxcarlson$elm_typed_time$TypedTime$TypedTime, 0, t);
};
var $jxxcarlson$elm_typed_time$TypedTime$MSRecord = F2(
	function (minutes, seconds) {
		return {jh: minutes, jY: seconds};
	});
var $jxxcarlson$elm_typed_time$TypedTime$typedTimeFromMSRecord = function (r) {
	return A2(
		$jxxcarlson$elm_typed_time$TypedTime$add,
		$jxxcarlson$elm_typed_time$TypedTime$minutes(r.jh),
		$jxxcarlson$elm_typed_time$TypedTime$seconds(r.jY));
};
var $jxxcarlson$elm_typed_time$TypedTime$msParser = A2(
	$elm$parser$Parser$map,
	$jxxcarlson$elm_typed_time$TypedTime$typedTimeFromMSRecord,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($jxxcarlson$elm_typed_time$TypedTime$MSRecord),
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$jxxcarlson$elm_typed_time$TypedTime$altIntParser, $elm$parser$Parser$int])),
				$elm$parser$Parser$symbol(':'))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[$jxxcarlson$elm_typed_time$TypedTime$altIntParser, $elm$parser$Parser$int]))));
var $jxxcarlson$elm_typed_time$TypedTime$sParser = A2($elm$parser$Parser$map, $jxxcarlson$elm_typed_time$TypedTime$seconds, $elm$parser$Parser$float);
var $jxxcarlson$elm_typed_time$TypedTime$timeParser = function (u) {
	switch (u) {
		case 0:
			return A2($elm$parser$Parser$map, $jxxcarlson$elm_typed_time$TypedTime$milliseconds, $elm$parser$Parser$float);
		case 1:
			return $elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable($jxxcarlson$elm_typed_time$TypedTime$hmsParser),
						$elm$parser$Parser$backtrackable($jxxcarlson$elm_typed_time$TypedTime$msParser),
						$jxxcarlson$elm_typed_time$TypedTime$sParser
					]));
		case 2:
			return $elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable($jxxcarlson$elm_typed_time$TypedTime$hmParser),
						$jxxcarlson$elm_typed_time$TypedTime$mParser
					]));
		default:
			return $jxxcarlson$elm_typed_time$TypedTime$hParser;
	}
};
var $jxxcarlson$elm_typed_time$TypedTime$fromString = F2(
	function (u, s) {
		return $elm$core$Result$toMaybe(
			A2(
				$elm$parser$Parser$run,
				$jxxcarlson$elm_typed_time$TypedTime$timeParser(u),
				s));
	});
var $author$project$Delay$Delay$decodeTypedTime = function (str) {
	var _v0 = A2($jxxcarlson$elm_typed_time$TypedTime$fromString, 2, str);
	if (!_v0.$) {
		var time = _v0.a;
		return $elm$json$Json$Decode$succeed(time);
	} else {
		return $elm$json$Json$Decode$fail('invalid time ' + str);
	}
};
var $author$project$Delay$Delay$expectedDeliveryDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A2($elm$json$Json$Decode$andThen, $author$project$Delay$Delay$decodeTypedTime, $elm$json$Json$Decode$string));
var $author$project$Delay$Delay$Id = $elm$core$Basics$identity;
var $author$project$Delay$Delay$idDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (id) {
		return $elm$json$Json$Decode$succeed(id);
	},
	$danyx23$elm_uuid$Uuid$decoder);
var $author$project$Delay$Delay$BadWeather = 8;
var $author$project$Delay$Delay$LateSupply = 0;
var $author$project$Delay$Delay$PaperboyIll = 7;
var $author$project$Delay$Delay$PaperboyLate = 1;
var $author$project$Delay$Delay$PaperboyNew = 2;
var $author$project$Delay$Delay$PaperboyOverslept = 6;
var $author$project$Delay$Delay$PaperboyShortage = 3;
var $author$project$Delay$Delay$PaperboySubstitute = 5;
var $author$project$Delay$Delay$TransportBreakdown = 4;
var $author$project$Delay$Delay$decodeReason = function (reason) {
	switch (reason) {
		case 'late_supply':
			return $elm$json$Json$Decode$succeed(0);
		case 'paperboy_late':
			return $elm$json$Json$Decode$succeed(1);
		case 'paperboy_new':
			return $elm$json$Json$Decode$succeed(2);
		case 'paperboy_shortage':
			return $elm$json$Json$Decode$succeed(3);
		case 'transport_breakdown':
			return $elm$json$Json$Decode$succeed(4);
		case 'paperboy_substitute':
			return $elm$json$Json$Decode$succeed(5);
		case 'paperboy_overslept':
			return $elm$json$Json$Decode$succeed(6);
		case 'paperboy_ill':
			return $elm$json$Json$Decode$succeed(7);
		case 'bad_weather':
			return $elm$json$Json$Decode$succeed(8);
		default:
			return $elm$json$Json$Decode$fail('ongeldige reden ' + reason);
	}
};
var $author$project$Delay$Delay$reasonDecoder = A2($elm$json$Json$Decode$andThen, $author$project$Delay$Delay$decodeReason, $elm$json$Json$Decode$string);
var $author$project$Delay$Delay$segmentDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['id']),
	$author$project$DistributionPoint$DistributionPoint$segmentIdDecoder);
var $author$project$Delay$Delay$decode = function (deliverers) {
	return A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'contour',
		$author$project$Contour$Contour$decode,
		$author$project$Contour$Contour$empty,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'createdOn',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'reason',
				$author$project$Delay$Delay$reasonDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'delay',
					$author$project$Delay$Delay$expectedDeliveryDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'segments',
						$elm$json$Json$Decode$list($author$project$Delay$Delay$segmentDecoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'cluster',
							$author$project$Cluster$Number$decoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'date',
								$author$project$Date$DeliveryDate$decoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'deliverer',
									$author$project$Delay$Delay$delivererDecoder(deliverers),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$maybe($author$project$Delay$Delay$idDecoder),
										$elm$json$Json$Decode$succeed(
											F9(
												function (id, deliverer, date, clusterNumber, segments, delay, reason, createdOn, contour) {
													return {
														d_: contour,
														bj: createdOn,
														lx: date,
														O: delay,
														eg: id,
														D: $author$project$Delay$Delay$Cluster(
															{
																H: A2($author$project$Cluster$Cluster$Cluster, clusterNumber, segments),
																bl: deliverer
															}),
														jL: reason
													};
												})))))))))));
};
var $author$project$Cluster$Number$encode = function (_v0) {
	var clusterId = _v0;
	return $elm$json$Json$Encode$int(clusterId);
};
var $author$project$Contour$Contour$encode = function (_v0) {
	var contour = _v0;
	return $mgold$elm_geojson$GeoJson$encode(
		_Utils_Tuple2(
			$mgold$elm_geojson$GeoJson$Geometry(contour),
			$elm$core$Maybe$Nothing));
};
var $jxxcarlson$elm_typed_time$TypedTime$hmRecordFromSeconds = function (s) {
	var m1 = $elm$core$Basics$round(s / 60);
	var m2 = A2($elm$core$Basics$modBy, 60, m1);
	var h1 = (m1 / 60) | 0;
	return {bP: h1, jh: m2};
};
var $jxxcarlson$elm_typed_time$TypedTime$hmStringFromSeconds = function (s) {
	var tr = $jxxcarlson$elm_typed_time$TypedTime$hmRecordFromSeconds(s);
	return A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(tr.bP)) + (':' + A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(tr.jh)));
};
var $jxxcarlson$elm_typed_time$TypedTime$hmsRecordFromSeconds = function (s) {
	var s1 = $elm$core$Basics$round(s);
	var s2 = A2($elm$core$Basics$modBy, 60, s1);
	var m1 = (s1 / 60) | 0;
	var m2 = A2($elm$core$Basics$modBy, 60, m1);
	var h1 = (m1 / 60) | 0;
	return {bP: h1, jh: m2, jY: s2};
};
var $jxxcarlson$elm_typed_time$TypedTime$hmsStringFromSeconds = function (s) {
	var tr = $jxxcarlson$elm_typed_time$TypedTime$hmsRecordFromSeconds(s);
	return A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(tr.bP)) + (':' + (A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(tr.jh)) + (':' + A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(tr.jY)))));
};
var $jxxcarlson$elm_typed_time$TypedTime$toString = F2(
	function (u, _v0) {
		var unit_ = _v0.a;
		var value = _v0.b;
		switch (u) {
			case 0:
				return $jxxcarlson$elm_typed_time$TypedTime$hmsStringFromSeconds(value / 1000);
			case 1:
				return $jxxcarlson$elm_typed_time$TypedTime$hmsStringFromSeconds(value / 1000);
			case 2:
				return $jxxcarlson$elm_typed_time$TypedTime$hmStringFromSeconds(value / 1000);
			default:
				return $jxxcarlson$elm_typed_time$TypedTime$hmStringFromSeconds(value / 1000);
		}
	});
var $author$project$Delay$Delay$encodeTypedTime = function (time) {
	return $elm$json$Json$Encode$string(
		A2($jxxcarlson$elm_typed_time$TypedTime$toString, 2, time));
};
var $author$project$Delay$Delay$encodeExpectedDelivery = function (_v0) {
	var typedTime = _v0;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'expected',
				$elm$json$Json$Encode$string('late')),
				_Utils_Tuple2(
				'clockTime',
				$author$project$Delay$Delay$encodeTypedTime(typedTime))
			]));
};
var $author$project$Delay$Delay$reasonToKey = function (reason) {
	switch (reason) {
		case 0:
			return 'late_supply';
		case 1:
			return 'paperboy_late';
		case 2:
			return 'paperboy_new';
		case 3:
			return 'paperboy_shortage';
		case 4:
			return 'transport_breakdown';
		case 5:
			return 'paperboy_substitute';
		case 6:
			return 'paperboy_overslept';
		case 7:
			return 'paperboy_ill';
		default:
			return 'bad_weather';
	}
};
var $author$project$Delay$Delay$encodeReason = function (reason) {
	return $elm$json$Json$Encode$string(
		$author$project$Delay$Delay$reasonToKey(reason));
};
var $author$project$Delay$Delay$encodeSegment = function (id) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$author$project$DistributionPoint$DistributionPoint$encodeSegmentId(id))
			]));
};
var $author$project$Delay$Delay$idEncoder = function (_v0) {
	var id = _v0;
	return $danyx23$elm_uuid$Uuid$encode(id);
};
var $author$project$Delay$Delay$encode = F2(
	function (dpId, delay) {
		var _v0 = delay.D;
		if (_v0.$ === 1) {
			var cluster = _v0.a.H;
			var deliverer = _v0.a.bl;
			var nonIdFields = _List_fromArray(
				[
					_Utils_Tuple2(
					'distributionPoint',
					$author$project$DistributionPoint$DistributionPoint$encodeId(dpId)),
					_Utils_Tuple2(
					'deliverer',
					$author$project$Deliverer$Deliverer$encodeId(
						$author$project$Deliverer$Deliverer$idFromTyped(deliverer))),
					_Utils_Tuple2(
					'date',
					$author$project$Date$DeliveryDate$encode(delay.lx)),
					_Utils_Tuple2(
					'cluster',
					$author$project$Cluster$Number$encode(cluster.bX)),
					_Utils_Tuple2(
					'segments',
					A2($elm$json$Json$Encode$list, $author$project$Delay$Delay$encodeSegment, cluster.bb)),
					_Utils_Tuple2(
					'expectedDelivery',
					$author$project$Delay$Delay$encodeExpectedDelivery(delay.O)),
					_Utils_Tuple2(
					'reason',
					$author$project$Delay$Delay$encodeReason(delay.jL)),
					_Utils_Tuple2(
					'contour',
					$author$project$Contour$Contour$encode(delay.d_)),
					_Utils_Tuple2(
					'createdOn',
					$elm$json$Json$Encode$int(delay.bj))
				]);
			return $elm$json$Json$Encode$object(
				function () {
					var _v1 = delay.eg;
					if (!_v1.$) {
						var id = _v1.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'id',
								$author$project$Delay$Delay$idEncoder(id)),
							nonIdFields);
					} else {
						return nonIdFields;
					}
				}());
		} else {
			var id = _v0.a;
			var nonIdFields = _List_fromArray(
				[
					_Utils_Tuple2(
					'distributionPoint',
					$author$project$DistributionPoint$DistributionPoint$encodeId(id)),
					_Utils_Tuple2(
					'date',
					$author$project$Date$DeliveryDate$encode(delay.lx)),
					_Utils_Tuple2(
					'expectedDelivery',
					$author$project$Delay$Delay$encodeExpectedDelivery(delay.O)),
					_Utils_Tuple2(
					'reason',
					$author$project$Delay$Delay$encodeReason(delay.jL)),
					_Utils_Tuple2(
					'contour',
					$author$project$Contour$Contour$encode(delay.d_))
				]);
			return $elm$json$Json$Encode$object(
				function () {
					var _v2 = delay.eg;
					if (!_v2.$) {
						var delayId = _v2.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'id',
								$author$project$Delay$Delay$idEncoder(delayId)),
							nonIdFields);
					} else {
						return nonIdFields;
					}
				}());
		}
	});
var $author$project$Delay$Delay$createDelayCmd = F5(
	function (token, dpId, deliverers, toMsg, delay) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['delays', 'incidental']),
			_List_Nil);
		return A5(
			$author$project$Api$Request$post,
			token,
			toMsg,
			uri,
			$elm$http$Http$jsonBody(
				A2($author$project$Delay$Delay$encode, dpId, delay)),
			$author$project$Delay$Delay$decode(deliverers));
	});
var $author$project$Delay$Delay$creatingDelay = $author$project$Delay$Delay$singleAction('creatingDelay');
var $author$project$Delay$Delay$dateAndDpIdOf = function (model) {
	switch (model.$) {
		case 0:
			var c = model.a;
			return _Utils_Tuple2(c.lx, c.c2);
		case 1:
			var m = model.a;
			return _Utils_Tuple2(
				m.lx,
				$author$project$DistributionPoint$DistributionPoint$idOf(m.bn));
		case 2:
			var c = model.a;
			return _Utils_Tuple2(c.lx, c.c2);
		default:
			var c = model.a;
			return _Utils_Tuple2(c.lx, c.c2);
	}
};
var $author$project$Delay$Delay$defaultReason = 0;
var $author$project$Delay$Delay$maxDelayTime = $jxxcarlson$elm_typed_time$TypedTime$hours(15);
var $jxxcarlson$elm_typed_time$TypedTime$gte = F2(
	function (s, t) {
		return _Utils_cmp(
			$jxxcarlson$elm_typed_time$TypedTime$toMilliseconds(s),
			$jxxcarlson$elm_typed_time$TypedTime$toMilliseconds(t)) > -1;
	});
var $author$project$Delay$Delay$maxTypedTime = F2(
	function (t1, t2) {
		var _v0 = A2($jxxcarlson$elm_typed_time$TypedTime$gte, t1, t2);
		if (_v0) {
			return t1;
		} else {
			return t2;
		}
	});
var $jxxcarlson$elm_typed_time$TypedTime$gt = F2(
	function (s, t) {
		return _Utils_cmp(
			$jxxcarlson$elm_typed_time$TypedTime$toMilliseconds(s),
			$jxxcarlson$elm_typed_time$TypedTime$toMilliseconds(t)) > 0;
	});
var $author$project$Delay$Delay$nextPossibleDelayFromNow = function (now) {
	var amsterdamTimeZone = $justinmimbs$timezone_data$TimeZone$europe__amsterdam(0);
	var totalMinutes = ((A2($elm$time$Time$toHour, amsterdamTimeZone, now) * 60) + A2($elm$time$Time$toMinute, amsterdamTimeZone, now)) + 1;
	var nextQuarterOfAnHour = ((totalMinutes / 15) | 0) + 1;
	var next = $jxxcarlson$elm_typed_time$TypedTime$minutes(nextQuarterOfAnHour * 15);
	var _v0 = A2($jxxcarlson$elm_typed_time$TypedTime$gt, next, $author$project$Delay$Delay$maxDelayTime);
	if (_v0) {
		return $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Just(next);
	}
};
var $author$project$Delay$Delay$range = function (_v0) {
	var start = _v0.hq;
	var end = _v0.gu;
	var interval = _v0.gJ;
	var step = function (t) {
		return A2($jxxcarlson$elm_typed_time$TypedTime$gt, t, end) ? _List_Nil : A2(
			$elm$core$List$cons,
			t,
			step(
				A2($jxxcarlson$elm_typed_time$TypedTime$add, t, interval)));
	};
	return step(start);
};
var $author$project$Delay$Delay$delayTimesFor = F2(
	function (date, now) {
		var time = F2(
			function (h, m) {
				return A2(
					$jxxcarlson$elm_typed_time$TypedTime$add,
					$jxxcarlson$elm_typed_time$TypedTime$hours(h),
					$jxxcarlson$elm_typed_time$TypedTime$minutes(m));
			});
		var next = $author$project$Delay$Delay$nextPossibleDelayFromNow(now);
		var _v0 = _Utils_Tuple2(
			$justinmimbs$date$Date$weekday(
				$author$project$Date$DeliveryDate$toDate(date)),
			next);
		if (!_v0.b.$) {
			if (_v0.a === 5) {
				var _v1 = _v0.a;
				var n = _v0.b.a;
				return $author$project$Delay$Delay$range(
					{
						gu: $author$project$Delay$Delay$maxDelayTime,
						gJ: $jxxcarlson$elm_typed_time$TypedTime$minutes(15),
						hq: A2(
							$author$project$Delay$Delay$maxTypedTime,
							A2(time, 9, 15),
							n)
					});
			} else {
				var n = _v0.b.a;
				return $author$project$Delay$Delay$range(
					{
						gu: $author$project$Delay$Delay$maxDelayTime,
						gJ: $jxxcarlson$elm_typed_time$TypedTime$minutes(15),
						hq: A2(
							$author$project$Delay$Delay$maxTypedTime,
							A2(time, 7, 15),
							n)
					});
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Delay$Delay$isClusterDelayed = F3(
	function (delays, deliverer, cluster) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (_v1) {
					return true;
				},
				A2(
					$elm_community$list_extra$List$Extra$find,
					function (d) {
						var _v0 = d.D;
						if (_v0.$ === 1) {
							var el = _v0.a;
							return _Utils_eq(el.H.bX, cluster.bX) && _Utils_eq(
								$author$project$Deliverer$Deliverer$idFromTyped(el.bl),
								$author$project$Deliverer$Deliverer$idFromTyped(deliverer));
						} else {
							return false;
						}
					},
					delays)));
	});
var $author$project$Delay$Delay$delayableCluster = F3(
	function (plan, delays, deliverer) {
		return A2(
			$elm$core$List$sortBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.bX;
				},
				$author$project$Cluster$Number$comparable),
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Basics$not,
					A2($author$project$Delay$Delay$isClusterDelayed, delays, deliverer)),
				A2($author$project$Plan$Supply$clustersByDeliverer, deliverer, plan.gL)));
	});
var $author$project$Contour$Contour$addContour = F2(
	function (_v0, polygons2) {
		var geometry = _v0;
		switch (geometry.$) {
			case 4:
				var polygon = geometry.a;
				return A2($elm$core$List$cons, polygon, polygons2);
			case 5:
				var polygons1 = geometry.a;
				return A2($elm$core$List$append, polygons1, polygons2);
			default:
				return polygons2;
		}
	});
var $author$project$Contour$Contour$onlyMultiPoint = function () {
	var isMultiPoint = function (_v1) {
		var geometry = _v1;
		if (geometry.$ === 1) {
			return true;
		} else {
			return false;
		}
	};
	return $elm$core$List$all(isMultiPoint);
}();
var $author$project$Contour$Contour$toPoints = function (_v0) {
	var geometry = _v0;
	if (geometry.$ === 1) {
		var points = geometry.a;
		return points;
	} else {
		return _List_Nil;
	}
};
var $author$project$Contour$Contour$toRings = function (_v0) {
	var geometry = _v0;
	switch (geometry.$) {
		case 4:
			var ring = geometry.a;
			return $elm$core$List$singleton(ring);
		case 5:
			var rings = geometry.a;
			return rings;
		default:
			return _List_Nil;
	}
};
var $author$project$Contour$Contour$combineContours = function (geometries) {
	var _v0 = _Utils_Tuple2(
		geometries,
		$author$project$Contour$Contour$onlyMultiPoint(geometries));
	_v0$1:
	while (true) {
		if (!_v0.a.b) {
			return $author$project$Contour$Contour$empty;
		} else {
			if (_v0.b) {
				if (!_v0.a.b.b) {
					break _v0$1;
				} else {
					var _v2 = _v0.a;
					var first = _v2.a;
					var rest = _v2.b;
					return $mgold$elm_geojson$GeoJson$MultiPoint(
						A2(
							$elm$core$List$concatMap,
							$author$project$Contour$Contour$toPoints,
							A2($elm$core$List$cons, first, rest)));
				}
			} else {
				if (!_v0.a.b.b) {
					break _v0$1;
				} else {
					var _v3 = _v0.a;
					var first = _v3.a;
					var rest = _v3.b;
					return $mgold$elm_geojson$GeoJson$MultiPolygon(
						$elm$core$List$reverse(
							A3(
								$elm$core$List$foldl,
								$author$project$Contour$Contour$addContour,
								$author$project$Contour$Contour$toRings(first),
								rest)));
				}
			}
		}
	}
	var _v1 = _v0.a;
	var only = _v1.a;
	return only;
};
var $author$project$Contour$Contour$contourFromGeoJson = function (json) {
	var _v0 = json.a;
	switch (_v0.$) {
		case 0:
			var geom = _v0.a;
			return $elm$core$Maybe$Just(geom);
		case 1:
			var obj = _v0.a;
			return A2(
				$elm$core$Maybe$map,
				function (geom) {
					return geom;
				},
				obj.l4);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Contour$Contour$combineGeoJsonContours = A2(
	$elm$core$Basics$composeL,
	$author$project$Contour$Contour$combineContours,
	$elm$core$List$filterMap($author$project$Contour$Contour$contourFromGeoJson));
var $author$project$DistributionPoint$DistributionPoint$segmentContour = function (segment) {
	if (!segment.$) {
		var c = segment.a;
		return $elm$core$Maybe$Just(c);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Delay$Delay$contourForLogisticalElement = F2(
	function (dp, logisticalElement) {
		if (!logisticalElement.$) {
			return $author$project$Contour$Contour$combineGeoJsonContours(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					A2(
						$elm$core$List$map,
						$author$project$DistributionPoint$DistributionPoint$segmentContour,
						$author$project$DistributionPoint$DistributionPoint$segmentsOf(dp))));
		} else {
			var cluster = logisticalElement.a.H;
			var deliverer = logisticalElement.a.bl;
			return $author$project$Contour$Contour$combineGeoJsonContours(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					A2(
						$elm$core$List$map,
						$author$project$DistributionPoint$DistributionPoint$segmentContour,
						A2($author$project$DistributionPoint$DistributionPoint$findSegmentsOnId, dp, cluster.bb))));
		}
	});
var $author$project$Delay$Delay$DP = function (a) {
	return {$: 0, a: a};
};
var $author$project$Delay$Delay$logisticalElementFormDecoder = $arowM$elm_form_decoder$Form$Decoder$custom(
	function (logisticalElementInput) {
		if (!logisticalElementInput.$) {
			var deliverer = logisticalElementInput.a;
			var cluster = logisticalElementInput.b;
			return $elm$core$Result$Ok(
				$author$project$Delay$Delay$Cluster(
					{H: cluster, bl: deliverer}));
		} else {
			var dpID = logisticalElementInput.a;
			return $elm$core$Result$Ok(
				$author$project$Delay$Delay$DP(dpID));
		}
	});
var $author$project$Delay$Delay$formDecoder = F2(
	function (date, dp) {
		return A2(
			$arowM$elm_form_decoder$Form$Decoder$field,
			A2(
				$arowM$elm_form_decoder$Form$Decoder$lift,
				function ($) {
					return $.bj;
				},
				$arowM$elm_form_decoder$Form$Decoder$identity),
			A2(
				$arowM$elm_form_decoder$Form$Decoder$field,
				A2(
					$arowM$elm_form_decoder$Form$Decoder$lift,
					function ($) {
						return $.jL;
					},
					$arowM$elm_form_decoder$Form$Decoder$identity),
				A2(
					$arowM$elm_form_decoder$Form$Decoder$field,
					A2(
						$arowM$elm_form_decoder$Form$Decoder$lift,
						function ($) {
							return $.O;
						},
						$arowM$elm_form_decoder$Form$Decoder$identity),
					A2(
						$arowM$elm_form_decoder$Form$Decoder$field,
						A2(
							$arowM$elm_form_decoder$Form$Decoder$lift,
							function ($) {
								return $.D;
							},
							$author$project$Delay$Delay$logisticalElementFormDecoder),
						$arowM$elm_form_decoder$Form$Decoder$top(
							F4(
								function (logisticalElement, expectedDelivery, reason, createdOn) {
									return {
										d_: A2($author$project$Delay$Delay$contourForLogisticalElement, dp, logisticalElement),
										bj: createdOn,
										lx: date,
										O: expectedDelivery,
										eg: $elm$core$Maybe$Nothing,
										D: logisticalElement,
										jL: reason
									};
								}))))));
	});
var $author$project$Delay$Delay$formOf = function (formState) {
	switch (formState.$) {
		case 1:
			var t = formState.a;
			var f = formState.b;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(f, t));
		case 2:
			var t = formState.a;
			var f = formState.c;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(f, t));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Delay$Delay$loadDelaysCmd = F5(
	function (token, toMsg, dpId, deliverers, date) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['delays', 'find', 'dp']),
			_List_fromArray(
				[
					A2(
					$elm$url$Url$Builder$string,
					'dpid',
					$author$project$DistributionPoint$DistributionPoint$encodeIdForUrl(dpId)),
					A2(
					$elm$url$Url$Builder$string,
					'date',
					$author$project$Date$DeliveryDate$encodeForUrl(date))
				]));
		return A4(
			$author$project$Api$Request$get,
			token,
			toMsg,
			uri,
			$elm$json$Json$Decode$list(
				$author$project$Delay$Delay$decode(deliverers)));
	});
var $author$project$Delay$Delay$loadingDelays = $author$project$Delay$Delay$singleAction('loadingDelays');
var $author$project$Plan$Supply$deliverersIn = function (supplyItem) {
	switch (supplyItem.$) {
		case 0:
			var deliverer = supplyItem.a.bl;
			var supplies = supplyItem.a.n0;
			return A2(
				$elm$core$List$cons,
				deliverer,
				A2($elm$core$List$concatMap, $author$project$Plan$Supply$deliverersIn, supplies));
		case 1:
			var deliverer = supplyItem.a.bl;
			return _List_fromArray(
				[deliverer]);
		default:
			return _List_Nil;
	}
};
var $author$project$Plan$Supply$allDeliverersOf = function (items) {
	return $Gizra$elm_all_set$EverySet$fromList(
		A2($elm$core$List$concatMap, $author$project$Plan$Supply$deliverersIn, items));
};
var $author$project$Delay$Delay$delivererView = function (deliverer) {
	return $elm$core$String$trim(
		function (_v0) {
			var firstName = _v0.fc;
			var lastName = _v0.fo;
			return lastName + (', ' + firstName);
		}(
			$author$project$Deliverer$Deliverer$fromTyped(deliverer)));
};
var $author$project$Delay$Delay$selectableDeliverers = F2(
	function (plan, delays) {
		return A2(
			$elm$core$List$sortWith,
			F2(
				function (d1, d2) {
					return A2(
						$elm$core$Basics$compare,
						$author$project$Delay$Delay$delivererView(d1),
						$author$project$Delay$Delay$delivererView(d2));
				}),
			A2(
				$elm$core$List$filter,
				function (d) {
					var _v0 = A3($author$project$Delay$Delay$delayableCluster, plan, delays, d);
					if (!_v0.b) {
						return false;
					} else {
						return true;
					}
				},
				$Gizra$elm_all_set$EverySet$toList(
					$author$project$Plan$Supply$allDeliverersOf(plan.gL))));
	});
var $author$project$Delay$Delay$titleFor = function (logisticalEl) {
	if (logisticalEl.$ === 1) {
		var deliverer = logisticalEl.a.bl;
		return $author$project$Delay$Delay$delivererView(deliverer);
	} else {
		var distributionPointId = logisticalEl.a;
		return $author$project$DistributionPoint$DistributionPoint$comparableId(distributionPointId);
	}
};
var $author$project$Delay$Delay$viewExpectedDelivery = function (expectedDelivery) {
	var time = expectedDelivery;
	return A2($jxxcarlson$elm_typed_time$TypedTime$toString, 2, time);
};
var $author$project$Delay$Delay$sort = function (delays) {
	return A2(
		$elm$core$List$sortWith,
		F2(
			function (d1, d2) {
				var c = A2(
					$elm$core$Basics$compare,
					$author$project$Delay$Delay$viewExpectedDelivery(d2.O),
					$author$project$Delay$Delay$viewExpectedDelivery(d1.O));
				if (c === 1) {
					return A2(
						$elm$core$Basics$compare,
						$author$project$Delay$Delay$titleFor(d1.D),
						$author$project$Delay$Delay$titleFor(d2.D));
				} else {
					return c;
				}
			}),
		delays);
};
var $author$project$Delay$Delay$timeOf = function (expectedDelivery) {
	var time = expectedDelivery;
	return time;
};
var $author$project$Delay$Delay$SelectingDP = function (a) {
	return {$: 1, a: a};
};
var $author$project$Delay$Delay$tologisticalElementInput = function (logisticalElement) {
	if (logisticalElement.$ === 1) {
		var cluster = logisticalElement.a.H;
		var deliverer = logisticalElement.a.bl;
		return A2($author$project$Delay$Delay$SelectingCluster, deliverer, cluster);
	} else {
		var dpID = logisticalElement.a;
		return $author$project$Delay$Delay$SelectingDP(dpID);
	}
};
var $author$project$Delay$Delay$updateDelayCmd = F6(
	function (token, dpId, deliverers, toMsg, _v0, delay) {
		var id = _v0;
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'delays',
					'incidental',
					$danyx23$elm_uuid$Uuid$toString(id)
				]),
			_List_Nil);
		return A5(
			$author$project$Api$Request$patch,
			token,
			toMsg,
			uri,
			$elm$http$Http$jsonBody(
				A2($author$project$Delay$Delay$encode, dpId, delay)),
			$author$project$Delay$Delay$decode(deliverers));
	});
var $author$project$Delay$Delay$updatingDelay = $author$project$Delay$Delay$singleAction('updatingDelay');
var $author$project$Delay$Delay$whenWaiting = function (msg) {
	switch (msg.$) {
		case 8:
			return 0;
		case 9:
			return 0;
		case 10:
			return 0;
		case 0:
			return 1;
		case 1:
			return 1;
		case 6:
			return 0;
		case 11:
			return 0;
		case 12:
			return 0;
		case 2:
			return 1;
		case 3:
			return 1;
		case 4:
			return 1;
		case 5:
			return 1;
		case 7:
			return 1;
		default:
			return 0;
	}
};
var $author$project$Delay$Delay$withUpdatedForm = F2(
	function (form, formState) {
		switch (formState.$) {
			case 1:
				var times = formState.a;
				return A2($author$project$Delay$Delay$Adding, times, form);
			case 2:
				var times = formState.a;
				var delay = formState.b;
				return A3($author$project$Delay$Delay$Editing, times, delay, form);
			default:
				return $author$project$Delay$Delay$NotEditing;
		}
	});
var $author$project$Delay$Delay$update = F3(
	function (msg, share, model) {
		var token = $author$project$Portal$Share$token(share);
		var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		var modelChange = function (m) {
			if (!m.$) {
				var context = m.a;
				var loadingModel = m.b;
				var _v35 = _Utils_Tuple3(
					loadingModel.bn,
					_Utils_Tuple2(loadingModel.fB, loadingModel.ah),
					loadingModel.W);
				if ((((!_v35.a.$) && (_v35.b.a.$ === 3)) && (!_v35.b.b.$)) && (!_v35.c.$)) {
					var dp = _v35.a.a;
					var _v36 = _v35.b;
					var pAndD = _v36.a.a;
					var delays = _v36.b.a;
					var now = _v35.c.a;
					return _Utils_Tuple3(
						share,
						$author$project$Delay$Delay$Loaded(
							{
								lx: context.lx,
								ah: $author$project$Delay$Delay$sort(delays),
								e4: pAndD.e4,
								bn: dp,
								bO: $author$project$Delay$Delay$NotEditing,
								W: now,
								fA: pAndD.fA
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
				}
			} else {
				return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
			}
		};
		var _v0 = $author$project$Delay$Delay$dateAndDpIdOf(model);
		var date = _v0.a;
		var dpId = _v0.b;
		var err = F3(
			function (toAction, error, m) {
				return _Utils_Tuple3(
					A2(
						$author$project$Portal$Share$withHttpError,
						error,
						A2(
							$author$project$Portal$Share$withoutWaitingAction,
							toAction(
								_Utils_Tuple2(dpId, date)),
							share)),
					m,
					$elm$core$Platform$Cmd$none);
			});
		var withCommand = function (toAction) {
			return $author$project$Portal$Return$withCommand(
				toAction(
					_Utils_Tuple2(dpId, date)));
		};
		var withoutAction = function (toAction) {
			return $author$project$Portal$Return$withoutAction(
				toAction(
					_Utils_Tuple2(dpId, date)));
		};
		if (A3($author$project$Portal$Share$allowed, $author$project$Delay$Delay$whenWaiting, msg, share) === 1) {
			return noChange;
		} else {
			switch (msg.$) {
				case 8:
					if (!msg.a.$) {
						var distributionPoint = msg.a.a;
						return A2(
							withoutAction,
							$author$project$Delay$Delay$loadingDP,
							modelChange(
								function () {
									if (!model.$) {
										var c = model.a;
										var l = model.b;
										return A2(
											$author$project$Delay$Delay$Loading,
											c,
											_Utils_update(
												l,
												{
													bn: $elm$core$Maybe$Just(distributionPoint)
												}));
									} else {
										return model;
									}
								}()));
					} else {
						var error = msg.a.a;
						return A3(err, $author$project$Delay$Delay$loadingDP, error, model);
					}
				case 9:
					var planLoaderMsg = msg.a;
					if (!model.$) {
						var c = model.a;
						var l = model.b;
						var _v4 = A2(
							$author$project$Plan$PlanLoader$registerErrorOnFailedExcept,
							$elm$http$Http$BadStatus(404),
							A2(
								$author$project$Plan$PlanLoader$mapCommand,
								$elm$core$Platform$Cmd$map($author$project$Delay$Delay$SystemGotLoaderMsg),
								A6(
									$author$project$Plan$PlanLoader$update,
									share,
									token,
									$author$project$Delay$Delay$loadingPlan(
										_Utils_Tuple2(dpId, date)),
									$elm$core$Basics$identity,
									planLoaderMsg,
									l.fB)));
						var s = _v4.a;
						var planAndDeliverers = _v4.b;
						var cmds = _v4.c;
						switch (planAndDeliverers.$) {
							case 3:
								var plan = planAndDeliverers.a.fA;
								var deliverers = planAndDeliverers.a.e4;
								return A3(
									withCommand,
									$author$project$Delay$Delay$loadingDelays,
									A5($author$project$Delay$Delay$loadDelaysCmd, token, $author$project$Delay$Delay$SystemGotDelays, dpId, deliverers, date),
									_Utils_Tuple3(
										s,
										A2(
											$author$project$Delay$Delay$Loading,
											c,
											_Utils_update(
												l,
												{fB: planAndDeliverers})),
										cmds));
							case 4:
								if ((planAndDeliverers.a.$ === 3) && (planAndDeliverers.a.a === 404)) {
									return _Utils_Tuple3(
										s,
										$author$project$Delay$Delay$LoadedWithoutPlan(c),
										cmds);
								} else {
									var error = planAndDeliverers.a;
									return _Utils_Tuple3(
										A2($author$project$Portal$Share$withHttpError, error, s),
										$author$project$Delay$Delay$Failed(c),
										$elm$core$Platform$Cmd$none);
								}
							default:
								return _Utils_Tuple3(
									s,
									A2(
										$author$project$Delay$Delay$Loading,
										c,
										_Utils_update(
											l,
											{fB: planAndDeliverers})),
									cmds);
						}
					} else {
						return noChange;
					}
				case 10:
					if (!msg.a.$) {
						var delays = msg.a.a;
						if (!model.$) {
							var c = model.a;
							var l = model.b;
							return A2(
								withoutAction,
								$author$project$Delay$Delay$loadingDelays,
								modelChange(
									A2(
										$author$project$Delay$Delay$Loading,
										c,
										_Utils_update(
											l,
											{
												ah: $elm$core$Maybe$Just(delays)
											}))));
						} else {
							return noChange;
						}
					} else {
						var error = msg.a.a;
						return A3(err, $author$project$Delay$Delay$loadingDelays, error, model);
					}
				case 0:
					if (model.$ === 1) {
						var m = model.a;
						var times = A2($author$project$Delay$Delay$delayTimesFor, date, m.W);
						var deliverers = A2($author$project$Delay$Delay$selectableDeliverers, m.fA, m.ah);
						var _v8 = _Utils_Tuple2(
							$elm$core$List$head(times),
							deliverers);
						if ((!_v8.a.$) && _v8.b.b) {
							var time = _v8.a.a;
							var _v9 = _v8.b;
							var head = _v9.a;
							var _v10 = A3($author$project$Delay$Delay$delayableCluster, m.fA, m.ah, head);
							if (_v10.b) {
								var cluster = _v10.a;
								return modelChange(
									$author$project$Delay$Delay$Loaded(
										_Utils_update(
											m,
											{
												bO: A2(
													$author$project$Delay$Delay$Adding,
													times,
													{
														bj: 0,
														O: time,
														D: A2($author$project$Delay$Delay$SelectingCluster, head, cluster),
														jL: $author$project$Delay$Delay$defaultReason,
														f_: _List_Nil
													})
											})));
							} else {
								return noChange;
							}
						} else {
							return noChange;
						}
					} else {
						return noChange;
					}
				case 1:
					var delay = msg.a;
					if (model.$ === 1) {
						var m = model.a;
						var times = A2($author$project$Delay$Delay$delayTimesFor, date, m.W);
						var _v12 = $elm$core$List$head(times);
						if (!_v12.$) {
							var head = _v12.a;
							return modelChange(
								$author$project$Delay$Delay$Loaded(
									_Utils_update(
										m,
										{
											bO: A3(
												$author$project$Delay$Delay$Editing,
												times,
												delay,
												{
													bj: delay.bj,
													O: A2(
														$jxxcarlson$elm_typed_time$TypedTime$gt,
														head,
														$author$project$Delay$Delay$timeOf(delay.O)) ? head : delay.O,
													D: $author$project$Delay$Delay$tologisticalElementInput(delay.D),
													jL: delay.jL,
													f_: _List_Nil
												})
										})));
						} else {
							return noChange;
						}
					} else {
						return noChange;
					}
				case 2:
					var deliverer = msg.a;
					if (model.$ === 1) {
						var m = model.a;
						var _v14 = _Utils_Tuple2(
							$author$project$Delay$Delay$formOf(m.bO),
							A3($author$project$Delay$Delay$delayableCluster, m.fA, m.ah, deliverer));
						if ((!_v14.a.$) && _v14.b.b) {
							var _v15 = _v14.a.a;
							var f = _v15.a;
							var _v16 = _v14.b;
							var cluster = _v16.a;
							return modelChange(
								$author$project$Delay$Delay$Loaded(
									_Utils_update(
										m,
										{
											bO: A2(
												$author$project$Delay$Delay$withUpdatedForm,
												_Utils_update(
													f,
													{
														D: A2($author$project$Delay$Delay$SelectingCluster, deliverer, cluster)
													}),
												m.bO)
										})));
						} else {
							return noChange;
						}
					} else {
						return noChange;
					}
				case 3:
					var deliverer = msg.a;
					var cluster = msg.b;
					if (model.$ === 1) {
						var m = model.a;
						var _v18 = $author$project$Delay$Delay$formOf(m.bO);
						if (!_v18.$) {
							var _v19 = _v18.a;
							var f = _v19.a;
							return modelChange(
								$author$project$Delay$Delay$Loaded(
									_Utils_update(
										m,
										{
											bO: A2(
												$author$project$Delay$Delay$withUpdatedForm,
												_Utils_update(
													f,
													{
														D: A2($author$project$Delay$Delay$SelectingCluster, deliverer, cluster)
													}),
												m.bO)
										})));
						} else {
							return noChange;
						}
					} else {
						return noChange;
					}
				case 4:
					var time = msg.a;
					if (model.$ === 1) {
						var m = model.a;
						var _v21 = $author$project$Delay$Delay$formOf(m.bO);
						if (!_v21.$) {
							var _v22 = _v21.a;
							var f = _v22.a;
							return modelChange(
								$author$project$Delay$Delay$Loaded(
									_Utils_update(
										m,
										{
											bO: A2(
												$author$project$Delay$Delay$withUpdatedForm,
												_Utils_update(
													f,
													{O: time}),
												m.bO)
										})));
						} else {
							return noChange;
						}
					} else {
						return noChange;
					}
				case 5:
					var reason = msg.a;
					if (model.$ === 1) {
						var m = model.a;
						var _v24 = $author$project$Delay$Delay$formOf(m.bO);
						if (!_v24.$) {
							var _v25 = _v24.a;
							var f = _v25.a;
							return modelChange(
								$author$project$Delay$Delay$Loaded(
									_Utils_update(
										m,
										{
											bO: A2(
												$author$project$Delay$Delay$withUpdatedForm,
												_Utils_update(
													f,
													{jL: reason}),
												m.bO)
										})));
						} else {
							return noChange;
						}
					} else {
						return noChange;
					}
				case 6:
					if (model.$ === 1) {
						var m = model.a;
						return modelChange(
							$author$project$Delay$Delay$Loaded(
								_Utils_update(
									m,
									{bO: $author$project$Delay$Delay$NotEditing})));
					} else {
						return noChange;
					}
				case 7:
					if (model.$ === 1) {
						var m = model.a;
						var _v28 = m.bO;
						switch (_v28.$) {
							case 1:
								var f = _v28.b;
								var _v29 = A2(
									$arowM$elm_form_decoder$Form$Decoder$run,
									A2($author$project$Delay$Delay$formDecoder, date, m.bn),
									f);
								if (!_v29.$) {
									var delay = _v29.a;
									return A3(
										withCommand,
										$author$project$Delay$Delay$creatingDelay,
										A5($author$project$Delay$Delay$createDelayCmd, token, dpId, m.e4, $author$project$Delay$Delay$SystemCreatedDelay, delay),
										modelChange(
											$author$project$Delay$Delay$Loaded(
												_Utils_update(
													m,
													{
														bO: A2(
															$author$project$Delay$Delay$withUpdatedForm,
															_Utils_update(
																f,
																{f_: _List_Nil}),
															m.bO)
													}))));
								} else {
									var errors = _v29.a;
									return modelChange(
										$author$project$Delay$Delay$Loaded(
											_Utils_update(
												m,
												{
													bO: A2(
														$author$project$Delay$Delay$withUpdatedForm,
														_Utils_update(
															f,
															{f_: errors}),
														m.bO)
												})));
								}
							case 2:
								var d = _v28.b;
								var f = _v28.c;
								var _v30 = _Utils_Tuple2(
									A2(
										$arowM$elm_form_decoder$Form$Decoder$run,
										A2($author$project$Delay$Delay$formDecoder, date, m.bn),
										f),
									d.eg);
								if (!_v30.a.$) {
									if (!_v30.b.$) {
										var delay = _v30.a.a;
										var id = _v30.b.a;
										return A3(
											withCommand,
											$author$project$Delay$Delay$updatingDelay,
											A6(
												$author$project$Delay$Delay$updateDelayCmd,
												token,
												dpId,
												m.e4,
												$author$project$Delay$Delay$SystemUpdatedDelay,
												id,
												_Utils_update(
													delay,
													{eg: d.eg})),
											modelChange(
												$author$project$Delay$Delay$Loaded(
													_Utils_update(
														m,
														{
															bO: A2(
																$author$project$Delay$Delay$withUpdatedForm,
																_Utils_update(
																	f,
																	{f_: _List_Nil}),
																m.bO)
														}))));
									} else {
										return noChange;
									}
								} else {
									var errors = _v30.a.a;
									return modelChange(
										$author$project$Delay$Delay$Loaded(
											_Utils_update(
												m,
												{
													bO: A2(
														$author$project$Delay$Delay$withUpdatedForm,
														_Utils_update(
															f,
															{f_: errors}),
														m.bO)
												})));
								}
							default:
								return noChange;
						}
					} else {
						return noChange;
					}
				case 11:
					if (!msg.a.$) {
						if (model.$ === 1) {
							var m = model.a;
							return A2(
								withoutAction,
								$author$project$Delay$Delay$creatingDelay,
								A3(
									withCommand,
									$author$project$Delay$Delay$loadingDelays,
									A5($author$project$Delay$Delay$loadDelaysCmd, token, $author$project$Delay$Delay$SystemGotDelays, dpId, m.e4, date),
									modelChange(
										A2(
											$author$project$Delay$Delay$Loading,
											{
												lx: date,
												c2: $author$project$DistributionPoint$DistributionPoint$idOf(m.bn)
											},
											{
												ah: $elm$core$Maybe$Nothing,
												bn: $elm$core$Maybe$Just(m.bn),
												W: $elm$core$Maybe$Just(m.W),
												fB: $author$project$Plan$PlanLoader$Loaded(
													{e4: m.e4, fA: m.fA})
											}))));
						} else {
							return noChange;
						}
					} else {
						var error = msg.a.a;
						return A3(err, $author$project$Delay$Delay$creatingDelay, error, model);
					}
				case 12:
					if (!msg.a.$) {
						if (model.$ === 1) {
							var m = model.a;
							return A2(
								withoutAction,
								$author$project$Delay$Delay$updatingDelay,
								A3(
									withCommand,
									$author$project$Delay$Delay$loadingDelays,
									A5($author$project$Delay$Delay$loadDelaysCmd, token, $author$project$Delay$Delay$SystemGotDelays, dpId, m.e4, date),
									modelChange(
										A2(
											$author$project$Delay$Delay$Loading,
											{
												lx: date,
												c2: $author$project$DistributionPoint$DistributionPoint$idOf(m.bn)
											},
											{
												ah: $elm$core$Maybe$Nothing,
												bn: $elm$core$Maybe$Just(m.bn),
												W: $elm$core$Maybe$Just(m.W),
												fB: $author$project$Plan$PlanLoader$Loaded(
													{e4: m.e4, fA: m.fA})
											}))));
						} else {
							return noChange;
						}
					} else {
						var error = msg.a.a;
						return A3(err, $author$project$Delay$Delay$creatingDelay, error, model);
					}
				default:
					var now = msg.a;
					switch (model.$) {
						case 0:
							var c = model.a;
							var l = model.b;
							return modelChange(
								A2(
									$author$project$Delay$Delay$Loading,
									c,
									_Utils_update(
										l,
										{
											W: $elm$core$Maybe$Just(now)
										})));
						case 1:
							var m = model.a;
							return modelChange(
								$author$project$Delay$Delay$Loaded(
									_Utils_update(
										m,
										{W: now})));
						default:
							return noChange;
					}
			}
		}
	});
var $author$project$Deliverer$Create$Failed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Deliverer$Create$SystemCreatedDeliverer = function (a) {
	return {$: 5, a: a};
};
var $author$project$Deliverer$Unregistered$addCmd = F4(
	function (token, toMsg, dpId, _v0) {
		var from = _v0.l2;
		var givenName = _v0.ed;
		var familyName = _v0.d9;
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['unregistered-deliverers']),
			_List_Nil);
		var encodeAvailability = function (_v1) {
			var location = _v1.a;
			var d = _v1.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'validity',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'from',
									$author$project$Date$DeliveryDate$encode(d))
								]))),
						_Utils_Tuple2(
						'location',
						$elm$json$Json$Encode$string(location))
					]));
		};
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'firstName',
						$elm$json$Json$Encode$string(givenName)),
						_Utils_Tuple2(
						'lastName',
						$elm$json$Json$Encode$string(familyName)),
						_Utils_Tuple2(
						'availabilities',
						A2(
							$elm$json$Json$Encode$list,
							encodeAvailability,
							_List_fromArray(
								[
									_Utils_Tuple2(
									$author$project$DistributionPoint$DistributionPoint$encodeIdForUrl(dpId),
									from)
								])))
					])));
		return A5($author$project$Api$Request$post, token, toMsg, uri, body, $author$project$Deliverer$Unregistered$unregisteredDelivererDecoder);
	});
var $author$project$Deliverer$Create$creatingDeliverer = $author$project$Deliverer$Create$singleAction('creatingDeliverer');
var $author$project$Deliverer$Create$setForm = F2(
	function (model, form) {
		return _Utils_update(
			model,
			{eC: form});
	});
var $author$project$Deliverer$Create$toDpId = function (_v0) {
	var distributionPoint = _v0.bn;
	switch (distributionPoint.$) {
		case 0:
			var dpId = distributionPoint.a;
			return dpId;
		case 1:
			var dp = distributionPoint.a;
			return dp.eg;
		default:
			var dpId = distributionPoint.a;
			return dpId;
	}
};
var $author$project$Deliverer$Unregistered$UnregisteredDeliverer = F3(
	function (from, givenName, familyName) {
		return {d9: familyName, l2: from, ed: givenName};
	});
var $author$project$Deliverer$Create$FamilyNameRequired = 1;
var $author$project$Deliverer$Create$familyNameDecoder = A2(
	$arowM$elm_form_decoder$Form$Decoder$assert,
	A2($arowM$elm_form_decoder$Form$Decoder$minLength, 1, 1),
	$arowM$elm_form_decoder$Form$Decoder$identity);
var $author$project$Deliverer$Create$FromInvalid = 3;
var $author$project$Deliverer$Create$FromRequired = 2;
var $arowM$elm_form_decoder$Form$Decoder$andThen = F2(
	function (f, _v0) {
		var g = _v0;
		return $arowM$elm_form_decoder$Form$Decoder$custom(
			function (a) {
				var _v1 = g(a);
				if (_v1.$ === 1) {
					var err = _v1.a;
					return $elm$core$Result$Err(err);
				} else {
					var x = _v1.a;
					return A2(
						$arowM$elm_form_decoder$Form$Decoder$run,
						f(x),
						a);
				}
			});
	});
var $author$project$Date$DeliveryDate$formDecoder = function (err) {
	return $arowM$elm_form_decoder$Form$Decoder$custom(
		A2(
			$elm$core$Basics$composeL,
			$elm$core$Result$fromMaybe(
				_List_fromArray(
					[err])),
			$author$project$Date$DeliveryDate$fromString));
};
var $author$project$Deliverer$Create$fromDecoder = A2(
	$arowM$elm_form_decoder$Form$Decoder$andThen,
	function (_v0) {
		return $author$project$Date$DeliveryDate$formDecoder(3);
	},
	A2(
		$arowM$elm_form_decoder$Form$Decoder$assert,
		A2($arowM$elm_form_decoder$Form$Decoder$minLength, 2, 1),
		$arowM$elm_form_decoder$Form$Decoder$identity));
var $author$project$Deliverer$Create$GivenNameRequired = 0;
var $author$project$Deliverer$Create$givenNameDecoder = A2(
	$arowM$elm_form_decoder$Form$Decoder$assert,
	A2($arowM$elm_form_decoder$Form$Decoder$minLength, 0, 1),
	$arowM$elm_form_decoder$Form$Decoder$identity);
var $author$project$Deliverer$Create$unregisteredDelivererDecoder = A2(
	$arowM$elm_form_decoder$Form$Decoder$field,
	A2(
		$arowM$elm_form_decoder$Form$Decoder$lift,
		function ($) {
			return $.d9;
		},
		$author$project$Deliverer$Create$familyNameDecoder),
	A2(
		$arowM$elm_form_decoder$Form$Decoder$field,
		A2(
			$arowM$elm_form_decoder$Form$Decoder$lift,
			function ($) {
				return $.ed;
			},
			$author$project$Deliverer$Create$givenNameDecoder),
		A2(
			$arowM$elm_form_decoder$Form$Decoder$field,
			A2(
				$arowM$elm_form_decoder$Form$Decoder$lift,
				function ($) {
					return $.l2;
				},
				$author$project$Deliverer$Create$fromDecoder),
			$arowM$elm_form_decoder$Form$Decoder$top($author$project$Deliverer$Unregistered$UnregisteredDeliverer))));
var $author$project$Deliverer$Create$whenWaiting = function (msg) {
	switch (msg.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 1;
		case 3:
			return 1;
		case 4:
			return 1;
		case 5:
			return 0;
		case 6:
			return 1;
		case 7:
			return 1;
		default:
			return 1;
	}
};
var $author$project$Deliverer$Create$update = F3(
	function (msg, share, model) {
		var unregisteredDelivererForm = model.eC;
		var withoutAction = function (action) {
			return $author$project$Portal$Return$withoutAction(
				action(0));
		};
		var withCommand = function (action) {
			return $author$project$Portal$Return$withCommand(
				action(0));
		};
		var token = $author$project$Portal$Share$token(share);
		var to = function (route) {
			return _Utils_Tuple3(
				A2($author$project$Portal$Share$withNewRoute, route, share),
				model,
				$elm$core$Platform$Cmd$none);
		};
		var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		var modelChange = function (m) {
			return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
		};
		var formChange = function (f) {
			return modelChange(
				A2($author$project$Deliverer$Create$setForm, model, f));
		};
		var err = F3(
			function (action, error, m) {
				return _Utils_Tuple3(
					A2(
						$author$project$Portal$Share$withHttpError,
						error,
						A2(
							$author$project$Portal$Share$withoutWaitingAction,
							action(0),
							share)),
					m,
					$elm$core$Platform$Cmd$none);
			});
		return (A3($author$project$Portal$Share$allowed, $author$project$Deliverer$Create$whenWaiting, msg, share) === 1) ? noChange : A2(
			$author$project$Portal$Return$ensureDataShared,
			$author$project$Deliverer$Create$shareDataFromModel,
			function () {
				switch (msg.$) {
					case 0:
						if (!msg.a.$) {
							var dp = msg.a.a;
							return A2(
								withoutAction,
								$author$project$Deliverer$Create$loadingDP,
								modelChange(
									_Utils_update(
										model,
										{
											bn: $author$project$Deliverer$Create$Loaded(dp)
										})));
						} else {
							var error = msg.a.a;
							return A3(
								err,
								$author$project$Deliverer$Create$loadingDP,
								error,
								_Utils_update(
									model,
									{
										bn: $author$project$Deliverer$Create$Failed(
											$author$project$Deliverer$Create$toDpId(model))
									}));
						}
					case 1:
						var from = msg.a;
						return formChange(
							_Utils_update(
								unregisteredDelivererForm,
								{l2: from}));
					case 2:
						var givenName = msg.a;
						return formChange(
							_Utils_update(
								unregisteredDelivererForm,
								{ed: givenName}));
					case 3:
						var familyName = msg.a;
						return formChange(
							_Utils_update(
								unregisteredDelivererForm,
								{d9: familyName}));
					case 4:
						var _v1 = A2($arowM$elm_form_decoder$Form$Decoder$run, $author$project$Deliverer$Create$unregisteredDelivererDecoder, unregisteredDelivererForm);
						if (!_v1.$) {
							var unregisteredDeliverer = _v1.a;
							return A3(
								withCommand,
								$author$project$Deliverer$Create$creatingDeliverer,
								A4(
									$author$project$Deliverer$Unregistered$addCmd,
									token,
									$author$project$Deliverer$Create$SystemCreatedDeliverer,
									$author$project$Deliverer$Create$toDpId(model),
									unregisteredDeliverer),
								formChange(
									_Utils_update(
										unregisteredDelivererForm,
										{f_: _List_Nil})));
						} else {
							var errors = _v1.a;
							return formChange(
								_Utils_update(
									unregisteredDelivererForm,
									{f_: errors}));
						}
					case 5:
						if (!msg.a.$) {
							return to(
								A2(
									$author$project$Portal$Route$DayPlanning,
									$author$project$Deliverer$Create$toDpId(model),
									model.lx));
						} else {
							var error = msg.a.a;
							return A3(err, $author$project$Deliverer$Create$creatingDeliverer, error, model);
						}
					case 6:
						return to(
							A2(
								$author$project$Portal$Route$DayPlanning,
								$author$project$Deliverer$Create$toDpId(model),
								model.lx));
					case 7:
						return to(
							A2(
								$author$project$Portal$Route$DayPlanning,
								$author$project$Deliverer$Create$toDpId(model),
								model.lx));
					default:
						return to($author$project$Portal$Route$Documents);
				}
			}());
	});
var $author$project$Deliverer$Edit$AddFreeMessage = function (a) {
	return {$: 8, a: a};
};
var $author$project$Deliverer$Edit$AddIntentToStop = function (a) {
	return {$: 7, a: a};
};
var $author$project$Deliverer$Edit$AddLocation = function (a) {
	return {$: 4, a: a};
};
var $author$project$Deliverer$Edit$AddReply = function (a) {
	return {$: 9, a: a};
};
var $author$project$Deliverer$Edit$AddSupplyPeriod = function (a) {
	return {$: 1, a: a};
};
var $author$project$Deliverer$Edit$DeleteLocation = function (a) {
	return {$: 6, a: a};
};
var $author$project$Deliverer$Edit$DeleteSupplyPeriod = function (a) {
	return {$: 3, a: a};
};
var $author$project$Deliverer$Edit$EditLocation = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Deliverer$Edit$EditSupplyPeriod = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Deliverer$Edit$Failed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Deliverer$Edit$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Deliverer$Edit$Submitting = function (a) {
	return {$: 10, a: a};
};
var $author$project$Deliverer$Edit$SystemAddedCommunication = function (a) {
	return {$: 31, a: a};
};
var $author$project$Deliverer$Edit$SystemAddedLocation = function (a) {
	return {$: 22, a: a};
};
var $author$project$Deliverer$Edit$SystemAddedSupplyPeriod = function (a) {
	return {$: 27, a: a};
};
var $author$project$Deliverer$Edit$SystemDeletedLocation = function (a) {
	return {$: 24, a: a};
};
var $author$project$Deliverer$Edit$SystemDeletedSupplyPeriod = function (a) {
	return {$: 29, a: a};
};
var $author$project$Deliverer$Edit$SystemGotAddress = function (a) {
	return {$: 26, a: a};
};
var $author$project$Deliverer$Edit$SystemGotTimeToSaveCommunication = function (a) {
	return {$: 15, a: a};
};
var $author$project$Deliverer$Edit$SystemUpdatedLocation = function (a) {
	return {$: 23, a: a};
};
var $author$project$Deliverer$Edit$SystemUpdatedSupplyPeriod = function (a) {
	return {$: 28, a: a};
};
var $author$project$Deliverer$Deliverer$encodeTime = function (time) {
	return $elm$json$Json$Encode$int(
		$elm$time$Time$posixToMillis(time));
};
var $author$project$Deliverer$Deliverer$encodeCommunication = function (communication) {
	switch (communication.$) {
		case 0:
			var communicatedOn = communication.a.a$;
			var stopOn = communication.a.hs;
			var reason = communication.a.jL;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'cType',
						$elm$json$Json$Encode$string('IntensionToStop')),
						_Utils_Tuple2(
						'on',
						$author$project$Deliverer$Deliverer$encodeTime(communicatedOn)),
						_Utils_Tuple2(
						'stopOn',
						$author$project$Date$DeliveryDate$encode(stopOn)),
						_Utils_Tuple2(
						'reason',
						$elm$json$Json$Encode$string(reason))
					]));
		case 1:
			var communicatedOn = communication.a.a$;
			var message = communication.a.fq;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'cType',
						$elm$json$Json$Encode$string('FreeMessage')),
						_Utils_Tuple2(
						'on',
						$author$project$Deliverer$Deliverer$encodeTime(communicatedOn)),
						_Utils_Tuple2(
						'message',
						$elm$json$Json$Encode$string(message))
					]));
		default:
			var replyTo = communication.a.jP;
			var communicatedOn = communication.a.a$;
			var message = communication.a.fq;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'cType',
						$elm$json$Json$Encode$string('Reply')),
						_Utils_Tuple2(
						'on',
						$author$project$Deliverer$Deliverer$encodeTime(communicatedOn)),
						_Utils_Tuple2(
						'replyTo',
						$author$project$Deliverer$Deliverer$encodeTime(replyTo)),
						_Utils_Tuple2(
						'message',
						$elm$json$Json$Encode$string(message))
					]));
	}
};
var $author$project$Deliverer$Deliverer$addCummunicationCmd = F4(
	function (token, toMsg, id, communication) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'deliverers',
					$author$project$Deliverer$Deliverer$encodeIdForUrl(id),
					'communications'
				]),
			_List_Nil);
		var body = $elm$http$Http$jsonBody(
			$author$project$Deliverer$Deliverer$encodeCommunication(communication));
		return A5($author$project$Api$Request$post, token, toMsg, uri, body, $author$project$Deliverer$Deliverer$communicationLogDecoder);
	});
var $author$project$Deliverer$Deliverer$addLocationCmd = F4(
	function (token, toMsg, id, location) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'deliverers',
					$author$project$Deliverer$Deliverer$encodeIdForUrl(id),
					'locations'
				]),
			_List_Nil);
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string(location.ft)),
						_Utils_Tuple2(
						'address',
						$author$project$Address$Address$encode(location.f1)),
						_Utils_Tuple2(
						'comment',
						A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, location.gg))
					])));
		return A5($author$project$Api$Request$post, token, toMsg, uri, body, $author$project$Deliverer$Deliverer$locationDecoder);
	});
var $author$project$Deliverer$Deliverer$encodeLocationIdForUrl = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$Deliverer$Deliverer$addSupplyPeriodCmd = F4(
	function (token, toMsg, id, supplyPeriod) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'deliverers',
					$author$project$Deliverer$Deliverer$encodeIdForUrl(id),
					'supply-periods',
					$author$project$Deliverer$Deliverer$encodeLocationIdForUrl(supplyPeriod.f5),
					$author$project$Date$DeliveryDate$encodeForUrl(supplyPeriod.l2)
				]),
			_List_Nil);
		return A5($author$project$Api$Request$post, token, toMsg, uri, $elm$http$Http$emptyBody, $author$project$Deliverer$Deliverer$supplyPeriodDecoder);
	});
var $author$project$Deliverer$Edit$addingCommunication = $author$project$Deliverer$Edit$singleAction('addingCommunication');
var $author$project$Deliverer$Edit$addingLocation = $author$project$Deliverer$Edit$singleAction('addingLocation');
var $author$project$Deliverer$Edit$addingSupplyPeriod = $author$project$Deliverer$Edit$singleAction('addingSupplyPeriod');
var $author$project$Deliverer$Deliverer$deleteLocationCmd = F4(
	function (token, toMsg, id, locationId) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'deliverers',
					$author$project$Deliverer$Deliverer$encodeIdForUrl(id),
					'locations',
					$author$project$Deliverer$Deliverer$encodeLocationIdForUrl(locationId)
				]),
			_List_Nil);
		return A5($author$project$Api$Request$delete, token, toMsg, uri, $elm$http$Http$emptyBody, $author$project$Deliverer$Deliverer$locationIdDecoder);
	});
var $author$project$Deliverer$Deliverer$deleteSupplyPeriodCmd = F4(
	function (token, toMsg, id, supplyPeriod) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'deliverers',
					$author$project$Deliverer$Deliverer$encodeIdForUrl(id),
					'supply-periods',
					$author$project$Deliverer$Deliverer$encodeLocationIdForUrl(supplyPeriod.f5),
					$author$project$Date$DeliveryDate$encodeForUrl(supplyPeriod.l2)
				]),
			_List_Nil);
		return A5($author$project$Api$Request$delete, token, toMsg, uri, $elm$http$Http$emptyBody, $author$project$Deliverer$Deliverer$supplyPeriodDecoder);
	});
var $author$project$Deliverer$Edit$deletingLocation = $author$project$Deliverer$Edit$singleAction('deletingLocation');
var $author$project$Deliverer$Edit$deletingSupplyPeriod = $author$project$Deliverer$Edit$singleAction('deletingSupplyPeriod');
var $author$project$Deliverer$Deliverer$encodeLocationId = function (_v0) {
	var id = _v0;
	return $elm$json$Json$Encode$string(id);
};
var $author$project$Deliverer$Deliverer$editLocationCmd = F4(
	function (token, toMSg, id, location) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'deliverers',
					$author$project$Deliverer$Deliverer$encodeIdForUrl(id),
					'locations',
					$author$project$Deliverer$Deliverer$encodeLocationIdForUrl(location.eg)
				]),
			_List_Nil);
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						$author$project$Deliverer$Deliverer$encodeLocationId(location.eg)),
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string(location.ft)),
						_Utils_Tuple2(
						'address',
						$author$project$Address$Address$encode(location.f1)),
						_Utils_Tuple2(
						'comment',
						A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, location.gg))
					])));
		return A5($author$project$Api$Request$patch, token, toMSg, uri, body, $author$project$Deliverer$Deliverer$locationDecoder);
	});
var $author$project$Deliverer$Deliverer$editSupplyPeriodCmd = F5(
	function (token, toMsg, id, original, _new) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'deliverers',
					$author$project$Deliverer$Deliverer$encodeIdForUrl(id),
					'supply-periods',
					$author$project$Deliverer$Deliverer$encodeLocationIdForUrl(original.f5),
					$author$project$Date$DeliveryDate$encodeForUrl(original.l2)
				]),
			_List_Nil);
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'at',
						$author$project$Deliverer$Deliverer$encodeLocationId(_new.f5)),
						_Utils_Tuple2(
						'from',
						$author$project$Date$DeliveryDate$encode(_new.l2))
					])));
		return A5($author$project$Api$Request$patch, token, toMsg, uri, body, $author$project$Deliverer$Deliverer$supplyPeriodDecoder);
	});
var $author$project$Deliverer$Edit$emptyLocationForm = {gg: '', bU: '', ft: '', bX: '', b5: '', dE: '', f_: _List_Nil, cT: ''};
var $author$project$Deliverer$Edit$emptySupplyPeriodForm = {f5: '', l2: '', f_: _List_Nil};
var $author$project$Deliverer$Edit$HouseNumberInt = 4;
var $author$project$Deliverer$Edit$HouseNumberRequired = 3;
var $arowM$elm_form_decoder$Form$Decoder$int = function (err) {
	return $arowM$elm_form_decoder$Form$Decoder$custom(
		A2(
			$elm$core$Basics$composeL,
			$elm$core$Result$fromMaybe(
				_List_fromArray(
					[err])),
			$elm$core$String$toInt));
};
var $author$project$Deliverer$Edit$locationAddressNumberDecoder = A2(
	$arowM$elm_form_decoder$Form$Decoder$andThen,
	function (_v0) {
		return $arowM$elm_form_decoder$Form$Decoder$int(4);
	},
	A2(
		$arowM$elm_form_decoder$Form$Decoder$assert,
		A2($arowM$elm_form_decoder$Form$Decoder$minLength, 3, 1),
		$arowM$elm_form_decoder$Form$Decoder$identity));
var $elm_community$string_extra$String$Extra$nonEmpty = function (string) {
	return $elm$core$String$isEmpty(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
};
var $author$project$Deliverer$Edit$locationAddressHouseNumberDecoder = A2(
	$arowM$elm_form_decoder$Form$Decoder$field,
	A2(
		$arowM$elm_form_decoder$Form$Decoder$lift,
		function ($) {
			return $.dE;
		},
		$arowM$elm_form_decoder$Form$Decoder$custom(
			A2($elm$core$Basics$composeR, $elm_community$string_extra$String$Extra$nonEmpty, $elm$core$Result$Ok))),
	A2(
		$arowM$elm_form_decoder$Form$Decoder$field,
		A2(
			$arowM$elm_form_decoder$Form$Decoder$lift,
			function ($) {
				return $.bX;
			},
			$author$project$Deliverer$Edit$locationAddressNumberDecoder),
		$arowM$elm_form_decoder$Form$Decoder$top($author$project$Address$Address$HouseNumber)));
var $author$project$Deliverer$Edit$ZipCodeRequired = 1;
var $author$project$Deliverer$Edit$locationAddressZipCodeDecoder = A2(
	$arowM$elm_form_decoder$Form$Decoder$assert,
	A2($arowM$elm_form_decoder$Form$Decoder$minLength, 1, 6),
	A2(
		$arowM$elm_form_decoder$Form$Decoder$map,
		$elm$core$String$toUpper,
		A2(
			$arowM$elm_form_decoder$Form$Decoder$map,
			A2($elm$core$String$replace, ' ', ''),
			$arowM$elm_form_decoder$Form$Decoder$identity)));
var $author$project$Deliverer$Edit$findAddressFormDecoder = A2(
	$arowM$elm_form_decoder$Form$Decoder$field,
	$arowM$elm_form_decoder$Form$Decoder$always($elm$core$Maybe$Nothing),
	A2(
		$arowM$elm_form_decoder$Form$Decoder$field,
		$arowM$elm_form_decoder$Form$Decoder$always(3),
		A2(
			$arowM$elm_form_decoder$Form$Decoder$field,
			$arowM$elm_form_decoder$Form$Decoder$custom(
				function (a) {
					return A2($arowM$elm_form_decoder$Form$Decoder$run, $author$project$Deliverer$Edit$locationAddressHouseNumberDecoder, a);
				}),
			A2(
				$arowM$elm_form_decoder$Form$Decoder$field,
				A2(
					$arowM$elm_form_decoder$Form$Decoder$lift,
					function ($) {
						return $.cT;
					},
					$author$project$Deliverer$Edit$locationAddressZipCodeDecoder),
				A2(
					$arowM$elm_form_decoder$Form$Decoder$field,
					$arowM$elm_form_decoder$Form$Decoder$always(''),
					A2(
						$arowM$elm_form_decoder$Form$Decoder$field,
						$arowM$elm_form_decoder$Form$Decoder$always(''),
						$arowM$elm_form_decoder$Form$Decoder$top($author$project$Address$Address$Address)))))));
var $author$project$Deliverer$Edit$MessageRequired = 0;
var $author$project$Deliverer$Edit$messageDecoder = function (required) {
	return A2(
		$arowM$elm_form_decoder$Form$Decoder$assert,
		A2($arowM$elm_form_decoder$Form$Decoder$minLength, required, 3),
		$arowM$elm_form_decoder$Form$Decoder$identity);
};
var $author$project$Deliverer$Edit$freeMessageDecoder = function (communicatedOn) {
	return A2(
		$arowM$elm_form_decoder$Form$Decoder$field,
		A2(
			$arowM$elm_form_decoder$Form$Decoder$lift,
			function ($) {
				return $.fq;
			},
			$author$project$Deliverer$Edit$messageDecoder(0)),
		$arowM$elm_form_decoder$Form$Decoder$top(
			function (message) {
				return $author$project$Deliverer$Deliverer$FreeMessage(
					{a$: communicatedOn, fq: message});
			}));
};
var $elm_community$list_extra$List$Extra$getAt = F2(
	function (idx, xs) {
		return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2($elm$core$List$drop, idx, xs));
	});
var $author$project$Deliverer$Edit$InvalidStopOn = 1;
var $author$project$Deliverer$Edit$ReasonRequired = 2;
var $author$project$Deliverer$Edit$StopOnRequired = 0;
var $author$project$Deliverer$Edit$intensionToStopDecoder = function (communicatedOn) {
	var reasonDecoder = A2(
		$arowM$elm_form_decoder$Form$Decoder$assert,
		A2($arowM$elm_form_decoder$Form$Decoder$minLength, 2, 3),
		$arowM$elm_form_decoder$Form$Decoder$identity);
	var dateDecoder = A2(
		$arowM$elm_form_decoder$Form$Decoder$pass,
		$arowM$elm_form_decoder$Form$Decoder$custom(
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Result$fromMaybe(
					_List_fromArray(
						[1])),
				$author$project$Date$DeliveryDate$fromString)),
		A2(
			$arowM$elm_form_decoder$Form$Decoder$assert,
			A2($arowM$elm_form_decoder$Form$Decoder$minLength, 0, 1),
			$arowM$elm_form_decoder$Form$Decoder$identity));
	return A2(
		$arowM$elm_form_decoder$Form$Decoder$field,
		A2(
			$arowM$elm_form_decoder$Form$Decoder$lift,
			function ($) {
				return $.jL;
			},
			reasonDecoder),
		A2(
			$arowM$elm_form_decoder$Form$Decoder$field,
			A2(
				$arowM$elm_form_decoder$Form$Decoder$lift,
				function ($) {
					return $.hs;
				},
				dateDecoder),
			$arowM$elm_form_decoder$Form$Decoder$top(
				F2(
					function (stopOn, reason) {
						return $author$project$Deliverer$Deliverer$IntentionToStop(
							{a$: communicatedOn, jL: reason, jO: $elm$core$Maybe$Nothing, hs: stopOn});
					}))));
};
var $author$project$Deliverer$Edit$ValidAddressRequired = 2;
var $author$project$Deliverer$Edit$locationValidAddressDecoder = A2(
	$arowM$elm_form_decoder$Form$Decoder$assert,
	A2($arowM$elm_form_decoder$Form$Decoder$minLength, 2, 1),
	$arowM$elm_form_decoder$Form$Decoder$identity);
var $author$project$Deliverer$Edit$locationAddressDecoder = A2(
	$arowM$elm_form_decoder$Form$Decoder$field,
	$arowM$elm_form_decoder$Form$Decoder$always($elm$core$Maybe$Nothing),
	A2(
		$arowM$elm_form_decoder$Form$Decoder$field,
		$arowM$elm_form_decoder$Form$Decoder$always(3),
		A2(
			$arowM$elm_form_decoder$Form$Decoder$field,
			$arowM$elm_form_decoder$Form$Decoder$custom(
				function (a) {
					return A2($arowM$elm_form_decoder$Form$Decoder$run, $author$project$Deliverer$Edit$locationAddressHouseNumberDecoder, a);
				}),
			A2(
				$arowM$elm_form_decoder$Form$Decoder$field,
				A2(
					$arowM$elm_form_decoder$Form$Decoder$lift,
					function ($) {
						return $.cT;
					},
					$author$project$Deliverer$Edit$locationAddressZipCodeDecoder),
				A2(
					$arowM$elm_form_decoder$Form$Decoder$field,
					A2(
						$arowM$elm_form_decoder$Form$Decoder$lift,
						function ($) {
							return $.b5;
						},
						$author$project$Deliverer$Edit$locationValidAddressDecoder),
					A2(
						$arowM$elm_form_decoder$Form$Decoder$field,
						A2(
							$arowM$elm_form_decoder$Form$Decoder$lift,
							function ($) {
								return $.bU;
							},
							$arowM$elm_form_decoder$Form$Decoder$identity),
						$arowM$elm_form_decoder$Form$Decoder$top($author$project$Address$Address$Address)))))));
var $author$project$Deliverer$Edit$NameRequired = 0;
var $author$project$Deliverer$Edit$locationNameDecoder = A2(
	$arowM$elm_form_decoder$Form$Decoder$assert,
	A2($arowM$elm_form_decoder$Form$Decoder$minLength, 0, 1),
	$arowM$elm_form_decoder$Form$Decoder$identity);
var $author$project$Deliverer$Edit$locationDecoder = function (id) {
	return A2(
		$arowM$elm_form_decoder$Form$Decoder$field,
		A2(
			$arowM$elm_form_decoder$Form$Decoder$lift,
			function ($) {
				return $.gg;
			},
			$arowM$elm_form_decoder$Form$Decoder$custom(
				A2($elm$core$Basics$composeR, $elm_community$string_extra$String$Extra$nonEmpty, $elm$core$Result$Ok))),
		A2(
			$arowM$elm_form_decoder$Form$Decoder$field,
			$arowM$elm_form_decoder$Form$Decoder$custom(
				function (a) {
					return A2($arowM$elm_form_decoder$Form$Decoder$run, $author$project$Deliverer$Edit$locationAddressDecoder, a);
				}),
			A2(
				$arowM$elm_form_decoder$Form$Decoder$field,
				A2(
					$arowM$elm_form_decoder$Form$Decoder$lift,
					function ($) {
						return $.ft;
					},
					$author$project$Deliverer$Edit$locationNameDecoder),
				A2(
					$arowM$elm_form_decoder$Form$Decoder$field,
					$arowM$elm_form_decoder$Form$Decoder$always(
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Deliverer$Deliverer$locationIdFromString(''),
							id)),
					$arowM$elm_form_decoder$Form$Decoder$top($author$project$Deliverer$Deliverer$Location)))));
};
var $author$project$Deliverer$Deliverer$sortedSupplyPeriods = function (supplyPeriods) {
	return A2(
		$elm$core$List$sortBy,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.l2;
			},
			$author$project$Date$DeliveryDate$oldestFirst),
		supplyPeriods);
};
var $author$project$Deliverer$Deliverer$activeSupplyPeriod = F2(
	function (date, supplyPeriods) {
		return $elm$core$List$head(
			$elm$core$List$reverse(
				$author$project$Deliverer$Deliverer$sortedSupplyPeriods(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.l2;
							},
							A2(
								$elm$core$Basics$composeR,
								$author$project$Date$DeliveryDate$toDate,
								A2(
									$elm$core$Basics$composeR,
									$justinmimbs$date$Date$compare(date),
									$elm$core$Basics$neq(0)))),
						supplyPeriods))));
	});
var $author$project$Deliverer$Deliverer$relevantSupplyPeriods = F2(
	function (date, supplyPeriods) {
		var active = function () {
			var _v0 = A2($author$project$Deliverer$Deliverer$activeSupplyPeriod, date, supplyPeriods);
			if (!_v0.$) {
				var a = _v0.a;
				return $author$project$Date$DeliveryDate$toDate(a.l2);
			} else {
				return date;
			}
		}();
		return A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.l2;
				},
				A2(
					$elm$core$Basics$composeR,
					$author$project$Date$DeliveryDate$toDate,
					A2(
						$elm$core$Basics$composeR,
						$justinmimbs$date$Date$compare(active),
						$elm$core$Basics$neq(2)))),
			supplyPeriods);
	});
var $elm_community$list_extra$List$Extra$removeAt = F2(
	function (index, l) {
		if (index < 0) {
			return l;
		} else {
			var _v0 = A2($elm$core$List$drop, index, l);
			if (!_v0.b) {
				return l;
			} else {
				var rest = _v0.b;
				return _Utils_ap(
					A2($elm$core$List$take, index, l),
					rest);
			}
		}
	});
var $author$project$Deliverer$Edit$ReplyMessageRequired = 0;
var $author$project$Deliverer$Edit$replyDecoder = function (communicatedOn) {
	return A2(
		$arowM$elm_form_decoder$Form$Decoder$field,
		A2(
			$arowM$elm_form_decoder$Form$Decoder$lift,
			function ($) {
				return $.fq;
			},
			$author$project$Deliverer$Edit$messageDecoder(0)),
		A2(
			$arowM$elm_form_decoder$Form$Decoder$field,
			A2(
				$arowM$elm_form_decoder$Form$Decoder$lift,
				function ($) {
					return $.jP;
				},
				$arowM$elm_form_decoder$Form$Decoder$identity),
			$arowM$elm_form_decoder$Form$Decoder$top(
				F2(
					function (replyTo, message) {
						return $author$project$Deliverer$Deliverer$Reply(
							{a$: communicatedOn, fq: message, jP: replyTo});
					}))));
};
var $author$project$Deliverer$Edit$AtRequired = 0;
var $author$project$Deliverer$Edit$locationIdDecoder = A2(
	$arowM$elm_form_decoder$Form$Decoder$map,
	$author$project$Deliverer$Deliverer$locationIdFromString,
	A2(
		$arowM$elm_form_decoder$Form$Decoder$assert,
		A2($arowM$elm_form_decoder$Form$Decoder$minLength, 0, 1),
		$arowM$elm_form_decoder$Form$Decoder$identity));
var $author$project$Deliverer$Edit$InvalidDate = 1;
var $author$project$Deliverer$Edit$supplyPeriodFromDecoder = F2(
	function (date, supplyPeriods) {
		return $arowM$elm_form_decoder$Form$Decoder$custom(
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Result$fromMaybe(
					_List_fromArray(
						[1])),
				A2(
					$elm$core$Basics$composeR,
					$author$project$Date$DeliveryDate$fromString,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$andThen(
							function (input) {
								var _v0 = A2(
									$justinmimbs$date$Date$compare,
									$author$project$Date$DeliveryDate$toDate(input),
									date);
								if (_v0 === 2) {
									return $elm$core$Maybe$Just(input);
								} else {
									return $elm$core$Maybe$Nothing;
								}
							}),
						$elm$core$Maybe$andThen(
							function (input) {
								var _v1 = A2(
									$elm_community$list_extra$List$Extra$find,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.l2;
										},
										$elm$core$Basics$eq(input)),
									supplyPeriods);
								if (!_v1.$) {
									return $elm$core$Maybe$Nothing;
								} else {
									return $elm$core$Maybe$Just(input);
								}
							})))));
	});
var $author$project$Deliverer$Edit$supplyPeriodDecoder = F2(
	function (date, supplyPeriods) {
		return A2(
			$arowM$elm_form_decoder$Form$Decoder$field,
			A2(
				$arowM$elm_form_decoder$Form$Decoder$lift,
				function ($) {
					return $.l2;
				},
				A2($author$project$Deliverer$Edit$supplyPeriodFromDecoder, date, supplyPeriods)),
			A2(
				$arowM$elm_form_decoder$Form$Decoder$field,
				A2(
					$arowM$elm_form_decoder$Form$Decoder$lift,
					function ($) {
						return $.f5;
					},
					$author$project$Deliverer$Edit$locationIdDecoder),
				$arowM$elm_form_decoder$Form$Decoder$top($author$project$Deliverer$Deliverer$SupplyPeriod)));
	});
var $author$project$Deliverer$Edit$toDelivererId = function (status) {
	switch (status.$) {
		case 0:
			var id = status.a;
			return id;
		case 1:
			var deliverer = status.a;
			return deliverer.eg;
		default:
			var id = status.a;
			return id;
	}
};
var $author$project$Deliverer$Edit$toLocationForm = function (location) {
	return {
		gg: A2($elm$core$Maybe$withDefault, '', location.gg),
		bU: location.f1.bU,
		ft: location.ft,
		bX: $elm$core$String$fromInt(location.f1.bs.bX),
		b5: location.f1.b5,
		dE: A2($elm$core$Maybe$withDefault, '', location.f1.bs.dE),
		f_: _List_Nil,
		cT: location.f1.cT
	};
};
var $author$project$Deliverer$Deliverer$locationIdToString = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$Deliverer$Edit$toSupplyPeriodForm = function (supplyPeriod) {
	return {
		f5: $author$project$Deliverer$Deliverer$locationIdToString(supplyPeriod.f5),
		l2: $author$project$Date$DeliveryDate$encodeForDateInput(supplyPeriod.l2),
		f_: _List_Nil
	};
};
var $author$project$Deliverer$Edit$updateForIntentToStop = F3(
	function (field, value, userInput) {
		if (userInput.$ === 7) {
			var form = userInput.a;
			return $author$project$Deliverer$Edit$AddIntentToStop(
				function () {
					if (!field) {
						return _Utils_update(
							form,
							{hs: value});
					} else {
						return _Utils_update(
							form,
							{jL: value});
					}
				}());
		} else {
			return userInput;
		}
	});
var $author$project$Deliverer$Edit$updateForLocation = F3(
	function (field, value, userInput) {
		var updateFor = function (location) {
			switch (field) {
				case 0:
					return _Utils_update(
						location,
						{ft: value});
				case 1:
					return _Utils_update(
						location,
						{gg: value});
				case 2:
					return _Utils_update(
						location,
						{cT: value});
				case 5:
					return _Utils_update(
						location,
						{bX: value});
				case 6:
					return _Utils_update(
						location,
						{dE: value});
				case 3:
					return _Utils_update(
						location,
						{b5: value});
				default:
					return _Utils_update(
						location,
						{bU: value});
			}
		};
		switch (userInput.$) {
			case 4:
				var location = userInput.a;
				return $author$project$Deliverer$Edit$AddLocation(
					updateFor(location));
			case 5:
				var id = userInput.a;
				var location = userInput.b;
				return A2(
					$author$project$Deliverer$Edit$EditLocation,
					id,
					updateFor(location));
			default:
				return userInput;
		}
	});
var $author$project$Deliverer$Edit$updateForSupplyPeriods = F3(
	function (field, value, userInput) {
		var updateFor = function (supplyPeriod) {
			if (!field) {
				return _Utils_update(
					supplyPeriod,
					{f5: value});
			} else {
				return _Utils_update(
					supplyPeriod,
					{l2: value});
			}
		};
		switch (userInput.$) {
			case 1:
				var supplyPeriod = userInput.a;
				return $author$project$Deliverer$Edit$AddSupplyPeriod(
					updateFor(supplyPeriod));
			case 2:
				var id = userInput.a;
				var supplyPeriod = userInput.b;
				return A2(
					$author$project$Deliverer$Edit$EditSupplyPeriod,
					id,
					updateFor(supplyPeriod));
			default:
				return userInput;
		}
	});
var $author$project$Deliverer$Edit$updateFreeMessage = F2(
	function (message, userInput) {
		if (userInput.$ === 8) {
			var form = userInput.a;
			return $author$project$Deliverer$Edit$AddFreeMessage(
				_Utils_update(
					form,
					{fq: message}));
		} else {
			return userInput;
		}
	});
var $author$project$Deliverer$Edit$updateReply = F2(
	function (message, userInput) {
		if (userInput.$ === 9) {
			var form = userInput.a;
			return $author$project$Deliverer$Edit$AddReply(
				_Utils_update(
					form,
					{fq: message}));
		} else {
			return userInput;
		}
	});
var $author$project$Deliverer$Edit$updatingLocation = $author$project$Deliverer$Edit$singleAction('updatingLocation');
var $author$project$Deliverer$Edit$updatingSupplyPeriod = $author$project$Deliverer$Edit$singleAction('updatingSupplyPeriod');
var $author$project$Deliverer$Edit$whenWaiting = function (msg) {
	switch (msg.$) {
		case 0:
			return 1;
		case 1:
			return 1;
		case 2:
			return 1;
		case 3:
			return 1;
		case 4:
			return 1;
		case 5:
			return 1;
		case 6:
			return 1;
		case 7:
			return 1;
		case 8:
			return 1;
		case 9:
			return 1;
		case 10:
			return 1;
		case 11:
			return 1;
		case 12:
			return 1;
		case 13:
			return 1;
		case 14:
			return 1;
		case 15:
			return 0;
		case 16:
			return 1;
		case 17:
			return 1;
		case 18:
			return 1;
		case 19:
			return 1;
		case 20:
			return 1;
		case 21:
			return 0;
		case 22:
			return 0;
		case 23:
			return 0;
		case 24:
			return 0;
		case 25:
			return 0;
		case 26:
			return 0;
		case 27:
			return 0;
		case 28:
			return 0;
		case 29:
			return 0;
		case 30:
			return 0;
		default:
			return 0;
	}
};
var $author$project$Deliverer$Edit$Municipal = 4;
var $author$project$Deliverer$Edit$Street = 3;
var $author$project$Deliverer$Edit$withLocationValidationError = F2(
	function (error, userInput) {
		switch (userInput.$) {
			case 4:
				var location = userInput.a;
				return $author$project$Deliverer$Edit$AddLocation(
					_Utils_update(
						location,
						{
							f_: _List_fromArray(
								[error])
						}));
			case 5:
				var id = userInput.a;
				var location = userInput.b;
				return A2(
					$author$project$Deliverer$Edit$EditLocation,
					id,
					_Utils_update(
						location,
						{
							f_: _List_fromArray(
								[error])
						}));
			default:
				return userInput;
		}
	});
var $author$project$Deliverer$Edit$withInvalidAddress = function (userInput) {
	return A2(
		$author$project$Deliverer$Edit$withLocationValidationError,
		2,
		A3(
			$author$project$Deliverer$Edit$updateForLocation,
			4,
			'',
			A3($author$project$Deliverer$Edit$updateForLocation, 3, '', userInput)));
};
var $author$project$Deliverer$Edit$withoutLocationValidationError = function (userInput) {
	switch (userInput.$) {
		case 4:
			var location = userInput.a;
			return $author$project$Deliverer$Edit$AddLocation(
				_Utils_update(
					location,
					{f_: _List_Nil}));
		case 5:
			var id = userInput.a;
			var location = userInput.b;
			return A2(
				$author$project$Deliverer$Edit$EditLocation,
				id,
				_Utils_update(
					location,
					{f_: _List_Nil}));
		default:
			return userInput;
	}
};
var $author$project$Deliverer$Edit$withValidAddress = F2(
	function (address, userInput) {
		return $author$project$Deliverer$Edit$withoutLocationValidationError(
			A3(
				$author$project$Deliverer$Edit$updateForLocation,
				4,
				address.bU,
				A3($author$project$Deliverer$Edit$updateForLocation, 3, address.b5, userInput)));
	});
var $author$project$Deliverer$Edit$update = F3(
	function (msg, share, model) {
		var token = $author$project$Portal$Share$token(share);
		var today = $author$project$Date$DeliveryDate$toDate(
			$author$project$Portal$Share$today(share));
		var to = function (route) {
			return _Utils_Tuple3(
				A2($author$project$Portal$Share$withNewRoute, route, share),
				model,
				$elm$core$Platform$Cmd$none);
		};
		var restoredUserInput = function () {
			var _v27 = model.ax;
			if (_v27.$ === 10) {
				var u = _v27.a;
				return _Utils_update(
					model,
					{ax: u});
			} else {
				return _Utils_update(
					model,
					{ax: $author$project$Deliverer$Edit$None});
			}
		}();
		var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		var modelChange = function (m) {
			return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
		};
		var userInputChange = function (i) {
			return modelChange(
				_Utils_update(
					model,
					{ax: i}));
		};
		var delivererId = $author$project$Deliverer$Edit$toDelivererId(model.bl);
		var err = F3(
			function (action, error, m) {
				return _Utils_Tuple3(
					A2(
						$author$project$Portal$Share$withHttpError,
						error,
						A2(
							$author$project$Portal$Share$withoutWaitingAction,
							action(delivererId),
							share)),
					m,
					$elm$core$Platform$Cmd$none);
			});
		var notification = F3(
			function (action, message, m) {
				return _Utils_Tuple3(
					A2(
						$author$project$Portal$Share$withNotification,
						message,
						A2(
							$author$project$Portal$Share$withoutWaitingAction,
							action(delivererId),
							share)),
					m,
					$elm$core$Platform$Cmd$none);
			});
		var withCommand = function (toAction) {
			return $author$project$Portal$Return$withCommand(
				toAction(delivererId));
		};
		var withoutAction = function (toAction) {
			return $author$project$Portal$Return$withoutAction(
				toAction(delivererId));
		};
		if (A3($author$project$Portal$Share$allowed, $author$project$Deliverer$Edit$whenWaiting, msg, share) === 1) {
			return _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		} else {
			switch (msg.$) {
				case 0:
					var route = msg.a;
					return to(route);
				case 1:
					return userInputChange(
						$author$project$Deliverer$Edit$AddLocation($author$project$Deliverer$Edit$emptyLocationForm));
				case 2:
					var location = msg.a;
					return userInputChange(
						A2(
							$author$project$Deliverer$Edit$EditLocation,
							location.eg,
							$author$project$Deliverer$Edit$toLocationForm(location)));
				case 3:
					var id = msg.a;
					return userInputChange(
						$author$project$Deliverer$Edit$DeleteLocation(id));
				case 4:
					return userInputChange(
						$author$project$Deliverer$Edit$AddSupplyPeriod($author$project$Deliverer$Edit$emptySupplyPeriodForm));
				case 5:
					var index = msg.a;
					var supplyPeriod = msg.b;
					return userInputChange(
						A2(
							$author$project$Deliverer$Edit$EditSupplyPeriod,
							index,
							$author$project$Deliverer$Edit$toSupplyPeriodForm(supplyPeriod)));
				case 6:
					var supplyPeriod = msg.a;
					return userInputChange(
						$author$project$Deliverer$Edit$DeleteSupplyPeriod(supplyPeriod));
				case 7:
					return userInputChange(
						$author$project$Deliverer$Edit$AddIntentToStop(
							{jL: '', hs: '', f_: _List_Nil}));
				case 8:
					return userInputChange(
						$author$project$Deliverer$Edit$AddFreeMessage(
							{fq: '', f_: _List_Nil}));
				case 9:
					var replyTo = msg.a;
					return userInputChange(
						$author$project$Deliverer$Edit$AddReply(
							{fq: '', jP: replyTo, f_: _List_Nil}));
				case 16:
					var field = msg.a;
					var value = msg.b;
					return userInputChange(
						A3($author$project$Deliverer$Edit$updateForLocation, field, value, model.ax));
				case 25:
					var address = function () {
						var _v2 = model.ax;
						switch (_v2.$) {
							case 4:
								var l = _v2.a;
								return $elm$core$Maybe$Just(
									A2($arowM$elm_form_decoder$Form$Decoder$run, $author$project$Deliverer$Edit$findAddressFormDecoder, l));
							case 5:
								var l = _v2.b;
								return $elm$core$Maybe$Just(
									A2($arowM$elm_form_decoder$Form$Decoder$run, $author$project$Deliverer$Edit$findAddressFormDecoder, l));
							default:
								return $elm$core$Maybe$Nothing;
						}
					}();
					var cmd = function () {
						if ((!address.$) && (!address.a.$)) {
							var addr = address.a.a;
							return A5($author$project$Address$Address$find, token, $author$project$Deliverer$Edit$SystemGotAddress, addr.cT, addr.bs, $author$project$Api$Request$Untracked);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return A2($author$project$Portal$Return$withBackgroundCommand, cmd, noChange);
				case 17:
					var field = msg.a;
					var value = msg.b;
					return userInputChange(
						A3($author$project$Deliverer$Edit$updateForSupplyPeriods, field, value, model.ax));
				case 18:
					var field = msg.a;
					var value = msg.b;
					return userInputChange(
						A3($author$project$Deliverer$Edit$updateForIntentToStop, field, value, model.ax));
				case 19:
					var message = msg.a;
					return userInputChange(
						A2($author$project$Deliverer$Edit$updateFreeMessage, message, model.ax));
				case 20:
					var message = msg.a;
					return userInputChange(
						A2($author$project$Deliverer$Edit$updateReply, message, model.ax));
				case 10:
					return userInputChange($author$project$Deliverer$Edit$None);
				case 11:
					var _v3 = _Utils_Tuple2(model.ax, model.bl);
					_v3$4:
					while (true) {
						if (_v3.b.$ === 1) {
							switch (_v3.a.$) {
								case 4:
									var input = _v3.a.a;
									var d = _v3.b.a;
									var _v4 = A2(
										$arowM$elm_form_decoder$Form$Decoder$run,
										$author$project$Deliverer$Edit$locationDecoder($elm$core$Maybe$Nothing),
										input);
									if (!_v4.$) {
										var location = _v4.a;
										return A3(
											withCommand,
											$author$project$Deliverer$Edit$addingLocation,
											A4($author$project$Deliverer$Deliverer$addLocationCmd, token, $author$project$Deliverer$Edit$SystemAddedLocation, d.eg, location),
											userInputChange(
												$author$project$Deliverer$Edit$Submitting(model.ax)));
									} else {
										var errors = _v4.a;
										return userInputChange(
											$author$project$Deliverer$Edit$AddLocation(
												_Utils_update(
													input,
													{f_: errors})));
									}
								case 5:
									var _v5 = _v3.a;
									var id = _v5.a;
									var input = _v5.b;
									var d = _v3.b.a;
									var _v6 = A2(
										$arowM$elm_form_decoder$Form$Decoder$run,
										$author$project$Deliverer$Edit$locationDecoder(
											$elm$core$Maybe$Just(id)),
										input);
									if (!_v6.$) {
										var location = _v6.a;
										return A3(
											withCommand,
											$author$project$Deliverer$Edit$updatingLocation,
											A4($author$project$Deliverer$Deliverer$editLocationCmd, token, $author$project$Deliverer$Edit$SystemUpdatedLocation, d.eg, location),
											userInputChange(
												$author$project$Deliverer$Edit$Submitting(model.ax)));
									} else {
										var errors = _v6.a;
										return userInputChange(
											A2(
												$author$project$Deliverer$Edit$EditLocation,
												id,
												_Utils_update(
													input,
													{f_: errors})));
									}
								case 1:
									var input = _v3.a.a;
									var d = _v3.b.a;
									var _v7 = A2(
										$arowM$elm_form_decoder$Form$Decoder$run,
										A2($author$project$Deliverer$Edit$supplyPeriodDecoder, today, d.kk),
										input);
									if (!_v7.$) {
										var supplyPeriod = _v7.a;
										return A3(
											withCommand,
											$author$project$Deliverer$Edit$addingSupplyPeriod,
											A4($author$project$Deliverer$Deliverer$addSupplyPeriodCmd, token, $author$project$Deliverer$Edit$SystemAddedSupplyPeriod, d.eg, supplyPeriod),
											userInputChange(
												$author$project$Deliverer$Edit$Submitting(model.ax)));
									} else {
										var errors = _v7.a;
										return userInputChange(
											$author$project$Deliverer$Edit$AddSupplyPeriod(
												_Utils_update(
													input,
													{f_: errors})));
									}
								case 2:
									var _v8 = _v3.a;
									var index = _v8.a;
									var input = _v8.b;
									var d = _v3.b.a;
									var _v9 = A2(
										$arowM$elm_form_decoder$Form$Decoder$run,
										A2(
											$author$project$Deliverer$Edit$supplyPeriodDecoder,
											today,
											A2($elm_community$list_extra$List$Extra$removeAt, index, d.kk)),
										input);
									if (!_v9.$) {
										var supplyPeriod = _v9.a;
										var _v10 = A2($elm_community$list_extra$List$Extra$getAt, index, d.kk);
										if (!_v10.$) {
											var original = _v10.a;
											return A3(
												withCommand,
												$author$project$Deliverer$Edit$updatingSupplyPeriod,
												A5($author$project$Deliverer$Deliverer$editSupplyPeriodCmd, token, $author$project$Deliverer$Edit$SystemUpdatedSupplyPeriod, d.eg, original, supplyPeriod),
												userInputChange(
													$author$project$Deliverer$Edit$Submitting(model.ax)));
										} else {
											return userInputChange($author$project$Deliverer$Edit$None);
										}
									} else {
										var errors = _v9.a;
										return userInputChange(
											A2(
												$author$project$Deliverer$Edit$EditSupplyPeriod,
												index,
												_Utils_update(
													input,
													{f_: errors})));
									}
								default:
									break _v3$4;
							}
						} else {
							break _v3$4;
						}
					}
					return userInputChange($author$project$Deliverer$Edit$None);
				case 12:
					return userInputChange($author$project$Deliverer$Edit$None);
				case 13:
					var _v11 = _Utils_Tuple2(model.bl, model.ax);
					_v11$2:
					while (true) {
						if (_v11.a.$ === 1) {
							switch (_v11.b.$) {
								case 3:
									var d = _v11.a.a;
									var supplyPeriod = _v11.b.a;
									return A3(
										withCommand,
										$author$project$Deliverer$Edit$deletingSupplyPeriod,
										A4($author$project$Deliverer$Deliverer$deleteSupplyPeriodCmd, token, $author$project$Deliverer$Edit$SystemDeletedSupplyPeriod, d.eg, supplyPeriod),
										userInputChange(
											$author$project$Deliverer$Edit$Submitting(model.ax)));
								case 6:
									var d = _v11.a.a;
									var id = _v11.b.a;
									return A3(
										withCommand,
										$author$project$Deliverer$Edit$deletingLocation,
										A4($author$project$Deliverer$Deliverer$deleteLocationCmd, token, $author$project$Deliverer$Edit$SystemDeletedLocation, d.eg, id),
										userInputChange(
											$author$project$Deliverer$Edit$Submitting(model.ax)));
								default:
									break _v11$2;
							}
						} else {
							break _v11$2;
						}
					}
					return userInputChange($author$project$Deliverer$Edit$None);
				case 14:
					return A2(
						$author$project$Portal$Return$withBackgroundCommand,
						A2($elm$core$Task$perform, $author$project$Deliverer$Edit$SystemGotTimeToSaveCommunication, $elm$time$Time$now),
						noChange);
				case 15:
					var now = msg.a;
					var _v12 = _Utils_Tuple2(model.ax, model.bl);
					_v12$3:
					while (true) {
						if (_v12.b.$ === 1) {
							switch (_v12.a.$) {
								case 7:
									var input = _v12.a.a;
									var d = _v12.b.a;
									var _v13 = A2(
										$arowM$elm_form_decoder$Form$Decoder$run,
										$author$project$Deliverer$Edit$intensionToStopDecoder(now),
										input);
									if (!_v13.$) {
										var communication = _v13.a;
										return A3(
											withCommand,
											$author$project$Deliverer$Edit$addingCommunication,
											A4($author$project$Deliverer$Deliverer$addCummunicationCmd, token, $author$project$Deliverer$Edit$SystemAddedCommunication, d.eg, communication),
											userInputChange(
												$author$project$Deliverer$Edit$Submitting(model.ax)));
									} else {
										var errors = _v13.a;
										return userInputChange(
											$author$project$Deliverer$Edit$AddIntentToStop(
												_Utils_update(
													input,
													{f_: errors})));
									}
								case 8:
									var input = _v12.a.a;
									var d = _v12.b.a;
									var _v14 = A2(
										$arowM$elm_form_decoder$Form$Decoder$run,
										$author$project$Deliverer$Edit$freeMessageDecoder(now),
										input);
									if (!_v14.$) {
										var communication = _v14.a;
										return A3(
											withCommand,
											$author$project$Deliverer$Edit$addingCommunication,
											A4($author$project$Deliverer$Deliverer$addCummunicationCmd, token, $author$project$Deliverer$Edit$SystemAddedCommunication, d.eg, communication),
											userInputChange(
												$author$project$Deliverer$Edit$Submitting(model.ax)));
									} else {
										var errors = _v14.a;
										return userInputChange(
											$author$project$Deliverer$Edit$AddFreeMessage(
												_Utils_update(
													input,
													{f_: errors})));
									}
								case 9:
									var input = _v12.a.a;
									var d = _v12.b.a;
									var _v15 = A2(
										$arowM$elm_form_decoder$Form$Decoder$run,
										$author$project$Deliverer$Edit$replyDecoder(now),
										input);
									if (!_v15.$) {
										var communication = _v15.a;
										return A3(
											withCommand,
											$author$project$Deliverer$Edit$addingCommunication,
											A4($author$project$Deliverer$Deliverer$addCummunicationCmd, token, $author$project$Deliverer$Edit$SystemAddedCommunication, d.eg, communication),
											userInputChange(
												$author$project$Deliverer$Edit$Submitting(model.ax)));
									} else {
										var errors = _v15.a;
										return userInputChange(
											$author$project$Deliverer$Edit$AddReply(
												_Utils_update(
													input,
													{f_: errors})));
									}
								default:
									break _v12$3;
							}
						} else {
							break _v12$3;
						}
					}
					return userInputChange($author$project$Deliverer$Edit$None);
				case 21:
					if (!msg.a.$) {
						var deliverer = msg.a.a;
						return A2(
							withoutAction,
							$author$project$Deliverer$Edit$loadingDeliverer,
							modelChange(
								function (d) {
									return _Utils_update(
										model,
										{
											bl: $author$project$Deliverer$Edit$Loaded(d)
										});
								}(
									function (sps) {
										return _Utils_update(
											deliverer,
											{kk: sps});
									}(
										$author$project$Deliverer$Deliverer$sortedSupplyPeriods(
											A2($author$project$Deliverer$Deliverer$relevantSupplyPeriods, today, deliverer.kk))))));
					} else {
						var error = msg.a.a;
						var _v16 = model.bl;
						if (!_v16.$) {
							var id = _v16.a;
							return A3(
								err,
								$author$project$Deliverer$Edit$loadingDeliverer,
								error,
								_Utils_update(
									model,
									{
										bl: $author$project$Deliverer$Edit$Failed(id)
									}));
						} else {
							return noChange;
						}
					}
				case 22:
					if (!msg.a.$) {
						var location = msg.a.a;
						var _v17 = model.bl;
						if (_v17.$ === 1) {
							var d = _v17.a;
							return A2(
								withoutAction,
								$author$project$Deliverer$Edit$addingLocation,
								modelChange(
									_Utils_update(
										model,
										{
											bl: $author$project$Deliverer$Edit$Loaded(
												_Utils_update(
													d,
													{
														i4: _Utils_ap(
															d.i4,
															_List_fromArray(
																[location]))
													})),
											ax: $author$project$Deliverer$Edit$None
										})));
						} else {
							return userInputChange($author$project$Deliverer$Edit$None);
						}
					} else {
						if ((msg.a.a.$ === 3) && (msg.a.a.a === 400)) {
							return A2(
								withoutAction,
								$author$project$Deliverer$Edit$addingLocation,
								userInputChange(
									$author$project$Deliverer$Edit$withInvalidAddress(restoredUserInput.ax)));
						} else {
							var error = msg.a.a;
							return A3(err, $author$project$Deliverer$Edit$addingLocation, error, restoredUserInput);
						}
					}
				case 23:
					if (!msg.a.$) {
						var location = msg.a.a;
						return A2(
							withoutAction,
							$author$project$Deliverer$Edit$updatingLocation,
							function () {
								var _v18 = model.bl;
								if (_v18.$ === 1) {
									var d = _v18.a;
									return modelChange(
										function (ls) {
											return _Utils_update(
												model,
												{
													bl: $author$project$Deliverer$Edit$Loaded(
														_Utils_update(
															d,
															{i4: ls}))
												});
										}(
											A3(
												$elm_community$list_extra$List$Extra$setIf,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.eg;
													},
													$elm$core$Basics$eq(location.eg)),
												location,
												d.i4)));
								} else {
									return noChange;
								}
							}());
					} else {
						if ((msg.a.a.$ === 3) && (msg.a.a.a === 400)) {
							return A2(
								withoutAction,
								$author$project$Deliverer$Edit$updatingLocation,
								userInputChange(
									$author$project$Deliverer$Edit$withInvalidAddress(restoredUserInput.ax)));
						} else {
							var error = msg.a.a;
							return A3(err, $author$project$Deliverer$Edit$updatingLocation, error, restoredUserInput);
						}
					}
				case 24:
					if (msg.a.$ === 1) {
						if ((msg.a.a.$ === 3) && (msg.a.a.a === 400)) {
							return A3(
								notification,
								$author$project$Deliverer$Edit$deletingLocation,
								A2(
									$author$project$Portal$Message$error,
									'Locatie kan niet verwijderd worden.',
									$elm$core$Maybe$Just('De locatie kan niet verwijderd worden, waarschijnlijk omdat deze ingepland is als afleverlocatie.')),
								_Utils_update(
									model,
									{ax: $author$project$Deliverer$Edit$None}));
						} else {
							var error = msg.a.a;
							return A3(
								err,
								$author$project$Deliverer$Edit$deletingLocation,
								error,
								_Utils_update(
									model,
									{ax: $author$project$Deliverer$Edit$None}));
						}
					} else {
						return A2(
							withoutAction,
							$author$project$Deliverer$Edit$deletingLocation,
							function () {
								var _v19 = _Utils_Tuple2(model.ax, model.bl);
								if ((_v19.a.$ === 10) && (_v19.b.$ === 1)) {
									var userInput = _v19.a.a;
									var d = _v19.b.a;
									if (userInput.$ === 6) {
										var id = userInput.a;
										return modelChange(
											function (ls) {
												return _Utils_update(
													model,
													{
														bl: $author$project$Deliverer$Edit$Loaded(
															_Utils_update(
																d,
																{i4: ls})),
														ax: $author$project$Deliverer$Edit$None
													});
											}(
												A2(
													$elm$core$List$filter,
													A2(
														$elm$core$Basics$composeR,
														function ($) {
															return $.eg;
														},
														$elm$core$Basics$neq(id)),
													d.i4)));
									} else {
										return userInputChange($author$project$Deliverer$Edit$None);
									}
								} else {
									return userInputChange($author$project$Deliverer$Edit$None);
								}
							}());
					}
				case 26:
					if (!msg.a.$) {
						var address = msg.a.a;
						return userInputChange(
							A2($author$project$Deliverer$Edit$withValidAddress, address, model.ax));
					} else {
						if (!msg.a.a.$) {
							var address = msg.a.a.a;
							return userInputChange(
								A2($author$project$Deliverer$Edit$withValidAddress, address, model.ax));
						} else {
							return userInputChange(
								$author$project$Deliverer$Edit$withInvalidAddress(model.ax));
						}
					}
				case 27:
					if (!msg.a.$) {
						var supplyPeriod = msg.a.a;
						return A2(
							withoutAction,
							$author$project$Deliverer$Edit$addingSupplyPeriod,
							function () {
								var _v21 = model.bl;
								if (_v21.$ === 1) {
									var d = _v21.a;
									return modelChange(
										function (sps) {
											return _Utils_update(
												model,
												{
													bl: $author$project$Deliverer$Edit$Loaded(
														_Utils_update(
															d,
															{kk: sps})),
													ax: $author$project$Deliverer$Edit$None
												});
										}(
											_Utils_ap(
												d.kk,
												_List_fromArray(
													[supplyPeriod]))));
								} else {
									return userInputChange($author$project$Deliverer$Edit$None);
								}
							}());
					} else {
						var error = msg.a.a;
						return A3(err, $author$project$Deliverer$Edit$addingSupplyPeriod, error, restoredUserInput);
					}
				case 28:
					if (!msg.a.$) {
						var supplyPeriod = msg.a.a;
						return A2(
							withoutAction,
							$author$project$Deliverer$Edit$updatingSupplyPeriod,
							function () {
								var _v22 = _Utils_Tuple2(model.ax, model.bl);
								if (((_v22.a.$ === 10) && (_v22.a.a.$ === 2)) && (_v22.b.$ === 1)) {
									var _v23 = _v22.a.a;
									var index = _v23.a;
									var d = _v22.b.a;
									return modelChange(
										function (sps) {
											return _Utils_update(
												model,
												{
													bl: $author$project$Deliverer$Edit$Loaded(
														_Utils_update(
															d,
															{kk: sps}))
												});
										}(
											A3($elm_community$list_extra$List$Extra$setAt, index, supplyPeriod, d.kk)));
								} else {
									return noChange;
								}
							}());
					} else {
						var error = msg.a.a;
						return A3(err, $author$project$Deliverer$Edit$updatingSupplyPeriod, error, restoredUserInput);
					}
				case 29:
					if (msg.a.$ === 1) {
						var error = msg.a.a;
						return A3(
							err,
							$author$project$Deliverer$Edit$deletingSupplyPeriod,
							error,
							_Utils_update(
								model,
								{ax: $author$project$Deliverer$Edit$None}));
					} else {
						return A2(
							withoutAction,
							$author$project$Deliverer$Edit$deletingSupplyPeriod,
							function () {
								var _v24 = _Utils_Tuple2(model.ax, model.bl);
								if (((_v24.a.$ === 10) && (_v24.a.a.$ === 3)) && (_v24.b.$ === 1)) {
									var supplyPeriod = _v24.a.a.a;
									var d = _v24.b.a;
									return modelChange(
										function (sps) {
											return _Utils_update(
												model,
												{
													bl: $author$project$Deliverer$Edit$Loaded(
														_Utils_update(
															d,
															{kk: sps})),
													ax: $author$project$Deliverer$Edit$None
												});
										}(
											A2(
												$elm$core$List$filter,
												function (p) {
													return !(_Utils_eq(p.f5, supplyPeriod.f5) && _Utils_eq(p.l2, supplyPeriod.l2));
												},
												d.kk)));
								} else {
									return userInputChange($author$project$Deliverer$Edit$None);
								}
							}());
					}
				case 30:
					if (!msg.a.$) {
						var communicationLog = msg.a.a;
						return A2(
							withoutAction,
							$author$project$Deliverer$Edit$loadingCommunicationLog,
							modelChange(
								_Utils_update(
									model,
									{
										bi: $author$project$Deliverer$Edit$Loaded(communicationLog)
									})));
					} else {
						if ((msg.a.a.$ === 3) && (msg.a.a.a === 404)) {
							return A2(
								withoutAction,
								$author$project$Deliverer$Edit$loadingCommunicationLog,
								function () {
									var _v25 = model.bi;
									if (!_v25.$) {
										var id = _v25.a;
										return modelChange(
											_Utils_update(
												model,
												{
													bi: $author$project$Deliverer$Edit$Loaded(
														{eg: id, gL: _List_Nil})
												}));
									} else {
										return noChange;
									}
								}());
						} else {
							var error = msg.a.a;
							var _v26 = model.bi;
							if (!_v26.$) {
								var id = _v26.a;
								return A3(
									err,
									$author$project$Deliverer$Edit$loadingCommunicationLog,
									error,
									_Utils_update(
										model,
										{
											bi: $author$project$Deliverer$Edit$Failed(id)
										}));
							} else {
								return A2(withoutAction, $author$project$Deliverer$Edit$loadingCommunicationLog, noChange);
							}
						}
					}
				default:
					if (!msg.a.$) {
						var communicationLog = msg.a.a;
						return A2(
							withoutAction,
							$author$project$Deliverer$Edit$addingCommunication,
							modelChange(
								_Utils_update(
									model,
									{
										bi: $author$project$Deliverer$Edit$Loaded(communicationLog),
										ax: $author$project$Deliverer$Edit$None
									})));
					} else {
						var error = msg.a.a;
						return A3(err, $author$project$Deliverer$Edit$addingCommunication, error, restoredUserInput);
					}
			}
		}
	});
var $author$project$Distributor$Validate$Failed = function (a) {
	return {$: 3, a: a};
};
var $author$project$Distributor$Validate$GotValidationReport = function (a) {
	return {$: 3, a: a};
};
var $author$project$Distributor$Validate$InvalidDateInput = 2;
var $author$project$Distributor$Validate$Loaded = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Distributor$Validate$Loading = function (a) {
	return {$: 1, a: a};
};
var $author$project$Distributor$Validate$DistributorDateRequired = 1;
var $author$project$Distributor$Validate$OrderDateRequired = 0;
var $author$project$Distributor$Validate$formDecoder = A2(
	$arowM$elm_form_decoder$Form$Decoder$field,
	A2(
		$arowM$elm_form_decoder$Form$Decoder$lift,
		function ($) {
			return $.d3;
		},
		$author$project$Date$DeliveryDate$formDecoder(1)),
	A2(
		$arowM$elm_form_decoder$Form$Decoder$field,
		A2(
			$arowM$elm_form_decoder$Form$Decoder$lift,
			function ($) {
				return $.ej;
			},
			$author$project$Date$DeliveryDate$formDecoder(0)),
		$arowM$elm_form_decoder$Form$Decoder$top(
			F2(
				function (od, dd) {
					return _Utils_Tuple2(od, dd);
				}))));
var $author$project$Distributor$Validate$formOf = function (model) {
	switch (model.$) {
		case 0:
			var form = model.a;
			return form;
		case 1:
			var form = model.a;
			return form;
		case 2:
			var form = model.a;
			return form;
		default:
			var form = model.a;
			return form;
	}
};
var $author$project$Distributor$Validate$actionIdFor = function (id) {
	return A2($author$project$Portal$Waiting$Id, 'DistributorValidate', id);
};
var $author$project$Distributor$Validate$singleAction = F2(
	function (id, _v0) {
		return $author$project$Portal$Waiting$singleAction(
			$author$project$Distributor$Validate$actionIdFor(id));
	});
var $author$project$Distributor$Validate$loading = $author$project$Distributor$Validate$singleAction('loadingReport');
var $BrianHicks$elm_csv$Csv$Encode$encodeItems = F2(
	function (encoder, rows) {
		if (!encoder.$) {
			var convert = encoder.a;
			var _v1 = A3(
				$elm$core$List$foldr,
				F2(
					function (row, _v2) {
						var converted_ = _v2.a;
						var names = _v2.b;
						var convertedRow = convert(row);
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								$elm$core$Dict$fromList(convertedRow),
								converted_),
							A3(
								$elm$core$List$foldl,
								F2(
									function (_v3, _v4) {
										var name = _v3.a;
										var soFar = _v4.a;
										var column = _v4.b;
										return _Utils_Tuple2(
											A3(
												$elm$core$Dict$update,
												name,
												function (value) {
													if (!value.$) {
														var columns = value.a;
														return $elm$core$Maybe$Just(
															A2($elm$core$List$cons, column, columns));
													} else {
														return $elm$core$Maybe$Just(
															_List_fromArray(
																[column]));
													}
												},
												soFar),
											column + 1);
									}),
								_Utils_Tuple2(names, 0),
								convertedRow).a);
					}),
				_Utils_Tuple2(_List_Nil, $elm$core$Dict$empty),
				rows);
			var converted = _v1.a;
			var namePositions = _v1.b;
			var ordering = A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2(
					$elm$core$List$sortBy,
					$elm$core$Tuple$second,
					$elm$core$Dict$toList(
						A2(
							$elm$core$Dict$map,
							F2(
								function (_v6, positions) {
									return $elm$core$List$sum(positions) / $elm$core$List$length(positions);
								}),
							namePositions))));
			return A2(
				$elm$core$List$cons,
				ordering,
				A2(
					$elm$core$List$map,
					function (row) {
						return A2(
							$elm$core$List$map,
							function (field) {
								return A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Dict$get, field, row));
							},
							ordering);
					},
					converted));
		} else {
			var convert = encoder.a;
			return A2($elm$core$List$map, convert, rows);
		}
	});
var $BrianHicks$elm_csv$Csv$Encode$quoteIfNecessary = F2(
	function (fieldSeparator, value) {
		return (A2($elm$core$String$contains, '\"', value) || (A2($elm$core$String$contains, fieldSeparator, value) || (A2($elm$core$String$contains, '\u000D\n', value) || A2($elm$core$String$contains, '\n', value)))) ? ('\"' + (A3($elm$core$String$replace, '\"', '\"\"', value) + '\"')) : value;
	});
var $BrianHicks$elm_csv$Csv$Encode$encode = F2(
	function (_v0, items) {
		var encoder = _v0.lO;
		var fieldSeparator = _v0.lX;
		var fieldSeparatorString = $elm$core$String$fromChar(fieldSeparator);
		return A2(
			$elm$core$String$join,
			'\u000D\n',
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$String$join(fieldSeparatorString),
					$elm$core$List$map(
						$BrianHicks$elm_csv$Csv$Encode$quoteIfNecessary(fieldSeparatorString))),
				A2($BrianHicks$elm_csv$Csv$Encode$encodeItems, encoder, items)));
	});
var $BrianHicks$elm_csv$Csv$Encode$WithFieldNames = function (a) {
	return {$: 0, a: a};
};
var $BrianHicks$elm_csv$Csv$Encode$withFieldNames = $BrianHicks$elm_csv$Csv$Encode$WithFieldNames;
var $author$project$Distributor$Validate$zipCodeToString = function (zipCode) {
	return zipCode;
};
var $author$project$Distributor$Validate$mutationsToCsv = function (mutations) {
	return A2(
		$BrianHicks$elm_csv$Csv$Encode$encode,
		{
			lO: $BrianHicks$elm_csv$Csv$Encode$withFieldNames(
				function (m) {
					return _List_fromArray(
						[
							_Utils_Tuple2('Klant ID', m.ia),
							_Utils_Tuple2(
							'Postcode',
							$author$project$Distributor$Validate$zipCodeToString(m.f1.cT)),
							_Utils_Tuple2('Straat', m.f1.b5),
							_Utils_Tuple2(
							'Nummer',
							$elm$core$String$fromInt(m.f1.bs.bX)),
							_Utils_Tuple2('Verpakking', m.ie),
							_Utils_Tuple2(
							'Product',
							_Utils_ap(m.jJ.dq, m.jJ.is)),
							_Utils_Tuple2('Distributeur', m.i9),
							_Utils_Tuple2('Gebied / Shop', m.ik),
							_Utils_Tuple2('Referentie', m.il),
							_Utils_Tuple2('Vorige Distributeur', m.jF),
							_Utils_Tuple2('Vorige Gebied / Shop', m.jD),
							_Utils_Tuple2('Vorige Referentie', m.jE)
						]);
				}),
			lX: ','
		},
		mutations);
};
var $elm$file$File$Download$string = F3(
	function (name, mime, content) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$never,
			A3(_File_download, name, mime, content));
	});
var $author$project$Distributor$Validate$Report = F3(
	function (mutations, distributor, shop) {
		return {ij: distributor, jk: mutations, j3: shop};
	});
var $author$project$Distributor$Validate$Mutation = function (customerID) {
	return function (address) {
		return function (deliveryMethod) {
			return function (product) {
				return function (previousMainDistributor) {
					return function (previousDistributorId) {
						return function (previousDistributorReference) {
							return function (mainDistributor) {
								return function (distributorId) {
									return function (distributorReference) {
										return {f1: address, ia: customerID, ie: deliveryMethod, ik: distributorId, il: distributorReference, i9: mainDistributor, jD: previousDistributorId, jE: previousDistributorReference, jF: previousMainDistributor, jJ: product};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Distributor$Validate$Product = F3(
	function (productCode, editionCode, quantity) {
		return {is: editionCode, dq: productCode, nm: quantity};
	});
var $author$project$Distributor$Validate$decodeProduct = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'quantity',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'editionCode',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'productCode',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Distributor$Validate$Product))));
var $author$project$Distributor$Validate$decodeMutation = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'distributorReference',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'distributorId',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'mainDistributor',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'prevDistributorReference',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'prevDistributorId',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'prevMainDistributor',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'product',
							$author$project$Distributor$Validate$decodeProduct,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'delivery',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'address',
									$author$project$Address$Address$decoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Distributor$Validate$Mutation)))))))))));
var $author$project$Distributor$Validate$StartStop = F2(
	function (start, stop) {
		return {hq: start, hr: stop};
	});
var $author$project$Distributor$Validate$decodeStartStops = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'stop',
	$elm$json$Json$Decode$dict($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'start',
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$int),
		$elm$json$Json$Decode$succeed($author$project$Distributor$Validate$StartStop)));
var $author$project$Distributor$Validate$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'shop',
	$elm$json$Json$Decode$dict($author$project$Distributor$Validate$decodeStartStops),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'distributor',
		$elm$json$Json$Decode$dict($author$project$Distributor$Validate$decodeStartStops),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'mutations',
			$elm$json$Json$Decode$list($author$project$Distributor$Validate$decodeMutation),
			$elm$json$Json$Decode$succeed($author$project$Distributor$Validate$Report))));
var $author$project$Distributor$Validate$validateCmd = F4(
	function (token, toMsg, orderDate, distributorDate) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'distributor',
					'validate',
					$author$project$Date$DeliveryDate$encodeForUrl(orderDate),
					$author$project$Date$DeliveryDate$encodeForUrl(distributorDate)
				]),
			_List_Nil);
		return A4($author$project$Api$Request$get, token, toMsg, uri, $author$project$Distributor$Validate$decode);
	});
var $author$project$Distributor$Validate$whenWaiting = function (msg) {
	switch (msg.$) {
		case 0:
			return 1;
		case 1:
			return 1;
		case 2:
			return 1;
		case 3:
			return 0;
		default:
			return 1;
	}
};
var $author$project$Distributor$Validate$withForm = F2(
	function (form, model) {
		switch (model.$) {
			case 0:
				return $author$project$Distributor$Validate$Selecting(form);
			case 1:
				return $author$project$Distributor$Validate$Loading(form);
			case 2:
				var report = model.b;
				return A2($author$project$Distributor$Validate$Loaded, form, report);
			default:
				return $author$project$Distributor$Validate$Failed(form);
		}
	});
var $author$project$Distributor$Validate$update = F3(
	function (msg, share, model) {
		var withoutAction = function (action) {
			return $author$project$Portal$Return$withoutAction(
				action(0));
		};
		var token = $author$project$Portal$Share$token(share);
		var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		var modelChange = function (m) {
			return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
		};
		if (A3($author$project$Portal$Share$allowed, $author$project$Distributor$Validate$whenWaiting, msg, share) === 1) {
			return noChange;
		} else {
			switch (msg.$) {
				case 0:
					var date = msg.a;
					var form = $author$project$Distributor$Validate$formOf(model);
					return modelChange(
						A2(
							$author$project$Distributor$Validate$withForm,
							_Utils_update(
								form,
								{ej: date}),
							model));
				case 1:
					var date = msg.a;
					var form = $author$project$Distributor$Validate$formOf(model);
					return modelChange(
						A2(
							$author$project$Distributor$Validate$withForm,
							_Utils_update(
								form,
								{d3: date}),
							model));
				case 2:
					var form = $author$project$Distributor$Validate$formOf(model);
					var _v1 = A2($arowM$elm_form_decoder$Form$Decoder$run, $author$project$Distributor$Validate$formDecoder, form);
					if (!_v1.$) {
						var _v2 = _v1.a;
						var od = _v2.a;
						var dd = _v2.b;
						return A3(
							$author$project$Portal$Return$withCommand,
							$author$project$Distributor$Validate$loading(0),
							A4($author$project$Distributor$Validate$validateCmd, token, $author$project$Distributor$Validate$GotValidationReport, od, dd),
							modelChange(
								$author$project$Distributor$Validate$Loading(
									_Utils_update(
										form,
										{f_: _List_Nil}))));
					} else {
						var errors = _v1.a;
						return modelChange(
							A2(
								$author$project$Distributor$Validate$withForm,
								_Utils_update(
									form,
									{f_: errors}),
								model));
					}
				case 3:
					if (!msg.a.$) {
						var report = msg.a.a;
						return A2(
							withoutAction,
							$author$project$Distributor$Validate$loading,
							modelChange(
								A2(
									$author$project$Distributor$Validate$Loaded,
									$author$project$Distributor$Validate$formOf(model),
									report)));
					} else {
						if ((msg.a.a.$ === 3) && (msg.a.a.a === 400)) {
							var form = $author$project$Distributor$Validate$formOf(model);
							return A2(
								withoutAction,
								$author$project$Distributor$Validate$loading,
								modelChange(
									$author$project$Distributor$Validate$Failed(
										_Utils_update(
											form,
											{
												f_: _List_fromArray(
													[2])
											}))));
						} else {
							var error = msg.a.a;
							return _Utils_Tuple3(
								A2(
									$author$project$Portal$Share$withHttpError,
									error,
									A2(
										$author$project$Portal$Share$withoutWaitingAction,
										$author$project$Distributor$Validate$loading(0),
										share)),
								$author$project$Distributor$Validate$Selecting(
									$author$project$Distributor$Validate$formOf(model)),
								$elm$core$Platform$Cmd$none);
						}
					}
				default:
					if (model.$ === 2) {
						var report = model.b;
						return A2(
							$author$project$Portal$Return$withBackgroundCommand,
							A3(
								$elm$file$File$Download$string,
								'mutations.csv',
								'text/csv',
								$author$project$Distributor$Validate$mutationsToCsv(report.jk)),
							noChange);
					} else {
						return noChange;
					}
			}
		}
	});
var $author$project$Documents$Documents$Failed = {$: 2};
var $author$project$Documents$Documents$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Documents$Documents$next = function (model) {
	if ((!model.$) && (!model.a.a)) {
		var _v1 = model.a;
		var folders = _v1.b;
		return $author$project$Documents$Documents$Loaded(
			{fd: $elm$core$Maybe$Nothing, fe: folders});
	} else {
		return model;
	}
};
var $author$project$Documents$Documents$withFolder = F2(
	function (f, model) {
		return $author$project$Documents$Documents$next(
			function () {
				if (!model.$) {
					var _v1 = model.a;
					var remaining = _v1.a;
					var folders = _v1.b;
					return $author$project$Documents$Documents$Loading(
						_Utils_Tuple2(
							remaining - 1,
							A2($elm$core$List$cons, f, folders)));
				} else {
					return model;
				}
			}());
	});
var $author$project$Documents$Documents$update = F3(
	function (msg, share, model) {
		var withoutIndexedAction = F2(
			function (toAction, index) {
				return $author$project$Portal$Return$withoutAction(
					A2(toAction, 0, index));
			});
		var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		var modelChange = function (m) {
			return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
		};
		var err = F3(
			function (action, error, m) {
				return _Utils_Tuple3(
					A2(
						$author$project$Portal$Share$withHttpError,
						error,
						A2($author$project$Portal$Share$withoutWaitingAction, action, share)),
					m,
					$elm$core$Platform$Cmd$none);
			});
		switch (msg.$) {
			case 0:
				if (!msg.b.$) {
					var index = msg.a;
					var f = msg.b.a;
					return A3(
						withoutIndexedAction,
						$author$project$Documents$Documents$loadingDocuments,
						index,
						modelChange(
							A2($author$project$Documents$Documents$withFolder, f, model)));
				} else {
					var index = msg.a;
					var error = msg.b.a;
					return A3(
						err,
						A2($author$project$Documents$Documents$loadingDocuments, 0, index),
						error,
						$author$project$Documents$Documents$Failed);
				}
			case 1:
				var document = msg.a;
				if (model.$ === 1) {
					var m = model.a;
					return modelChange(
						$author$project$Documents$Documents$Loaded(
							_Utils_update(
								m,
								{
									fd: $elm$core$Maybe$Just(document)
								})));
				} else {
					return noChange;
				}
			default:
				if (model.$ === 1) {
					var m = model.a;
					return modelChange(
						$author$project$Documents$Documents$Loaded(
							_Utils_update(
								m,
								{fd: $elm$core$Maybe$Nothing})));
				} else {
					return noChange;
				}
		}
	});
var $author$project$Lists$Distribution$DistributionList$toDistributionPointId = function (loadedStatus) {
	switch (loadedStatus.$) {
		case 0:
			var dpId = loadedStatus.a;
			return dpId;
		case 1:
			var distributionPoint = loadedStatus.a;
			return distributionPoint.eg;
		default:
			var dpId = loadedStatus.a;
			return dpId;
	}
};
var $author$project$Lists$Distribution$DistributionList$update = F3(
	function (msg, share, model) {
		return A2(
			$author$project$Portal$Return$ensureDataShared,
			$author$project$Lists$Distribution$DistributionList$shareDataFromModel,
			function () {
				var token = $author$project$Portal$Share$token(share);
				var to = function (route) {
					return _Utils_Tuple3(
						A2($author$project$Portal$Share$withNewRoute, route, share),
						model,
						$elm$core$Platform$Cmd$none);
				};
				var modelChange = function (m) {
					return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
				};
				var dpId = $author$project$Lists$Distribution$DistributionList$toDistributionPointId(model.bn);
				var actionKey = _Utils_Tuple2(dpId, model.lx);
				var err = F3(
					function (toAction, error, m) {
						return _Utils_Tuple3(
							A2(
								$author$project$Portal$Share$withHttpError,
								error,
								A2(
									$author$project$Portal$Share$withoutWaitingAction,
									toAction(actionKey),
									share)),
							m,
							$elm$core$Platform$Cmd$none);
					});
				var withCommands = function (toAction) {
					return $author$project$Portal$Return$withCommands(
						toAction(actionKey));
				};
				var withoutAction = function (toAction) {
					return $author$project$Portal$Return$withoutAction(
						toAction(actionKey));
				};
				var withoutIndexedAction = F2(
					function (toAction, index) {
						return $author$project$Portal$Return$withoutAction(
							A2(toAction, actionKey, index));
					});
				switch (msg.$) {
					case 0:
						if (!msg.a.$) {
							var distributionPoint = msg.a.a;
							return A2(
								withoutAction,
								$author$project$Lists$Distribution$DistributionList$loadingDP,
								function () {
									var _v1 = _Utils_Tuple2(
										$author$project$DistributionPoint$IdDict$isEmpty(model.bm),
										$author$project$DistributionPoint$DistributionPoint$getSubDistributionPoints(distributionPoint));
									if (_v1.a && _v1.b.b) {
										var subDPs = _v1.b;
										return A2(
											withCommands,
											$author$project$Lists$Distribution$DistributionList$loadingSummaries,
											A2(
												$elm$core$List$map,
												F2(
													function (subDP, i) {
														return A4(
															$author$project$Demand$Summary$loadForDPCmd,
															token,
															$author$project$Lists$Distribution$DistributionList$SystemGotSubDPDemandSummary(i),
															$author$project$DistributionPoint$DistributionPoint$idOf(subDP),
															model.lx);
													}),
												subDPs));
									} else {
										return $elm$core$Basics$identity;
									}
								}()(
									modelChange(
										_Utils_update(
											model,
											{
												bn: $author$project$Lists$Distribution$DistributionList$Loaded(distributionPoint)
											}))));
						} else {
							var error = msg.a.a;
							return A3(err, $author$project$Lists$Distribution$DistributionList$loadingDP, error, model);
						}
					case 1:
						var planLoaderMsg = msg.a;
						return A2(
							$author$project$Plan$PlanLoader$mapModel,
							function (pAndD) {
								return _Utils_update(
									model,
									{fB: pAndD});
							},
							$author$project$Plan$PlanLoader$registerErrorOnFailed(
								A2(
									$author$project$Plan$PlanLoader$mapCommand,
									$elm$core$Platform$Cmd$map($author$project$Lists$Distribution$DistributionList$SystemGotLoaderMsg),
									A6(
										$author$project$Plan$PlanLoader$update,
										share,
										token,
										$author$project$Lists$Distribution$DistributionList$loadingPlan(actionKey),
										$elm$core$Basics$identity,
										planLoaderMsg,
										model.fB))));
					case 2:
						if (!msg.a.$) {
							var orders = msg.a.a;
							return A2(
								withoutAction,
								$author$project$Lists$Distribution$DistributionList$loadingOrders,
								modelChange(
									_Utils_update(
										model,
										{
											Y: $author$project$Lists$Distribution$DistributionList$Loaded(orders)
										})));
						} else {
							var error = msg.a.a;
							return A3(err, $author$project$Lists$Distribution$DistributionList$loadingOrders, error, model);
						}
					case 3:
						if (!msg.b.$) {
							var index = msg.a;
							var subDpOrderSummary = msg.b.a;
							return A3(
								withoutIndexedAction,
								$author$project$Lists$Distribution$DistributionList$loadingSummaries,
								index,
								modelChange(
									function (s) {
										return _Utils_update(
											model,
											{bm: s});
									}(
										A3($author$project$DistributionPoint$IdDict$insert, subDpOrderSummary.lK, subDpOrderSummary, model.bm))));
						} else {
							var index = msg.a;
							var error = msg.b.a;
							return _Utils_Tuple3(
								A2(
									$author$project$Portal$Share$withHttpError,
									error,
									A2(
										$author$project$Portal$Share$withoutWaitingAction,
										A2($author$project$Lists$Distribution$DistributionList$loadingSummaries, actionKey, index),
										share)),
								model,
								$elm$core$Platform$Cmd$none);
						}
					case 4:
						if (!msg.a.$) {
							var products = msg.a.a;
							return A2(
								withoutAction,
								$author$project$Lists$Distribution$DistributionList$loadingProducts,
								modelChange(
									_Utils_update(
										model,
										{
											bu: $author$project$Lists$Distribution$DistributionList$Loaded(products)
										})));
						} else {
							var error = msg.a.a;
							return A3(err, $author$project$Lists$Distribution$DistributionList$loadingProducts, error, model);
						}
					default:
						return to(
							A2($author$project$Portal$Route$DayPlanning, dpId, model.lx));
				}
			}());
	});
var $author$project$Lists$Distribution$PreSupplyList$toDistributionPointId = function (loadedStatus) {
	switch (loadedStatus.$) {
		case 0:
			var dpId = loadedStatus.a;
			return dpId;
		case 1:
			var distributionPoint = loadedStatus.a;
			return distributionPoint.eg;
		default:
			var dpId = loadedStatus.a;
			return dpId;
	}
};
var $author$project$Lists$Distribution$PreSupplyList$update = F3(
	function (msg, share, model) {
		return A2(
			$author$project$Portal$Return$ensureDataShared,
			$author$project$Lists$Distribution$PreSupplyList$shareDataFromModel,
			function () {
				var token = $author$project$Portal$Share$token(share);
				var to = function (route) {
					return _Utils_Tuple3(
						A2($author$project$Portal$Share$withNewRoute, route, share),
						model,
						$elm$core$Platform$Cmd$none);
				};
				var modelChange = function (m) {
					return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
				};
				var dpId = $author$project$Lists$Distribution$PreSupplyList$toDistributionPointId(model.bn);
				var actionKey = _Utils_Tuple2(dpId, model.lx);
				var err = F3(
					function (toAction, error, m) {
						return _Utils_Tuple3(
							A2(
								$author$project$Portal$Share$withHttpError,
								error,
								A2(
									$author$project$Portal$Share$withoutWaitingAction,
									toAction(actionKey),
									share)),
							m,
							$elm$core$Platform$Cmd$none);
					});
				var withCommands = function (toAction) {
					return $author$project$Portal$Return$withCommands(
						toAction(actionKey));
				};
				var withoutAction = function (toAction) {
					return $author$project$Portal$Return$withoutAction(
						toAction(actionKey));
				};
				var withoutIndexedAction = F2(
					function (toAction, index) {
						return $author$project$Portal$Return$withoutAction(
							A2(toAction, actionKey, index));
					});
				switch (msg.$) {
					case 0:
						if (!msg.a.$) {
							var distributionPoint = msg.a.a;
							return A2(
								withoutAction,
								$author$project$Lists$Distribution$PreSupplyList$loadingDP,
								function () {
									var _v1 = _Utils_Tuple2(
										$author$project$DistributionPoint$IdDict$isEmpty(model.bm),
										$author$project$DistributionPoint$DistributionPoint$getSubDistributionPoints(distributionPoint));
									if (_v1.a && _v1.b.b) {
										var subDPs = _v1.b;
										return A2(
											withCommands,
											$author$project$Lists$Distribution$PreSupplyList$loadingSummaries,
											A2(
												$elm$core$List$map,
												F2(
													function (subDP, i) {
														return A4(
															$author$project$Demand$Summary$loadForDPCmd,
															token,
															$author$project$Lists$Distribution$PreSupplyList$SystemGotSubDPDemandSummary(i),
															$author$project$DistributionPoint$DistributionPoint$idOf(subDP),
															model.lx);
													}),
												subDPs));
									} else {
										return $elm$core$Basics$identity;
									}
								}()(
									modelChange(
										_Utils_update(
											model,
											{
												bn: $author$project$Lists$Distribution$PreSupplyList$Loaded(distributionPoint)
											}))));
						} else {
							var error = msg.a.a;
							return A3(err, $author$project$Lists$Distribution$PreSupplyList$loadingDP, error, model);
						}
					case 1:
						var planLoaderMsg = msg.a;
						return A2(
							$author$project$Plan$PlanLoader$mapModel,
							function (pAndD) {
								return _Utils_update(
									model,
									{fB: pAndD});
							},
							$author$project$Plan$PlanLoader$registerErrorOnFailed(
								A2(
									$author$project$Plan$PlanLoader$mapCommand,
									$elm$core$Platform$Cmd$map($author$project$Lists$Distribution$PreSupplyList$SystemGotLoaderMsg),
									A6(
										$author$project$Plan$PlanLoader$update,
										share,
										token,
										$author$project$Lists$Distribution$PreSupplyList$loadingPlan(actionKey),
										$elm$core$Basics$identity,
										planLoaderMsg,
										model.fB))));
					case 2:
						if (!msg.a.$) {
							var orders = msg.a.a;
							return A2(
								withoutAction,
								$author$project$Lists$Distribution$PreSupplyList$loadingOrders,
								modelChange(
									_Utils_update(
										model,
										{
											Y: $author$project$Lists$Distribution$PreSupplyList$Loaded(orders)
										})));
						} else {
							var error = msg.a.a;
							return A3(err, $author$project$Lists$Distribution$PreSupplyList$loadingOrders, error, model);
						}
					case 3:
						if (!msg.b.$) {
							var index = msg.a;
							var subDpOrderSummary = msg.b.a;
							return A3(
								withoutIndexedAction,
								$author$project$Lists$Distribution$PreSupplyList$loadingSummaries,
								index,
								modelChange(
									function (s) {
										return _Utils_update(
											model,
											{bm: s});
									}(
										A3($author$project$DistributionPoint$IdDict$insert, subDpOrderSummary.lK, subDpOrderSummary, model.bm))));
						} else {
							var index = msg.a;
							var error = msg.b.a;
							return _Utils_Tuple3(
								A2(
									$author$project$Portal$Share$withHttpError,
									error,
									A2(
										$author$project$Portal$Share$withoutWaitingAction,
										A2($author$project$Lists$Distribution$PreSupplyList$loadingSummaries, actionKey, index),
										share)),
								model,
								$elm$core$Platform$Cmd$none);
						}
					case 4:
						if (!msg.a.$) {
							var products = msg.a.a;
							return A2(
								withoutAction,
								$author$project$Lists$Distribution$PreSupplyList$loadingProducts,
								modelChange(
									_Utils_update(
										model,
										{
											bu: $author$project$Lists$Distribution$PreSupplyList$Loaded(products)
										})));
						} else {
							var error = msg.a.a;
							return A3(err, $author$project$Lists$Distribution$PreSupplyList$loadingProducts, error, model);
						}
					default:
						return to(
							A2($author$project$Portal$Route$DayPlanning, dpId, model.lx));
				}
			}());
	});
var $author$project$Lists$Received$CheckList$Failed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Lists$Received$CheckList$parameters = function (model) {
	switch (model.$) {
		case 0:
			var p = model.a;
			return p;
		case 1:
			var p = model.a;
			return p;
		default:
			var p = model.a;
			return p;
	}
};
var $author$project$Lists$Received$CheckList$update = F3(
	function (msg, share, model) {
		var token = $author$project$Portal$Share$token(share);
		var to = function (route) {
			return _Utils_Tuple3(
				A2($author$project$Portal$Share$withNewRoute, route, share),
				model,
				$elm$core$Platform$Cmd$none);
		};
		var planId = $author$project$Lists$Received$CheckList$parameters(model).a8;
		var withCommands = function (toAction) {
			return $author$project$Portal$Return$withCommands(
				toAction(planId));
		};
		var withoutAction = function (toAction) {
			return $author$project$Portal$Return$withoutAction(
				toAction(planId));
		};
		var withoutIndexedAction = F2(
			function (toAction, index) {
				return $author$project$Portal$Return$withoutAction(
					A2(toAction, planId, index));
			});
		var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		var modelChange = function (m) {
			return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
		};
		var err = F3(
			function (action, error, m) {
				return _Utils_Tuple3(
					A2(
						$author$project$Portal$Share$withHttpError,
						error,
						A2(
							$author$project$Portal$Share$withoutWaitingAction,
							action(planId),
							share)),
					m,
					$elm$core$Platform$Cmd$none);
			});
		var _v0 = _Utils_Tuple2(msg, model);
		switch (_v0.a.$) {
			case 0:
				if (!_v0.a.a.$) {
					if (!_v0.b.$) {
						var distributionPoint = _v0.a.a.a;
						var _v1 = _v0.b;
						var p = _v1.a;
						var m = _v1.b;
						return A2(
							withoutAction,
							$author$project$Lists$Received$CheckList$loadingDP,
							A3(
								$elm$core$Basics$apR,
								A2(
									$elm$core$List$map,
									F2(
										function (subDP, i) {
											return A4(
												$author$project$Lists$Received$CheckList$loadForDPCmd,
												token,
												$author$project$Lists$Received$CheckList$BackendRespondedSubDPAggregatedOrders(i),
												$author$project$DistributionPoint$DistributionPoint$idOf(subDP),
												planId.lx);
										}),
									$author$project$DistributionPoint$DistributionPoint$getSubDistributionPoints(distributionPoint)),
								withCommands($author$project$Lists$Received$CheckList$loadingSubDPSummaries),
								modelChange(
									$author$project$Lists$Received$CheckList$next(
										A2(
											$author$project$Lists$Received$CheckList$Loading,
											p,
											_Utils_update(
												m,
												{
													bn: $elm$core$Maybe$Just(distributionPoint)
												}))))));
					} else {
						return A2(withoutAction, $author$project$Lists$Received$CheckList$loadingDP, noChange);
					}
				} else {
					var error = _v0.a.a.a;
					return A3(
						err,
						$author$project$Lists$Received$CheckList$loadingDP,
						error,
						$author$project$Lists$Received$CheckList$Failed(
							$author$project$Lists$Received$CheckList$parameters(model)));
				}
			case 1:
				if (!_v0.a.a.$) {
					if (!_v0.b.$) {
						var dpDemandSummary = _v0.a.a.a;
						var _v2 = _v0.b;
						var p = _v2.a;
						var m = _v2.b;
						return A2(
							withoutAction,
							$author$project$Lists$Received$CheckList$loadingSummary,
							modelChange(
								$author$project$Lists$Received$CheckList$next(
									A2(
										$author$project$Lists$Received$CheckList$Loading,
										p,
										_Utils_update(
											m,
											{
												c3: A3($author$project$DistributionPoint$IdDict$insert, dpDemandSummary.lK, dpDemandSummary, m.c3)
											})))));
					} else {
						return A2(withoutAction, $author$project$Lists$Received$CheckList$loadingSummary, noChange);
					}
				} else {
					var error = _v0.a.a.a;
					return A3(
						err,
						$author$project$Lists$Received$CheckList$loadingSummary,
						error,
						$author$project$Lists$Received$CheckList$Failed(
							$author$project$Lists$Received$CheckList$parameters(model)));
				}
			case 2:
				if (!_v0.a.b.$) {
					if (!_v0.b.$) {
						var _v3 = _v0.a;
						var index = _v3.a;
						var dpDemandSummary = _v3.b.a;
						var _v4 = _v0.b;
						var p = _v4.a;
						var m = _v4.b;
						return A3(
							withoutIndexedAction,
							$author$project$Lists$Received$CheckList$loadingSubDPSummaries,
							index,
							modelChange(
								$author$project$Lists$Received$CheckList$next(
									A2(
										$author$project$Lists$Received$CheckList$Loading,
										p,
										_Utils_update(
											m,
											{
												c3: A3($author$project$DistributionPoint$IdDict$insert, dpDemandSummary.lK, dpDemandSummary, m.c3)
											})))));
					} else {
						var _v5 = _v0.a;
						var index = _v5.a;
						return A3(withoutIndexedAction, $author$project$Lists$Received$CheckList$loadingSubDPSummaries, index, noChange);
					}
				} else {
					var _v6 = _v0.a;
					var index = _v6.a;
					var error = _v6.b.a;
					return _Utils_Tuple3(
						A2(
							$author$project$Portal$Share$withHttpError,
							error,
							A2(
								$author$project$Portal$Share$withoutWaitingAction,
								A2($author$project$Lists$Received$CheckList$loadingSubDPSummaries, planId, index),
								share)),
						$author$project$Lists$Received$CheckList$Failed(
							$author$project$Lists$Received$CheckList$parameters(model)),
						$elm$core$Platform$Cmd$none);
				}
			default:
				var _v7 = _v0.a;
				return to(
					A2($author$project$Portal$Route$DayPlanning, planId.gm, planId.lx));
		}
	});
var $author$project$Lists$RouteDetail$Deliverer$Failed = function (a) {
	return {$: 3, a: a};
};
var $author$project$Lists$RouteDetail$Deliverer$GotSubHeaderMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Lists$RouteDetail$Route$GuidedOrders = 2;
var $author$project$Lists$RouteDetail$Deliverer$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Portal$Share$MinimizedHeader = 1;
var $author$project$Lists$RouteDetail$Deliverer$NoOrders = function (a) {
	return {$: 2, a: a};
};
var $author$project$Lists$RouteDetail$Deliverer$bikeRouteDetail = function (route) {
	switch (route.$) {
		case 0:
			var b = route.a;
			return $elm$core$Maybe$Just(b);
		case 1:
			var own = route.a.js;
			if (!own.$) {
				var bb = own.a;
				return $elm$core$Maybe$Just(bb);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Lists$RouteDetail$Deliverer$checkPrintItem = F3(
	function (printItems, _v0, bool) {
		var distributionPoint = _v0.bn;
		var cluster = _v0.H;
		return A3(
			$elm_community$list_extra$List$Extra$updateIf,
			function (i) {
				return _Utils_eq(
					$author$project$DistributionPoint$DistributionPoint$idOf(i.bn),
					$author$project$DistributionPoint$DistributionPoint$idOf(distributionPoint)) && _Utils_eq(i.H.bX, cluster.bX);
			},
			function (i) {
				return _Utils_update(
					i,
					{lc: bool});
			},
			printItems);
	});
var $author$project$Sequence$Edit$WithoutMap = {$: 0};
var $author$project$Sequence$Edit$default = F2(
	function (date, sequence) {
		return {lx: date, bo: $author$project$Sequence$Edit$dnd.mL, fm: false, dg: $author$project$Sequence$Edit$WithoutMap, j0: sequence};
	});
var $author$project$UI$Swipe$defaultSensitivity = 80;
var $author$project$Sequence$Sequence$Joinable = 0;
var $author$project$Sequence$Sequence$Unjoinable = 1;
var $author$project$Sequence$Sequence$setJoinability = function (sequence) {
	var newSequence = A3(
		$elm$core$List$foldl,
		F2(
			function (item, _v0) {
				var soFar = _v0.a;
				var lastStreet = _v0.b;
				var street = A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.b5;
						},
						$elm$core$List$head(item.aR)));
				var isJoinable = function () {
					var _v1 = _Utils_eq(lastStreet, street);
					if (_v1) {
						return 0;
					} else {
						return 1;
					}
				}();
				return _Utils_Tuple2(
					_Utils_ap(
						soFar,
						_List_fromArray(
							[
								_Utils_update(
								item,
								{mC: isJoinable})
							])),
					street);
			}),
		_Utils_Tuple2(_List_Nil, ''),
		sequence.gL).a;
	return _Utils_update(
		sequence,
		{gL: newSequence});
};
var $author$project$Sequence$StreetPart$withoutEmpty = function (streetParts) {
	return A2(
		$elm$core$List$filter,
		A2(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$List$isEmpty),
			function ($) {
				return $.fD;
			}),
		streetParts);
};
var $author$project$Sequence$Sequence$withoutEmptyStreetParts = function (sequence) {
	var items = A2(
		$elm$core$List$filter,
		A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$List$isEmpty),
				$author$project$Sequence$StreetPart$withoutEmpty),
			function ($) {
				return $.aR;
			}),
		sequence.gL);
	return _Utils_update(
		sequence,
		{gL: items});
};
var $author$project$Sequence$Sequence$prepareForEdit = A2($elm$core$Basics$composeL, $author$project$Sequence$Sequence$setJoinability, $author$project$Sequence$Sequence$withoutEmptyStreetParts);
var $author$project$UI$Swipe$EndGesture = function (a) {
	return {$: 3, a: a};
};
var $author$project$UI$Swipe$EndTap = function (a) {
	return {$: 4, a: a};
};
var $author$project$UI$Swipe$Moved = function (a) {
	return {$: 2, a: a};
};
var $author$project$UI$Swipe$Started = function (a) {
	return {$: 1, a: a};
};
var $author$project$UI$Swipe$addToTrail = F2(
	function (coordinate, _v0) {
		var from = _v0.l2;
		var to = _v0.oj;
		var through = _v0.fW;
		return {
			l2: from,
			fW: A2($elm$core$List$cons, to, through),
			oj: coordinate
		};
	});
var $author$project$UI$Swipe$record = F2(
	function (_v0, gesture) {
		var eventType = _v0.a;
		var coordinate = _v0.b;
		var _v1 = _Utils_Tuple2(eventType, gesture);
		switch (_v1.a) {
			case 0:
				var _v2 = _v1.a;
				return $author$project$UI$Swipe$Started(coordinate);
			case 1:
				switch (_v1.b.$) {
					case 1:
						var _v3 = _v1.a;
						var prev = _v1.b.a;
						return $author$project$UI$Swipe$Moved(
							{l2: prev, fW: _List_Nil, oj: coordinate});
					case 2:
						var _v4 = _v1.a;
						var trail = _v1.b.a;
						return $author$project$UI$Swipe$Moved(
							A2($author$project$UI$Swipe$addToTrail, coordinate, trail));
					default:
						var _v5 = _v1.a;
						return $author$project$UI$Swipe$Started(coordinate);
				}
			default:
				if (_v1.b.$ === 2) {
					var _v6 = _v1.a;
					var trail = _v1.b.a;
					return $author$project$UI$Swipe$EndGesture(
						A2($author$project$UI$Swipe$addToTrail, coordinate, trail));
				} else {
					var _v7 = _v1.a;
					return $author$project$UI$Swipe$EndTap(coordinate);
				}
		}
	});
var $author$project$Plan$Supply$findEmptyClusters = function (items) {
	var findInItem = function (item) {
		switch (item.$) {
			case 0:
				var id = item.a.eg;
				var cluster = item.a.H;
				var supplies = item.a.n0;
				return ($elm$core$List$isEmpty(cluster.bb) && $elm$core$List$isEmpty(supplies)) ? _List_fromArray(
					[
						{ll: cluster.bX, dF: id}
					]) : $elm$core$List$concat(
					A2(
						$elm$core$List$map,
						function (s) {
							return findInItem(s);
						},
						supplies));
			case 1:
				var id = item.a.eg;
				var clusters = item.a.k;
				return A2(
					$elm$core$List$map,
					function (c) {
						return {ll: c.bX, dF: id};
					},
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.bb;
							},
							$elm$core$List$isEmpty),
						clusters));
			default:
				return _List_Nil;
		}
	};
	return $elm$core$List$concat(
		A2($elm$core$List$map, findInItem, items));
};
var $author$project$Plan$Supply$idOf = function (item) {
	switch (item.$) {
		case 1:
			var id = item.a.eg;
			return id;
		case 0:
			var id = item.a.eg;
			return id;
		default:
			var id = item.a.eg;
			return id;
	}
};
var $author$project$Plan$Supply$findItemById = F2(
	function (items, target) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (i) {
					if (_Utils_eq(
						$author$project$Plan$Supply$idOf(i),
						target)) {
						return $elm$core$Maybe$Just(i);
					} else {
						if (!i.$) {
							var supplies = i.a.n0;
							return A2($author$project$Plan$Supply$findItemById, supplies, target);
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}
				},
				items));
	});
var $author$project$Plan$Supply$findClusterIn = F2(
	function (clusterNumber, item) {
		switch (item.$) {
			case 0:
				var cluster = item.a.H;
				return _Utils_eq(cluster.bX, clusterNumber) ? $elm$core$Maybe$Just(cluster) : $elm$core$Maybe$Nothing;
			case 1:
				var clusters = item.a.k;
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.bX;
							},
							$elm$core$Basics$eq(clusterNumber)),
						clusters));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Plan$Supply$removeItem = F2(
	function (target, items) {
		return A2(
			$elm$core$List$filterMap,
			function (i) {
				if (_Utils_eq(
					$author$project$Plan$Supply$idOf(i),
					target)) {
					return $elm$core$Maybe$Nothing;
				} else {
					if (!i.$) {
						var car = i.a;
						return $elm$core$Maybe$Just(
							$author$project$Plan$Supply$Car(
								_Utils_update(
									car,
									{
										n0: A2($author$project$Plan$Supply$removeItem, target, car.n0)
									})));
					} else {
						return $elm$core$Maybe$Just(i);
					}
				}
			},
			items);
	});
var $author$project$Plan$Supply$replaceItem = F3(
	function (id, item, items) {
		return A2(
			$elm$core$List$map,
			function (i) {
				if (_Utils_eq(
					$author$project$Plan$Supply$idOf(i),
					id)) {
					return item;
				} else {
					if (!i.$) {
						var car = i.a;
						return $author$project$Plan$Supply$Car(
							_Utils_update(
								car,
								{
									n0: A3($author$project$Plan$Supply$replaceItem, id, item, car.n0)
								}));
					} else {
						return i;
					}
				}
			},
			items);
	});
var $author$project$Plan$Supply$withClusters = F2(
	function (clusters, item) {
		var _v0 = _Utils_Tuple2(item, clusters);
		_v0$2:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if (_v0.b.b) {
						var car = _v0.a.a;
						var _v1 = _v0.b;
						var cluster = _v1.a;
						return $author$project$Plan$Supply$Car(
							_Utils_update(
								car,
								{H: cluster}));
					} else {
						break _v0$2;
					}
				case 1:
					var bike = _v0.a.a;
					return $author$project$Plan$Supply$Bike(
						_Utils_update(
							bike,
							{k: clusters}));
				default:
					break _v0$2;
			}
		}
		return item;
	});
var $author$project$Plan$Supply$removeCluster = F3(
	function (id, clusterId, supplyItems) {
		var _v0 = function () {
			var _v1 = A2($author$project$Plan$Supply$findItemById, supplyItems, id);
			if (!_v1.$) {
				switch (_v1.a.$) {
					case 0:
						var originalItem = _v1.a;
						var deliverer = originalItem.a.bl;
						var cluster = originalItem.a.H;
						return _Utils_eq(cluster.bX, clusterId) ? _Utils_Tuple2(
							A2($author$project$Plan$Supply$removeItem, id, supplyItems),
							$elm$core$Maybe$Just(originalItem)) : _Utils_Tuple2(supplyItems, $elm$core$Maybe$Nothing);
					case 1:
						var originalItem = _v1.a;
						var bike = originalItem.a;
						var deliverer = bike.bl;
						var clusters = bike.k;
						var _v2 = A2(
							$author$project$Plan$Supply$findClusterIn,
							clusterId,
							$author$project$Plan$Supply$Bike(bike));
						if (!_v2.$) {
							var cluster = _v2.a;
							var _v3 = A2($elm_community$list_extra$List$Extra$remove, cluster, clusters);
							if (!_v3.b) {
								return _Utils_Tuple2(
									A2($author$project$Plan$Supply$removeItem, id, supplyItems),
									$elm$core$Maybe$Just(originalItem));
							} else {
								var newClusters = _v3;
								return _Utils_Tuple2(
									A3(
										$author$project$Plan$Supply$replaceItem,
										bike.eg,
										A2($author$project$Plan$Supply$withClusters, newClusters, originalItem),
										supplyItems),
									$elm$core$Maybe$Nothing);
							}
						} else {
							return _Utils_Tuple2(supplyItems, $elm$core$Maybe$Nothing);
						}
					default:
						return _Utils_Tuple2(supplyItems, $elm$core$Maybe$Nothing);
				}
			} else {
				return _Utils_Tuple2(supplyItems, $elm$core$Maybe$Nothing);
			}
		}();
		var updatedItems = _v0.a;
		var removedItem = _v0.b;
		return _Utils_Tuple2(updatedItems, removedItem);
	});
var $author$project$Plan$Supply$removeEmptyClusters = function (supplyItems) {
	var remove = F2(
		function (_v3, _v4) {
			var supplyItemId = _v3.dF;
			var clusterId = _v3.ll;
			var itemsAndDeliverers = _v4.a;
			var removedIds = _v4.b;
			var deliverers = _v4.c;
			var _v1 = A2($author$project$Plan$Supply$findItemById, supplyItems, supplyItemId);
			if (!_v1.$) {
				var item = _v1.a;
				var _v2 = $author$project$Plan$Supply$delivererOf(item);
				if (!_v2.$) {
					var deliverer = _v2.a;
					return _Utils_Tuple3(
						A3(
							$author$project$Plan$Supply$removeCluster,
							$author$project$Plan$Supply$idOf(item),
							clusterId,
							itemsAndDeliverers).a,
						A2(
							$elm$core$List$cons,
							{
								lA: $author$project$Deliverer$Deliverer$idFromTyped(deliverer),
								eg: clusterId
							},
							removedIds),
						A2($Gizra$elm_all_set$EverySet$insert, deliverer, deliverers));
				} else {
					return _Utils_Tuple3(itemsAndDeliverers, removedIds, deliverers);
				}
			} else {
				return _Utils_Tuple3(itemsAndDeliverers, removedIds, deliverers);
			}
		});
	var emptyClusters = $author$project$Plan$Supply$findEmptyClusters(supplyItems);
	return function (_v0) {
		var itemsAndDeliverers = _v0.a;
		var removedIds = _v0.b;
		return _Utils_Tuple2(itemsAndDeliverers, removedIds);
	}(
		A3(
			$elm$core$List$foldl,
			remove,
			_Utils_Tuple3(supplyItems, _List_Nil, $Gizra$elm_all_set$EverySet$empty),
			emptyClusters));
};
var $author$project$Lists$RouteDetail$Deliverer$PrintItem = F7(
	function (distributionPoint, cluster, html, item, orders, sequence, checked) {
		return {lc: checked, H: cluster, bn: distributionPoint, ef: html, gK: item, Y: orders, j0: sequence};
	});
var $author$project$Demand$Aggregated$ProductsAndInserts = 0;
var $author$project$DistributionPoint$DistributionPoint$filterOnSegments = F2(
	function (items, segments) {
		return A2(
			$elm$core$List$filter,
			function (i) {
				return A2(
					$elm$core$List$any,
					function (id) {
						return _Utils_eq(i.jZ, id);
					},
					segments);
			},
			items);
	});
var $author$project$DistributionPoint$DistributionPoint$encodeSegmentIdForUrl = A2($elm$core$Basics$composeR, $danyx23$elm_uuid$Uuid$toString, $elm$core$String$toLower);
var $elm_community$list_extra$List$Extra$zip = $elm$core$List$map2($elm$core$Tuple$pair);
var $author$project$Sequence$Sequence$findSequence = F3(
	function (sequences, delivererId, segmentIds) {
		var sortedSegmentIds = A2($elm$core$List$sortBy, $author$project$DistributionPoint$DistributionPoint$encodeSegmentIdForUrl, segmentIds);
		return A2(
			$elm_community$list_extra$List$Extra$find,
			function (sequence) {
				return _Utils_eq(sequence.lA, delivererId) && A2(
					$elm$core$List$all,
					function (_v0) {
						var a = _v0.a;
						var b = _v0.b;
						return _Utils_eq(a, b);
					},
					A2(
						$elm_community$list_extra$List$Extra$zip,
						A2($elm$core$List$sortBy, $author$project$DistributionPoint$DistributionPoint$encodeSegmentIdForUrl, sequence.nH),
						sortedSegmentIds));
			},
			sequences);
	});
var $author$project$UI$Paradise$longNameAndIdView = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map($author$project$UI$Paradise$nameAndIdView),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$sort,
		$elm$core$String$join(', ')));
var $author$project$Cluster$Cluster$longNameView = F2(
	function (distributionPoint, cluster) {
		return $author$project$UI$Paradise$longNameAndIdView(
			A2(
				$elm$core$List$map,
				$author$project$DistributionPoint$DistributionPoint$segmentInfo,
				A2($author$project$DistributionPoint$DistributionPoint$findSegmentsOnId, distributionPoint, cluster.bb)));
	});
var $author$project$Sequence$Fuzzy$ExactMatch = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Sequence$Fuzzy$NoMatch = {$: 2};
var $author$project$Sequence$Fuzzy$OtherSuffixMatch = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Sequence$Fuzzy$TooFuzzy = {$: 3};
var $author$project$Sequence$Fuzzy$bestFactor = function (f) {
	switch (f.$) {
		case 0:
			return 3;
		case 1:
			return 2;
		case 2:
			return 1;
		default:
			return 0;
	}
};
var $elm_community$list_extra$List$Extra$maximumBy = F2(
	function (f, ls) {
		var maxBy = F2(
			function (x, _v1) {
				var y = _v1.a;
				var fy = _v1.b;
				var fx = f(x);
				return (_Utils_cmp(fx, fy) > 0) ? _Utils_Tuple2(x, fx) : _Utils_Tuple2(y, fy);
			});
		if (ls.b) {
			if (!ls.b.b) {
				var l_ = ls.a;
				return $elm$core$Maybe$Just(l_);
			} else {
				var l_ = ls.a;
				var ls_ = ls.b;
				return $elm$core$Maybe$Just(
					A3(
						$elm$core$List$foldl,
						maxBy,
						_Utils_Tuple2(
							l_,
							f(l_)),
						ls_).a);
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Sequence$Fuzzy$Exact = function (a) {
	return {$: 0, a: a};
};
var $author$project$Sequence$Fuzzy$IgnoreSuffix = function (a) {
	return {$: 2, a: a};
};
var $author$project$Address$Address$NlKey = $elm$core$Basics$identity;
var $author$project$Sequence$Fuzzy$WithoutSuffix = function (a) {
	return {$: 1, a: a};
};
var $author$project$Sequence$Fuzzy$factor = F2(
	function (toFind, _v0) {
		var zipCode = _v0.cT;
		var houseNumber = _v0.bs;
		var _v1 = _Utils_eq(houseNumber, toFind.bs);
		if (_v1) {
			return $author$project$Sequence$Fuzzy$Exact(
				{bs: houseNumber, cT: zipCode});
		} else {
			var _v2 = _Utils_Tuple2(
				_Utils_eq(houseNumber.bX, toFind.bs.bX),
				houseNumber.dE);
			if (!_v2.a) {
				return $author$project$Sequence$Fuzzy$TooFuzzy;
			} else {
				if (_v2.b.$ === 1) {
					var _v3 = _v2.b;
					return $author$project$Sequence$Fuzzy$WithoutSuffix(
						{bs: houseNumber, cT: zipCode});
				} else {
					return $author$project$Sequence$Fuzzy$IgnoreSuffix(
						{bs: houseNumber, cT: zipCode});
				}
			}
		}
	});
var $author$project$Address$Address$toLocation = function (coordinates) {
	return _Utils_Tuple2(
		$mgold$elm_geojson$GeoJson$Geometry(
			$mgold$elm_geojson$GeoJson$Point(
				_Utils_Tuple3(coordinates.gR, coordinates.gO, 0))),
		$elm$core$Maybe$Nothing);
};
var $author$project$Sequence$StreetPart$toAddresses = function (streetPart) {
	return A2(
		$elm$core$List$map,
		function (pa) {
			return {
				h8: streetPart.h8,
				bs: pa.bX,
				i3: $elm$core$Maybe$Just(
					$author$project$Address$Address$toLocation(pa.h7)),
				bU: streetPart.bU,
				b5: streetPart.b5,
				cT: streetPart.cT
			};
		},
		streetPart.fD);
};
var $author$project$Address$Address$suffixLeadingZeros = F2(
	function (i, a) {
		return _Utils_ap(
			A3(
				$elm$core$String$padLeft,
				4,
				'0',
				$elm$core$String$fromInt(i)),
			a);
	});
var $author$project$Address$Address$ParsedSuffix = F3(
	function (beforeNumber, _int, afterNumber) {
		return {dO: afterNumber, eL: beforeNumber, iV: _int};
	});
var $author$project$Address$Address$afterNumber = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $elm$core$String$toUpper, $elm$parser$Parser$succeed),
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile(
			function (_v0) {
				return true;
			})));
var $author$project$Address$Address$beforeNumber = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $elm$core$String$toUpper, $elm$parser$Parser$succeed),
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile(
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$Char$isDigit))));
var $author$project$Address$Address$theNumber = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $elm$core$String$toInt, $elm$parser$Parser$succeed),
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $author$project$Address$Address$suffixParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($author$project$Address$Address$ParsedSuffix),
			$author$project$Address$Address$beforeNumber),
		$author$project$Address$Address$theNumber),
	A2($elm$parser$Parser$ignorer, $author$project$Address$Address$afterNumber, $elm$parser$Parser$end));
var $author$project$Address$Address$toKeySuffix = function (suffix) {
	var _v0 = A2($elm$parser$Parser$run, $author$project$Address$Address$suffixParser, suffix);
	if (!_v0.$) {
		var parsed = _v0.a;
		var _v1 = _Utils_Tuple2(parsed.iV, parsed.eL);
		if (!_v1.a.$) {
			switch (_v1.b) {
				case '-':
					var i = _v1.a.a;
					return A2($author$project$Address$Address$suffixLeadingZeros, i, parsed.dO);
				case '/':
					var i = _v1.a.a;
					return A2($author$project$Address$Address$suffixLeadingZeros, i, parsed.dO);
				case '.':
					var i = _v1.a.a;
					return A2($author$project$Address$Address$suffixLeadingZeros, i, parsed.dO);
				default:
					var i = _v1.a.a;
					return _Utils_ap(
						parsed.eL,
						A2($author$project$Address$Address$suffixLeadingZeros, i, parsed.dO));
			}
		} else {
			var _v2 = _v1.a;
			return parsed.eL;
		}
	} else {
		return A2(
			$elm$core$Basics$composeR,
			$elm$core$String$toUpper,
			$elm$core$String$filter($elm$core$Char$isAlphaNum))(suffix);
	}
};
var $author$project$Address$Address$toKey = function (_v0) {
	var houseNumber = _v0.bs;
	var zipCode = _v0.cT;
	return {
		bs: _Utils_update(
			houseNumber,
			{
				dE: A2($elm$core$Maybe$map, $author$project$Address$Address$toKeySuffix, houseNumber.dE)
			}),
		cT: zipCode
	};
};
var $author$project$Sequence$Fuzzy$streetPartFactor = F2(
	function (toFindKey, streetPart) {
		var _v0 = _Utils_eq(toFindKey.cT, streetPart.cT);
		if (!_v0) {
			return $elm$core$Maybe$Nothing;
		} else {
			return A2(
				$elm_community$list_extra$List$Extra$maximumBy,
				A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $author$project$Sequence$Fuzzy$bestFactor),
				A2(
					$elm$core$List$map,
					function (a) {
						return _Utils_Tuple2(
							A2(
								$author$project$Sequence$Fuzzy$factor,
								toFindKey,
								$author$project$Address$Address$toKey(a)),
							a.bs);
					},
					$author$project$Sequence$StreetPart$toAddresses(streetPart)));
		}
	});
var $author$project$Sequence$Fuzzy$findItemForKey = F2(
	function (items, _v0) {
		var nlKeyDetail = _v0;
		var best = A2(
			$elm_community$list_extra$List$Extra$maximumBy,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$second,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$withDefault(
						_Utils_Tuple2(
							$author$project$Sequence$Fuzzy$TooFuzzy,
							A2($author$project$Address$Address$HouseNumber, 0, $elm$core$Maybe$Nothing))),
					A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $author$project$Sequence$Fuzzy$bestFactor))),
			A2(
				$elm$core$List$indexedMap,
				$elm$core$Tuple$pair,
				A2(
					$elm$core$List$map,
					$elm_community$list_extra$List$Extra$maximumBy(
						A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $author$project$Sequence$Fuzzy$bestFactor)),
					A2(
						$elm$core$List$map,
						$elm$core$List$filterMap(
							$author$project$Sequence$Fuzzy$streetPartFactor(nlKeyDetail)),
						A2(
							$elm$core$List$map,
							function ($) {
								return $.aR;
							},
							items)))));
		_v1$3:
		while (true) {
			if ((!best.$) && (!best.a.b.$)) {
				switch (best.a.b.a.a.$) {
					case 0:
						var _v2 = best.a;
						var i = _v2.a;
						var _v3 = _v2.b.a;
						var _v4 = A2($elm_community$list_extra$List$Extra$getAt, i, items);
						if (!_v4.$) {
							var item = _v4.a;
							return A2($author$project$Sequence$Fuzzy$ExactMatch, i, item);
						} else {
							return $author$project$Sequence$Fuzzy$NoMatch;
						}
					case 1:
						var _v5 = best.a;
						var i = _v5.a;
						var _v6 = _v5.b.a;
						var foundNumber = _v6.b;
						var _v7 = A2($elm_community$list_extra$List$Extra$getAt, i, items);
						if (!_v7.$) {
							var item = _v7.a;
							return A3($author$project$Sequence$Fuzzy$OtherSuffixMatch, i, item, foundNumber);
						} else {
							return $author$project$Sequence$Fuzzy$NoMatch;
						}
					case 2:
						var _v8 = best.a;
						var i = _v8.a;
						var _v9 = _v8.b.a;
						var foundNumber = _v9.b;
						var _v10 = A2($elm_community$list_extra$List$Extra$getAt, i, items);
						if (!_v10.$) {
							var item = _v10.a;
							return A3($author$project$Sequence$Fuzzy$OtherSuffixMatch, i, item, foundNumber);
						} else {
							return $author$project$Sequence$Fuzzy$NoMatch;
						}
					default:
						break _v1$3;
				}
			} else {
				break _v1$3;
			}
		}
		return $author$project$Sequence$Fuzzy$NoMatch;
	});
var $author$project$Sorting$Orders$onNumber = F2(
	function (direction, _v0) {
		var number = _v0.bX;
		if (!direction) {
			return number;
		} else {
			return -number;
		}
	});
var $author$project$Sorting$Orders$zipCodetoInt = F2(
	function (numbers, letters) {
		var lettersValue = A3(
			$elm$core$String$foldr,
			F2(
				function (_char, _v0) {
					var mult = _v0.a;
					var result = _v0.b;
					return _Utils_Tuple2(
						mult * 26,
						result + (mult * ($elm$core$Char$toCode(_char) - 65)));
				}),
			_Utils_Tuple2(1, 0),
			letters).b;
		return (numbers * 1000) + lettersValue;
	});
var $author$project$Sorting$Orders$indexForZipcode = function (zipCode) {
	var _v0 = _Utils_Tuple2(
		$elm$core$String$toInt(
			A2($elm$core$String$left, 4, zipCode)),
		A3($elm$core$String$slice, 4, 6, zipCode));
	if (!_v0.a.$) {
		var numbers = _v0.a.a;
		var letters = _v0.b;
		return A2($author$project$Sorting$Orders$zipCodetoInt, numbers, letters);
	} else {
		return -1;
	}
};
var $author$project$Sorting$Orders$onSuffix = function (_v0) {
	var suffix = _v0.dE;
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $author$project$Address$Address$toKeySuffix, suffix));
};
var $author$project$Sorting$Orders$onPostalCodeHouseNumber = function (_v0) {
	var address = _v0.f1;
	var productId = _v0.av;
	return _Utils_Tuple3(
		_Utils_Tuple2(
			$author$project$Sorting$Orders$indexForZipcode(address.cT),
			address.b5),
		_Utils_Tuple3(
			A2($author$project$Sorting$Orders$onNumber, 0, address.bs),
			$author$project$Sorting$Orders$onSuffix(address.bs),
			''),
		productId);
};
var $author$project$Sorting$Orders$onRoute = F2(
	function (items, order) {
		var address = order.f1;
		var _v0 = A2(
			$author$project$Sequence$Fuzzy$findItemForKey,
			items,
			$author$project$Address$Address$toKey(address));
		switch (_v0.$) {
			case 0:
				var i = _v0.a;
				var item = _v0.b;
				return _Utils_Tuple3(
					_Utils_Tuple2(i, address.b5),
					_Utils_Tuple3(
						A2($author$project$Sorting$Orders$onNumber, item.cg, address.bs),
						$author$project$Sorting$Orders$onSuffix(address.bs),
						''),
					order.av);
			case 1:
				var i = _v0.a;
				var item = _v0.b;
				var houseNumberNear = _v0.c;
				return _Utils_Tuple3(
					_Utils_Tuple2(i, address.b5),
					_Utils_Tuple3(
						A2($author$project$Sorting$Orders$onNumber, item.cg, houseNumberNear),
						$author$project$Sorting$Orders$onSuffix(houseNumberNear),
						$author$project$Sorting$Orders$onSuffix(address.bs)),
					order.av);
			default:
				return $author$project$Sorting$Orders$onPostalCodeHouseNumber(order);
		}
	});
var $author$project$Lists$RouteDetail$Kiosk$stopsFor = F2(
	function (orders, products) {
		return A2(
			$elm$core$List$map,
			function (os) {
				return {Y: os, bu: products};
			},
			A2(
				$elm_community$list_extra$List$Extra$groupWhile,
				F2(
					function (o1, o2) {
						return _Utils_eq(o1.f1.bU, o2.f1.bU) && (_Utils_eq(o1.f1.b5, o2.f1.b5) && _Utils_eq(o1.f1.bs, o2.f1.bs));
					}),
				orders));
	});
var $author$project$Print$Document$Document = $elm$core$Basics$identity;
var $elm$html$Html$article = _VirtualDom_node('article');
var $author$project$Print$Document$toReversePages = function (_v0) {
	var document = _v0;
	return A2(
		$elm$core$List$filter,
		function (p) {
			return $elm$core$List$length(p.d) > 0;
		},
		A2($elm$core$List$cons, document.a0, document.dm));
};
var $author$project$Print$Document$numberOfPages = function (document) {
	return $elm$core$List$length(
		$author$project$Print$Document$toReversePages(document));
};
var $author$project$Print$Document$emptyPageContent = _List_fromArray(
	[
		A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('empty-page')
			]),
		_List_Nil)
	]);
var $author$project$Print$Document$printOptionAdjustment = F3(
	function (printOption, total, content) {
		var _v0 = _Utils_Tuple2(
			printOption,
			A2($elm$core$Basics$modBy, 2, total));
		if ((_v0.a === 1) && (_v0.b === 1)) {
			var _v1 = _v0.a;
			return _Utils_ap(content, $author$project$Print$Document$emptyPageContent);
		} else {
			return content;
		}
	});
var $elm$html$Html$header = _VirtualDom_node('header');
var $author$project$Print$Document$toPageHtml = F3(
	function (header, _v0, page) {
		var current = _v0.h9;
		var total = _v0.dH;
		var _v1 = page.d;
		if (!_v1.b) {
			return _List_fromArray(
				[
					$elm$html$Html$text('')
				]);
		} else {
			return A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$header,
					_List_Nil,
					A2($elm$core$Basics$composeL, $elm$core$Tuple$first, header)(
						{h9: current, dH: total})),
				page.d);
		}
	});
var $author$project$Print$Document$toHtml = F3(
	function (printOption, attrs, _v0) {
		var document = _v0;
		var total = $author$project$Print$Document$numberOfPages(document);
		return A2(
			$elm$html$Html$article,
			attrs,
			A3(
				$author$project$Print$Document$printOptionAdjustment,
				printOption,
				total,
				$elm$core$List$concat(
					$elm$core$List$reverse(
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (i, p) {
									return A3(
										$author$project$Print$Document$toPageHtml,
										document.l9,
										{h9: total - i, dH: total},
										p);
								}),
							$author$project$Print$Document$toReversePages(document))))));
	});
var $author$project$Print$Document$addPageContent = F3(
	function (size, contentToAdd, _v0) {
		var content = _v0.d;
		var spaceLeft = _v0.cH;
		return {
			d: _Utils_ap(content, contentToAdd),
			cH: spaceLeft - size
		};
	});
var $author$project$Print$Document$headerSizeForPage = F2(
	function (header, pageNumber) {
		return A2($elm$core$Basics$composeR, header, $elm$core$Tuple$second)(
			{h9: pageNumber, dH: pageNumber});
	});
var $author$project$Print$Document$newPage = function (size) {
	return {d: _List_Nil, cH: size};
};
var $author$project$Print$Document$nextPage = function (_v0) {
	var document = _v0;
	var pagesWithCurrent = A2($elm$core$List$cons, document.a0, document.dm);
	var nextPageNumber = 1 + $elm$core$List$length(pagesWithCurrent);
	return _Utils_update(
		document,
		{
			a0: $author$project$Print$Document$newPage(
				document.fx - A2($author$project$Print$Document$headerSizeForPage, document.l9, nextPageNumber)),
			dm: pagesWithCurrent
		});
};
var $author$project$Print$Document$addContent = F3(
	function (size, content, _v0) {
		var document = _v0;
		var withContent = function (_v2) {
			var d = _v2;
			return _Utils_update(
				d,
				{
					a0: A3($author$project$Print$Document$addPageContent, size, content, d.a0)
				});
		};
		var contentTooBigEvenForNextEmptyPage = _Utils_cmp(
			size,
			document.fx - A2(
				$author$project$Print$Document$headerSizeForPage,
				document.l9,
				2 + $elm$core$List$length(document.dm))) > 0;
		var _v1 = _Utils_Tuple2(
			_Utils_cmp(size, document.a0.cH) > 0,
			contentTooBigEvenForNextEmptyPage);
		if (!_v1.a) {
			return withContent(document);
		} else {
			if (!_v1.b) {
				return withContent(
					$author$project$Print$Document$nextPage(document));
			} else {
				return A3(
					$author$project$Print$Document$addContent,
					size - document.a0.cH,
					_List_Nil,
					$author$project$Print$Document$nextPage(
						withContent(document)));
			}
		}
	});
var $author$project$Print$Document$addSizedHtml = F2(
	function (_v0, document) {
		var content = _v0.a;
		var size = _v0.b;
		return (!size) ? document : A3(
			$author$project$Print$Document$addContent,
			size,
			_List_fromArray(
				[content]),
			document);
	});
var $author$project$Demand$SummaryView$summaryByProduct = function (orders) {
	var summary = A2(
		$elm$core$List$map,
		function (_v3) {
			var h = _v3.a;
			var t = _v3.b;
			return A3(
				$elm$core$List$foldl,
				F2(
					function (o, _v4) {
						var c = _v4.c;
						return _Utils_Tuple3(
							$elm$core$Maybe$Just(o.av),
							$elm$core$Maybe$Just(o.lB),
							c + o.aa);
					}),
				_Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, 0),
				A2($elm$core$List$cons, h, t));
		},
		A2(
			$elm_community$list_extra$List$Extra$groupWhile,
			F2(
				function (o1, o2) {
					return _Utils_eq(o1.av, o2.av) && _Utils_eq(o1.lB, o2.lB);
				}),
			A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.av;
				},
				A2(
					$elm$core$List$filter,
					function (o) {
						return !_Utils_eq(
							o.mN,
							$elm$core$Maybe$Just(1));
					},
					orders))));
	return A2(
		$elm$core$List$map,
		function (_v2) {
			var h = _v2.a;
			var t = _v2.b;
			return A2($elm$core$List$cons, h, t);
		},
		A2(
			$elm_community$list_extra$List$Extra$groupWhile,
			F2(
				function (_v0, _v1) {
					var p1 = _v0.a;
					var p2 = _v1.a;
					return _Utils_eq(p1, p2);
				}),
			summary));
};
var $author$project$Demand$SummaryView$OnlyInserts = 2;
var $author$project$Demand$Demand$amountOf = function (orders) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				var amount = _v0.c;
				return i + amount;
			}),
		0,
		orders);
};
var $author$project$Demand$SummaryView$numberToText = function (number) {
	if (!number) {
		return $elm$html$Html$text('');
	} else {
		var i = number;
		return $elm$html$Html$text(
			$elm$core$String$fromInt(i));
	}
};
var $author$project$Demand$SummaryView$amountOfInText = function (orders) {
	return $author$project$Demand$SummaryView$numberToText(
		$author$project$Demand$Demand$amountOf(orders));
};
var $elm$core$Char$fromCode = _Char_fromCode;
var $author$project$Demand$SummaryView$checkMark = $elm$core$String$fromChar(
	$elm$core$Char$fromCode(10003));
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $elm$html$Html$td = _VirtualDom_node('td');
var $author$project$Demand$SummaryView$emptyCell = A2($elm$html$Html$td, _List_Nil, _List_Nil);
var $author$project$Demand$SummaryView$numberCell = function (content) {
	return A2(
		$elm$html$Html$td,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('cluster-summary-number')
			]),
		_List_fromArray(
			[content]));
};
var $author$project$Demand$PackIcon$ExtraSmall = 0;
var $author$project$Demand$Demand$amountWithPacks = F2(
	function (_v0, amount) {
		var packSize = _v0.E;
		var packs = (amount / packSize) | 0;
		var individual = amount % packSize;
		return _Utils_Tuple2(
			individual,
			_Utils_Tuple2(packs, packSize));
	});
var $elm$svg$Svg$circle = $elm$svg$Svg$trustedNode('circle');
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute('cx');
var $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute('cy');
var $elm$svg$Svg$Attributes$dominantBaseline = _VirtualDom_attribute('dominant-baseline');
var $elm$svg$Svg$Attributes$fontFamily = _VirtualDom_attribute('font-family');
var $elm$svg$Svg$Attributes$fontSize = _VirtualDom_attribute('font-size');
var $elm$svg$Svg$Attributes$fontWeight = _VirtualDom_attribute('font-weight');
var $elm$svg$Svg$Attributes$id = _VirtualDom_attribute('id');
var $elm$svg$Svg$line = $elm$svg$Svg$trustedNode('line');
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $elm$svg$Svg$Attributes$strokeLinecap = _VirtualDom_attribute('stroke-linecap');
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $author$project$Demand$PackIcon$strokeWidth_ = $elm$svg$Svg$Attributes$strokeWidth('3px');
var $author$project$Demand$PackIcon$line_ = F2(
	function (attributes, children) {
		return A2(
			$elm$svg$Svg$line,
			_Utils_ap(
				attributes,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$stroke('#000000'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$author$project$Demand$PackIcon$strokeWidth_
					])),
			children);
	});
var $elm$svg$Svg$Attributes$points = _VirtualDom_attribute('points');
var $elm$svg$Svg$polyline = $elm$svg$Svg$trustedNode('polyline');
var $elm$svg$Svg$Attributes$strokeLinejoin = _VirtualDom_attribute('stroke-linejoin');
var $author$project$Demand$PackIcon$polyline_ = F2(
	function (attributes, children) {
		return A2(
			$elm$svg$Svg$polyline,
			_Utils_ap(
				attributes,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$strokeWidth('3px')
					])),
			children);
	});
var $elm$svg$Svg$Attributes$preserveAspectRatio = _VirtualDom_attribute('preserveAspectRatio');
var $elm$svg$Svg$Attributes$r = _VirtualDom_attribute('r');
var $elm$svg$Svg$rect = $elm$svg$Svg$trustedNode('rect');
var $author$project$Demand$PackIcon$rect_ = F2(
	function (attributes, children) {
		return A2(
			$elm$svg$Svg$rect,
			_Utils_ap(
				attributes,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fill('#ffffff'),
						$elm$svg$Svg$Attributes$stroke('#000000'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$author$project$Demand$PackIcon$strokeWidth_
					])),
			children);
	});
var $elm$svg$Svg$Attributes$style = _VirtualDom_attribute('style');
var $elm$svg$Svg$text = $elm$virtual_dom$VirtualDom$text;
var $elm$svg$Svg$Attributes$textAnchor = _VirtualDom_attribute('text-anchor');
var $elm$svg$Svg$Attributes$textRendering = _VirtualDom_attribute('text-rendering');
var $elm$svg$Svg$text_ = $elm$svg$Svg$trustedNode('text');
var $elm$svg$Svg$Attributes$transform = _VirtualDom_attribute('transform');
var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
var $elm$svg$Svg$Attributes$x1 = _VirtualDom_attribute('x1');
var $elm$svg$Svg$Attributes$x2 = _VirtualDom_attribute('x2');
var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
var $elm$svg$Svg$Attributes$y1 = _VirtualDom_attribute('y1');
var $elm$svg$Svg$Attributes$y2 = _VirtualDom_attribute('y2');
var $author$project$Demand$PackIcon$viewWithText = F2(
	function (size, packSize) {
		var px = function (i) {
			return $elm$core$String$fromInt(i) + 'px';
		};
		var _v0 = function () {
			switch (size) {
				case 0:
					return _Utils_Tuple2(24, 38);
				case 1:
					return _Utils_Tuple2(32, 50);
				default:
					return _Utils_Tuple2(64, 100);
			}
		}();
		var h = _v0.a;
		var w = _v0.b;
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height(
					px(h)),
					$elm$svg$Svg$Attributes$preserveAspectRatio('xMidYMid meet'),
					$elm$svg$Svg$Attributes$viewBox('0 0 100 64'),
					$elm$svg$Svg$Attributes$width(
					px(w)),
					$elm$svg$Svg$Attributes$class('icons-pack')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('pack'),
							$elm$svg$Svg$Attributes$transform('scale(1 0.55) rotate(45 47.5 57.5)')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$g,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('top_newspaper')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Demand$PackIcon$rect_,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$height('60px'),
											$elm$svg$Svg$Attributes$id('complete'),
											$elm$svg$Svg$Attributes$width('60px'),
											$elm$svg$Svg$Attributes$x('10px'),
											$elm$svg$Svg$Attributes$y('20px')
										]),
									_List_Nil),
									A2(
									$author$project$Demand$PackIcon$rect_,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$height('15px'),
											$elm$svg$Svg$Attributes$id('picture'),
											$elm$svg$Svg$Attributes$width('15px'),
											$elm$svg$Svg$Attributes$x('17.5px'),
											$elm$svg$Svg$Attributes$y('35px')
										]),
									_List_Nil),
									A2(
									$author$project$Demand$PackIcon$line_,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$id('line1'),
											$elm$svg$Svg$Attributes$x1('17.5px'),
											$elm$svg$Svg$Attributes$x2('62.5px'),
											$elm$svg$Svg$Attributes$y1('27.5px'),
											$elm$svg$Svg$Attributes$y2('27.5px')
										]),
									_List_Nil),
									A2(
									$author$project$Demand$PackIcon$line_,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$id('line2'),
											$elm$svg$Svg$Attributes$x1('40px'),
											$elm$svg$Svg$Attributes$x2('62.5px'),
											$elm$svg$Svg$Attributes$y1('35px'),
											$elm$svg$Svg$Attributes$y2('35px')
										]),
									_List_Nil),
									A2(
									$author$project$Demand$PackIcon$line_,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$id('line3'),
											$elm$svg$Svg$Attributes$x1('40px'),
											$elm$svg$Svg$Attributes$x2('62.5px'),
											$elm$svg$Svg$Attributes$y1('42.5px'),
											$elm$svg$Svg$Attributes$y2('42.5px')
										]),
									_List_Nil),
									A2(
									$author$project$Demand$PackIcon$line_,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$id('line4'),
											$elm$svg$Svg$Attributes$x1('40px'),
											$elm$svg$Svg$Attributes$x2('62.5px'),
											$elm$svg$Svg$Attributes$y1('50px'),
											$elm$svg$Svg$Attributes$y2('50px')
										]),
									_List_Nil),
									A2(
									$author$project$Demand$PackIcon$line_,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$id('line5'),
											$elm$svg$Svg$Attributes$x1('17.5px'),
											$elm$svg$Svg$Attributes$x2('62.5px'),
											$elm$svg$Svg$Attributes$y1('57.5px'),
											$elm$svg$Svg$Attributes$y2('57.5px')
										]),
									_List_Nil),
									A2(
									$author$project$Demand$PackIcon$line_,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$id('line6'),
											$elm$svg$Svg$Attributes$x1('17.5px'),
											$elm$svg$Svg$Attributes$x2('62.5px'),
											$elm$svg$Svg$Attributes$y1('65px'),
											$elm$svg$Svg$Attributes$y2('65px')
										]),
									_List_Nil),
									A2(
									$author$project$Demand$PackIcon$line_,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$id('line7'),
											$elm$svg$Svg$Attributes$x1('17.5px'),
											$elm$svg$Svg$Attributes$x2('62.5px'),
											$elm$svg$Svg$Attributes$y1('72.5px'),
											$elm$svg$Svg$Attributes$y2('72.5px')
										]),
									_List_Nil)
								])),
							A2(
							$author$project$Demand$PackIcon$polyline_,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('middle_newspaper'),
									$elm$svg$Svg$Attributes$points('77.5,27.5 77.5,87.5 17.5,87.5'),
									$elm$svg$Svg$Attributes$stroke('#000000')
								]),
							_List_Nil),
							A2(
							$author$project$Demand$PackIcon$polyline_,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('bottom_newspaper'),
									$elm$svg$Svg$Attributes$points('85.0,35.0 85.0,95.0 25.0,95.0'),
									$elm$svg$Svg$Attributes$stroke('#000000')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$g,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('hor_bind')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Demand$PackIcon$polyline_,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$id('middle'),
											$elm$svg$Svg$Attributes$points('13.0,50.0 70.0,50.0 85.0,65.0'),
											$elm$svg$Svg$Attributes$stroke('white')
										]),
									_List_Nil),
									A2(
									$author$project$Demand$PackIcon$polyline_,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$id('right'),
											$elm$svg$Svg$Attributes$points('10.0,47.0 70.0,47.0 85.0,62.0 '),
											$elm$svg$Svg$Attributes$stroke('#000000')
										]),
									_List_Nil),
									A2(
									$author$project$Demand$PackIcon$polyline_,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$id('left'),
											$elm$svg$Svg$Attributes$points('10.0,53.0 70.0,53.0 85.0,68.0'),
											$elm$svg$Svg$Attributes$stroke('#000000')
										]),
									_List_Nil)
								])),
							A2(
							$elm$svg$Svg$g,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('vert_bind')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Demand$PackIcon$polyline_,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$id('v_middle'),
											$elm$svg$Svg$Attributes$points('40.0,23.0 40.0,80.0 55.0,95.0'),
											$elm$svg$Svg$Attributes$stroke('white')
										]),
									_List_Nil),
									A2(
									$author$project$Demand$PackIcon$polyline_,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$id('v_right'),
											$elm$svg$Svg$Attributes$points('37.0,20.0 37.0,80.0 52.0,95.0'),
											$elm$svg$Svg$Attributes$stroke('#000000')
										]),
									_List_Nil),
									A2(
									$author$project$Demand$PackIcon$polyline_,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$id('v_left'),
											$elm$svg$Svg$Attributes$points('43.0,20.0 43.0,80.0 58.0,95.0'),
											$elm$svg$Svg$Attributes$stroke('#000000')
										]),
									_List_Nil)
								]))
						])),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('pack_size')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$cx('80px'),
									$elm$svg$Svg$Attributes$cy('45px'),
									$elm$svg$Svg$Attributes$fill('black'),
									$elm$svg$Svg$Attributes$id('circle1'),
									$elm$svg$Svg$Attributes$r('20px'),
									$elm$svg$Svg$Attributes$stroke('white'),
									$elm$svg$Svg$Attributes$strokeWidth('0.5px')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$text_,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$dominantBaseline('central'),
									$elm$svg$Svg$Attributes$fill('white'),
									$elm$svg$Svg$Attributes$fontFamily('Courier New'),
									$elm$svg$Svg$Attributes$fontSize('24px'),
									$elm$svg$Svg$Attributes$fontWeight('600'),
									$elm$svg$Svg$Attributes$id('text1'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$strokeWidth('1px'),
									$elm$svg$Svg$Attributes$style('outline-style:none;'),
									$elm$svg$Svg$Attributes$textAnchor('middle'),
									$elm$svg$Svg$Attributes$textRendering('geometricPrecision'),
									$elm$svg$Svg$Attributes$x('80px'),
									$elm$svg$Svg$Attributes$y('45px')
								]),
							_List_fromArray(
								[
									$elm$svg$Svg$text(packSize)
								]))
						]))
				]));
	});
var $author$project$Demand$PackIcon$view = F2(
	function (size, packSize) {
		return A2(
			$author$project$Demand$PackIcon$viewWithText,
			size,
			$elm$core$String$fromInt(packSize));
	});
var $author$project$Demand$SummaryView$packsCell = F3(
	function (product, total, packsVisibility) {
		if (packsVisibility === 2) {
			return A2($elm$html$Html$td, _List_Nil, _List_Nil);
		} else {
			var _v1 = A2($author$project$Demand$Demand$amountWithPacks, product, total);
			var individual = _v1.a;
			var _v2 = _v1.b;
			var packs = _v2.a;
			var packSize = _v2.b;
			return A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('amount')
					]),
				function () {
					var _v3 = _Utils_Tuple2(packs, packsVisibility);
					_v3$2:
					while (true) {
						if (!_v3.a) {
							switch (_v3.b) {
								case 0:
									var _v4 = _v3.b;
									return _List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(individual))
										]);
								case 1:
									var _v5 = _v3.b;
									return _List_Nil;
								default:
									break _v3$2;
							}
						} else {
							break _v3$2;
						}
					}
					return _List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(packs)),
							A2($author$project$Demand$PackIcon$view, 0, packSize),
							$elm$html$Html$text('+'),
							$elm$html$Html$text(
							$elm$core$String$fromInt(individual))
						]);
				}());
		}
	});
var $author$project$Demand$SummaryView$NeverShowPacks = 2;
var $author$project$Demand$SummaryView$Packs = function (a) {
	return {$: 6, a: a};
};
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $author$project$Demand$SummaryView$row = F3(
	function (_v0, attributes, _v1) {
		var columns = _v0.eT;
		var productCode = _v1.dq;
		var productName = _v1.dr;
		var subscription = _v1.dD;
		var sale = _v1.dw;
		var extra = _v1.c6;
		var packs = _v1.dl;
		var total = _v1.dH;
		return A2(
			$elm$html$Html$tr,
			attributes,
			A2(
				$elm$core$List$map,
				function (c) {
					switch (c.$) {
						case 0:
							return total;
						case 6:
							var packsVisibility = c.a;
							return packs(packsVisibility);
						case 1:
							return productCode;
						case 2:
							return productName;
						case 3:
							return subscription;
						case 4:
							return sale;
						default:
							return extra;
					}
				},
				A2(
					$elm$core$List$filter,
					$elm$core$Basics$neq(
						$author$project$Demand$SummaryView$Packs(2)),
					columns)));
	});
var $author$project$Demand$SummaryView$insertRow = F3(
	function (config, summary, insert) {
		var maybeDemandTypes = A2($elm$core$List$map, $elm$core$Maybe$Just, insert.$8);
		var total = $author$project$Demand$Demand$amountOf(
			A2(
				$elm$core$List$filter,
				function (_v6) {
					var t = _v6.b;
					return A2($elm$core$List$member, t, maybeDemandTypes);
				},
				summary));
		var iconFor = function (demandType) {
			var _v1 = _Utils_Tuple3(
				A2($elm$core$List$member, demandType, insert.$8),
				A2(
					$elm$core$List$member,
					$elm$core$Maybe$Just(demandType),
					A2(
						$elm$core$List$map,
						function (_v2) {
							var t = _v2.b;
							return t;
						},
						summary)),
				config.iT);
			_v1$2:
			while (true) {
				if (_v1.a && _v1.b) {
					switch (_v1.c) {
						case 2:
							var _v3 = _v1.c;
							return $author$project$Demand$SummaryView$amountOfInText(
								A2(
									$elm$core$List$filter,
									function (_v4) {
										var dt = _v4.b;
										return _Utils_eq(
											dt,
											$elm$core$Maybe$Just(demandType));
									},
									summary));
						case 0:
							var _v5 = _v1.c;
							return $elm$html$Html$text($author$project$Demand$SummaryView$checkMark);
						default:
							break _v1$2;
					}
				} else {
					break _v1$2;
				}
			}
			return $elm$html$Html$text('');
		};
		return A3(
			$author$project$Demand$SummaryView$row,
			config,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('cluster-insert', config.iT !== 2),
							_Utils_Tuple2('cluster-insert-only', config.iT === 2)
						]))
				]),
			{
				c6: $author$project$Demand$SummaryView$numberCell(
					iconFor(2)),
				dl: A2($author$project$Demand$SummaryView$packsCell, insert, total),
				dq: A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('cluster-insert-name')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(insert.eg)
						])),
				dr: $elm$html$Html$text(insert.ft),
				dw: $author$project$Demand$SummaryView$numberCell(
					iconFor(1)),
				dD: $author$project$Demand$SummaryView$numberCell(
					iconFor(0)),
				dH: function () {
					var _v0 = config.iT;
					if (_v0 === 2) {
						return $author$project$Demand$SummaryView$numberCell(
							$author$project$Demand$SummaryView$numberToText(total));
					} else {
						return $author$project$Demand$SummaryView$emptyCell;
					}
				}()
			});
	});
var $author$project$Demand$SummaryView$productRow = F3(
	function (config, product, summary) {
		var total = $author$project$Demand$Demand$amountOf(summary);
		var amountFor = function (demandType) {
			return $author$project$Demand$SummaryView$amountOfInText(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var dt = _v0.b;
						return _Utils_eq(
							dt,
							$elm$core$Maybe$Just(demandType));
					},
					summary));
		};
		return A3(
			$author$project$Demand$SummaryView$row,
			config,
			_List_Nil,
			{
				c6: $author$project$Demand$SummaryView$numberCell(
					amountFor(2)),
				dl: A2($author$project$Demand$SummaryView$packsCell, product, total),
				dq: A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(product.eg)
						])),
				dr: A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(product.ft)
						])),
				dw: $author$project$Demand$SummaryView$numberCell(
					amountFor(1)),
				dD: $author$project$Demand$SummaryView$numberCell(
					amountFor(0)),
				dH: $author$project$Demand$SummaryView$numberCell(
					$author$project$Demand$SummaryView$numberToText(total))
			});
	});
var $author$project$Demand$SummaryView$unknownProductRow = F3(
	function (config, productId, summary) {
		var total = $author$project$Demand$Demand$amountOf(summary);
		var amountFor = function (demandType) {
			return $author$project$Demand$SummaryView$amountOfInText(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var dt = _v0.b;
						return _Utils_eq(
							dt,
							$elm$core$Maybe$Just(demandType));
					},
					summary));
		};
		return A3(
			$author$project$Demand$SummaryView$row,
			config,
			_List_Nil,
			{
				c6: $author$project$Demand$SummaryView$numberCell(
					amountFor(2)),
				dl: A2(
					$author$project$Demand$SummaryView$packsCell,
					{eg: productId, ja: 1, ft: productId, E: 100},
					total),
				dq: A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(productId)
						])),
				dr: A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(productId)
						])),
				dw: $author$project$Demand$SummaryView$numberCell(
					amountFor(1)),
				dD: $author$project$Demand$SummaryView$numberCell(
					amountFor(0)),
				dH: $author$project$Demand$SummaryView$numberCell(
					$author$project$Demand$SummaryView$numberToText(total))
			});
	});
var $author$project$Demand$SummaryView$summaryRow = F3(
	function (config, products, summary) {
		if ((summary.b && (!summary.a.a.$)) && (!summary.a.b.$)) {
			var _v1 = summary.a;
			var productId = _v1.a.a;
			var _v2 = A2(
				$elm_community$list_extra$List$Extra$find,
				function (p) {
					return _Utils_eq(p.eg, productId);
				},
				products);
			if (_v2.$ === 1) {
				return _List_fromArray(
					[
						A3($author$project$Demand$SummaryView$unknownProductRow, config, productId, summary)
					]);
			} else {
				var product = _v2.a;
				var _v3 = config.iT;
				switch (_v3) {
					case 0:
						return A2(
							$elm$core$List$cons,
							A3($author$project$Demand$SummaryView$productRow, config, product, summary),
							A2(
								$elm$core$List$map,
								A2($author$project$Demand$SummaryView$insertRow, config, summary),
								product.iT));
					case 1:
						return _List_fromArray(
							[
								A3($author$project$Demand$SummaryView$productRow, config, product, summary)
							]);
					default:
						return A2(
							$elm$core$List$map,
							A2($author$project$Demand$SummaryView$insertRow, config, summary),
							product.iT);
				}
			}
		} else {
			return _List_Nil;
		}
	});
var $elm_community$list_extra$List$Extra$scanl = F3(
	function (f, b, xs) {
		var scan1 = F2(
			function (x, accAcc) {
				if (accAcc.b) {
					var acc = accAcc.a;
					return A2(
						$elm$core$List$cons,
						A2(f, x, acc),
						accAcc);
				} else {
					return _List_Nil;
				}
			});
		return $elm$core$List$reverse(
			A3(
				$elm$core$List$foldl,
				scan1,
				_List_fromArray(
					[b]),
				xs));
	});
var $elm_community$list_extra$List$Extra$takeWhileRight = function (p) {
	var step = F2(
		function (x, _v0) {
			var xs = _v0.a;
			var free = _v0.b;
			return (p(x) && free) ? _Utils_Tuple2(
				A2($elm$core$List$cons, x, xs),
				true) : _Utils_Tuple2(xs, false);
		});
	return A2(
		$elm$core$Basics$composeL,
		$elm$core$Tuple$first,
		A2(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(_List_Nil, true)));
};
var $author$project$Demand$SummaryView$calcGroupSize = F2(
	function (columnSplit, rowsByProduct) {
		var sizeByProduct = A3(
			$elm_community$list_extra$List$Extra$scanl,
			$elm$core$Basics$add,
			0,
			A2(
				$elm$core$List$map,
				function (l) {
					return $elm$core$List$length(l);
				},
				rowsByProduct));
		var totalSize = A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$List$maximum(sizeByProduct));
		if (!columnSplit.$) {
			return totalSize;
		} else {
			var halfSize = ((1 + totalSize) / 2) | 0;
			return A2(
				$elm$core$Maybe$withDefault,
				halfSize,
				$elm$core$List$head(
					A2(
						$elm_community$list_extra$List$Extra$takeWhileRight,
						$elm$core$Basics$lt(halfSize - 1),
						sizeByProduct)));
		}
	});
var $author$project$Demand$SummaryView$summaryHeader = function (config) {
	return A3(
		$author$project$Demand$SummaryView$row,
		config,
		_List_Nil,
		{
			c6: A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Extra')
					])),
			dl: $elm$core$Basics$always(
				A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Pak/Losse')
						]))),
			dq: A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Product')
					])),
			dr: A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Product')
					])),
			dw: A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Lvk')
					])),
			dD: A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Abo')
					])),
			dH: A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Totaal')
					]))
		});
};
var $elm$html$Html$table = _VirtualDom_node('table');
var $author$project$Demand$SummaryView$summaryTable = F2(
	function (config, rows) {
		return A2(
			$elm$html$Html$table,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				$author$project$Demand$SummaryView$summaryHeader(config),
				rows));
	});
var $author$project$Demand$SummaryView$summaryView = F2(
	function (config, rowsByProduct) {
		var lengthRows = A2($author$project$Demand$SummaryView$calcGroupSize, config.h4, rowsByProduct);
		var lengthHeader = 2;
		return _Utils_Tuple2(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('cluster-summary flex-container')
					]),
				A2(
					$elm$core$List$map,
					$author$project$Demand$SummaryView$summaryTable(config),
					A2(
						$elm_community$list_extra$List$Extra$greedyGroupsOf,
						lengthRows,
						$elm$core$List$concat(rowsByProduct)))),
			lengthHeader + lengthRows);
	});
var $author$project$Demand$SummaryView$addSummary = F4(
	function (config, orders, products, document) {
		var rowsByProduct = A2(
			$elm$core$List$map,
			A2($author$project$Demand$SummaryView$summaryRow, config, products),
			$author$project$Demand$SummaryView$summaryByProduct(orders));
		return A2(
			$author$project$Print$Document$addSizedHtml,
			A2($author$project$Demand$SummaryView$summaryView, config, rowsByProduct),
			document);
	});
var $author$project$UI$Util$maybeCons = F2(
	function (maybe, list) {
		if (!maybe.$) {
			var a = maybe.a;
			return A2($elm$core$List$cons, a, list);
		} else {
			return list;
		}
	});
var $author$project$Lists$RouteDetail$Kiosk$addressView = function (_v0) {
	var name = _v0.ft;
	var address = _v0.f1;
	var info = _v0.iP;
	var additionalAddressInfo = _v0.f0;
	return function (l) {
		return _Utils_Tuple2(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('kiosk-stop-address')
					]),
				l),
			$elm$core$List$length(l));
	}(
		A2(
			$author$project$UI$Util$maybeCons,
			A2(
				$elm$core$Maybe$map,
				function (n) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('kiosk-stop-name')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(n)
							]));
				},
				name),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								address.b5 + (' ' + $author$project$Address$Address$houseNumberView(address.bs)))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(address.cT + (' ' + address.bU))
							]))
					]),
				function () {
					if (!info.$) {
						var i = info.a;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('kiosk-stop-info')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(i)
									]))
							]);
					} else {
						return _List_Nil;
					}
				}())));
};
var $hayleigh_dot_dev$tuple_extra$Tuple$Extra$apply = F2(
	function (f, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		return A2(f, a, b);
	});
var $author$project$Demand$SummaryView$AlwaysShowPacks = 0;
var $author$project$Demand$SummaryView$ExcludeInserts = 1;
var $author$project$Demand$SummaryView$NoSplit = {$: 0};
var $author$project$Demand$SummaryView$ProductName = {$: 2};
var $author$project$Lists$RouteDetail$Kiosk$summaryViewConfig = {
	h4: $author$project$Demand$SummaryView$NoSplit,
	eT: _List_fromArray(
		[
			$author$project$Demand$SummaryView$ProductName,
			$author$project$Demand$SummaryView$Packs(0)
		]),
	iT: 1
};
var $author$project$Lists$RouteDetail$Kiosk$addStop = F3(
	function (index, _v0, document) {
		var orders = _v0.Y;
		var products = _v0.bu;
		return A4(
			$author$project$Demand$SummaryView$addSummary,
			$author$project$Lists$RouteDetail$Kiosk$summaryViewConfig,
			A2($hayleigh_dot_dev$tuple_extra$Tuple$Extra$apply, $elm$core$List$cons, orders),
			products,
			A2(
				$author$project$Print$Document$addSizedHtml,
				$author$project$Lists$RouteDetail$Kiosk$addressView(orders.a),
				A3(
					$author$project$Print$Document$addContent,
					1,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('kiosk-stop-nr')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									'Stop ' + $elm$core$String$fromInt(index + 1))
								]))
						]),
					document)));
	});
var $author$project$Print$Document$defaultPageSize = 49;
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $hayleigh_dot_dev$tuple_extra$Tuple$Extra$pairWith = F2(
	function (b, a) {
		return A2($elm$core$Tuple$pair, a, b);
	});
var $author$project$Print$SizedHtml$listWithSize = $hayleigh_dot_dev$tuple_extra$Tuple$Extra$pairWith;
var $author$project$Print$Logo$dpgMediaLogo = A2(
	$elm$svg$Svg$g,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$rect,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x('130.581'),
					$elm$svg$Svg$Attributes$y('15.82'),
					$elm$svg$Svg$Attributes$width('4.191'),
					$elm$svg$Svg$Attributes$height('6.893'),
					$elm$svg$Svg$Attributes$fill('inherit')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$rect,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x('137.353'),
					$elm$svg$Svg$Attributes$y('10.597'),
					$elm$svg$Svg$Attributes$width('4.191'),
					$elm$svg$Svg$Attributes$height('14.696'),
					$elm$svg$Svg$Attributes$fill('inherit')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$rect,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x('144.129'),
					$elm$svg$Svg$Attributes$y('5.001'),
					$elm$svg$Svg$Attributes$width('4.191'),
					$elm$svg$Svg$Attributes$height('17.712'),
					$elm$svg$Svg$Attributes$fill('inherit')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$rect,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x('150.898'),
					$elm$svg$Svg$Attributes$y('10.597'),
					$elm$svg$Svg$Attributes$width('4.191'),
					$elm$svg$Svg$Attributes$height('7.3943'),
					$elm$svg$Svg$Attributes$fill('inherit')
				]),
			_List_Nil)
		]));
var $author$project$Print$Logo$dpgMediaPath = A2(
	$elm$svg$Svg$path,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$d('M0 39.975c0-5.415 3.976-7.953 7.433-7.953 1.988 0 3.548.734 4.557 1.804v-8.533h4.19V47.62h-4.19V45.91c-1.009 1.193-2.63 2.018-4.618 2.018-3.243 0-7.372-2.57-7.372-7.952zm12.113-.031c0-2.294-1.621-4.099-3.915-4.099-2.295 0-4.1 1.744-4.1 4.099a4.068 4.068 0 0 0 4.1 4.13c2.294 0 3.915-1.836 3.915-4.13zm10.4 6.179v8.534h-4.191v-22.33h4.19v1.744c.979-1.193 2.508-2.05 4.588-2.05 3.456 0 7.402 2.54 7.402 7.954 0 5.383-4.067 7.952-7.34 7.952-2.05 0-3.671-.673-4.65-1.804zm7.891-6.179c0-2.355-1.744-4.099-4.099-4.099-2.294 0-3.915 1.805-3.915 4.099 0 2.294 1.621 4.13 3.915 4.13 2.355 0 4.1-1.806 4.1-4.13zm5.351.03c0-5.413 3.977-7.952 7.434-7.952 1.988 0 3.547.826 4.557 1.957v-1.651h4.19v15.049c0 4.588-3.395 7.585-7.402 7.585-4.313 0-7.126-2.508-8.014-5.842h4.527c.581 1.224 1.499 1.927 3.487 1.927 1.835 0 3.212-1.56 3.212-3.548v-1.59c-1.01 1.193-2.63 2.018-4.619 2.018-3.242 0-7.372-2.57-7.372-7.952zm12.113-.03c0-2.294-1.621-4.099-3.915-4.099s-4.099 1.744-4.099 4.099a4.068 4.068 0 0 0 4.099 4.13c2.294 0 3.915-1.836 3.915-4.13zM55.75 32.328h2.325v2.08c1.01-1.469 2.691-2.386 4.894-2.386 2.783 0 4.588 1.285 5.444 3.12.98-1.866 2.967-3.12 5.536-3.12 4.405 0 6.822 2.66 6.822 6.607v8.992h-2.386v-9.145c0-2.57-1.683-4.344-4.466-4.344-2.508 0-4.496 1.713-4.496 4.588v8.901h-2.356v-9.42c0-2.448-1.712-4.069-4.282-4.069-2.692 0-4.68 1.805-4.68 4.864v8.625h-2.355V32.328zm27.496 7.769c0-4.588 3.365-8.075 7.923-8.075 4.435 0 7.83 3.059 7.83 7.708v.948H85.51c.245 2.875 2.447 5.139 5.628 5.139 2.57 0 4.374-1.254 5.077-3.334h2.54c-1.102 3.395-3.733 5.444-7.648 5.444-4.802 0-7.86-3.548-7.86-7.83zm2.448-1.56h10.888c-.459-2.784-2.447-4.405-5.413-4.405-2.784 0-4.864 1.836-5.475 4.405zm15.751 1.438c0-4.375 3.274-7.953 7.83-7.953 1.958 0 4.283.948 5.599 2.783v-9.512h2.293V47.62h-2.263v-2.508c-1.315 1.836-3.67 2.814-5.628 2.814-4.496 0-7.83-3.579-7.83-7.952zm13.673 0c0-3.182-2.416-5.812-5.72-5.812-3.12 0-5.567 2.6-5.567 5.812 0 3.211 2.447 5.811 5.567 5.811 3.304 0 5.72-2.6 5.72-5.811zm6.701-14.56c1.101 0 1.897.795 1.897 1.866a1.85 1.85 0 0 1-1.897 1.896c-1.101 0-1.866-.825-1.866-1.896a1.817 1.817 0 0 1 1.866-1.866zm-1.193 6.913h2.386V47.62h-2.386V32.328zm5.104 7.647c0-4.375 3.273-7.953 7.83-7.953 1.958 0 4.314.979 5.629 2.814v-2.508h2.355V47.62h-2.355v-2.508c-1.315 1.836-3.67 2.814-5.628 2.814-4.497 0-7.83-3.579-7.83-7.952zm13.673 0c0-3.182-2.417-5.812-5.72-5.812-3.12 0-5.567 2.6-5.567 5.812 0 3.211 2.447 5.811 5.567 5.811 3.303 0 5.72-2.6 5.72-5.811z'),
			$elm$svg$Svg$Attributes$fill('inherit')
		]),
	_List_Nil);
var $author$project$Print$Logo$logo = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 156 60'),
			$elm$svg$Svg$Attributes$height('48px'),
			$elm$svg$Svg$Attributes$preserveAspectRatio('xMidYMid meet')
		]),
	_List_fromArray(
		[$author$project$Print$Logo$dpgMediaPath, $author$project$Print$Logo$dpgMediaLogo]));
var $author$project$Lists$RouteDetail$Kiosk$header = F3(
	function (date, name, _v0) {
		return A2(
			$author$project$Print$SizedHtml$listWithSize,
			3,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('kiosk-logo')
						]),
					_List_fromArray(
						[$author$project$Print$Logo$logo])),
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('kiosk-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							'Ontvangstmasker Losse Verkoop ' + $author$project$Date$DeliveryDate$view(date))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						]))
				]));
	});
var $author$project$Print$Document$init = F2(
	function (sizeOfPage, header) {
		return {
			a0: $author$project$Print$Document$newPage(
				sizeOfPage - A2($author$project$Print$Document$headerSizeForPage, header, 1)),
			l9: header,
			fx: sizeOfPage,
			dm: _List_Nil
		};
	});
var $author$project$Lists$RouteDetail$Kiosk$view = function (_v0) {
	var date = _v0.lx;
	var name = _v0.ft;
	var stops = _v0.nW;
	return A2(
		$elm$core$List$indexedMap,
		F2(
			function (i, stop) {
				return A3(
					$author$project$Lists$RouteDetail$Kiosk$addStop,
					i,
					stop,
					A2(
						$author$project$Print$Document$init,
						$author$project$Print$Document$defaultPageSize,
						A2($author$project$Lists$RouteDetail$Kiosk$header, date, name)));
			}),
		stops);
};
var $author$project$Lists$RouteDetail$Deliverer$kioskListView = F7(
	function (distributionPoint, date, products, orders, sequenceItems, cluster, printOption) {
		var name = A2($author$project$Cluster$Cluster$longNameView, distributionPoint, cluster);
		var kioskSegments = A2(
			$elm$core$List$map,
			$author$project$DistributionPoint$DistributionPoint$segmentId,
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$author$project$DistributionPoint$DistributionPoint$segmentInfo,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.g4;
						},
						$elm$core$Basics$eq(1))),
				A2($author$project$DistributionPoint$DistributionPoint$findSegmentsOnId, distributionPoint, cluster.bb)));
		var kioskOrders = A2(
			$elm$core$List$sortBy,
			$author$project$Sorting$Orders$onRoute(sequenceItems),
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.lB;
					},
					$elm$core$Basics$neq(2)),
				A2(
					$elm$core$List$concatMap,
					function ($) {
						return $.Y;
					},
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.jZ;
							},
							function (id) {
								return A2($elm$core$List$member, id, kioskSegments);
							}),
						orders))));
		return A2(
			$elm$core$List$map,
			A2($author$project$Print$Document$toHtml, printOption, _List_Nil),
			$author$project$Lists$RouteDetail$Kiosk$view(
				{
					lx: date,
					ft: name,
					nW: A2($author$project$Lists$RouteDetail$Kiosk$stopsFor, kioskOrders, products)
				}));
	});
var $author$project$Lists$RouteDetail$PrintSelection$identityFilter = {lY: $elm$core$Basics$identity, ft: $elm$core$Maybe$Nothing, n_: $elm$core$Basics$identity};
var $elm$core$Set$isEmpty = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$isEmpty(dict);
};
var $author$project$Lists$RouteDetail$PrintSelection$orderFilters = function (_v0) {
	var selectedSubscriptions = _v0.ev;
	var selectedProducts = _v0.dy;
	var onlyProductPredicate = function (order) {
		return A2($elm$core$Set$member, order.av, selectedProducts);
	};
	var onlyPartialSubscriptionPredicate = function (order) {
		return (!_Utils_eq(order.hD, $author$project$Date$DaysInTheWeek$everyDeliveryDay)) && (!order.lB);
	};
	var irregularPredicate = function (order) {
		return (!_Utils_eq(order.hD, $author$project$Date$DaysInTheWeek$everyDeliveryDay)) || (!_Utils_eq(order.mN, $elm$core$Maybe$Nothing));
	};
	var filterName = F3(
		function (_default, prefix, name) {
			return $elm$core$Maybe$Just(
				A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_default,
					function (n) {
						return _Utils_ap(n, prefix);
					},
					name) + (' ' + A2(
					$elm$core$String$join,
					', ',
					$elm$core$Set$toList(selectedProducts))));
		});
	var splitFilterOnProducts = function (filter) {
		return $elm$core$Set$isEmpty(selectedProducts) ? _List_fromArray(
			[filter]) : _List_fromArray(
			[
				{
				lY: A2(
					$elm$core$Basics$composeR,
					filter.lY,
					$elm$core$List$filter(onlyProductPredicate)),
				ft: A3(filterName, 'Enkel', ' van', filter.ft),
				n_: A2(
					$elm$core$Basics$composeR,
					filter.n_,
					$elm$core$List$filter(onlyProductPredicate))
			},
				{
				lY: A2(
					$elm$core$Basics$composeR,
					filter.lY,
					$elm$core$List$filter(
						A2($elm$core$Basics$composeL, $elm$core$Basics$not, onlyProductPredicate))),
				ft: A3(filterName, 'Zonder', ', zonder', filter.ft),
				n_: A2(
					$elm$core$Basics$composeR,
					filter.n_,
					$elm$core$List$filter(
						A2($elm$core$Basics$composeL, $elm$core$Basics$not, onlyProductPredicate)))
			}
			]);
	};
	return splitFilterOnProducts(
		function () {
			switch (selectedSubscriptions) {
				case 0:
					return $author$project$Lists$RouteDetail$PrintSelection$identityFilter;
				case 1:
					return {
						lY: $elm$core$List$filter(irregularPredicate),
						ft: $elm$core$Maybe$Just('Enkel de uitzonderingen'),
						n_: $elm$core$Basics$identity
					};
				case 2:
					return {
						lY: $elm$core$List$filter(onlyPartialSubscriptionPredicate),
						ft: $elm$core$Maybe$Just('Enkel de deelabonnementen'),
						n_: $elm$core$List$filter(onlyPartialSubscriptionPredicate)
					};
				default:
					return {
						lY: $elm$core$List$filter(
							A2($elm$core$Basics$composeL, $elm$core$Basics$not, onlyPartialSubscriptionPredicate)),
						ft: $elm$core$Maybe$Just('Zonder deelabonnementen'),
						n_: $elm$core$List$filter(
							A2($elm$core$Basics$composeL, $elm$core$Basics$not, onlyPartialSubscriptionPredicate))
					};
			}
		}());
};
var $author$project$Lists$RouteDetail$ClusterView$filterOrdersNotInSequenceItems = function (items) {
	return $elm$core$List$filter(
		function (o) {
			return _Utils_eq(
				$author$project$Sequence$Fuzzy$NoMatch,
				A2(
					$author$project$Sequence$Fuzzy$findItemForKey,
					items,
					$author$project$Address$Address$toKey(o.f1)));
		});
};
var $author$project$Lists$RouteDetail$ClusterView$filterOrdersOnSequenceItems = function (items) {
	return $elm$core$List$filter(
		function (o) {
			return !_Utils_eq(
				$author$project$Sequence$Fuzzy$NoMatch,
				A2(
					$author$project$Sequence$Fuzzy$findItemForKey,
					items,
					$author$project$Address$Address$toKey(o.f1)));
		});
};
var $elm_community$list_extra$List$Extra$uncons = function (list) {
	if (!list.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var first = list.a;
		var rest = list.b;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(first, rest));
	}
};
var $author$project$Lists$RouteDetail$ClusterView$mapLastItem = F3(
	function (_default, mapFct, list) {
		return $elm$core$List$reverse(
			A2(
				$hayleigh_dot_dev$tuple_extra$Tuple$Extra$apply,
				$elm$core$List$cons,
				A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_Utils_Tuple2(_default, _List_Nil),
					$elm$core$Tuple$mapFirst(mapFct),
					$elm_community$list_extra$List$Extra$uncons(
						$elm$core$List$reverse(list)))));
	});
var $author$project$Sequence$Sequence$splitOnCutPoints = function (items) {
	return A2(
		$elm$core$List$map,
		function (_v0) {
			var a = _v0.a;
			var b = _v0.b;
			return A2($elm$core$List$cons, a, b);
		},
		A2(
			$elm_community$list_extra$List$Extra$groupWhile,
			F2(
				function (_v1, item) {
					return !item.e0;
				}),
			items));
};
var $author$project$Lists$RouteDetail$ClusterView$splitByCutPoints = F2(
	function (items, orders) {
		return A3(
			$author$project$Lists$RouteDetail$ClusterView$mapLastItem,
			_Utils_Tuple2(items, orders),
			$elm$core$Tuple$mapSecond(
				$elm$core$Basics$append(
					A2($author$project$Lists$RouteDetail$ClusterView$filterOrdersNotInSequenceItems, items, orders))),
			A2(
				$elm$core$List$map,
				function (s) {
					return _Utils_Tuple2(
						s,
						A2($author$project$Lists$RouteDetail$ClusterView$filterOrdersOnSequenceItems, s, orders));
				},
				$author$project$Sequence$Sequence$splitOnCutPoints(items)));
	});
var $author$project$Demand$Demand$complaintAddressNameMadeOn = function (complaint) {
	return _Utils_Tuple3(
		_Utils_ap(
			complaint.b5,
			$author$project$Address$Address$houseNumberView(complaint.bs)),
		A2($elm$core$Maybe$withDefault, '', complaint.ft),
		$author$project$Date$DeliveryDate$encodeForUrl(complaint.i8));
};
var $author$project$Lists$RouteDetail$ComplaintSummaryView$addressOf = function (complaint) {
	var _v0 = complaint.ft;
	if (!_v0.$) {
		var name = _v0.a;
		return name + (', ' + (complaint.b5 + (' ' + ($author$project$Address$Address$houseNumberView(complaint.bs) + (', ' + complaint.bU)))));
	} else {
		return complaint.b5 + (' ' + ($author$project$Address$Address$houseNumberView(complaint.bs) + (', ' + complaint.bU)));
	}
};
var $author$project$Lists$RouteDetail$ComplaintSummaryView$complaintTypeText = function (complaintType) {
	var _v0 = A2($elm$core$String$split, '/', complaintType);
	if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
		var main = _v0.a;
		var _v1 = _v0.b;
		var secondary = _v1.a;
		return _Utils_eq(main, secondary) ? $elm$html$Html$text(main) : $elm$html$Html$text(complaintType);
	} else {
		return $elm$html$Html$text(complaintType);
	}
};
var $author$project$Lists$RouteDetail$ComplaintSummaryView$demandTypeText = function (demandType) {
	return $elm$html$Html$text(
		$author$project$Demand$Demand$typeToString(demandType));
};
var $author$project$Date$DaysInTheWeek$circleSize = 20;
var $author$project$Date$DaysInTheWeek$circleSizeLarge = 30;
var $author$project$Date$DaysInTheWeek$abbrev = function (day) {
	switch (day) {
		case 0:
			return 'm';
		case 1:
			return 'd';
		case 2:
			return 'w';
		case 3:
			return 'd';
		case 4:
			return 'v';
		case 5:
			return 'z';
		default:
			return 'z';
	}
};
var $elm$svg$Svg$Attributes$cursor = _VirtualDom_attribute('cursor');
var $author$project$UI$Palette$lightGreen = $tesk9$palette$SolidColor$fromRGB(
	_Utils_Tuple3(37, 197, 109));
var $author$project$Date$DaysInTheWeek$margin = 2;
var $author$project$Date$DaysInTheWeek$px = function (i) {
	return $elm$core$String$fromInt(i) + 'px';
};
var $tesk9$palette$Internal$RGBA$toStringWithoutOpacity = function (_v0) {
	var red = _v0.no;
	var green = _v0.l6;
	var blue = _v0.k_;
	return 'rgb(' + ($elm$core$String$fromFloat(red) + (',' + ($elm$core$String$fromFloat(green) + (',' + ($elm$core$String$fromFloat(blue) + ')')))));
};
var $tesk9$palette$SolidColor$toRGBString = function (_v0) {
	var color = _v0;
	return $tesk9$palette$Internal$RGBA$toStringWithoutOpacity(
		$tesk9$palette$Internal$Color$asRGBA(color));
};
var $author$project$Date$DaysInTheWeek$dayIcon = F2(
	function (_v0, day) {
		var button = _v0.eP;
		var size = _v0.bB;
		var color = _v0.eS;
		var days = _v0.e1;
		var _v1 = function () {
			var _v2 = _Utils_Tuple2(
				A2($Gizra$elm_all_set$EverySet$member, day, days),
				color);
			if (_v2.a) {
				if (_v2.b === 1) {
					var _v3 = _v2.b;
					return _Utils_Tuple2(
						$tesk9$palette$SolidColor$toRGBString($author$project$UI$Palette$lightGreen),
						'white');
				} else {
					var _v4 = _v2.b;
					return _Utils_Tuple2('grey', 'white');
				}
			} else {
				return _Utils_Tuple2('white', 'grey');
			}
		}();
		var fillColor = _v1.a;
		var textColor = _v1.b;
		var _v5 = function () {
			if (button) {
				return _Utils_Tuple3(
					(size / 2) | 0,
					(size / 2) | 0,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cursor('pointer')
						]));
			} else {
				return _Utils_Tuple3(
					((size / 2) | 0) + (size * $author$project$Date$DaysInTheWeek$dayIndex(day)),
					(size / 2) | 0,
					_List_Nil);
			}
		}();
		var centerX = _v5.a;
		var centerY = _v5.b;
		var pointer = _v5.c;
		return A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$circle,
					_Utils_ap(
						pointer,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$cx(
								$author$project$Date$DaysInTheWeek$px(centerX)),
								$elm$svg$Svg$Attributes$cy(
								$author$project$Date$DaysInTheWeek$px(centerY)),
								$elm$svg$Svg$Attributes$r(
								$author$project$Date$DaysInTheWeek$px(((size - $author$project$Date$DaysInTheWeek$margin) / 2) | 0)),
								$elm$svg$Svg$Attributes$fill(fillColor),
								$elm$svg$Svg$Attributes$stroke(textColor),
								$elm$svg$Svg$Attributes$strokeWidth('0.5px')
							])),
					_List_Nil),
					A2(
					$elm$svg$Svg$text_,
					_Utils_ap(
						pointer,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$x(
								$author$project$Date$DaysInTheWeek$px(centerX)),
								$elm$svg$Svg$Attributes$y(
								$author$project$Date$DaysInTheWeek$px(centerY)),
								$elm$svg$Svg$Attributes$fill(textColor),
								$elm$svg$Svg$Attributes$dominantBaseline('central'),
								$elm$svg$Svg$Attributes$fontFamily('Courier New'),
								$elm$svg$Svg$Attributes$fontSize('14px'),
								$elm$svg$Svg$Attributes$stroke('none'),
								$elm$svg$Svg$Attributes$strokeWidth('1px'),
								$elm$svg$Svg$Attributes$style('outline-style:none;'),
								$elm$svg$Svg$Attributes$textAnchor('middle'),
								$elm$svg$Svg$Attributes$textRendering('geometricPrecision')
							])),
					_List_fromArray(
						[
							$elm$svg$Svg$text(
							$elm$core$String$fromChar(
								$author$project$Date$DaysInTheWeek$abbrev(day)))
						]))
				]));
	});
var $author$project$Date$DaysInTheWeek$icon = function (_v0) {
	var days = _v0;
	var _v1 = days.bB;
	if (!_v1) {
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$width('102'),
					$elm$svg$Svg$Attributes$height('17'),
					$elm$svg$Svg$Attributes$viewBox('0 0 120 20')
				]),
			A2(
				$elm$core$List$map,
				$author$project$Date$DaysInTheWeek$dayIcon(
					{eP: false, eS: days.da, e1: days.e1, bB: $author$project$Date$DaysInTheWeek$circleSize}),
				$author$project$Date$DaysInTheWeek$deliveryDays));
	} else {
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$width('180'),
					$elm$svg$Svg$Attributes$height('30'),
					$elm$svg$Svg$Attributes$viewBox('0 0 180 30')
				]),
			A2(
				$elm$core$List$map,
				$author$project$Date$DaysInTheWeek$dayIcon(
					{eP: false, eS: days.da, e1: days.e1, bB: $author$project$Date$DaysInTheWeek$circleSizeLarge}),
				$author$project$Date$DaysInTheWeek$deliveryDays));
	}
};
var $author$project$Lists$RouteDetail$ComplaintSummaryView$maxWidthAddress = 37;
var $elm$svg$Svg$polygon = $elm$svg$Svg$trustedNode('polygon');
var $author$project$Lists$SeverityIcon$cyclicalSign = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$height('17px'),
			$elm$svg$Svg$Attributes$preserveAspectRatio('xMidYMid meet'),
			$elm$svg$Svg$Attributes$viewBox('0 0 20 20'),
			$elm$svg$Svg$Attributes$width('17px')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('10'),
					$elm$svg$Svg$Attributes$cy('10'),
					$elm$svg$Svg$Attributes$r('6'),
					$elm$svg$Svg$Attributes$fill('transparent'),
					$elm$svg$Svg$Attributes$stroke('black'),
					$elm$svg$Svg$Attributes$strokeWidth('3')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('0'),
					$elm$svg$Svg$Attributes$y1('1'),
					$elm$svg$Svg$Attributes$x2('10'),
					$elm$svg$Svg$Attributes$y2('11'),
					$elm$svg$Svg$Attributes$stroke('white'),
					$elm$svg$Svg$Attributes$strokeWidth('3')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('10'),
					$elm$svg$Svg$Attributes$y1('9'),
					$elm$svg$Svg$Attributes$x2('20'),
					$elm$svg$Svg$Attributes$y2('19'),
					$elm$svg$Svg$Attributes$stroke('white'),
					$elm$svg$Svg$Attributes$strokeWidth('3')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$polygon,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('12,10 20,10 16,14'),
					$elm$svg$Svg$Attributes$fill('black')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$polygon,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('8,10 0,10 4,6'),
					$elm$svg$Svg$Attributes$fill('black')
				]),
			_List_Nil)
		]));
var $author$project$Lists$SeverityIcon$lightningSign = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$height('17px'),
			$elm$svg$Svg$Attributes$preserveAspectRatio('xMidYMid meet'),
			$elm$svg$Svg$Attributes$viewBox('0 0 20 20'),
			$elm$svg$Svg$Attributes$width('17px')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$polygon,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('10,0 0,20 20,20'),
					$elm$svg$Svg$Attributes$fill('black')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$polygon,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('8.5,6 6,12 10,12 8.5,18 9.5,18 13.5,10.5 9.5,10.5 11.5,6'),
					$elm$svg$Svg$Attributes$fill('white')
				]),
			_List_Nil)
		]));
var $author$project$Lists$SeverityIcon$warningSign = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$height('17px'),
			$elm$svg$Svg$Attributes$preserveAspectRatio('xMidYMid meet'),
			$elm$svg$Svg$Attributes$viewBox('0 0 20 20'),
			$elm$svg$Svg$Attributes$width('17px')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$text_,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$dominantBaseline('central'),
					$elm$svg$Svg$Attributes$fill('black'),
					$elm$svg$Svg$Attributes$fontFamily('Courier New'),
					$elm$svg$Svg$Attributes$fontSize('20pt'),
					$elm$svg$Svg$Attributes$fontWeight('bolder'),
					$elm$svg$Svg$Attributes$style('outline-style:none;'),
					$elm$svg$Svg$Attributes$textAnchor('middle'),
					$elm$svg$Svg$Attributes$textRendering('geometricPrecision'),
					$elm$svg$Svg$Attributes$x('10'),
					$elm$svg$Svg$Attributes$y('11')
				]),
			_List_fromArray(
				[
					$elm$svg$Svg$text('!')
				]))
		]));
var $author$project$Lists$SeverityIcon$view = function (severity) {
	switch (severity) {
		case 0:
			return $author$project$Lists$SeverityIcon$warningSign;
		case 1:
			return $author$project$Lists$SeverityIcon$cyclicalSign;
		default:
			return $author$project$Lists$SeverityIcon$lightningSign;
	}
};
var $author$project$Lists$RouteDetail$ComplaintSummaryView$complaintLine = function (complaint) {
	var address = $author$project$Lists$RouteDetail$ComplaintSummaryView$addressOf(complaint);
	return _Utils_Tuple2(
		A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('severe', complaint.nL === 2)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Lists$SeverityIcon$view(complaint.nL)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Lists$RouteDetail$ComplaintSummaryView$complaintTypeText(complaint.lo)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Date$DeliveryDate$view(complaint.i8))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Lists$RouteDetail$ComplaintSummaryView$demandTypeText(complaint.lB)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(complaint.av)
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('complaint-address')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(address)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Date$DaysInTheWeek$icon(complaint.hD)
						]))
				])),
		1 + (($elm$core$String$length(address) / $author$project$Lists$RouteDetail$ComplaintSummaryView$maxWidthAddress) | 0));
};
var $elm$html$Html$Attributes$colspan = function (n) {
	return A2(
		_VirtualDom_attribute,
		'colspan',
		$elm$core$String$fromInt(n));
};
var $author$project$Lists$RouteDetail$ComplaintSummaryView$header = A2(
	$elm$html$Html$tr,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$colspan(2)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Klachten')
				]))
		]));
var $author$project$Lists$RouteDetail$ComplaintSummaryView$add = F3(
	function (complaints, complaintVisibility, document) {
		if (complaintVisibility === 1) {
			return document;
		} else {
			var sortedComplaints = A2($elm$core$List$sortBy, $author$project$Demand$Demand$complaintAddressNameMadeOn, complaints);
			if (!sortedComplaints.b) {
				return document;
			} else {
				var itemsWithLength = A2(
					$elm$core$List$cons,
					_Utils_Tuple2($author$project$Lists$RouteDetail$ComplaintSummaryView$header, 2),
					A2($elm$core$List$map, $author$project$Lists$RouteDetail$ComplaintSummaryView$complaintLine, sortedComplaints));
				var length = $elm$core$List$sum(
					A2($elm$core$List$map, $elm$core$Tuple$second, itemsWithLength));
				var items = A2($elm$core$List$map, $elm$core$Tuple$first, itemsWithLength);
				return A3(
					$author$project$Print$Document$addContent,
					length,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$table,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('complaint-summary')
								]),
							items)
						]),
					document);
			}
		}
	});
var $author$project$Print$Document$addColumnGroup = F3(
	function (toColumnContainer, columns, document) {
		var lengthOfColumn = function (c) {
			return $elm$core$List$sum(
				A2($elm$core$List$map, $elm$core$Tuple$second, c));
		};
		var maxLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$List$maximum(
				A2($elm$core$List$map, lengthOfColumn, columns)));
		var content = _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex-container')
					]),
				A2(
					$elm$core$List$map,
					toColumnContainer,
					A2(
						$elm$core$List$map,
						$elm$core$List$map($elm$core$Tuple$first),
						columns)))
			]);
		return A3($author$project$Print$Document$addContent, maxLength, content, document);
	});
var $author$project$Print$Document$spaceLeftOnPage = function (_v0) {
	var document = _v0;
	return document.a0.cH;
};
var $author$project$Print$Pager$addToColumn = F2(
	function (itemWithLength, state) {
		return _Utils_update(
			state,
			{
				bk: A2($elm$core$List$cons, itemWithLength, state.bk)
			});
	});
var $author$project$Print$Pager$isCurrentColumnTheLast = F2(
	function (documentState, state) {
		return _Utils_eq(
			1 + $elm$core$List$length(state.a0),
			documentState.mX);
	});
var $author$project$Print$Pager$nextColumn = function (state) {
	return _Utils_update(
		state,
		{
			bk: _List_Nil,
			a0: A2(
				$elm$core$List$cons,
				$elm$core$List$reverse(state.bk),
				state.a0)
		});
};
var $author$project$Print$Pager$nextPage = function (state) {
	var columnInPageState = function () {
		var _v0 = state.bk;
		if (!_v0.b) {
			return state;
		} else {
			return $author$project$Print$Pager$nextColumn(state);
		}
	}();
	return _Utils_update(
		columnInPageState,
		{
			a0: _List_Nil,
			dm: A2(
				$elm$core$List$cons,
				$elm$core$List$reverse(columnInPageState.a0),
				columnInPageState.dm)
		});
};
var $author$project$Print$Pager$pagesOf = function (state) {
	var currentPage = state.a0;
	var currentColumn = state.bk;
	var pages = state.dm;
	var _v0 = _Utils_Tuple2(currentPage, currentColumn);
	if ((!_v0.a.b) && (!_v0.b.b)) {
		return pages;
	} else {
		return $elm$core$List$reverse(
			$author$project$Print$Pager$nextPage(state).dm);
	}
};
var $author$project$Print$Pager$split = F3(
	function (spaceLeftOnEmptyPage, documentState, itemsWithLength) {
		var initialState = {bk: _List_Nil, a0: _List_Nil, dm: _List_Nil};
		return $author$project$Print$Pager$pagesOf(
			A3(
				$elm$core$List$foldl,
				F2(
					function (_v0, state) {
						var item = _v0.a;
						var itemLength = _v0.b;
						var spaceLeftInPage = function () {
							var _v2 = state.dm;
							if (!_v2.b) {
								return documentState.lu;
							} else {
								return spaceLeftOnEmptyPage(
									documentState.a0 + $elm$core$List$length(state.dm));
							}
						}();
						var spaceLeftInColumn = spaceLeftInPage - $elm$core$List$sum(
							A2($elm$core$List$map, $elm$core$Tuple$second, state.bk));
						var _v1 = _Utils_Tuple3(
							_Utils_cmp(itemLength, spaceLeftInColumn) < 1,
							_Utils_cmp(itemLength, spaceLeftInPage) < 1,
							A2($author$project$Print$Pager$isCurrentColumnTheLast, documentState, state));
						if (_v1.a) {
							return A2(
								$author$project$Print$Pager$addToColumn,
								_Utils_Tuple2(item, itemLength),
								state);
						} else {
							if (_v1.b && (!_v1.c)) {
								return A2(
									$author$project$Print$Pager$addToColumn,
									_Utils_Tuple2(item, itemLength),
									$author$project$Print$Pager$nextColumn(state));
							} else {
								return A2(
									$author$project$Print$Pager$addToColumn,
									_Utils_Tuple2(item, itemLength),
									$author$project$Print$Pager$nextPage(state));
							}
						}
					}),
				initialState,
				itemsWithLength));
	});
var $elm_community$list_extra$List$Extra$unconsLast = function (list) {
	var _v0 = $elm$core$List$reverse(list);
	if (!_v0.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var last_ = _v0.a;
		var rest = _v0.b;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(
				last_,
				$elm$core$List$reverse(rest)));
	}
};
var $author$project$Print$Document$addColumns = F4(
	function (toColumnContainer, numberOfColumns, itemsWithLength, _v0) {
		var document = _v0;
		var state = {
			a0: 1 + $elm$core$List$length(document.dm),
			lu: $author$project$Print$Document$spaceLeftOnPage(document),
			mX: numberOfColumns
		};
		var spaceLeftOnEmptyPage = A2(
			$elm$core$Basics$composeR,
			$author$project$Print$Document$headerSizeForPage(document.l9),
			function (headerSize) {
				return document.fx - headerSize;
			});
		var sections = A3($author$project$Print$Pager$split, spaceLeftOnEmptyPage, state, itemsWithLength);
		var _v1 = $elm_community$list_extra$List$Extra$unconsLast(sections);
		if (_v1.$ === 1) {
			return document;
		} else {
			var _v2 = _v1.a;
			var last = _v2.a;
			var body = _v2.b;
			return A3(
				$author$project$Print$Document$addColumnGroup,
				toColumnContainer,
				last,
				A3(
					$elm$core$List$foldl,
					F2(
						function (gr, d) {
							return $author$project$Print$Document$nextPage(
								A3($author$project$Print$Document$addColumnGroup, toColumnContainer, gr, d));
						}),
					document,
					body));
		}
	});
var $author$project$Demand$Demand$DifferentMunicipal = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Demand$Demand$DifferentStreet = function (a) {
	return {$: 2, a: a};
};
var $author$project$Demand$Demand$NotLast = 0;
var $author$project$Demand$Demand$OrderExtraInfo = F4(
	function (order, difference, position, found) {
		return {ih: difference, l0: found, m8: order, fC: position};
	});
var $author$project$Demand$Demand$SameCustomer = {$: 0};
var $author$project$Demand$Demand$SameStreet = {$: 1};
var $author$project$Demand$Demand$calcState = F2(
	function (order, _v0) {
		var address = order.f1;
		var soFar = _v0.a;
		var lastOrder = _v0.b;
		var lastAddress = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.f1;
			},
			lastOrder);
		var difference = function () {
			var _v1 = _Utils_Tuple2(
				_Utils_Tuple2(
					_Utils_eq(
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.bU;
							},
							lastAddress),
						$elm$core$Maybe$Just(address.bU)),
					_Utils_eq(
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.b5;
							},
							lastAddress),
						$elm$core$Maybe$Just(address.b5))),
				_Utils_Tuple2(
					_Utils_eq(
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.bs;
							},
							lastAddress),
						$elm$core$Maybe$Just(address.bs)),
					_Utils_eq(
						A2(
							$elm$core$Maybe$andThen,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.ft;
								},
								$elm$core$Maybe$map($elm$core$String$toUpper)),
							lastOrder),
						A2($elm$core$Maybe$map, $elm$core$String$toUpper, order.ft))));
			if (_v1.a.a) {
				if (_v1.a.b) {
					if (_v1.b.a && _v1.b.b) {
						var _v2 = _v1.a;
						var _v3 = _v1.b;
						return $author$project$Demand$Demand$SameCustomer;
					} else {
						var _v4 = _v1.a;
						return $author$project$Demand$Demand$SameStreet;
					}
				} else {
					var _v5 = _v1.a;
					return $author$project$Demand$Demand$DifferentStreet(address.b5);
				}
			} else {
				var _v6 = _v1.a;
				return A2($author$project$Demand$Demand$DifferentMunicipal, address.bU, address.b5);
			}
		}();
		return _Utils_Tuple2(
			A2(
				$elm$core$List$cons,
				A4($author$project$Demand$Demand$OrderExtraInfo, order, difference, 0, false),
				soFar),
			$elm$core$Maybe$Just(order));
	});
var $author$project$Demand$Demand$addDifference = function (orders) {
	return $elm$core$List$reverse(
		A3(
			$elm$core$List$foldl,
			$author$project$Demand$Demand$calcState,
			_Utils_Tuple2(_List_Nil, $elm$core$Maybe$Nothing),
			orders).a);
};
var $author$project$Lists$RouteDetail$ClusterView$addFoundIn = F2(
	function (sequenceItems, oei) {
		return _Utils_update(
			oei,
			{
				l0: !_Utils_eq(
					$author$project$Sequence$Fuzzy$NoMatch,
					A2(
						$author$project$Sequence$Fuzzy$findItemForKey,
						sequenceItems,
						$author$project$Address$Address$toKey(oei.m8.f1)))
			});
	});
var $author$project$Demand$Demand$Last = 1;
var $author$project$Demand$Demand$addPosition = function (orderAndDiff) {
	var _v0 = $elm_community$list_extra$List$Extra$unconsLast(orderAndDiff);
	if (_v0.$ === 1) {
		return _List_Nil;
	} else {
		var _v1 = _v0.a;
		var last = _v1.a;
		var init = _v1.b;
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (oei) {
					return _Utils_update(
						oei,
						{fC: 0});
				},
				init),
			_List_fromArray(
				[
					_Utils_update(
					last,
					{fC: 1})
				]));
	}
};
var $author$project$Demand$Demand$lineLengthForText = function (str) {
	return 1 + (($elm$core$String$length(str) / 20) | 0);
};
var $author$project$Demand$Demand$maxLineLength = 30;
var $author$project$Demand$Demand$lineLength = function (oei) {
	var linesForWeek = _Utils_eq(oei.m8.hD, $author$project$Date$DaysInTheWeek$everyDeliveryDay) ? 0 : 1;
	var linesForStreetMunicipal = function () {
		var _v2 = oei.ih;
		switch (_v2.$) {
			case 0:
				return 0;
			case 1:
				return 0;
			case 2:
				var street = _v2.a;
				return 1 + (($elm$core$String$length(street) / $author$project$Demand$Demand$maxLineLength) | 0);
			default:
				var municipal = _v2.a;
				var street = _v2.b;
				return 1 + (($elm$core$String$length(street + (', ' + municipal)) / $author$project$Demand$Demand$maxLineLength) | 0);
		}
	}();
	var linesForName = 1;
	var linesForLabel = oei.m8.mD ? 1 : 0;
	var linesForInfo = function () {
		var _v1 = oei.m8.iP;
		if (!_v1.$) {
			var info = _v1.a;
			return $author$project$Demand$Demand$lineLengthForText(info);
		} else {
			return 0;
		}
	}();
	var linesForAdditionalAddressInfo = $elm$core$List$isEmpty(oei.m8.f0) ? 0 : $author$project$Demand$Demand$lineLengthForText(
		A2($elm$core$String$join, ' - ', oei.m8.f0));
	return (((((linesForLabel + linesForAdditionalAddressInfo) + linesForInfo) + linesForWeek) + linesForStreetMunicipal) + linesForName) + function () {
		var _v0 = oei.fC;
		if (!_v0) {
			return 0;
		} else {
			return 1;
		}
	}();
};
var $author$project$Lists$RouteDetail$ClusterView$numberOfOrderColumns = 3;
var $author$project$Lists$RouteDetail$ClusterView$additionalAddressInfoLine = function (infoString) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('route-address-line')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('route-additional-address-info-text')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(infoString)
					]))
			]));
};
var $author$project$Lists$RouteDetail$ClusterView$additionalAddressInfo = function (order) {
	var _v0 = $elm$core$List$isEmpty(order.f0);
	if (!_v0) {
		return $elm$core$Maybe$Just(
			$author$project$Lists$RouteDetail$ClusterView$additionalAddressInfoLine(
				A2($elm$core$String$join, ' - ', order.f0)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Lists$RouteDetail$ClusterView$emptyLine = {
	aa: $elm$html$Html$text(''),
	dT: _List_Nil,
	mg: $elm$html$Html$text(''),
	ft: $elm$html$Html$text(''),
	gY: $elm$core$Maybe$Nothing,
	bX: $elm$html$Html$text(''),
	jJ: $elm$html$Html$text(''),
	dE: $elm$html$Html$text('')
};
var $author$project$Lists$RouteDetail$ClusterView$lineView = function (_v0) {
	var icon = _v0.mg;
	var number = _v0.bX;
	var suffix = _v0.dE;
	var product = _v0.jJ;
	var amount = _v0.aa;
	var name = _v0.ft;
	var nameAttr = _v0.gY;
	var classes = _v0.dT;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2('route-address-line', true),
					classes))
			]),
		_List_fromArray(
			[
				icon,
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('route-housenumber')
					]),
				_List_fromArray(
					[number])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('route-housenumber-suffix')
					]),
				_List_fromArray(
					[suffix])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('route-productid')
					]),
				_List_fromArray(
					[product])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('route-amount')
					]),
				_List_fromArray(
					[amount])),
				A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$elm$core$Maybe$Just(
							$elm$html$Html$Attributes$class('route-name')),
							nameAttr
						])),
				_List_fromArray(
					[name]))
			]));
};
var $author$project$Lists$RouteDetail$ClusterView$withAmountOf = F2(
	function (order, l) {
		var _v0 = _Utils_Tuple2(order.lB, order.aa);
		if ((!_v0.a) && (_v0.b === 1)) {
			var _v1 = _v0.a;
			return l;
		} else {
			return _Utils_update(
				l,
				{
					aa: $elm$html$Html$text(
						$elm$core$String$fromInt(order.aa))
				});
		}
	});
var $author$project$Lists$RouteDetail$ClusterView$withClasses = F2(
	function (classes, l) {
		return _Utils_update(
			l,
			{
				dT: _Utils_ap(l.dT, classes)
			});
	});
var $author$project$Lists$RouteDetail$ClusterView$withMutationClassesFor = function (_v0) {
	var mutation = _v0.mN;
	return $author$project$Lists$RouteDetail$ClusterView$withClasses(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'route-stopped',
				_Utils_eq(
					mutation,
					$elm$core$Maybe$Just(1))),
				_Utils_Tuple2(
				'route-started',
				_Utils_eq(
					mutation,
					$elm$core$Maybe$Just(0))),
				_Utils_Tuple2(
				'route-changed',
				_Utils_eq(
					mutation,
					$elm$core$Maybe$Just(2)))
			]));
};
var $author$project$Lists$MutationIcon$noParkingSign = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$height('17px'),
			$elm$svg$Svg$Attributes$preserveAspectRatio('xMidYMid meet'),
			$elm$svg$Svg$Attributes$viewBox('0 0 20 20'),
			$elm$svg$Svg$Attributes$width('17px')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('10'),
					$elm$svg$Svg$Attributes$cy('10'),
					$elm$svg$Svg$Attributes$r('8'),
					$elm$svg$Svg$Attributes$fill('transparent'),
					$elm$svg$Svg$Attributes$stroke('black'),
					$elm$svg$Svg$Attributes$strokeWidth('3')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('16'),
					$elm$svg$Svg$Attributes$y1('4'),
					$elm$svg$Svg$Attributes$x2('4'),
					$elm$svg$Svg$Attributes$y2('16'),
					$elm$svg$Svg$Attributes$stroke('black'),
					$elm$svg$Svg$Attributes$strokeWidth('3')
				]),
			_List_Nil)
		]));
var $author$project$Lists$MutationIcon$startSign = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$height('17px'),
			$elm$svg$Svg$Attributes$preserveAspectRatio('xMidYMid meet'),
			$elm$svg$Svg$Attributes$viewBox('0 0 20 20'),
			$elm$svg$Svg$Attributes$width('17px')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('10'),
					$elm$svg$Svg$Attributes$cy('10'),
					$elm$svg$Svg$Attributes$r('10'),
					$elm$svg$Svg$Attributes$fill('black')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$polygon,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('7,5 7,15 15,10'),
					$elm$svg$Svg$Attributes$fill('white')
				]),
			_List_Nil)
		]));
var $author$project$Lists$MutationIcon$circle_ = function (mutation) {
	var _v0 = function () {
		switch (mutation) {
			case 1:
				return _Utils_Tuple2('7', 'red');
			case 2:
				return _Utils_Tuple2('12', 'orange');
			default:
				return _Utils_Tuple2('17', 'green');
		}
	}();
	var y = _v0.a;
	var color = _v0.b;
	return A2(
		$elm$svg$Svg$circle,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$cx('8'),
				$elm$svg$Svg$Attributes$cy(y),
				$elm$svg$Svg$Attributes$r('5'),
				$elm$svg$Svg$Attributes$fill(color)
			]),
		_List_Nil);
};
var $elm$svg$Svg$Attributes$rx = _VirtualDom_attribute('rx');
var $elm$svg$Svg$Attributes$ry = _VirtualDom_attribute('ry');
var $author$project$Lists$MutationIcon$trafficLight = function (mutation) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$height('24px'),
				$elm$svg$Svg$Attributes$preserveAspectRatio('xMidYMid meet'),
				$elm$svg$Svg$Attributes$viewBox('0 0 16 24'),
				$elm$svg$Svg$Attributes$width('16px')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$rect,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$x('1'),
						$elm$svg$Svg$Attributes$y('1'),
						$elm$svg$Svg$Attributes$width('14'),
						$elm$svg$Svg$Attributes$height('22'),
						$elm$svg$Svg$Attributes$rx('6'),
						$elm$svg$Svg$Attributes$ry('6'),
						$elm$svg$Svg$Attributes$stroke('black'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fill('transparent')
					]),
				_List_Nil),
				$author$project$Lists$MutationIcon$circle_(mutation)
			]));
};
var $author$project$Lists$MutationIcon$view = function (mutation) {
	switch (mutation) {
		case 0:
			return $author$project$Lists$MutationIcon$startSign;
		case 1:
			return $author$project$Lists$MutationIcon$noParkingSign;
		default:
			var m = mutation;
			return $author$project$Lists$MutationIcon$trafficLight(m);
	}
};
var $author$project$UI$Util$withDefaultEmptyText = F2(
	function (f, value) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$text(''),
			A2($elm$core$Maybe$map, f, value));
	});
var $author$project$Lists$RouteDetail$ClusterView$withIcon = F2(
	function (icon, l) {
		return _Utils_update(
			l,
			{mg: icon});
	});
var $author$project$Lists$RouteDetail$ClusterView$withMutationIconFor = F2(
	function (mutationVisibility, _v0) {
		var mutation = _v0.mN;
		if (!mutationVisibility) {
			return $author$project$Lists$RouteDetail$ClusterView$withIcon(
				A2($author$project$UI$Util$withDefaultEmptyText, $author$project$Lists$MutationIcon$view, mutation));
		} else {
			return $elm$core$Basics$identity;
		}
	});
var $author$project$Lists$RouteDetail$ClusterView$withName = F2(
	function (name, l) {
		return _Utils_update(
			l,
			{
				ft: $elm$html$Html$text(
					A2($elm$core$Maybe$withDefault, '', name))
			});
	});
var $author$project$Lists$RouteDetail$ClusterView$withNumber = F2(
	function (number, l) {
		return _Utils_update(
			l,
			{
				bX: $elm$html$Html$text(
					$elm$core$String$fromInt(number))
			});
	});
var $author$project$Lists$RouteDetail$ClusterView$withProduct = F2(
	function (product, l) {
		return _Utils_update(
			l,
			{
				jJ: $elm$html$Html$text(product)
			});
	});
var $author$project$Lists$RouteDetail$ClusterView$withSuffix = F2(
	function (suffix, l) {
		return _Utils_update(
			l,
			{
				dE: $elm$html$Html$text(
					A2($elm$core$Maybe$withDefault, '', suffix))
			});
	});
var $author$project$Lists$RouteDetail$ClusterView$addressLine = F2(
	function (mutationVisibility, order) {
		return $author$project$Lists$RouteDetail$ClusterView$lineView(
			A2(
				$author$project$Lists$RouteDetail$ClusterView$withMutationClassesFor,
				order,
				A2(
					$author$project$Lists$RouteDetail$ClusterView$withName,
					order.ft,
					A2(
						$author$project$Lists$RouteDetail$ClusterView$withAmountOf,
						order,
						A2(
							$author$project$Lists$RouteDetail$ClusterView$withProduct,
							order.av,
							A2(
								$author$project$Lists$RouteDetail$ClusterView$withSuffix,
								order.f1.bs.dE,
								A2(
									$author$project$Lists$RouteDetail$ClusterView$withNumber,
									order.f1.bs.bX,
									A3($author$project$Lists$RouteDetail$ClusterView$withMutationIconFor, mutationVisibility, order, $author$project$Lists$RouteDetail$ClusterView$emptyLine))))))));
	});
var $author$project$Lists$RouteDetail$ClusterView$endList = function (position) {
	if (!position) {
		return $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('route-end-text')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('*** Einde looplijst ***')
					])));
	}
};
var $author$project$Lists$RouteDetail$ClusterView$infoLine = function (infoString) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('route-address-line')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('route-info-text')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(infoString)
					]))
			]));
};
var $author$project$Lists$RouteDetail$ClusterView$info = function (order) {
	var _v0 = order.iP;
	if (!_v0.$) {
		var orderInfo = _v0.a;
		return $elm$core$Maybe$Just(
			$author$project$Lists$RouteDetail$ClusterView$infoLine(orderInfo));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Lists$RouteDetail$ClusterView$label = function (order) {
	var _v0 = order.mD;
	if (_v0) {
		return $elm$core$Maybe$Just(
			$author$project$Lists$RouteDetail$ClusterView$lineView(
				A2(
					$author$project$Lists$RouteDetail$ClusterView$withClasses,
					_List_fromArray(
						[
							_Utils_Tuple2('route-label', true)
						]),
					A2(
						$author$project$Lists$RouteDetail$ClusterView$withName,
						$elm$core$Maybe$Just('Etiket'),
						$author$project$Lists$RouteDetail$ClusterView$emptyLine))));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Lists$RouteDetail$ClusterView$maybe = function (maybeHtml) {
	if (!maybeHtml.$) {
		var html = maybeHtml.a;
		return _List_fromArray(
			[html]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Lists$RouteDetail$ClusterView$subscriptionTypeLine = function (order) {
	return $author$project$Lists$RouteDetail$ClusterView$lineView(
		_Utils_update(
			$author$project$Lists$RouteDetail$ClusterView$emptyLine,
			{
				ft: $author$project$Date$DaysInTheWeek$icon(order.hD)
			}));
};
var $author$project$Lists$RouteDetail$ClusterView$week = function (order) {
	return _Utils_eq(order.hD, $author$project$Date$DaysInTheWeek$everyDeliveryDay) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		$author$project$Lists$RouteDetail$ClusterView$subscriptionTypeLine(order));
};
var $author$project$Lists$RouteDetail$ClusterView$orderView = F2(
	function (mutationVisibility, _v0) {
		var order = _v0.m8;
		var difference = _v0.ih;
		var position = _v0.fC;
		var found = _v0.l0;
		var className = function () {
			if (found) {
				return 'route-order';
			} else {
				return 'route-order route-unknown-streetpart';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(className)
				]),
			_Utils_ap(
				function () {
					switch (difference.$) {
						case 0:
							return _List_fromArray(
								[
									A2($author$project$Lists$RouteDetail$ClusterView$addressLine, mutationVisibility, order)
								]);
						case 1:
							return _List_fromArray(
								[
									A2($author$project$Lists$RouteDetail$ClusterView$addressLine, mutationVisibility, order)
								]);
						case 3:
							var municipal = difference.a;
							var street = difference.b;
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('route-new-municipal')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(street + (', ' + municipal))
										])),
									A2($author$project$Lists$RouteDetail$ClusterView$addressLine, mutationVisibility, order)
								]);
						default:
							var street = difference.a;
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('route-new-street')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(street)
										])),
									A2($author$project$Lists$RouteDetail$ClusterView$addressLine, mutationVisibility, order)
								]);
					}
				}(),
				_Utils_ap(
					$author$project$Lists$RouteDetail$ClusterView$maybe(
						$author$project$Lists$RouteDetail$ClusterView$label(order)),
					_Utils_ap(
						$author$project$Lists$RouteDetail$ClusterView$maybe(
							$author$project$Lists$RouteDetail$ClusterView$additionalAddressInfo(order)),
						_Utils_ap(
							$author$project$Lists$RouteDetail$ClusterView$maybe(
								$author$project$Lists$RouteDetail$ClusterView$info(order)),
							_Utils_ap(
								$author$project$Lists$RouteDetail$ClusterView$maybe(
									$author$project$Lists$RouteDetail$ClusterView$week(order)),
								$author$project$Lists$RouteDetail$ClusterView$maybe(
									$author$project$Lists$RouteDetail$ClusterView$endList(position))))))));
	});
var $author$project$Lists$RouteDetail$ClusterView$addOrders = F4(
	function (sequenceItems, orders, mutationVisibility, document) {
		var applyMutationVisibilityOption = function () {
			if (!mutationVisibility) {
				return $elm$core$Basics$identity;
			} else {
				return $elm$core$List$filter(
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.mN;
						},
						$elm$core$Basics$neq(
							$elm$core$Maybe$Just(1))));
			}
		}();
		var lines = A2(
			$elm$core$List$map,
			function (oei) {
				return _Utils_Tuple2(
					A2($author$project$Lists$RouteDetail$ClusterView$orderView, mutationVisibility, oei),
					$author$project$Demand$Demand$lineLength(oei));
			},
			A2(
				$elm$core$List$map,
				$author$project$Lists$RouteDetail$ClusterView$addFoundIn(sequenceItems),
				$author$project$Demand$Demand$addPosition(
					$author$project$Demand$Demand$addDifference(
						A2(
							$elm$core$List$sortBy,
							$author$project$Sorting$Orders$onRoute(sequenceItems),
							applyMutationVisibilityOption(orders))))));
		return A4(
			$author$project$Print$Document$addColumns,
			$elm$html$Html$div(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('route-column')
					])),
			$author$project$Lists$RouteDetail$ClusterView$numberOfOrderColumns,
			lines,
			document);
	});
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $author$project$Lists$RouteDetail$ClusterView$linesForBottomMargin = 1;
var $author$project$Lists$RouteDetail$ClusterView$linesForTitle = 2;
var $author$project$Deliverer$Deliverer$supplyPeriodFor = F2(
	function (date, deliverer) {
		return A2($author$project$Deliverer$Deliverer$activeSupplyPeriod, date, deliverer.kk);
	});
var $author$project$Deliverer$Deliverer$locationOf = F2(
	function (date, deliverer) {
		var _v0 = A2($author$project$Deliverer$Deliverer$supplyPeriodFor, date, deliverer);
		if (!_v0.$) {
			var p = _v0.a;
			return A2(
				$elm_community$list_extra$List$Extra$find,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.eg;
					},
					$elm$core$Basics$eq(p.f5)),
				deliverer.i4);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Plan$Supply$ownSegmentsOf = function (item) {
	return A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.bb;
		},
		$author$project$Plan$Supply$ownClustersOf(item));
};
var $author$project$UI$Name$view = function (_v0) {
	var name = _v0.ft;
	return name;
};
var $author$project$Plan$Supply$parentView = F2(
	function (distributionPoint, _v0) {
		var parents = _v0.g9;
		return A2(
			$elm$core$Maybe$map,
			function (carName) {
				return 'aangeleverd door: ' + carName;
			},
			A2(
				$elm$core$Maybe$map,
				$author$project$UI$Name$view,
				A2(
					$elm$core$Maybe$map,
					$author$project$DistributionPoint$DistributionPoint$segmentInfo,
					A2(
						$elm$core$Maybe$andThen,
						$author$project$DistributionPoint$DistributionPoint$findSegmentOnId(distributionPoint),
						A2(
							$elm$core$Maybe$andThen,
							$elm$core$List$head,
							A2(
								$elm$core$Maybe$map,
								$author$project$Plan$Supply$ownSegmentsOf,
								$elm$core$List$head(parents)))))));
	});
var $author$project$UI$Name$shortenedListView = function (items) {
	var findCommon = F2(
		function (l1, l2) {
			var _v0 = _Utils_Tuple2(l1, l2);
			if (!_v0.a.b) {
				return _List_Nil;
			} else {
				if (!_v0.b.b) {
					return _List_Nil;
				} else {
					var _v1 = _v0.a;
					var h1 = _v1.a;
					var t1 = _v1.b;
					var _v2 = _v0.b;
					var h2 = _v2.a;
					var t2 = _v2.b;
					return _Utils_eq(h1, h2) ? A2(
						$elm$core$List$cons,
						h1,
						A2(findCommon, t1, t2)) : _List_Nil;
				}
			}
		});
	return A3(
		$elm$core$Basics$composeR,
		$elm$core$Tuple$second,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$reverse,
			$elm$core$String$join(', ')),
		A3(
			$elm$core$List$foldl,
			F2(
				function (name, _v3) {
					var common = _v3.a;
					var list = _v3.b;
					var _v4 = A2(findCommon, name, common);
					if (!_v4.b) {
						return _Utils_Tuple2(
							name,
							A2(
								$elm$core$List$cons,
								A2($elm$core$String$join, ' ', name),
								list));
					} else {
						var newCommon = _v4;
						return _Utils_Tuple2(
							name,
							A2(
								$elm$core$List$cons,
								A2(
									$elm$core$String$join,
									' ',
									A2(
										$elm$core$List$drop,
										$elm$core$List$length(newCommon),
										name)),
								list));
					}
				}),
			_Utils_Tuple2(_List_Nil, _List_Nil),
			A2(
				$elm$core$List$map,
				$elm$core$String$words,
				$elm$core$List$sort(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.ft;
						},
						items)))));
};
var $author$project$UI$Paradise$shortNameAndIdView = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map($author$project$UI$Paradise$nameAndIdView),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(
			function (n) {
				return {ft: n};
			}),
		$author$project$UI$Name$shortenedListView));
var $author$project$Cluster$Cluster$shortNameView = F2(
	function (distributionPoint, cluster) {
		return $author$project$UI$Paradise$shortNameAndIdView(
			A2(
				$elm$core$List$map,
				$author$project$DistributionPoint$DistributionPoint$segmentInfo,
				A2($author$project$DistributionPoint$DistributionPoint$findSegmentsOnId, distributionPoint, cluster.bb)));
	});
var $author$project$Print$Document$simplePageCounter = function (_v0) {
	var current = _v0.h9;
	var total = _v0.dH;
	return '(' + ($elm$core$String$fromInt(current) + ('/' + ($elm$core$String$fromInt(total) + ')')));
};
var $author$project$Lists$RouteDetail$ClusterView$supplyLocationView = function (location) {
	var address = location.f1.b5 + (' ' + ($author$project$Address$Address$houseNumberView(location.f1.bs) + (', ' + (location.f1.cT + (' ' + location.f1.bU)))));
	var _v0 = location.gg;
	if (!_v0.$) {
		var comment = _v0.a;
		return _Utils_Tuple2(address + (' - ' + comment), 6);
	} else {
		return _Utils_Tuple2(address, 5);
	}
};
var $author$project$Lists$RouteDetail$ClusterView$header = F6(
	function (distributionPoint, orderFilter, validOn, deliverer, clusterWithParents, pageCounters) {
		var title = function () {
			var _v4 = orderFilter.ft;
			if (!_v4.$) {
				var filterName = _v4.a;
				return _List_fromArray(
					[
						$elm$html$Html$text(
						'Looplijst ' + $author$project$Date$DeliveryDate$view(validOn)),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('route-filter-description')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(filterName)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('route-page-counter')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Print$Document$simplePageCounter(pageCounters))
							]))
					]);
			} else {
				return _List_fromArray(
					[
						$elm$html$Html$text(
						'Looplijst ' + $author$project$Date$DeliveryDate$view(validOn)),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('route-page-counter')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Print$Document$simplePageCounter(pageCounters))
							]))
					]);
			}
		}();
		var maxLineLength = 80;
		var linesForCluster = 1 + (2 * (($elm$core$String$length(
			A2($author$project$Cluster$Cluster$shortNameView, distributionPoint, clusterWithParents.H)) / maxLineLength) | 0));
		var deliveredByView = A2(
			$elm$core$Maybe$map,
			function (dBy) {
				return A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(dBy)
						]));
			},
			A2($author$project$Plan$Supply$parentView, distributionPoint, clusterWithParents));
		var linesForDeliveredBy = function () {
			if (!deliveredByView.$) {
				return 1;
			} else {
				return 0;
			}
		}();
		var address = function () {
			var _v0 = _Utils_Tuple2(
				clusterWithParents.g9,
				A2(
					$author$project$Deliverer$Deliverer$locationOf,
					$author$project$Date$DeliveryDate$toDate(validOn),
					deliverer));
			_v0$0:
			while (true) {
				if (!_v0.b.$) {
					if (!_v0.a.b) {
						break _v0$0;
					} else {
						var l = _v0.b.a;
						var _v1 = $author$project$Lists$RouteDetail$ClusterView$supplyLocationView(l);
						var a = _v1.a;
						return ' | Afleveradres: ' + a;
					}
				} else {
					if (!_v0.a.b) {
						break _v0$0;
					} else {
						var _v2 = _v0.b;
						return ' | Afleveradres: onbekend';
					}
				}
			}
			return '';
		}();
		var linesForDeliverer = 1 + (2 * (($elm$core$String$length(
			_Utils_ap(
				$author$project$Deliverer$Deliverer$nameAndIdView(deliverer),
				address)) / maxLineLength) | 0));
		return A2(
			$author$project$Print$SizedHtml$listWithSize,
			((($author$project$Lists$RouteDetail$ClusterView$linesForTitle + linesForDeliverer) + linesForDeliveredBy) + linesForCluster) + $author$project$Lists$RouteDetail$ClusterView$linesForBottomMargin,
			_List_fromArray(
				[
					A2($elm$html$Html$h1, _List_Nil, title),
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Deliverer$Deliverer$nameAndIdView(deliverer)),
							$elm$html$Html$text(address)
						])),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text(''),
					deliveredByView),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Cluster$Cluster$shortNameView, distributionPoint, clusterWithParents.H))
						]))
				]));
	});
var $author$project$Demand$SummaryView$Columns = function (a) {
	return {$: 1, a: a};
};
var $author$project$Demand$SummaryView$IncludeInserts = 0;
var $author$project$Demand$SummaryView$Extra = {$: 5};
var $author$project$Demand$SummaryView$ProductCode = {$: 1};
var $author$project$Demand$SummaryView$Sale = {$: 4};
var $author$project$Demand$SummaryView$Subscription = {$: 3};
var $author$project$Demand$SummaryView$Total = {$: 0};
var $author$project$Demand$SummaryView$columnsWithTrailingTotal = function (packsVisibility) {
	return _List_fromArray(
		[
			$author$project$Demand$SummaryView$ProductCode,
			$author$project$Demand$SummaryView$Subscription,
			$author$project$Demand$SummaryView$Sale,
			$author$project$Demand$SummaryView$Extra,
			$author$project$Demand$SummaryView$Packs(packsVisibility),
			$author$project$Demand$SummaryView$Total
		]);
};
var $author$project$Lists$RouteDetail$ClusterView$summaryViewConfig = {
	h4: $author$project$Demand$SummaryView$Columns(2),
	eT: $author$project$Demand$SummaryView$columnsWithTrailingTotal(2),
	iT: 0
};
var $author$project$Lists$RouteDetail$MutationSummaryView$header = A2(
	$elm$html$Html$tr,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$colspan(2)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Mutaties')
				]))
		]));
var $author$project$Lists$RouteDetail$MutationSummaryView$addressText = function (order) {
	var address = order.f1;
	return $elm$html$Html$text(
		function () {
			var _v0 = order.ft;
			if (!_v0.$) {
				var name = _v0.a;
				return name + (', ' + (address.b5 + (' ' + ($author$project$Address$Address$houseNumberView(address.bs) + (', ' + address.bU)))));
			} else {
				return address.b5 + (' ' + ($author$project$Address$Address$houseNumberView(address.bs) + (', ' + address.bU)));
			}
		}());
};
var $author$project$Lists$RouteDetail$MutationSummaryView$demandTypeText = function (demandType) {
	return $elm$html$Html$text(
		$author$project$Demand$Demand$typeToString(demandType));
};
var $author$project$Demand$Demand$mutationToString = function (mutation) {
	switch (mutation) {
		case 0:
			return 'START';
		case 1:
			return 'STOP';
		default:
			return 'INFO';
	}
};
var $author$project$Lists$RouteDetail$MutationSummaryView$mutationLine = function (order) {
	return A2(
		$elm$html$Html$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$UI$Util$withDefaultEmptyText, $author$project$Lists$MutationIcon$view, order.mN)
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$UI$Util$withDefaultEmptyText,
						A2($elm$core$Basics$composeR, $author$project$Demand$Demand$mutationToString, $elm$html$Html$text),
						order.mN)
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Lists$RouteDetail$MutationSummaryView$demandTypeText(order.lB)
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('route-productid')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(order.av)
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('route-mutation-address')
					]),
				_List_fromArray(
					[
						$author$project$Lists$RouteDetail$MutationSummaryView$addressText(order)
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Date$DaysInTheWeek$icon(order.hD)
					]))
			]));
};
var $author$project$Lists$RouteDetail$MutationSummaryView$mutationSort = function (order) {
	var mutationComparable = function () {
		var _v0 = order.mN;
		if (!_v0.$) {
			switch (_v0.a) {
				case 1:
					var _v1 = _v0.a;
					return '1';
				case 0:
					var _v2 = _v0.a;
					return '2';
				default:
					var _v3 = _v0.a;
					return '3';
			}
		} else {
			return '4';
		}
	}();
	return mutationComparable;
};
var $author$project$Lists$RouteDetail$MutationSummaryView$add = F2(
	function (orders, document) {
		var mutatedOrders = A2(
			$elm$core$List$sortBy,
			$author$project$Lists$RouteDetail$MutationSummaryView$mutationSort,
			A2(
				$elm$core$List$filter,
				function (o) {
					return !_Utils_eq(o.mN, $elm$core$Maybe$Nothing);
				},
				orders));
		if (!mutatedOrders.b) {
			return document;
		} else {
			var headerWithLength = _Utils_Tuple2($author$project$Lists$RouteDetail$MutationSummaryView$header, 2);
			var itemsWithLength = A2(
				$elm$core$List$cons,
				headerWithLength,
				A2(
					$elm$core$List$map,
					$hayleigh_dot_dev$tuple_extra$Tuple$Extra$pairWith(1),
					A2($elm$core$List$map, $author$project$Lists$RouteDetail$MutationSummaryView$mutationLine, mutatedOrders)));
			var items = A2($elm$core$List$map, $elm$core$Tuple$first, itemsWithLength);
			var length = $elm$core$List$sum(
				A2($elm$core$List$map, $elm$core$Tuple$second, itemsWithLength));
			return A3(
				$author$project$Print$Document$addContent,
				length,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$table,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mutation-summary')
							]),
						items)
					]),
				document);
		}
	});
var $author$project$Lists$RouteDetail$MutationSummaryView$view = F3(
	function (orders, mutationVisibility, document) {
		if (!mutationVisibility) {
			return A2($author$project$Lists$RouteDetail$MutationSummaryView$add, orders, document);
		} else {
			return document;
		}
	});
var $author$project$Lists$RouteDetail$ClusterView$splitView = function (distributionPoint) {
	return function (orderFilter) {
		return function (_v0) {
			return function (validOn) {
				return function (deliverer) {
					return function (clusterWithParents) {
						return function (sequenceItems) {
							return function (orders) {
								return function (products) {
									return function (complaints) {
										return function (printOption) {
											var complaintVisibility = _v0.h6;
											var mutationVisibility = _v0.jj;
											var ordersFilteredForSummary = orderFilter.n_(orders);
											var ordersFilteredForDetail = orderFilter.lY(
												A2(
													$elm$core$List$filter,
													function (o) {
														return o.lB !== 2;
													},
													orders));
											var document = A2(
												$author$project$Print$Document$init,
												$author$project$Print$Document$defaultPageSize,
												A5($author$project$Lists$RouteDetail$ClusterView$header, distributionPoint, orderFilter, validOn, deliverer, clusterWithParents));
											return A3(
												$author$project$Print$Document$toHtml,
												printOption,
												_List_Nil,
												A4(
													$author$project$Lists$RouteDetail$ClusterView$addOrders,
													sequenceItems,
													ordersFilteredForDetail,
													mutationVisibility,
													A3(
														$author$project$Lists$RouteDetail$MutationSummaryView$view,
														ordersFilteredForSummary,
														mutationVisibility,
														A3(
															$author$project$Lists$RouteDetail$ComplaintSummaryView$add,
															complaints,
															complaintVisibility,
															A4($author$project$Demand$SummaryView$addSummary, $author$project$Lists$RouteDetail$ClusterView$summaryViewConfig, ordersFilteredForSummary, products, document)))));
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Lists$RouteDetail$ClusterView$view = function (distributionPoint) {
	return function (printSelection) {
		return function (validOn) {
			return function (deliverer) {
				return function (clusterWithParents) {
					return function (sequenceItems) {
						return function (orders) {
							return function (products) {
								return function (complaints) {
									return function (printOption) {
										return A2(
											$elm$core$List$concatMap,
											function (orderFilter) {
												return A2(
													$elm$core$List$map,
													function (_v0) {
														var splitItems = _v0.a;
														var splitOrders = _v0.b;
														return $author$project$Lists$RouteDetail$ClusterView$splitView(distributionPoint)(orderFilter)(printSelection)(validOn)(deliverer)(clusterWithParents)(splitItems)(splitOrders)(products)(complaints)(printOption);
													},
													A2($author$project$Lists$RouteDetail$ClusterView$splitByCutPoints, sequenceItems, orders));
											},
											$author$project$Lists$RouteDetail$PrintSelection$orderFilters(printSelection));
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Lists$RouteDetail$Deliverer$clusterToPrintItem = function (distributionPoint) {
	return function (date) {
		return function (products) {
			return function (orders) {
				return function (complaints) {
					return function (sequences) {
						return function (parents) {
							return function (item) {
								return function (deliverer) {
									return function (cluster) {
										var sequence = A3($author$project$Sequence$Sequence$findSequence, sequences, deliverer.eg, cluster.bb);
										var sequenceItems = A2(
											$elm$core$Maybe$withDefault,
											_List_Nil,
											A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.gL;
												},
												sequence));
										var filterOrders = $author$project$DistributionPoint$DistributionPoint$filterOnSegments(orders);
										var filterComplaints = $author$project$DistributionPoint$DistributionPoint$filterOnSegments(complaints);
										var concatOrders = $elm$core$List$concatMap(
											function ($) {
												return $.Y;
											});
										var html = _Utils_ap(
											$author$project$Lists$RouteDetail$ClusterView$view(distributionPoint)($author$project$Lists$RouteDetail$PrintSelection$defaults)(date)(deliverer)(
												{H: cluster, g9: parents})(sequenceItems)(
												concatOrders(
													filterOrders(cluster.bb)))(products)(
												filterComplaints(cluster.bb))(0),
											A7(
												$author$project$Lists$RouteDetail$Deliverer$kioskListView,
												distributionPoint,
												date,
												products,
												filterOrders(cluster.bb),
												sequenceItems,
												cluster,
												0));
										return A7($author$project$Lists$RouteDetail$Deliverer$PrintItem, distributionPoint, cluster, html, item, orders, sequence, true);
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Lists$Ride$List$headerForCluster = F5(
	function (distributionPoint, date, deliverer, cluster, pageCounters) {
		return A2(
			$author$project$Print$SizedHtml$listWithSize,
			4,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							'Routelijst / Verdeellijst ' + $author$project$Date$DeliveryDate$view(date)),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('route-page-counter')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Print$Document$simplePageCounter(pageCounters))
								]))
						])),
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Deliverer$Deliverer$nameAndIdView(
								$author$project$Deliverer$Deliverer$fromTyped(deliverer)))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Cluster$Cluster$longNameView, distributionPoint, cluster))
						]))
				]));
	});
var $author$project$Lists$Ride$List$IncludeSupplies = 0;
var $author$project$Demand$Aggregated$Orders = $elm$core$Basics$identity;
var $author$project$Demand$Aggregated$filterAmounts = F2(
	function (demandTypes, amounts) {
		return A2(
			$author$project$Demand$TypeDict$filter,
			F2(
				function (dt, _v0) {
					return A2($elm$core$List$member, dt, demandTypes);
				}),
			amounts);
	});
var $author$project$Demand$TypeDict$foldl = $timo_weike$generic_collections$ManualDict$foldl;
var $author$project$Demand$InsertDict$toComparable = function ($) {
	return $.eg;
};
var $author$project$Demand$InsertDict$fromList = $timo_weike$generic_collections$ManualDict$fromList($author$project$Demand$InsertDict$toComparable);
var $author$project$Demand$Aggregated$totalsFor = F2(
	function (product, amountPerType) {
		var toBundle = F2(
			function (p, a) {
				return A2(
					$author$project$Demand$Bundle$make,
					p,
					A3(
						$author$project$Demand$TypeDict$foldl,
						F3(
							function (_v0, b, acc) {
								return b + acc;
							}),
						0,
						a));
			});
		return {
			iT: $author$project$Demand$InsertDict$fromList(
				A2(
					$elm$core$List$map,
					function (insert) {
						return _Utils_Tuple2(
							insert,
							A2(
								toBundle,
								insert,
								A2($author$project$Demand$Aggregated$filterAmounts, insert.$8, amountPerType)));
					},
					product.iT)),
			jJ: A2(toBundle, product, amountPerType)
		};
	});
var $author$project$Demand$Aggregated$amountsFor = F2(
	function (product, amountPerType) {
		return {
			aZ: amountPerType,
			bD: A2($author$project$Demand$Aggregated$totalsFor, product, amountPerType)
		};
	});
var $author$project$Demand$ProductDict$empty = $timo_weike$generic_collections$ManualDict$empty;
var $author$project$Demand$ProductDict$map = $timo_weike$generic_collections$ManualDict$map;
var $author$project$Demand$ProductDict$toComparable = function ($) {
	return $.eg;
};
var $author$project$Demand$ProductDict$update = $timo_weike$generic_collections$ManualDict$update($author$project$Demand$ProductDict$toComparable);
var $author$project$Demand$TypeDict$insert = $timo_weike$generic_collections$ManualDict$insert($author$project$Demand$TypeDict$toComparable);
var $author$project$Demand$Aggregated$updateAmount = F3(
	function (demandType, amount, demandPerType) {
		return $elm$core$Maybe$Just(
			function () {
				if (!demandPerType.$) {
					var existing = demandPerType.a;
					return A3(
						$author$project$Demand$TypeDict$update,
						demandType,
						A2(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$elm$core$Maybe$Just(amount),
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Basics$add(amount),
								$elm$core$Maybe$Just)),
						existing);
				} else {
					return A3($author$project$Demand$TypeDict$insert, demandType, amount, $author$project$Demand$TypeDict$empty);
				}
			}());
	});
var $author$project$Demand$Aggregated$fromOrders = F2(
	function (products, orders) {
		var productsPerId = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (p) {
					return _Utils_Tuple2(p.eg, p);
				},
				products));
		return function (_v1) {
			var perProduct = _v1.S;
			var perUnknownProduct = _v1.T;
			return {
				S: A2($author$project$Demand$ProductDict$map, $author$project$Demand$Aggregated$amountsFor, perProduct),
				T: perUnknownProduct
			};
		}(
			A3(
				$elm$core$List$foldl,
				F2(
					function (order, aggregated) {
						var _v0 = A2($elm$core$Dict$get, order.av, productsPerId);
						if (!_v0.$) {
							var product = _v0.a;
							return _Utils_update(
								aggregated,
								{
									S: A3(
										$author$project$Demand$ProductDict$update,
										product,
										A2($author$project$Demand$Aggregated$updateAmount, order.lB, order.aa),
										aggregated.S)
								});
						} else {
							return _Utils_update(
								aggregated,
								{
									T: A3(
										$elm$core$Dict$update,
										order.av,
										A2($author$project$Demand$Aggregated$updateAmount, order.lB, order.aa),
										aggregated.T)
								});
						}
					}),
				{S: $author$project$Demand$ProductDict$empty, T: $elm$core$Dict$empty},
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.mN;
						},
						$elm$core$Basics$neq(
							$elm$core$Maybe$Just(1))),
					orders)));
	});
var $timo_weike$generic_collections$ManualDict$merge = F7(
	function (ord, leftAccu, bothAccu, rightAccu, leftDict, rightDict, start) {
		var step = F3(
			function (rKey, rValue, _v0) {
				step:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightAccu, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (!A2(ord, lKey, rKey)) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftAccu, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue step;
						} else {
							if (A2(ord, lKey, rKey) === 2) {
								return _Utils_Tuple2(
									list,
									A3(rightAccu, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothAccu, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$timo_weike$generic_collections$ManualDict$foldl,
			step,
			_Utils_Tuple2(
				$timo_weike$generic_collections$ManualDict$toList(leftDict),
				start),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftAccu, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $author$project$Demand$TypeDict$merge = $timo_weike$generic_collections$ManualDict$merge(
	F2(
		function (t1, t2) {
			return A2(
				$elm$core$Basics$compare,
				$author$project$Demand$TypeDict$toComparable(t1),
				$author$project$Demand$TypeDict$toComparable(t2));
		}));
var $author$project$Demand$Aggregated$combineAmountPerType = F2(
	function (typeDict, otherTypeDict) {
		return A6(
			$author$project$Demand$TypeDict$merge,
			$author$project$Demand$TypeDict$insert,
			F3(
				function (demandType, amount, otherAmount) {
					return A2($author$project$Demand$TypeDict$insert, demandType, amount + otherAmount);
				}),
			$author$project$Demand$TypeDict$insert,
			typeDict,
			otherTypeDict,
			$author$project$Demand$TypeDict$empty);
	});
var $author$project$Demand$InsertDict$empty = $timo_weike$generic_collections$ManualDict$empty;
var $author$project$Demand$InsertDict$insert = $timo_weike$generic_collections$ManualDict$insert($author$project$Demand$InsertDict$toComparable);
var $author$project$Demand$InsertDict$merge = $timo_weike$generic_collections$ManualDict$merge(
	F2(
		function (t1, t2) {
			return A2(
				$elm$core$Basics$compare,
				$author$project$Demand$InsertDict$toComparable(t1),
				$author$project$Demand$InsertDict$toComparable(t2));
		}));
var $author$project$Demand$Aggregated$combineTotals = F2(
	function (_v0, other) {
		var product = _v0.jJ;
		var inserts = _v0.iT;
		return {
			iT: A6(
				$author$project$Demand$InsertDict$merge,
				$author$project$Demand$InsertDict$insert,
				F3(
					function (insert, insertTotal, otherInsertTotal) {
						return A2(
							$author$project$Demand$InsertDict$insert,
							insert,
							A2($author$project$Demand$Bundle$combine, insertTotal, otherInsertTotal).a);
					}),
				$author$project$Demand$InsertDict$insert,
				inserts,
				other.iT,
				$author$project$Demand$InsertDict$empty),
			jJ: A2($author$project$Demand$Bundle$combine, product, other.jJ).a
		};
	});
var $author$project$Demand$Aggregated$combineAmounts = F2(
	function (_v0, other) {
		var totals = _v0.bD;
		var amountPerType = _v0.aZ;
		return {
			aZ: A2($author$project$Demand$Aggregated$combineAmountPerType, amountPerType, other.aZ),
			bD: A2($author$project$Demand$Aggregated$combineTotals, totals, other.bD)
		};
	});
var $author$project$Demand$ProductDict$insert = $timo_weike$generic_collections$ManualDict$insert($author$project$Demand$ProductDict$toComparable);
var $author$project$Demand$ProductDict$merge = $timo_weike$generic_collections$ManualDict$merge(
	F2(
		function (t1, t2) {
			return A2(
				$elm$core$Basics$compare,
				$author$project$Demand$ProductDict$toComparable(t1),
				$author$project$Demand$ProductDict$toComparable(t2));
		}));
var $author$project$Demand$Aggregated$combine = F2(
	function (_v0, _v1) {
		var aggregated = _v0;
		var other = _v1;
		return {
			S: A6(
				$author$project$Demand$ProductDict$merge,
				$author$project$Demand$ProductDict$insert,
				F3(
					function (product, perProduct, otherPerProduct) {
						return A2(
							$author$project$Demand$ProductDict$insert,
							product,
							A2($author$project$Demand$Aggregated$combineAmounts, perProduct, otherPerProduct));
					}),
				$author$project$Demand$ProductDict$insert,
				aggregated.S,
				other.S,
				$author$project$Demand$ProductDict$empty),
			T: A6(
				$elm$core$Dict$merge,
				$elm$core$Dict$insert,
				F3(
					function (productId, perProduct, otherPerProduct) {
						return A2(
							$elm$core$Dict$insert,
							productId,
							A2($author$project$Demand$Aggregated$combineAmountPerType, perProduct, otherPerProduct));
					}),
				$elm$core$Dict$insert,
				aggregated.T,
				other.T,
				$elm$core$Dict$empty)
		};
	});
var $author$project$Demand$Aggregated$empty = {S: $author$project$Demand$ProductDict$empty, T: $elm$core$Dict$empty};
var $author$project$Demand$Aggregated$combineAll = function (orders) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (o, cummul) {
				return A2($author$project$Demand$Aggregated$combine, o, cummul);
			}),
		$author$project$Demand$Aggregated$empty,
		orders);
};
var $author$project$Demand$Aggregated$fromSummary = F2(
	function (products, summary) {
		var productsPerId = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (p) {
					return _Utils_Tuple2(p.eg, p);
				},
				products));
		return A3(
			$elm$core$Dict$foldr,
			F3(
				function (productId, amountPerType, aggregated) {
					var _v0 = A2($elm$core$Dict$get, productId, productsPerId);
					if (!_v0.$) {
						var product = _v0.a;
						return _Utils_update(
							aggregated,
							{
								S: A3(
									$author$project$Demand$ProductDict$insert,
									product,
									A2($author$project$Demand$Aggregated$amountsFor, product, amountPerType),
									aggregated.S)
							});
					} else {
						return _Utils_update(
							aggregated,
							{
								T: A3($elm$core$Dict$insert, productId, amountPerType, aggregated.T)
							});
					}
				}),
			{S: $author$project$Demand$ProductDict$empty, T: $elm$core$Dict$empty},
			summary);
	});
var $author$project$Lists$Ride$List$aggregatedOrdersIncludingSupplies = F4(
	function (products, orders, summaries, item) {
		switch (item.$) {
			case 0:
				var cluster = item.a.H;
				var supplies = item.a.n0;
				return $author$project$Demand$Aggregated$combineAll(
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Demand$Aggregated$fromOrders,
							products,
							A2(
								$elm$core$List$concatMap,
								function ($) {
									return $.Y;
								},
								A2(
									$author$project$DistributionPoint$DistributionPoint$filterOnSegments,
									orders,
									$author$project$Plan$Supply$ownSegmentsOf(item)))),
						A2(
							$elm$core$List$map,
							A3($author$project$Lists$Ride$List$aggregatedOrdersIncludingSupplies, products, orders, summaries),
							supplies)));
			case 1:
				var clusters = item.a.k;
				return A2(
					$author$project$Demand$Aggregated$fromOrders,
					products,
					A2(
						$elm$core$List$concatMap,
						function ($) {
							return $.Y;
						},
						A2(
							$author$project$DistributionPoint$DistributionPoint$filterOnSegments,
							orders,
							A2(
								$elm$core$List$concatMap,
								function ($) {
									return $.bb;
								},
								clusters))));
			default:
				var dpId = item.a.lK;
				return A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$author$project$Demand$Aggregated$empty,
					function (ds) {
						return A2($author$project$Demand$Aggregated$fromSummary, ds.bu, ds.kO);
					},
					A2($author$project$DistributionPoint$IdDict$get, dpId, summaries));
		}
	});
var $author$project$Lists$Ride$List$emptyInfo = {f1: $elm$core$Maybe$Nothing, lE: _List_Nil, fl: $elm$core$Maybe$Nothing, ft: ''};
var $author$project$Lists$Ride$List$infoForDeliverer = F3(
	function (date, typed, details) {
		var deliverer = $author$project$Deliverer$Deliverer$fromTyped(typed);
		var location = A2(
			$author$project$Deliverer$Deliverer$locationOf,
			$author$project$Date$DeliveryDate$toDate(date),
			deliverer);
		return {
			f1: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.f1;
				},
				location),
			lE: details,
			fl: A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.gg;
				},
				location),
			ft: $author$project$Deliverer$Deliverer$nameView(deliverer)
		};
	});
var $author$project$DistributionPoint$DistributionPoint$getSegmentName = F2(
	function (distributionPoint, sId) {
		return A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.ft;
			},
			A2(
				$elm$core$Maybe$map,
				$author$project$DistributionPoint$DistributionPoint$segmentInfo,
				A2($author$project$DistributionPoint$DistributionPoint$findSegmentOnId, distributionPoint, sId)));
	});
var $author$project$DistributionPoint$DistributionPoint$sortedSegmentNames = F2(
	function (distributionPoint, segments) {
		return $elm$core$List$sort(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				A2(
					$elm$core$List$map,
					$author$project$DistributionPoint$DistributionPoint$getSegmentName(distributionPoint),
					segments)));
	});
var $author$project$Lists$Ride$List$infoFromItem = F7(
	function (distributionPoint, date, products, orders, demandSummaryBySubDPId, inclusion, item) {
		switch (item.$) {
			case 0:
				var deliverer = item.a.bl;
				var cluster = item.a.H;
				var supplies = item.a.n0;
				var aggregatedOrders = function () {
					if (!inclusion) {
						return function (aggregatedOrdersFromCarItself) {
							return $author$project$Demand$Aggregated$combineAll(
								A2(
									$elm$core$List$cons,
									aggregatedOrdersFromCarItself,
									A2(
										$elm$core$List$map,
										A3($author$project$Lists$Ride$List$aggregatedOrdersIncludingSupplies, products, orders, demandSummaryBySubDPId),
										supplies)));
						};
					} else {
						return $elm$core$Basics$identity;
					}
				}()(
					A2(
						$author$project$Demand$Aggregated$fromOrders,
						products,
						A2(
							$elm$core$List$concatMap,
							function ($) {
								return $.Y;
							},
							A2($author$project$DistributionPoint$DistributionPoint$filterOnSegments, orders, cluster.bb))));
				return _List_fromArray(
					[
						_Utils_Tuple2(
						A3(
							$author$project$Lists$Ride$List$infoForDeliverer,
							date,
							deliverer,
							A2($author$project$DistributionPoint$DistributionPoint$sortedSegmentNames, distributionPoint, cluster.bb)),
						aggregatedOrders)
					]);
			case 1:
				var deliverer = item.a.bl;
				var clusters = item.a.k;
				return A2(
					$elm$core$List$map,
					function (cluster) {
						return _Utils_Tuple2(
							A3(
								$author$project$Lists$Ride$List$infoForDeliverer,
								date,
								deliverer,
								A2($author$project$DistributionPoint$DistributionPoint$sortedSegmentNames, distributionPoint, cluster.bb)),
							A2(
								$author$project$Demand$Aggregated$fromOrders,
								products,
								A2(
									$elm$core$List$concatMap,
									function ($) {
										return $.Y;
									},
									A2($author$project$DistributionPoint$DistributionPoint$filterOnSegments, orders, cluster.bb))));
					},
					clusters);
			default:
				var dpId = item.a.lK;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							_Utils_update(
								$author$project$Lists$Ride$List$emptyInfo,
								{ft: 'Ongekend depot'}),
							function (_v2) {
								var subDp = _v2;
								return _Utils_update(
									$author$project$Lists$Ride$List$emptyInfo,
									{
										f1: $elm$core$Maybe$Just(subDp.f1),
										ft: subDp.ft
									});
							},
							A2($author$project$DistributionPoint$DistributionPoint$findSubDistributionPointOnId, distributionPoint, dpId)),
						A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$author$project$Demand$Aggregated$empty,
							function (ds) {
								return A2($author$project$Demand$Aggregated$fromSummary, ds.bu, ds.kO);
							},
							A2($author$project$DistributionPoint$IdDict$get, dpId, demandSummaryBySubDPId)))
					]);
		}
	});
var $author$project$Lists$Ride$List$listFromCarItem = F8(
	function (distributionPoint, date, products, cluster, deliverer, stops, orders, demandSummaryBySubDPId) {
		return {
			nw: _Utils_Tuple2(
				{
					lE: A2($author$project$DistributionPoint$DistributionPoint$sortedSegmentNames, distributionPoint, cluster.bb),
					ft: $author$project$Deliverer$Deliverer$nameView(
						$author$project$Deliverer$Deliverer$fromTyped(deliverer))
				},
				A2(
					$author$project$Demand$Aggregated$fromOrders,
					products,
					A2(
						$elm$core$List$concatMap,
						function ($) {
							return $.Y;
						},
						A2($author$project$DistributionPoint$DistributionPoint$filterOnSegments, orders, cluster.bb)))),
			nW: A2(
				$elm$core$List$concatMap,
				A6($author$project$Lists$Ride$List$infoFromItem, distributionPoint, date, products, orders, demandSummaryBySubDPId, 0),
				stops)
		};
	});
var $author$project$Plan$Supply$allClustersOf = function (item) {
	switch (item.$) {
		case 2:
			return _List_Nil;
		case 0:
			var cluster = item.a.H;
			var supplies = item.a.n0;
			return _Utils_ap(
				_List_fromArray(
					[cluster]),
				A2($elm$core$List$concatMap, $author$project$Plan$Supply$allClustersOf, supplies));
		default:
			var clusters = item.a.k;
			return clusters;
	}
};
var $author$project$Plan$Supply$allSegmentsOf = function (item) {
	return A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.bb;
		},
		$author$project$Plan$Supply$allClustersOf(item));
};
var $author$project$Lists$Ride$Summary$ordersForIncludingStops = F2(
	function (segmentOrders, item) {
		return A2(
			$author$project$DistributionPoint$DistributionPoint$filterOnSegments,
			segmentOrders,
			$author$project$Plan$Supply$allSegmentsOf(item));
	});
var $author$project$Print$Document$addMultiple = F2(
	function (items, document) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (item, d) {
					return A2($author$project$Print$Document$addSizedHtml, item, d);
				}),
			document,
			items);
	});
var $ianmackenzie$elm_units$Mass$inKilograms = function (_v0) {
	var numKilograms = _v0;
	return numKilograms;
};
var $author$project$Demand$ProductDict$foldl = $timo_weike$generic_collections$ManualDict$foldl;
var $author$project$Demand$TypeDict$map = $timo_weike$generic_collections$ManualDict$map;
var $ianmackenzie$elm_units$Quantity$multiplyBy = F2(
	function (scale, _v0) {
		var value = _v0;
		return scale * value;
	});
var $ianmackenzie$elm_units$Quantity$plus = F2(
	function (_v0, _v1) {
		var y = _v0;
		var x = _v1;
		return x + y;
	});
var $author$project$Demand$Demand$relevantInsertsFor = F2(
	function (demandType, product) {
		return A2(
			$elm$core$List$filter,
			function (i) {
				return A2($elm$core$List$member, demandType, i.$8);
			},
			product.iT);
	});
var $ianmackenzie$elm_units$Quantity$zero = 0;
var $ianmackenzie$elm_units$Quantity$sum = function (quantities) {
	return A3($elm$core$List$foldl, $ianmackenzie$elm_units$Quantity$plus, $ianmackenzie$elm_units$Quantity$zero, quantities);
};
var $author$project$Demand$Aggregated$massOf = F2(
	function (include, _v0) {
		var perProduct = _v0.S;
		var massOfProduct = F2(
			function (amount, product) {
				return A2($ianmackenzie$elm_units$Quantity$multiplyBy, amount, product.ja);
			});
		var massOfInserts = F3(
			function (amount, demandType, product) {
				return $ianmackenzie$elm_units$Quantity$sum(
					A2(
						$elm$core$List$map,
						function (i) {
							return A2($ianmackenzie$elm_units$Quantity$multiplyBy, amount, i.ja);
						},
						A2($author$project$Demand$Demand$relevantInsertsFor, demandType, product)));
			});
		return A3(
			$author$project$Demand$ProductDict$foldl,
			F3(
				function (_v4, m, total) {
					return A2($ianmackenzie$elm_units$Quantity$plus, m, total);
				}),
			$ianmackenzie$elm_units$Mass$grams(0),
			A2(
				$author$project$Demand$ProductDict$map,
				F2(
					function (product, _v1) {
						var amountPerType = _v1.aZ;
						return A3(
							$author$project$Demand$TypeDict$foldl,
							F3(
								function (_v3, m, total) {
									return A2($ianmackenzie$elm_units$Quantity$plus, m, total);
								}),
							$ianmackenzie$elm_units$Mass$grams(0),
							A2(
								$author$project$Demand$TypeDict$map,
								F2(
									function (demandType, amount) {
										switch (include) {
											case 0:
												return A2(
													$ianmackenzie$elm_units$Quantity$plus,
													A2(massOfProduct, amount, product),
													A3(massOfInserts, amount, demandType, product));
											case 1:
												return A2(massOfProduct, amount, product);
											default:
												return A3(massOfInserts, amount, demandType, product);
										}
									}),
								amountPerType));
					}),
				perProduct));
	});
var $author$project$Print$SizedHtml$withSize = $hayleigh_dot_dev$tuple_extra$Tuple$Extra$pairWith;
var $author$project$Lists$Ride$List$massView = F2(
	function (config, aggregatedOrders) {
		return A2(
			$author$project$Print$SizedHtml$withSize,
			2,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ride-summary-mass')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Gewicht: '),
						$elm$html$Html$text(
						$elm$core$String$fromInt(
							$elm$core$Basics$round(
								$ianmackenzie$elm_units$Mass$inKilograms(
									A2($author$project$Demand$Aggregated$massOf, config.df, aggregatedOrders))))),
						$elm$html$Html$text('kg')
					])));
	});
var $author$project$Lists$Ride$List$numberOfStopsView = function (stops) {
	return A2(
		$author$project$Print$SizedHtml$withSize,
		2,
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ride-summary-info')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Aantal stops: '),
					$elm$html$Html$text(
					$elm$core$String$fromInt(
						$elm$core$List$length(stops)))
				])));
};
var $elm$html$Html$section = _VirtualDom_node('section');
var $author$project$Print$SizedHtml$section = F2(
	function (attrs, items) {
		return A2(
			$author$project$Print$SizedHtml$withSize,
			$elm$core$List$sum(
				A2($elm$core$List$map, $elm$core$Tuple$second, items)),
			A2(
				$elm$html$Html$section,
				attrs,
				A2($elm$core$List$map, $elm$core$Tuple$first, items)));
	});
var $author$project$Demand$Aggregated$OneColumn = 0;
var $author$project$Demand$Aggregated$Packs = function (a) {
	return {$: 6, a: a};
};
var $author$project$Demand$Aggregated$ProductCode = {$: 1};
var $author$project$Demand$Aggregated$ProductName = {$: 2};
var $author$project$Demand$Aggregated$Total = {$: 0};
var $author$project$Demand$Bundle$IndividualsAndPacks = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Demand$Bundle$ShowPacksWhenAtLeastOne = 1;
var $author$project$Lists$Ride$List$bundleConfig = A2($author$project$Demand$Bundle$IndividualsAndPacks, 0, 1);
var $author$project$Demand$Aggregated$OnlyInserts = 2;
var $author$project$Demand$Bundle$isEmpty = function (_v0) {
	var individual = _v0.aM;
	var packs = _v0.dl;
	return (!individual) && (!packs);
};
var $author$project$Demand$Aggregated$bundleTotalView = function (bundle) {
	return $author$project$Demand$Bundle$isEmpty(bundle) ? $elm$html$Html$text('') : $elm$html$Html$text(
		$elm$core$String$fromInt(
			$author$project$Demand$Bundle$total(bundle)));
};
var $author$project$Demand$Aggregated$checkMark = $elm$core$String$fromChar(
	$elm$core$Char$fromCode(10003));
var $author$project$Demand$Aggregated$emptyCell = A2($elm$html$Html$td, _List_Nil, _List_Nil);
var $author$project$Demand$Aggregated$numberCell = function (content) {
	return A2(
		$elm$html$Html$td,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('aggregated-number')
			]),
		_List_fromArray(
			[content]));
};
var $author$project$Demand$Bundle$individualPrint = function (_v0) {
	var individual = _v0.aM;
	return $elm$html$Html$text(
		$elm$core$String$fromInt(individual));
};
var $author$project$Demand$Bundle$packSizePrint = F2(
	function (size, _v0) {
		var packSize = _v0.E;
		return A2($author$project$Demand$PackIcon$view, size, packSize);
	});
var $author$project$Demand$Bundle$packsPrint = function (_v0) {
	var packs = _v0.dl;
	return $elm$html$Html$text(
		$elm$core$String$fromInt(packs));
};
var $author$project$Demand$Bundle$print = F2(
	function (config, bundle) {
		var packs = bundle.dl;
		var _v0 = _Utils_Tuple2(config, packs);
		switch (_v0.a.$) {
			case 0:
				var iconSize = _v0.a.a;
				return _List_fromArray(
					[
						$author$project$Demand$Bundle$packsPrint(bundle),
						A2($author$project$Demand$Bundle$packSizePrint, iconSize, bundle)
					]);
			case 1:
				var _v1 = _v0.a;
				return _List_fromArray(
					[
						$author$project$Demand$Bundle$individualPrint(bundle)
					]);
			default:
				if ((_v0.a.b === 1) && (!_v0.b)) {
					var _v2 = _v0.a;
					var _v3 = _v2.b;
					return _List_fromArray(
						[
							$author$project$Demand$Bundle$individualPrint(bundle)
						]);
				} else {
					var _v4 = _v0.a;
					var iconSize = _v4.a;
					return _List_fromArray(
						[
							$author$project$Demand$Bundle$packsPrint(bundle),
							A2($author$project$Demand$Bundle$packSizePrint, iconSize, bundle),
							$elm$html$Html$text('+'),
							$author$project$Demand$Bundle$individualPrint(bundle)
						]);
				}
		}
	});
var $author$project$Demand$Aggregated$packsCell = F2(
	function (bundle, bundleConfig) {
		return A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('aggregated-bundle')
				]),
			A2($author$project$Demand$Bundle$print, bundleConfig, bundle));
	});
var $author$project$Demand$Aggregated$row = F3(
	function (_v0, attributes, _v1) {
		var columns = _v0.eT;
		var productCode = _v1.dq;
		var productName = _v1.dr;
		var subscription = _v1.dD;
		var sale = _v1.dw;
		var extra = _v1.c6;
		var packs = _v1.dl;
		var total = _v1.dH;
		return A2(
			$elm$html$Html$tr,
			attributes,
			A2(
				$elm$core$List$map,
				function (c) {
					switch (c.$) {
						case 0:
							return total;
						case 6:
							var packsVisibility = c.a;
							return packs(packsVisibility);
						case 1:
							return productCode;
						case 2:
							return productName;
						case 3:
							return subscription;
						case 4:
							return sale;
						default:
							return extra;
					}
				},
				columns));
	});
var $author$project$Demand$Aggregated$totalView = function (total) {
	return (!total) ? $elm$html$Html$text('') : $elm$html$Html$text(
		$elm$core$String$fromInt(total));
};
var $author$project$Demand$Aggregated$insertLine = F4(
	function (config, insert, total, amountPerType) {
		var amountCellFor = function (demandType) {
			return $author$project$Demand$Aggregated$numberCell(
				function () {
					var _v1 = _Utils_Tuple3(
						config.df,
						A2($elm$core$List$member, demandType, insert.$8),
						A2($author$project$Demand$TypeDict$get, demandType, amountPerType));
					_v1$2:
					while (true) {
						if (_v1.b && (!_v1.c.$)) {
							switch (_v1.a) {
								case 2:
									var _v2 = _v1.a;
									var amount = _v1.c.a;
									return $author$project$Demand$Aggregated$totalView(amount);
								case 0:
									var _v3 = _v1.a;
									return $elm$html$Html$text($author$project$Demand$Aggregated$checkMark);
								default:
									break _v1$2;
							}
						} else {
							break _v1$2;
						}
					}
					return $elm$html$Html$text('');
				}());
		};
		return A3(
			$author$project$Demand$Aggregated$row,
			config,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('aggregated-insert', config.df !== 2),
							_Utils_Tuple2('aggregated-insert-only', config.df === 2)
						]))
				]),
			{
				c6: amountCellFor(2),
				dl: $author$project$Demand$Aggregated$packsCell(total),
				dq: A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('aggregated-insert-code')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(insert.eg)
						])),
				dr: A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('aggregated-insert-name')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(insert.ft)
						])),
				dw: amountCellFor(1),
				dD: amountCellFor(0),
				dH: function () {
					var _v0 = config.df;
					if (_v0 === 2) {
						return $author$project$Demand$Aggregated$numberCell(
							$author$project$Demand$Aggregated$bundleTotalView(total));
					} else {
						return $author$project$Demand$Aggregated$emptyCell;
					}
				}()
			});
	});
var $author$project$Demand$InsertDict$foldl = $timo_weike$generic_collections$ManualDict$foldl;
var $author$project$Demand$InsertDict$update = $timo_weike$generic_collections$ManualDict$update($author$project$Demand$InsertDict$toComparable);
var $author$project$Demand$Aggregated$insertsOf = function (perProduct) {
	var add = F2(
		function (_v2, _v3) {
			var b1 = _v2.a;
			var a1 = _v2.b;
			var b2 = _v3.a;
			var a2 = _v3.b;
			return _Utils_Tuple2(
				A2($author$project$Demand$Bundle$combine, b1, b2).a,
				A2($author$project$Demand$Aggregated$combineAmountPerType, a1, a2));
		});
	return A3(
		$author$project$Demand$ProductDict$foldl,
		F3(
			function (_v0, _v1, result) {
				var totals = _v1.bD;
				var amountPerType = _v1.aZ;
				return A3(
					$author$project$Demand$InsertDict$foldl,
					F3(
						function (insert, insertTotal, res) {
							var item = _Utils_Tuple2(
								insertTotal,
								A2($author$project$Demand$Aggregated$filterAmounts, insert.$8, amountPerType));
							return A3(
								$author$project$Demand$InsertDict$update,
								insert,
								function (current) {
									return $elm$core$Maybe$Just(
										A3(
											$elm_community$maybe_extra$Maybe$Extra$unwrap,
											item,
											add(item),
											current));
								},
								res);
						}),
					result,
					totals.iT);
			}),
		$author$project$Demand$InsertDict$empty,
		perProduct);
};
var $author$project$Demand$InsertDict$map = $timo_weike$generic_collections$ManualDict$map;
var $author$project$Demand$Aggregated$productLine = F4(
	function (config, product, total, amountPerType) {
		var amountFor = function (demandType) {
			return $author$project$Demand$Aggregated$numberCell(
				A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$html$Html$text(''),
					$author$project$Demand$Aggregated$totalView,
					A2($author$project$Demand$TypeDict$get, demandType, amountPerType)));
		};
		return A3(
			$author$project$Demand$Aggregated$row,
			config,
			_List_Nil,
			{
				c6: amountFor(2),
				dl: $author$project$Demand$Aggregated$packsCell(total),
				dq: A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(product.eg)
						])),
				dr: A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(product.ft)
						])),
				dw: amountFor(1),
				dD: amountFor(0),
				dH: $author$project$Demand$Aggregated$numberCell(
					$author$project$Demand$Aggregated$bundleTotalView(total))
			});
	});
var $author$project$Demand$InsertDict$values = $timo_weike$generic_collections$ManualDict$values;
var $author$project$Demand$ProductDict$values = $timo_weike$generic_collections$ManualDict$values;
var $author$project$Demand$Aggregated$knownProductsView = F2(
	function (config, perProduct) {
		var _v0 = config.df;
		switch (_v0) {
			case 0:
				return $author$project$Demand$ProductDict$values(
					A2(
						$author$project$Demand$ProductDict$map,
						F2(
							function (product, _v1) {
								var totals = _v1.bD;
								var amountPerType = _v1.aZ;
								return A2(
									$elm$core$List$cons,
									A4($author$project$Demand$Aggregated$productLine, config, product, totals.jJ, amountPerType),
									$author$project$Demand$InsertDict$values(
										A2(
											$author$project$Demand$InsertDict$map,
											F2(
												function (insert, insertTotal) {
													return A4($author$project$Demand$Aggregated$insertLine, config, insert, insertTotal, amountPerType);
												}),
											totals.iT)));
							}),
						perProduct));
			case 1:
				return $author$project$Demand$ProductDict$values(
					A2(
						$author$project$Demand$ProductDict$map,
						F2(
							function (product, _v2) {
								var totals = _v2.bD;
								var amountPerType = _v2.aZ;
								return _List_fromArray(
									[
										A4($author$project$Demand$Aggregated$productLine, config, product, totals.jJ, amountPerType)
									]);
							}),
						perProduct));
			default:
				return $author$project$Demand$InsertDict$values(
					A2(
						$author$project$Demand$InsertDict$map,
						F2(
							function (insert, _v3) {
								var total = _v3.a;
								var amountPerType = _v3.b;
								return _List_fromArray(
									[
										A4($author$project$Demand$Aggregated$insertLine, config, insert, total, amountPerType)
									]);
							}),
						$author$project$Demand$Aggregated$insertsOf(perProduct)));
		}
	});
var $author$project$Demand$Aggregated$split = F2(
	function (config, lines) {
		var numberOfLines = $elm$core$List$sum(
			A2($elm$core$List$map, $elm$core$List$length, lines));
		var _v0 = config.h4;
		if (!_v0) {
			return _Utils_Tuple2(
				_List_fromArray(
					[
						$elm$core$List$concat(lines)
					]),
				numberOfLines);
		} else {
			return function (_v2) {
				var firstRow = _v2.a;
				var secondRow = _v2.b;
				return _Utils_Tuple2(
					_List_fromArray(
						[firstRow, secondRow]),
					A2(
						$elm$core$Basics$max,
						$elm$core$List$length(firstRow),
						$elm$core$List$length(secondRow)));
			}(
				A3(
					$elm$core$List$foldr,
					F2(
						function (l, _v1) {
							var firstRow = _v1.a;
							var secondRow = _v1.b;
							var height = _v1.c;
							return (_Utils_cmp(
								2 * (height + $elm$core$List$length(l)),
								numberOfLines) > 0) ? _Utils_Tuple3(
								_Utils_ap(l, firstRow),
								secondRow,
								height + $elm$core$List$length(l)) : _Utils_Tuple3(
								firstRow,
								_Utils_ap(l, secondRow),
								height + $elm$core$List$length(l));
						}),
					_Utils_Tuple3(_List_Nil, _List_Nil, 0),
					lines));
		}
	});
var $author$project$Demand$Aggregated$header = function (config) {
	var productNameHeader = (A2($elm$core$List$member, $author$project$Demand$Aggregated$ProductCode, config.eT) && A2($elm$core$List$member, $author$project$Demand$Aggregated$ProductName, config.eT)) ? 'Omschrijving' : 'Product';
	return A3(
		$author$project$Demand$Aggregated$row,
		config,
		_List_Nil,
		{
			c6: A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Extra')
					])),
			dl: $elm$core$Basics$always(
				A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Pak/Losse')
						]))),
			dq: A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Product')
					])),
			dr: A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(productNameHeader)
					])),
			dw: A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Lvk')
					])),
			dD: A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Abo')
					])),
			dH: A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Totaal')
					]))
		});
};
var $author$project$Demand$Aggregated$table = F2(
	function (config, rows) {
		return A2(
			$elm$html$Html$table,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				$author$project$Demand$Aggregated$header(config),
				rows));
	});
var $author$project$Demand$PackIcon$viewUnknownPackSize = function (size) {
	return A2($author$project$Demand$PackIcon$viewWithText, size, '??');
};
var $author$project$Demand$Aggregated$unknownProductLine = F3(
	function (config, productId, amountPerType) {
		var total = A3(
			$author$project$Demand$TypeDict$foldl,
			F3(
				function (_v0, b, acc) {
					return b + acc;
				}),
			0,
			amountPerType);
		var amountFor = function (demandType) {
			return $author$project$Demand$Aggregated$numberCell(
				$author$project$Demand$Aggregated$totalView(
					A2(
						$elm$core$Maybe$withDefault,
						0,
						A2($author$project$Demand$TypeDict$get, demandType, amountPerType))));
		};
		return A3(
			$author$project$Demand$Aggregated$row,
			config,
			_List_Nil,
			{
				c6: amountFor(2),
				dl: $elm$core$Basics$always(
					A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('aggregated-number')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(total)),
								$elm$html$Html$text(' ('),
								$author$project$Demand$PackIcon$viewUnknownPackSize(0),
								$elm$html$Html$text(')')
							]))),
				dq: A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(productId)
						])),
				dr: A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(productId + ' (bijlagen?)')
						])),
				dw: amountFor(1),
				dD: amountFor(0),
				dH: $author$project$Demand$Aggregated$numberCell(
					$author$project$Demand$Aggregated$totalView(total))
			});
	});
var $author$project$Demand$Aggregated$unknownProductsView = F2(
	function (config, perUnknownProduct) {
		return A2(
			$elm$core$List$map,
			$elm$core$List$singleton,
			$elm$core$Dict$values(
				A2(
					$elm$core$Dict$map,
					F2(
						function (productId, amountPerType) {
							return A3($author$project$Demand$Aggregated$unknownProductLine, config, productId, amountPerType);
						}),
					perUnknownProduct)));
	});
var $author$project$Demand$Aggregated$view = F2(
	function (config, _v0) {
		var perProduct = _v0.S;
		var perUnknownProduct = _v0.T;
		return A3(
			$elm$core$Tuple$mapBoth,
			A2(
				$elm$core$Basics$composeL,
				$elm$html$Html$div(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('aggregated')
						])),
				$elm$core$List$map(
					$author$project$Demand$Aggregated$table(config))),
			$elm$core$Basics$add(1),
			A2(
				$author$project$Demand$Aggregated$split,
				config,
				_Utils_ap(
					A2($author$project$Demand$Aggregated$knownProductsView, config, perProduct),
					A2($author$project$Demand$Aggregated$unknownProductsView, config, perUnknownProduct))));
	});
var $author$project$Lists$Ride$List$summaryView = F2(
	function (config, aggregatedOrders) {
		return A2(
			$author$project$Demand$Aggregated$view,
			{
				h4: 0,
				eT: _List_fromArray(
					[
						$author$project$Demand$Aggregated$ProductCode,
						$author$project$Demand$Aggregated$ProductName,
						$author$project$Demand$Aggregated$Total,
						$author$project$Demand$Aggregated$Packs($author$project$Lists$Ride$List$bundleConfig)
					]),
				df: config.df
			},
			aggregatedOrders);
	});
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $author$project$Lists$Ride$List$title = _Utils_Tuple2(
	A2(
		$elm$html$Html$h2,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ride-summary-title')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Ontvangstmasker')
			])),
	1);
var $author$project$Lists$Ride$List$coverView = F2(
	function (config, _v0) {
		var rideItself = _v0.nw;
		var stops = _v0.nW;
		var summary = A3(
			$elm$core$List$foldl,
			function (_v1) {
				var stopOrders = _v1.b;
				return $author$project$Demand$Aggregated$combine(stopOrders);
			},
			rideItself.b,
			stops);
		return A2(
			$author$project$Print$SizedHtml$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ride-summary')
				]),
			_List_fromArray(
				[
					$author$project$Lists$Ride$List$title,
					$author$project$Lists$Ride$List$numberOfStopsView(stops),
					A2($author$project$Lists$Ride$List$summaryView, config, summary),
					A2($author$project$Lists$Ride$List$massView, config, summary)
				]));
	});
var $author$project$Print$SizedHtml$article = F2(
	function (attrs, items) {
		return A2(
			$author$project$Print$SizedHtml$withSize,
			A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$List$maximum(
					A2($elm$core$List$map, $elm$core$Tuple$second, items))),
			A2(
				$elm$html$Html$article,
				attrs,
				A2($elm$core$List$map, $elm$core$Tuple$first, items)));
	});
var $icidasset$elm_material_icons$Material$Icons$directions_car = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z')
				]),
			_List_Nil)
		]));
var $author$project$Print$SizedHtml$div = F2(
	function (attrs, items) {
		return A2(
			$author$project$Print$SizedHtml$withSize,
			$elm$core$List$sum(
				A2($elm$core$List$map, $elm$core$Tuple$second, items)),
			A2(
				$elm$html$Html$div,
				attrs,
				A2($elm$core$List$map, $elm$core$Tuple$first, items)));
	});
var $icidasset$elm_material_icons$Material$Icons$Types$Color = function (a) {
	return {$: 0, a: a};
};
var $avh4$elm_color$Color$RgbaSpace = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $avh4$elm_color$Color$black = A4($avh4$elm_color$Color$RgbaSpace, 0 / 255, 0 / 255, 0 / 255, 1.0);
var $author$project$Print$Palette$fontColor = $avh4$elm_color$Color$black;
var $author$project$Print$Palette$iconFor = function (icon) {
	return icon(
		$icidasset$elm_material_icons$Material$Icons$Types$Color($author$project$Print$Palette$fontColor));
};
var $author$project$Demand$ProductDict$filter = $timo_weike$generic_collections$ManualDict$filter;
var $author$project$Demand$ProductDict$isEmpty = $timo_weike$generic_collections$ManualDict$isEmpty;
var $author$project$Demand$TypeDict$isEmpty = $timo_weike$generic_collections$ManualDict$isEmpty;
var $author$project$Demand$Aggregated$isEmpty = function (_v0) {
	var perProduct = _v0.S;
	var perUnknownProduct = _v0.T;
	return $author$project$Demand$ProductDict$isEmpty(
		A2(
			$author$project$Demand$ProductDict$filter,
			F2(
				function (_v1, _v2) {
					var amountPerType = _v2.aZ;
					return !$author$project$Demand$TypeDict$isEmpty(amountPerType);
				}),
			perProduct)) && $elm$core$Dict$isEmpty(
		A2(
			$elm$core$Dict$filter,
			F2(
				function (_v3, amountPerType) {
					return !$author$project$Demand$TypeDict$isEmpty(amountPerType);
				}),
			perUnknownProduct));
};
var $author$project$Print$SizedHtml$none = _Utils_Tuple2(
	$elm$html$Html$text(''),
	0);
var $author$project$Demand$Aggregated$Extra = {$: 5};
var $author$project$Demand$Aggregated$Sale = {$: 4};
var $author$project$Demand$Aggregated$Subscription = {$: 3};
var $author$project$Lists$Ride$List$stopSummaryView = F2(
	function (config, aggregatedOrders) {
		return A2(
			$author$project$Demand$Aggregated$view,
			{
				h4: 0,
				eT: _List_fromArray(
					[
						$author$project$Demand$Aggregated$ProductCode,
						$author$project$Demand$Aggregated$Total,
						$author$project$Demand$Aggregated$Packs($author$project$Lists$Ride$List$bundleConfig),
						$author$project$Demand$Aggregated$Subscription,
						$author$project$Demand$Aggregated$Sale,
						$author$project$Demand$Aggregated$Extra
					]),
				df: config.df
			},
			aggregatedOrders);
	});
var $author$project$Lists$Ride$List$rideItselfView = F2(
	function (config, _v0) {
		var name = _v0.a.ft;
		var details = _v0.a.lE;
		var aggregatedOrders = _v0.b;
		return $author$project$Demand$Aggregated$isEmpty(aggregatedOrders) ? $author$project$Print$SizedHtml$none : A2(
			$author$project$Print$SizedHtml$article,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ride-info')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Print$SizedHtml$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('cluster-header')
						]),
					_Utils_ap(
						_List_fromArray(
							[
								_Utils_Tuple2(
								$author$project$Print$Palette$iconFor(
									$icidasset$elm_material_icons$Material$Icons$directions_car(18)),
								1),
								_Utils_Tuple2(
								A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(name)
										])),
								1)
							]),
						A2(
							$elm$core$List$map,
							function (n) {
								return _Utils_Tuple2(
									A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(n)
											])),
									1);
							},
							details))),
					A2($author$project$Lists$Ride$List$stopSummaryView, config, aggregatedOrders)
				]));
	});
var $author$project$Lists$Ride$List$addressView = F2(
	function (instructions, _v0) {
		var street = _v0.b5;
		var houseNumber = _v0.bs;
		var zipCode = _v0.cT;
		var municipal = _v0.bU;
		return _Utils_Tuple2(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('cluster-address')
					]),
				$elm_community$maybe_extra$Maybe$Extra$values(
					_List_fromArray(
						[
							$elm$core$Maybe$Just(
							A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										street + (' ' + $author$project$Address$Address$houseNumberView(houseNumber)))
									]))),
							$elm$core$Maybe$Just(
							A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(zipCode + (' ' + municipal))
									]))),
							A2($elm$core$Maybe$map, $elm$html$Html$text, instructions)
						]))),
			3 + A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				0,
				$elm$core$Basics$always(1),
				instructions));
	});
var $icidasset$elm_material_icons$Material$Icons$location_on = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z')
				]),
			_List_Nil)
		]));
var $author$project$Lists$Ride$List$infoView = function (_v0) {
	var name = _v0.ft;
	var instructions = _v0.fl;
	var address = _v0.f1;
	var details = _v0.lE;
	return A2(
		$author$project$Print$SizedHtml$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('cluster-header')
			]),
		_Utils_ap(
			$elm_community$maybe_extra$Maybe$Extra$values(
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						_Utils_Tuple2(
							$author$project$Print$Palette$iconFor(
								$icidasset$elm_material_icons$Material$Icons$location_on(18)),
							1)),
						$elm$core$Maybe$Just(
						_Utils_Tuple2(
							A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(name)
									])),
							1)),
						A2(
						$elm$core$Maybe$map,
						$author$project$Lists$Ride$List$addressView(instructions),
						address)
					])),
			A2(
				$elm$core$List$map,
				function (n) {
					return _Utils_Tuple2(
						A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(n)
								])),
						1);
				},
				details)));
};
var $author$project$Lists$Ride$List$stopView = F2(
	function (config, _v0) {
		var info = _v0.a;
		var aggregatedOrders = _v0.b;
		return A2(
			$author$project$Print$SizedHtml$article,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('stop-info')
				]),
			_List_fromArray(
				[
					$author$project$Lists$Ride$List$infoView(info),
					A2($author$project$Lists$Ride$List$stopSummaryView, config, aggregatedOrders)
				]));
	});
var $author$project$Lists$Ride$List$view = F3(
	function (config, header, rideList) {
		var rideItself = rideList.nw;
		var stops = rideList.nW;
		return A3(
			$author$project$Print$Document$toHtml,
			config.nl,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('cluster-ride')
				]),
			A2(
				$author$project$Print$Document$addMultiple,
				A2(
					$elm$core$List$map,
					$author$project$Lists$Ride$List$stopView(config),
					stops),
				A2(
					$author$project$Print$Document$addSizedHtml,
					A2($author$project$Lists$Ride$List$rideItselfView, config, rideItself),
					A2(
						$author$project$Print$Document$addSizedHtml,
						A2($author$project$Lists$Ride$List$coverView, config, rideList),
						A2($author$project$Print$Document$init, $author$project$Print$Document$defaultPageSize, header)))));
	});
var $author$project$Lists$RouteDetail$Deliverer$supplyItemsToPrintItem = F9(
	function (distributionPoint, date, products, orders, demandSummaryBySubDPId, complaints, sequences, parents, item) {
		var suppliesView = function (supplies) {
			return A2(
				$elm$core$List$concatMap,
				A8(
					$author$project$Lists$RouteDetail$Deliverer$supplyItemsToPrintItem,
					distributionPoint,
					date,
					products,
					orders,
					demandSummaryBySubDPId,
					complaints,
					sequences,
					A2($elm$core$List$cons, item, parents)),
				supplies);
		};
		var sequenceOf = F2(
			function (deliverer, segments) {
				return A3(
					$author$project$Sequence$Sequence$findSequence,
					sequences,
					$author$project$Deliverer$Deliverer$idFromTyped(deliverer),
					segments);
			});
		var selectedClusters = A2(
			$elm$core$List$map,
			function (c) {
				return {H: c, gK: item};
			},
			$author$project$Plan$Supply$ownClustersOf(item));
		var clustersToPrintItems = function (deliverer) {
			return A2(
				$elm$core$List$map,
				A9(
					$author$project$Lists$RouteDetail$Deliverer$clusterToPrintItem,
					distributionPoint,
					date,
					products,
					orders,
					complaints,
					sequences,
					parents,
					item,
					$author$project$Deliverer$Deliverer$fromTyped(deliverer)),
				A2(
					$elm$core$List$map,
					function ($) {
						return $.H;
					},
					selectedClusters));
		};
		var _v0 = _Utils_Tuple2(selectedClusters, item);
		if (_v0.a.b) {
			switch (_v0.b.$) {
				case 0:
					var _v1 = _v0.a;
					var car = _v0.b.a;
					var stops = A2(
						$elm$core$List$concatMap,
						$elm$core$Basics$identity,
						A2(
							$elm$core$List$map,
							function ($) {
								return $.ef;
							},
							suppliesView(car.n0)));
					var sequence = A2(sequenceOf, car.bl, car.H.bb);
					var rideSummary = A3(
						$author$project$Lists$Ride$List$view,
						{df: 0, nl: 0},
						A4($author$project$Lists$Ride$List$headerForCluster, distributionPoint, date, car.bl, car.H),
						A8(
							$author$project$Lists$Ride$List$listFromCarItem,
							distributionPoint,
							date,
							products,
							car.H,
							car.bl,
							car.n0,
							A2($author$project$Lists$Ride$Summary$ordersForIncludingStops, orders, item),
							demandSummaryBySubDPId));
					var carRoute = clustersToPrintItems(car.bl);
					return _List_fromArray(
						[
							A7(
							$author$project$Lists$RouteDetail$Deliverer$PrintItem,
							distributionPoint,
							car.H,
							A2(
								$elm$core$List$cons,
								rideSummary,
								_Utils_ap(
									A2(
										$elm$core$List$concatMap,
										function ($) {
											return $.ef;
										},
										carRoute),
									stops)),
							item,
							orders,
							sequence,
							true)
						]);
				case 1:
					var _v2 = _v0.a;
					var bike = _v0.b.a;
					return clustersToPrintItems(bike.bl);
				default:
					var _v3 = _v0.a;
					return _List_Nil;
			}
		} else {
			if (!_v0.b.$) {
				var car = _v0.b.a;
				var sequence = A2(sequenceOf, car.bl, car.H.bb);
				return _List_fromArray(
					[
						A7(
						$author$project$Lists$RouteDetail$Deliverer$PrintItem,
						distributionPoint,
						car.H,
						A2(
							$elm$core$List$concatMap,
							$elm$core$Basics$identity,
							A2(
								$elm$core$List$map,
								function ($) {
									return $.ef;
								},
								suppliesView(car.n0))),
						item,
						orders,
						sequence,
						true)
					]);
			} else {
				return _List_Nil;
			}
		}
	});
var $author$project$Lists$RouteDetail$Deliverer$routeDetailToPrintItems = F2(
	function (date, _v0) {
		var distributionPoint = _v0.bn;
		var items = _v0.gL;
		var orders = _v0.Y;
		var subOrders = _v0.hx;
		var products = _v0.bu;
		var deliverers = _v0.e4;
		var complaints = _v0.m;
		var sequences = _v0.hm;
		var supplyItems = $author$project$Plan$Supply$removeEmptyClusters(items).a;
		var demandSummaryBySubDPId = $author$project$DistributionPoint$IdDict$fromList(
			A2(
				$elm$core$List$map,
				function (s) {
					return _Utils_Tuple2(s.lK, s);
				},
				subOrders));
		var allOrders = _Utils_ap(
			orders,
			A3($author$project$Demand$Extra$orders, supplyItems, deliverers, products));
		return A2(
			$elm$core$List$concatMap,
			$elm$core$Basics$identity,
			A2(
				$elm$core$List$map,
				A8($author$project$Lists$RouteDetail$Deliverer$supplyItemsToPrintItem, distributionPoint, date, products, allOrders, demandSummaryBySubDPId, complaints, sequences, _List_Nil),
				supplyItems));
	});
var $author$project$Lists$RouteDetail$Deliverer$PrintItemId = F2(
	function (distributionPoint, cluster) {
		return {H: cluster, bn: distributionPoint};
	});
var $author$project$Lists$RouteDetail$Deliverer$toBase = function (model) {
	switch (model.$) {
		case 0:
			var base = model.a;
			return base;
		case 1:
			var date = model.a.lx;
			var calendarState = model.a.r;
			var display = model.a.N;
			var printItems = model.a.dn;
			var routes = model.a.fL;
			var uncheckedPrintItem = function (_v5) {
				var checked = _v5.lc;
				return !checked;
			};
			var idOfPrintItem = function (_v4) {
				var distributionPoint = _v4.bn;
				var cluster = _v4.H;
				return A2($author$project$Lists$RouteDetail$Deliverer$PrintItemId, distributionPoint, cluster);
			};
			var _v1 = function () {
				if ((!display.$) && (!display.a.$)) {
					var p = display.a.a;
					var _v3 = A2(
						$elm_community$list_extra$List$Extra$findIndex,
						$elm$core$Basics$eq(p.bx),
						routes);
					if (!_v3.$) {
						var i = _v3.a;
						return _Utils_Tuple2(
							$elm$core$Maybe$Just(i),
							$elm$core$Maybe$Just(p.ba));
					} else {
						return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
					}
				} else {
					return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
				}
			}();
			var c = _v1.a;
			var page = _v1.b;
			return {
				r: calendarState,
				H: c,
				lx: date,
				N: display,
				cv: page,
				cO: A2(
					$elm$core$List$map,
					idOfPrintItem,
					A2($elm$core$List$filter, uncheckedPrintItem, printItems))
			};
		case 2:
			var base = model.a;
			return base;
		default:
			var base = model.a;
			return base;
	}
};
var $author$project$Lists$RouteDetail$Route$Bike = function (a) {
	return {$: 0, a: a};
};
var $author$project$Lists$RouteDetail$Route$Car = function (a) {
	return {$: 1, a: a};
};
var $author$project$Lists$RouteDetail$Route$FromDistributionPoint = {$: 0};
var $author$project$Lists$RouteDetail$Route$SubDP = function (a) {
	return {$: 2, a: a};
};
var $author$project$Lists$RouteDetail$Route$ToAddress = function (a) {
	return {$: 2, a: a};
};
var $author$project$Lists$RouteDetail$Route$ToUnknownAddress = function (a) {
	return {$: 1, a: a};
};
var $author$project$Demand$Demand$complaintToAddress = function (complaint) {
	return {h8: 0, bs: complaint.bs, i3: $elm$core$Maybe$Nothing, bU: complaint.bU, b5: complaint.b5, cT: ''};
};
var $author$project$Address$Address$toOrder = F2(
	function (a1, a2) {
		return (!_Utils_eq(a1.bU, a2.bU)) ? A2($elm$core$Basics$compare, a1.bU, a2.bU) : ((!_Utils_eq(a1.b5, a2.b5)) ? A2($elm$core$Basics$compare, a1.b5, a2.b5) : A2(
			$elm$core$Basics$compare,
			$author$project$Address$Address$houseNumberView(a1.bs),
			$author$project$Address$Address$houseNumberView(a2.bs)));
	});
var $author$project$Lists$RouteDetail$Route$toStops = F2(
	function (complaints, orders) {
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var o = _v0.a;
				var r = _v0.b;
				return {
					f1: o.f1,
					dX: A2(
						$elm_community$list_extra$List$Extra$find,
						function (c) {
							return 1 === A2(
								$author$project$Address$Address$toOrder,
								o.f1,
								$author$project$Demand$Demand$complaintToAddress(c));
						},
						complaints),
					lB: o.lB,
					Y: A2($elm$core$List$cons, o, r)
				};
			},
			A2(
				$elm_community$list_extra$List$Extra$groupWhile,
				F2(
					function (o1, o2) {
						return 1 === A2($author$project$Address$Address$toOrder, o1.f1, o2.f1);
					}),
				orders));
	});
var $author$project$Demand$ProductDict$toList = $timo_weike$generic_collections$ManualDict$toList;
var $author$project$Demand$Aggregated$totalsByProduct = function (_v0) {
	var perProduct = _v0.S;
	var perUnknownProduct = _v0.T;
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$mapSecond(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.bD;
				},
				function ($) {
					return $.jJ;
				})),
		$author$project$Demand$ProductDict$toList(perProduct));
};
var $author$project$Demand$Aggregated$totalsByUnknownProduct = function (_v0) {
	var perUnknownProduct = _v0.T;
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$mapSecond(
			A2($elm$core$Basics$composeR, $author$project$Demand$TypeDict$values, $elm$core$List$sum)),
		$elm$core$Dict$toList(perUnknownProduct));
};
var $author$project$Lists$RouteDetail$Deliverer$toRoute = F8(
	function (distributionPoint, date, products, orders, complaints, sequences, parents, item) {
		var routeDetail = F2(
			function (deliverer, segments) {
				var sequence = A3(
					$author$project$Sequence$Sequence$findSequence,
					sequences,
					$author$project$Deliverer$Deliverer$idFromTyped(deliverer),
					segments);
				var sequenceItems = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.gL;
						},
						sequence));
				var filteredOrders = A2(
					$elm$core$List$concatMap,
					function ($) {
						return $.Y;
					},
					A2($author$project$DistributionPoint$DistributionPoint$filterOnSegments, orders, segments));
				var summary = A2($author$project$Demand$Aggregated$fromOrders, products, filteredOrders);
				var filteredComplaints = A2($author$project$DistributionPoint$DistributionPoint$filterOnSegments, complaints, segments);
				return $author$project$Lists$RouteDetail$Route$Bike(
					{
						bl: $author$project$Deliverer$Deliverer$reference(deliverer),
						bb: A2(
							$elm$core$List$map,
							A2($elm$core$Basics$composeR, $author$project$DistributionPoint$DistributionPoint$segmentInfo, $author$project$Reference$from),
							A2($author$project$DistributionPoint$DistributionPoint$findSegmentsOnId, distributionPoint, segments)),
						nW: A2(
							$author$project$Lists$RouteDetail$Route$toStops,
							filteredComplaints,
							A2(
								$elm$core$List$sortBy,
								$author$project$Sorting$Orders$onRoute(sequenceItems),
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.lB;
										},
										$elm$core$Basics$neq(2)),
									filteredOrders))),
						kj: _Utils_Tuple2(
							$author$project$Demand$Aggregated$totalsByProduct(summary),
							$author$project$Demand$Aggregated$totalsByUnknownProduct(summary)),
						n$: function () {
							var _v1 = _Utils_Tuple2(
								$elm$core$List$head(parents),
								A2(
									$author$project$Deliverer$Deliverer$locationOf,
									date,
									$author$project$Deliverer$Deliverer$fromTyped(deliverer)));
							if ((!_v1.a.$) && (!_v1.a.a.$)) {
								if (!_v1.b.$) {
									var cluster = _v1.a.a.a.H;
									var location = _v1.b.a;
									return $author$project$Lists$RouteDetail$Route$ToAddress(
										_Utils_Tuple2(
											A2(
												$elm$core$List$map,
												A2($elm$core$Basics$composeR, $author$project$DistributionPoint$DistributionPoint$segmentInfo, $author$project$Reference$from),
												A2($author$project$DistributionPoint$DistributionPoint$findSegmentsOnId, distributionPoint, cluster.bb)),
											location));
								} else {
									var cluster = _v1.a.a.a.H;
									var _v2 = _v1.b;
									return $author$project$Lists$RouteDetail$Route$ToUnknownAddress(
										A2(
											$elm$core$List$map,
											A2($elm$core$Basics$composeR, $author$project$DistributionPoint$DistributionPoint$segmentInfo, $author$project$Reference$from),
											A2($author$project$DistributionPoint$DistributionPoint$findSegmentsOnId, distributionPoint, cluster.bb)));
								}
							} else {
								return $author$project$Lists$RouteDetail$Route$FromDistributionPoint;
							}
						}()
					});
			});
		switch (item.$) {
			case 1:
				var deliverer = item.a.bl;
				var clusters = item.a.k;
				return A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.bb;
						},
						routeDetail(deliverer)),
					clusters);
			case 0:
				var deliverer = item.a.bl;
				var cluster = item.a.H;
				return _List_fromArray(
					[
						$author$project$Lists$RouteDetail$Route$Car(
						{
							js: A2(routeDetail, deliverer, cluster.bb)
						})
					]);
			default:
				return _List_fromArray(
					[
						$author$project$Lists$RouteDetail$Route$SubDP(
						{})
					]);
		}
	});
var $author$project$Lists$RouteDetail$Deliverer$toRoutes = F2(
	function (date, _v0) {
		var distributionPoint = _v0.bn;
		var items = _v0.gL;
		var orders = _v0.Y;
		var subOrders = _v0.hx;
		var products = _v0.bu;
		var deliverers = _v0.e4;
		var complaints = _v0.m;
		var sequences = _v0.hm;
		var supplyItems = $author$project$Plan$Supply$removeEmptyClusters(items).a;
		var allOrders = _Utils_ap(
			orders,
			A3($author$project$Demand$Extra$orders, supplyItems, deliverers, products));
		return A2(
			$elm$core$List$concatMap,
			A7($author$project$Lists$RouteDetail$Deliverer$toRoute, distributionPoint, date, products, allOrders, complaints, sequences, _List_Nil),
			supplyItems);
	});
var $author$project$UI$Swipe$Down = 3;
var $author$project$UI$Swipe$Left = 0;
var $author$project$UI$Swipe$Right = 1;
var $author$project$UI$Swipe$Tap = 4;
var $author$project$UI$Swipe$Up = 2;
var $author$project$UI$Swipe$deltaY = function (gesture) {
	if (gesture.$ === 3) {
		var from = gesture.a.l2;
		var to = gesture.a.oj;
		return $elm$core$Maybe$Just(to.bg - from.bg);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$UI$Swipe$isSwipeType = F2(
	function (delta, predicate) {
		return A2(
			$elm$core$Basics$composeR,
			delta,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map(predicate),
				$elm$core$Maybe$withDefault(false)));
	});
var $author$project$UI$Swipe$isDownSwipe = function (sensitivity) {
	return A2(
		$author$project$UI$Swipe$isSwipeType,
		$author$project$UI$Swipe$deltaY,
		function (dY) {
			return _Utils_cmp(dY, sensitivity) > -1;
		});
};
var $author$project$UI$Swipe$deltaX = function (gesture) {
	if (gesture.$ === 3) {
		var from = gesture.a.l2;
		var to = gesture.a.oj;
		return $elm$core$Maybe$Just(to.ay - from.ay);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$UI$Swipe$isLeftSwipe = function (sensitivity) {
	return A2(
		$author$project$UI$Swipe$isSwipeType,
		$author$project$UI$Swipe$deltaX,
		function (dX) {
			return _Utils_cmp(dX, -sensitivity) < 1;
		});
};
var $author$project$UI$Swipe$isRightSwipe = function (sensitivity) {
	return A2(
		$author$project$UI$Swipe$isSwipeType,
		$author$project$UI$Swipe$deltaX,
		function (dX) {
			return _Utils_cmp(dX, sensitivity) > -1;
		});
};
var $author$project$UI$Swipe$isTap = function (gesture) {
	if (gesture.$ === 4) {
		return true;
	} else {
		return false;
	}
};
var $author$project$UI$Swipe$isUpSwipe = function (sensitivity) {
	return A2(
		$author$project$UI$Swipe$isSwipeType,
		$author$project$UI$Swipe$deltaY,
		function (dY) {
			return _Utils_cmp(dY, -sensitivity) < 1;
		});
};
var $author$project$UI$Swipe$toSwipeDirection = F2(
	function (sensitivity, gesture) {
		return A2($author$project$UI$Swipe$isLeftSwipe, sensitivity, gesture) ? $elm$core$Maybe$Just(0) : (A2($author$project$UI$Swipe$isRightSwipe, sensitivity, gesture) ? $elm$core$Maybe$Just(1) : (A2($author$project$UI$Swipe$isUpSwipe, sensitivity, gesture) ? $elm$core$Maybe$Just(2) : (A2($author$project$UI$Swipe$isDownSwipe, sensitivity, gesture) ? $elm$core$Maybe$Just(3) : ($author$project$UI$Swipe$isTap(gesture) ? $elm$core$Maybe$Just(4) : $elm$core$Maybe$Nothing))));
	});
var $author$project$Lists$RouteDetail$Deliverer$uncheckPrintItems = F2(
	function (uncheckedItems, printItems) {
		var contains = function (_v0) {
			var distributionPoint = _v0.bn;
			var cluster = _v0.H;
			return A2(
				$elm$core$List$any,
				function (c) {
					return _Utils_eq(
						$author$project$DistributionPoint$DistributionPoint$idOf(distributionPoint),
						$author$project$DistributionPoint$DistributionPoint$idOf(c.bn)) && _Utils_eq(cluster.bX, c.H.bX);
				},
				uncheckedItems);
		};
		return A3(
			$elm_community$list_extra$List$Extra$updateIf,
			contains,
			function (p) {
				return _Utils_update(
					p,
					{lc: false});
			},
			printItems);
	});
var $author$project$Sequence$Edit$NoImpact = {$: 0};
var $author$project$Sequence$Edit$SavedSequence = function (a) {
	return {$: 8, a: a};
};
var $author$project$Sequence$Edit$SequenceUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$UI$LeafletMap$ToBounds = function (a) {
	return {$: 2, a: a};
};
var $author$project$Sequence$Edit$WithMap = function (a) {
	return {$: 1, a: a};
};
var $author$project$Sequence$StreetPart$reverseDirection = function (direction) {
	if (!direction) {
		return 1;
	} else {
		return 0;
	}
};
var $author$project$Sequence$Edit$reverseItem = function (item) {
	return _Utils_update(
		item,
		{
			cg: $author$project$Sequence$StreetPart$reverseDirection(item.cg)
		});
};
var $author$project$Sequence$Edit$ensureAscending = function (sequenceItems) {
	return A2(
		$elm$core$List$map,
		function (item) {
			var _v0 = item.cg;
			if (!_v0) {
				return item;
			} else {
				return $author$project$Sequence$Edit$reverseItem(item);
			}
		},
		sequenceItems);
};
var $author$project$Sequence$Edit$join = F2(
	function (sequence, index) {
		var _v0 = _Utils_Tuple2(
			A2($elm_community$list_extra$List$Extra$getAt, index - 1, sequence.gL),
			A2($elm_community$list_extra$List$Extra$getAt, index, sequence.gL));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var itemToJoinInto = _v0.a.a;
			var joiningItem = _v0.b.a;
			var joinedItem = _Utils_update(
				itemToJoinInto,
				{
					aR: _Utils_ap(itemToJoinInto.aR, joiningItem.aR)
				});
			var itemsJoined = A2(
				$elm_community$list_extra$List$Extra$removeAt,
				index,
				A3($elm_community$list_extra$List$Extra$setAt, index - 1, joinedItem, sequence.gL));
			return $author$project$Sequence$Sequence$setJoinability(
				_Utils_update(
					sequence,
					{gL: itemsJoined}));
		} else {
			return sequence;
		}
	});
var $author$project$Sequence$Edit$moveSequence = F3(
	function (sequence, fromIndex, toIndex) {
		var _v0 = A2($elm_community$list_extra$List$Extra$getAt, fromIndex, sequence.gL);
		if (!_v0.$) {
			var sequenceItemToMove = _v0.a;
			var sequenceWithout = A2($elm_community$list_extra$List$Extra$remove, sequenceItemToMove, sequence.gL);
			var sequenceWithMovedItem = _Utils_ap(
				A2($elm$core$List$take, toIndex, sequenceWithout),
				A2(
					$elm$core$List$cons,
					sequenceItemToMove,
					A2($elm$core$List$drop, toIndex, sequenceWithout)));
			return $author$project$Sequence$Sequence$setJoinability(
				_Utils_update(
					sequence,
					{gL: sequenceWithMovedItem}));
		} else {
			return sequence;
		}
	});
var $author$project$Sequence$Edit$reverse = F2(
	function (sequence, index) {
		var _v0 = A2($elm_community$list_extra$List$Extra$getAt, index, sequence.gL);
		if (!_v0.$) {
			var sequenceItemToReverse = _v0.a;
			var sequenceWithReversedItem = A3(
				$elm_community$list_extra$List$Extra$setAt,
				index,
				$author$project$Sequence$Edit$reverseItem(sequenceItemToReverse),
				sequence.gL);
			return _Utils_update(
				sequence,
				{gL: sequenceWithReversedItem});
		} else {
			return sequence;
		}
	});
var $elm$json$Json$Encode$bool = _Json_wrap;
var $author$project$Sequence$StreetPart$encodeDirection = function (direction) {
	if (!direction) {
		return $elm$json$Json$Encode$string('Ascending');
	} else {
		return $elm$json$Json$Encode$string('Descending');
	}
};
var $author$project$Sequence$StreetPart$encodeStreetPart = function (_v0) {
	var zipCode = _v0.cT;
	var municipal = _v0.bU;
	var street = _v0.b5;
	var postalAddresses = _v0.fD;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'zipCode',
				$elm$json$Json$Encode$string(zipCode)),
				_Utils_Tuple2(
				'municipal',
				$elm$json$Json$Encode$string(municipal)),
				_Utils_Tuple2(
				'street',
				$elm$json$Json$Encode$string(street)),
				_Utils_Tuple2(
				'houses',
				A2(
					$elm$json$Json$Encode$list,
					$author$project$Address$Address$encodeHouseNumber,
					A2(
						$elm$core$List$map,
						function ($) {
							return $.bX;
						},
						postalAddresses)))
			]));
};
var $author$project$Sequence$Sequence$encodeItem = function (_v0) {
	var direction = _v0.cg;
	var cutPoint = _v0.e0;
	var streetParts = _v0.aR;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'direction',
				$author$project$Sequence$StreetPart$encodeDirection(direction)),
				_Utils_Tuple2(
				'cutPoint',
				$elm$json$Json$Encode$bool(cutPoint)),
				_Utils_Tuple2(
				'streetParts',
				A2($elm$json$Json$Encode$list, $author$project$Sequence$StreetPart$encodeStreetPart, streetParts))
			]));
};
var $author$project$Sequence$Sequence$encodeSequence = F2(
	function (date, _v0) {
		var delivererId = _v0.lA;
		var segmentIds = _v0.nH;
		var items = _v0.gL;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'delivererId',
					$author$project$Deliverer$Deliverer$encodeId(delivererId)),
					_Utils_Tuple2(
					'segmentIds',
					A2($elm$json$Json$Encode$list, $author$project$DistributionPoint$DistributionPoint$encodeSegmentId, segmentIds)),
					_Utils_Tuple2(
					'validOn',
					$author$project$Date$DeliveryDate$encode(date)),
					_Utils_Tuple2(
					'items',
					A2($elm$json$Json$Encode$list, $author$project$Sequence$Sequence$encodeItem, items))
				]));
	});
var $author$project$Sequence$Sequence$saveSequenceCmd = F4(
	function (token, toMsg, date, sequence) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['sequences']),
			_List_Nil);
		var body = $elm$http$Http$jsonBody(
			A2($author$project$Sequence$Sequence$encodeSequence, date, sequence));
		return A4($author$project$Api$Request$put, token, toMsg, uri, body);
	});
var $elm_community$list_extra$List$Extra$indexedFoldr = F3(
	function (func, acc, list) {
		var step = F2(
			function (x, _v0) {
				var i = _v0.a;
				var thisAcc = _v0.b;
				return _Utils_Tuple2(
					i - 1,
					A3(func, i, x, thisAcc));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(
				$elm$core$List$length(list) - 1,
				acc),
			list).b;
	});
var $author$project$Sequence$Edit$separate = F2(
	function (sequence, index) {
		var separateStep = F3(
			function (i, item, soFar) {
				if (_Utils_eq(i, index)) {
					var separatedItems = A2(
						$elm$core$List$map,
						function (p) {
							return A4(
								$author$project$Sequence$Sequence$Item,
								item.cg,
								2,
								false,
								_List_fromArray(
									[p]));
						},
						item.aR);
					return _Utils_ap(separatedItems, soFar);
				} else {
					return A2($elm$core$List$cons, item, soFar);
				}
			});
		return $author$project$Sequence$Sequence$setJoinability(
			_Utils_update(
				sequence,
				{
					gL: A3($elm_community$list_extra$List$Extra$indexedFoldr, separateStep, _List_Nil, sequence.gL)
				}));
	});
var $author$project$Sequence$StreetPart$firstNumberOf = function (_v0) {
	var postalAddresses = _v0.fD;
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.bX;
		},
		$elm$core$List$head(postalAddresses));
};
var $author$project$Sequence$Edit$firstNumberOf = function (sequenceItem) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Maybe$map(
					function ($) {
						return $.bX;
					}),
				A2($elm$core$List$map, $author$project$Sequence$StreetPart$firstNumberOf, sequenceItem.aR))));
};
var $author$project$Sequence$Edit$zipCodeOf = function (sequenceItem) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.cT;
			},
			$elm$core$List$head(sequenceItem.aR)));
};
var $author$project$Sequence$Edit$zipCodeHouseNumber = function (sequenceItem) {
	var zipCode = $author$project$Sequence$Edit$zipCodeOf(sequenceItem);
	var firstNumber = $author$project$Sequence$Edit$firstNumberOf(sequenceItem);
	return _Utils_Tuple2(zipCode, firstNumber);
};
var $author$project$Sequence$Edit$sortZipCodeHouseNumber = function (sequenceItems) {
	return A2($elm$core$List$sortBy, $author$project$Sequence$Edit$zipCodeHouseNumber, sequenceItems);
};
var $author$project$Sequence$Edit$toggleCut = F2(
	function (sequence, index) {
		var toggled = function (item) {
			return _Utils_update(
				item,
				{e0: !item.e0});
		};
		return _Utils_update(
			sequence,
			{
				gL: A3($elm_community$list_extra$List$Extra$updateAt, index, toggled, sequence.gL)
			});
	});
var $ir4y$elm_dnd$DnD$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var dragMeta = msg.a;
				var xy = msg.b;
				return $elm$core$Maybe$Just(
					{e7: dragMeta, d4: $elm$core$Maybe$Nothing, fC: xy});
			case 1:
				var xy = msg.a;
				return A2(
					$elm$core$Maybe$map,
					function (d) {
						return _Utils_update(
							d,
							{fC: xy});
					},
					model);
			case 2:
				var xy = msg.a;
				return $elm$core$Maybe$Nothing;
			case 3:
				var dropMeta = msg.a;
				return A2(
					$elm$core$Maybe$map,
					function (d) {
						return _Utils_update(
							d,
							{
								d4: $elm$core$Maybe$Just(dropMeta)
							});
					},
					model);
			default:
				return A2(
					$elm$core$Maybe$map,
					function (d) {
						return _Utils_update(
							d,
							{d4: $elm$core$Maybe$Nothing});
					},
					model);
		}
	});
var $author$project$Sequence$Edit$update = F3(
	function (msg, share, edit) {
		var updateZoomTo = function (newBounds) {
			var _v2 = edit.dg;
			if (!_v2.$) {
				return edit;
			} else {
				var e = _v2.a;
				return _Utils_update(
					edit,
					{
						dg: $author$project$Sequence$Edit$WithMap(
							_Utils_update(
								e,
								{
									hN: $author$project$UI$LeafletMap$ToBounds(newBounds)
								}))
					});
			}
		};
		var updateSequence = function (s) {
			return _Utils_update(
				edit,
				{j0: s});
		};
		var updateDraggable = function (dnDMsg) {
			return _Utils_update(
				edit,
				{
					bo: A2($ir4y$elm_dnd$DnD$update, dnDMsg, edit.bo)
				});
		};
		var token = $author$project$Portal$Share$token(share);
		var withSequence = function (s) {
			return $author$project$Sequence$Edit$SequenceUpdated(
				_Utils_Tuple3(
					share,
					updateSequence(s),
					A5($author$project$Sequence$Sequence$saveSequenceCmd, token, $author$project$Sequence$Edit$SavedSequence, edit.lx, s, $author$project$Api$Request$Untracked)));
		};
		var sequence = edit.j0;
		var noChange = $author$project$Sequence$Edit$NoImpact;
		switch (msg.$) {
			case 0:
				return noChange;
			case 1:
				var dnDMsg = msg.a;
				return $author$project$Sequence$Edit$SequenceUpdated(
					_Utils_Tuple3(
						share,
						updateDraggable(dnDMsg),
						$elm$core$Platform$Cmd$none));
			case 2:
				var toIndex = msg.a;
				var _v1 = msg.b;
				var from = _v1.a;
				return (!_Utils_eq(toIndex, from)) ? withSequence(
					A3($author$project$Sequence$Edit$moveSequence, sequence, from, toIndex)) : noChange;
			case 3:
				var index = msg.a;
				return withSequence(
					A2($author$project$Sequence$Edit$reverse, sequence, index));
			case 4:
				var index = msg.a;
				return withSequence(
					A2($author$project$Sequence$Edit$join, sequence, index));
			case 5:
				var index = msg.a;
				return withSequence(
					A2($author$project$Sequence$Edit$separate, sequence, index));
			case 6:
				var index = msg.a;
				return withSequence(
					A2($author$project$Sequence$Edit$toggleCut, sequence, index));
			case 7:
				return withSequence(
					_Utils_update(
						sequence,
						{
							gL: $author$project$Sequence$Edit$sortZipCodeHouseNumber(
								$author$project$Sequence$Edit$ensureAscending(sequence.gL))
						}));
			case 8:
				if (!msg.a.$) {
					return noChange;
				} else {
					var error = msg.a.a;
					return $author$project$Sequence$Edit$SequenceUpdated(
						_Utils_Tuple3(
							A2($author$project$Portal$Share$withHttpError, error, share),
							edit,
							$elm$core$Platform$Cmd$none));
				}
			case 9:
				var newBounds = msg.a;
				return $author$project$Sequence$Edit$SequenceUpdated(
					_Utils_Tuple3(
						share,
						updateZoomTo(newBounds),
						$elm$core$Platform$Cmd$none));
			case 10:
				return noChange;
			default:
				return noChange;
		}
	});
var $author$project$Portal$WakeLock$wakeLock = _Platform_outgoingPort(
	'wakeLock',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Portal$WakeLock$wakeLockRelease = _Platform_outgoingPort(
	'wakeLockRelease',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Lists$RouteDetail$Deliverer$whenWaiting = function (msg) {
	switch (msg.$) {
		case 9:
			return 0;
		case 0:
			return 0;
		case 1:
			return 0;
		case 2:
			return 0;
		case 4:
			return 0;
		case 3:
			return 1;
		case 5:
			return 1;
		case 6:
			return 0;
		case 7:
			return 0;
		default:
			if (msg.a.$ === 11) {
				var _v1 = msg.a;
				return 1;
			} else {
				return 0;
			}
	}
};
var $author$project$Lists$RouteDetail$Deliverer$withCalendarState = F2(
	function (calendar, model) {
		switch (model.$) {
			case 0:
				var base = model.a;
				return $author$project$Lists$RouteDetail$Deliverer$Loading(
					_Utils_update(
						base,
						{r: calendar}));
			case 1:
				var base = model.a;
				return $author$project$Lists$RouteDetail$Deliverer$Loaded(
					_Utils_update(
						base,
						{r: calendar}));
			case 2:
				var base = model.a;
				return $author$project$Lists$RouteDetail$Deliverer$NoOrders(
					_Utils_update(
						base,
						{r: calendar}));
			default:
				var base = model.a;
				return $author$project$Lists$RouteDetail$Deliverer$Failed(
					_Utils_update(
						base,
						{r: calendar}));
		}
	});
var $author$project$Portal$Share$withHeader = F2(
	function (header, _v0) {
		var model = _v0;
		var currentUI = model.dI;
		return _Utils_update(
			model,
			{
				dI: _Utils_update(
					currentUI,
					{l9: header})
			});
	});
var $author$project$Lists$RouteDetail$Deliverer$update = F3(
	function (msg, share, model) {
		var withoutAction = function (toAction) {
			return $author$project$Portal$Return$withoutAction(
				toAction(
					$author$project$Lists$RouteDetail$Deliverer$toBase(model).lx));
		};
		var withShare = F2(
			function (s, _v33) {
				var m = _v33.b;
				var c = _v33.c;
				return A2(
					$author$project$Portal$Return$withShare,
					s,
					_Utils_Tuple2(m, c));
			});
		var to = function (route) {
			return _Utils_Tuple3(
				A2($author$project$Portal$Share$withNewRoute, route, share),
				model,
				$elm$core$Platform$Cmd$none);
		};
		var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		var onLoaded = function (f) {
			switch (model.$) {
				case 1:
					var loaded = model.a;
					return f(loaded);
				case 0:
					return noChange;
				case 2:
					return noChange;
				default:
					return noChange;
			}
		};
		var modelChange = function (m) {
			return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
		};
		var withUpdatedDisplay = function (f) {
			return onLoaded(
				function (m) {
					return modelChange(
						$author$project$Lists$RouteDetail$Deliverer$Loaded(
							_Utils_update(
								m,
								{
									N: f(m.N)
								})));
				});
		};
		var withDisplay = function (d) {
			return withUpdatedDisplay(
				$elm$core$Basics$always(d));
		};
		var withMobile = F2(
			function (d, s) {
				return withUpdatedDisplay(
					$elm$core$Basics$always(
						A2(
							$author$project$Lists$RouteDetail$Deliverer$Mobile,
							$elm$core$Maybe$Just(d),
							s)));
			});
		var err = F3(
			function (toAction, error, m) {
				return _Utils_Tuple3(
					A2(
						$author$project$Portal$Share$withHttpError,
						error,
						A2(
							$author$project$Portal$Share$withoutWaitingAction,
							toAction(
								$author$project$Lists$RouteDetail$Deliverer$toBase(model).lx),
							share)),
					m,
					$elm$core$Platform$Cmd$none);
			});
		var _v0 = $author$project$Lists$RouteDetail$Deliverer$toBase(model);
		var date = _v0.lx;
		var calendarState = _v0.r;
		var display = _v0.N;
		var uncheckedItems = _v0.cO;
		var cluster = _v0.H;
		var page = _v0.cv;
		var activeStopKey = function (c) {
			return $elm$core$String$concat(
				_List_fromArray(
					[
						'route-detail-guided-',
						$author$project$Date$DeliveryDate$encodeForUrl(date),
						'-',
						$elm$core$String$fromInt(c)
					]));
		};
		if (A3($author$project$Portal$Share$allowed, $author$project$Lists$RouteDetail$Deliverer$whenWaiting, msg, share) === 1) {
			return noChange;
		} else {
			switch (msg.$) {
				case 9:
					return noChange;
				case 1:
					var key = msg.a.iY;
					var value = msg.a.kt;
					if ((!display.$) && (!display.a.$)) {
						var routeView = display.a.a;
						var s = display.b;
						return A2(
							withMobile,
							_Utils_update(
								routeView,
								{
									_: $elm$core$String$toInt(value)
								}),
							s);
					} else {
						return noChange;
					}
				case 0:
					if (!msg.a.$) {
						var routeDetails = msg.a.a;
						var routes = A2(
							$elm$core$List$concatMap,
							$author$project$Lists$RouteDetail$Deliverer$toRoutes(
								$author$project$Date$DeliveryDate$toDate(date)),
							routeDetails);
						var route = A2(
							$elm$core$Maybe$andThen,
							function (c) {
								return A2($elm_community$list_extra$List$Extra$getAt, c, routes);
							},
							cluster);
						var newDisplay = function () {
							var _v3 = _Utils_Tuple2(
								$author$project$Portal$Share$device(share).le,
								_Utils_Tuple2(route, page));
							if (((!_v3.a) && (!_v3.b.a.$)) && (!_v3.b.b.$)) {
								var _v4 = _v3.a;
								var _v5 = _v3.b;
								var r = _v5.a.a;
								var p = _v5.b.a;
								return A2(
									$author$project$Lists$RouteDetail$Deliverer$Mobile,
									$elm$core$Maybe$Just(
										{_: $elm$core$Maybe$Nothing, bx: r, ba: p}),
									$author$project$UI$Swipe$blanco);
							} else {
								return display;
							}
						}();
						return function () {
							if (!cluster.$) {
								var c = cluster.a;
								return $author$project$Portal$Return$withBackgroundCommand(
									$author$project$Ports$rememberedValue(
										activeStopKey(c)));
							} else {
								return $elm$core$Basics$identity;
							}
						}()(
							A2(
								withoutAction,
								$author$project$Lists$RouteDetail$Deliverer$loadingRouteDetail,
								modelChange(
									$author$project$Lists$RouteDetail$Deliverer$Loaded(
										{
											r: calendarState,
											lx: date,
											N: newDisplay,
											dn: A2(
												$author$project$Lists$RouteDetail$Deliverer$uncheckPrintItems,
												uncheckedItems,
												A2(
													$elm$core$List$concatMap,
													$author$project$Lists$RouteDetail$Deliverer$routeDetailToPrintItems(date),
													routeDetails)),
											hh: routeDetails,
											fL: routes
										}))));
					} else {
						if ((msg.a.a.$ === 3) && (msg.a.a.a === 404)) {
							return A2(
								withoutAction,
								$author$project$Lists$RouteDetail$Deliverer$loadingRouteDetail,
								modelChange(
									$author$project$Lists$RouteDetail$Deliverer$NoOrders(
										{r: calendarState, H: cluster, lx: date, N: display, cv: page, cO: _List_Nil})));
						} else {
							var error = msg.a.a;
							return A3(
								err,
								$author$project$Lists$RouteDetail$Deliverer$loadingRouteDetail,
								error,
								$author$project$Lists$RouteDetail$Deliverer$Failed(
									{r: calendarState, H: cluster, lx: date, N: display, cv: page, cO: _List_Nil}));
						}
					}
				case 2:
					var subHeaderMsg = msg.a;
					var _v7 = A5($author$project$Portal$Subheader$update, subHeaderMsg, share, $elm$core$Maybe$Nothing, date, calendarState);
					switch (_v7.a.$) {
						case 0:
							var _v8 = _v7.a;
							var _v9 = _v7.b;
							var s = _v9.a;
							var m = _v9.b;
							var cmd = _v9.c;
							return _Utils_Tuple3(
								s,
								A2($author$project$Lists$RouteDetail$Deliverer$withCalendarState, m, model),
								A2($elm$core$Platform$Cmd$map, $author$project$Lists$RouteDetail$Deliverer$GotSubHeaderMsg, cmd));
						case 1:
							var dateToOpen = _v7.a.a;
							return to(
								$author$project$Portal$Route$DelivererRouteDetail(dateToOpen));
						case 2:
							var dateToOpen = _v7.a.a;
							return to(
								$author$project$Portal$Route$DelivererRouteDetail(dateToOpen));
						default:
							return noChange;
					}
				case 4:
					return withUpdatedDisplay(
						$author$project$Lists$RouteDetail$Deliverer$updateDisplay(
							$author$project$Portal$Share$device(share)));
				case 3:
					var routeMsg = msg.a;
					var _v10 = _Utils_Tuple3(display, routeMsg, cluster);
					_v10$10:
					while (true) {
						switch (_v10.b.$) {
							case 0:
								var _v11 = _v10.b;
								var r = _v11.b;
								return A2(
									withMobile,
									{_: $elm$core$Maybe$Nothing, bx: r, ba: 4},
									$author$project$UI$Swipe$blanco);
							case 1:
								var _v12 = _v10.b;
								var r = _v12.b;
								return A2(
									withMobile,
									{_: $elm$core$Maybe$Nothing, bx: r, ba: 3},
									$author$project$UI$Swipe$blanco);
							case 2:
								var _v13 = _v10.b;
								var r = _v13.b;
								return A2(
									withMobile,
									{_: $elm$core$Maybe$Nothing, bx: r, ba: 0},
									$author$project$UI$Swipe$blanco);
							case 3:
								var _v14 = _v10.b;
								var r = _v14.b;
								return A2(
									withMobile,
									{_: $elm$core$Maybe$Nothing, bx: r, ba: 1},
									$author$project$UI$Swipe$blanco);
							case 9:
								if ((!_v10.a.$) && (!_v10.a.a.$)) {
									var _v15 = _v10.a;
									var selectedRouteView = _v15.a.a;
									var s = _v15.b;
									var index = _v10.b.a;
									return A2(
										withMobile,
										_Utils_update(
											selectedRouteView,
											{
												_: $elm$core$Maybe$Just(index)
											}),
										s);
								} else {
									break _v10$10;
								}
							case 6:
								if ((!_v10.a.$) && (!_v10.a.a.$)) {
									var _v16 = _v10.a;
									var selectedRouteView = _v16.a.a;
									var s = _v16.b;
									var _v17 = _v10.b;
									return A2(
										$author$project$Portal$Return$withBackgroundCommand,
										$author$project$Portal$WakeLock$wakeLock(0),
										A2(
											withShare,
											A2($author$project$Portal$Share$withHeader, 1, share),
											A2(
												withMobile,
												_Utils_update(
													selectedRouteView,
													{ba: 2}),
												s)));
								} else {
									break _v10$10;
								}
							case 7:
								if ((!_v10.a.$) && (!_v10.a.a.$)) {
									var _v18 = _v10.a;
									var selectedRouteView = _v18.a.a;
									var s = _v18.b;
									var _v19 = _v10.b;
									return A2(
										$author$project$Portal$Return$withBackgroundCommand,
										$author$project$Portal$WakeLock$wakeLockRelease(0),
										A2(
											withShare,
											A2($author$project$Portal$Share$withHeader, 0, share),
											A2(
												withMobile,
												_Utils_update(
													selectedRouteView,
													{ba: 1}),
												s)));
								} else {
									break _v10$10;
								}
							case 8:
								if ((!_v10.a.$) && (!_v10.a.a.$)) {
									var _v20 = _v10.a;
									var selectedRouteView = _v20.a.a;
									var s = _v20.b;
									var _v21 = _v10.b;
									return A2(
										withMobile,
										_Utils_update(
											selectedRouteView,
											{
												_: $elm$core$Maybe$Just(0)
											}),
										s);
								} else {
									break _v10$10;
								}
							case 4:
								if ((!_v10.a.$) && (!_v10.a.a.$)) {
									var _v22 = _v10.a;
									var selectedRouteView = _v22.a.a;
									var swipeState = _v22.b;
									var swipeEvent = _v10.b.a;
									return A2(
										withMobile,
										selectedRouteView,
										A2($author$project$UI$Swipe$record, swipeEvent, swipeState));
								} else {
									break _v10$10;
								}
							default:
								if (((!_v10.a.$) && (!_v10.a.a.$)) && (!_v10.c.$)) {
									var _v23 = _v10.a;
									var selectedRouteView = _v23.a.a;
									var swipeState = _v23.b;
									var swipeEvent = _v10.b.a;
									var c = _v10.c.a;
									var gesture = A2($author$project$UI$Swipe$record, swipeEvent, swipeState);
									var _v24 = _Utils_Tuple2(
										A2($author$project$UI$Swipe$toSwipeDirection, $author$project$UI$Swipe$defaultSensitivity, gesture),
										$author$project$Lists$RouteDetail$Deliverer$bikeRouteDetail(selectedRouteView.bx));
									_v24$2:
									while (true) {
										if (!_v24.a.$) {
											switch (_v24.a.a) {
												case 0:
													if (!_v24.b.$) {
														var _v25 = _v24.a.a;
														var stops = _v24.b.a.nW;
														var stop = A2($elm$core$Maybe$withDefault, 0, selectedRouteView._) + 1;
														var _v26 = A2($elm_community$list_extra$List$Extra$getAt, stop, stops);
														if (!_v26.$) {
															return A2(
																$author$project$Portal$Return$withBackgroundCommand,
																$author$project$Ports$rememberValue(
																	{
																		iY: activeStopKey(c),
																		kt: $elm$core$String$fromInt(stop)
																	}),
																A2(
																	withMobile,
																	_Utils_update(
																		selectedRouteView,
																		{
																			_: $elm$core$Maybe$Just(stop)
																		}),
																	$author$project$UI$Swipe$blanco));
														} else {
															return noChange;
														}
													} else {
														break _v24$2;
													}
												case 1:
													var _v27 = _v24.a.a;
													var stop = A2($elm$core$Maybe$withDefault, 0, selectedRouteView._) - 1;
													return (stop >= 0) ? A2(
														$author$project$Portal$Return$withBackgroundCommand,
														$author$project$Ports$rememberValue(
															{
																iY: activeStopKey(c),
																kt: $elm$core$String$fromInt(stop)
															}),
														A2(
															withMobile,
															_Utils_update(
																selectedRouteView,
																{
																	_: $elm$core$Maybe$Just(stop)
																}),
															$author$project$UI$Swipe$blanco)) : noChange;
												default:
													break _v24$2;
											}
										} else {
											break _v24$2;
										}
									}
									return noChange;
								} else {
									break _v10$10;
								}
						}
					}
					return noChange;
				case 5:
					return withDisplay(
						A2($author$project$Lists$RouteDetail$Deliverer$Mobile, $elm$core$Maybe$Nothing, $author$project$UI$Swipe$blanco));
				case 6:
					var item = msg.a;
					var bool = msg.b;
					return onLoaded(
						function (m) {
							return modelChange(
								$author$project$Lists$RouteDetail$Deliverer$Loaded(
									_Utils_update(
										m,
										{
											dn: A3($author$project$Lists$RouteDetail$Deliverer$checkPrintItem, m.dn, item, bool)
										})));
						});
				case 7:
					var item = msg.a;
					var sequence = msg.b;
					return withDisplay(
						A2(
							$author$project$Lists$RouteDetail$Deliverer$updateDisplay,
							$author$project$Portal$Share$device(share),
							A2(
								$author$project$Lists$RouteDetail$Deliverer$EditSequence,
								item,
								A2(
									$author$project$Sequence$Edit$default,
									date,
									$author$project$Sequence$Sequence$prepareForEdit(sequence)))));
				default:
					if (msg.a.$ === 11) {
						var _v28 = msg.a;
						var token = $author$project$Portal$Share$token(share);
						return A3(
							$author$project$Portal$Return$withCommand,
							$author$project$Lists$RouteDetail$Deliverer$loadingRouteDetail(date),
							A3($author$project$Lists$RouteDetail$Deliverer$loadCmd, token, $author$project$Lists$RouteDetail$Deliverer$SystemGotRouteDetail, date),
							_Utils_Tuple3(
								share,
								$author$project$Lists$RouteDetail$Deliverer$Loading(
									{r: $author$project$Portal$Subheader$initCalendarState, H: cluster, lx: date, N: $author$project$Lists$RouteDetail$Deliverer$Print, cv: page, cO: uncheckedItems}),
								$elm$core$Platform$Cmd$none));
					} else {
						var editMsg = msg.a;
						if (display.$ === 2) {
							var item = display.a;
							var edit = display.b;
							var _v30 = A3($author$project$Sequence$Edit$update, editMsg, share, edit);
							switch (_v30.$) {
								case 2:
									var _v31 = _v30.a;
									var s = _v31.a;
									var e = _v31.b;
									var c = _v31.c;
									return onLoaded(
										function (m) {
											return _Utils_Tuple3(
												s,
												$author$project$Lists$RouteDetail$Deliverer$Loaded(
													_Utils_update(
														m,
														{
															N: A2($author$project$Lists$RouteDetail$Deliverer$EditSequence, item, e)
														})),
												A2($elm$core$Platform$Cmd$map, $author$project$Lists$RouteDetail$Deliverer$SystemGotSequenceEditMsg, c));
										});
								case 0:
									return noChange;
								default:
									return noChange;
							}
						} else {
							return noChange;
						}
					}
			}
		}
	});
var $author$project$Lists$RouteDetail$RouteDetail$Failed = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Lists$RouteDetail$RouteDetail$toDeliveryDate = function (status) {
	switch (status.$) {
		case 0:
			var planInfo = status.b;
			return planInfo.lx;
		case 1:
			var planInfo = status.a;
			return planInfo.lx;
		default:
			var date = status.b;
			return date;
	}
};
var $author$project$Lists$RouteDetail$RouteDetail$toDistributionPointId = function (status) {
	switch (status.$) {
		case 0:
			var dpId = status.a;
			return dpId;
		case 1:
			var planInfo = status.a;
			return $author$project$DistributionPoint$DistributionPoint$idOf(planInfo.bn);
		default:
			var dpId = status.a;
			return dpId;
	}
};
var $author$project$Print$Option$DoubleSided = 1;
var $author$project$Lists$RouteDetail$PrintSelection$HideComplaints = 1;
var $author$project$Lists$RouteDetail$PrintSelection$HideKioskList = 1;
var $author$project$Lists$RouteDetail$PrintSelection$HideMutations = 1;
var $author$project$Lists$RouteDetail$PrintSelection$HideRouteList = 1;
var $author$project$Plan$Supply$allClustersByItem = function (items) {
	return A2(
		$elm$core$List$concatMap,
		function (i) {
			return A2(
				$elm$core$List$map,
				function (c) {
					return _Utils_Tuple2(i, c);
				},
				$author$project$Plan$Supply$allClustersOf(i));
		},
		$author$project$Plan$Supply$flatten(items));
};
var $author$project$Plan$Supply$allClustersByDeliverer = function (items) {
	return A2(
		$elm$core$List$concatMap,
		function (item) {
			switch (item.$) {
				case 0:
					var deliverer = item.a.bl;
					var cluster = item.a.H;
					return _List_fromArray(
						[
							_Utils_Tuple2(deliverer, cluster)
						]);
				case 1:
					var deliverer = item.a.bl;
					var clusters = item.a.k;
					return A2(
						$elm$core$List$map,
						function (c) {
							return _Utils_Tuple2(deliverer, c);
						},
						clusters);
				default:
					return _List_Nil;
			}
		},
		$author$project$Plan$Supply$flatten(items));
};
var $author$project$Cluster$Cluster$getSegments = function (cluster) {
	return cluster.bb;
};
var $author$project$Plan$Supply$findExpiredSegments = F3(
	function (distributionPoint, deliverers, items) {
		var delivererIds = A3(
			$elm$core$Basics$composeR,
			$author$project$Deliverer$IdDict$values,
			$elm$core$List$map($author$project$Deliverer$Deliverer$idFromTyped),
			deliverers);
		return A2(
			$author$project$DistributionPoint$DistributionPoint$findSegmentsOnId,
			distributionPoint,
			A2(
				$elm$core$List$concatMap,
				$author$project$Cluster$Cluster$getSegments,
				A2(
					$elm$core$List$map,
					$elm$core$Tuple$second,
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var d = _v0.a;
							return !A2(
								$elm$core$List$member,
								$author$project$Deliverer$Deliverer$idFromTyped(d),
								delivererIds);
						},
						$author$project$Plan$Supply$allClustersByDeliverer(items)))));
	});
var $author$project$Plan$Supply$findOpenSegments = F2(
	function (_v0, items) {
		var distributionPoint = _v0;
		var clusterSegmentIds = A2(
			$elm$core$List$concatMap,
			$author$project$Cluster$Cluster$getSegments,
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$second,
				$author$project$Plan$Supply$allClustersByDeliverer(items)));
		return A2(
			$elm$core$List$filter,
			function (s) {
				return !A2(
					$elm$core$List$member,
					$author$project$DistributionPoint$DistributionPoint$segmentId(s),
					clusterSegmentIds);
			},
			distributionPoint.bb);
	});
var $author$project$Lists$RouteDetail$PrintSelection$allOpenOrExpiredSegments = F3(
	function (distributionPoint, deliverers, items) {
		return _Utils_ap(
			A2($author$project$Plan$Supply$findOpenSegments, distributionPoint, items),
			A3($author$project$Plan$Supply$findExpiredSegments, distributionPoint, deliverers, items));
	});
var $author$project$Lists$RouteDetail$ClusterSelection$clusterItem = F2(
	function (item, cluster) {
		switch (item.$) {
			case 0:
				var car = item.a;
				return _Utils_Tuple2(
					A3($elm$core$Basics$composeR, $author$project$Deliverer$Deliverer$idFromTyped, $author$project$Deliverer$Deliverer$comparableId, car.bl),
					$author$project$Cluster$Number$comparable(cluster.bX));
			case 1:
				var bike = item.a;
				return _Utils_Tuple2(
					A3($elm$core$Basics$composeR, $author$project$Deliverer$Deliverer$idFromTyped, $author$project$Deliverer$Deliverer$comparableId, bike.bl),
					$author$project$Cluster$Number$comparable(cluster.bX));
			default:
				var dpId = item.a.lK;
				return _Utils_Tuple2(
					'',
					$author$project$DistributionPoint$DistributionPoint$comparableId(dpId));
		}
	});
var $author$project$Lists$RouteDetail$ClusterSelection$deselectCluster = F3(
	function (item, cluster, _v0) {
		var selected = _v0;
		return A2(
			$elm$core$Set$remove,
			A2($author$project$Lists$RouteDetail$ClusterSelection$clusterItem, item, cluster),
			selected);
	});
var $elm$core$Dict$diff = F2(
	function (t1, t2) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, t) {
					return A2($elm$core$Dict$remove, k, t);
				}),
			t1,
			t2);
	});
var $elm$core$Set$diff = F2(
	function (_v0, _v1) {
		var dict1 = _v0;
		var dict2 = _v1;
		return A2($elm$core$Dict$diff, dict1, dict2);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $elm$core$Set$union = F2(
	function (_v0, _v1) {
		var dict1 = _v0;
		var dict2 = _v1;
		return A2($elm$core$Dict$union, dict1, dict2);
	});
var $author$project$Lists$RouteDetail$ClusterSelection$selectClusters = F2(
	function (itemsWithCluster, _v0) {
		var selected = _v0;
		return A2(
			$elm$core$Set$union,
			$elm$core$Set$fromList(
				A2(
					$elm$core$List$map,
					function (_v1) {
						var item = _v1.a;
						var cluster = _v1.b;
						return A2($author$project$Lists$RouteDetail$ClusterSelection$clusterItem, item, cluster);
					},
					itemsWithCluster)),
			selected);
	});
var $author$project$Lists$RouteDetail$ClusterSelection$deselectClusters = F2(
	function (itemsWithCluster, _v0) {
		var selected = _v0;
		var _v1 = A2($author$project$Lists$RouteDetail$ClusterSelection$selectClusters, itemsWithCluster, $author$project$Lists$RouteDetail$ClusterSelection$empty);
		var clusterSet = _v1;
		return A2($elm$core$Set$diff, selected, clusterSet);
	});
var $author$project$Lists$RouteDetail$ClusterSelection$deselectItem = F2(
	function (item, _v0) {
		var selected = _v0;
		switch (item.$) {
			case 0:
				return A2(
					$author$project$Lists$RouteDetail$ClusterSelection$deselectClusters,
					$author$project$Plan$Supply$allClustersByItem(
						_List_fromArray(
							[item])),
					selected);
			case 1:
				return A2(
					$author$project$Lists$RouteDetail$ClusterSelection$deselectClusters,
					$author$project$Plan$Supply$allClustersByItem(
						_List_fromArray(
							[item])),
					selected);
			default:
				var dpId = item.a.lK;
				return A2(
					$elm$core$Set$remove,
					_Utils_Tuple2(
						'',
						$author$project$DistributionPoint$DistributionPoint$comparableId(dpId)),
					selected);
		}
	});
var $author$project$Lists$RouteDetail$ClusterSelection$segmentItem = function (segmentId) {
	return _Utils_Tuple2(
		'segment',
		$author$project$DistributionPoint$DistributionPoint$encodeSegmentIdForUrl(segmentId));
};
var $author$project$Lists$RouteDetail$ClusterSelection$deselectSegment = F2(
	function (segment, _v0) {
		var selected = _v0;
		return A2(
			$elm$core$Set$remove,
			$author$project$Lists$RouteDetail$ClusterSelection$segmentItem(segment),
			selected);
	});
var $author$project$Lists$RouteDetail$ClusterSelection$selectSegments = F2(
	function (segments, _v0) {
		var selected = _v0;
		var segmentItems = A2(
			$elm$core$List$map,
			A2($elm$core$Basics$composeL, $author$project$Lists$RouteDetail$ClusterSelection$segmentItem, $author$project$DistributionPoint$DistributionPoint$segmentId),
			segments);
		return A2(
			$elm$core$Set$union,
			$elm$core$Set$fromList(segmentItems),
			selected);
	});
var $author$project$Lists$RouteDetail$ClusterSelection$deselectSegments = F2(
	function (segments, _v0) {
		var selected = _v0;
		var _v1 = A2($author$project$Lists$RouteDetail$ClusterSelection$selectSegments, segments, $author$project$Lists$RouteDetail$ClusterSelection$empty);
		var segmentSet = _v1;
		return A2($elm$core$Set$diff, selected, segmentSet);
	});
var $author$project$Lists$RouteDetail$ClusterSelection$selectCluster = F3(
	function (item, cluster, _v0) {
		var selected = _v0;
		return A2(
			$elm$core$Set$insert,
			A2($author$project$Lists$RouteDetail$ClusterSelection$clusterItem, item, cluster),
			selected);
	});
var $author$project$Lists$RouteDetail$ClusterSelection$selectItem = F2(
	function (item, _v0) {
		var selected = _v0;
		switch (item.$) {
			case 2:
				var dpId = item.a.lK;
				return A2(
					$elm$core$Set$insert,
					_Utils_Tuple2(
						'',
						$author$project$DistributionPoint$DistributionPoint$comparableId(dpId)),
					selected);
			case 0:
				return A2(
					$author$project$Lists$RouteDetail$ClusterSelection$selectClusters,
					$author$project$Plan$Supply$allClustersByItem(
						_List_fromArray(
							[item])),
					selected);
			default:
				return A2(
					$author$project$Lists$RouteDetail$ClusterSelection$selectClusters,
					$author$project$Plan$Supply$allClustersByItem(
						_List_fromArray(
							[item])),
					selected);
		}
	});
var $author$project$Lists$RouteDetail$ClusterSelection$selectSegment = F2(
	function (segment, _v0) {
		var selected = _v0;
		return A2(
			$elm$core$Set$insert,
			$author$project$Lists$RouteDetail$ClusterSelection$segmentItem(segment),
			selected);
	});
var $author$project$Lists$RouteDetail$PrintSelection$updateSelectedClusters = F4(
	function (model, _v0, key, selected) {
		var distributionPoint = _v0.bn;
		var deliverers = _v0.e4;
		var plan = _v0.fA;
		var _v1 = _Utils_Tuple2(key, selected);
		if (_v1.b) {
			switch (_v1.a.$) {
				case 0:
					var _v3 = _v1.a;
					return A2(
						$author$project$Lists$RouteDetail$ClusterSelection$selectSegments,
						A3($author$project$Lists$RouteDetail$PrintSelection$allOpenOrExpiredSegments, distributionPoint, deliverers, plan.gL),
						A2(
							$author$project$Lists$RouteDetail$ClusterSelection$selectClusters,
							$author$project$Plan$Supply$allClustersByItem(plan.gL),
							model.s));
				case 1:
					switch (_v1.a.a.$) {
						case 1:
							var _v4 = _v1.a;
							var item = _v4.a;
							return A2($author$project$Lists$RouteDetail$ClusterSelection$selectItem, item, model.s);
						case 0:
							var _v6 = _v1.a;
							var item = _v6.a;
							var supplies = item.a.n0;
							return A2($author$project$Lists$RouteDetail$ClusterSelection$selectItem, item, model.s);
						default:
							var _v8 = _v1.a;
							var item = _v8.a;
							return A2($author$project$Lists$RouteDetail$ClusterSelection$selectItem, item, model.s);
					}
				case 2:
					var _v10 = _v1.a;
					var item = _v10.a;
					var cluster = _v10.b;
					return A3($author$project$Lists$RouteDetail$ClusterSelection$selectCluster, item, cluster, model.s);
				case 3:
					var item = _v1.a.a;
					return A2($author$project$Lists$RouteDetail$ClusterSelection$selectItem, item, model.s);
				case 4:
					var _v13 = _v1.a;
					return A2(
						$author$project$Lists$RouteDetail$ClusterSelection$selectSegments,
						A3($author$project$Lists$RouteDetail$PrintSelection$allOpenOrExpiredSegments, distributionPoint, deliverers, plan.gL),
						model.s);
				default:
					var segmentId = _v1.a.a;
					return A2($author$project$Lists$RouteDetail$ClusterSelection$selectSegment, segmentId, model.s);
			}
		} else {
			switch (_v1.a.$) {
				case 0:
					var _v2 = _v1.a;
					return $author$project$Lists$RouteDetail$ClusterSelection$empty;
				case 1:
					switch (_v1.a.a.$) {
						case 1:
							var _v5 = _v1.a;
							var item = _v5.a;
							return A2($author$project$Lists$RouteDetail$ClusterSelection$deselectItem, item, model.s);
						case 0:
							var _v7 = _v1.a;
							var item = _v7.a;
							var supplies = item.a.n0;
							return A2($author$project$Lists$RouteDetail$ClusterSelection$deselectItem, item, model.s);
						default:
							var _v9 = _v1.a;
							var item = _v9.a;
							return A2($author$project$Lists$RouteDetail$ClusterSelection$deselectItem, item, model.s);
					}
				case 2:
					var _v11 = _v1.a;
					var item = _v11.a;
					var cluster = _v11.b;
					return A3($author$project$Lists$RouteDetail$ClusterSelection$deselectCluster, item, cluster, model.s);
				case 3:
					var item = _v1.a.a;
					return A2($author$project$Lists$RouteDetail$ClusterSelection$deselectItem, item, model.s);
				case 4:
					var _v12 = _v1.a;
					return A2(
						$author$project$Lists$RouteDetail$ClusterSelection$deselectSegments,
						A3($author$project$Lists$RouteDetail$PrintSelection$allOpenOrExpiredSegments, distributionPoint, deliverers, plan.gL),
						model.s);
				default:
					var segmentId = _v1.a.a;
					return A2($author$project$Lists$RouteDetail$ClusterSelection$deselectSegment, segmentId, model.s);
			}
		}
	});
var $author$project$Lists$RouteDetail$PrintSelection$updateSelectedProducts = F2(
	function (_v0, productId) {
		var selectedProducts = _v0.dy;
		var _v1 = A2($elm$core$Set$member, productId, selectedProducts);
		if (_v1) {
			return A2($elm$core$Set$remove, productId, selectedProducts);
		} else {
			return A2($elm$core$Set$insert, productId, selectedProducts);
		}
	});
var $author$project$Lists$RouteDetail$PrintSelection$update = F3(
	function (msg, model, planInfo) {
		var iif = F3(
			function (bool, _true, _false) {
				return bool ? _true : _false;
			});
		switch (msg.$) {
			case 0:
				var key = msg.a;
				var selected = msg.b;
				return _Utils_update(
					model,
					{
						s: A4($author$project$Lists$RouteDetail$PrintSelection$updateSelectedClusters, model, planInfo, key, selected)
					});
			case 1:
				var selected = msg.a;
				return _Utils_update(
					model,
					{ev: selected});
			case 2:
				var productId = msg.a;
				return _Utils_update(
					model,
					{
						dy: A2($author$project$Lists$RouteDetail$PrintSelection$updateSelectedProducts, model, productId)
					});
			case 3:
				var printDoubleSided = msg.a;
				return _Utils_update(
					model,
					{
						nl: A3(iif, printDoubleSided, 1, 0)
					});
			case 4:
				var hideMutations = msg.a;
				return _Utils_update(
					model,
					{
						jj: A3(iif, hideMutations, 1, 0)
					});
			case 5:
				var hideComplaints = msg.a;
				return _Utils_update(
					model,
					{
						h6: A3(iif, hideComplaints, 1, 0)
					});
			case 6:
				var shouldHideRouteList = msg.a;
				return _Utils_update(
					model,
					{
						fK: A3(iif, shouldHideRouteList, 1, 0)
					});
			default:
				var shouldHideKioskList = msg.a;
				return _Utils_update(
					model,
					{
						fn: A3(iif, shouldHideKioskList, 1, 0)
					});
		}
	});
var $author$project$Lists$RouteDetail$RouteDetail$update = F3(
	function (msg, share, model) {
		return A2(
			$author$project$Portal$Return$ensureDataShared,
			$author$project$Lists$RouteDetail$RouteDetail$shareDataFromModel,
			function () {
				var zone = $author$project$Portal$Share$timeZone(share);
				var token = $author$project$Portal$Share$token(share);
				var to = function (route) {
					return _Utils_Tuple3(
						A2($author$project$Portal$Share$withNewRoute, route, share),
						model,
						$elm$core$Platform$Cmd$none);
				};
				var planId = A2(
					$author$project$Plan$Plan$Id,
					$author$project$Lists$RouteDetail$RouteDetail$toDistributionPointId(model.h),
					$author$project$Lists$RouteDetail$RouteDetail$toDeliveryDate(model.h));
				var withCommands = function (toAction) {
					return $author$project$Portal$Return$withCommands(
						toAction(planId));
				};
				var withoutAction = function (toAction) {
					return $author$project$Portal$Return$withoutAction(
						toAction(planId));
				};
				var withoutIndexedAction = F2(
					function (toAction, index) {
						return $author$project$Portal$Return$withoutAction(
							A2(toAction, planId, index));
					});
				var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
				var modelChange = function (m) {
					return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
				};
				var errIndexed = F4(
					function (action, index, error, m) {
						return _Utils_Tuple3(
							A2(
								$author$project$Portal$Share$withHttpError,
								error,
								A2(
									$author$project$Portal$Share$withoutWaitingAction,
									A2(action, planId, index),
									share)),
							m,
							$elm$core$Platform$Cmd$none);
					});
				var err = F3(
					function (action, error, m) {
						return _Utils_Tuple3(
							A2(
								$author$project$Portal$Share$withHttpError,
								error,
								A2(
									$author$project$Portal$Share$withoutWaitingAction,
									action(planId),
									share)),
							m,
							$elm$core$Platform$Cmd$none);
					});
				switch (msg.$) {
					case 1:
						var printSelectionMsg = msg.a;
						var _v1 = model.h;
						if (_v1.$ === 1) {
							var planInfo = _v1.a;
							return modelChange(
								function (ps) {
									return _Utils_update(
										model,
										{$7: ps});
								}(
									A3($author$project$Lists$RouteDetail$PrintSelection$update, printSelectionMsg, model.$7, planInfo)));
						} else {
							return noChange;
						}
					case 2:
						if (!msg.a.$) {
							var loadedDistributionPoint = msg.a.a;
							return A2(
								withoutAction,
								$author$project$Lists$RouteDetail$RouteDetail$loadingDP,
								function () {
									var _v2 = model.h;
									if (!_v2.$) {
										var dpId = _v2.a;
										var planInfo = _v2.b;
										return function () {
											var _v3 = _Utils_Tuple2(
												$author$project$DistributionPoint$IdDict$isEmpty(planInfo.bm),
												$author$project$DistributionPoint$DistributionPoint$getSubDistributionPoints(loadedDistributionPoint));
											if (_v3.a && _v3.b.b) {
												var subDPs = _v3.b;
												return A2(
													withCommands,
													$author$project$Lists$RouteDetail$RouteDetail$loadingSummaries,
													A2(
														$elm$core$List$map,
														F2(
															function (subDP, i) {
																return A4(
																	$author$project$Demand$Summary$loadForDPCmd,
																	token,
																	$author$project$Lists$RouteDetail$RouteDetail$BackendRespondedDemandSummary(i),
																	$author$project$DistributionPoint$DistributionPoint$idOf(subDP),
																	planInfo.lx);
															}),
														subDPs));
											} else {
												return $elm$core$Basics$identity;
											}
										}()(
											modelChange(
												$author$project$Lists$RouteDetail$RouteDetail$ensureCorrectStatus(
													_Utils_update(
														model,
														{
															h: A2(
																$author$project$Lists$RouteDetail$RouteDetail$Loading,
																dpId,
																_Utils_update(
																	planInfo,
																	{
																		bn: $elm$core$Maybe$Just(loadedDistributionPoint)
																	}))
														}))));
									} else {
										return noChange;
									}
								}());
						} else {
							var error = msg.a.a;
							return A3(err, $author$project$Lists$RouteDetail$RouteDetail$loadingDP, error, model);
						}
					case 3:
						var planLoaderMsg = msg.a;
						var _v4 = model.h;
						if (!_v4.$) {
							var dpId = _v4.a;
							var loadState = _v4.b;
							return function (_v5) {
								var s = _v5.a;
								var pAndD = _v5.b;
								var cmd = _v5.c;
								switch (pAndD.$) {
									case 3:
										var p = pAndD.a;
										var batchedSequences = A2(
											$elm_community$list_extra$List$Extra$greedyGroupsOf,
											10,
											A2(
												$author$project$Lists$RouteDetail$RouteDetail$withDateFirst,
												loadState.lx,
												$author$project$Lists$RouteDetail$RouteDetail$segmentsByDelivererIdOf(p.fA.gL)));
										return A3(
											withCommands,
											$author$project$Lists$RouteDetail$RouteDetail$loadingSequences,
											A2(
												$elm$core$List$map,
												F2(
													function (seq, i) {
														return A3(
															$author$project$Sequence$Sequence$loadSequencesCmd,
															token,
															$author$project$Lists$RouteDetail$RouteDetail$SequencesLoaded(i),
															seq);
													}),
												batchedSequences),
											_Utils_Tuple3(
												s,
												_Utils_update(
													model,
													{
														h: A2(
															$author$project$Lists$RouteDetail$RouteDetail$Loading,
															dpId,
															_Utils_update(
																loadState,
																{
																	fB: pAndD,
																	hm: _Utils_Tuple2(
																		$elm$core$List$length(batchedSequences),
																		_List_Nil)
																}))
													}),
												cmd));
									case 4:
										return _Utils_Tuple3(
											s,
											_Utils_update(
												model,
												{
													h: A2($author$project$Lists$RouteDetail$RouteDetail$Failed, dpId, loadState.lx)
												}),
											cmd);
									default:
										return _Utils_Tuple3(
											s,
											_Utils_update(
												model,
												{
													h: A2(
														$author$project$Lists$RouteDetail$RouteDetail$Loading,
														dpId,
														_Utils_update(
															loadState,
															{fB: pAndD}))
												}),
											cmd);
								}
							}(
								$author$project$Plan$PlanLoader$registerErrorOnFailed(
									A2(
										$author$project$Plan$PlanLoader$mapCommand,
										$elm$core$Platform$Cmd$map($author$project$Lists$RouteDetail$RouteDetail$SystemGotLoaderMsg),
										A6(
											$author$project$Plan$PlanLoader$update,
											share,
											token,
											$author$project$Lists$RouteDetail$RouteDetail$loadingPlan(planId),
											$elm$core$Basics$identity,
											planLoaderMsg,
											loadState.fB))));
						} else {
							return noChange;
						}
					case 4:
						if (!msg.a.$) {
							var orders = msg.a.a;
							return A2(
								withoutAction,
								$author$project$Lists$RouteDetail$RouteDetail$loadingOrders,
								function () {
									var _v7 = model.h;
									if (!_v7.$) {
										var dpId = _v7.a;
										var planInfo = _v7.b;
										return modelChange(
											$author$project$Lists$RouteDetail$RouteDetail$ensureCorrectStatus(
												_Utils_update(
													model,
													{
														h: A2(
															$author$project$Lists$RouteDetail$RouteDetail$Loading,
															dpId,
															_Utils_update(
																planInfo,
																{
																	Y: $elm$core$Maybe$Just(orders)
																}))
													})));
									} else {
										return noChange;
									}
								}());
						} else {
							var error = msg.a.a;
							return A3(err, $author$project$Lists$RouteDetail$RouteDetail$loadingOrders, error, model);
						}
					case 5:
						if (!msg.b.$) {
							var index = msg.a;
							var subDpOrderSummary = msg.b.a;
							return A3(
								withoutIndexedAction,
								$author$project$Lists$RouteDetail$RouteDetail$loadingSummaries,
								index,
								function () {
									var _v8 = model.h;
									if (!_v8.$) {
										var dpId = _v8.a;
										var planInfo = _v8.b;
										return modelChange(
											$author$project$Lists$RouteDetail$RouteDetail$ensureCorrectStatus(
												function (summ) {
													return _Utils_update(
														model,
														{
															h: A2(
																$author$project$Lists$RouteDetail$RouteDetail$Loading,
																dpId,
																_Utils_update(
																	planInfo,
																	{bm: summ}))
														});
												}(
													A3($author$project$DistributionPoint$IdDict$insert, subDpOrderSummary.lK, subDpOrderSummary, planInfo.bm))));
									} else {
										return noChange;
									}
								}());
						} else {
							var index = msg.a;
							var error = msg.b.a;
							return A4(errIndexed, $author$project$Lists$RouteDetail$RouteDetail$loadingSummaries, index, error, model);
						}
					case 6:
						if (!msg.a.$) {
							var products = msg.a.a;
							return A2(
								withoutAction,
								$author$project$Lists$RouteDetail$RouteDetail$loadingProducts,
								function () {
									var _v9 = model.h;
									if (!_v9.$) {
										var dpId = _v9.a;
										var planInfo = _v9.b;
										return modelChange(
											$author$project$Lists$RouteDetail$RouteDetail$ensureCorrectStatus(
												_Utils_update(
													model,
													{
														h: A2(
															$author$project$Lists$RouteDetail$RouteDetail$Loading,
															dpId,
															_Utils_update(
																planInfo,
																{
																	bu: $elm$core$Maybe$Just(products)
																}))
													})));
									} else {
										return noChange;
									}
								}());
						} else {
							var error = msg.a.a;
							return A3(err, $author$project$Lists$RouteDetail$RouteDetail$loadingProducts, error, model);
						}
					case 7:
						if (!msg.a.$) {
							var complaints = msg.a.a;
							return A2(
								withoutAction,
								$author$project$Lists$RouteDetail$RouteDetail$loadingComplaints,
								function () {
									var _v10 = model.h;
									if (!_v10.$) {
										var dpId = _v10.a;
										var planInfo = _v10.b;
										return modelChange(
											$author$project$Lists$RouteDetail$RouteDetail$ensureCorrectStatus(
												_Utils_update(
													model,
													{
														h: A2(
															$author$project$Lists$RouteDetail$RouteDetail$Loading,
															dpId,
															_Utils_update(
																planInfo,
																{
																	m: $elm$core$Maybe$Just(complaints)
																}))
													})));
									} else {
										return noChange;
									}
								}());
						} else {
							var error = msg.a.a;
							return A3(err, $author$project$Lists$RouteDetail$RouteDetail$loadingComplaints, error, model);
						}
					case 8:
						if (!msg.b.$) {
							var index = msg.a;
							var sequences = msg.b.a;
							return A3(
								withoutIndexedAction,
								$author$project$Lists$RouteDetail$RouteDetail$loadingSequences,
								index,
								function () {
									var _v11 = model.h;
									if (!_v11.$) {
										var dpId = _v11.a;
										var planInfo = _v11.b;
										var updatedSequences = _Utils_Tuple2(
											planInfo.hm.a - 1,
											A2($elm$core$List$append, sequences, planInfo.hm.b));
										return modelChange(
											$author$project$Lists$RouteDetail$RouteDetail$ensureCorrectStatus(
												_Utils_update(
													model,
													{
														h: A2(
															$author$project$Lists$RouteDetail$RouteDetail$Loading,
															dpId,
															_Utils_update(
																planInfo,
																{hm: updatedSequences}))
													})));
									} else {
										return noChange;
									}
								}());
						} else {
							var index = msg.a;
							var error = msg.b.a;
							return A4(errIndexed, $author$project$Lists$RouteDetail$RouteDetail$loadingSequences, index, error, model);
						}
					case 0:
						return to(
							A2(
								$author$project$Portal$Route$DayPlanning,
								$author$project$Lists$RouteDetail$RouteDetail$toDistributionPointId(model.h),
								$author$project$Lists$RouteDetail$RouteDetail$toDeliveryDate(model.h)));
					case 9:
						return noChange;
					default:
						var time = msg.a;
						var deadline = A3(
							$author$project$Date$DeliveryDate$toPosix,
							zone,
							{me: 0, mH: 0},
							$author$project$Date$DeliveryDate$fromDate(
								A3($justinmimbs$date$Date$fromCalendarDate, 2025, 3, 15)));
						return modelChange(
							_Utils_update(
								model,
								{
									e$: A2(
										$author$project$Lists$RouteDetail$RouteDetail$countDownClock,
										zone,
										$elm$time$Time$millisToPosix(
											$elm$time$Time$posixToMillis(deadline) - $elm$time$Time$posixToMillis(time)))
								}));
				}
			}());
	});
var $author$project$Message$Message$BackendRespondedMessageDeleted = function (a) {
	return {$: 17, a: a};
};
var $author$project$Message$Message$Failed = {$: 2};
var $author$project$Message$Message$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Message$Message$MessageFormToAdd = function (a) {
	return {$: 1, a: a};
};
var $author$project$Message$Message$MessageFormToEdit = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Message$Message$SystemAddedMessage = function (a) {
	return {$: 11, a: a};
};
var $author$project$Message$Message$SystemUpdatedMessage = function (a) {
	return {$: 12, a: a};
};
var $author$project$Message$Message$encodePeriod = function (period) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'from',
				$elm$json$Json$Encode$int(
					$elm$time$Time$posixToMillis(period.l2))),
				_Utils_Tuple2(
				'to',
				$elm$json$Json$Encode$int(
					$elm$time$Time$posixToMillis(period.oj)))
			]));
};
var $author$project$Message$Message$encodePermission = function (permission) {
	switch (permission) {
		case 0:
			return $elm$json$Json$Encode$string('vdm');
		case 1:
			return $elm$json$Json$Encode$string('vrm');
		default:
			return $elm$json$Json$Encode$string('vmm');
	}
};
var $author$project$Message$Message$encodeType = function (messageType) {
	if (!messageType) {
		return $elm$json$Json$Encode$string('notification');
	} else {
		return $elm$json$Json$Encode$string('news');
	}
};
var $author$project$Message$Message$encodeMessage = function (message) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'showDuring',
				$author$project$Message$Message$encodePeriod(message.bA)),
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(message.oi)),
				_Utils_Tuple2(
				'text',
				$elm$json$Json$Encode$string(message.n3)),
				_Utils_Tuple2(
				'kind',
				$author$project$Message$Message$encodeType(message.dh)),
				_Utils_Tuple2(
				'permissions',
				A2($elm$json$Json$Encode$list, $author$project$Message$Message$encodePermission, message.fz))
			]));
};
var $author$project$Message$Message$addCmd = F3(
	function (token, toMsg, message) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['messages']),
			_List_Nil);
		var body = $elm$http$Http$jsonBody(
			$author$project$Message$Message$encodeMessage(message));
		return A5(
			$author$project$Api$Request$post,
			token,
			toMsg,
			uri,
			body,
			$elm$json$Json$Decode$succeed(0));
	});
var $author$project$Message$Message$addingMessages = $author$project$Message$Message$singleAction('addingMessages');
var $author$project$Message$Message$encodeForUrl = $danyx23$elm_uuid$Uuid$toString;
var $author$project$Message$Message$deleteCmd = F3(
	function (token, toMsg, id) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'messages',
					$author$project$Message$Message$encodeForUrl(id)
				]),
			_List_Nil);
		return A4($author$project$Api$Request$deleteWithoutResponse, token, toMsg, uri, $elm$http$Http$emptyBody);
	});
var $author$project$Message$Message$deletingMessages = $author$project$Message$Message$singleAction('deletingMessages');
var $author$project$UI$DateTime$padded = function (value) {
	return (value < 10) ? ('0' + $elm$core$String$fromInt(value)) : $elm$core$String$fromInt(value);
};
var $author$project$UI$DateTime$timeView = F2(
	function (timeZone, posix) {
		return $author$project$UI$DateTime$padded(
			A2($elm$time$Time$toHour, timeZone, posix)) + (':' + $author$project$UI$DateTime$padded(
			A2($elm$time$Time$toMinute, timeZone, posix)));
	});
var $author$project$Message$Message$newMessageFormToAdd = F2(
	function (timeZone, maybeNow) {
		var _v0 = function () {
			if (!maybeNow.$) {
				var now = maybeNow.a;
				var date = A2($author$project$Date$DeliveryDate$fromPosix, timeZone, now);
				var nextDate = $author$project$Date$DeliveryDate$fromDate(
					A3(
						$justinmimbs$date$Date$add,
						3,
						1,
						$author$project$Date$DeliveryDate$toDate(date)));
				return _Utils_Tuple3(
					$author$project$Date$DeliveryDate$encodeForDateInput(date),
					$author$project$Date$DeliveryDate$encodeForDateInput(nextDate),
					A2($author$project$UI$DateTime$timeView, timeZone, now));
			} else {
				return _Utils_Tuple3('', '', '');
			}
		}();
		var dateFrom = _v0.a;
		var dateTo = _v0.b;
		var time = _v0.c;
		return $author$project$Message$Message$MessageFormToAdd(
			{co: dateFrom, cp: time, b2: _List_Nil, dz: 1, n3: '', oi: '', cL: dateTo, cM: time});
	});
var $author$project$Message$Message$newMessageFormToEdit = F2(
	function (timeZone, _v0) {
		var messageId = _v0.a;
		var message = _v0.b;
		var toTime = A2($author$project$UI$DateTime$timeView, timeZone, message.bA.oj);
		var toDate = $author$project$Date$DeliveryDate$encodeForDateInput(
			A2($author$project$Date$DeliveryDate$fromPosix, timeZone, message.bA.oj));
		var fromTime = A2($author$project$UI$DateTime$timeView, timeZone, message.bA.l2);
		var fromDate = $author$project$Date$DeliveryDate$encodeForDateInput(
			A2($author$project$Date$DeliveryDate$fromPosix, timeZone, message.bA.l2));
		return A2(
			$author$project$Message$Message$MessageFormToEdit,
			messageId,
			{co: fromDate, cp: fromTime, b2: message.fz, dz: message.dh, n3: message.n3, oi: message.oi, cL: toDate, cM: toTime});
	});
var $author$project$Message$Message$toPosix = F3(
	function (zone, date, time) {
		var _v0 = _Utils_Tuple2(
			$author$project$Date$DeliveryDate$fromString(date),
			A2(
				$elm$core$List$map,
				$elm$core$String$toInt,
				A2($elm$core$String$split, ':', time)));
		if ((((((!_v0.a.$) && _v0.b.b) && (!_v0.b.a.$)) && _v0.b.b.b) && (!_v0.b.b.a.$)) && (!_v0.b.b.b.b)) {
			var dd = _v0.a.a;
			var _v1 = _v0.b;
			var hours = _v1.a.a;
			var _v2 = _v1.b;
			var minutes = _v2.a.a;
			return $elm$core$Maybe$Just(
				A3(
					$author$project$Date$DeliveryDate$toPosix,
					zone,
					{me: hours, mH: minutes},
					dd));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Message$Message$toMessage = F2(
	function (zone, _v0) {
		var fromDate = _v0.co;
		var fromTime = _v0.cp;
		var toDate = _v0.cL;
		var toTime = _v0.cM;
		var title = _v0.oi;
		var text = _v0.n3;
		var selectedType = _v0.dz;
		var selectedPermissions = _v0.b2;
		var _v1 = _Utils_Tuple2(
			A3($author$project$Message$Message$toPosix, zone, fromDate, fromTime),
			A3($author$project$Message$Message$toPosix, zone, toDate, toTime));
		if ((!_v1.a.$) && (!_v1.b.$)) {
			var from = _v1.a.a;
			var to = _v1.b.a;
			return $elm$core$Maybe$Just(
				{
					ec: '',
					dh: selectedType,
					fz: selectedPermissions,
					bA: {l2: from, oj: to},
					n3: text,
					oi: title
				});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Message$Message$updateCmd = F3(
	function (token, toMsg, _v0) {
		var id = _v0.a;
		var message = _v0.b;
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'messages',
					$author$project$Message$Message$encodeForUrl(id)
				]),
			_List_Nil);
		var body = $elm$http$Http$jsonBody(
			$author$project$Message$Message$encodeMessage(message));
		return A5(
			$author$project$Api$Request$patch,
			token,
			toMsg,
			uri,
			body,
			$elm$json$Json$Decode$succeed(0));
	});
var $author$project$Message$Message$updatingMessages = $author$project$Message$Message$singleAction('updatingMessages');
var $author$project$Message$Message$whenWaiting = function (msg) {
	switch (msg.$) {
		case 0:
			return 0;
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 1;
		case 4:
			return 1;
		case 5:
			return 1;
		case 6:
			return 1;
		case 7:
			return 1;
		case 8:
			return 1;
		case 9:
			return 1;
		case 10:
			return 0;
		case 11:
			return 0;
		case 12:
			return 0;
		case 13:
			return 1;
		case 14:
			return 1;
		case 15:
			return 1;
		case 16:
			return 1;
		default:
			return 0;
	}
};
var $author$project$Message$Message$update = F3(
	function (msg, share, model) {
		var withoutAction = function (action) {
			return $author$project$Portal$Return$withoutAction(
				action(0));
		};
		var withCommand = function (action) {
			return $author$project$Portal$Return$withCommand(
				action(0));
		};
		var token = $author$project$Portal$Share$token(share);
		var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		var modelChange = function (m) {
			return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
		};
		var formChange = function (mapper) {
			return modelChange(
				function (mfs) {
					return _Utils_update(
						model,
						{ac: mfs});
				}(
					function () {
						var _v11 = model.ac;
						switch (_v11.$) {
							case 0:
								return $author$project$Message$Message$NoMessageForm;
							case 1:
								var mf = _v11.a;
								return $author$project$Message$Message$MessageFormToAdd(
									mapper(mf));
							default:
								var messageId = _v11.a;
								var mf = _v11.b;
								return A2(
									$author$project$Message$Message$MessageFormToEdit,
									messageId,
									mapper(mf));
						}
					}()));
		};
		var err = F3(
			function (action, error, m) {
				return _Utils_Tuple3(
					A2(
						$author$project$Portal$Share$withHttpError,
						error,
						A2(
							$author$project$Portal$Share$withoutWaitingAction,
							action(0),
							share)),
					m,
					$elm$core$Platform$Cmd$none);
			});
		if (A3($author$project$Portal$Share$allowed, $author$project$Message$Message$whenWaiting, msg, share) === 1) {
			return noChange;
		} else {
			switch (msg.$) {
				case 0:
					var now = msg.a;
					return modelChange(
						_Utils_update(
							model,
							{
								W: $elm$core$Maybe$Just(now)
							}));
				case 1:
					if (!msg.a.$) {
						var messages = msg.a.a;
						return A2(
							withoutAction,
							$author$project$Message$Message$loadingMessages,
							modelChange(
								_Utils_update(
									model,
									{
										di: $author$project$Message$Message$Loaded(messages)
									})));
					} else {
						var error = msg.a.a;
						return A3(
							err,
							$author$project$Message$Message$loadingMessages,
							error,
							_Utils_update(
								model,
								{di: $author$project$Message$Message$Failed}));
					}
				case 2:
					var _v1 = model.ac;
					switch (_v1.$) {
						case 0:
							return modelChange(
								_Utils_update(
									model,
									{
										ac: A2(
											$author$project$Message$Message$newMessageFormToAdd,
											$author$project$Portal$Share$timeZone(share),
											model.W)
									}));
						case 1:
							return noChange;
						default:
							return noChange;
					}
				case 3:
					var fromDate = msg.a;
					return formChange(
						function (mf) {
							return _Utils_update(
								mf,
								{co: fromDate});
						});
				case 4:
					var fromTime = msg.a;
					return formChange(
						function (mf) {
							return _Utils_update(
								mf,
								{cp: fromTime});
						});
				case 5:
					var toDate = msg.a;
					return formChange(
						function (mf) {
							return _Utils_update(
								mf,
								{cL: toDate});
						});
				case 6:
					var toTime = msg.a;
					return formChange(
						function (mf) {
							return _Utils_update(
								mf,
								{cM: toTime});
						});
				case 7:
					var title = msg.a;
					return formChange(
						function (mf) {
							return _Utils_update(
								mf,
								{oi: title});
						});
				case 8:
					var text = msg.a;
					return formChange(
						function (mf) {
							return _Utils_update(
								mf,
								{n3: text});
						});
				case 14:
					var permission = msg.a;
					var checked = msg.b;
					var addRemovePermission = function (selected) {
						if (checked) {
							return A2(
								$elm$core$List$append,
								selected,
								_List_fromArray(
									[permission]));
						} else {
							return A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(permission),
								selected);
						}
					};
					return formChange(
						function (mf) {
							return _Utils_update(
								mf,
								{
									b2: addRemovePermission(mf.b2)
								});
						});
				case 15:
					var messageType = msg.a;
					return formChange(
						function (mf) {
							return _Utils_update(
								mf,
								{dz: messageType});
						});
				case 9:
					var _v3 = model.ac;
					switch (_v3.$) {
						case 0:
							return noChange;
						case 1:
							var messageForm = _v3.a;
							var _v4 = A2(
								$author$project$Message$Message$toMessage,
								$author$project$Portal$Share$timeZone(share),
								messageForm);
							if (!_v4.$) {
								var message = _v4.a;
								return A3(
									withCommand,
									$author$project$Message$Message$addingMessages,
									A3($author$project$Message$Message$addCmd, token, $author$project$Message$Message$SystemAddedMessage, message),
									noChange);
							} else {
								return noChange;
							}
						default:
							var messageId = _v3.a;
							var messageForm = _v3.b;
							var _v5 = A2(
								$author$project$Message$Message$toMessage,
								$author$project$Portal$Share$timeZone(share),
								messageForm);
							if (!_v5.$) {
								var message = _v5.a;
								return A3(
									withCommand,
									$author$project$Message$Message$updatingMessages,
									A3(
										$author$project$Message$Message$updateCmd,
										token,
										$author$project$Message$Message$SystemUpdatedMessage,
										_Utils_Tuple2(messageId, message)),
									noChange);
							} else {
								return noChange;
							}
					}
				case 10:
					return modelChange(
						_Utils_update(
							model,
							{ac: $author$project$Message$Message$NoMessageForm}));
				case 11:
					if (!msg.a.$) {
						return A2(
							withoutAction,
							$author$project$Message$Message$addingMessages,
							A3(
								withCommand,
								$author$project$Message$Message$loadingMessages,
								A2($author$project$Message$Message$loadLastMonthCmd, token, $author$project$Message$Message$BackendRespondedMessages),
								modelChange(
									_Utils_update(
										model,
										{ac: $author$project$Message$Message$NoMessageForm}))));
					} else {
						var error = msg.a.a;
						return A3(err, $author$project$Message$Message$addingMessages, error, model);
					}
				case 12:
					if (!msg.a.$) {
						return A2(
							withoutAction,
							$author$project$Message$Message$updatingMessages,
							A3(
								withCommand,
								$author$project$Message$Message$loadingMessages,
								A2($author$project$Message$Message$loadLastMonthCmd, token, $author$project$Message$Message$BackendRespondedMessages),
								modelChange(
									_Utils_update(
										model,
										{ac: $author$project$Message$Message$NoMessageForm}))));
					} else {
						var error = msg.a.a;
						return A3(err, $author$project$Message$Message$updatingMessages, error, model);
					}
				case 13:
					var messageId = msg.a;
					var _v6 = _Utils_Tuple2(model.ac, model.di);
					if ((!_v6.a.$) && (_v6.b.$ === 1)) {
						var _v7 = _v6.a;
						var messages = _v6.b.a;
						var _v8 = A2(
							$elm_community$list_extra$List$Extra$find,
							function (_v9) {
								var id = _v9.a;
								return _Utils_eq(id, messageId);
							},
							messages);
						if (!_v8.$) {
							var _v10 = _v8.a;
							var message = _v10.b;
							return modelChange(
								_Utils_update(
									model,
									{
										ac: A2(
											$author$project$Message$Message$newMessageFormToEdit,
											$author$project$Portal$Share$timeZone(share),
											_Utils_Tuple2(messageId, message))
									}));
						} else {
							return noChange;
						}
					} else {
						return noChange;
					}
				case 16:
					var messageId = msg.a;
					return A3(
						withCommand,
						$author$project$Message$Message$deletingMessages,
						A3($author$project$Message$Message$deleteCmd, token, $author$project$Message$Message$BackendRespondedMessageDeleted, messageId),
						noChange);
				default:
					if (!msg.a.$) {
						return A2(
							withoutAction,
							$author$project$Message$Message$deletingMessages,
							A3(
								withCommand,
								$author$project$Message$Message$loadingMessages,
								A2($author$project$Message$Message$loadLastMonthCmd, token, $author$project$Message$Message$BackendRespondedMessages),
								modelChange(
									_Utils_update(
										model,
										{ac: $author$project$Message$Message$NoMessageForm}))));
					} else {
						var error = msg.a.a;
						return A3(err, $author$project$Message$Message$deletingMessages, error, model);
					}
			}
		}
	});
var $author$project$Payment$AnnualDetail$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Payment$AnnualDetail$update = F3(
	function (msg, share, model) {
		var withoutAction = function (action) {
			return $author$project$Portal$Return$withoutAction(action);
		};
		var modelChange = function (m) {
			return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
		};
		var err = F3(
			function (action, error, m) {
				return _Utils_Tuple3(
					A2(
						$author$project$Portal$Share$withHttpError,
						error,
						A2($author$project$Portal$Share$withoutWaitingAction, action, share)),
					m,
					$elm$core$Platform$Cmd$none);
			});
		if (!msg.$) {
			var payment = msg.a;
			return A2(
				withoutAction,
				$author$project$Payment$AnnualDetail$loadingAnnualDetail,
				modelChange(
					$author$project$Payment$AnnualDetail$Loaded(payment)));
		} else {
			var error = msg.a;
			return A3(err, $author$project$Payment$AnnualDetail$loadingAnnualDetail, error, model);
		}
	});
var $author$project$Payment$Archive$AnnualPaymentSelected = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Payment$Archive$BackendRespondedArchiveAnnualSummaries = function (a) {
	return {$: 2, a: a};
};
var $author$project$Payment$Archive$BackendRespondedArchiveSummaries = function (a) {
	return {$: 1, a: a};
};
var $author$project$Payment$Archive$BackendRespondedMonthlyPayment = function (a) {
	return {$: 3, a: a};
};
var $author$project$Payment$Archive$DeliverersFound = function (a) {
	return {$: 2, a: a};
};
var $author$project$Payment$Archive$LoadedPayments = F3(
	function (deliverers, selectedDeliverer, payments) {
		return {e4: deliverers, ep: payments, cF: selectedDeliverer};
	});
var $author$project$Payment$Archive$LoadingFailed = {$: 8};
var $author$project$Payment$Archive$LoadingMonthlyPayment = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Payment$Archive$LoadingPayments = function (a) {
	return {$: 3, a: a};
};
var $author$project$Payment$Archive$MonthlyPaymentSelected = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Payment$Archive$PaymentsLoaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$Payment$Archive$deliverersOf = function (statements) {
	switch (statements.$) {
		case 2:
			var deliverers = statements.a;
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(deliverers),
				$elm$core$Maybe$Nothing);
		case 3:
			var deliverers = statements.a.e4;
			var selectedDeliverer = statements.a.cF;
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(deliverers),
				$elm$core$Maybe$Just(selectedDeliverer));
		case 4:
			var loadedPayments = statements.a;
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(loadedPayments.e4),
				$elm$core$Maybe$Just(loadedPayments.cF));
		case 5:
			var loadedPayments = statements.a;
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(loadedPayments.e4),
				$elm$core$Maybe$Just(loadedPayments.cF));
		case 6:
			var loadedPayments = statements.a;
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(loadedPayments.e4),
				$elm$core$Maybe$Just(loadedPayments.cF));
		case 7:
			var loadedPayments = statements.a;
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(loadedPayments.e4),
				$elm$core$Maybe$Just(loadedPayments.cF));
		default:
			return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
	}
};
var $author$project$Payment$Payment$loadAnnualSummariesByIdCmd = F3(
	function (token, toMsg, id) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'statements',
					'deliverer',
					$author$project$Deliverer$Deliverer$encodeIdForUrl(id),
					'limit',
					'7'
				]),
			_List_Nil);
		return A4(
			$author$project$Api$Request$get,
			token,
			toMsg,
			uri,
			$elm$json$Json$Decode$list($author$project$Payment$Payment$annualStatementDecoder));
	});
var $author$project$Payment$Payment$loadByIdCmd = F4(
	function (token, _v0, toMsg, id) {
		var year = _v0.kC;
		var period = _v0.jv;
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'payments',
					'deliverer',
					$author$project$Deliverer$Deliverer$encodeIdForUrl(id),
					$elm$core$String$fromInt(year),
					$elm$core$String$fromInt(period)
				]),
			_List_Nil);
		return A4($author$project$Api$Request$get, token, toMsg, uri, $author$project$Payment$Payment$slipDecoder);
	});
var $author$project$Payment$Payment$loadSummariesByIdCmd = F3(
	function (token, toMsg, id) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'wageperiods',
					'deliverer',
					$author$project$Deliverer$Deliverer$encodeIdForUrl(id),
					'limit',
					'95'
				]),
			_List_Nil);
		return A4(
			$author$project$Api$Request$get,
			token,
			toMsg,
			uri,
			$elm$json$Json$Decode$list($author$project$Payment$Payment$monthlySummaryDecoder));
	});
var $author$project$Payment$Archive$actionIdFor = function (id) {
	return A2($author$project$Portal$Waiting$Id, 'archive', id);
};
var $author$project$Payment$Archive$singleAction = function (id) {
	return $author$project$Portal$Waiting$singleAction(
		$author$project$Payment$Archive$actionIdFor(id));
};
var $author$project$Payment$Archive$loadingAnnualSummaries = $author$project$Payment$Archive$singleAction('loadingAnnualSummaries');
var $author$project$Payment$Archive$loadingDeliverers = $author$project$Payment$Archive$singleAction('loadingDeliverers');
var $author$project$Payment$Archive$loadingMonthlyPayment = $author$project$Payment$Archive$singleAction('loadingMonthlyPayment');
var $author$project$Payment$Archive$loadingSummaries = $author$project$Payment$Archive$singleAction('loadingSummaries');
var $author$project$Payment$Archive$BackendRespondedDeliverers = function (a) {
	return {$: 0, a: a};
};
var $author$project$Deliverer$Deliverer$findByNameCmd = F3(
	function (token, toMsg, name) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['deliverers', 'find']),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'name', name)
				]));
		return A4(
			$author$project$Api$Request$get,
			token,
			toMsg,
			uri,
			$elm$json$Json$Decode$list($author$project$Deliverer$Deliverer$delivererDecoder));
	});
var $elm_community$string_extra$String$Extra$regexFromString = A2(
	$elm$core$Basics$composeR,
	$elm$regex$Regex$fromString,
	$elm$core$Maybe$withDefault($elm$regex$Regex$never));
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $elm_community$string_extra$String$Extra$underscored = function (string) {
	return $elm$core$String$toLower(
		A3(
			$elm$regex$Regex$replace,
			$elm_community$string_extra$String$Extra$regexFromString('[_-\\s]+'),
			$elm$core$Basics$always('_'),
			A3(
				$elm$regex$Regex$replace,
				$elm_community$string_extra$String$Extra$regexFromString('([a-z\\d])([A-Z]+)'),
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.nY;
					},
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$filterMap($elm$core$Basics$identity),
						$elm$core$String$join('_'))),
				$elm$core$String$trim(string))));
};
var $author$project$UI$Tag$query = function (_v0) {
	var name = _v0.ft;
	var value = _v0.kt;
	return A2(
		$elm$url$Url$Builder$string,
		'tag_' + $elm_community$string_extra$String$Extra$underscored(name),
		value);
};
var $author$project$Deliverer$Deliverer$findByTagCmd = F3(
	function (token, toMsg, tag) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['deliverers', 'find']),
			_List_fromArray(
				[
					$author$project$UI$Tag$query(tag)
				]));
		return A4(
			$author$project$Api$Request$get,
			token,
			toMsg,
			uri,
			$elm$json$Json$Decode$list($author$project$Deliverer$Deliverer$delivererDecoder));
	});
var $author$project$Payment$Archive$Lastname = function (a) {
	return {$: 0, a: a};
};
var $author$project$Payment$Archive$ParadiseId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Payment$Archive$StartsWithMinimalThreeRequired = 0;
var $elm_community$maybe_extra$Maybe$Extra$isJust = function (m) {
	if (m.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $author$project$UI$Paradise$canBeId = function (string) {
	return $elm_community$maybe_extra$Maybe$Extra$isJust(
		$elm$core$String$toInt(string));
};
var $author$project$Payment$Archive$searchFormDecoder = function () {
	var strDecoder = A2(
		$arowM$elm_form_decoder$Form$Decoder$assert,
		A2($arowM$elm_form_decoder$Form$Decoder$minLength, 0, 3),
		$arowM$elm_form_decoder$Form$Decoder$identity);
	return $arowM$elm_form_decoder$Form$Decoder$with(
		function (s) {
			return $author$project$UI$Paradise$canBeId(s) ? A2($arowM$elm_form_decoder$Form$Decoder$map, $author$project$Payment$Archive$ParadiseId, strDecoder) : A2($arowM$elm_form_decoder$Form$Decoder$map, $author$project$Payment$Archive$Lastname, strDecoder);
		});
}();
var $author$project$UI$Tag$Tag = $elm$core$Basics$identity;
var $author$project$UI$Tag$make = $elm$core$Basics$identity;
var $author$project$UI$Paradise$tag = function (value) {
	return $author$project$UI$Tag$make(
		{ft: $author$project$UI$Paradise$tagName, kt: value});
};
var $author$project$Payment$Archive$withValidationErrors = F2(
	function (errors, model) {
		var searchForm = model.cC;
		return _Utils_update(
			model,
			{
				cC: _Utils_update(
					searchForm,
					{f_: errors})
			});
	});
var $author$project$Payment$Archive$withoutValidationErrors = $author$project$Payment$Archive$withValidationErrors(_List_Nil);
var $author$project$Payment$Archive$search = F2(
	function (share, model) {
		var token = $author$project$Portal$Share$token(share);
		var _v0 = A2($arowM$elm_form_decoder$Form$Decoder$run, $author$project$Payment$Archive$searchFormDecoder, model.cC.n3);
		if (!_v0.$) {
			if (_v0.a.$ === 1) {
				var paradiseId = _v0.a.a;
				return A3(
					$author$project$Portal$Return$withCommand,
					$author$project$Payment$Archive$loadingDeliverers,
					A3(
						$author$project$Deliverer$Deliverer$findByTagCmd,
						token,
						$author$project$Payment$Archive$BackendRespondedDeliverers,
						$author$project$UI$Paradise$tag(paradiseId)),
					_Utils_Tuple3(
						share,
						$author$project$Payment$Archive$withoutValidationErrors(model),
						$elm$core$Platform$Cmd$none));
			} else {
				var lastname = _v0.a.a;
				return A3(
					$author$project$Portal$Return$withCommand,
					$author$project$Payment$Archive$loadingDeliverers,
					A3($author$project$Deliverer$Deliverer$findByNameCmd, token, $author$project$Payment$Archive$BackendRespondedDeliverers, lastname),
					_Utils_Tuple3(
						share,
						$author$project$Payment$Archive$withoutValidationErrors(model),
						$elm$core$Platform$Cmd$none));
			}
		} else {
			var errors = _v0.a;
			return _Utils_Tuple3(
				share,
				A2($author$project$Payment$Archive$withValidationErrors, errors, model),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Payment$Archive$update = F3(
	function (msg, share, model) {
		var token = $author$project$Portal$Share$token(share);
		var statusChange = function (st) {
			return _Utils_Tuple3(
				share,
				_Utils_update(
					model,
					{nS: st}),
				$elm$core$Platform$Cmd$none);
		};
		var selectMonthlyPayment = F2(
			function (loadedPayments, monthlyPayment) {
				return A3(
					$author$project$Portal$Return$withCommand,
					$author$project$Payment$Archive$loadingMonthlyPayment,
					A4(
						$author$project$Payment$Payment$loadByIdCmd,
						token,
						{jv: monthlyPayment.dK.jv, kC: monthlyPayment.dK.kC},
						$author$project$Payment$Archive$BackendRespondedMonthlyPayment,
						loadedPayments.cF.eg),
					statusChange(
						A2(
							$author$project$Payment$Archive$LoadingMonthlyPayment,
							loadedPayments,
							{cG: monthlyPayment})));
			});
		var selectAnnualPayment = F2(
			function (loadedPayments, annualPayment) {
				return statusChange(
					A2(
						$author$project$Payment$Archive$AnnualPaymentSelected,
						loadedPayments,
						{cG: annualPayment}));
			});
		var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		var modelChange = function (m) {
			return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
		};
		var err = F3(
			function (action, error, m) {
				return _Utils_Tuple3(
					A2(
						$author$project$Portal$Share$withHttpError,
						error,
						A2($author$project$Portal$Share$withoutWaitingAction, action, share)),
					m,
					$elm$core$Platform$Cmd$none);
			});
		var _v0 = _Utils_Tuple2(msg, model.nS);
		switch (_v0.a.$) {
			case 0:
				if (!_v0.a.a.$) {
					var deliverers = _v0.a.a.a;
					return A2(
						$author$project$Portal$Return$withoutAction,
						$author$project$Payment$Archive$loadingDeliverers,
						statusChange(
							$author$project$Payment$Archive$DeliverersFound(deliverers)));
				} else {
					var error = _v0.a.a.a;
					return A3(
						err,
						$author$project$Payment$Archive$loadingDeliverers,
						error,
						_Utils_update(
							model,
							{nS: $author$project$Payment$Archive$LoadingFailed}));
				}
			case 1:
				if (!_v0.a.a.$) {
					if (_v0.b.$ === 3) {
						var monthly = _v0.a.a.a;
						var m = _v0.b.a;
						return A2(
							$author$project$Portal$Return$withoutAction,
							$author$project$Payment$Archive$loadingSummaries,
							function () {
								var _v1 = m.bE;
								if (!_v1.$) {
									var annual = _v1.a;
									return statusChange(
										$author$project$Payment$Archive$PaymentsLoaded(
											A3(
												$author$project$Payment$Archive$LoadedPayments,
												m.e4,
												m.cF,
												{bE: annual, bT: monthly})));
								} else {
									return statusChange(
										$author$project$Payment$Archive$LoadingPayments(
											_Utils_update(
												m,
												{
													bT: $elm$core$Maybe$Just(monthly)
												})));
								}
							}());
					} else {
						return noChange;
					}
				} else {
					var error = _v0.a.a.a;
					return A3(
						err,
						$author$project$Payment$Archive$loadingSummaries,
						error,
						_Utils_update(
							model,
							{nS: $author$project$Payment$Archive$LoadingFailed}));
				}
			case 2:
				if (!_v0.a.a.$) {
					if (_v0.b.$ === 3) {
						var annual = _v0.a.a.a;
						var m = _v0.b.a;
						return A2(
							$author$project$Portal$Return$withoutAction,
							$author$project$Payment$Archive$loadingAnnualSummaries,
							function () {
								var _v2 = m.bT;
								if (!_v2.$) {
									var monthly = _v2.a;
									return statusChange(
										$author$project$Payment$Archive$PaymentsLoaded(
											A3(
												$author$project$Payment$Archive$LoadedPayments,
												m.e4,
												m.cF,
												{bE: annual, bT: monthly})));
								} else {
									return statusChange(
										$author$project$Payment$Archive$LoadingPayments(
											_Utils_update(
												m,
												{
													bE: $elm$core$Maybe$Just(annual)
												})));
								}
							}());
					} else {
						return noChange;
					}
				} else {
					var error = _v0.a.a.a;
					return A3(
						err,
						$author$project$Payment$Archive$loadingAnnualSummaries,
						error,
						_Utils_update(
							model,
							{nS: $author$project$Payment$Archive$LoadingFailed}));
				}
			case 7:
				switch (_v0.b.$) {
					case 4:
						var monthlyPayment = _v0.a.a;
						var loadedPayments = _v0.b.a;
						return A2(selectMonthlyPayment, loadedPayments, monthlyPayment);
					case 7:
						var monthlyPayment = _v0.a.a;
						var _v3 = _v0.b;
						var loadedPayments = _v3.a;
						return A2(selectMonthlyPayment, loadedPayments, monthlyPayment);
					case 5:
						var monthlyPayment = _v0.a.a;
						var _v4 = _v0.b;
						var loadedPayments = _v4.a;
						return A2(selectMonthlyPayment, loadedPayments, monthlyPayment);
					default:
						return noChange;
				}
			case 3:
				if (!_v0.a.a.$) {
					if (_v0.b.$ === 6) {
						var monthlyPayment = _v0.a.a.a;
						var _v5 = _v0.b;
						var loadedPayments = _v5.a;
						var selectedPayment = _v5.b.cG;
						return A2(
							$author$project$Portal$Return$withoutAction,
							$author$project$Payment$Archive$loadingMonthlyPayment,
							statusChange(
								A2(
									$author$project$Payment$Archive$MonthlyPaymentSelected,
									loadedPayments,
									{cG: monthlyPayment, j_: selectedPayment})));
					} else {
						return noChange;
					}
				} else {
					var error = _v0.a.a.a;
					return A3(
						err,
						$author$project$Payment$Archive$loadingMonthlyPayment,
						error,
						_Utils_update(
							model,
							{nS: $author$project$Payment$Archive$LoadingFailed}));
				}
			case 8:
				switch (_v0.b.$) {
					case 4:
						var annualPayment = _v0.a.a;
						var loadedPayments = _v0.b.a;
						return A2(selectAnnualPayment, loadedPayments, annualPayment);
					case 5:
						var annualPayment = _v0.a.a;
						var _v6 = _v0.b;
						var loadedPayments = _v6.a;
						return A2(selectAnnualPayment, loadedPayments, annualPayment);
					case 7:
						var annualPayment = _v0.a.a;
						var _v7 = _v0.b;
						var loadedPayments = _v7.a;
						return A2(selectAnnualPayment, loadedPayments, annualPayment);
					default:
						return noChange;
				}
			case 4:
				var _v8 = _v0.a;
				var searchForm = _v8.a;
				var value = _v8.b;
				return modelChange(
					_Utils_update(
						model,
						{
							cC: _Utils_update(
								searchForm,
								{n3: value})
						}));
			case 5:
				var _v9 = _v0.a;
				return A2($author$project$Payment$Archive$search, share, model);
			default:
				var deliverer = _v0.a.a;
				var statements = _v0.b;
				var _v10 = $author$project$Payment$Archive$deliverersOf(statements);
				if (_v10.a.$ === 1) {
					var _v11 = _v10.a;
					return noChange;
				} else {
					if (!_v10.b.$) {
						var deliverers = _v10.a.a;
						var selectedDeliverer = _v10.b.a;
						return (!_Utils_eq(deliverer, selectedDeliverer)) ? A3(
							$author$project$Portal$Return$withCommand,
							$author$project$Payment$Archive$loadingAnnualSummaries,
							A3($author$project$Payment$Payment$loadAnnualSummariesByIdCmd, token, $author$project$Payment$Archive$BackendRespondedArchiveAnnualSummaries, deliverer.eg),
							A3(
								$author$project$Portal$Return$withCommand,
								$author$project$Payment$Archive$loadingSummaries,
								A3($author$project$Payment$Payment$loadSummariesByIdCmd, token, $author$project$Payment$Archive$BackendRespondedArchiveSummaries, deliverer.eg),
								statusChange(
									$author$project$Payment$Archive$LoadingPayments(
										{bE: $elm$core$Maybe$Nothing, e4: deliverers, bT: $elm$core$Maybe$Nothing, cF: deliverer})))) : noChange;
					} else {
						var deliverers = _v10.a.a;
						var _v12 = _v10.b;
						return A3(
							$author$project$Portal$Return$withCommand,
							$author$project$Payment$Archive$loadingAnnualSummaries,
							A3($author$project$Payment$Payment$loadAnnualSummariesByIdCmd, token, $author$project$Payment$Archive$BackendRespondedArchiveAnnualSummaries, deliverer.eg),
							A3(
								$author$project$Portal$Return$withCommand,
								$author$project$Payment$Archive$loadingSummaries,
								A3($author$project$Payment$Payment$loadSummariesByIdCmd, token, $author$project$Payment$Archive$BackendRespondedArchiveSummaries, deliverer.eg),
								statusChange(
									$author$project$Payment$Archive$LoadingPayments(
										{bE: $elm$core$Maybe$Nothing, e4: deliverers, bT: $elm$core$Maybe$Nothing, cF: deliverer}))));
					}
				}
		}
	});
var $author$project$Payment$DelivererOverview$Failed = {$: 2};
var $author$project$Payment$DelivererOverview$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Payment$DelivererOverview$next = function (status) {
	if (!status.$) {
		var summaries = status.a.cK;
		var annualSummaries = status.a.cX;
		var _v1 = _Utils_Tuple2(summaries, annualSummaries);
		if ((!_v1.a.$) && (!_v1.b.$)) {
			var s = _v1.a.a;
			var a = _v1.b.a;
			return $author$project$Payment$DelivererOverview$Loaded(
				{cX: a, cK: s, cP: $Gizra$elm_all_set$EverySet$empty, cQ: $Gizra$elm_all_set$EverySet$empty});
		} else {
			return status;
		}
	} else {
		return status;
	}
};
var $author$project$Payment$DelivererOverview$update = F3(
	function (msg, share, model) {
		var to = function (route) {
			return _Utils_Tuple3(
				A2($author$project$Portal$Share$withNewRoute, route, share),
				model,
				$elm$core$Platform$Cmd$none);
		};
		var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		var onLoaded = function (f) {
			switch (model.$) {
				case 1:
					var loaded = model.a;
					return f(loaded);
				case 0:
					return noChange;
				default:
					return noChange;
			}
		};
		var onLoading = function (f) {
			switch (model.$) {
				case 1:
					return noChange;
				case 0:
					var loading = model.a;
					return f(loading);
				default:
					return noChange;
			}
		};
		var modelChange = function (m) {
			return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
		};
		var err = F3(
			function (action, error, m) {
				return _Utils_Tuple3(
					A2(
						$author$project$Portal$Share$withHttpError,
						error,
						A2($author$project$Portal$Share$withoutWaitingAction, action, share)),
					m,
					$elm$core$Platform$Cmd$none);
			});
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var summaries = msg.a.a;
					return onLoading(
						function (loading) {
							return A2(
								$author$project$Portal$Return$withoutAction,
								$author$project$Payment$DelivererOverview$loadingSummaries,
								modelChange(
									$author$project$Payment$DelivererOverview$next(
										$author$project$Payment$DelivererOverview$Loading(
											_Utils_update(
												loading,
												{
													cK: $elm$core$Maybe$Just(summaries)
												})))));
						});
				} else {
					var error = msg.a.a;
					return A3(err, $author$project$Payment$DelivererOverview$loadingSummaries, error, $author$project$Payment$DelivererOverview$Failed);
				}
			case 1:
				if (!msg.a.$) {
					var annualSummaries = msg.a.a;
					return onLoading(
						function (loading) {
							return A2(
								$author$project$Portal$Return$withoutAction,
								$author$project$Payment$DelivererOverview$loadingAnnualSummaries,
								modelChange(
									$author$project$Payment$DelivererOverview$next(
										$author$project$Payment$DelivererOverview$Loading(
											_Utils_update(
												loading,
												{
													cX: $elm$core$Maybe$Just(annualSummaries)
												})))));
						});
				} else {
					var error = msg.a.a;
					return A3(err, $author$project$Payment$DelivererOverview$loadingAnnualSummaries, error, $author$project$Payment$DelivererOverview$Failed);
				}
			case 2:
				var wagePeriod = msg.a.dK;
				return to(
					A2($author$project$Portal$Route$PaymentsSummaryDetail, wagePeriod.kC, wagePeriod.jv));
			case 3:
				var year = msg.a.kC;
				return to(
					$author$project$Portal$Route$PaymentsSummaryAnnualDetail(year));
			case 4:
				var summary = msg.a;
				return onLoaded(
					function (loaded) {
						return modelChange(
							$author$project$Payment$DelivererOverview$Loaded(
								_Utils_update(
									loaded,
									{
										cP: A2($Gizra$elm_all_set$EverySet$insert, summary, loaded.cP)
									})));
					});
			case 5:
				var annualSummary = msg.a;
				return onLoaded(
					function (loaded) {
						return modelChange(
							$author$project$Payment$DelivererOverview$Loaded(
								_Utils_update(
									loaded,
									{
										cQ: A2($Gizra$elm_all_set$EverySet$insert, annualSummary, loaded.cQ)
									})));
					});
			case 6:
				var summary = msg.a;
				return onLoaded(
					function (loaded) {
						return modelChange(
							$author$project$Payment$DelivererOverview$Loaded(
								_Utils_update(
									loaded,
									{
										cP: A2($Gizra$elm_all_set$EverySet$remove, summary, loaded.cP)
									})));
					});
			default:
				var annualSummary = msg.a;
				return onLoaded(
					function (loaded) {
						return modelChange(
							$author$project$Payment$DelivererOverview$Loaded(
								_Utils_update(
									loaded,
									{
										cQ: A2($Gizra$elm_all_set$EverySet$remove, annualSummary, loaded.cQ)
									})));
					});
		}
	});
var $author$project$Payment$Detail$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Payment$Detail$update = F3(
	function (msg, share, model) {
		var modelChange = function (m) {
			return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
		};
		var id = function () {
			switch (model.$) {
				case 0:
					var i = model.a;
					return i;
				case 1:
					var paymentSlip = model.a;
					var wagePeriod = function () {
						if (!paymentSlip.$) {
							var payment = paymentSlip.a;
							return payment.dK;
						} else {
							var payment = paymentSlip.a;
							return payment.dK;
						}
					}();
					return {jv: wagePeriod.jv, kC: wagePeriod.kC};
				default:
					var i = model.a;
					return i;
			}
		}();
		var withoutAction = function (action) {
			return $author$project$Portal$Return$withoutAction(
				action(id));
		};
		var err = F3(
			function (action, error, m) {
				return _Utils_Tuple3(
					A2(
						$author$project$Portal$Share$withHttpError,
						error,
						A2(
							$author$project$Portal$Share$withoutWaitingAction,
							action(id),
							share)),
					m,
					$elm$core$Platform$Cmd$none);
			});
		if (!msg.$) {
			var payment = msg.a;
			return A2(
				withoutAction,
				$author$project$Payment$Detail$loadingCompensationDetail,
				modelChange(
					$author$project$Payment$Detail$Loaded(payment)));
		} else {
			var error = msg.a;
			return A3(err, $author$project$Payment$Detail$loadingCompensationDetail, error, model);
		}
	});
var $author$project$Payment$DistributionPointOverview$BackendRespondedOverview = function (a) {
	return {$: 2, a: a};
};
var $author$project$Payment$DistributionPointOverview$Failed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Payment$DistributionPointOverview$LoadedWagePeriods = function (a) {
	return {$: 1, a: a};
};
var $author$project$Payment$DistributionPointOverview$NoWagePeriodSelected = {$: 0};
var $author$project$Payment$DistributionPointOverview$OverviewLoaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Payment$DistributionPointOverview$WagePeriodSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Payment$DistributionPointOverview$dpIdFrom = function (model) {
	switch (model.$) {
		case 0:
			var dpId = model.a.lK;
			return dpId;
		case 1:
			var dpId = model.a.lK;
			return dpId;
		default:
			var dpId = model.a.lK;
			return dpId;
	}
};
var $author$project$Payment$DistributionPointOverview$Element = F5(
	function (id, name, elementType, deliverers, tags) {
		return {e4: deliverers, iu: elementType, eg: id, ft: name, kn: tags};
	});
var $author$project$Payment$DistributionPointOverview$Deliverer = F6(
	function (id, salutation, firstName, lastName, tags, compensations) {
		return {aD: compensations, fc: firstName, eg: id, fo: lastName, hi: salutation, kn: tags};
	});
var $author$project$Payment$DistributionPointOverview$delivererDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'compensations',
	$elm$json$Json$Decode$list($author$project$Payment$Payment$compensationDecoder),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'tags',
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
		$elm$core$Dict$empty,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'lastName',
			$elm$json$Json$Decode$string,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'firstName',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'salutation',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$author$project$Deliverer$Deliverer$idDecoder,
						$elm$json$Json$Decode$succeed($author$project$Payment$DistributionPointOverview$Deliverer)))))));
var $author$project$Payment$DistributionPointOverview$ElementId = $elm$core$Basics$identity;
var $author$project$Payment$DistributionPointOverview$elementIdDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (id) {
		return $elm$json$Json$Decode$succeed(id);
	},
	$danyx23$elm_uuid$Uuid$decoder);
var $author$project$Payment$DistributionPointOverview$UnknownElementType = $elm$core$Basics$identity;
var $author$project$Payment$DistributionPointOverview$elementTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		return $elm$json$Json$Decode$succeed(string);
	},
	$elm$json$Json$Decode$string);
var $author$project$Payment$DistributionPointOverview$elementDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'tags',
	$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
	$elm$core$Dict$empty,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'deliverers',
		$elm$json$Json$Decode$list($author$project$Payment$DistributionPointOverview$delivererDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'type',
			$author$project$Payment$DistributionPointOverview$elementTypeDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$author$project$Payment$DistributionPointOverview$elementIdDecoder,
					$elm$json$Json$Decode$succeed($author$project$Payment$DistributionPointOverview$Element))))));
var $author$project$Payment$DistributionPointOverview$decoder = A2(
	$elm$json$Json$Decode$field,
	'elements',
	$elm$json$Json$Decode$list($author$project$Payment$DistributionPointOverview$elementDecoder));
var $author$project$Payment$DistributionPointOverview$loadCmd = F3(
	function (token, _v0, toMsg) {
		var distributionPointId = _v0.c2;
		var year = _v0.kC;
		var period = _v0.jv;
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'distributionpoints',
					$author$project$DistributionPoint$DistributionPoint$encodeIdForUrl(distributionPointId),
					'payments',
					'wageperiods',
					$elm$core$String$fromInt(year),
					$elm$core$String$fromInt(period)
				]),
			_List_Nil);
		return A4($author$project$Api$Request$get, token, toMsg, uri, $author$project$Payment$DistributionPointOverview$decoder);
	});
var $author$project$Payment$DistributionPointOverview$loadingOverview = $author$project$Payment$DistributionPointOverview$singleAction('loadingoverview');
var $author$project$Payment$DistributionPointOverview$delivererHasAnyWord = F2(
	function (words, _v0) {
		var firstName = _v0.fc;
		var lastName = _v0.fo;
		var tags = _v0.kn;
		return A2(
			$elm$core$List$any,
			function (w) {
				return A2(
					$author$project$Reference$hasText,
					w,
					{
						ft: A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							lastName,
							function (f) {
								return f + (' ' + lastName);
							},
							firstName),
						kn: tags
					});
			},
			words);
	});
var $author$project$Payment$DistributionPointOverview$filteredDeliverers = F2(
	function (words, deliverers) {
		return A2(
			$elm$core$List$filter,
			$author$project$Payment$DistributionPointOverview$delivererHasAnyWord(words),
			deliverers);
	});
var $author$project$Payment$DistributionPointOverview$filteredElement = F2(
	function (_v0, element) {
		var anyWords = _v0.kR;
		if (A2(
			$elm$core$List$any,
			function (w) {
				return A2($author$project$Reference$hasText, w, element);
			},
			anyWords)) {
			return $elm$core$Maybe$Just(element);
		} else {
			var _v1 = A2($author$project$Payment$DistributionPointOverview$filteredDeliverers, anyWords, element.e4);
			if (!_v1.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var dels = _v1;
				return $elm$core$Maybe$Just(
					_Utils_update(
						element,
						{e4: dels}));
			}
		}
	});
var $author$project$Payment$Filter$isWhitespace = function (_char) {
	return (_char === ' ') || ((_char === '\t') || ((_char === '\n') || (_char === '\u000D')));
};
var $author$project$Payment$Filter$spaces = $elm$parser$Parser$chompWhile($author$project$Payment$Filter$isWhitespace);
var $author$project$Payment$Filter$addWord = F2(
	function (word, model) {
		var anyWords = model.kR;
		return _Utils_update(
			model,
			{
				kR: A2($elm$core$List$cons, word, anyWords)
			});
	});
var $author$project$Payment$Filter$empty = {kR: _List_Nil};
var $author$project$Payment$Filter$words = A2(
	$elm$parser$Parser$loop,
	$author$project$Payment$Filter$empty,
	function (model) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(
							function (word) {
								return $elm$parser$Parser$Loop(
									A2($author$project$Payment$Filter$addWord, word, model));
							}),
						$elm$parser$Parser$token('\"')),
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$getChompedString(
							$elm$parser$Parser$chompUntilEndOr('\"')),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$end,
									A2(
									$elm$parser$Parser$ignorer,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(0),
										$elm$parser$Parser$token('\"')),
									$author$project$Payment$Filter$spaces)
								])))),
					A2(
					$elm$parser$Parser$keeper,
					$elm$parser$Parser$succeed(
						function (word) {
							return $elm$parser$Parser$Loop(
								A2($author$project$Payment$Filter$addWord, word, model));
						}),
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$getChompedString(
							A2(
								$elm$parser$Parser$ignorer,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed(0),
									$elm$parser$Parser$chompIf(
										function (c) {
											return (!$author$project$Payment$Filter$isWhitespace(c)) && (c !== '\"');
										})),
								$elm$parser$Parser$chompWhile(
									function (c) {
										return (!$author$project$Payment$Filter$isWhitespace(c)) && (c !== '\"');
									}))),
						$author$project$Payment$Filter$spaces)),
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return $elm$parser$Parser$Done(
							_Utils_update(
								model,
								{
									kR: $elm$core$List$reverse(model.kR)
								}));
					},
					$elm$parser$Parser$end)
				]));
	});
var $author$project$Payment$Filter$paddedWords = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$author$project$Payment$Filter$spaces),
	$author$project$Payment$Filter$words);
var $author$project$Payment$Filter$from = function (text) {
	var _v0 = A2($elm$parser$Parser$run, $author$project$Payment$Filter$paddedWords, text);
	if (!_v0.$) {
		var ws = _v0.a;
		return ws;
	} else {
		return {
			kR: $elm$core$String$words(text)
		};
	}
};
var $author$project$Payment$DistributionPointOverview$filteredElements = F2(
	function (filterText, elements) {
		if (filterText === '') {
			return elements;
		} else {
			return function (f) {
				return A2(
					$elm$core$List$filterMap,
					$author$project$Payment$DistributionPointOverview$filteredElement(f),
					elements);
			}(
				$author$project$Payment$Filter$from(filterText));
		}
	});
var $author$project$Payment$DistributionPointOverview$updatedFiltered = function (_v0) {
	var model = _v0.b;
	if (model.$ === 1) {
		var loaded = model.a;
		var selected = loaded.nI;
		var filterText = loaded.fb;
		if (selected.$ === 2) {
			var overview = selected.a;
			var all = overview.aX;
			return $author$project$Payment$DistributionPointOverview$LoadedWagePeriods(
				_Utils_update(
					loaded,
					{
						nI: $author$project$Payment$DistributionPointOverview$OverviewLoaded(
							_Utils_update(
								overview,
								{
									eb: A2($author$project$Payment$DistributionPointOverview$filteredElements, filterText, all)
								}))
					}));
		} else {
			return model;
		}
	} else {
		return model;
	}
};
var $author$project$Payment$DistributionPointOverview$wagePeriodsIn = function (model) {
	if (model.$ === 1) {
		var wagePeriods = model.a.hG;
		return $elm$core$Maybe$Just(wagePeriods);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Payment$DistributionPointOverview$whenWaiting = function (msg) {
	switch (msg.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 0;
		default:
			return 0;
	}
};
var $author$project$Payment$DistributionPointOverview$update = F3(
	function (msg, share, model) {
		if (A3($author$project$Portal$Share$allowed, $author$project$Payment$DistributionPointOverview$whenWaiting, msg, share) === 1) {
			return _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		} else {
			var token = $author$project$Portal$Share$token(share);
			var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
			var onLoaded = function (f) {
				if (model.$ === 1) {
					var loaded = model.a;
					return f(loaded);
				} else {
					return noChange;
				}
			};
			var onSelected = function (f) {
				return onLoaded(
					function (loaded) {
						var selected = loaded.nI;
						switch (selected.$) {
							case 1:
								var wagePeriod = selected.a;
								return A2(f, loaded, wagePeriod);
							case 2:
								var wagePeriod = selected.a.dK;
								return A2(f, loaded, wagePeriod);
							default:
								return noChange;
						}
					});
			};
			var modelChange = function (m) {
				return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
			};
			var selectionChange = function (s) {
				if (model.$ === 1) {
					var loaded = model.a;
					return modelChange(
						$author$project$Payment$DistributionPointOverview$LoadedWagePeriods(
							_Utils_update(
								loaded,
								{nI: s})));
				} else {
					return noChange;
				}
			};
			var dpId = $author$project$Payment$DistributionPointOverview$dpIdFrom(model);
			var actionKey = dpId;
			var err = F3(
				function (toAction, error, m) {
					return _Utils_Tuple3(
						A2(
							$author$project$Portal$Share$withHttpError,
							error,
							A2(
								$author$project$Portal$Share$withoutWaitingAction,
								toAction(actionKey),
								share)),
						m,
						$elm$core$Platform$Cmd$none);
				});
			var withoutAction = function (toAction) {
				return $author$project$Portal$Return$withoutAction(
					toAction(actionKey));
			};
			return A2(
				$author$project$Portal$Return$mapModel,
				$author$project$Payment$DistributionPointOverview$updatedFiltered,
				function () {
					switch (msg.$) {
						case 0:
							if (!msg.a.$) {
								var wagePeriods = msg.a.a;
								return A2(
									withoutAction,
									$author$project$Payment$DistributionPointOverview$loadingWagePeriods,
									modelChange(
										$author$project$Payment$DistributionPointOverview$LoadedWagePeriods(
											{lK: dpId, fb: '', nI: $author$project$Payment$DistributionPointOverview$NoWagePeriodSelected, hG: wagePeriods})));
							} else {
								var error = msg.a.a;
								return A3(
									err,
									$author$project$Payment$DistributionPointOverview$loadingWagePeriods,
									error,
									$author$project$Payment$DistributionPointOverview$Failed(
										{lK: dpId}));
							}
						case 1:
							var wagePeriod = msg.a;
							var _v1 = $author$project$Payment$DistributionPointOverview$wagePeriodsIn(model);
							if (!_v1.$) {
								return A3(
									$author$project$Portal$Return$withCommand,
									$author$project$Payment$DistributionPointOverview$loadingOverview(dpId),
									A3(
										$author$project$Payment$DistributionPointOverview$loadCmd,
										token,
										{c2: dpId, jv: wagePeriod.jv, kC: wagePeriod.kC},
										$author$project$Payment$DistributionPointOverview$BackendRespondedOverview),
									selectionChange(
										$author$project$Payment$DistributionPointOverview$WagePeriodSelected(wagePeriod)));
							} else {
								return noChange;
							}
						case 2:
							if (!msg.a.$) {
								var elements = msg.a.a;
								return A2(
									withoutAction,
									$author$project$Payment$DistributionPointOverview$loadingOverview,
									onSelected(
										F2(
											function (_v2, selectedWagePeriod) {
												return selectionChange(
													$author$project$Payment$DistributionPointOverview$OverviewLoaded(
														{aX: elements, eb: elements, dK: selectedWagePeriod}));
											})));
							} else {
								var error = msg.a.a;
								return A3(
									err,
									$author$project$Payment$DistributionPointOverview$loadingOverview,
									error,
									$author$project$Payment$DistributionPointOverview$Failed(
										{lK: dpId}));
							}
						default:
							var filterText = msg.a;
							return onLoaded(
								function (loaded) {
									return modelChange(
										$author$project$Payment$DistributionPointOverview$LoadedWagePeriods(
											_Utils_update(
												loaded,
												{fb: filterText})));
								});
					}
				}());
		}
	});
var $author$project$Plan$CreatePlan$BackendRespondedPlanCreation = function (a) {
	return {$: 7, a: a};
};
var $author$project$Plan$CreatePlan$Failed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Plan$CreatePlan$GotSubHeaderMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Plan$Plan$createPlanBasedOnOtherPlanCmd = F4(
	function (token, toMsg, dpId, _v0) {
		var toCreate = _v0.ok;
		var copyFrom = _v0.lr;
		var uri = A2(
			$author$project$Api$Uri$for,
			A2($author$project$Plan$Plan$subPathWithDate, dpId, toCreate),
			_List_fromArray(
				[
					A2(
					$elm$url$Url$Builder$string,
					'based_on_plan_with_date',
					$author$project$Date$DeliveryDate$encodeForUrl(copyFrom))
				]));
		return A5(
			$author$project$Api$Request$post,
			token,
			toMsg,
			uri,
			$elm$http$Http$emptyBody,
			$elm$json$Json$Decode$succeed(0));
	});
var $author$project$Plan$CreatePlan$creatingPlan = $author$project$Plan$CreatePlan$singleAction('creatingPlan');
var $author$project$Date$Dict$map = $timo_weike$generic_collections$ManualDict$map;
var $timo_weike$generic_collections$ManualDict$member = F3(
	function (f, key, _v0) {
		var dict = _v0;
		return A2(
			$elm$core$Dict$member,
			f(key),
			dict);
	});
var $author$project$Date$Dict$member = $timo_weike$generic_collections$ManualDict$member($author$project$Date$Dict$toComparable);
var $author$project$Plan$CreatePlan$selectedDateHasPlan = function (model) {
	var _v0 = model.ck;
	if (_v0.$ === 1) {
		var dict = _v0.a;
		return A2($author$project$Date$Dict$member, model.dx, dict);
	} else {
		return false;
	}
};
var $author$project$Plan$CreatePlan$toDistributionPointId = function (status) {
	switch (status.$) {
		case 0:
			var dpId = status.a;
			return dpId;
		case 1:
			var distributionPoint = status.a;
			return distributionPoint.eg;
		default:
			var dpId = status.a;
			return dpId;
	}
};
var $author$project$Date$Icon$DeliveringPlan = 3;
var $author$project$Date$Icon$DraftPlan = 2;
var $author$project$Date$Icon$FinalPlan = 4;
var $author$project$Plan$CreatePlan$toState = function (status) {
	switch (status) {
		case 0:
			return 2;
		case 1:
			return 3;
		default:
			return 4;
	}
};
var $author$project$Plan$CreatePlan$whenWaiting = function (msg) {
	switch (msg.$) {
		case 0:
			return 0;
		case 1:
			return 0;
		case 2:
			return 0;
		case 4:
			return 0;
		case 3:
			return 0;
		case 5:
			return 1;
		case 6:
			return 1;
		default:
			return 0;
	}
};
var $author$project$Plan$CreatePlan$update = F3(
	function (msg, share, model) {
		return A2(
			$author$project$Portal$Return$ensureDataShared,
			$author$project$Plan$CreatePlan$shareDataFromModel,
			function () {
				if (A3($author$project$Portal$Share$allowed, $author$project$Plan$CreatePlan$whenWaiting, msg, share) === 1) {
					return _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
				} else {
					var withNotification = F2(
						function (message, _v8) {
							var s = _v8.a;
							var m = _v8.b;
							var cmd = _v8.c;
							return _Utils_Tuple3(
								A2($author$project$Portal$Share$withNotification, message, s),
								m,
								cmd);
						});
					var token = $author$project$Portal$Share$token(share);
					var to = function (route) {
						return _Utils_Tuple3(
							A2($author$project$Portal$Share$withNewRoute, route, share),
							model,
							$elm$core$Platform$Cmd$none);
					};
					var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
					var modelChange = function (m) {
						return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
					};
					var dpId = $author$project$Plan$CreatePlan$toDistributionPointId(model.bn);
					var actionKey = _Utils_Tuple2(dpId, model.aE);
					var err = F3(
						function (toAction, error, m) {
							return _Utils_Tuple3(
								A2(
									$author$project$Portal$Share$withHttpError,
									error,
									A2(
										$author$project$Portal$Share$withoutWaitingAction,
										toAction(actionKey),
										share)),
								m,
								$elm$core$Platform$Cmd$none);
						});
					var withCommand = function (toAction) {
						return $author$project$Portal$Return$withCommand(
							toAction(actionKey));
					};
					var withoutAction = function (toAction) {
						return $author$project$Portal$Return$withoutAction(
							toAction(actionKey));
					};
					switch (msg.$) {
						case 0:
							if (!msg.a.$) {
								var distributionPoint = msg.a.a;
								return A2(
									withoutAction,
									$author$project$Plan$CreatePlan$loadingDP,
									modelChange(
										_Utils_update(
											model,
											{
												bn: $author$project$Plan$CreatePlan$Loaded(distributionPoint)
											})));
							} else {
								if ((msg.a.a.$ === 3) && (msg.a.a.a === 404)) {
									var error = msg.a.a;
									return _Utils_eq(
										model.aE,
										$author$project$Portal$Share$today(share)) ? A3(
										err,
										$author$project$Plan$CreatePlan$loadingDP,
										error,
										_Utils_update(
											model,
											{
												bn: $author$project$Plan$CreatePlan$Failed(dpId)
											})) : A2(
										$author$project$Portal$Return$withMessage,
										A2($author$project$Portal$Message$info, 'Ongeldige datum', 'Het distributiepunt is niet geldig op de gevraagde datum. We hebben je daarom naar vandaag doorgewezen.'),
										A2(
											withoutAction,
											$author$project$Plan$CreatePlan$loadingDP,
											to(
												A2(
													$author$project$Portal$Route$DayPlanning,
													dpId,
													$author$project$Portal$Share$today(share)))));
								} else {
									var error = msg.a.a;
									return A3(
										err,
										$author$project$Plan$CreatePlan$loadingDP,
										error,
										_Utils_update(
											model,
											{
												bn: $author$project$Plan$CreatePlan$Failed(dpId)
											}));
								}
							}
						case 1:
							if (!msg.a.$) {
								var planStatuses = msg.a.a;
								return A2(
									withoutAction,
									$author$project$Plan$CreatePlan$loadingStatuses,
									modelChange(
										_Utils_update(
											model,
											{
												ck: $author$project$Plan$CreatePlan$Loaded(
													A2(
														$author$project$Date$Dict$map,
														F2(
															function (_v1, status) {
																return $author$project$Plan$CreatePlan$toState(status);
															}),
														planStatuses))
											})));
							} else {
								var error = msg.a.a;
								return A3(
									err,
									$author$project$Plan$CreatePlan$loadingStatuses,
									error,
									_Utils_update(
										model,
										{
											ck: $author$project$Plan$CreatePlan$Failed(0)
										}));
							}
						case 2:
							var planLoaderMsg = msg.a;
							return function (_v2) {
								var s = _v2.a;
								var m = _v2.b;
								var c = _v2.c;
								var _v3 = m.fB;
								if (_v3.$ === 3) {
									return _Utils_Tuple3(
										A2(
											$author$project$Portal$Share$withNewRoute,
											A2($author$project$Portal$Route$DayPlanning, dpId, model.aE),
											s),
										m,
										c);
								} else {
									return _Utils_Tuple3(s, m, c);
								}
							}(
								A2(
									$author$project$Plan$PlanLoader$mapModel,
									function (pAndD) {
										return _Utils_update(
											model,
											{fB: pAndD});
									},
									A2(
										$author$project$Plan$PlanLoader$registerErrorOnFailedExcept,
										$elm$http$Http$BadStatus(404),
										A2(
											$author$project$Plan$PlanLoader$mapCommand,
											$elm$core$Platform$Cmd$map($author$project$Plan$CreatePlan$SystemGotLoaderMsg),
											A6(
												$author$project$Plan$PlanLoader$update,
												share,
												token,
												$author$project$Plan$CreatePlan$loadingPlan(actionKey),
												$elm$core$Basics$identity,
												planLoaderMsg,
												model.fB)))));
						case 4:
							var subHeaderMsg = msg.a;
							var _v4 = A5(
								$author$project$Portal$Subheader$update,
								subHeaderMsg,
								share,
								$elm$core$Maybe$Just(dpId),
								model.aE,
								model.r);
							switch (_v4.a.$) {
								case 0:
									var _v5 = _v4.a;
									var _v6 = _v4.b;
									var s = _v6.a;
									var m = _v6.b;
									var cmd = _v6.c;
									return _Utils_Tuple3(
										s,
										_Utils_update(
											model,
											{r: m}),
										A2($elm$core$Platform$Cmd$map, $author$project$Plan$CreatePlan$GotSubHeaderMsg, cmd));
								case 1:
									var date = _v4.a.a;
									return to(
										A2($author$project$Portal$Route$DayPlanning, dpId, date));
								case 2:
									var date = _v4.a.a;
									return to(
										A2($author$project$Portal$Route$CreatePlan, dpId, date));
								default:
									return noChange;
							}
						case 3:
							var selected = msg.a;
							return modelChange(
								_Utils_update(
									model,
									{dx: selected}));
						case 5:
							var _v7 = $author$project$Plan$CreatePlan$selectedDateHasPlan(model);
							if (_v7) {
								return A3(
									withCommand,
									$author$project$Plan$CreatePlan$creatingPlan,
									A4(
										$author$project$Plan$Plan$createPlanBasedOnOtherPlanCmd,
										token,
										$author$project$Plan$CreatePlan$BackendRespondedPlanCreation,
										dpId,
										{
											lr: $author$project$Date$DeliveryDate$fromDate(model.dx),
											ok: model.aE
										}),
									noChange);
							} else {
								return noChange;
							}
						case 6:
							return noChange;
						default:
							if (!msg.a.$) {
								return to(
									A2($author$project$Portal$Route$DayPlanning, dpId, model.aE));
							} else {
								if ((msg.a.a.$ === 3) && (msg.a.a.a === 404)) {
									return A2(
										withNotification,
										A2(
											$author$project$Portal$Message$error,
											'Het gekozen plan bestaat niet',
											$elm$core$Maybe$Just('Het plan bestaat niet (meer), kies een andere dag of ververs de pagina om een actueel overzicht van de bestaande plannen te zien.')),
										A2(withoutAction, $author$project$Plan$CreatePlan$creatingPlan, noChange));
								} else {
									var error = msg.a.a;
									return A3(err, $author$project$Plan$CreatePlan$creatingPlan, error, model);
								}
							}
					}
				}
			}());
	});
var $author$project$Plan$DayPlanning$Failed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Plan$DayPlanning$FinalizedPlan = function (a) {
	return {$: 14, a: a};
};
var $author$project$Plan$DayPlanning$Finalizing = 0;
var $author$project$Plan$DayPlanning$GotSubHeaderMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Plan$DayPlanning$ListsMenuPopup = {$: 2};
var $author$project$Plan$DayPlanning$Reediting = 1;
var $author$project$Plan$DayPlanning$StatusUpdateFailurePopup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Plan$DayPlanning$SystemRespondedPlanDelete = function (a) {
	return {$: 8, a: a};
};
var $author$project$Plan$DayPlanning$changingPlan = $author$project$Plan$DayPlanning$singleAction('changingPlan');
var $author$project$Plan$DayPlanning$closePopup = function (model) {
	return _Utils_update(
		model,
		{b_: $author$project$Plan$DayPlanning$NoPopup});
};
var $author$project$Plan$Plan$planIdDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'validOn',
	A2(
		$elm$json$Json$Decode$andThen,
		function (d) {
			var _v0 = $author$project$Date$DeliveryDate$fromString(d);
			if (!_v0.$) {
				var date = _v0.a;
				return $elm$json$Json$Decode$succeed(date);
			} else {
				return $elm$json$Json$Decode$fail('Invalid date: ' + d);
			}
		},
		$elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['distributionPoint', 'id']),
		$author$project$DistributionPoint$DistributionPoint$idDecoder,
		$elm$json$Json$Decode$succeed($elm$core$Tuple$pair)));
var $author$project$Plan$Plan$deletePlanCmd = F4(
	function (token, toMsg, dpId, date) {
		var uri = A2(
			$author$project$Api$Uri$for,
			A2($author$project$Plan$Plan$subPathWithDate, dpId, date),
			_List_Nil);
		return A5($author$project$Api$Request$delete, token, toMsg, uri, $elm$http$Http$emptyBody, $author$project$Plan$Plan$planIdDecoder);
	});
var $author$project$Plan$DayPlanning$deletingPlan = $author$project$Plan$DayPlanning$singleAction('deletingPlan');
var $author$project$Plan$DayPlanning$deletingUnregisteredDeliverer = $author$project$Plan$DayPlanning$singleAction('deletingUnregisteredDeliverer');
var $author$project$Plan$Plan$HttpError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$Plan$StatusUpdateFailures = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Request$patchWithCustomError = F6(
	function (token, toMsg, toError, url, body, tracker) {
		return $elm$http$Http$request(
			{
				aA: body,
				aJ: A2($elm$http$Http$expectStringResponse, toMsg, toError),
				aK: $author$project$Api$Request$headers(token),
				aO: 'PATCH',
				aS: $elm$core$Maybe$Nothing,
				aU: $author$project$Api$Request$trackingFor(tracker),
				aW: url
			});
	});
var $author$project$Plan$Plan$ExpiredDeliverers = {$: 2};
var $author$project$Plan$Plan$InTheFuture = {$: 0};
var $author$project$Plan$Plan$UnassignedAssistantPositions = function (a) {
	return {$: 7, a: a};
};
var $author$project$Plan$Plan$UnassignedDistributionPoints = {$: 3};
var $author$project$Plan$Plan$UnassignedInserterPositions = function (a) {
	return {$: 8, a: a};
};
var $author$project$Plan$Plan$UnassignedPreSupplies = function (a) {
	return {$: 6, a: a};
};
var $author$project$Plan$Plan$UnassignedSegments = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$Plan$WagePeriodDeadlineExceeded = {$: 4};
var $author$project$Plan$Plan$WagePeriodDeadlineTooFarInFuture = {$: 5};
var $author$project$Api$Request$hasValue = function (value) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (s) {
			return _Utils_eq(
				$elm$core$String$toLower(s),
				$elm$core$String$toLower(value)) ? $elm$json$Json$Decode$succeed(0) : $elm$json$Json$Decode$fail('wrong type');
		},
		$elm$json$Json$Decode$string);
};
var $author$project$Plan$Plan$statusUpdateFailureDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$map,
			function (_v0) {
				return $author$project$Plan$Plan$ExpiredDeliverers;
			},
			A2(
				$elm$json$Json$Decode$field,
				'type',
				$author$project$Api$Request$hasValue('expiredDeliverers'))),
			A3(
			$elm$json$Json$Decode$map2,
			function (_v1) {
				return $author$project$Plan$Plan$UnassignedSegments;
			},
			A2(
				$elm$json$Json$Decode$field,
				'type',
				$author$project$Api$Request$hasValue('openSegments')),
			A2(
				$elm$json$Json$Decode$field,
				'segments',
				$elm$json$Json$Decode$list($author$project$DistributionPoint$DistributionPoint$segmentIdDecoder))),
			A2(
			$elm$json$Json$Decode$map,
			function (_v2) {
				return $author$project$Plan$Plan$InTheFuture;
			},
			A2(
				$elm$json$Json$Decode$field,
				'type',
				$author$project$Api$Request$hasValue('dateInFuture'))),
			A2(
			$elm$json$Json$Decode$map,
			function (_v3) {
				return $author$project$Plan$Plan$UnassignedDistributionPoints;
			},
			A2(
				$elm$json$Json$Decode$field,
				'type',
				$author$project$Api$Request$hasValue('openDistributionPoints'))),
			A2(
			$elm$json$Json$Decode$map,
			function (_v4) {
				return $author$project$Plan$Plan$WagePeriodDeadlineExceeded;
			},
			A2(
				$elm$json$Json$Decode$field,
				'type',
				$author$project$Api$Request$hasValue('wagePeriodDeadlineExceeded'))),
			A2(
			$elm$json$Json$Decode$map,
			function (_v5) {
				return $author$project$Plan$Plan$WagePeriodDeadlineTooFarInFuture;
			},
			A2(
				$elm$json$Json$Decode$field,
				'type',
				$author$project$Api$Request$hasValue('wagePeriodDeadlineTooFarInFuture'))),
			A3(
			$elm$json$Json$Decode$map2,
			function (_v6) {
				return $author$project$Plan$Plan$UnassignedPreSupplies;
			},
			A2(
				$elm$json$Json$Decode$field,
				'type',
				$author$project$Api$Request$hasValue('unassignedPreSupplies')),
			A2(
				$elm$json$Json$Decode$field,
				'unassignedPreSupplies',
				$elm$json$Json$Decode$list($author$project$DistributionPoint$DistributionPoint$preSupplyIdDecoder))),
			A3(
			$elm$json$Json$Decode$map2,
			function (_v7) {
				return $author$project$Plan$Plan$UnassignedAssistantPositions;
			},
			A2(
				$elm$json$Json$Decode$field,
				'type',
				$author$project$Api$Request$hasValue('unassignedAssistantPositions')),
			A2(
				$elm$json$Json$Decode$field,
				'unassignedAssistantPositions',
				$elm$json$Json$Decode$list($author$project$DistributionPoint$DistributionPoint$assistantPositionIdDecoder))),
			A3(
			$elm$json$Json$Decode$map2,
			function (_v8) {
				return $author$project$Plan$Plan$UnassignedInserterPositions;
			},
			A2(
				$elm$json$Json$Decode$field,
				'type',
				$author$project$Api$Request$hasValue('unassignedInserterPositions')),
			A2(
				$elm$json$Json$Decode$field,
				'unassignedInserterPositions',
				$elm$json$Json$Decode$list($author$project$DistributionPoint$DistributionPoint$inserterPositionIdDecoder)))
		]));
var $author$project$Plan$Plan$setPlanStatusCmd = F5(
	function (token, toMsg, dpId, date, status) {
		var uri = A2(
			$author$project$Api$Uri$for,
			A3($author$project$Plan$Plan$subPathWithDateAndSuffix, dpId, date, 'status'),
			_List_Nil);
		var toError = function (response) {
			switch (response.$) {
				case 0:
					var url = response.a;
					return $elm$core$Result$Err(
						$author$project$Plan$Plan$HttpError(
							$elm$http$Http$BadUrl(url)));
				case 1:
					return $elm$core$Result$Err(
						$author$project$Plan$Plan$HttpError($elm$http$Http$Timeout));
				case 2:
					return $elm$core$Result$Err(
						$author$project$Plan$Plan$HttpError($elm$http$Http$NetworkError));
				case 3:
					var metadata = response.a;
					var b = response.b;
					return $elm$core$Result$Err(
						function () {
							var _v2 = metadata.kf;
							if (_v2 === 412) {
								var _v3 = A2(
									$elm$json$Json$Decode$decodeString,
									A2(
										$elm$json$Json$Decode$field,
										'issues',
										$elm$json$Json$Decode$list($author$project$Plan$Plan$statusUpdateFailureDecoder)),
									b);
								if (!_v3.$) {
									var failures = _v3.a;
									return $author$project$Plan$Plan$StatusUpdateFailures(failures);
								} else {
									var err = _v3.a;
									return $author$project$Plan$Plan$HttpError(
										$elm$http$Http$BadBody(
											$elm$json$Json$Decode$errorToString(err)));
								}
							} else {
								return $author$project$Plan$Plan$HttpError(
									$elm$http$Http$BadStatus(metadata.kf));
							}
						}());
				default:
					var b = response.b;
					return $elm$core$Result$Ok(b);
			}
		};
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$string(
				function () {
					switch (status) {
						case 0:
							return 'draft';
						case 1:
							return 'delivering';
						default:
							return 'final';
					}
				}()));
		return A5($author$project$Api$Request$patchWithCustomError, token, toMsg, toError, uri, body);
	});
var $author$project$Plan$Plan$finalizePlanCmd = F4(
	function (token, toMsg, dpId, date) {
		return A5($author$project$Plan$Plan$setPlanStatusCmd, token, toMsg, dpId, date, 2);
	});
var $author$project$Plan$DayPlanning$finalizingPlan = $author$project$Plan$DayPlanning$singleAction('finalizingPlan');
var $author$project$Plan$DayPlanning$SavedPlan = function (a) {
	return {$: 13, a: a};
};
var $author$project$Plan$DayPlanning$toDistributionPointId = function (status) {
	switch (status.$) {
		case 0:
			var dpId = status.a;
			return dpId;
		case 1:
			var distributionPoint = status.a;
			return distributionPoint.eg;
		default:
			var dpId = status.a;
			return dpId;
	}
};
var $author$project$Plan$DayPlanning$Demand$NoImpact = {$: 0};
var $author$project$Plan$DayPlanning$Demand$PlanUpdated = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Plan$Supply$addBikeCluster = F4(
	function (id, deliverer, newCluster, supplyItems) {
		var newItem = A4(
			$author$project$Plan$Supply$bikeItem,
			id,
			deliverer,
			_List_fromArray(
				[newCluster]),
			$author$project$Plan$Supply$NotPreSupplied);
		return _Utils_Tuple3(
			_Utils_ap(
				supplyItems,
				_List_fromArray(
					[newItem])),
			$author$project$Plan$Supply$idOf(newItem),
			$author$project$Plan$Supply$nextId(id));
	});
var $author$project$Plan$Supply$addSegment = F4(
	function (items, id, clusterId, segmentId) {
		var _v0 = A2($author$project$Plan$Supply$findItemById, items, id);
		if (!_v0.$) {
			switch (_v0.a.$) {
				case 0:
					var item = _v0.a;
					var cluster = item.a.H;
					var newItem = A2(
						$author$project$Plan$Supply$withClusters,
						_List_fromArray(
							[
								_Utils_update(
								cluster,
								{
									bb: _Utils_ap(
										cluster.bb,
										_List_fromArray(
											[segmentId]))
								})
							]),
						item);
					return A3($author$project$Plan$Supply$replaceItem, id, newItem, items);
				case 1:
					var item = _v0.a;
					var clusters = item.a.k;
					var newItem = A2(
						$author$project$Plan$Supply$withClusters,
						A3(
							$elm_community$list_extra$List$Extra$updateIf,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.bX;
								},
								$elm$core$Basics$eq(clusterId)),
							function (cluster) {
								return _Utils_update(
									cluster,
									{
										bb: _Utils_ap(
											cluster.bb,
											_List_fromArray(
												[segmentId]))
									});
							},
							clusters),
						item);
					return A3($author$project$Plan$Supply$replaceItem, id, newItem, items);
				default:
					return items;
			}
		} else {
			return items;
		}
	});
var $author$project$Plan$Supply$canConvertToCar = function (item) {
	switch (item.$) {
		case 1:
			var clusters = item.a.k;
			return $elm$core$List$length(clusters) < 2;
		case 0:
			return true;
		default:
			return false;
	}
};
var $author$project$Plan$Selection$Cluster = function (a) {
	return {$: 2, a: a};
};
var $author$project$Plan$Selection$Maximized = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$Selection$Hidden = 0;
var $author$project$Plan$Selection$initMoving = 0;
var $author$project$Plan$Selection$cluster = F3(
	function (deliverer, clusterId, supplyItemId) {
		return $author$project$Plan$Selection$Cluster(
			{
				dU: clusterId,
				bl: deliverer,
				n: $author$project$Plan$Selection$Maximized($author$project$Plan$Selection$initMoving),
				fE: 0,
				dF: supplyItemId
			});
	});
var $author$project$DistributionPoint$DistributionPoint$containsCarSegments = F2(
	function (distributionPoint, segmentIds) {
		return !$elm$core$List$isEmpty(
			A2(
				$elm$core$List$filter,
				function (s) {
					return _Utils_eq(
						$author$project$DistributionPoint$DistributionPoint$segmentInfo(s).e2,
						$elm$core$Maybe$Just(2));
				},
				A2($author$project$DistributionPoint$DistributionPoint$findSegmentsOnId, distributionPoint, segmentIds)));
	});
var $author$project$Plan$Selection$findSelectedCluster = F2(
	function (selected, supplyItems) {
		switch (selected.$) {
			case 0:
				return $elm$core$Maybe$Nothing;
			case 1:
				return $elm$core$Maybe$Nothing;
			case 3:
				return $elm$core$Maybe$Nothing;
			default:
				var clusterNumber = selected.a.dU;
				var supplyItemId = selected.a.dF;
				var _v1 = A2($author$project$Plan$Supply$findItemById, supplyItems, supplyItemId);
				if (!_v1.$) {
					var supplyItem = _v1.a;
					var _v2 = A2($author$project$Plan$Supply$findClusterIn, clusterNumber, supplyItem);
					if (!_v2.$) {
						var c = _v2.a;
						return $elm$core$Maybe$Just(
							{H: c, gK: supplyItem});
					} else {
						return $elm$core$Maybe$Nothing;
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
		}
	});
var $author$project$Plan$Supply$idOfPosition = function (position) {
	switch (position.$) {
		case 0:
			var id = position.a;
			return id;
		case 1:
			var id = position.a;
			return id;
		case 2:
			var id = position.a;
			return id;
		case 3:
			var id = position.a;
			return id;
		default:
			var id = position.a;
			return id;
	}
};
var $author$project$Cluster$Number$generateMultiple = F2(
	function (count, clusters) {
		return function (_v2) {
			var remainingCount = _v2.a;
			var generated = _v2.b;
			var available = _v2.c;
			return A2(
				$elm$core$List$map,
				$elm$core$Basics$identity,
				_Utils_ap(
					generated,
					A2($elm$core$List$range, available, (available + remainingCount) - 1)));
		}(
			A3(
				$elm$core$List$foldl,
				F2(
					function (i, _v1) {
						var remainingCount = _v1.a;
						var collect = _v1.b;
						var expect = _v1.c;
						if (!remainingCount) {
							return _Utils_Tuple3(0, collect, i + 1);
						} else {
							if (_Utils_eq(i, expect)) {
								return _Utils_Tuple3(remainingCount, collect, i + 1);
							} else {
								var countToAdd = A2($elm$core$Basics$min, remainingCount, i - expect);
								return _Utils_Tuple3(
									remainingCount - countToAdd,
									_Utils_ap(
										collect,
										A2($elm$core$List$range, expect, (expect + countToAdd) - 1)),
									i + 1);
							}
						}
					}),
				_Utils_Tuple3(count, _List_Nil, 1),
				$elm$core$List$sort(
					A2(
						$elm$core$List$map,
						function (_v0) {
							var cId = _v0;
							return cId;
						},
						A2(
							$elm$core$List$map,
							function ($) {
								return $.bX;
							},
							clusters)))));
	});
var $author$project$Plan$Supply$newClusterNumbersFor = F3(
	function (count, items, deliverer) {
		return A2(
			$author$project$Cluster$Number$generateMultiple,
			count,
			A2($author$project$Plan$Supply$clustersByDeliverer, deliverer, items));
	});
var $author$project$Plan$Supply$withClustersOf = F3(
	function (items, from, item) {
		var _v0 = $author$project$Plan$Supply$delivererOf(item);
		if (!_v0.$) {
			var deliverer = _v0.a;
			var clusters = A2(
				$elm_community$list_extra$List$Extra$uniqueBy,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.bb;
					},
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map($author$project$DistributionPoint$DistributionPoint$encodeSegmentIdForUrl),
						$elm$core$String$join(''))),
				_Utils_ap(
					$author$project$Plan$Supply$ownClustersOf(item),
					$author$project$Plan$Supply$ownClustersOf(from)));
			var availableClusterNumbers = A3(
				$author$project$Plan$Supply$newClusterNumbersFor,
				$elm$core$List$length(clusters),
				A2(
					$author$project$Plan$Supply$removeItem,
					$author$project$Plan$Supply$idOf(item),
					items),
				deliverer);
			return A2(
				$author$project$Plan$Supply$withClusters,
				A3(
					$elm$core$List$map2,
					F2(
						function (number, cluster) {
							return _Utils_update(
								cluster,
								{bX: number});
						}),
					availableClusterNumbers,
					clusters),
				item);
		} else {
			return item;
		}
	});
var $author$project$Plan$Supply$insertItem = F3(
	function (position, toInsert, items) {
		var insert = F3(
			function (pos, toInsertItem, rest) {
				if (!rest.b) {
					return {ab: false, nu: _List_Nil};
				} else {
					var item = rest.a;
					var tail = rest.b;
					if (_Utils_eq(
						$author$project$Plan$Supply$idOfPosition(pos),
						$author$project$Plan$Supply$idOf(item))) {
						switch (pos.$) {
							case 0:
								return {
									ab: true,
									nu: A2(
										$elm$core$List$cons,
										toInsertItem,
										A2($elm$core$List$cons, item, tail))
								};
							case 1:
								return {
									ab: true,
									nu: A2(
										$elm$core$List$cons,
										item,
										A2($elm$core$List$cons, toInsertItem, tail))
								};
							case 2:
								if (!item.$) {
									var car = item.a;
									return {
										ab: true,
										nu: A2(
											$elm$core$List$cons,
											$author$project$Plan$Supply$Car(
												_Utils_update(
													car,
													{
														n0: A2($elm$core$List$cons, toInsertItem, car.n0)
													})),
											tail)
									};
								} else {
									return {
										ab: false,
										nu: A2($elm$core$List$cons, item, tail)
									};
								}
							case 3:
								if (!item.$) {
									var car = item.a;
									return {
										ab: true,
										nu: A2(
											$elm$core$List$cons,
											$author$project$Plan$Supply$Car(
												_Utils_update(
													car,
													{
														n0: _Utils_ap(
															car.n0,
															_List_fromArray(
																[toInsertItem]))
													})),
											tail)
									};
								} else {
									return {
										ab: false,
										nu: A2($elm$core$List$cons, item, tail)
									};
								}
							default:
								if (!item.$) {
									return {
										ab: false,
										nu: A2($elm$core$List$cons, item, tail)
									};
								} else {
									var newItem = A3($author$project$Plan$Supply$withClustersOf, items, toInsertItem, item);
									return {
										ab: true,
										nu: A2($elm$core$List$cons, newItem, tail)
									};
								}
						}
					} else {
						var afterInsertTail = A3(insert, pos, toInsertItem, tail);
						var _v5 = function () {
							if (!item.$) {
								var car = item.a;
								var _v7 = A3(insert, pos, toInsertItem, car.n0);
								var insertSucceeded = _v7.ab;
								var result = _v7.nu;
								return _Utils_Tuple2(
									insertSucceeded,
									$author$project$Plan$Supply$Car(
										_Utils_update(
											car,
											{n0: result})));
							} else {
								return _Utils_Tuple2(false, item);
							}
						}();
						var carSucceeded = _v5.a;
						var newItem = _v5.b;
						return {
							ab: carSucceeded || afterInsertTail.ab,
							nu: A2($elm$core$List$cons, newItem, afterInsertTail.nu)
						};
					}
				}
			});
		return A3(insert, position, toInsert, items);
	});
var $author$project$Plan$Supply$newClusterNumberFor = F2(
	function (items, deliverer) {
		return $author$project$Cluster$Number$generate(
			A2($author$project$Plan$Supply$clustersByDeliverer, deliverer, items));
	});
var $author$project$Plan$Supply$newClusterFor = F3(
	function (deliverer, segmentIds, supplyItems) {
		return {
			bX: A2($author$project$Plan$Supply$newClusterNumberFor, supplyItems, deliverer),
			bb: segmentIds
		};
	});
var $author$project$Plan$Supply$isSame = F2(
	function (item, other) {
		var _v0 = _Utils_Tuple2(item, other);
		_v0$3:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if (!_v0.b.$) {
						var itemCar = _v0.a.a;
						var otherCar = _v0.b.a;
						return _Utils_eq(itemCar.bl, otherCar.bl) && _Utils_eq(itemCar.H.bX, otherCar.H.bX);
					} else {
						break _v0$3;
					}
				case 1:
					if (_v0.b.$ === 1) {
						var itemBike = _v0.a.a;
						var otherBike = _v0.b.a;
						return _Utils_eq(itemBike.bl, otherBike.bl) && _Utils_eq(
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.bX;
								},
								$elm$core$List$head(itemBike.k)),
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.bX;
								},
								$elm$core$List$head(otherBike.k)));
					} else {
						break _v0$3;
					}
				default:
					if (_v0.b.$ === 2) {
						var itemSubDP = _v0.a.a;
						var otherSubDP = _v0.b.a;
						return _Utils_eq(itemSubDP.lK, otherSubDP.lK);
					} else {
						break _v0$3;
					}
			}
		}
		return false;
	});
var $author$project$Plan$Supply$removeSegment = F2(
	function (segmentId, items) {
		var removeInCluster = function (cluster) {
			return A2($elm$core$List$member, segmentId, cluster.bb) ? $elm$core$Maybe$Just(
				_Utils_update(
					cluster,
					{
						bb: A2($elm_community$list_extra$List$Extra$remove, segmentId, cluster.bb)
					})) : $elm$core$Maybe$Nothing;
		};
		var remove = function (item) {
			switch (item.$) {
				case 0:
					var car = item.a;
					var id = car.eg;
					var deliverer = car.bl;
					var cluster = car.H;
					var supplies = car.n0;
					var _v1 = removeInCluster(cluster);
					if (!_v1.$) {
						var removed = _v1.a;
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(
								$author$project$Plan$Supply$Car(
									_Utils_update(
										car,
										{H: removed})),
								{dU: removed.bX, dF: id}));
					} else {
						return A2(
							$elm$core$Maybe$map,
							$elm$core$Tuple$mapFirst(
								function (i) {
									return $author$project$Plan$Supply$Car(
										_Utils_update(
											car,
											{
												n0: A3(
													$elm_community$list_extra$List$Extra$setIf,
													$author$project$Plan$Supply$isSame(i),
													i,
													supplies)
											}));
								}),
							$elm$core$List$head(
								A2($elm$core$List$filterMap, remove, supplies)));
					}
				case 1:
					var bike = item.a;
					var id = bike.eg;
					var deliverer = bike.bl;
					var clusters = bike.k;
					return A2(
						$elm$core$Maybe$map,
						function (c) {
							return _Utils_Tuple2(
								$author$project$Plan$Supply$Bike(
									_Utils_update(
										bike,
										{
											k: A3(
												$elm_community$list_extra$List$Extra$setIf,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.bX;
													},
													$elm$core$Basics$eq(c.bX)),
												c,
												clusters)
										})),
								{dU: c.bX, dF: id});
						},
						$elm$core$List$head(
							A2($elm$core$List$filterMap, removeInCluster, clusters)));
				default:
					return $elm$core$Maybe$Nothing;
			}
		};
		var _v2 = $elm$core$List$head(
			A2($elm$core$List$filterMap, remove, items));
		if (_v2.$ === 1) {
			return _Utils_Tuple2(items, $elm$core$Maybe$Nothing);
		} else {
			var _v3 = _v2.a;
			var changedItem = _v3.a;
			var changedClusterNumber = _v3.b;
			return _Utils_Tuple2(
				A3(
					$elm_community$list_extra$List$Extra$setIf,
					$author$project$Plan$Supply$isSame(changedItem),
					changedItem,
					items),
				$elm$core$Maybe$Just(changedClusterNumber));
		}
	});
var $author$project$Plan$DayPlanning$Demand$convertToCar = F3(
	function (nextId, dp, _v0) {
		var id = _v0.eg;
		var deliverer = _v0.bl;
		var clusters = _v0.k;
		var preSupply = _v0.ni;
		var _v1 = A2(
			$elm$core$List$partition,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.bb;
				},
				$author$project$DistributionPoint$DistributionPoint$containsCarSegments(dp)),
			clusters);
		if (_v1.a.b) {
			var _v2 = _v1.a;
			var carCluster = _v2.a;
			var otherCarClusters = _v2.b;
			var bikeClusters = _v1.b;
			var carItem = A5($author$project$Plan$Supply$carItem, id, deliverer, carCluster, _List_Nil, preSupply);
			var _v3 = $author$project$Plan$Supply$withIds(
				_Utils_Tuple2(
					A2(
						$elm$core$List$map,
						function (c) {
							return A5($author$project$Plan$Supply$carItem, id, deliverer, c, _List_Nil, preSupply);
						},
						otherCarClusters),
					nextId));
			var otherCarItems = _v3.a;
			var newNextId = _v3.b;
			return _Utils_eq(bikeClusters, _List_Nil) ? {eN: $elm$core$Maybe$Nothing, gK: carItem, fv: newNextId, en: otherCarItems} : {
				eN: $elm$core$Maybe$Just(
					A4($author$project$Plan$Supply$bikeItem, newNextId, deliverer, bikeClusters, preSupply)),
				gK: carItem,
				fv: $author$project$Plan$Supply$nextId(newNextId),
				en: otherCarItems
			};
		} else {
			return {
				eN: $elm$core$Maybe$Nothing,
				gK: A4($author$project$Plan$Supply$bikeItem, id, deliverer, clusters, preSupply),
				fv: nextId,
				en: _List_Nil
			};
		}
	});
var $author$project$Plan$DayPlanning$Demand$updateSuppliesIn = F3(
	function (nextId, dp, item) {
		var segments = function () {
			switch (item.$) {
				case 0:
					var cluster = item.a.H;
					return cluster.bb;
				case 1:
					var clusters = item.a.k;
					return A2(
						$elm$core$List$concatMap,
						function ($) {
							return $.bb;
						},
						clusters);
				default:
					return _List_Nil;
			}
		}();
		var _v0 = _Utils_Tuple2(
			A2($author$project$DistributionPoint$DistributionPoint$containsCarSegments, dp, segments),
			item);
		switch (_v0.b.$) {
			case 0:
				if (_v0.a) {
					return _Utils_Tuple3(item, _List_Nil, nextId);
				} else {
					var id = _v0.b.a.eg;
					var deliverer = _v0.b.a.bl;
					var cluster = _v0.b.a.H;
					var supplies = _v0.b.a.n0;
					var preSupply = _v0.b.a.ni;
					var updated = $author$project$Plan$Supply$Bike(
						{
							k: _List_fromArray(
								[cluster]),
							bl: deliverer,
							eg: id,
							ni: preSupply
						});
					return _Utils_Tuple3(updated, supplies, nextId);
				}
			case 1:
				if (_v0.a) {
					var bike = _v0.b.a;
					var result = A3($author$project$Plan$DayPlanning$Demand$convertToCar, nextId, dp, bike);
					var others = function () {
						var _v1 = result.eN;
						if (!_v1.$) {
							var b = _v1.a;
							return _Utils_ap(
								result.en,
								_List_fromArray(
									[b]));
						} else {
							return result.en;
						}
					}();
					return _Utils_Tuple3(result.gK, others, result.fv);
				} else {
					return _Utils_Tuple3(item, _List_Nil, nextId);
				}
			default:
				return _Utils_Tuple3(item, _List_Nil, nextId);
		}
	});
var $author$project$Plan$DayPlanning$Demand$updateSuppliesWhenNeeded = F4(
	function (nextId, distributionPoint, fullClusterNumber, items) {
		var _v0 = A2($author$project$Plan$Supply$findItemById, items, fullClusterNumber.dF);
		if (!_v0.$) {
			var item = _v0.a;
			return function (_v1) {
				var i = _v1.a;
				var others = _v1.b;
				var id = _v1.c;
				return _Utils_Tuple2(
					A3(
						$author$project$Plan$Supply$replaceItem,
						$author$project$Plan$Supply$idOf(i),
						i,
						_Utils_ap(items, others)),
					id);
			}(
				A3($author$project$Plan$DayPlanning$Demand$updateSuppliesIn, nextId, distributionPoint, item));
		} else {
			return _Utils_Tuple2(items, nextId);
		}
	});
var $author$project$Plan$Plan$withNextId = F2(
	function (id, plan) {
		return _Utils_update(
			plan,
			{ei: id});
	});
var $author$project$Plan$DayPlanning$Demand$handleSegmentSelected = F4(
	function (segmentId, distributionPoint, plan, selected) {
		var _v0 = A2($author$project$Plan$Supply$removeSegment, segmentId, plan.gL);
		var itemsWithoutSegment = _v0.a;
		var clusterNumberWithSegment = _v0.b;
		var _v1 = function () {
			if (!clusterNumberWithSegment.$) {
				var fullId = clusterNumberWithSegment.a;
				return A4($author$project$Plan$DayPlanning$Demand$updateSuppliesWhenNeeded, plan.ei, distributionPoint, fullId, itemsWithoutSegment);
			} else {
				return _Utils_Tuple2(itemsWithoutSegment, plan.ei);
			}
		}();
		var itemsWithoutSegmentCorrected = _v1.a;
		var nextId = _v1.b;
		var _v3 = function () {
			switch (selected.$) {
				case 0:
					return _Utils_Tuple3(
						itemsWithoutSegmentCorrected,
						$elm$core$Maybe$Nothing,
						_Utils_Tuple2(selected, nextId));
				case 3:
					return _Utils_Tuple3(
						itemsWithoutSegmentCorrected,
						$elm$core$Maybe$Nothing,
						_Utils_Tuple2(selected, nextId));
				case 1:
					var deliverer = selected.a.bl;
					var newCluster = A3(
						$author$project$Plan$Supply$newClusterFor,
						deliverer,
						_List_fromArray(
							[segmentId]),
						itemsWithoutSegmentCorrected);
					var _v6 = A4($author$project$Plan$Supply$addBikeCluster, nextId, deliverer, newCluster, itemsWithoutSegmentCorrected);
					var items = _v6.a;
					var supplyItemId = _v6.b;
					var nextItemId = _v6.c;
					return _Utils_Tuple3(
						items,
						$elm$core$Maybe$Just(
							{dU: newCluster.bX, dF: supplyItemId}),
						_Utils_Tuple2(
							A3($author$project$Plan$Selection$cluster, deliverer, newCluster.bX, supplyItemId),
							nextItemId));
				default:
					var deliverer = selected.a.bl;
					var clusterNumber = selected.a.dU;
					var supplyItemId = selected.a.dF;
					if (_Utils_eq(
						$elm$core$Maybe$Just(
							{dU: clusterNumber, dF: supplyItemId}),
						clusterNumberWithSegment)) {
						return _Utils_Tuple3(
							itemsWithoutSegmentCorrected,
							$elm$core$Maybe$Nothing,
							_Utils_Tuple2(
								A3($author$project$Plan$Selection$cluster, deliverer, clusterNumber, supplyItemId),
								nextId));
					} else {
						var itemAndCluster = A2($author$project$Plan$Selection$findSelectedCluster, selected, itemsWithoutSegmentCorrected);
						var _v7 = _Utils_Tuple3(
							A2(
								$author$project$DistributionPoint$DistributionPoint$containsCarSegments,
								distributionPoint,
								_List_fromArray(
									[segmentId])),
							A2(
								$elm$core$Maybe$withDefault,
								true,
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.gK;
										},
										$author$project$Plan$Supply$canConvertToCar),
									itemAndCluster)),
							itemAndCluster);
						if ((_v7.a && (!_v7.b)) && (!_v7.c.$)) {
							var cluster = _v7.c.a.H;
							var newItem = A5(
								$author$project$Plan$Supply$carItem,
								plan.ei,
								deliverer,
								{
									bX: cluster.bX,
									bb: _Utils_ap(
										cluster.bb,
										_List_fromArray(
											[segmentId]))
								},
								_List_Nil,
								$author$project$Plan$Supply$NotPreSupplied);
							return _Utils_Tuple3(
								A3(
									$author$project$Plan$Supply$removeCluster,
									supplyItemId,
									cluster.bX,
									A3(
										$author$project$Plan$Supply$insertItem,
										$author$project$Plan$Supply$After(supplyItemId),
										newItem,
										itemsWithoutSegmentCorrected).nu).a,
								$elm$core$Maybe$Just(
									{
										dU: cluster.bX,
										dF: $author$project$Plan$Supply$idOf(newItem)
									}),
								_Utils_Tuple2(
									A3(
										$author$project$Plan$Selection$cluster,
										deliverer,
										cluster.bX,
										$author$project$Plan$Supply$idOf(newItem)),
									$author$project$Plan$Supply$nextId(plan.ei)));
						} else {
							return _Utils_Tuple3(
								A4($author$project$Plan$Supply$addSegment, itemsWithoutSegmentCorrected, supplyItemId, clusterNumber, segmentId),
								$elm$core$Maybe$Just(
									{dU: clusterNumber, dF: supplyItemId}),
								_Utils_Tuple2(
									A3($author$project$Plan$Selection$cluster, deliverer, clusterNumber, supplyItemId),
									plan.ei));
						}
					}
			}
		}();
		var updatedItems = _v3.a;
		var itemAndClusterIdToMoveTo = _v3.b;
		var _v4 = _v3.c;
		var newSelection = _v4.a;
		var newNextId = _v4.b;
		return _Utils_Tuple2(
			function () {
				if (!itemAndClusterIdToMoveTo.$) {
					var fullId = itemAndClusterIdToMoveTo.a;
					var _v9 = A4($author$project$Plan$DayPlanning$Demand$updateSuppliesWhenNeeded, newNextId, distributionPoint, fullId, updatedItems);
					var newItems = _v9.a;
					var itemId = _v9.b;
					return A2(
						$author$project$Plan$Plan$withNextId,
						itemId,
						A2($author$project$Plan$Plan$withItems, newItems, plan));
				} else {
					return A2(
						$author$project$Plan$Plan$withNextId,
						newNextId,
						A2($author$project$Plan$Plan$withItems, updatedItems, plan));
				}
			}(),
			newSelection);
	});
var $author$project$Plan$DayPlanning$Demand$update = F4(
	function (msg, plan, dp, selection) {
		var withImpact = function (impact) {
			return impact;
		};
		var noImpact = $author$project$Plan$DayPlanning$Demand$NoImpact;
		var segmentId = msg;
		var _v1 = plan.nS;
		if (!_v1) {
			var _v2 = A4($author$project$Plan$DayPlanning$Demand$handleSegmentSelected, segmentId, dp, plan, selection);
			var newPlan = _v2.a;
			var newSelection = _v2.b;
			return withImpact(
				A2($author$project$Plan$DayPlanning$Demand$PlanUpdated, newPlan, newSelection));
		} else {
			return noImpact;
		}
	});
var $author$project$Plan$Plan$Conflict = function (a) {
	return {$: 0, a: a};
};
var $author$project$Plan$Plan$SaveHttpError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Cluster$Cluster$encode = function (cluster) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'number',
				$author$project$Cluster$Number$encode(cluster.bX)),
				_Utils_Tuple2(
				'segments',
				A2(
					$elm$json$Json$Encode$list,
					$elm$core$Basics$identity,
					A2($elm$core$List$map, $author$project$DistributionPoint$DistributionPoint$encodeSegmentId, cluster.bb)))
			]));
};
var $author$project$DistributionPoint$DistributionPoint$encodePreSupplyId = $danyx23$elm_uuid$Uuid$encode;
var $author$project$Plan$Supply$withPreSupplyEncoding = F2(
	function (preSupply, list) {
		if (!preSupply.$) {
			return list;
		} else {
			var id = preSupply.a;
			return _Utils_ap(
				list,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'preSupplyId',
						$author$project$DistributionPoint$DistributionPoint$encodePreSupplyId(id))
					]));
		}
	});
var $author$project$Plan$Supply$encode = function (item) {
	switch (item.$) {
		case 0:
			var deliverer = item.a.bl;
			var cluster = item.a.H;
			var supplies = item.a.n0;
			var preSupply = item.a.ni;
			return $elm$json$Json$Encode$object(
				A2(
					$author$project$Plan$Supply$withPreSupplyEncoding,
					preSupply,
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('ride')),
							_Utils_Tuple2(
							'deliverer',
							$author$project$Deliverer$Deliverer$encodeId(
								$author$project$Deliverer$Deliverer$idFromTyped(deliverer))),
							_Utils_Tuple2(
							'clusters',
							A2(
								$elm$json$Json$Encode$list,
								$elm$core$Basics$identity,
								A2(
									$elm$core$List$map,
									$author$project$Cluster$Cluster$encode,
									_List_fromArray(
										[cluster])))),
							_Utils_Tuple2(
							'supplies',
							A2(
								$elm$json$Json$Encode$list,
								$elm$core$Basics$identity,
								A2($elm$core$List$map, $author$project$Plan$Supply$encode, supplies)))
						])));
		case 1:
			var deliverer = item.a.bl;
			var clusters = item.a.k;
			var preSupply = item.a.ni;
			return $elm$json$Json$Encode$object(
				A2(
					$author$project$Plan$Supply$withPreSupplyEncoding,
					preSupply,
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('bike')),
							_Utils_Tuple2(
							'deliverer',
							$author$project$Deliverer$Deliverer$encodeId(
								$author$project$Deliverer$Deliverer$idFromTyped(deliverer))),
							_Utils_Tuple2(
							'clusters',
							A2(
								$elm$json$Json$Encode$list,
								$elm$core$Basics$identity,
								A2($elm$core$List$map, $author$project$Cluster$Cluster$encode, clusters)))
						])));
		default:
			var dpId = item.a.lK;
			var preSupply = item.a.ni;
			return $elm$json$Json$Encode$object(
				A2(
					$author$project$Plan$Supply$withPreSupplyEncoding,
					preSupply,
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('distributionPoint')),
							_Utils_Tuple2(
							'distributionPoint',
							$author$project$DistributionPoint$DistributionPoint$encodeId(dpId))
						])));
	}
};
var $author$project$Plan$Plan$encodeAssignment = F2(
	function (encodeId, _v0) {
		var id = _v0.eg;
		var deliverer = _v0.bl;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					encodeId(id)),
					_Utils_Tuple2(
					'deliverer',
					$author$project$Deliverer$Deliverer$encodeId(
						$author$project$Deliverer$Deliverer$idFromTyped(deliverer)))
				]));
	});
var $author$project$DistributionPoint$DistributionPoint$encodeAssistantPositionId = $danyx23$elm_uuid$Uuid$encode;
var $author$project$DistributionPoint$DistributionPoint$encodeInserterPositionId = $danyx23$elm_uuid$Uuid$encode;
var $author$project$Plan$Plan$preSupplyAssignmentsOf = function (preSupply) {
	if (!preSupply.$) {
		var assignments = preSupply.a;
		return assignments;
	} else {
		var assignments = preSupply.a;
		return assignments;
	}
};
var $author$project$Plan$Plan$encodePreSupply = function (preSupply) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'enabled',
				$elm$json$Json$Encode$bool(
					function () {
						if (!preSupply.$) {
							return true;
						} else {
							return false;
						}
					}())),
				_Utils_Tuple2(
				'assignments',
				A2(
					$elm$json$Json$Encode$list,
					$author$project$Plan$Plan$encodeAssignment($author$project$DistributionPoint$DistributionPoint$encodePreSupplyId),
					$author$project$Plan$Plan$preSupplyAssignmentsOf(preSupply)))
			]));
};
var $author$project$Plan$Plan$encodeStatus = function (status) {
	return $elm$json$Json$Encode$string(
		function () {
			switch (status) {
				case 0:
					return 'draft';
				case 1:
					return 'delivering';
				default:
					return 'final';
			}
		}());
};
var $author$project$Plan$Plan$encodeVersion = function (_v0) {
	var version = _v0;
	return $elm$json$Json$Encode$int(version);
};
var $author$project$Plan$Plan$encode = function (_v0) {
	var id = _v0.eg;
	var version = _v0.ov;
	var status = _v0.nS;
	var items = _v0.gL;
	var preSupply = _v0.ni;
	var assistants = _v0.kT;
	var inserters = _v0.ms;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'distributionPoint',
				$author$project$DistributionPoint$DistributionPoint$encodeId(id.gm)),
				_Utils_Tuple2(
				'validOn',
				$author$project$Date$DeliveryDate$encode(id.lx)),
				_Utils_Tuple2(
				'version',
				$author$project$Plan$Plan$encodeVersion(version)),
				_Utils_Tuple2(
				'status',
				$author$project$Plan$Plan$encodeStatus(status)),
				_Utils_Tuple2(
				'items',
				A2(
					$elm$json$Json$Encode$list,
					$elm$core$Basics$identity,
					A2($elm$core$List$map, $author$project$Plan$Supply$encode, items))),
				_Utils_Tuple2(
				'preSupply',
				$author$project$Plan$Plan$encodePreSupply(preSupply)),
				_Utils_Tuple2(
				'assisting',
				A2(
					$elm$json$Json$Encode$list,
					$author$project$Plan$Plan$encodeAssignment($author$project$DistributionPoint$DistributionPoint$encodeAssistantPositionId),
					assistants)),
				_Utils_Tuple2(
				'inserting',
				A2(
					$elm$json$Json$Encode$list,
					$author$project$Plan$Plan$encodeAssignment($author$project$DistributionPoint$DistributionPoint$encodeInserterPositionId),
					inserters)),
				_Utils_Tuple2(
				'missedChange',
				$elm$json$Json$Encode$bool(false))
			]));
};
var $author$project$Cluster$Cluster$isEmpty = function (cluster) {
	return $elm$core$List$isEmpty(cluster.bb);
};
var $author$project$Cluster$Cluster$findNonEmpty = function (clusters) {
	return A2(
		$elm$core$List$filter,
		A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Cluster$Cluster$isEmpty),
		clusters);
};
var $author$project$Plan$Supply$withoutEmptyClusters = function (items) {
	var without = function (item) {
		switch (item.$) {
			case 0:
				var car = item.a;
				var cluster = car.H;
				var supplies = car.n0;
				return $author$project$Cluster$Cluster$isEmpty(cluster) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Plan$Supply$Car(
						_Utils_update(
							car,
							{
								n0: A2($elm$core$List$filterMap, without, supplies)
							})));
			case 1:
				var bike = item.a;
				var clusters = bike.k;
				var _v1 = $author$project$Cluster$Cluster$findNonEmpty(clusters);
				if (!_v1.b) {
					return $elm$core$Maybe$Nothing;
				} else {
					var nonEmptyClusters = _v1;
					return $elm$core$Maybe$Just(
						$author$project$Plan$Supply$Bike(
							_Utils_update(
								bike,
								{k: nonEmptyClusters})));
				}
			default:
				var subDP = item;
				return $elm$core$Maybe$Just(subDP);
		}
	};
	return A2($elm$core$List$filterMap, without, items);
};
var $author$project$Plan$Plan$withoutEmptyClusters = function (plan) {
	return A2(
		$author$project$Plan$Plan$withItems,
		$author$project$Plan$Supply$withoutEmptyClusters(plan.gL),
		plan);
};
var $author$project$Plan$Plan$updatePlanCmd = F4(
	function (token, toMsg, plan, deliverers) {
		var uri = A2(
			$author$project$Api$Uri$for,
			A2($author$project$Plan$Plan$subPathWithDate, plan.eg.gm, plan.eg.lx),
			_List_Nil);
		var toError = function (response) {
			switch (response.$) {
				case 0:
					var url = response.a;
					return $elm$core$Result$Err(
						$author$project$Plan$Plan$SaveHttpError(
							$elm$http$Http$BadUrl(url)));
				case 1:
					return $elm$core$Result$Err(
						$author$project$Plan$Plan$SaveHttpError($elm$http$Http$Timeout));
				case 2:
					return $elm$core$Result$Err(
						$author$project$Plan$Plan$SaveHttpError($elm$http$Http$NetworkError));
				case 3:
					var metadata = response.a;
					var b = response.b;
					return $elm$core$Result$Err(
						function () {
							var _v1 = metadata.kf;
							if (_v1 === 409) {
								var _v2 = A2(
									$elm$json$Json$Decode$decodeString,
									$author$project$Plan$Plan$decoder(deliverers),
									b);
								if (!_v2.$) {
									var p = _v2.a;
									return $author$project$Plan$Plan$Conflict(p);
								} else {
									var err = _v2.a;
									return $author$project$Plan$Plan$SaveHttpError(
										$elm$http$Http$BadBody(
											$elm$json$Json$Decode$errorToString(err)));
								}
							} else {
								return $author$project$Plan$Plan$SaveHttpError(
									$elm$http$Http$BadStatus(metadata.kf));
							}
						}());
				default:
					var b = response.b;
					var _v3 = A2(
						$elm$json$Json$Decode$decodeString,
						$author$project$Plan$Plan$decoder(deliverers),
						b);
					if (!_v3.$) {
						var p = _v3.a;
						return $elm$core$Result$Ok(p);
					} else {
						var err = _v3.a;
						return $elm$core$Result$Err(
							$author$project$Plan$Plan$SaveHttpError(
								$elm$http$Http$BadBody(
									$elm$json$Json$Decode$errorToString(err))));
					}
			}
		};
		return A5(
			$author$project$Api$Request$patchWithCustomError,
			token,
			toMsg,
			toError,
			uri,
			$elm$http$Http$jsonBody(
				$author$project$Plan$Plan$encode(
					$author$project$Plan$Plan$withoutEmptyClusters(plan))));
	});
var $author$project$Plan$DayPlanning$handleDemandMsg = F3(
	function (share, model, demandMsg) {
		var token = $author$project$Portal$Share$token(share);
		var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		var modelChange = function (m) {
			return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
		};
		var dpId = $author$project$Plan$DayPlanning$toDistributionPointId(model.bn);
		var actionKey = _Utils_Tuple2(dpId, model.lx);
		var withCommand = function (toAction) {
			return $author$project$Portal$Return$withCommand(
				toAction(actionKey));
		};
		var _v0 = _Utils_Tuple2(
			model.bn,
			$author$project$Plan$PlanLoader$loadedOf(model.fB));
		if ((_v0.a.$ === 1) && (!_v0.b.$)) {
			var distributionPoint = _v0.a.a;
			var p = _v0.b.a;
			var impact = A4($author$project$Plan$DayPlanning$Demand$update, demandMsg, p.fA, distributionPoint, model.z.nI);
			if (!impact.$) {
				return noChange;
			} else {
				var newPlan = impact.a;
				var newSelection = impact.b;
				var supplyMdl = model.z;
				return A3(
					withCommand,
					$author$project$Plan$DayPlanning$changingPlan,
					A4($author$project$Plan$Plan$updatePlanCmd, token, $author$project$Plan$DayPlanning$SavedPlan, newPlan, p.e4),
					modelChange(
						_Utils_update(
							model,
							{
								fB: $author$project$Plan$PlanLoader$Loaded(
									_Utils_update(
										p,
										{fA: newPlan})),
								z: _Utils_update(
									supplyMdl,
									{nI: newSelection})
							})));
			}
		} else {
			return noChange;
		}
	});
var $author$project$Plan$DayPlanning$SystemDeletedUnregisteredDeliverer = function (a) {
	return {$: 11, a: a};
};
var $author$project$Plan$DayPlanning$SystemLinkedUnregisteredDeliverer = function (a) {
	return {$: 10, a: a};
};
var $author$project$Plan$DayPlanning$SystemRespondedDelivererColorUpdated = function (a) {
	return {$: 24, a: a};
};
var $author$project$Plan$DayPlanning$SystemRespondedPlanReedit = function (a) {
	return {$: 9, a: a};
};
var $author$project$Deliverer$Deliverer$colorOf = A2(
	$elm$core$Basics$composeR,
	$author$project$Deliverer$Deliverer$fromTyped,
	function ($) {
		return $.eS;
	});
var $author$project$Deliverer$Unregistered$deleteCmd = F4(
	function (token, toMsg, unregisteredDelivererId, date) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'unregistered-deliverers',
					$author$project$Deliverer$Deliverer$encodeIdForUrl(unregisteredDelivererId),
					'on',
					$author$project$Date$DeliveryDate$encodeForUrl(date)
				]),
			_List_Nil);
		return A4($author$project$Api$Request$postWithoutResponse, token, toMsg, uri, $elm$http$Http$emptyBody);
	});
var $author$project$Deliverer$IdDict$insert = $timo_weike$generic_collections$ManualDict$insert($author$project$Deliverer$IdDict$toComparable);
var $author$project$Deliverer$Unregistered$linkCmd = F3(
	function (token, toMsg, _v0) {
		var unregisteredDelivererId = _v0.op;
		var registeredDelivererId = _v0.nr;
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'unregistered-deliverers',
					$author$project$Deliverer$Deliverer$encodeIdForUrl(unregisteredDelivererId),
					'link',
					$author$project$Deliverer$Deliverer$encodeIdForUrl(registeredDelivererId)
				]),
			_List_Nil);
		return A5(
			$author$project$Api$Request$patch,
			token,
			toMsg,
			uri,
			A2($elm$http$Http$stringBody, 'text/plain', ''),
			$elm$json$Json$Decode$succeed(0));
	});
var $author$project$Plan$DayPlanning$linkingUnregisteredDeliverer = $author$project$Plan$DayPlanning$singleAction('linkingUnregisteredDeliverer');
var $author$project$Plan$Plan$reeditPlanCmd = F4(
	function (token, toMsg, dpId, date) {
		return A5($author$project$Plan$Plan$setPlanStatusCmd, token, toMsg, dpId, date, 0);
	});
var $author$project$Plan$DayPlanning$reeditingPlan = $author$project$Plan$DayPlanning$singleAction('reeditingPlan');
var $author$project$Plan$DayPlanning$Supply$AssistantPositionSelection = function (a) {
	return {$: 2, a: a};
};
var $author$project$Plan$DayPlanning$Supply$BackgroundCommand = function (a) {
	return {$: 10, a: a};
};
var $author$project$Plan$DayPlanning$Supply$DeleteDeliverer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$DayPlanning$Supply$DeleteUnregisteredDeliverer = function (a) {
	return {$: 8, a: a};
};
var $author$project$Plan$DayPlanning$Supply$DelivererColorUpdated = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Plan$DayPlanning$Supply$DraggingCluster = function (a) {
	return {$: 2, a: a};
};
var $author$project$Plan$DayPlanning$Supply$DraggingItem = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$DayPlanning$Supply$FocusedSegment = function (a) {
	return {$: 6, a: a};
};
var $author$project$Plan$DayPlanning$Supply$InserterPositionSelection = function (a) {
	return {$: 3, a: a};
};
var $author$project$Plan$DayPlanning$Supply$LinkedUnregisteredDeliverer = function (a) {
	return {$: 7, a: a};
};
var $author$project$Plan$DayPlanning$Supply$MaximizedDetail = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$Selection$Moving = 1;
var $author$project$Plan$DayPlanning$Supply$NewHighlighted = function (a) {
	return {$: 5, a: a};
};
var $author$project$Plan$DayPlanning$Supply$NewRoute = function (a) {
	return {$: 9, a: a};
};
var $author$project$Plan$DayPlanning$Supply$NoImpact = {$: 0};
var $author$project$Plan$DayPlanning$Supply$NothingSelected = {$: 0};
var $author$project$Plan$DayPlanning$Supply$PlanChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$DayPlanning$Supply$PlanDeleted = {$: 3};
var $author$project$Plan$DayPlanning$Supply$PlanMinimized = 0;
var $author$project$Plan$DayPlanning$Supply$PlanReeditMaximized = 2;
var $author$project$Plan$DayPlanning$Supply$PlanReedited = {$: 4};
var $author$project$Plan$DayPlanning$Supply$PlanRemoveMaximized = 1;
var $author$project$Plan$DayPlanning$Supply$PlanUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Plan$DayPlanning$Supply$PreSupplySelection = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$DayPlanning$Supply$SystemScrolledSupplyView = function (a) {
	return {$: 36, a: a};
};
var $author$project$Cluster$Cluster$addCluster = F2(
	function (cluster, clusters) {
		return _Utils_ap(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.bb;
					},
					$elm$core$Basics$neq(cluster.bb)),
				clusters),
			_List_fromArray(
				[cluster]));
	});
var $author$project$Plan$Supply$addBikeClusterAt = F5(
	function (idForNewItem, deliverer, cluster, supplyItemId, supplyItems) {
		var _v0 = A2($author$project$Plan$Supply$findItemById, supplyItems, supplyItemId);
		_v0$2:
		while (true) {
			if (!_v0.$) {
				switch (_v0.a.$) {
					case 1:
						var item = _v0.a;
						var id = item.a.eg;
						var clusters = item.a.k;
						var newItem = A2(
							$author$project$Plan$Supply$withClusters,
							A2($author$project$Cluster$Cluster$addCluster, cluster, clusters),
							item);
						return _Utils_Tuple3(
							A3($author$project$Plan$Supply$replaceItem, id, newItem, supplyItems),
							id,
							idForNewItem);
					case 0:
						var newItem = A4(
							$author$project$Plan$Supply$bikeItem,
							idForNewItem,
							deliverer,
							_List_fromArray(
								[cluster]),
							$author$project$Plan$Supply$NotPreSupplied);
						var _v1 = A3(
							$author$project$Plan$Supply$insertItem,
							$author$project$Plan$Supply$After(supplyItemId),
							newItem,
							supplyItems);
						var insertSucceeded = _v1.ab;
						var result = _v1.nu;
						var newItems = insertSucceeded ? result : _Utils_ap(
							supplyItems,
							_List_fromArray(
								[newItem]));
						return _Utils_Tuple3(
							newItems,
							$author$project$Plan$Supply$idOf(newItem),
							$author$project$Plan$Supply$nextId(idForNewItem));
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return _Utils_Tuple3(supplyItems, supplyItemId, idForNewItem);
	});
var $author$project$Plan$Selection$SubDistributionPoint = function (a) {
	return {$: 3, a: a};
};
var $author$project$Plan$Selection$DelivererWithoutCluster = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$DayPlanning$Supply$selectFirstCluster = F3(
	function (items, typedDeliverer, supplyItemId) {
		var _v0 = _Utils_Tuple2(
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Plan$Supply$findItemById(items),
				supplyItemId),
			supplyItemId);
		_v0$3:
		while (true) {
			if (!_v0.a.$) {
				switch (_v0.a.a.$) {
					case 0:
						var id = _v0.a.a.a.eg;
						var deliverer = _v0.a.a.a.bl;
						var cluster = _v0.a.a.a.H;
						return A3($author$project$Plan$Selection$cluster, deliverer, cluster.bX, id);
					case 1:
						var id = _v0.a.a.a.eg;
						var deliverer = _v0.a.a.a.bl;
						var clusters = _v0.a.a.a.k;
						if (clusters.b) {
							var head = clusters.a;
							return A3($author$project$Plan$Selection$cluster, deliverer, head.bX, id);
						} else {
							return $author$project$Plan$Selection$DelivererWithoutCluster(
								{bl: deliverer, fE: 0});
						}
					default:
						if (!_v0.b.$) {
							var selectedSupplyItem = _v0.b.a;
							return $author$project$Plan$Selection$SubDistributionPoint(
								{ff: 1, fE: 0, dF: selectedSupplyItem});
						} else {
							break _v0$3;
						}
				}
			} else {
				break _v0$3;
			}
		}
		if (!typedDeliverer.$) {
			var deliverer = typedDeliverer.a;
			return $author$project$Plan$Selection$DelivererWithoutCluster(
				{bl: deliverer, fE: 0});
		} else {
			return $author$project$Plan$Selection$NoDeliverer;
		}
	});
var $author$project$Plan$Selection$maximize = function (selection) {
	if (selection.$ === 2) {
		var c = selection.a;
		return $author$project$Plan$Selection$Cluster(
			_Utils_update(
				c,
				{
					n: $author$project$Plan$Selection$Maximized($author$project$Plan$Selection$initMoving)
				}));
	} else {
		return selection;
	}
};
var $author$project$Plan$Selection$Minimized = {$: 0};
var $author$project$Plan$Selection$minimize = function (selection) {
	if (selection.$ === 2) {
		var c = selection.a;
		return $author$project$Plan$Selection$Cluster(
			_Utils_update(
				c,
				{n: $author$project$Plan$Selection$Minimized}));
	} else {
		return selection;
	}
};
var $author$project$Plan$Selection$moveFoldingFrom = function (selection) {
	switch (selection.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 2:
			var moveFolding = selection.a.n;
			return $elm$core$Maybe$Just(moveFolding);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Plan$Selection$toggleFolding = function (selection) {
	var _v0 = $author$project$Plan$Selection$moveFoldingFrom(selection);
	if (!_v0.$) {
		if (!_v0.a.$) {
			var _v1 = _v0.a;
			return $author$project$Plan$Selection$maximize(selection);
		} else {
			return $author$project$Plan$Selection$minimize(selection);
		}
	} else {
		return selection;
	}
};
var $author$project$UI$Util$toggleFolding = function (state) {
	if (!state) {
		return 1;
	} else {
		return 0;
	}
};
var $author$project$Plan$DayPlanning$Supply$changeSelection = F4(
	function (deliverer, supplyItemId, plan, previousSelection) {
		var _v0 = _Utils_Tuple2(previousSelection, supplyItemId);
		_v0$2:
		while (true) {
			if (!_v0.b.$) {
				switch (_v0.a.$) {
					case 2:
						var previous = _v0.a.a;
						var id = _v0.b.a;
						return (_Utils_eq(
							deliverer,
							$elm$core$Maybe$Just(previous.bl)) && _Utils_eq(id, previous.dF)) ? $author$project$Plan$Selection$toggleFolding(previousSelection) : A3($author$project$Plan$DayPlanning$Supply$selectFirstCluster, plan.gL, deliverer, supplyItemId);
					case 3:
						var previous = _v0.a.a;
						var id = _v0.b.a;
						return _Utils_eq(id, previous.dF) ? $author$project$Plan$Selection$SubDistributionPoint(
							_Utils_update(
								previous,
								{
									ff: $author$project$UI$Util$toggleFolding(previous.ff)
								})) : A3($author$project$Plan$DayPlanning$Supply$selectFirstCluster, plan.gL, $elm$core$Maybe$Nothing, supplyItemId);
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return A3($author$project$Plan$DayPlanning$Supply$selectFirstCluster, plan.gL, deliverer, supplyItemId);
	});
var $author$project$Plan$Selection$delivererFrom = function (selection) {
	switch (selection.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var deliverer = selection.a.bl;
			return $elm$core$Maybe$Just(deliverer);
		case 2:
			var deliverer = selection.a.bl;
			return $elm$core$Maybe$Just(deliverer);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Plan$DayPlanning$Supply$cleanPlan = F3(
	function (oldSelection, plan, model) {
		var _v0 = _Utils_eq(
			$author$project$Plan$Selection$delivererFrom(model.nI),
			$author$project$Plan$Selection$delivererFrom(oldSelection));
		if (!_v0) {
			var _v1 = $author$project$Plan$Supply$removeEmptyClusters(plan.gL);
			if (!_v1.b.b) {
				return $author$project$Plan$DayPlanning$Supply$NoImpact;
			} else {
				var withoutEmpty = _v1.a;
				return $author$project$Plan$DayPlanning$Supply$PlanChanged(
					A2($author$project$Plan$Plan$withItems, withoutEmpty, plan));
			}
		} else {
			return $author$project$Plan$DayPlanning$Supply$NoImpact;
		}
	});
var $author$project$Plan$DayPlanning$Supply$center = function (_v0) {
	var x = _v0.ay;
	var y = _v0.bg;
	var width = _v0.oy;
	var height = _v0.iK;
	return {ay: x + (width / 2), bg: y + (height / 2)};
};
var $author$project$Plan$DayPlanning$Supply$distanceSquared = F2(
	function (coords1, coords2) {
		var dy = coords1.bg - coords2.bg;
		var dx = coords1.ay - coords2.ay;
		return (dx * dx) + (dy * dy);
	});
var $author$project$Plan$DayPlanning$Supply$closestBeacon = F2(
	function (cursor, handlers) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$first,
			$elm$core$List$head(
				A2(
					$elm$core$List$sortBy,
					$elm$core$Tuple$second,
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$mapSecond(
							A2(
								$elm$core$Basics$composeL,
								$author$project$Plan$DayPlanning$Supply$distanceSquared(cursor),
								$author$project$Plan$DayPlanning$Supply$center)),
						handlers))));
	});
var $author$project$Plan$DayPlanning$Supply$handleClusterDragged = F3(
	function (position, _v0, items) {
		var draggedItem = _v0.C;
		var newItem = _v0.jl;
		var originalItem = _v0.jr;
		var newItems = function () {
			if (!originalItem.$) {
				var item = originalItem.a;
				return A3(
					$author$project$Plan$Supply$replaceItem,
					$author$project$Plan$Supply$idOf(draggedItem),
					item,
					A3($author$project$Plan$Supply$insertItem, position, newItem, items).nu);
			} else {
				return A2(
					$author$project$Plan$Supply$removeItem,
					$author$project$Plan$Supply$idOf(draggedItem),
					A3($author$project$Plan$Supply$insertItem, position, newItem, items).nu);
			}
		}();
		if (position.$ === 4) {
			var id = position.a;
			return _Utils_Tuple2(
				newItems,
				A2($author$project$Plan$Supply$findItemById, items, id));
		} else {
			return _Utils_Tuple2(newItems, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Plan$Supply$moveItem = F3(
	function (item, position, items) {
		if (_Utils_eq(
			$author$project$Plan$Supply$idOfPosition(position),
			$author$project$Plan$Supply$idOf(item))) {
			return _Utils_Tuple2(false, items);
		} else {
			var _v0 = A3(
				$author$project$Plan$Supply$insertItem,
				position,
				item,
				A2(
					$author$project$Plan$Supply$removeItem,
					$author$project$Plan$Supply$idOf(item),
					items));
			var insertSucceeded = _v0.ab;
			var result = _v0.nu;
			return insertSucceeded ? _Utils_Tuple2(insertSucceeded, result) : _Utils_Tuple2(insertSucceeded, items);
		}
	});
var $author$project$Plan$DayPlanning$Supply$handleItemDragged = F3(
	function (position, draggedItem, items) {
		var newItems = function () {
			var _v2 = draggedItem.bF;
			if (!_v2.$) {
				var item = _v2.a;
				return A3(
					$author$project$Plan$Supply$moveItem,
					draggedItem.gK,
					position,
					A3(
						$author$project$Plan$Supply$replaceItem,
						$author$project$Plan$Supply$idOf(item),
						item,
						items)).b;
			} else {
				return A3($author$project$Plan$Supply$moveItem, draggedItem.gK, position, items).b;
			}
		}();
		var appendedTo = function () {
			var _v0 = _Utils_Tuple2(position, draggedItem.bF);
			if (_v0.a.$ === 4) {
				if (!_v0.b.$) {
					var id = _v0.a.a;
					var item = _v0.b.a;
					return _Utils_eq(
						$author$project$Plan$Supply$idOf(item),
						id) ? draggedItem.bF : A2($author$project$Plan$Supply$findItemById, items, id);
				} else {
					var id = _v0.a.a;
					var _v1 = _v0.b;
					return A2($author$project$Plan$Supply$findItemById, items, id);
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return _Utils_Tuple2(newItems, appendedTo);
	});
var $author$project$Plan$Selection$move = F2(
	function (change, selection) {
		if (selection.$ === 2) {
			var c = selection.a;
			var _v1 = c.n;
			if (_v1.$ === 1) {
				var moving = _v1.a;
				return $author$project$Plan$Selection$Cluster(
					_Utils_update(
						c,
						{
							n: $author$project$Plan$Selection$Maximized(
								change(moving))
						}));
			} else {
				return selection;
			}
		} else {
			return selection;
		}
	});
var $author$project$Plan$Supply$addClusterTo = F2(
	function (cluster, item) {
		return _Utils_Tuple2(
			A2(
				$author$project$Plan$Supply$withClusters,
				A2(
					$author$project$Cluster$Cluster$addCluster,
					cluster,
					$author$project$Plan$Supply$ownClustersOf(item)),
				item),
			cluster);
	});
var $author$project$Plan$Supply$isBike = function (supplyItem) {
	switch (supplyItem.$) {
		case 0:
			return false;
		case 1:
			return true;
		default:
			return false;
	}
};
var $author$project$Plan$Supply$preSupplyOf = function (supplyItem) {
	switch (supplyItem.$) {
		case 0:
			var preSupply = supplyItem.a.ni;
			return preSupply;
		case 1:
			var preSupply = supplyItem.a.ni;
			return preSupply;
		default:
			var preSupply = supplyItem.a.ni;
			return preSupply;
	}
};
var $author$project$Plan$Supply$reassignItem = F3(
	function (toDeliverer, item, supplyItems) {
		var newItem = function () {
			switch (item.$) {
				case 0:
					var car = item.a;
					var deliverer = car.bl;
					var cluster = car.H;
					return $author$project$Plan$Supply$Car(
						_Utils_update(
							car,
							{
								H: _Utils_update(
									cluster,
									{
										bX: A2($author$project$Plan$Supply$newClusterNumberFor, supplyItems, toDeliverer)
									}),
								bl: toDeliverer
							}));
				case 1:
					var bike = item.a;
					var deliverer = bike.bl;
					var clusters = bike.k;
					var availableClusterNumbers = A3(
						$author$project$Plan$Supply$newClusterNumbersFor,
						$elm$core$List$length(clusters),
						supplyItems,
						toDeliverer);
					var toClusters = A3(
						$elm$core$List$map2,
						F2(
							function (number, cluster) {
								return _Utils_update(
									cluster,
									{bX: number});
							}),
						availableClusterNumbers,
						clusters);
					return $author$project$Plan$Supply$Bike(
						_Utils_update(
							bike,
							{k: toClusters, bl: toDeliverer}));
				default:
					return item;
			}
		}();
		return A3(
			$author$project$Plan$Supply$replaceItem,
			$author$project$Plan$Supply$idOf(item),
			newItem,
			supplyItems);
	});
var $author$project$Plan$Supply$moveCluster = F5(
	function (id, fromItem, cluster, toDeliverer, supplyItems) {
		var toDelivererItems = A2(
			$elm$core$List$filter,
			$author$project$Plan$Supply$isBike,
			A2(
				$author$project$Plan$Supply$findByDeliverer,
				$author$project$Deliverer$Deliverer$idFromTyped(toDeliverer),
				supplyItems));
		var remainingClusters = A2(
			$elm_community$list_extra$List$Extra$remove,
			cluster,
			$author$project$Plan$Supply$ownClustersOf(fromItem));
		var _v0 = _Utils_Tuple3(
			_Utils_Tuple2(
				$author$project$Plan$Supply$delivererOf(fromItem),
				fromItem),
			toDelivererItems,
			remainingClusters);
		if (!_v0.a.a.$) {
			if (_v0.c.b) {
				if (!_v0.b.b) {
					var _v1 = _v0.a;
					var rest = _v0.c;
					var updatedFromItem = A2($author$project$Plan$Supply$withClusters, rest, fromItem);
					var newItem = A4(
						$author$project$Plan$Supply$bikeItem,
						id,
						toDeliverer,
						_List_fromArray(
							[
								A3($author$project$Plan$Supply$newClusterFor, toDeliverer, cluster.bb, supplyItems)
							]),
						$author$project$Plan$Supply$preSupplyOf(fromItem));
					return function (i) {
						return _Utils_Tuple3(
							$elm$core$Maybe$Just(
								_Utils_Tuple2(cluster.bX, id)),
							$author$project$Plan$Supply$nextId(id),
							i);
					}(
						A3(
							$author$project$Plan$Supply$insertItem,
							$author$project$Plan$Supply$After(
								$author$project$Plan$Supply$idOf(updatedFromItem)),
							newItem,
							A3(
								$author$project$Plan$Supply$replaceItem,
								$author$project$Plan$Supply$idOf(fromItem),
								updatedFromItem,
								supplyItems)).nu);
				} else {
					var _v2 = _v0.a;
					var _v3 = _v0.b;
					var toItem = _v3.a;
					var rest = _v0.c;
					var _v4 = A2(
						$author$project$Plan$Supply$addClusterTo,
						_Utils_update(
							cluster,
							{
								bX: A2($author$project$Plan$Supply$newClusterNumberFor, supplyItems, toDeliverer)
							}),
						toItem);
					var updatedToItem = _v4.a;
					var addedCluster = _v4.b;
					return function (i) {
						return _Utils_Tuple3(
							$elm$core$Maybe$Just(
								_Utils_Tuple2(
									addedCluster.bX,
									$author$project$Plan$Supply$idOf(toItem))),
							id,
							i);
					}(
						A3(
							$author$project$Plan$Supply$replaceItem,
							$author$project$Plan$Supply$idOf(toItem),
							updatedToItem,
							A3(
								$author$project$Plan$Supply$replaceItem,
								$author$project$Plan$Supply$idOf(fromItem),
								A2($author$project$Plan$Supply$withClusters, rest, fromItem),
								supplyItems)));
				}
			} else {
				if ((_v0.a.b.$ === 1) && _v0.b.b) {
					var _v5 = _v0.a;
					var _v6 = _v0.b;
					var toItem = _v6.a;
					var _v7 = A2(
						$author$project$Plan$Supply$addClusterTo,
						_Utils_update(
							cluster,
							{
								bX: A2($author$project$Plan$Supply$newClusterNumberFor, supplyItems, toDeliverer)
							}),
						toItem);
					var updatedToItem = _v7.a;
					var addedCluster = _v7.b;
					return _Utils_eq(
						$author$project$Plan$Supply$idOf(fromItem),
						$author$project$Plan$Supply$idOf(toItem)) ? _Utils_Tuple3($elm$core$Maybe$Nothing, id, supplyItems) : function (i) {
						return _Utils_Tuple3(
							$elm$core$Maybe$Just(
								_Utils_Tuple2(
									addedCluster.bX,
									$author$project$Plan$Supply$idOf(toItem))),
							id,
							i);
					}(
						A3(
							$author$project$Plan$Supply$replaceItem,
							$author$project$Plan$Supply$idOf(toItem),
							updatedToItem,
							A2(
								$author$project$Plan$Supply$removeItem,
								$author$project$Plan$Supply$idOf(fromItem),
								supplyItems)));
				} else {
					var _v8 = _v0.a;
					return function (newItemsAndPassive) {
						return _Utils_Tuple3(
							$elm$core$Maybe$Just(
								_Utils_Tuple2(
									cluster.bX,
									$author$project$Plan$Supply$idOf(fromItem))),
							id,
							newItemsAndPassive);
					}(
						A3($author$project$Plan$Supply$reassignItem, toDeliverer, fromItem, supplyItems));
				}
			}
		} else {
			return _Utils_Tuple3($elm$core$Maybe$Nothing, id, supplyItems);
		}
	});
var $author$project$Plan$DayPlanning$Supply$constrainedDistance = F2(
	function (position, distance) {
		if (!position) {
			return A3($elm$core$Basics$clamp, -50, 0, distance);
		} else {
			return A3($elm$core$Basics$clamp, 0, 50, distance);
		}
	});
var $author$project$Plan$DayPlanning$Supply$distanceFrom = F2(
	function (cursor, limit) {
		return cursor.bg - limit;
	});
var $author$project$Plan$DayPlanning$Supply$scrollThresholdFor = function (_v0) {
	var position = _v0.a;
	var rect = _v0.b;
	var scrollMargin = 40;
	if (!position) {
		return rect.bg + scrollMargin;
	} else {
		return rect.bg - scrollMargin;
	}
};
var $author$project$Plan$DayPlanning$Supply$speedFromDistance = function (distance) {
	return ((distance * distance) * distance) / 1000;
};
var $author$project$Plan$DayPlanning$Supply$scrollSpeedFor = F2(
	function (cursor, beacon) {
		var position = beacon.a;
		return $author$project$Plan$DayPlanning$Supply$speedFromDistance(
			A2(
				$author$project$Plan$DayPlanning$Supply$constrainedDistance,
				position,
				A2(
					$author$project$Plan$DayPlanning$Supply$distanceFrom,
					cursor,
					$author$project$Plan$DayPlanning$Supply$scrollThresholdFor(beacon))));
	});
var $author$project$Plan$DayPlanning$Supply$scrollingFor = function (dragInfo) {
	return A3(
		$elm$core$List$foldl,
		$elm$core$Basics$add,
		0,
		A2(
			$elm$core$List$map,
			$author$project$Plan$DayPlanning$Supply$scrollSpeedFor(dragInfo.bJ),
			dragInfo.jX));
};
var $author$project$Plan$Supply$splitClusterFrom = F3(
	function (id, cluster, item) {
		if (item.$ === 1) {
			var bike = item.a;
			var _v1 = A2(
				$elm$core$List$filter,
				function (c) {
					return !_Utils_eq(c.bX, cluster.bX);
				},
				bike.k);
			if (_v1.b) {
				var remaining = _v1;
				return $elm$core$Maybe$Just(
					_Utils_Tuple3(
						$elm$core$Maybe$Just(
							A2($author$project$Plan$Supply$withClusters, remaining, item)),
						$author$project$Plan$Supply$Bike(
							_Utils_update(
								bike,
								{
									k: _List_fromArray(
										[cluster]),
									eg: id
								})),
						$author$project$Plan$Supply$nextId(id)));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Plan$DayPlanning$Supply$subtractCoords = F2(
	function (coords1, coords2) {
		return {ay: coords1.ay - coords2.ay, bg: coords1.bg - coords2.bg};
	});
var $author$project$Plan$Selection$supplyItemIdFrom = function (selection) {
	switch (selection.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 2:
			var supplyItemId = selection.a.dF;
			return $elm$core$Maybe$Just(supplyItemId);
		default:
			var supplyItemId = selection.a.dF;
			return $elm$core$Maybe$Just(supplyItemId);
	}
};
var $author$project$Plan$DayPlanning$Supply$supplyItemsId = 'supply-items';
var $author$project$Plan$Plan$ReadOnly = 0;
var $author$project$Plan$Plan$ReadWrite = 1;
var $author$project$Plan$Plan$toReadStatus = function (status) {
	switch (status) {
		case 0:
			return 1;
		case 1:
			return 0;
		default:
			return 0;
	}
};
var $author$project$Plan$Selection$togglePreSupplyFolding = function (selection) {
	switch (selection.$) {
		case 0:
			return $author$project$Plan$Selection$NoDeliverer;
		case 1:
			var model = selection.a;
			var preSupplyFolding = model.fE;
			return $author$project$Plan$Selection$DelivererWithoutCluster(
				_Utils_update(
					model,
					{
						fE: $author$project$UI$Util$toggleFolding(preSupplyFolding)
					}));
		case 2:
			var model = selection.a;
			var preSupplyFolding = model.fE;
			return $author$project$Plan$Selection$Cluster(
				_Utils_update(
					model,
					{
						fE: $author$project$UI$Util$toggleFolding(preSupplyFolding)
					}));
		default:
			var model = selection.a;
			var preSupplyFolding = model.fE;
			return $author$project$Plan$Selection$SubDistributionPoint(
				_Utils_update(
					model,
					{
						fE: $author$project$UI$Util$toggleFolding(preSupplyFolding)
					}));
	}
};
var $author$project$Plan$Plan$withAssistantPositionAssignment = F3(
	function (assistantPositionId, deliverer, plan) {
		var assistants = plan.kT;
		return _Utils_update(
			plan,
			{
				kT: function () {
					var _v0 = A2(
						$elm_community$list_extra$List$Extra$find,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.eg;
							},
							$elm$core$Basics$eq(assistantPositionId)),
						assistants);
					if (!_v0.$) {
						return A3(
							$elm_community$list_extra$List$Extra$updateIf,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.eg;
								},
								$elm$core$Basics$eq(assistantPositionId)),
							function (a) {
								return _Utils_update(
									a,
									{bl: deliverer});
							},
							assistants);
					} else {
						return A2(
							$elm$core$List$cons,
							{bl: deliverer, eg: assistantPositionId},
							assistants);
					}
				}()
			});
	});
var $author$project$Deliverer$Deliverer$withColor = F2(
	function (color, typed) {
		switch (typed.$) {
			case 0:
				var deliverer = typed.a;
				return $author$project$Deliverer$Deliverer$Registered(
					_Utils_update(
						deliverer,
						{eS: color}));
			case 1:
				var id = typed.a;
				var deliverer = typed.b;
				return A2(
					$author$project$Deliverer$Deliverer$Expired,
					id,
					A2(
						$elm$core$Maybe$map,
						function (d) {
							return _Utils_update(
								d,
								{eS: color});
						},
						deliverer));
			default:
				var deliverer = typed.a;
				var deliverers = typed.b;
				return A2(
					$author$project$Deliverer$Deliverer$Unregistered,
					_Utils_update(
						deliverer,
						{eS: color}),
					deliverers);
		}
	});
var $author$project$Plan$Selection$withDeliverer = F2(
	function (typed, selected) {
		switch (selected.$) {
			case 0:
				return selected;
			case 1:
				var record = selected.a;
				return $author$project$Plan$Selection$DelivererWithoutCluster(
					_Utils_update(
						record,
						{bl: typed}));
			case 2:
				var record = selected.a;
				return $author$project$Plan$Selection$Cluster(
					_Utils_update(
						record,
						{bl: typed}));
			default:
				return selected;
		}
	});
var $author$project$Plan$Plan$withInserterPositionAssignment = F3(
	function (inserterPositionId, deliverer, plan) {
		var inserters = plan.ms;
		return _Utils_update(
			plan,
			{
				ms: function () {
					var _v0 = A2(
						$elm_community$list_extra$List$Extra$find,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.eg;
							},
							$elm$core$Basics$eq(inserterPositionId)),
						inserters);
					if (!_v0.$) {
						return A3(
							$elm_community$list_extra$List$Extra$updateIf,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.eg;
								},
								$elm$core$Basics$eq(inserterPositionId)),
							function (a) {
								return _Utils_update(
									a,
									{bl: deliverer});
							},
							inserters);
					} else {
						return A2(
							$elm$core$List$cons,
							{bl: deliverer, eg: inserterPositionId},
							inserters);
					}
				}()
			});
	});
var $author$project$Plan$Supply$withNotPreSupplied = function (item) {
	switch (item.$) {
		case 0:
			var car = item.a;
			return $author$project$Plan$Supply$Car(
				_Utils_update(
					car,
					{ni: $author$project$Plan$Supply$NotPreSupplied}));
		case 1:
			var bike = item.a;
			return $author$project$Plan$Supply$Bike(
				_Utils_update(
					bike,
					{ni: $author$project$Plan$Supply$NotPreSupplied}));
		default:
			var subDP = item.a;
			return $author$project$Plan$Supply$SubDistributionPoint(
				_Utils_update(
					subDP,
					{ni: $author$project$Plan$Supply$NotPreSupplied}));
	}
};
var $author$project$Plan$Supply$withPreSuppliedBy = F2(
	function (preSupplyId, item) {
		switch (item.$) {
			case 0:
				var car = item.a;
				return $author$project$Plan$Supply$Car(
					_Utils_update(
						car,
						{
							ni: $author$project$Plan$Supply$PreSuppliedBy(preSupplyId)
						}));
			case 1:
				var bike = item.a;
				return $author$project$Plan$Supply$Bike(
					_Utils_update(
						bike,
						{
							ni: $author$project$Plan$Supply$PreSuppliedBy(preSupplyId)
						}));
			default:
				var subDP = item.a;
				return $author$project$Plan$Supply$SubDistributionPoint(
					_Utils_update(
						subDP,
						{
							ni: $author$project$Plan$Supply$PreSuppliedBy(preSupplyId)
						}));
		}
	});
var $author$project$Plan$Plan$withPreSupplyAssignment = F3(
	function (preSupplyId, deliverer, plan) {
		var preSupply = plan.ni;
		return function (updatedAssignments) {
			var _v1 = plan.ni;
			if (!_v1.$) {
				return _Utils_update(
					plan,
					{
						ni: $author$project$Plan$Plan$PreSupplied(updatedAssignments)
					});
			} else {
				return _Utils_update(
					plan,
					{
						ni: $author$project$Plan$Plan$NotPreSupplied(updatedAssignments)
					});
			}
		}(
			function () {
				var assignments = $author$project$Plan$Plan$preSupplyAssignmentsOf(preSupply);
				var _v0 = A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.eg;
						},
						$elm$core$Basics$eq(preSupplyId)),
					assignments);
				if (!_v0.$) {
					return A3(
						$elm_community$list_extra$List$Extra$setIf,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.eg;
							},
							$elm$core$Basics$eq(preSupplyId)),
						{bl: deliverer, eg: preSupplyId},
						assignments);
				} else {
					return A2(
						$elm$core$List$cons,
						{bl: deliverer, eg: preSupplyId},
						assignments);
				}
			}());
	});
var $author$project$Plan$DayPlanning$Supply$update = F5(
	function (msg, plan, date, dpId, model) {
		var withImpact = F2(
			function (m, impact) {
				return _Utils_Tuple2(m, impact);
			});
		var noImpact = function (m) {
			return _Utils_Tuple2(m, $author$project$Plan$DayPlanning$Supply$NoImpact);
		};
		var noChange = _Utils_Tuple2(model, $author$project$Plan$DayPlanning$Supply$NoImpact);
		switch (msg.$) {
			case 4:
				var deliverer = msg.a;
				var supplyItemId = msg.b;
				var newMdl = _Utils_update(
					model,
					{
						nI: A4(
							$author$project$Plan$DayPlanning$Supply$changeSelection,
							$elm$core$Maybe$Just(deliverer),
							supplyItemId,
							plan,
							model.nI)
					});
				return A2(
					withImpact,
					newMdl,
					A3($author$project$Plan$DayPlanning$Supply$cleanPlan, model.nI, plan, newMdl));
			case 23:
				var supplyItemId = msg.a;
				var newMdl = _Utils_update(
					model,
					{
						nI: A4(
							$author$project$Plan$DayPlanning$Supply$changeSelection,
							$elm$core$Maybe$Nothing,
							$elm$core$Maybe$Just(supplyItemId),
							plan,
							model.nI)
					});
				return A2(
					withImpact,
					newMdl,
					A3($author$project$Plan$DayPlanning$Supply$cleanPlan, model.nI, plan, newMdl));
			case 25:
				var selectedClusterId = msg.a;
				var _v1 = model.nI;
				if (_v1.$ === 2) {
					var deliverer = _v1.a.bl;
					var supplyItemId = _v1.a.dF;
					return noImpact(
						_Utils_update(
							model,
							{
								nI: A3($author$project$Plan$Selection$cluster, deliverer, selectedClusterId, supplyItemId)
							}));
				} else {
					return noChange;
				}
			case 24:
				var id = msg.a;
				var shouldHighlight = msg.b;
				var newHighlighted = function () {
					if (shouldHighlight) {
						return $elm$core$Maybe$Just(id);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				return A2(
					withImpact,
					model,
					$author$project$Plan$DayPlanning$Supply$NewHighlighted(newHighlighted));
			case 26:
				var _v3 = model.nI;
				if (_v3.$ === 2) {
					var deliverer = _v3.a.bl;
					var supplyItemId = _v3.a.dF;
					var _v4 = $author$project$Plan$Plan$toReadStatus(plan.nS);
					if (_v4 === 1) {
						var newCluster = A3($author$project$Plan$Supply$newClusterFor, deliverer, _List_Nil, plan.gL);
						var _v5 = A5($author$project$Plan$Supply$addBikeClusterAt, plan.ei, deliverer, newCluster, supplyItemId, plan.gL);
						var newItems = _v5.a;
						var newSupplyItemId = _v5.b;
						var newNextId = _v5.c;
						return A2(
							withImpact,
							_Utils_update(
								model,
								{
									nI: A3($author$project$Plan$Selection$cluster, deliverer, newCluster.bX, newSupplyItemId)
								}),
							$author$project$Plan$DayPlanning$Supply$PlanChanged(
								A2(
									$author$project$Plan$Plan$withNextId,
									newNextId,
									A2($author$project$Plan$Plan$withItems, newItems, plan))));
					} else {
						return noChange;
					}
				} else {
					return noChange;
				}
			case 5:
				var id = msg.a;
				return A2(
					withImpact,
					model,
					$author$project$Plan$DayPlanning$Supply$NewRoute(
						$author$project$Portal$Route$EditDeliverer(id)));
			case 14:
				var _v6 = model.nI;
				if (_v6.$ === 2) {
					var deliverer = _v6.a.bl;
					var clusterNumber = _v6.a.dU;
					return A2(
						withImpact,
						model,
						$author$project$Plan$DayPlanning$Supply$NewRoute(
							A4(
								$author$project$Portal$Route$SequenceDetail,
								dpId,
								date,
								$author$project$Deliverer$Deliverer$idFromTyped(deliverer),
								clusterNumber)));
				} else {
					return noChange;
				}
			case 27:
				return noImpact(
					_Utils_update(
						model,
						{
							nI: A2(
								$author$project$Plan$Selection$move,
								function (m) {
									if (m === 1) {
										return 0;
									} else {
										return 1;
									}
								},
								model.nI)
						}));
			case 28:
				var deliverer = msg.a;
				var _v8 = A2($author$project$Plan$Selection$findSelectedCluster, model.nI, plan.gL);
				if (!_v8.$) {
					var selected = _v8.a;
					var _v9 = A5($author$project$Plan$Supply$moveCluster, plan.ei, selected.gK, selected.H, deliverer, plan.gL);
					if (!_v9.a.$) {
						var _v10 = _v9.a.a;
						var clusterNumber = _v10.a;
						var itemId = _v10.b;
						var newNextId = _v9.b;
						var updatedItems = _v9.c;
						return A2(
							withImpact,
							_Utils_update(
								model,
								{
									nI: $author$project$Plan$Selection$Cluster(
										{
											dU: clusterNumber,
											bl: deliverer,
											n: $author$project$Plan$Selection$Maximized(0),
											fE: 0,
											dF: itemId
										})
								}),
							$author$project$Plan$DayPlanning$Supply$PlanUpdated(
								A2(
									$author$project$Plan$Plan$withNextId,
									newNextId,
									A2($author$project$Plan$Plan$withItems, updatedItems, plan))));
					} else {
						return noChange;
					}
				} else {
					return noChange;
				}
			case 6:
				return noImpact(
					_Utils_update(
						model,
						{
							dt: $author$project$UI$Util$toggleFolding(model.dt)
						}));
			case 7:
				return noImpact(
					_Utils_update(
						model,
						{
							lD: function () {
								var _v11 = model.lD;
								if (!_v11.$) {
									return $author$project$Plan$DayPlanning$Supply$MaximizedDetail(
										{bY: 0, al: $author$project$Plan$DayPlanning$Supply$NothingSelected});
								} else {
									return $author$project$Plan$DayPlanning$Supply$MinimizedDetail;
								}
							}()
						}));
			case 8:
				var preSupplyId = msg.a;
				var _v12 = model.lD;
				if (_v12.$ === 1) {
					var info = _v12.a;
					var selection = info.al;
					if (selection.$ === 1) {
						var id = selection.a.eg;
						return _Utils_eq(id, preSupplyId) ? noImpact(
							_Utils_update(
								model,
								{
									lD: $author$project$Plan$DayPlanning$Supply$MaximizedDetail(
										_Utils_update(
											info,
											{al: $author$project$Plan$DayPlanning$Supply$NothingSelected}))
								})) : noImpact(
							_Utils_update(
								model,
								{
									lD: $author$project$Plan$DayPlanning$Supply$MaximizedDetail(
										_Utils_update(
											info,
											{
												al: $author$project$Plan$DayPlanning$Supply$PreSupplySelection(
													{eg: preSupplyId, n: 0})
											}))
								}));
					} else {
						return noImpact(
							_Utils_update(
								model,
								{
									lD: $author$project$Plan$DayPlanning$Supply$MaximizedDetail(
										_Utils_update(
											info,
											{
												al: $author$project$Plan$DayPlanning$Supply$PreSupplySelection(
													{eg: preSupplyId, n: 0})
											}))
								}));
					}
				} else {
					return noChange;
				}
			case 13:
				var _v14 = model.lD;
				if (_v14.$ === 1) {
					var info = _v14.a;
					var selection = info.al;
					switch (selection.$) {
						case 0:
							return noChange;
						case 1:
							var selectionInfo = selection.a;
							var moveFolding = selectionInfo.n;
							return noImpact(
								_Utils_update(
									model,
									{
										lD: $author$project$Plan$DayPlanning$Supply$MaximizedDetail(
											_Utils_update(
												info,
												{
													al: $author$project$Plan$DayPlanning$Supply$PreSupplySelection(
														_Utils_update(
															selectionInfo,
															{
																n: $author$project$UI$Util$toggleFolding(moveFolding)
															}))
												}))
									}));
						case 2:
							var selectionInfo = selection.a;
							var moveFolding = selectionInfo.n;
							return noImpact(
								_Utils_update(
									model,
									{
										lD: $author$project$Plan$DayPlanning$Supply$MaximizedDetail(
											_Utils_update(
												info,
												{
													al: $author$project$Plan$DayPlanning$Supply$AssistantPositionSelection(
														_Utils_update(
															selectionInfo,
															{
																n: $author$project$UI$Util$toggleFolding(moveFolding)
															}))
												}))
									}));
						default:
							var selectionInfo = selection.a;
							var moveFolding = selectionInfo.n;
							return noImpact(
								_Utils_update(
									model,
									{
										lD: $author$project$Plan$DayPlanning$Supply$MaximizedDetail(
											_Utils_update(
												info,
												{
													al: $author$project$Plan$DayPlanning$Supply$InserterPositionSelection(
														_Utils_update(
															selectionInfo,
															{
																n: $author$project$UI$Util$toggleFolding(moveFolding)
															}))
												}))
									}));
					}
				} else {
					return noChange;
				}
			case 9:
				var preSupplyId = msg.a;
				var deliverer = msg.b;
				var _v16 = model.lD;
				if (_v16.$ === 1) {
					var info = _v16.a;
					var _v17 = info.al;
					if (_v17.$ === 1) {
						var preSupplyInfo = _v17.a;
						var moveFolding = preSupplyInfo.n;
						return A2(
							withImpact,
							_Utils_update(
								model,
								{
									lD: $author$project$Plan$DayPlanning$Supply$MaximizedDetail(
										_Utils_update(
											info,
											{
												al: $author$project$Plan$DayPlanning$Supply$PreSupplySelection(
													_Utils_update(
														preSupplyInfo,
														{n: 0}))
											}))
								}),
							$author$project$Plan$DayPlanning$Supply$PlanUpdated(
								A3($author$project$Plan$Plan$withPreSupplyAssignment, preSupplyId, deliverer, plan)));
					} else {
						return noChange;
					}
				} else {
					return noChange;
				}
			case 15:
				var assistantPositionId = msg.a;
				var _v18 = model.lD;
				if (_v18.$ === 1) {
					var info = _v18.a;
					var selection = info.al;
					if (selection.$ === 2) {
						var id = selection.a.eg;
						return _Utils_eq(id, assistantPositionId) ? noImpact(
							_Utils_update(
								model,
								{
									lD: $author$project$Plan$DayPlanning$Supply$MaximizedDetail(
										_Utils_update(
											info,
											{al: $author$project$Plan$DayPlanning$Supply$NothingSelected}))
								})) : noImpact(
							_Utils_update(
								model,
								{
									lD: $author$project$Plan$DayPlanning$Supply$MaximizedDetail(
										_Utils_update(
											info,
											{
												al: $author$project$Plan$DayPlanning$Supply$AssistantPositionSelection(
													{eg: assistantPositionId, n: 0})
											}))
								}));
					} else {
						return noImpact(
							_Utils_update(
								model,
								{
									lD: $author$project$Plan$DayPlanning$Supply$MaximizedDetail(
										_Utils_update(
											info,
											{
												al: $author$project$Plan$DayPlanning$Supply$AssistantPositionSelection(
													{eg: assistantPositionId, n: 0})
											}))
								}));
					}
				} else {
					return noChange;
				}
			case 16:
				var assistantPositionId = msg.a;
				var deliverer = msg.b;
				var _v20 = model.lD;
				if (_v20.$ === 1) {
					var info = _v20.a;
					var _v21 = info.al;
					if (_v21.$ === 2) {
						var assistentInfo = _v21.a;
						var moveFolding = assistentInfo.n;
						return A2(
							withImpact,
							_Utils_update(
								model,
								{
									lD: $author$project$Plan$DayPlanning$Supply$MaximizedDetail(
										_Utils_update(
											info,
											{
												al: $author$project$Plan$DayPlanning$Supply$AssistantPositionSelection(
													_Utils_update(
														assistentInfo,
														{n: 0}))
											}))
								}),
							$author$project$Plan$DayPlanning$Supply$PlanUpdated(
								A3($author$project$Plan$Plan$withAssistantPositionAssignment, assistantPositionId, deliverer, plan)));
					} else {
						return noChange;
					}
				} else {
					return noChange;
				}
			case 17:
				var inserterPositionId = msg.a;
				var _v22 = model.lD;
				if (_v22.$ === 1) {
					var info = _v22.a;
					var selection = info.al;
					if (selection.$ === 3) {
						var id = selection.a.eg;
						return _Utils_eq(id, inserterPositionId) ? noImpact(
							_Utils_update(
								model,
								{
									lD: $author$project$Plan$DayPlanning$Supply$MaximizedDetail(
										_Utils_update(
											info,
											{al: $author$project$Plan$DayPlanning$Supply$NothingSelected}))
								})) : noImpact(
							_Utils_update(
								model,
								{
									lD: $author$project$Plan$DayPlanning$Supply$MaximizedDetail(
										_Utils_update(
											info,
											{
												al: $author$project$Plan$DayPlanning$Supply$InserterPositionSelection(
													{eg: inserterPositionId, n: 0})
											}))
								}));
					} else {
						return noImpact(
							_Utils_update(
								model,
								{
									lD: $author$project$Plan$DayPlanning$Supply$MaximizedDetail(
										_Utils_update(
											info,
											{
												al: $author$project$Plan$DayPlanning$Supply$InserterPositionSelection(
													{eg: inserterPositionId, n: 0})
											}))
								}));
					}
				} else {
					return noChange;
				}
			case 18:
				var inserterPositionId = msg.a;
				var deliverer = msg.b;
				var _v24 = model.lD;
				if (_v24.$ === 1) {
					var info = _v24.a;
					var _v25 = info.al;
					if (_v25.$ === 3) {
						var assistantInfo = _v25.a;
						var moveFolding = assistantInfo.n;
						return A2(
							withImpact,
							_Utils_update(
								model,
								{
									lD: $author$project$Plan$DayPlanning$Supply$MaximizedDetail(
										_Utils_update(
											info,
											{
												al: $author$project$Plan$DayPlanning$Supply$InserterPositionSelection(
													_Utils_update(
														assistantInfo,
														{n: 0}))
											}))
								}),
							$author$project$Plan$DayPlanning$Supply$PlanUpdated(
								A3($author$project$Plan$Plan$withInserterPositionAssignment, inserterPositionId, deliverer, plan)));
					} else {
						return noChange;
					}
				} else {
					return noChange;
				}
			case 10:
				var preSupplyId = msg.a;
				var _v26 = $author$project$Plan$Selection$supplyItemIdFrom(model.nI);
				if (!_v26.$) {
					var supplyItemId = _v26.a;
					var _v27 = _Utils_Tuple2(
						$author$project$Plan$Plan$toReadStatus(plan.nS),
						A2($author$project$Plan$Supply$findItemById, plan.gL, supplyItemId));
					if ((_v27.a === 1) && (!_v27.b.$)) {
						var _v28 = _v27.a;
						var selectedItem = _v27.b.a;
						var changedItem = A2($author$project$Plan$Supply$withPreSuppliedBy, preSupplyId, selectedItem);
						var changedItems = A3(
							$author$project$Plan$Supply$replaceItem,
							$author$project$Plan$Supply$idOf(selectedItem),
							changedItem,
							plan.gL);
						return A2(
							withImpact,
							_Utils_update(
								model,
								{
									nI: $author$project$Plan$Selection$togglePreSupplyFolding(model.nI)
								}),
							$author$project$Plan$DayPlanning$Supply$PlanUpdated(
								A2($author$project$Plan$Plan$withItems, changedItems, plan)));
					} else {
						return noChange;
					}
				} else {
					return noChange;
				}
			case 11:
				var _v29 = $author$project$Plan$Selection$supplyItemIdFrom(model.nI);
				if (!_v29.$) {
					var supplyItemId = _v29.a;
					var _v30 = _Utils_Tuple2(
						$author$project$Plan$Plan$toReadStatus(plan.nS),
						A2($author$project$Plan$Supply$findItemById, plan.gL, supplyItemId));
					if ((_v30.a === 1) && (!_v30.b.$)) {
						var _v31 = _v30.a;
						var selectedItem = _v30.b.a;
						var changedItem = $author$project$Plan$Supply$withNotPreSupplied(selectedItem);
						var changedItems = A3(
							$author$project$Plan$Supply$replaceItem,
							$author$project$Plan$Supply$idOf(selectedItem),
							changedItem,
							plan.gL);
						return A2(
							withImpact,
							model,
							$author$project$Plan$DayPlanning$Supply$PlanUpdated(
								A2($author$project$Plan$Plan$withItems, changedItems, plan)));
					} else {
						return noChange;
					}
				} else {
					return noChange;
				}
			case 12:
				return noImpact(
					_Utils_update(
						model,
						{
							nI: $author$project$Plan$Selection$togglePreSupplyFolding(model.nI)
						}));
			case 19:
				return noImpact(
					_Utils_update(
						model,
						{
							lD: function () {
								var _v32 = model.lD;
								if (!_v32.$) {
									return model.lD;
								} else {
									var info = _v32.a;
									var planFolding = info.bY;
									if (planFolding === 1) {
										return $author$project$Plan$DayPlanning$Supply$MaximizedDetail(
											_Utils_update(
												info,
												{bY: 0}));
									} else {
										return $author$project$Plan$DayPlanning$Supply$MaximizedDetail(
											_Utils_update(
												info,
												{bY: 1}));
									}
								}
							}()
						}));
			case 20:
				return noImpact(
					_Utils_update(
						model,
						{
							lD: function () {
								var _v34 = model.lD;
								if (!_v34.$) {
									return model.lD;
								} else {
									var info = _v34.a;
									var planFolding = info.bY;
									if (planFolding === 2) {
										return $author$project$Plan$DayPlanning$Supply$MaximizedDetail(
											_Utils_update(
												info,
												{bY: 0}));
									} else {
										return $author$project$Plan$DayPlanning$Supply$MaximizedDetail(
											_Utils_update(
												info,
												{bY: 2}));
									}
								}
							}()
						}));
			case 21:
				return A2(withImpact, model, $author$project$Plan$DayPlanning$Supply$PlanDeleted);
			case 22:
				return A2(withImpact, model, $author$project$Plan$DayPlanning$Supply$PlanReedited);
			case 0:
				return A2(
					withImpact,
					model,
					$author$project$Plan$DayPlanning$Supply$NewRoute(
						A2($author$project$Portal$Route$CreateDeliverer, dpId, date)));
			case 1:
				var unregisteredId = msg.a;
				var potentialId = msg.b;
				return noImpact(
					_Utils_update(
						model,
						{
							bz: A3($author$project$Deliverer$IdDict$insert, unregisteredId, potentialId, model.bz)
						}));
			case 2:
				return noChange;
			case 3:
				var unregisteredId = msg.a;
				var _v36 = A2($author$project$Deliverer$IdDict$get, unregisteredId, model.bz);
				if (!_v36.$) {
					var registeredId = _v36.a;
					return A2(
						withImpact,
						model,
						$author$project$Plan$DayPlanning$Supply$LinkedUnregisteredDeliverer(
							{ns: registeredId, oq: unregisteredId}));
				} else {
					return noChange;
				}
			case 37:
				var unregistered = msg.a;
				return A2(
					withImpact,
					_Utils_update(
						model,
						{
							ax: $author$project$Plan$DayPlanning$Supply$DeleteDeliverer(unregistered)
						}),
					$author$project$Plan$DayPlanning$Supply$NoImpact);
			case 38:
				return noChange;
			case 39:
				return A2(
					withImpact,
					_Utils_update(
						model,
						{ax: $author$project$Plan$DayPlanning$Supply$None}),
					$author$project$Plan$DayPlanning$Supply$NoImpact);
			case 40:
				var unregisteredId = msg.a;
				return A2(
					withImpact,
					_Utils_update(
						model,
						{ax: $author$project$Plan$DayPlanning$Supply$None}),
					$author$project$Plan$DayPlanning$Supply$DeleteUnregisteredDeliverer(unregisteredId));
			case 30:
				var draggedItem = msg.a;
				return noImpact(
					_Utils_update(
						model,
						{C: draggedItem}));
			case 31:
				var dragInfo = msg.a;
				var withoutDraggedImpact = function () {
					var _v43 = model.C;
					switch (_v43.$) {
						case 1:
							var draggedItem = _v43.a;
							return noImpact(
								_Utils_update(
									model,
									{
										C: $author$project$Plan$DayPlanning$Supply$DraggingItem(
											_Utils_update(
												draggedItem,
												{aG: dragInfo.bJ}))
									}));
						case 2:
							var draggedItem = _v43.a;
							return noImpact(
								_Utils_update(
									model,
									{
										C: $author$project$Plan$DayPlanning$Supply$DraggingCluster(
											_Utils_update(
												draggedItem,
												{aG: dragInfo.bJ}))
									}));
						default:
							return noImpact(model);
					}
				}();
				var withDraggedImpact = F2(
					function (draggedItem, p) {
						return A2(
							withImpact,
							_Utils_update(
								model,
								{
									C: draggedItem,
									cA: $author$project$Plan$DayPlanning$Supply$scrollingFor(dragInfo)
								}),
							$author$project$Plan$DayPlanning$Supply$PlanChanged(p));
					});
				var _v37 = model.C;
				switch (_v37.$) {
					case 1:
						var draggedItem = _v37.a;
						var _v38 = _Utils_Tuple2(
							A2(
								$author$project$Plan$DayPlanning$Supply$closestBeacon,
								A2($author$project$Plan$DayPlanning$Supply$subtractCoords, dragInfo.bJ, draggedItem.aF),
								dragInfo.f9),
							draggedItem.gK);
						if (!_v38.a.$) {
							if ((_v38.a.a.$ === 4) && (!_v38.b.$)) {
								return withoutDraggedImpact;
							} else {
								var position = _v38.a.a;
								if (_Utils_eq(
									$author$project$Plan$Supply$idOf(draggedItem.gK),
									$author$project$Plan$Supply$idOfPosition(position))) {
									return withoutDraggedImpact;
								} else {
									var _v39 = A3(
										$author$project$Plan$DayPlanning$Supply$handleItemDragged,
										position,
										{bF: draggedItem.bF, gK: draggedItem.gK},
										plan.gL);
									var newItems = _v39.a;
									var appendedTo = _v39.b;
									return A2(
										withDraggedImpact,
										$author$project$Plan$DayPlanning$Supply$DraggingItem(
											_Utils_update(
												draggedItem,
												{bF: appendedTo, aG: dragInfo.bJ})),
										A2($author$project$Plan$Plan$withItems, newItems, plan));
								}
							}
						} else {
							return withoutDraggedImpact;
						}
					case 2:
						var draggedItem = _v37.a;
						var _v40 = _Utils_Tuple2(
							A2(
								$author$project$Plan$DayPlanning$Supply$closestBeacon,
								A2($author$project$Plan$DayPlanning$Supply$subtractCoords, dragInfo.bJ, draggedItem.aF),
								dragInfo.f9),
							A3($author$project$Plan$Supply$splitClusterFrom, plan.ei, draggedItem.H, draggedItem.gK));
						if ((!_v40.a.$) && (!_v40.b.$)) {
							var position = _v40.a.a;
							var _v41 = _v40.b.a;
							var originalItem = _v41.a;
							var newItem = _v41.b;
							var nextId = _v41.c;
							var _v42 = A3(
								$author$project$Plan$DayPlanning$Supply$handleClusterDragged,
								position,
								{C: draggedItem.gK, jl: newItem, jr: originalItem},
								plan.gL);
							var newItems = _v42.a;
							var appendedTo = _v42.b;
							return A2(
								withDraggedImpact,
								$author$project$Plan$DayPlanning$Supply$DraggingItem(
									{bF: appendedTo, aF: draggedItem.aF, aG: dragInfo.bJ, gK: newItem}),
								A2(
									$author$project$Plan$Plan$withNextId,
									nextId,
									A2($author$project$Plan$Plan$withItems, newItems, plan)));
						} else {
							return withoutDraggedImpact;
						}
					default:
						return withoutDraggedImpact;
				}
			case 33:
				var _v44 = model.C;
				if (!_v44.$) {
					return noImpact(
						_Utils_update(
							model,
							{cA: 0}));
				} else {
					var selected = function () {
						var _v45 = model.nI;
						if (_v45.$ === 2) {
							var supplyItemId = _v45.a.dF;
							var _v46 = A2($author$project$Plan$Supply$findItemById, plan.gL, supplyItemId);
							if (!_v46.$) {
								return model.nI;
							} else {
								return $author$project$Plan$Selection$NoDeliverer;
							}
						} else {
							return model.nI;
						}
					}();
					return A2(
						withImpact,
						_Utils_update(
							model,
							{C: $author$project$Plan$DayPlanning$Supply$NotDragging, nI: selected}),
						$author$project$Plan$DayPlanning$Supply$PlanUpdated(plan));
				}
			case 32:
				return noImpact(
					_Utils_update(
						model,
						{cA: 0}));
			case 35:
				return A2(
					withImpact,
					model,
					$author$project$Plan$DayPlanning$Supply$BackgroundCommand(
						A2(
							$elm$core$Task$attempt,
							$author$project$Plan$DayPlanning$Supply$SystemScrolledSupplyView,
							A2(
								$elm$core$Task$andThen,
								function (info) {
									return A3($elm$browser$Browser$Dom$setViewportOf, $author$project$Plan$DayPlanning$Supply$supplyItemsId, info.kx.ay, info.kx.bg + model.cA);
								},
								$elm$browser$Browser$Dom$getViewportOf($author$project$Plan$DayPlanning$Supply$supplyItemsId)))));
			case 36:
				return noChange;
			case 29:
				var show = msg.a;
				var segmentId = msg.b;
				if (show) {
					return A2(
						withImpact,
						model,
						$author$project$Plan$DayPlanning$Supply$FocusedSegment(
							$elm$core$Maybe$Just(segmentId)));
				} else {
					return A2(
						withImpact,
						model,
						$author$project$Plan$DayPlanning$Supply$FocusedSegment($elm$core$Maybe$Nothing));
				}
			case 34:
				return noChange;
			default:
				var deliverer = msg.a;
				var color = msg.b;
				var updated = A2($author$project$Deliverer$Deliverer$withColor, color, deliverer);
				return A2(
					withImpact,
					_Utils_update(
						model,
						{
							nI: A2($author$project$Plan$Selection$withDeliverer, updated, model.nI)
						}),
					A2($author$project$Plan$DayPlanning$Supply$DelivererColorUpdated, updated, plan));
		}
	});
var $author$project$Deliverer$Colors$toString = function (color) {
	switch (color) {
		case 0:
			return 'blue';
		case 1:
			return 'orange';
		case 2:
			return 'green';
		case 3:
			return 'red';
		case 4:
			return 'purple';
		case 5:
			return 'brown';
		case 6:
			return 'pink';
		case 7:
			return 'grey';
		case 8:
			return 'yellow';
		case 9:
			return 'cyan';
		case 10:
			return 'darkBlue';
		case 11:
			return 'darkOrange';
		case 12:
			return 'darkGreen';
		case 13:
			return 'darkRed';
		case 14:
			return 'darkPurple';
		case 15:
			return 'darkBrown';
		case 16:
			return 'darkPink';
		case 19:
			return 'darkGrey';
		case 18:
			return 'darkYellow';
		default:
			return 'darkCyan';
	}
};
var $author$project$Deliverer$Deliverer$updateColor = F4(
	function (token, toMsg, id, color) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'deliverers',
					$author$project$Deliverer$Deliverer$comparableId(id),
					'color',
					$author$project$Deliverer$Colors$toString(color)
				]),
			_List_Nil);
		return A4($author$project$Api$Request$put, token, toMsg, uri, $elm$http$Http$emptyBody);
	});
var $author$project$Plan$DayPlanning$updatingDeliverer = $author$project$Plan$DayPlanning$singleAction('updatingDeliverer');
var $author$project$Plan$Supply$updateDeliverer = F2(
	function (updated, supplyItem) {
		switch (supplyItem.$) {
			case 0:
				var car = supplyItem.a;
				var deliverer = car.bl;
				var supplies = car.n0;
				return _Utils_eq(
					$author$project$Deliverer$Deliverer$idFromTyped(deliverer),
					$author$project$Deliverer$Deliverer$idFromTyped(updated)) ? $author$project$Plan$Supply$Car(
					_Utils_update(
						car,
						{
							bl: updated,
							n0: A2(
								$elm$core$List$map,
								$author$project$Plan$Supply$updateDeliverer(updated),
								supplies)
						})) : $author$project$Plan$Supply$Car(
					_Utils_update(
						car,
						{
							n0: A2(
								$elm$core$List$map,
								$author$project$Plan$Supply$updateDeliverer(updated),
								supplies)
						}));
			case 1:
				var bike = supplyItem.a;
				var deliverer = bike.bl;
				return _Utils_eq(
					$author$project$Deliverer$Deliverer$idFromTyped(deliverer),
					$author$project$Deliverer$Deliverer$idFromTyped(updated)) ? $author$project$Plan$Supply$Bike(
					_Utils_update(
						bike,
						{bl: updated})) : supplyItem;
			default:
				return supplyItem;
		}
	});
var $author$project$Plan$Plan$withDelivererUpdated = F2(
	function (updated, plan) {
		var updateAssignment = function (assignment) {
			var id = assignment.eg;
			var deliverer = assignment.bl;
			var _v1 = _Utils_eq(
				$author$project$Deliverer$Deliverer$idFromTyped(deliverer),
				$author$project$Deliverer$Deliverer$idFromTyped(updated));
			if (_v1) {
				return _Utils_update(
					assignment,
					{bl: updated});
			} else {
				return assignment;
			}
		};
		var preSupply = function () {
			var _v0 = plan.ni;
			if (!_v0.$) {
				var assignments = _v0.a;
				return $author$project$Plan$Plan$PreSupplied(
					A2($elm$core$List$map, updateAssignment, assignments));
			} else {
				var assignments = _v0.a;
				return $author$project$Plan$Plan$PreSupplied(
					A2($elm$core$List$map, updateAssignment, assignments));
			}
		}();
		return _Utils_update(
			plan,
			{
				kT: A2($elm$core$List$map, updateAssignment, plan.kT),
				ms: A2($elm$core$List$map, updateAssignment, plan.ms),
				gL: A2(
					$elm$core$List$map,
					$author$project$Plan$Supply$updateDeliverer(updated),
					plan.gL),
				ni: preSupply
			});
	});
var $author$project$Plan$DayPlanning$withoutPopup = $author$project$Plan$DayPlanning$closePopup;
var $author$project$Plan$DayPlanning$handleSupplyMsg = F3(
	function (share, model, supplyMsg) {
		var token = $author$project$Portal$Share$token(share);
		var to = function (route) {
			return _Utils_Tuple3(
				A2($author$project$Portal$Share$withNewRoute, route, share),
				model,
				$elm$core$Platform$Cmd$none);
		};
		var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		var modelChange = function (m) {
			return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
		};
		var dpId = $author$project$Plan$DayPlanning$toDistributionPointId(model.bn);
		var actionKey = _Utils_Tuple2(dpId, model.lx);
		var withCommand = function (toAction) {
			return $author$project$Portal$Return$withCommand(
				toAction(actionKey));
		};
		var _v0 = $author$project$Plan$PlanLoader$loadedOf(model.fB);
		if (!_v0.$) {
			var p = _v0.a;
			var _v1 = A5($author$project$Plan$DayPlanning$Supply$update, supplyMsg, p.fA, model.lx, dpId, model.z);
			var supplyMdl = _v1.a;
			var impact = _v1.b;
			switch (impact.$) {
				case 0:
					return modelChange(
						_Utils_update(
							model,
							{z: supplyMdl}));
				case 1:
					var newPlan = impact.a;
					return modelChange(
						$author$project$Plan$DayPlanning$withoutPopup(
							_Utils_update(
								model,
								{
									fB: $author$project$Plan$PlanLoader$Loaded(
										_Utils_update(
											p,
											{fA: newPlan})),
									z: supplyMdl
								})));
				case 2:
					var newPlan = impact.a;
					return A3(
						withCommand,
						$author$project$Plan$DayPlanning$changingPlan,
						A4($author$project$Plan$Plan$updatePlanCmd, token, $author$project$Plan$DayPlanning$SavedPlan, newPlan, p.e4),
						modelChange(
							$author$project$Plan$DayPlanning$withoutPopup(
								_Utils_update(
									model,
									{
										fB: $author$project$Plan$PlanLoader$Loaded(
											_Utils_update(
												p,
												{fA: newPlan})),
										z: supplyMdl
									}))));
				case 5:
					var maybeId = impact.a;
					return modelChange(
						_Utils_update(
							model,
							{de: maybeId, z: supplyMdl}));
				case 9:
					var route = impact.a;
					return to(route);
				case 3:
					return A3(
						withCommand,
						$author$project$Plan$DayPlanning$deletingPlan,
						A4($author$project$Plan$Plan$deletePlanCmd, token, $author$project$Plan$DayPlanning$SystemRespondedPlanDelete, dpId, model.lx),
						noChange);
				case 4:
					return A3(
						withCommand,
						$author$project$Plan$DayPlanning$reeditingPlan,
						A4($author$project$Plan$Plan$reeditPlanCmd, token, $author$project$Plan$DayPlanning$SystemRespondedPlanReedit, dpId, model.lx),
						noChange);
				case 7:
					var unregisteredId = impact.a.oq;
					var registeredId = impact.a.ns;
					return A3(
						withCommand,
						$author$project$Plan$DayPlanning$linkingUnregisteredDeliverer,
						A3(
							$author$project$Deliverer$Unregistered$linkCmd,
							token,
							$author$project$Plan$DayPlanning$SystemLinkedUnregisteredDeliverer,
							{nr: registeredId, op: unregisteredId}),
						noChange);
				case 8:
					var unregisteredId = impact.a;
					return A3(
						withCommand,
						$author$project$Plan$DayPlanning$deletingUnregisteredDeliverer,
						A4($author$project$Deliverer$Unregistered$deleteCmd, token, $author$project$Plan$DayPlanning$SystemDeletedUnregisteredDeliverer, unregisteredId, model.lx),
						modelChange(
							_Utils_update(
								model,
								{z: supplyMdl})));
				case 6:
					var maybeId = impact.a;
					return modelChange(
						_Utils_update(
							model,
							{dc: maybeId, z: supplyMdl}));
				case 10:
					var cmd = impact.a;
					return A2(
						$author$project$Portal$Return$withBackgroundCommand,
						A2($elm$core$Platform$Cmd$map, $author$project$Plan$DayPlanning$GotSupplyMsg, cmd),
						noChange);
				default:
					var updated = impact.a;
					var newPlan = impact.b;
					return A3(
						withCommand,
						$author$project$Plan$DayPlanning$updatingDeliverer,
						A4(
							$author$project$Deliverer$Deliverer$updateColor,
							token,
							$author$project$Plan$DayPlanning$SystemRespondedDelivererColorUpdated,
							$author$project$Deliverer$Deliverer$idFromTyped(updated),
							$author$project$Deliverer$Deliverer$colorOf(updated)),
						modelChange(
							function (planAndDeliverers) {
								return _Utils_update(
									model,
									{fB: planAndDeliverers, z: supplyMdl});
							}(
								$author$project$Plan$PlanLoader$Loaded(
									_Utils_update(
										p,
										{
											e4: A3(
												$author$project$Deliverer$IdDict$insert,
												$author$project$Deliverer$Deliverer$idFromTyped(updated),
												updated,
												p.e4),
											fA: A2($author$project$Plan$Plan$withDelivererUpdated, updated, newPlan)
										})))));
			}
		} else {
			return noChange;
		}
	});
var $author$project$Plan$DayPlanning$OpeningPopup = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$DayPlanning$openPopup = F2(
	function (popupState, model) {
		return _Utils_update(
			model,
			{
				b_: $author$project$Plan$DayPlanning$OpeningPopup(popupState)
			});
	});
var $author$project$Plan$PlanLoader$reload = F5(
	function (share, token, toAction, dpId, date) {
		var unregisteredAction = A2($author$project$Plan$PlanLoader$toWaitingAction, toAction, 1);
		var delivererAction = A2($author$project$Plan$PlanLoader$toWaitingAction, toAction, 0);
		return _Utils_Tuple3(
			A2(
				$author$project$Portal$Share$withWaitingActions,
				_List_fromArray(
					[delivererAction, unregisteredAction]),
				share),
			$author$project$Plan$PlanLoader$LoadingDeliverers(
				{
					a8: A2($author$project$Plan$Plan$Id, dpId, date),
					aQ: $elm$core$Maybe$Nothing,
					aV: $elm$core$Maybe$Nothing
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A5(
						$author$project$Deliverer$Deliverer$loadByPlan,
						token,
						$author$project$Plan$PlanLoader$SystemLoadedRegistered,
						dpId,
						date,
						$author$project$Plan$PlanLoader$tracked(delivererAction)),
						A5(
						$author$project$Deliverer$Unregistered$loadCmd,
						token,
						$author$project$Plan$PlanLoader$SystemLoadedUnregistered,
						dpId,
						date,
						$author$project$Plan$PlanLoader$tracked(unregisteredAction))
					])));
	});
var $author$project$Plan$DayPlanning$togglePopup = F2(
	function (popupState, model) {
		return _Utils_eq(model.b_, popupState) ? $author$project$Plan$DayPlanning$closePopup(model) : A2($author$project$Plan$DayPlanning$openPopup, popupState, model);
	});
var $author$project$Plan$DayPlanning$Demand$whenWaiting = function (msg) {
	return 1;
};
var $author$project$Plan$DayPlanning$Supply$whenWaiting = function (msg) {
	switch (msg.$) {
		case 4:
			return 1;
		case 23:
			return 1;
		case 25:
			return 1;
		case 29:
			return 0;
		case 24:
			return 0;
		case 26:
			return 1;
		case 5:
			return 1;
		case 34:
			return 1;
		case 14:
			return 1;
		case 28:
			return 1;
		case 27:
			return 1;
		case 6:
			return 0;
		case 7:
			return 0;
		case 8:
			return 0;
		case 13:
			return 0;
		case 9:
			return 1;
		case 15:
			return 0;
		case 16:
			return 1;
		case 17:
			return 0;
		case 18:
			return 1;
		case 10:
			return 1;
		case 11:
			return 1;
		case 12:
			return 0;
		case 19:
			return 0;
		case 20:
			return 0;
		case 21:
			return 1;
		case 22:
			return 1;
		case 0:
			return 0;
		case 1:
			return 0;
		case 3:
			return 1;
		case 2:
			return 0;
		case 30:
			return 1;
		case 31:
			return 1;
		case 33:
			return 1;
		case 32:
			return 1;
		case 35:
			return 0;
		case 36:
			return 0;
		case 37:
			return 1;
		case 38:
			return 1;
		case 39:
			return 1;
		case 40:
			return 1;
		default:
			return 0;
	}
};
var $author$project$Plan$DayPlanning$whenWaiting = function (msg) {
	switch (msg.$) {
		case 0:
			return 0;
		case 22:
			return 0;
		case 1:
			return 0;
		case 2:
			return 0;
		case 12:
			return 1;
		case 13:
			return 0;
		case 14:
			return 0;
		case 15:
			return 0;
		case 16:
			return 0;
		case 17:
			return 0;
		case 18:
			return 0;
		case 19:
			return 0;
		case 20:
			return 0;
		case 21:
			return 0;
		case 6:
			return 0;
		case 7:
			return 0;
		case 23:
			return 0;
		case 8:
			return 0;
		case 9:
			return 0;
		case 5:
			return 0;
		case 10:
			return 0;
		case 11:
			return 0;
		case 4:
			var supplyMsg = msg.a;
			return $author$project$Plan$DayPlanning$Supply$whenWaiting(supplyMsg);
		case 3:
			var demandMsg = msg.a;
			return $author$project$Plan$DayPlanning$Demand$whenWaiting(demandMsg);
		default:
			return 0;
	}
};
var $author$project$Plan$Plan$withStatus = F2(
	function (status, plan) {
		return _Utils_update(
			plan,
			{nS: status});
	});
var $author$project$Plan$Plan$withVersion = F2(
	function (version, plan) {
		return _Utils_update(
			plan,
			{ov: version});
	});
var $author$project$Plan$DayPlanning$update = F3(
	function (msg, share, model) {
		return A2(
			$author$project$Portal$Return$ensureDataShared,
			$author$project$Plan$DayPlanning$shareDataFromModel,
			function () {
				if (A3($author$project$Portal$Share$allowed, $author$project$Plan$DayPlanning$whenWaiting, msg, share) === 1) {
					return _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
				} else {
					var withNotification = F2(
						function (message, _v16) {
							var s = _v16.a;
							var m = _v16.b;
							var cmd = _v16.c;
							return _Utils_Tuple3(
								A2($author$project$Portal$Share$withNotification, message, s),
								m,
								cmd);
						});
					var token = $author$project$Portal$Share$token(share);
					var to = function (route) {
						return _Utils_Tuple3(
							A2($author$project$Portal$Share$withNewRoute, route, share),
							model,
							$elm$core$Platform$Cmd$none);
					};
					var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
					var modelChange = function (m) {
						return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
					};
					var dpId = $author$project$Plan$DayPlanning$toDistributionPointId(model.bn);
					var actionKey = _Utils_Tuple2(dpId, model.lx);
					var err = F3(
						function (toAction, error, m) {
							return _Utils_Tuple3(
								A2(
									$author$project$Portal$Share$withHttpError,
									error,
									A2(
										$author$project$Portal$Share$withoutWaitingAction,
										toAction(actionKey),
										share)),
								m,
								$elm$core$Platform$Cmd$none);
						});
					var withCommand = function (toAction) {
						return $author$project$Portal$Return$withCommand(
							toAction(actionKey));
					};
					var withCommands = function (toAction) {
						return $author$project$Portal$Return$withCommands(
							toAction(actionKey));
					};
					var withoutAction = function (toAction) {
						return $author$project$Portal$Return$withoutAction(
							toAction(actionKey));
					};
					var withoutIndexedAction = F2(
						function (toAction, index) {
							return $author$project$Portal$Return$withoutAction(
								A2(toAction, actionKey, index));
						});
					_v0$27:
					while (true) {
						_v0$32:
						while (true) {
							switch (msg.$) {
								case 0:
									return noChange;
								case 1:
									var planLoaderMsg = msg.a;
									var _v1 = A2(
										$author$project$Plan$PlanLoader$mapModel,
										function (pAndD) {
											return _Utils_update(
												model,
												{fB: pAndD});
										},
										A2(
											$author$project$Plan$PlanLoader$registerErrorOnFailedExcept,
											$elm$http$Http$BadStatus(404),
											A2(
												$author$project$Plan$PlanLoader$mapCommand,
												$elm$core$Platform$Cmd$map($author$project$Plan$DayPlanning$SystemGotLoaderMsg),
												A6(
													$author$project$Plan$PlanLoader$update,
													share,
													token,
													$author$project$Plan$DayPlanning$loadingPlan(actionKey),
													$author$project$Plan$DayPlanning$convert,
													planLoaderMsg,
													model.fB))));
									var newShare = _v1.a;
									var modelWithNewPAndD = _v1.b;
									var loadMoreCmd = _v1.c;
									var _v2 = modelWithNewPAndD.fB;
									switch (_v2.$) {
										case 4:
											if ((_v2.a.$ === 3) && (_v2.a.a === 404)) {
												return _Utils_Tuple3(
													A2(
														$author$project$Portal$Share$withNewRoute,
														A2($author$project$Portal$Route$CreatePlan, dpId, model.lx),
														share),
													modelWithNewPAndD,
													$elm$core$Platform$Cmd$none);
											} else {
												var error = _v2.a;
												return _Utils_Tuple3(
													A2($author$project$Portal$Share$withHttpError, error, newShare),
													modelWithNewPAndD,
													$elm$core$Platform$Cmd$none);
											}
										case 3:
											var loaded = _v2.a;
											return _Utils_Tuple3(
												function () {
													var _v3 = loaded.fA.mI;
													if (_v3) {
														return A2(
															$author$project$Portal$Share$withNotification,
															A2(
																$author$project$Portal$Message$error,
																'Bezorgers zijn mogelijk verkeerd gekoppeld',
																$elm$core$Maybe$Just('Het is niet gelukt om alle wijzigingen vanuit Embrace te synchroniseren. Gelieve het plan te controleren.')),
															newShare);
													} else {
														return newShare;
													}
												}(),
												_Utils_update(
													modelWithNewPAndD,
													{
														z: A3($author$project$Plan$DayPlanning$Supply$ensureMaximizedWhenUnregisteredReserve, loaded.fA, loaded.e4, model.z)
													}),
												loadMoreCmd);
										default:
											return _Utils_Tuple3(newShare, modelWithNewPAndD, loadMoreCmd);
									}
								case 2:
									if (!msg.b.$) {
										var index = msg.a;
										var _v4 = msg.b.a;
										var subDPId = _v4.a;
										var status = _v4.b;
										return A3(
											withoutIndexedAction,
											$author$project$Plan$DayPlanning$loadingSubDPStatuses,
											index,
											modelChange(
												_Utils_update(
													model,
													{
														cJ: A3(
															$author$project$DistributionPoint$IdDict$insert,
															subDPId,
															$elm$core$Maybe$Just(status),
															model.cJ)
													})));
									} else {
										if (!msg.b.a.$) {
											var index = msg.a;
											var subDPId = msg.b.a.a;
											return A3(
												withoutIndexedAction,
												$author$project$Plan$DayPlanning$loadingSubDPStatuses,
												index,
												modelChange(
													_Utils_update(
														model,
														{
															cJ: A3($author$project$DistributionPoint$IdDict$insert, subDPId, $elm$core$Maybe$Nothing, model.cJ)
														})));
										} else {
											var index = msg.a;
											var error = msg.b.a.a;
											return A3(
												err,
												function (key) {
													return A2($author$project$Plan$DayPlanning$loadingSubDPStatuses, key, index);
												},
												error,
												model);
										}
									}
								case 3:
									var demandMsg = msg.a;
									return A3($author$project$Plan$DayPlanning$handleDemandMsg, share, model, demandMsg);
								case 4:
									if (msg.a.$ === 34) {
										var demandMsg = msg.a.a;
										return A3($author$project$Plan$DayPlanning$handleDemandMsg, share, model, demandMsg);
									} else {
										var supplyMsg = msg.a;
										return A3($author$project$Plan$DayPlanning$handleSupplyMsg, share, model, supplyMsg);
									}
								case 13:
									if (!msg.a.$) {
										var plan = msg.a.a;
										return A2(
											withoutAction,
											$author$project$Plan$DayPlanning$changingPlan,
											function () {
												var _v5 = $author$project$Plan$PlanLoader$loadedOf(model.fB);
												if (!_v5.$) {
													var p = _v5.a;
													return modelChange(
														_Utils_update(
															model,
															{
																fB: $author$project$Plan$PlanLoader$Loaded(
																	_Utils_update(
																		p,
																		{
																			fA: A2($author$project$Plan$Plan$withVersion, plan.ov, p.fA)
																		}))
															}));
												} else {
													return noChange;
												}
											}());
									} else {
										if (!msg.a.a.$) {
											var plan = msg.a.a.a;
											return A2(
												withoutAction,
												$author$project$Plan$DayPlanning$changingPlan,
												function () {
													var _v6 = model.fB;
													if (_v6.$ === 3) {
														var p = _v6.a;
														return A2(
															$author$project$Portal$Return$withMessage,
															A2($author$project$Portal$Message$info, 'Het plan werd gewijzigd.', 'Het gewijzigde plan werd ingeladen.'),
															modelChange(
																_Utils_update(
																	model,
																	{
																		fB: $author$project$Plan$PlanLoader$Loaded(
																			_Utils_update(
																				p,
																				{fA: plan}))
																	})));
													} else {
														return A2(
															$author$project$Portal$Return$withMessage,
															A2(
																$author$project$Portal$Message$error,
																'Er is een probleem opgetreden.',
																$elm$core$Maybe$Just('We raden aan om de applicatie opnieuw op te starten.')),
															noChange);
													}
												}());
										} else {
											var error = msg.a.a.a;
											return A3(err, $author$project$Plan$DayPlanning$changingPlan, error, model);
										}
									}
								case 6:
									if (!msg.a.$) {
										var distributionPoint = msg.a.a;
										var supplyMdl = model.z;
										return function () {
											var _v7 = $author$project$DistributionPoint$DistributionPoint$getSubDistributionPoints(distributionPoint);
											if (!_v7.b) {
												return $elm$core$Basics$identity;
											} else {
												var subDPs = _v7;
												return A2(
													withCommands,
													$author$project$Plan$DayPlanning$loadingSubDPStatuses,
													A2(
														$elm$core$List$map,
														A2($author$project$Plan$DayPlanning$cmdToLoadSubDPStatus, token, model.lx),
														subDPs));
											}
										}()(
											A2(
												withoutAction,
												$author$project$Plan$DayPlanning$loadingDP,
												modelChange(
													_Utils_update(
														model,
														{
															bn: $author$project$Plan$DayPlanning$Loaded(distributionPoint),
															dc: $elm$core$Maybe$Nothing,
															de: $elm$core$Maybe$Nothing,
															z: _Utils_update(
																supplyMdl,
																{nI: $author$project$Plan$Selection$NoDeliverer})
														}))));
									} else {
										var error = msg.a.a;
										return A3(
											err,
											$author$project$Plan$DayPlanning$loadingDP,
											error,
											_Utils_update(
												model,
												{
													bn: $author$project$Plan$DayPlanning$Failed(dpId)
												}));
									}
								case 7:
									if (!msg.a.$) {
										var orders = msg.a.a;
										return A2(
											withoutAction,
											$author$project$Plan$DayPlanning$loadingOrders,
											modelChange(
												_Utils_update(
													model,
													{
														Y: $author$project$Plan$DayPlanning$Loaded(orders)
													})));
									} else {
										var error = msg.a.a;
										return A3(err, $author$project$Plan$DayPlanning$loadingOrders, error, model);
									}
								case 8:
									if (!msg.a.$) {
										var _v8 = msg.a.a;
										var selected = _v8.b;
										return A2(
											$author$project$Portal$Return$withMessage,
											A2(
												$author$project$Portal$Message$info,
												'Plan verwijderd',
												'Het plan voor ' + ($author$project$Date$DeliveryDate$view(selected) + ' is verwijderd.')),
											A2(
												withoutAction,
												$author$project$Plan$DayPlanning$deletingPlan,
												_Utils_eq(selected, model.lx) ? to(
													A2($author$project$Portal$Route$CreatePlan, dpId, model.lx)) : modelChange(
													_Utils_update(
														model,
														{
															r: $author$project$Portal$Subheader$Hidden(
																{fT: $elm$core$Maybe$Nothing})
														}))));
									} else {
										var error = msg.a.a;
										return A3(err, $author$project$Plan$DayPlanning$deletingPlan, error, model);
									}
								case 5:
									var subHeaderMsg = msg.a;
									var _v9 = A5(
										$author$project$Portal$Subheader$update,
										subHeaderMsg,
										share,
										$elm$core$Maybe$Just(dpId),
										model.lx,
										model.r);
									switch (_v9.a.$) {
										case 0:
											var _v10 = _v9.a;
											var _v11 = _v9.b;
											var s = _v11.a;
											var m = _v11.b;
											var cmd = _v11.c;
											return _Utils_Tuple3(
												s,
												_Utils_update(
													model,
													{r: m}),
												A2($elm$core$Platform$Cmd$map, $author$project$Plan$DayPlanning$GotSubHeaderMsg, cmd));
										case 1:
											var date = _v9.a.a;
											return to(
												A2(
													$author$project$Portal$Route$DayPlanning,
													$author$project$Plan$DayPlanning$toDistributionPointId(model.bn),
													date));
										case 2:
											var date = _v9.a.a;
											return to(
												A2(
													$author$project$Portal$Route$CreatePlan,
													$author$project$Plan$DayPlanning$toDistributionPointId(model.bn),
													date));
										default:
											var date = _v9.a.a;
											return A3(
												withCommand,
												$author$project$Plan$DayPlanning$deletingPlan,
												A4($author$project$Plan$Plan$deletePlanCmd, token, $author$project$Plan$DayPlanning$SystemRespondedPlanDelete, dpId, date),
												noChange);
									}
								case 10:
									if (!msg.a.$) {
										return A2(
											withoutAction,
											$author$project$Plan$DayPlanning$linkingUnregisteredDeliverer,
											A2(
												$author$project$Plan$PlanLoader$mapModel,
												function (pAndD) {
													return _Utils_update(
														model,
														{fB: pAndD});
												},
												A2(
													$author$project$Plan$PlanLoader$mapCommand,
													$elm$core$Platform$Cmd$map($author$project$Plan$DayPlanning$SystemGotLoaderMsg),
													A5(
														$author$project$Plan$PlanLoader$reload,
														share,
														token,
														$author$project$Plan$DayPlanning$loadingPlan(actionKey),
														dpId,
														model.lx))));
									} else {
										var error = msg.a.a;
										return A3(err, $author$project$Plan$DayPlanning$linkingUnregisteredDeliverer, error, model);
									}
								case 11:
									if (!msg.a.$) {
										return A2(
											withoutAction,
											$author$project$Plan$DayPlanning$deletingUnregisteredDeliverer,
											A2(
												$author$project$Plan$PlanLoader$mapModel,
												function (pAndD) {
													return _Utils_update(
														model,
														{fB: pAndD});
												},
												A2(
													$author$project$Plan$PlanLoader$mapCommand,
													$elm$core$Platform$Cmd$map($author$project$Plan$DayPlanning$SystemGotLoaderMsg),
													A5(
														$author$project$Plan$PlanLoader$reload,
														share,
														token,
														$author$project$Plan$DayPlanning$loadingPlan(actionKey),
														dpId,
														model.lx))));
									} else {
										var error = msg.a.a;
										return A3(err, $author$project$Plan$DayPlanning$deletingUnregisteredDeliverer, error, model);
									}
								case 12:
									var _v12 = $author$project$Plan$PlanLoader$loadedOf(model.fB);
									if (!_v12.$) {
										var p = _v12.a;
										var _v13 = p.fA.nS;
										if (!_v13) {
											return A3(
												withCommand,
												$author$project$Plan$DayPlanning$finalizingPlan,
												A4($author$project$Plan$Plan$finalizePlanCmd, token, $author$project$Plan$DayPlanning$FinalizedPlan, dpId, model.lx),
												noChange);
										} else {
											return noChange;
										}
									} else {
										return noChange;
									}
								case 14:
									if (!msg.a.$) {
										return A2(
											withoutAction,
											$author$project$Plan$DayPlanning$finalizingPlan,
											function () {
												var _v14 = $author$project$Plan$PlanLoader$loadedOf(model.fB);
												if (_v14.$ === 1) {
													return noChange;
												} else {
													var p = _v14.a;
													return modelChange(
														function (pl) {
															return _Utils_update(
																model,
																{fB: pl});
														}(
															$author$project$Plan$PlanLoader$Loaded(
																_Utils_update(
																	p,
																	{
																		fA: A2($author$project$Plan$Plan$withStatus, 2, p.fA)
																	}))));
												}
											}());
									} else {
										if (!msg.a.a.$) {
											var failures = msg.a.a.a;
											return A2(
												withoutAction,
												$author$project$Plan$DayPlanning$finalizingPlan,
												modelChange(
													A2(
														$author$project$Plan$DayPlanning$openPopup,
														A2($author$project$Plan$DayPlanning$StatusUpdateFailurePopup, 0, failures),
														model)));
										} else {
											if (msg.a.a.a.$ === 3) {
												switch (msg.a.a.a.a) {
													case 409:
														return A2(
															withNotification,
															A2(
																$author$project$Portal$Message$error,
																'Het plan is al doorgestuurd voor betaling',
																$elm$core$Maybe$Just('Het plan kan niet nogmaals doorgestuurd worden.')),
															A2(withoutAction, $author$project$Plan$DayPlanning$finalizingPlan, noChange));
													case 404:
														return A2(
															withNotification,
															A2(
																$author$project$Portal$Message$error,
																'Het plan bestaat niet meer',
																$elm$core$Maybe$Just('Het plan bestaat niet (meer), door de pagina te verversen kunt u een nieuw plan aanmaken voor deze dag.')),
															A2(withoutAction, $author$project$Plan$DayPlanning$finalizingPlan, noChange));
													default:
														break _v0$27;
												}
											} else {
												break _v0$27;
											}
										}
									}
								case 9:
									if (!msg.a.$) {
										return A2(
											withoutAction,
											$author$project$Plan$DayPlanning$reeditingPlan,
											function () {
												var _v15 = $author$project$Plan$PlanLoader$loadedOf(model.fB);
												if (_v15.$ === 1) {
													return noChange;
												} else {
													var p = _v15.a;
													return modelChange(
														function (pl) {
															return _Utils_update(
																model,
																{fB: pl});
														}(
															$author$project$Plan$PlanLoader$Loaded(
																_Utils_update(
																	p,
																	{
																		fA: A2($author$project$Plan$Plan$withStatus, 0, p.fA)
																	}))));
												}
											}());
									} else {
										if (!msg.a.a.$) {
											var failures = msg.a.a.a;
											return A2(
												withoutAction,
												$author$project$Plan$DayPlanning$reeditingPlan,
												modelChange(
													A2(
														$author$project$Plan$DayPlanning$openPopup,
														A2($author$project$Plan$DayPlanning$StatusUpdateFailurePopup, 1, failures),
														model)));
										} else {
											if (msg.a.a.a.$ === 3) {
												switch (msg.a.a.a.a) {
													case 409:
														return A2(
															withNotification,
															A2($author$project$Portal$Message$error, 'Het plan is nog niet doorgestuurd voor betaling', $elm$core$Maybe$Nothing),
															A2(withoutAction, $author$project$Plan$DayPlanning$reeditingPlan, noChange));
													case 404:
														return A2(
															withNotification,
															A2(
																$author$project$Portal$Message$error,
																'Het plan bestaat niet meer',
																$elm$core$Maybe$Just('Het plan bestaat niet (meer), door de pagina te verversen kunt u een nieuw plan aanmaken voor deze dag.')),
															A2(withoutAction, $author$project$Plan$DayPlanning$reeditingPlan, noChange));
													default:
														break _v0$32;
												}
											} else {
												break _v0$32;
											}
										}
									}
								case 15:
									return modelChange(
										A2($author$project$Plan$DayPlanning$togglePopup, $author$project$Plan$DayPlanning$ListsMenuPopup, model));
								case 16:
									return to(
										A2($author$project$Portal$Route$DistributionList, dpId, model.lx));
								case 17:
									return to(
										A2($author$project$Portal$Route$DistributionListB, dpId, model.lx));
								case 18:
									return to(
										A2($author$project$Portal$Route$HubPackList, dpId, model.lx));
								case 19:
									return to(
										A2($author$project$Portal$Route$ReceivedCheckList, dpId, model.lx));
								case 20:
									return to(
										A2($author$project$Portal$Route$PreSupplyList, dpId, model.lx));
								case 21:
									return to(
										A2($author$project$Portal$Route$RouteDetail, dpId, model.lx));
								case 22:
									var popupState = msg.a;
									return modelChange(
										_Utils_update(
											model,
											{b_: popupState}));
								case 23:
									return modelChange(
										$author$project$Plan$DayPlanning$closePopup(model));
								default:
									if (!msg.a.$) {
										return A2(withoutAction, $author$project$Plan$DayPlanning$updatingDeliverer, noChange);
									} else {
										var error = msg.a.a;
										return A2(
											withoutAction,
											$author$project$Plan$DayPlanning$updatingDeliverer,
											A3(err, $author$project$Plan$DayPlanning$updatingDeliverer, error, model));
									}
							}
						}
						var error = msg.a.a.a;
						return A3(err, $author$project$Plan$DayPlanning$reeditingPlan, error, model);
					}
					var error = msg.a.a.a;
					return A3(err, $author$project$Plan$DayPlanning$finalizingPlan, error, model);
				}
			}());
	});
var $author$project$Plan$NotFinalized$Failed = {$: 2};
var $author$project$Plan$NotFinalized$SearchFailed = {$: 2};
var $author$project$Plan$NotFinalized$Searching = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Plan$NotFinalized$SystemGotNotFinalizedPlans = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Plan$NotFinalized$Found = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$NotFinalized$ensureSearchComplete = function (search) {
	if (!search.$) {
		var length = search.a;
		var found = search.b;
		return _Utils_eq(
			length,
			$elm$core$List$length(found)) ? $author$project$Plan$NotFinalized$Found(
			$author$project$DistributionPoint$IdDict$fromList(
				$elm$core$List$concat(found))) : search;
	} else {
		return search;
	}
};
var $author$project$Plan$NotFinalized$addNonFinalizedPlans = F2(
	function (nonFinalizedPlan, search) {
		return $author$project$Plan$NotFinalized$ensureSearchComplete(
			function () {
				if (!search.$) {
					var length = search.a;
					var found = search.b;
					return A2(
						$author$project$Plan$NotFinalized$Searching,
						length,
						A2($elm$core$List$cons, nonFinalizedPlan, found));
				} else {
					return search;
				}
			}());
	});
var $author$project$Plan$Plan$notFinalizedPlanDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (tuples) {
		return $elm$json$Json$Decode$succeed(
			A2(
				$elm$core$List$filterMap,
				function (_v0) {
					var dpId = _v0.a;
					var dates = _v0.b;
					var _v1 = $author$project$DistributionPoint$DistributionPoint$idFromString(dpId);
					if (!_v1.$) {
						var id = _v1.a;
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(id, dates));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				tuples));
	},
	$elm$json$Json$Decode$keyValuePairs(
		$elm$json$Json$Decode$list($author$project$Date$DeliveryDate$decoder)));
var $author$project$Plan$Plan$findNotFinalizedCmd = F5(
	function (token, toMsg, start, end, dpIds) {
		var dpIdQueryParameters = A2(
			$elm$core$List$map,
			$elm$url$Url$Builder$string('dp_id'),
			A2($elm$core$List$map, $author$project$DistributionPoint$DistributionPoint$encodeIdForUrl, dpIds));
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['plans', 'status', 'not-finalized']),
			_Utils_ap(
				dpIdQueryParameters,
				_List_fromArray(
					[
						A2(
						$elm$url$Url$Builder$string,
						'start',
						$author$project$Date$DeliveryDate$encodeForUrl(start)),
						A2(
						$elm$url$Url$Builder$string,
						'end',
						$author$project$Date$DeliveryDate$encodeForUrl(end))
					])));
		return A4($author$project$Api$Request$get, token, toMsg, uri, $author$project$Plan$Plan$notFinalizedPlanDecoder);
	});
var $author$project$Plan$NotFinalized$loadingFinalizedPlans = F2(
	function (_v0, index) {
		return A2(
			$author$project$Plan$NotFinalized$singleAction,
			'loadingFinalizedPlans' + $elm$core$String$fromInt(index),
			0);
	});
var $author$project$Plan$NotFinalized$maximumNumberOfDPsPerRequest = 75;
var $author$project$Plan$NotFinalized$Search = F2(
	function (start, end) {
		return {gu: end, hq: start};
	});
var $author$project$Plan$NotFinalized$ValidRange = 2;
var $author$project$Plan$NotFinalized$EndRequired = 1;
var $author$project$Plan$NotFinalized$endDateDecoder = $arowM$elm_form_decoder$Form$Decoder$custom(
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Result$fromMaybe(
			_List_fromArray(
				[1])),
		$author$project$Date$DeliveryDate$fromString));
var $author$project$Plan$NotFinalized$invalidRange = function (err) {
	return $arowM$elm_form_decoder$Form$Decoder$custom(
		function (search) {
			return (_Utils_cmp(
				$author$project$Date$DeliveryDate$oldestFirst(search.hq),
				$author$project$Date$DeliveryDate$oldestFirst(search.gu)) < 1) ? $elm$core$Result$Ok(0) : $elm$core$Result$Err(
				_List_fromArray(
					[err]));
		});
};
var $author$project$Plan$NotFinalized$StartRequired = 0;
var $author$project$Plan$NotFinalized$startDateDecoder = $arowM$elm_form_decoder$Form$Decoder$custom(
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Result$fromMaybe(
			_List_fromArray(
				[0])),
		$author$project$Date$DeliveryDate$fromString));
var $author$project$Plan$NotFinalized$searchFormDecoder = A2(
	$arowM$elm_form_decoder$Form$Decoder$assert,
	$author$project$Plan$NotFinalized$invalidRange(2),
	A2(
		$arowM$elm_form_decoder$Form$Decoder$field,
		A2(
			$arowM$elm_form_decoder$Form$Decoder$lift,
			function ($) {
				return $.gu;
			},
			$author$project$Plan$NotFinalized$endDateDecoder),
		A2(
			$arowM$elm_form_decoder$Form$Decoder$field,
			A2(
				$arowM$elm_form_decoder$Form$Decoder$lift,
				function ($) {
					return $.hq;
				},
				$author$project$Plan$NotFinalized$startDateDecoder),
			$arowM$elm_form_decoder$Form$Decoder$top($author$project$Plan$NotFinalized$Search))));
var $author$project$Plan$NotFinalized$withSearchFormInput = F3(
	function (field, value, search) {
		if (!field) {
			return _Utils_update(
				search,
				{hq: value});
		} else {
			return _Utils_update(
				search,
				{gu: value});
		}
	});
var $author$project$Plan$NotFinalized$withValidationErrors = F2(
	function (errors, model) {
		var searchForm = model.aj;
		return _Utils_update(
			model,
			{
				aj: _Utils_update(
					searchForm,
					{f_: errors})
			});
	});
var $author$project$Plan$NotFinalized$withoutValidationErrors = $author$project$Plan$NotFinalized$withValidationErrors(_List_Nil);
var $author$project$Plan$NotFinalized$update = F3(
	function (msg, share, model) {
		var withoutIndexedAction = F2(
			function (action, i) {
				return $author$project$Portal$Return$withoutAction(
					A2(action, 0, i));
			});
		var withoutAction = function (action) {
			return $author$project$Portal$Return$withoutAction(
				action(0));
		};
		var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		var modelChange = function (m) {
			return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
		};
		var err = F3(
			function (action, error, m) {
				return _Utils_Tuple3(
					A2(
						$author$project$Portal$Share$withHttpError,
						error,
						A2(
							$author$project$Portal$Share$withoutWaitingAction,
							action(0),
							share)),
					m,
					$elm$core$Platform$Cmd$none);
			});
		switch (msg.$) {
			case 2:
				if (!msg.a.$) {
					var distributionPoints = msg.a.a;
					return A2(
						withoutAction,
						$author$project$Plan$NotFinalized$loadingDPs,
						modelChange(
							_Utils_update(
								model,
								{
									A: $author$project$Plan$NotFinalized$Loaded(distributionPoints)
								})));
				} else {
					var error = msg.a.a;
					return A3(
						err,
						$author$project$Plan$NotFinalized$loadingDPs,
						error,
						_Utils_update(
							model,
							{A: $author$project$Plan$NotFinalized$Failed}));
				}
			case 3:
				if (!msg.b.$) {
					var index = msg.a;
					var nonFinalizedPlans = msg.b.a;
					return A3(
						withoutIndexedAction,
						$author$project$Plan$NotFinalized$loadingFinalizedPlans,
						index,
						modelChange(
							_Utils_update(
								model,
								{
									cs: A2($author$project$Plan$NotFinalized$addNonFinalizedPlans, nonFinalizedPlans, model.cs)
								})));
				} else {
					var index = msg.a;
					var error = msg.b.a;
					return A3(
						err,
						function (_v1) {
							return A2($author$project$Plan$NotFinalized$loadingFinalizedPlans, 0, index);
						},
						error,
						_Utils_update(
							model,
							{cs: $author$project$Plan$NotFinalized$SearchFailed}));
				}
			case 1:
				var _v2 = _Utils_Tuple2(
					model.A,
					A2($arowM$elm_form_decoder$Form$Decoder$run, $author$project$Plan$NotFinalized$searchFormDecoder, model.aj));
				if (!_v2.b.$) {
					if (_v2.a.$ === 1) {
						var distributionPoints = _v2.a.a;
						var search = _v2.b.a;
						var groupedRequests = A2(
							$elm_community$list_extra$List$Extra$greedyGroupsOf,
							$author$project$Plan$NotFinalized$maximumNumberOfDPsPerRequest,
							A2(
								$elm$core$List$map,
								function ($) {
									return $.eg;
								},
								distributionPoints));
						var loadCmds = A2(
							$elm$core$List$map,
							F2(
								function (dpIds, i) {
									return A5(
										$author$project$Plan$Plan$findNotFinalizedCmd,
										$author$project$Portal$Share$token(share),
										$author$project$Plan$NotFinalized$SystemGotNotFinalizedPlans(i),
										search.hq,
										search.gu,
										dpIds);
								}),
							groupedRequests);
						return A3(
							$author$project$Portal$Return$withCommands,
							$author$project$Plan$NotFinalized$loadingFinalizedPlans(0),
							loadCmds,
							modelChange(
								$author$project$Plan$NotFinalized$withoutValidationErrors(
									_Utils_update(
										model,
										{
											cs: A2(
												$author$project$Plan$NotFinalized$Searching,
												$elm$core$List$length(loadCmds),
												_List_Nil)
										}))));
					} else {
						return noChange;
					}
				} else {
					var errors = _v2.b.a;
					return _Utils_Tuple3(
						share,
						A2($author$project$Plan$NotFinalized$withValidationErrors, errors, model),
						$elm$core$Platform$Cmd$none);
				}
			default:
				var field = msg.a;
				var value = msg.b;
				return modelChange(
					_Utils_update(
						model,
						{
							aj: A3($author$project$Plan$NotFinalized$withSearchFormInput, field, value, model.aj)
						}));
		}
	});
var $author$project$Portal$Page$Failed = {$: 2};
var $author$project$Portal$Page$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Portal$Page$GotDistributionPointDropdownMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Portal$Page$UserSelectedDistributionPoint = function (a) {
	return {$: 3, a: a};
};
var $elm_community$maybe_extra$Maybe$Extra$orElse = F2(
	function (ma, mb) {
		if (mb.$ === 1) {
			return ma;
		} else {
			return mb;
		}
	});
var $author$project$DistributionPoint$IdDict$toList = $timo_weike$generic_collections$ManualDict$toList;
var $author$project$Portal$Page$sortedDistributionPointsFrom = function (_v0) {
	var distributionPoints = _v0.A;
	if (distributionPoints.$ === 1) {
		var dps = distributionPoints.a;
		return A2(
			$elm$core$List$sortBy,
			A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$String$toLower),
			$author$project$DistributionPoint$IdDict$toList(dps));
	} else {
		return _List_Nil;
	}
};
var $author$project$Portal$Page$selectedDistributionPoint = function (_v0) {
	var share = _v0.a;
	var model = _v0.b;
	var _v1 = model.A;
	if (_v1.$ === 1) {
		var dps = _v1.a;
		return A2(
			$elm$core$Maybe$andThen,
			function (id) {
				return A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair(id),
					A2($author$project$DistributionPoint$IdDict$get, id, dps));
			},
			A2(
				$elm_community$maybe_extra$Maybe$Extra$orElse,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$first,
					$elm$core$List$head(
						$author$project$Portal$Page$sortedDistributionPointsFrom(model))),
				A2(
					$elm_community$maybe_extra$Maybe$Extra$orElse,
					model.fJ,
					A2(
						$elm_community$maybe_extra$Maybe$Extra$orElse,
						A2(
							$elm$core$Maybe$map,
							$elm$core$Tuple$first,
							$author$project$Portal$Route$context(
								$author$project$Portal$Share$currentRoute(share))),
						$author$project$Portal$Share$distributionPointIdOfHeader(share)))));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Portal$Page$distributionPointsConfig = function (w) {
	return A2(
		$PaackEng$elm_ui_dropdown$Dropdown$withSearchAttributes,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$htmlAttribute(
				$elm$html$Html$Attributes$autocomplete(false))
			]),
		A2(
			$author$project$UI$Dropdown$config,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$padding(8),
					$mdgriffith$elm_ui$Element$width(w),
					$mdgriffith$elm_ui$Element$Background$color(
					$author$project$UI$Element$colorFor($author$project$UI$Palette$base1))
				]),
			{
				mv: $author$project$Portal$Page$UserSelectedDistributionPoint,
				mz: $elm$core$Tuple$second,
				mA: A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $author$project$Portal$Page$sortedDistributionPointsFrom),
				nJ: $author$project$Portal$Page$selectedDistributionPoint,
				hz: $author$project$Portal$Page$GotDistributionPointDropdownMsg
			}));
};
var $author$project$Ports$rememberSelectedDP = _Platform_outgoingPort('rememberSelectedDP', $elm$json$Json$Encode$string);
var $author$project$Date$DeliveryDate$isBusinessDay = function (deliveryDate) {
	var _v0 = $justinmimbs$date$Date$weekday(
		$author$project$Date$DeliveryDate$toDate(deliveryDate));
	if (_v0 === 6) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Portal$Page$routeFor = F3(
	function (dpID, date, menuItemId) {
		var businessDay = $author$project$Date$DeliveryDate$isBusinessDay(date) ? date : $author$project$Date$DeliveryDate$previousBusinessDay(date);
		var _v0 = _Utils_Tuple2(menuItemId, dpID);
		switch (_v0.a) {
			case 0:
				var _v1 = _v0.a;
				return $elm$core$Maybe$Just($author$project$Portal$Route$Dashboard);
			case 1:
				var _v2 = _v0.a;
				return $elm$core$Maybe$Just(
					$author$project$Portal$Route$Publications(date));
			case 2:
				if (!_v0.b.$) {
					var _v3 = _v0.a;
					var id = _v0.b.a;
					return $elm$core$Maybe$Just(
						A2($author$project$Portal$Route$DayPlanning, id, businessDay));
				} else {
					var _v4 = _v0.a;
					var _v5 = _v0.b;
					return $elm$core$Maybe$Nothing;
				}
			case 3:
				if (!_v0.b.$) {
					var _v6 = _v0.a;
					var id = _v0.b.a;
					return $elm$core$Maybe$Just(
						A2($author$project$Portal$Route$Delay, id, businessDay));
				} else {
					var _v7 = _v0.a;
					var _v8 = _v0.b;
					return $elm$core$Maybe$Nothing;
				}
			case 4:
				if (!_v0.b.$) {
					var _v9 = _v0.a;
					var id = _v0.b.a;
					return $elm$core$Maybe$Just(
						A2($author$project$Portal$Route$Count, id, businessDay));
				} else {
					var _v10 = _v0.a;
					var _v11 = _v0.b;
					return $elm$core$Maybe$Nothing;
				}
			case 5:
				var _v12 = _v0.a;
				return $elm$core$Maybe$Just($author$project$Portal$Route$Applicants);
			case 8:
				var _v13 = _v0.a;
				return $elm$core$Maybe$Just($author$project$Portal$Route$Documents);
			case 9:
				var _v14 = _v0.a;
				return $elm$core$Maybe$Just($author$project$Portal$Route$Accounts);
			case 6:
				var _v15 = _v0.a;
				return $elm$core$Maybe$Just($author$project$Portal$Route$Messages);
			case 7:
				var _v16 = _v0.a;
				return $elm$core$Maybe$Just($author$project$Portal$Route$PlansNotFinalized);
			case 10:
				var _v17 = _v0.a;
				return $elm$core$Maybe$Just(
					$author$project$Portal$Route$DelivererRouteDetail(businessDay));
			case 11:
				var _v18 = _v0.a;
				return $elm$core$Maybe$Just($author$project$Portal$Route$Compensations);
			case 12:
				var _v19 = _v0.a;
				return $elm$core$Maybe$Just($author$project$Portal$Route$ApproveCompensations);
			case 13:
				var _v20 = _v0.a;
				return $elm$core$Maybe$Just($author$project$Portal$Route$PaymentsSummaryOverview);
			case 14:
				if (!_v0.b.$) {
					var _v21 = _v0.a;
					var id = _v0.b.a;
					return $elm$core$Maybe$Just(
						$author$project$Portal$Route$PaymentsDistributionPointOverview(id));
				} else {
					var _v22 = _v0.a;
					var _v23 = _v0.b;
					return $elm$core$Maybe$Nothing;
				}
			case 15:
				var _v24 = _v0.a;
				return $elm$core$Maybe$Just($author$project$Portal$Route$PaymentsArchive);
			case 16:
				var _v25 = _v0.a;
				return $elm$core$Maybe$Nothing;
			case 17:
				var _v26 = _v0.a;
				return $elm$core$Maybe$Nothing;
			case 18:
				var _v27 = _v0.a;
				return $elm$core$Maybe$Nothing;
			case 19:
				var _v28 = _v0.a;
				return $elm$core$Maybe$Nothing;
			case 20:
				var _v29 = _v0.a;
				return $elm$core$Maybe$Just($author$project$Portal$Route$ComplaintHandle);
			case 21:
				var _v30 = _v0.a;
				return $elm$core$Maybe$Just(
					$author$project$Portal$Route$ComplaintFeedback(date));
			case 24:
				var _v31 = _v0.a;
				return $elm$core$Maybe$Just($author$project$Portal$Route$Report);
			case 22:
				var _v32 = _v0.a;
				return $elm$core$Maybe$Just($author$project$Portal$Route$ClosingCalendar);
			case 23:
				var _v33 = _v0.a;
				return $elm$core$Maybe$Just($author$project$Portal$Route$DistributorValidate);
			default:
				var _v34 = _v0.a;
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Portal$Page$toggleFolding = function (model) {
	var _v0 = model.ai;
	if (!_v0.$) {
		return _Utils_update(
			model,
			{
				ai: $author$project$Portal$Page$Folded(
					{bt: $elm$core$Maybe$Nothing})
			});
	} else {
		return _Utils_update(
			model,
			{ai: $author$project$Portal$Page$Unfolded});
	}
};
var $author$project$Portal$Route$withDistributionPoint = F2(
	function (dpId, route) {
		switch (route.$) {
			case 0:
				return $author$project$Portal$Route$Dashboard;
			case 1:
				var date = route.a;
				return $author$project$Portal$Route$Publications(date);
			case 2:
				return $author$project$Portal$Route$DayPlanningToday(dpId);
			case 3:
				var date = route.b;
				return A2($author$project$Portal$Route$CreatePlan, dpId, date);
			case 4:
				var date = route.b;
				return A2($author$project$Portal$Route$DayPlanning, dpId, date);
			case 5:
				return $author$project$Portal$Route$PlansNotFinalized;
			case 6:
				var date = route.b;
				return A2($author$project$Portal$Route$DistributionList, dpId, date);
			case 7:
				var date = route.b;
				return A2($author$project$Portal$Route$DistributionListB, dpId, date);
			case 8:
				var date = route.b;
				return A2($author$project$Portal$Route$PreSupplyList, dpId, date);
			case 9:
				var date = route.b;
				return A2($author$project$Portal$Route$HubPackList, dpId, date);
			case 10:
				var date = route.b;
				return A2($author$project$Portal$Route$ReceivedCheckList, dpId, date);
			case 11:
				var date = route.b;
				return A2($author$project$Portal$Route$RouteDetail, dpId, date);
			case 12:
				var date = route.b;
				var delivererId = route.c;
				var clusterNumber = route.d;
				return A4($author$project$Portal$Route$SequenceDetail, dpId, date, delivererId, clusterNumber);
			case 17:
				var date = route.a;
				return $author$project$Portal$Route$DelivererRouteDetail(date);
			case 18:
				var date = route.a;
				var cluster = route.b;
				var page = route.c;
				return A3($author$project$Portal$Route$DelivererRouteDetailPage, date, cluster, page);
			case 13:
				var date = route.b;
				return A2($author$project$Portal$Route$CreateDeliverer, dpId, date);
			case 14:
				var delivererId = route.a;
				return $author$project$Portal$Route$EditDeliverer(delivererId);
			case 15:
				var date = route.b;
				return A2($author$project$Portal$Route$Count, dpId, date);
			case 16:
				var date = route.b;
				return A2($author$project$Portal$Route$Delay, dpId, date);
			case 19:
				return $author$project$Portal$Route$Documents;
			case 20:
				return $author$project$Portal$Route$Accounts;
			case 22:
				return $author$project$Portal$Route$AccountAdd;
			case 21:
				var id = route.a;
				return $author$project$Portal$Route$AccountEdit(id);
			case 23:
				return $author$project$Portal$Route$Messages;
			case 24:
				return $author$project$Portal$Route$Compensations;
			case 25:
				var date = route.b;
				return A2($author$project$Portal$Route$CreateCompensation, dpId, date);
			case 26:
				var id = route.a;
				return $author$project$Portal$Route$EditCompensation(id);
			case 27:
				return $author$project$Portal$Route$ApproveCompensations;
			case 28:
				return $author$project$Portal$Route$PaymentsSummaryOverview;
			case 30:
				var year = route.a;
				var period = route.b;
				return A2($author$project$Portal$Route$PaymentsSummaryDetail, year, period);
			case 31:
				var year = route.a;
				return $author$project$Portal$Route$PaymentsSummaryAnnualDetail(year);
			case 29:
				return $author$project$Portal$Route$PaymentsDistributionPointOverview(dpId);
			case 32:
				return $author$project$Portal$Route$PaymentsArchive;
			case 33:
				return $author$project$Portal$Route$Applicants;
			case 34:
				return $author$project$Portal$Route$ComplaintHandle;
			case 35:
				var date = route.a;
				return $author$project$Portal$Route$ComplaintFeedback(date);
			case 38:
				return $author$project$Portal$Route$Report;
			case 36:
				return $author$project$Portal$Route$ClosingCalendar;
			case 37:
				return $author$project$Portal$Route$DistributorValidate;
			default:
				return $author$project$Portal$Route$NotFound;
		}
	});
var $author$project$Portal$Page$update = F3(
	function (msg, share, model) {
		var withoutAction = function (action) {
			return $author$project$Portal$Return$withoutAction(
				action(0));
		};
		var to = F2(
			function (route, m) {
				return _Utils_Tuple3(
					A2($author$project$Portal$Share$withNewRoute, route, share),
					m,
					$elm$core$Platform$Cmd$none);
			});
		var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		var modelChange = function (m) {
			return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
		};
		var err = F3(
			function (action, error, m) {
				return _Utils_Tuple3(
					A2(
						$author$project$Portal$Share$withHttpError,
						error,
						A2(
							$author$project$Portal$Share$withoutWaitingAction,
							action(0),
							share)),
					m,
					$elm$core$Platform$Cmd$none);
			});
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var dps = msg.a.a;
					return A2(
						withoutAction,
						$author$project$Portal$Page$loadingDPs,
						_Utils_Tuple3(
							A2($author$project$Portal$Share$withDistributionPoints, dps, share),
							_Utils_update(
								model,
								{
									A: $author$project$Portal$Page$Loaded(
										$author$project$DistributionPoint$IdDict$fromList(
											$author$project$DistributionPoint$DistributionPoint$toIdAndName(dps)))
								}),
							$elm$core$Platform$Cmd$none));
				} else {
					var error = msg.a.a;
					return A3(
						err,
						$author$project$Portal$Page$loadingDPs,
						error,
						_Utils_update(
							model,
							{A: $author$project$Portal$Page$Failed}));
				}
			case 1:
				return modelChange(
					$author$project$Portal$Page$toggleFolding(model));
			case 2:
				var menuItemId = msg.a;
				var dpId = A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$first,
					$author$project$Portal$Page$selectedDistributionPoint(
						_Utils_Tuple2(share, model)));
				var _v1 = A3($author$project$Portal$Page$routeFor, dpId, model.lx, menuItemId);
				if (!_v1.$) {
					var route = _v1.a;
					return A2(
						to,
						route,
						_Utils_update(
							model,
							{
								ai: $author$project$Portal$Page$Folded(
									{bt: $elm$core$Maybe$Nothing})
							}));
				} else {
					return noChange;
				}
			case 3:
				var selectedDPId = msg.a;
				if (!selectedDPId.$) {
					var _v3 = selectedDPId.a;
					var dpId = _v3.a;
					return function (_v4) {
						var s = _v4.a;
						var m = _v4.b;
						var c = _v4.c;
						return _Utils_Tuple3(
							A2($author$project$Portal$Share$withDistributionPointIdOfHeader, dpId, s),
							m,
							c);
					}(
						A2(
							$author$project$Portal$Return$withBackgroundCommand,
							$author$project$Ports$rememberSelectedDP(
								$author$project$DistributionPoint$DistributionPoint$encodeIdForUrl(dpId)),
							A2(
								to,
								A2(
									$author$project$Portal$Route$withDistributionPoint,
									dpId,
									$author$project$Portal$Share$currentRoute(share)),
								_Utils_update(
									model,
									{
										fJ: $elm$core$Maybe$Just(dpId)
									}))));
				} else {
					return noChange;
				}
			case 4:
				var dropdownMsg = msg.a;
				return function (_v5) {
					var state = _v5.a;
					var cmd = _v5.b;
					return _Utils_Tuple3(
						share,
						_Utils_update(
							model,
							{d2: state}),
						cmd);
				}(
					A4(
						$PaackEng$elm_ui_dropdown$Dropdown$update,
						$author$project$Portal$Page$distributionPointsConfig($mdgriffith$elm_ui$Element$fill),
						dropdownMsg,
						_Utils_Tuple2(share, model),
						model.d2));
			case 5:
				var menuItemId = msg.a;
				var _v6 = model.ai;
				if (!_v6.$) {
					return noChange;
				} else {
					return modelChange(
						_Utils_update(
							model,
							{
								ai: $author$project$Portal$Page$Folded(
									{
										bt: $elm$core$Maybe$Just(menuItemId)
									})
							}));
				}
			case 6:
				var _v7 = model.ai;
				if (!_v7.$) {
					return noChange;
				} else {
					return modelChange(
						_Utils_update(
							model,
							{
								ai: $author$project$Portal$Page$Folded(
									{bt: $elm$core$Maybe$Nothing})
							}));
				}
			default:
				return noChange;
		}
	});
var $author$project$Publications$ClosingCalendar$Adding = function (a) {
	return {$: 2, a: a};
};
var $author$project$Publications$ClosingCalendar$BackendRemovedException = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Publications$ClosingCalendar$BackendRespondedExceptions = function (a) {
	return {$: 0, a: a};
};
var $author$project$Publications$ClosingCalendar$BackendSavedException = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Publications$ClosingCalendar$Delivered = function (a) {
	return {$: 0, a: a};
};
var $author$project$Publications$ClosingCalendar$Editing = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Publications$ClosingCalendar$Edition = function (a) {
	return {$: 0, a: a};
};
var $author$project$Publications$ClosingCalendar$Removing = function (a) {
	return {$: 1, a: a};
};
var $author$project$Publications$ClosingCalendar$RunCustom = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Publications$ClosingCalendar$YearSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Publications$ClosingCalendar$Exception = F4(
	function (scope, day, delivery, remark) {
		return {a2: day, u: delivery, a9: remark, hj: scope};
	});
var $author$project$Publications$ClosingCalendar$DayRequired = 0;
var $author$project$Publications$ClosingCalendar$dayFormDecoder = $arowM$elm_form_decoder$Form$Decoder$custom(
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Result$fromMaybe(
			_List_fromArray(
				[0])),
		$author$project$Date$DeliveryDate$fromString));
var $author$project$Publications$ClosingCalendar$formDecoder = A2(
	$arowM$elm_form_decoder$Form$Decoder$field,
	A2(
		$arowM$elm_form_decoder$Form$Decoder$lift,
		function ($) {
			return $.a9;
		},
		$arowM$elm_form_decoder$Form$Decoder$identity),
	A2(
		$arowM$elm_form_decoder$Form$Decoder$field,
		A2(
			$arowM$elm_form_decoder$Form$Decoder$lift,
			function ($) {
				return $.u;
			},
			$arowM$elm_form_decoder$Form$Decoder$identity),
		A2(
			$arowM$elm_form_decoder$Form$Decoder$field,
			A2(
				$arowM$elm_form_decoder$Form$Decoder$lift,
				function ($) {
					return $.a2;
				},
				$author$project$Publications$ClosingCalendar$dayFormDecoder),
			A2(
				$arowM$elm_form_decoder$Form$Decoder$field,
				A2(
					$arowM$elm_form_decoder$Form$Decoder$lift,
					function ($) {
						return $.hj;
					},
					$arowM$elm_form_decoder$Form$Decoder$identity),
				$arowM$elm_form_decoder$Form$Decoder$top($author$project$Publications$ClosingCalendar$Exception)))));
var $author$project$Publications$ClosingCalendar$formOf = function (_v0) {
	var formState = _v0.P;
	switch (formState.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 2:
			var form = formState.a;
			return $elm$core$Maybe$Just(form);
		default:
			var form = formState.a;
			return $elm$core$Maybe$Just(form);
	}
};
var $author$project$Publications$ClosingCalendar$NotDelivered = {$: 1};
var $author$project$Publications$ClosingCalendar$Run1 = {$: 0};
var $author$project$Publications$ClosingCalendar$Run2 = {$: 1};
var $author$project$Publications$ClosingCalendar$Run3 = {$: 2};
var $author$project$Publications$ClosingCalendar$runDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'minutes',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'hours',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'run',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed(
				F3(
					function (r, h, m) {
						switch (r) {
							case 1:
								return $author$project$Publications$ClosingCalendar$Run1;
							case 2:
								return $author$project$Publications$ClosingCalendar$Run2;
							case 3:
								return $author$project$Publications$ClosingCalendar$Run3;
							default:
								return A2($author$project$Publications$ClosingCalendar$RunCustom, h, m);
						}
					})))));
var $author$project$Publications$ClosingCalendar$deliveredDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Publications$ClosingCalendar$runDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'daysBefore',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed(
			F2(
				function (d, r) {
					return $author$project$Publications$ClosingCalendar$Delivered(
						{aH: d, by: r});
				}))));
var $author$project$Publications$ClosingCalendar$BelgianTitles = {$: 2};
var $author$project$Publications$ClosingCalendar$DutchTitles = {$: 1};
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt = F4(
	function (path, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder, path, valDecoder, fallback),
			decoder);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$resolve = $elm$json$Json$Decode$andThen($elm$core$Basics$identity);
var $author$project$Publications$ClosingCalendar$scopeDecoder = $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$resolve(
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
		_List_fromArray(
			['edition', 'abbreviation']),
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'scope',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed(
				F2(
					function (s, e) {
						var _v0 = _Utils_Tuple2(s, e);
						_v0$3:
						while (true) {
							switch (_v0.a) {
								case 'nl-titles':
									return $elm$json$Json$Decode$succeed($author$project$Publications$ClosingCalendar$DutchTitles);
								case 'be-titles':
									return $elm$json$Json$Decode$succeed($author$project$Publications$ClosingCalendar$BelgianTitles);
								case 'edition':
									if (!_v0.b.$) {
										var edition = _v0.b.a;
										return $elm$json$Json$Decode$succeed(
											$author$project$Publications$ClosingCalendar$Edition(edition));
									} else {
										break _v0$3;
									}
								default:
									break _v0$3;
							}
						}
						return $elm$json$Json$Decode$fail('problem decoding scope');
					})))));
var $author$project$Publications$ClosingCalendar$decode = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'remark',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'updatesIn',
		$author$project$Publications$ClosingCalendar$deliveredDecoder,
		$author$project$Publications$ClosingCalendar$NotDelivered,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'day',
			$author$project$Date$DeliveryDate$decoder,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				$author$project$Publications$ClosingCalendar$scopeDecoder,
				$elm$json$Json$Decode$succeed($author$project$Publications$ClosingCalendar$Exception)))));
var $author$project$Publications$ClosingCalendar$loadCmd = F3(
	function (token, toMsg, year) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['closing-calendar', 'exception']),
			_List_fromArray(
				[
					A2(
					$elm$url$Url$Builder$string,
					'from',
					$elm$core$String$fromInt(year) + '-01-01'),
					A2(
					$elm$url$Url$Builder$string,
					'to',
					$elm$core$String$fromInt(year + 1) + '-01-01')
				]));
		return A4(
			$author$project$Api$Request$get,
			token,
			toMsg,
			uri,
			$elm$json$Json$Decode$list($author$project$Publications$ClosingCalendar$decode));
	});
var $author$project$Publications$ClosingCalendar$actionIdFor = function (id) {
	return A2($author$project$Portal$Waiting$Id, 'ClosingCalendar', id);
};
var $author$project$Publications$ClosingCalendar$singleAction = F2(
	function (id, _v0) {
		return $author$project$Portal$Waiting$singleAction(
			$author$project$Publications$ClosingCalendar$actionIdFor(id));
	});
var $author$project$Publications$ClosingCalendar$loading = $author$project$Publications$ClosingCalendar$singleAction('loadingExceptions');
var $author$project$Publications$ClosingCalendar$scopeToString = function (scope) {
	switch (scope.$) {
		case 0:
			return 'edition';
		case 1:
			return 'nl-titles';
		default:
			return 'be-titles';
	}
};
var $author$project$Publications$ClosingCalendar$removeCmd = F3(
	function (token, toMsg, exception) {
		var uri = function () {
			var _v0 = exception.hj;
			if (!_v0.$) {
				var edition = _v0.a;
				return A2(
					$author$project$Api$Uri$for,
					_List_fromArray(
						[
							'closing-calendar',
							'exception',
							$author$project$Publications$ClosingCalendar$scopeToString(exception.hj),
							$author$project$Date$DeliveryDate$encodeForUrl(exception.a2),
							edition
						]),
					_List_Nil);
			} else {
				return A2(
					$author$project$Api$Uri$for,
					_List_fromArray(
						[
							'closing-calendar',
							'exception',
							$author$project$Publications$ClosingCalendar$scopeToString(exception.hj),
							$author$project$Date$DeliveryDate$encodeForUrl(exception.a2)
						]),
					_List_Nil);
			}
		}();
		return A4($author$project$Api$Request$deleteWithoutResponse, token, toMsg, uri, $elm$http$Http$emptyBody);
	});
var $author$project$Publications$ClosingCalendar$removing = $author$project$Publications$ClosingCalendar$singleAction('removingException');
var $author$project$Publications$ClosingCalendar$runOf = function (delivery) {
	if (!delivery.$) {
		var run = delivery.a.by;
		return $elm$core$Maybe$Just(run);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Publications$ClosingCalendar$encode = function (exception) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					_Utils_Tuple2(
						'scope',
						$elm$json$Json$Encode$string(
							$author$project$Publications$ClosingCalendar$scopeToString(exception.hj)))),
					function () {
					var _v0 = exception.hj;
					if (!_v0.$) {
						var e = _v0.a;
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(
								'edition',
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'abbreviation',
											$elm$json$Json$Encode$string(e))
										]))));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}(),
					$elm$core$Maybe$Just(
					_Utils_Tuple2(
						'day',
						$author$project$Date$DeliveryDate$encode(exception.a2))),
					function () {
					var _v1 = exception.u;
					if (!_v1.$) {
						var updatesIn = _v1.a;
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(
								'updatesIn',
								$elm$json$Json$Encode$object(
									function () {
										var _v2 = updatesIn.by;
										switch (_v2.$) {
											case 3:
												var hours = _v2.a;
												var minutes = _v2.b;
												return _List_fromArray(
													[
														_Utils_Tuple2(
														'daysBefore',
														$elm$json$Json$Encode$int(updatesIn.aH)),
														_Utils_Tuple2(
														'run',
														$elm$json$Json$Encode$int(0)),
														_Utils_Tuple2(
														'hours',
														$elm$json$Json$Encode$int(hours)),
														_Utils_Tuple2(
														'minutes',
														$elm$json$Json$Encode$int(minutes))
													]);
											case 0:
												return _List_fromArray(
													[
														_Utils_Tuple2(
														'daysBefore',
														$elm$json$Json$Encode$int(updatesIn.aH)),
														_Utils_Tuple2(
														'run',
														$elm$json$Json$Encode$int(1)),
														_Utils_Tuple2(
														'hours',
														$elm$json$Json$Encode$int(0)),
														_Utils_Tuple2(
														'minutes',
														$elm$json$Json$Encode$int(0))
													]);
											case 1:
												return _List_fromArray(
													[
														_Utils_Tuple2(
														'daysBefore',
														$elm$json$Json$Encode$int(updatesIn.aH)),
														_Utils_Tuple2(
														'run',
														$elm$json$Json$Encode$int(2)),
														_Utils_Tuple2(
														'hours',
														$elm$json$Json$Encode$int(0)),
														_Utils_Tuple2(
														'minutes',
														$elm$json$Json$Encode$int(0))
													]);
											default:
												return _List_fromArray(
													[
														_Utils_Tuple2(
														'daysBefore',
														$elm$json$Json$Encode$int(updatesIn.aH)),
														_Utils_Tuple2(
														'run',
														$elm$json$Json$Encode$int(3)),
														_Utils_Tuple2(
														'hours',
														$elm$json$Json$Encode$int(0)),
														_Utils_Tuple2(
														'minutes',
														$elm$json$Json$Encode$int(0))
													]);
										}
									}())));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}(),
					$elm$core$Maybe$Just(
					_Utils_Tuple2(
						'remark',
						$elm$json$Json$Encode$string(exception.a9)))
				])));
};
var $author$project$Publications$ClosingCalendar$saveCmd = F3(
	function (token, toMsg, exception) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['closing-calendar', 'exception']),
			_List_Nil);
		var body = $elm$http$Http$jsonBody(
			$author$project$Publications$ClosingCalendar$encode(exception));
		return A4($author$project$Api$Request$patchWithoutResponse, token, toMsg, uri, body);
	});
var $author$project$Publications$ClosingCalendar$saving = $author$project$Publications$ClosingCalendar$singleAction('savingException');
var $author$project$Publications$ClosingCalendar$toComparable = function (exception) {
	return $author$project$Date$DeliveryDate$oldestFirst(exception.a2) + ('|' + function () {
		var _v0 = exception.hj;
		switch (_v0.$) {
			case 0:
				var e = _v0.a;
				return 'b|' + e;
			case 1:
				return 'a|nl';
			default:
				return 'a|be';
		}
	}());
};
var $author$project$Publications$ClosingCalendar$toForm = function (exception) {
	if (!exception.$) {
		var e = exception.a;
		return {
			a2: $author$project$Date$DeliveryDate$encodeForDateInput(e.a2),
			u: e.u,
			a9: e.a9,
			hj: e.hj,
			f_: _List_Nil
		};
	} else {
		return {a2: '', u: $author$project$Publications$ClosingCalendar$NotDelivered, a9: '', hj: $author$project$Publications$ClosingCalendar$DutchTitles, f_: _List_Nil};
	}
};
var $author$project$Publications$ClosingCalendar$whenWaiting = function (msg) {
	switch (msg.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 1;
		case 3:
			return 1;
		case 4:
			return 1;
		case 5:
			return 1;
		case 6:
			return 1;
		case 7:
			return 1;
		case 8:
			return 1;
		case 9:
			return 1;
		case 10:
			return 1;
		case 11:
			return 1;
		case 12:
			return 1;
		case 13:
			return 1;
		case 15:
			return 1;
		case 14:
			return 0;
		case 16:
			return 1;
		case 17:
			return 0;
		default:
			return 1;
	}
};
var $author$project$Publications$ClosingCalendar$withForm = F2(
	function (form, model) {
		var _v0 = model.P;
		switch (_v0.$) {
			case 0:
				return model;
			case 1:
				return model;
			case 2:
				return _Utils_update(
					model,
					{
						P: $author$project$Publications$ClosingCalendar$Adding(form)
					});
			default:
				var exception = _v0.b;
				return _Utils_update(
					model,
					{
						P: A2($author$project$Publications$ClosingCalendar$Editing, form, exception)
					});
		}
	});
var $author$project$Publications$ClosingCalendar$withRun = F2(
	function (run, delivery) {
		if (!delivery.$) {
			var daysBefore = delivery.a.aH;
			return $author$project$Publications$ClosingCalendar$Delivered(
				{aH: daysBefore, by: run});
		} else {
			return delivery;
		}
	});
var $author$project$Publications$ClosingCalendar$update = F3(
	function (msg, share, model) {
		var withoutAction = function (action) {
			return $author$project$Portal$Return$withoutAction(
				action(0));
		};
		var token = $author$project$Portal$Share$token(share);
		var notification = F3(
			function (action, message, m) {
				return _Utils_Tuple3(
					A2(
						$author$project$Portal$Share$withNotification,
						message,
						A2(
							$author$project$Portal$Share$withoutWaitingAction,
							action(0),
							share)),
					m,
					$elm$core$Platform$Cmd$none);
			});
		var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		var modelChange = function (m) {
			return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
		};
		if (A3($author$project$Portal$Share$allowed, $author$project$Publications$ClosingCalendar$whenWaiting, msg, share) === 1) {
			return noChange;
		} else {
			switch (msg.$) {
				case 0:
					if (!msg.a.$) {
						var exceptions = msg.a.a;
						return A2(
							withoutAction,
							$author$project$Publications$ClosingCalendar$loading,
							modelChange(
								_Utils_update(
									model,
									{bM: exceptions})));
					} else {
						var error = msg.a.a;
						return _Utils_Tuple3(
							A2(
								$author$project$Portal$Share$withHttpError,
								error,
								A2(
									$author$project$Portal$Share$withoutWaitingAction,
									$author$project$Publications$ClosingCalendar$loading(0),
									share)),
							model,
							$elm$core$Platform$Cmd$none);
					}
				case 1:
					var year = msg.a;
					return A3(
						$author$project$Portal$Return$withCommand,
						$author$project$Publications$ClosingCalendar$loading(0),
						A3($author$project$Publications$ClosingCalendar$loadCmd, token, $author$project$Publications$ClosingCalendar$BackendRespondedExceptions, year),
						modelChange(
							_Utils_update(
								model,
								{
									bM: _List_Nil,
									nI: $author$project$Publications$ClosingCalendar$YearSelected(year)
								})));
				case 2:
					return modelChange(
						_Utils_update(
							model,
							{
								P: $author$project$Publications$ClosingCalendar$Adding(
									$author$project$Publications$ClosingCalendar$toForm($elm$core$Maybe$Nothing))
							}));
				case 3:
					var exception = msg.a;
					return modelChange(
						_Utils_update(
							model,
							{
								P: A2(
									$author$project$Publications$ClosingCalendar$Editing,
									$author$project$Publications$ClosingCalendar$toForm(
										$elm$core$Maybe$Just(exception)),
									exception)
							}));
				case 4:
					var value = msg.a;
					var _v1 = $author$project$Publications$ClosingCalendar$formOf(model);
					if (!_v1.$) {
						var exceptionForm = _v1.a;
						return modelChange(
							A2(
								$author$project$Publications$ClosingCalendar$withForm,
								_Utils_update(
									exceptionForm,
									{a2: value}),
								model));
					} else {
						return noChange;
					}
				case 6:
					var value = msg.a;
					var _v2 = $author$project$Publications$ClosingCalendar$formOf(model);
					if (!_v2.$) {
						var exceptionForm = _v2.a;
						var _v3 = _Utils_Tuple2(
							exceptionForm.u,
							$elm$core$String$toInt(value));
						if ((!_v3.a.$) && (!_v3.b.$)) {
							var run = _v3.a.a.by;
							var daysBefore = _v3.b.a;
							return modelChange(
								A2(
									$author$project$Publications$ClosingCalendar$withForm,
									_Utils_update(
										exceptionForm,
										{
											u: $author$project$Publications$ClosingCalendar$Delivered(
												{aH: daysBefore, by: run})
										}),
									model));
						} else {
							return noChange;
						}
					} else {
						return noChange;
					}
				case 5:
					var value = msg.a;
					var _v4 = $author$project$Publications$ClosingCalendar$formOf(model);
					if (!_v4.$) {
						var exceptionForm = _v4.a;
						return modelChange(
							A2(
								$author$project$Publications$ClosingCalendar$withForm,
								_Utils_update(
									exceptionForm,
									{u: value}),
								model));
					} else {
						return noChange;
					}
				case 7:
					var value = msg.a;
					var _v5 = $author$project$Publications$ClosingCalendar$formOf(model);
					if (!_v5.$) {
						var exceptionForm = _v5.a;
						return modelChange(
							A2(
								$author$project$Publications$ClosingCalendar$withForm,
								_Utils_update(
									exceptionForm,
									{hj: value}),
								model));
					} else {
						return noChange;
					}
				case 8:
					var value = msg.a;
					var _v6 = $author$project$Publications$ClosingCalendar$formOf(model);
					if (!_v6.$) {
						var exceptionForm = _v6.a;
						return modelChange(
							A2(
								$author$project$Publications$ClosingCalendar$withForm,
								_Utils_update(
									exceptionForm,
									{
										hj: $author$project$Publications$ClosingCalendar$Edition(value)
									}),
								model));
					} else {
						return noChange;
					}
				case 9:
					var value = msg.a;
					var _v7 = $author$project$Publications$ClosingCalendar$formOf(model);
					if (!_v7.$) {
						var exceptionForm = _v7.a;
						return modelChange(
							A2(
								$author$project$Publications$ClosingCalendar$withForm,
								_Utils_update(
									exceptionForm,
									{
										u: A2($author$project$Publications$ClosingCalendar$withRun, value, exceptionForm.u)
									}),
								model));
					} else {
						return noChange;
					}
				case 10:
					var value = msg.a;
					var toHoursMinutes = function () {
						var _v12 = A2($elm$core$String$split, ':', value);
						if ((_v12.b && _v12.b.b) && (!_v12.b.b.b)) {
							var hours = _v12.a;
							var _v13 = _v12.b;
							var minutes = _v13.a;
							var _v14 = _Utils_Tuple2(
								$elm$core$String$toInt(hours),
								$elm$core$String$toInt(minutes));
							if ((!_v14.a.$) && (!_v14.b.$)) {
								var h = _v14.a.a;
								var m = _v14.b.a;
								return $elm$core$Maybe$Just(
									_Utils_Tuple2(h, m));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}();
					var _v8 = $author$project$Publications$ClosingCalendar$formOf(model);
					if (!_v8.$) {
						var exceptionForm = _v8.a;
						var _v9 = _Utils_Tuple2(
							$author$project$Publications$ClosingCalendar$runOf(exceptionForm.u),
							toHoursMinutes);
						if (((!_v9.a.$) && (_v9.a.a.$ === 3)) && (!_v9.b.$)) {
							var _v10 = _v9.a.a;
							var _v11 = _v9.b.a;
							var hours = _v11.a;
							var minutes = _v11.b;
							return modelChange(
								A2(
									$author$project$Publications$ClosingCalendar$withForm,
									_Utils_update(
										exceptionForm,
										{
											u: A2(
												$author$project$Publications$ClosingCalendar$withRun,
												A2($author$project$Publications$ClosingCalendar$RunCustom, hours, minutes),
												exceptionForm.u)
										}),
									model));
						} else {
							return noChange;
						}
					} else {
						return noChange;
					}
				case 11:
					var value = msg.a;
					var _v15 = $author$project$Publications$ClosingCalendar$formOf(model);
					if (!_v15.$) {
						var exceptionForm = _v15.a;
						return modelChange(
							A2(
								$author$project$Publications$ClosingCalendar$withForm,
								_Utils_update(
									exceptionForm,
									{a9: value}),
								model));
					} else {
						return noChange;
					}
				case 12:
					return modelChange(
						_Utils_update(
							model,
							{P: $author$project$Publications$ClosingCalendar$NotEditing}));
				case 13:
					var _v16 = $author$project$Publications$ClosingCalendar$formOf(model);
					if (!_v16.$) {
						var exceptionForm = _v16.a;
						var _v17 = A2($arowM$elm_form_decoder$Form$Decoder$run, $author$project$Publications$ClosingCalendar$formDecoder, exceptionForm);
						if (!_v17.$) {
							var exception = _v17.a;
							return A3(
								$author$project$Portal$Return$withCommand,
								$author$project$Publications$ClosingCalendar$saving(0),
								A3(
									$author$project$Publications$ClosingCalendar$saveCmd,
									token,
									$author$project$Publications$ClosingCalendar$BackendSavedException(
										$justinmimbs$date$Date$year(
											$author$project$Date$DeliveryDate$toDate(exception.a2))),
									exception),
								noChange);
						} else {
							var errors = _v17.a;
							return modelChange(
								A2(
									$author$project$Publications$ClosingCalendar$withForm,
									_Utils_update(
										exceptionForm,
										{f_: errors}),
									model));
						}
					} else {
						return noChange;
					}
				case 14:
					if (!msg.b.$) {
						var year = msg.a;
						return A3(
							$author$project$Portal$Return$withCommand,
							$author$project$Publications$ClosingCalendar$loading(0),
							A3($author$project$Publications$ClosingCalendar$loadCmd, token, $author$project$Publications$ClosingCalendar$BackendRespondedExceptions, year),
							A2(
								withoutAction,
								$author$project$Publications$ClosingCalendar$saving,
								modelChange(
									_Utils_update(
										model,
										{
											bM: _List_Nil,
											P: $author$project$Publications$ClosingCalendar$NotEditing,
											nI: $author$project$Publications$ClosingCalendar$YearSelected(year)
										}))));
					} else {
						var error = msg.b.a;
						return _Utils_Tuple3(
							A2(
								$author$project$Portal$Share$withHttpError,
								error,
								A2(
									$author$project$Portal$Share$withoutWaitingAction,
									$author$project$Publications$ClosingCalendar$saving(0),
									share)),
							model,
							$elm$core$Platform$Cmd$none);
					}
				case 15:
					var exception = msg.a;
					return modelChange(
						_Utils_update(
							model,
							{
								P: $author$project$Publications$ClosingCalendar$Removing(exception)
							}));
				case 16:
					var exception = msg.a;
					return A3(
						$author$project$Portal$Return$withCommand,
						$author$project$Publications$ClosingCalendar$removing(0),
						A3(
							$author$project$Publications$ClosingCalendar$removeCmd,
							token,
							$author$project$Publications$ClosingCalendar$BackendRemovedException(exception),
							exception),
						noChange);
				case 17:
					if (!msg.b.$) {
						var exception = msg.a;
						return A2(
							withoutAction,
							$author$project$Publications$ClosingCalendar$removing,
							modelChange(
								_Utils_update(
									model,
									{
										bM: A2(
											$elm$core$List$filter,
											A2(
												$elm$core$Basics$composeR,
												$author$project$Publications$ClosingCalendar$toComparable,
												A2(
													$elm$core$Basics$composeR,
													$elm$core$Basics$eq(
														$author$project$Publications$ClosingCalendar$toComparable(exception)),
													$elm$core$Basics$not)),
											model.bM),
										P: $author$project$Publications$ClosingCalendar$NotEditing
									})));
					} else {
						if ((msg.b.a.$ === 3) && (msg.b.a.a === 400)) {
							return A3(
								notification,
								$author$project$Publications$ClosingCalendar$removing,
								A2(
									$author$project$Portal$Message$error,
									'Fout bij verwijderen',
									$elm$core$Maybe$Just('De aanvraag kon niet verwerkt worden, er missen gegevens in de aanvraag.')),
								model);
						} else {
							var error = msg.b.a;
							return _Utils_Tuple3(
								A2(
									$author$project$Portal$Share$withHttpError,
									error,
									A2(
										$author$project$Portal$Share$withoutWaitingAction,
										$author$project$Publications$ClosingCalendar$removing(0),
										share)),
								model,
								$elm$core$Platform$Cmd$none);
						}
					}
				default:
					return modelChange(
						_Utils_update(
							model,
							{P: $author$project$Publications$ClosingCalendar$NotEditing}));
			}
		}
	});
var $author$project$Publications$Publications$Failed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Publications$Publications$GotSubHeaderMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Publications$Publications$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Publications$Publications$NoneSelected = {$: 0};
var $author$project$Publications$Publications$PublicationSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Publications$Publications$SystemGotDownloadLink = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Publications$Publications$SystemGotDownloadTime = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Publications$Publications$deliveryDateOf = function (model) {
	switch (model.$) {
		case 1:
			var m = model.a;
			return m.t;
		case 0:
			var context = model.a;
			return context.t;
		default:
			var context = model.a;
			return context.t;
	}
};
var $author$project$Publications$Publications$fileTypeToString = function (fileType) {
	switch (fileType) {
		case 0:
			return 'H';
		case 1:
			return 'L';
		case 2:
			return 'AM';
		case 3:
			return 'PPP';
		case 4:
			return 'DI';
		case 5:
			return 'WA';
		case 6:
			return 'BD';
		default:
			return 'Oplage';
	}
};
var $elm$http$Http$expectString = function (toMsg) {
	return A2(
		$elm$http$Http$expectStringResponse,
		toMsg,
		$elm$http$Http$resolve($elm$core$Result$Ok));
};
var $author$project$Api$Request$getString = F4(
	function (token, toMsg, url, tracker) {
		return $elm$http$Http$request(
			{
				aA: $elm$http$Http$emptyBody,
				aJ: $elm$http$Http$expectString(toMsg),
				aK: $author$project$Api$Request$headers(token),
				aO: 'GET',
				aS: $elm$core$Maybe$Nothing,
				aU: $author$project$Api$Request$trackingFor(tracker),
				aW: url
			});
	});
var $author$project$Publications$Publications$downloadCmd = F5(
	function (token, toMsg, date, title, fileType) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'publication-info',
					$author$project$Date$DeliveryDate$encodeForUrl(date),
					$author$project$Publications$Publications$fileTypeToString(fileType),
					title
				]),
			_List_Nil);
		return A3($author$project$Api$Request$getString, token, toMsg, uri);
	});
var $author$project$Publications$Publications$loadingDownloadLink = $author$project$Publications$Publications$singleAction('loadingDownloadLink');
var $author$project$Publications$Publications$publicationsOf = function (model) {
	switch (model.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var l = model.a;
			return $elm$core$Maybe$Just(l.ds);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Publications$Publications$searchIn = function (model) {
	switch (model.$) {
		case 0:
			var search = model.a.aj;
			return search;
		case 1:
			var search = model.a.aj;
			return search;
		default:
			var search = model.a.aj;
			return search;
	}
};
var $author$project$Publications$Publications$selectedOf = function (model) {
	switch (model.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var l = model.a;
			return $elm$core$Maybe$Just(l.nI);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Publications$Publications$selectedPublication = function (selection) {
	if (!selection.$) {
		return $elm$core$Maybe$Nothing;
	} else {
		var publication = selection.a;
		return $elm$core$Maybe$Just(publication);
	}
};
var $author$project$Publications$Publications$toContext = function (model) {
	switch (model.$) {
		case 0:
			var context = model.a;
			return context;
		case 1:
			var currentDate = model.a.t;
			var calendarState = model.a.r;
			var search = model.a.aj;
			return {r: calendarState, t: currentDate, aj: search};
		default:
			var context = model.a;
			return context;
	}
};
var $author$project$Publications$Publications$whenWaiting = function (msg) {
	switch (msg.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 1;
		case 3:
			return 0;
		case 4:
			return 0;
		case 5:
			return 0;
		default:
			return 0;
	}
};
var $author$project$Publications$Publications$withCalendarState = F2(
	function (calendar, model) {
		switch (model.$) {
			case 0:
				var loading = model.a;
				return $author$project$Publications$Publications$Loading(
					_Utils_update(
						loading,
						{r: calendar}));
			case 1:
				var loaded = model.a;
				return $author$project$Publications$Publications$Loaded(
					_Utils_update(
						loaded,
						{r: calendar}));
			default:
				var failed = model.a;
				return $author$project$Publications$Publications$Failed(
					_Utils_update(
						failed,
						{r: calendar}));
		}
	});
var $author$project$Publications$Publications$withSearch = F2(
	function (search, model) {
		switch (model.$) {
			case 0:
				var l = model.a;
				return $author$project$Publications$Publications$Loading(
					_Utils_update(
						l,
						{aj: search}));
			case 1:
				var l = model.a;
				return $author$project$Publications$Publications$Loaded(
					_Utils_update(
						l,
						{aj: search}));
			default:
				var f = model.a;
				return $author$project$Publications$Publications$Failed(
					_Utils_update(
						f,
						{aj: search}));
		}
	});
var $author$project$Publications$Publications$update = F3(
	function (msg, share, model) {
		var token = $author$project$Portal$Share$token(share);
		var to = function (route) {
			return _Utils_Tuple3(
				A2($author$project$Portal$Share$withNewRoute, route, share),
				model,
				$elm$core$Platform$Cmd$none);
		};
		var search = $author$project$Publications$Publications$searchIn(model);
		var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		var modelChange = function (m) {
			return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
		};
		var context = $author$project$Publications$Publications$toContext(model);
		var withoutAction = function (toAction) {
			return $author$project$Portal$Return$withoutAction(
				toAction(context.t));
		};
		var actionKey = $author$project$Publications$Publications$deliveryDateOf(model);
		var withCommand = function (toAction) {
			return $author$project$Portal$Return$withCommand(
				toAction(actionKey));
		};
		if (A3($author$project$Portal$Share$allowed, $author$project$Publications$Publications$whenWaiting, msg, share) === 1) {
			return noChange;
		} else {
			switch (msg.$) {
				case 0:
					var subHeaderMsg = msg.a;
					var _v1 = A5($author$project$Portal$Subheader$update, subHeaderMsg, share, $elm$core$Maybe$Nothing, context.t, context.r);
					switch (_v1.a.$) {
						case 0:
							var _v2 = _v1.a;
							var _v3 = _v1.b;
							var s = _v3.a;
							var m = _v3.b;
							var cmd = _v3.c;
							return _Utils_Tuple3(
								s,
								A2($author$project$Publications$Publications$withCalendarState, m, model),
								A2($elm$core$Platform$Cmd$map, $author$project$Publications$Publications$GotSubHeaderMsg, cmd));
						case 1:
							var date = _v1.a.a;
							return to(
								$author$project$Portal$Route$Publications(date));
						case 2:
							var date = _v1.a.a;
							return to(
								$author$project$Portal$Route$Publications(date));
						default:
							return noChange;
					}
				case 2:
					var publication = msg.a;
					var file = msg.b;
					if (model.$ === 1) {
						var m = model.a;
						return A3(
							withCommand,
							$author$project$Publications$Publications$loadingDownloadLink,
							A5(
								$author$project$Publications$Publications$downloadCmd,
								token,
								$author$project$Publications$Publications$SystemGotDownloadLink(file),
								m.t,
								publication.oi.cU,
								file.c9),
							modelChange(
								$author$project$Publications$Publications$Loaded(
									_Utils_update(
										m,
										{
											nI: $author$project$Publications$Publications$PublicationSelected(publication)
										}))));
					} else {
						return noChange;
					}
				case 3:
					if (msg.b.$ === 1) {
						var error = msg.b.a;
						return A2(
							withoutAction,
							$author$project$Publications$Publications$loadingDownloadLink,
							_Utils_Tuple3(
								A2(
									$author$project$Portal$Share$withHttpError,
									error,
									A2(
										$author$project$Portal$Share$withoutWaitingAction,
										$author$project$Publications$Publications$loadingDownloadLink(context.t),
										share)),
								model,
								$elm$core$Platform$Cmd$none));
					} else {
						var file = msg.a;
						var link = msg.b.a;
						return A2(
							withoutAction,
							$author$project$Publications$Publications$loadingDownloadLink,
							A2(
								$author$project$Portal$Return$withBackgroundCommand,
								A2(
									$elm$core$Task$perform,
									$author$project$Publications$Publications$SystemGotDownloadTime(file),
									$elm$time$Time$now),
								A2(
									$author$project$Portal$Return$withBackgroundCommand,
									$elm$browser$Browser$Navigation$load(link),
									noChange)));
					}
				case 4:
					var file = msg.a;
					var time = msg.b;
					var _v5 = _Utils_Tuple3(
						model,
						A2(
							$elm$core$Maybe$andThen,
							$author$project$Publications$Publications$selectedPublication,
							$author$project$Publications$Publications$selectedOf(model)),
						$author$project$Publications$Publications$publicationsOf(model));
					if (((_v5.a.$ === 1) && (!_v5.b.$)) && (!_v5.c.$)) {
						var m = _v5.a.a;
						var sP = _v5.b.a;
						var publications = _v5.c.a;
						var titleEq = A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.oi;
							},
							$elm$core$Basics$eq(sP.oi));
						var newFile = _Utils_update(
							file,
							{
								gp: $author$project$Publications$Publications$Downloaded(time)
							});
						var fileEq = A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.c9;
							},
							$elm$core$Basics$eq(file.c9));
						var newPublication = _Utils_update(
							sP,
							{
								fa: A3($elm_community$list_extra$List$Extra$setIf, fileEq, newFile, sP.fa)
							});
						return modelChange(
							$author$project$Publications$Publications$Loaded(
								_Utils_update(
									m,
									{
										ds: A3($elm_community$list_extra$List$Extra$setIf, titleEq, newPublication, publications)
									})));
					} else {
						return noChange;
					}
				case 1:
					var publication = msg.a;
					if (model.$ === 1) {
						var m = model.a;
						return modelChange(
							$author$project$Publications$Publications$Loaded(
								_Utils_update(
									m,
									{
										nI: $author$project$Publications$Publications$PublicationSelected(publication)
									})));
					} else {
						return noChange;
					}
				case 5:
					if (!msg.a.$) {
						var publications = msg.a.a;
						return A2(
							withoutAction,
							$author$project$Publications$Publications$loadingPublications,
							modelChange(
								$author$project$Publications$Publications$Loaded(
									{r: context.r, t: context.t, ds: publications, aj: search, nI: $author$project$Publications$Publications$NoneSelected})));
					} else {
						var error = msg.a.a;
						return _Utils_Tuple3(
							A2(
								$author$project$Portal$Share$withHttpError,
								error,
								A2(
									$author$project$Portal$Share$withoutWaitingAction,
									$author$project$Publications$Publications$loadingPublications(context.t),
									share)),
							$author$project$Publications$Publications$Failed(
								{r: context.r, t: context.t, aj: search}),
							$elm$core$Platform$Cmd$none);
					}
				default:
					var value = msg.a;
					return modelChange(
						A2(
							$author$project$Publications$Publications$withSearch,
							_Utils_update(
								search,
								{dC: value}),
							model));
			}
		}
	});
var $author$project$Report$Report$Available = function (a) {
	return {$: 0, a: a};
};
var $author$project$Report$Report$SystemGotDownloadComplaintsReportLink = function (a) {
	return {$: 8, a: a};
};
var $author$project$Report$Report$SystemGotDownloadFeedbackReportLink = function (a) {
	return {$: 9, a: a};
};
var $author$project$Report$Report$SystemGotDownloadSubscriptionsReportLink = function (a) {
	return {$: 10, a: a};
};
var $author$project$Report$Report$actionIdFor = function (id) {
	return A2($author$project$Portal$Waiting$Id, 'reports', id);
};
var $author$project$Report$Report$singleAction = F2(
	function (id, _v0) {
		return $author$project$Portal$Waiting$singleAction(
			$author$project$Report$Report$actionIdFor(id));
	});
var $author$project$Report$Report$downloadComplaintReport = $author$project$Report$Report$singleAction('downloadComplaintReport');
var $author$project$Report$Report$downloadFeedbackReport = $author$project$Report$Report$singleAction('downloadFeedbackReport');
var $author$project$Report$Report$downloadSubscriptionReport = $author$project$Report$Report$singleAction('downloadSubscriptionReport');
var $author$project$Report$Report$FromInvalid = 1;
var $author$project$Report$Report$FromRequired = 0;
var $author$project$Report$Report$ToInvalid = 3;
var $author$project$Report$Report$ToRequired = 2;
var $author$project$Report$Report$dateDecoder = F2(
	function (require, invalid) {
		return A2(
			$arowM$elm_form_decoder$Form$Decoder$andThen,
			function (_v0) {
				return $author$project$Date$DeliveryDate$formDecoder(invalid);
			},
			A2(
				$arowM$elm_form_decoder$Form$Decoder$assert,
				A2($arowM$elm_form_decoder$Form$Decoder$minLength, require, 1),
				$arowM$elm_form_decoder$Form$Decoder$identity));
	});
var $author$project$Report$Report$formDecoder = A2(
	$arowM$elm_form_decoder$Form$Decoder$field,
	A2(
		$arowM$elm_form_decoder$Form$Decoder$lift,
		function ($) {
			return $.eF;
		},
		A2($author$project$Report$Report$dateDecoder, 2, 3)),
	A2(
		$arowM$elm_form_decoder$Form$Decoder$field,
		A2(
			$arowM$elm_form_decoder$Form$Decoder$lift,
			function ($) {
				return $.eE;
			},
			A2($author$project$Report$Report$dateDecoder, 0, 1)),
		$arowM$elm_form_decoder$Form$Decoder$top(
			F2(
				function (from, to) {
					return _Utils_Tuple2(from, to);
				}))));
var $author$project$Report$Report$getDownloadComplaintsReportLinkCmd = F4(
	function (token, toMsg, validFrom, validTo) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'reports',
					'complaints',
					$author$project$Date$DeliveryDate$encodeForUrl(validFrom),
					$author$project$Date$DeliveryDate$encodeForUrl(validTo),
					'BE'
				]),
			_List_Nil);
		return A3($author$project$Api$Request$getString, token, toMsg, uri);
	});
var $author$project$Report$Report$getDownloadFeedbackReportLinkCmd = F4(
	function (token, toMsg, validFrom, validTo) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'reports',
					'feedback',
					$author$project$Date$DeliveryDate$encodeForUrl(validFrom),
					$author$project$Date$DeliveryDate$encodeForUrl(validTo),
					'BE'
				]),
			_List_Nil);
		return A3($author$project$Api$Request$getString, token, toMsg, uri);
	});
var $author$project$Report$Report$getDownloadSubscriptionsReportLinkCmd = F4(
	function (token, toMsg, validFrom, validTo) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				[
					'reports',
					'subscriptions',
					$author$project$Date$DeliveryDate$encodeForUrl(validFrom),
					$author$project$Date$DeliveryDate$encodeForUrl(validTo),
					'BE'
				]),
			_List_Nil);
		return A3($author$project$Api$Request$getString, token, toMsg, uri);
	});
var $author$project$Report$Report$whenWaiting = function (msg) {
	switch (msg.$) {
		case 0:
			return 1;
		case 1:
			return 1;
		case 2:
			return 1;
		case 3:
			return 1;
		case 4:
			return 1;
		case 5:
			return 1;
		case 6:
			return 1;
		case 7:
			return 1;
		case 8:
			return 0;
		case 9:
			return 0;
		default:
			return 0;
	}
};
var $author$project$Report$Report$update = F3(
	function (msg, share, model) {
		var form = model.bO;
		var withoutAction = function (toAction) {
			return $author$project$Portal$Return$withoutAction(
				toAction(0));
		};
		var withCommand = function (toAction) {
			return $author$project$Portal$Return$withCommand(
				toAction(0));
		};
		var token = $author$project$Portal$Share$token(share);
		var modelChange = function (m) {
			return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
		};
		var formChange = function (f) {
			return modelChange(
				_Utils_update(
					model,
					{bO: f}));
		};
		if (A3($author$project$Portal$Share$allowed, $author$project$Report$Report$whenWaiting, msg, share) === 1) {
			return _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
		} else {
			switch (msg.$) {
				case 0:
					var validOn = msg.a;
					return formChange(
						_Utils_update(
							form,
							{eE: validOn}));
				case 1:
					var validOn = msg.a;
					return formChange(
						_Utils_update(
							form,
							{eF: validOn}));
				case 2:
					var f = msg.a;
					var _v1 = A2($arowM$elm_form_decoder$Form$Decoder$run, $author$project$Report$Report$formDecoder, f);
					if (!_v1.$) {
						var _v2 = _v1.a;
						var from = _v2.a;
						var to = _v2.b;
						return A3(
							withCommand,
							$author$project$Report$Report$downloadComplaintReport,
							A4($author$project$Report$Report$getDownloadComplaintsReportLinkCmd, token, $author$project$Report$Report$SystemGotDownloadComplaintsReportLink, from, to),
							modelChange(
								_Utils_update(
									model,
									{
										dY: $author$project$Report$Report$Unavailable,
										bO: _Utils_update(
											f,
											{f_: _List_Nil})
									})));
					} else {
						var errors = _v1.a;
						return modelChange(
							_Utils_update(
								model,
								{
									bO: _Utils_update(
										f,
										{f_: errors})
								}));
					}
				case 3:
					var f = msg.a;
					var _v3 = A2($arowM$elm_form_decoder$Form$Decoder$run, $author$project$Report$Report$formDecoder, f);
					if (!_v3.$) {
						var _v4 = _v3.a;
						var from = _v4.a;
						var to = _v4.b;
						return A3(
							withCommand,
							$author$project$Report$Report$downloadFeedbackReport,
							A4($author$project$Report$Report$getDownloadFeedbackReportLinkCmd, token, $author$project$Report$Report$SystemGotDownloadFeedbackReportLink, from, to),
							modelChange(
								_Utils_update(
									model,
									{
										ea: $author$project$Report$Report$Unavailable,
										bO: _Utils_update(
											f,
											{f_: _List_Nil})
									})));
					} else {
						var errors = _v3.a;
						return modelChange(
							_Utils_update(
								model,
								{
									bO: _Utils_update(
										f,
										{f_: errors})
								}));
					}
				case 4:
					var f = msg.a;
					var _v5 = A2($arowM$elm_form_decoder$Form$Decoder$run, $author$project$Report$Report$formDecoder, f);
					if (!_v5.$) {
						var _v6 = _v5.a;
						var from = _v6.a;
						var to = _v6.b;
						return A3(
							withCommand,
							$author$project$Report$Report$downloadSubscriptionReport,
							A4($author$project$Report$Report$getDownloadSubscriptionsReportLinkCmd, token, $author$project$Report$Report$SystemGotDownloadSubscriptionsReportLink, from, to),
							modelChange(
								_Utils_update(
									model,
									{
										bO: _Utils_update(
											f,
											{f_: _List_Nil}),
										ew: $author$project$Report$Report$Unavailable
									})));
					} else {
						var errors = _v5.a;
						return modelChange(
							_Utils_update(
								model,
								{
									bO: _Utils_update(
										f,
										{f_: errors})
								}));
					}
				case 5:
					var link = msg.a;
					return A2(
						withoutAction,
						$author$project$Report$Report$downloadComplaintReport,
						A2(
							$author$project$Portal$Return$withBackgroundCommand,
							$elm$browser$Browser$Navigation$load(link),
							_Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none)));
				case 6:
					var link = msg.a;
					return A2(
						withoutAction,
						$author$project$Report$Report$downloadFeedbackReport,
						A2(
							$author$project$Portal$Return$withBackgroundCommand,
							$elm$browser$Browser$Navigation$load(link),
							_Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none)));
				case 7:
					var link = msg.a;
					return A2(
						withoutAction,
						$author$project$Report$Report$downloadSubscriptionReport,
						A2(
							$author$project$Portal$Return$withBackgroundCommand,
							$elm$browser$Browser$Navigation$load(link),
							_Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none)));
				case 8:
					if (!msg.a.$) {
						var link = msg.a.a;
						return A2(
							withoutAction,
							$author$project$Report$Report$downloadComplaintReport,
							modelChange(
								_Utils_update(
									model,
									{
										dY: $author$project$Report$Report$Available(link)
									})));
					} else {
						var error = msg.a.a;
						return A2(
							withoutAction,
							$author$project$Report$Report$downloadComplaintReport,
							_Utils_Tuple3(
								A2($author$project$Portal$Share$withHttpError, error, share),
								model,
								$elm$core$Platform$Cmd$none));
					}
				case 9:
					if (!msg.a.$) {
						var link = msg.a.a;
						return A2(
							withoutAction,
							$author$project$Report$Report$downloadFeedbackReport,
							modelChange(
								_Utils_update(
									model,
									{
										ea: $author$project$Report$Report$Available(link)
									})));
					} else {
						var error = msg.a.a;
						return A2(
							withoutAction,
							$author$project$Report$Report$downloadFeedbackReport,
							_Utils_Tuple3(
								A2($author$project$Portal$Share$withHttpError, error, share),
								model,
								$elm$core$Platform$Cmd$none));
					}
				default:
					if (!msg.a.$) {
						var link = msg.a.a;
						return A2(
							withoutAction,
							$author$project$Report$Report$downloadSubscriptionReport,
							modelChange(
								_Utils_update(
									model,
									{
										ew: $author$project$Report$Report$Available(link)
									})));
					} else {
						var error = msg.a.a;
						return A2(
							withoutAction,
							$author$project$Report$Report$downloadSubscriptionReport,
							_Utils_Tuple3(
								A2($author$project$Portal$Share$withHttpError, error, share),
								model,
								$elm$core$Platform$Cmd$none));
					}
			}
		}
	});
var $author$project$Security$Security$Authenticated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Security$Security$Authenticating = function (a) {
	return {$: 1, a: a};
};
var $author$project$Security$Security$Authorized = function (a) {
	return {$: 4, a: a};
};
var $author$project$Security$Security$DecodeError = function (a) {
	return {$: 2, a: a};
};
var $author$project$Security$Security$HttpError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Security$Security$NoImpact = {$: 0};
var $author$project$Security$Security$SystemGotPermissions = function (a) {
	return {$: 2, a: a};
};
var $author$project$Security$Security$SystemRefreshedToken = function (a) {
	return {$: 3, a: a};
};
var $author$project$Security$Security$TokenRefreshTimeExpired = function (a) {
	return {$: 4, a: a};
};
var $author$project$Security$Security$defaultTokenExpiration = $jxxcarlson$elm_typed_time$TypedTime$hours(1);
var $author$project$Security$Security$FinalizePlan = {$: 1};
var $author$project$Security$Security$FindDeliverersIntentToStop = {$: 4};
var $author$project$Security$Security$FindDraftPlans = {$: 3};
var $author$project$Security$Security$ImportOrders = {$: 7};
var $author$project$Security$Security$ManageAccounts = {$: 11};
var $author$project$Security$Security$ManageAllComplaints = {$: 16};
var $author$project$Security$Security$ManageCompensations = {$: 13};
var $author$project$Security$Security$ManageDelay = {$: 5};
var $author$project$Security$Security$ManageMessages = {$: 12};
var $author$project$Security$Security$ManageOwnCompensations = {$: 18};
var $author$project$Security$Security$ManagePlan = {$: 0};
var $author$project$Security$Security$ManagePublications = {$: 22};
var $author$project$Security$Security$Reports = {$: 32};
var $author$project$Security$Security$UnknownPermission = function (a) {
	return {$: 33, a: a};
};
var $author$project$Security$Security$UseBrincr = {$: 31};
var $author$project$Security$Security$UseCount = {$: 6};
var $author$project$Security$Security$ViewAllPayments = {$: 23};
var $author$project$Security$Security$ViewApplicants = {$: 28};
var $author$project$Security$Security$ViewDelivererMessages = {$: 25};
var $author$project$Security$Security$ViewDelivererPaymentOverview = {$: 21};
var $author$project$Security$Security$ViewDelivererRouteDetail = {$: 17};
var $author$project$Security$Security$ViewDistributionPointPayments = {$: 24};
var $author$project$Security$Security$ViewEmbraceDashboard = {$: 30};
var $author$project$Security$Security$ViewRegionDistributorMessages = {$: 26};
var $author$project$Security$Security$ViewRegionManagerMessages = {$: 27};
var $author$project$Security$Security$ViewSequence = {$: 2};
var $author$project$Security$Security$permissionDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (permission) {
		return $elm$json$Json$Decode$succeed(
			function () {
				switch (permission) {
					case 'manage-plan':
						return $author$project$Security$Security$ManagePlan;
					case 'manage-all-plans':
						return $author$project$Security$Security$ManagePlan;
					case 'finalize-plan':
						return $author$project$Security$Security$FinalizePlan;
					case 'finalize-all-plans':
						return $author$project$Security$Security$FinalizePlan;
					case 'find-draft-plans':
						return $author$project$Security$Security$FindDraftPlans;
					case 'find-deliverers-stop':
						return $author$project$Security$Security$FindDeliverersIntentToStop;
					case 'view-sequence':
						return $author$project$Security$Security$ViewSequence;
					case 'manage-delay':
						return $author$project$Security$Security$ManageDelay;
					case 'use-count':
						return $author$project$Security$Security$UseCount;
					case 'import-orders':
						return $author$project$Security$Security$ImportOrders;
					case 'view-deliverer-documents':
						return $author$project$Security$Security$ViewDelivererDocuments;
					case 'view-region-distributor-documents':
						return $author$project$Security$Security$ViewRegionDistributorDocuments;
					case 'view-region-manager-documents':
						return $author$project$Security$Security$ViewRegionManagerDocuments;
					case 'manage-accounts':
						return $author$project$Security$Security$ManageAccounts;
					case 'manage-messages':
						return $author$project$Security$Security$ManageMessages;
					case 'manage-compensations':
						return $author$project$Security$Security$ManageCompensations;
					case 'view-deliverer-route-detail':
						return $author$project$Security$Security$ViewDelivererRouteDetail;
					case 'manage-own-compensations':
						return $author$project$Security$Security$ManageOwnCompensations;
					case 'validate-compensations':
						return $author$project$Security$Security$ValidateCompensations;
					case 'approve-compensations':
						return $author$project$Security$Security$ApproveCompensations;
					case 'view-deliverer-payment-overview':
						return $author$project$Security$Security$ViewDelivererPaymentOverview;
					case 'manage-publications':
						return $author$project$Security$Security$ManagePublications;
					case 'view-all-payments':
						return $author$project$Security$Security$ViewAllPayments;
					case 'view-dp-payments':
						return $author$project$Security$Security$ViewDistributionPointPayments;
					case 'view-deliverer-messages':
						return $author$project$Security$Security$ViewDelivererMessages;
					case 'view-region-distributor-messages':
						return $author$project$Security$Security$ViewRegionDistributorMessages;
					case 'view-region-manager-messages':
						return $author$project$Security$Security$ViewRegionManagerMessages;
					case 'view-applicants':
						return $author$project$Security$Security$ViewApplicants;
					case 'manage-contracts':
						return $author$project$Security$Security$ManageContracts;
					case 'view-embrace-dashboard':
						return $author$project$Security$Security$ViewEmbraceDashboard;
					case 'use-brincr':
						return $author$project$Security$Security$UseBrincr;
					case 'handle-distributor-complaints':
						return $author$project$Security$Security$HandleDistributorComplaints;
					case 'handle-relation-manager-complaints':
						return $author$project$Security$Security$HandleRelationManagerComplaints;
					case 'manage-all-complaints':
						return $author$project$Security$Security$ManageAllComplaints;
					case 'reports':
						return $author$project$Security$Security$Reports;
					default:
						return $author$project$Security$Security$UnknownPermission(permission);
				}
			}());
	},
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string));
var $author$project$Security$Security$getPermissionsCmd = F2(
	function (token, toMsg) {
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['accounts', 'permissions']),
			_List_Nil);
		return A4(
			$author$project$Api$Request$get,
			$elm$core$Maybe$Just(token),
			toMsg,
			uri,
			$elm$json$Json$Decode$list($author$project$Security$Security$permissionDecoder));
	});
var $author$project$Security$Security$resignIn = F2(
	function (state, model) {
		var returnFor = function (_v1) {
			var uris = _v1.Z;
			var clientId = _v1.lf;
			return _Utils_Tuple2(
				$author$project$Security$Security$Unauthenticated(
					{lf: clientId, b4: state, Z: uris}),
				$author$project$Security$Security$signInStep1);
		};
		switch (model.$) {
			case 0:
				var u = model.a;
				return returnFor(u);
			case 1:
				var a = model.a;
				return returnFor(a);
			case 2:
				var a = model.a;
				return returnFor(a);
			case 3:
				var a = model.a;
				return returnFor(a);
			case 4:
				var a = model.a;
				return returnFor(a);
			default:
				var message = model.a;
				return _Utils_Tuple2(
					$author$project$Security$Security$Failed(message),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Security$ApplicationState$avoidTrailingEqualSign = function (state) {
	var _v0 = A2(
		$elm$core$Basics$modBy,
		3,
		$elm$core$String$length(state));
	switch (_v0) {
		case 1:
			return state + '  ';
		case 2:
			return state + ' ';
		default:
			return state;
	}
};
var $author$project$Security$ApplicationState$encrypted = F2(
	function (_v0, _v1) {
		var statePrefix = _v0.kc;
		var state = _v1;
		return _Utils_ap(
			statePrefix,
			$chelovek0v$bbase64$Base64$Encode$encode(
				$chelovek0v$bbase64$Base64$Encode$string(
					$author$project$Security$ApplicationState$avoidTrailingEqualSign(state))));
	});
var $truqu$elm_oauth2$OAuth$Code = {$: 0};
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$codeChallengeToString = function (_v0) {
	var str = _v0;
	return $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$base64UrlEncode(str);
};
var $truqu$elm_oauth2$OAuth$responseTypeToString = function (r) {
	switch (r.$) {
		case 0:
			return 'code';
		case 1:
			return 'token';
		default:
			var str = r.a;
			return str;
	}
};
var $truqu$elm_oauth2$Internal$urlAddList = F3(
	function (param, xs, qs) {
		return _Utils_ap(
			qs,
			function () {
				if (!xs.b) {
					return _List_Nil;
				} else {
					return _List_fromArray(
						[
							A2(
							$elm$url$Url$Builder$string,
							param,
							A2($elm$core$String$join, ' ', xs))
						]);
				}
			}());
	});
var $truqu$elm_oauth2$Internal$urlAddMaybe = F3(
	function (param, ms, qs) {
		return _Utils_ap(
			qs,
			function () {
				if (ms.$ === 1) {
					return _List_Nil;
				} else {
					var s = ms.a;
					return _List_fromArray(
						[
							A2($elm$url$Url$Builder$string, param, s)
						]);
				}
			}());
	});
var $truqu$elm_oauth2$Internal$makeAuthorizationUrl = F3(
	function (responseType, extraFields, _v0) {
		var clientId = _v0.lf;
		var url = _v0.aW;
		var redirectUri = _v0.jM;
		var scope = _v0.hj;
		var state = _v0.b4;
		var query = A2(
			$elm$core$String$dropLeft,
			1,
			$elm$url$Url$Builder$toQuery(
				A2(
					$truqu$elm_oauth2$Internal$urlAddExtraFields,
					extraFields,
					A3(
						$truqu$elm_oauth2$Internal$urlAddMaybe,
						'state',
						state,
						A3(
							$truqu$elm_oauth2$Internal$urlAddList,
							'scope',
							scope,
							_List_fromArray(
								[
									A2($elm$url$Url$Builder$string, 'client_id', clientId),
									A2(
									$elm$url$Url$Builder$string,
									'redirect_uri',
									$truqu$elm_oauth2$Internal$makeRedirectUri(redirectUri)),
									A2(
									$elm$url$Url$Builder$string,
									'response_type',
									$truqu$elm_oauth2$OAuth$responseTypeToString(responseType))
								]))))));
		var _v1 = url.he;
		if (_v1.$ === 1) {
			return _Utils_update(
				url,
				{
					he: $elm$core$Maybe$Just(query)
				});
		} else {
			var baseQuery = _v1.a;
			return _Utils_update(
				url,
				{
					he: $elm$core$Maybe$Just(baseQuery + ('&' + query))
				});
		}
	});
var $truqu$elm_oauth2$OAuth$AuthorizationCode$makeAuthorizationUrlWith = F3(
	function (responseType, extraFields, _v0) {
		var clientId = _v0.lf;
		var url = _v0.aW;
		var redirectUri = _v0.jM;
		var scope = _v0.hj;
		var state = _v0.b4;
		return A3(
			$truqu$elm_oauth2$Internal$makeAuthorizationUrl,
			responseType,
			extraFields,
			{lf: clientId, jM: redirectUri, hj: scope, b4: state, aW: url});
	});
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$makeAuthorizationUrlWith = F3(
	function (responseType, extraFields, _v0) {
		var clientId = _v0.lf;
		var url = _v0.aW;
		var redirectUri = _v0.jM;
		var scope = _v0.hj;
		var state = _v0.b4;
		var codeChallenge = _v0.lm;
		var extraInternalFields = $elm$core$Dict$fromList(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'code_challenge',
					$truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$codeChallengeToString(codeChallenge)),
					_Utils_Tuple2('code_challenge_method', 'S256')
				]));
		return A3(
			$truqu$elm_oauth2$OAuth$AuthorizationCode$makeAuthorizationUrlWith,
			responseType,
			A2($elm$core$Dict$union, extraFields, extraInternalFields),
			{lf: clientId, jM: redirectUri, hj: scope, b4: state, aW: url});
	});
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$makeAuthorizationUrl = A2($truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$makeAuthorizationUrlWith, $truqu$elm_oauth2$OAuth$Code, $elm$core$Dict$empty);
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$CodeChallenge = $elm$core$Basics$identity;
var $folkertdev$elm_sha2$Internal$SHA256$Digest = $elm$core$Basics$identity;
var $folkertdev$elm_sha2$Internal$SHA256$Tuple8 = F8(
	function (a, b, c, d, e, f, g, h) {
		return {$: 0, a: a, b: b, c: c, d: d, e: e, f: f, g: g, h: h};
	});
var $folkertdev$elm_sha2$Internal$SHA256$loopHelp = F2(
	function (step, _v0) {
		var n = _v0.a;
		var state = _v0.b;
		return (n > 0) ? A2(
			$elm$bytes$Bytes$Decode$map,
			function (_new) {
				return $elm$bytes$Bytes$Decode$Loop(
					_Utils_Tuple2(n - 1, _new));
			},
			step(state)) : $elm$bytes$Bytes$Decode$succeed(
			$elm$bytes$Bytes$Decode$Done(state));
	});
var $folkertdev$elm_sha2$Internal$SHA256$iterate = F3(
	function (n, step, initial) {
		return A2(
			$elm$bytes$Bytes$Decode$loop,
			_Utils_Tuple2(n, initial),
			$folkertdev$elm_sha2$Internal$SHA256$loopHelp(step));
	});
var $elm$bytes$Bytes$Decode$map5 = F6(
	function (func, _v0, _v1, _v2, _v3, _v4) {
		var decodeA = _v0;
		var decodeB = _v1;
		var decodeC = _v2;
		var decodeD = _v3;
		var decodeE = _v4;
		return F2(
			function (bites, offset) {
				var _v5 = A2(decodeA, bites, offset);
				var aOffset = _v5.a;
				var a = _v5.b;
				var _v6 = A2(decodeB, bites, aOffset);
				var bOffset = _v6.a;
				var b = _v6.b;
				var _v7 = A2(decodeC, bites, bOffset);
				var cOffset = _v7.a;
				var c = _v7.b;
				var _v8 = A2(decodeD, bites, cOffset);
				var dOffset = _v8.a;
				var d = _v8.b;
				var _v9 = A2(decodeE, bites, dOffset);
				var eOffset = _v9.a;
				var e = _v9.b;
				return _Utils_Tuple2(
					eOffset,
					A5(func, a, b, c, d, e));
			});
	});
var $folkertdev$elm_sha2$Internal$SHA256$map16 = function (f) {
	return function (b1) {
		return function (b2) {
			return function (b3) {
				return function (b4) {
					return function (b5) {
						return function (b6) {
							return function (b7) {
								return function (b8) {
									return function (b9) {
										return function (b10) {
											return function (b11) {
												return function (b12) {
													return function (b13) {
														return function (b14) {
															return function (b15) {
																return function (b16) {
																	return A6(
																		$elm$bytes$Bytes$Decode$map5,
																		F5(
																			function (a, b, c, d, e) {
																				return A4(e, d, c, b, a);
																			}),
																		b16,
																		b15,
																		b14,
																		b13,
																		A6(
																			$elm$bytes$Bytes$Decode$map5,
																			F5(
																				function (a, b, c, d, e) {
																					return A4(e, d, c, b, a);
																				}),
																			b12,
																			b11,
																			b10,
																			b9,
																			A6(
																				$elm$bytes$Bytes$Decode$map5,
																				F5(
																					function (a, b, c, d, e) {
																						return A4(e, d, c, b, a);
																					}),
																				b8,
																				b7,
																				b6,
																				b5,
																				A6(
																					$elm$bytes$Bytes$Decode$map5,
																					F5(
																						function (a, b, c, d, e) {
																							return A4(e, d, c, b, a);
																						}),
																					b4,
																					b3,
																					b2,
																					b1,
																					$elm$bytes$Bytes$Decode$succeed(f)))));
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $folkertdev$elm_sha2$Internal$SHA256$DeltaState = $elm$core$Basics$identity;
var $folkertdev$elm_sha2$Internal$SHA256$State = $elm$core$Basics$identity;
var $elm$core$Bitwise$complement = _Bitwise_complement;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{L: nodeList, x: nodeListSize, F: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $folkertdev$elm_sha2$Internal$SHA256$ks = $elm$core$Array$fromList(
	_List_fromArray(
		[1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298]));
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas = F3(
	function (index, w, _v0) {
		var _v1 = _v0;
		var a = _v1.a;
		var b = _v1.b;
		var c = _v1.c;
		var d = _v1.d;
		var e = _v1.e;
		var f = _v1.f;
		var g = _v1.g;
		var h = _v1.h;
		var maj = (b & c) ^ (a & (b ^ c));
		var k = function () {
			var _v2 = A2($elm$core$Array$get, index, $folkertdev$elm_sha2$Internal$SHA256$ks);
			if (_v2.$ === 1) {
				return 0;
			} else {
				var v = _v2.a;
				return v;
			}
		}();
		var ch = (((~e) & g) ^ (e & f)) >>> 0;
		var bigSigma1 = ((e << (32 - 25)) | (e >>> 25)) ^ (((e << (32 - 11)) | (e >>> 11)) ^ ((e << (32 - 6)) | (e >>> 6)));
		var t1 = (((h + bigSigma1) + ch) + k) + w;
		var newE = (d + t1) >>> 0;
		var bigSigma0 = ((a << (32 - 22)) | (a >>> 22)) ^ (((a << (32 - 13)) | (a >>> 13)) ^ ((a << (32 - 2)) | (a >>> 2)));
		var t2 = bigSigma0 + maj;
		var newA = (t1 + t2) >>> 0;
		var result = A8($folkertdev$elm_sha2$Internal$SHA256$Tuple8, newA, a, b, c, newE, e, f, g);
		var alt = (e >>> 25) ^ ((e << (32 - 25)) ^ ((e >>> 11) ^ ((e << (32 - 11)) ^ ((e >>> 6) ^ (e << (32 - 6))))));
		return result;
	});
var $folkertdev$elm_sha2$Internal$SHA256$numberOfWords = 16;
var $folkertdev$elm_sha2$Internal$SHA256$reduceWordsHelp = function (i) {
	return function (deltaState) {
		return function (b16) {
			return function (b15) {
				return function (b14) {
					return function (b13) {
						return function (b12) {
							return function (b11) {
								return function (b10) {
									return function (b9) {
										return function (b8) {
											return function (b7) {
												return function (b6) {
													return function (b5) {
														return function (b4) {
															return function (b3) {
																return function (b2) {
																	return function (b1) {
																		reduceWordsHelp:
																		while (true) {
																			if (i < 48) {
																				var smallSigma1 = (b2 >>> 10) ^ (((b2 << (32 - 19)) | (b2 >>> 19)) ^ ((b2 << (32 - 17)) | (b2 >>> 17)));
																				var smallSigma0 = (b15 >>> 3) ^ (((b15 << (32 - 18)) | (b15 >>> 18)) ^ ((b15 << (32 - 7)) | (b15 >>> 7)));
																				var w = (((smallSigma1 + b7) + smallSigma0) + b16) >>> 0;
																				var $temp$i = i + 1,
																					$temp$deltaState = A3($folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas, i + $folkertdev$elm_sha2$Internal$SHA256$numberOfWords, w, deltaState),
																					$temp$b16 = b15,
																					$temp$b15 = b14,
																					$temp$b14 = b13,
																					$temp$b13 = b12,
																					$temp$b12 = b11,
																					$temp$b11 = b10,
																					$temp$b10 = b9,
																					$temp$b9 = b8,
																					$temp$b8 = b7,
																					$temp$b7 = b6,
																					$temp$b6 = b5,
																					$temp$b5 = b4,
																					$temp$b4 = b3,
																					$temp$b3 = b2,
																					$temp$b2 = b1,
																					$temp$b1 = w;
																				i = $temp$i;
																				deltaState = $temp$deltaState;
																				b16 = $temp$b16;
																				b15 = $temp$b15;
																				b14 = $temp$b14;
																				b13 = $temp$b13;
																				b12 = $temp$b12;
																				b11 = $temp$b11;
																				b10 = $temp$b10;
																				b9 = $temp$b9;
																				b8 = $temp$b8;
																				b7 = $temp$b7;
																				b6 = $temp$b6;
																				b5 = $temp$b5;
																				b4 = $temp$b4;
																				b3 = $temp$b3;
																				b2 = $temp$b2;
																				b1 = $temp$b1;
																				continue reduceWordsHelp;
																			} else {
																				return deltaState;
																			}
																		}
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $folkertdev$elm_sha2$Internal$SHA256$reduceMessage = function (_v0) {
	return function (b16) {
		return function (b15) {
			return function (b14) {
				return function (b13) {
					return function (b12) {
						return function (b11) {
							return function (b10) {
								return function (b9) {
									return function (b8) {
										return function (b7) {
											return function (b6) {
												return function (b5) {
													return function (b4) {
														return function (b3) {
															return function (b2) {
																return function (b1) {
																	var initial = _v0;
																	var h0 = initial.a;
																	var h1 = initial.b;
																	var h2 = initial.c;
																	var h3 = initial.d;
																	var h4 = initial.e;
																	var h5 = initial.f;
																	var h6 = initial.g;
																	var h7 = initial.h;
																	var initialDeltaState = A3(
																		$folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas,
																		15,
																		b16,
																		A3(
																			$folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas,
																			14,
																			b15,
																			A3(
																				$folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas,
																				13,
																				b14,
																				A3(
																					$folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas,
																					12,
																					b13,
																					A3(
																						$folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas,
																						11,
																						b12,
																						A3(
																							$folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas,
																							10,
																							b11,
																							A3(
																								$folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas,
																								9,
																								b10,
																								A3(
																									$folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas,
																									8,
																									b9,
																									A3(
																										$folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas,
																										7,
																										b8,
																										A3(
																											$folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas,
																											6,
																											b7,
																											A3(
																												$folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas,
																												5,
																												b6,
																												A3(
																													$folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas,
																													4,
																													b5,
																													A3(
																														$folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas,
																														3,
																														b4,
																														A3(
																															$folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas,
																															2,
																															b3,
																															A3(
																																$folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas,
																																1,
																																b2,
																																A3($folkertdev$elm_sha2$Internal$SHA256$calculateDigestDeltas, 0, b1, initial))))))))))))))));
																	var _v1 = $folkertdev$elm_sha2$Internal$SHA256$reduceWordsHelp(0)(initialDeltaState)(b1)(b2)(b3)(b4)(b5)(b6)(b7)(b8)(b9)(b10)(b11)(b12)(b13)(b14)(b15)(b16);
																	var _v2 = _v1;
																	var a = _v2.a;
																	var b = _v2.b;
																	var c = _v2.c;
																	var d = _v2.d;
																	var e = _v2.e;
																	var f = _v2.f;
																	var g = _v2.g;
																	var h = _v2.h;
																	return A8($folkertdev$elm_sha2$Internal$SHA256$Tuple8, h0 + a, h1 + b, h2 + c, h3 + d, h4 + e, h5 + f, h6 + g, h7 + h);
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$bytes$Bytes$BE = 1;
var $elm$bytes$Bytes$Decode$unsignedInt32 = function (endianness) {
	return _Bytes_read_u32(!endianness);
};
var $folkertdev$elm_sha2$Internal$SHA256$u32 = $elm$bytes$Bytes$Decode$unsignedInt32(1);
var $folkertdev$elm_sha2$Internal$SHA256$reduceBytesMessage = function (state) {
	return $folkertdev$elm_sha2$Internal$SHA256$map16(
		$folkertdev$elm_sha2$Internal$SHA256$reduceMessage(state))($folkertdev$elm_sha2$Internal$SHA256$u32)($folkertdev$elm_sha2$Internal$SHA256$u32)($folkertdev$elm_sha2$Internal$SHA256$u32)($folkertdev$elm_sha2$Internal$SHA256$u32)($folkertdev$elm_sha2$Internal$SHA256$u32)($folkertdev$elm_sha2$Internal$SHA256$u32)($folkertdev$elm_sha2$Internal$SHA256$u32)($folkertdev$elm_sha2$Internal$SHA256$u32)($folkertdev$elm_sha2$Internal$SHA256$u32)($folkertdev$elm_sha2$Internal$SHA256$u32)($folkertdev$elm_sha2$Internal$SHA256$u32)($folkertdev$elm_sha2$Internal$SHA256$u32)($folkertdev$elm_sha2$Internal$SHA256$u32)($folkertdev$elm_sha2$Internal$SHA256$u32)($folkertdev$elm_sha2$Internal$SHA256$u32)($folkertdev$elm_sha2$Internal$SHA256$u32);
};
var $folkertdev$elm_sha2$Internal$SHA256$hashChunks = F2(
	function (message, state) {
		var numberOfChunks = ($elm$bytes$Bytes$width(message) / 64) | 0;
		var hashState = A3($folkertdev$elm_sha2$Internal$SHA256$iterate, numberOfChunks, $folkertdev$elm_sha2$Internal$SHA256$reduceBytesMessage, state);
		var _v0 = A2($elm$bytes$Bytes$Decode$decode, hashState, message);
		if (!_v0.$) {
			var newState = _v0.a;
			return newState;
		} else {
			return state;
		}
	});
var $folkertdev$elm_sha2$Internal$SHA256$maxSize = 2048 * 64;
var $elm$bytes$Bytes$Encode$Bytes = function (a) {
	return {$: 10, a: a};
};
var $elm$bytes$Bytes$Encode$bytes = $elm$bytes$Bytes$Encode$Bytes;
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $elm$bytes$Bytes$Encode$U32 = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$unsignedInt32 = $elm$bytes$Bytes$Encode$U32;
var $folkertdev$elm_sha2$Internal$SHA256$padBuffer = F2(
	function (byteCount, bytes) {
		var finalBlockSize = byteCount & 63;
		var paddingSize = (finalBlockSize < 56) ? ((55 - finalBlockSize) + 4) : ((119 - finalBlockSize) + 4);
		var message = $elm$bytes$Bytes$Encode$encode(
			$elm$bytes$Bytes$Encode$sequence(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$bytes(bytes),
						$elm$bytes$Bytes$Encode$unsignedInt8(128),
						$elm$bytes$Bytes$Encode$sequence(
						A2(
							$elm$core$List$repeat,
							paddingSize,
							$elm$bytes$Bytes$Encode$unsignedInt8(0))),
						A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, byteCount << 3)
					])));
		return message;
	});
var $elm$bytes$Bytes$Decode$bytes = function (n) {
	return _Bytes_read_bytes(n);
};
var $elm$bytes$Bytes$Decode$map2 = F3(
	function (func, _v0, _v1) {
		var decodeA = _v0;
		var decodeB = _v1;
		return F2(
			function (bites, offset) {
				var _v2 = A2(decodeA, bites, offset);
				var aOffset = _v2.a;
				var a = _v2.b;
				var _v3 = A2(decodeB, bites, aOffset);
				var bOffset = _v3.a;
				var b = _v3.b;
				return _Utils_Tuple2(
					bOffset,
					A2(func, a, b));
			});
	});
var $folkertdev$elm_sha2$Internal$SHA256$splitBytes = F2(
	function (n, buffer) {
		var decoder = A3(
			$elm$bytes$Bytes$Decode$map2,
			$elm$core$Tuple$pair,
			$elm$bytes$Bytes$Decode$bytes(n),
			$elm$bytes$Bytes$Decode$bytes(
				$elm$bytes$Bytes$width(buffer) - n));
		var _v0 = A2($elm$bytes$Bytes$Decode$decode, decoder, buffer);
		if (!_v0.$) {
			var v = _v0.a;
			return v;
		} else {
			return _Utils_Tuple2(
				buffer,
				$elm$bytes$Bytes$Encode$encode(
					$elm$bytes$Bytes$Encode$sequence(_List_Nil)));
		}
	});
var $folkertdev$elm_sha2$Internal$SHA256$hashBytesHelp = F4(
	function (fullSize, isLast, bytes, state) {
		hashBytesHelp:
		while (true) {
			if (_Utils_cmp(
				$elm$bytes$Bytes$width(bytes),
				$folkertdev$elm_sha2$Internal$SHA256$maxSize) > 0) {
				var _v0 = A2($folkertdev$elm_sha2$Internal$SHA256$splitBytes, $folkertdev$elm_sha2$Internal$SHA256$maxSize, bytes);
				var first = _v0.a;
				var rest = _v0.b;
				var $temp$fullSize = fullSize,
					$temp$isLast = true,
					$temp$bytes = rest,
					$temp$state = A4($folkertdev$elm_sha2$Internal$SHA256$hashBytesHelp, fullSize, false, first, state);
				fullSize = $temp$fullSize;
				isLast = $temp$isLast;
				bytes = $temp$bytes;
				state = $temp$state;
				continue hashBytesHelp;
			} else {
				if (isLast) {
					return A2(
						$folkertdev$elm_sha2$Internal$SHA256$hashChunks,
						A2($folkertdev$elm_sha2$Internal$SHA256$padBuffer, fullSize, bytes),
						state);
				} else {
					return A2($folkertdev$elm_sha2$Internal$SHA256$hashChunks, bytes, state);
				}
			}
		}
	});
var $folkertdev$elm_sha2$Internal$SHA256$hashBytes = F2(
	function (state, bytes) {
		var _v0 = A4(
			$folkertdev$elm_sha2$Internal$SHA256$hashBytesHelp,
			$elm$bytes$Bytes$width(bytes),
			true,
			bytes,
			state);
		var _v1 = _v0;
		var a = _v1.a;
		var b = _v1.b;
		var c = _v1.c;
		var d = _v1.d;
		var e = _v1.e;
		var f = _v1.f;
		var g = _v1.g;
		var h = _v1.h;
		return A8($folkertdev$elm_sha2$Internal$SHA256$Tuple8, a >>> 0, b >>> 0, c >>> 0, d >>> 0, e >>> 0, f >>> 0, g >>> 0, h >>> 0);
	});
var $folkertdev$elm_sha2$Internal$SHA256$fromString = function (state) {
	return A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			$folkertdev$elm_sha2$Internal$SHA256$hashBytes(state),
			$elm$bytes$Bytes$Encode$encode),
		$elm$bytes$Bytes$Encode$string);
};
var $folkertdev$elm_sha2$SHA256$initialState = A8($folkertdev$elm_sha2$Internal$SHA256$Tuple8, 1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225);
var $folkertdev$elm_sha2$SHA256$fromString = $folkertdev$elm_sha2$Internal$SHA256$fromString($folkertdev$elm_sha2$SHA256$initialState);
var $folkertdev$elm_sha2$SHA256$toEncoder = function (_v0) {
	var _v1 = _v0;
	var a = _v1.a;
	var b = _v1.b;
	var c = _v1.c;
	var d = _v1.d;
	var e = _v1.e;
	var f = _v1.f;
	var g = _v1.g;
	var h = _v1.h;
	return $elm$bytes$Bytes$Encode$sequence(
		_List_fromArray(
			[
				A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, a),
				A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, b),
				A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, c),
				A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, d),
				A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, e),
				A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, f),
				A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, g),
				A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, h)
			]));
};
var $folkertdev$elm_sha2$SHA256$toBytes = A2($elm$core$Basics$composeL, $elm$bytes$Bytes$Encode$encode, $folkertdev$elm_sha2$SHA256$toEncoder);
var $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$mkCodeChallenge = A2(
	$elm$core$Basics$composeR,
	$truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$codeVerifierToString,
	A2(
		$elm$core$Basics$composeR,
		$folkertdev$elm_sha2$SHA256$fromString,
		A2(
			$elm$core$Basics$composeR,
			$folkertdev$elm_sha2$SHA256$toBytes,
			A2($elm$core$Basics$composeR, $chelovek0v$bbase64$Base64$Encode$bytes, $elm$core$Basics$identity))));
var $author$project$Security$Security$oauthScope = _List_fromArray(
	['profile', 'openid', 'aws.cognito.signin.user.admin', 'email']);
var $author$project$Security$Security$signInStep2 = F2(
	function (config, state) {
		var uris = config.Z;
		var clientId = config.lf;
		var codeVerifier = config.c0;
		var _v0 = clientId;
		var clId = _v0;
		return $elm$browser$Browser$Navigation$load(
			$elm$url$Url$toString(
				$truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$makeAuthorizationUrl(
					{
						lf: clId,
						lm: $truqu$elm_oauth2$OAuth$AuthorizationCode$PKCE$mkCodeChallenge(codeVerifier),
						jM: uris.fH,
						hj: $author$project$Security$Security$oauthScope,
						b4: $elm$core$Maybe$Just(
							A2($author$project$Security$ApplicationState$encrypted, config, state)),
						aW: uris.f6
					})));
	});
var $author$project$Security$Security$Tokens = F3(
	function (token, refreshToken, expiresIn) {
		return {gx: expiresIn, bv: refreshToken, aT: token};
	});
var $truqu$elm_oauth2$OAuth$tokenFromString = function (str) {
	var _v0 = _Utils_Tuple2(
		A2($elm$core$String$left, 6, str),
		A2($elm$core$String$dropLeft, 7, str));
	if (_v0.a === 'Bearer') {
		var t = _v0.b;
		return $elm$core$Maybe$Just(t);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Security$Security$tokenDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		var _v0 = $truqu$elm_oauth2$OAuth$tokenFromString(string);
		if (!_v0.$) {
			var token = _v0.a;
			return $elm$json$Json$Decode$succeed(token);
		} else {
			return $elm$json$Json$Decode$fail('Invalid Token');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Security$Security$tokensDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'expiresIn',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'refreshToken',
		$author$project$Security$Security$tokenDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'token',
			$author$project$Security$Security$tokenDecoder,
			$elm$json$Json$Decode$succeed($author$project$Security$Security$Tokens))));
var $author$project$Security$Security$tokenRefreshCmd = F2(
	function (_v0, toMsg) {
		var token = _v0.aT;
		var refreshToken = _v0.bv;
		var uri = A2(
			$author$project$Api$Uri$for,
			_List_fromArray(
				['token', 'refresh']),
			_List_Nil);
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'refreshToken',
						$elm$json$Json$Encode$string(
							$truqu$elm_oauth2$OAuth$tokenToString(refreshToken)))
					])));
		return A6(
			$author$project$Api$Request$post,
			$elm$core$Maybe$Just(token),
			toMsg,
			uri,
			body,
			$author$project$Security$Security$tokensDecoder,
			$author$project$Api$Request$Untracked);
	});
var $author$project$Security$Security$refreshTokenBuffer = $jxxcarlson$elm_typed_time$TypedTime$minutes(2);
var $elm$core$Process$sleep = _Process_sleep;
var $jxxcarlson$elm_typed_time$TypedTime$sub = F2(
	function (s, t) {
		return A3($jxxcarlson$elm_typed_time$TypedTime$map2, $elm$core$Basics$sub, s, t);
	});
var $jxxcarlson$elm_typed_time$TypedTime$toSeconds = function (_v0) {
	var t = _v0.b;
	return t / 1000.0;
};
var $author$project$Security$Security$tokenRefreshTimerCmd = F2(
	function (expiresIn, toMsg) {
		return A2(
			$elm$core$Task$perform,
			toMsg,
			$elm$core$Process$sleep(
				A3(
					$elm$core$Basics$composeR,
					$jxxcarlson$elm_typed_time$TypedTime$toSeconds,
					$elm$core$Basics$mul(1000),
					A2($jxxcarlson$elm_typed_time$TypedTime$sub, expiresIn, $author$project$Security$Security$refreshTokenBuffer))));
	});
var $author$project$Security$Security$update = F3(
	function (msg, applicationState, model) {
		var noImpact = function (_v4) {
			var m = _v4.a;
			var c = _v4.b;
			return _Utils_Tuple3($author$project$Security$Security$NoImpact, m, c);
		};
		var noChange = _Utils_Tuple3($author$project$Security$Security$NoImpact, model, $elm$core$Platform$Cmd$none);
		var modelChange = function (m) {
			return _Utils_Tuple3($author$project$Security$Security$NoImpact, m, $elm$core$Platform$Cmd$none);
		};
		var err = function (error) {
			return _Utils_Tuple3(
				$author$project$Security$Security$HttpError(error),
				model,
				$elm$core$Platform$Cmd$none);
		};
		var _do = function (c) {
			return _Utils_Tuple3($author$project$Security$Security$NoImpact, model, c);
		};
		var decodeErr = function (error) {
			return _Utils_Tuple3(
				$author$project$Security$Security$DecodeError(error),
				model,
				$elm$core$Platform$Cmd$none);
		};
		var andDo = F2(
			function (cmd, _v3) {
				var e = _v3.a;
				var m = _v3.b;
				var c = _v3.c;
				return _Utils_Tuple3(
					e,
					m,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[c, cmd])));
			});
		var _v0 = _Utils_Tuple2(msg, model);
		switch (_v0.a.$) {
			case 0:
				if (!_v0.b.$) {
					var value = _v0.a.a;
					var uris = _v0.b.a.Z;
					var clientId = _v0.b.a.lf;
					var state = _v0.b.a.b4;
					var _v1 = A2($elm$json$Json$Decode$decodeValue, $author$project$Security$Security$securityCodesDecoder, value);
					if (!_v1.$) {
						var statePrefix = _v1.a.kc;
						var codeVerifier = _v1.a.c0;
						var newModel = {lf: clientId, c0: codeVerifier, b4: state, kc: statePrefix, Z: uris};
						return A2(
							andDo,
							A2($author$project$Security$Security$signInStep2, newModel, state),
							modelChange(
								$author$project$Security$Security$Authenticating(newModel)));
					} else {
						var error = _v1.a;
						return decodeErr(error);
					}
				} else {
					return noChange;
				}
			case 1:
				if (_v0.a.a.$ === 1) {
					var error = _v0.a.a.a;
					return err(error);
				} else {
					if (_v0.b.$ === 2) {
						var token = _v0.a.a.a.aT;
						var refreshToken = _v0.a.a.a.bv;
						var expiresIn = _v0.a.a.a.gx;
						var m = _v0.b.a;
						if (!refreshToken.$) {
							var rToken = refreshToken.a;
							return A2(
								andDo,
								A2(
									$author$project$Security$Security$tokenRefreshTimerCmd,
									A3(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										$author$project$Security$Security$defaultTokenExpiration,
										A2($elm$core$Basics$composeR, $elm$core$Basics$toFloat, $jxxcarlson$elm_typed_time$TypedTime$seconds),
										expiresIn),
									$author$project$Security$Security$TokenRefreshTimeExpired),
								A2(
									andDo,
									A3($author$project$Security$Security$getPermissionsCmd, token, $author$project$Security$Security$SystemGotPermissions, $author$project$Api$Request$Untracked),
									modelChange(
										$author$project$Security$Security$Authenticated(
											{lf: m.lf, bv: rToken, aT: token, Z: m.Z}))));
						} else {
							return modelChange(
								$author$project$Security$Security$Failed(
									A2(
										$author$project$Portal$Message$error,
										'Er is een security probleem!',
										$elm$core$Maybe$Just('Geen refresh token beschikbaar.'))));
						}
					} else {
						return noChange;
					}
				}
			case 2:
				if (_v0.a.a.$ === 1) {
					var error = _v0.a.a.a;
					return err(error);
				} else {
					if (_v0.b.$ === 3) {
						var permissions = _v0.a.a.a;
						var m = _v0.b.a;
						return modelChange(
							$author$project$Security$Security$Authorized(
								{lf: m.lf, fz: permissions, bv: m.bv, aT: m.aT, Z: m.Z}));
					} else {
						return noChange;
					}
				}
			case 4:
				if (_v0.b.$ === 4) {
					var m = _v0.b.a;
					return _do(
						A2($author$project$Security$Security$tokenRefreshCmd, m, $author$project$Security$Security$SystemRefreshedToken));
				} else {
					return noChange;
				}
			default:
				if (_v0.a.a.$ === 1) {
					if ((_v0.a.a.a.$ === 3) && (_v0.a.a.a.a === 401)) {
						return noImpact(
							A2($author$project$Security$Security$resignIn, applicationState, model));
					} else {
						var error = _v0.a.a.a;
						return err(error);
					}
				} else {
					if (_v0.b.$ === 4) {
						var token = _v0.a.a.a.aT;
						var refreshToken = _v0.a.a.a.bv;
						var expiresIn = _v0.a.a.a.gx;
						var m = _v0.b.a;
						return A2(
							andDo,
							A2(
								$author$project$Security$Security$tokenRefreshTimerCmd,
								A2($elm$core$Basics$composeR, $elm$core$Basics$toFloat, $jxxcarlson$elm_typed_time$TypedTime$seconds)(expiresIn),
								$author$project$Security$Security$TokenRefreshTimeExpired),
							modelChange(
								$author$project$Security$Security$Authorized(
									_Utils_update(
										m,
										{bv: refreshToken, aT: token}))));
					} else {
						return noChange;
					}
				}
		}
	});
var $author$project$Sequence$Plan$Failed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Sequence$Plan$shareDataFromModel = function (model) {
	return function () {
		var _v2 = model.Y;
		if (_v2.$ === 1) {
			var orders = _v2.a;
			return $author$project$Portal$ShareData$withOrders(orders);
		} else {
			return $author$project$Portal$ShareData$noChange;
		}
	}()(
		function () {
			var _v1 = $author$project$Plan$PlanLoader$loadedOf(model.fB);
			if (!_v1.$) {
				var plan = _v1.a.fA;
				var deliverers = _v1.a.e4;
				return A2(
					$elm$core$Basics$composeR,
					$author$project$Portal$ShareData$withTypedDeliverers(deliverers),
					$author$project$Portal$ShareData$withPlan(plan));
			} else {
				return $author$project$Portal$ShareData$noChange;
			}
		}()(
			function () {
				var _v0 = model.bn;
				if (_v0.$ === 1) {
					var distributionPoint = _v0.a;
					return $author$project$Portal$ShareData$withDistributionPoint(distributionPoint);
				} else {
					return $author$project$Portal$ShareData$noChange;
				}
			}()(
				$author$project$Portal$ShareData$empty(model.lx))));
};
var $author$project$Sequence$Plan$toDistributionPointId = function (model) {
	var _v0 = model.bn;
	switch (_v0.$) {
		case 0:
			var distributionPointId = _v0.a;
			return distributionPointId;
		case 1:
			var distributionPoint = _v0.a;
			return distributionPoint.eg;
		default:
			var distributionPointId = _v0.a;
			return distributionPointId;
	}
};
var $author$project$Sequence$Plan$toUnique = function (model) {
	var delivererId = function () {
		var _v0 = model.lD;
		switch (_v0.$) {
			case 0:
				var delId = _v0.a;
				return delId;
			case 1:
				var edit = _v0.a;
				return edit.j0.lA;
			default:
				var delId = _v0.a;
				return delId;
		}
	}();
	return A4(
		$author$project$Sequence$Plan$Unique,
		$author$project$Sequence$Plan$toDistributionPointId(model),
		model.lx,
		delivererId,
		model.dU);
};
var $author$project$Sequence$Plan$update = F3(
	function (msg, share, model) {
		return A2(
			$author$project$Portal$Return$ensureDataShared,
			$author$project$Sequence$Plan$shareDataFromModel,
			function () {
				var withoutAction = function (action) {
					return $author$project$Portal$Return$withoutAction(
						action(
							$author$project$Sequence$Plan$toUnique(model)));
				};
				var withCommand = function (action) {
					return $author$project$Portal$Return$withCommand(
						action(
							$author$project$Sequence$Plan$toUnique(model)));
				};
				var token = $author$project$Portal$Share$token(share);
				var to = function (route) {
					return _Utils_Tuple3(
						A2($author$project$Portal$Share$withNewRoute, route, share),
						model,
						$elm$core$Platform$Cmd$none);
				};
				var noChange = _Utils_Tuple3(share, model, $elm$core$Platform$Cmd$none);
				var modelChange = function (m) {
					return _Utils_Tuple3(share, m, $elm$core$Platform$Cmd$none);
				};
				var err = F3(
					function (action, error, m) {
						return _Utils_Tuple3(
							A2(
								$author$project$Portal$Share$withHttpError,
								error,
								A2(
									$author$project$Portal$Share$withoutWaitingAction,
									action(
										$author$project$Sequence$Plan$toUnique(model)),
									share)),
							m,
							$elm$core$Platform$Cmd$none);
					});
				switch (msg.$) {
					case 5:
						return to(
							A2(
								$author$project$Portal$Route$DayPlanning,
								$author$project$Sequence$Plan$toDistributionPointId(model),
								model.lx));
					case 0:
						if (!msg.a.$) {
							var sequences = msg.a.a;
							return A2(
								withoutAction,
								$author$project$Sequence$Plan$loadingSequence,
								function () {
									if (sequences.b && (!sequences.b.b)) {
										var sequence = sequences.a;
										return modelChange(
											function (s) {
												return _Utils_update(
													model,
													{
														lD: $author$project$Sequence$Plan$Loaded(
															A2($author$project$Sequence$Edit$default, model.lx, s))
													});
											}(
												$author$project$Sequence$Sequence$prepareForEdit(sequence)));
									} else {
										return noChange;
									}
								}());
						} else {
							var error = msg.a.a;
							return A3(err, $author$project$Sequence$Plan$loadingSequence, error, model);
						}
					case 1:
						if (!msg.a.$) {
							var distributionPoint = msg.a.a;
							return A2(
								withoutAction,
								$author$project$Sequence$Plan$loadingDP,
								modelChange(
									_Utils_update(
										model,
										{
											bn: $author$project$Sequence$Plan$Loaded(distributionPoint)
										})));
						} else {
							var error = msg.a.a;
							return A3(err, $author$project$Sequence$Plan$loadingDP, error, model);
						}
					case 2:
						var planLoaderMsg = msg.a;
						return function (_v2) {
							var s = _v2.a;
							var m = _v2.b;
							var c = _v2.c;
							var _v3 = _Utils_Tuple2(m.fB, m.lD);
							if ((_v3.a.$ === 3) && (!_v3.b.$)) {
								var planAndDeliverers = _v3.a.a;
								var delivererId = _v3.b.a;
								return A3(
									withCommand,
									$author$project$Sequence$Plan$loadingSequence,
									A5($author$project$Sequence$Plan$loadSingleSequenceCmdMsg, token, m.lx, delivererId, m.dU, planAndDeliverers.fA.gL),
									_Utils_Tuple3(s, m, c));
							} else {
								return _Utils_Tuple3(s, m, c);
							}
						}(
							A2(
								$author$project$Plan$PlanLoader$mapModel,
								function (pAndD) {
									return _Utils_update(
										model,
										{fB: pAndD});
								},
								$author$project$Plan$PlanLoader$registerErrorOnFailed(
									A2(
										$author$project$Plan$PlanLoader$mapCommand,
										$elm$core$Platform$Cmd$map($author$project$Sequence$Plan$SystemGotLoaderMsg),
										A6(
											$author$project$Plan$PlanLoader$update,
											share,
											token,
											$author$project$Sequence$Plan$loadingPlan(
												$author$project$Sequence$Plan$toUnique(model)),
											$elm$core$Basics$identity,
											planLoaderMsg,
											model.fB)))));
					case 3:
						if (!msg.a.$) {
							var orders = msg.a.a;
							return modelChange(
								_Utils_update(
									model,
									{
										Y: $author$project$Sequence$Plan$Loaded(orders)
									}));
						} else {
							var error = msg.a.a;
							return _Utils_Tuple3(
								A2($author$project$Portal$Share$withHttpError, error, share),
								_Utils_update(
									model,
									{
										Y: $author$project$Sequence$Plan$Failed(
											_Utils_Tuple2(
												$author$project$Sequence$Plan$toDistributionPointId(model),
												model.lx))
									}),
								$elm$core$Platform$Cmd$none);
						}
					default:
						var editMsg = msg.a;
						var delivererId = function () {
							var _v8 = model.lD;
							switch (_v8.$) {
								case 1:
									var load = _v8.a;
									return load.j0.lA;
								case 0:
									var id = _v8.a;
									return id;
								default:
									var id = _v8.a;
									return id;
							}
						}();
						var _v4 = model.lD;
						if (_v4.$ === 1) {
							var edit = _v4.a;
							var _v5 = A3($author$project$Sequence$Edit$update, editMsg, share, edit);
							switch (_v5.$) {
								case 0:
									return noChange;
								case 1:
									var _v6 = $author$project$Plan$PlanLoader$loadedOf(model.fB);
									if (!_v6.$) {
										var p = _v6.a;
										return A3(
											withCommand,
											$author$project$Sequence$Plan$loadingSequence,
											A5($author$project$Sequence$Plan$loadSingleSequenceCmdMsg, token, model.lx, delivererId, model.dU, p.fA.gL),
											noChange);
									} else {
										return noChange;
									}
								default:
									var _v7 = _v5.a;
									var s = _v7.a;
									var e = _v7.b;
									var cmd = _v7.c;
									return _Utils_Tuple3(
										s,
										_Utils_update(
											model,
											{
												lD: $author$project$Sequence$Plan$Loaded(e)
											}),
										A2($elm$core$Platform$Cmd$map, $author$project$Sequence$Plan$SystemGotEditMsg, cmd));
							}
						} else {
							return noChange;
						}
				}
			}());
	});
var $author$project$Lists$RouteDetail$Deliverer$UserResizedWindow = {$: 4};
var $author$project$Lists$RouteDetail$Deliverer$userResizedWindow = $author$project$Lists$RouteDetail$Deliverer$UserResizedWindow;
var $author$project$Dashboard$News$uniqueness = function (_v0) {
	var from = _v0.l2;
	var title = _v0.oi;
	var text = _v0.n3;
	return _Utils_Tuple3(from, title, text);
};
var $author$project$Dashboard$News$unique = function (messages) {
	return A2($elm_community$list_extra$List$Extra$uniqueBy, $author$project$Dashboard$News$uniqueness, messages);
};
var $author$project$Portal$Share$withMessages = F3(
	function (notifications, news, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				fu: $author$project$Dashboard$News$unique(
					_Utils_ap(news, model.fu)),
				bW: $author$project$Portal$Message$unique(
					_Utils_ap(notifications, model.bW))
			});
	});
var $author$project$Portal$Share$routes = function (_v0) {
	var model = _v0;
	return model.fL;
};
var $author$project$Main$withStableRoute = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	var _v1 = $author$project$Portal$Share$routes(model.fQ);
	if (!_v1.$) {
		return _Utils_Tuple2(model, cmd);
	} else {
		var newRoute = _v1.a;
		var current = _v1.b.h9;
		return A2(
			$Fresheyeball$elm_return$Return$command,
			cmd,
			A2($author$project$Main$changeRouteTo, newRoute, model));
	}
};
var $author$project$Portal$Share$withWindow = F2(
	function (window, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				dI: $author$project$Portal$Share$uiForWindow(window)
			});
	});
var $author$project$Portal$Share$withoutNotification = F2(
	function (message, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				bW: A2(
					$elm$core$List$filter,
					$elm$core$Basics$neq(message),
					model.bW)
			});
	});
var $author$project$Main$resignIn = function (model) {
	var share = model.fQ;
	var state = $author$project$Main$stateFromRoute(
		$author$project$Portal$Share$currentRoute(share));
	return A3(
		$elm$core$Tuple$mapBoth,
		function (security) {
			return _Utils_update(
				model,
				{
					fQ: A2($author$project$Portal$Share$withSecurity, security, share)
				});
		},
		$elm$core$Platform$Cmd$map($author$project$Main$GotSecurityMsg),
		A2(
			$author$project$Security$Security$resignIn,
			state,
			$author$project$Portal$Share$security(share)));
};
var $author$project$Portal$Share$withoutUnhandled = function (_v0) {
	var model = _v0;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{eA: _List_Nil}),
		model.eA);
};
var $author$project$Main$withoutUnhandled = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	var _v1 = $author$project$Portal$Share$withoutUnhandled(model.fQ);
	if (!_v1.b.b) {
		return _Utils_Tuple2(model, cmd);
	} else {
		var cleanShare = _v1.a;
		var unhandled = _v1.b;
		return A2($elm$core$List$member, 0, unhandled) ? $author$project$Main$resignIn(
			_Utils_update(
				model,
				{fQ: cleanShare})) : _Utils_Tuple2(model, cmd);
	}
};
var $author$project$Main$initializedUpdate = F2(
	function (msg, model) {
		var noChange = _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		return $author$project$Main$withoutUnhandled(
			$author$project$Main$withStableRoute(
				function () {
					var _v0 = _Utils_Tuple2(msg, model.cv);
					_v0$47:
					while (true) {
						switch (_v0.a.$) {
							case 0:
								return noChange;
							case 1:
								if (_v0.b.$ === 15) {
									var _v1 = _v0.a;
									var width = _v1.a;
									var height = _v1.b;
									var pageModel = _v0.b.a;
									var resizedShare = A2(
										$author$project$Portal$Share$withWindow,
										{iK: height, oy: width},
										model.fQ);
									return A4(
										$author$project$Main$map,
										_Utils_update(
											model,
											{fQ: resizedShare}),
										$author$project$Main$GotDelivererRouteDetailMsg,
										$author$project$Portal$Pages$DelivererRouteDetail,
										A3($author$project$Lists$RouteDetail$Deliverer$update, $author$project$Lists$RouteDetail$Deliverer$userResizedWindow, resizedShare, pageModel));
								} else {
									var _v2 = _v0.a;
									var width = _v2.a;
									var height = _v2.b;
									return $Fresheyeball$elm_return$Return$singleton(
										_Utils_update(
											model,
											{
												fQ: A2(
													$author$project$Portal$Share$withWindow,
													{iK: height, oy: width},
													model.fQ)
											}));
								}
							case 2:
								if (_v0.a.a.$ === 7) {
									var _v3 = _v0.a.a;
									return $author$project$Main$signOut(model);
								} else {
									var pageMsg = _v0.a.a;
									return function (_v4) {
										var s = _v4.a;
										var m = _v4.b;
										var c = _v4.c;
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{eo: m, fQ: s}),
											A2($elm$core$Platform$Cmd$map, $author$project$Main$GotPageMsg, c));
									}(
										A3($author$project$Portal$Page$update, pageMsg, model.fQ, model.eo));
								}
							case 6:
								var securityMsg = _v0.a.a;
								return A3(
									$author$project$Main$mapSecurity,
									model,
									$author$project$Main$GotSecurityMsg,
									A3(
										$author$project$Security$Security$update,
										securityMsg,
										$author$project$Main$stateFromRoute(
											$author$project$Portal$Share$currentRoute(model.fQ)),
										$author$project$Portal$Share$security(model.fQ)));
							case 40:
								var url = _v0.a.a;
								return A2(
									$author$project$Main$changeRouteTo,
									A2(
										$elm$core$Maybe$withDefault,
										$author$project$Portal$Route$NotFound,
										$author$project$Portal$Route$fromUrl(url)),
									model);
							case 41:
								var message = _v0.a.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											fQ: A2($author$project$Portal$Share$withoutNotification, message, model.fQ)
										}),
									$elm$core$Platform$Cmd$none);
							case 42:
								if (!_v0.a.a.$) {
									var loaded = _v0.a.a.a;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												fQ: A3(
													$author$project$Portal$Share$withMessages,
													$author$project$Message$Message$notificationsOf(loaded),
													$author$project$Message$Message$newsOf(loaded),
													model.fQ)
											}),
										$elm$core$Platform$Cmd$none);
								} else {
									var error = _v0.a.a.a;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												fQ: A2($author$project$Portal$Share$withHttpError, error, model.fQ)
											}),
										$elm$core$Platform$Cmd$none);
								}
							case 3:
								if (_v0.b.$ === 11) {
									var dashboardMsg = _v0.a.a;
									var dashboardModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotDashboardMsg,
										$author$project$Portal$Pages$Dashboard,
										A3($author$project$Dashboard$Dashboard$update, dashboardMsg, model.fQ, dashboardModel));
								} else {
									break _v0$47;
								}
							case 4:
								if (_v0.b.$ === 12) {
									var publicationsMsg = _v0.a.a;
									var publicationsModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotPublicationsMsg,
										$author$project$Portal$Pages$Publications,
										A3($author$project$Publications$Publications$update, publicationsMsg, model.fQ, publicationsModel));
								} else {
									break _v0$47;
								}
							case 5:
								if (_v0.b.$ === 9) {
									var routeDetailMsg = _v0.a.a;
									var routeDetailModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotRouteDetailMsg,
										$author$project$Portal$Pages$RouteDetail,
										A3($author$project$Lists$RouteDetail$RouteDetail$update, routeDetailMsg, model.fQ, routeDetailModel));
								} else {
									break _v0$47;
								}
							case 8:
								if (_v0.b.$ === 10) {
									var sequenceMsg = _v0.a.a;
									var sequenceModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotSequenceMsg,
										$author$project$Portal$Pages$SequenceDetail,
										A3($author$project$Sequence$Plan$update, sequenceMsg, model.fQ, sequenceModel));
								} else {
									break _v0$47;
								}
							case 9:
								if (_v0.b.$ === 1) {
									var createPlanMsg = _v0.a.a;
									var createPlanModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotCreatePlanMsg,
										$author$project$Portal$Pages$CreatePlan,
										A3($author$project$Plan$CreatePlan$update, createPlanMsg, model.fQ, createPlanModel));
								} else {
									break _v0$47;
								}
							case 10:
								if (_v0.b.$ === 2) {
									var dayPlanningMsg = _v0.a.a;
									var dayPlanningModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotDayPlanningMsg,
										$author$project$Portal$Pages$DayPlanning,
										A3($author$project$Plan$DayPlanning$update, dayPlanningMsg, model.fQ, dayPlanningModel));
								} else {
									break _v0$47;
								}
							case 11:
								if (_v0.b.$ === 3) {
									var planNotFinalizedMsg = _v0.a.a;
									var planNotFinalizedModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotPlanNotFinalizedMsg,
										$author$project$Portal$Pages$PlansNotFinalized,
										A3($author$project$Plan$NotFinalized$update, planNotFinalizedMsg, model.fQ, planNotFinalizedModel));
								} else {
									break _v0$47;
								}
							case 12:
								switch (_v0.b.$) {
									case 4:
										var listMsg = _v0.a.a;
										var listModel = _v0.b.a;
										return A4(
											$author$project$Main$map,
											model,
											$author$project$Main$GotDistributionListMsg,
											$author$project$Portal$Pages$DistributionList,
											A3($author$project$Lists$Distribution$DistributionList$update, listMsg, model.fQ, listModel));
									case 5:
										var listMsg = _v0.a.a;
										var listModel = _v0.b.a;
										return A4(
											$author$project$Main$map,
											model,
											$author$project$Main$GotDistributionListMsg,
											$author$project$Portal$Pages$DistributionListB,
											A3($author$project$Lists$Distribution$DistributionList$update, listMsg, model.fQ, listModel));
									default:
										break _v0$47;
								}
							case 13:
								if (_v0.b.$ === 6) {
									var listMsg = _v0.a.a;
									var listModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotPreSupplyListMsg,
										$author$project$Portal$Pages$PreSupplyList,
										A3($author$project$Lists$Distribution$PreSupplyList$update, listMsg, model.fQ, listModel));
								} else {
									break _v0$47;
								}
							case 14:
								if (_v0.b.$ === 8) {
									var listMsg = _v0.a.a;
									var listModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotReceivedCheckListMsg,
										$author$project$Portal$Pages$ReceivedCheckList,
										A3($author$project$Lists$Received$CheckList$update, listMsg, model.fQ, listModel));
								} else {
									break _v0$47;
								}
							case 15:
								if (_v0.b.$ === 30) {
									var createDelivererMsg = _v0.a.a;
									var createModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotCreateDelivererMsg,
										$author$project$Portal$Pages$CreateDeliverer,
										A3($author$project$Deliverer$Create$update, createDelivererMsg, model.fQ, createModel));
								} else {
									break _v0$47;
								}
							case 16:
								if (_v0.b.$ === 31) {
									var editDelivererMsg = _v0.a.a;
									var editModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotEditDelivererMsg,
										$author$project$Portal$Pages$EditDeliverer,
										A3($author$project$Deliverer$Edit$update, editDelivererMsg, model.fQ, editModel));
								} else {
									break _v0$47;
								}
							case 17:
								switch (_v0.b.$) {
									case 13:
										var countMsg = _v0.a.a;
										var countModel = _v0.b.a;
										return A4(
											$author$project$Main$map,
											model,
											$author$project$Main$GotCountMsg,
											$author$project$Portal$Pages$Count,
											A3($author$project$Count$Count$update, countMsg, model.fQ, countModel));
									case 7:
										var countMsg = _v0.a.a;
										var countModel = _v0.b.a;
										return A4(
											$author$project$Main$map,
											model,
											$author$project$Main$GotCountMsg,
											$author$project$Portal$Pages$HubPackList,
											A3($author$project$Count$Count$update, countMsg, model.fQ, countModel));
									default:
										break _v0$47;
								}
							case 18:
								if (_v0.b.$ === 14) {
									var delayMsg = _v0.a.a;
									var delayModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotDelayMsg,
										$author$project$Portal$Pages$Delay,
										A3($author$project$Delay$Delay$update, delayMsg, model.fQ, delayModel));
								} else {
									break _v0$47;
								}
							case 19:
								if (_v0.b.$ === 26) {
									var documentsMsg = _v0.a.a;
									var documentsModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotDocumentsMsg,
										$author$project$Portal$Pages$Documents,
										A3($author$project$Documents$Documents$update, documentsMsg, model.fQ, documentsModel));
								} else {
									break _v0$47;
								}
							case 20:
								if (_v0.b.$ === 27) {
									var pageMsg = _v0.a.a;
									var pageModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotAccountsMsg,
										$author$project$Portal$Pages$Accounts,
										A3($author$project$Accounts$Overview$update, pageMsg, model.fQ, pageModel));
								} else {
									break _v0$47;
								}
							case 21:
								if (_v0.b.$ === 29) {
									var pageMsg = _v0.a.a;
									var pageModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotAccountAddMsg,
										$author$project$Portal$Pages$AccountAdd,
										A3($author$project$Accounts$Add$update, pageMsg, model.fQ, pageModel));
								} else {
									break _v0$47;
								}
							case 22:
								if (_v0.b.$ === 28) {
									var pageMsg = _v0.a.a;
									var pageModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotAccountEditMsg,
										$author$project$Portal$Pages$AccountEdit,
										A3($author$project$Accounts$Edit$update, pageMsg, model.fQ, pageModel));
								} else {
									break _v0$47;
								}
							case 23:
								if (_v0.b.$ === 16) {
									var messagesMsg = _v0.a.a;
									var messageModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotMessageMsg,
										$author$project$Portal$Pages$Messages,
										A3($author$project$Message$Message$update, messagesMsg, model.fQ, messageModel));
								} else {
									break _v0$47;
								}
							case 24:
								if (_v0.b.$ === 17) {
									var pageMsg = _v0.a.a;
									var pageModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotCompensationOverviewMsg,
										$author$project$Portal$Pages$Compensations,
										A3($author$project$Compensation$Overview$update, pageMsg, model.fQ, pageModel));
								} else {
									break _v0$47;
								}
							case 25:
								if (_v0.b.$ === 18) {
									var pageMsg = _v0.a.a;
									var pageModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotCreateCompensationMsg,
										$author$project$Portal$Pages$CreateCompensation,
										A3($author$project$Compensation$Add$update, pageMsg, model.fQ, pageModel));
								} else {
									break _v0$47;
								}
							case 26:
								if (_v0.b.$ === 19) {
									var pageMsg = _v0.a.a;
									var pageModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotEditCompensationMsg,
										$author$project$Portal$Pages$EditCompensation,
										A3($author$project$Compensation$Edit$update, pageMsg, model.fQ, pageModel));
								} else {
									break _v0$47;
								}
							case 27:
								if (_v0.b.$ === 20) {
									var pageMsg = _v0.a.a;
									var pageModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotApproveCompensationMsg,
										$author$project$Portal$Pages$ApproveCompensations,
										A3($author$project$Compensation$Approve$update, pageMsg, model.fQ, pageModel));
								} else {
									break _v0$47;
								}
							case 28:
								if (_v0.b.$ === 21) {
									var pageMsg = _v0.a.a;
									var pageModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotPaymentDelivererOverviewMsg,
										$author$project$Portal$Pages$PaymentDelivererOverview,
										A3($author$project$Payment$DelivererOverview$update, pageMsg, model.fQ, pageModel));
								} else {
									break _v0$47;
								}
							case 29:
								if (_v0.b.$ === 22) {
									var pageMsg = _v0.a.a;
									var pageModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotPaymentDistributionPointOverviewMsg,
										$author$project$Portal$Pages$PaymentDistributionPointOverview,
										A3($author$project$Payment$DistributionPointOverview$update, pageMsg, model.fQ, pageModel));
								} else {
									break _v0$47;
								}
							case 30:
								if (_v0.b.$ === 23) {
									var pageMsg = _v0.a.a;
									var pageModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotPaymentDetailMsg,
										$author$project$Portal$Pages$PaymentDetail,
										A3($author$project$Payment$Detail$update, pageMsg, model.fQ, pageModel));
								} else {
									break _v0$47;
								}
							case 31:
								if (_v0.b.$ === 24) {
									var pageMsg = _v0.a.a;
									var pageModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotAnnualPaymentDetailMsg,
										$author$project$Portal$Pages$AnnualPaymentDetail,
										A3($author$project$Payment$AnnualDetail$update, pageMsg, model.fQ, pageModel));
								} else {
									break _v0$47;
								}
							case 32:
								if (_v0.b.$ === 25) {
									var pageMsg = _v0.a.a;
									var pageModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotPaymentArchiveMsg,
										$author$project$Portal$Pages$PaymentArchive,
										A3($author$project$Payment$Archive$update, pageMsg, model.fQ, pageModel));
								} else {
									break _v0$47;
								}
							case 33:
								if (_v0.b.$ === 15) {
									var delivererRouteDetailMsg = _v0.a.a;
									var delivererRouteDetailModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotDelivererRouteDetailMsg,
										$author$project$Portal$Pages$DelivererRouteDetail,
										A3($author$project$Lists$RouteDetail$Deliverer$update, delivererRouteDetailMsg, model.fQ, delivererRouteDetailModel));
								} else {
									break _v0$47;
								}
							case 34:
								if (_v0.b.$ === 32) {
									var pageMsg = _v0.a.a;
									var pageModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotApplicantsMsg,
										$author$project$Portal$Pages$Applicants,
										A3($author$project$Applicant$Overview$update, pageMsg, model.fQ, pageModel));
								} else {
									break _v0$47;
								}
							case 36:
								if (_v0.b.$ === 34) {
									var pageMsg = _v0.a.a;
									var pageModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotComplaintFeedbackMsg,
										$author$project$Portal$Pages$ComplaintFeedback,
										A3($author$project$Complaint$Feedback$update, pageMsg, model.fQ, pageModel));
								} else {
									break _v0$47;
								}
							case 35:
								if (_v0.b.$ === 33) {
									var pageMsg = _v0.a.a;
									var pageModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotComplaintHandleMsg,
										$author$project$Portal$Pages$ComplaintHandle,
										A3($author$project$Complaint$Handle$update, pageMsg, model.fQ, pageModel));
								} else {
									break _v0$47;
								}
							case 37:
								if (_v0.b.$ === 35) {
									var pageMsg = _v0.a.a;
									var pageModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotReportMsg,
										$author$project$Portal$Pages$Report,
										A3($author$project$Report$Report$update, pageMsg, model.fQ, pageModel));
								} else {
									break _v0$47;
								}
							case 38:
								if (_v0.b.$ === 36) {
									var pageMsg = _v0.a.a;
									var pageModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotClosingCalendarMsg,
										$author$project$Portal$Pages$ClosingCalendar,
										A3($author$project$Publications$ClosingCalendar$update, pageMsg, model.fQ, pageModel));
								} else {
									break _v0$47;
								}
							case 39:
								if (_v0.b.$ === 37) {
									var pageMsg = _v0.a.a;
									var pageModel = _v0.b.a;
									return A4(
										$author$project$Main$map,
										model,
										$author$project$Main$GotDistributorValidateMsg,
										$author$project$Portal$Pages$DistributorValidate,
										A3($author$project$Distributor$Validate$update, pageMsg, model.fQ, pageModel));
								} else {
									break _v0$47;
								}
							default:
								break _v0$47;
						}
					}
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}()));
	});
var $author$project$Main$update = F2(
	function (msg, model) {
		var _v0 = _Utils_Tuple2(model, msg);
		if (!_v0.a.$) {
			if (_v0.b.$ === 6) {
				var initializingModel = _v0.a.a;
				var security = initializingModel.et;
				var flags = initializingModel.iC;
				var url = initializingModel.aW;
				var key = initializingModel.iY;
				var secMsg = _v0.b.a;
				return function (_v1) {
					var newSec = _v1.b;
					var securityCmd = _v1.c;
					return A2(
						$Fresheyeball$elm_return$Return$command,
						A2($elm$core$Platform$Cmd$map, $author$project$Main$GotSecurityMsg, securityCmd),
						function () {
							if (newSec.$ === 4) {
								var route = A2(
									$elm$core$Maybe$withDefault,
									$author$project$Portal$Route$NotFound,
									$author$project$Portal$Route$fromUrl(url));
								return A2(
									$elm$core$Tuple$mapFirst,
									$author$project$Main$Initialized,
									A4($author$project$Main$initializeFinished, flags, key, route, newSec));
							} else {
								return _Utils_Tuple2(
									$author$project$Main$Initializing(
										_Utils_update(
											initializingModel,
											{et: newSec})),
									$elm$core$Platform$Cmd$none);
							}
						}());
				}(
					A3(
						$author$project$Security$Security$update,
						secMsg,
						$author$project$Security$ApplicationState$fromUrl(url),
						security));
			} else {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		} else {
			var initializedModel = _v0.a.a;
			return A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Main$Initialized,
				A2($author$project$Main$initializedUpdate, msg, initializedModel));
		}
	});
var $author$project$Main$UserClosedMessage = function (a) {
	return {$: 41, a: a};
};
var $author$project$UI$Element$avoidPrintInterference = $mdgriffith$elm_ui$Element$htmlAttribute(
	$elm$html$Html$Attributes$class('part-of-frame'));
var $mdgriffith$elm_ui$Internal$Model$AsColumn = 1;
var $mdgriffith$elm_ui$Internal$Model$asColumn = 1;
var $mdgriffith$elm_ui$Internal$Model$htmlClass = function (cls) {
	return $mdgriffith$elm_ui$Internal$Model$Attr(
		$elm$html$Html$Attributes$class(cls));
};
var $mdgriffith$elm_ui$Element$column = F2(
	function (attrs, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asColumn,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.lp + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.dZ)),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
						attrs))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
	});
var $author$project$Lists$Distribution$DistributionList$clusterHeader = F5(
	function (distributionPoint, deliverer, parents, item, cluster) {
		var segmentNames = A2(
			$elm$core$String$join,
			', ',
			A2($author$project$DistributionPoint$DistributionPoint$sortedSegmentNames, distributionPoint, cluster.bb));
		var clusterIcon = function () {
			var _v0 = _Utils_Tuple2(parents, item);
			_v0$0:
			while (true) {
				if (_v0.a.b) {
					if (!_v0.b.$) {
						break _v0$0;
					} else {
						var _v1 = _v0.a;
						return $author$project$Print$Palette$iconFor(
							$icidasset$elm_material_icons$Material$Icons$location_on(18));
					}
				} else {
					switch (_v0.b.$) {
						case 0:
							break _v0$0;
						case 1:
							return $elm$html$Html$text('');
						default:
							return $elm$html$Html$text('');
					}
				}
			}
			return $author$project$Print$Palette$iconFor(
				$icidasset$elm_material_icons$Material$Icons$directions_car(18));
		}();
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$h1,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('')
					])),
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						clusterIcon,
						$elm$html$Html$text(
						$author$project$Deliverer$Deliverer$nameView(deliverer))
					])),
				A2(
				$elm$html$Html$h4,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(segmentNames)
					]))
			]);
	});
var $author$project$Demand$Demand$filterByProduct = F2(
	function (product, orders) {
		return A2(
			$elm$core$List$filter,
			function (o) {
				return _Utils_eq(o.av, product.eg);
			},
			orders);
	});
var $author$project$Demand$PackIcon$Small = 1;
var $author$project$Lists$Distribution$DistributionList$amountBox = F2(
	function (name, _v0) {
		var individual = _v0.a;
		var _v1 = _v0.b;
		var packs = _v1.a;
		var packSize = _v1.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lot-product')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('amount')
						]),
					function () {
						if (!packs) {
							return _List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(individual))
								]);
						} else {
							return _List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(packs)),
									A2($author$project$Demand$PackIcon$view, 1, packSize),
									$elm$html$Html$text('+'),
									$elm$html$Html$text(
									$elm$core$String$fromInt(individual))
								]);
						}
					}())
				]));
	});
var $author$project$Lists$Distribution$DistributionList$productView = F2(
	function (orders, product) {
		var totalFor = function (demandTypes) {
			return $elm$core$List$sum(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.aa;
					},
					A2(
						$elm$core$List$filter,
						function (o) {
							return A2($elm$core$List$member, o.lB, demandTypes);
						},
						orders)));
		};
		var total = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.aa;
				},
				orders));
		var insertBox = function (insert) {
			return A2(
				$author$project$Lists$Distribution$DistributionList$amountBox,
				insert.eg,
				A2(
					$author$project$Demand$Demand$amountWithPacks,
					insert,
					totalFor(insert.$8)));
		};
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Lists$Distribution$DistributionList$amountBox,
				product.eg,
				A2($author$project$Demand$Demand$amountWithPacks, product, total)),
			A2($elm$core$List$map, insertBox, product.iT));
	});
var $author$project$Lists$Distribution$DistributionList$summaryView = F2(
	function (orders, products) {
		var productsById = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (p) {
					return _Utils_Tuple2(p.eg, p);
				},
				products));
		var nonStopOrders = A2(
			$elm$core$List$filter,
			function (o) {
				return !_Utils_eq(
					o.mN,
					$elm$core$Maybe$Just(1));
			},
			orders);
		var usedProducts = A2(
			$elm$core$List$filterMap,
			function (pId) {
				return A2($elm$core$Dict$get, pId, productsById);
			},
			$elm$core$List$sort(
				$elm_community$list_extra$List$Extra$unique(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.av;
						},
						nonStopOrders))));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$concatMap,
				function (p) {
					return A2(
						$author$project$Lists$Distribution$DistributionList$productView,
						A2($author$project$Demand$Demand$filterByProduct, p, nonStopOrders),
						p);
				},
				usedProducts));
	});
var $author$project$Lists$Distribution$DistributionList$alternateClusterView = F7(
	function (distributionPoint, deliverer, orders, products, parents, item, cluster) {
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lot')
				]),
			_Utils_ap(
				A5($author$project$Lists$Distribution$DistributionList$clusterHeader, distributionPoint, deliverer, parents, item, cluster),
				_List_fromArray(
					[
						A2($author$project$Lists$Distribution$DistributionList$summaryView, orders, products)
					])));
	});
var $author$project$Lists$Distribution$DistributionList$alternateDistributionPointClusterProductView = F2(
	function (product, amountPerDemandType) {
		var totalFor = function (demandTypes) {
			return $elm$core$List$sum(
				A2(
					$elm$core$List$map,
					$elm$core$Tuple$second,
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var demandType = _v0.a;
							return A2($elm$core$List$member, demandType, demandTypes);
						},
						$author$project$Demand$TypeDict$toList(amountPerDemandType))));
		};
		var total = $elm$core$List$sum(
			$author$project$Demand$TypeDict$values(amountPerDemandType));
		var insertBox = function (insert) {
			return A2(
				$author$project$Lists$Distribution$DistributionList$amountBox,
				insert.eg,
				A2(
					$author$project$Demand$Demand$amountWithPacks,
					insert,
					totalFor(insert.$8)));
		};
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Lists$Distribution$DistributionList$amountBox,
				product.eg,
				A2($author$project$Demand$Demand$amountWithPacks, product, total)),
			A2($elm$core$List$map, insertBox, product.iT));
	});
var $author$project$Lists$Distribution$DistributionList$alternateDistributionPointItemView = F2(
	function (_v0, _v1) {
		var distributionPoint = _v0;
		var products = _v1.bu;
		var amountsByProduct = _v1.kO;
		var productsWithSummary = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			A2(
				$elm$core$List$map,
				function (product) {
					var _v3 = A2($elm$core$Dict$get, product.eg, amountsByProduct);
					if (!_v3.$) {
						var productOrderSummary = _v3.a;
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(product, productOrderSummary));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				products));
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lot')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Print$Palette$iconFor(
							$icidasset$elm_material_icons$Material$Icons$location_on(18)),
							$elm$html$Html$text(distributionPoint.ft)
						])),
				A2(
					$elm$core$List$concatMap,
					function (_v2) {
						var product = _v2.a;
						var summary = _v2.b;
						return A2($author$project$Lists$Distribution$DistributionList$alternateDistributionPointClusterProductView, product, summary);
					},
					productsWithSummary)));
	});
var $author$project$Lists$Distribution$DistributionList$alternateItemView = F6(
	function (distributionPoint, orders, demandSummaryBySubDPId, products, parents, item) {
		switch (item.$) {
			case 0:
				var car = item.a;
				return A2(
					$elm$core$List$cons,
					A7(
						$author$project$Lists$Distribution$DistributionList$alternateClusterView,
						distributionPoint,
						$author$project$Deliverer$Deliverer$fromTyped(car.bl),
						A2(
							$elm$core$List$concatMap,
							function ($) {
								return $.Y;
							},
							A2($author$project$DistributionPoint$DistributionPoint$filterOnSegments, orders, car.H.bb)),
						products,
						parents,
						item,
						car.H),
					A2(
						$elm$core$List$concatMap,
						A5(
							$author$project$Lists$Distribution$DistributionList$alternateItemView,
							distributionPoint,
							orders,
							demandSummaryBySubDPId,
							products,
							_Utils_ap(
								parents,
								_List_fromArray(
									[item]))),
						car.n0));
			case 1:
				var bike = item.a;
				return A2(
					$elm$core$List$map,
					function (cluster) {
						return A7(
							$author$project$Lists$Distribution$DistributionList$alternateClusterView,
							distributionPoint,
							$author$project$Deliverer$Deliverer$fromTyped(bike.bl),
							A2(
								$elm$core$List$concatMap,
								function ($) {
									return $.Y;
								},
								A2($author$project$DistributionPoint$DistributionPoint$filterOnSegments, orders, cluster.bb)),
							products,
							parents,
							item,
							cluster);
					},
					bike.k);
			default:
				var dpId = item.a.lK;
				var _v1 = _Utils_Tuple2(
					A2($author$project$DistributionPoint$DistributionPoint$findSubDistributionPointOnId, distributionPoint, dpId),
					A2($author$project$DistributionPoint$IdDict$get, dpId, demandSummaryBySubDPId));
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var subDistributionPoint = _v1.a.a;
					var subDPDemandSummary = _v1.b.a;
					return _List_fromArray(
						[
							A2($author$project$Lists$Distribution$DistributionList$alternateDistributionPointItemView, subDistributionPoint, subDPDemandSummary)
						]);
				} else {
					return _List_fromArray(
						[
							$elm$html$Html$text('')
						]);
				}
		}
	});
var $author$project$Lists$Distribution$DistributionList$alternateItemsView = F6(
	function (distributionPoint, deliverers, items, orders, demandSummaryBySubDPId, products) {
		var allOrders = _Utils_ap(
			orders,
			A3($author$project$Demand$Extra$orders, items, deliverers, products));
		return A2(
			$elm$core$List$concatMap,
			A5($author$project$Lists$Distribution$DistributionList$alternateItemView, distributionPoint, allOrders, demandSummaryBySubDPId, products, _List_Nil),
			items);
	});
var $author$project$Lists$Distribution$DistributionList$loadingView = $mdgriffith$elm_ui$Element$none;
var $author$project$Lists$Distribution$DistributionList$problemView = $mdgriffith$elm_ui$Element$text('Er is een onvoorzien probleem opgetreden. Er is geen data om weer te geven.');
var $author$project$UI$Paradise$idView = function (_v0) {
	var tags = _v0.kn;
	return A2($elm$core$Dict$get, $author$project$UI$Paradise$tagName, tags);
};
var $author$project$Lists$Distribution$DistributionList$title = F2(
	function (_v0, date) {
		var distributionPoint = _v0;
		var paradiseIdText = A2(
			$elm$core$Maybe$withDefault,
			'(onbekend nr)',
			$author$project$UI$Paradise$idView(distributionPoint));
		return A2(
			$elm$html$Html$header,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('DP Verdeellijst ' + (paradiseIdText + (' ' + distributionPoint.ft)))
						])),
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							'Distributie datum: ' + $author$project$Date$DeliveryDate$view(date))
						]))
				]));
	});
var $author$project$Lists$Distribution$DistributionList$alternateView = function (model) {
	var _v0 = _Utils_Tuple3(
		model.bn,
		$author$project$Plan$PlanLoader$loadedOf(model.fB),
		_Utils_Tuple2(model.Y, model.bu));
	_v0$1:
	while (true) {
		_v0$3:
		while (true) {
			_v0$4:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.$) {
						switch (_v0.a.$) {
							case 1:
								switch (_v0.c.a.$) {
									case 1:
										switch (_v0.c.b.$) {
											case 1:
												var distributionPoint = _v0.a.a;
												var p = _v0.b.a;
												var _v1 = _v0.c;
												var orders = _v1.a.a;
												var products = _v1.b.a;
												return $mdgriffith$elm_ui$Element$html(
													A2(
														$elm$html$Html$article,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('distributionlist-b')
															]),
														A2(
															$elm$core$List$cons,
															A2($author$project$Lists$Distribution$DistributionList$title, distributionPoint, model.lx),
															A6(
																$author$project$Lists$Distribution$DistributionList$alternateItemsView,
																distributionPoint,
																A3(
																	$elm$core$Basics$composeR,
																	$author$project$Deliverer$IdDict$values,
																	$elm$core$List$map($author$project$Deliverer$Deliverer$fromTyped),
																	p.e4),
																p.fA.gL,
																orders,
																model.bm,
																products))));
											case 0:
												break _v0$4;
											default:
												break _v0$5;
										}
									case 0:
										break _v0$3;
									default:
										if (!_v0.c.b.$) {
											break _v0$4;
										} else {
											break _v0$5;
										}
								}
							case 0:
								break _v0$1;
							default:
								if (!_v0.c.a.$) {
									break _v0$3;
								} else {
									if (!_v0.c.b.$) {
										break _v0$4;
									} else {
										break _v0$5;
									}
								}
						}
					} else {
						if (!_v0.a.$) {
							break _v0$1;
						} else {
							var _v2 = _v0.b;
							return $author$project$Lists$Distribution$DistributionList$loadingView;
						}
					}
				}
				return $author$project$Lists$Distribution$DistributionList$problemView;
			}
			var _v4 = _v0.c;
			return $author$project$Lists$Distribution$DistributionList$loadingView;
		}
		var _v3 = _v0.c;
		return $author$project$Lists$Distribution$DistributionList$loadingView;
	}
	return $author$project$Lists$Distribution$DistributionList$loadingView;
};
var $author$project$Portal$Subheader$Business = 0;
var $author$project$Portal$Subheader$Disabled = {$: 1};
var $author$project$Portal$Subheader$Enabled = function (a) {
	return {$: 0, a: a};
};
var $author$project$Count$Count$ShowZero = 1;
var $author$project$Count$Count$UserChangedZeroVisibilityOption = function (a) {
	return {$: 15, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$Left = 0;
var $mdgriffith$elm_ui$Element$alignLeft = $mdgriffith$elm_ui$Internal$Model$AlignX(0);
var $mdgriffith$elm_ui$Internal$Model$LivePolite = {$: 6};
var $mdgriffith$elm_ui$Element$Region$announce = $mdgriffith$elm_ui$Internal$Model$Describe($mdgriffith$elm_ui$Internal$Model$LivePolite);
var $mdgriffith$elm_ui$Internal$Model$AsRow = 0;
var $mdgriffith$elm_ui$Internal$Model$asRow = 0;
var $mdgriffith$elm_ui$Element$Input$applyLabel = F3(
	function (attrs, label, input) {
		if (label.$ === 1) {
			var labelText = label.a;
			return A4(
				$mdgriffith$elm_ui$Internal$Model$element,
				$mdgriffith$elm_ui$Internal$Model$asColumn,
				$mdgriffith$elm_ui$Internal$Model$NodeName('label'),
				attrs,
				$mdgriffith$elm_ui$Internal$Model$Unkeyed(
					_List_fromArray(
						[input])));
		} else {
			var position = label.a;
			var labelAttrs = label.b;
			var labelChild = label.c;
			var labelElement = A4(
				$mdgriffith$elm_ui$Internal$Model$element,
				$mdgriffith$elm_ui$Internal$Model$asEl,
				$mdgriffith$elm_ui$Internal$Model$div,
				labelAttrs,
				$mdgriffith$elm_ui$Internal$Model$Unkeyed(
					_List_fromArray(
						[labelChild])));
			switch (position) {
				case 2:
					return A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asColumn,
						$mdgriffith$elm_ui$Internal$Model$NodeName('label'),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.fk),
							attrs),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							_List_fromArray(
								[labelElement, input])));
				case 3:
					return A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asColumn,
						$mdgriffith$elm_ui$Internal$Model$NodeName('label'),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.fk),
							attrs),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							_List_fromArray(
								[input, labelElement])));
				case 0:
					return A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asRow,
						$mdgriffith$elm_ui$Internal$Model$NodeName('label'),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.fk),
							attrs),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							_List_fromArray(
								[input, labelElement])));
				default:
					return A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asRow,
						$mdgriffith$elm_ui$Internal$Model$NodeName('label'),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.fk),
							attrs),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							_List_fromArray(
								[labelElement, input])));
			}
		}
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $mdgriffith$elm_ui$Internal$Model$CenterY = 1;
var $mdgriffith$elm_ui$Element$centerY = $mdgriffith$elm_ui$Internal$Model$AlignY(1);
var $mdgriffith$elm_ui$Element$Input$enter = 'Enter';
var $mdgriffith$elm_ui$Internal$Model$Label = function (a) {
	return {$: 5, a: a};
};
var $mdgriffith$elm_ui$Element$Input$hiddenLabelAttribute = function (label) {
	if (label.$ === 1) {
		var textLabel = label.a;
		return $mdgriffith$elm_ui$Internal$Model$Describe(
			$mdgriffith$elm_ui$Internal$Model$Label(textLabel));
	} else {
		return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
	}
};
var $mdgriffith$elm_ui$Element$Input$isHiddenLabel = function (label) {
	if (label.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $mdgriffith$elm_ui$Element$Input$onKeyLookup = function (lookup) {
	var decode = function (code) {
		var _v0 = lookup(code);
		if (_v0.$ === 1) {
			return $elm$json$Json$Decode$fail('No key matched');
		} else {
			var msg = _v0.a;
			return $elm$json$Json$Decode$succeed(msg);
		}
	};
	var isKey = A2(
		$elm$json$Json$Decode$andThen,
		decode,
		A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
	return $mdgriffith$elm_ui$Internal$Model$Attr(
		A2(
			$elm$html$Html$Events$preventDefaultOn,
			'keydown',
			A2(
				$elm$json$Json$Decode$map,
				function (fired) {
					return _Utils_Tuple2(fired, true);
				},
				isKey)));
};
var $mdgriffith$elm_ui$Internal$Flag$cursor = $mdgriffith$elm_ui$Internal$Flag$flag(21);
var $mdgriffith$elm_ui$Element$pointer = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$cursor, $mdgriffith$elm_ui$Internal$Style$classes.lv);
var $mdgriffith$elm_ui$Element$Input$space = ' ';
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $mdgriffith$elm_ui$Element$Input$tabindex = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Attributes$tabindex);
var $mdgriffith$elm_ui$Element$Input$checkbox = F2(
	function (attrs, _v0) {
		var label = _v0.mD;
		var icon = _v0.mg;
		var checked = _v0.lc;
		var onChange = _v0.mY;
		var attributes = _Utils_ap(
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Input$isHiddenLabel(label) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Element$spacing(6),
					$mdgriffith$elm_ui$Internal$Model$Attr(
					$elm$html$Html$Events$onClick(
						onChange(!checked))),
					$mdgriffith$elm_ui$Element$Region$announce,
					$mdgriffith$elm_ui$Element$Input$onKeyLookup(
					function (code) {
						return _Utils_eq(code, $mdgriffith$elm_ui$Element$Input$enter) ? $elm$core$Maybe$Just(
							onChange(!checked)) : (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$space) ? $elm$core$Maybe$Just(
							onChange(!checked)) : $elm$core$Maybe$Nothing);
					}),
					$mdgriffith$elm_ui$Element$Input$tabindex(0),
					$mdgriffith$elm_ui$Element$pointer,
					$mdgriffith$elm_ui$Element$alignLeft,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			attrs);
		return A3(
			$mdgriffith$elm_ui$Element$Input$applyLabel,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$Attr(
					A2($elm$html$Html$Attributes$attribute, 'role', 'checkbox')),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Internal$Model$Attr(
						A2(
							$elm$html$Html$Attributes$attribute,
							'aria-checked',
							checked ? 'true' : 'false')),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$Input$hiddenLabelAttribute(label),
						attributes))),
			label,
			A4(
				$mdgriffith$elm_ui$Internal$Model$element,
				$mdgriffith$elm_ui$Internal$Model$asEl,
				$mdgriffith$elm_ui$Internal$Model$div,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$centerY,
						$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink)
					]),
				$mdgriffith$elm_ui$Internal$Model$Unkeyed(
					_List_fromArray(
						[
							icon(checked)
						]))));
	});
var $mdgriffith$elm_ui$Internal$Flag$fontAlignment = $mdgriffith$elm_ui$Internal$Flag$flag(12);
var $mdgriffith$elm_ui$Element$Font$center = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$fontAlignment, $mdgriffith$elm_ui$Internal$Style$classes.n4);
var $mdgriffith$elm_ui$Internal$Model$CenterX = 1;
var $mdgriffith$elm_ui$Element$centerX = $mdgriffith$elm_ui$Internal$Model$AlignX(1);
var $elm$core$Basics$pi = _Basics_pi;
var $elm$core$Basics$degrees = function (angleInDegrees) {
	return (angleInDegrees * $elm$core$Basics$pi) / 180;
};
var $mdgriffith$elm_ui$Internal$Model$InFront = 4;
var $mdgriffith$elm_ui$Element$createNearby = F2(
	function (loc, element) {
		if (element.$ === 3) {
			return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
		} else {
			return A2($mdgriffith$elm_ui$Internal$Model$Nearby, loc, element);
		}
	});
var $mdgriffith$elm_ui$Element$inFront = function (element) {
	return A2($mdgriffith$elm_ui$Element$createNearby, 4, element);
};
var $mdgriffith$elm_ui$Internal$Model$MoveY = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$moveY = $mdgriffith$elm_ui$Internal$Flag$flag(26);
var $mdgriffith$elm_ui$Element$moveUp = function (y) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$TransformComponent,
		$mdgriffith$elm_ui$Internal$Flag$moveY,
		$mdgriffith$elm_ui$Internal$Model$MoveY(-y));
};
var $mdgriffith$elm_ui$Element$rgb = F3(
	function (r, g, b) {
		return A4($mdgriffith$elm_ui$Internal$Model$Rgba, r, g, b, 1);
	});
var $mdgriffith$elm_ui$Element$rgba = $mdgriffith$elm_ui$Internal$Model$Rgba;
var $mdgriffith$elm_ui$Internal$Model$Rotate = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$rotate = $mdgriffith$elm_ui$Internal$Flag$flag(24);
var $mdgriffith$elm_ui$Element$rotate = function (angle) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$TransformComponent,
		$mdgriffith$elm_ui$Internal$Flag$rotate,
		A2(
			$mdgriffith$elm_ui$Internal$Model$Rotate,
			_Utils_Tuple3(0, 0, 1),
			angle));
};
var $mdgriffith$elm_ui$Internal$Model$boxShadowClass = function (shadow) {
	return $elm$core$String$concat(
		_List_fromArray(
			[
				shadow.iU ? 'box-inset' : 'box-',
				$mdgriffith$elm_ui$Internal$Model$floatClass(shadow.c.a) + 'px',
				$mdgriffith$elm_ui$Internal$Model$floatClass(shadow.c.b) + 'px',
				$mdgriffith$elm_ui$Internal$Model$floatClass(shadow.c_) + 'px',
				$mdgriffith$elm_ui$Internal$Model$floatClass(shadow.bB) + 'px',
				$mdgriffith$elm_ui$Internal$Model$formatColorClass(shadow.eS)
			]));
};
var $mdgriffith$elm_ui$Internal$Flag$shadows = $mdgriffith$elm_ui$Internal$Flag$flag(19);
var $mdgriffith$elm_ui$Element$Border$shadow = function (almostShade) {
	var shade = {c_: almostShade.c_, eS: almostShade.eS, iU: false, c: almostShade.c, bB: almostShade.bB};
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$shadows,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Single,
			$mdgriffith$elm_ui$Internal$Model$boxShadowClass(shade),
			'box-shadow',
			$mdgriffith$elm_ui$Internal$Model$formatBoxShadow(shade)));
};
var $mdgriffith$elm_ui$Internal$Model$FontSize = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$fontSize = $mdgriffith$elm_ui$Internal$Flag$flag(4);
var $mdgriffith$elm_ui$Element$Font$size = function (i) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$fontSize,
		$mdgriffith$elm_ui$Internal$Model$FontSize(i));
};
var $mdgriffith$elm_ui$Internal$Model$Transparency = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$transparency = $mdgriffith$elm_ui$Internal$Flag$flag(0);
var $mdgriffith$elm_ui$Element$transparent = function (on) {
	return on ? A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$transparency,
		A2($mdgriffith$elm_ui$Internal$Model$Transparency, 'transparent', 1.0)) : A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$transparency,
		A2($mdgriffith$elm_ui$Internal$Model$Transparency, 'visible', 0.0));
};
var $mdgriffith$elm_ui$Element$Input$white = A3($mdgriffith$elm_ui$Element$rgb, 1, 1, 1);
var $mdgriffith$elm_ui$Element$Border$widthXY = F2(
	function (x, y) {
		return A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$borderWidth,
			A5(
				$mdgriffith$elm_ui$Internal$Model$BorderWidth,
				'b-' + ($elm$core$String$fromInt(x) + ('-' + $elm$core$String$fromInt(y))),
				y,
				x,
				y,
				x));
	});
var $mdgriffith$elm_ui$Element$Border$widthEach = function (_v0) {
	var bottom = _v0.k5;
	var top = _v0.ol;
	var left = _v0.mE;
	var right = _v0.nx;
	return (_Utils_eq(top, bottom) && _Utils_eq(left, right)) ? (_Utils_eq(top, right) ? $mdgriffith$elm_ui$Element$Border$width(top) : A2($mdgriffith$elm_ui$Element$Border$widthXY, left, top)) : A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$borderWidth,
		A5(
			$mdgriffith$elm_ui$Internal$Model$BorderWidth,
			'b-' + ($elm$core$String$fromInt(top) + ('-' + ($elm$core$String$fromInt(right) + ('-' + ($elm$core$String$fromInt(bottom) + ('-' + $elm$core$String$fromInt(left))))))),
			top,
			right,
			bottom,
			left));
};
var $mdgriffith$elm_ui$Element$Input$defaultCheckbox = function (checked) {
	return A2(
		$mdgriffith$elm_ui$Element$el,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Internal$Model$htmlClass('focusable'),
				$mdgriffith$elm_ui$Element$width(
				$mdgriffith$elm_ui$Element$px(14)),
				$mdgriffith$elm_ui$Element$height(
				$mdgriffith$elm_ui$Element$px(14)),
				$mdgriffith$elm_ui$Element$Font$color($mdgriffith$elm_ui$Element$Input$white),
				$mdgriffith$elm_ui$Element$centerY,
				$mdgriffith$elm_ui$Element$Font$size(9),
				$mdgriffith$elm_ui$Element$Font$center,
				$mdgriffith$elm_ui$Element$Border$rounded(3),
				$mdgriffith$elm_ui$Element$Border$color(
				checked ? A3($mdgriffith$elm_ui$Element$rgb, 59 / 255, 153 / 255, 252 / 255) : A3($mdgriffith$elm_ui$Element$rgb, 211 / 255, 211 / 255, 211 / 255)),
				$mdgriffith$elm_ui$Element$Border$shadow(
				{
					c_: 1,
					eS: checked ? A4($mdgriffith$elm_ui$Element$rgba, 238 / 255, 238 / 255, 238 / 255, 0) : A3($mdgriffith$elm_ui$Element$rgb, 238 / 255, 238 / 255, 238 / 255),
					c: _Utils_Tuple2(0, 0),
					bB: 1
				}),
				$mdgriffith$elm_ui$Element$Background$color(
				checked ? A3($mdgriffith$elm_ui$Element$rgb, 59 / 255, 153 / 255, 252 / 255) : $mdgriffith$elm_ui$Element$Input$white),
				$mdgriffith$elm_ui$Element$Border$width(
				checked ? 0 : 1),
				$mdgriffith$elm_ui$Element$inFront(
				A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Border$color($mdgriffith$elm_ui$Element$Input$white),
							$mdgriffith$elm_ui$Element$height(
							$mdgriffith$elm_ui$Element$px(6)),
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$px(9)),
							$mdgriffith$elm_ui$Element$rotate(
							$elm$core$Basics$degrees(-45)),
							$mdgriffith$elm_ui$Element$centerX,
							$mdgriffith$elm_ui$Element$centerY,
							$mdgriffith$elm_ui$Element$moveUp(1),
							$mdgriffith$elm_ui$Element$transparent(!checked),
							$mdgriffith$elm_ui$Element$Border$widthEach(
							{k5: 2, mE: 2, nx: 0, ol: 0})
						]),
					$mdgriffith$elm_ui$Element$none))
			]),
		$mdgriffith$elm_ui$Element$none);
};
var $author$project$Portal$Subheader$NoDate = {$: 0};
var $author$project$Portal$Subheader$Subheader = $elm$core$Basics$identity;
var $author$project$Portal$Subheader$empty = {dR: $elm$core$Maybe$Nothing, lx: $author$project$Portal$Subheader$NoDate, dk: _List_Nil, oi: $elm$core$Maybe$Nothing};
var $mdgriffith$elm_ui$Element$Input$Label = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $mdgriffith$elm_ui$Element$Input$OnRight = 0;
var $mdgriffith$elm_ui$Element$Input$labelRight = $mdgriffith$elm_ui$Element$Input$Label(0);
var $author$project$Demand$Bundle$AlwaysShowPacks = 0;
var $author$project$Demand$PackIcon$Large = 2;
var $author$project$Demand$Bundle$OnlyPacks = function (a) {
	return {$: 0, a: a};
};
var $author$project$Count$Count$UserChangedBundleConfig = function (a) {
	return {$: 14, a: a};
};
var $author$project$UI$MultiButton$MultiButton = $elm$core$Basics$identity;
var $author$project$UI$MultiButton$multiButton = function (b) {
	return b;
};
var $author$project$UI$MultiButton$Left = 0;
var $author$project$UI$MultiButton$Middle = 1;
var $author$project$UI$MultiButton$Right = 2;
var $mdgriffith$elm_ui$Element$Input$HiddenLabel = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Element$Input$labelHidden = $mdgriffith$elm_ui$Element$Input$HiddenLabel;
var $mdgriffith$elm_ui$Element$Input$Option = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Element$Input$optionWith = F2(
	function (val, view) {
		return A2($mdgriffith$elm_ui$Element$Input$Option, val, view);
	});
var $mdgriffith$elm_ui$Element$paddingXY = F2(
	function (x, y) {
		if (_Utils_eq(x, y)) {
			var f = x;
			return A2(
				$mdgriffith$elm_ui$Internal$Model$StyleClass,
				$mdgriffith$elm_ui$Internal$Flag$padding,
				A5(
					$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
					'p-' + $elm$core$String$fromInt(x),
					f,
					f,
					f,
					f));
		} else {
			var yFloat = y;
			var xFloat = x;
			return A2(
				$mdgriffith$elm_ui$Internal$Model$StyleClass,
				$mdgriffith$elm_ui$Internal$Flag$padding,
				A5(
					$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
					'p-' + ($elm$core$String$fromInt(x) + ('-' + $elm$core$String$fromInt(y))),
					yFloat,
					xFloat,
					yFloat,
					xFloat));
		}
	});
var $mdgriffith$elm_ui$Element$Border$roundEach = function (_v0) {
	var topLeft = _v0.hB;
	var topRight = _v0.hC;
	var bottomLeft = _v0.gb;
	var bottomRight = _v0.gc;
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$borderRound,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Single,
			'br-' + ($elm$core$String$fromInt(topLeft) + ('-' + ($elm$core$String$fromInt(topRight) + ($elm$core$String$fromInt(bottomLeft) + ('-' + $elm$core$String$fromInt(bottomRight)))))),
			'border-radius',
			$elm$core$String$fromInt(topLeft) + ('px ' + ($elm$core$String$fromInt(topRight) + ('px ' + ($elm$core$String$fromInt(bottomRight) + ('px ' + ($elm$core$String$fromInt(bottomLeft) + 'px'))))))));
};
var $author$project$UI$MultiButton$partView = F3(
	function (content, position, state) {
		var allCorners = {gb: 6, gc: 6, hB: 6, hC: 6};
		var allBorders = {k5: 2, mE: 2, nx: 2, ol: 2};
		var _v0 = function () {
			if (state === 2) {
				return _Utils_Tuple2($author$project$UI$Palette$base02, $author$project$UI$Palette$base2);
			} else {
				return _Utils_Tuple2($author$project$UI$Palette$base1, $author$project$UI$Palette$base03);
			}
		}();
		var background = _v0.a;
		var font = _v0.b;
		var _v2 = function () {
			switch (position) {
				case 0:
					return _Utils_Tuple2(
						_Utils_update(
							allBorders,
							{nx: 0}),
						_Utils_update(
							allCorners,
							{gc: 0, hC: 0}));
				case 1:
					return _Utils_Tuple2(
						_Utils_update(
							allBorders,
							{nx: 0}),
						{gb: 0, gc: 0, hB: 0, hC: 0});
				default:
					return _Utils_Tuple2(
						allBorders,
						_Utils_update(
							allCorners,
							{gb: 0, hB: 0}));
			}
		}();
		var borders = _v2.a;
		var corners = _v2.b;
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					A2($mdgriffith$elm_ui$Element$paddingXY, 15, 8),
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$Border$widthEach(borders),
					$mdgriffith$elm_ui$Element$Border$roundEach(corners),
					$mdgriffith$elm_ui$Element$Border$color(
					$author$project$UI$Element$colorFor($author$project$UI$Palette$base0)),
					$mdgriffith$elm_ui$Element$Background$color(
					$author$project$UI$Element$colorFor(background)),
					$mdgriffith$elm_ui$Element$Font$color(
					$author$project$UI$Element$colorFor(font)),
					$mdgriffith$elm_ui$Element$centerX,
					$mdgriffith$elm_ui$Element$centerY
				]),
			content);
	});
var $mdgriffith$elm_ui$Element$Input$Row = 0;
var $mdgriffith$elm_ui$Element$Input$AfterFound = 2;
var $mdgriffith$elm_ui$Element$Input$BeforeFound = 1;
var $mdgriffith$elm_ui$Element$Input$Idle = 0;
var $mdgriffith$elm_ui$Element$Input$NotFound = 0;
var $mdgriffith$elm_ui$Element$Input$Selected = 2;
var $mdgriffith$elm_ui$Element$Input$column = F2(
	function (attributes, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asColumn,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					attributes)),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
	});
var $mdgriffith$elm_ui$Element$Input$downArrow = 'ArrowDown';
var $mdgriffith$elm_ui$Internal$Model$filter = function (attrs) {
	return A3(
		$elm$core$List$foldr,
		F2(
			function (x, _v0) {
				var found = _v0.a;
				var has = _v0.b;
				switch (x.$) {
					case 0:
						return _Utils_Tuple2(found, has);
					case 3:
						var key = x.a;
						return _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							has);
					case 1:
						var attr = x.a;
						return _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							has);
					case 4:
						var style = x.b;
						return _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							has);
					case 7:
						var width = x.a;
						return A2($elm$core$Set$member, 'width', has) ? _Utils_Tuple2(found, has) : _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							A2($elm$core$Set$insert, 'width', has));
					case 8:
						var height = x.a;
						return A2($elm$core$Set$member, 'height', has) ? _Utils_Tuple2(found, has) : _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							A2($elm$core$Set$insert, 'height', has));
					case 2:
						var description = x.a;
						return A2($elm$core$Set$member, 'described', has) ? _Utils_Tuple2(found, has) : _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							A2($elm$core$Set$insert, 'described', has));
					case 9:
						var location = x.a;
						var elem = x.b;
						return _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							has);
					case 6:
						return A2($elm$core$Set$member, 'align-x', has) ? _Utils_Tuple2(found, has) : _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							A2($elm$core$Set$insert, 'align-x', has));
					case 5:
						return A2($elm$core$Set$member, 'align-y', has) ? _Utils_Tuple2(found, has) : _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							A2($elm$core$Set$insert, 'align-y', has));
					default:
						return A2($elm$core$Set$member, 'transform', has) ? _Utils_Tuple2(found, has) : _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							A2($elm$core$Set$insert, 'transform', has));
				}
			}),
		_Utils_Tuple2(_List_Nil, $elm$core$Set$empty),
		attrs).a;
};
var $mdgriffith$elm_ui$Internal$Model$get = F2(
	function (attrs, isAttr) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, found) {
					return isAttr(x) ? A2($elm$core$List$cons, x, found) : found;
				}),
			_List_Nil,
			$mdgriffith$elm_ui$Internal$Model$filter(attrs));
	});
var $mdgriffith$elm_ui$Element$Input$leftArrow = 'ArrowLeft';
var $mdgriffith$elm_ui$Element$Events$onClick = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Events$onClick);
var $mdgriffith$elm_ui$Element$Input$rightArrow = 'ArrowRight';
var $mdgriffith$elm_ui$Element$Input$row = F2(
	function (attributes, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asRow,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				attributes),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
	});
var $mdgriffith$elm_ui$Element$Input$upArrow = 'ArrowUp';
var $mdgriffith$elm_ui$Element$Input$radioHelper = F3(
	function (orientation, attrs, input) {
		var track = F2(
			function (opt, _v14) {
				var found = _v14.a;
				var prev = _v14.b;
				var nxt = _v14.c;
				var val = opt.a;
				switch (found) {
					case 0:
						return _Utils_eq(
							$elm$core$Maybe$Just(val),
							input.nI) ? _Utils_Tuple3(1, prev, nxt) : _Utils_Tuple3(found, val, nxt);
					case 1:
						return _Utils_Tuple3(2, prev, val);
					default:
						return _Utils_Tuple3(found, prev, nxt);
				}
			});
		var renderOption = function (_v11) {
			var val = _v11.a;
			var view = _v11.b;
			var status = _Utils_eq(
				$elm$core$Maybe$Just(val),
				input.nI) ? 2 : 0;
			return A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$pointer,
						function () {
						if (!orientation) {
							return $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink);
						} else {
							return $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill);
						}
					}(),
						$mdgriffith$elm_ui$Element$Events$onClick(
						input.mY(val)),
						function () {
						if (status === 2) {
							return $mdgriffith$elm_ui$Internal$Model$Attr(
								A2($elm$html$Html$Attributes$attribute, 'aria-checked', 'true'));
						} else {
							return $mdgriffith$elm_ui$Internal$Model$Attr(
								A2($elm$html$Html$Attributes$attribute, 'aria-checked', 'false'));
						}
					}(),
						$mdgriffith$elm_ui$Internal$Model$Attr(
						A2($elm$html$Html$Attributes$attribute, 'role', 'radio'))
					]),
				view(status));
		};
		var prevNext = function () {
			var _v5 = input.m7;
			if (!_v5.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v6 = _v5.a;
				var val = _v6.a;
				return function (_v7) {
					var found = _v7.a;
					var b = _v7.b;
					var a = _v7.c;
					switch (found) {
						case 0:
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(b, val));
						case 1:
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(b, val));
						default:
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(b, a));
					}
				}(
					A3(
						$elm$core$List$foldl,
						track,
						_Utils_Tuple3(0, val, val),
						input.m7));
			}
		}();
		var optionArea = function () {
			if (!orientation) {
				return A2(
					$mdgriffith$elm_ui$Element$Input$row,
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$Input$hiddenLabelAttribute(input.mD),
						attrs),
					A2($elm$core$List$map, renderOption, input.m7));
			} else {
				return A2(
					$mdgriffith$elm_ui$Element$Input$column,
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$Input$hiddenLabelAttribute(input.mD),
						attrs),
					A2($elm$core$List$map, renderOption, input.m7));
			}
		}();
		var events = A2(
			$mdgriffith$elm_ui$Internal$Model$get,
			attrs,
			function (attr) {
				_v3$3:
				while (true) {
					switch (attr.$) {
						case 7:
							if (attr.a.$ === 2) {
								return true;
							} else {
								break _v3$3;
							}
						case 8:
							if (attr.a.$ === 2) {
								return true;
							} else {
								break _v3$3;
							}
						case 1:
							return true;
						default:
							break _v3$3;
					}
				}
				return false;
			});
		return A3(
			$mdgriffith$elm_ui$Element$Input$applyLabel,
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$elm$core$Maybe$Just($mdgriffith$elm_ui$Element$alignLeft),
							$elm$core$Maybe$Just(
							$mdgriffith$elm_ui$Element$Input$tabindex(0)),
							$elm$core$Maybe$Just(
							$mdgriffith$elm_ui$Internal$Model$htmlClass('focus')),
							$elm$core$Maybe$Just($mdgriffith$elm_ui$Element$Region$announce),
							$elm$core$Maybe$Just(
							$mdgriffith$elm_ui$Internal$Model$Attr(
								A2($elm$html$Html$Attributes$attribute, 'role', 'radiogroup'))),
							function () {
							if (prevNext.$ === 1) {
								return $elm$core$Maybe$Nothing;
							} else {
								var _v1 = prevNext.a;
								var prev = _v1.a;
								var next = _v1.b;
								return $elm$core$Maybe$Just(
									$mdgriffith$elm_ui$Element$Input$onKeyLookup(
										function (code) {
											if (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$leftArrow)) {
												return $elm$core$Maybe$Just(
													input.mY(prev));
											} else {
												if (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$upArrow)) {
													return $elm$core$Maybe$Just(
														input.mY(prev));
												} else {
													if (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$rightArrow)) {
														return $elm$core$Maybe$Just(
															input.mY(next));
													} else {
														if (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$downArrow)) {
															return $elm$core$Maybe$Just(
																input.mY(next));
														} else {
															if (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$space)) {
																var _v2 = input.nI;
																if (_v2.$ === 1) {
																	return $elm$core$Maybe$Just(
																		input.mY(prev));
																} else {
																	return $elm$core$Maybe$Nothing;
																}
															} else {
																return $elm$core$Maybe$Nothing;
															}
														}
													}
												}
											}
										}));
							}
						}()
						])),
				events),
			input.mD,
			optionArea);
	});
var $mdgriffith$elm_ui$Element$Input$radioRow = $mdgriffith$elm_ui$Element$Input$radioHelper(0);
var $author$project$UI$MultiButton$toElement = F3(
	function (optionView, selected, _v0) {
		var label = _v0.mD;
		var msg = _v0.gX;
		var first = _v0.gy;
		var last = _v0.gN;
		var rest = _v0.hf;
		var options = A2(
			$elm$core$List$cons,
			A2(
				$mdgriffith$elm_ui$Element$Input$optionWith,
				first,
				A2(
					$author$project$UI$MultiButton$partView,
					optionView(first),
					0)),
			_Utils_ap(
				A2(
					$elm$core$List$map,
					function (i) {
						return A2(
							$mdgriffith$elm_ui$Element$Input$optionWith,
							i,
							A2(
								$author$project$UI$MultiButton$partView,
								optionView(i),
								1));
					},
					rest),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$Input$optionWith,
						last,
						A2(
							$author$project$UI$MultiButton$partView,
							optionView(last),
							2))
					])));
		return A2(
			$mdgriffith$elm_ui$Element$Input$radioRow,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Border$rounded(6)
				]),
			{
				mD: $mdgriffith$elm_ui$Element$Input$labelHidden(label),
				mY: msg,
				m7: options,
				nI: selected
			});
	});
var $mdgriffith$elm_ui$Element$row = F2(
	function (attrs, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asRow,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.dZ + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.bI)),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
						attrs))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
	});
var $author$project$Demand$Bundle$view = F2(
	function (config, _v0) {
		var individual = _v0.aM;
		var packs = _v0.dl;
		var packSize = _v0.E;
		var _v1 = _Utils_Tuple2(config, packs);
		switch (_v1.a.$) {
			case 0:
				var iconSize = _v1.a.a;
				return A2(
					$mdgriffith$elm_ui$Element$row,
					_List_Nil,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text(
							$elm$core$String$fromInt(packs)),
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_Nil,
							$mdgriffith$elm_ui$Element$html(
								A2($author$project$Demand$PackIcon$view, iconSize, packSize)))
						]));
			case 1:
				var _v2 = _v1.a;
				return A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$centerX,
							$mdgriffith$elm_ui$Element$centerY,
							A2($mdgriffith$elm_ui$Element$paddingXY, 20, 0)
						]),
					$mdgriffith$elm_ui$Element$text(
						$elm$core$String$fromInt(individual)));
			default:
				if ((_v1.a.b === 1) && (!_v1.b)) {
					var _v3 = _v1.a;
					var _v4 = _v3.b;
					return A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$centerX,
								$mdgriffith$elm_ui$Element$centerY,
								A2($mdgriffith$elm_ui$Element$paddingXY, 20, 0)
							]),
						$mdgriffith$elm_ui$Element$text(
							$elm$core$String$fromInt(individual)));
				} else {
					var _v5 = _v1.a;
					var iconSize = _v5.a;
					return A2(
						$mdgriffith$elm_ui$Element$row,
						_List_Nil,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text(
								$elm$core$String$fromInt(packs)),
								A2(
								$mdgriffith$elm_ui$Element$el,
								_List_Nil,
								$mdgriffith$elm_ui$Element$html(
									A2($author$project$Demand$PackIcon$view, iconSize, packSize))),
								A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Element$paddingXY, 5, 0)
									]),
								$mdgriffith$elm_ui$Element$text('+')),
								$mdgriffith$elm_ui$Element$text(
								$elm$core$String$fromInt(individual))
							]));
				}
		}
	});
var $author$project$Demand$Bundle$withIconSize = F2(
	function (iconSize, config) {
		switch (config.$) {
			case 0:
				return $author$project$Demand$Bundle$OnlyPacks(iconSize);
			case 1:
				return config;
			default:
				var packVisibility = config.b;
				return A2($author$project$Demand$Bundle$IndividualsAndPacks, iconSize, packVisibility);
		}
	});
var $author$project$Count$Count$packsOptionView = function (selectedPacksOption) {
	var exampleBundle = A2(
		$author$project$Demand$Bundle$make,
		{E: 60},
		64);
	var optionView = function (option) {
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Font$size(22),
					$mdgriffith$elm_ui$Element$centerY
				]),
			A2(
				$author$project$Demand$Bundle$view,
				A2($author$project$Demand$Bundle$withIconSize, 1, option),
				exampleBundle));
	};
	return A3(
		$author$project$UI$MultiButton$toElement,
		optionView,
		$elm$core$Maybe$Just(selectedPacksOption),
		$author$project$UI$MultiButton$multiButton(
			{
				gy: $author$project$Demand$Bundle$OnlyIndividuals,
				mD: 'Kies of losse exemplaren en/of volle pakken zichtbaar zijn',
				gN: $author$project$Demand$Bundle$OnlyPacks(2),
				gX: $author$project$Count$Count$UserChangedBundleConfig,
				hf: _List_fromArray(
					[
						A2($author$project$Demand$Bundle$IndividualsAndPacks, 2, 0)
					])
			}));
};
var $author$project$Portal$Subheader$MovableDate = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Portal$Subheader$withMoveableDate = F3(
	function (moveableDateConfig, calendarState, _v0) {
		var s = _v0;
		return _Utils_update(
			s,
			{
				lx: A2($author$project$Portal$Subheader$MovableDate, moveableDateConfig, calendarState)
			});
	});
var $author$project$Portal$Subheader$withOther = F2(
	function (others, _v0) {
		var s = _v0;
		return _Utils_update(
			s,
			{
				dk: _Utils_ap(s.dk, others)
			});
	});
var $author$project$Count$Count$countMenu = function (_v0) {
	var options = _v0.m7;
	var calendarState = _v0.r;
	var planId = _v0.a8;
	var checkedToZeroOption = function (checked) {
		return checked ? 1 : 0;
	};
	return A2(
		$author$project$Portal$Subheader$withOther,
		_List_fromArray(
			[
				$author$project$Count$Count$packsOptionView(options.ag),
				A2(
				$mdgriffith$elm_ui$Element$Input$checkbox,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$alignRight,
						$mdgriffith$elm_ui$Element$width(
						$mdgriffith$elm_ui$Element$px(90))
					]),
				{
					lc: options.eH === 1,
					mg: $mdgriffith$elm_ui$Element$Input$defaultCheckbox,
					mD: A2(
						$mdgriffith$elm_ui$Element$Input$labelRight,
						_List_Nil,
						$mdgriffith$elm_ui$Element$text('Toon alles')),
					mY: A2($elm$core$Basics$composeR, checkedToZeroOption, $author$project$Count$Count$UserChangedZeroVisibilityOption)
				})
			]),
		A3(
			$author$project$Portal$Subheader$withMoveableDate,
			{
				k7: {
					ls: $author$project$Portal$Subheader$Disabled,
					lz: $author$project$Portal$Subheader$Disabled,
					m5: $author$project$Portal$Subheader$Enabled('Dag openen')
				},
				l5: $author$project$Count$Count$GotSubHeaderMsg,
				nb: planId.lx,
				ow: 0
			},
			calendarState,
			$author$project$Portal$Subheader$empty));
};
var $mdgriffith$elm_ui$Element$map = $mdgriffith$elm_ui$Internal$Model$map;
var $author$project$Portal$Subheader$UnmovableDate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Portal$Subheader$mapConfig = F2(
	function (mapper, _v0) {
		var gotMsg = _v0.l5;
		var buttons = _v0.k7;
		var pageDate = _v0.nb;
		var week = _v0.ow;
		return {
			k7: buttons,
			l5: A2($elm$core$Basics$composeR, gotMsg, mapper),
			nb: pageDate,
			ow: week
		};
	});
var $author$project$Portal$Subheader$mapDate = F2(
	function (mapper, d) {
		switch (d.$) {
			case 0:
				return $author$project$Portal$Subheader$NoDate;
			case 1:
				var date = d.a;
				return $author$project$Portal$Subheader$UnmovableDate(date);
			default:
				var config = d.a;
				var calendarState = d.b;
				return A2(
					$author$project$Portal$Subheader$MovableDate,
					A2($author$project$Portal$Subheader$mapConfig, mapper, config),
					calendarState);
		}
	});
var $author$project$Portal$Subheader$map = F2(
	function (mapper, _v0) {
		var s = _v0;
		return {
			dR: A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$mapFirst(mapper),
				s.dR),
			lx: A2($author$project$Portal$Subheader$mapDate, mapper, s.lx),
			dk: A2(
				$elm$core$List$map,
				$mdgriffith$elm_ui$Element$map(mapper),
				s.dk),
			oi: s.oi
		};
	});
var $author$project$Portal$Page$mapPage = F2(
	function (gotMsg, _v0) {
		var subheader = _v0.e;
		var content = _v0.d;
		var closedMessageMsg = _v0.lk;
		var pageMsg = _v0.nc;
		return {
			lk: closedMessageMsg,
			d: A2($mdgriffith$elm_ui$Element$map, gotMsg, content),
			nc: pageMsg,
			e: A2($author$project$Portal$Subheader$map, gotMsg, subheader)
		};
	});
var $mdgriffith$elm_ui$Internal$Model$Top = 0;
var $mdgriffith$elm_ui$Element$alignTop = $mdgriffith$elm_ui$Internal$Model$AlignY(0);
var $mdgriffith$elm_ui$Internal$Model$FontFamily = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$fontFamily = $mdgriffith$elm_ui$Internal$Flag$flag(5);
var $mdgriffith$elm_ui$Internal$Model$renderFontClassName = F2(
	function (font, current) {
		return _Utils_ap(
			current,
			function () {
				switch (font.$) {
					case 0:
						return 'serif';
					case 1:
						return 'sans-serif';
					case 2:
						return 'monospace';
					case 3:
						var name = font.a;
						return A2(
							$elm$core$String$join,
							'-',
							$elm$core$String$words(
								$elm$core$String$toLower(name)));
					case 4:
						var name = font.a;
						var url = font.b;
						return A2(
							$elm$core$String$join,
							'-',
							$elm$core$String$words(
								$elm$core$String$toLower(name)));
					default:
						var name = font.a.ft;
						return A2(
							$elm$core$String$join,
							'-',
							$elm$core$String$words(
								$elm$core$String$toLower(name)));
				}
			}());
	});
var $mdgriffith$elm_ui$Element$Font$family = function (families) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$fontFamily,
		A2(
			$mdgriffith$elm_ui$Internal$Model$FontFamily,
			A3($elm$core$List$foldl, $mdgriffith$elm_ui$Internal$Model$renderFontClassName, 'ff-', families),
			families));
};
var $mdgriffith$elm_ui$Internal$Model$Typeface = function (a) {
	return {$: 3, a: a};
};
var $mdgriffith$elm_ui$Element$Font$typeface = $mdgriffith$elm_ui$Internal$Model$Typeface;
var $author$project$UI$Font$openSans = $mdgriffith$elm_ui$Element$Font$family(
	_List_fromArray(
		[
			$mdgriffith$elm_ui$Element$Font$typeface('Open Sans'),
			$mdgriffith$elm_ui$Element$Font$typeface('Helvetica')
		]));
var $mdgriffith$elm_ui$Internal$Flag$fontWeight = $mdgriffith$elm_ui$Internal$Flag$flag(13);
var $mdgriffith$elm_ui$Element$Font$regular = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$fontWeight, $mdgriffith$elm_ui$Internal$Style$classes.oc);
var $elm$core$Basics$pow = _Basics_pow;
var $mdgriffith$elm_ui$Element$modular = F3(
	function (normal, ratio, rescale) {
		return (!rescale) ? normal : ((rescale < 0) ? (normal * A2($elm$core$Basics$pow, ratio, rescale)) : (normal * A2($elm$core$Basics$pow, ratio, rescale - 1)));
	});
var $author$project$UI$Font$scaled = A2(
	$elm$core$Basics$composeR,
	A2($mdgriffith$elm_ui$Element$modular, 16, 1.15),
	$elm$core$Basics$floor);
var $author$project$UI$Font$body = _List_fromArray(
	[
		$mdgriffith$elm_ui$Element$Font$size(
		$author$project$UI$Font$scaled(1)),
		$mdgriffith$elm_ui$Element$Font$regular,
		$author$project$UI$Font$openSans
	]);
var $author$project$Portal$Page$Dashboard = 0;
var $author$project$Portal$Page$UserClickedMenuItem = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$Button = {$: 8};
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $mdgriffith$elm_ui$Element$Input$hasFocusStyle = function (attr) {
	if (((attr.$ === 4) && (attr.b.$ === 11)) && (!attr.b.a)) {
		var _v1 = attr.b;
		var _v2 = _v1.a;
		return true;
	} else {
		return false;
	}
};
var $mdgriffith$elm_ui$Element$Input$focusDefault = function (attrs) {
	return A2($elm$core$List$any, $mdgriffith$elm_ui$Element$Input$hasFocusStyle, attrs) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Internal$Model$htmlClass('focusable');
};
var $mdgriffith$elm_ui$Element$Input$button = F2(
	function (attrs, _v0) {
		var onPress = _v0.jp;
		var label = _v0.mD;
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.eZ + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.bI + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.nE + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.jm)))))),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Element$pointer,
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Element$Input$focusDefault(attrs),
								A2(
									$elm$core$List$cons,
									$mdgriffith$elm_ui$Internal$Model$Describe($mdgriffith$elm_ui$Internal$Model$Button),
									A2(
										$elm$core$List$cons,
										$mdgriffith$elm_ui$Internal$Model$Attr(
											$elm$html$Html$Attributes$tabindex(0)),
										function () {
											if (onPress.$ === 1) {
												return A2(
													$elm$core$List$cons,
													$mdgriffith$elm_ui$Internal$Model$Attr(
														$elm$html$Html$Attributes$disabled(true)),
													attrs);
											} else {
												var msg = onPress.a;
												return A2(
													$elm$core$List$cons,
													$mdgriffith$elm_ui$Element$Events$onClick(msg),
													A2(
														$elm$core$List$cons,
														$mdgriffith$elm_ui$Element$Input$onKeyLookup(
															function (code) {
																return _Utils_eq(code, $mdgriffith$elm_ui$Element$Input$enter) ? $elm$core$Maybe$Just(msg) : (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$space) ? $elm$core$Maybe$Just(msg) : $elm$core$Maybe$Nothing);
															}),
														attrs));
											}
										}()))))))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(
				_List_fromArray(
					[label])));
	});
var $author$project$Portal$Share$environment = function (_v0) {
	var model = _v0;
	return model.iy;
};
var $author$project$UI$Palette$base01 = $tesk9$palette$SolidColor$fromRGB(
	_Utils_Tuple3(61, 148, 216));
var $author$project$UI$Palette$lightMagenta = $tesk9$palette$SolidColor$fromRGB(
	_Utils_Tuple3(238, 22, 124));
var $author$project$UI$Palette$orange = $tesk9$palette$SolidColor$fromRGB(
	_Utils_Tuple3(224, 78, 57));
var $author$project$UI$Palette$yellow = $tesk9$palette$SolidColor$fromRGB(
	_Utils_Tuple3(255, 184, 28));
var $author$project$Portal$Page$headerColorFor = function (environment) {
	var envColor = function () {
		switch (environment.$) {
			case 0:
				return $author$project$UI$Palette$base2;
			case 1:
				return $author$project$UI$Palette$base01;
			case 2:
				return $author$project$UI$Palette$lightMagenta;
			case 3:
				return $author$project$UI$Palette$yellow;
			case 4:
				return $author$project$UI$Palette$lightGreen;
			default:
				return $author$project$UI$Palette$orange;
		}
	}();
	return {kV: envColor, k0: envColor, lZ: $author$project$UI$Palette$base03};
};
var $author$project$Portal$Page$headerHeight = 60;
var $author$project$UI$Element$invisibleForPrint = $mdgriffith$elm_ui$Element$htmlAttribute(
	$elm$html$Html$Attributes$class('no-print'));
var $author$project$UI$Spacing$largeSize = 20;
var $elm$svg$Svg$animate = $elm$svg$Svg$trustedNode('animate');
var $elm$svg$Svg$Attributes$attributeName = _VirtualDom_attribute('attributeName');
var $elm$svg$Svg$Attributes$dur = _VirtualDom_attribute('dur');
var $elm$svg$Svg$Attributes$repeatCount = _VirtualDom_attribute('repeatCount');
var $elm$svg$Svg$Attributes$values = function (value) {
	return A2(
		_VirtualDom_attribute,
		'values',
		_VirtualDom_noJavaScriptUri(value));
};
var $author$project$Portal$Page$dpgMediaLogo = function (waiting) {
	var ifDancing = function (animation) {
		return A3(
			$author$project$Portal$Waiting$map,
			_List_Nil,
			$elm$core$Basics$always(
				_List_fromArray(
					[animation])),
			waiting);
	};
	return A2(
		$elm$svg$Svg$g,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$rect,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$x('130.581'),
						$elm$svg$Svg$Attributes$y('15.82'),
						$elm$svg$Svg$Attributes$width('4.191'),
						$elm$svg$Svg$Attributes$height('6.893'),
						$elm$svg$Svg$Attributes$fill('#783C96')
					]),
				ifDancing(
					A2(
						$elm$svg$Svg$animate,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$attributeName('y'),
								$elm$svg$Svg$Attributes$values('15.82; 5.001; 15.82'),
								$elm$svg$Svg$Attributes$dur('0.8s'),
								$elm$svg$Svg$Attributes$repeatCount('indefinite')
							]),
						_List_Nil))),
				A2(
				$elm$svg$Svg$rect,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$x('137.353'),
						$elm$svg$Svg$Attributes$y('10.597'),
						$elm$svg$Svg$Attributes$width('4.191'),
						$elm$svg$Svg$Attributes$height('14.696'),
						$elm$svg$Svg$Attributes$fill('#CE0F69')
					]),
				ifDancing(
					A2(
						$elm$svg$Svg$animate,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$attributeName('height'),
								$elm$svg$Svg$Attributes$values('14.696; 6.893; 14.696'),
								$elm$svg$Svg$Attributes$dur('0.9s'),
								$elm$svg$Svg$Attributes$repeatCount('indefinite')
							]),
						_List_Nil))),
				A2(
				$elm$svg$Svg$rect,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$x('144.129'),
						$elm$svg$Svg$Attributes$y('5.001'),
						$elm$svg$Svg$Attributes$width('4.191'),
						$elm$svg$Svg$Attributes$height('17.712'),
						$elm$svg$Svg$Attributes$fill('#E04E39')
					]),
				ifDancing(
					A2(
						$elm$svg$Svg$animate,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$attributeName('height'),
								$elm$svg$Svg$Attributes$values('17.712; 7.3943; 17.712'),
								$elm$svg$Svg$Attributes$dur('0.7s'),
								$elm$svg$Svg$Attributes$repeatCount('indefinite')
							]),
						_List_Nil))),
				A2(
				$elm$svg$Svg$rect,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$x('150.898'),
						$elm$svg$Svg$Attributes$y('10.597'),
						$elm$svg$Svg$Attributes$width('4.191'),
						$elm$svg$Svg$Attributes$height('7.3943'),
						$elm$svg$Svg$Attributes$fill('#FFB81C')
					]),
				ifDancing(
					A2(
						$elm$svg$Svg$animate,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$attributeName('y'),
								$elm$svg$Svg$Attributes$values('10.597; 5.001; 10.597'),
								$elm$svg$Svg$Attributes$dur('1.1s'),
								$elm$svg$Svg$Attributes$repeatCount('indefinite')
							]),
						_List_Nil)))
			]));
};
var $author$project$Portal$Page$dpgMediaPath = function (waiting) {
	var color = A3(
		$author$project$Portal$Waiting$map,
		'inherit',
		$elm$core$Basics$always('#606060'),
		waiting);
	return A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$d('M0 39.975c0-5.415 3.976-7.953 7.433-7.953 1.988 0 3.548.734 4.557 1.804v-8.533h4.19V47.62h-4.19V45.91c-1.009 1.193-2.63 2.018-4.618 2.018-3.243 0-7.372-2.57-7.372-7.952zm12.113-.031c0-2.294-1.621-4.099-3.915-4.099-2.295 0-4.1 1.744-4.1 4.099a4.068 4.068 0 0 0 4.1 4.13c2.294 0 3.915-1.836 3.915-4.13zm10.4 6.179v8.534h-4.191v-22.33h4.19v1.744c.979-1.193 2.508-2.05 4.588-2.05 3.456 0 7.402 2.54 7.402 7.954 0 5.383-4.067 7.952-7.34 7.952-2.05 0-3.671-.673-4.65-1.804zm7.891-6.179c0-2.355-1.744-4.099-4.099-4.099-2.294 0-3.915 1.805-3.915 4.099 0 2.294 1.621 4.13 3.915 4.13 2.355 0 4.1-1.806 4.1-4.13zm5.351.03c0-5.413 3.977-7.952 7.434-7.952 1.988 0 3.547.826 4.557 1.957v-1.651h4.19v15.049c0 4.588-3.395 7.585-7.402 7.585-4.313 0-7.126-2.508-8.014-5.842h4.527c.581 1.224 1.499 1.927 3.487 1.927 1.835 0 3.212-1.56 3.212-3.548v-1.59c-1.01 1.193-2.63 2.018-4.619 2.018-3.242 0-7.372-2.57-7.372-7.952zm12.113-.03c0-2.294-1.621-4.099-3.915-4.099s-4.099 1.744-4.099 4.099a4.068 4.068 0 0 0 4.099 4.13c2.294 0 3.915-1.836 3.915-4.13zM55.75 32.328h2.325v2.08c1.01-1.469 2.691-2.386 4.894-2.386 2.783 0 4.588 1.285 5.444 3.12.98-1.866 2.967-3.12 5.536-3.12 4.405 0 6.822 2.66 6.822 6.607v8.992h-2.386v-9.145c0-2.57-1.683-4.344-4.466-4.344-2.508 0-4.496 1.713-4.496 4.588v8.901h-2.356v-9.42c0-2.448-1.712-4.069-4.282-4.069-2.692 0-4.68 1.805-4.68 4.864v8.625h-2.355V32.328zm27.496 7.769c0-4.588 3.365-8.075 7.923-8.075 4.435 0 7.83 3.059 7.83 7.708v.948H85.51c.245 2.875 2.447 5.139 5.628 5.139 2.57 0 4.374-1.254 5.077-3.334h2.54c-1.102 3.395-3.733 5.444-7.648 5.444-4.802 0-7.86-3.548-7.86-7.83zm2.448-1.56h10.888c-.459-2.784-2.447-4.405-5.413-4.405-2.784 0-4.864 1.836-5.475 4.405zm15.751 1.438c0-4.375 3.274-7.953 7.83-7.953 1.958 0 4.283.948 5.599 2.783v-9.512h2.293V47.62h-2.263v-2.508c-1.315 1.836-3.67 2.814-5.628 2.814-4.496 0-7.83-3.579-7.83-7.952zm13.673 0c0-3.182-2.416-5.812-5.72-5.812-3.12 0-5.567 2.6-5.567 5.812 0 3.211 2.447 5.811 5.567 5.811 3.304 0 5.72-2.6 5.72-5.811zm6.701-14.56c1.101 0 1.897.795 1.897 1.866a1.85 1.85 0 0 1-1.897 1.896c-1.101 0-1.866-.825-1.866-1.896a1.817 1.817 0 0 1 1.866-1.866zm-1.193 6.913h2.386V47.62h-2.386V32.328zm5.104 7.647c0-4.375 3.273-7.953 7.83-7.953 1.958 0 4.314.979 5.629 2.814v-2.508h2.355V47.62h-2.355v-2.508c-1.315 1.836-3.67 2.814-5.628 2.814-4.497 0-7.83-3.579-7.83-7.952zm13.673 0c0-3.182-2.417-5.812-5.72-5.812-3.12 0-5.567 2.6-5.567 5.812 0 3.211 2.447 5.811 5.567 5.811 3.303 0 5.72-2.6 5.72-5.811z'),
				$elm$svg$Svg$Attributes$fill(color)
			]),
		_List_Nil);
};
var $author$project$Portal$Page$logo = function (waiting) {
	return {
		jf: $mdgriffith$elm_ui$Element$html(
			A2(
				$elm$svg$Svg$svg,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$viewBox('0 0 156 60'),
						$elm$svg$Svg$Attributes$height('48px'),
						$elm$svg$Svg$Attributes$preserveAspectRatio('xMidYMid meet')
					]),
				_List_fromArray(
					[
						$author$project$Portal$Page$dpgMediaPath(waiting),
						$author$project$Portal$Page$dpgMediaLogo(waiting)
					]))),
		j6: $mdgriffith$elm_ui$Element$html(
			A2(
				$elm$svg$Svg$svg,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$viewBox('0 0 26 21'),
						$elm$svg$Svg$Attributes$height('21px'),
						$elm$svg$Svg$Attributes$width('26px'),
						$elm$svg$Svg$Attributes$preserveAspectRatio('xMidYMid meet')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$transform('translate(-130 -5)')
							]),
						_List_fromArray(
							[
								$author$project$Portal$Page$dpgMediaLogo(waiting)
							]))
					])))
	};
};
var $author$project$Portal$Page$UserToggledMenu = {$: 1};
var $icidasset$elm_material_icons$Material$Icons$close = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z')
				]),
			_List_Nil)
		]));
var $icidasset$elm_material_icons$Material$Icons$menu = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z')
				]),
			_List_Nil)
		]));
var $author$project$Portal$Page$menuToggleView = F2(
	function (gotMsg, status) {
		var icon = function () {
			if (status.$ === 1) {
				return $icidasset$elm_material_icons$Material$Icons$menu;
			} else {
				return $icidasset$elm_material_icons$Material$Icons$close;
			}
		}();
		return A2(
			$mdgriffith$elm_ui$Element$Input$button,
			_List_Nil,
			{
				mD: A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Font$size(9),
							$mdgriffith$elm_ui$Element$padding(1)
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[$mdgriffith$elm_ui$Element$centerX]),
							$author$project$UI$Element$iconFor(
								icon(24))),
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[$mdgriffith$elm_ui$Element$centerX]),
							$mdgriffith$elm_ui$Element$text('Menu'))
						])),
				jp: $elm$core$Maybe$Just(
					gotMsg($author$project$Portal$Page$UserToggledMenu))
			});
	});
var $mdgriffith$elm_ui$Internal$Model$Below = 1;
var $mdgriffith$elm_ui$Element$below = function (element) {
	return A2($mdgriffith$elm_ui$Element$createNearby, 1, element);
};
var $PaackEng$elm_ui_dropdown$Dropdown$ariaRoleListbox = $mdgriffith$elm_ui$Element$htmlAttribute(
	A2($elm$html$Html$Attributes$attribute, 'role', 'listbox'));
var $PaackEng$elm_ui_dropdown$Dropdown$OnSelect = function (a) {
	return {$: 3, a: a};
};
var $PaackEng$elm_ui_dropdown$Dropdown$ariaRoleOption = $mdgriffith$elm_ui$Element$htmlAttribute(
	A2($elm$html$Html$Attributes$attribute, 'role', 'option'));
var $PaackEng$elm_ui_dropdown$Dropdown$ariaSelected = $mdgriffith$elm_ui$Element$htmlAttribute(
	A2($elm$html$Html$Attributes$attribute, 'aria-selected', 'true'));
var $PaackEng$elm_ui_dropdown$Dropdown$onClick = function (message) {
	return $mdgriffith$elm_ui$Element$Events$onClick(message);
};
var $PaackEng$elm_ui_dropdown$Dropdown$referenceDataName = 'data-dropdown-id';
var $PaackEng$elm_ui_dropdown$Dropdown$referenceAttr = function (model) {
	return $mdgriffith$elm_ui$Element$htmlAttribute(
		A2($elm$html$Html$Attributes$attribute, $PaackEng$elm_ui_dropdown$Dropdown$referenceDataName, model.eg));
};
var $PaackEng$elm_ui_dropdown$Dropdown$tabIndexAttr = function (tabIndex) {
	return $mdgriffith$elm_ui$Element$htmlAttribute(
		$elm$html$Html$Attributes$tabindex(tabIndex));
};
var $PaackEng$elm_ui_dropdown$Dropdown$itemView = F5(
	function (config, selectedItems, state, i, item) {
		var selected = A2($elm$core$List$member, item, selectedItems);
		var itemAttrsBase = _List_fromArray(
			[
				$PaackEng$elm_ui_dropdown$Dropdown$onClick(
				config.lM(
					$PaackEng$elm_ui_dropdown$Dropdown$OnSelect(item))),
				$PaackEng$elm_ui_dropdown$Dropdown$referenceAttr(state),
				$PaackEng$elm_ui_dropdown$Dropdown$tabIndexAttr(-1),
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$PaackEng$elm_ui_dropdown$Dropdown$ariaRoleOption
			]);
		var itemAttrs = selected ? A2($elm$core$List$cons, $PaackEng$elm_ui_dropdown$Dropdown$ariaSelected, itemAttrsBase) : itemAttrsBase;
		var highlighed = _Utils_eq(i, state.br);
		return A2(
			$mdgriffith$elm_ui$Element$el,
			itemAttrs,
			A3(config.mw, selected, highlighed, item));
	});
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $PaackEng$elm_ui_dropdown$Dropdown$bodyView = F4(
	function (config, selectedItems, state, data) {
		if (state.K) {
			var items = ($elm$core$List$length(data) >= 1) ? A2(
				$mdgriffith$elm_ui$Element$column,
				config.bQ,
				A2(
					$elm$core$List$indexedMap,
					A3($PaackEng$elm_ui_dropdown$Dropdown$itemView, config, selectedItems, state),
					data)) : A2($mdgriffith$elm_ui$Element$el, config.bQ, config.cj);
			var body = A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$htmlAttribute(
						A2($elm$html$Html$Attributes$style, 'flex-shrink', '1')),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$PaackEng$elm_ui_dropdown$Dropdown$ariaRoleListbox
					]),
				items);
			return body;
		} else {
			return $mdgriffith$elm_ui$Element$none;
		}
	});
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $PaackEng$elm_ui_dropdown$Dropdown$idAttr = function (id) {
	return $mdgriffith$elm_ui$Element$htmlAttribute(
		$elm$html$Html$Attributes$id(id));
};
var $PaackEng$elm_ui_dropdown$Dropdown$Basic = 0;
var $PaackEng$elm_ui_dropdown$Dropdown$OnClickPrompt = {$: 2};
var $PaackEng$elm_ui_dropdown$Dropdown$OnFilterTyped = function (a) {
	return {$: 4, a: a};
};
var $PaackEng$elm_ui_dropdown$Dropdown$OnKeyDown = function (a) {
	return {$: 5, a: a};
};
var $PaackEng$elm_ui_dropdown$Dropdown$ariaExpanded = $mdgriffith$elm_ui$Element$htmlAttribute(
	A2($elm$html$Html$Attributes$attribute, 'aria-expanded', 'true'));
var $PaackEng$elm_ui_dropdown$Dropdown$ariaHasPopup = $mdgriffith$elm_ui$Element$htmlAttribute(
	A2($elm$html$Html$Attributes$attribute, 'aria-haspopup', 'listbox'));
var $PaackEng$elm_ui_dropdown$Dropdown$ariaRoleButton = $mdgriffith$elm_ui$Element$htmlAttribute(
	A2($elm$html$Html$Attributes$attribute, 'role', 'button'));
var $mdgriffith$elm_ui$Internal$Model$Focus = 0;
var $mdgriffith$elm_ui$Internal$Flag$focus = $mdgriffith$elm_ui$Internal$Flag$flag(31);
var $mdgriffith$elm_ui$Element$focused = function (decs) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$focus,
		A2(
			$mdgriffith$elm_ui$Internal$Model$PseudoSelector,
			0,
			$mdgriffith$elm_ui$Internal$Model$unwrapDecorations(decs)));
};
var $PaackEng$elm_ui_dropdown$Dropdown$OnBlur = {$: 1};
var $PaackEng$elm_ui_dropdown$Dropdown$onBlurAttribute = F2(
	function (config, state) {
		var dataDecoder = A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['relatedTarget', 'attributes', $PaackEng$elm_ui_dropdown$Dropdown$referenceDataName, 'value']),
			$elm$json$Json$Decode$string);
		var attrToMsg = function (maybeAttr) {
			if (!maybeAttr.$) {
				var attr = maybeAttr.a;
				return _Utils_eq(attr, state.eg) ? $elm$json$Json$Decode$fail('') : $elm$json$Json$Decode$succeed(
					config.lM($PaackEng$elm_ui_dropdown$Dropdown$OnBlur));
			} else {
				return $elm$json$Json$Decode$succeed(
					config.lM($PaackEng$elm_ui_dropdown$Dropdown$OnBlur));
			}
		};
		return $mdgriffith$elm_ui$Element$htmlAttribute(
			A2(
				$elm$html$Html$Events$on,
				'blur',
				A2(
					$elm$json$Json$Decode$andThen,
					attrToMsg,
					$elm$json$Json$Decode$maybe(dataDecoder))));
	});
var $PaackEng$elm_ui_dropdown$Dropdown$ArrowDown = 0;
var $PaackEng$elm_ui_dropdown$Dropdown$ArrowUp = 1;
var $PaackEng$elm_ui_dropdown$Dropdown$Enter = 2;
var $PaackEng$elm_ui_dropdown$Dropdown$Esc = 3;
var $PaackEng$elm_ui_dropdown$Dropdown$onKeyDown = function (msg) {
	var stringToKey = function (str) {
		switch (str) {
			case 'ArrowDown':
				return $elm$json$Json$Decode$succeed(0);
			case 'ArrowUp':
				return $elm$json$Json$Decode$succeed(1);
			case 'Enter':
				return $elm$json$Json$Decode$succeed(2);
			case 'Escape':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('not used key');
		}
	};
	var keyDecoder = A2(
		$elm$json$Json$Decode$andThen,
		stringToKey,
		A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
	return $mdgriffith$elm_ui$Element$htmlAttribute(
		A2(
			$elm$html$Html$Events$on,
			'keydown',
			A2($elm$json$Json$Decode$map, msg, keyDecoder)));
};
var $mdgriffith$elm_ui$Element$Input$Placeholder = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Element$Input$placeholder = $mdgriffith$elm_ui$Element$Input$Placeholder;
var $mdgriffith$elm_ui$Element$Input$TextInputNode = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Element$Input$TextArea = {$: 1};
var $mdgriffith$elm_ui$Element$Input$autofill = A2(
	$elm$core$Basics$composeL,
	$mdgriffith$elm_ui$Internal$Model$Attr,
	$elm$html$Html$Attributes$attribute('autocomplete'));
var $mdgriffith$elm_ui$Internal$Model$Behind = 5;
var $mdgriffith$elm_ui$Element$behindContent = function (element) {
	return A2($mdgriffith$elm_ui$Element$createNearby, 5, element);
};
var $mdgriffith$elm_ui$Element$Input$calcMoveToCompensateForPadding = function (attrs) {
	var gatherSpacing = F2(
		function (attr, found) {
			if ((attr.$ === 4) && (attr.b.$ === 5)) {
				var _v2 = attr.b;
				var x = _v2.b;
				var y = _v2.c;
				if (found.$ === 1) {
					return $elm$core$Maybe$Just(y);
				} else {
					return found;
				}
			} else {
				return found;
			}
		});
	var _v0 = A3($elm$core$List$foldr, gatherSpacing, $elm$core$Maybe$Nothing, attrs);
	if (_v0.$ === 1) {
		return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
	} else {
		var vSpace = _v0.a;
		return $mdgriffith$elm_ui$Element$moveUp(
			$elm$core$Basics$floor(vSpace / 2));
	}
};
var $mdgriffith$elm_ui$Element$clip = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$overflow, $mdgriffith$elm_ui$Internal$Style$classes.lg);
var $mdgriffith$elm_ui$Element$Input$darkGrey = A3($mdgriffith$elm_ui$Element$rgb, 186 / 255, 189 / 255, 182 / 255);
var $mdgriffith$elm_ui$Element$Input$defaultTextPadding = A2($mdgriffith$elm_ui$Element$paddingXY, 12, 12);
var $mdgriffith$elm_ui$Element$Input$defaultTextBoxStyle = _List_fromArray(
	[
		$mdgriffith$elm_ui$Element$Input$defaultTextPadding,
		$mdgriffith$elm_ui$Element$Border$rounded(3),
		$mdgriffith$elm_ui$Element$Border$color($mdgriffith$elm_ui$Element$Input$darkGrey),
		$mdgriffith$elm_ui$Element$Background$color($mdgriffith$elm_ui$Element$Input$white),
		$mdgriffith$elm_ui$Element$Border$width(1),
		$mdgriffith$elm_ui$Element$spacing(5),
		$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
		$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink)
	]);
var $mdgriffith$elm_ui$Element$Input$getHeight = function (attr) {
	if (attr.$ === 8) {
		var h = attr.a;
		return $elm$core$Maybe$Just(h);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $mdgriffith$elm_ui$Element$Input$isConstrained = function (len) {
	isConstrained:
	while (true) {
		switch (len.$) {
			case 1:
				return false;
			case 0:
				return true;
			case 2:
				return true;
			case 3:
				var l = len.b;
				var $temp$len = l;
				len = $temp$len;
				continue isConstrained;
			default:
				var l = len.b;
				return true;
		}
	}
};
var $mdgriffith$elm_ui$Element$Input$isStacked = function (label) {
	if (!label.$) {
		var loc = label.a;
		switch (loc) {
			case 0:
				return false;
			case 1:
				return false;
			case 2:
				return true;
			default:
				return true;
		}
	} else {
		return true;
	}
};
var $mdgriffith$elm_ui$Element$Input$negateBox = function (box) {
	return {k5: -box.k5, mE: -box.mE, nx: -box.nx, ol: -box.ol};
};
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $mdgriffith$elm_ui$Element$Input$isFill = function (len) {
	isFill:
	while (true) {
		switch (len.$) {
			case 2:
				return true;
			case 1:
				return false;
			case 0:
				return false;
			case 3:
				var l = len.b;
				var $temp$len = l;
				len = $temp$len;
				continue isFill;
			default:
				var l = len.b;
				var $temp$len = l;
				len = $temp$len;
				continue isFill;
		}
	}
};
var $mdgriffith$elm_ui$Element$Input$isPixel = function (len) {
	isPixel:
	while (true) {
		switch (len.$) {
			case 1:
				return false;
			case 0:
				return true;
			case 2:
				return false;
			case 3:
				var l = len.b;
				var $temp$len = l;
				len = $temp$len;
				continue isPixel;
			default:
				var l = len.b;
				var $temp$len = l;
				len = $temp$len;
				continue isPixel;
		}
	}
};
var $mdgriffith$elm_ui$Internal$Model$paddingNameFloat = F4(
	function (top, right, bottom, left) {
		return 'pad-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(top) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(right) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(bottom) + ('-' + $mdgriffith$elm_ui$Internal$Model$floatClass(left)))))));
	});
var $mdgriffith$elm_ui$Element$Input$redistributeOver = F4(
	function (isMultiline, stacked, attr, els) {
		switch (attr.$) {
			case 9:
				return _Utils_update(
					els,
					{
						f: A2($elm$core$List$cons, attr, els.f)
					});
			case 7:
				var width = attr.a;
				return $mdgriffith$elm_ui$Element$Input$isFill(width) ? _Utils_update(
					els,
					{
						q: A2($elm$core$List$cons, attr, els.q),
						Q: A2($elm$core$List$cons, attr, els.Q),
						f: A2($elm$core$List$cons, attr, els.f)
					}) : (stacked ? _Utils_update(
					els,
					{
						q: A2($elm$core$List$cons, attr, els.q)
					}) : _Utils_update(
					els,
					{
						f: A2($elm$core$List$cons, attr, els.f)
					}));
			case 8:
				var height = attr.a;
				return (!stacked) ? _Utils_update(
					els,
					{
						q: A2($elm$core$List$cons, attr, els.q),
						f: A2($elm$core$List$cons, attr, els.f)
					}) : ($mdgriffith$elm_ui$Element$Input$isFill(height) ? _Utils_update(
					els,
					{
						q: A2($elm$core$List$cons, attr, els.q),
						f: A2($elm$core$List$cons, attr, els.f)
					}) : ($mdgriffith$elm_ui$Element$Input$isPixel(height) ? _Utils_update(
					els,
					{
						f: A2($elm$core$List$cons, attr, els.f)
					}) : _Utils_update(
					els,
					{
						f: A2($elm$core$List$cons, attr, els.f)
					})));
			case 6:
				return _Utils_update(
					els,
					{
						q: A2($elm$core$List$cons, attr, els.q)
					});
			case 5:
				return _Utils_update(
					els,
					{
						q: A2($elm$core$List$cons, attr, els.q)
					});
			case 4:
				switch (attr.b.$) {
					case 5:
						var _v1 = attr.b;
						return _Utils_update(
							els,
							{
								q: A2($elm$core$List$cons, attr, els.q),
								Q: A2($elm$core$List$cons, attr, els.Q),
								f: A2($elm$core$List$cons, attr, els.f),
								dL: A2($elm$core$List$cons, attr, els.dL)
							});
					case 7:
						var cls = attr.a;
						var _v2 = attr.b;
						var pad = _v2.a;
						var t = _v2.b;
						var r = _v2.c;
						var b = _v2.d;
						var l = _v2.e;
						if (isMultiline) {
							return _Utils_update(
								els,
								{
									aq: A2($elm$core$List$cons, attr, els.aq),
									f: A2($elm$core$List$cons, attr, els.f)
								});
						} else {
							var newTop = t - A2($elm$core$Basics$min, t, b);
							var newLineHeight = $mdgriffith$elm_ui$Element$htmlAttribute(
								A2(
									$elm$html$Html$Attributes$style,
									'line-height',
									'calc(1.0em + ' + ($elm$core$String$fromFloat(
										2 * A2($elm$core$Basics$min, t, b)) + 'px)')));
							var newHeight = $mdgriffith$elm_ui$Element$htmlAttribute(
								A2(
									$elm$html$Html$Attributes$style,
									'height',
									'calc(1.0em + ' + ($elm$core$String$fromFloat(
										2 * A2($elm$core$Basics$min, t, b)) + 'px)')));
							var newBottom = b - A2($elm$core$Basics$min, t, b);
							var reducedVerticalPadding = A2(
								$mdgriffith$elm_ui$Internal$Model$StyleClass,
								$mdgriffith$elm_ui$Internal$Flag$padding,
								A5(
									$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
									A4($mdgriffith$elm_ui$Internal$Model$paddingNameFloat, newTop, r, newBottom, l),
									newTop,
									r,
									newBottom,
									l));
							return _Utils_update(
								els,
								{
									aq: A2($elm$core$List$cons, attr, els.aq),
									Q: A2(
										$elm$core$List$cons,
										newHeight,
										A2($elm$core$List$cons, newLineHeight, els.Q)),
									f: A2($elm$core$List$cons, reducedVerticalPadding, els.f)
								});
						}
					case 6:
						var _v3 = attr.b;
						return _Utils_update(
							els,
							{
								aq: A2($elm$core$List$cons, attr, els.aq),
								f: A2($elm$core$List$cons, attr, els.f)
							});
					case 10:
						return _Utils_update(
							els,
							{
								aq: A2($elm$core$List$cons, attr, els.aq),
								f: A2($elm$core$List$cons, attr, els.f)
							});
					case 2:
						return _Utils_update(
							els,
							{
								q: A2($elm$core$List$cons, attr, els.q)
							});
					case 1:
						var _v4 = attr.b;
						return _Utils_update(
							els,
							{
								q: A2($elm$core$List$cons, attr, els.q)
							});
					default:
						var flag = attr.a;
						var cls = attr.b;
						return _Utils_update(
							els,
							{
								f: A2($elm$core$List$cons, attr, els.f)
							});
				}
			case 0:
				return els;
			case 1:
				var a = attr.a;
				return _Utils_update(
					els,
					{
						Q: A2($elm$core$List$cons, attr, els.Q)
					});
			case 2:
				return _Utils_update(
					els,
					{
						Q: A2($elm$core$List$cons, attr, els.Q)
					});
			case 3:
				return _Utils_update(
					els,
					{
						f: A2($elm$core$List$cons, attr, els.f)
					});
			default:
				return _Utils_update(
					els,
					{
						Q: A2($elm$core$List$cons, attr, els.Q)
					});
		}
	});
var $mdgriffith$elm_ui$Element$Input$redistribute = F3(
	function (isMultiline, stacked, attrs) {
		return function (redist) {
			return {
				aq: $elm$core$List$reverse(redist.aq),
				q: $elm$core$List$reverse(redist.q),
				Q: $elm$core$List$reverse(redist.Q),
				f: $elm$core$List$reverse(redist.f),
				dL: $elm$core$List$reverse(redist.dL)
			};
		}(
			A3(
				$elm$core$List$foldl,
				A2($mdgriffith$elm_ui$Element$Input$redistributeOver, isMultiline, stacked),
				{aq: _List_Nil, q: _List_Nil, Q: _List_Nil, f: _List_Nil, dL: _List_Nil},
				attrs));
	});
var $mdgriffith$elm_ui$Element$Input$renderBox = function (_v0) {
	var top = _v0.ol;
	var right = _v0.nx;
	var bottom = _v0.k5;
	var left = _v0.mE;
	return $elm$core$String$fromInt(top) + ('px ' + ($elm$core$String$fromInt(right) + ('px ' + ($elm$core$String$fromInt(bottom) + ('px ' + ($elm$core$String$fromInt(left) + 'px'))))));
};
var $mdgriffith$elm_ui$Element$alpha = function (o) {
	var transparency = function (x) {
		return 1 - x;
	}(
		A2(
			$elm$core$Basics$min,
			1.0,
			A2($elm$core$Basics$max, 0.0, o)));
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$transparency,
		A2(
			$mdgriffith$elm_ui$Internal$Model$Transparency,
			'transparency-' + $mdgriffith$elm_ui$Internal$Model$floatClass(transparency),
			transparency));
};
var $mdgriffith$elm_ui$Element$Input$charcoal = A3($mdgriffith$elm_ui$Element$rgb, 136 / 255, 138 / 255, 133 / 255);
var $mdgriffith$elm_ui$Element$Input$renderPlaceholder = F3(
	function (_v0, forPlaceholder, on) {
		var placeholderAttrs = _v0.a;
		var placeholderEl = _v0.b;
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_Utils_ap(
				forPlaceholder,
				_Utils_ap(
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Font$color($mdgriffith$elm_ui$Element$Input$charcoal),
							$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.jm + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.nd)),
							$mdgriffith$elm_ui$Element$clip,
							$mdgriffith$elm_ui$Element$Border$color(
							A4($mdgriffith$elm_ui$Element$rgba, 0, 0, 0, 0)),
							$mdgriffith$elm_ui$Element$Background$color(
							A4($mdgriffith$elm_ui$Element$rgba, 0, 0, 0, 0)),
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$alpha(
							on ? 1 : 0)
						]),
					placeholderAttrs)),
			placeholderEl);
	});
var $elm$html$Html$span = _VirtualDom_node('span');
var $elm$html$Html$Attributes$spellcheck = $elm$html$Html$Attributes$boolProperty('spellcheck');
var $mdgriffith$elm_ui$Element$Input$spellcheck = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Attributes$spellcheck);
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $mdgriffith$elm_ui$Element$Input$value = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Attributes$value);
var $mdgriffith$elm_ui$Element$Input$textHelper = F3(
	function (textInput, attrs, textOptions) {
		var withDefaults = _Utils_ap($mdgriffith$elm_ui$Element$Input$defaultTextBoxStyle, attrs);
		var redistributed = A3(
			$mdgriffith$elm_ui$Element$Input$redistribute,
			_Utils_eq(textInput.af, $mdgriffith$elm_ui$Element$Input$TextArea),
			$mdgriffith$elm_ui$Element$Input$isStacked(textOptions.mD),
			withDefaults);
		var onlySpacing = function (attr) {
			if ((attr.$ === 4) && (attr.b.$ === 5)) {
				var _v9 = attr.b;
				return true;
			} else {
				return false;
			}
		};
		var heightConstrained = function () {
			var _v7 = textInput.af;
			if (!_v7.$) {
				var inputType = _v7.a;
				return false;
			} else {
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$mdgriffith$elm_ui$Element$Input$isConstrained,
						$elm$core$List$head(
							$elm$core$List$reverse(
								A2($elm$core$List$filterMap, $mdgriffith$elm_ui$Element$Input$getHeight, withDefaults)))));
			}
		}();
		var getPadding = function (attr) {
			if ((attr.$ === 4) && (attr.b.$ === 7)) {
				var cls = attr.a;
				var _v6 = attr.b;
				var pad = _v6.a;
				var t = _v6.b;
				var r = _v6.c;
				var b = _v6.d;
				var l = _v6.e;
				return $elm$core$Maybe$Just(
					{
						k5: A2(
							$elm$core$Basics$max,
							0,
							$elm$core$Basics$floor(b - 3)),
						mE: A2(
							$elm$core$Basics$max,
							0,
							$elm$core$Basics$floor(l - 3)),
						nx: A2(
							$elm$core$Basics$max,
							0,
							$elm$core$Basics$floor(r - 3)),
						ol: A2(
							$elm$core$Basics$max,
							0,
							$elm$core$Basics$floor(t - 3))
					});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		var parentPadding = A2(
			$elm$core$Maybe$withDefault,
			{k5: 0, mE: 0, nx: 0, ol: 0},
			$elm$core$List$head(
				$elm$core$List$reverse(
					A2($elm$core$List$filterMap, getPadding, withDefaults))));
		var inputElement = A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			function () {
				var _v3 = textInput.af;
				if (!_v3.$) {
					var inputType = _v3.a;
					return $mdgriffith$elm_ui$Internal$Model$NodeName('input');
				} else {
					return $mdgriffith$elm_ui$Internal$Model$NodeName('textarea');
				}
			}(),
			_Utils_ap(
				function () {
					var _v4 = textInput.af;
					if (!_v4.$) {
						var inputType = _v4.a;
						return _List_fromArray(
							[
								$mdgriffith$elm_ui$Internal$Model$Attr(
								$elm$html$Html$Attributes$type_(inputType)),
								$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.mr)
							]);
					} else {
						return _List_fromArray(
							[
								$mdgriffith$elm_ui$Element$clip,
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.mn),
								$mdgriffith$elm_ui$Element$Input$calcMoveToCompensateForPadding(withDefaults),
								$mdgriffith$elm_ui$Element$paddingEach(parentPadding),
								$mdgriffith$elm_ui$Internal$Model$Attr(
								A2(
									$elm$html$Html$Attributes$style,
									'margin',
									$mdgriffith$elm_ui$Element$Input$renderBox(
										$mdgriffith$elm_ui$Element$Input$negateBox(parentPadding)))),
								$mdgriffith$elm_ui$Internal$Model$Attr(
								A2($elm$html$Html$Attributes$style, 'box-sizing', 'content-box'))
							]);
					}
				}(),
				_Utils_ap(
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Input$value(textOptions.n3),
							$mdgriffith$elm_ui$Internal$Model$Attr(
							$elm$html$Html$Events$onInput(textOptions.mY)),
							$mdgriffith$elm_ui$Element$Input$hiddenLabelAttribute(textOptions.mD),
							$mdgriffith$elm_ui$Element$Input$spellcheck(textInput.be),
							A2(
							$elm$core$Maybe$withDefault,
							$mdgriffith$elm_ui$Internal$Model$NoAttribute,
							A2($elm$core$Maybe$map, $mdgriffith$elm_ui$Element$Input$autofill, textInput.a_))
						]),
					redistributed.Q)),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_Nil));
		var wrappedInput = function () {
			var _v0 = textInput.af;
			if (_v0.$ === 1) {
				return A4(
					$mdgriffith$elm_ui$Internal$Model$element,
					$mdgriffith$elm_ui$Internal$Model$asEl,
					$mdgriffith$elm_ui$Internal$Model$div,
					_Utils_ap(
						(heightConstrained ? $elm$core$List$cons($mdgriffith$elm_ui$Element$scrollbarY) : $elm$core$Basics$identity)(
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									A2($elm$core$List$any, $mdgriffith$elm_ui$Element$Input$hasFocusStyle, withDefaults) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.iE),
									$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.mq)
								])),
						redistributed.f),
					$mdgriffith$elm_ui$Internal$Model$Unkeyed(
						_List_fromArray(
							[
								A4(
								$mdgriffith$elm_ui$Internal$Model$element,
								$mdgriffith$elm_ui$Internal$Model$asParagraph,
								$mdgriffith$elm_ui$Internal$Model$div,
								A2(
									$elm$core$List$cons,
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									A2(
										$elm$core$List$cons,
										$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
										A2(
											$elm$core$List$cons,
											$mdgriffith$elm_ui$Element$inFront(inputElement),
											A2(
												$elm$core$List$cons,
												$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.mp),
												redistributed.dL)))),
								$mdgriffith$elm_ui$Internal$Model$Unkeyed(
									function () {
										if (textOptions.n3 === '') {
											var _v1 = textOptions.ng;
											if (_v1.$ === 1) {
												return _List_fromArray(
													[
														$mdgriffith$elm_ui$Element$text('\u00A0')
													]);
											} else {
												var place = _v1.a;
												return _List_fromArray(
													[
														A3($mdgriffith$elm_ui$Element$Input$renderPlaceholder, place, _List_Nil, textOptions.n3 === '')
													]);
											}
										} else {
											return _List_fromArray(
												[
													$mdgriffith$elm_ui$Internal$Model$unstyled(
													A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class($mdgriffith$elm_ui$Internal$Style$classes.mo)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(textOptions.n3 + '\u00A0')
															])))
												]);
										}
									}()))
							])));
			} else {
				var inputType = _v0.a;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$element,
					$mdgriffith$elm_ui$Internal$Model$asEl,
					$mdgriffith$elm_ui$Internal$Model$div,
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						A2(
							$elm$core$List$cons,
							A2($elm$core$List$any, $mdgriffith$elm_ui$Element$Input$hasFocusStyle, withDefaults) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.iE),
							$elm$core$List$concat(
								_List_fromArray(
									[
										redistributed.f,
										function () {
										var _v2 = textOptions.ng;
										if (_v2.$ === 1) {
											return _List_Nil;
										} else {
											var place = _v2.a;
											return _List_fromArray(
												[
													$mdgriffith$elm_ui$Element$behindContent(
													A3($mdgriffith$elm_ui$Element$Input$renderPlaceholder, place, redistributed.aq, textOptions.n3 === ''))
												]);
										}
									}()
									])))),
					$mdgriffith$elm_ui$Internal$Model$Unkeyed(
						_List_fromArray(
							[inputElement])));
			}
		}();
		return A3(
			$mdgriffith$elm_ui$Element$Input$applyLabel,
			A2(
				$elm$core$List$cons,
				A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$cursor, $mdgriffith$elm_ui$Internal$Style$classes.lw),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$Input$isHiddenLabel(textOptions.mD) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Element$spacing(5),
					A2($elm$core$List$cons, $mdgriffith$elm_ui$Element$Region$announce, redistributed.q))),
			textOptions.mD,
			wrappedInput);
	});
var $mdgriffith$elm_ui$Element$Input$search = $mdgriffith$elm_ui$Element$Input$textHelper(
	{
		a_: $elm$core$Maybe$Nothing,
		be: false,
		af: $mdgriffith$elm_ui$Element$Input$TextInputNode('search')
	});
var $PaackEng$elm_ui_dropdown$Dropdown$triggerView = F3(
	function (config, selectedItems, state) {
		var selectAttrs = A2(
			$elm$core$List$cons,
			$PaackEng$elm_ui_dropdown$Dropdown$onClick(
				config.lM($PaackEng$elm_ui_dropdown$Dropdown$OnClickPrompt)),
			A2(
				$elm$core$List$cons,
				$PaackEng$elm_ui_dropdown$Dropdown$onKeyDown(
					A2($elm$core$Basics$composeL, config.lM, $PaackEng$elm_ui_dropdown$Dropdown$OnKeyDown)),
				A2(
					$elm$core$List$cons,
					$PaackEng$elm_ui_dropdown$Dropdown$tabIndexAttr(0),
					A2(
						$elm$core$List$cons,
						$PaackEng$elm_ui_dropdown$Dropdown$ariaHasPopup,
						A2(
							$elm$core$List$cons,
							$PaackEng$elm_ui_dropdown$Dropdown$ariaRoleButton,
							A2(
								$elm$core$List$cons,
								$PaackEng$elm_ui_dropdown$Dropdown$referenceAttr(state),
								_Utils_ap(
									(!config.aI) ? _List_fromArray(
										[
											A2($PaackEng$elm_ui_dropdown$Dropdown$onBlurAttribute, config, state)
										]) : _List_Nil,
									_Utils_ap(
										state.K ? _List_fromArray(
											[$PaackEng$elm_ui_dropdown$Dropdown$ariaExpanded]) : _List_Nil,
										config.cD))))))));
		var searchInput = A2(
			$mdgriffith$elm_ui$Element$Input$search,
			A2(
				$elm$core$List$cons,
				$PaackEng$elm_ui_dropdown$Dropdown$idAttr(state.eg + 'input-search'),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$focused(_List_Nil),
					A2(
						$elm$core$List$cons,
						A2($PaackEng$elm_ui_dropdown$Dropdown$onBlurAttribute, config, state),
						config.cB))),
			{
				mD: $mdgriffith$elm_ui$Element$Input$labelHidden('Filter List'),
				mY: A2($elm$core$Basics$composeL, config.lM, $PaackEng$elm_ui_dropdown$Dropdown$OnFilterTyped),
				ng: A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$mdgriffith$elm_ui$Element$text,
						$mdgriffith$elm_ui$Element$Input$placeholder(_List_Nil)),
					config.cm),
				n3: state.fb
			});
		var prompt = A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			function () {
				if (!selectedItems.b) {
					return config.b$;
				} else {
					var xs = selectedItems;
					var _v3 = config.dA;
					if (!_v3.$) {
						var f = _v3.a;
						var _v4 = $elm$core$List$head(xs);
						if (_v4.$ === 1) {
							return config.b$;
						} else {
							var x = _v4.a;
							return f(x);
						}
					} else {
						var f = _v3.a;
						return f(xs);
					}
				}
			}());
		var search = function () {
			var _v1 = config.aI;
			switch (_v1) {
				case 0:
					return prompt;
				case 2:
					return prompt;
				case 1:
					return searchInput;
				default:
					return searchInput;
			}
		}();
		var _v0 = state.K ? _Utils_Tuple2(
			search,
			A2($mdgriffith$elm_ui$Element$el, _List_Nil, config.lj)) : _Utils_Tuple2(
			prompt,
			A2($mdgriffith$elm_ui$Element$el, _List_Nil, config.m6));
		var promptOrSearch = _v0.a;
		var button = _v0.b;
		return A2(
			$mdgriffith$elm_ui$Element$row,
			selectAttrs,
			_List_fromArray(
				[promptOrSearch, button]));
	});
var $PaackEng$elm_ui_dropdown$Dropdown$view = F3(
	function (_v0, model, _v1) {
		var config = _v0;
		var state = _v1;
		var selectedItems = A2($PaackEng$elm_ui_dropdown$Dropdown$selectedItemsAsList, config, model);
		var trigger = A3($PaackEng$elm_ui_dropdown$Dropdown$triggerView, config, selectedItems, state);
		var items = config.mA(model);
		var filter = function (item) {
			return A2(
				$elm$core$String$contains,
				$elm$core$String$toLower(state.fb),
				$elm$core$String$toLower(
					config.my(item)));
		};
		var filteredData = A2($elm$core$List$filter, filter, items);
		var data = function () {
			var _v2 = config.aI;
			switch (_v2) {
				case 3:
					return items;
				case 1:
					return filteredData;
				case 0:
					return items;
				default:
					return items;
			}
		}();
		var body = A4($PaackEng$elm_ui_dropdown$Dropdown$bodyView, config, selectedItems, state, data);
		var containerAttrs = A2(
			$elm$core$List$cons,
			$PaackEng$elm_ui_dropdown$Dropdown$idAttr(state.eg),
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$below(body),
				config.ce));
		return A2(
			$mdgriffith$elm_ui$Element$column,
			containerAttrs,
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					trigger)
				]));
	});
var $author$project$Portal$Page$headerView = F4(
	function (gotMsg, responsive, share, model) {
		var menuStatus = model.ai;
		var distributionPointsState = model.d2;
		var distributionPoints = model.A;
		var whenAtLeastOneDp = function (dpsEl) {
			if (distributionPoints.$ === 1) {
				var dpDict = distributionPoints.a;
				return $author$project$DistributionPoint$IdDict$isEmpty(dpDict) ? $mdgriffith$elm_ui$Element$none : dpsEl;
			} else {
				return $mdgriffith$elm_ui$Element$none;
			}
		};
		var spaceWidth = $author$project$UI$Spacing$largeSize;
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_Utils_ap(
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$height(
						$mdgriffith$elm_ui$Element$px($author$project$Portal$Page$headerHeight)),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$author$project$UI$Element$invisibleForPrint,
						A2($mdgriffith$elm_ui$Element$paddingXY, spaceWidth, 0),
						$mdgriffith$elm_ui$Element$spacing(spaceWidth)
					]),
				$author$project$UI$Element$colors(
					$author$project$Portal$Page$headerColorFor(
						$author$project$Portal$Share$environment(share)))),
			_List_fromArray(
				[
					A2($author$project$Portal$Page$menuToggleView, gotMsg, menuStatus),
					whenAtLeastOneDp(
					A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[$mdgriffith$elm_ui$Element$alignLeft]),
						A2(
							$mdgriffith$elm_ui$Element$map,
							gotMsg,
							A2(
								responsive.gq,
								{i5: 26, jg: 40, j9: spaceWidth},
								function (w) {
									return A3(
										$PaackEng$elm_ui_dropdown$Dropdown$view,
										$author$project$Portal$Page$distributionPointsConfig(w),
										_Utils_Tuple2(share, model),
										distributionPointsState);
								})))),
					A2(
					$mdgriffith$elm_ui$Element$Input$button,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$alignRight]),
					{
						mD: responsive.gP(
							$author$project$Portal$Page$logo(
								$author$project$Portal$Share$waitingStatus(share))),
						jp: $elm$core$Maybe$Just(
							gotMsg(
								$author$project$Portal$Page$UserClickedMenuItem(0)))
					})
				]));
	});
var $author$project$Portal$Page$menuColors = {kV: $author$project$UI$Palette$base03, k0: $author$project$UI$Palette$base03, lZ: $author$project$UI$Palette$base0};
var $author$project$Portal$Page$AccountManager = 9;
var $author$project$Portal$Page$Count = 4;
var $author$project$Portal$Page$Delay = 3;
var $author$project$Portal$Page$Documents = 8;
var $author$project$Portal$Page$ListNonFinal = 7;
var $author$project$Portal$Page$Messages = 6;
var $author$project$Portal$Page$Planning = 2;
var $author$project$Portal$Page$menuItemFor = function (route) {
	switch (route.$) {
		case 0:
			return $elm$core$Maybe$Just(0);
		case 3:
			return $elm$core$Maybe$Just(2);
		case 4:
			return $elm$core$Maybe$Just(2);
		case 15:
			return $elm$core$Maybe$Just(4);
		case 16:
			return $elm$core$Maybe$Just(3);
		case 23:
			return $elm$core$Maybe$Just(6);
		case 5:
			return $elm$core$Maybe$Just(7);
		case 19:
			return $elm$core$Maybe$Just(8);
		case 20:
			return $elm$core$Maybe$Just(9);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Portal$Page$UserClickedLogout = {$: 7};
var $author$project$Portal$Page$UsersMouseIsNoLongerOverMenuItem = {$: 6};
var $author$project$Portal$Page$UsersMouseIsOverMenuItem = function (a) {
	return {$: 5, a: a};
};
var $author$project$UI$Caption$Caption = $elm$core$Basics$identity;
var $author$project$UI$Caption$caption = function (label) {
	return {mD: label};
};
var $avh4$elm_color$Color$scaleFrom255 = function (c) {
	return c / 255;
};
var $avh4$elm_color$Color$rgb255 = F3(
	function (r, g, b) {
		return A4(
			$avh4$elm_color$Color$RgbaSpace,
			$avh4$elm_color$Color$scaleFrom255(r),
			$avh4$elm_color$Color$scaleFrom255(g),
			$avh4$elm_color$Color$scaleFrom255(b),
			1.0);
	});
var $author$project$UI$Element$coloredIconFor = F2(
	function (icon, color) {
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$paddingEach(
					{k5: 2, mE: 0, nx: 0, ol: 0})
				]),
			$mdgriffith$elm_ui$Element$html(
				icon(
					$icidasset$elm_material_icons$Material$Icons$Types$Color(
						function (_v0) {
							var r = _v0.a;
							var g = _v0.b;
							var b = _v0.c;
							return A3(
								$avh4$elm_color$Color$rgb255,
								$elm$core$Basics$round(r),
								$elm$core$Basics$round(g),
								$elm$core$Basics$round(b));
						}(
							$tesk9$palette$SolidColor$toRGB(color))))));
	});
var $author$project$UI$Caption$colors = {kV: $author$project$UI$Palette$base02, k0: $author$project$UI$Palette$base03, lZ: $author$project$UI$Palette$base2};
var $author$project$UI$Caption$elementFor = function (_v0) {
	var label = _v0.mD;
	return A2(
		$mdgriffith$elm_ui$Element$el,
		_Utils_ap(
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Border$rounded(3),
					$mdgriffith$elm_ui$Element$Border$width(1),
					$mdgriffith$elm_ui$Element$padding(11)
				]),
			$author$project$UI$Element$colors($author$project$UI$Caption$colors)),
		$mdgriffith$elm_ui$Element$text(label));
};
var $author$project$UI$Palette$magenta = $tesk9$palette$SolidColor$fromRGB(
	_Utils_Tuple3(206, 15, 105));
var $author$project$Portal$Page$menuItemColors = {
	bt: {kV: $author$project$UI$Palette$base02, k0: $author$project$UI$Palette$base02, lZ: $author$project$UI$Palette$base2},
	nI: {kV: $author$project$UI$Palette$base03, k0: $author$project$UI$Palette$magenta, lZ: $author$project$UI$Palette$base2},
	fZ: {kV: $author$project$UI$Palette$base03, k0: $author$project$UI$Palette$base03, lZ: $author$project$UI$Palette$base0}
};
var $author$project$Portal$Page$menuItemIconColor = {nI: $author$project$UI$Palette$magenta, fZ: $author$project$UI$Palette$base0};
var $mdgriffith$elm_ui$Element$moveDown = function (y) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$TransformComponent,
		$mdgriffith$elm_ui$Internal$Flag$moveY,
		$mdgriffith$elm_ui$Internal$Model$MoveY(y));
};
var $mdgriffith$elm_ui$Internal$Model$MoveX = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$moveX = $mdgriffith$elm_ui$Internal$Flag$flag(25);
var $mdgriffith$elm_ui$Element$moveRight = function (x) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$TransformComponent,
		$mdgriffith$elm_ui$Internal$Flag$moveX,
		$mdgriffith$elm_ui$Internal$Model$MoveX(x));
};
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $elm$html$Html$Attributes$rel = _VirtualDom_attribute('rel');
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $mdgriffith$elm_ui$Element$newTabLink = F2(
	function (attrs, _v0) {
		var url = _v0.aW;
		var label = _v0.mD;
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			$mdgriffith$elm_ui$Internal$Model$NodeName('a'),
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$Attr(
					$elm$html$Html$Attributes$href(url)),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Internal$Model$Attr(
						$elm$html$Html$Attributes$rel('noopener noreferrer')),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Internal$Model$Attr(
							$elm$html$Html$Attributes$target('_blank')),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
								A2(
									$elm$core$List$cons,
									$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.eZ + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.bI + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.i1)))),
									attrs)))))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(
				_List_fromArray(
					[label])));
	});
var $mdgriffith$elm_ui$Element$Events$onMouseEnter = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Events$onMouseEnter);
var $mdgriffith$elm_ui$Element$Events$onMouseLeave = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Events$onMouseLeave);
var $mdgriffith$elm_ui$Internal$Model$OnRight = 2;
var $mdgriffith$elm_ui$Element$onRight = function (element) {
	return A2($mdgriffith$elm_ui$Element$createNearby, 2, element);
};
var $author$project$Portal$Page$menuItemView = F3(
	function (status, selectedMenuItemId, _v0) {
		var icon = _v0.mg;
		var label = _v0.mD;
		var id = _v0.eg;
		var effect = _v0.i;
		var element = F2(
			function (attrs, l) {
				switch (effect.$) {
					case 0:
						return A2(
							$mdgriffith$elm_ui$Element$Input$button,
							attrs,
							{
								mD: l,
								jp: $elm$core$Maybe$Just(
									$author$project$Portal$Page$UserClickedMenuItem(id))
							});
					case 1:
						var url = effect.a;
						return A2(
							$mdgriffith$elm_ui$Element$newTabLink,
							attrs,
							{mD: l, aW: url});
					default:
						return A2(
							$mdgriffith$elm_ui$Element$Input$button,
							attrs,
							{
								mD: l,
								jp: $elm$core$Maybe$Just($author$project$Portal$Page$UserClickedLogout)
							});
				}
			});
		var caption = _Utils_eq(
			status,
			$author$project$Portal$Page$Folded(
				{
					bt: $elm$core$Maybe$Just(id)
				})) ? $elm$core$Maybe$Just(
			$mdgriffith$elm_ui$Element$onRight(
				A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$moveDown(7),
							$mdgriffith$elm_ui$Element$moveRight(7)
						]),
					$author$project$UI$Caption$elementFor(
						$author$project$UI$Caption$caption(label))))) : $elm$core$Maybe$Nothing;
		var _v1 = _Utils_eq(
			selectedMenuItemId,
			$elm$core$Maybe$Just(id)) ? _Utils_Tuple2($author$project$Portal$Page$menuItemColors.nI, $author$project$Portal$Page$menuItemIconColor.nI) : _Utils_Tuple2($author$project$Portal$Page$menuItemColors.fZ, $author$project$Portal$Page$menuItemIconColor.fZ);
		var itemColors = _v1.a;
		var iconColor = _v1.b;
		return A2(
			element,
			A2(
				$author$project$UI$Util$maybeCons,
				caption,
				_Utils_ap(
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$Border$widthEach(
							{k5: 0, mE: 3, nx: 0, ol: 0}),
							$mdgriffith$elm_ui$Element$mouseOver(
							$author$project$UI$Element$colors($author$project$Portal$Page$menuItemColors.bt)),
							$mdgriffith$elm_ui$Element$Events$onMouseEnter(
							$author$project$Portal$Page$UsersMouseIsOverMenuItem(id)),
							$mdgriffith$elm_ui$Element$Events$onMouseLeave($author$project$Portal$Page$UsersMouseIsNoLongerOverMenuItem)
						]),
					$author$project$UI$Element$colors(itemColors))),
			A2(
				$mdgriffith$elm_ui$Element$row,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$spacing(12),
						A2($mdgriffith$elm_ui$Element$paddingXY, 20, 15),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$UI$Element$coloredIconFor,
						icon(24),
						iconColor),
						function () {
						if (status.$ === 1) {
							return $mdgriffith$elm_ui$Element$none;
						} else {
							return $mdgriffith$elm_ui$Element$text(label);
						}
					}()
					])));
	});
var $author$project$Portal$Page$Applicants = 5;
var $author$project$Portal$Page$Brincr = 19;
var $author$project$Portal$Page$ClosingCalendar = 22;
var $author$project$Portal$Page$CompensationValidate = 12;
var $author$project$Portal$Page$Compensations = 11;
var $author$project$Portal$Page$ComplaintFeedback = 21;
var $author$project$Portal$Page$DelivererRouteDetail = 10;
var $author$project$Portal$Page$DistributorValidate = 23;
var $author$project$Portal$Page$Embrace = 16;
var $author$project$Portal$Page$EmbraceDashboard = 18;
var $author$project$Portal$Page$Logout = 25;
var $author$project$Portal$Page$LogoutEffect = {$: 2};
var $author$project$Portal$Page$NewTab = function (a) {
	return {$: 1, a: a};
};
var $author$project$Portal$Page$PaymentsArchive = 15;
var $author$project$Portal$Page$PaymentsOverviewBySegment = 14;
var $author$project$Portal$Page$PaymentsSummaryOverview = 13;
var $author$project$Portal$Page$Publications = 1;
var $author$project$Portal$Page$Report = 24;
var $author$project$Portal$Page$Routing = {$: 0};
var $author$project$Portal$Page$TeamShopJako = 17;
var $icidasset$elm_material_icons$Material$Icons$alarm = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z')
				]),
			_List_Nil)
		]));
var $elm$svg$Svg$Attributes$enableBackground = _VirtualDom_attribute('enable-background');
var $icidasset$elm_material_icons$Material$Icons$Internal$b = $elm$svg$Svg$Attributes$enableBackground;
var $icidasset$elm_material_icons$Material$Icons$app_shortcut = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$b('new 0 0 24 24'),
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$rect,
					_List_fromArray(
						[
							$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$g,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$icidasset$elm_material_icons$Material$Icons$Internal$p,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M17,18H7V6h10v1h2V3c0-1.1-0.9-2-2-2H7C5.9,1,5,1.9,5,3v18c0,1.1,0.9,2,2,2h10c1.1,0,2-0.9,2-2v-4h-2V18z')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$polygon,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$points('20.38,9.62 21,11 21.62,9.62 23,9 21.62,8.38 21,7 20.38,8.38 19,9')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$polygon,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$points('16,8 14.75,10.75 12,12 14.75,13.25 16,16 17.25,13.25 20,12 17.25,10.75')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$polygon,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$points('21,13 20.38,14.38 19,15 20.38,15.62 21,17 21.62,15.62 23,15 21.62,14.38')
								]),
							_List_Nil)
						]))
				]))
		]));
var $icidasset$elm_material_icons$Material$Icons$calendar_month = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$b('new 0 0 24 24'),
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$rect,
					_List_fromArray(
						[
							$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$icidasset$elm_material_icons$Material$Icons$Internal$p,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M19,4h-1V2h-2v2H8V2H6v2H5C3.89,4,3.01,4.9,3.01,6L3,20c0,1.1,0.89,2,2,2h14c1.1,0,2-0.9,2-2V6C21,4.9,20.1,4,19,4z M19,20 H5V10h14V20z M9,14H7v-2h2V14z M13,14h-2v-2h2V14z M17,14h-2v-2h2V14z M9,18H7v-2h2V18z M13,18h-2v-2h2V18z M17,18h-2v-2h2V18z')
						]),
					_List_Nil)
				]))
		]));
var $icidasset$elm_material_icons$Material$Icons$dashboard = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z')
				]),
			_List_Nil)
		]));
var $author$project$Portal$Page$disableOnProduction = F2(
	function (env, securityCheck) {
		if (!env.$) {
			return $elm$core$Basics$always(false);
		} else {
			return securityCheck;
		}
	});
var $icidasset$elm_material_icons$Material$Icons$euro = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$b('new 0 0 24 24'),
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$rect,
					_List_fromArray(
						[
							$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2($elm$svg$Svg$g, _List_Nil, _List_Nil),
					A2(
					$icidasset$elm_material_icons$Material$Icons$Internal$p,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M15,18.5c-2.51,0-4.68-1.42-5.76-3.5H15l1-2H8.58c-0.05-0.33-0.08-0.66-0.08-1s0.03-0.67,0.08-1H15l1-2H9.24 C10.32,6.92,12.5,5.5,15,5.5c1.61,0,3.09,0.59,4.23,1.57L21,5.3C19.41,3.87,17.3,3,15,3c-3.92,0-7.24,2.51-8.48,6H3l-1,2h4.06 C6.02,11.33,6,11.66,6,12s0.02,0.67,0.06,1H3l-1,2h4.52c1.24,3.49,4.56,6,8.48,6c2.31,0,4.41-0.87,6-2.3l-1.78-1.77 C18.09,17.91,16.62,18.5,15,18.5z')
						]),
					_List_Nil)
				]))
		]));
var $icidasset$elm_material_icons$Material$Icons$event = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z')
				]),
			_List_Nil)
		]));
var $icidasset$elm_material_icons$Material$Icons$hub = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$b('new 0 0 24 24'),
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$rect,
			_List_fromArray(
				[
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M8.4,18.2C8.78,18.7,9,19.32,9,20c0,1.66-1.34,3-3,3s-3-1.34-3-3s1.34-3,3-3c0.44,0,0.85,0.09,1.23,0.26l1.41-1.77 c-0.92-1.03-1.29-2.39-1.09-3.69l-2.03-0.68C4.98,11.95,4.06,12.5,3,12.5c-1.66,0-3-1.34-3-3s1.34-3,3-3s3,1.34,3,3 c0,0.07,0,0.14-0.01,0.21l2.03,0.68c0.64-1.21,1.82-2.09,3.22-2.32l0-2.16C9.96,5.57,9,4.4,9,3c0-1.66,1.34-3,3-3s3,1.34,3,3 c0,1.4-0.96,2.57-2.25,2.91v2.16c1.4,0.23,2.58,1.11,3.22,2.32l2.03-0.68C18,9.64,18,9.57,18,9.5c0-1.66,1.34-3,3-3s3,1.34,3,3 s-1.34,3-3,3c-1.06,0-1.98-0.55-2.52-1.37l-2.03,0.68c0.2,1.29-0.16,2.65-1.09,3.69l1.41,1.77C17.15,17.09,17.56,17,18,17 c1.66,0,3,1.34,3,3s-1.34,3-3,3s-3-1.34-3-3c0-0.68,0.22-1.3,0.6-1.8l-1.41-1.77c-1.35,0.75-3.01,0.76-4.37,0L8.4,18.2z')
				]),
			_List_Nil)
		]));
var $icidasset$elm_material_icons$Material$Icons$inventory_2 = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$b('new 0 0 24 24'),
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$rect,
					_List_fromArray(
						[
							$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$icidasset$elm_material_icons$Material$Icons$Internal$p,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M20,2H4C3,2,2,2.9,2,4v3.01C2,7.73,2.43,8.35,3,8.7V20c0,1.1,1.1,2,2,2h14c0.9,0,2-0.9,2-2V8.7c0.57-0.35,1-0.97,1-1.69V4 C22,2.9,21,2,20,2z M15,14H9v-2h6V14z M20,7H4V4h16V7z')
						]),
					_List_Nil)
				]))
		]));
var $icidasset$elm_material_icons$Material$Icons$library_books = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z')
				]),
			_List_Nil)
		]));
var $icidasset$elm_material_icons$Material$Icons$link = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z')
				]),
			_List_Nil)
		]));
var $icidasset$elm_material_icons$Material$Icons$list = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z')
				]),
			_List_Nil)
		]));
var $icidasset$elm_material_icons$Material$Icons$logout = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z')
				]),
			_List_Nil)
		]));
var $icidasset$elm_material_icons$Material$Icons$Internal$c = $elm$svg$Svg$circle;
var $icidasset$elm_material_icons$Material$Icons$manage_accounts = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$b('new 0 0 24 24'),
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$icidasset$elm_material_icons$Material$Icons$Internal$p,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M0,0h24v24H0V0z'),
							$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$g,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$icidasset$elm_material_icons$Material$Icons$Internal$c,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$cx('10'),
									$elm$svg$Svg$Attributes$cy('8'),
									$elm$svg$Svg$Attributes$r('4')
								]),
							_List_Nil),
							A2(
							$icidasset$elm_material_icons$Material$Icons$Internal$p,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M10.67,13.02C10.45,13.01,10.23,13,10,13c-2.42,0-4.68,0.67-6.61,1.82C2.51,15.34,2,16.32,2,17.35V20h9.26 C10.47,18.87,10,17.49,10,16C10,14.93,10.25,13.93,10.67,13.02z')
								]),
							_List_Nil),
							A2(
							$icidasset$elm_material_icons$Material$Icons$Internal$p,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M20.75,16c0-0.22-0.03-0.42-0.06-0.63l1.14-1.01l-1-1.73l-1.45,0.49c-0.32-0.27-0.68-0.48-1.08-0.63L18,11h-2l-0.3,1.49 c-0.4,0.15-0.76,0.36-1.08,0.63l-1.45-0.49l-1,1.73l1.14,1.01c-0.03,0.21-0.06,0.41-0.06,0.63s0.03,0.42,0.06,0.63l-1.14,1.01 l1,1.73l1.45-0.49c0.32,0.27,0.68,0.48,1.08,0.63L16,21h2l0.3-1.49c0.4-0.15,0.76-0.36,1.08-0.63l1.45,0.49l1-1.73l-1.14-1.01 C20.72,16.42,20.75,16.22,20.75,16z M17,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S18.1,18,17,18z')
								]),
							_List_Nil)
						]))
				]))
		]));
var $icidasset$elm_material_icons$Material$Icons$manage_search = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$b('new 0 0 24 24'),
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$icidasset$elm_material_icons$Material$Icons$Internal$p,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M0,0h24v24H0V0z'),
							$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$icidasset$elm_material_icons$Material$Icons$Internal$p,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M7,9H2V7h5V9z M7,12H2v2h5V12z M20.59,19l-3.83-3.83C15.96,15.69,15.02,16,14,16c-2.76,0-5-2.24-5-5s2.24-5,5-5s5,2.24,5,5 c0,1.02-0.31,1.96-0.83,2.75L22,17.59L20.59,19z M17,11c0-1.65-1.35-3-3-3s-3,1.35-3,3s1.35,3,3,3S17,12.65,17,11z M2,19h10v-2H2 V19z')
						]),
					_List_Nil)
				]))
		]));
var $icidasset$elm_material_icons$Material$Icons$message = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z')
				]),
			_List_Nil)
		]));
var $icidasset$elm_material_icons$Material$Icons$person_search = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$b('new 0 0 24 24'),
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$rect,
					_List_fromArray(
						[
							$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$g,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$icidasset$elm_material_icons$Material$Icons$Internal$c,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$cx('10'),
									$elm$svg$Svg$Attributes$cy('8'),
									$elm$svg$Svg$Attributes$r('4')
								]),
							_List_Nil),
							A2(
							$icidasset$elm_material_icons$Material$Icons$Internal$p,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M10.35,14.01C7.62,13.91,2,15.27,2,18v2h9.54C9.07,17.24,10.31,14.11,10.35,14.01z')
								]),
							_List_Nil),
							A2(
							$icidasset$elm_material_icons$Material$Icons$Internal$p,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M19.43,18.02C19.79,17.43,20,16.74,20,16c0-2.21-1.79-4-4-4s-4,1.79-4,4c0,2.21,1.79,4,4,4c0.74,0,1.43-0.22,2.02-0.57 L20.59,22L22,20.59L19.43,18.02z M16,18c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2s2,0.9,2,2C18,17.1,17.1,18,16,18z')
								]),
							_List_Nil)
						]))
				]))
		]));
var $icidasset$elm_material_icons$Material$Icons$receipt = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z')
				]),
			_List_Nil)
		]));
var $icidasset$elm_material_icons$Material$Icons$receipt_long = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$b('new 0 0 24 24'),
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0,0h24v24H0V0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$icidasset$elm_material_icons$Material$Icons$Internal$p,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M19.5,3.5L18,2l-1.5,1.5L15,2l-1.5,1.5L12,2l-1.5,1.5L9,2L7.5,3.5L6,2v14H3v3c0,1.66,1.34,3,3,3h12c1.66,0,3-1.34,3-3V2 L19.5,3.5z M19,19c0,0.55-0.45,1-1,1s-1-0.45-1-1v-3H8V5h11V19z')
						]),
					_List_Nil),
					A2($elm$svg$Svg$rect, _List_Nil, _List_Nil),
					A2($elm$svg$Svg$rect, _List_Nil, _List_Nil),
					A2($elm$svg$Svg$rect, _List_Nil, _List_Nil),
					A2($elm$svg$Svg$rect, _List_Nil, _List_Nil)
				]))
		]));
var $icidasset$elm_material_icons$Material$Icons$report = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z')
				]),
			_List_Nil)
		]));
var $icidasset$elm_material_icons$Material$Icons$rule = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$b('new 0 0 24 24'),
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$rect,
					_List_fromArray(
						[
							$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
						]),
					_List_Nil),
					A2(
					$icidasset$elm_material_icons$Material$Icons$Internal$p,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M16.54,11L13,7.46l1.41-1.41l2.12,2.12l4.24-4.24l1.41,1.41L16.54,11z M11,7H2v2h9V7z M21,13.41L19.59,12L17,14.59 L14.41,12L13,13.41L15.59,16L13,18.59L14.41,20L17,17.41L19.59,20L21,18.59L18.41,16L21,13.41z M11,15H2v2h9V15z')
						]),
					_List_Nil)
				]))
		]));
var $icidasset$elm_material_icons$Material$Icons$shopping_cart = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z')
				]),
			_List_Nil)
		]));
var $icidasset$elm_material_icons$Material$Icons$sms_failed = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z')
				]),
			_List_Nil)
		]));
var $icidasset$elm_material_icons$Material$Icons$space_dashboard = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$b('new 0 0 24 24'),
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$rect,
			_List_fromArray(
				[
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M11,21H5c-1.1,0-2-0.9-2-2V5c0-1.1,0.9-2,2-2h6V21z M13,21h6c1.1,0,2-0.9,2-2v-7h-8V21z M21,10V5c0-1.1-0.9-2-2-2h-6v7H21z')
				]),
			_List_Nil)
		]));
var $icidasset$elm_material_icons$Material$Icons$topic = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$b('new 0 0 24 24'),
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$rect,
					_List_fromArray(
						[
							$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
						]),
					_List_Nil),
					A2(
					$icidasset$elm_material_icons$Material$Icons$Internal$p,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M20,6h-8l-2-2H4C2.9,4,2.01,4.9,2.01,6L2,18c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V8C22,6.9,21.1,6,20,6z M14,16H6v-2h8V16z M18,12H6v-2h12V12z')
						]),
					_List_Nil)
				]))
		]));
var $author$project$Portal$Page$menuItems = F2(
	function (today, environment) {
		return _List_fromArray(
			[
				{
				i: $author$project$Portal$Page$Routing,
				lN: $elm$core$Basics$always(true),
				mg: $icidasset$elm_material_icons$Material$Icons$dashboard,
				eg: 0,
				mD: 'Dashboard'
			},
				{
				i: $author$project$Portal$Page$Routing,
				lN: $author$project$Security$Security$can($author$project$Security$Security$ManagePublications),
				mg: $icidasset$elm_material_icons$Material$Icons$library_books,
				eg: 1,
				mD: 'Publicaties'
			},
				{
				i: $author$project$Portal$Page$Routing,
				lN: $author$project$Security$Security$can($author$project$Security$Security$ManagePlan),
				mg: $icidasset$elm_material_icons$Material$Icons$event,
				eg: 2,
				mD: 'Planning'
			},
				{
				i: $author$project$Portal$Page$Routing,
				lN: $author$project$Security$Security$can($author$project$Security$Security$ManageDelay),
				mg: $icidasset$elm_material_icons$Material$Icons$alarm,
				eg: 3,
				mD: 'Vertragingen'
			},
				{
				i: $author$project$Portal$Page$Routing,
				lN: $author$project$Security$Security$can($author$project$Security$Security$UseCount),
				mg: $icidasset$elm_material_icons$Material$Icons$rule,
				eg: 4,
				mD: 'Tellen'
			},
				{
				i: $author$project$Portal$Page$Routing,
				lN: $author$project$Security$Security$can($author$project$Security$Security$ManageAllComplaints),
				mg: $icidasset$elm_material_icons$Material$Icons$sms_failed,
				eg: 21,
				mD: 'Klacht terugkoppeling'
			},
				{
				i: $author$project$Portal$Page$Routing,
				lN: $author$project$Security$Security$can($author$project$Security$Security$ViewApplicants),
				mg: $icidasset$elm_material_icons$Material$Icons$person_search,
				eg: 5,
				mD: 'Kandidaten'
			},
				{
				i: $author$project$Portal$Page$Routing,
				lN: $elm$core$Basics$always(true),
				mg: $icidasset$elm_material_icons$Material$Icons$message,
				eg: 6,
				mD: 'Laatste berichten tonen'
			},
				{
				i: $author$project$Portal$Page$NewTab('https://krantenbezorgen.nl/embrace'),
				lN: $elm$core$Basics$always(true),
				mg: $icidasset$elm_material_icons$Material$Icons$app_shortcut,
				eg: 16,
				mD: 'Embrace'
			},
				{
				i: $author$project$Portal$Page$Routing,
				lN: $author$project$Security$Security$can($author$project$Security$Security$FindDraftPlans),
				mg: $icidasset$elm_material_icons$Material$Icons$manage_search,
				eg: 7,
				mD: 'Niet doorgestuurde plannen'
			},
				{
				i: $author$project$Portal$Page$Routing,
				lN: $elm$core$Basics$always(true),
				mg: $icidasset$elm_material_icons$Material$Icons$topic,
				eg: 8,
				mD: 'Documenten'
			},
				{
				i: $author$project$Portal$Page$Routing,
				lN: $author$project$Security$Security$can($author$project$Security$Security$ManageAccounts),
				mg: $icidasset$elm_material_icons$Material$Icons$manage_accounts,
				eg: 9,
				mD: 'Accounts beheren'
			},
				{
				i: $author$project$Portal$Page$Routing,
				lN: $author$project$Security$Security$can($author$project$Security$Security$ViewDelivererRouteDetail),
				mg: $icidasset$elm_material_icons$Material$Icons$list,
				eg: 10,
				mD: 'Looplijsten'
			},
				{
				i: $author$project$Portal$Page$Routing,
				lN: $author$project$Security$Security$can($author$project$Security$Security$ManageOwnCompensations),
				mg: $icidasset$elm_material_icons$Material$Icons$euro,
				eg: 11,
				mD: 'Incidentele vergoedingen'
			},
				{
				i: $author$project$Portal$Page$Routing,
				lN: function (s) {
					return (A2($author$project$Security$Security$can, $author$project$Security$Security$ValidateCompensations, s) || A2($author$project$Security$Security$can, $author$project$Security$Security$ApproveCompensations, s)) && (!A2($author$project$Security$Security$can, $author$project$Security$Security$ManageOwnCompensations, s));
				},
				mg: $icidasset$elm_material_icons$Material$Icons$euro,
				eg: 12,
				mD: 'Incidentele vergoedingen'
			},
				{
				i: $author$project$Portal$Page$Routing,
				lN: $author$project$Security$Security$can($author$project$Security$Security$ViewDelivererPaymentOverview),
				mg: $icidasset$elm_material_icons$Material$Icons$receipt,
				eg: 13,
				mD: 'Vergoedingsspecificaties'
			},
				{
				i: $author$project$Portal$Page$Routing,
				lN: $author$project$Security$Security$can($author$project$Security$Security$ViewAllPayments),
				mg: $icidasset$elm_material_icons$Material$Icons$inventory_2,
				eg: 15,
				mD: 'Vergoedingenarchief'
			},
				{
				i: $author$project$Portal$Page$Routing,
				lN: $author$project$Security$Security$can($author$project$Security$Security$ViewDistributionPointPayments),
				mg: $icidasset$elm_material_icons$Material$Icons$receipt_long,
				eg: 14,
				mD: 'Wijkoverzicht'
			},
				{
				i: $author$project$Portal$Page$NewTab('https://team.jako.com/be-nl/team/dpg/'),
				lN: $elm$core$Basics$always(true),
				mg: $icidasset$elm_material_icons$Material$Icons$link,
				eg: 17,
				mD: 'Teamshop JAKO'
			},
				{
				i: $author$project$Portal$Page$NewTab('https://dpg.cubivue.com/Login'),
				lN: $author$project$Security$Security$can($author$project$Security$Security$ViewEmbraceDashboard),
				mg: $icidasset$elm_material_icons$Material$Icons$space_dashboard,
				eg: 18,
				mD: 'Embrace dashboard'
			},
				{
				i: $author$project$Portal$Page$NewTab('https://dpgdistributie.brincr.com'),
				lN: $author$project$Security$Security$can($author$project$Security$Security$UseBrincr),
				mg: $icidasset$elm_material_icons$Material$Icons$shopping_cart,
				eg: 19,
				mD: 'Bestellingen'
			},
				{
				i: $author$project$Portal$Page$Routing,
				lN: $elm$core$Basics$always(false),
				mg: $icidasset$elm_material_icons$Material$Icons$report,
				eg: 24,
				mD: 'Rapportages'
			},
				{
				i: $author$project$Portal$Page$Routing,
				lN: A2(
					$author$project$Portal$Page$disableOnProduction,
					environment,
					$author$project$Security$Security$can($author$project$Security$Security$ManagePublications)),
				mg: $icidasset$elm_material_icons$Material$Icons$calendar_month,
				eg: 22,
				mD: 'Verschijnkalender'
			},
				{
				i: $author$project$Portal$Page$Routing,
				lN: $author$project$Security$Security$can($author$project$Security$Security$ManagePublications),
				mg: $icidasset$elm_material_icons$Material$Icons$hub,
				eg: 23,
				mD: 'Distributie Configuratie validatie'
			},
				{
				i: $author$project$Portal$Page$LogoutEffect,
				lN: $elm$core$Basics$always(true),
				mg: $icidasset$elm_material_icons$Material$Icons$logout,
				eg: 25,
				mD: 'Logout'
			}
			]);
	});
var $mdgriffith$elm_ui$Internal$Model$Navigation = {$: 1};
var $mdgriffith$elm_ui$Element$Region$navigation = $mdgriffith$elm_ui$Internal$Model$Describe($mdgriffith$elm_ui$Internal$Model$Navigation);
var $mdgriffith$elm_ui$Element$spacingXY = F2(
	function (x, y) {
		return A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$spacing,
			A3(
				$mdgriffith$elm_ui$Internal$Model$SpacingStyle,
				A2($mdgriffith$elm_ui$Internal$Model$spacingName, x, y),
				x,
				y));
	});
var $author$project$Portal$Page$menuView = F4(
	function (gotMsg, security, share, menuFoldStatus) {
		var selectedMenuItemId = $author$project$Portal$Page$menuItemFor(
			$author$project$Portal$Share$currentRoute(share));
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_Utils_ap(
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$alignTop,
						$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
						A2($mdgriffith$elm_ui$Element$spacingXY, 0, 5),
						$author$project$UI$Element$invisibleForPrint,
						$mdgriffith$elm_ui$Element$Region$navigation
					]),
				_Utils_ap(
					$author$project$UI$Element$colors($author$project$Portal$Page$menuColors),
					$author$project$UI$Font$body)),
			A2(
				$elm$core$List$map,
				$mdgriffith$elm_ui$Element$map(gotMsg),
				A2(
					$elm$core$List$map,
					function (i) {
						return A3($author$project$Portal$Page$menuItemView, menuFoldStatus, selectedMenuItemId, i);
					},
					A2(
						$elm$core$List$filter,
						function (i) {
							return i.lN(security);
						},
						A2(
							$author$project$Portal$Page$menuItems,
							$author$project$Portal$Share$today(share),
							$author$project$Portal$Share$environment(share))))));
	});
var $author$project$Portal$Share$notificationsOf = function (_v0) {
	var model = _v0;
	return model.bW;
};
var $author$project$Portal$Page$responsiveness = function (_v0) {
	var window = _v0.oz;
	var device = _v0.lF;
	return {
		gq: F2(
			function (_v1, toDropdown) {
				var spacing = _v1.j9;
				var menuWidth = _v1.jg;
				var logoWidth = _v1.i5;
				return toDropdown(
					function () {
						var _v2 = device.le;
						if (!_v2) {
							return $mdgriffith$elm_ui$Element$px((((((window.oy - spacing) - menuWidth) - spacing) - spacing) - logoWidth) - spacing);
						} else {
							return $mdgriffith$elm_ui$Element$px(300);
						}
					}());
			}),
		gP: function (_v3) {
			var small = _v3.j6;
			var medium = _v3.jf;
			var _v4 = device.le;
			if (!_v4) {
				return small;
			} else {
				return medium;
			}
		},
		gT: F2(
			function (foldStatus, menuEl) {
				var _v5 = _Utils_Tuple3(device.le, device.m9, foldStatus);
				_v5$2:
				while (true) {
					if (_v5.c.$ === 1) {
						switch (_v5.a) {
							case 0:
								var _v6 = _v5.a;
								return $mdgriffith$elm_ui$Element$none;
							case 1:
								if (!_v5.b) {
									var _v7 = _v5.a;
									var _v8 = _v5.b;
									return $mdgriffith$elm_ui$Element$none;
								} else {
									break _v5$2;
								}
							default:
								break _v5$2;
						}
					} else {
						break _v5$2;
					}
				}
				return menuEl;
			})
	};
};
var $author$project$Portal$Subheader$UserClickedOneDayIntoFuture = function (a) {
	return {$: 0, a: a};
};
var $author$project$Portal$Subheader$UserClickedOneDayIntoPast = function (a) {
	return {$: 1, a: a};
};
var $icidasset$elm_material_icons$Material$Icons$arrow_back = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z')
				]),
			_List_Nil)
		]));
var $author$project$Portal$Subheader$fontSize = 24;
var $author$project$Portal$Subheader$back = function (_v0) {
	var msg = _v0.a;
	var label = _v0.b;
	return A2(
		$mdgriffith$elm_ui$Element$Input$button,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$alignLeft,
				A2($mdgriffith$elm_ui$Element$paddingXY, $author$project$Portal$Subheader$fontSize, 0),
				$mdgriffith$elm_ui$Element$Border$widthEach(
				{k5: 0, mE: 0, nx: 1, ol: 0}),
				$mdgriffith$elm_ui$Element$Border$color(
				$author$project$UI$Element$colorFor($author$project$UI$Palette$base0)),
				$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
			]),
		{
			mD: A2(
				$mdgriffith$elm_ui$Element$row,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$spacing(9),
						$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
					]),
				_List_fromArray(
					[
						$author$project$UI$Element$iconFor(
						$icidasset$elm_material_icons$Material$Icons$arrow_back($author$project$Portal$Subheader$fontSize)),
						$mdgriffith$elm_ui$Element$text(label)
					])),
			jp: $elm$core$Maybe$Just(msg)
		});
};
var $icidasset$elm_material_icons$Material$Icons$chevron_left = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z')
				]),
			_List_Nil)
		]));
var $icidasset$elm_material_icons$Material$Icons$chevron_right = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z')
				]),
			_List_Nil)
		]));
var $author$project$Portal$Subheader$move = F2(
	function (msg, icon) {
		return A2(
			$mdgriffith$elm_ui$Element$Input$button,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$centerX,
					A2($mdgriffith$elm_ui$Element$paddingXY, 11, 7),
					$mdgriffith$elm_ui$Element$Border$rounded(3),
					$mdgriffith$elm_ui$Element$Border$width(1),
					$mdgriffith$elm_ui$Element$Border$color(
					$author$project$UI$Element$colorFor($author$project$UI$Palette$base0))
				]),
			{
				mD: $author$project$UI$Element$iconFor(
					icon($author$project$Portal$Subheader$fontSize)),
				jp: $elm$core$Maybe$Just(msg)
			});
	});
var $author$project$Portal$Subheader$UserClickedDate = {$: 2};
var $author$project$Portal$Subheader$UserClickedAroundCalendarPopup = {$: 4};
var $author$project$Portal$Subheader$UserClickedInsideCalendarPopup = {$: 5};
var $author$project$Portal$Subheader$UserSelectedDateInCalendar = function (a) {
	return {$: 3, a: a};
};
var $tesk9$palette$TransparentColor$customOpacity = $tesk9$palette$Internal$Opacity$custom;
var $tesk9$palette$TransparentColor$Color = $elm$core$Basics$identity;
var $tesk9$palette$TransparentColor$fromRGBA = A2($elm$core$Basics$composeR, $tesk9$palette$Internal$Color$fromRGBA, $elm$core$Basics$identity);
var $tesk9$palette$TransparentColor$fromColor = F2(
	function (opacity, color) {
		var _v0 = $tesk9$palette$SolidColor$toRGB(color);
		var r = _v0.a;
		var g = _v0.b;
		var b = _v0.c;
		return $tesk9$palette$TransparentColor$fromRGBA(
			{kN: opacity, k_: b, l6: g, no: r});
	});
var $author$project$UI$Palette$aroundPopup = A2(
	$tesk9$palette$TransparentColor$fromColor,
	$tesk9$palette$TransparentColor$customOpacity(0.7),
	$author$project$UI$Palette$base03);
var $author$project$Portal$Subheader$Delete = function (a) {
	return {$: 3, a: a};
};
var $author$project$UI$Button$Secondary = 1;
var $author$project$Portal$Subheader$UserClickedInCalendar = function (a) {
	return {$: 6, a: a};
};
var $author$project$UI$Button$Button = $elm$core$Basics$identity;
var $author$project$UI$Button$Enabled = function (a) {
	return {$: 0, a: a};
};
var $author$project$UI$Button$button = F2(
	function (msg, text) {
		return {
			eJ: false,
			eK: false,
			mg: $elm$core$Maybe$Nothing,
			iY: $elm$core$Maybe$Nothing,
			gX: $author$project$UI$Button$Enabled(msg),
			cz: $elm$core$Maybe$Nothing,
			n3: text,
			oy: $elm$core$Maybe$Nothing
		};
	});
var $author$project$UI$Palette$green = $tesk9$palette$SolidColor$fromRGB(
	_Utils_Tuple3(31, 164, 91));
var $author$project$UI$Button$actionColors = {
	cr: {kV: $author$project$UI$Palette$lightGreen, k0: $author$project$UI$Palette$green, lZ: $author$project$UI$Palette$base2},
	cx: {kV: $author$project$UI$Palette$green, k0: $author$project$UI$Palette$green, lZ: $author$project$UI$Palette$base2}
};
var $author$project$UI$Button$secondaryColors = {
	cr: {kV: $author$project$UI$Palette$lightMagenta, k0: $author$project$UI$Palette$magenta, lZ: $author$project$UI$Palette$base2},
	cx: {kV: $author$project$UI$Palette$magenta, k0: $author$project$UI$Palette$magenta, lZ: $author$project$UI$Palette$base2}
};
var $author$project$UI$Button$softColors = {
	cr: {kV: $author$project$UI$Palette$base2, k0: $author$project$UI$Palette$base0, lZ: $author$project$UI$Palette$base02},
	cx: {kV: $author$project$UI$Palette$base1, k0: $author$project$UI$Palette$base0, lZ: $author$project$UI$Palette$base02}
};
var $author$project$UI$Button$colorsForRole = function (role) {
	switch (role) {
		case 0:
			return $author$project$UI$Button$actionColors;
		case 1:
			return $author$project$UI$Button$secondaryColors;
		default:
			return $author$project$UI$Button$softColors;
	}
};
var $tesk9$palette$Internal$Color$HSLA = function (a) {
	return {$: 0, a: a};
};
var $tesk9$palette$Internal$HSLA$Color = $elm$core$Basics$identity;
var $tesk9$palette$Internal$HSLA$fromChannels = function (_v0) {
	var hue = _v0.iN;
	var saturation = _v0.jV;
	var lightness = _v0.i0;
	var alpha = _v0.kN;
	var hueInt = $elm$core$Basics$floor(hue);
	var hue360 = A2($elm$core$Basics$modBy, 360, hueInt);
	var floatingHueValues = hue - hueInt;
	return {
		kN: alpha,
		iN: hue360 + floatingHueValues,
		i0: A3($elm$core$Basics$clamp, 0, 100, lightness),
		jV: A3($elm$core$Basics$clamp, 0, 100, saturation)
	};
};
var $tesk9$palette$Internal$HSLA$fromRGBA = function (_v0) {
	var red = _v0.no;
	var green = _v0.l6;
	var blue = _v0.k_;
	var alpha = _v0.kN;
	var _v1 = _Utils_Tuple3(red / 255, green / 255, blue / 255);
	var r = _v1.a;
	var g = _v1.b;
	var b = _v1.c;
	var maximum = A2(
		$elm$core$Basics$max,
		A2($elm$core$Basics$max, r, g),
		b);
	var minimum = A2(
		$elm$core$Basics$min,
		A2($elm$core$Basics$min, r, g),
		b);
	var chroma = maximum - minimum;
	var hue = (!chroma) ? 0 : (_Utils_eq(maximum, r) ? ((60 * (g - b)) / chroma) : (_Utils_eq(maximum, g) ? (60 * (((b - r) / chroma) + 2)) : (60 * (((r - g) / chroma) + 4))));
	var lightness = (minimum + maximum) / 2;
	var saturation = ((lightness === 1) || (!lightness)) ? 0 : (chroma / (1 - $elm$core$Basics$abs((2 * lightness) - 1)));
	return $tesk9$palette$Internal$HSLA$fromChannels(
		{kN: alpha, iN: hue, i0: lightness * 100, jV: saturation * 100});
};
var $tesk9$palette$Internal$Color$convertRGBAToHSL = function (color) {
	return $tesk9$palette$Internal$Color$HSLA(
		$tesk9$palette$Internal$HSLA$fromRGBA(
			$tesk9$palette$Internal$RGBA$toChannels(color)));
};
var $tesk9$palette$Internal$Color$asHSLA = function (color) {
	asHSLA:
	while (true) {
		if (!color.$) {
			var values = color.a;
			return values;
		} else {
			var rgbValues = color.a;
			var $temp$color = $tesk9$palette$Internal$Color$convertRGBAToHSL(rgbValues);
			color = $temp$color;
			continue asHSLA;
		}
	}
};
var $tesk9$palette$Internal$Color$fromHSLA = function (values) {
	return $tesk9$palette$Internal$Color$HSLA(
		$tesk9$palette$Internal$HSLA$fromChannels(values));
};
var $tesk9$palette$Internal$Color$addLightness = F2(
	function (percentage, color) {
		var hsla = $tesk9$palette$Internal$HSLA$toChannels(
			$tesk9$palette$Internal$Color$asHSLA(color));
		var lightness = hsla.i0;
		return $tesk9$palette$Internal$Color$fromHSLA(
			_Utils_update(
				hsla,
				{i0: lightness + percentage}));
	});
var $tesk9$palette$SolidColor$addLightness = F2(
	function (percentage, _v0) {
		var color = _v0;
		return A2($tesk9$palette$Internal$Color$addLightness, percentage, color);
	});
var $tesk9$palette$SolidColor$whiten = F2(
	function (percentage, color) {
		return A2(
			$tesk9$palette$SolidColor$addLightness,
			$elm$core$Basics$abs(percentage),
			color);
	});
var $author$project$UI$Palette$disabledColor = function (color) {
	return A2($tesk9$palette$SolidColor$whiten, 30, color);
};
var $author$project$UI$Palette$disabled = function (colors) {
	return {
		kV: $author$project$UI$Palette$disabledColor(colors.kV),
		k0: $author$project$UI$Palette$disabledColor(colors.k0),
		lZ: $author$project$UI$Palette$disabledColor(colors.lZ)
	};
};
var $author$project$UI$Button$forActionability = F2(
	function (actionable, borderColors) {
		var idle = borderColors.cr;
		var pressing = borderColors.cx;
		if (!actionable.$) {
			return borderColors;
		} else {
			return {
				cr: $author$project$UI$Palette$disabled(idle),
				cx: $author$project$UI$Palette$disabled(idle)
			};
		}
	});
var $mdgriffith$elm_ui$Internal$Model$Active = 2;
var $mdgriffith$elm_ui$Internal$Flag$active = $mdgriffith$elm_ui$Internal$Flag$flag(32);
var $mdgriffith$elm_ui$Element$mouseDown = function (decs) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$active,
		A2(
			$mdgriffith$elm_ui$Internal$Model$PseudoSelector,
			2,
			$mdgriffith$elm_ui$Internal$Model$unwrapDecorations(decs)));
};
var $author$project$UI$Button$regularColors = {
	cr: {kV: $author$project$UI$Palette$base02, k0: $author$project$UI$Palette$base03, lZ: $author$project$UI$Palette$base2},
	cx: {kV: $author$project$UI$Palette$base03, k0: $author$project$UI$Palette$base03, lZ: $author$project$UI$Palette$base2}
};
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$UI$Button$elementFor = function (_v0) {
	var b = _v0;
	var labelText = function () {
		var _v4 = b.iY;
		if (_v4.$ === 1) {
			return b.n3;
		} else {
			var key = _v4.a;
			return b.n3 + (' (' + (key + ')'));
		}
	}();
	var c = A2(
		$author$project$UI$Button$forActionability,
		b.gX,
		A2(
			$elm$core$Maybe$withDefault,
			$author$project$UI$Button$regularColors,
			A2($elm$core$Maybe$map, $author$project$UI$Button$colorsForRole, b.cz)));
	return A2(
		$mdgriffith$elm_ui$Element$Input$button,
		_Utils_ap(
			$elm_community$maybe_extra$Maybe$Extra$values(
				_List_fromArray(
					[
						function () {
						var _v1 = b.gX;
						if (!_v1.$) {
							return $elm$core$Maybe$Nothing;
						} else {
							var reason = _v1.a;
							return $elm$core$Maybe$Just(
								$mdgriffith$elm_ui$Element$htmlAttribute(
									$elm$html$Html$Attributes$title(reason)));
						}
					}(),
						A2($elm$core$Maybe$map, $mdgriffith$elm_ui$Element$width, b.oy),
						b.eJ ? $elm$core$Maybe$Just($mdgriffith$elm_ui$Element$alignRight) : $elm$core$Maybe$Nothing,
						b.eK ? $elm$core$Maybe$Just($mdgriffith$elm_ui$Element$alignTop) : $elm$core$Maybe$Nothing
					])),
			_Utils_ap(
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$Border$rounded(3),
						$mdgriffith$elm_ui$Element$Border$width(1),
						$mdgriffith$elm_ui$Element$padding(11),
						$mdgriffith$elm_ui$Element$mouseDown(
						$author$project$UI$Element$colors(c.cx))
					]),
				$author$project$UI$Element$colors(c.cr))),
		{
			mD: function () {
				var _v2 = b.mg;
				if (_v2.$ === 1) {
					return $mdgriffith$elm_ui$Element$text(labelText);
				} else {
					var i = _v2.a;
					return A2(
						$mdgriffith$elm_ui$Element$row,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$spacing(8)
							]),
						_List_fromArray(
							[
								$author$project$UI$Element$iconFor(
								i(16)),
								$mdgriffith$elm_ui$Element$text(labelText)
							]));
				}
			}(),
			jp: function () {
				var _v3 = b.gX;
				if (!_v3.$) {
					var msg = _v3.a;
					return $elm$core$Maybe$Just(msg);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}()
		});
};
var $author$project$Date$Icon$Unknown = 0;
var $author$project$Date$Dict$get = $timo_weike$generic_collections$ManualDict$get($author$project$Date$Dict$toComparable);
var $author$project$Date$Selector$planStateOf = F2(
	function (_v0, date) {
		var statesByDate = _v0.fS;
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($author$project$Date$Dict$get, date, statesByDate));
	});
var $author$project$Date$Selector$selectedState = function (model) {
	var selected = model.nI;
	return A2($author$project$Date$Selector$planStateOf, model, selected);
};
var $author$project$UI$Button$withRole = F2(
	function (role, _v0) {
		var b = _v0;
		return _Utils_update(
			b,
			{
				cz: $elm$core$Maybe$Just(role)
			});
	});
var $author$project$Portal$Subheader$calendarDeleteButtonView = F2(
	function (label, calendarModel) {
		var _v0 = $author$project$Date$Selector$selectedState(calendarModel);
		if (_v0 === 2) {
			return $author$project$UI$Button$elementFor(
				A2(
					$author$project$UI$Button$withRole,
					1,
					A2(
						$author$project$UI$Button$button,
						$author$project$Portal$Subheader$UserClickedInCalendar(
							$author$project$Portal$Subheader$Delete(
								$author$project$Date$DeliveryDate$fromDate(calendarModel.nI))),
						label)));
		} else {
			return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$UI$Button$Action = 0;
var $author$project$Portal$Subheader$Create = function (a) {
	return {$: 2, a: a};
};
var $author$project$UI$Button$emptyElement = A2(
	$mdgriffith$elm_ui$Element$el,
	_List_fromArray(
		[
			$mdgriffith$elm_ui$Element$height(
			$mdgriffith$elm_ui$Element$px(40))
		]),
	$mdgriffith$elm_ui$Element$none);
var $author$project$Portal$Subheader$calendarOpenOrCreateButtonView = F3(
	function (_v0, currentPlanDate, calendarModel) {
		var create = _v0.ls;
		var open = _v0.m5;
		var buttonFor = function (_v5) {
			var msg = _v5.a;
			var label = _v5.b;
			return A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[$mdgriffith$elm_ui$Element$alignRight]),
				$author$project$UI$Button$elementFor(
					A2(
						$author$project$UI$Button$withRole,
						0,
						A2($author$project$UI$Button$button, msg, label))));
		};
		if (_Utils_eq(
			currentPlanDate,
			$author$project$Date$DeliveryDate$fromDate(calendarModel.nI))) {
			return $author$project$UI$Button$emptyElement;
		} else {
			var _v1 = _Utils_Tuple3(
				create,
				open,
				$author$project$Date$Selector$selectedState(calendarModel));
			_v1$3:
			while (true) {
				_v1$4:
				while (true) {
					if (!_v1.b.$) {
						switch (_v1.c) {
							case 2:
								var label = _v1.b.a;
								var _v2 = _v1.c;
								return buttonFor(
									_Utils_Tuple2(
										$author$project$Portal$Subheader$UserClickedInCalendar(
											$author$project$Portal$Subheader$Open(
												$author$project$Date$DeliveryDate$fromDate(calendarModel.nI))),
										label));
							case 3:
								var label = _v1.b.a;
								var _v3 = _v1.c;
								return buttonFor(
									_Utils_Tuple2(
										$author$project$Portal$Subheader$UserClickedInCalendar(
											$author$project$Portal$Subheader$Open(
												$author$project$Date$DeliveryDate$fromDate(calendarModel.nI))),
										label));
							case 4:
								var label = _v1.b.a;
								var _v4 = _v1.c;
								return buttonFor(
									_Utils_Tuple2(
										$author$project$Portal$Subheader$UserClickedInCalendar(
											$author$project$Portal$Subheader$Open(
												$author$project$Date$DeliveryDate$fromDate(calendarModel.nI))),
										label));
							default:
								if (!_v1.a.$) {
									break _v1$3;
								} else {
									break _v1$4;
								}
						}
					} else {
						if (!_v1.a.$) {
							break _v1$3;
						} else {
							break _v1$4;
						}
					}
				}
				return $mdgriffith$elm_ui$Element$none;
			}
			var label = _v1.a.a;
			return buttonFor(
				_Utils_Tuple2(
					$author$project$Portal$Subheader$UserClickedInCalendar(
						$author$project$Portal$Subheader$Create(
							$author$project$Date$DeliveryDate$fromDate(calendarModel.nI))),
					label));
		}
	});
var $author$project$Portal$Subheader$calendarButtonsView = F3(
	function (currentPlanDate, buttons, calendarState) {
		var deleteButton = function () {
			var _v0 = buttons.lz;
			if (!_v0.$) {
				var label = _v0.a;
				return A2($author$project$Portal$Subheader$calendarDeleteButtonView, label, calendarState);
			} else {
				return $mdgriffith$elm_ui$Element$none;
			}
		}();
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			_List_fromArray(
				[
					deleteButton,
					A3($author$project$Portal$Subheader$calendarOpenOrCreateButtonView, buttons, currentPlanDate, calendarState)
				]));
	});
var $author$project$Date$Selector$create = F3(
	function (selected, _v0, enableSunday) {
		var start = _v0.hq;
		var end = _v0.gu;
		return {
			gt: enableSunday,
			bR: $author$project$Date$DeliveryDate$toDate(end),
			bS: $author$project$Date$DeliveryDate$toDate(start),
			nI: selected,
			fS: $author$project$Date$Dict$empty
		};
	});
var $author$project$UI$Element$doNotCloseWhenClickedInside = function (msg) {
	return $mdgriffith$elm_ui$Element$htmlAttribute(
		A2(
			$elm$html$Html$Events$stopPropagationOn,
			'click',
			$elm$json$Json$Decode$succeed(
				_Utils_Tuple2(msg, true))));
};
var $tesk9$palette$Internal$Opacity$toFloat = function (_v0) {
	var v = _v0;
	return v;
};
var $tesk9$palette$TransparentColor$opacityToFloat = $tesk9$palette$Internal$Opacity$toFloat;
var $mdgriffith$elm_ui$Element$rgba255 = F4(
	function (red, green, blue, a) {
		return A4($mdgriffith$elm_ui$Internal$Model$Rgba, red / 255, green / 255, blue / 255, a);
	});
var $tesk9$palette$TransparentColor$toRGBA = function (_v0) {
	var color = _v0;
	return $tesk9$palette$Internal$RGBA$toChannels(
		$tesk9$palette$Internal$Color$asRGBA(color));
};
var $author$project$UI$Element$transparentColorFor = function (color) {
	var _v0 = $tesk9$palette$TransparentColor$toRGBA(color);
	var red = _v0.no;
	var green = _v0.l6;
	var blue = _v0.k_;
	var alpha = _v0.kN;
	return A4(
		$mdgriffith$elm_ui$Element$rgba255,
		$elm$core$Basics$round(red),
		$elm$core$Basics$round(green),
		$elm$core$Basics$round(blue),
		$tesk9$palette$TransparentColor$opacityToFloat(alpha));
};
var $justinmimbs$date$Date$clamp = F3(
	function (dateA, dateB, dateX) {
		var a = dateA;
		var b = dateB;
		var x = dateX;
		return (_Utils_cmp(x, a) < 0) ? dateA : ((_Utils_cmp(b, x) < 0) ? dateB : dateX);
	});
var $author$project$Date$Selector$OnlyLeft = 0;
var $author$project$Style$Palet$gray = A3($mdgriffith$elm_ui$Element$rgb255, 189, 189, 189);
var $author$project$Style$Palet$lightDivider = $author$project$Style$Palet$gray;
var $mdgriffith$elm_ui$Internal$Flag$borderStyle = $mdgriffith$elm_ui$Internal$Flag$flag(11);
var $mdgriffith$elm_ui$Element$Border$solid = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$borderStyle, $mdgriffith$elm_ui$Internal$Style$classes.k4);
var $author$project$Date$Selector$borderStyle = function (on) {
	var bottom = function () {
		if (!on) {
			return 0;
		} else {
			return 1;
		}
	}();
	return _List_fromArray(
		[
			$mdgriffith$elm_ui$Element$Border$solid,
			$mdgriffith$elm_ui$Element$Border$widthEach(
			{k5: bottom, mE: 1, nx: 0, ol: 0}),
			$mdgriffith$elm_ui$Element$Border$color($author$project$Style$Palet$lightDivider)
		]);
};
var $justinmimbs$date$Date$Day = 11;
var $justinmimbs$date$Date$weekdayToNumber = function (wd) {
	switch (wd) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$date$Date$daysSincePreviousWeekday = F2(
	function (wd, date) {
		return A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$date$Date$weekdayNumber(date) + 7) - $justinmimbs$date$Date$weekdayToNumber(wd));
	});
var $justinmimbs$date$Date$firstOfMonth = F2(
	function (y, m) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + 1;
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $justinmimbs$date$Date$quarterToMonth = function (q) {
	return $justinmimbs$date$Date$numberToMonth((q * 3) - 2);
};
var $justinmimbs$date$Date$floor = F2(
	function (interval, date) {
		var rd = date;
		switch (interval) {
			case 0:
				return $justinmimbs$date$Date$firstOfYear(
					$justinmimbs$date$Date$year(date));
			case 1:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$quarterToMonth(
						$justinmimbs$date$Date$quarter(date)));
			case 2:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$month(date));
			case 3:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 4:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 5:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 1, date);
			case 6:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 2, date);
			case 7:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 3, date);
			case 8:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 4, date);
			case 9:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 5, date);
			case 10:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 6, date);
			default:
				return date;
		}
	});
var $justinmimbs$date$Date$Weeks = 2;
var $justinmimbs$date$Date$intervalToUnits = function (interval) {
	switch (interval) {
		case 0:
			return _Utils_Tuple2(1, 0);
		case 1:
			return _Utils_Tuple2(3, 1);
		case 2:
			return _Utils_Tuple2(1, 1);
		case 11:
			return _Utils_Tuple2(1, 3);
		default:
			var week = interval;
			return _Utils_Tuple2(1, 2);
	}
};
var $justinmimbs$date$Date$ceiling = F2(
	function (interval, date) {
		var floored = A2($justinmimbs$date$Date$floor, interval, date);
		if (_Utils_eq(date, floored)) {
			return date;
		} else {
			var _v0 = $justinmimbs$date$Date$intervalToUnits(interval);
			var n = _v0.a;
			var unit = _v0.b;
			return A3($justinmimbs$date$Date$add, unit, n, floored);
		}
	});
var $justinmimbs$date$Date$rangeHelp = F5(
	function (unit, step, until, revList, current) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(current, until) < 0) {
				var _v0 = A3($justinmimbs$date$Date$add, unit, step, current);
				var next = _v0;
				var $temp$unit = unit,
					$temp$step = step,
					$temp$until = until,
					$temp$revList = A2($elm$core$List$cons, current, revList),
					$temp$current = next;
				unit = $temp$unit;
				step = $temp$step;
				until = $temp$until;
				revList = $temp$revList;
				current = $temp$current;
				continue rangeHelp;
			} else {
				return $elm$core$List$reverse(revList);
			}
		}
	});
var $justinmimbs$date$Date$range = F4(
	function (interval, step, _v0, _v1) {
		var start = _v0;
		var until = _v1;
		var _v2 = $justinmimbs$date$Date$intervalToUnits(interval);
		var n = _v2.a;
		var unit = _v2.b;
		var _v3 = A2($justinmimbs$date$Date$ceiling, interval, start);
		var first = _v3;
		return (_Utils_cmp(first, until) < 0) ? A5(
			$justinmimbs$date$Date$rangeHelp,
			unit,
			A2($elm$core$Basics$max, 1, step) * n,
			until,
			_List_Nil,
			first) : _List_Nil;
	});
var $justinmimbs$date$Date$Monday = 4;
var $justinmimbs$date$Date$Month = 2;
var $author$project$Date$Selector$toMonthInterval = function (date) {
	var firstOfMonth = A2($justinmimbs$date$Date$floor, 2, date);
	var start = A2($justinmimbs$date$Date$floor, 4, firstOfMonth);
	return {
		gu: A3($justinmimbs$date$Date$add, 3, 42, start),
		hq: start
	};
};
var $author$project$Date$Selector$datesToShow = function (date) {
	var interval = $author$project$Date$Selector$toMonthInterval(date);
	return A4($justinmimbs$date$Date$range, 11, 1, interval.hq, interval.gu);
};
var $author$project$Date$Selector$onClickIf = F2(
	function (state, date) {
		switch (state) {
			case 0:
				return _List_fromArray(
					[
						$mdgriffith$elm_ui$Element$Events$onClick(date),
						$mdgriffith$elm_ui$Element$pointer
					]);
			case 1:
				return _List_fromArray(
					[
						$mdgriffith$elm_ui$Element$Events$onClick(date),
						$mdgriffith$elm_ui$Element$pointer
					]);
			default:
				return _List_Nil;
		}
	});
var $author$project$Date$Selector$Dimmed = 1;
var $author$project$Date$Selector$Disabled = 2;
var $author$project$Date$Selector$Normal = 0;
var $author$project$Date$Selector$Selected = 3;
var $justinmimbs$date$Date$isBetween = F3(
	function (_v0, _v1, _v2) {
		var a = _v0;
		var b = _v1;
		var x = _v2;
		return A3($justinmimbs$date$Date$isBetweenInt, a, b, x);
	});
var $author$project$Date$Selector$stateOfDay = F2(
	function (_v0, day) {
		var minimum = _v0.bS;
		var maximum = _v0.bR;
		var selected = _v0.nI;
		var enableSunday = _v0.gt;
		return _Utils_eq(day, selected) ? 3 : ((!A3($justinmimbs$date$Date$isBetween, minimum, maximum, day)) ? 2 : ((($justinmimbs$date$Date$weekday(day) === 6) && (!enableSunday)) ? 2 : ((!_Utils_eq(
			$justinmimbs$date$Date$month(day),
			$justinmimbs$date$Date$month(selected))) ? 1 : 0)));
	});
var $author$project$Date$Selector$dimmedStyle = $mdgriffith$elm_ui$Element$Font$color(
	A3($mdgriffith$elm_ui$Element$rgb255, 170, 170, 170));
var $author$project$Date$Selector$disabledStyle = $mdgriffith$elm_ui$Element$Font$color(
	A3($mdgriffith$elm_ui$Element$rgb255, 221, 221, 221));
var $author$project$Date$Selector$selectedStyle = _List_fromArray(
	[
		$mdgriffith$elm_ui$Element$Background$color(
		A3($mdgriffith$elm_ui$Element$rgb255, 105, 179, 255)),
		$mdgriffith$elm_ui$Element$Font$color(
		A3($mdgriffith$elm_ui$Element$rgb255, 255, 255, 255))
	]);
var $author$project$Date$Selector$toStyle = function (state) {
	switch (state) {
		case 0:
			return _List_Nil;
		case 1:
			return _List_fromArray(
				[$author$project$Date$Selector$dimmedStyle]);
		case 2:
			return _List_fromArray(
				[$author$project$Date$Selector$disabledStyle]);
		default:
			return $author$project$Date$Selector$selectedStyle;
	}
};
var $author$project$Date$Selector$toSvgColor = function (state) {
	switch (state) {
		case 0:
			return 'inherit';
		case 1:
			return '#aaaaaa';
		case 2:
			return '#dddddd';
		default:
			return '#ffffff';
	}
};
var $tesk9$palette$Internal$Hex$getHexSymbol = function (m) {
	var hexValues = $elm$core$Dict$fromList(
		_List_fromArray(
			[
				_Utils_Tuple2(0, '0'),
				_Utils_Tuple2(1, '1'),
				_Utils_Tuple2(2, '2'),
				_Utils_Tuple2(3, '3'),
				_Utils_Tuple2(4, '4'),
				_Utils_Tuple2(5, '5'),
				_Utils_Tuple2(6, '6'),
				_Utils_Tuple2(7, '7'),
				_Utils_Tuple2(8, '8'),
				_Utils_Tuple2(9, '9'),
				_Utils_Tuple2(10, 'A'),
				_Utils_Tuple2(11, 'B'),
				_Utils_Tuple2(12, 'C'),
				_Utils_Tuple2(13, 'D'),
				_Utils_Tuple2(14, 'E'),
				_Utils_Tuple2(15, 'F')
			]));
	return A2(
		$elm$core$Maybe$withDefault,
		'0',
		A2($elm$core$Dict$get, m, hexValues));
};
var $tesk9$palette$Internal$Hex$decToHex = function (c) {
	var nextValue = function (_v0) {
		nextValue:
		while (true) {
			var dec = _v0.a;
			var hex = _v0.b;
			if (!dec) {
				return hex;
			} else {
				var $temp$_v0 = _Utils_Tuple2(
					(dec / 16) | 0,
					_Utils_ap(
						$tesk9$palette$Internal$Hex$getHexSymbol(dec % 16),
						hex));
				_v0 = $temp$_v0;
				continue nextValue;
			}
		}
	};
	return A3(
		$elm$core$String$padLeft,
		2,
		'0',
		nextValue(
			_Utils_Tuple2(
				$elm$core$Basics$round(c),
				'')));
};
var $tesk9$palette$Internal$Hex$toStringWithOpacity = function (_v0) {
	var red = _v0.no;
	var green = _v0.l6;
	var blue = _v0.k_;
	var alpha = _v0.kN;
	var opacityInDec = $tesk9$palette$Internal$Hex$decToHex(
		$tesk9$palette$Internal$Opacity$toFloat(alpha) * 255);
	return '#' + ($tesk9$palette$Internal$Hex$decToHex(red) + ($tesk9$palette$Internal$Hex$decToHex(green) + ($tesk9$palette$Internal$Hex$decToHex(blue) + opacityInDec)));
};
var $tesk9$palette$Internal$Hex$toStringWithoutOpacity = function (_v0) {
	var red = _v0.no;
	var green = _v0.l6;
	var blue = _v0.k_;
	return '#' + ($tesk9$palette$Internal$Hex$decToHex(red) + ($tesk9$palette$Internal$Hex$decToHex(green) + $tesk9$palette$Internal$Hex$decToHex(blue)));
};
var $tesk9$palette$Internal$Hex$toString = function (values) {
	var alpha = values.kN;
	return _Utils_eq($tesk9$palette$Internal$Opacity$opaque, alpha) ? $tesk9$palette$Internal$Hex$toStringWithoutOpacity(values) : $tesk9$palette$Internal$Hex$toStringWithOpacity(values);
};
var $tesk9$palette$SolidColor$toHex = function (color) {
	var _v0 = $tesk9$palette$SolidColor$toRGB(color);
	var red = _v0.a;
	var green = _v0.b;
	var blue = _v0.c;
	return $tesk9$palette$Internal$Hex$toString(
		{kN: $tesk9$palette$Internal$Opacity$opaque, k_: blue, l6: green, no: red});
};
var $elm$svg$Svg$ellipse = $elm$svg$Svg$trustedNode('ellipse');
var $author$project$Date$Icon$viewEllipse = F2(
	function (color, attrs) {
		return A2(
			$elm$svg$Svg$ellipse,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$cx('18'),
						$elm$svg$Svg$Attributes$cy('15'),
						$elm$svg$Svg$Attributes$rx('12'),
						$elm$svg$Svg$Attributes$ry('10'),
						$elm$svg$Svg$Attributes$fill('transparent'),
						$elm$svg$Svg$Attributes$stroke(color),
						$elm$svg$Svg$Attributes$strokeWidth('1.5')
					]),
				attrs),
			_List_Nil);
	});
var $author$project$Date$Icon$viewNoDashedEllipse = function (color) {
	return A2($author$project$Date$Icon$viewEllipse, color, _List_Nil);
};
var $author$project$Date$Icon$viewText = F2(
	function (color, day) {
		return A2(
			$elm$svg$Svg$text_,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x('18'),
					$elm$svg$Svg$Attributes$y('15.5'),
					$elm$svg$Svg$Attributes$textAnchor('middle'),
					$elm$svg$Svg$Attributes$dominantBaseline('middle'),
					$elm$svg$Svg$Attributes$fill(color)
				]),
			_List_fromArray(
				[
					$elm$svg$Svg$text(
					$elm$core$String$fromInt(day))
				]));
	});
var $author$project$Date$Icon$view = F3(
	function (color, state, day) {
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('30px'),
					$elm$svg$Svg$Attributes$width('36px'),
					$elm$svg$Svg$Attributes$viewBox('0 0 36 30')
				]),
			A2(
				$elm$core$List$cons,
				A2($author$project$Date$Icon$viewText, color, day),
				function () {
					switch (state) {
						case 0:
							return _List_Nil;
						case 1:
							return _List_Nil;
						case 2:
							return _List_fromArray(
								[
									$author$project$Date$Icon$viewNoDashedEllipse('#bbbbbb')
								]);
						case 3:
							return _List_fromArray(
								[
									$author$project$Date$Icon$viewNoDashedEllipse(
									$tesk9$palette$SolidColor$toHex($author$project$UI$Palette$yellow))
								]);
						default:
							return _List_fromArray(
								[
									$author$project$Date$Icon$viewNoDashedEllipse(
									$tesk9$palette$SolidColor$toHex($author$project$UI$Palette$green))
								]);
					}
				}()));
	});
var $author$project$Date$Selector$viewDay = F2(
	function (model, day) {
		var state = A2($author$project$Date$Selector$stateOfDay, model, day);
		var planState = A2($author$project$Date$Selector$planStateOf, model, day);
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_Utils_ap(
				$author$project$Date$Selector$toStyle(state),
				_Utils_ap(
					A2($author$project$Date$Selector$onClickIf, state, day),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Border$color(
							$author$project$UI$Element$colorFor($author$project$UI$Palette$base1)),
							$mdgriffith$elm_ui$Element$Border$width(1)
						]))),
			$mdgriffith$elm_ui$Element$html(
				A3(
					$author$project$Date$Icon$view,
					$author$project$Date$Selector$toSvgColor(state),
					planState,
					$justinmimbs$date$Date$day(day))));
	});
var $mdgriffith$elm_ui$Element$Font$bold = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$fontWeight, $mdgriffith$elm_ui$Internal$Style$classes.k$);
var $author$project$Date$Selector$dayOfWeekNames = _List_fromArray(
	['Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za', 'Zo']);
var $mdgriffith$elm_ui$Element$Font$alignRight = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$fontAlignment, $mdgriffith$elm_ui$Internal$Style$classes.od);
var $author$project$Date$Selector$viewCell = F3(
	function (state, attrs, content) {
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_Utils_ap(
				attrs,
				$author$project$Date$Selector$toStyle(state)),
			$mdgriffith$elm_ui$Element$text(content));
	});
var $author$project$Date$Selector$viewCalendarCell = F3(
	function (state, attrs, content) {
		var calendarStyle = _List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width(
				$mdgriffith$elm_ui$Element$px(38)),
				A2($mdgriffith$elm_ui$Element$paddingXY, 12, 9),
				$mdgriffith$elm_ui$Element$Font$alignRight
			]);
		return A3(
			$author$project$Date$Selector$viewCell,
			state,
			_Utils_ap(attrs, calendarStyle),
			content);
	});
var $author$project$Date$Selector$viewDayOfWeekHeader = A2(
	$mdgriffith$elm_ui$Element$row,
	_List_fromArray(
		[
			$mdgriffith$elm_ui$Element$Font$bold,
			$mdgriffith$elm_ui$Element$Font$color(
			$author$project$UI$Element$colorFor($author$project$UI$Palette$base01))
		]),
	A2(
		$elm$core$List$map,
		A2($author$project$Date$Selector$viewCalendarCell, 0, _List_Nil),
		$author$project$Date$Selector$dayOfWeekNames));
var $author$project$Date$Selector$viewDays = function (model) {
	var minimum = model.bS;
	var maximum = model.bR;
	var selected = model.nI;
	var weeks = A2(
		$elm_community$list_extra$List$Extra$greedyGroupsOf,
		7,
		$author$project$Date$Selector$datesToShow(selected));
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[$mdgriffith$elm_ui$Element$alignTop]),
		A2(
			$elm$core$List$cons,
			$author$project$Date$Selector$viewDayOfWeekHeader,
			A2(
				$elm$core$List$map,
				$mdgriffith$elm_ui$Element$row(
					$author$project$Date$Selector$borderStyle(0)),
				A2(
					$elm$core$List$map,
					$elm$core$List$map(
						function (day) {
							return A2($author$project$Date$Selector$viewDay, model, day);
						}),
					weeks))));
};
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $author$project$Date$Selector$viewMonths = function (_v0) {
	var minimum = _v0.bS;
	var maximum = _v0.bR;
	var selected = _v0.nI;
	var months = A2(
		$elm$core$List$map,
		$justinmimbs$date$Date$numberToMonth,
		A2($elm$core$List$range, 1, 12));
	var last = _Utils_eq(
		$justinmimbs$date$Date$year(selected),
		$justinmimbs$date$Date$year(maximum)) ? $justinmimbs$date$Date$monthNumber(maximum) : 12;
	var first = _Utils_eq(
		$justinmimbs$date$Date$year(selected),
		$justinmimbs$date$Date$year(minimum)) ? $justinmimbs$date$Date$monthNumber(minimum) : 1;
	var dateInMonth = function (month) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			$justinmimbs$date$Date$year(selected),
			month,
			$justinmimbs$date$Date$day(selected));
	};
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_Utils_ap(
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
					A2($mdgriffith$elm_ui$Element$paddingXY, 0, 9)
				]),
			$author$project$Date$Selector$borderStyle(0)),
		A2(
			$elm$core$List$map,
			function (month) {
				var state = function () {
					var _v1 = _Utils_Tuple3(
						_Utils_eq(
							month,
							$justinmimbs$date$Date$month(selected)),
						_Utils_cmp(
							first,
							$justinmimbs$date$Date$monthToNumber(month)) < 1,
						_Utils_cmp(
							$justinmimbs$date$Date$monthToNumber(month),
							last) < 1);
					if (_v1.a) {
						return 3;
					} else {
						if (_v1.b && _v1.c) {
							return 0;
						} else {
							return 2;
						}
					}
				}();
				return A3(
					$author$project$Date$Selector$viewCell,
					state,
					A2(
						$elm$core$List$cons,
						A2($mdgriffith$elm_ui$Element$paddingXY, 12, 3),
						A2(
							$author$project$Date$Selector$onClickIf,
							state,
							dateInMonth(month))),
					$author$project$Date$DeliveryDate$monthToString(month));
			},
			months));
};
var $author$project$Date$Selector$stateOfYear = F2(
	function (_v0, year) {
		var minimum = _v0.bS;
		var maximum = _v0.bR;
		var selected = _v0.nI;
		var selectedYear = $justinmimbs$date$Date$year(selected);
		return _Utils_eq(selectedYear, year) ? 3 : (((_Utils_cmp(
			selectedYear,
			$justinmimbs$date$Date$year(minimum)) < 0) || (_Utils_cmp(
			$justinmimbs$date$Date$year(maximum),
			selectedYear) < 0)) ? 2 : 0);
	});
var $author$project$Date$Selector$viewYears = function (model) {
	var minimum = model.bS;
	var maximum = model.bR;
	var selected = model.nI;
	var years = A2(
		$elm$core$List$range,
		$justinmimbs$date$Date$year(minimum),
		$justinmimbs$date$Date$year(maximum));
	var dateInYear = function (year) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			year,
			$justinmimbs$date$Date$month(selected),
			$justinmimbs$date$Date$day(selected));
	};
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$alignTop,
				A2($mdgriffith$elm_ui$Element$paddingXY, 0, 9)
			]),
		A2(
			$elm$core$List$map,
			function (year) {
				var state = A2($author$project$Date$Selector$stateOfYear, model, year);
				return A3(
					$author$project$Date$Selector$viewCell,
					state,
					A2(
						$elm$core$List$cons,
						A2($mdgriffith$elm_ui$Element$paddingXY, 12, 3),
						A2(
							$author$project$Date$Selector$onClickIf,
							state,
							dateInYear(year))),
					$elm$core$String$fromInt(year));
			},
			years));
};
var $author$project$Date$Selector$view = function (model) {
	var minimum = model.bS;
	var maximum = model.bR;
	return A2(
		$mdgriffith$elm_ui$Element$map,
		A2($justinmimbs$date$Date$clamp, minimum, maximum),
		A2(
			$mdgriffith$elm_ui$Element$row,
			_Utils_ap(
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$Font$size(12),
						$mdgriffith$elm_ui$Element$centerX
					]),
				$author$project$UI$Element$colors(
					{kV: $author$project$UI$Palette$base2, k0: $author$project$UI$Palette$base0, lZ: $author$project$UI$Palette$base02})),
			_List_fromArray(
				[
					$author$project$Date$Selector$viewYears(model),
					$author$project$Date$Selector$viewMonths(model),
					$author$project$Date$Selector$viewDays(model)
				])));
};
var $author$project$Date$Selector$withStatesByDate = F2(
	function (statesByDate, model) {
		return _Utils_update(
			model,
			{fS: statesByDate});
	});
var $author$project$Portal$Subheader$calendarView = F5(
	function (today, currentDate, buttons, calendarState, week) {
		var enableSunday = function () {
			if (!week) {
				return false;
			} else {
				return true;
			}
		}();
		var calView = function (state) {
			return _List_fromArray(
				[
					$mdgriffith$elm_ui$Element$inFront(
					A2(
						$mdgriffith$elm_ui$Element$el,
						_Utils_ap(
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$htmlAttribute(
									A2($elm$html$Html$Attributes$style, 'z-index', '2')),
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
									$mdgriffith$elm_ui$Element$Background$color(
									$author$project$UI$Element$transparentColorFor($author$project$UI$Palette$aroundPopup)),
									$mdgriffith$elm_ui$Element$Events$onClick($author$project$Portal$Subheader$UserClickedAroundCalendarPopup)
								]),
							$author$project$UI$Font$body),
						A2(
							$mdgriffith$elm_ui$Element$column,
							_Utils_ap(
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$centerX,
										$author$project$UI$Element$doNotCloseWhenClickedInside($author$project$Portal$Subheader$UserClickedInsideCalendarPopup),
										$mdgriffith$elm_ui$Element$padding(8),
										$mdgriffith$elm_ui$Element$spacing(8)
									]),
								$author$project$UI$Element$colors(
									{kV: $author$project$UI$Palette$base2, k0: $author$project$UI$Palette$base0, lZ: $author$project$UI$Palette$base03})),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$map,
									$author$project$Portal$Subheader$UserSelectedDateInCalendar,
									$author$project$Date$Selector$view(state)),
									A3($author$project$Portal$Subheader$calendarButtonsView, currentDate, buttons, state)
								]))))
				]);
		};
		switch (calendarState.$) {
			case 1:
				var selected = calendarState.a.nI;
				return calView(
					A3(
						$author$project$Date$Selector$create,
						selected,
						$author$project$Plan$Plan$visibleRange(today),
						enableSunday));
			case 2:
				var selected = calendarState.a.nI;
				var statuses = calendarState.a.fT;
				return A3(
					$elm$core$Basics$composeR,
					$author$project$Date$Selector$withStatesByDate(
						A2(
							$author$project$Date$Dict$map,
							F2(
								function (_v1, s) {
									switch (s) {
										case 0:
											return 2;
										case 1:
											return 3;
										default:
											return 4;
									}
								}),
							statuses)),
					calView,
					A3(
						$author$project$Date$Selector$create,
						selected,
						$author$project$Plan$Plan$visibleRange(today),
						enableSunday));
			case 3:
				return _List_Nil;
			default:
				return _List_Nil;
		}
	});
var $icidasset$elm_material_icons$Material$Icons$calendar_today = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z')
				]),
			_List_Nil)
		]));
var $mdgriffith$elm_ui$Internal$Model$mapAttr = F2(
	function (fn, attr) {
		switch (attr.$) {
			case 0:
				return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
			case 2:
				var description = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$Describe(description);
			case 6:
				var x = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$AlignX(x);
			case 5:
				var y = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$AlignY(y);
			case 7:
				var x = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$Width(x);
			case 8:
				var x = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$Height(x);
			case 3:
				var x = attr.a;
				var y = attr.b;
				return A2($mdgriffith$elm_ui$Internal$Model$Class, x, y);
			case 4:
				var flag = attr.a;
				var style = attr.b;
				return A2($mdgriffith$elm_ui$Internal$Model$StyleClass, flag, style);
			case 9:
				var location = attr.a;
				var elem = attr.b;
				return A2(
					$mdgriffith$elm_ui$Internal$Model$Nearby,
					location,
					A2($mdgriffith$elm_ui$Internal$Model$map, fn, elem));
			case 1:
				var htmlAttr = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$Attr(
					A2($elm$virtual_dom$VirtualDom$mapAttribute, fn, htmlAttr));
			default:
				var fl = attr.a;
				var trans = attr.b;
				return A2($mdgriffith$elm_ui$Internal$Model$TransformComponent, fl, trans);
		}
	});
var $mdgriffith$elm_ui$Element$mapAttribute = $mdgriffith$elm_ui$Internal$Model$mapAttr;
var $author$project$Portal$Subheader$moveableDateView = F3(
	function (toMsg, date, _v0) {
		var today = _v0.fX;
		var buttons = _v0.k7;
		var calendarState = _v0.r;
		var week = _v0.ow;
		return _Utils_Tuple2(
			A2(
				$mdgriffith$elm_ui$Element$map,
				toMsg,
				A2(
					$mdgriffith$elm_ui$Element$Input$button,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Border$rounded(3),
							$mdgriffith$elm_ui$Element$Border$width(1),
							$mdgriffith$elm_ui$Element$Border$color(
							$author$project$UI$Element$colorFor($author$project$UI$Palette$base0)),
							A2($mdgriffith$elm_ui$Element$paddingXY, 11, 7)
						]),
					{
						mD: A2(
							$mdgriffith$elm_ui$Element$row,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$spacing(8)
								]),
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text(
									$author$project$Date$DeliveryDate$view(date)),
									$author$project$UI$Element$iconFor(
									$icidasset$elm_material_icons$Material$Icons$calendar_today(24))
								])),
						jp: $elm$core$Maybe$Just($author$project$Portal$Subheader$UserClickedDate)
					})),
			A2(
				$elm$core$List$map,
				$mdgriffith$elm_ui$Element$mapAttribute(toMsg),
				A5($author$project$Portal$Subheader$calendarView, today, date, buttons, calendarState, week)));
	});
var $mdgriffith$elm_ui$Internal$Model$SansSerif = {$: 1};
var $mdgriffith$elm_ui$Element$Font$sansSerif = $mdgriffith$elm_ui$Internal$Model$SansSerif;
var $author$project$UI$Font$montserrat = $mdgriffith$elm_ui$Element$Font$family(
	_List_fromArray(
		[
			$mdgriffith$elm_ui$Element$Font$typeface('Montserrat'),
			$mdgriffith$elm_ui$Element$Font$sansSerif
		]));
var $mdgriffith$elm_ui$Element$Font$semiBold = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$fontWeight, $mdgriffith$elm_ui$Internal$Style$classes.oe);
var $author$project$UI$Font$heading1 = _List_fromArray(
	[
		$mdgriffith$elm_ui$Element$Font$size(
		$author$project$UI$Font$scaled(5)),
		$mdgriffith$elm_ui$Element$Font$semiBold,
		$author$project$UI$Font$montserrat
	]);
var $author$project$Portal$Subheader$title = F2(
	function (label, dateView) {
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_Utils_ap(
				$author$project$UI$Font$heading1,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$centerX,
						$mdgriffith$elm_ui$Element$spacing(11)
					])),
			_List_fromArray(
				[
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $mdgriffith$elm_ui$Element$none, $mdgriffith$elm_ui$Element$text, label),
					dateView
				]));
	});
var $author$project$Portal$Subheader$elementFor = F2(
	function (today, _v0) {
		var s = _v0;
		var _v1 = function () {
			var _v2 = s.lx;
			switch (_v2.$) {
				case 0:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($author$project$Portal$Subheader$title, s.oi, $mdgriffith$elm_ui$Element$none)
							]),
						$elm$core$Maybe$Nothing);
				case 1:
					var date = _v2.a;
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2(
								$author$project$Portal$Subheader$title,
								s.oi,
								$mdgriffith$elm_ui$Element$text(
									$author$project$Date$DeliveryDate$view(date)))
							]),
						$elm$core$Maybe$Nothing);
				default:
					var gotMsg = _v2.a.l5;
					var buttons = _v2.a.k7;
					var pageDate = _v2.a.nb;
					var week = _v2.a.ow;
					var calendarState = _v2.b;
					var _v3 = A3(
						$author$project$Portal$Subheader$moveableDateView,
						gotMsg,
						pageDate,
						{k7: buttons, r: calendarState, fX: today, ow: week});
					var element = _v3.a;
					var attrs = _v3.b;
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2(
								$author$project$Portal$Subheader$move,
								gotMsg(
									$author$project$Portal$Subheader$UserClickedOneDayIntoPast(week)),
								$icidasset$elm_material_icons$Material$Icons$chevron_left),
								A2($author$project$Portal$Subheader$title, s.oi, element),
								A2(
								$author$project$Portal$Subheader$move,
								gotMsg(
									$author$project$Portal$Subheader$UserClickedOneDayIntoFuture(week)),
								$icidasset$elm_material_icons$Material$Icons$chevron_right)
							]),
						$elm$core$Maybe$Just(attrs));
			}
		}();
		var elements = _v1.a;
		var attributes = _v1.b;
		return _Utils_Tuple2(
			A2(
				$author$project$UI$Util$maybeCons,
				A2($elm$core$Maybe$map, $author$project$Portal$Subheader$back, s.dR),
				_Utils_ap(elements, s.dk)),
			attributes);
	});
var $author$project$Portal$Page$subHeaderHeight = 60;
var $author$project$Portal$Page$subheaderColors = {kV: $author$project$UI$Palette$base1, k0: $author$project$UI$Palette$base2, lZ: $author$project$UI$Palette$base03};
var $author$project$Portal$Page$subheaderView = F2(
	function (today, contextSpecificHeader) {
		var _v0 = A2($author$project$Portal$Subheader$elementFor, today, contextSpecificHeader);
		var elements = _v0.a;
		var attrs = _v0.b;
		return _Utils_Tuple2(
			A2(
				$mdgriffith$elm_ui$Element$row,
				_Utils_ap(
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$height(
							$mdgriffith$elm_ui$Element$px($author$project$Portal$Page$subHeaderHeight)),
							$mdgriffith$elm_ui$Element$spacing(15),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$paddingEach(
							{k5: 0, mE: 0, nx: 15, ol: 0}),
							$mdgriffith$elm_ui$Element$Border$width(1),
							$author$project$UI$Element$invisibleForPrint
						]),
					$author$project$UI$Element$colors($author$project$Portal$Page$subheaderColors)),
				elements),
			attrs);
	});
var $author$project$Portal$Share$ui = function (_v0) {
	var model = _v0;
	return model.dI;
};
var $author$project$UI$Container$Error = 2;
var $author$project$UI$Container$Container = $elm$core$Basics$identity;
var $author$project$UI$Container$Content = 0;
var $author$project$UI$Container$Normal = function (a) {
	return {$: 0, a: a};
};
var $author$project$UI$Container$container = {
	k0: true,
	d: $author$project$UI$Container$Normal(_List_Nil),
	iK: $elm$core$Maybe$Nothing,
	g6: {k5: 10, mE: 10, nx: 10, ol: 10},
	j9: 5,
	oi: $elm$core$Maybe$Nothing,
	hE: 0,
	oy: $elm$core$Maybe$Nothing
};
var $mdgriffith$elm_ui$Element$Keyed$column = F2(
	function (attrs, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asColumn,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.lp + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.dZ)),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
						attrs))),
			$mdgriffith$elm_ui$Internal$Model$Keyed(children));
	});
var $author$project$UI$Palette$default = {kV: $author$project$UI$Palette$base2, k0: $author$project$UI$Palette$base1, lZ: $author$project$UI$Palette$base03};
var $author$project$UI$Palette$error = {
	kV: A2($tesk9$palette$SolidColor$whiten, 52, $author$project$UI$Palette$magenta),
	k0: $author$project$UI$Palette$magenta,
	lZ: $author$project$UI$Palette$base03
};
var $author$project$UI$Palette$success = {
	kV: A2($tesk9$palette$SolidColor$whiten, 40, $author$project$UI$Palette$green),
	k0: $author$project$UI$Palette$green,
	lZ: $author$project$UI$Palette$base03
};
var $author$project$UI$Palette$warning = {
	kV: A2($tesk9$palette$SolidColor$whiten, 40, $author$project$UI$Palette$yellow),
	k0: $author$project$UI$Palette$yellow,
	lZ: $author$project$UI$Palette$base03
};
var $author$project$UI$Container$elementFor = function (_v0) {
	var c = _v0;
	var title = function () {
		var _v5 = _Utils_Tuple2(c.oi, c.d);
		_v5$2:
		while (true) {
			if (!_v5.a.$) {
				if (!_v5.b.$) {
					if (!_v5.b.a.b) {
						var t = _v5.a.a;
						return A2(
							$mdgriffith$elm_ui$Element$el,
							_Utils_ap(
								t.bB,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
									])),
							t.oi);
					} else {
						break _v5$2;
					}
				} else {
					if (!_v5.b.a.b) {
						var t = _v5.a.a;
						return A2(
							$mdgriffith$elm_ui$Element$el,
							_Utils_ap(
								t.bB,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
									])),
							t.oi);
					} else {
						break _v5$2;
					}
				}
			} else {
				var _v6 = _v5.a;
				return $mdgriffith$elm_ui$Element$none;
			}
		}
		var t = _v5.a.a;
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_Utils_ap(
				t.bB,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$paddingEach(
						{k5: 10, mE: 0, nx: 0, ol: 0}),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					])),
			t.oi);
	}();
	var attributes = function () {
		var widthAttr = function () {
			var _v4 = c.oy;
			if (!_v4.$) {
				var length = _v4.a;
				return _List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width(length)
					]);
			} else {
				return _List_Nil;
			}
		}();
		var heightAttr = function () {
			var _v3 = c.iK;
			if (!_v3.$) {
				var h = _v3.a;
				return _List_fromArray(
					[
						$mdgriffith$elm_ui$Element$height(h),
						$mdgriffith$elm_ui$Element$scrollbarY
					]);
			} else {
				return _List_Nil;
			}
		}();
		var color = function () {
			var _v2 = c.hE;
			switch (_v2) {
				case 0:
					return $author$project$UI$Palette$default;
				case 1:
					return $author$project$UI$Palette$warning;
				case 2:
					return $author$project$UI$Palette$error;
				case 3:
					return $author$project$UI$Palette$success;
				default:
					return {
						kV: $author$project$UI$Palette$base1,
						k0: $author$project$UI$Palette$base0,
						lZ: $author$project$UI$Palette$disabledColor($author$project$UI$Palette$base03)
					};
			}
		}();
		var border = c.k0 ? _List_fromArray(
			[
				$mdgriffith$elm_ui$Element$Border$width(2),
				$mdgriffith$elm_ui$Element$Border$rounded(5),
				$mdgriffith$elm_ui$Element$Border$color(
				$author$project$UI$Element$colorFor(color.k0))
			]) : _List_Nil;
		return _Utils_ap(
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$alignTop,
					$mdgriffith$elm_ui$Element$Background$color(
					$author$project$UI$Element$colorFor(color.kV)),
					$mdgriffith$elm_ui$Element$Font$color(
					$author$project$UI$Element$colorFor(color.lZ)),
					$mdgriffith$elm_ui$Element$paddingEach(c.g6),
					$mdgriffith$elm_ui$Element$spacing(c.j9)
				]),
			_Utils_ap(
				border,
				_Utils_ap(widthAttr, heightAttr)));
	}();
	var _v1 = c.d;
	if (!_v1.$) {
		var content = _v1.a;
		return A2(
			$mdgriffith$elm_ui$Element$column,
			attributes,
			A2($elm$core$List$cons, title, content));
	} else {
		var content = _v1.a;
		return A2(
			$mdgriffith$elm_ui$Element$Keyed$column,
			attributes,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2('title', title),
				content));
	}
};
var $author$project$UI$Font$tag = _List_fromArray(
	[
		$mdgriffith$elm_ui$Element$Font$size(
		$author$project$UI$Font$scaled(-1))
	]);
var $author$project$UI$Container$withContent = F2(
	function (content, _v0) {
		var c = _v0;
		return _Utils_update(
			c,
			{
				d: $author$project$UI$Container$Normal(content)
			});
	});
var $author$project$UI$Container$withVariant = F2(
	function (variant, _v0) {
		var c = _v0;
		return _Utils_update(
			c,
			{hE: variant});
	});
var $author$project$UI$Container$withWidth = F2(
	function (length, _v0) {
		var c = _v0;
		return _Utils_update(
			c,
			{
				oy: $elm$core$Maybe$Just(length)
			});
	});
var $author$project$Portal$Message$errorView = F2(
	function (closeErrorMsg, err) {
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$row,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
							]),
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$column,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$spacing(10),
										$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
									]),
								_Utils_ap(
									A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											$mdgriffith$elm_ui$Element$text,
											A2(
												$elm$core$Basics$composeR,
												$elm$core$List$singleton,
												$mdgriffith$elm_ui$Element$paragraph(_List_Nil))),
										A2($elm$core$String$split, '\n', err.fq)),
									function () {
										var _v0 = err.lE;
										if (!_v0.$) {
											var details = _v0.a;
											return A2(
												$elm$core$List$map,
												A2(
													$elm$core$Basics$composeR,
													$mdgriffith$elm_ui$Element$text,
													A2(
														$elm$core$Basics$composeR,
														$elm$core$List$singleton,
														$mdgriffith$elm_ui$Element$paragraph($author$project$UI$Font$tag))),
												A2($elm$core$String$split, '\n', details));
										} else {
											return _List_Nil;
										}
									}())),
								A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$pointer,
										$mdgriffith$elm_ui$Element$alignTop,
										$mdgriffith$elm_ui$Element$Events$onClick(closeErrorMsg)
									]),
								A2(
									$author$project$UI$Element$coloredIconFor,
									$icidasset$elm_material_icons$Material$Icons$close(16),
									$author$project$UI$Palette$magenta))
							]))
					]),
				A2(
					$author$project$UI$Container$withWidth,
					$mdgriffith$elm_ui$Element$fill,
					A2($author$project$UI$Container$withVariant, 2, $author$project$UI$Container$container))));
	});
var $elm_community$html_extra$Html$Extra$nothing = $elm$html$Html$text('');
var $hecrj$html_parser$Html$Parser$Element = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $hecrj$html_parser$Html$Parser$chompOneOrMore = function (fn) {
	return A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$chompIf(fn),
		$elm$parser$Parser$chompWhile(fn));
};
var $hecrj$html_parser$Html$Parser$isSpaceCharacter = function (c) {
	return (c === ' ') || ((c === '\t') || ((c === '\n') || ((c === '\u000D') || ((c === '\u000C') || (c === '\u00A0')))));
};
var $hecrj$html_parser$Html$Parser$closingTag = function (name) {
	var chompName = A2(
		$elm$parser$Parser$andThen,
		function (closingName) {
			return _Utils_eq(
				$elm$core$String$toLower(closingName),
				name) ? $elm$parser$Parser$succeed(0) : $elm$parser$Parser$problem('closing tag does not match opening tag: ' + name);
		},
		$elm$parser$Parser$getChompedString(
			$hecrj$html_parser$Html$Parser$chompOneOrMore(
				function (c) {
					return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && (c !== '>');
				})));
	return A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<')),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('/'))),
				chompName),
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('>')));
};
var $hecrj$html_parser$Html$Parser$Comment = function (a) {
	return {$: 2, a: a};
};
var $elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
var $elm$parser$Parser$Advanced$chompUntil = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$findSubString, str, s.c, s.dv, s.h3, s.ka);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A4($elm$parser$Parser$Advanced$fromInfo, newRow, newCol, expecting, s.g)) : A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.c, newOffset) < 0,
			0,
			{h3: newCol, g: s.g, l: s.l, c: newOffset, dv: newRow, ka: s.ka});
	};
};
var $elm$parser$Parser$chompUntil = function (str) {
	return $elm$parser$Parser$Advanced$chompUntil(
		$elm$parser$Parser$toToken(str));
};
var $hecrj$html_parser$Html$Parser$commentString = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$token('<!')),
		$elm$parser$Parser$token('--')),
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$getChompedString(
			$elm$parser$Parser$chompUntil('-->')),
		$elm$parser$Parser$token('-->')));
var $hecrj$html_parser$Html$Parser$comment = A2($elm$parser$Parser$map, $hecrj$html_parser$Html$Parser$Comment, $hecrj$html_parser$Html$Parser$commentString);
var $hecrj$html_parser$Html$Parser$voidElements = _List_fromArray(
	['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr']);
var $hecrj$html_parser$Html$Parser$isVoidElement = function (name) {
	return A2($elm$core$List$member, name, $hecrj$html_parser$Html$Parser$voidElements);
};
var $hecrj$html_parser$Html$Parser$many = function (parser_) {
	return A2(
		$elm$parser$Parser$loop,
		_List_Nil,
		function (list) {
			return $elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$map,
						function (_new) {
							return $elm$parser$Parser$Loop(
								A2($elm$core$List$cons, _new, list));
						},
						parser_),
						$elm$parser$Parser$succeed(
						$elm$parser$Parser$Done(
							$elm$core$List$reverse(list)))
					]));
		});
};
var $hecrj$html_parser$Html$Parser$isTagAttributeCharacter = function (c) {
	return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '>') && ((c !== '/') && (c !== '=')))));
};
var $hecrj$html_parser$Html$Parser$tagAttributeName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($hecrj$html_parser$Html$Parser$isTagAttributeCharacter)));
var $hecrj$html_parser$Html$Parser$chompSemicolon = $elm$parser$Parser$chompIf(
	$elm$core$Basics$eq(';'));
var $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('Aacute', 'Á'),
			_Utils_Tuple2('aacute', 'á'),
			_Utils_Tuple2('Abreve', 'Ă'),
			_Utils_Tuple2('abreve', 'ă'),
			_Utils_Tuple2('ac', '∾'),
			_Utils_Tuple2('acd', '∿'),
			_Utils_Tuple2('acE', '∾̳'),
			_Utils_Tuple2('Acirc', 'Â'),
			_Utils_Tuple2('acirc', 'â'),
			_Utils_Tuple2('acute', '´'),
			_Utils_Tuple2('Acy', 'А'),
			_Utils_Tuple2('acy', 'а'),
			_Utils_Tuple2('AElig', 'Æ'),
			_Utils_Tuple2('aelig', 'æ'),
			_Utils_Tuple2('af', '\u2061'),
			_Utils_Tuple2('Afr', '\uD835\uDD04'),
			_Utils_Tuple2('afr', '\uD835\uDD1E'),
			_Utils_Tuple2('Agrave', 'À'),
			_Utils_Tuple2('agrave', 'à'),
			_Utils_Tuple2('alefsym', 'ℵ'),
			_Utils_Tuple2('aleph', 'ℵ'),
			_Utils_Tuple2('Alpha', 'Α'),
			_Utils_Tuple2('alpha', 'α'),
			_Utils_Tuple2('Amacr', 'Ā'),
			_Utils_Tuple2('amacr', 'ā'),
			_Utils_Tuple2('amalg', '⨿'),
			_Utils_Tuple2('amp', '&'),
			_Utils_Tuple2('AMP', '&'),
			_Utils_Tuple2('andand', '⩕'),
			_Utils_Tuple2('And', '⩓'),
			_Utils_Tuple2('and', '∧'),
			_Utils_Tuple2('andd', '⩜'),
			_Utils_Tuple2('andslope', '⩘'),
			_Utils_Tuple2('andv', '⩚'),
			_Utils_Tuple2('ang', '∠'),
			_Utils_Tuple2('ange', '⦤'),
			_Utils_Tuple2('angle', '∠'),
			_Utils_Tuple2('angmsdaa', '⦨'),
			_Utils_Tuple2('angmsdab', '⦩'),
			_Utils_Tuple2('angmsdac', '⦪'),
			_Utils_Tuple2('angmsdad', '⦫'),
			_Utils_Tuple2('angmsdae', '⦬'),
			_Utils_Tuple2('angmsdaf', '⦭'),
			_Utils_Tuple2('angmsdag', '⦮'),
			_Utils_Tuple2('angmsdah', '⦯'),
			_Utils_Tuple2('angmsd', '∡'),
			_Utils_Tuple2('angrt', '∟'),
			_Utils_Tuple2('angrtvb', '⊾'),
			_Utils_Tuple2('angrtvbd', '⦝'),
			_Utils_Tuple2('angsph', '∢'),
			_Utils_Tuple2('angst', 'Å'),
			_Utils_Tuple2('angzarr', '⍼'),
			_Utils_Tuple2('Aogon', 'Ą'),
			_Utils_Tuple2('aogon', 'ą'),
			_Utils_Tuple2('Aopf', '\uD835\uDD38'),
			_Utils_Tuple2('aopf', '\uD835\uDD52'),
			_Utils_Tuple2('apacir', '⩯'),
			_Utils_Tuple2('ap', '≈'),
			_Utils_Tuple2('apE', '⩰'),
			_Utils_Tuple2('ape', '≊'),
			_Utils_Tuple2('apid', '≋'),
			_Utils_Tuple2('apos', '\''),
			_Utils_Tuple2('ApplyFunction', '\u2061'),
			_Utils_Tuple2('approx', '≈'),
			_Utils_Tuple2('approxeq', '≊'),
			_Utils_Tuple2('Aring', 'Å'),
			_Utils_Tuple2('aring', 'å'),
			_Utils_Tuple2('Ascr', '\uD835\uDC9C'),
			_Utils_Tuple2('ascr', '\uD835\uDCB6'),
			_Utils_Tuple2('Assign', '≔'),
			_Utils_Tuple2('ast', '*'),
			_Utils_Tuple2('asymp', '≈'),
			_Utils_Tuple2('asympeq', '≍'),
			_Utils_Tuple2('Atilde', 'Ã'),
			_Utils_Tuple2('atilde', 'ã'),
			_Utils_Tuple2('Auml', 'Ä'),
			_Utils_Tuple2('auml', 'ä'),
			_Utils_Tuple2('awconint', '∳'),
			_Utils_Tuple2('awint', '⨑'),
			_Utils_Tuple2('backcong', '≌'),
			_Utils_Tuple2('backepsilon', '϶'),
			_Utils_Tuple2('backprime', '‵'),
			_Utils_Tuple2('backsim', '∽'),
			_Utils_Tuple2('backsimeq', '⋍'),
			_Utils_Tuple2('Backslash', '∖'),
			_Utils_Tuple2('Barv', '⫧'),
			_Utils_Tuple2('barvee', '⊽'),
			_Utils_Tuple2('barwed', '⌅'),
			_Utils_Tuple2('Barwed', '⌆'),
			_Utils_Tuple2('barwedge', '⌅'),
			_Utils_Tuple2('bbrk', '⎵'),
			_Utils_Tuple2('bbrktbrk', '⎶'),
			_Utils_Tuple2('bcong', '≌'),
			_Utils_Tuple2('Bcy', 'Б'),
			_Utils_Tuple2('bcy', 'б'),
			_Utils_Tuple2('bdquo', '„'),
			_Utils_Tuple2('becaus', '∵'),
			_Utils_Tuple2('because', '∵'),
			_Utils_Tuple2('Because', '∵'),
			_Utils_Tuple2('bemptyv', '⦰'),
			_Utils_Tuple2('bepsi', '϶'),
			_Utils_Tuple2('bernou', 'ℬ'),
			_Utils_Tuple2('Bernoullis', 'ℬ'),
			_Utils_Tuple2('Beta', 'Β'),
			_Utils_Tuple2('beta', 'β'),
			_Utils_Tuple2('beth', 'ℶ'),
			_Utils_Tuple2('between', '≬'),
			_Utils_Tuple2('Bfr', '\uD835\uDD05'),
			_Utils_Tuple2('bfr', '\uD835\uDD1F'),
			_Utils_Tuple2('bigcap', '⋂'),
			_Utils_Tuple2('bigcirc', '◯'),
			_Utils_Tuple2('bigcup', '⋃'),
			_Utils_Tuple2('bigodot', '⨀'),
			_Utils_Tuple2('bigoplus', '⨁'),
			_Utils_Tuple2('bigotimes', '⨂'),
			_Utils_Tuple2('bigsqcup', '⨆'),
			_Utils_Tuple2('bigstar', '★'),
			_Utils_Tuple2('bigtriangledown', '▽'),
			_Utils_Tuple2('bigtriangleup', '△'),
			_Utils_Tuple2('biguplus', '⨄'),
			_Utils_Tuple2('bigvee', '⋁'),
			_Utils_Tuple2('bigwedge', '⋀'),
			_Utils_Tuple2('bkarow', '⤍'),
			_Utils_Tuple2('blacklozenge', '⧫'),
			_Utils_Tuple2('blacksquare', '▪'),
			_Utils_Tuple2('blacktriangle', '▴'),
			_Utils_Tuple2('blacktriangledown', '▾'),
			_Utils_Tuple2('blacktriangleleft', '◂'),
			_Utils_Tuple2('blacktriangleright', '▸'),
			_Utils_Tuple2('blank', '␣'),
			_Utils_Tuple2('blk12', '▒'),
			_Utils_Tuple2('blk14', '░'),
			_Utils_Tuple2('blk34', '▓'),
			_Utils_Tuple2('block', '█'),
			_Utils_Tuple2('bne', '=⃥'),
			_Utils_Tuple2('bnequiv', '≡⃥'),
			_Utils_Tuple2('bNot', '⫭'),
			_Utils_Tuple2('bnot', '⌐'),
			_Utils_Tuple2('Bopf', '\uD835\uDD39'),
			_Utils_Tuple2('bopf', '\uD835\uDD53'),
			_Utils_Tuple2('bot', '⊥'),
			_Utils_Tuple2('bottom', '⊥'),
			_Utils_Tuple2('bowtie', '⋈'),
			_Utils_Tuple2('boxbox', '⧉'),
			_Utils_Tuple2('boxdl', '┐'),
			_Utils_Tuple2('boxdL', '╕'),
			_Utils_Tuple2('boxDl', '╖'),
			_Utils_Tuple2('boxDL', '╗'),
			_Utils_Tuple2('boxdr', '┌'),
			_Utils_Tuple2('boxdR', '╒'),
			_Utils_Tuple2('boxDr', '╓'),
			_Utils_Tuple2('boxDR', '╔'),
			_Utils_Tuple2('boxh', '─'),
			_Utils_Tuple2('boxH', '═'),
			_Utils_Tuple2('boxhd', '┬'),
			_Utils_Tuple2('boxHd', '╤'),
			_Utils_Tuple2('boxhD', '╥'),
			_Utils_Tuple2('boxHD', '╦'),
			_Utils_Tuple2('boxhu', '┴'),
			_Utils_Tuple2('boxHu', '╧'),
			_Utils_Tuple2('boxhU', '╨'),
			_Utils_Tuple2('boxHU', '╩'),
			_Utils_Tuple2('boxminus', '⊟'),
			_Utils_Tuple2('boxplus', '⊞'),
			_Utils_Tuple2('boxtimes', '⊠'),
			_Utils_Tuple2('boxul', '┘'),
			_Utils_Tuple2('boxuL', '╛'),
			_Utils_Tuple2('boxUl', '╜'),
			_Utils_Tuple2('boxUL', '╝'),
			_Utils_Tuple2('boxur', '└'),
			_Utils_Tuple2('boxuR', '╘'),
			_Utils_Tuple2('boxUr', '╙'),
			_Utils_Tuple2('boxUR', '╚'),
			_Utils_Tuple2('boxv', '│'),
			_Utils_Tuple2('boxV', '║'),
			_Utils_Tuple2('boxvh', '┼'),
			_Utils_Tuple2('boxvH', '╪'),
			_Utils_Tuple2('boxVh', '╫'),
			_Utils_Tuple2('boxVH', '╬'),
			_Utils_Tuple2('boxvl', '┤'),
			_Utils_Tuple2('boxvL', '╡'),
			_Utils_Tuple2('boxVl', '╢'),
			_Utils_Tuple2('boxVL', '╣'),
			_Utils_Tuple2('boxvr', '├'),
			_Utils_Tuple2('boxvR', '╞'),
			_Utils_Tuple2('boxVr', '╟'),
			_Utils_Tuple2('boxVR', '╠'),
			_Utils_Tuple2('bprime', '‵'),
			_Utils_Tuple2('breve', '˘'),
			_Utils_Tuple2('Breve', '˘'),
			_Utils_Tuple2('brvbar', '¦'),
			_Utils_Tuple2('bscr', '\uD835\uDCB7'),
			_Utils_Tuple2('Bscr', 'ℬ'),
			_Utils_Tuple2('bsemi', '⁏'),
			_Utils_Tuple2('bsim', '∽'),
			_Utils_Tuple2('bsime', '⋍'),
			_Utils_Tuple2('bsolb', '⧅'),
			_Utils_Tuple2('bsol', '\\'),
			_Utils_Tuple2('bsolhsub', '⟈'),
			_Utils_Tuple2('bull', '•'),
			_Utils_Tuple2('bullet', '•'),
			_Utils_Tuple2('bump', '≎'),
			_Utils_Tuple2('bumpE', '⪮'),
			_Utils_Tuple2('bumpe', '≏'),
			_Utils_Tuple2('Bumpeq', '≎'),
			_Utils_Tuple2('bumpeq', '≏'),
			_Utils_Tuple2('Cacute', 'Ć'),
			_Utils_Tuple2('cacute', 'ć'),
			_Utils_Tuple2('capand', '⩄'),
			_Utils_Tuple2('capbrcup', '⩉'),
			_Utils_Tuple2('capcap', '⩋'),
			_Utils_Tuple2('cap', '∩'),
			_Utils_Tuple2('Cap', '⋒'),
			_Utils_Tuple2('capcup', '⩇'),
			_Utils_Tuple2('capdot', '⩀'),
			_Utils_Tuple2('CapitalDifferentialD', 'ⅅ'),
			_Utils_Tuple2('caps', '∩︀'),
			_Utils_Tuple2('caret', '⁁'),
			_Utils_Tuple2('caron', 'ˇ'),
			_Utils_Tuple2('Cayleys', 'ℭ'),
			_Utils_Tuple2('ccaps', '⩍'),
			_Utils_Tuple2('Ccaron', 'Č'),
			_Utils_Tuple2('ccaron', 'č'),
			_Utils_Tuple2('Ccedil', 'Ç'),
			_Utils_Tuple2('ccedil', 'ç'),
			_Utils_Tuple2('Ccirc', 'Ĉ'),
			_Utils_Tuple2('ccirc', 'ĉ'),
			_Utils_Tuple2('Cconint', '∰'),
			_Utils_Tuple2('ccups', '⩌'),
			_Utils_Tuple2('ccupssm', '⩐'),
			_Utils_Tuple2('Cdot', 'Ċ'),
			_Utils_Tuple2('cdot', 'ċ'),
			_Utils_Tuple2('cedil', '¸'),
			_Utils_Tuple2('Cedilla', '¸'),
			_Utils_Tuple2('cemptyv', '⦲'),
			_Utils_Tuple2('cent', '¢'),
			_Utils_Tuple2('centerdot', '·'),
			_Utils_Tuple2('CenterDot', '·'),
			_Utils_Tuple2('cfr', '\uD835\uDD20'),
			_Utils_Tuple2('Cfr', 'ℭ'),
			_Utils_Tuple2('CHcy', 'Ч'),
			_Utils_Tuple2('chcy', 'ч'),
			_Utils_Tuple2('check', '✓'),
			_Utils_Tuple2('checkmark', '✓'),
			_Utils_Tuple2('Chi', 'Χ'),
			_Utils_Tuple2('chi', 'χ'),
			_Utils_Tuple2('circ', 'ˆ'),
			_Utils_Tuple2('circeq', '≗'),
			_Utils_Tuple2('circlearrowleft', '↺'),
			_Utils_Tuple2('circlearrowright', '↻'),
			_Utils_Tuple2('circledast', '⊛'),
			_Utils_Tuple2('circledcirc', '⊚'),
			_Utils_Tuple2('circleddash', '⊝'),
			_Utils_Tuple2('CircleDot', '⊙'),
			_Utils_Tuple2('circledR', '®'),
			_Utils_Tuple2('circledS', 'Ⓢ'),
			_Utils_Tuple2('CircleMinus', '⊖'),
			_Utils_Tuple2('CirclePlus', '⊕'),
			_Utils_Tuple2('CircleTimes', '⊗'),
			_Utils_Tuple2('cir', '○'),
			_Utils_Tuple2('cirE', '⧃'),
			_Utils_Tuple2('cire', '≗'),
			_Utils_Tuple2('cirfnint', '⨐'),
			_Utils_Tuple2('cirmid', '⫯'),
			_Utils_Tuple2('cirscir', '⧂'),
			_Utils_Tuple2('ClockwiseContourIntegral', '∲'),
			_Utils_Tuple2('CloseCurlyDoubleQuote', '”'),
			_Utils_Tuple2('CloseCurlyQuote', '’'),
			_Utils_Tuple2('clubs', '♣'),
			_Utils_Tuple2('clubsuit', '♣'),
			_Utils_Tuple2('colon', ':'),
			_Utils_Tuple2('Colon', '∷'),
			_Utils_Tuple2('Colone', '⩴'),
			_Utils_Tuple2('colone', '≔'),
			_Utils_Tuple2('coloneq', '≔'),
			_Utils_Tuple2('comma', ','),
			_Utils_Tuple2('commat', '@'),
			_Utils_Tuple2('comp', '∁'),
			_Utils_Tuple2('compfn', '∘'),
			_Utils_Tuple2('complement', '∁'),
			_Utils_Tuple2('complexes', 'ℂ'),
			_Utils_Tuple2('cong', '≅'),
			_Utils_Tuple2('congdot', '⩭'),
			_Utils_Tuple2('Congruent', '≡'),
			_Utils_Tuple2('conint', '∮'),
			_Utils_Tuple2('Conint', '∯'),
			_Utils_Tuple2('ContourIntegral', '∮'),
			_Utils_Tuple2('copf', '\uD835\uDD54'),
			_Utils_Tuple2('Copf', 'ℂ'),
			_Utils_Tuple2('coprod', '∐'),
			_Utils_Tuple2('Coproduct', '∐'),
			_Utils_Tuple2('copy', '©'),
			_Utils_Tuple2('COPY', '©'),
			_Utils_Tuple2('copysr', '℗'),
			_Utils_Tuple2('CounterClockwiseContourIntegral', '∳'),
			_Utils_Tuple2('crarr', '↵'),
			_Utils_Tuple2('cross', '✗'),
			_Utils_Tuple2('Cross', '⨯'),
			_Utils_Tuple2('Cscr', '\uD835\uDC9E'),
			_Utils_Tuple2('cscr', '\uD835\uDCB8'),
			_Utils_Tuple2('csub', '⫏'),
			_Utils_Tuple2('csube', '⫑'),
			_Utils_Tuple2('csup', '⫐'),
			_Utils_Tuple2('csupe', '⫒'),
			_Utils_Tuple2('ctdot', '⋯'),
			_Utils_Tuple2('cudarrl', '⤸'),
			_Utils_Tuple2('cudarrr', '⤵'),
			_Utils_Tuple2('cuepr', '⋞'),
			_Utils_Tuple2('cuesc', '⋟'),
			_Utils_Tuple2('cularr', '↶'),
			_Utils_Tuple2('cularrp', '⤽'),
			_Utils_Tuple2('cupbrcap', '⩈'),
			_Utils_Tuple2('cupcap', '⩆'),
			_Utils_Tuple2('CupCap', '≍'),
			_Utils_Tuple2('cup', '∪'),
			_Utils_Tuple2('Cup', '⋓'),
			_Utils_Tuple2('cupcup', '⩊'),
			_Utils_Tuple2('cupdot', '⊍'),
			_Utils_Tuple2('cupor', '⩅'),
			_Utils_Tuple2('cups', '∪︀'),
			_Utils_Tuple2('curarr', '↷'),
			_Utils_Tuple2('curarrm', '⤼'),
			_Utils_Tuple2('curlyeqprec', '⋞'),
			_Utils_Tuple2('curlyeqsucc', '⋟'),
			_Utils_Tuple2('curlyvee', '⋎'),
			_Utils_Tuple2('curlywedge', '⋏'),
			_Utils_Tuple2('curren', '¤'),
			_Utils_Tuple2('curvearrowleft', '↶'),
			_Utils_Tuple2('curvearrowright', '↷'),
			_Utils_Tuple2('cuvee', '⋎'),
			_Utils_Tuple2('cuwed', '⋏'),
			_Utils_Tuple2('cwconint', '∲'),
			_Utils_Tuple2('cwint', '∱'),
			_Utils_Tuple2('cylcty', '⌭'),
			_Utils_Tuple2('dagger', '†'),
			_Utils_Tuple2('Dagger', '‡'),
			_Utils_Tuple2('daleth', 'ℸ'),
			_Utils_Tuple2('darr', '↓'),
			_Utils_Tuple2('Darr', '↡'),
			_Utils_Tuple2('dArr', '⇓'),
			_Utils_Tuple2('dash', '‐'),
			_Utils_Tuple2('Dashv', '⫤'),
			_Utils_Tuple2('dashv', '⊣'),
			_Utils_Tuple2('dbkarow', '⤏'),
			_Utils_Tuple2('dblac', '˝'),
			_Utils_Tuple2('Dcaron', 'Ď'),
			_Utils_Tuple2('dcaron', 'ď'),
			_Utils_Tuple2('Dcy', 'Д'),
			_Utils_Tuple2('dcy', 'д'),
			_Utils_Tuple2('ddagger', '‡'),
			_Utils_Tuple2('ddarr', '⇊'),
			_Utils_Tuple2('DD', 'ⅅ'),
			_Utils_Tuple2('dd', 'ⅆ'),
			_Utils_Tuple2('DDotrahd', '⤑'),
			_Utils_Tuple2('ddotseq', '⩷'),
			_Utils_Tuple2('deg', '°'),
			_Utils_Tuple2('Del', '∇'),
			_Utils_Tuple2('Delta', 'Δ'),
			_Utils_Tuple2('delta', 'δ'),
			_Utils_Tuple2('demptyv', '⦱'),
			_Utils_Tuple2('dfisht', '⥿'),
			_Utils_Tuple2('Dfr', '\uD835\uDD07'),
			_Utils_Tuple2('dfr', '\uD835\uDD21'),
			_Utils_Tuple2('dHar', '⥥'),
			_Utils_Tuple2('dharl', '⇃'),
			_Utils_Tuple2('dharr', '⇂'),
			_Utils_Tuple2('DiacriticalAcute', '´'),
			_Utils_Tuple2('DiacriticalDot', '˙'),
			_Utils_Tuple2('DiacriticalDoubleAcute', '˝'),
			_Utils_Tuple2('DiacriticalGrave', '`'),
			_Utils_Tuple2('DiacriticalTilde', '˜'),
			_Utils_Tuple2('diam', '⋄'),
			_Utils_Tuple2('diamond', '⋄'),
			_Utils_Tuple2('Diamond', '⋄'),
			_Utils_Tuple2('diamondsuit', '♦'),
			_Utils_Tuple2('diams', '♦'),
			_Utils_Tuple2('die', '¨'),
			_Utils_Tuple2('DifferentialD', 'ⅆ'),
			_Utils_Tuple2('digamma', 'ϝ'),
			_Utils_Tuple2('disin', '⋲'),
			_Utils_Tuple2('div', '÷'),
			_Utils_Tuple2('divide', '÷'),
			_Utils_Tuple2('divideontimes', '⋇'),
			_Utils_Tuple2('divonx', '⋇'),
			_Utils_Tuple2('DJcy', 'Ђ'),
			_Utils_Tuple2('djcy', 'ђ'),
			_Utils_Tuple2('dlcorn', '⌞'),
			_Utils_Tuple2('dlcrop', '⌍'),
			_Utils_Tuple2('dollar', '$'),
			_Utils_Tuple2('Dopf', '\uD835\uDD3B'),
			_Utils_Tuple2('dopf', '\uD835\uDD55'),
			_Utils_Tuple2('Dot', '¨'),
			_Utils_Tuple2('dot', '˙'),
			_Utils_Tuple2('DotDot', '⃜'),
			_Utils_Tuple2('doteq', '≐'),
			_Utils_Tuple2('doteqdot', '≑'),
			_Utils_Tuple2('DotEqual', '≐'),
			_Utils_Tuple2('dotminus', '∸'),
			_Utils_Tuple2('dotplus', '∔'),
			_Utils_Tuple2('dotsquare', '⊡'),
			_Utils_Tuple2('doublebarwedge', '⌆'),
			_Utils_Tuple2('DoubleContourIntegral', '∯'),
			_Utils_Tuple2('DoubleDot', '¨'),
			_Utils_Tuple2('DoubleDownArrow', '⇓'),
			_Utils_Tuple2('DoubleLeftArrow', '⇐'),
			_Utils_Tuple2('DoubleLeftRightArrow', '⇔'),
			_Utils_Tuple2('DoubleLeftTee', '⫤'),
			_Utils_Tuple2('DoubleLongLeftArrow', '⟸'),
			_Utils_Tuple2('DoubleLongLeftRightArrow', '⟺'),
			_Utils_Tuple2('DoubleLongRightArrow', '⟹'),
			_Utils_Tuple2('DoubleRightArrow', '⇒'),
			_Utils_Tuple2('DoubleRightTee', '⊨'),
			_Utils_Tuple2('DoubleUpArrow', '⇑'),
			_Utils_Tuple2('DoubleUpDownArrow', '⇕'),
			_Utils_Tuple2('DoubleVerticalBar', '∥'),
			_Utils_Tuple2('DownArrowBar', '⤓'),
			_Utils_Tuple2('downarrow', '↓'),
			_Utils_Tuple2('DownArrow', '↓'),
			_Utils_Tuple2('Downarrow', '⇓'),
			_Utils_Tuple2('DownArrowUpArrow', '⇵'),
			_Utils_Tuple2('DownBreve', '̑'),
			_Utils_Tuple2('downdownarrows', '⇊'),
			_Utils_Tuple2('downharpoonleft', '⇃'),
			_Utils_Tuple2('downharpoonright', '⇂'),
			_Utils_Tuple2('DownLeftRightVector', '⥐'),
			_Utils_Tuple2('DownLeftTeeVector', '⥞'),
			_Utils_Tuple2('DownLeftVectorBar', '⥖'),
			_Utils_Tuple2('DownLeftVector', '↽'),
			_Utils_Tuple2('DownRightTeeVector', '⥟'),
			_Utils_Tuple2('DownRightVectorBar', '⥗'),
			_Utils_Tuple2('DownRightVector', '⇁'),
			_Utils_Tuple2('DownTeeArrow', '↧'),
			_Utils_Tuple2('DownTee', '⊤'),
			_Utils_Tuple2('drbkarow', '⤐'),
			_Utils_Tuple2('drcorn', '⌟'),
			_Utils_Tuple2('drcrop', '⌌'),
			_Utils_Tuple2('Dscr', '\uD835\uDC9F'),
			_Utils_Tuple2('dscr', '\uD835\uDCB9'),
			_Utils_Tuple2('DScy', 'Ѕ'),
			_Utils_Tuple2('dscy', 'ѕ'),
			_Utils_Tuple2('dsol', '⧶'),
			_Utils_Tuple2('Dstrok', 'Đ'),
			_Utils_Tuple2('dstrok', 'đ'),
			_Utils_Tuple2('dtdot', '⋱'),
			_Utils_Tuple2('dtri', '▿'),
			_Utils_Tuple2('dtrif', '▾'),
			_Utils_Tuple2('duarr', '⇵'),
			_Utils_Tuple2('duhar', '⥯'),
			_Utils_Tuple2('dwangle', '⦦'),
			_Utils_Tuple2('DZcy', 'Џ'),
			_Utils_Tuple2('dzcy', 'џ'),
			_Utils_Tuple2('dzigrarr', '⟿'),
			_Utils_Tuple2('Eacute', 'É'),
			_Utils_Tuple2('eacute', 'é'),
			_Utils_Tuple2('easter', '⩮'),
			_Utils_Tuple2('Ecaron', 'Ě'),
			_Utils_Tuple2('ecaron', 'ě'),
			_Utils_Tuple2('Ecirc', 'Ê'),
			_Utils_Tuple2('ecirc', 'ê'),
			_Utils_Tuple2('ecir', '≖'),
			_Utils_Tuple2('ecolon', '≕'),
			_Utils_Tuple2('Ecy', 'Э'),
			_Utils_Tuple2('ecy', 'э'),
			_Utils_Tuple2('eDDot', '⩷'),
			_Utils_Tuple2('Edot', 'Ė'),
			_Utils_Tuple2('edot', 'ė'),
			_Utils_Tuple2('eDot', '≑'),
			_Utils_Tuple2('ee', 'ⅇ'),
			_Utils_Tuple2('efDot', '≒'),
			_Utils_Tuple2('Efr', '\uD835\uDD08'),
			_Utils_Tuple2('efr', '\uD835\uDD22'),
			_Utils_Tuple2('eg', '⪚'),
			_Utils_Tuple2('Egrave', 'È'),
			_Utils_Tuple2('egrave', 'è'),
			_Utils_Tuple2('egs', '⪖'),
			_Utils_Tuple2('egsdot', '⪘'),
			_Utils_Tuple2('el', '⪙'),
			_Utils_Tuple2('Element', '∈'),
			_Utils_Tuple2('elinters', '⏧'),
			_Utils_Tuple2('ell', 'ℓ'),
			_Utils_Tuple2('els', '⪕'),
			_Utils_Tuple2('elsdot', '⪗'),
			_Utils_Tuple2('Emacr', 'Ē'),
			_Utils_Tuple2('emacr', 'ē'),
			_Utils_Tuple2('empty', '∅'),
			_Utils_Tuple2('emptyset', '∅'),
			_Utils_Tuple2('EmptySmallSquare', '◻'),
			_Utils_Tuple2('emptyv', '∅'),
			_Utils_Tuple2('EmptyVerySmallSquare', '▫'),
			_Utils_Tuple2('emsp13', '\u2004'),
			_Utils_Tuple2('emsp14', '\u2005'),
			_Utils_Tuple2('emsp', '\u2003'),
			_Utils_Tuple2('ENG', 'Ŋ'),
			_Utils_Tuple2('eng', 'ŋ'),
			_Utils_Tuple2('ensp', '\u2002'),
			_Utils_Tuple2('Eogon', 'Ę'),
			_Utils_Tuple2('eogon', 'ę'),
			_Utils_Tuple2('Eopf', '\uD835\uDD3C'),
			_Utils_Tuple2('eopf', '\uD835\uDD56'),
			_Utils_Tuple2('epar', '⋕'),
			_Utils_Tuple2('eparsl', '⧣'),
			_Utils_Tuple2('eplus', '⩱'),
			_Utils_Tuple2('epsi', 'ε'),
			_Utils_Tuple2('Epsilon', 'Ε'),
			_Utils_Tuple2('epsilon', 'ε'),
			_Utils_Tuple2('epsiv', 'ϵ'),
			_Utils_Tuple2('eqcirc', '≖'),
			_Utils_Tuple2('eqcolon', '≕'),
			_Utils_Tuple2('eqsim', '≂'),
			_Utils_Tuple2('eqslantgtr', '⪖'),
			_Utils_Tuple2('eqslantless', '⪕'),
			_Utils_Tuple2('Equal', '⩵'),
			_Utils_Tuple2('equals', '='),
			_Utils_Tuple2('EqualTilde', '≂'),
			_Utils_Tuple2('equest', '≟'),
			_Utils_Tuple2('Equilibrium', '⇌'),
			_Utils_Tuple2('equiv', '≡'),
			_Utils_Tuple2('equivDD', '⩸'),
			_Utils_Tuple2('eqvparsl', '⧥'),
			_Utils_Tuple2('erarr', '⥱'),
			_Utils_Tuple2('erDot', '≓'),
			_Utils_Tuple2('escr', 'ℯ'),
			_Utils_Tuple2('Escr', 'ℰ'),
			_Utils_Tuple2('esdot', '≐'),
			_Utils_Tuple2('Esim', '⩳'),
			_Utils_Tuple2('esim', '≂'),
			_Utils_Tuple2('Eta', 'Η'),
			_Utils_Tuple2('eta', 'η'),
			_Utils_Tuple2('ETH', 'Ð'),
			_Utils_Tuple2('eth', 'ð'),
			_Utils_Tuple2('Euml', 'Ë'),
			_Utils_Tuple2('euml', 'ë'),
			_Utils_Tuple2('euro', '€'),
			_Utils_Tuple2('excl', '!'),
			_Utils_Tuple2('exist', '∃'),
			_Utils_Tuple2('Exists', '∃'),
			_Utils_Tuple2('expectation', 'ℰ'),
			_Utils_Tuple2('exponentiale', 'ⅇ'),
			_Utils_Tuple2('ExponentialE', 'ⅇ'),
			_Utils_Tuple2('fallingdotseq', '≒'),
			_Utils_Tuple2('Fcy', 'Ф'),
			_Utils_Tuple2('fcy', 'ф'),
			_Utils_Tuple2('female', '♀'),
			_Utils_Tuple2('ffilig', 'ﬃ'),
			_Utils_Tuple2('fflig', 'ﬀ'),
			_Utils_Tuple2('ffllig', 'ﬄ'),
			_Utils_Tuple2('Ffr', '\uD835\uDD09'),
			_Utils_Tuple2('ffr', '\uD835\uDD23'),
			_Utils_Tuple2('filig', 'ﬁ'),
			_Utils_Tuple2('FilledSmallSquare', '◼'),
			_Utils_Tuple2('FilledVerySmallSquare', '▪'),
			_Utils_Tuple2('fjlig', 'fj'),
			_Utils_Tuple2('flat', '♭'),
			_Utils_Tuple2('fllig', 'ﬂ'),
			_Utils_Tuple2('fltns', '▱'),
			_Utils_Tuple2('fnof', 'ƒ'),
			_Utils_Tuple2('Fopf', '\uD835\uDD3D'),
			_Utils_Tuple2('fopf', '\uD835\uDD57'),
			_Utils_Tuple2('forall', '∀'),
			_Utils_Tuple2('ForAll', '∀'),
			_Utils_Tuple2('fork', '⋔'),
			_Utils_Tuple2('forkv', '⫙'),
			_Utils_Tuple2('Fouriertrf', 'ℱ'),
			_Utils_Tuple2('fpartint', '⨍'),
			_Utils_Tuple2('frac12', '½'),
			_Utils_Tuple2('frac13', '⅓'),
			_Utils_Tuple2('frac14', '¼'),
			_Utils_Tuple2('frac15', '⅕'),
			_Utils_Tuple2('frac16', '⅙'),
			_Utils_Tuple2('frac18', '⅛'),
			_Utils_Tuple2('frac23', '⅔'),
			_Utils_Tuple2('frac25', '⅖'),
			_Utils_Tuple2('frac34', '¾'),
			_Utils_Tuple2('frac35', '⅗'),
			_Utils_Tuple2('frac38', '⅜'),
			_Utils_Tuple2('frac45', '⅘'),
			_Utils_Tuple2('frac56', '⅚'),
			_Utils_Tuple2('frac58', '⅝'),
			_Utils_Tuple2('frac78', '⅞'),
			_Utils_Tuple2('frasl', '⁄'),
			_Utils_Tuple2('frown', '⌢'),
			_Utils_Tuple2('fscr', '\uD835\uDCBB'),
			_Utils_Tuple2('Fscr', 'ℱ'),
			_Utils_Tuple2('gacute', 'ǵ'),
			_Utils_Tuple2('Gamma', 'Γ'),
			_Utils_Tuple2('gamma', 'γ'),
			_Utils_Tuple2('Gammad', 'Ϝ'),
			_Utils_Tuple2('gammad', 'ϝ'),
			_Utils_Tuple2('gap', '⪆'),
			_Utils_Tuple2('Gbreve', 'Ğ'),
			_Utils_Tuple2('gbreve', 'ğ'),
			_Utils_Tuple2('Gcedil', 'Ģ'),
			_Utils_Tuple2('Gcirc', 'Ĝ'),
			_Utils_Tuple2('gcirc', 'ĝ'),
			_Utils_Tuple2('Gcy', 'Г'),
			_Utils_Tuple2('gcy', 'г'),
			_Utils_Tuple2('Gdot', 'Ġ'),
			_Utils_Tuple2('gdot', 'ġ'),
			_Utils_Tuple2('ge', '≥'),
			_Utils_Tuple2('gE', '≧'),
			_Utils_Tuple2('gEl', '⪌'),
			_Utils_Tuple2('gel', '⋛'),
			_Utils_Tuple2('geq', '≥'),
			_Utils_Tuple2('geqq', '≧'),
			_Utils_Tuple2('geqslant', '⩾'),
			_Utils_Tuple2('gescc', '⪩'),
			_Utils_Tuple2('ges', '⩾'),
			_Utils_Tuple2('gesdot', '⪀'),
			_Utils_Tuple2('gesdoto', '⪂'),
			_Utils_Tuple2('gesdotol', '⪄'),
			_Utils_Tuple2('gesl', '⋛︀'),
			_Utils_Tuple2('gesles', '⪔'),
			_Utils_Tuple2('Gfr', '\uD835\uDD0A'),
			_Utils_Tuple2('gfr', '\uD835\uDD24'),
			_Utils_Tuple2('gg', '≫'),
			_Utils_Tuple2('Gg', '⋙'),
			_Utils_Tuple2('ggg', '⋙'),
			_Utils_Tuple2('gimel', 'ℷ'),
			_Utils_Tuple2('GJcy', 'Ѓ'),
			_Utils_Tuple2('gjcy', 'ѓ'),
			_Utils_Tuple2('gla', '⪥'),
			_Utils_Tuple2('gl', '≷'),
			_Utils_Tuple2('glE', '⪒'),
			_Utils_Tuple2('glj', '⪤'),
			_Utils_Tuple2('gnap', '⪊'),
			_Utils_Tuple2('gnapprox', '⪊'),
			_Utils_Tuple2('gne', '⪈'),
			_Utils_Tuple2('gnE', '≩'),
			_Utils_Tuple2('gneq', '⪈'),
			_Utils_Tuple2('gneqq', '≩'),
			_Utils_Tuple2('gnsim', '⋧'),
			_Utils_Tuple2('Gopf', '\uD835\uDD3E'),
			_Utils_Tuple2('gopf', '\uD835\uDD58'),
			_Utils_Tuple2('grave', '`'),
			_Utils_Tuple2('GreaterEqual', '≥'),
			_Utils_Tuple2('GreaterEqualLess', '⋛'),
			_Utils_Tuple2('GreaterFullEqual', '≧'),
			_Utils_Tuple2('GreaterGreater', '⪢'),
			_Utils_Tuple2('GreaterLess', '≷'),
			_Utils_Tuple2('GreaterSlantEqual', '⩾'),
			_Utils_Tuple2('GreaterTilde', '≳'),
			_Utils_Tuple2('Gscr', '\uD835\uDCA2'),
			_Utils_Tuple2('gscr', 'ℊ'),
			_Utils_Tuple2('gsim', '≳'),
			_Utils_Tuple2('gsime', '⪎'),
			_Utils_Tuple2('gsiml', '⪐'),
			_Utils_Tuple2('gtcc', '⪧'),
			_Utils_Tuple2('gtcir', '⩺'),
			_Utils_Tuple2('gt', '>'),
			_Utils_Tuple2('GT', '>'),
			_Utils_Tuple2('Gt', '≫'),
			_Utils_Tuple2('gtdot', '⋗'),
			_Utils_Tuple2('gtlPar', '⦕'),
			_Utils_Tuple2('gtquest', '⩼'),
			_Utils_Tuple2('gtrapprox', '⪆'),
			_Utils_Tuple2('gtrarr', '⥸'),
			_Utils_Tuple2('gtrdot', '⋗'),
			_Utils_Tuple2('gtreqless', '⋛'),
			_Utils_Tuple2('gtreqqless', '⪌'),
			_Utils_Tuple2('gtrless', '≷'),
			_Utils_Tuple2('gtrsim', '≳'),
			_Utils_Tuple2('gvertneqq', '≩︀'),
			_Utils_Tuple2('gvnE', '≩︀'),
			_Utils_Tuple2('Hacek', 'ˇ'),
			_Utils_Tuple2('hairsp', '\u200A'),
			_Utils_Tuple2('half', '½'),
			_Utils_Tuple2('hamilt', 'ℋ'),
			_Utils_Tuple2('HARDcy', 'Ъ'),
			_Utils_Tuple2('hardcy', 'ъ'),
			_Utils_Tuple2('harrcir', '⥈'),
			_Utils_Tuple2('harr', '↔'),
			_Utils_Tuple2('hArr', '⇔'),
			_Utils_Tuple2('harrw', '↭'),
			_Utils_Tuple2('Hat', '^'),
			_Utils_Tuple2('hbar', 'ℏ'),
			_Utils_Tuple2('Hcirc', 'Ĥ'),
			_Utils_Tuple2('hcirc', 'ĥ'),
			_Utils_Tuple2('hearts', '♥'),
			_Utils_Tuple2('heartsuit', '♥'),
			_Utils_Tuple2('hellip', '…'),
			_Utils_Tuple2('hercon', '⊹'),
			_Utils_Tuple2('hfr', '\uD835\uDD25'),
			_Utils_Tuple2('Hfr', 'ℌ'),
			_Utils_Tuple2('HilbertSpace', 'ℋ'),
			_Utils_Tuple2('hksearow', '⤥'),
			_Utils_Tuple2('hkswarow', '⤦'),
			_Utils_Tuple2('hoarr', '⇿'),
			_Utils_Tuple2('homtht', '∻'),
			_Utils_Tuple2('hookleftarrow', '↩'),
			_Utils_Tuple2('hookrightarrow', '↪'),
			_Utils_Tuple2('hopf', '\uD835\uDD59'),
			_Utils_Tuple2('Hopf', 'ℍ'),
			_Utils_Tuple2('horbar', '―'),
			_Utils_Tuple2('HorizontalLine', '─'),
			_Utils_Tuple2('hscr', '\uD835\uDCBD'),
			_Utils_Tuple2('Hscr', 'ℋ'),
			_Utils_Tuple2('hslash', 'ℏ'),
			_Utils_Tuple2('Hstrok', 'Ħ'),
			_Utils_Tuple2('hstrok', 'ħ'),
			_Utils_Tuple2('HumpDownHump', '≎'),
			_Utils_Tuple2('HumpEqual', '≏'),
			_Utils_Tuple2('hybull', '⁃'),
			_Utils_Tuple2('hyphen', '‐'),
			_Utils_Tuple2('Iacute', 'Í'),
			_Utils_Tuple2('iacute', 'í'),
			_Utils_Tuple2('ic', '\u2063'),
			_Utils_Tuple2('Icirc', 'Î'),
			_Utils_Tuple2('icirc', 'î'),
			_Utils_Tuple2('Icy', 'И'),
			_Utils_Tuple2('icy', 'и'),
			_Utils_Tuple2('Idot', 'İ'),
			_Utils_Tuple2('IEcy', 'Е'),
			_Utils_Tuple2('iecy', 'е'),
			_Utils_Tuple2('iexcl', '¡'),
			_Utils_Tuple2('iff', '⇔'),
			_Utils_Tuple2('ifr', '\uD835\uDD26'),
			_Utils_Tuple2('Ifr', 'ℑ'),
			_Utils_Tuple2('Igrave', 'Ì'),
			_Utils_Tuple2('igrave', 'ì'),
			_Utils_Tuple2('ii', 'ⅈ'),
			_Utils_Tuple2('iiiint', '⨌'),
			_Utils_Tuple2('iiint', '∭'),
			_Utils_Tuple2('iinfin', '⧜'),
			_Utils_Tuple2('iiota', '℩'),
			_Utils_Tuple2('IJlig', 'Ĳ'),
			_Utils_Tuple2('ijlig', 'ĳ'),
			_Utils_Tuple2('Imacr', 'Ī'),
			_Utils_Tuple2('imacr', 'ī'),
			_Utils_Tuple2('image', 'ℑ'),
			_Utils_Tuple2('ImaginaryI', 'ⅈ'),
			_Utils_Tuple2('imagline', 'ℐ'),
			_Utils_Tuple2('imagpart', 'ℑ'),
			_Utils_Tuple2('imath', 'ı'),
			_Utils_Tuple2('Im', 'ℑ'),
			_Utils_Tuple2('imof', '⊷'),
			_Utils_Tuple2('imped', 'Ƶ'),
			_Utils_Tuple2('Implies', '⇒'),
			_Utils_Tuple2('incare', '℅'),
			_Utils_Tuple2('in', '∈'),
			_Utils_Tuple2('infin', '∞'),
			_Utils_Tuple2('infintie', '⧝'),
			_Utils_Tuple2('inodot', 'ı'),
			_Utils_Tuple2('intcal', '⊺'),
			_Utils_Tuple2('int', '∫'),
			_Utils_Tuple2('Int', '∬'),
			_Utils_Tuple2('integers', 'ℤ'),
			_Utils_Tuple2('Integral', '∫'),
			_Utils_Tuple2('intercal', '⊺'),
			_Utils_Tuple2('Intersection', '⋂'),
			_Utils_Tuple2('intlarhk', '⨗'),
			_Utils_Tuple2('intprod', '⨼'),
			_Utils_Tuple2('InvisibleComma', '\u2063'),
			_Utils_Tuple2('InvisibleTimes', '\u2062'),
			_Utils_Tuple2('IOcy', 'Ё'),
			_Utils_Tuple2('iocy', 'ё'),
			_Utils_Tuple2('Iogon', 'Į'),
			_Utils_Tuple2('iogon', 'į'),
			_Utils_Tuple2('Iopf', '\uD835\uDD40'),
			_Utils_Tuple2('iopf', '\uD835\uDD5A'),
			_Utils_Tuple2('Iota', 'Ι'),
			_Utils_Tuple2('iota', 'ι'),
			_Utils_Tuple2('iprod', '⨼'),
			_Utils_Tuple2('iquest', '¿'),
			_Utils_Tuple2('iscr', '\uD835\uDCBE'),
			_Utils_Tuple2('Iscr', 'ℐ'),
			_Utils_Tuple2('isin', '∈'),
			_Utils_Tuple2('isindot', '⋵'),
			_Utils_Tuple2('isinE', '⋹'),
			_Utils_Tuple2('isins', '⋴'),
			_Utils_Tuple2('isinsv', '⋳'),
			_Utils_Tuple2('isinv', '∈'),
			_Utils_Tuple2('it', '\u2062'),
			_Utils_Tuple2('Itilde', 'Ĩ'),
			_Utils_Tuple2('itilde', 'ĩ'),
			_Utils_Tuple2('Iukcy', 'І'),
			_Utils_Tuple2('iukcy', 'і'),
			_Utils_Tuple2('Iuml', 'Ï'),
			_Utils_Tuple2('iuml', 'ï'),
			_Utils_Tuple2('Jcirc', 'Ĵ'),
			_Utils_Tuple2('jcirc', 'ĵ'),
			_Utils_Tuple2('Jcy', 'Й'),
			_Utils_Tuple2('jcy', 'й'),
			_Utils_Tuple2('Jfr', '\uD835\uDD0D'),
			_Utils_Tuple2('jfr', '\uD835\uDD27'),
			_Utils_Tuple2('jmath', 'ȷ'),
			_Utils_Tuple2('Jopf', '\uD835\uDD41'),
			_Utils_Tuple2('jopf', '\uD835\uDD5B'),
			_Utils_Tuple2('Jscr', '\uD835\uDCA5'),
			_Utils_Tuple2('jscr', '\uD835\uDCBF'),
			_Utils_Tuple2('Jsercy', 'Ј'),
			_Utils_Tuple2('jsercy', 'ј'),
			_Utils_Tuple2('Jukcy', 'Є'),
			_Utils_Tuple2('jukcy', 'є'),
			_Utils_Tuple2('Kappa', 'Κ'),
			_Utils_Tuple2('kappa', 'κ'),
			_Utils_Tuple2('kappav', 'ϰ'),
			_Utils_Tuple2('Kcedil', 'Ķ'),
			_Utils_Tuple2('kcedil', 'ķ'),
			_Utils_Tuple2('Kcy', 'К'),
			_Utils_Tuple2('kcy', 'к'),
			_Utils_Tuple2('Kfr', '\uD835\uDD0E'),
			_Utils_Tuple2('kfr', '\uD835\uDD28'),
			_Utils_Tuple2('kgreen', 'ĸ'),
			_Utils_Tuple2('KHcy', 'Х'),
			_Utils_Tuple2('khcy', 'х'),
			_Utils_Tuple2('KJcy', 'Ќ'),
			_Utils_Tuple2('kjcy', 'ќ'),
			_Utils_Tuple2('Kopf', '\uD835\uDD42'),
			_Utils_Tuple2('kopf', '\uD835\uDD5C'),
			_Utils_Tuple2('Kscr', '\uD835\uDCA6'),
			_Utils_Tuple2('kscr', '\uD835\uDCC0'),
			_Utils_Tuple2('lAarr', '⇚'),
			_Utils_Tuple2('Lacute', 'Ĺ'),
			_Utils_Tuple2('lacute', 'ĺ'),
			_Utils_Tuple2('laemptyv', '⦴'),
			_Utils_Tuple2('lagran', 'ℒ'),
			_Utils_Tuple2('Lambda', 'Λ'),
			_Utils_Tuple2('lambda', 'λ'),
			_Utils_Tuple2('lang', '⟨'),
			_Utils_Tuple2('Lang', '⟪'),
			_Utils_Tuple2('langd', '⦑'),
			_Utils_Tuple2('langle', '⟨'),
			_Utils_Tuple2('lap', '⪅'),
			_Utils_Tuple2('Laplacetrf', 'ℒ'),
			_Utils_Tuple2('laquo', '«'),
			_Utils_Tuple2('larrb', '⇤'),
			_Utils_Tuple2('larrbfs', '⤟'),
			_Utils_Tuple2('larr', '←'),
			_Utils_Tuple2('Larr', '↞'),
			_Utils_Tuple2('lArr', '⇐'),
			_Utils_Tuple2('larrfs', '⤝'),
			_Utils_Tuple2('larrhk', '↩'),
			_Utils_Tuple2('larrlp', '↫'),
			_Utils_Tuple2('larrpl', '⤹'),
			_Utils_Tuple2('larrsim', '⥳'),
			_Utils_Tuple2('larrtl', '↢'),
			_Utils_Tuple2('latail', '⤙'),
			_Utils_Tuple2('lAtail', '⤛'),
			_Utils_Tuple2('lat', '⪫'),
			_Utils_Tuple2('late', '⪭'),
			_Utils_Tuple2('lates', '⪭︀'),
			_Utils_Tuple2('lbarr', '⤌'),
			_Utils_Tuple2('lBarr', '⤎'),
			_Utils_Tuple2('lbbrk', '❲'),
			_Utils_Tuple2('lbrace', '{'),
			_Utils_Tuple2('lbrack', '['),
			_Utils_Tuple2('lbrke', '⦋'),
			_Utils_Tuple2('lbrksld', '⦏'),
			_Utils_Tuple2('lbrkslu', '⦍'),
			_Utils_Tuple2('Lcaron', 'Ľ'),
			_Utils_Tuple2('lcaron', 'ľ'),
			_Utils_Tuple2('Lcedil', 'Ļ'),
			_Utils_Tuple2('lcedil', 'ļ'),
			_Utils_Tuple2('lceil', '⌈'),
			_Utils_Tuple2('lcub', '{'),
			_Utils_Tuple2('Lcy', 'Л'),
			_Utils_Tuple2('lcy', 'л'),
			_Utils_Tuple2('ldca', '⤶'),
			_Utils_Tuple2('ldquo', '“'),
			_Utils_Tuple2('ldquor', '„'),
			_Utils_Tuple2('ldrdhar', '⥧'),
			_Utils_Tuple2('ldrushar', '⥋'),
			_Utils_Tuple2('ldsh', '↲'),
			_Utils_Tuple2('le', '≤'),
			_Utils_Tuple2('lE', '≦'),
			_Utils_Tuple2('LeftAngleBracket', '⟨'),
			_Utils_Tuple2('LeftArrowBar', '⇤'),
			_Utils_Tuple2('leftarrow', '←'),
			_Utils_Tuple2('LeftArrow', '←'),
			_Utils_Tuple2('Leftarrow', '⇐'),
			_Utils_Tuple2('LeftArrowRightArrow', '⇆'),
			_Utils_Tuple2('leftarrowtail', '↢'),
			_Utils_Tuple2('LeftCeiling', '⌈'),
			_Utils_Tuple2('LeftDoubleBracket', '⟦'),
			_Utils_Tuple2('LeftDownTeeVector', '⥡'),
			_Utils_Tuple2('LeftDownVectorBar', '⥙'),
			_Utils_Tuple2('LeftDownVector', '⇃'),
			_Utils_Tuple2('LeftFloor', '⌊'),
			_Utils_Tuple2('leftharpoondown', '↽'),
			_Utils_Tuple2('leftharpoonup', '↼'),
			_Utils_Tuple2('leftleftarrows', '⇇'),
			_Utils_Tuple2('leftrightarrow', '↔'),
			_Utils_Tuple2('LeftRightArrow', '↔'),
			_Utils_Tuple2('Leftrightarrow', '⇔'),
			_Utils_Tuple2('leftrightarrows', '⇆'),
			_Utils_Tuple2('leftrightharpoons', '⇋'),
			_Utils_Tuple2('leftrightsquigarrow', '↭'),
			_Utils_Tuple2('LeftRightVector', '⥎'),
			_Utils_Tuple2('LeftTeeArrow', '↤'),
			_Utils_Tuple2('LeftTee', '⊣'),
			_Utils_Tuple2('LeftTeeVector', '⥚'),
			_Utils_Tuple2('leftthreetimes', '⋋'),
			_Utils_Tuple2('LeftTriangleBar', '⧏'),
			_Utils_Tuple2('LeftTriangle', '⊲'),
			_Utils_Tuple2('LeftTriangleEqual', '⊴'),
			_Utils_Tuple2('LeftUpDownVector', '⥑'),
			_Utils_Tuple2('LeftUpTeeVector', '⥠'),
			_Utils_Tuple2('LeftUpVectorBar', '⥘'),
			_Utils_Tuple2('LeftUpVector', '↿'),
			_Utils_Tuple2('LeftVectorBar', '⥒'),
			_Utils_Tuple2('LeftVector', '↼'),
			_Utils_Tuple2('lEg', '⪋'),
			_Utils_Tuple2('leg', '⋚'),
			_Utils_Tuple2('leq', '≤'),
			_Utils_Tuple2('leqq', '≦'),
			_Utils_Tuple2('leqslant', '⩽'),
			_Utils_Tuple2('lescc', '⪨'),
			_Utils_Tuple2('les', '⩽'),
			_Utils_Tuple2('lesdot', '⩿'),
			_Utils_Tuple2('lesdoto', '⪁'),
			_Utils_Tuple2('lesdotor', '⪃'),
			_Utils_Tuple2('lesg', '⋚︀'),
			_Utils_Tuple2('lesges', '⪓'),
			_Utils_Tuple2('lessapprox', '⪅'),
			_Utils_Tuple2('lessdot', '⋖'),
			_Utils_Tuple2('lesseqgtr', '⋚'),
			_Utils_Tuple2('lesseqqgtr', '⪋'),
			_Utils_Tuple2('LessEqualGreater', '⋚'),
			_Utils_Tuple2('LessFullEqual', '≦'),
			_Utils_Tuple2('LessGreater', '≶'),
			_Utils_Tuple2('lessgtr', '≶'),
			_Utils_Tuple2('LessLess', '⪡'),
			_Utils_Tuple2('lesssim', '≲'),
			_Utils_Tuple2('LessSlantEqual', '⩽'),
			_Utils_Tuple2('LessTilde', '≲'),
			_Utils_Tuple2('lfisht', '⥼'),
			_Utils_Tuple2('lfloor', '⌊'),
			_Utils_Tuple2('Lfr', '\uD835\uDD0F'),
			_Utils_Tuple2('lfr', '\uD835\uDD29'),
			_Utils_Tuple2('lg', '≶'),
			_Utils_Tuple2('lgE', '⪑'),
			_Utils_Tuple2('lHar', '⥢'),
			_Utils_Tuple2('lhard', '↽'),
			_Utils_Tuple2('lharu', '↼'),
			_Utils_Tuple2('lharul', '⥪'),
			_Utils_Tuple2('lhblk', '▄'),
			_Utils_Tuple2('LJcy', 'Љ'),
			_Utils_Tuple2('ljcy', 'љ'),
			_Utils_Tuple2('llarr', '⇇'),
			_Utils_Tuple2('ll', '≪'),
			_Utils_Tuple2('Ll', '⋘'),
			_Utils_Tuple2('llcorner', '⌞'),
			_Utils_Tuple2('Lleftarrow', '⇚'),
			_Utils_Tuple2('llhard', '⥫'),
			_Utils_Tuple2('lltri', '◺'),
			_Utils_Tuple2('Lmidot', 'Ŀ'),
			_Utils_Tuple2('lmidot', 'ŀ'),
			_Utils_Tuple2('lmoustache', '⎰'),
			_Utils_Tuple2('lmoust', '⎰'),
			_Utils_Tuple2('lnap', '⪉'),
			_Utils_Tuple2('lnapprox', '⪉'),
			_Utils_Tuple2('lne', '⪇'),
			_Utils_Tuple2('lnE', '≨'),
			_Utils_Tuple2('lneq', '⪇'),
			_Utils_Tuple2('lneqq', '≨'),
			_Utils_Tuple2('lnsim', '⋦'),
			_Utils_Tuple2('loang', '⟬'),
			_Utils_Tuple2('loarr', '⇽'),
			_Utils_Tuple2('lobrk', '⟦'),
			_Utils_Tuple2('longleftarrow', '⟵'),
			_Utils_Tuple2('LongLeftArrow', '⟵'),
			_Utils_Tuple2('Longleftarrow', '⟸'),
			_Utils_Tuple2('longleftrightarrow', '⟷'),
			_Utils_Tuple2('LongLeftRightArrow', '⟷'),
			_Utils_Tuple2('Longleftrightarrow', '⟺'),
			_Utils_Tuple2('longmapsto', '⟼'),
			_Utils_Tuple2('longrightarrow', '⟶'),
			_Utils_Tuple2('LongRightArrow', '⟶'),
			_Utils_Tuple2('Longrightarrow', '⟹'),
			_Utils_Tuple2('looparrowleft', '↫'),
			_Utils_Tuple2('looparrowright', '↬'),
			_Utils_Tuple2('lopar', '⦅'),
			_Utils_Tuple2('Lopf', '\uD835\uDD43'),
			_Utils_Tuple2('lopf', '\uD835\uDD5D'),
			_Utils_Tuple2('loplus', '⨭'),
			_Utils_Tuple2('lotimes', '⨴'),
			_Utils_Tuple2('lowast', '∗'),
			_Utils_Tuple2('lowbar', '_'),
			_Utils_Tuple2('LowerLeftArrow', '↙'),
			_Utils_Tuple2('LowerRightArrow', '↘'),
			_Utils_Tuple2('loz', '◊'),
			_Utils_Tuple2('lozenge', '◊'),
			_Utils_Tuple2('lozf', '⧫'),
			_Utils_Tuple2('lpar', '('),
			_Utils_Tuple2('lparlt', '⦓'),
			_Utils_Tuple2('lrarr', '⇆'),
			_Utils_Tuple2('lrcorner', '⌟'),
			_Utils_Tuple2('lrhar', '⇋'),
			_Utils_Tuple2('lrhard', '⥭'),
			_Utils_Tuple2('lrm', '\u200E'),
			_Utils_Tuple2('lrtri', '⊿'),
			_Utils_Tuple2('lsaquo', '‹'),
			_Utils_Tuple2('lscr', '\uD835\uDCC1'),
			_Utils_Tuple2('Lscr', 'ℒ'),
			_Utils_Tuple2('lsh', '↰'),
			_Utils_Tuple2('Lsh', '↰'),
			_Utils_Tuple2('lsim', '≲'),
			_Utils_Tuple2('lsime', '⪍'),
			_Utils_Tuple2('lsimg', '⪏'),
			_Utils_Tuple2('lsqb', '['),
			_Utils_Tuple2('lsquo', '‘'),
			_Utils_Tuple2('lsquor', '‚'),
			_Utils_Tuple2('Lstrok', 'Ł'),
			_Utils_Tuple2('lstrok', 'ł'),
			_Utils_Tuple2('ltcc', '⪦'),
			_Utils_Tuple2('ltcir', '⩹'),
			_Utils_Tuple2('lt', '<'),
			_Utils_Tuple2('LT', '<'),
			_Utils_Tuple2('Lt', '≪'),
			_Utils_Tuple2('ltdot', '⋖'),
			_Utils_Tuple2('lthree', '⋋'),
			_Utils_Tuple2('ltimes', '⋉'),
			_Utils_Tuple2('ltlarr', '⥶'),
			_Utils_Tuple2('ltquest', '⩻'),
			_Utils_Tuple2('ltri', '◃'),
			_Utils_Tuple2('ltrie', '⊴'),
			_Utils_Tuple2('ltrif', '◂'),
			_Utils_Tuple2('ltrPar', '⦖'),
			_Utils_Tuple2('lurdshar', '⥊'),
			_Utils_Tuple2('luruhar', '⥦'),
			_Utils_Tuple2('lvertneqq', '≨︀'),
			_Utils_Tuple2('lvnE', '≨︀'),
			_Utils_Tuple2('macr', '¯'),
			_Utils_Tuple2('male', '♂'),
			_Utils_Tuple2('malt', '✠'),
			_Utils_Tuple2('maltese', '✠'),
			_Utils_Tuple2('Map', '⤅'),
			_Utils_Tuple2('map', '↦'),
			_Utils_Tuple2('mapsto', '↦'),
			_Utils_Tuple2('mapstodown', '↧'),
			_Utils_Tuple2('mapstoleft', '↤'),
			_Utils_Tuple2('mapstoup', '↥'),
			_Utils_Tuple2('marker', '▮'),
			_Utils_Tuple2('mcomma', '⨩'),
			_Utils_Tuple2('Mcy', 'М'),
			_Utils_Tuple2('mcy', 'м'),
			_Utils_Tuple2('mdash', '—'),
			_Utils_Tuple2('mDDot', '∺'),
			_Utils_Tuple2('measuredangle', '∡'),
			_Utils_Tuple2('MediumSpace', '\u205F'),
			_Utils_Tuple2('Mellintrf', 'ℳ'),
			_Utils_Tuple2('Mfr', '\uD835\uDD10'),
			_Utils_Tuple2('mfr', '\uD835\uDD2A'),
			_Utils_Tuple2('mho', '℧'),
			_Utils_Tuple2('micro', 'µ'),
			_Utils_Tuple2('midast', '*'),
			_Utils_Tuple2('midcir', '⫰'),
			_Utils_Tuple2('mid', '∣'),
			_Utils_Tuple2('middot', '·'),
			_Utils_Tuple2('minusb', '⊟'),
			_Utils_Tuple2('minus', '−'),
			_Utils_Tuple2('minusd', '∸'),
			_Utils_Tuple2('minusdu', '⨪'),
			_Utils_Tuple2('MinusPlus', '∓'),
			_Utils_Tuple2('mlcp', '⫛'),
			_Utils_Tuple2('mldr', '…'),
			_Utils_Tuple2('mnplus', '∓'),
			_Utils_Tuple2('models', '⊧'),
			_Utils_Tuple2('Mopf', '\uD835\uDD44'),
			_Utils_Tuple2('mopf', '\uD835\uDD5E'),
			_Utils_Tuple2('mp', '∓'),
			_Utils_Tuple2('mscr', '\uD835\uDCC2'),
			_Utils_Tuple2('Mscr', 'ℳ'),
			_Utils_Tuple2('mstpos', '∾'),
			_Utils_Tuple2('Mu', 'Μ'),
			_Utils_Tuple2('mu', 'μ'),
			_Utils_Tuple2('multimap', '⊸'),
			_Utils_Tuple2('mumap', '⊸'),
			_Utils_Tuple2('nabla', '∇'),
			_Utils_Tuple2('Nacute', 'Ń'),
			_Utils_Tuple2('nacute', 'ń'),
			_Utils_Tuple2('nang', '∠⃒'),
			_Utils_Tuple2('nap', '≉'),
			_Utils_Tuple2('napE', '⩰̸'),
			_Utils_Tuple2('napid', '≋̸'),
			_Utils_Tuple2('napos', 'ŉ'),
			_Utils_Tuple2('napprox', '≉'),
			_Utils_Tuple2('natural', '♮'),
			_Utils_Tuple2('naturals', 'ℕ'),
			_Utils_Tuple2('natur', '♮'),
			_Utils_Tuple2('nbsp', '\u00A0'),
			_Utils_Tuple2('nbump', '≎̸'),
			_Utils_Tuple2('nbumpe', '≏̸'),
			_Utils_Tuple2('ncap', '⩃'),
			_Utils_Tuple2('Ncaron', 'Ň'),
			_Utils_Tuple2('ncaron', 'ň'),
			_Utils_Tuple2('Ncedil', 'Ņ'),
			_Utils_Tuple2('ncedil', 'ņ'),
			_Utils_Tuple2('ncong', '≇'),
			_Utils_Tuple2('ncongdot', '⩭̸'),
			_Utils_Tuple2('ncup', '⩂'),
			_Utils_Tuple2('Ncy', 'Н'),
			_Utils_Tuple2('ncy', 'н'),
			_Utils_Tuple2('ndash', '–'),
			_Utils_Tuple2('nearhk', '⤤'),
			_Utils_Tuple2('nearr', '↗'),
			_Utils_Tuple2('neArr', '⇗'),
			_Utils_Tuple2('nearrow', '↗'),
			_Utils_Tuple2('ne', '≠'),
			_Utils_Tuple2('nedot', '≐̸'),
			_Utils_Tuple2('NegativeMediumSpace', '\u200B'),
			_Utils_Tuple2('NegativeThickSpace', '\u200B'),
			_Utils_Tuple2('NegativeThinSpace', '\u200B'),
			_Utils_Tuple2('NegativeVeryThinSpace', '\u200B'),
			_Utils_Tuple2('nequiv', '≢'),
			_Utils_Tuple2('nesear', '⤨'),
			_Utils_Tuple2('nesim', '≂̸'),
			_Utils_Tuple2('NestedGreaterGreater', '≫'),
			_Utils_Tuple2('NestedLessLess', '≪'),
			_Utils_Tuple2('NewLine', '\n'),
			_Utils_Tuple2('nexist', '∄'),
			_Utils_Tuple2('nexists', '∄'),
			_Utils_Tuple2('Nfr', '\uD835\uDD11'),
			_Utils_Tuple2('nfr', '\uD835\uDD2B'),
			_Utils_Tuple2('ngE', '≧̸'),
			_Utils_Tuple2('nge', '≱'),
			_Utils_Tuple2('ngeq', '≱'),
			_Utils_Tuple2('ngeqq', '≧̸'),
			_Utils_Tuple2('ngeqslant', '⩾̸'),
			_Utils_Tuple2('nges', '⩾̸'),
			_Utils_Tuple2('nGg', '⋙̸'),
			_Utils_Tuple2('ngsim', '≵'),
			_Utils_Tuple2('nGt', '≫⃒'),
			_Utils_Tuple2('ngt', '≯'),
			_Utils_Tuple2('ngtr', '≯'),
			_Utils_Tuple2('nGtv', '≫̸'),
			_Utils_Tuple2('nharr', '↮'),
			_Utils_Tuple2('nhArr', '⇎'),
			_Utils_Tuple2('nhpar', '⫲'),
			_Utils_Tuple2('ni', '∋'),
			_Utils_Tuple2('nis', '⋼'),
			_Utils_Tuple2('nisd', '⋺'),
			_Utils_Tuple2('niv', '∋'),
			_Utils_Tuple2('NJcy', 'Њ'),
			_Utils_Tuple2('njcy', 'њ'),
			_Utils_Tuple2('nlarr', '↚'),
			_Utils_Tuple2('nlArr', '⇍'),
			_Utils_Tuple2('nldr', '‥'),
			_Utils_Tuple2('nlE', '≦̸'),
			_Utils_Tuple2('nle', '≰'),
			_Utils_Tuple2('nleftarrow', '↚'),
			_Utils_Tuple2('nLeftarrow', '⇍'),
			_Utils_Tuple2('nleftrightarrow', '↮'),
			_Utils_Tuple2('nLeftrightarrow', '⇎'),
			_Utils_Tuple2('nleq', '≰'),
			_Utils_Tuple2('nleqq', '≦̸'),
			_Utils_Tuple2('nleqslant', '⩽̸'),
			_Utils_Tuple2('nles', '⩽̸'),
			_Utils_Tuple2('nless', '≮'),
			_Utils_Tuple2('nLl', '⋘̸'),
			_Utils_Tuple2('nlsim', '≴'),
			_Utils_Tuple2('nLt', '≪⃒'),
			_Utils_Tuple2('nlt', '≮'),
			_Utils_Tuple2('nltri', '⋪'),
			_Utils_Tuple2('nltrie', '⋬'),
			_Utils_Tuple2('nLtv', '≪̸'),
			_Utils_Tuple2('nmid', '∤'),
			_Utils_Tuple2('NoBreak', '\u2060'),
			_Utils_Tuple2('NonBreakingSpace', '\u00A0'),
			_Utils_Tuple2('nopf', '\uD835\uDD5F'),
			_Utils_Tuple2('Nopf', 'ℕ'),
			_Utils_Tuple2('Not', '⫬'),
			_Utils_Tuple2('not', '¬'),
			_Utils_Tuple2('NotCongruent', '≢'),
			_Utils_Tuple2('NotCupCap', '≭'),
			_Utils_Tuple2('NotDoubleVerticalBar', '∦'),
			_Utils_Tuple2('NotElement', '∉'),
			_Utils_Tuple2('NotEqual', '≠'),
			_Utils_Tuple2('NotEqualTilde', '≂̸'),
			_Utils_Tuple2('NotExists', '∄'),
			_Utils_Tuple2('NotGreater', '≯'),
			_Utils_Tuple2('NotGreaterEqual', '≱'),
			_Utils_Tuple2('NotGreaterFullEqual', '≧̸'),
			_Utils_Tuple2('NotGreaterGreater', '≫̸'),
			_Utils_Tuple2('NotGreaterLess', '≹'),
			_Utils_Tuple2('NotGreaterSlantEqual', '⩾̸'),
			_Utils_Tuple2('NotGreaterTilde', '≵'),
			_Utils_Tuple2('NotHumpDownHump', '≎̸'),
			_Utils_Tuple2('NotHumpEqual', '≏̸'),
			_Utils_Tuple2('notin', '∉'),
			_Utils_Tuple2('notindot', '⋵̸'),
			_Utils_Tuple2('notinE', '⋹̸'),
			_Utils_Tuple2('notinva', '∉'),
			_Utils_Tuple2('notinvb', '⋷'),
			_Utils_Tuple2('notinvc', '⋶'),
			_Utils_Tuple2('NotLeftTriangleBar', '⧏̸'),
			_Utils_Tuple2('NotLeftTriangle', '⋪'),
			_Utils_Tuple2('NotLeftTriangleEqual', '⋬'),
			_Utils_Tuple2('NotLess', '≮'),
			_Utils_Tuple2('NotLessEqual', '≰'),
			_Utils_Tuple2('NotLessGreater', '≸'),
			_Utils_Tuple2('NotLessLess', '≪̸'),
			_Utils_Tuple2('NotLessSlantEqual', '⩽̸'),
			_Utils_Tuple2('NotLessTilde', '≴'),
			_Utils_Tuple2('NotNestedGreaterGreater', '⪢̸'),
			_Utils_Tuple2('NotNestedLessLess', '⪡̸'),
			_Utils_Tuple2('notni', '∌'),
			_Utils_Tuple2('notniva', '∌'),
			_Utils_Tuple2('notnivb', '⋾'),
			_Utils_Tuple2('notnivc', '⋽'),
			_Utils_Tuple2('NotPrecedes', '⊀'),
			_Utils_Tuple2('NotPrecedesEqual', '⪯̸'),
			_Utils_Tuple2('NotPrecedesSlantEqual', '⋠'),
			_Utils_Tuple2('NotReverseElement', '∌'),
			_Utils_Tuple2('NotRightTriangleBar', '⧐̸'),
			_Utils_Tuple2('NotRightTriangle', '⋫'),
			_Utils_Tuple2('NotRightTriangleEqual', '⋭'),
			_Utils_Tuple2('NotSquareSubset', '⊏̸'),
			_Utils_Tuple2('NotSquareSubsetEqual', '⋢'),
			_Utils_Tuple2('NotSquareSuperset', '⊐̸'),
			_Utils_Tuple2('NotSquareSupersetEqual', '⋣'),
			_Utils_Tuple2('NotSubset', '⊂⃒'),
			_Utils_Tuple2('NotSubsetEqual', '⊈'),
			_Utils_Tuple2('NotSucceeds', '⊁'),
			_Utils_Tuple2('NotSucceedsEqual', '⪰̸'),
			_Utils_Tuple2('NotSucceedsSlantEqual', '⋡'),
			_Utils_Tuple2('NotSucceedsTilde', '≿̸'),
			_Utils_Tuple2('NotSuperset', '⊃⃒'),
			_Utils_Tuple2('NotSupersetEqual', '⊉'),
			_Utils_Tuple2('NotTilde', '≁'),
			_Utils_Tuple2('NotTildeEqual', '≄'),
			_Utils_Tuple2('NotTildeFullEqual', '≇'),
			_Utils_Tuple2('NotTildeTilde', '≉'),
			_Utils_Tuple2('NotVerticalBar', '∤'),
			_Utils_Tuple2('nparallel', '∦'),
			_Utils_Tuple2('npar', '∦'),
			_Utils_Tuple2('nparsl', '⫽⃥'),
			_Utils_Tuple2('npart', '∂̸'),
			_Utils_Tuple2('npolint', '⨔'),
			_Utils_Tuple2('npr', '⊀'),
			_Utils_Tuple2('nprcue', '⋠'),
			_Utils_Tuple2('nprec', '⊀'),
			_Utils_Tuple2('npreceq', '⪯̸'),
			_Utils_Tuple2('npre', '⪯̸'),
			_Utils_Tuple2('nrarrc', '⤳̸'),
			_Utils_Tuple2('nrarr', '↛'),
			_Utils_Tuple2('nrArr', '⇏'),
			_Utils_Tuple2('nrarrw', '↝̸'),
			_Utils_Tuple2('nrightarrow', '↛'),
			_Utils_Tuple2('nRightarrow', '⇏'),
			_Utils_Tuple2('nrtri', '⋫'),
			_Utils_Tuple2('nrtrie', '⋭'),
			_Utils_Tuple2('nsc', '⊁'),
			_Utils_Tuple2('nsccue', '⋡'),
			_Utils_Tuple2('nsce', '⪰̸'),
			_Utils_Tuple2('Nscr', '\uD835\uDCA9'),
			_Utils_Tuple2('nscr', '\uD835\uDCC3'),
			_Utils_Tuple2('nshortmid', '∤'),
			_Utils_Tuple2('nshortparallel', '∦'),
			_Utils_Tuple2('nsim', '≁'),
			_Utils_Tuple2('nsime', '≄'),
			_Utils_Tuple2('nsimeq', '≄'),
			_Utils_Tuple2('nsmid', '∤'),
			_Utils_Tuple2('nspar', '∦'),
			_Utils_Tuple2('nsqsube', '⋢'),
			_Utils_Tuple2('nsqsupe', '⋣'),
			_Utils_Tuple2('nsub', '⊄'),
			_Utils_Tuple2('nsubE', '⫅̸'),
			_Utils_Tuple2('nsube', '⊈'),
			_Utils_Tuple2('nsubset', '⊂⃒'),
			_Utils_Tuple2('nsubseteq', '⊈'),
			_Utils_Tuple2('nsubseteqq', '⫅̸'),
			_Utils_Tuple2('nsucc', '⊁'),
			_Utils_Tuple2('nsucceq', '⪰̸'),
			_Utils_Tuple2('nsup', '⊅'),
			_Utils_Tuple2('nsupE', '⫆̸'),
			_Utils_Tuple2('nsupe', '⊉'),
			_Utils_Tuple2('nsupset', '⊃⃒'),
			_Utils_Tuple2('nsupseteq', '⊉'),
			_Utils_Tuple2('nsupseteqq', '⫆̸'),
			_Utils_Tuple2('ntgl', '≹'),
			_Utils_Tuple2('Ntilde', 'Ñ'),
			_Utils_Tuple2('ntilde', 'ñ'),
			_Utils_Tuple2('ntlg', '≸'),
			_Utils_Tuple2('ntriangleleft', '⋪'),
			_Utils_Tuple2('ntrianglelefteq', '⋬'),
			_Utils_Tuple2('ntriangleright', '⋫'),
			_Utils_Tuple2('ntrianglerighteq', '⋭'),
			_Utils_Tuple2('Nu', 'Ν'),
			_Utils_Tuple2('nu', 'ν'),
			_Utils_Tuple2('num', '#'),
			_Utils_Tuple2('numero', '№'),
			_Utils_Tuple2('numsp', '\u2007'),
			_Utils_Tuple2('nvap', '≍⃒'),
			_Utils_Tuple2('nvdash', '⊬'),
			_Utils_Tuple2('nvDash', '⊭'),
			_Utils_Tuple2('nVdash', '⊮'),
			_Utils_Tuple2('nVDash', '⊯'),
			_Utils_Tuple2('nvge', '≥⃒'),
			_Utils_Tuple2('nvgt', '>⃒'),
			_Utils_Tuple2('nvHarr', '⤄'),
			_Utils_Tuple2('nvinfin', '⧞'),
			_Utils_Tuple2('nvlArr', '⤂'),
			_Utils_Tuple2('nvle', '≤⃒'),
			_Utils_Tuple2('nvlt', '<⃒'),
			_Utils_Tuple2('nvltrie', '⊴⃒'),
			_Utils_Tuple2('nvrArr', '⤃'),
			_Utils_Tuple2('nvrtrie', '⊵⃒'),
			_Utils_Tuple2('nvsim', '∼⃒'),
			_Utils_Tuple2('nwarhk', '⤣'),
			_Utils_Tuple2('nwarr', '↖'),
			_Utils_Tuple2('nwArr', '⇖'),
			_Utils_Tuple2('nwarrow', '↖'),
			_Utils_Tuple2('nwnear', '⤧'),
			_Utils_Tuple2('Oacute', 'Ó'),
			_Utils_Tuple2('oacute', 'ó'),
			_Utils_Tuple2('oast', '⊛'),
			_Utils_Tuple2('Ocirc', 'Ô'),
			_Utils_Tuple2('ocirc', 'ô'),
			_Utils_Tuple2('ocir', '⊚'),
			_Utils_Tuple2('Ocy', 'О'),
			_Utils_Tuple2('ocy', 'о'),
			_Utils_Tuple2('odash', '⊝'),
			_Utils_Tuple2('Odblac', 'Ő'),
			_Utils_Tuple2('odblac', 'ő'),
			_Utils_Tuple2('odiv', '⨸'),
			_Utils_Tuple2('odot', '⊙'),
			_Utils_Tuple2('odsold', '⦼'),
			_Utils_Tuple2('OElig', 'Œ'),
			_Utils_Tuple2('oelig', 'œ'),
			_Utils_Tuple2('ofcir', '⦿'),
			_Utils_Tuple2('Ofr', '\uD835\uDD12'),
			_Utils_Tuple2('ofr', '\uD835\uDD2C'),
			_Utils_Tuple2('ogon', '˛'),
			_Utils_Tuple2('Ograve', 'Ò'),
			_Utils_Tuple2('ograve', 'ò'),
			_Utils_Tuple2('ogt', '⧁'),
			_Utils_Tuple2('ohbar', '⦵'),
			_Utils_Tuple2('ohm', 'Ω'),
			_Utils_Tuple2('oint', '∮'),
			_Utils_Tuple2('olarr', '↺'),
			_Utils_Tuple2('olcir', '⦾'),
			_Utils_Tuple2('olcross', '⦻'),
			_Utils_Tuple2('oline', '‾'),
			_Utils_Tuple2('olt', '⧀'),
			_Utils_Tuple2('Omacr', 'Ō'),
			_Utils_Tuple2('omacr', 'ō'),
			_Utils_Tuple2('Omega', 'Ω'),
			_Utils_Tuple2('omega', 'ω'),
			_Utils_Tuple2('Omicron', 'Ο'),
			_Utils_Tuple2('omicron', 'ο'),
			_Utils_Tuple2('omid', '⦶'),
			_Utils_Tuple2('ominus', '⊖'),
			_Utils_Tuple2('Oopf', '\uD835\uDD46'),
			_Utils_Tuple2('oopf', '\uD835\uDD60'),
			_Utils_Tuple2('opar', '⦷'),
			_Utils_Tuple2('OpenCurlyDoubleQuote', '“'),
			_Utils_Tuple2('OpenCurlyQuote', '‘'),
			_Utils_Tuple2('operp', '⦹'),
			_Utils_Tuple2('oplus', '⊕'),
			_Utils_Tuple2('orarr', '↻'),
			_Utils_Tuple2('Or', '⩔'),
			_Utils_Tuple2('or', '∨'),
			_Utils_Tuple2('ord', '⩝'),
			_Utils_Tuple2('order', 'ℴ'),
			_Utils_Tuple2('orderof', 'ℴ'),
			_Utils_Tuple2('ordf', 'ª'),
			_Utils_Tuple2('ordm', 'º'),
			_Utils_Tuple2('origof', '⊶'),
			_Utils_Tuple2('oror', '⩖'),
			_Utils_Tuple2('orslope', '⩗'),
			_Utils_Tuple2('orv', '⩛'),
			_Utils_Tuple2('oS', 'Ⓢ'),
			_Utils_Tuple2('Oscr', '\uD835\uDCAA'),
			_Utils_Tuple2('oscr', 'ℴ'),
			_Utils_Tuple2('Oslash', 'Ø'),
			_Utils_Tuple2('oslash', 'ø'),
			_Utils_Tuple2('osol', '⊘'),
			_Utils_Tuple2('Otilde', 'Õ'),
			_Utils_Tuple2('otilde', 'õ'),
			_Utils_Tuple2('otimesas', '⨶'),
			_Utils_Tuple2('Otimes', '⨷'),
			_Utils_Tuple2('otimes', '⊗'),
			_Utils_Tuple2('Ouml', 'Ö'),
			_Utils_Tuple2('ouml', 'ö'),
			_Utils_Tuple2('ovbar', '⌽'),
			_Utils_Tuple2('OverBar', '‾'),
			_Utils_Tuple2('OverBrace', '⏞'),
			_Utils_Tuple2('OverBracket', '⎴'),
			_Utils_Tuple2('OverParenthesis', '⏜'),
			_Utils_Tuple2('para', '¶'),
			_Utils_Tuple2('parallel', '∥'),
			_Utils_Tuple2('par', '∥'),
			_Utils_Tuple2('parsim', '⫳'),
			_Utils_Tuple2('parsl', '⫽'),
			_Utils_Tuple2('part', '∂'),
			_Utils_Tuple2('PartialD', '∂'),
			_Utils_Tuple2('Pcy', 'П'),
			_Utils_Tuple2('pcy', 'п'),
			_Utils_Tuple2('percnt', '%'),
			_Utils_Tuple2('period', '.'),
			_Utils_Tuple2('permil', '‰'),
			_Utils_Tuple2('perp', '⊥'),
			_Utils_Tuple2('pertenk', '‱'),
			_Utils_Tuple2('Pfr', '\uD835\uDD13'),
			_Utils_Tuple2('pfr', '\uD835\uDD2D'),
			_Utils_Tuple2('Phi', 'Φ'),
			_Utils_Tuple2('phi', 'φ'),
			_Utils_Tuple2('phiv', 'ϕ'),
			_Utils_Tuple2('phmmat', 'ℳ'),
			_Utils_Tuple2('phone', '☎'),
			_Utils_Tuple2('Pi', 'Π'),
			_Utils_Tuple2('pi', 'π'),
			_Utils_Tuple2('pitchfork', '⋔'),
			_Utils_Tuple2('piv', 'ϖ'),
			_Utils_Tuple2('planck', 'ℏ'),
			_Utils_Tuple2('planckh', 'ℎ'),
			_Utils_Tuple2('plankv', 'ℏ'),
			_Utils_Tuple2('plusacir', '⨣'),
			_Utils_Tuple2('plusb', '⊞'),
			_Utils_Tuple2('pluscir', '⨢'),
			_Utils_Tuple2('plus', '+'),
			_Utils_Tuple2('plusdo', '∔'),
			_Utils_Tuple2('plusdu', '⨥'),
			_Utils_Tuple2('pluse', '⩲'),
			_Utils_Tuple2('PlusMinus', '±'),
			_Utils_Tuple2('plusmn', '±'),
			_Utils_Tuple2('plussim', '⨦'),
			_Utils_Tuple2('plustwo', '⨧'),
			_Utils_Tuple2('pm', '±'),
			_Utils_Tuple2('Poincareplane', 'ℌ'),
			_Utils_Tuple2('pointint', '⨕'),
			_Utils_Tuple2('popf', '\uD835\uDD61'),
			_Utils_Tuple2('Popf', 'ℙ'),
			_Utils_Tuple2('pound', '£'),
			_Utils_Tuple2('prap', '⪷'),
			_Utils_Tuple2('Pr', '⪻'),
			_Utils_Tuple2('pr', '≺'),
			_Utils_Tuple2('prcue', '≼'),
			_Utils_Tuple2('precapprox', '⪷'),
			_Utils_Tuple2('prec', '≺'),
			_Utils_Tuple2('preccurlyeq', '≼'),
			_Utils_Tuple2('Precedes', '≺'),
			_Utils_Tuple2('PrecedesEqual', '⪯'),
			_Utils_Tuple2('PrecedesSlantEqual', '≼'),
			_Utils_Tuple2('PrecedesTilde', '≾'),
			_Utils_Tuple2('preceq', '⪯'),
			_Utils_Tuple2('precnapprox', '⪹'),
			_Utils_Tuple2('precneqq', '⪵'),
			_Utils_Tuple2('precnsim', '⋨'),
			_Utils_Tuple2('pre', '⪯'),
			_Utils_Tuple2('prE', '⪳'),
			_Utils_Tuple2('precsim', '≾'),
			_Utils_Tuple2('prime', '′'),
			_Utils_Tuple2('Prime', '″'),
			_Utils_Tuple2('primes', 'ℙ'),
			_Utils_Tuple2('prnap', '⪹'),
			_Utils_Tuple2('prnE', '⪵'),
			_Utils_Tuple2('prnsim', '⋨'),
			_Utils_Tuple2('prod', '∏'),
			_Utils_Tuple2('Product', '∏'),
			_Utils_Tuple2('profalar', '⌮'),
			_Utils_Tuple2('profline', '⌒'),
			_Utils_Tuple2('profsurf', '⌓'),
			_Utils_Tuple2('prop', '∝'),
			_Utils_Tuple2('Proportional', '∝'),
			_Utils_Tuple2('Proportion', '∷'),
			_Utils_Tuple2('propto', '∝'),
			_Utils_Tuple2('prsim', '≾'),
			_Utils_Tuple2('prurel', '⊰'),
			_Utils_Tuple2('Pscr', '\uD835\uDCAB'),
			_Utils_Tuple2('pscr', '\uD835\uDCC5'),
			_Utils_Tuple2('Psi', 'Ψ'),
			_Utils_Tuple2('psi', 'ψ'),
			_Utils_Tuple2('puncsp', '\u2008'),
			_Utils_Tuple2('Qfr', '\uD835\uDD14'),
			_Utils_Tuple2('qfr', '\uD835\uDD2E'),
			_Utils_Tuple2('qint', '⨌'),
			_Utils_Tuple2('qopf', '\uD835\uDD62'),
			_Utils_Tuple2('Qopf', 'ℚ'),
			_Utils_Tuple2('qprime', '⁗'),
			_Utils_Tuple2('Qscr', '\uD835\uDCAC'),
			_Utils_Tuple2('qscr', '\uD835\uDCC6'),
			_Utils_Tuple2('quaternions', 'ℍ'),
			_Utils_Tuple2('quatint', '⨖'),
			_Utils_Tuple2('quest', '?'),
			_Utils_Tuple2('questeq', '≟'),
			_Utils_Tuple2('quot', '\"'),
			_Utils_Tuple2('QUOT', '\"'),
			_Utils_Tuple2('rAarr', '⇛'),
			_Utils_Tuple2('race', '∽̱'),
			_Utils_Tuple2('Racute', 'Ŕ'),
			_Utils_Tuple2('racute', 'ŕ'),
			_Utils_Tuple2('radic', '√'),
			_Utils_Tuple2('raemptyv', '⦳'),
			_Utils_Tuple2('rang', '⟩'),
			_Utils_Tuple2('Rang', '⟫'),
			_Utils_Tuple2('rangd', '⦒'),
			_Utils_Tuple2('range', '⦥'),
			_Utils_Tuple2('rangle', '⟩'),
			_Utils_Tuple2('raquo', '»'),
			_Utils_Tuple2('rarrap', '⥵'),
			_Utils_Tuple2('rarrb', '⇥'),
			_Utils_Tuple2('rarrbfs', '⤠'),
			_Utils_Tuple2('rarrc', '⤳'),
			_Utils_Tuple2('rarr', '→'),
			_Utils_Tuple2('Rarr', '↠'),
			_Utils_Tuple2('rArr', '⇒'),
			_Utils_Tuple2('rarrfs', '⤞'),
			_Utils_Tuple2('rarrhk', '↪'),
			_Utils_Tuple2('rarrlp', '↬'),
			_Utils_Tuple2('rarrpl', '⥅'),
			_Utils_Tuple2('rarrsim', '⥴'),
			_Utils_Tuple2('Rarrtl', '⤖'),
			_Utils_Tuple2('rarrtl', '↣'),
			_Utils_Tuple2('rarrw', '↝'),
			_Utils_Tuple2('ratail', '⤚'),
			_Utils_Tuple2('rAtail', '⤜'),
			_Utils_Tuple2('ratio', '∶'),
			_Utils_Tuple2('rationals', 'ℚ'),
			_Utils_Tuple2('rbarr', '⤍'),
			_Utils_Tuple2('rBarr', '⤏'),
			_Utils_Tuple2('RBarr', '⤐'),
			_Utils_Tuple2('rbbrk', '❳'),
			_Utils_Tuple2('rbrace', '}'),
			_Utils_Tuple2('rbrack', ']'),
			_Utils_Tuple2('rbrke', '⦌'),
			_Utils_Tuple2('rbrksld', '⦎'),
			_Utils_Tuple2('rbrkslu', '⦐'),
			_Utils_Tuple2('Rcaron', 'Ř'),
			_Utils_Tuple2('rcaron', 'ř'),
			_Utils_Tuple2('Rcedil', 'Ŗ'),
			_Utils_Tuple2('rcedil', 'ŗ'),
			_Utils_Tuple2('rceil', '⌉'),
			_Utils_Tuple2('rcub', '}'),
			_Utils_Tuple2('Rcy', 'Р'),
			_Utils_Tuple2('rcy', 'р'),
			_Utils_Tuple2('rdca', '⤷'),
			_Utils_Tuple2('rdldhar', '⥩'),
			_Utils_Tuple2('rdquo', '”'),
			_Utils_Tuple2('rdquor', '”'),
			_Utils_Tuple2('rdsh', '↳'),
			_Utils_Tuple2('real', 'ℜ'),
			_Utils_Tuple2('realine', 'ℛ'),
			_Utils_Tuple2('realpart', 'ℜ'),
			_Utils_Tuple2('reals', 'ℝ'),
			_Utils_Tuple2('Re', 'ℜ'),
			_Utils_Tuple2('rect', '▭'),
			_Utils_Tuple2('reg', '®'),
			_Utils_Tuple2('REG', '®'),
			_Utils_Tuple2('ReverseElement', '∋'),
			_Utils_Tuple2('ReverseEquilibrium', '⇋'),
			_Utils_Tuple2('ReverseUpEquilibrium', '⥯'),
			_Utils_Tuple2('rfisht', '⥽'),
			_Utils_Tuple2('rfloor', '⌋'),
			_Utils_Tuple2('rfr', '\uD835\uDD2F'),
			_Utils_Tuple2('Rfr', 'ℜ'),
			_Utils_Tuple2('rHar', '⥤'),
			_Utils_Tuple2('rhard', '⇁'),
			_Utils_Tuple2('rharu', '⇀'),
			_Utils_Tuple2('rharul', '⥬'),
			_Utils_Tuple2('Rho', 'Ρ'),
			_Utils_Tuple2('rho', 'ρ'),
			_Utils_Tuple2('rhov', 'ϱ'),
			_Utils_Tuple2('RightAngleBracket', '⟩'),
			_Utils_Tuple2('RightArrowBar', '⇥'),
			_Utils_Tuple2('rightarrow', '→'),
			_Utils_Tuple2('RightArrow', '→'),
			_Utils_Tuple2('Rightarrow', '⇒'),
			_Utils_Tuple2('RightArrowLeftArrow', '⇄'),
			_Utils_Tuple2('rightarrowtail', '↣'),
			_Utils_Tuple2('RightCeiling', '⌉'),
			_Utils_Tuple2('RightDoubleBracket', '⟧'),
			_Utils_Tuple2('RightDownTeeVector', '⥝'),
			_Utils_Tuple2('RightDownVectorBar', '⥕'),
			_Utils_Tuple2('RightDownVector', '⇂'),
			_Utils_Tuple2('RightFloor', '⌋'),
			_Utils_Tuple2('rightharpoondown', '⇁'),
			_Utils_Tuple2('rightharpoonup', '⇀'),
			_Utils_Tuple2('rightleftarrows', '⇄'),
			_Utils_Tuple2('rightleftharpoons', '⇌'),
			_Utils_Tuple2('rightrightarrows', '⇉'),
			_Utils_Tuple2('rightsquigarrow', '↝'),
			_Utils_Tuple2('RightTeeArrow', '↦'),
			_Utils_Tuple2('RightTee', '⊢'),
			_Utils_Tuple2('RightTeeVector', '⥛'),
			_Utils_Tuple2('rightthreetimes', '⋌'),
			_Utils_Tuple2('RightTriangleBar', '⧐'),
			_Utils_Tuple2('RightTriangle', '⊳'),
			_Utils_Tuple2('RightTriangleEqual', '⊵'),
			_Utils_Tuple2('RightUpDownVector', '⥏'),
			_Utils_Tuple2('RightUpTeeVector', '⥜'),
			_Utils_Tuple2('RightUpVectorBar', '⥔'),
			_Utils_Tuple2('RightUpVector', '↾'),
			_Utils_Tuple2('RightVectorBar', '⥓'),
			_Utils_Tuple2('RightVector', '⇀'),
			_Utils_Tuple2('ring', '˚'),
			_Utils_Tuple2('risingdotseq', '≓'),
			_Utils_Tuple2('rlarr', '⇄'),
			_Utils_Tuple2('rlhar', '⇌'),
			_Utils_Tuple2('rlm', '\u200F'),
			_Utils_Tuple2('rmoustache', '⎱'),
			_Utils_Tuple2('rmoust', '⎱'),
			_Utils_Tuple2('rnmid', '⫮'),
			_Utils_Tuple2('roang', '⟭'),
			_Utils_Tuple2('roarr', '⇾'),
			_Utils_Tuple2('robrk', '⟧'),
			_Utils_Tuple2('ropar', '⦆'),
			_Utils_Tuple2('ropf', '\uD835\uDD63'),
			_Utils_Tuple2('Ropf', 'ℝ'),
			_Utils_Tuple2('roplus', '⨮'),
			_Utils_Tuple2('rotimes', '⨵'),
			_Utils_Tuple2('RoundImplies', '⥰'),
			_Utils_Tuple2('rpar', ')'),
			_Utils_Tuple2('rpargt', '⦔'),
			_Utils_Tuple2('rppolint', '⨒'),
			_Utils_Tuple2('rrarr', '⇉'),
			_Utils_Tuple2('Rrightarrow', '⇛'),
			_Utils_Tuple2('rsaquo', '›'),
			_Utils_Tuple2('rscr', '\uD835\uDCC7'),
			_Utils_Tuple2('Rscr', 'ℛ'),
			_Utils_Tuple2('rsh', '↱'),
			_Utils_Tuple2('Rsh', '↱'),
			_Utils_Tuple2('rsqb', ']'),
			_Utils_Tuple2('rsquo', '’'),
			_Utils_Tuple2('rsquor', '’'),
			_Utils_Tuple2('rthree', '⋌'),
			_Utils_Tuple2('rtimes', '⋊'),
			_Utils_Tuple2('rtri', '▹'),
			_Utils_Tuple2('rtrie', '⊵'),
			_Utils_Tuple2('rtrif', '▸'),
			_Utils_Tuple2('rtriltri', '⧎'),
			_Utils_Tuple2('RuleDelayed', '⧴'),
			_Utils_Tuple2('ruluhar', '⥨'),
			_Utils_Tuple2('rx', '℞'),
			_Utils_Tuple2('Sacute', 'Ś'),
			_Utils_Tuple2('sacute', 'ś'),
			_Utils_Tuple2('sbquo', '‚'),
			_Utils_Tuple2('scap', '⪸'),
			_Utils_Tuple2('Scaron', 'Š'),
			_Utils_Tuple2('scaron', 'š'),
			_Utils_Tuple2('Sc', '⪼'),
			_Utils_Tuple2('sc', '≻'),
			_Utils_Tuple2('sccue', '≽'),
			_Utils_Tuple2('sce', '⪰'),
			_Utils_Tuple2('scE', '⪴'),
			_Utils_Tuple2('Scedil', 'Ş'),
			_Utils_Tuple2('scedil', 'ş'),
			_Utils_Tuple2('Scirc', 'Ŝ'),
			_Utils_Tuple2('scirc', 'ŝ'),
			_Utils_Tuple2('scnap', '⪺'),
			_Utils_Tuple2('scnE', '⪶'),
			_Utils_Tuple2('scnsim', '⋩'),
			_Utils_Tuple2('scpolint', '⨓'),
			_Utils_Tuple2('scsim', '≿'),
			_Utils_Tuple2('Scy', 'С'),
			_Utils_Tuple2('scy', 'с'),
			_Utils_Tuple2('sdotb', '⊡'),
			_Utils_Tuple2('sdot', '⋅'),
			_Utils_Tuple2('sdote', '⩦'),
			_Utils_Tuple2('searhk', '⤥'),
			_Utils_Tuple2('searr', '↘'),
			_Utils_Tuple2('seArr', '⇘'),
			_Utils_Tuple2('searrow', '↘'),
			_Utils_Tuple2('sect', '§'),
			_Utils_Tuple2('semi', ';'),
			_Utils_Tuple2('seswar', '⤩'),
			_Utils_Tuple2('setminus', '∖'),
			_Utils_Tuple2('setmn', '∖'),
			_Utils_Tuple2('sext', '✶'),
			_Utils_Tuple2('Sfr', '\uD835\uDD16'),
			_Utils_Tuple2('sfr', '\uD835\uDD30'),
			_Utils_Tuple2('sfrown', '⌢'),
			_Utils_Tuple2('sharp', '♯'),
			_Utils_Tuple2('SHCHcy', 'Щ'),
			_Utils_Tuple2('shchcy', 'щ'),
			_Utils_Tuple2('SHcy', 'Ш'),
			_Utils_Tuple2('shcy', 'ш'),
			_Utils_Tuple2('ShortDownArrow', '↓'),
			_Utils_Tuple2('ShortLeftArrow', '←'),
			_Utils_Tuple2('shortmid', '∣'),
			_Utils_Tuple2('shortparallel', '∥'),
			_Utils_Tuple2('ShortRightArrow', '→'),
			_Utils_Tuple2('ShortUpArrow', '↑'),
			_Utils_Tuple2('shy', '\u00AD'),
			_Utils_Tuple2('Sigma', 'Σ'),
			_Utils_Tuple2('sigma', 'σ'),
			_Utils_Tuple2('sigmaf', 'ς'),
			_Utils_Tuple2('sigmav', 'ς'),
			_Utils_Tuple2('sim', '∼'),
			_Utils_Tuple2('simdot', '⩪'),
			_Utils_Tuple2('sime', '≃'),
			_Utils_Tuple2('simeq', '≃'),
			_Utils_Tuple2('simg', '⪞'),
			_Utils_Tuple2('simgE', '⪠'),
			_Utils_Tuple2('siml', '⪝'),
			_Utils_Tuple2('simlE', '⪟'),
			_Utils_Tuple2('simne', '≆'),
			_Utils_Tuple2('simplus', '⨤'),
			_Utils_Tuple2('simrarr', '⥲'),
			_Utils_Tuple2('slarr', '←'),
			_Utils_Tuple2('SmallCircle', '∘'),
			_Utils_Tuple2('smallsetminus', '∖'),
			_Utils_Tuple2('smashp', '⨳'),
			_Utils_Tuple2('smeparsl', '⧤'),
			_Utils_Tuple2('smid', '∣'),
			_Utils_Tuple2('smile', '⌣'),
			_Utils_Tuple2('smt', '⪪'),
			_Utils_Tuple2('smte', '⪬'),
			_Utils_Tuple2('smtes', '⪬︀'),
			_Utils_Tuple2('SOFTcy', 'Ь'),
			_Utils_Tuple2('softcy', 'ь'),
			_Utils_Tuple2('solbar', '⌿'),
			_Utils_Tuple2('solb', '⧄'),
			_Utils_Tuple2('sol', '/'),
			_Utils_Tuple2('Sopf', '\uD835\uDD4A'),
			_Utils_Tuple2('sopf', '\uD835\uDD64'),
			_Utils_Tuple2('spades', '♠'),
			_Utils_Tuple2('spadesuit', '♠'),
			_Utils_Tuple2('spar', '∥'),
			_Utils_Tuple2('sqcap', '⊓'),
			_Utils_Tuple2('sqcaps', '⊓︀'),
			_Utils_Tuple2('sqcup', '⊔'),
			_Utils_Tuple2('sqcups', '⊔︀'),
			_Utils_Tuple2('Sqrt', '√'),
			_Utils_Tuple2('sqsub', '⊏'),
			_Utils_Tuple2('sqsube', '⊑'),
			_Utils_Tuple2('sqsubset', '⊏'),
			_Utils_Tuple2('sqsubseteq', '⊑'),
			_Utils_Tuple2('sqsup', '⊐'),
			_Utils_Tuple2('sqsupe', '⊒'),
			_Utils_Tuple2('sqsupset', '⊐'),
			_Utils_Tuple2('sqsupseteq', '⊒'),
			_Utils_Tuple2('square', '□'),
			_Utils_Tuple2('Square', '□'),
			_Utils_Tuple2('SquareIntersection', '⊓'),
			_Utils_Tuple2('SquareSubset', '⊏'),
			_Utils_Tuple2('SquareSubsetEqual', '⊑'),
			_Utils_Tuple2('SquareSuperset', '⊐'),
			_Utils_Tuple2('SquareSupersetEqual', '⊒'),
			_Utils_Tuple2('SquareUnion', '⊔'),
			_Utils_Tuple2('squarf', '▪'),
			_Utils_Tuple2('squ', '□'),
			_Utils_Tuple2('squf', '▪'),
			_Utils_Tuple2('srarr', '→'),
			_Utils_Tuple2('Sscr', '\uD835\uDCAE'),
			_Utils_Tuple2('sscr', '\uD835\uDCC8'),
			_Utils_Tuple2('ssetmn', '∖'),
			_Utils_Tuple2('ssmile', '⌣'),
			_Utils_Tuple2('sstarf', '⋆'),
			_Utils_Tuple2('Star', '⋆'),
			_Utils_Tuple2('star', '☆'),
			_Utils_Tuple2('starf', '★'),
			_Utils_Tuple2('straightepsilon', 'ϵ'),
			_Utils_Tuple2('straightphi', 'ϕ'),
			_Utils_Tuple2('strns', '¯'),
			_Utils_Tuple2('sub', '⊂'),
			_Utils_Tuple2('Sub', '⋐'),
			_Utils_Tuple2('subdot', '⪽'),
			_Utils_Tuple2('subE', '⫅'),
			_Utils_Tuple2('sube', '⊆'),
			_Utils_Tuple2('subedot', '⫃'),
			_Utils_Tuple2('submult', '⫁'),
			_Utils_Tuple2('subnE', '⫋'),
			_Utils_Tuple2('subne', '⊊'),
			_Utils_Tuple2('subplus', '⪿'),
			_Utils_Tuple2('subrarr', '⥹'),
			_Utils_Tuple2('subset', '⊂'),
			_Utils_Tuple2('Subset', '⋐'),
			_Utils_Tuple2('subseteq', '⊆'),
			_Utils_Tuple2('subseteqq', '⫅'),
			_Utils_Tuple2('SubsetEqual', '⊆'),
			_Utils_Tuple2('subsetneq', '⊊'),
			_Utils_Tuple2('subsetneqq', '⫋'),
			_Utils_Tuple2('subsim', '⫇'),
			_Utils_Tuple2('subsub', '⫕'),
			_Utils_Tuple2('subsup', '⫓'),
			_Utils_Tuple2('succapprox', '⪸'),
			_Utils_Tuple2('succ', '≻'),
			_Utils_Tuple2('succcurlyeq', '≽'),
			_Utils_Tuple2('Succeeds', '≻'),
			_Utils_Tuple2('SucceedsEqual', '⪰'),
			_Utils_Tuple2('SucceedsSlantEqual', '≽'),
			_Utils_Tuple2('SucceedsTilde', '≿'),
			_Utils_Tuple2('succeq', '⪰'),
			_Utils_Tuple2('succnapprox', '⪺'),
			_Utils_Tuple2('succneqq', '⪶'),
			_Utils_Tuple2('succnsim', '⋩'),
			_Utils_Tuple2('succsim', '≿'),
			_Utils_Tuple2('SuchThat', '∋'),
			_Utils_Tuple2('sum', '∑'),
			_Utils_Tuple2('Sum', '∑'),
			_Utils_Tuple2('sung', '♪'),
			_Utils_Tuple2('sup1', '¹'),
			_Utils_Tuple2('sup2', '²'),
			_Utils_Tuple2('sup3', '³'),
			_Utils_Tuple2('sup', '⊃'),
			_Utils_Tuple2('Sup', '⋑'),
			_Utils_Tuple2('supdot', '⪾'),
			_Utils_Tuple2('supdsub', '⫘'),
			_Utils_Tuple2('supE', '⫆'),
			_Utils_Tuple2('supe', '⊇'),
			_Utils_Tuple2('supedot', '⫄'),
			_Utils_Tuple2('Superset', '⊃'),
			_Utils_Tuple2('SupersetEqual', '⊇'),
			_Utils_Tuple2('suphsol', '⟉'),
			_Utils_Tuple2('suphsub', '⫗'),
			_Utils_Tuple2('suplarr', '⥻'),
			_Utils_Tuple2('supmult', '⫂'),
			_Utils_Tuple2('supnE', '⫌'),
			_Utils_Tuple2('supne', '⊋'),
			_Utils_Tuple2('supplus', '⫀'),
			_Utils_Tuple2('supset', '⊃'),
			_Utils_Tuple2('Supset', '⋑'),
			_Utils_Tuple2('supseteq', '⊇'),
			_Utils_Tuple2('supseteqq', '⫆'),
			_Utils_Tuple2('supsetneq', '⊋'),
			_Utils_Tuple2('supsetneqq', '⫌'),
			_Utils_Tuple2('supsim', '⫈'),
			_Utils_Tuple2('supsub', '⫔'),
			_Utils_Tuple2('supsup', '⫖'),
			_Utils_Tuple2('swarhk', '⤦'),
			_Utils_Tuple2('swarr', '↙'),
			_Utils_Tuple2('swArr', '⇙'),
			_Utils_Tuple2('swarrow', '↙'),
			_Utils_Tuple2('swnwar', '⤪'),
			_Utils_Tuple2('szlig', 'ß'),
			_Utils_Tuple2('Tab', '\t'),
			_Utils_Tuple2('target', '⌖'),
			_Utils_Tuple2('Tau', 'Τ'),
			_Utils_Tuple2('tau', 'τ'),
			_Utils_Tuple2('tbrk', '⎴'),
			_Utils_Tuple2('Tcaron', 'Ť'),
			_Utils_Tuple2('tcaron', 'ť'),
			_Utils_Tuple2('Tcedil', 'Ţ'),
			_Utils_Tuple2('tcedil', 'ţ'),
			_Utils_Tuple2('Tcy', 'Т'),
			_Utils_Tuple2('tcy', 'т'),
			_Utils_Tuple2('tdot', '⃛'),
			_Utils_Tuple2('telrec', '⌕'),
			_Utils_Tuple2('Tfr', '\uD835\uDD17'),
			_Utils_Tuple2('tfr', '\uD835\uDD31'),
			_Utils_Tuple2('there4', '∴'),
			_Utils_Tuple2('therefore', '∴'),
			_Utils_Tuple2('Therefore', '∴'),
			_Utils_Tuple2('Theta', 'Θ'),
			_Utils_Tuple2('theta', 'θ'),
			_Utils_Tuple2('thetasym', 'ϑ'),
			_Utils_Tuple2('thetav', 'ϑ'),
			_Utils_Tuple2('thickapprox', '≈'),
			_Utils_Tuple2('thicksim', '∼'),
			_Utils_Tuple2('ThickSpace', '\u205F\u200A'),
			_Utils_Tuple2('ThinSpace', '\u2009'),
			_Utils_Tuple2('thinsp', '\u2009'),
			_Utils_Tuple2('thkap', '≈'),
			_Utils_Tuple2('thksim', '∼'),
			_Utils_Tuple2('THORN', 'Þ'),
			_Utils_Tuple2('thorn', 'þ'),
			_Utils_Tuple2('tilde', '˜'),
			_Utils_Tuple2('Tilde', '∼'),
			_Utils_Tuple2('TildeEqual', '≃'),
			_Utils_Tuple2('TildeFullEqual', '≅'),
			_Utils_Tuple2('TildeTilde', '≈'),
			_Utils_Tuple2('timesbar', '⨱'),
			_Utils_Tuple2('timesb', '⊠'),
			_Utils_Tuple2('times', '×'),
			_Utils_Tuple2('timesd', '⨰'),
			_Utils_Tuple2('tint', '∭'),
			_Utils_Tuple2('toea', '⤨'),
			_Utils_Tuple2('topbot', '⌶'),
			_Utils_Tuple2('topcir', '⫱'),
			_Utils_Tuple2('top', '⊤'),
			_Utils_Tuple2('Topf', '\uD835\uDD4B'),
			_Utils_Tuple2('topf', '\uD835\uDD65'),
			_Utils_Tuple2('topfork', '⫚'),
			_Utils_Tuple2('tosa', '⤩'),
			_Utils_Tuple2('tprime', '‴'),
			_Utils_Tuple2('trade', '™'),
			_Utils_Tuple2('TRADE', '™'),
			_Utils_Tuple2('triangle', '▵'),
			_Utils_Tuple2('triangledown', '▿'),
			_Utils_Tuple2('triangleleft', '◃'),
			_Utils_Tuple2('trianglelefteq', '⊴'),
			_Utils_Tuple2('triangleq', '≜'),
			_Utils_Tuple2('triangleright', '▹'),
			_Utils_Tuple2('trianglerighteq', '⊵'),
			_Utils_Tuple2('tridot', '◬'),
			_Utils_Tuple2('trie', '≜'),
			_Utils_Tuple2('triminus', '⨺'),
			_Utils_Tuple2('TripleDot', '⃛'),
			_Utils_Tuple2('triplus', '⨹'),
			_Utils_Tuple2('trisb', '⧍'),
			_Utils_Tuple2('tritime', '⨻'),
			_Utils_Tuple2('trpezium', '⏢'),
			_Utils_Tuple2('Tscr', '\uD835\uDCAF'),
			_Utils_Tuple2('tscr', '\uD835\uDCC9'),
			_Utils_Tuple2('TScy', 'Ц'),
			_Utils_Tuple2('tscy', 'ц'),
			_Utils_Tuple2('TSHcy', 'Ћ'),
			_Utils_Tuple2('tshcy', 'ћ'),
			_Utils_Tuple2('Tstrok', 'Ŧ'),
			_Utils_Tuple2('tstrok', 'ŧ'),
			_Utils_Tuple2('twixt', '≬'),
			_Utils_Tuple2('twoheadleftarrow', '↞'),
			_Utils_Tuple2('twoheadrightarrow', '↠'),
			_Utils_Tuple2('Uacute', 'Ú'),
			_Utils_Tuple2('uacute', 'ú'),
			_Utils_Tuple2('uarr', '↑'),
			_Utils_Tuple2('Uarr', '↟'),
			_Utils_Tuple2('uArr', '⇑'),
			_Utils_Tuple2('Uarrocir', '⥉'),
			_Utils_Tuple2('Ubrcy', 'Ў'),
			_Utils_Tuple2('ubrcy', 'ў'),
			_Utils_Tuple2('Ubreve', 'Ŭ'),
			_Utils_Tuple2('ubreve', 'ŭ'),
			_Utils_Tuple2('Ucirc', 'Û'),
			_Utils_Tuple2('ucirc', 'û'),
			_Utils_Tuple2('Ucy', 'У'),
			_Utils_Tuple2('ucy', 'у'),
			_Utils_Tuple2('udarr', '⇅'),
			_Utils_Tuple2('Udblac', 'Ű'),
			_Utils_Tuple2('udblac', 'ű'),
			_Utils_Tuple2('udhar', '⥮'),
			_Utils_Tuple2('ufisht', '⥾'),
			_Utils_Tuple2('Ufr', '\uD835\uDD18'),
			_Utils_Tuple2('ufr', '\uD835\uDD32'),
			_Utils_Tuple2('Ugrave', 'Ù'),
			_Utils_Tuple2('ugrave', 'ù'),
			_Utils_Tuple2('uHar', '⥣'),
			_Utils_Tuple2('uharl', '↿'),
			_Utils_Tuple2('uharr', '↾'),
			_Utils_Tuple2('uhblk', '▀'),
			_Utils_Tuple2('ulcorn', '⌜'),
			_Utils_Tuple2('ulcorner', '⌜'),
			_Utils_Tuple2('ulcrop', '⌏'),
			_Utils_Tuple2('ultri', '◸'),
			_Utils_Tuple2('Umacr', 'Ū'),
			_Utils_Tuple2('umacr', 'ū'),
			_Utils_Tuple2('uml', '¨'),
			_Utils_Tuple2('UnderBar', '_'),
			_Utils_Tuple2('UnderBrace', '⏟'),
			_Utils_Tuple2('UnderBracket', '⎵'),
			_Utils_Tuple2('UnderParenthesis', '⏝'),
			_Utils_Tuple2('Union', '⋃'),
			_Utils_Tuple2('UnionPlus', '⊎'),
			_Utils_Tuple2('Uogon', 'Ų'),
			_Utils_Tuple2('uogon', 'ų'),
			_Utils_Tuple2('Uopf', '\uD835\uDD4C'),
			_Utils_Tuple2('uopf', '\uD835\uDD66'),
			_Utils_Tuple2('UpArrowBar', '⤒'),
			_Utils_Tuple2('uparrow', '↑'),
			_Utils_Tuple2('UpArrow', '↑'),
			_Utils_Tuple2('Uparrow', '⇑'),
			_Utils_Tuple2('UpArrowDownArrow', '⇅'),
			_Utils_Tuple2('updownarrow', '↕'),
			_Utils_Tuple2('UpDownArrow', '↕'),
			_Utils_Tuple2('Updownarrow', '⇕'),
			_Utils_Tuple2('UpEquilibrium', '⥮'),
			_Utils_Tuple2('upharpoonleft', '↿'),
			_Utils_Tuple2('upharpoonright', '↾'),
			_Utils_Tuple2('uplus', '⊎'),
			_Utils_Tuple2('UpperLeftArrow', '↖'),
			_Utils_Tuple2('UpperRightArrow', '↗'),
			_Utils_Tuple2('upsi', 'υ'),
			_Utils_Tuple2('Upsi', 'ϒ'),
			_Utils_Tuple2('upsih', 'ϒ'),
			_Utils_Tuple2('Upsilon', 'Υ'),
			_Utils_Tuple2('upsilon', 'υ'),
			_Utils_Tuple2('UpTeeArrow', '↥'),
			_Utils_Tuple2('UpTee', '⊥'),
			_Utils_Tuple2('upuparrows', '⇈'),
			_Utils_Tuple2('urcorn', '⌝'),
			_Utils_Tuple2('urcorner', '⌝'),
			_Utils_Tuple2('urcrop', '⌎'),
			_Utils_Tuple2('Uring', 'Ů'),
			_Utils_Tuple2('uring', 'ů'),
			_Utils_Tuple2('urtri', '◹'),
			_Utils_Tuple2('Uscr', '\uD835\uDCB0'),
			_Utils_Tuple2('uscr', '\uD835\uDCCA'),
			_Utils_Tuple2('utdot', '⋰'),
			_Utils_Tuple2('Utilde', 'Ũ'),
			_Utils_Tuple2('utilde', 'ũ'),
			_Utils_Tuple2('utri', '▵'),
			_Utils_Tuple2('utrif', '▴'),
			_Utils_Tuple2('uuarr', '⇈'),
			_Utils_Tuple2('Uuml', 'Ü'),
			_Utils_Tuple2('uuml', 'ü'),
			_Utils_Tuple2('uwangle', '⦧'),
			_Utils_Tuple2('vangrt', '⦜'),
			_Utils_Tuple2('varepsilon', 'ϵ'),
			_Utils_Tuple2('varkappa', 'ϰ'),
			_Utils_Tuple2('varnothing', '∅'),
			_Utils_Tuple2('varphi', 'ϕ'),
			_Utils_Tuple2('varpi', 'ϖ'),
			_Utils_Tuple2('varpropto', '∝'),
			_Utils_Tuple2('varr', '↕'),
			_Utils_Tuple2('vArr', '⇕'),
			_Utils_Tuple2('varrho', 'ϱ'),
			_Utils_Tuple2('varsigma', 'ς'),
			_Utils_Tuple2('varsubsetneq', '⊊︀'),
			_Utils_Tuple2('varsubsetneqq', '⫋︀'),
			_Utils_Tuple2('varsupsetneq', '⊋︀'),
			_Utils_Tuple2('varsupsetneqq', '⫌︀'),
			_Utils_Tuple2('vartheta', 'ϑ'),
			_Utils_Tuple2('vartriangleleft', '⊲'),
			_Utils_Tuple2('vartriangleright', '⊳'),
			_Utils_Tuple2('vBar', '⫨'),
			_Utils_Tuple2('Vbar', '⫫'),
			_Utils_Tuple2('vBarv', '⫩'),
			_Utils_Tuple2('Vcy', 'В'),
			_Utils_Tuple2('vcy', 'в'),
			_Utils_Tuple2('vdash', '⊢'),
			_Utils_Tuple2('vDash', '⊨'),
			_Utils_Tuple2('Vdash', '⊩'),
			_Utils_Tuple2('VDash', '⊫'),
			_Utils_Tuple2('Vdashl', '⫦'),
			_Utils_Tuple2('veebar', '⊻'),
			_Utils_Tuple2('vee', '∨'),
			_Utils_Tuple2('Vee', '⋁'),
			_Utils_Tuple2('veeeq', '≚'),
			_Utils_Tuple2('vellip', '⋮'),
			_Utils_Tuple2('verbar', '|'),
			_Utils_Tuple2('Verbar', '‖'),
			_Utils_Tuple2('vert', '|'),
			_Utils_Tuple2('Vert', '‖'),
			_Utils_Tuple2('VerticalBar', '∣'),
			_Utils_Tuple2('VerticalLine', '|'),
			_Utils_Tuple2('VerticalSeparator', '❘'),
			_Utils_Tuple2('VerticalTilde', '≀'),
			_Utils_Tuple2('VeryThinSpace', '\u200A'),
			_Utils_Tuple2('Vfr', '\uD835\uDD19'),
			_Utils_Tuple2('vfr', '\uD835\uDD33'),
			_Utils_Tuple2('vltri', '⊲'),
			_Utils_Tuple2('vnsub', '⊂⃒'),
			_Utils_Tuple2('vnsup', '⊃⃒'),
			_Utils_Tuple2('Vopf', '\uD835\uDD4D'),
			_Utils_Tuple2('vopf', '\uD835\uDD67'),
			_Utils_Tuple2('vprop', '∝'),
			_Utils_Tuple2('vrtri', '⊳'),
			_Utils_Tuple2('Vscr', '\uD835\uDCB1'),
			_Utils_Tuple2('vscr', '\uD835\uDCCB'),
			_Utils_Tuple2('vsubnE', '⫋︀'),
			_Utils_Tuple2('vsubne', '⊊︀'),
			_Utils_Tuple2('vsupnE', '⫌︀'),
			_Utils_Tuple2('vsupne', '⊋︀'),
			_Utils_Tuple2('Vvdash', '⊪'),
			_Utils_Tuple2('vzigzag', '⦚'),
			_Utils_Tuple2('Wcirc', 'Ŵ'),
			_Utils_Tuple2('wcirc', 'ŵ'),
			_Utils_Tuple2('wedbar', '⩟'),
			_Utils_Tuple2('wedge', '∧'),
			_Utils_Tuple2('Wedge', '⋀'),
			_Utils_Tuple2('wedgeq', '≙'),
			_Utils_Tuple2('weierp', '℘'),
			_Utils_Tuple2('Wfr', '\uD835\uDD1A'),
			_Utils_Tuple2('wfr', '\uD835\uDD34'),
			_Utils_Tuple2('Wopf', '\uD835\uDD4E'),
			_Utils_Tuple2('wopf', '\uD835\uDD68'),
			_Utils_Tuple2('wp', '℘'),
			_Utils_Tuple2('wr', '≀'),
			_Utils_Tuple2('wreath', '≀'),
			_Utils_Tuple2('Wscr', '\uD835\uDCB2'),
			_Utils_Tuple2('wscr', '\uD835\uDCCC'),
			_Utils_Tuple2('xcap', '⋂'),
			_Utils_Tuple2('xcirc', '◯'),
			_Utils_Tuple2('xcup', '⋃'),
			_Utils_Tuple2('xdtri', '▽'),
			_Utils_Tuple2('Xfr', '\uD835\uDD1B'),
			_Utils_Tuple2('xfr', '\uD835\uDD35'),
			_Utils_Tuple2('xharr', '⟷'),
			_Utils_Tuple2('xhArr', '⟺'),
			_Utils_Tuple2('Xi', 'Ξ'),
			_Utils_Tuple2('xi', 'ξ'),
			_Utils_Tuple2('xlarr', '⟵'),
			_Utils_Tuple2('xlArr', '⟸'),
			_Utils_Tuple2('xmap', '⟼'),
			_Utils_Tuple2('xnis', '⋻'),
			_Utils_Tuple2('xodot', '⨀'),
			_Utils_Tuple2('Xopf', '\uD835\uDD4F'),
			_Utils_Tuple2('xopf', '\uD835\uDD69'),
			_Utils_Tuple2('xoplus', '⨁'),
			_Utils_Tuple2('xotime', '⨂'),
			_Utils_Tuple2('xrarr', '⟶'),
			_Utils_Tuple2('xrArr', '⟹'),
			_Utils_Tuple2('Xscr', '\uD835\uDCB3'),
			_Utils_Tuple2('xscr', '\uD835\uDCCD'),
			_Utils_Tuple2('xsqcup', '⨆'),
			_Utils_Tuple2('xuplus', '⨄'),
			_Utils_Tuple2('xutri', '△'),
			_Utils_Tuple2('xvee', '⋁'),
			_Utils_Tuple2('xwedge', '⋀'),
			_Utils_Tuple2('Yacute', 'Ý'),
			_Utils_Tuple2('yacute', 'ý'),
			_Utils_Tuple2('YAcy', 'Я'),
			_Utils_Tuple2('yacy', 'я'),
			_Utils_Tuple2('Ycirc', 'Ŷ'),
			_Utils_Tuple2('ycirc', 'ŷ'),
			_Utils_Tuple2('Ycy', 'Ы'),
			_Utils_Tuple2('ycy', 'ы'),
			_Utils_Tuple2('yen', '¥'),
			_Utils_Tuple2('Yfr', '\uD835\uDD1C'),
			_Utils_Tuple2('yfr', '\uD835\uDD36'),
			_Utils_Tuple2('YIcy', 'Ї'),
			_Utils_Tuple2('yicy', 'ї'),
			_Utils_Tuple2('Yopf', '\uD835\uDD50'),
			_Utils_Tuple2('yopf', '\uD835\uDD6A'),
			_Utils_Tuple2('Yscr', '\uD835\uDCB4'),
			_Utils_Tuple2('yscr', '\uD835\uDCCE'),
			_Utils_Tuple2('YUcy', 'Ю'),
			_Utils_Tuple2('yucy', 'ю'),
			_Utils_Tuple2('yuml', 'ÿ'),
			_Utils_Tuple2('Yuml', 'Ÿ'),
			_Utils_Tuple2('Zacute', 'Ź'),
			_Utils_Tuple2('zacute', 'ź'),
			_Utils_Tuple2('Zcaron', 'Ž'),
			_Utils_Tuple2('zcaron', 'ž'),
			_Utils_Tuple2('Zcy', 'З'),
			_Utils_Tuple2('zcy', 'з'),
			_Utils_Tuple2('Zdot', 'Ż'),
			_Utils_Tuple2('zdot', 'ż'),
			_Utils_Tuple2('zeetrf', 'ℨ'),
			_Utils_Tuple2('ZeroWidthSpace', '\u200B'),
			_Utils_Tuple2('Zeta', 'Ζ'),
			_Utils_Tuple2('zeta', 'ζ'),
			_Utils_Tuple2('zfr', '\uD835\uDD37'),
			_Utils_Tuple2('Zfr', 'ℨ'),
			_Utils_Tuple2('ZHcy', 'Ж'),
			_Utils_Tuple2('zhcy', 'ж'),
			_Utils_Tuple2('zigrarr', '⇝'),
			_Utils_Tuple2('zopf', '\uD835\uDD6B'),
			_Utils_Tuple2('Zopf', 'ℤ'),
			_Utils_Tuple2('Zscr', '\uD835\uDCB5'),
			_Utils_Tuple2('zscr', '\uD835\uDCCF'),
			_Utils_Tuple2('zwj', '\u200D'),
			_Utils_Tuple2('zwnj', '\u200C')
		]));
var $hecrj$html_parser$Html$Parser$namedCharacterReference = A2(
	$elm$parser$Parser$map,
	function (reference) {
		return A2(
			$elm$core$Maybe$withDefault,
			'&' + (reference + ';'),
			A2($elm$core$Dict$get, reference, $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict));
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isAlpha)));
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $elm$core$Char$isHexDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return ((48 <= code) && (code <= 57)) || (((65 <= code) && (code <= 70)) || ((97 <= code) && (code <= 102)));
};
var $hecrj$html_parser$Html$Parser$hexadecimal = A2(
	$elm$parser$Parser$andThen,
	function (hex) {
		var _v0 = $rtfeldman$elm_hex$Hex$fromString(
			$elm$core$String$toLower(hex));
		if (!_v0.$) {
			var value = _v0.a;
			return $elm$parser$Parser$succeed(value);
		} else {
			var error = _v0.a;
			return $elm$parser$Parser$problem(error);
		}
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isHexDigit)));
var $hecrj$html_parser$Html$Parser$numericCharacterReference = function () {
	var codepoint = $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						function (c) {
							return (c === 'x') || (c === 'X');
						})),
				$hecrj$html_parser$Html$Parser$hexadecimal),
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq('0'))),
				$elm$parser$Parser$int)
			]));
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq('#'))),
		A2(
			$elm$parser$Parser$map,
			A2($elm$core$Basics$composeR, $elm$core$Char$fromCode, $elm$core$String$fromChar),
			codepoint));
}();
var $hecrj$html_parser$Html$Parser$characterReference = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('&'))),
	$elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$namedCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$numericCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				$elm$parser$Parser$succeed('&')
			])));
var $hecrj$html_parser$Html$Parser$tagAttributeQuotedValue = function (quote) {
	var isQuotedValueChar = function (c) {
		return (!_Utils_eq(c, quote)) && (c !== '&');
	};
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))),
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$map,
				$elm$core$String$join(''),
				$hecrj$html_parser$Html$Parser$many(
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$getChompedString(
								$hecrj$html_parser$Html$Parser$chompOneOrMore(isQuotedValueChar)),
								$hecrj$html_parser$Html$Parser$characterReference
							])))),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))));
};
var $hecrj$html_parser$Html$Parser$oneOrMore = F2(
	function (type_, parser_) {
		return A2(
			$elm$parser$Parser$loop,
			_List_Nil,
			function (list) {
				return $elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$map,
							function (_new) {
								return $elm$parser$Parser$Loop(
									A2($elm$core$List$cons, _new, list));
							},
							parser_),
							$elm$core$List$isEmpty(list) ? $elm$parser$Parser$problem('expecting at least one ' + type_) : $elm$parser$Parser$succeed(
							$elm$parser$Parser$Done(
								$elm$core$List$reverse(list)))
						]));
			});
	});
var $hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue = function () {
	var isUnquotedValueChar = function (c) {
		return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '=') && ((c !== '<') && ((c !== '>') && ((c !== '`') && (c !== '&')))))));
	};
	return A2(
		$elm$parser$Parser$map,
		$elm$core$String$join(''),
		A2(
			$hecrj$html_parser$Html$Parser$oneOrMore,
			'attribute value',
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$getChompedString(
						$hecrj$html_parser$Html$Parser$chompOneOrMore(isUnquotedValueChar)),
						$hecrj$html_parser$Html$Parser$characterReference
					]))));
}();
var $hecrj$html_parser$Html$Parser$tagAttributeValue = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('='))),
				$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue,
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\"'),
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\'')
					]))),
			$elm$parser$Parser$succeed('')
		]));
var $hecrj$html_parser$Html$Parser$tagAttribute = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Tuple$pair),
		A2(
			$elm$parser$Parser$ignorer,
			$hecrj$html_parser$Html$Parser$tagAttributeName,
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
	A2(
		$elm$parser$Parser$ignorer,
		$hecrj$html_parser$Html$Parser$tagAttributeValue,
		$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)));
var $hecrj$html_parser$Html$Parser$tagAttributes = $hecrj$html_parser$Html$Parser$many($hecrj$html_parser$Html$Parser$tagAttribute);
var $hecrj$html_parser$Html$Parser$tagName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$chompIf($elm$core$Char$isAlphaNum),
			$elm$parser$Parser$chompWhile(
				function (c) {
					return $elm$core$Char$isAlphaNum(c) || (c === '-');
				}))));
var $hecrj$html_parser$Html$Parser$Text = function (a) {
	return {$: 0, a: a};
};
var $hecrj$html_parser$Html$Parser$text = A2(
	$elm$parser$Parser$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$join(''),
		$hecrj$html_parser$Html$Parser$Text),
	A2(
		$hecrj$html_parser$Html$Parser$oneOrMore,
		'text element',
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$getChompedString(
					$hecrj$html_parser$Html$Parser$chompOneOrMore(
						function (c) {
							return (c !== '<') && (c !== '&');
						})),
					$hecrj$html_parser$Html$Parser$characterReference
				]))));
function $hecrj$html_parser$Html$Parser$cyclic$node() {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$hecrj$html_parser$Html$Parser$text,
				$hecrj$html_parser$Html$Parser$comment,
				$hecrj$html_parser$Html$Parser$cyclic$element()
			]));
}
function $hecrj$html_parser$Html$Parser$cyclic$element() {
	return A2(
		$elm$parser$Parser$andThen,
		function (_v0) {
			var name = _v0.a;
			var attributes = _v0.b;
			return $hecrj$html_parser$Html$Parser$isVoidElement(name) ? A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A3($hecrj$html_parser$Html$Parser$Element, name, attributes, _List_Nil)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$chompIf(
								$elm$core$Basics$eq('/')),
								$elm$parser$Parser$succeed(0)
							]))),
				$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('>'))) : A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A2($hecrj$html_parser$Html$Parser$Element, name, attributes)),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('>'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$many(
						$elm$parser$Parser$backtrackable(
							$hecrj$html_parser$Html$Parser$cyclic$node())),
					$hecrj$html_parser$Html$Parser$closingTag(name)));
		},
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Tuple$pair),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$tagName,
					$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
			$hecrj$html_parser$Html$Parser$tagAttributes));
}
var $hecrj$html_parser$Html$Parser$node = $hecrj$html_parser$Html$Parser$cyclic$node();
$hecrj$html_parser$Html$Parser$cyclic$node = function () {
	return $hecrj$html_parser$Html$Parser$node;
};
var $hecrj$html_parser$Html$Parser$element = $hecrj$html_parser$Html$Parser$cyclic$element();
$hecrj$html_parser$Html$Parser$cyclic$element = function () {
	return $hecrj$html_parser$Html$Parser$element;
};
var $hecrj$html_parser$Html$Parser$run = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Result$Ok(_List_Nil) : A2(
		$elm$parser$Parser$run,
		A2($hecrj$html_parser$Html$Parser$oneOrMore, 'node', $hecrj$html_parser$Html$Parser$node),
		str);
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $hecrj$html_parser$Html$Parser$Util$toAttribute = function (_v0) {
	var name = _v0.a;
	var value = _v0.b;
	return A2($elm$html$Html$Attributes$attribute, name, value);
};
var $hecrj$html_parser$Html$Parser$Util$toVirtualDom = function (nodes) {
	return A2($elm$core$List$map, $hecrj$html_parser$Html$Parser$Util$toVirtualDomEach, nodes);
};
var $hecrj$html_parser$Html$Parser$Util$toVirtualDomEach = function (node) {
	switch (node.$) {
		case 1:
			var name = node.a;
			var attrs = node.b;
			var children = node.c;
			return A3(
				$elm$html$Html$node,
				name,
				A2($elm$core$List$map, $hecrj$html_parser$Html$Parser$Util$toAttribute, attrs),
				$hecrj$html_parser$Html$Parser$Util$toVirtualDom(children));
		case 0:
			var s = node.a;
			return $elm$html$Html$text(s);
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$UI$Html$stringToHtml = function (text) {
	var _v0 = $hecrj$html_parser$Html$Parser$run(text);
	if (!_v0.$) {
		var nodes = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			$hecrj$html_parser$Html$Parser$Util$toVirtualDom(nodes));
	} else {
		return $elm_community$html_extra$Html$Extra$nothing;
	}
};
var $author$project$UI$Font$heading3 = _List_fromArray(
	[
		$mdgriffith$elm_ui$Element$Font$size(
		$author$project$UI$Font$scaled(2)),
		$mdgriffith$elm_ui$Element$Font$semiBold,
		$author$project$UI$Font$montserrat
	]);
var $author$project$UI$Container$withTitle = F2(
	function (title, _v0) {
		var c = _v0;
		var _v1 = c.oi;
		if (!_v1.$) {
			var t = _v1.a;
			return _Utils_update(
				c,
				{
					oi: $elm$core$Maybe$Just(
						{bB: t.bB, oi: title})
				});
		} else {
			return _Utils_update(
				c,
				{
					oi: $elm$core$Maybe$Just(
						{bB: $author$project$UI$Font$heading3, oi: title})
				});
		}
	});
var $author$project$Portal$Message$infoView = F2(
	function (msg, _v0) {
		var title = _v0.oi;
		var text = _v0.n3;
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				_List_fromArray(
					[
						function () {
						if (text.$ === 1) {
							var t = text.a;
							return A2(
								$mdgriffith$elm_ui$Element$column,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$spacing(10),
										$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
									]),
								A2(
									$elm$core$List$map,
									A2(
										$elm$core$Basics$composeR,
										$mdgriffith$elm_ui$Element$text,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$List$singleton,
											$mdgriffith$elm_ui$Element$paragraph(_List_Nil))),
									A2($elm$core$String$split, '\n', t)));
						} else {
							var t = text.a;
							return A2(
								$mdgriffith$elm_ui$Element$paragraph,
								_List_Nil,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$html(
										$author$project$UI$Html$stringToHtml(t))
									]));
						}
					}()
					]),
				A2(
					$author$project$UI$Container$withWidth,
					$mdgriffith$elm_ui$Element$fill,
					A2(
						$author$project$UI$Container$withTitle,
						A2(
							$mdgriffith$elm_ui$Element$row,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
								]),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$paragraph,
									_List_fromArray(
										[$mdgriffith$elm_ui$Element$alignLeft]),
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$html(
											A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														A2($elm$html$Html$Attributes$style, 'white-space', 'pre-wrap')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(title)
													])))
										])),
									A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$pointer,
											$mdgriffith$elm_ui$Element$alignRight,
											$mdgriffith$elm_ui$Element$alignTop,
											$mdgriffith$elm_ui$Element$Events$onClick(msg)
										]),
									A2(
										$author$project$UI$Element$coloredIconFor,
										$icidasset$elm_material_icons$Material$Icons$close(16),
										$author$project$UI$Palette$base02))
								])),
						$author$project$UI$Container$container))));
	});
var $author$project$Portal$Message$view = F2(
	function (cmd, messages) {
		return A2(
			$elm$core$List$map,
			function (_v2) {
				var m = _v2.b;
				if (!m.$) {
					var e = m.a;
					return A2(
						$author$project$Portal$Message$errorView,
						cmd(m),
						e);
				} else {
					var i = m.a;
					return A2(
						$author$project$Portal$Message$infoView,
						cmd(m),
						i);
				}
			},
			A2(
				$elm$core$List$sortBy,
				function (_v0) {
					var i = _v0.a;
					var m = _v0.b;
					if (!m.$) {
						return _Utils_Tuple2(1, i);
					} else {
						return _Utils_Tuple2(2, i);
					}
				},
				A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, messages)));
	});
var $author$project$Portal$Page$messagesPopupColors = {kV: $author$project$UI$Palette$base2, k0: $author$project$UI$Palette$base03, lZ: $author$project$UI$Palette$base03};
var $mdgriffith$elm_ui$Internal$Model$Min = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $mdgriffith$elm_ui$Element$minimum = F2(
	function (i, l) {
		return A2($mdgriffith$elm_ui$Internal$Model$Min, i, l);
	});
var $author$project$Portal$Page$viewPopup = function (items) {
	return $mdgriffith$elm_ui$Element$inFront(
		A2(
			$mdgriffith$elm_ui$Element$column,
			_Utils_ap(
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$centerX,
						$mdgriffith$elm_ui$Element$width(
						A2(
							$mdgriffith$elm_ui$Element$minimum,
							300,
							A2($mdgriffith$elm_ui$Element$maximum, 700, $mdgriffith$elm_ui$Element$fill))),
						$mdgriffith$elm_ui$Element$Border$width(2),
						$mdgriffith$elm_ui$Element$padding(20),
						$mdgriffith$elm_ui$Element$spacing(10),
						$mdgriffith$elm_ui$Element$htmlAttribute(
						A2($elm$html$Html$Attributes$style, 'z-index', '2147483647'))
					]),
				$author$project$UI$Element$colors($author$project$Portal$Page$messagesPopupColors)),
			items));
};
var $author$project$Portal$Page$view = F3(
	function (share, _v0, model) {
		var subheader = _v0.e;
		var content = _v0.d;
		var closedMessageMsg = _v0.lk;
		var pageMsg = _v0.nc;
		var responsive = $author$project$Portal$Page$responsiveness(
			$author$project$Portal$Share$ui(share));
		var maybeViewPopup = function (attrs) {
			var _v4 = $author$project$Portal$Share$notificationsOf(share);
			if (!_v4.b) {
				return attrs;
			} else {
				var messages = _v4;
				return A2(
					$elm$core$List$cons,
					$author$project$Portal$Page$viewPopup(
						A2($author$project$Portal$Message$view, closedMessageMsg, messages)),
					attrs);
			}
		};
		var _v1 = $author$project$Portal$Share$ui(share).l9;
		if (!_v1) {
			return A2(
				$mdgriffith$elm_ui$Element$row,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
						$author$project$UI$Element$avoidPrintInterference
					]),
				_List_fromArray(
					[
						A2(
						responsive.gT,
						model.ai,
						A4(
							$author$project$Portal$Page$menuView,
							pageMsg,
							$author$project$Portal$Share$security(share),
							share,
							model.ai)),
						A2(
						$mdgriffith$elm_ui$Element$column,
						maybeViewPopup(
							_Utils_ap(
								$author$project$UI$Font$body,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$alignTop,
										$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
										$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
										$author$project$UI$Element$avoidPrintInterference
									]))),
						_List_fromArray(
							[
								A4($author$project$Portal$Page$headerView, pageMsg, responsive, share, model),
								A2(
								$mdgriffith$elm_ui$Element$column,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
										$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
										$mdgriffith$elm_ui$Element$scrollbarY,
										$author$project$UI$Element$avoidPrintInterference
									]),
								function () {
									var _v2 = A2(
										$author$project$Portal$Page$subheaderView,
										$author$project$Portal$Share$today(share),
										subheader);
									if (!_v2.b.$) {
										var subHeader = _v2.a;
										var subHeaderAttrs = _v2.b.a;
										return _List_fromArray(
											[
												subHeader,
												A2(
												$mdgriffith$elm_ui$Element$el,
												A2(
													$elm$core$List$cons,
													$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
													A2(
														$elm$core$List$cons,
														$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
														A2($elm$core$List$cons, $author$project$UI$Element$avoidPrintInterference, subHeaderAttrs))),
												content)
											]);
									} else {
										var subHeader = _v2.a;
										var _v3 = _v2.b;
										return _List_fromArray(
											[subHeader, content]);
									}
								}())
							]))
					]));
		} else {
			return content;
		}
	});
var $author$project$Portal$Page$viewMap = F4(
	function (share, gotMsg, page, model) {
		return A3(
			$author$project$Portal$Page$view,
			share,
			A2($author$project$Portal$Page$mapPage, gotMsg, page),
			model);
	});
var $author$project$Main$frameFor = F3(
	function (model, gotMsg, _v0) {
		var subheader = _v0.e;
		var content = _v0.d;
		var emptyPage = {lk: $author$project$Main$UserClosedMessage, d: $mdgriffith$elm_ui$Element$none, nc: $author$project$Main$GotPageMsg, e: $author$project$Portal$Subheader$empty};
		return A4(
			$author$project$Portal$Page$viewMap,
			model.fQ,
			gotMsg,
			_Utils_update(
				emptyPage,
				{d: content, e: subheader}),
			model.eo);
	});
var $author$project$Count$Count$UserClickedBackToPlan = {$: 16};
var $author$project$Portal$Subheader$withBack = F3(
	function (msg, label, _v0) {
		var s = _v0;
		return _Utils_update(
			s,
			{
				dR: $elm$core$Maybe$Just(
					_Utils_Tuple2(msg, label))
			});
	});
var $author$project$Count$Count$hubPackListMenu = function (model) {
	return A3(
		$author$project$Portal$Subheader$withBack,
		$author$project$Count$Count$UserClickedBackToPlan,
		'Plan',
		$author$project$Count$Count$countMenu(model));
};
var $mdgriffith$elm_ui$Internal$Model$OnlyDynamic = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$StaticRootAndDynamic = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$AllowHover = 1;
var $mdgriffith$elm_ui$Internal$Model$Layout = 0;
var $mdgriffith$elm_ui$Internal$Model$focusDefaultStyle = {
	kW: $elm$core$Maybe$Nothing,
	k1: $elm$core$Maybe$Nothing,
	j2: $elm$core$Maybe$Just(
		{
			c_: 0,
			eS: A4($mdgriffith$elm_ui$Internal$Model$Rgba, 155 / 255, 203 / 255, 1, 1),
			c: _Utils_Tuple2(0, 0),
			bB: 3
		})
};
var $mdgriffith$elm_ui$Internal$Model$optionsToRecord = function (options) {
	var combine = F2(
		function (opt, record) {
			switch (opt.$) {
				case 0:
					var hoverable = opt.a;
					var _v4 = record.mf;
					if (_v4.$ === 1) {
						return _Utils_update(
							record,
							{
								mf: $elm$core$Maybe$Just(hoverable)
							});
					} else {
						return record;
					}
				case 1:
					var focusStyle = opt.a;
					var _v5 = record.db;
					if (_v5.$ === 1) {
						return _Utils_update(
							record,
							{
								db: $elm$core$Maybe$Just(focusStyle)
							});
					} else {
						return record;
					}
				default:
					var renderMode = opt.a;
					var _v6 = record.mK;
					if (_v6.$ === 1) {
						return _Utils_update(
							record,
							{
								mK: $elm$core$Maybe$Just(renderMode)
							});
					} else {
						return record;
					}
			}
		});
	var andFinally = function (record) {
		return {
			db: function () {
				var _v0 = record.db;
				if (_v0.$ === 1) {
					return $mdgriffith$elm_ui$Internal$Model$focusDefaultStyle;
				} else {
					var focusable = _v0.a;
					return focusable;
				}
			}(),
			mf: function () {
				var _v1 = record.mf;
				if (_v1.$ === 1) {
					return 1;
				} else {
					var hoverable = _v1.a;
					return hoverable;
				}
			}(),
			mK: function () {
				var _v2 = record.mK;
				if (_v2.$ === 1) {
					return 0;
				} else {
					var actualMode = _v2.a;
					return actualMode;
				}
			}()
		};
	};
	return andFinally(
		A3(
			$elm$core$List$foldr,
			combine,
			{db: $elm$core$Maybe$Nothing, mf: $elm$core$Maybe$Nothing, mK: $elm$core$Maybe$Nothing},
			options));
};
var $mdgriffith$elm_ui$Internal$Model$toHtml = F2(
	function (mode, el) {
		switch (el.$) {
			case 0:
				var html = el.a;
				return html($mdgriffith$elm_ui$Internal$Model$asEl);
			case 1:
				var styles = el.a.kh;
				var html = el.a.ef;
				return A2(
					html,
					mode(styles),
					$mdgriffith$elm_ui$Internal$Model$asEl);
			case 2:
				var text = el.a;
				return $mdgriffith$elm_ui$Internal$Model$textElement(text);
			default:
				return $mdgriffith$elm_ui$Internal$Model$textElement('');
		}
	});
var $mdgriffith$elm_ui$Internal$Model$renderRoot = F3(
	function (optionList, attributes, child) {
		var options = $mdgriffith$elm_ui$Internal$Model$optionsToRecord(optionList);
		var embedStyle = function () {
			var _v0 = options.mK;
			if (_v0 === 1) {
				return $mdgriffith$elm_ui$Internal$Model$OnlyDynamic(options);
			} else {
				return $mdgriffith$elm_ui$Internal$Model$StaticRootAndDynamic(options);
			}
		}();
		return A2(
			$mdgriffith$elm_ui$Internal$Model$toHtml,
			embedStyle,
			A4(
				$mdgriffith$elm_ui$Internal$Model$element,
				$mdgriffith$elm_ui$Internal$Model$asEl,
				$mdgriffith$elm_ui$Internal$Model$div,
				attributes,
				$mdgriffith$elm_ui$Internal$Model$Unkeyed(
					_List_fromArray(
						[child]))));
	});
var $mdgriffith$elm_ui$Internal$Model$rootStyle = function () {
	var families = _List_fromArray(
		[
			$mdgriffith$elm_ui$Internal$Model$Typeface('Open Sans'),
			$mdgriffith$elm_ui$Internal$Model$Typeface('Helvetica'),
			$mdgriffith$elm_ui$Internal$Model$Typeface('Verdana'),
			$mdgriffith$elm_ui$Internal$Model$SansSerif
		]);
	return _List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$bgColor,
			A3(
				$mdgriffith$elm_ui$Internal$Model$Colored,
				'bg-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(
					A4($mdgriffith$elm_ui$Internal$Model$Rgba, 1, 1, 1, 0)),
				'background-color',
				A4($mdgriffith$elm_ui$Internal$Model$Rgba, 1, 1, 1, 0))),
			A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$fontColor,
			A3(
				$mdgriffith$elm_ui$Internal$Model$Colored,
				'fc-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(
					A4($mdgriffith$elm_ui$Internal$Model$Rgba, 0, 0, 0, 1)),
				'color',
				A4($mdgriffith$elm_ui$Internal$Model$Rgba, 0, 0, 0, 1))),
			A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$fontSize,
			$mdgriffith$elm_ui$Internal$Model$FontSize(20)),
			A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$fontFamily,
			A2(
				$mdgriffith$elm_ui$Internal$Model$FontFamily,
				A3($elm$core$List$foldl, $mdgriffith$elm_ui$Internal$Model$renderFontClassName, 'font-', families),
				families))
		]);
}();
var $mdgriffith$elm_ui$Element$layoutWith = F3(
	function (_v0, attrs, child) {
		var options = _v0.m7;
		return A3(
			$mdgriffith$elm_ui$Internal$Model$renderRoot,
			options,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass(
					A2(
						$elm$core$String$join,
						' ',
						_List_fromArray(
							[$mdgriffith$elm_ui$Internal$Style$classes.nz, $mdgriffith$elm_ui$Internal$Style$classes.kQ, $mdgriffith$elm_ui$Internal$Style$classes.nM]))),
				_Utils_ap($mdgriffith$elm_ui$Internal$Model$rootStyle, attrs)),
			child);
	});
var $mdgriffith$elm_ui$Element$layout = $mdgriffith$elm_ui$Element$layoutWith(
	{m7: _List_Nil});
var $author$project$Count$Count$filterAmounts = F2(
	function (satisfy, amountByProductOrInsert) {
		return A2(
			$elm$core$Dict$filter,
			F2(
				function (_v1, v) {
					return A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$List$isEmpty)(v.k);
				}),
			A2(
				$elm$core$Dict$map,
				F2(
					function (_v0, v) {
						return {
							k: A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.G;
									},
									satisfy),
								v.k),
							E: v.E
						};
					}),
				amountByProductOrInsert));
	});
var $author$project$Cluster$Cluster$nameViewBasedOn = F2(
	function (segments, clusterId) {
		var _v0 = A2(
			$elm$core$List$sortBy,
			$author$project$UI$Name$view,
			A2($elm$core$List$map, $author$project$DistributionPoint$DistributionPoint$segmentInfo, segments));
		if (!_v0.b) {
			return '';
		} else {
			if (!_v0.b.b) {
				var only = _v0.a;
				return $author$project$UI$Name$view(only);
			} else {
				var first = _v0.a;
				var rest = _v0.b;
				return 'cluster #' + ($author$project$Cluster$Number$print(clusterId) + (': ' + ($author$project$UI$Name$view(first) + (', ... (' + ($elm$core$String$fromInt(
					$elm$core$List$length(rest)) + ' meer)')))));
			}
		}
	});
var $author$project$Count$Count$clusterName = function (cluster) {
	switch (cluster.$) {
		case 0:
			var id = cluster.a.eg;
			var deliverer = cluster.a.bl;
			var segments = cluster.a.bb;
			return _Utils_Tuple2(
				$author$project$Deliverer$Deliverer$nameView(deliverer),
				A2($author$project$Cluster$Cluster$nameViewBasedOn, segments, id));
		case 1:
			var id = cluster.a.eg;
			var deliverer = cluster.a.bl;
			var segments = cluster.a.bb;
			return _Utils_Tuple2(
				$author$project$Deliverer$Deliverer$nameView(deliverer),
				A2($author$project$Cluster$Cluster$nameViewBasedOn, segments, id));
		default:
			if (!cluster.a.$) {
				var dp = cluster.a.a;
				return _Utils_Tuple2(
					'Subdepot',
					$author$project$DistributionPoint$DistributionPoint$nameOf(dp));
			} else {
				return _Utils_Tuple2('Subdepot', '');
			}
	}
};
var $author$project$Count$Count$productOrInsertIndividualsAndPacksView = function (_v0) {
	var id = _v0.a;
	var packSize = _v0.b.E;
	var clusters = _v0.b.k;
	var totalBundle = function () {
		if (clusters.b) {
			var head = clusters.a;
			var tail = clusters.b;
			return A3(
				$elm$core$List$foldl,
				F2(
					function (cluster, cummul) {
						return A2($author$project$Demand$Bundle$combine, cummul, cluster.G).a;
					}),
				head.G,
				tail);
		} else {
			return A2(
				$author$project$Demand$Bundle$make,
				{E: packSize},
				0);
		}
	}();
	var header = function (productId) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('hub-packs-product')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(productId)
						])),
					A2($elm$html$Html$td, _List_Nil, _List_Nil)
				]));
	};
	var bundleConfig = A2($author$project$Demand$Bundle$IndividualsAndPacks, 0, 1);
	var line = function (c) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					function (_v1) {
						var delivererName = _v1.a;
						var name = _v1.b;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('hub-packs-deliverer')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(delivererName)
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(name)
									]))
							]);
					}(
						$author$project$Count$Count$clusterName(c.H))),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('hub-packs-count')
						]),
					A2($author$project$Demand$Bundle$print, bundleConfig, c.G))
				]));
	};
	var total = A2(
		$elm$html$Html$tr,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('hub-packs-totals')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Totaal')
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				A2($author$project$Demand$Bundle$print, bundleConfig, totalBundle))
			]));
	return A2(
		$elm$html$Html$table,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('hub-packs')
			]),
		A2(
			$elm$core$List$cons,
			header(id),
			A2(
				$elm$core$List$cons,
				total,
				A2($elm$core$List$map, line, clusters))));
};
var $author$project$Count$Count$bundlesOf = function (clusters) {
	return A2(
		$elm$core$List$map,
		function ($) {
			return $.G;
		},
		clusters);
};
var $author$project$Demand$Bundle$individualSumPrint = function (bundles) {
	return $elm$html$Html$text(
		$elm$core$String$fromInt(
			A3(
				$elm$core$List$foldl,
				function (_v0) {
					var bundle = _v0;
					return $elm$core$Basics$add(bundle.aM);
				},
				0,
				bundles)));
};
var $author$project$Count$Count$productOrInsertIndividualsView = function (_v0) {
	var id = _v0.a;
	var clusters = _v0.b.k;
	var total = A2(
		$elm$html$Html$tr,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('hub-packs-totals')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Totaal')
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Demand$Bundle$individualSumPrint(
						$author$project$Count$Count$bundlesOf(clusters))
					]))
			]));
	var line = function (c) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					function (_v1) {
						var delivererName = _v1.a;
						var name = _v1.b;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('hub-packs-deliverer')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(delivererName)
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(name)
									]))
							]);
					}(
						$author$project$Count$Count$clusterName(c.H))),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('hub-packs-count')
						]),
					_List_fromArray(
						[
							$author$project$Demand$Bundle$individualPrint(c.G)
						]))
				]));
	};
	var header = function (productId) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('hub-packs-product')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(productId)
						])),
					A2($elm$html$Html$td, _List_Nil, _List_Nil)
				]));
	};
	return A2(
		$elm$html$Html$table,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('hub-packs')
			]),
		A2(
			$elm$core$List$cons,
			header(id),
			A2(
				$elm$core$List$cons,
				total,
				A2($elm$core$List$map, line, clusters))));
};
var $author$project$Demand$Bundle$packsSumPrint = function (bundles) {
	return $elm$html$Html$text(
		$elm$core$String$fromInt(
			A3(
				$elm$core$List$foldl,
				function (_v0) {
					var bundle = _v0;
					return $elm$core$Basics$add(bundle.dl);
				},
				0,
				bundles)));
};
var $author$project$Count$Count$productOrInsertPacksView = function (_v0) {
	var id = _v0.a;
	var packSize = _v0.b.E;
	var clusters = _v0.b.k;
	var total = A2(
		$elm$html$Html$tr,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('hub-packs-totals')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Totaal')
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Demand$Bundle$packsSumPrint(
						$author$project$Count$Count$bundlesOf(clusters))
					]))
			]));
	var line = function (c) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					function (_v1) {
						var delivererName = _v1.a;
						var name = _v1.b;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('hub-packs-deliverer')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(delivererName)
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(name)
									]))
							]);
					}(
						$author$project$Count$Count$clusterName(c.H))),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('hub-packs-count')
						]),
					_List_fromArray(
						[
							$author$project$Demand$Bundle$packsPrint(c.G)
						]))
				]));
	};
	var header = F2(
		function (productId, productPackSize) {
			return A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('hub-packs-product')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(productId)
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Demand$PackIcon$view, 2, productPackSize)
							]))
					]));
		});
	return A2(
		$elm$html$Html$table,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('hub-packs')
			]),
		A2(
			$elm$core$List$cons,
			A2(header, id, packSize),
			A2(
				$elm$core$List$cons,
				total,
				A2($elm$core$List$map, line, clusters))));
};
var $author$project$Count$Count$ordersView = F2(
	function (options, amountByProductOrInsert) {
		return A2(
			$elm$html$Html$article,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hub-packs-list')
				]),
			A2(
				$elm$core$List$map,
				function () {
					var _v0 = options.ag;
					switch (_v0.$) {
						case 0:
							return $author$project$Count$Count$productOrInsertPacksView;
						case 2:
							return $author$project$Count$Count$productOrInsertIndividualsAndPacksView;
						default:
							return $author$project$Count$Count$productOrInsertIndividualsView;
					}
				}(),
				A2(
					$elm$core$List$sortBy,
					$elm$core$Tuple$first,
					$elm$core$Dict$toList(amountByProductOrInsert))));
	});
var $author$project$Count$Count$listView = function (_v0) {
	var orderAmounts = _v0.j;
	var options = _v0.m7;
	if (orderAmounts.$ === 1) {
		var amountByProductOrInsert = orderAmounts.a.aY;
		return $mdgriffith$elm_ui$Element$html(
			A2(
				$author$project$Count$Count$ordersView,
				options,
				A2(
					$author$project$Count$Count$filterAmounts,
					$author$project$Count$Count$amountsFilterFor(options),
					amountByProductOrInsert)));
	} else {
		return $mdgriffith$elm_ui$Element$none;
	}
};
var $author$project$Accounts$Add$UserClickedBackToAccounts = {$: 0};
var $author$project$Portal$Subheader$withTitle = F2(
	function (t, _v0) {
		var s = _v0;
		return _Utils_update(
			s,
			{
				oi: $elm$core$Maybe$Just(t)
			});
	});
var $author$project$Accounts$Add$menu = A3(
	$author$project$Portal$Subheader$withBack,
	$author$project$Accounts$Add$UserClickedBackToAccounts,
	'Accounts',
	A2($author$project$Portal$Subheader$withTitle, 'Account toevoegen', $author$project$Portal$Subheader$empty));
var $author$project$Accounts$Edit$UserClickedBackToAccounts = {$: 12};
var $author$project$Accounts$Account$statusView = function (status) {
	switch (status.$) {
		case 0:
			return 'Unconfirmed';
		case 1:
			return 'DPG user';
		case 2:
			return 'FLO user';
		default:
			var unknown = status.a;
			return unknown;
	}
};
var $author$project$Accounts$Edit$menu = function (model) {
	if (model.$ === 1) {
		var account = model.a.ca;
		var enabled = function () {
			var _v1 = account.lN;
			if (_v1) {
				return 'Actief';
			} else {
				return 'Niet actief';
			}
		}();
		var name = account.os + (' <' + (account.d5 + ('> (' + (enabled + (' - ' + ($author$project$Accounts$Account$statusView(account.nS) + ')'))))));
		return A3(
			$author$project$Portal$Subheader$withBack,
			$author$project$Accounts$Edit$UserClickedBackToAccounts,
			'Accounts',
			A2($author$project$Portal$Subheader$withTitle, name, $author$project$Portal$Subheader$empty));
	} else {
		return A3(
			$author$project$Portal$Subheader$withBack,
			$author$project$Accounts$Edit$UserClickedBackToAccounts,
			'Accounts',
			A2($author$project$Portal$Subheader$withTitle, 'Account bewerken', $author$project$Portal$Subheader$empty));
	}
};
var $author$project$Accounts$Overview$menu = function (_v0) {
	return A2($author$project$Portal$Subheader$withTitle, 'Accounts', $author$project$Portal$Subheader$empty);
};
var $author$project$Applicant$Overview$menu = F2(
	function (_v0, _v1) {
		return A2($author$project$Portal$Subheader$withTitle, 'Overzicht kandidaten', $author$project$Portal$Subheader$empty);
	});
var $author$project$Compensation$Add$UserClickedReturnToOverview = {$: 4};
var $author$project$Compensation$Add$menu = F2(
	function (_v0, model) {
		var context = $author$project$Compensation$Add$toContext(model);
		return A3(
			$author$project$Portal$Subheader$withMoveableDate,
			{
				k7: {
					ls: $author$project$Portal$Subheader$Enabled('Ga naar'),
					lz: $author$project$Portal$Subheader$Disabled,
					m5: $author$project$Portal$Subheader$Disabled
				},
				l5: $author$project$Compensation$Add$GotSubHeaderMsg,
				nb: context.t,
				ow: 0
			},
			context.r,
			A3(
				$author$project$Portal$Subheader$withBack,
				$author$project$Compensation$Add$UserClickedReturnToOverview,
				'Terug',
				A2($author$project$Portal$Subheader$withTitle, 'Incidentele vergoeding', $author$project$Portal$Subheader$empty)));
	});
var $author$project$Compensation$Approve$menu = F2(
	function (_v0, _v1) {
		return A2($author$project$Portal$Subheader$withTitle, 'Incidentele vergoedingen goedkeuren', $author$project$Portal$Subheader$empty);
	});
var $author$project$Compensation$Edit$menu = F2(
	function (share, model) {
		return A3(
			$author$project$Portal$Subheader$withMoveableDate,
			{
				k7: {
					ls: $author$project$Portal$Subheader$Enabled('Ga naar'),
					lz: $author$project$Portal$Subheader$Disabled,
					m5: $author$project$Portal$Subheader$Disabled
				},
				l5: $author$project$Compensation$Edit$GotSubHeaderMsg,
				nb: A2($author$project$Compensation$Edit$dateOf, share, model),
				ow: 0
			},
			$author$project$Compensation$Edit$calendarStateOf(model),
			A2($author$project$Portal$Subheader$withTitle, 'Incidentele vergoeding', $author$project$Portal$Subheader$empty));
	});
var $author$project$Compensation$Overview$menu = F2(
	function (_v0, _v1) {
		return A2($author$project$Portal$Subheader$withTitle, 'Incidentele vergoedingen', $author$project$Portal$Subheader$empty);
	});
var $author$project$Portal$Subheader$Full = 1;
var $author$project$Complaint$Feedback$menu = function (model) {
	var context = $author$project$Complaint$Feedback$toContext(model);
	return A3(
		$author$project$Portal$Subheader$withMoveableDate,
		{
			k7: {
				ls: $author$project$Portal$Subheader$Enabled('Ga naar'),
				lz: $author$project$Portal$Subheader$Disabled,
				m5: $author$project$Portal$Subheader$Disabled
			},
			l5: $author$project$Complaint$Feedback$GotSubHeaderMsg,
			nb: context.t,
			ow: 1
		},
		context.r,
		A2($author$project$Portal$Subheader$withTitle, 'Klachten gemeld op:', $author$project$Portal$Subheader$empty));
};
var $author$project$Complaint$Handle$menu = function (_v0) {
	return A2($author$project$Portal$Subheader$withTitle, 'Klachten afhandelen', $author$project$Portal$Subheader$empty);
};
var $author$project$Dashboard$Dashboard$UserClickedManageBanner = {$: 1};
var $author$project$Dashboard$Dashboard$UserClickedReturnToDashboard = {$: 2};
var $icidasset$elm_material_icons$Material$Icons$edit = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z')
				]),
			_List_Nil)
		]));
var $author$project$UI$Element$iff = F2(
	function (predicate, element) {
		return predicate ? element : $mdgriffith$elm_ui$Element$none;
	});
var $author$project$UI$Button$withIcon = F2(
	function (icon, _v0) {
		var b = _v0;
		return _Utils_update(
			b,
			{
				mg: $elm$core$Maybe$Just(icon)
			});
	});
var $author$project$Dashboard$Dashboard$menu = F2(
	function (share, model) {
		if (!model.$) {
			return A2(
				$author$project$Portal$Subheader$withOther,
				_List_fromArray(
					[
						A2(
						$author$project$UI$Element$iff,
						A2(
							$author$project$Security$Security$can,
							$author$project$Security$Security$ManageMessages,
							$author$project$Portal$Share$security(share)),
						$author$project$UI$Button$elementFor(
							A2(
								$author$project$UI$Button$withIcon,
								$icidasset$elm_material_icons$Material$Icons$edit,
								A2(
									$author$project$UI$Button$withRole,
									0,
									A2($author$project$UI$Button$button, $author$project$Dashboard$Dashboard$UserClickedManageBanner, 'Aanpassen')))))
					]),
				A2($author$project$Portal$Subheader$withTitle, 'Dashboard', $author$project$Portal$Subheader$empty));
		} else {
			return A3(
				$author$project$Portal$Subheader$withBack,
				$author$project$Dashboard$Dashboard$UserClickedReturnToDashboard,
				'Terug',
				A2($author$project$Portal$Subheader$withTitle, 'Dashboard beheren', $author$project$Portal$Subheader$empty));
		}
	});
var $author$project$Portal$Subheader$withDate = F2(
	function (date, _v0) {
		var s = _v0;
		return _Utils_update(
			s,
			{
				lx: $author$project$Portal$Subheader$UnmovableDate(date)
			});
	});
var $author$project$Delay$Delay$menu = function (model) {
	return A2(
		$author$project$Portal$Subheader$withDate,
		$author$project$Delay$Delay$dateAndDpIdOf(model).a,
		$author$project$Portal$Subheader$empty);
};
var $author$project$Deliverer$Create$UserClickedBackToPlan = {$: 7};
var $author$project$Deliverer$Create$menu = function (_v0) {
	var distributionPoint = _v0.bn;
	return A3(
		$author$project$Portal$Subheader$withBack,
		$author$project$Deliverer$Create$UserClickedBackToPlan,
		'Plan',
		A2($author$project$Portal$Subheader$withTitle, 'Nieuwe bezorger aanmaken', $author$project$Portal$Subheader$empty));
};
var $author$project$Deliverer$Edit$UserClickedBack = function (a) {
	return {$: 0, a: a};
};
var $author$project$Portal$Share$previousRoute = function (_v0) {
	var model = _v0;
	var _v1 = model.fL;
	if (!_v1.$) {
		var s = _v1.a;
		return s.nk;
	} else {
		var s = _v1.b;
		return s.nk;
	}
};
var $author$project$Portal$Route$view = function (route) {
	switch (route.$) {
		case 0:
			return 'Dashboard';
		case 1:
			return 'Publicaties';
		case 2:
			return 'Plan';
		case 3:
			return 'Plan aanmaken';
		case 4:
			return 'Plan';
		case 5:
			return 'Niet doorgestuurde plannen';
		case 6:
			return 'Verdeellijst';
		case 7:
			return 'Verdeellijst B';
		case 8:
			return 'Voordraailijst';
		case 9:
			return 'Tellijst volle pakken';
		case 10:
			return 'Ontvangstcontrolelijst';
		case 11:
			return 'Looplijst';
		case 12:
			return 'Loopvolgorde';
		case 13:
			return 'Bezorger aanmaken';
		case 14:
			return 'Bezorger ophaaladressen aanpassen';
		case 15:
			return 'Telapplicatie';
		case 16:
			return 'Vertragingen';
		case 19:
			return 'Documenten';
		case 20:
			return 'Accounts beheren';
		case 21:
			return 'Account bewerken';
		case 22:
			return 'Account toevoegen';
		case 23:
			return 'Berichten';
		case 17:
			return 'Looplijsten';
		case 18:
			return 'Looplijsten';
		case 24:
			return 'Incidentele vergoedingen';
		case 25:
			return 'Incidentele vergoeding aanmaken';
		case 26:
			return 'Incidentele vergoeding aanpassen';
		case 27:
			return 'Incidentele vergoedingen goedkeuren';
		case 28:
			return 'Vergoeding document';
		case 30:
			return 'Vergoedings details';
		case 31:
			return 'Jaar vergoedings details';
		case 29:
			return 'Wijkoverzicht';
		case 32:
			return 'Vergoedingenarchief';
		case 33:
			return 'Kandidaten';
		case 34:
			return 'Klacht afhandelen';
		case 35:
			return 'Klacht feedback';
		case 38:
			return 'Rapportage';
		case 36:
			return 'Verschijnkalender';
		case 37:
			return 'Distributeur configuratie validatie';
		default:
			return 'Pagina niet gevonden';
	}
};
var $author$project$Deliverer$Edit$menu = F2(
	function (share, _v0) {
		return function () {
			var _v1 = $author$project$Portal$Share$previousRoute(share);
			if (!_v1.$) {
				if (_v1.a.$ === 39) {
					var _v2 = _v1.a;
					return $elm$core$Basics$identity;
				} else {
					var route = _v1.a;
					return A2(
						$author$project$Portal$Subheader$withBack,
						$author$project$Deliverer$Edit$UserClickedBack(route),
						$author$project$Portal$Route$view(route));
				}
			} else {
				return $elm$core$Basics$identity;
			}
		}()(
			A2($author$project$Portal$Subheader$withTitle, 'Bezorger details', $author$project$Portal$Subheader$empty));
	});
var $author$project$Distributor$Validate$menu = A2($author$project$Portal$Subheader$withTitle, 'Distributeur configuratie validatie', $author$project$Portal$Subheader$empty);
var $author$project$Documents$Documents$menu = function (_v0) {
	return A2($author$project$Portal$Subheader$withTitle, 'Documenten', $author$project$Portal$Subheader$empty);
};
var $author$project$Lists$Distribution$DistributionList$UserClickedBackToPlan = {$: 5};
var $author$project$Lists$Distribution$DistributionList$menu = function (model) {
	return A3(
		$author$project$Portal$Subheader$withBack,
		$author$project$Lists$Distribution$DistributionList$UserClickedBackToPlan,
		'Plan',
		function () {
			var _v0 = model.bn;
			if (_v0.$ === 1) {
				return A2(
					$author$project$Portal$Subheader$withDate,
					model.lx,
					A2($author$project$Portal$Subheader$withTitle, 'Verdeellijsten', $author$project$Portal$Subheader$empty));
			} else {
				return $author$project$Portal$Subheader$empty;
			}
		}());
};
var $author$project$Lists$Distribution$PreSupplyList$UserClickedBackToPlan = {$: 5};
var $author$project$Lists$Distribution$PreSupplyList$menu = function (model) {
	return A3(
		$author$project$Portal$Subheader$withBack,
		$author$project$Lists$Distribution$PreSupplyList$UserClickedBackToPlan,
		'Plan',
		function () {
			var _v0 = model.bn;
			if (_v0.$ === 1) {
				return A2(
					$author$project$Portal$Subheader$withDate,
					model.lx,
					A2($author$project$Portal$Subheader$withTitle, 'Voordraailijst', $author$project$Portal$Subheader$empty));
			} else {
				return $author$project$Portal$Subheader$empty;
			}
		}());
};
var $author$project$Lists$Received$CheckList$UserClickedBackToPlan = {$: 3};
var $author$project$Lists$Received$CheckList$menu = function (model) {
	return A3(
		$author$project$Portal$Subheader$withBack,
		$author$project$Lists$Received$CheckList$UserClickedBackToPlan,
		'Plan',
		function () {
			if (model.$ === 1) {
				var p = model.a;
				return A2(
					$author$project$Portal$Subheader$withDate,
					p.a8.lx,
					A2($author$project$Portal$Subheader$withTitle, 'Ontvangstcontrolelijst', $author$project$Portal$Subheader$empty));
			} else {
				return $author$project$Portal$Subheader$empty;
			}
		}());
};
var $author$project$Lists$RouteDetail$Deliverer$menu = function (model) {
	var _v0 = $author$project$Lists$RouteDetail$Deliverer$toBase(model);
	var date = _v0.lx;
	var calendarState = _v0.r;
	var display = _v0.N;
	return A3(
		$author$project$Portal$Subheader$withMoveableDate,
		{
			k7: {
				ls: $author$project$Portal$Subheader$Enabled('Ga naar'),
				lz: $author$project$Portal$Subheader$Disabled,
				m5: $author$project$Portal$Subheader$Disabled
			},
			l5: $author$project$Lists$RouteDetail$Deliverer$GotSubHeaderMsg,
			nb: date,
			ow: 0
		},
		calendarState,
		$author$project$Portal$Subheader$empty);
};
var $author$project$Lists$RouteDetail$RouteDetail$UserClickedBackToPlan = {$: 0};
var $author$project$Lists$RouteDetail$RouteDetail$menu = function (model) {
	return A3(
		$author$project$Portal$Subheader$withBack,
		$author$project$Lists$RouteDetail$RouteDetail$UserClickedBackToPlan,
		'Plan',
		function () {
			var _v0 = model.h;
			if (_v0.$ === 1) {
				var planInfo = _v0.a;
				return A2(
					$author$project$Portal$Subheader$withDate,
					planInfo.lx,
					A2($author$project$Portal$Subheader$withTitle, 'Looplijsten', $author$project$Portal$Subheader$empty));
			} else {
				return $author$project$Portal$Subheader$empty;
			}
		}());
};
var $author$project$Message$Message$menu = F2(
	function (_v0, _v1) {
		return A2($author$project$Portal$Subheader$withTitle, 'Overzicht laatste berichten', $author$project$Portal$Subheader$empty);
	});
var $author$project$Payment$AnnualDetail$menu = F2(
	function (_v0, _v1) {
		return A2($author$project$Portal$Subheader$withTitle, 'Jaaropgaaf', $author$project$Portal$Subheader$empty);
	});
var $author$project$Payment$Archive$menu = F2(
	function (_v0, _v1) {
		return A2($author$project$Portal$Subheader$withTitle, 'Vergoedingenarchief', $author$project$Portal$Subheader$empty);
	});
var $author$project$Payment$DelivererOverview$menu = F2(
	function (_v0, _v1) {
		return A2($author$project$Portal$Subheader$withTitle, 'Vergoedingsspecificaties', $author$project$Portal$Subheader$empty);
	});
var $author$project$Payment$Detail$menu = F2(
	function (_v0, _v1) {
		return A2($author$project$Portal$Subheader$withTitle, 'Vergoedingsspecificatie', $author$project$Portal$Subheader$empty);
	});
var $author$project$Payment$DistributionPointOverview$menu = F2(
	function (_v0, _v1) {
		return A2($author$project$Portal$Subheader$withTitle, 'Wijkoverzicht', $author$project$Portal$Subheader$empty);
	});
var $author$project$Plan$CreatePlan$menu = function (_v0) {
	var distributionPoint = _v0.bn;
	var currentPlanDate = _v0.aE;
	var calendarState = _v0.r;
	return A3(
		$author$project$Portal$Subheader$withMoveableDate,
		{
			k7: {
				ls: $author$project$Portal$Subheader$Enabled('Plan aanmaken'),
				lz: $author$project$Portal$Subheader$Disabled,
				m5: $author$project$Portal$Subheader$Enabled('Plan openen')
			},
			l5: $author$project$Plan$CreatePlan$GotSubHeaderMsg,
			nb: currentPlanDate,
			ow: 0
		},
		calendarState,
		$author$project$Portal$Subheader$empty);
};
var $author$project$Plan$DayPlanning$UserSelectedFinalizePlan = {$: 12};
var $author$project$DistributionPoint$DistributionPoint$assistantPositionsOf = function (_v0) {
	var dp = _v0;
	return dp.hT;
};
var $author$project$DistributionPoint$DistributionPoint$findReferenceOnId = F2(
	function (references, id) {
		return A2(
			$elm_community$list_extra$List$Extra$find,
			function (s) {
				return _Utils_eq(s.eg, id);
			},
			references);
	});
var $author$project$DistributionPoint$DistributionPoint$inserterPositionsOf = function (_v0) {
	var dp = _v0;
	return dp.iS;
};
var $author$project$DistributionPoint$DistributionPoint$preSuppliesOf = function (_v0) {
	var dp = _v0;
	return dp.jA;
};
var $author$project$Plan$DayPlanning$viewStatusUpdateFailure = F2(
	function (distributionPoint, failures) {
		var item = function (element) {
			return A2(
				$mdgriffith$elm_ui$Element$row,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$spacing(5)
					]),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[$mdgriffith$elm_ui$Element$alignTop]),
						$mdgriffith$elm_ui$Element$text('-')),
						element
					]));
		};
		var textItem = A2($elm$core$Basics$composeL, item, $mdgriffith$elm_ui$Element$text);
		switch (failures.$) {
			case 0:
				return textItem('het plan in de toekomst ligt');
			case 1:
				if (failures.a.b && (!failures.a.b.b)) {
					var _v1 = failures.a;
					var segmentId = _v1.a;
					var _v2 = A2($author$project$DistributionPoint$DistributionPoint$findSegmentOnId, distributionPoint, segmentId);
					if (!_v2.$) {
						var segment = _v2.a;
						return textItem(
							'het plan een open segment heeft, ' + $author$project$DistributionPoint$DistributionPoint$segmentInfo(segment).ft);
					} else {
						return textItem('het plan een open segment heeft');
					}
				} else {
					var segmentIds = failures.a;
					var items = A2(
						$elm$core$List$map,
						textItem,
						$elm$core$List$sort(
							A2(
								$elm$core$List$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$DistributionPoint$DistributionPoint$segmentInfo,
									function ($) {
										return $.ft;
									}),
								A2(
									$elm$core$List$filterMap,
									$author$project$DistributionPoint$DistributionPoint$findSegmentOnId(distributionPoint),
									segmentIds))));
					return item(
						A2(
							$mdgriffith$elm_ui$Element$column,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$spacing(5)
								]),
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Element$text('het plan open segmenten heeft'),
								items)));
				}
			case 3:
				return textItem('het plan een niet toegewezen sub distributiepunt heeft');
			case 2:
				return textItem('een cluster/assistent/insteker een verlopen bezorger heeft.');
			case 4:
				return textItem('de betaalperiode al afgesloten is.');
			case 5:
				return textItem('het plan ligt te ver in de toekomst.');
			case 6:
				if (failures.a.b && (!failures.a.b.b)) {
					var _v3 = failures.a;
					var preSupplyId = _v3.a;
					var _v4 = A2(
						$author$project$DistributionPoint$DistributionPoint$findReferenceOnId,
						$author$project$DistributionPoint$DistributionPoint$preSuppliesOf(distributionPoint),
						preSupplyId);
					if (!_v4.$) {
						var preSupply = _v4.a;
						return item(
							A2(
								$mdgriffith$elm_ui$Element$column,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$spacing(5)
									]),
								A2(
									$elm$core$List$cons,
									$mdgriffith$elm_ui$Element$text('het plan een niet toegekende voordraai rit heeft'),
									_List_fromArray(
										[
											textItem(preSupply.ft)
										]))));
					} else {
						return textItem('een voordraai rit niet toegekend is.');
					}
				} else {
					var preSupplyIds = failures.a;
					var references = $author$project$DistributionPoint$DistributionPoint$preSuppliesOf(distributionPoint);
					var items = A2(
						$elm$core$List$map,
						textItem,
						$elm$core$List$sort(
							A2(
								$elm$core$List$map,
								function ($) {
									return $.ft;
								},
								A2(
									$elm$core$List$filterMap,
									$author$project$DistributionPoint$DistributionPoint$findReferenceOnId(references),
									preSupplyIds))));
					return item(
						A2(
							$mdgriffith$elm_ui$Element$column,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$spacing(5)
								]),
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Element$text('het plan niet toegekende voordraai ritten heeft'),
								items)));
				}
			case 7:
				if (failures.a.b && (!failures.a.b.b)) {
					var _v5 = failures.a;
					var assistantPositionId = _v5.a;
					var _v6 = A2(
						$author$project$DistributionPoint$DistributionPoint$findReferenceOnId,
						$author$project$DistributionPoint$DistributionPoint$assistantPositionsOf(distributionPoint),
						assistantPositionId);
					if (!_v6.$) {
						var assistantPosition = _v6.a;
						return item(
							A2(
								$mdgriffith$elm_ui$Element$column,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$spacing(5)
									]),
								A2(
									$elm$core$List$cons,
									$mdgriffith$elm_ui$Element$text('het plan een niet toegekende assistent positie heeft'),
									_List_fromArray(
										[
											textItem(assistantPosition.ft)
										]))));
					} else {
						return textItem('een assistent positie niet toegekend is.');
					}
				} else {
					var assistantPositionIds = failures.a;
					var references = $author$project$DistributionPoint$DistributionPoint$assistantPositionsOf(distributionPoint);
					var items = A2(
						$elm$core$List$map,
						textItem,
						$elm$core$List$sort(
							A2(
								$elm$core$List$map,
								function ($) {
									return $.ft;
								},
								A2(
									$elm$core$List$filterMap,
									$author$project$DistributionPoint$DistributionPoint$findReferenceOnId(references),
									assistantPositionIds))));
					return item(
						A2(
							$mdgriffith$elm_ui$Element$column,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$spacing(5)
								]),
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Element$text('het plan niet toegekende assistent posities heeft'),
								items)));
				}
			default:
				if (failures.a.b && (!failures.a.b.b)) {
					var _v7 = failures.a;
					var inserterPositionId = _v7.a;
					var _v8 = A2(
						$author$project$DistributionPoint$DistributionPoint$findReferenceOnId,
						$author$project$DistributionPoint$DistributionPoint$inserterPositionsOf(distributionPoint),
						inserterPositionId);
					if (!_v8.$) {
						var inserterPosition = _v8.a;
						return item(
							A2(
								$mdgriffith$elm_ui$Element$column,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$spacing(5)
									]),
								A2(
									$elm$core$List$cons,
									$mdgriffith$elm_ui$Element$text('het plan een niet toegekende insteker positie heeft'),
									_List_fromArray(
										[
											textItem(inserterPosition.ft)
										]))));
					} else {
						return textItem('een insteker positie niet toegekend is.');
					}
				} else {
					var inserterPositionIds = failures.a;
					var references = $author$project$DistributionPoint$DistributionPoint$inserterPositionsOf(distributionPoint);
					var items = A2(
						$elm$core$List$map,
						textItem,
						$elm$core$List$sort(
							A2(
								$elm$core$List$map,
								function ($) {
									return $.ft;
								},
								A2(
									$elm$core$List$filterMap,
									$author$project$DistributionPoint$DistributionPoint$findReferenceOnId(references),
									inserterPositionIds))));
					return item(
						A2(
							$mdgriffith$elm_ui$Element$column,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$spacing(5)
								]),
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Element$text('het plan niet toegekende insteker posities heeft'),
								items)));
				}
		}
	});
var $author$project$Plan$DayPlanning$viewStatusUpdateFailures = F3(
	function (statusUpdate, distributionPoint, failures) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_Utils_ap(
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$moveDown(5.0),
						$mdgriffith$elm_ui$Element$alignRight,
						$mdgriffith$elm_ui$Element$width(
						A2(
							$mdgriffith$elm_ui$Element$minimum,
							450,
							A2($mdgriffith$elm_ui$Element$maximum, 600, $mdgriffith$elm_ui$Element$fill))),
						$mdgriffith$elm_ui$Element$padding(8),
						$mdgriffith$elm_ui$Element$spacing(8),
						$mdgriffith$elm_ui$Element$Border$width(1),
						$mdgriffith$elm_ui$Element$Border$rounded(3)
					]),
				$author$project$UI$Element$colors($author$project$UI$Palette$error)),
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$text(
					function () {
						if (!statusUpdate) {
							return 'Het plan kan niet doorgestuurd worden, omdat ';
						} else {
							return 'Het plan kan niet meer gewijzigd worden, omdat ';
						}
					}()),
				A2(
					$elm$core$List$map,
					$author$project$Plan$DayPlanning$viewStatusUpdateFailure(distributionPoint),
					failures)));
	});
var $author$project$Plan$DayPlanning$attrsForFinalizationPopup = F2(
	function (distributionPoint, popupState) {
		if ((popupState.$ === 3) && popupState.b.b) {
			var statusUpdate = popupState.a;
			var failures = popupState.b;
			return _List_fromArray(
				[
					$mdgriffith$elm_ui$Element$below(
					A3($author$project$Plan$DayPlanning$viewStatusUpdateFailures, statusUpdate, distributionPoint, failures))
				]);
		} else {
			return _List_Nil;
		}
	});
var $icidasset$elm_material_icons$Material$Icons$check = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z')
				]),
			_List_Nil)
		]));
var $author$project$UI$Button$Disabled = function (a) {
	return {$: 1, a: a};
};
var $author$project$UI$Button$disabledButton = function (_v0) {
	var reason = _v0.jL;
	var text = _v0.n3;
	return {
		eJ: false,
		eK: false,
		mg: $elm$core$Maybe$Nothing,
		iY: $elm$core$Maybe$Nothing,
		gX: $author$project$UI$Button$Disabled(reason),
		cz: $elm$core$Maybe$Nothing,
		n3: text,
		oy: $elm$core$Maybe$Nothing
	};
};
var $icidasset$elm_material_icons$Material$Icons$send = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M2.01 21L23 12 2.01 3 2 10l15 2-15 2z')
				]),
			_List_Nil)
		]));
var $author$project$Plan$DayPlanning$finalizeSubheader = F4(
	function (share, popupState, _v0, planStatus) {
		var dp = _v0;
		var _v1 = _Utils_Tuple2(
			planStatus,
			A2(
				$author$project$Security$Security$can,
				$author$project$Security$Security$FinalizePlan,
				$author$project$Portal$Share$security(share)));
		switch (_v1.a) {
			case 2:
				var _v2 = _v1.a;
				return A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$alignRight]),
					$author$project$UI$Button$elementFor(
						A2(
							$author$project$UI$Button$withIcon,
							$icidasset$elm_material_icons$Material$Icons$check,
							A2(
								$author$project$UI$Button$withRole,
								0,
								$author$project$UI$Button$disabledButton(
									{jL: 'Het plan is doorgestuurd en het kan maar één maal doorgestuurd worden.', n3: 'Doorgestuurd voor betaling'})))));
			case 1:
				var _v3 = _v1.a;
				return A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$alignRight]),
					$author$project$UI$Button$elementFor(
						A2(
							$author$project$UI$Button$withRole,
							0,
							$author$project$UI$Button$disabledButton(
								{jL: 'Momenteel wordt het plan uitgevoerd, zodra de bezorging is afgerond kan het plan doorgestuurd worden.', n3: 'Nog niet doorgestuurd'}))));
			default:
				if (_v1.b) {
					var _v4 = _v1.a;
					return A2(
						$mdgriffith$elm_ui$Element$el,
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Element$alignRight,
							A2($author$project$Plan$DayPlanning$attrsForFinalizationPopup, dp, popupState)),
						$author$project$UI$Button$elementFor(
							A2(
								$author$project$UI$Button$withIcon,
								$icidasset$elm_material_icons$Material$Icons$send,
								A2(
									$author$project$UI$Button$withRole,
									0,
									A2($author$project$UI$Button$button, $author$project$Plan$DayPlanning$UserSelectedFinalizePlan, 'Doorsturen voor betaling')))));
				} else {
					var _v5 = _v1.a;
					return $mdgriffith$elm_ui$Element$text('Nog niet doorgestuurd');
				}
		}
	});
var $author$project$Plan$DayPlanning$ListsAvailable = {$: 2};
var $author$project$Plan$DayPlanning$MissingSubDPPlans = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$DayPlanning$NoOrders = {$: 0};
var $author$project$Plan$DayPlanning$listsAvailability = F3(
	function (distributionPointStatus, ordersStatus, subDpPlanStatuses) {
		var _v0 = _Utils_Tuple2(distributionPointStatus, ordersStatus);
		if (((_v0.a.$ === 1) && (_v0.b.$ === 1)) && _v0.b.a.b) {
			var dp = _v0.a.a;
			var _v1 = _v0.b.a;
			var missingSubDPPlans = A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2(
					$elm$core$List$filter,
					function (_v3) {
						var status = _v3.b;
						return _Utils_eq(status, $elm$core$Maybe$Nothing) || _Utils_eq(
							status,
							$elm$core$Maybe$Just($elm$core$Maybe$Nothing));
					},
					A2(
						$elm$core$List$map,
						function (subDP) {
							return _Utils_Tuple2(
								subDP,
								A2(
									$author$project$DistributionPoint$IdDict$get,
									$author$project$DistributionPoint$DistributionPoint$idOf(subDP),
									subDpPlanStatuses));
						},
						$author$project$DistributionPoint$DistributionPoint$getSubDistributionPoints(dp))));
			if (!missingSubDPPlans.b) {
				return $author$project$Plan$DayPlanning$ListsAvailable;
			} else {
				return $author$project$Plan$DayPlanning$MissingSubDPPlans(missingSubDPPlans);
			}
		} else {
			return $author$project$Plan$DayPlanning$NoOrders;
		}
	});
var $author$project$Plan$DayPlanning$ShowDistributionList = {$: 16};
var $author$project$Plan$DayPlanning$ShowDistributionListB = {$: 17};
var $author$project$Plan$DayPlanning$ShowHubPackList = {$: 18};
var $author$project$Plan$DayPlanning$ShowReceivedCheckList = {$: 19};
var $author$project$Plan$DayPlanning$ShowRouteDetail = {$: 21};
var $author$project$Plan$DayPlanning$UserClickedListsMenu = {$: 15};
var $author$project$Plan$DayPlanning$UserSelectedPreSupplyListInLists = {$: 20};
var $author$project$UI$PullDownMenu$itemColors = {kV: $author$project$UI$Palette$base2, k0: $author$project$UI$Palette$base02, lZ: $author$project$UI$Palette$base03};
var $author$project$UI$PullDownMenu$itemMouseOverColors = {kV: $author$project$UI$Palette$base02, k0: $author$project$UI$Palette$base02, lZ: $author$project$UI$Palette$base2};
var $author$project$UI$PullDownMenu$itemView = function (item) {
	if (!item.$) {
		var msg = item.a.gX;
		var title = item.a.oi;
		return A2(
			$mdgriffith$elm_ui$Element$Input$button,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$pointer,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$padding(11),
					$mdgriffith$elm_ui$Element$mouseOver(
					$author$project$UI$Element$colors($author$project$UI$PullDownMenu$itemMouseOverColors))
				]),
			{
				mD: $mdgriffith$elm_ui$Element$text(title),
				jp: $elm$core$Maybe$Just(msg)
			});
	} else {
		var label = item.a;
		return A2(
			$mdgriffith$elm_ui$Element$paragraph,
			_Utils_ap(
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width(
						A2(
							$mdgriffith$elm_ui$Element$maximum,
							600,
							A2($mdgriffith$elm_ui$Element$minimum, 450, $mdgriffith$elm_ui$Element$fill))),
						$mdgriffith$elm_ui$Element$padding(8),
						$mdgriffith$elm_ui$Element$Border$width(1),
						$mdgriffith$elm_ui$Element$Border$rounded(3)
					]),
				$author$project$UI$Element$colors($author$project$UI$Palette$warning)),
			A2($elm$core$List$map, $mdgriffith$elm_ui$Element$text, label));
	}
};
var $author$project$UI$PullDownMenu$itemsView = function (items) {
	if (!items.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Just(
			$mdgriffith$elm_ui$Element$below(
				A2(
					$mdgriffith$elm_ui$Element$column,
					_Utils_ap(
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$alignRight,
								$mdgriffith$elm_ui$Element$moveDown(5.0),
								$mdgriffith$elm_ui$Element$Border$width(1),
								$mdgriffith$elm_ui$Element$Border$rounded(3)
							]),
						$author$project$UI$Element$colors($author$project$UI$PullDownMenu$itemColors)),
					A2($elm$core$List$map, $author$project$UI$PullDownMenu$itemView, items))));
	}
};
var $author$project$UI$PullDownMenu$expandIcon = $author$project$UI$Element$coloredIconFor(
	$icidasset$elm_material_icons$Material$Icons$expand_more(16));
var $author$project$UI$PullDownMenu$softColors = {
	cr: {kV: $author$project$UI$Palette$base1, k0: $author$project$UI$Palette$base0, lZ: $author$project$UI$Palette$base03},
	cx: {kV: $author$project$UI$Palette$base0, k0: $author$project$UI$Palette$base02, lZ: $author$project$UI$Palette$base03}
};
var $author$project$UI$PullDownMenu$titleView = F3(
	function (msg, title, itemsV) {
		return A2(
			$mdgriffith$elm_ui$Element$el,
			A2($author$project$UI$Util$maybeCons, itemsV, _List_Nil),
			A2(
				$mdgriffith$elm_ui$Element$Input$button,
				_Utils_ap(
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Border$rounded(3),
							$mdgriffith$elm_ui$Element$Border$width(1),
							$mdgriffith$elm_ui$Element$padding(11),
							$mdgriffith$elm_ui$Element$mouseDown(
							$author$project$UI$Element$colors($author$project$UI$PullDownMenu$softColors.cx))
						]),
					$author$project$UI$Element$colors($author$project$UI$PullDownMenu$softColors.cr)),
				{
					mD: A2(
						$mdgriffith$elm_ui$Element$row,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$spacing(8)
							]),
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text(title),
								$author$project$UI$PullDownMenu$expandIcon($author$project$UI$PullDownMenu$softColors.cr.lZ)
							])),
					jp: $elm$core$Maybe$Just(msg)
				}));
	});
var $author$project$UI$PullDownMenu$elementFor = function (_v0) {
	var m = _v0;
	return A3(
		$author$project$UI$PullDownMenu$titleView,
		m.kp,
		m.oi,
		$author$project$UI$PullDownMenu$itemsView(m.gL));
};
var $author$project$UI$PullDownMenu$PullDownMenu = $elm$core$Basics$identity;
var $author$project$UI$PullDownMenu$pullDownMenu = F2(
	function (toggleMsg, title) {
		return {gL: _List_Nil, oi: title, kp: toggleMsg};
	});
var $author$project$UI$PullDownMenu$Message = function (a) {
	return {$: 1, a: a};
};
var $author$project$UI$PullDownMenu$withMessage = F2(
	function (text, _v0) {
		var m = _v0;
		return _Utils_update(
			m,
			{
				gL: _Utils_ap(
					m.gL,
					_List_fromArray(
						[
							$author$project$UI$PullDownMenu$Message(text)
						]))
			});
	});
var $author$project$UI$PullDownMenu$Selectable = function (a) {
	return {$: 0, a: a};
};
var $author$project$UI$PullDownMenu$withSelectables = F2(
	function (selectables, _v0) {
		var m = _v0;
		return _Utils_update(
			m,
			{
				gL: _Utils_ap(
					m.gL,
					A2(
						$elm$core$List$map,
						function (_v1) {
							var msg = _v1.a;
							var t = _v1.b;
							return $author$project$UI$PullDownMenu$Selectable(
								{gX: msg, oi: t});
						},
						selectables))
			});
	});
var $author$project$Plan$DayPlanning$listsMenu = F4(
	function (popupState, availability, preSupplyItems, preSupply) {
		return $author$project$UI$PullDownMenu$elementFor(
			function () {
				var _v0 = _Utils_Tuple2(popupState, availability);
				if (_v0.a.$ === 2) {
					switch (_v0.b.$) {
						case 2:
							var _v1 = _v0.a;
							var _v2 = _v0.b;
							return $author$project$UI$PullDownMenu$withSelectables(
								$elm_community$maybe_extra$Maybe$Extra$values(
									_List_fromArray(
										[
											$elm$core$Maybe$Just(
											_Utils_Tuple2($author$project$Plan$DayPlanning$ShowDistributionList, 'Verdeellijst')),
											$elm$core$Maybe$Just(
											_Utils_Tuple2($author$project$Plan$DayPlanning$ShowDistributionListB, 'Verdeellijst B')),
											$elm$core$Maybe$Just(
											_Utils_Tuple2($author$project$Plan$DayPlanning$ShowRouteDetail, 'Looplijsten')),
											$elm$core$Maybe$Just(
											_Utils_Tuple2($author$project$Plan$DayPlanning$ShowHubPackList, 'Tellijst')),
											$elm$core$Maybe$Just(
											_Utils_Tuple2($author$project$Plan$DayPlanning$ShowReceivedCheckList, 'Ontvangstcontrolelijst')),
											function () {
											var _v3 = _Utils_Tuple2(preSupplyItems, preSupply);
											if (_v3.a.b && (!_v3.b.$)) {
												var _v4 = _v3.a;
												return $elm$core$Maybe$Just(
													_Utils_Tuple2($author$project$Plan$DayPlanning$UserSelectedPreSupplyListInLists, 'Voordraailijst'));
											} else {
												return $elm$core$Maybe$Nothing;
											}
										}()
										])));
						case 0:
							var _v5 = _v0.a;
							var _v6 = _v0.b;
							return $author$project$UI$PullDownMenu$withMessage(
								_List_fromArray(
									['De lijsten zijn niet beschikbaar, er zijn geen orders gevonden']));
						default:
							var _v7 = _v0.a;
							var subDps = _v0.b.a;
							return $author$project$UI$PullDownMenu$withMessage(
								A2(
									$elm$core$List$cons,
									'De lijsten zijn niet beschikbaar, er is nog geen plan aangemaakt voor de volgende distributiepunten: ',
									A2($elm$core$List$map, $author$project$DistributionPoint$DistributionPoint$nameOf, subDps)));
					}
				} else {
					return $elm$core$Basics$identity;
				}
			}()(
				A2($author$project$UI$PullDownMenu$pullDownMenu, $author$project$Plan$DayPlanning$UserClickedListsMenu, 'Lijsten')));
	});
var $author$project$Plan$DayPlanning$menu = F2(
	function (share, _v0) {
		var distributionPoint = _v0.bn;
		var date = _v0.lx;
		var planAndDeliverers = _v0.fB;
		var orders = _v0.Y;
		var popupState = _v0.b_;
		var subDpPlanStatuses = _v0.cJ;
		var calendarState = _v0.r;
		return function () {
			var _v1 = _Utils_Tuple2(
				distributionPoint,
				$author$project$Plan$PlanLoader$loadedOf(planAndDeliverers));
			if ((_v1.a.$ === 1) && (!_v1.b.$)) {
				var dp = _v1.a.a;
				var plan = _v1.b.a.fA;
				return $author$project$Portal$Subheader$withOther(
					A2(
						$elm$core$List$cons,
						A4($author$project$Plan$DayPlanning$finalizeSubheader, share, popupState, dp, plan.nS),
						_List_fromArray(
							[
								A4(
								$author$project$Plan$DayPlanning$listsMenu,
								popupState,
								A3($author$project$Plan$DayPlanning$listsAvailability, distributionPoint, orders, subDpPlanStatuses),
								$author$project$DistributionPoint$DistributionPoint$preSuppliesOf(dp),
								plan.ni)
							])));
			} else {
				return $elm$core$Basics$identity;
			}
		}()(
			A3(
				$author$project$Portal$Subheader$withMoveableDate,
				{
					k7: {
						ls: $author$project$Portal$Subheader$Enabled('Plan aanmaken'),
						lz: $author$project$Portal$Subheader$Enabled('Plan verwijderen'),
						m5: $author$project$Portal$Subheader$Enabled('Plan openen')
					},
					l5: $author$project$Plan$DayPlanning$GotSubHeaderMsg,
					nb: date,
					ow: 0
				},
				calendarState,
				$author$project$Portal$Subheader$empty));
	});
var $author$project$Plan$NotFinalized$menu = function (_v0) {
	return A2($author$project$Portal$Subheader$withTitle, 'Niet doorgestuurde plannen', $author$project$Portal$Subheader$empty);
};
var $author$project$Publications$ClosingCalendar$menu = function (model) {
	var _v0 = model.nI;
	if (_v0.$ === 1) {
		var year = _v0.a;
		return A2(
			$author$project$Portal$Subheader$withTitle,
			'Verschijnkalender ' + $elm$core$String$fromInt(year),
			$author$project$Portal$Subheader$empty);
	} else {
		return A2($author$project$Portal$Subheader$withTitle, 'Verschijnkalender', $author$project$Portal$Subheader$empty);
	}
};
var $author$project$Publications$Publications$menu = function (model) {
	var context = $author$project$Publications$Publications$toContext(model);
	return A3(
		$author$project$Portal$Subheader$withMoveableDate,
		{
			k7: {
				ls: $author$project$Portal$Subheader$Enabled('Ga naar'),
				lz: $author$project$Portal$Subheader$Disabled,
				m5: $author$project$Portal$Subheader$Disabled
			},
			l5: $author$project$Publications$Publications$GotSubHeaderMsg,
			nb: context.t,
			ow: 0
		},
		context.r,
		$author$project$Portal$Subheader$empty);
};
var $author$project$Report$Report$menu = function (_v0) {
	return A2($author$project$Portal$Subheader$withTitle, 'Rapportages', $author$project$Portal$Subheader$empty);
};
var $author$project$Sequence$Plan$CloseSequence = {$: 5};
var $author$project$Sequence$Plan$menu = function (_v0) {
	var distributionPoint = _v0.bn;
	var date = _v0.lx;
	return A3(
		$author$project$Portal$Subheader$withBack,
		$author$project$Sequence$Plan$CloseSequence,
		'Plan',
		function () {
			if (distributionPoint.$ === 1) {
				return A2($author$project$Portal$Subheader$withDate, date, $author$project$Portal$Subheader$empty);
			} else {
				return $author$project$Portal$Subheader$empty;
			}
		}());
};
var $author$project$Accounts$Add$UserChangedEmail = function (a) {
	return {$: 1, a: a};
};
var $author$project$Accounts$Add$UserClickedCreate = {$: 2};
var $author$project$UI$Validation$Email$invalidView = function (err) {
	switch (err) {
		case 0:
			return 'Het e-mailadres dient een \'@\' te bevatten.';
		case 1:
			return 'Het e-mailadres mag maar 1 \'@\' bevatten.';
		case 2:
			return 'Het e-mailadres mag niet beginnen met een \'@\'.';
		case 6:
			return 'Het e-mailadres mag geen spaties bevatten.';
		case 3:
			return 'Het e-mailadres moet een domein bevatten.';
		case 4:
			return 'Het domein van het e-mailadres moet een punt bevatten.';
		default:
			return 'Het domein van het e-mailadres bevat ongeldige punten.';
	}
};
var $author$project$Accounts$Add$addAccountFormErrorView = function (_v0) {
	var err = _v0;
	return A2(
		$mdgriffith$elm_ui$Element$paragraph,
		_List_Nil,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$text(
				$author$project$UI$Validation$Email$invalidView(err))
			]));
};
var $author$project$Accounts$Add$addAccountFormErrorsView = function (errors) {
	var _v0 = $elm$core$List$length(errors);
	if (!_v0) {
		return $mdgriffith$elm_ui$Element$none;
	} else {
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				A2($elm$core$List$map, $author$project$Accounts$Add$addAccountFormErrorView, errors),
				A2($author$project$UI$Container$withVariant, 2, $author$project$UI$Container$container)));
	}
};
var $mdgriffith$elm_ui$Element$Input$text = $mdgriffith$elm_ui$Element$Input$textHelper(
	{
		a_: $elm$core$Maybe$Nothing,
		be: false,
		af: $mdgriffith$elm_ui$Element$Input$TextInputNode('text')
	});
var $author$project$UI$Input$email = function (attributes) {
	return $mdgriffith$elm_ui$Element$Input$text(
		_Utils_ap(
			attributes,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$htmlAttribute(
					$elm$html$Html$Attributes$type_('email'))
				])));
};
var $author$project$UI$Font$label = _List_fromArray(
	[
		$mdgriffith$elm_ui$Element$Font$size(
		$author$project$UI$Font$scaled(1)),
		$mdgriffith$elm_ui$Element$Font$semiBold
	]);
var $mdgriffith$elm_ui$Element$Input$Above = 2;
var $mdgriffith$elm_ui$Element$Input$labelAbove = $mdgriffith$elm_ui$Element$Input$Label(2);
var $author$project$UI$Input$label = function (labelText) {
	return A2(
		$mdgriffith$elm_ui$Element$Input$labelAbove,
		$author$project$UI$Font$label,
		$mdgriffith$elm_ui$Element$text(labelText));
};
var $author$project$UI$Input$row = function (content) {
	return A2(
		$mdgriffith$elm_ui$Element$row,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				A2($mdgriffith$elm_ui$Element$spacingXY, 10, 0),
				A2($mdgriffith$elm_ui$Element$paddingXY, 0, 5)
			]),
		content);
};
var $author$project$Accounts$Add$accountAddView = F2(
	function (emailAddress, errors) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[$mdgriffith$elm_ui$Element$centerX]),
			_List_fromArray(
				[
					$author$project$Accounts$Add$addAccountFormErrorsView(errors),
					A2(
					$author$project$UI$Input$email,
					_List_Nil,
					{
						mD: $author$project$UI$Input$label('Email'),
						mY: $author$project$Accounts$Add$UserChangedEmail,
						ng: $elm$core$Maybe$Nothing,
						n3: emailAddress
					}),
					$author$project$UI$Input$row(
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$column,
							_List_fromArray(
								[$mdgriffith$elm_ui$Element$alignLeft]),
							_List_fromArray(
								[
									$author$project$UI$Button$elementFor(
									A2(
										$author$project$UI$Button$withRole,
										0,
										A2($author$project$UI$Button$button, $author$project$Accounts$Add$UserClickedCreate, 'Opslaan')))
								]))
						]))
				]));
	});
var $author$project$Accounts$Add$view = function (model) {
	return A2(
		$mdgriffith$elm_ui$Element$el,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$padding(10),
				$mdgriffith$elm_ui$Element$spacing(10),
				$mdgriffith$elm_ui$Element$centerX
			]),
		$author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				_List_fromArray(
					[
						A2($author$project$Accounts$Add$accountAddView, model.d5, model.f_)
					]),
				$author$project$UI$Container$container)));
};
var $author$project$UI$Font$tagSized = function (el) {
	return el(
		$author$project$UI$Font$scaled(-1));
};
var $mdgriffith$elm_ui$Element$Font$italic = $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.mu);
var $author$project$UI$Text$textElementFor = function (_v0) {
	var content = _v0.d;
	var selectableValue = _v0.fP;
	var style = _v0.hu;
	return function (attrs) {
		if (!attrs.b) {
			return $mdgriffith$elm_ui$Element$text(content);
		} else {
			return A2(
				$mdgriffith$elm_ui$Element$el,
				attrs,
				$mdgriffith$elm_ui$Element$text(content));
		}
	}(
		_Utils_ap(
			selectableValue ? _List_fromArray(
				[
					$mdgriffith$elm_ui$Element$htmlAttribute(
					A2($elm$html$Html$Attributes$style, 'user-select', 'text'))
				]) : _List_Nil,
			function () {
				switch (style) {
					case 0:
						return _List_Nil;
					case 1:
						return _List_fromArray(
							[$mdgriffith$elm_ui$Element$Font$italic]);
					default:
						return _List_fromArray(
							[
								$mdgriffith$elm_ui$Element$Font$italic,
								$mdgriffith$elm_ui$Element$Font$color(
								$author$project$UI$Element$colorFor($author$project$UI$Palette$magenta))
							]);
				}
			}()));
};
var $author$project$UI$Text$elementFor = function (t) {
	var content = t.d;
	var label = t.mD;
	var action = t.dN;
	var selectableValue = t.fP;
	var lbl = function (l) {
		return A2(
			$mdgriffith$elm_ui$Element$el,
			$author$project$UI$Font$tag,
			$mdgriffith$elm_ui$Element$text(l));
	};
	var icon = function (a) {
		return A2(
			$mdgriffith$elm_ui$Element$Input$button,
			_List_fromArray(
				[$mdgriffith$elm_ui$Element$pointer]),
			{
				mD: A2(
					$author$project$UI$Element$coloredIconFor,
					$author$project$UI$Font$tagSized(a.mg),
					$author$project$UI$Palette$base02),
				jp: $elm$core$Maybe$Just(a.gX)
			});
	};
	var _v0 = _Utils_Tuple2(label, action);
	if (!_v0.a.$) {
		if (!_v0.b.$) {
			var l = _v0.a.a;
			var a = _v0.b.a;
			return A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$spacing(3),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$row,
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Element$spacing(10),
							$author$project$UI$Font$tag),
						_List_fromArray(
							[
								lbl(l),
								icon(a)
							])),
						$author$project$UI$Text$textElementFor(t)
					]));
		} else {
			var l = _v0.a.a;
			var _v1 = _v0.b;
			return A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$spacing(3),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				_List_fromArray(
					[
						lbl(l),
						$author$project$UI$Text$textElementFor(t)
					]));
		}
	} else {
		if (!_v0.b.$) {
			var _v2 = _v0.a;
			var a = _v0.b.a;
			return A2(
				$mdgriffith$elm_ui$Element$row,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$spacing(10)
					]),
				_List_fromArray(
					[
						$author$project$UI$Text$textElementFor(t),
						icon(a)
					]));
		} else {
			var _v3 = _v0.a;
			var _v4 = _v0.b;
			return $author$project$UI$Text$textElementFor(t);
		}
	}
};
var $author$project$Accounts$Authorization$roleName = function (role) {
	switch (role.$) {
		case 0:
			return 'Regio distributeur';
		case 1:
			return 'Ondernemer';
		case 2:
			return 'Assistent distributeur';
		case 3:
			return 'Teller';
		case 4:
			return 'Account manager';
		case 5:
			return 'Logistieke ondersteuner';
		case 6:
			return 'Regio manager';
		case 7:
			return 'Admin';
		case 8:
			return 'Bezorger';
		case 9:
			return 'Operationele manager';
		case 10:
			return 'Financiële admin';
		case 11:
			return 'Voorbereider';
		case 12:
			return 'Recruiter';
		default:
			return 'Arbeidsmarktcommunicatie';
	}
};
var $author$project$Accounts$Edit$UserClickedEditRole = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Accounts$Edit$UserClickedRevokeRole = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $icidasset$elm_material_icons$Material$Icons$delete = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z')
				]),
			_List_Nil)
		]));
var $author$project$Accounts$Edit$roleView = F3(
	function (dps, authorization, role) {
		var roleName = A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Border$widthEach(
					{k5: 1, mE: 0, nx: 0, ol: 0}),
					$mdgriffith$elm_ui$Element$Border$color(
					$author$project$UI$Element$colorFor($author$project$UI$Palette$base0)),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$Font$bold
				]),
			$mdgriffith$elm_ui$Element$text(
				$author$project$Accounts$Authorization$roleName(role)));
		var dpView = function (uuids) {
			return A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ft;
					},
					$mdgriffith$elm_ui$Element$text),
				A2(
					$elm$core$List$sortBy,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.ft;
						},
						$elm$core$String$toLower),
					A2(
						$elm$core$List$filter,
						function (_v1) {
							var id = _v1.eg;
							return A2($elm$core$List$member, id, uuids);
						},
						dps)));
		};
		var buttons = _List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$el,
				_List_Nil,
				$author$project$UI$Button$elementFor(
					A2(
						$author$project$UI$Button$withIcon,
						$icidasset$elm_material_icons$Material$Icons$delete,
						A2(
							$author$project$UI$Button$withRole,
							1,
							A2(
								$author$project$UI$Button$button,
								A2($author$project$Accounts$Edit$UserClickedRevokeRole, role, authorization.l2),
								'Intrekken'))))),
				A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[$mdgriffith$elm_ui$Element$alignRight]),
				$author$project$UI$Button$elementFor(
					A2(
						$author$project$UI$Button$withIcon,
						$icidasset$elm_material_icons$Material$Icons$edit,
						A2(
							$author$project$UI$Button$withRole,
							0,
							A2(
								$author$project$UI$Button$button,
								A2($author$project$Accounts$Edit$UserClickedEditRole, role, authorization.l2),
								'Aanpassen')))))
			]);
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(5)
				]),
			A2(
				$elm$core$List$cons,
				roleName,
				_Utils_ap(
					function () {
						switch (role.$) {
							case 0:
								var uuids = role.a;
								return dpView(uuids);
							case 1:
								var uuids = role.a;
								return dpView(uuids);
							case 2:
								var uuids = role.a;
								return dpView(uuids);
							case 3:
								var uuids = role.a;
								return dpView(uuids);
							case 4:
								return _List_Nil;
							case 5:
								return _List_Nil;
							case 6:
								return _List_Nil;
							case 7:
								return _List_Nil;
							case 8:
								var delivererId = role.a;
								return _List_fromArray(
									[
										$mdgriffith$elm_ui$Element$text(
										$author$project$Deliverer$Deliverer$comparableId(delivererId))
									]);
							case 9:
								return _List_Nil;
							case 10:
								return _List_Nil;
							case 11:
								return _List_Nil;
							case 12:
								return _List_Nil;
							default:
								return _List_Nil;
						}
					}(),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$row,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
								]),
							buttons)
						]))));
	});
var $author$project$UI$Text$Normal = 0;
var $author$project$UI$Text$Text = $elm$core$Basics$identity;
var $author$project$UI$Text$text = function (content) {
	return {dN: $elm$core$Maybe$Nothing, d: content, mD: $elm$core$Maybe$Nothing, fP: false, hu: 0};
};
var $author$project$Accounts$Edit$rolesView = F2(
	function (dps, authorization) {
		var _v0 = authorization.ny;
		if (_v0.b) {
			return A2(
				$elm$core$List$map,
				A2($author$project$Accounts$Edit$roleView, dps, authorization),
				A2($elm$core$List$sortBy, $author$project$Accounts$Authorization$roleName, authorization.ny));
		} else {
			return _List_fromArray(
				[
					$author$project$UI$Text$elementFor(
					$author$project$UI$Text$text('Geen rollen'))
				]);
		}
	});
var $author$project$Accounts$Edit$authorizationView = F2(
	function (dps, authorization) {
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				A2($author$project$Accounts$Edit$rolesView, dps, authorization),
				A2(
					$author$project$UI$Container$withTitle,
					$mdgriffith$elm_ui$Element$text(
						'Vanaf ' + $author$project$Date$DeliveryDate$view(authorization.l2)),
					A2($author$project$UI$Container$withWidth, $mdgriffith$elm_ui$Element$fill, $author$project$UI$Container$container))));
	});
var $author$project$Accounts$Edit$authorizationsView = F2(
	function (dps, authorizations) {
		return A2(
			$elm$core$List$map,
			$author$project$Accounts$Edit$authorizationView(dps),
			A2(
				$elm$core$List$sortBy,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.l2;
					},
					$author$project$Date$DeliveryDate$oldestFirst),
				authorizations));
	});
var $mdgriffith$elm_ui$Element$fillPortion = $mdgriffith$elm_ui$Internal$Model$Fill;
var $author$project$Accounts$Edit$UserClickedAddRole = {$: 3};
var $icidasset$elm_material_icons$Material$Icons$add = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z')
				]),
			_List_Nil)
		]));
var $author$project$Accounts$Edit$UserClickedCancel = {$: 9};
var $author$project$Accounts$Edit$UserClickedSave = {$: 10};
var $author$project$Accounts$Edit$UserSelectedDate = function (a) {
	return {$: 4, a: a};
};
var $author$project$Accounts$Edit$UserSelectedRole = function (a) {
	return {$: 5, a: a};
};
var $author$project$UI$Input$date = function (attributes) {
	return $mdgriffith$elm_ui$Element$Input$text(
		_Utils_ap(
			attributes,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$htmlAttribute(
					$elm$html$Html$Attributes$type_('date')),
					$mdgriffith$elm_ui$Element$htmlAttribute(
					A2($elm$html$Html$Attributes$style, 'flex-direction', 'row'))
				])));
};
var $author$project$Accounts$Edit$UserClickedDistributionPoint = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Accounts$Edit$distributionPointCheckboxView = F2(
	function (selected, _v0) {
		var id = _v0.eg;
		var name = _v0.ft;
		return A2(
			$mdgriffith$elm_ui$Element$Input$checkbox,
			_List_Nil,
			{
				lc: A2($elm$core$List$member, id, selected),
				mg: $mdgriffith$elm_ui$Element$Input$defaultCheckbox,
				mD: A2(
					$mdgriffith$elm_ui$Element$Input$labelRight,
					_List_Nil,
					$mdgriffith$elm_ui$Element$text(name)),
				mY: $author$project$Accounts$Edit$UserClickedDistributionPoint(id)
			});
	});
var $author$project$Accounts$Edit$distributionPointFormField = F2(
	function (available, selected) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$spacing(2)
				]),
			A2(
				$elm$core$List$map,
				$author$project$Accounts$Edit$distributionPointCheckboxView(selected),
				A2(
					$elm$core$List$sortBy,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.ft;
						},
						$elm$core$String$toLower),
					available)));
	});
var $author$project$Accounts$Edit$distributionPointFormFieldForRole = F3(
	function (available, selected, role) {
		switch (role.$) {
			case 0:
				return $elm$core$Maybe$Just(
					A2($author$project$Accounts$Edit$distributionPointFormField, available, selected));
			case 1:
				return $elm$core$Maybe$Just(
					A2($author$project$Accounts$Edit$distributionPointFormField, available, selected));
			case 2:
				return $elm$core$Maybe$Just(
					A2($author$project$Accounts$Edit$distributionPointFormField, available, selected));
			case 3:
				return $elm$core$Maybe$Just(
					A2($author$project$Accounts$Edit$distributionPointFormField, available, selected));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $mdgriffith$elm_ui$Element$Input$defaultRadioOption = F2(
	function (optionLabel, status) {
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$spacing(10),
					$mdgriffith$elm_ui$Element$alignLeft,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$px(14)),
							$mdgriffith$elm_ui$Element$height(
							$mdgriffith$elm_ui$Element$px(14)),
							$mdgriffith$elm_ui$Element$Background$color($mdgriffith$elm_ui$Element$Input$white),
							$mdgriffith$elm_ui$Element$Border$rounded(7),
							function () {
							if (status === 2) {
								return $mdgriffith$elm_ui$Internal$Model$htmlClass('focusable');
							} else {
								return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
							}
						}(),
							$mdgriffith$elm_ui$Element$Border$width(
							function () {
								switch (status) {
									case 0:
										return 1;
									case 1:
										return 1;
									default:
										return 5;
								}
							}()),
							$mdgriffith$elm_ui$Element$Border$color(
							function () {
								switch (status) {
									case 0:
										return A3($mdgriffith$elm_ui$Element$rgb, 208 / 255, 208 / 255, 208 / 255);
									case 1:
										return A3($mdgriffith$elm_ui$Element$rgb, 208 / 255, 208 / 255, 208 / 255);
									default:
										return A3($mdgriffith$elm_ui$Element$rgb, 59 / 255, 153 / 255, 252 / 255);
								}
							}())
						]),
					$mdgriffith$elm_ui$Element$none),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Internal$Model$htmlClass('unfocusable')
						]),
					optionLabel)
				]));
	});
var $mdgriffith$elm_ui$Element$Input$option = F2(
	function (val, txt) {
		return A2(
			$mdgriffith$elm_ui$Element$Input$Option,
			val,
			$mdgriffith$elm_ui$Element$Input$defaultRadioOption(txt));
	});
var $mdgriffith$elm_ui$Element$Input$Column = 1;
var $mdgriffith$elm_ui$Element$Input$radio = $mdgriffith$elm_ui$Element$Input$radioHelper(1);
var $author$project$Accounts$Edit$roleFormErrorView = function (error) {
	if (error === 1) {
		return A2(
			$mdgriffith$elm_ui$Element$paragraph,
			_List_Nil,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$text('Rol is verplicht')
				]));
	} else {
		return A2(
			$mdgriffith$elm_ui$Element$paragraph,
			_List_Nil,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$text('Datum moet in de toekomst zijn')
				]));
	}
};
var $author$project$Accounts$Edit$roleFormErrorsView = function (errors) {
	if (!errors.b) {
		return $mdgriffith$elm_ui$Element$none;
	} else {
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				A2($elm$core$List$map, $author$project$Accounts$Edit$roleFormErrorView, errors),
				A2($author$project$UI$Container$withVariant, 2, $author$project$UI$Container$container)));
	}
};
var $author$project$Accounts$Authorization$roles = _List_fromArray(
	[
		$author$project$Accounts$Authorization$RegionDistributor(_List_Nil),
		$author$project$Accounts$Authorization$Entrepreneur(_List_Nil),
		$author$project$Accounts$Authorization$AssistantDistributor(_List_Nil),
		$author$project$Accounts$Authorization$Counter(_List_Nil),
		$author$project$Accounts$Authorization$AccountManager,
		$author$project$Accounts$Authorization$LogisticsSupporter,
		$author$project$Accounts$Authorization$RegionManager,
		$author$project$Accounts$Authorization$OperationalManager,
		$author$project$Accounts$Authorization$FinancialAdministrator,
		$author$project$Accounts$Authorization$Preparer,
		$author$project$Accounts$Authorization$Recruiter,
		$author$project$Accounts$Authorization$LaborMarketCommunicator,
		$author$project$Accounts$Authorization$Admin
	]);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.g5;
	});
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				'0',
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0;
	var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
	var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		ky: 1 + (((rd - week1Day1) / 7) | 0),
		kz: wy,
		ox: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.ky;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.kz;
	});
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.fs(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.gW(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.fs(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.gi(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.cS(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.cS(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.cS(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.hH(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.cS(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.cS(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4($justinmimbs$date$Date$formatField, language, 'E', length, date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (!token.$) {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 1, a: a};
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\'')),
	$elm$parser$Parser$token('\'\''));
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.c, s);
};
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 1) && _v0.b.b) && (_v0.b.a.$ === 1)) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return function (s) {
		var _v0 = thunk(0);
		var parse = _v0;
		return parse(s);
	};
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (_char !== '\'') && (!$elm$core$Char$isAlpha(_char));
};
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq('\''))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq('\''))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
				},
				$elm$parser$Parser$token('\'\'')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('\''))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('\'')),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	gi: $justinmimbs$date$Date$withOrdinalSuffix,
	gW: $justinmimbs$date$Date$monthToName,
	fs: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	hH: $justinmimbs$date$Date$weekdayToName,
	cS: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $justinmimbs$date$Date$toIsoString = $justinmimbs$date$Date$format('yyyy-MM-dd');
var $author$project$Accounts$Edit$roleAddFormView = F3(
	function (today, availableDps, _v0) {
		var from = _v0.l2;
		var role = _v0.cz;
		var distributionPoints = _v0.A;
		var validationErrors = _v0.f_;
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_Nil,
			$elm_community$maybe_extra$Maybe$Extra$values(
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						$author$project$Accounts$Edit$roleFormErrorsView(validationErrors)),
						$elm$core$Maybe$Just(
						$author$project$UI$Input$row(
							_List_fromArray(
								[
									A2(
									$author$project$UI$Input$date,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$width(
											$mdgriffith$elm_ui$Element$px(180)),
											$mdgriffith$elm_ui$Element$htmlAttribute(
											A2(
												$elm$html$Html$Attributes$attribute,
												'min',
												$justinmimbs$date$Date$toIsoString(
													$author$project$Date$DeliveryDate$toDate(today))))
										]),
									{
										mD: $author$project$UI$Input$label('Gaat in op'),
										mY: $author$project$Accounts$Edit$UserSelectedDate,
										ng: $elm$core$Maybe$Nothing,
										n3: from
									})
								]))),
						$elm$core$Maybe$Just(
						$author$project$UI$Input$row(
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$Input$radio,
									_List_Nil,
									{
										mD: $author$project$UI$Input$label('Rol'),
										mY: $author$project$Accounts$Edit$UserSelectedRole,
										m7: A2(
											$elm$core$List$map,
											function (r) {
												return A2(
													$mdgriffith$elm_ui$Element$Input$option,
													r,
													$mdgriffith$elm_ui$Element$text(
														$author$project$Accounts$Authorization$roleName(r)));
											},
											A2($elm$core$List$sortBy, $author$project$Accounts$Authorization$roleName, $author$project$Accounts$Authorization$roles)),
										nI: role
									})
								]))),
						A2(
						$elm$core$Maybe$andThen,
						A2($author$project$Accounts$Edit$distributionPointFormFieldForRole, availableDps, distributionPoints),
						role),
						$elm$core$Maybe$Just(
						$author$project$UI$Input$row(
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$column,
									_List_fromArray(
										[$mdgriffith$elm_ui$Element$alignLeft]),
									_List_fromArray(
										[
											$author$project$UI$Button$elementFor(
											A2(
												$author$project$UI$Button$withRole,
												1,
												A2($author$project$UI$Button$button, $author$project$Accounts$Edit$UserClickedCancel, 'Annuleren')))
										])),
									A2(
									$mdgriffith$elm_ui$Element$column,
									_List_fromArray(
										[$mdgriffith$elm_ui$Element$alignRight]),
									_List_fromArray(
										[
											$author$project$UI$Button$elementFor(
											A2(
												$author$project$UI$Button$withRole,
												0,
												A2($author$project$UI$Button$button, $author$project$Accounts$Edit$UserClickedSave, 'Opslaan')))
										]))
								])))
					])));
	});
var $author$project$UI$Text$withLabel = F2(
	function (label, _v0) {
		var t = _v0;
		return _Utils_update(
			t,
			{
				mD: $elm$core$Maybe$Just(label)
			});
	});
var $author$project$Accounts$Edit$roleEditFormView = F3(
	function (today, availableDps, _v0) {
		var from = _v0.l2;
		var role = _v0.cz;
		var distributionPoints = _v0.A;
		var validationErrors = _v0.f_;
		var roleTitle = function (r) {
			return $author$project$UI$Text$elementFor(
				A2(
					$author$project$UI$Text$withLabel,
					'Rol',
					$author$project$UI$Text$text(
						$author$project$Accounts$Authorization$roleName(r))));
		};
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_Nil,
			$elm_community$maybe_extra$Maybe$Extra$values(
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$andThen,
						A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, roleTitle),
						role),
						$elm$core$Maybe$Just(
						$author$project$Accounts$Edit$roleFormErrorsView(validationErrors)),
						$elm$core$Maybe$Just(
						$author$project$UI$Input$row(
							_List_fromArray(
								[
									A2(
									$author$project$UI$Input$date,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$width(
											$mdgriffith$elm_ui$Element$px(180)),
											$mdgriffith$elm_ui$Element$htmlAttribute(
											A2(
												$elm$html$Html$Attributes$attribute,
												'min',
												$justinmimbs$date$Date$toIsoString(
													$author$project$Date$DeliveryDate$toDate(today))))
										]),
									{
										mD: $author$project$UI$Input$label('Gaat in op'),
										mY: $author$project$Accounts$Edit$UserSelectedDate,
										ng: $elm$core$Maybe$Nothing,
										n3: from
									})
								]))),
						A2(
						$elm$core$Maybe$andThen,
						A2($author$project$Accounts$Edit$distributionPointFormFieldForRole, availableDps, distributionPoints),
						role),
						$elm$core$Maybe$Just(
						$author$project$UI$Input$row(
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$column,
									_List_fromArray(
										[$mdgriffith$elm_ui$Element$alignLeft]),
									_List_fromArray(
										[
											$author$project$UI$Button$elementFor(
											A2(
												$author$project$UI$Button$withRole,
												1,
												A2($author$project$UI$Button$button, $author$project$Accounts$Edit$UserClickedCancel, 'Annuleren')))
										])),
									A2(
									$mdgriffith$elm_ui$Element$column,
									_List_fromArray(
										[$mdgriffith$elm_ui$Element$alignRight]),
									_List_fromArray(
										[
											$author$project$UI$Button$elementFor(
											A2(
												$author$project$UI$Button$withRole,
												0,
												A2($author$project$UI$Button$button, $author$project$Accounts$Edit$UserClickedSave, 'Opslaan')))
										]))
								])))
					])));
	});
var $author$project$Accounts$Edit$roleRevokeFormErrorView = function (error) {
	return A2(
		$mdgriffith$elm_ui$Element$paragraph,
		_List_Nil,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$text('Datum moet in de toekomst zijn')
			]));
};
var $author$project$Accounts$Edit$roleRevokeFormErrorsView = function (errors) {
	if (!errors.b) {
		return $mdgriffith$elm_ui$Element$none;
	} else {
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				A2($elm$core$List$map, $author$project$Accounts$Edit$roleRevokeFormErrorView, errors),
				A2($author$project$UI$Container$withVariant, 2, $author$project$UI$Container$container)));
	}
};
var $author$project$Accounts$Edit$roleRevokeFormView = F3(
	function (role, today, _v0) {
		var from = _v0.l2;
		var validationErrors = _v0.f_;
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$UI$Text$elementFor(
					A2(
						$author$project$UI$Text$withLabel,
						'Rol',
						$author$project$UI$Text$text(
							$author$project$Accounts$Authorization$roleName(role)))),
					$author$project$Accounts$Edit$roleRevokeFormErrorsView(validationErrors),
					$author$project$UI$Input$row(
					_List_fromArray(
						[
							A2(
							$author$project$UI$Input$date,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width(
									$mdgriffith$elm_ui$Element$px(180)),
									$mdgriffith$elm_ui$Element$htmlAttribute(
									A2(
										$elm$html$Html$Attributes$attribute,
										'min',
										$justinmimbs$date$Date$toIsoString(
											$author$project$Date$DeliveryDate$toDate(today))))
								]),
							{
								mD: $author$project$UI$Input$label('Tot'),
								mY: $author$project$Accounts$Edit$UserSelectedDate,
								ng: $elm$core$Maybe$Nothing,
								n3: from
							})
						])),
					$author$project$UI$Input$row(
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$column,
							_List_fromArray(
								[$mdgriffith$elm_ui$Element$alignLeft]),
							_List_fromArray(
								[
									$author$project$UI$Button$elementFor(
									A2(
										$author$project$UI$Button$withRole,
										1,
										A2($author$project$UI$Button$button, $author$project$Accounts$Edit$UserClickedCancel, 'Annuleren')))
								])),
							A2(
							$mdgriffith$elm_ui$Element$column,
							_List_fromArray(
								[$mdgriffith$elm_ui$Element$alignRight]),
							_List_fromArray(
								[
									$author$project$UI$Button$elementFor(
									A2(
										$author$project$UI$Button$withRole,
										0,
										A2($author$project$UI$Button$button, $author$project$Accounts$Edit$UserClickedSave, 'Intrekken')))
								]))
						]))
				]));
	});
var $author$project$Accounts$Edit$userInputView = F3(
	function (today, availableDps, userInput) {
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withWidth,
				$mdgriffith$elm_ui$Element$fill,
				A2(
					$author$project$UI$Container$withContent,
					function () {
						switch (userInput.$) {
							case 0:
								return _List_fromArray(
									[
										$author$project$UI$Button$elementFor(
										A2(
											$author$project$UI$Button$withIcon,
											$icidasset$elm_material_icons$Material$Icons$add,
											A2(
												$author$project$UI$Button$withRole,
												0,
												A2($author$project$UI$Button$button, $author$project$Accounts$Edit$UserClickedAddRole, 'Rol toevoegen'))))
									]);
							case 1:
								var roleForm = userInput.a;
								return _List_fromArray(
									[
										A3($author$project$Accounts$Edit$roleAddFormView, today, availableDps, roleForm)
									]);
							case 2:
								var roleForm = userInput.a;
								return _List_fromArray(
									[
										A3($author$project$Accounts$Edit$roleEditFormView, today, availableDps, roleForm)
									]);
							case 3:
								var role = userInput.a;
								var form = userInput.b;
								return _List_fromArray(
									[
										A3($author$project$Accounts$Edit$roleRevokeFormView, role, today, form)
									]);
							default:
								return _List_fromArray(
									[
										$mdgriffith$elm_ui$Element$text('Bezig met verwerken...')
									]);
						}
					}(),
					$author$project$UI$Container$container)));
	});
var $author$project$Accounts$Edit$view = F2(
	function (share, model) {
		var today = $author$project$Portal$Share$today(share);
		if (model.$ === 1) {
			var distributionPoints = model.a.A;
			var authorizations = model.a.az;
			var userInput = model.a.ax;
			return A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$padding(2),
						$mdgriffith$elm_ui$Element$spacing(10),
						$mdgriffith$elm_ui$Element$centerX
					]),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$row,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$spacing(10)
							]),
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$column,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width(
										A2($mdgriffith$elm_ui$Element$minimum, 450, $mdgriffith$elm_ui$Element$fill)),
										$mdgriffith$elm_ui$Element$alignTop,
										$mdgriffith$elm_ui$Element$spacing(10)
									]),
								A2($author$project$Accounts$Edit$authorizationsView, distributionPoints, authorizations)),
								A2(
								$mdgriffith$elm_ui$Element$column,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width(
										$mdgriffith$elm_ui$Element$fillPortion(1)),
										$mdgriffith$elm_ui$Element$alignTop
									]),
								_List_fromArray(
									[
										A3($author$project$Accounts$Edit$userInputView, today, distributionPoints, userInput)
									]))
							]))
					]));
		} else {
			return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$Accounts$Overview$UserCanceledEdit = {$: 15};
var $author$project$Accounts$Overview$UserClickedSave = {$: 16};
var $author$project$Accounts$Overview$UserClickedAccessRights = {$: 5};
var $author$project$Accounts$Overview$UserClickedDisable = {$: 3};
var $author$project$Accounts$Overview$UserClickedEdit = {$: 12};
var $author$project$Accounts$Overview$UserClickedEnable = {$: 1};
var $author$project$Accounts$Overview$UserClickedResend = {$: 9};
var $author$project$UI$Spacing$large = $mdgriffith$elm_ui$Element$spacing($author$project$UI$Spacing$largeSize);
var $icidasset$elm_material_icons$Material$Icons$person_off = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$b('new 0 0 24 24'),
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$rect,
			_List_fromArray(
				[
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$icidasset$elm_material_icons$Material$Icons$Internal$p,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M8.65,5.82C9.36,4.72,10.6,4,12,4c2.21,0,4,1.79,4,4c0,1.4-0.72,2.64-1.82,3.35L8.65,5.82z M20,17.17 c-0.02-1.1-0.63-2.11-1.61-2.62c-0.54-0.28-1.13-0.54-1.77-0.76L20,17.17z M21.19,21.19L2.81,2.81L1.39,4.22l8.89,8.89 c-1.81,0.23-3.39,0.79-4.67,1.45C4.61,15.07,4,16.1,4,17.22V20h13.17l2.61,2.61L21.19,21.19z')
						]),
					_List_Nil)
				]))
		]));
var $icidasset$elm_material_icons$Material$Icons$person_pin = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M12 2c-4.97 0-9 4.03-9 9 0 4.17 2.84 7.67 6.69 8.69L12 22l2.31-2.31C18.16 18.67 21 15.17 21 11c0-4.97-4.03-9-9-9zm0 2c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.3c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z')
				]),
			_List_Nil)
		]));
var $icidasset$elm_material_icons$Material$Icons$settings = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$b('new 0 0 24 24'),
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$icidasset$elm_material_icons$Material$Icons$Internal$p,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M0,0h24v24H0V0z'),
							$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
						]),
					_List_Nil),
					A2(
					$icidasset$elm_material_icons$Material$Icons$Internal$p,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z')
						]),
					_List_Nil)
				]))
		]));
var $author$project$UI$Button$withAlignRight = function (_v0) {
	var b = _v0;
	return _Utils_update(
		b,
		{eJ: true});
};
var $author$project$Accounts$Overview$buttons = function (_v0) {
	var enabled = _v0.lN;
	var status = _v0.nS;
	return enabled ? A2(
		$mdgriffith$elm_ui$Element$row,
		_List_fromArray(
			[
				$author$project$UI$Spacing$large,
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
			]),
		_List_fromArray(
			[
				$author$project$UI$Button$elementFor(
				A2(
					$author$project$UI$Button$withRole,
					0,
					A2(
						$author$project$UI$Button$withIcon,
						$icidasset$elm_material_icons$Material$Icons$edit,
						A2($author$project$UI$Button$button, $author$project$Accounts$Overview$UserClickedEdit, 'Aanpassen')))),
				$author$project$UI$Button$elementFor(
				A2(
					$author$project$UI$Button$withRole,
					0,
					A2(
						$author$project$UI$Button$withIcon,
						$icidasset$elm_material_icons$Material$Icons$settings,
						A2($author$project$UI$Button$button, $author$project$Accounts$Overview$UserClickedAccessRights, 'Toegangsrechten')))),
				function () {
				if (!status.$) {
					return $author$project$UI$Button$elementFor(
						A2($author$project$UI$Button$button, $author$project$Accounts$Overview$UserClickedResend, 'Validatie email versturen'));
				} else {
					return $mdgriffith$elm_ui$Element$none;
				}
			}(),
				$author$project$UI$Button$elementFor(
				$author$project$UI$Button$withAlignRight(
					A2(
						$author$project$UI$Button$withRole,
						1,
						A2(
							$author$project$UI$Button$withIcon,
							$icidasset$elm_material_icons$Material$Icons$person_off,
							A2($author$project$UI$Button$button, $author$project$Accounts$Overview$UserClickedDisable, 'Deactiveren')))))
			])) : $author$project$UI$Button$elementFor(
		A2(
			$author$project$UI$Button$withRole,
			0,
			A2(
				$author$project$UI$Button$withIcon,
				$icidasset$elm_material_icons$Material$Icons$person_pin,
				A2($author$project$UI$Button$button, $author$project$Accounts$Overview$UserClickedEnable, 'Activeren'))));
};
var $author$project$UI$Spacing$defaultSize = 10;
var $author$project$UI$Spacing$default = $mdgriffith$elm_ui$Element$spacing($author$project$UI$Spacing$defaultSize);
var $author$project$UI$Container$Disabled = 4;
var $author$project$UI$Element$iconBadge = F3(
	function (label, icon, _v0) {
		var background = _v0.kV;
		var border = _v0.k0;
		var font = _v0.lZ;
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					A2($mdgriffith$elm_ui$Element$paddingXY, 5, 2),
					$mdgriffith$elm_ui$Element$Border$rounded(12),
					$mdgriffith$elm_ui$Element$Border$color(
					$author$project$UI$Element$colorFor(border)),
					$mdgriffith$elm_ui$Element$Background$color(
					$author$project$UI$Element$colorFor(background)),
					$mdgriffith$elm_ui$Element$Border$width(2),
					$mdgriffith$elm_ui$Element$alignRight,
					$mdgriffith$elm_ui$Element$alignTop,
					$mdgriffith$elm_ui$Element$htmlAttribute(
					$elm$html$Html$Attributes$title(label))
				]),
			$mdgriffith$elm_ui$Element$html(
				A2(
					icon,
					12,
					$icidasset$elm_material_icons$Material$Icons$Types$Color(
						function (_v1) {
							var r = _v1.a;
							var g = _v1.b;
							var b = _v1.c;
							return A3(
								$avh4$elm_color$Color$rgb255,
								$elm$core$Basics$round(r),
								$elm$core$Basics$round(g),
								$elm$core$Basics$round(b));
						}(
							$tesk9$palette$SolidColor$toRGB(font))))));
	});
var $author$project$Accounts$Overview$notActiveTag = A3($author$project$UI$Element$iconBadge, 'Niet actief', $icidasset$elm_material_icons$Material$Icons$person_off, $author$project$UI$Palette$error);
var $author$project$UI$Container$withSpacing = F2(
	function (spacing, _v0) {
		var c = _v0;
		return _Utils_update(
			c,
			{j9: spacing});
	});
var $author$project$Accounts$Overview$detailContainer = function (_v0) {
	var enabled = _v0.lN;
	return A2(
		$author$project$UI$Container$withSpacing,
		$author$project$UI$Spacing$defaultSize,
		A2(
			$author$project$UI$Container$withWidth,
			$mdgriffith$elm_ui$Element$fill,
			(enabled ? $author$project$UI$Container$withTitle(
				$mdgriffith$elm_ui$Element$text('Account')) : A2(
				$elm$core$Basics$composeR,
				$author$project$UI$Container$withTitle(
					A2(
						$mdgriffith$elm_ui$Element$row,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
							]),
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text('Account (Niet actief)'),
								$author$project$Accounts$Overview$notActiveTag
							]))),
				$author$project$UI$Container$withVariant(4)))($author$project$UI$Container$container)));
};
var $author$project$Accounts$Overview$statusColor = function (status) {
	return $mdgriffith$elm_ui$Element$Font$color(
		$author$project$UI$Element$colorFor(
			function () {
				switch (status.$) {
					case 0:
						return $author$project$UI$Palette$lightMagenta;
					case 1:
						return $author$project$UI$Palette$base01;
					case 2:
						return $author$project$UI$Palette$green;
					default:
						return $author$project$UI$Palette$magenta;
				}
			}()));
};
var $author$project$UI$Label$tagged = F2(
	function (label, element) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$spacing(3),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					$author$project$UI$Font$tag,
					$mdgriffith$elm_ui$Element$text(label)),
					element
				]));
	});
var $author$project$Accounts$Overview$detailView = function (account) {
	var username = account.os;
	var email = account.d5;
	var phone = account.eq;
	var status = account.nS;
	var enabled = account.lN;
	return $author$project$UI$Container$elementFor(
		A2(
			$author$project$UI$Container$withContent,
			_List_fromArray(
				[
					$author$project$UI$Text$elementFor(
					A2(
						$author$project$UI$Text$withLabel,
						'Gebruikersnaam',
						$author$project$UI$Text$text(username))),
					$author$project$UI$Text$elementFor(
					A2(
						$author$project$UI$Text$withLabel,
						'Email',
						$author$project$UI$Text$text(email))),
					$author$project$UI$Text$elementFor(
					A2(
						$author$project$UI$Text$withLabel,
						'Phone',
						$author$project$UI$Text$text(phone))),
					A2(
					$author$project$UI$Label$tagged,
					'Type',
					A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$author$project$Accounts$Overview$statusColor(status)
							]),
						$mdgriffith$elm_ui$Element$text(
							$author$project$Accounts$Account$statusView(status))))
				]),
			$author$project$Accounts$Overview$detailContainer(account)));
};
var $author$project$UI$Button$disabledIf = F3(
	function (condition, reason, _v0) {
		var b = _v0;
		return condition ? _Utils_update(
			b,
			{
				gX: $author$project$UI$Button$Disabled(reason)
			}) : b;
	});
var $author$project$Accounts$Overview$UserChangedEmail = function (a) {
	return {$: 13, a: a};
};
var $author$project$Accounts$Overview$UserChangedPhone = function (a) {
	return {$: 14, a: a};
};
var $author$project$Accounts$Account$emailErrorsView = function (errors) {
	var _v0 = $elm$core$List$length(errors);
	if (!_v0) {
		return $mdgriffith$elm_ui$Element$none;
	} else {
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				A2(
					$elm$core$List$map,
					function (err) {
						return A2(
							$mdgriffith$elm_ui$Element$paragraph,
							_List_Nil,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text(
									$author$project$UI$Validation$Email$invalidView(err))
								]));
					},
					errors),
				A2($author$project$UI$Container$withVariant, 2, $author$project$UI$Container$container)));
	}
};
var $author$project$Accounts$Account$invalidPhoneView = function (err) {
	switch (err) {
		case 0:
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[
						'Het mobiele nummer dient minimaal ',
						$elm$core$String$fromInt($author$project$Accounts$Account$minLength),
						'karakters te bevatten.'
					]));
		case 1:
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[
						'Het mobiele nummer mag maximaal ',
						$elm$core$String$fromInt($author$project$Accounts$Account$maxLength),
						'karakters bevatten.'
					]));
		default:
			return 'Het ingevoerde mobiele nummer is ongeldig. Gebruik alstublieft het formaat: +31612345678.';
	}
};
var $author$project$Accounts$Account$phoneErrorsView = function (errors) {
	var _v0 = $elm$core$List$length(errors);
	if (!_v0) {
		return $mdgriffith$elm_ui$Element$none;
	} else {
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				A2(
					$elm$core$List$map,
					function (err) {
						return A2(
							$mdgriffith$elm_ui$Element$paragraph,
							_List_Nil,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text(
									$author$project$Accounts$Account$invalidPhoneView(err))
								]));
					},
					errors),
				A2($author$project$UI$Container$withVariant, 2, $author$project$UI$Container$container)));
	}
};
var $author$project$Accounts$Overview$editView = F2(
	function (account, _v0) {
		var username = account.os;
		var status = account.nS;
		var email = _v0.d5;
		var phone = _v0.eq;
		var emailErrors = _v0.iv;
		var phoneErrors = _v0.jw;
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				_List_fromArray(
					[
						$author$project$UI$Text$elementFor(
						A2(
							$author$project$UI$Text$withLabel,
							'Gebruikersnaam',
							$author$project$UI$Text$text(username))),
						A2(
						$author$project$UI$Input$email,
						_List_Nil,
						{
							mD: A2(
								$mdgriffith$elm_ui$Element$Input$labelAbove,
								$author$project$UI$Font$tag,
								$mdgriffith$elm_ui$Element$text('Email')),
							mY: $author$project$Accounts$Overview$UserChangedEmail,
							ng: $elm$core$Maybe$Nothing,
							n3: email
						}),
						$author$project$Accounts$Account$emailErrorsView(emailErrors),
						A2(
						$mdgriffith$elm_ui$Element$Input$text,
						_List_Nil,
						{
							mD: A2(
								$mdgriffith$elm_ui$Element$Input$labelAbove,
								$author$project$UI$Font$tag,
								$mdgriffith$elm_ui$Element$text('Telefoon')),
							mY: $author$project$Accounts$Overview$UserChangedPhone,
							ng: $elm$core$Maybe$Nothing,
							n3: phone
						}),
						$author$project$Accounts$Account$phoneErrorsView(phoneErrors),
						A2(
						$author$project$UI$Label$tagged,
						'Type',
						A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$author$project$Accounts$Overview$statusColor(status)
								]),
							$mdgriffith$elm_ui$Element$text(
								$author$project$Accounts$Account$statusView(status))))
					]),
				$author$project$Accounts$Overview$detailContainer(account)));
	});
var $author$project$Accounts$Overview$accountView = function (selected) {
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$author$project$UI$Spacing$default,
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$alignTop
			]),
		function () {
			switch (selected.$) {
				case 0:
					return _List_Nil;
				case 1:
					var account = selected.a;
					return _List_fromArray(
						[
							$author$project$Accounts$Overview$detailView(account),
							$author$project$Accounts$Overview$buttons(account)
						]);
				default:
					var account = selected.a;
					var accountForm = selected.b;
					return _List_fromArray(
						[
							A2($author$project$Accounts$Overview$editView, account, accountForm),
							A2(
							$mdgriffith$elm_ui$Element$row,
							_List_fromArray(
								[
									$author$project$UI$Spacing$large,
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
								]),
							_List_fromArray(
								[
									$author$project$UI$Button$elementFor(
									A2(
										$author$project$UI$Button$withRole,
										1,
										A2($author$project$UI$Button$button, $author$project$Accounts$Overview$UserCanceledEdit, 'Annuleren'))),
									$author$project$UI$Button$elementFor(
									$author$project$UI$Button$withAlignRight(
										A3(
											$author$project$UI$Button$disabledIf,
											!($elm$core$List$isEmpty(accountForm.iv) && $elm$core$List$isEmpty(accountForm.jw)),
											'Het account kan niet opgeslagen worden.',
											A2(
												$author$project$UI$Button$withRole,
												0,
												A2($author$project$UI$Button$button, $author$project$Accounts$Overview$UserClickedSave, 'Opslaan')))))
								]))
						]);
			}
		}());
};
var $author$project$Accounts$Overview$UserClickedAccount = function (a) {
	return {$: 11, a: a};
};
var $author$project$UI$Font$bodyLarge = _List_fromArray(
	[
		$mdgriffith$elm_ui$Element$Font$size(
		$author$project$UI$Font$scaled(2)),
		$author$project$UI$Font$openSans
	]);
var $author$project$UI$Card$Card = $elm$core$Basics$identity;
var $author$project$UI$Card$card = function (onPress) {
	return {d: _List_Nil, gS: $elm$core$Maybe$Nothing, jp: onPress, nI: false, hl: $elm$core$Maybe$Nothing};
};
var $author$project$UI$Card$cardColors = function (selected) {
	return $author$project$UI$Element$colors(
		selected ? {kV: $author$project$UI$Palette$base1, k0: $author$project$UI$Palette$base0, lZ: $author$project$UI$Palette$base02} : {kV: $author$project$UI$Palette$base2, k0: $author$project$UI$Palette$base0, lZ: $author$project$UI$Palette$base02});
};
var $author$project$UI$Card$attributesFor = F2(
	function (selectedAttr, selected) {
		return function () {
			var _v0 = _Utils_Tuple2(selected, selectedAttr);
			if (_v0.a && (!_v0.b.$)) {
				var attr = _v0.b.a;
				return $elm$core$List$cons(attr);
			} else {
				return $elm$core$Basics$identity;
			}
		}()(
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$Border$width(2),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$Border$rounded(3),
						$author$project$UI$Card$cardColors(selected)))));
	});
var $author$project$UI$Card$labelFor = F2(
	function (marker, content) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_Utils_ap(
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$spacing(4),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				function () {
					if (marker.$ === 1) {
						return _List_fromArray(
							[
								$mdgriffith$elm_ui$Element$padding(8)
							]);
					} else {
						if (!marker.a.$) {
							var _v1 = marker.a;
							return _List_fromArray(
								[
									$mdgriffith$elm_ui$Element$paddingEach(
									{k5: 8, mE: 11, nx: 8, ol: 8})
								]);
						} else {
							var c = marker.a.a;
							return _List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Border$color(
									$author$project$UI$Element$colorFor(c)),
									$mdgriffith$elm_ui$Element$Border$widthEach(
									{k5: 0, mE: 3, nx: 0, ol: 0}),
									$mdgriffith$elm_ui$Element$padding(8)
								]);
						}
					}
				}()),
			content);
	});
var $author$project$UI$Card$elementFor = function (_v0) {
	var onPress = _v0.jp;
	var content = _v0.d;
	var selected = _v0.nI;
	var selectedAttr = _v0.hl;
	var marker = _v0.gS;
	return A2(
		$mdgriffith$elm_ui$Element$Input$button,
		A2($author$project$UI$Card$attributesFor, selectedAttr, selected),
		{
			mD: A2($author$project$UI$Card$labelFor, marker, content),
			jp: $elm$core$Maybe$Just(onPress)
		});
};
var $icidasset$elm_material_icons$Material$Icons$email = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z')
				]),
			_List_Nil)
		]));
var $author$project$Accounts$Overview$selectedAccount = function (selection) {
	switch (selection.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var account = selection.a;
			return $elm$core$Maybe$Just(account);
		default:
			var account = selection.a;
			return $elm$core$Maybe$Just(account);
	}
};
var $author$project$UI$Card$selectedIf = F2(
	function (selection, _v0) {
		var c = _v0;
		return _Utils_update(
			c,
			{nI: selection});
	});
var $author$project$UI$Card$withContent = F2(
	function (content, _v0) {
		var c = _v0;
		return _Utils_update(
			c,
			{
				d: _Utils_ap(c.d, content)
			});
	});
var $author$project$Accounts$Overview$accountCard = F2(
	function (selected, account) {
		var username = account.os;
		var email = account.d5;
		var status = account.nS;
		var enabled = account.lN;
		return $author$project$UI$Card$elementFor(
			A2(
				$author$project$UI$Card$selectedIf,
				_Utils_eq(
					$author$project$Accounts$Overview$selectedAccount(selected),
					$elm$core$Maybe$Just(account)),
				A2(
					$author$project$UI$Card$withContent,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$row,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
								]),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$el,
									$author$project$UI$Font$bodyLarge,
									$mdgriffith$elm_ui$Element$text(username)),
									enabled ? $mdgriffith$elm_ui$Element$none : $author$project$Accounts$Overview$notActiveTag
								])),
							A2(
							$mdgriffith$elm_ui$Element$row,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$spacing(5),
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
								]),
							_List_fromArray(
								[
									$author$project$UI$Element$iconFor(
									$icidasset$elm_material_icons$Material$Icons$email(12)),
									A2(
									$mdgriffith$elm_ui$Element$paragraph,
									$author$project$UI$Font$tag,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$text(email)
										]))
								])),
							A2(
							$mdgriffith$elm_ui$Element$el,
							A2(
								$elm$core$List$cons,
								$author$project$Accounts$Overview$statusColor(status),
								A2($elm$core$List$cons, $mdgriffith$elm_ui$Element$alignRight, $author$project$UI$Font$tag)),
							$mdgriffith$elm_ui$Element$text(
								$author$project$Accounts$Account$statusView(status)))
						]),
					$author$project$UI$Card$card(
						$author$project$Accounts$Overview$UserClickedAccount(account)))));
	});
var $author$project$UI$Card$column = F3(
	function (window, toCard, items) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_Utils_ap(
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$spacing(5),
						$mdgriffith$elm_ui$Element$alignTop,
						$mdgriffith$elm_ui$Element$alignLeft,
						$mdgriffith$elm_ui$Element$paddingEach(
						{k5: 20, mE: 5, nx: 5, ol: 5}),
						$mdgriffith$elm_ui$Element$scrollbarY,
						$mdgriffith$elm_ui$Element$width(window.oy),
						$mdgriffith$elm_ui$Element$height(window.iK)
					]),
				$author$project$UI$Element$colors(
					{kV: $author$project$UI$Palette$base1, k0: $author$project$UI$Palette$base0, lZ: $author$project$UI$Palette$base03})),
			A2($elm$core$List$map, toCard, items));
	});
var $author$project$UI$Card$defaultColumnWidth = $mdgriffith$elm_ui$Element$px(300);
var $author$project$Accounts$Overview$listWidth = $author$project$UI$Card$defaultColumnWidth;
var $author$project$Accounts$Overview$accountsView = F3(
	function (selected, accounts, window) {
		return A3(
			$author$project$UI$Card$column,
			{
				iK: $mdgriffith$elm_ui$Element$px(window.iK),
				oy: $author$project$Accounts$Overview$listWidth
			},
			$author$project$Accounts$Overview$accountCard(selected),
			accounts);
	});
var $author$project$UI$Columns$Columns = $elm$core$Basics$identity;
var $author$project$UI$Padding$largeSize = 20;
var $author$project$UI$Columns$columns = function (window) {
	return {
		eT: _List_Nil,
		l9: _Utils_Tuple2(0, $mdgriffith$elm_ui$Element$none),
		g6: $author$project$UI$Padding$largeSize,
		j9: $author$project$UI$Spacing$largeSize,
		oz: window
	};
};
var $author$project$Portal$Page$contentSize = function (_v0) {
	var width = _v0.oy;
	var height = _v0.iK;
	return {iK: (height - $author$project$Portal$Page$headerHeight) - $author$project$Portal$Page$subHeaderHeight, oy: width};
};
var $author$project$Portal$Page$contentWindow = function (share) {
	return $author$project$Portal$Page$contentSize(
		$author$project$Portal$Share$ui(share).oz);
};
var $author$project$Accounts$Overview$UserClickedAddAccount = {$: 6};
var $author$project$Accounts$Overview$createAccountButton = $author$project$UI$Button$elementFor(
	$author$project$UI$Button$withAlignRight(
		A2(
			$author$project$UI$Button$withIcon,
			$icidasset$elm_material_icons$Material$Icons$add,
			A2(
				$author$project$UI$Button$withRole,
				1,
				A2($author$project$UI$Button$button, $author$project$Accounts$Overview$UserClickedAddAccount, 'Account aanmaken')))));
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $author$project$UI$Separator$size = 1;
var $author$project$UI$Separator$vertical = A2(
	$mdgriffith$elm_ui$Element$el,
	_List_fromArray(
		[
			$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
			$mdgriffith$elm_ui$Element$width(
			$mdgriffith$elm_ui$Element$px($author$project$UI$Separator$size)),
			$mdgriffith$elm_ui$Element$Background$color(
			$author$project$UI$Element$colorFor($author$project$UI$Palette$base0))
		]),
	$mdgriffith$elm_ui$Element$none);
var $author$project$UI$Columns$columnElementsFor = F2(
	function (window, cols) {
		return $elm$core$List$reverse(
			A2(
				$elm$core$List$intersperse,
				$author$project$UI$Separator$vertical,
				A2(
					$elm$core$List$filter,
					$elm$core$Basics$neq($mdgriffith$elm_ui$Element$none),
					A2(
						$elm$core$List$map,
						function (c) {
							return c(
								{iK: window.iK});
						},
						cols))));
	});
var $author$project$UI$Separator$horizontal = A2(
	$mdgriffith$elm_ui$Element$el,
	_List_fromArray(
		[
			$mdgriffith$elm_ui$Element$height(
			$mdgriffith$elm_ui$Element$px($author$project$UI$Separator$size)),
			$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
			$mdgriffith$elm_ui$Element$Background$color(
			$author$project$UI$Element$colorFor($author$project$UI$Palette$base0))
		]),
	$mdgriffith$elm_ui$Element$none);
var $author$project$UI$Window$reducedHeight = F2(
	function (heightToReduce, window) {
		return _Utils_update(
			window,
			{
				iK: A2($elm$core$Basics$max, 0, window.iK - heightToReduce)
			});
	});
var $author$project$UI$Columns$elementFor = function (_v0) {
	var c = _v0;
	var windowWithoutPadding = A2($author$project$UI$Window$reducedHeight, 2 * c.g6, c.oz);
	var _v1 = c.l9;
	if (!_v1.a) {
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$padding(c.g6),
					$mdgriffith$elm_ui$Element$spacing(c.j9),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$author$project$UI$Element$avoidPrintInterference
				]),
			A2($author$project$UI$Columns$columnElementsFor, windowWithoutPadding, c.eT));
	} else {
		var headerHeight = _v1.a;
		var header = _v1.b;
		var columnsWindow = A2($author$project$UI$Window$reducedHeight, ((headerHeight + c.j9) + $author$project$UI$Separator$size) + c.j9, windowWithoutPadding);
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$padding(c.g6),
					$mdgriffith$elm_ui$Element$spacing(c.j9),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$author$project$UI$Element$avoidPrintInterference
				]),
			_List_fromArray(
				[
					header,
					$author$project$UI$Separator$horizontal,
					A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$spacing(c.j9),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
							$author$project$UI$Element$avoidPrintInterference
						]),
					A2($author$project$UI$Columns$columnElementsFor, columnsWindow, c.eT))
				]));
	}
};
var $author$project$UI$Search$height = 42;
var $author$project$Accounts$Overview$noAccountsFoundView = $author$project$UI$Container$elementFor(
	A2(
		$author$project$UI$Container$withWidth,
		$author$project$Accounts$Overview$listWidth,
		A2(
			$author$project$UI$Container$withContent,
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$paragraph,
					_List_Nil,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text('Geen accounts gevonden.')
						]))
				]),
			$author$project$UI$Container$container)));
var $author$project$Accounts$Overview$UserChangedSearch = function (a) {
	return {$: 7, a: a};
};
var $author$project$Accounts$Overview$UserPressedEnterInSearch = {$: 8};
var $author$project$UI$Search$attributesFor = function (printVisibility) {
	return A2(
		$elm$core$List$cons,
		$author$project$UI$Spacing$default,
		A2(
			$elm$core$List$cons,
			$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
			function () {
				if (!printVisibility) {
					return _List_Nil;
				} else {
					return _List_fromArray(
						[$author$project$UI$Element$invisibleForPrint]);
				}
			}()));
};
var $author$project$UI$Search$elementForErrors = function (errors) {
	if (!errors.b) {
		return $mdgriffith$elm_ui$Element$none;
	} else {
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withWidth,
				$mdgriffith$elm_ui$Element$fill,
				A2(
					$author$project$UI$Container$withContent,
					A2(
						$elm$core$List$map,
						function (e) {
							return A2(
								$mdgriffith$elm_ui$Element$paragraph,
								_List_Nil,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$text(e)
									]));
						},
						errors),
					A2($author$project$UI$Container$withVariant, 2, $author$project$UI$Container$container))));
	}
};
var $icidasset$elm_material_icons$Material$Icons$search = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z')
				]),
			_List_Nil)
		]));
var $elm$html$Html$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
var $elm_community$html_extra$Html$Events$Extra$onEnter = function (onEnterAction) {
	return A2(
		$elm$html$Html$Events$on,
		'keyup',
		A2(
			$elm$json$Json$Decode$andThen,
			function (keyCode) {
				return (keyCode === 13) ? $elm$json$Json$Decode$succeed(onEnterAction) : $elm$json$Json$Decode$fail(
					$elm$core$String$fromInt(keyCode));
			},
			$elm$html$Html$Events$keyCode));
};
var $elm$html$Html$Events$onFocus = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'focus',
		$elm$json$Json$Decode$succeed(msg));
};
var $mdgriffith$elm_ui$Element$Events$onFocus = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Events$onFocus);
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $mdgriffith$elm_ui$Element$Events$onLoseFocus = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Events$onBlur);
var $author$project$UI$Search$textAttributesFor = F2(
	function (focus, onPressedEnter) {
		return $elm_community$maybe_extra$Maybe$Extra$values(
			A2(
				$elm$core$List$cons,
				$elm$core$Maybe$Just(
					$mdgriffith$elm_ui$Element$width(
						$mdgriffith$elm_ui$Element$px(400))),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Element$htmlAttribute, $elm_community$html_extra$Html$Events$Extra$onEnter),
						onPressedEnter),
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						_List_Nil,
						function (_v0) {
							var onFocus = _v0.m_;
							var onLoseFocus = _v0.m0;
							return _List_fromArray(
								[
									$elm$core$Maybe$Just(
									$mdgriffith$elm_ui$Element$Events$onFocus(onFocus)),
									$elm$core$Maybe$Just(
									$mdgriffith$elm_ui$Element$Events$onLoseFocus(onLoseFocus))
								]);
						},
						focus))));
	});
var $author$project$UI$Search$elementFor = function (_v0) {
	var search = _v0;
	var focus = search.db;
	var onChange = search.mY;
	var placeholder = search.ng;
	var label = search.mD;
	var errors = search.b;
	var onPressedEnter = search.g3;
	var printVisibility = search.hc;
	return A2(
		$mdgriffith$elm_ui$Element$row,
		$author$project$UI$Search$attributesFor(printVisibility),
		_List_fromArray(
			[
				$author$project$UI$Element$iconFor(
				$icidasset$elm_material_icons$Material$Icons$search(32)),
				A2(
				$mdgriffith$elm_ui$Element$Input$text,
				A2($author$project$UI$Search$textAttributesFor, focus, onPressedEnter),
				{mD: label, mY: onChange, ng: placeholder, n3: search.n3}),
				$author$project$UI$Search$elementForErrors(errors)
			]));
};
var $author$project$Accounts$Overview$searchFormErrorView = function (error) {
	return 'Gelieve ten minste drie karakters in te voeren.';
};
var $author$project$UI$Search$Search = $elm$core$Basics$identity;
var $author$project$UI$Search$VisibleForPrint = 0;
var $author$project$UI$Search$text = F3(
	function (txt, onChange, label) {
		return {b: _List_Nil, db: $elm$core$Maybe$Nothing, mD: label, mY: onChange, g3: $elm$core$Maybe$Nothing, ng: $elm$core$Maybe$Nothing, hc: 0, n3: txt};
	});
var $author$project$UI$Search$withErrors = F2(
	function (errors, _v0) {
		var input = _v0;
		return _Utils_update(
			input,
			{b: errors});
	});
var $author$project$UI$Search$withOnPressedEnter = F2(
	function (onPressedEnter, _v0) {
		var input = _v0;
		return _Utils_update(
			input,
			{
				g3: $elm$core$Maybe$Just(onPressedEnter)
			});
	});
var $author$project$UI$Search$withPlaceholder = F2(
	function (placeholder, _v0) {
		var input = _v0;
		return _Utils_update(
			input,
			{
				ng: $elm$core$Maybe$Just(placeholder)
			});
	});
var $author$project$Accounts$Overview$searchView = function (_v0) {
	var startsWith = _v0.dC;
	var validationErrors = _v0.f_;
	return $author$project$UI$Search$elementFor(
		A2(
			$author$project$UI$Search$withErrors,
			A2($elm$core$List$map, $author$project$Accounts$Overview$searchFormErrorView, validationErrors),
			A2(
				$author$project$UI$Search$withOnPressedEnter,
				$author$project$Accounts$Overview$UserPressedEnterInSearch,
				A2(
					$author$project$UI$Search$withPlaceholder,
					A2(
						$mdgriffith$elm_ui$Element$Input$placeholder,
						_List_Nil,
						$mdgriffith$elm_ui$Element$text('Email adres')),
					A3(
						$author$project$UI$Search$text,
						startsWith,
						$author$project$Accounts$Overview$UserChangedSearch,
						$mdgriffith$elm_ui$Element$Input$labelHidden('Zoek op het begin van een email adres'))))));
};
var $author$project$UI$Columns$withColumn = F2(
	function (column, _v0) {
		var c = _v0;
		return _Utils_update(
			c,
			{
				eT: A2($elm$core$List$cons, column, c.eT)
			});
	});
var $author$project$UI$Columns$withHeader = F3(
	function (height, header, _v0) {
		var c = _v0;
		return _Utils_update(
			c,
			{
				l9: _Utils_Tuple2(height, header)
			});
	});
var $author$project$Accounts$Overview$view = F2(
	function (share, model) {
		return $author$project$UI$Columns$elementFor(
			function () {
				if (model.$ === 2) {
					var accounts = model.a.dM;
					var selected = model.a.nI;
					if (!accounts.b) {
						return $author$project$UI$Columns$withColumn(
							$elm$core$Basics$always($author$project$Accounts$Overview$noAccountsFoundView));
					} else {
						return A2(
							$elm$core$Basics$composeR,
							$author$project$UI$Columns$withColumn(
								A2($author$project$Accounts$Overview$accountsView, selected, accounts)),
							$author$project$UI$Columns$withColumn(
								$elm$core$Basics$always(
									$author$project$Accounts$Overview$accountView(selected))));
					}
				} else {
					return $elm$core$Basics$identity;
				}
			}()(
				A3(
					$author$project$UI$Columns$withHeader,
					$author$project$UI$Search$height,
					A2(
						$mdgriffith$elm_ui$Element$row,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$author$project$UI$Spacing$large
							]),
						_List_fromArray(
							[
								$author$project$Accounts$Overview$searchView(
								$author$project$Accounts$Overview$searchIn(model)),
								$author$project$Accounts$Overview$createAccountButton
							])),
					$author$project$UI$Columns$columns(
						$author$project$Portal$Page$contentWindow(share)))));
	});
var $author$project$Applicant$Overview$UserChangedCompanyName = function (a) {
	return {$: 32, a: a};
};
var $author$project$Applicant$Overview$UserChangedStart = function (a) {
	return {$: 41, a: a};
};
var $author$project$Applicant$Overview$UserClickedCancelButton = {$: 17};
var $author$project$Applicant$Overview$UserClickedSave = function (a) {
	return {$: 18, a: a};
};
var $author$project$UI$Container$Warning = 1;
var $author$project$Applicant$Overview$UserChangedAvailability = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$Date$DaysInTheWeek$Green = 1;
var $author$project$Date$DaysInTheWeek$buttonView = F2(
	function (_v0, day) {
		var days = _v0;
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$width('30px'),
					$elm$svg$Svg$Attributes$height('30px'),
					$elm$svg$Svg$Attributes$viewBox('0 0 30 30')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Date$DaysInTheWeek$dayIcon,
					{eP: true, eS: 1, e1: days.e1, bB: $author$project$Date$DaysInTheWeek$circleSizeLarge},
					day)
				]));
	});
var $author$project$Date$DaysInTheWeek$member = F2(
	function (day, _v0) {
		var days = _v0.e1;
		return A2($Gizra$elm_all_set$EverySet$member, day, days);
	});
var $author$project$Applicant$Overview$availabilityDayView = F2(
	function (days, day) {
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Events$onClick(
					A2(
						$author$project$Applicant$Overview$UserChangedAvailability,
						day,
						!A2($author$project$Date$DaysInTheWeek$member, day, days)))
				]),
			$mdgriffith$elm_ui$Element$html(
				A2($author$project$Date$DaysInTheWeek$buttonView, days, day)));
	});
var $author$project$Applicant$Overview$dpChangeView = function (model) {
	var _v0 = model.e6;
	if (!_v0.b) {
		return $mdgriffith$elm_ui$Element$none;
	} else {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(5),
					$mdgriffith$elm_ui$Element$alignTop
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					$author$project$UI$Font$label,
					$mdgriffith$elm_ui$Element$text('Distributiepunt')),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_Nil,
					A3($PaackEng$elm_ui_dropdown$Dropdown$view, $author$project$Applicant$Overview$dpDDConfig, model, model.w))
				]));
	}
};
var $author$project$Applicant$Overview$validationAvailabilityView = function (_v0) {
	return 'Er dient op minimaal een dag beschikbaar te zijn.';
};
var $author$project$Applicant$Overview$validationView = function (content) {
	var _v0 = $elm$core$List$length(content);
	if (!_v0) {
		return $mdgriffith$elm_ui$Element$none;
	} else {
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				A2(
					$elm$core$List$map,
					function (line) {
						return A2(
							$mdgriffith$elm_ui$Element$paragraph,
							_List_Nil,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text(line)
								]));
					},
					content),
				A2($author$project$UI$Container$withVariant, 2, $author$project$UI$Container$container)));
	}
};
var $author$project$Applicant$Overview$availabilityDaysDPChangeView = function (model) {
	return A2(
		$mdgriffith$elm_ui$Element$row,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$spacing(10)
			]),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$spacing(5),
						$mdgriffith$elm_ui$Element$alignTop
					]),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$el,
						$author$project$UI$Font$label,
						$mdgriffith$elm_ui$Element$text('Beschikbaarheid')),
						A2(
						$mdgriffith$elm_ui$Element$row,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Applicant$Overview$availabilityDayView, model.a.cY.e1, 0),
								A2($author$project$Applicant$Overview$availabilityDayView, model.a.cY.e1, 1),
								A2($author$project$Applicant$Overview$availabilityDayView, model.a.cY.e1, 2),
								A2($author$project$Applicant$Overview$availabilityDayView, model.a.cY.e1, 3),
								A2($author$project$Applicant$Overview$availabilityDayView, model.a.cY.e1, 4),
								A2($author$project$Applicant$Overview$availabilityDayView, model.a.cY.e1, 5)
							])),
						$author$project$Applicant$Overview$validationView(
						A2($elm$core$List$map, $author$project$Applicant$Overview$validationAvailabilityView, model.b.cc))
					])),
				$author$project$Applicant$Overview$dpChangeView(model.I)
			]));
};
var $author$project$Applicant$Overview$UserChangedBornOn = function (a) {
	return {$: 40, a: a};
};
var $author$project$Applicant$Overview$UserChangedContractType = function (a) {
	return {$: 42, a: a};
};
var $author$project$Applicant$Applicant$contractTypeView = function (contractType) {
	switch (contractType) {
		case 0:
			return 'Regulier';
		case 1:
			return 'Fictief';
		case 2:
			return 'Ondertekening door ouders';
		default:
			return 'Firma';
	}
};
var $author$project$Applicant$Overview$emptyWarningAndErrorAttributes = F2(
	function (errorList, isEmpty) {
		return function (field) {
			var _v0 = _Utils_Tuple2(
				$elm$core$List$isEmpty(errorList),
				isEmpty(field));
			if (_v0.a) {
				if (_v0.b) {
					return $author$project$UI$Element$colors($author$project$UI$Palette$warning);
				} else {
					return _List_Nil;
				}
			} else {
				return $author$project$UI$Element$colors($author$project$UI$Palette$error);
			}
		};
	});
var $author$project$Applicant$Overview$maxStart = function (today) {
	return A3(
		$justinmimbs$date$Date$add,
		0,
		1,
		$author$project$Date$DeliveryDate$toDate(today));
};
var $author$project$UI$Input$onOptionSelect = F2(
	function (toMsg, optionDecode) {
		var decoder = A2(
			$elm$json$Json$Decode$map,
			toMsg,
			A2($elm$json$Json$Decode$andThen, optionDecode, $elm$html$Html$Events$targetValue));
		return A2($elm$html$Html$Events$on, 'change', decoder);
	});
var $elm$html$Html$option = _VirtualDom_node('option');
var $author$project$UI$Input$optionIsSelected = F2(
	function (selection, value) {
		if (!selection.$) {
			var string = selection.a;
			return _Utils_eq(value, string);
		} else {
			return false;
		}
	});
var $elm$html$Html$select = _VirtualDom_node('select');
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $author$project$UI$Input$selectWithOptions = F5(
	function (allOptions, selectedOption, toMsg, _v0, inputLabel) {
		var view = _v0.eG;
		var encode = _v0.d6;
		var decode = _v0.d$;
		var isSelected = $author$project$UI$Input$optionIsSelected(selectedOption);
		var toOption = function (optionValue) {
			return A2(
				$elm$html$Html$option,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$selected(
						isSelected(optionValue)),
						$elm$html$Html$Attributes$value(
						encode(optionValue))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						view(optionValue))
					]));
		};
		var options = A2($elm$core$List$map, toOption, allOptions);
		var element = $mdgriffith$elm_ui$Element$html(
			A2(
				$elm$html$Html$select,
				_List_fromArray(
					[
						A2($author$project$UI$Input$onOptionSelect, toMsg, decode),
						A2($elm$html$Html$Attributes$style, 'height', 'calc(1em + 24px)'),
						A2($elm$html$Html$Attributes$style, 'padding', '0 5px'),
						A2($elm$html$Html$Attributes$style, 'margin', '5px 0 0 0'),
						A2($elm$html$Html$Attributes$style, 'border-color', 'rgba(186,189,182,1)'),
						A2(
						$elm$html$Html$Attributes$style,
						'background-color',
						$tesk9$palette$SolidColor$toHex($author$project$UI$Palette$base2)),
						A2($elm$html$Html$Attributes$style, 'border-radius', '3px')
					]),
				options));
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					$author$project$UI$Font$label,
					$mdgriffith$elm_ui$Element$text(inputLabel)),
					element
				]));
	});
var $author$project$Applicant$Overview$validateStart = F3(
	function (minStart, start, today) {
		return A3(
			$justinmimbs$date$Date$isBetween,
			$author$project$Date$DeliveryDate$toDate(minStart),
			$author$project$Applicant$Overview$maxStart(today),
			$author$project$Date$DeliveryDate$toDate(start));
	});
var $author$project$Applicant$Overview$validationBornOnView = function (err) {
	if (!err) {
		return 'Om de krant te bezorgen dient de kandidaat minimaal 15 jaar te zijn als het contract start.';
	} else {
		return 'Gelieve een correcte geboortedatum invullen.';
	}
};
var $author$project$Applicant$Overview$validationStartView = 'Gelieve een geldige ingangsdatum in te vullen.';
var $author$project$Applicant$Overview$bornOnStartChangeView = F3(
	function (minStart, today, _v0) {
		var changed = _v0.a;
		var errors = _v0.b;
		var bornOn = _v0.c$;
		var start = _v0.hq;
		var _v1 = A3($author$project$Applicant$Overview$validateStart, minStart, changed.cY.hq, today) ? _Utils_Tuple2(_List_Nil, $mdgriffith$elm_ui$Element$none) : _Utils_Tuple2(
			$author$project$UI$Element$colors($author$project$UI$Palette$warning),
			$author$project$UI$Container$elementFor(
				A2(
					$author$project$UI$Container$withContent,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text($author$project$Applicant$Overview$validationStartView)
						]),
					A2($author$project$UI$Container$withVariant, 1, $author$project$UI$Container$container))));
		var startAttributes = _v1.a;
		var startValidationView = _v1.b;
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(10)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(5),
							$mdgriffith$elm_ui$Element$alignTop
						]),
					_List_fromArray(
						[
							A2(
							$author$project$UI$Input$date,
							_Utils_ap(
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width(
										$mdgriffith$elm_ui$Element$px(140)),
										$mdgriffith$elm_ui$Element$htmlAttribute(
										A2(
											$elm$html$Html$Attributes$attribute,
											'min',
											$justinmimbs$date$Date$toIsoString(
												A3(
													$justinmimbs$date$Date$add,
													0,
													0 - $author$project$Applicant$Overview$maximumAge,
													$author$project$Date$DeliveryDate$toDate(today))))),
										$mdgriffith$elm_ui$Element$htmlAttribute(
										A2(
											$elm$html$Html$Attributes$attribute,
											'max',
											$justinmimbs$date$Date$toIsoString(
												A3(
													$justinmimbs$date$Date$add,
													0,
													0 - $author$project$Applicant$Overview$minimumAge,
													$author$project$Date$DeliveryDate$toDate(changed.cY.hq)))))
									]),
								A3($author$project$Applicant$Overview$emptyWarningAndErrorAttributes, errors.c$, $elm$core$String$isEmpty, bornOn)),
							{
								mD: $author$project$UI$Input$label('Geboortedatum'),
								mY: $author$project$Applicant$Overview$UserChangedBornOn,
								ng: $elm$core$Maybe$Nothing,
								n3: bornOn
							}),
							$author$project$Applicant$Overview$validationView(
							A2($elm$core$List$map, $author$project$Applicant$Overview$validationBornOnView, errors.c$))
						])),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(5),
							$mdgriffith$elm_ui$Element$alignTop
						]),
					_List_fromArray(
						[
							A2(
							$author$project$UI$Input$date,
							_Utils_ap(
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width(
										$mdgriffith$elm_ui$Element$px(140)),
										$mdgriffith$elm_ui$Element$htmlAttribute(
										A2(
											$elm$html$Html$Attributes$attribute,
											'min',
											$justinmimbs$date$Date$toIsoString(
												$author$project$Date$DeliveryDate$toDate(minStart)))),
										$mdgriffith$elm_ui$Element$htmlAttribute(
										A2(
											$elm$html$Html$Attributes$attribute,
											'max',
											$justinmimbs$date$Date$toIsoString(
												$author$project$Applicant$Overview$maxStart(today))))
									]),
								startAttributes),
							{
								mD: $author$project$UI$Input$label('Ingangsdatum'),
								mY: $author$project$Applicant$Overview$UserChangedStart,
								ng: $elm$core$Maybe$Nothing,
								n3: start
							}),
							startValidationView
						])),
					A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(5),
							$mdgriffith$elm_ui$Element$alignTop
						]),
					_List_fromArray(
						[
							A5(
							$author$project$UI$Input$selectWithOptions,
							$author$project$Applicant$Applicant$availableContractTypes(
								A2(
									$elm$core$Maybe$map,
									$author$project$Date$DeliveryDate$age(changed.cY.hq),
									changed.c$)),
							$elm$core$Maybe$Just(changed.gh),
							$author$project$Applicant$Overview$UserChangedContractType,
							{d$: $author$project$Applicant$Applicant$contractTypeDecoder, d6: $author$project$Applicant$Applicant$contractTypeToString, eG: $author$project$Applicant$Applicant$contractTypeView},
							'Contractsoort'),
							(changed.gh === 1) ? A2(
							$mdgriffith$elm_ui$Element$paragraph,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Font$bold,
									$mdgriffith$elm_ui$Element$moveDown(10)
								]),
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text('Bij een fictief contract dient minimaal €875,00 verdiend te worden.')
								])) : $mdgriffith$elm_ui$Element$none
						]))
				]));
	});
var $author$project$Applicant$Overview$UserChangedBSN = function (a) {
	return {$: 45, a: a};
};
var $author$project$Applicant$Overview$UserChangedIBAN = function (a) {
	return {$: 48, a: a};
};
var $author$project$Applicant$Overview$validationLengthView = F2(
	function (field, err) {
		if (!err.$) {
			var i = err.a;
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[
						field,
						'dient minimaal',
						$elm$core$String$fromInt(i),
						'karakters te bevatten.'
					]));
		} else {
			var i = err.a;
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[
						field,
						'mag maximaal',
						$elm$core$String$fromInt(i),
						'karakters bevatten.'
					]));
		}
	});
var $author$project$Applicant$Overview$validationBSNView = function (err) {
	switch (err.$) {
		case 0:
			var lengthInvalid = err.a;
			return A2($author$project$Applicant$Overview$validationLengthView, 'Het BSN', lengthInvalid);
		case 1:
			return 'Het BSN mag alleen uit getallen bestaan.';
		default:
			return 'Het BSN is ongeldig, het voldoet niet aan de elf proef.';
	}
};
var $author$project$Applicant$Overview$validationIBANView = function (err) {
	switch (err.$) {
		case 0:
			var lengthInvalid = err.a;
			return A2($author$project$Applicant$Overview$validationLengthView, 'Het IBAN', lengthInvalid);
		case 1:
			return 'Gelieve met een geldige landcode te beginnen, bijvoorbeeld NL.';
		case 2:
			return 'Gelieve met een geldige landcode en controlegetal te beginnen, bijvoorbeeld NL99.';
		case 3:
			return 'Gelieve een geldige IBAN in te vullen, formaat NL99BBBB9999999999.';
		default:
			return 'Het IBAN is ongeldig, controleer het rekeningnummer op fouten.';
	}
};
var $author$project$Applicant$Overview$bsnAndIBANChangeView = F3(
	function (bsn, iban, errors) {
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(10)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(5),
							$mdgriffith$elm_ui$Element$alignTop
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$Input$text,
							A3($author$project$Applicant$Overview$emptyWarningAndErrorAttributes, errors.gd, $elm$core$String$isEmpty, bsn),
							{
								mD: $author$project$UI$Input$label('Burgerservicenummer (BSN)'),
								mY: $author$project$Applicant$Overview$UserChangedBSN,
								ng: $elm$core$Maybe$Nothing,
								n3: bsn
							}),
							$author$project$Applicant$Overview$validationView(
							A2($elm$core$List$map, $author$project$Applicant$Overview$validationBSNView, errors.gd))
						])),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(5),
							$mdgriffith$elm_ui$Element$alignTop
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$Input$text,
							A3($author$project$Applicant$Overview$emptyWarningAndErrorAttributes, errors.gE, $elm$core$String$isEmpty, iban),
							{
								mD: $author$project$UI$Input$label('IBAN'),
								mY: $author$project$Applicant$Overview$UserChangedIBAN,
								ng: $elm$core$Maybe$Nothing,
								n3: iban
							}),
							$author$project$Applicant$Overview$validationView(
							A2($elm$core$List$map, $author$project$Applicant$Overview$validationIBANView, errors.gE))
						]))
				]));
	});
var $author$project$Applicant$Overview$UserChangedStatusComment = function (a) {
	return {$: 26, a: a};
};
var $mdgriffith$elm_ui$Element$Input$multiline = F2(
	function (attrs, multi) {
		return A3(
			$mdgriffith$elm_ui$Element$Input$textHelper,
			{a_: $elm$core$Maybe$Nothing, be: multi.nR, af: $mdgriffith$elm_ui$Element$Input$TextArea},
			attrs,
			{mD: multi.mD, mY: multi.mY, ng: multi.ng, n3: multi.n3});
	});
var $author$project$Applicant$Overview$commentChangeView = function (text) {
	return A2(
		$mdgriffith$elm_ui$Element$Input$multiline,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$height(
				$mdgriffith$elm_ui$Element$px(64))
			]),
		{
			mD: $author$project$UI$Input$label('Commentaar'),
			mY: $author$project$Applicant$Overview$UserChangedStatusComment,
			ng: $elm$core$Maybe$Nothing,
			nR: true,
			n3: text
		});
};
var $author$project$Applicant$Overview$UserChangedIdentificationType = function (a) {
	return {$: 49, a: a};
};
var $author$project$Applicant$Overview$UserChangedNationality = function (a) {
	return {$: 50, a: a};
};
var $author$project$Applicant$Applicant$allIdentificationTypes = _List_fromArray(
	[
		$elm$core$Maybe$Nothing,
		$elm$core$Maybe$Just(0),
		$elm$core$Maybe$Just(1),
		$elm$core$Maybe$Just(2),
		$elm$core$Maybe$Just(3)
	]);
var $author$project$Applicant$Applicant$identificationTypeView = function (identificationType) {
	if (!identificationType.$) {
		switch (identificationType.a) {
			case 0:
				var _v1 = identificationType.a;
				return 'Nederlands Paspoort';
			case 1:
				var _v2 = identificationType.a;
				return 'Nederlandse identiteitskaart';
			case 2:
				var _v3 = identificationType.a;
				return 'Nederlands vreemdelingendocument';
			default:
				var _v4 = identificationType.a;
				return 'ID-kaart of paspoort uit een EER-land';
		}
	} else {
		return '';
	}
};
var $author$project$UI$Input$selectWithMaybeOptions = function (dd) {
	var toOption = function (optionValue) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$selected(
					_Utils_eq(dd.nI, optionValue)),
					$elm$html$Html$Attributes$value(
					dd.d6(optionValue))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					dd.eG(optionValue))
				]));
	};
	var options = A2($elm$core$List$map, toOption, dd.m7);
	var _v0 = function () {
		var _v1 = dd.ix && (dd.eG(dd.nI) === '');
		if (_v1) {
			return function (_v2) {
				var background = _v2.kV;
				var border = _v2.k0;
				return _Utils_Tuple2(
					$tesk9$palette$SolidColor$toHex(background),
					$tesk9$palette$SolidColor$toHex(border));
			}($author$project$UI$Palette$warning);
		} else {
			return _Utils_Tuple2(
				$tesk9$palette$SolidColor$toHex($author$project$UI$Palette$base2),
				'rgba(186,189,182,1)');
		}
	}();
	var backgroundColor = _v0.a;
	var borderColor = _v0.b;
	var element = $mdgriffith$elm_ui$Element$html(
		A2(
			$elm$html$Html$select,
			_List_fromArray(
				[
					A2($author$project$UI$Input$onOptionSelect, dd.hz, dd.d$),
					A2($elm$html$Html$Attributes$style, 'height', 'calc(1em + 24px)'),
					A2($elm$html$Html$Attributes$style, 'padding', '0 5px'),
					A2($elm$html$Html$Attributes$style, 'margin', '5px 0 0 0'),
					A2($elm$html$Html$Attributes$style, 'background-color', backgroundColor),
					A2($elm$html$Html$Attributes$style, 'border-color', borderColor),
					A2($elm$html$Html$Attributes$style, 'border-radius', '3px')
				]),
			options));
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$el,
				$author$project$UI$Font$label,
				$mdgriffith$elm_ui$Element$text(dd.mD)),
				element
			]));
};
var $author$project$Applicant$Overview$identificationChangeView = function (changed) {
	return A2(
		$mdgriffith$elm_ui$Element$row,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$spacing(10)
			]),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				$author$project$UI$Input$selectWithMaybeOptions(
					{d$: $author$project$Applicant$Applicant$identificationTypeDecoder, ix: true, d6: $author$project$Applicant$Applicant$identificationTypeToString, mD: 'Legitimatie', m7: $author$project$Applicant$Applicant$allIdentificationTypes, nI: changed.gH, hz: $author$project$Applicant$Overview$UserChangedIdentificationType, eG: $author$project$Applicant$Applicant$identificationTypeView})),
				A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$spacing(5),
						$mdgriffith$elm_ui$Element$alignTop
					]),
				A5(
					$author$project$UI$Input$selectWithOptions,
					$author$project$Applicant$Applicant$availableNationalities(changed.gH),
					$elm$core$Maybe$Just(changed.gZ),
					$author$project$Applicant$Overview$UserChangedNationality,
					{d$: $author$project$Applicant$Nationality$decoder, d6: $author$project$Applicant$Nationality$encoder, eG: $author$project$Applicant$Nationality$view},
					'Nationaliteit'))
			]));
};
var $author$project$Applicant$Overview$UserChangedIdentificationExpiryDate = function (a) {
	return {$: 52, a: a};
};
var $author$project$Applicant$Overview$UserChangedIdentificationNumber = function (a) {
	return {$: 51, a: a};
};
var $author$project$Applicant$Overview$validationIdentificationExpiryDate = function (_v0) {
	return 'Het document is ongeldig op het moment dat de kandidaat start.';
};
var $author$project$Applicant$Overview$identificationDetailsChangeView = F2(
	function (today, _v0) {
		var changed = _v0.a;
		var errors = _v0.b;
		var expiryDate = _v0.bq;
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(10)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(5),
							$mdgriffith$elm_ui$Element$alignTop
						]),
					A2(
						$mdgriffith$elm_ui$Element$Input$text,
						A3($author$project$Applicant$Overview$emptyWarningAndErrorAttributes, errors.gG, $elm$core$String$isEmpty, changed.gG),
						{
							mD: $author$project$UI$Input$label('Documentnummer'),
							mY: $author$project$Applicant$Overview$UserChangedIdentificationNumber,
							ng: $elm$core$Maybe$Nothing,
							n3: changed.gG
						})),
					$author$project$Applicant$Overview$validationView(
					A2(
						$elm$core$List$map,
						$author$project$Applicant$Overview$validationLengthView('Het documentnummer'),
						errors.gG)),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(5),
							$mdgriffith$elm_ui$Element$alignTop
						]),
					_List_fromArray(
						[
							A2(
							$author$project$UI$Input$date,
							_Utils_ap(
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width(
										$mdgriffith$elm_ui$Element$px(140)),
										$mdgriffith$elm_ui$Element$htmlAttribute(
										A2(
											$elm$html$Html$Attributes$attribute,
											'min',
											$justinmimbs$date$Date$toIsoString(
												A2(
													$justinmimbs$date$Date$max,
													$author$project$Date$DeliveryDate$toDate(today),
													A3(
														$justinmimbs$date$Date$add,
														3,
														1,
														$author$project$Date$DeliveryDate$toDate(changed.cY.hq)))))),
										$mdgriffith$elm_ui$Element$htmlAttribute(
										A2($elm$html$Html$Attributes$attribute, 'max', '2999-12-31'))
									]),
								A3(
									$author$project$Applicant$Overview$emptyWarningAndErrorAttributes,
									errors.gF,
									$elm$core$Basics$eq($elm$core$Maybe$Nothing),
									changed.gF)),
							{
								mD: $author$project$UI$Input$label('Geldig tot'),
								mY: $author$project$Applicant$Overview$UserChangedIdentificationExpiryDate,
								ng: $elm$core$Maybe$Nothing,
								n3: expiryDate
							}),
							$author$project$Applicant$Overview$validationView(
							A2($elm$core$List$map, $author$project$Applicant$Overview$validationIdentificationExpiryDate, errors.gF))
						]))
				]));
	});
var $author$project$Applicant$Overview$UserChangedKVKNumber = function (a) {
	return {$: 46, a: a};
};
var $author$project$Applicant$Overview$UserChangedVatId = function (a) {
	return {$: 47, a: a};
};
var $author$project$Applicant$Overview$UserWantsToCheckVatId = {$: 61};
var $author$project$Applicant$Overview$validationKVKNumberView = function (err) {
	if (!err.$) {
		var lengthInvalid = err.a;
		return A2($author$project$Applicant$Overview$validationLengthView, 'Het Kvk Nummer', lengthInvalid);
	} else {
		return 'Het Kvk Nummer mag alleen uit getallen bestaan.';
	}
};
var $author$project$Applicant$Overview$validationVatIdView = function (content) {
	if (!content.b) {
		return $mdgriffith$elm_ui$Element$none;
	} else {
		if ((!content.a) && (!content.b.b)) {
			var _v1 = content.a;
			return $author$project$UI$Container$elementFor(
				A2(
					$author$project$UI$Container$withContent,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$paragraph,
							_List_Nil,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text('Een Nederlands btw-id begint met NL.')
								]))
						]),
					A2($author$project$UI$Container$withVariant, 2, $author$project$UI$Container$container)));
		} else {
			return $author$project$UI$Container$elementFor(
				A2(
					$author$project$UI$Container$withContent,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$paragraph,
							_List_Nil,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text('Gelieve een geldige btw-id in te vullen, die gelidg is volgens '),
									A2(
									$mdgriffith$elm_ui$Element$newTabLink,
									_List_Nil,
									{
										mD: $mdgriffith$elm_ui$Element$text('https://ec.europa.eu/taxation_customs/vies/#/vat-validation.'),
										aW: 'https://ec.europa.eu/taxation_customs/vies/#/vat-validation'
									})
								]))
						]),
					A2($author$project$UI$Container$withVariant, 2, $author$project$UI$Container$container)));
		}
	}
};
var $author$project$Applicant$Overview$kvkNumberAndVatIdAndIBANChangeView = F4(
	function (kvkNumber, vatId, iban, errors) {
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(10)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(5),
							$mdgriffith$elm_ui$Element$alignTop
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$Input$text,
							A3($author$project$Applicant$Overview$emptyWarningAndErrorAttributes, errors.gM, $elm$core$String$isEmpty, kvkNumber),
							{
								mD: $author$project$UI$Input$label('Kvk Nummer'),
								mY: $author$project$Applicant$Overview$UserChangedKVKNumber,
								ng: $elm$core$Maybe$Nothing,
								n3: kvkNumber
							}),
							$author$project$Applicant$Overview$validationView(
							A2($elm$core$List$map, $author$project$Applicant$Overview$validationKVKNumberView, errors.gM))
						])),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(5),
							$mdgriffith$elm_ui$Element$alignTop
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$Input$text,
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Element$Events$onLoseFocus($author$project$Applicant$Overview$UserWantsToCheckVatId),
								A3($author$project$Applicant$Overview$emptyWarningAndErrorAttributes, errors.hF, $elm$core$String$isEmpty, vatId)),
							{
								mD: $author$project$UI$Input$label('BTW-ID'),
								mY: $author$project$Applicant$Overview$UserChangedVatId,
								ng: $elm$core$Maybe$Nothing,
								n3: vatId
							}),
							$author$project$Applicant$Overview$validationVatIdView(errors.hF)
						])),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(5),
							$mdgriffith$elm_ui$Element$alignTop
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$Input$text,
							A3($author$project$Applicant$Overview$emptyWarningAndErrorAttributes, errors.gE, $elm$core$String$isEmpty, iban),
							{
								mD: $author$project$UI$Input$label('IBAN'),
								mY: $author$project$Applicant$Overview$UserChangedIBAN,
								ng: $elm$core$Maybe$Nothing,
								n3: iban
							}),
							$author$project$Applicant$Overview$validationView(
							A2($elm$core$List$map, $author$project$Applicant$Overview$validationIBANView, errors.gE))
						]))
				]));
	});
var $author$project$Applicant$Overview$UserChangedFirstName = function (a) {
	return {$: 29, a: a};
};
var $author$project$Applicant$Overview$UserChangedLastName = function (a) {
	return {$: 31, a: a};
};
var $author$project$Applicant$Overview$UserChangedPrefix = function (a) {
	return {$: 30, a: a};
};
var $author$project$Applicant$Overview$errorAttributes = function (list) {
	return $elm$core$List$isEmpty(list) ? _List_Nil : $author$project$UI$Element$colors($author$project$UI$Palette$error);
};
var $author$project$Applicant$Overview$nameChangeView = F2(
	function (changed, errors) {
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(10)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(5),
							$mdgriffith$elm_ui$Element$alignTop
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$Input$text,
							A3($author$project$Applicant$Overview$emptyWarningAndErrorAttributes, errors.fc, $elm$core$String$isEmpty, changed.fc),
							{
								mD: $author$project$UI$Input$label('Voornaam'),
								mY: $author$project$Applicant$Overview$UserChangedFirstName,
								ng: $elm$core$Maybe$Nothing,
								n3: changed.fc
							}),
							$author$project$Applicant$Overview$validationView(
							A2(
								$elm$core$List$map,
								$author$project$Applicant$Overview$validationLengthView('De voornaam'),
								errors.fc))
						])),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(5),
							$mdgriffith$elm_ui$Element$alignTop
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$Input$text,
							$author$project$Applicant$Overview$errorAttributes(errors.fF),
							{
								mD: $author$project$UI$Input$label('Tussenvoegsel'),
								mY: $author$project$Applicant$Overview$UserChangedPrefix,
								ng: $elm$core$Maybe$Nothing,
								n3: changed.fF
							}),
							$author$project$Applicant$Overview$validationView(
							A2(
								$elm$core$List$map,
								$author$project$Applicant$Overview$validationLengthView('Het tussenvoegsel'),
								errors.fF))
						])),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(5),
							$mdgriffith$elm_ui$Element$alignTop
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$Input$text,
							A3($author$project$Applicant$Overview$emptyWarningAndErrorAttributes, errors.fo, $elm$core$String$isEmpty, changed.fo),
							{
								mD: $author$project$UI$Input$label('Achternaam'),
								mY: $author$project$Applicant$Overview$UserChangedLastName,
								ng: $elm$core$Maybe$Nothing,
								n3: changed.fo
							}),
							$author$project$Applicant$Overview$validationView(
							A2(
								$elm$core$List$map,
								$author$project$Applicant$Overview$validationLengthView('De achternaam'),
								errors.fo))
						]))
				]));
	});
var $author$project$Applicant$Overview$UserChangedParentEmail = function (a) {
	return {$: 44, a: a};
};
var $author$project$Applicant$Overview$UserChangedParentName = function (a) {
	return {$: 43, a: a};
};
var $mdgriffith$elm_ui$Element$Input$email = $mdgriffith$elm_ui$Element$Input$textHelper(
	{
		a_: $elm$core$Maybe$Just('email'),
		be: false,
		af: $mdgriffith$elm_ui$Element$Input$TextInputNode('email')
	});
var $author$project$Applicant$Overview$parentChangeView = F3(
	function (parentName, parentEmail, errors) {
		var maybeStringIsEmpty = A2($elm_community$maybe_extra$Maybe$Extra$unwrap, true, $elm$core$String$isEmpty);
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(10)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(5),
							$mdgriffith$elm_ui$Element$alignTop
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$Input$email,
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								A3($author$project$Applicant$Overview$emptyWarningAndErrorAttributes, errors.g8, maybeStringIsEmpty, parentName)),
							{
								mD: $author$project$UI$Input$label('Ouder naam'),
								mY: $author$project$Applicant$Overview$UserChangedParentName,
								ng: $elm$core$Maybe$Nothing,
								n3: A2($elm$core$Maybe$withDefault, '', parentName)
							}),
							$author$project$Applicant$Overview$validationView(
							A2(
								$elm$core$List$map,
								$author$project$Applicant$Overview$validationLengthView('Ouder naam'),
								errors.g8))
						])),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(5),
							$mdgriffith$elm_ui$Element$alignTop
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$Input$text,
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								A3($author$project$Applicant$Overview$emptyWarningAndErrorAttributes, errors.g7, maybeStringIsEmpty, parentEmail)),
							{
								mD: $author$project$UI$Input$label('Ouder e-mail'),
								mY: $author$project$Applicant$Overview$UserChangedParentEmail,
								ng: $elm$core$Maybe$Nothing,
								n3: A2($elm$core$Maybe$withDefault, '', parentEmail)
							}),
							$author$project$Applicant$Overview$validationView(
							A2($elm$core$List$map, $author$project$UI$Validation$Email$invalidView, errors.g7))
						]))
				]));
	});
var $author$project$Applicant$Overview$UserChangedEmail = function (a) {
	return {$: 39, a: a};
};
var $author$project$Applicant$Overview$UserChangedPhone = function (a) {
	return {$: 38, a: a};
};
var $author$project$Applicant$Overview$validationPhoneView = function (err) {
	if (!err.$) {
		var lengthInvalid = err.a;
		return A2($author$project$Applicant$Overview$validationLengthView, 'Het telefoonnummer', lengthInvalid);
	} else {
		return 'Het telefoonnummer bevat ongeldige karakters.';
	}
};
var $author$project$Applicant$Overview$phoneEmailChangeView = F3(
	function (email, phone, errors) {
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(10)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(5),
							$mdgriffith$elm_ui$Element$alignTop
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$Input$text,
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								A3($author$project$Applicant$Overview$emptyWarningAndErrorAttributes, errors.eq, $elm$core$String$isEmpty, phone)),
							{
								mD: $author$project$UI$Input$label('Telefoon/Mobiel'),
								mY: $author$project$Applicant$Overview$UserChangedPhone,
								ng: $elm$core$Maybe$Nothing,
								n3: phone
							}),
							$author$project$Applicant$Overview$validationView(
							A2($elm$core$List$map, $author$project$Applicant$Overview$validationPhoneView, errors.eq))
						])),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(5),
							$mdgriffith$elm_ui$Element$alignTop
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$Input$email,
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								A3($author$project$Applicant$Overview$emptyWarningAndErrorAttributes, errors.d5, $elm$core$String$isEmpty, email)),
							{
								mD: $author$project$UI$Input$label('E-mail'),
								mY: $author$project$Applicant$Overview$UserChangedEmail,
								ng: $elm$core$Maybe$Nothing,
								n3: email
							}),
							$author$project$Applicant$Overview$validationView(
							A2($elm$core$List$map, $author$project$UI$Validation$Email$invalidView, errors.d5))
						]))
				]));
	});
var $author$project$Applicant$Overview$UserChangedInitials = function (a) {
	return {$: 28, a: a};
};
var $author$project$Applicant$Overview$UserChangedSalutation = function (a) {
	return {$: 27, a: a};
};
var $author$project$Applicant$Applicant$allSalutations = _List_fromArray(
	[
		$elm$core$Maybe$Nothing,
		$elm$core$Maybe$Just(0),
		$elm$core$Maybe$Just(1)
	]);
var $author$project$Applicant$Applicant$salutationView = function (salutation) {
	if (!salutation.$) {
		switch (salutation.a) {
			case 0:
				var _v1 = salutation.a;
				return 'De heer';
			case 1:
				var _v2 = salutation.a;
				return 'Mevrouw';
			default:
				var _v3 = salutation.a;
				return 'Firma';
		}
	} else {
		return '';
	}
};
var $author$project$Applicant$Overview$salutationInitialsChangeView = F3(
	function (salutation, initials, errors) {
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(10)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(5),
							$mdgriffith$elm_ui$Element$alignTop
						]),
					$author$project$UI$Input$selectWithMaybeOptions(
						{d$: $author$project$Applicant$Applicant$salutationDecoder, ix: false, d6: $author$project$Applicant$Applicant$salutationToString, mD: 'Aanhef', m7: $author$project$Applicant$Applicant$allSalutations, nI: salutation, hz: $author$project$Applicant$Overview$UserChangedSalutation, eG: $author$project$Applicant$Applicant$salutationView})),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(5),
							$mdgriffith$elm_ui$Element$alignTop
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$Input$text,
							A3($author$project$Applicant$Overview$emptyWarningAndErrorAttributes, errors.gI, $elm$core$String$isEmpty, initials),
							{
								mD: $author$project$UI$Input$label('Voorletter(s)'),
								mY: $author$project$Applicant$Overview$UserChangedInitials,
								ng: $elm$core$Maybe$Nothing,
								n3: initials
							}),
							$author$project$Applicant$Overview$validationView(
							A2(
								$elm$core$List$map,
								$author$project$Applicant$Overview$validationLengthView('Het veld voorletters'),
								errors.gI))
						]))
				]));
	});
var $author$project$Applicant$Overview$saveWarningsReversed = function (applicant) {
	var _v0 = applicant.gh;
	if (_v0 === 3) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, missingFields) {
					var b = _v1.b;
					return A2($elm$core$List$cons, b, missingFields);
				}),
			_List_Nil,
			A2(
				$elm$core$List$filter,
				$elm$core$Tuple$first,
				_List_fromArray(
					[
						_Utils_Tuple2(
						$elm$core$String$isEmpty(
							A2($elm$core$Maybe$withDefault, '', applicant.eU)),
						'Firma'),
						_Utils_Tuple2(
						$elm$core$String$isEmpty(applicant.f1.cT),
						'Postcode'),
						_Utils_Tuple2(!applicant.f1.bs.bX, 'Huisnummer'),
						_Utils_Tuple2(
						$elm$core$String$isEmpty(applicant.f1.b5),
						'Straat'),
						_Utils_Tuple2(
						$elm$core$String$isEmpty(applicant.f1.bU),
						'Plaats'),
						_Utils_Tuple2(
						$elm$core$String$isEmpty(applicant.eq),
						'Telefoon/Mobiel'),
						_Utils_Tuple2(
						$elm$core$String$isEmpty(applicant.fc),
						'Voornaam'),
						_Utils_Tuple2(
						$elm$core$String$isEmpty(applicant.fo),
						'Achternaam')
					])));
	} else {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v2, missingFields) {
					var b = _v2.b;
					return A2($elm$core$List$cons, b, missingFields);
				}),
			_List_Nil,
			A2(
				$elm$core$List$filter,
				$elm$core$Tuple$first,
				_List_fromArray(
					[
						_Utils_Tuple2(
						$elm$core$String$isEmpty(applicant.fc),
						'Voornaam'),
						_Utils_Tuple2(
						$elm$core$String$isEmpty(applicant.fo),
						'Achternaam'),
						_Utils_Tuple2(
						$elm$core$String$isEmpty(applicant.f1.cT),
						'Postcode'),
						_Utils_Tuple2(!applicant.f1.bs.bX, 'Huisnummer'),
						_Utils_Tuple2(
						$elm$core$String$isEmpty(applicant.f1.b5),
						'Straat'),
						_Utils_Tuple2(
						$elm$core$String$isEmpty(applicant.f1.bU),
						'Plaats'),
						_Utils_Tuple2(
						$elm$core$String$isEmpty(applicant.eq),
						'Telefoon/Mobiel'),
						_Utils_Tuple2(
						_Utils_eq($elm$core$Maybe$Nothing, applicant.c$),
						'Geboortedatum')
					])));
	}
};
var $author$project$Applicant$Overview$saveDisabled = F4(
	function (applicant, autocomplete, errors, checkVatId) {
		var hasErrors = A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$List$isEmpty);
		return (autocomplete === 2) || (checkVatId || (hasErrors(
			$author$project$Applicant$Overview$saveWarningsReversed(applicant)) || (hasErrors(errors.gI) || (hasErrors(errors.fc) || (hasErrors(errors.fF) || (hasErrors(errors.fo) || (hasErrors(errors.d5) || (hasErrors(errors.eq) || (hasErrors(errors.c$) || (hasErrors(errors.cc) || (hasErrors(errors.cT) || (hasErrors(errors.bs) || (hasErrors(errors.dE) || (hasErrors(errors.b5) || (hasErrors(errors.bU) || (hasErrors(errors.gd) || (hasErrors(errors.gE) || (hasErrors(errors.gF) || (hasErrors(errors.gM) || hasErrors(errors.hF))))))))))))))))))));
	});
var $author$project$Applicant$Overview$saveWarning = function (applicant) {
	var _v0 = $author$project$Applicant$Overview$saveWarningsReversed(applicant);
	if (_v0.b) {
		if (!_v0.b.b) {
			var missingOne = _v0.a;
			return $author$project$UI$Container$elementFor(
				A2(
					$author$project$UI$Container$withVariant,
					1,
					A2(
						$author$project$UI$Container$withContent,
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$paragraph,
								_List_Nil,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$text('Het veld ' + (missingOne + ' dient gevuld te zijn om de kandidaat op te slaan'))
									]))
							]),
						$author$project$UI$Container$container)));
		} else {
			var lastField = _v0.a;
			var missingFieldsReversed = _v0.b;
			return $author$project$UI$Container$elementFor(
				A2(
					$author$project$UI$Container$withVariant,
					1,
					A2(
						$author$project$UI$Container$withContent,
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$paragraph,
								_List_Nil,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$text(
										'De velden ' + (A2(
											$elm$core$String$join,
											', ',
											$elm$core$List$reverse(missingFieldsReversed)) + (' en ' + (lastField + ' dienen gevuld te zijn om de kandidaat op te slaan.'))))
									]))
							]),
						$author$project$UI$Container$container)));
		}
	} else {
		return $mdgriffith$elm_ui$Element$none;
	}
};
var $author$project$Applicant$Overview$sendContractWarningsReversed = function (applicant) {
	var parentalFields = (applicant.gh === 2) ? _List_fromArray(
		[
			_Utils_Tuple2(
			$elm$core$String$isEmpty(
				A2($elm$core$Maybe$withDefault, '', applicant.g8)),
			'Ouder naam'),
			_Utils_Tuple2(
			$elm$core$String$isEmpty(
				A2($elm$core$Maybe$withDefault, '', applicant.g7)),
			'Ouder e-mail')
		]) : _List_Nil;
	var _v0 = applicant.gh;
	if (_v0 === 3) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, missingFields) {
					var b = _v1.b;
					return A2($elm$core$List$cons, b, missingFields);
				}),
			_List_Nil,
			A2(
				$elm$core$List$filter,
				$elm$core$Tuple$first,
				_List_fromArray(
					[
						_Utils_Tuple2(
						$elm$core$String$isEmpty(applicant.d5),
						'E-mail'),
						_Utils_Tuple2(
						$elm$core$String$isEmpty(
							A2($elm$core$Maybe$withDefault, '', applicant.gM)),
						'Kvk Nummer'),
						_Utils_Tuple2(
						$elm$core$String$isEmpty(
							A2($elm$core$Maybe$withDefault, '', applicant.hF)),
						'BTW-ID'),
						_Utils_Tuple2(
						$elm$core$String$isEmpty(applicant.gE),
						'IBAN'),
						_Utils_Tuple2(
						$elm$core$List$isEmpty(
							A2(
								$elm$core$List$filterMap,
								$elm$core$Basics$identity,
								_List_fromArray(
									[applicant.gH]))),
						'Legitimatie'),
						_Utils_Tuple2(
						$elm$core$String$isEmpty(applicant.gG),
						'Documentnummer'),
						_Utils_Tuple2(
						$elm$core$List$isEmpty(
							A2(
								$elm$core$List$filterMap,
								$elm$core$Basics$identity,
								_List_fromArray(
									[applicant.gF]))),
						'Geldig tot')
					])));
	} else {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v2, missingFields) {
					var b = _v2.b;
					return A2($elm$core$List$cons, b, missingFields);
				}),
			_List_Nil,
			A2(
				$elm$core$List$filter,
				$elm$core$Tuple$first,
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						$elm$core$String$isEmpty(applicant.gI),
						'Voorletter(s)'),
					_Utils_ap(
						parentalFields,
						_List_fromArray(
							[
								_Utils_Tuple2(
								$elm$core$String$isEmpty(applicant.d5),
								'E-mail'),
								_Utils_Tuple2(
								$elm$core$String$isEmpty(applicant.gd),
								'Burgerservicenummer (BSN)'),
								_Utils_Tuple2(
								$elm$core$String$isEmpty(applicant.gE),
								'IBAN'),
								_Utils_Tuple2(
								$elm$core$List$isEmpty(
									A2(
										$elm$core$List$filterMap,
										$elm$core$Basics$identity,
										_List_fromArray(
											[applicant.gH]))),
								'Legitimatie'),
								_Utils_Tuple2(
								$elm$core$String$isEmpty(applicant.gG),
								'Documentnummer'),
								_Utils_Tuple2(
								$elm$core$List$isEmpty(
									A2(
										$elm$core$List$filterMap,
										$elm$core$Basics$identity,
										_List_fromArray(
											[applicant.gF]))),
								'Geldig tot')
							])))));
	}
};
var $author$project$Applicant$Overview$sendContractMissingFieldsWarning = function (applicant) {
	var _v0 = $author$project$Applicant$Overview$sendContractWarningsReversed(applicant);
	if (_v0.b) {
		if (!_v0.b.b) {
			var missingOne = _v0.a;
			return $author$project$UI$Container$elementFor(
				A2(
					$author$project$UI$Container$withVariant,
					1,
					A2(
						$author$project$UI$Container$withContent,
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$paragraph,
								_List_Nil,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$text('Het veld ' + (missingOne + ' dient gevuld te zijn om het contract te versturen'))
									]))
							]),
						$author$project$UI$Container$container)));
		} else {
			var lastField = _v0.a;
			var missingFieldsReversed = _v0.b;
			return $author$project$UI$Container$elementFor(
				A2(
					$author$project$UI$Container$withVariant,
					1,
					A2(
						$author$project$UI$Container$withContent,
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$paragraph,
								_List_Nil,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$text(
										'De velden ' + (A2(
											$elm$core$String$join,
											', ',
											$elm$core$List$reverse(missingFieldsReversed)) + (' en ' + (lastField + ' dienen gevuld te zijn om het contract te kunnen versturen.'))))
									]))
							]),
						$author$project$UI$Container$container)));
		}
	} else {
		return $mdgriffith$elm_ui$Element$none;
	}
};
var $author$project$Applicant$Applicant$NotEditable = 1;
var $author$project$Applicant$Overview$UserChangedStatusSelection = function (a) {
	return {$: 25, a: a};
};
var $author$project$Applicant$Applicant$Editable = 0;
var $author$project$Applicant$Applicant$toEditable = function (status) {
	var _v0 = _Utils_Tuple2(
		$author$project$Applicant$Applicant$phaseOf(status),
		status);
	if (_v0.b.$ === 9) {
		var _v1 = _v0.b;
		return 1;
	} else {
		if (_v0.a === 2) {
			var _v2 = _v0.a;
			return 1;
		} else {
			return 0;
		}
	}
};
var $author$project$Applicant$Overview$statusChangeView = F2(
	function (applicantId, selectedOption) {
		var _v0 = $author$project$Applicant$Applicant$toEditable(selectedOption);
		if (_v0 === 1) {
			return A2(
				$mdgriffith$elm_ui$Element$column,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$el,
						$author$project$UI$Font$label,
						$mdgriffith$elm_ui$Element$text('Status')),
						$mdgriffith$elm_ui$Element$text(
						$author$project$Applicant$Applicant$statusView(selectedOption))
					]));
		} else {
			var statuses = function () {
				if (!applicantId.$) {
					return A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeL,
							$elm$core$Basics$neq(1),
							$author$project$Applicant$Applicant$toEditable),
						$author$project$Applicant$Applicant$allStatuses);
				} else {
					return _List_fromArray(
						[selectedOption]);
				}
			}();
			return A5(
				$author$project$UI$Input$selectWithOptions,
				statuses,
				$elm$core$Maybe$Just(selectedOption),
				$author$project$Applicant$Overview$UserChangedStatusSelection,
				{
					d$: A2($elm$core$Basics$composeR, $author$project$Applicant$Applicant$statusFromString, $elm$json$Json$Decode$succeed),
					d6: $author$project$Applicant$Applicant$statusView,
					eG: $author$project$Applicant$Applicant$statusView
				},
				'Status');
		}
	});
var $author$project$Applicant$Overview$UserChangedMunicipal = function (a) {
	return {$: 37, a: a};
};
var $author$project$Applicant$Overview$UserChangedStreet = function (a) {
	return {$: 36, a: a};
};
var $author$project$Applicant$Overview$autocompleteAttributes = F2(
	function (autocomplete, field) {
		return function (a) {
			var _v0 = _Utils_Tuple3(
				$elm$core$List$isEmpty(a),
				autocomplete,
				$elm$core$String$isEmpty(field));
			_v0$0:
			while (true) {
				switch (_v0.b) {
					case 0:
						if (!_v0.c) {
							if (!_v0.a) {
								break _v0$0;
							} else {
								var _v1 = _v0.b;
								return _List_Nil;
							}
						} else {
							if (!_v0.a) {
								break _v0$0;
							} else {
								var _v2 = _v0.b;
								return $author$project$UI$Element$colors($author$project$UI$Palette$warning);
							}
						}
					case 1:
						if (!_v0.c) {
							if (!_v0.a) {
								break _v0$0;
							} else {
								var _v3 = _v0.b;
								return $author$project$UI$Element$colors($author$project$UI$Palette$success);
							}
						} else {
							if (!_v0.a) {
								break _v0$0;
							} else {
								var _v4 = _v0.b;
								return $author$project$UI$Element$colors($author$project$UI$Palette$warning);
							}
						}
					default:
						if (!_v0.a) {
							break _v0$0;
						} else {
							var _v5 = _v0.b;
							return $author$project$UI$Element$colors($author$project$UI$Palette$error);
						}
				}
			}
			return $author$project$UI$Element$colors($author$project$UI$Palette$error);
		};
	});
var $author$project$Applicant$Overview$streetMunicipalChangeView = F3(
	function (address, autocomplete, errors) {
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(10)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(5),
							$mdgriffith$elm_ui$Element$alignTop
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$Input$text,
							A3($author$project$Applicant$Overview$autocompleteAttributes, autocomplete, address.b5, errors.b5),
							{
								mD: $author$project$UI$Input$label('Straat'),
								mY: $author$project$Applicant$Overview$UserChangedStreet,
								ng: $elm$core$Maybe$Nothing,
								n3: address.b5
							}),
							$author$project$Applicant$Overview$validationView(
							A2(
								$elm$core$List$map,
								$author$project$Applicant$Overview$validationLengthView('De straat'),
								errors.b5))
						])),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(5),
							$mdgriffith$elm_ui$Element$alignTop
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$Input$text,
							A3($author$project$Applicant$Overview$autocompleteAttributes, autocomplete, address.bU, errors.bU),
							{
								mD: $author$project$UI$Input$label('Plaats'),
								mY: $author$project$Applicant$Overview$UserChangedMunicipal,
								ng: $elm$core$Maybe$Nothing,
								n3: address.bU
							}),
							$author$project$Applicant$Overview$validationView(
							A2(
								$elm$core$List$map,
								$author$project$Applicant$Overview$validationLengthView('De plaats'),
								errors.bU))
						]))
				]));
	});
var $author$project$Applicant$Overview$UserChangedHouseNumber = function (a) {
	return {$: 34, a: a};
};
var $author$project$Applicant$Overview$UserChangedSuffix = function (a) {
	return {$: 35, a: a};
};
var $author$project$Applicant$Overview$UserChangedZipCode = function (a) {
	return {$: 33, a: a};
};
var $author$project$Applicant$Overview$UserWantsToAutocompleteAddress = {$: 60};
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $mdgriffith$elm_ui$Element$spaceEvenly = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$spacing, $mdgriffith$elm_ui$Internal$Style$classes.nQ);
var $author$project$Applicant$Overview$validationHouseNumberView = function (_v0) {
	return 'Gelieve een geldig huisnummer in te vullen.';
};
var $author$project$Applicant$Overview$validationZipCodeView = function (_v0) {
	return 'Gelieve een geldige postcode in te vullen, formaat 1000AA.';
};
var $author$project$Applicant$Overview$zipCodeHouseNumberChangeView = F2(
	function (address, errors) {
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(10)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(5),
							$mdgriffith$elm_ui$Element$alignTop
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$Input$text,
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Element$Events$onLoseFocus($author$project$Applicant$Overview$UserWantsToAutocompleteAddress),
								A3($author$project$Applicant$Overview$emptyWarningAndErrorAttributes, errors.cT, $elm$core$String$isEmpty, address.cT)),
							{
								mD: $author$project$UI$Input$label('Postcode'),
								mY: $author$project$Applicant$Overview$UserChangedZipCode,
								ng: $elm$core$Maybe$Nothing,
								n3: address.cT
							}),
							$author$project$Applicant$Overview$validationView(
							A2($elm$core$List$map, $author$project$Applicant$Overview$validationZipCodeView, errors.cT))
						])),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(5),
							$mdgriffith$elm_ui$Element$alignTop
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$Input$text,
							_Utils_ap(
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$htmlAttribute(
										$elm$html$Html$Attributes$type_('number')),
										$mdgriffith$elm_ui$Element$htmlAttribute(
										$elm$html$Html$Attributes$min('0')),
										$mdgriffith$elm_ui$Element$spaceEvenly,
										$mdgriffith$elm_ui$Element$Events$onLoseFocus($author$project$Applicant$Overview$UserWantsToAutocompleteAddress)
									]),
								A3(
									$author$project$Applicant$Overview$emptyWarningAndErrorAttributes,
									errors.bs,
									$elm$core$Basics$eq(0),
									address.bs.bX)),
							{
								mD: $author$project$UI$Input$label('Huisnummer'),
								mY: $author$project$Applicant$Overview$UserChangedHouseNumber,
								ng: $elm$core$Maybe$Nothing,
								n3: $elm$core$String$fromInt(address.bs.bX)
							}),
							$author$project$Applicant$Overview$validationView(
							A2($elm$core$List$map, $author$project$Applicant$Overview$validationHouseNumberView, errors.bs))
						])),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(5),
							$mdgriffith$elm_ui$Element$alignTop
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$Input$text,
							$author$project$Applicant$Overview$errorAttributes(errors.dE),
							{
								mD: $author$project$UI$Input$label('Toevoeging'),
								mY: $author$project$Applicant$Overview$UserChangedSuffix,
								ng: $elm$core$Maybe$Nothing,
								n3: A2($elm$core$Maybe$withDefault, '', address.bs.dE)
							}),
							$author$project$Applicant$Overview$validationView(
							A2(
								$elm$core$List$map,
								$author$project$Applicant$Overview$validationLengthView('De toevoeging'),
								errors.dE))
						]))
				]));
	});
var $author$project$Applicant$Overview$changeView = F3(
	function (minStart, today, changeModel) {
		var changed = changeModel.a;
		var autocomplete = changeModel.an;
		var errors = changeModel.b;
		var checkVatIdRequired = changeModel.bh;
		var _v0 = A3($author$project$Applicant$Overview$validateStart, minStart, changed.cY.hq, today) ? _Utils_Tuple2(_List_Nil, $mdgriffith$elm_ui$Element$none) : _Utils_Tuple2(
			$author$project$UI$Element$colors($author$project$UI$Palette$warning),
			$author$project$UI$Container$elementFor(
				A2(
					$author$project$UI$Container$withContent,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text($author$project$Applicant$Overview$validationStartView)
						]),
					A2($author$project$UI$Container$withVariant, 1, $author$project$UI$Container$container))));
		var startAttributes = _v0.a;
		var startValidationView = _v0.b;
		var content = function () {
			var _v1 = changed.gh;
			if (_v1 === 3) {
				return _List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$Input$text,
						A3(
							$author$project$Applicant$Overview$emptyWarningAndErrorAttributes,
							_List_Nil,
							$elm$core$String$isEmpty,
							A2($elm$core$Maybe$withDefault, '', changed.eU)),
						{
							mD: $author$project$UI$Input$label('Firma'),
							mY: $author$project$Applicant$Overview$UserChangedCompanyName,
							ng: $elm$core$Maybe$Nothing,
							n3: A2($elm$core$Maybe$withDefault, '', changed.eU)
						}),
						A2($author$project$Applicant$Overview$zipCodeHouseNumberChangeView, changed.f1, errors),
						A3($author$project$Applicant$Overview$streetMunicipalChangeView, changed.f1, autocomplete, errors),
						A3($author$project$Applicant$Overview$phoneEmailChangeView, changed.d5, changed.eq, errors),
						A2(
						$mdgriffith$elm_ui$Element$column,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$spacing(5),
								$mdgriffith$elm_ui$Element$alignTop
							]),
						_List_fromArray(
							[
								A2(
								$author$project$UI$Input$date,
								_Utils_ap(
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$width(
											$mdgriffith$elm_ui$Element$px(140)),
											$mdgriffith$elm_ui$Element$htmlAttribute(
											A2(
												$elm$html$Html$Attributes$attribute,
												'min',
												$justinmimbs$date$Date$toIsoString(
													$author$project$Date$DeliveryDate$toDate(minStart)))),
											$mdgriffith$elm_ui$Element$htmlAttribute(
											A2(
												$elm$html$Html$Attributes$attribute,
												'max',
												$justinmimbs$date$Date$toIsoString(
													$author$project$Applicant$Overview$maxStart(today))))
										]),
									startAttributes),
								{
									mD: $author$project$UI$Input$label('Ingangsdatum'),
									mY: $author$project$Applicant$Overview$UserChangedStart,
									ng: $elm$core$Maybe$Nothing,
									n3: changeModel.hq
								}),
								startValidationView
							])),
						$author$project$Applicant$Overview$availabilityDaysDPChangeView(changeModel),
						A4(
						$author$project$Applicant$Overview$kvkNumberAndVatIdAndIBANChangeView,
						A2($elm$core$Maybe$withDefault, '', changed.gM),
						A2($elm$core$Maybe$withDefault, '', changed.hF),
						changed.gE,
						errors),
						A2($author$project$Applicant$Overview$nameChangeView, changed, errors),
						$author$project$Applicant$Overview$identificationChangeView(changed),
						A2($author$project$Applicant$Overview$identificationDetailsChangeView, today, changeModel),
						A2($author$project$Applicant$Overview$statusChangeView, changed.eg, changed.nS),
						$author$project$Applicant$Overview$commentChangeView(changed.gg),
						$author$project$UI$Input$row(
						_List_fromArray(
							[
								$author$project$UI$Button$elementFor(
								A3(
									$author$project$UI$Button$disabledIf,
									A4($author$project$Applicant$Overview$saveDisabled, changed, autocomplete, errors, checkVatIdRequired),
									'Gelieve eerst de validatiefouten op te lossen',
									A2(
										$author$project$UI$Button$withRole,
										0,
										A2(
											$author$project$UI$Button$button,
											$author$project$Applicant$Overview$UserClickedSave(changed.eg),
											'Opslaan')))),
								$author$project$UI$Button$elementFor(
								A2(
									$author$project$UI$Button$withRole,
									1,
									A2($author$project$UI$Button$button, $author$project$Applicant$Overview$UserClickedCancelButton, 'Annuleren')))
							])),
						$author$project$Applicant$Overview$saveWarning(changed),
						$author$project$Applicant$Overview$sendContractMissingFieldsWarning(changed)
					]);
			} else {
				return _List_fromArray(
					[
						A3($author$project$Applicant$Overview$salutationInitialsChangeView, changed.hi, changed.gI, errors),
						A2($author$project$Applicant$Overview$nameChangeView, changed, errors),
						A2($author$project$Applicant$Overview$zipCodeHouseNumberChangeView, changed.f1, errors),
						A3($author$project$Applicant$Overview$streetMunicipalChangeView, changed.f1, autocomplete, errors),
						A3($author$project$Applicant$Overview$phoneEmailChangeView, changed.d5, changed.eq, errors),
						A3($author$project$Applicant$Overview$bornOnStartChangeView, minStart, today, changeModel),
						function () {
						var _v2 = changed.gh;
						if (_v2 === 2) {
							return A3($author$project$Applicant$Overview$parentChangeView, changed.g8, changed.g7, errors);
						} else {
							return $mdgriffith$elm_ui$Element$none;
						}
					}(),
						$author$project$Applicant$Overview$availabilityDaysDPChangeView(changeModel),
						A3($author$project$Applicant$Overview$bsnAndIBANChangeView, changed.gd, changed.gE, errors),
						$author$project$Applicant$Overview$identificationChangeView(changed),
						A2($author$project$Applicant$Overview$identificationDetailsChangeView, today, changeModel),
						A2($author$project$Applicant$Overview$statusChangeView, changed.eg, changed.nS),
						$author$project$Applicant$Overview$commentChangeView(changed.gg),
						$author$project$UI$Input$row(
						_List_fromArray(
							[
								$author$project$UI$Button$elementFor(
								A3(
									$author$project$UI$Button$disabledIf,
									A4($author$project$Applicant$Overview$saveDisabled, changed, autocomplete, errors, checkVatIdRequired),
									'Gelieve eerst de validatiefouten op te lossen',
									A2(
										$author$project$UI$Button$withRole,
										0,
										A2(
											$author$project$UI$Button$button,
											$author$project$Applicant$Overview$UserClickedSave(changed.eg),
											'Opslaan')))),
								$author$project$UI$Button$elementFor(
								A2(
									$author$project$UI$Button$withRole,
									1,
									A2($author$project$UI$Button$button, $author$project$Applicant$Overview$UserClickedCancelButton, 'Annuleren')))
							])),
						$author$project$Applicant$Overview$saveWarning(changed),
						$author$project$Applicant$Overview$sendContractMissingFieldsWarning(changed)
					]);
			}
		}();
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withSpacing,
				$author$project$UI$Spacing$defaultSize,
				A2(
					$author$project$UI$Container$withWidth,
					$mdgriffith$elm_ui$Element$fill,
					A2($author$project$UI$Container$withContent, content, $author$project$UI$Container$container))));
	});
var $author$project$Address$Address$twoLineView = function (_v0) {
	var street = _v0.b5;
	var houseNumber = _v0.bs;
	var zipCode = _v0.cT;
	var municipal = _v0.bU;
	return _Utils_Tuple2(
		A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					street,
					$author$project$Address$Address$houseNumberView(houseNumber)
				])),
		A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[zipCode, municipal])));
};
var $author$project$Applicant$Overview$addressView = function (address) {
	return function (_v0) {
		var a = _v0.a;
		var b = _v0.b;
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_Nil,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$text(a),
					$mdgriffith$elm_ui$Element$text(b)
				]));
	}(
		$author$project$Address$Address$twoLineView(address));
};
var $author$project$Applicant$Overview$bornOnView = F2(
	function (today, bornOn) {
		return _Utils_ap(
			A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $author$project$Date$DeliveryDate$view, bornOn),
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				'',
				function (dateOfBirth) {
					return ' (' + ($elm$core$String$fromInt(
						A2($author$project$Date$DeliveryDate$age, today, dateOfBirth)) + ' jaar)');
				},
				bornOn));
	});
var $author$project$Date$DaysInTheWeek$fillColorGreen = function (_v0) {
	var d = _v0;
	return _Utils_update(
		d,
		{da: 1});
};
var $author$project$Applicant$Overview$optionalField = F2(
	function (label, field) {
		if (field === '') {
			return $mdgriffith$elm_ui$Element$none;
		} else {
			return $author$project$UI$Text$elementFor(
				A2(
					$author$project$UI$Text$withLabel,
					label,
					$author$project$UI$Text$text(field)));
		}
	});
var $author$project$Applicant$Overview$passedAssessmentToString = function (assessment) {
	if (!assessment) {
		return 'Gemarkeerd als serieuze kandidaat';
	} else {
		return '';
	}
};
var $author$project$Date$DaysInTheWeek$Large = 1;
var $author$project$Date$DaysInTheWeek$sizeLarge = function (_v0) {
	var d = _v0;
	return _Utils_update(
		d,
		{bB: 1});
};
var $author$project$Applicant$Overview$detailView = F4(
	function (today, distributionPoints, footer, applicant) {
		var content = function () {
			var _v0 = applicant.gh;
			if (_v0 === 3) {
				return _List_fromArray(
					[
						$author$project$UI$Text$elementFor(
						A2(
							$author$project$UI$Text$withLabel,
							'Firma',
							$author$project$UI$Text$text(
								A2($elm$core$Maybe$withDefault, '', applicant.eU)))),
						A2(
						$author$project$UI$Label$tagged,
						'Adres',
						$author$project$Applicant$Overview$addressView(applicant.f1)),
						$author$project$UI$Text$elementFor(
						A2(
							$author$project$UI$Text$withLabel,
							'Voornaam',
							$author$project$UI$Text$text(applicant.fc))),
						$author$project$UI$Text$elementFor(
						A2(
							$author$project$UI$Text$withLabel,
							'Achternaam',
							$author$project$UI$Text$text(applicant.fo))),
						$author$project$UI$Text$elementFor(
						A2(
							$author$project$UI$Text$withLabel,
							'Email',
							$author$project$UI$Text$text(applicant.d5))),
						$author$project$UI$Text$elementFor(
						A2(
							$author$project$UI$Text$withLabel,
							'Telefoon',
							$author$project$UI$Text$text(applicant.eq))),
						$author$project$UI$Text$elementFor(
						A2(
							$author$project$UI$Text$withLabel,
							'Ingangsdatum',
							$author$project$UI$Text$text(
								$author$project$Date$DeliveryDate$view(applicant.cY.hq)))),
						A2(
						$author$project$UI$Label$tagged,
						'Beschikbaarheid',
						A2(
							$mdgriffith$elm_ui$Element$el,
							_List_Nil,
							$mdgriffith$elm_ui$Element$html(
								$author$project$Date$DaysInTheWeek$icon(
									$author$project$Date$DaysInTheWeek$sizeLarge(
										$author$project$Date$DaysInTheWeek$fillColorGreen(applicant.cY.e1)))))),
						$author$project$UI$Text$elementFor(
						A2(
							$author$project$UI$Text$withLabel,
							'Distributiepunt',
							$author$project$UI$Text$text(
								A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									'',
									function ($) {
										return $.ft;
									},
									$elm$core$List$head(
										A2(
											$elm$core$List$filter,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.eg;
												},
												$elm$core$Basics$eq(applicant.c2)),
											distributionPoints)))))),
						$author$project$UI$Text$elementFor(
						A2(
							$author$project$UI$Text$withLabel,
							'Toegevoegd op',
							$author$project$UI$Text$text(
								$author$project$Date$DeliveryDate$view(applicant.hP)))),
						$author$project$UI$Text$elementFor(
						A2(
							$author$project$UI$Text$withLabel,
							'Status',
							$author$project$UI$Text$text(
								$author$project$Applicant$Applicant$statusView(applicant.nS)))),
						$author$project$UI$Text$elementFor(
						A2(
							$author$project$UI$Text$withLabel,
							'Laatste commentaar',
							$author$project$UI$Text$text(applicant.gg))),
						footer
					]);
			} else {
				return _List_fromArray(
					[
						A2(
						$author$project$Applicant$Overview$optionalField,
						'Aanhef',
						$author$project$Applicant$Applicant$salutationView(applicant.hi)),
						A2($author$project$Applicant$Overview$optionalField, 'Voorletter(s)', applicant.gI),
						$author$project$UI$Text$elementFor(
						A2(
							$author$project$UI$Text$withLabel,
							'Achternaam',
							$author$project$UI$Text$text(applicant.fo))),
						A2(
						$author$project$UI$Label$tagged,
						'Adres',
						$author$project$Applicant$Overview$addressView(applicant.f1)),
						A2(
						$author$project$UI$Label$tagged,
						'Contact',
						A2(
							$mdgriffith$elm_ui$Element$column,
							_List_Nil,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text(
									'Best bereikbaar via: ' + $author$project$Applicant$Applicant$bestReachableToString(applicant.ga)),
									$mdgriffith$elm_ui$Element$text(applicant.d5),
									$mdgriffith$elm_ui$Element$text(applicant.eq),
									$mdgriffith$elm_ui$Element$text(
									$author$project$Applicant$Overview$passedAssessmentToString(applicant.dQ))
								]))),
						A2(
						$author$project$Applicant$Overview$optionalField,
						'Geboortedatum',
						A2($author$project$Applicant$Overview$bornOnView, today, applicant.c$)),
						$author$project$UI$Text$elementFor(
						A2(
							$author$project$UI$Text$withLabel,
							'Ingangsdatum',
							$author$project$UI$Text$text(
								$author$project$Date$DeliveryDate$view(applicant.cY.hq)))),
						A2(
						$author$project$UI$Label$tagged,
						'Beschikbaarheid',
						A2(
							$mdgriffith$elm_ui$Element$el,
							_List_Nil,
							$mdgriffith$elm_ui$Element$html(
								$author$project$Date$DaysInTheWeek$icon(
									$author$project$Date$DaysInTheWeek$sizeLarge(
										$author$project$Date$DaysInTheWeek$fillColorGreen(applicant.cY.e1)))))),
						$author$project$UI$Text$elementFor(
						A2(
							$author$project$UI$Text$withLabel,
							'Distributiepunt',
							$author$project$UI$Text$text(
								A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									'',
									function ($) {
										return $.ft;
									},
									$elm$core$List$head(
										A2(
											$elm$core$List$filter,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.eg;
												},
												$elm$core$Basics$eq(applicant.c2)),
											distributionPoints)))))),
						$author$project$UI$Text$elementFor(
						A2(
							$author$project$UI$Text$withLabel,
							'Toegevoegd op',
							$author$project$UI$Text$text(
								$author$project$Date$DeliveryDate$view(applicant.hP)))),
						$author$project$UI$Text$elementFor(
						A2(
							$author$project$UI$Text$withLabel,
							'Status',
							$author$project$UI$Text$text(
								$author$project$Applicant$Applicant$statusView(applicant.nS)))),
						$author$project$UI$Text$elementFor(
						A2(
							$author$project$UI$Text$withLabel,
							'Laatste commentaar',
							$author$project$UI$Text$text(applicant.gg))),
						footer
					]);
			}
		}();
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withSpacing,
				$author$project$UI$Spacing$defaultSize,
				A2(
					$author$project$UI$Container$withWidth,
					$mdgriffith$elm_ui$Element$fill,
					A2(
						$author$project$UI$Container$withContent,
						content,
						A2(
							$author$project$UI$Container$withTitle,
							$mdgriffith$elm_ui$Element$text(
								$author$project$Applicant$Applicant$nameView(applicant)),
							$author$project$UI$Container$container)))));
	});
var $author$project$Applicant$Overview$UserChangedDistributorEmail = function (a) {
	return {$: 58, a: a};
};
var $author$project$Applicant$Overview$UserChangedDistributorName = function (a) {
	return {$: 57, a: a};
};
var $author$project$Applicant$Overview$UserClickedSendContract = function (a) {
	return {$: 20, a: a};
};
var $author$project$Applicant$Overview$sendContractView = F2(
	function (applicantId, _v0) {
		var distributorName = _v0.lI;
		var distributorEmail = _v0.lH;
		var warningContent = function () {
			var _v2 = _Utils_Tuple2(
				$elm$core$String$isEmpty(distributorName),
				$elm$core$String$isEmpty(distributorEmail));
			if (_v2.a) {
				if (_v2.b) {
					return 'De velden Naam distributeur en Email distributeur dienen ingevuld te worden.';
				} else {
					return 'Het veld Naam distributeur dient ingevuld te worden.';
				}
			} else {
				if (_v2.b) {
					return 'Het veld Email distributeur dient ingevuld te worden.';
				} else {
					return '';
				}
			}
		}();
		var warning = $elm$core$String$isEmpty(warningContent) ? $mdgriffith$elm_ui$Element$none : $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withVariant,
				1,
				A2(
					$author$project$UI$Container$withContent,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$paragraph,
							_List_Nil,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text(warningContent)
								]))
						]),
					$author$project$UI$Container$container)));
		var nameErrors = A3($author$project$Applicant$Overview$validateLength, 0, 60, distributorName);
		var emailErrors = $elm$core$String$isEmpty(distributorEmail) ? _List_Nil : A2($arowM$elm_form_decoder$Form$Decoder$errors, $author$project$UI$Validation$Email$decoder, distributorEmail);
		if (!applicantId.$) {
			var id = applicantId.a;
			return $author$project$UI$Container$elementFor(
				A2(
					$author$project$UI$Container$withWidth,
					$mdgriffith$elm_ui$Element$fill,
					A2(
						$author$project$UI$Container$withContent,
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$Input$text,
								_Utils_ap(
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$spaceEvenly,
											$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
										]),
									$author$project$Applicant$Overview$errorAttributes(nameErrors)),
								{
									mD: $author$project$UI$Input$label('Naam distributeur'),
									mY: $author$project$Applicant$Overview$UserChangedDistributorName,
									ng: $elm$core$Maybe$Nothing,
									n3: distributorName
								}),
								$author$project$Applicant$Overview$validationView(
								A2(
									$elm$core$List$map,
									$author$project$Applicant$Overview$validationLengthView('Naam distributeur'),
									nameErrors)),
								A2(
								$mdgriffith$elm_ui$Element$Input$text,
								_Utils_ap(
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$spaceEvenly,
											$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
										]),
									$author$project$Applicant$Overview$errorAttributes(emailErrors)),
								{
									mD: $author$project$UI$Input$label('Email distributeur'),
									mY: $author$project$Applicant$Overview$UserChangedDistributorEmail,
									ng: $elm$core$Maybe$Nothing,
									n3: distributorEmail
								}),
								$author$project$Applicant$Overview$validationView(
								A2($elm$core$List$map, $author$project$UI$Validation$Email$invalidView, emailErrors)),
								$author$project$UI$Input$row(
								_List_fromArray(
									[
										$author$project$UI$Button$elementFor(
										A3(
											$author$project$UI$Button$disabledIf,
											!($elm$core$String$isEmpty(warningContent) && ($elm$core$List$isEmpty(nameErrors) && $elm$core$List$isEmpty(emailErrors))),
											'Velden ontbreken',
											A2(
												$author$project$UI$Button$withRole,
												0,
												A2(
													$author$project$UI$Button$button,
													$author$project$Applicant$Overview$UserClickedSendContract(id),
													'Versturen')))),
										$author$project$UI$Button$elementFor(
										A2(
											$author$project$UI$Button$withRole,
											1,
											A2($author$project$UI$Button$button, $author$project$Applicant$Overview$UserClickedCancelButton, 'Annuleren')))
									])),
								warning
							]),
						$author$project$UI$Container$container)));
		} else {
			return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$Applicant$Overview$UserClickedSaveStatusAndDP = function (a) {
	return {$: 19, a: a};
};
var $author$project$Applicant$Overview$updateStatusAndDPView = F2(
	function (applicantId, _v0) {
		var status = _v0.nS;
		var comment = _v0.gg;
		var dpModel = _v0.I;
		if (!applicantId.$) {
			var id = applicantId.a;
			return $author$project$UI$Container$elementFor(
				A2(
					$author$project$UI$Container$withWidth,
					$mdgriffith$elm_ui$Element$fill,
					A2(
						$author$project$UI$Container$withContent,
						_List_fromArray(
							[
								$author$project$Applicant$Overview$dpChangeView(dpModel),
								A2($author$project$Applicant$Overview$statusChangeView, applicantId, status),
								$author$project$Applicant$Overview$commentChangeView(comment),
								$author$project$UI$Input$row(
								_List_fromArray(
									[
										$author$project$UI$Button$elementFor(
										A2(
											$author$project$UI$Button$withRole,
											0,
											A2(
												$author$project$UI$Button$button,
												$author$project$Applicant$Overview$UserClickedSaveStatusAndDP(id),
												'Opslaan'))),
										$author$project$UI$Button$elementFor(
										A2(
											$author$project$UI$Button$withRole,
											1,
											A2($author$project$UI$Button$button, $author$project$Applicant$Overview$UserClickedCancelButton, 'Annuleren')))
									]))
							]),
						$author$project$UI$Container$container)));
		} else {
			return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$Applicant$Overview$UserClickedChangeButton = {$: 15};
var $author$project$Applicant$Overview$UserClickedChangeStatusButton = {$: 16};
var $author$project$Applicant$Overview$UserClickedSendingContract = {$: 21};
var $author$project$Applicant$Overview$UserClickedVoidingContract = {$: 23};
var $author$project$DistributionPoint$DistributionPoint$regionNumberMinimumForEntrepreneurs = 800;
var $author$project$Applicant$Overview$sendContractEntrepreneurWarning = F2(
	function (dps, _v0) {
		var distributionPointId = _v0.c2;
		var _v1 = A2(
			$elm$core$Maybe$map,
			function (_v2) {
				var region = _v2.nq;
				return _Utils_cmp(region.bX, $author$project$DistributionPoint$DistributionPoint$regionNumberMinimumForEntrepreneurs) > -1;
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.eg;
						},
						$elm$core$Basics$eq(distributionPointId)),
					dps)));
		if ((!_v1.$) && _v1.a) {
			return $author$project$UI$Container$elementFor(
				A2(
					$author$project$UI$Container$withVariant,
					1,
					A2(
						$author$project$UI$Container$withContent,
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$paragraph,
								_List_Nil,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$text('De kandidaat is toegewezen aan een distributiepunt dat wordt beheerd door een ondernemer. Hiervoor worden digitale contracten niet ondersteund.')
									]))
							]),
						$author$project$UI$Container$container)));
		} else {
			return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$Applicant$Overview$sendContractIdentificationExpiryWarning = F2(
	function (today, _v0) {
		var identificationExpiryDate = _v0.gF;
		var availability = _v0.cY;
		var _v1 = $author$project$Applicant$Overview$validateIdentificationExpiryDate(
			{bq: identificationExpiryDate, fR: availability.hq, fY: today});
		if (!_v1.b) {
			return $mdgriffith$elm_ui$Element$none;
		} else {
			return $author$project$UI$Container$elementFor(
				A2(
					$author$project$UI$Container$withVariant,
					1,
					A2(
						$author$project$UI$Container$withContent,
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$paragraph,
								_List_Nil,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$text('De kandidaat bevat een ongeldig document op het moment dat de kandidaat start.')
									]))
							]),
						$author$project$UI$Container$container)));
		}
	});
var $author$project$Applicant$Overview$sendContractNameLengthWarning = function (_v0) {
	var firstName = _v0.fc;
	var prefix = _v0.fF;
	var lastName = _v0.fo;
	var _v1 = $elm$core$List$length(
		_Utils_ap(
			$author$project$Applicant$Overview$validateFirstName(firstName),
			_Utils_ap(
				$author$project$Applicant$Overview$validatePrefix(prefix),
				$author$project$Applicant$Overview$validateLastName(lastName))));
	if (!_v1) {
		return $mdgriffith$elm_ui$Element$none;
	} else {
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withVariant,
				1,
				A2(
					$author$project$UI$Container$withContent,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$paragraph,
							_List_Nil,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text('Kan het contract niet versturen. De kandidaat bevat een ongeldige naam.')
								]))
						]),
					$author$project$UI$Container$container)));
	}
};
var $author$project$Applicant$Overview$sendContractStartWarning = F3(
	function (minStart, today, _v0) {
		var availability = _v0.cY;
		return A3($author$project$Applicant$Overview$validateStart, minStart, availability.hq, today) ? $mdgriffith$elm_ui$Element$none : $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withVariant,
				1,
				A2(
					$author$project$UI$Container$withContent,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$paragraph,
							_List_Nil,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text('De kandidaat bevat een ongeldige ingangsdatum om het contract te kunnen versturen.')
								]))
						]),
					$author$project$UI$Container$container)));
	});
var $author$project$Applicant$Overview$sendContractDisabled = F4(
	function (dps, minStart, today, applicant) {
		return (!_Utils_eq(
			$author$project$Applicant$Overview$saveWarningsReversed(applicant),
			_List_Nil)) || ((!_Utils_eq(
			$author$project$Applicant$Overview$sendContractWarningsReversed(applicant),
			_List_Nil)) || ((!_Utils_eq(
			A3($author$project$Applicant$Overview$sendContractStartWarning, minStart, today, applicant),
			$mdgriffith$elm_ui$Element$none)) || ((!_Utils_eq(
			$author$project$Applicant$Overview$sendContractNameLengthWarning(applicant),
			$mdgriffith$elm_ui$Element$none)) || ((!_Utils_eq(
			A2($author$project$Applicant$Overview$sendContractIdentificationExpiryWarning, today, applicant),
			$mdgriffith$elm_ui$Element$none)) || (!_Utils_eq(
			A2($author$project$Applicant$Overview$sendContractEntrepreneurWarning, dps, applicant),
			$mdgriffith$elm_ui$Element$none))))));
	});
var $author$project$Applicant$Overview$viewingFooter = F5(
	function (dps, today, minStart, canManageContracts, applicant) {
		var _v0 = _Utils_Tuple2(
			$author$project$Applicant$Applicant$phaseOf(applicant.nS),
			canManageContracts);
		if (!_v0.b) {
			if (_v0.a === 2) {
				var _v1 = _v0.a;
				return $mdgriffith$elm_ui$Element$none;
			} else {
				return $author$project$UI$Input$row(
					_List_fromArray(
						[
							$author$project$UI$Button$elementFor(
							A2(
								$author$project$UI$Button$withRole,
								0,
								A2($author$project$UI$Button$button, $author$project$Applicant$Overview$UserClickedChangeStatusButton, 'Status wijzigen')))
						]));
			}
		} else {
			if (_v0.a === 2) {
				var _v2 = _v0.a;
				return $author$project$UI$Input$row(
					_List_fromArray(
						[
							$author$project$UI$Button$elementFor(
							A2(
								$author$project$UI$Button$withRole,
								1,
								A2($author$project$UI$Button$button, $author$project$Applicant$Overview$UserClickedVoidingContract, 'Ondertekening stoppen')))
						]));
			} else {
				return A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$spacing(5)
						]),
					_List_fromArray(
						[
							$author$project$UI$Input$row(
							_List_fromArray(
								[
									$author$project$UI$Button$elementFor(
									A2(
										$author$project$UI$Button$withRole,
										0,
										A2($author$project$UI$Button$button, $author$project$Applicant$Overview$UserClickedChangeButton, 'Wijzigen'))),
									$author$project$UI$Button$elementFor(
									A3(
										$author$project$UI$Button$disabledIf,
										A4($author$project$Applicant$Overview$sendContractDisabled, dps, minStart, today, applicant),
										'Het contract kan niet verstuurd worden',
										A2(
											$author$project$UI$Button$withRole,
											0,
											A2($author$project$UI$Button$button, $author$project$Applicant$Overview$UserClickedSendingContract, 'Contract versturen'))))
								])),
							$author$project$Applicant$Overview$sendContractMissingFieldsWarning(applicant),
							A3($author$project$Applicant$Overview$sendContractStartWarning, minStart, today, applicant),
							$author$project$Applicant$Overview$sendContractNameLengthWarning(applicant),
							A2($author$project$Applicant$Overview$sendContractIdentificationExpiryWarning, today, applicant),
							A2($author$project$Applicant$Overview$sendContractEntrepreneurWarning, dps, applicant)
						]));
			}
		}
	});
var $author$project$Applicant$Overview$UserChangedVoidReason = function (a) {
	return {$: 59, a: a};
};
var $author$project$Applicant$Overview$UserClickedVoidContract = function (a) {
	return {$: 22, a: a};
};
var $author$project$Applicant$Overview$voidContractView = F2(
	function (applicantId, reason) {
		var _v0 = _Utils_Tuple2(
			$elm$core$String$isEmpty(reason),
			'De reden dient gevuld te zijn.');
		var disabled = _v0.a;
		var disabledReason = _v0.b;
		var _v1 = disabled ? _Utils_Tuple2(
			$author$project$UI$Container$elementFor(
				A2(
					$author$project$UI$Container$withVariant,
					1,
					A2(
						$author$project$UI$Container$withContent,
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$paragraph,
								_List_Nil,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$text(disabledReason)
									]))
							]),
						$author$project$UI$Container$container))),
			$author$project$UI$Element$colors($author$project$UI$Palette$warning)) : _Utils_Tuple2($mdgriffith$elm_ui$Element$none, _List_Nil);
		var warning = _v1.a;
		var warningAttributes = _v1.b;
		if (!applicantId.$) {
			var id = applicantId.a;
			return $author$project$UI$Container$elementFor(
				A2(
					$author$project$UI$Container$withWidth,
					$mdgriffith$elm_ui$Element$fill,
					A2(
						$author$project$UI$Container$withContent,
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$Input$text,
								_Utils_ap(
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$spaceEvenly,
											$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
										]),
									warningAttributes),
								{
									mD: $author$project$UI$Input$label('Reden'),
									mY: $author$project$Applicant$Overview$UserChangedVoidReason,
									ng: $elm$core$Maybe$Nothing,
									n3: reason
								}),
								$author$project$UI$Input$row(
								_List_fromArray(
									[
										$author$project$UI$Button$elementFor(
										A3(
											$author$project$UI$Button$disabledIf,
											disabled,
											disabledReason,
											A2(
												$author$project$UI$Button$withRole,
												0,
												A2(
													$author$project$UI$Button$button,
													$author$project$Applicant$Overview$UserClickedVoidContract(id),
													'Onderbreken')))),
										$author$project$UI$Button$elementFor(
										A2(
											$author$project$UI$Button$withRole,
											1,
											A2($author$project$UI$Button$button, $author$project$Applicant$Overview$UserClickedCancelButton, 'Annuleren')))
									])),
								warning
							]),
						$author$project$UI$Container$container)));
		} else {
			return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$Applicant$Overview$applicantView = function (_v0) {
	var selected = _v0.nI;
	var distributionPoints = _v0.A;
	var today = _v0.fX;
	var minStart = _v0.fr;
	var canManageContracts = _v0.dS;
	switch (selected.$) {
		case 2:
			return $mdgriffith$elm_ui$Element$none;
		case 0:
			return $mdgriffith$elm_ui$Element$none;
		default:
			switch (selected.b.$) {
				case 0:
					var applicant = selected.a;
					var _v2 = selected.b;
					return A2(
						$mdgriffith$elm_ui$Element$column,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$alignTop,
								$author$project$UI$Spacing$default,
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
							]),
						_List_fromArray(
							[
								A4(
								$author$project$Applicant$Overview$detailView,
								minStart,
								distributionPoints,
								A5($author$project$Applicant$Overview$viewingFooter, distributionPoints, today, minStart, canManageContracts, applicant),
								applicant)
							]));
				case 1:
					var applicant = selected.a;
					var form = selected.b.a;
					return A2(
						$mdgriffith$elm_ui$Element$column,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$alignTop,
								$author$project$UI$Spacing$default,
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
							]),
						_List_fromArray(
							[
								A4($author$project$Applicant$Overview$detailView, minStart, distributionPoints, $mdgriffith$elm_ui$Element$none, applicant),
								A2($author$project$Applicant$Overview$updateStatusAndDPView, applicant.eg, form)
							]));
				case 2:
					var changeModel = selected.b.a;
					return A2(
						$mdgriffith$elm_ui$Element$column,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$alignTop,
								$author$project$UI$Spacing$default,
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
							]),
						_List_fromArray(
							[
								A3($author$project$Applicant$Overview$changeView, minStart, today, changeModel)
							]));
				case 3:
					var applicant = selected.a;
					var distributor = selected.b.a;
					return A2(
						$mdgriffith$elm_ui$Element$column,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$alignTop,
								$author$project$UI$Spacing$default,
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
							]),
						_List_fromArray(
							[
								A4($author$project$Applicant$Overview$detailView, today, distributionPoints, $mdgriffith$elm_ui$Element$none, applicant),
								A2($author$project$Applicant$Overview$sendContractView, applicant.eg, distributor)
							]));
				default:
					var applicant = selected.a;
					var reason = selected.b.a;
					return A2(
						$mdgriffith$elm_ui$Element$column,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$alignTop,
								$author$project$UI$Spacing$default,
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
							]),
						_List_fromArray(
							[
								A4($author$project$Applicant$Overview$detailView, today, distributionPoints, $mdgriffith$elm_ui$Element$none, applicant),
								A2($author$project$Applicant$Overview$voidContractView, applicant.eg, reason)
							]));
			}
	}
};
var $author$project$Applicant$Overview$UserClickedApplicantCard = function (a) {
	return {$: 13, a: a};
};
var $author$project$Applicant$Overview$isSelected = F2(
	function (card, selected) {
		switch (selected.$) {
			case 0:
				var id = selected.a;
				return _Utils_eq(card.eg, id);
			case 1:
				var id = selected.a.eg;
				return _Utils_eq(
					$elm$core$Maybe$Just(card.eg),
					id);
			default:
				return false;
		}
	});
var $author$project$Applicant$Overview$passedAssessmentView = function (passedAssessment) {
	if (!passedAssessment) {
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[$mdgriffith$elm_ui$Element$alignRight]),
			$mdgriffith$elm_ui$Element$text('Serieus'));
	} else {
		return $mdgriffith$elm_ui$Element$none;
	}
};
var $icidasset$elm_material_icons$Material$Icons$phone = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z')
				]),
			_List_Nil)
		]));
var $author$project$Applicant$Overview$cardView = F3(
	function (today, selected, applicant) {
		return $author$project$UI$Card$elementFor(
			A2(
				$author$project$UI$Card$selectedIf,
				A2($author$project$Applicant$Overview$isSelected, applicant, selected),
				A2(
					$author$project$UI$Card$withContent,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$row,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
								]),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$el,
									$author$project$UI$Font$bodyLarge,
									$mdgriffith$elm_ui$Element$text(applicant.ft))
								])),
							A2(
							$mdgriffith$elm_ui$Element$row,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$spacing(5),
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
								]),
							_List_fromArray(
								[
									$author$project$UI$Element$iconFor(
									$icidasset$elm_material_icons$Material$Icons$phone(12)),
									A2(
									$mdgriffith$elm_ui$Element$paragraph,
									$author$project$UI$Font$tag,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$text(applicant.eq),
											$author$project$Applicant$Overview$passedAssessmentView(applicant.dQ)
										]))
								])),
							A2(
							$mdgriffith$elm_ui$Element$row,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
								]),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$el,
									_List_Nil,
									$mdgriffith$elm_ui$Element$html(
										$author$project$Date$DaysInTheWeek$icon(
											$author$project$Date$DaysInTheWeek$fillColorGreen(applicant.cY)))),
									function () {
									var _v0 = applicant.c$;
									if (!_v0.$) {
										var bornOn = _v0.a;
										return A2(
											$mdgriffith$elm_ui$Element$el,
											A2($elm$core$List$cons, $mdgriffith$elm_ui$Element$alignRight, $author$project$UI$Font$tag),
											$mdgriffith$elm_ui$Element$text(
												$elm$core$String$fromInt(
													A2($author$project$Date$DeliveryDate$age, today, bornOn)) + 'j'));
									} else {
										return $mdgriffith$elm_ui$Element$none;
									}
								}()
								]))
						]),
					$author$project$UI$Card$card(
						$author$project$Applicant$Overview$UserClickedApplicantCard(applicant)))));
	});
var $author$project$Applicant$Overview$applicantsView = F2(
	function (_v0, window) {
		var today = _v0.fX;
		var selected = _v0.nI;
		var filtered = _v0.eb;
		return A3(
			$author$project$UI$Card$column,
			{
				iK: $mdgriffith$elm_ui$Element$px(window.iK),
				oy: $author$project$UI$Card$defaultColumnWidth
			},
			A2($author$project$Applicant$Overview$cardView, today, selected),
			filtered);
	});
var $author$project$Applicant$Overview$UserClickedCreateButton = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Applicant$Overview$UserChangedSearch = function (a) {
	return {$: 55, a: a};
};
var $author$project$Applicant$Overview$UserSelectedDPFilter = F2(
	function (a, b) {
		return {$: 56, a: a, b: b};
	});
var $author$project$Applicant$Overview$dpFilterView = function (_v0) {
	var filterOn = _v0.J;
	var distributionPoints = _v0.A;
	var selected = A2(
		$elm$core$List$sortBy,
		function ($) {
			return $.ft;
		},
		A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.eg;
				},
				function (id) {
					return A2($Gizra$elm_all_set$EverySet$member, id, filterOn.w);
				}),
			distributionPoints));
	var filtered = ($elm$core$String$length(filterOn.aj) < 2) ? _List_Nil : A2(
		$elm$core$List$sortBy,
		function ($) {
			return $.ft;
		},
		A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.ft;
				},
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$toLower,
					$elm$core$String$contains(
						$elm$core$String$toLower(filterOn.aj)))),
			A2(
				$elm$core$List$filter,
				function (dp) {
					return !A2($elm$core$List$member, dp, selected);
				},
				distributionPoints)));
	return _List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Element$el,
			$author$project$UI$Font$heading3,
			$mdgriffith$elm_ui$Element$text('Distributiepunt')),
			A2(
			$mdgriffith$elm_ui$Element$Input$text,
			_List_Nil,
			{
				mD: $mdgriffith$elm_ui$Element$Input$labelHidden(''),
				mY: $author$project$Applicant$Overview$UserChangedSearch,
				ng: $elm$core$Maybe$Just(
					A2(
						$mdgriffith$elm_ui$Element$Input$placeholder,
						_List_Nil,
						$mdgriffith$elm_ui$Element$text('Zoek DP'))),
				n3: filterOn.aj
			}),
			A2(
			$mdgriffith$elm_ui$Element$column,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (_v1) {
					var id = _v1.eg;
					var name = _v1.ft;
					return A2(
						$mdgriffith$elm_ui$Element$Input$checkbox,
						_List_Nil,
						{
							lc: A2($Gizra$elm_all_set$EverySet$member, id, filterOn.w),
							mg: $mdgriffith$elm_ui$Element$Input$defaultCheckbox,
							mD: A2(
								$mdgriffith$elm_ui$Element$Input$labelRight,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
										$mdgriffith$elm_ui$Element$padding(1)
									]),
								$mdgriffith$elm_ui$Element$text(name)),
							mY: $author$project$Applicant$Overview$UserSelectedDPFilter(id)
						});
				},
				_Utils_ap(selected, filtered)))
		]);
};
var $author$project$Applicant$Applicant$allStatusesByPhase = A2(
	$elm$core$List$map,
	function (_v0) {
		var status = _v0.a;
		var rest = _v0.b;
		return _Utils_Tuple2(
			$author$project$Applicant$Applicant$phaseOf(status),
			A2($elm$core$List$cons, status, rest));
	},
	A2($elm_community$list_extra$List$Extra$gatherEqualsBy, $author$project$Applicant$Applicant$phaseOf, $author$project$Applicant$Applicant$allStatuses));
var $author$project$Applicant$Applicant$phaseView = function (statusType) {
	switch (statusType) {
		case 0:
			return 'Nieuw';
		case 1:
			return 'In behandeling';
		case 2:
			return 'In ondertekening';
		default:
			return 'Afgehandeld';
	}
};
var $author$project$Applicant$Overview$UserChangedStatusCheckBox = F2(
	function (a, b) {
		return {$: 54, a: a, b: b};
	});
var $author$project$Applicant$Overview$statusCheckBox = F2(
	function (filterOn, _v0) {
		var status = _v0.a;
		var count = _v0.b;
		return A2(
			$mdgriffith$elm_ui$Element$Input$checkbox,
			_List_Nil,
			{
				lc: A2($Gizra$elm_all_set$EverySet$member, status, filterOn),
				mg: $mdgriffith$elm_ui$Element$Input$defaultCheckbox,
				mD: A2(
					$mdgriffith$elm_ui$Element$Input$labelRight,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					A2(
						$mdgriffith$elm_ui$Element$paragraph,
						_List_Nil,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text(
								$author$project$Applicant$Applicant$statusView(status) + (' (' + ($elm$core$String$fromInt(count) + ')')))
							]))),
				mY: $author$project$Applicant$Overview$UserChangedStatusCheckBox(status)
			});
	});
var $author$project$Applicant$Applicant$statusSortable = function (status) {
	return function (priority) {
		return _Utils_ap(
			priority,
			$author$project$Applicant$Applicant$statusView(status));
	}(
		function () {
			switch (status.$) {
				case 5:
					return '1';
				case 6:
					return '2';
				case 7:
					return '3';
				case 8:
					return '4';
				case 9:
					return '1';
				default:
					return '9';
			}
		}());
};
var $author$project$Applicant$Overview$statusGroupView = F3(
	function (all, filterOn, _v0) {
		var phase = _v0.a;
		var statuses = _v0.b;
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$author$project$UI$Spacing$default,
					$mdgriffith$elm_ui$Element$paddingEach(
					{k5: 10, mE: 5, nx: 0, ol: 0})
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$mdgriffith$elm_ui$Element$el,
					$author$project$UI$Font$heading3,
					$mdgriffith$elm_ui$Element$text(
						$author$project$Applicant$Applicant$phaseView(phase))),
				A2(
					$elm$core$List$map,
					$author$project$Applicant$Overview$statusCheckBox(filterOn),
					A2(
						$elm$core$List$filter,
						function (a) {
							return A2($elm$core$List$member, a.a, all);
						},
						A2(
							$elm$core$List$sortBy,
							A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $author$project$Applicant$Applicant$statusSortable),
							statuses)))));
	});
var $author$project$Applicant$Overview$statusFilterView = function (_v0) {
	var all = _v0.aX;
	var statuses = _v0.fT;
	var filterOn = _v0.J;
	var statusWithCount = function (s) {
		return _Utils_Tuple2(
			s,
			$elm$core$List$length(
				A2(
					$elm$core$List$filter,
					function (a) {
						return _Utils_eq(a.nS, s);
					},
					all)));
	};
	return A2(
		$elm$core$List$map,
		A2($author$project$Applicant$Overview$statusGroupView, statuses, filterOn.nS),
		A2(
			$elm$core$List$map,
			function (_v1) {
				var phase = _v1.a;
				var pStatuses = _v1.b;
				return _Utils_Tuple2(
					phase,
					A2($elm$core$List$map, statusWithCount, pStatuses));
			},
			$author$project$Applicant$Applicant$allStatusesByPhase));
};
var $author$project$UI$Button$withWidth = F2(
	function (width, _v0) {
		var b = _v0;
		return _Utils_update(
			b,
			{
				oy: $elm$core$Maybe$Just(width)
			});
	});
var $author$project$Applicant$Overview$filtersView = F2(
	function (loaded, window) {
		var buttonElement = A2(
			$elm$core$Basics$composeR,
			$author$project$UI$Button$withRole(0),
			A2(
				$elm$core$Basics$composeR,
				$author$project$UI$Button$withIcon($icidasset$elm_material_icons$Material$Icons$add),
				A2(
					$elm$core$Basics$composeR,
					$author$project$UI$Button$withWidth(
						$mdgriffith$elm_ui$Element$px(110)),
					$author$project$UI$Button$elementFor)));
		var createButton = function () {
			var _v0 = _Utils_Tuple2(
				loaded.dS,
				$elm$core$List$head(loaded.A));
			if (!_v0.a) {
				return _List_fromArray(
					[$mdgriffith$elm_ui$Element$none]);
			} else {
				if (!_v0.b.$) {
					var id = _v0.b.a.eg;
					var name = _v0.b.a.ft;
					return _List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$row,
							_List_fromArray(
								[$author$project$UI$Spacing$default]),
							_List_fromArray(
								[
									buttonElement(
									A2(
										$author$project$UI$Button$button,
										A2(
											$author$project$Applicant$Overview$UserClickedCreateButton,
											0,
											_Utils_Tuple2(id, name)),
										'Persoon')),
									buttonElement(
									A2(
										$author$project$UI$Button$button,
										A2(
											$author$project$Applicant$Overview$UserClickedCreateButton,
											3,
											_Utils_Tuple2(id, name)),
										'Firma'))
								])),
							$author$project$UI$Separator$horizontal
						]);
				} else {
					var _v1 = _v0.b;
					return _List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$row,
							_List_fromArray(
								[$author$project$UI$Spacing$default]),
							_List_fromArray(
								[
									buttonElement(
									$author$project$UI$Button$disabledButton(
										{jL: 'Geen distributiepunten om een persoon mee aan te maken.', n3: 'Persoon'})),
									buttonElement(
									$author$project$UI$Button$disabledButton(
										{jL: 'Geen distributiepunten om een firma mee aan te maken.', n3: 'Firma'}))
								])),
							$author$project$UI$Separator$horizontal
						]);
				}
			}
		}();
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$author$project$UI$Spacing$default,
					$mdgriffith$elm_ui$Element$alignTop,
					$mdgriffith$elm_ui$Element$alignLeft,
					$mdgriffith$elm_ui$Element$scrollbarY,
					$mdgriffith$elm_ui$Element$width(
					$mdgriffith$elm_ui$Element$px(250)),
					$mdgriffith$elm_ui$Element$height(
					$mdgriffith$elm_ui$Element$px(window.iK))
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						createButton,
						$author$project$Applicant$Overview$dpFilterView(loaded),
						_List_fromArray(
						[$author$project$UI$Separator$horizontal]),
						$author$project$Applicant$Overview$statusFilterView(loaded)
					])));
	});
var $author$project$Applicant$Overview$noApplicantsFoundView = $author$project$UI$Container$elementFor(
	A2(
		$author$project$UI$Container$withContent,
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$paragraph,
				_List_Nil,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$text('Geen kandidaten gevonden.')
					]))
			]),
		$author$project$UI$Container$container));
var $author$project$Applicant$Overview$view = F2(
	function (share, model) {
		switch (model.$) {
			case 0:
				return $mdgriffith$elm_ui$Element$none;
			case 2:
				return $mdgriffith$elm_ui$Element$none;
			default:
				var loaded = model.a;
				return $author$project$UI$Columns$elementFor(
					function () {
						var _v1 = loaded.aX;
						if (!_v1.b) {
							return $author$project$UI$Columns$withColumn(
								$elm$core$Basics$always($author$project$Applicant$Overview$noApplicantsFoundView));
						} else {
							return A2(
								$elm$core$Basics$composeR,
								$author$project$UI$Columns$withColumn(
									$author$project$Applicant$Overview$filtersView(loaded)),
								A2(
									$elm$core$Basics$composeR,
									$author$project$UI$Columns$withColumn(
										$author$project$Applicant$Overview$applicantsView(loaded)),
									$author$project$UI$Columns$withColumn(
										$elm$core$Basics$always(
											$author$project$Applicant$Overview$applicantView(loaded)))));
						}
					}()(
						$author$project$UI$Columns$columns(
							$author$project$Portal$Page$contentWindow(share))));
		}
	});
var $author$project$Compensation$Money$isNegative = function (_v0) {
	var m = _v0;
	return m < 0;
};
var $author$project$Compensation$Money$styleForNegative = $mdgriffith$elm_ui$Element$Font$color(
	$author$project$UI$Element$colorFor($author$project$UI$Palette$magenta));
var $author$project$Compensation$Compensation$moneyView = F2(
	function (attrs, amount) {
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_Utils_ap(
				attrs,
				$author$project$Compensation$Money$isNegative(amount) ? _List_fromArray(
					[$author$project$Compensation$Money$styleForNegative]) : _List_Nil),
			$mdgriffith$elm_ui$Element$text(
				A2($author$project$Compensation$Money$view, 1, amount)));
	});
var $author$project$Compensation$Compensation$amountView = function (amount) {
	return A2(
		$author$project$UI$Label$tagged,
		'Bedrag',
		A2($author$project$Compensation$Compensation$moneyView, $author$project$UI$Font$heading3, amount));
};
var $author$project$Compensation$Compensation$bookedOnView = function (on) {
	return $author$project$UI$Text$elementFor(
		A2(
			$author$project$UI$Text$withLabel,
			'Geboekt op',
			$author$project$UI$Text$text(
				$author$project$Date$DeliveryDate$view(on))));
};
var $author$project$Compensation$Compensation$hasResubmittedIn = function (log) {
	return 2 <= $elm$core$List$length(
		A2($elm$core$List$filter, $author$project$Compensation$Compensation$isSubmitLogItem, log));
};
var $author$project$Compensation$Compensation$rejectReason = function (log) {
	return A3(
		$elm$core$List$foldr,
		F2(
			function (_v0, cumm) {
				var action = _v0.dN;
				var _v1 = _Utils_Tuple2(cumm, action);
				if ((_v1.a.$ === 1) && (_v1.b.$ === 4)) {
					var _v2 = _v1.a;
					var _v3 = _v1.b;
					var reason = _v3.b;
					return $elm$core$Maybe$Just(reason);
				} else {
					return cumm;
				}
			}),
		$elm$core$Maybe$Nothing,
		log);
};
var $author$project$Compensation$Compensation$historicRejectionView = F2(
	function (log, status) {
		if ($author$project$Compensation$Compensation$hasResubmittedIn(log) && (status !== 3)) {
			var _v0 = $author$project$Compensation$Compensation$rejectReason(log);
			if (!_v0.$) {
				var reason = _v0.a;
				return A2(
					$author$project$UI$Label$tagged,
					'Vroeger afgekeurd omdat',
					A2(
						$mdgriffith$elm_ui$Element$paragraph,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$Font$italic,
								$mdgriffith$elm_ui$Element$Border$color(
								$author$project$UI$Element$colorFor($author$project$UI$Palette$magenta)),
								$mdgriffith$elm_ui$Element$Border$widthEach(
								{k5: 0, mE: 3, nx: 0, ol: 0}),
								$mdgriffith$elm_ui$Element$paddingEach(
								{k5: 0, mE: 5, nx: 0, ol: 0})
							]),
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text(reason)
							])));
			} else {
				return $mdgriffith$elm_ui$Element$none;
			}
		} else {
			return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$Compensation$Compensation$logView = F2(
	function (timeZone, log) {
		var _v0 = $author$project$Compensation$Compensation$lastSubmitted(log);
		if (!_v0.$) {
			var at = _v0.a.f5;
			var action = _v0.a.dN;
			var ifHasName = function (el) {
				var _v1 = A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.ft;
					},
					$author$project$Compensation$Compensation$userOf(action));
				if (_v1.$ === 1) {
					return $mdgriffith$elm_ui$Element$none;
				} else {
					if (_v1.a === '') {
						return $mdgriffith$elm_ui$Element$none;
					} else {
						var name = _v1.a;
						return el(name);
					}
				}
			};
			return A2(
				$author$project$UI$Label$tagged,
				'Ingevoerd',
				A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$spacing(5)
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$el,
							$author$project$UI$Font$tag,
							$mdgriffith$elm_ui$Element$text('op')),
							$mdgriffith$elm_ui$Element$text(
							$author$project$Date$DeliveryDate$view(
								A2($author$project$Date$DeliveryDate$fromPosix, timeZone, at))),
							ifHasName(
							$elm$core$Basics$always(
								A2(
									$mdgriffith$elm_ui$Element$el,
									$author$project$UI$Font$tag,
									$mdgriffith$elm_ui$Element$text('door')))),
							ifHasName($mdgriffith$elm_ui$Element$text)
						])));
		} else {
			return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$Compensation$Compensation$reasonView = function (reason) {
	return A2(
		$author$project$UI$Label$tagged,
		'Toelichting',
		A2(
			$mdgriffith$elm_ui$Element$paragraph,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$text(reason)
				])));
};
var $icidasset$elm_material_icons$Material$Icons$check_circle = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z')
				]),
			_List_Nil)
		]));
var $icidasset$elm_material_icons$Material$Icons$pending = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$b('new 0 0 24 24'),
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$rect,
					_List_fromArray(
						[
							$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$icidasset$elm_material_icons$Material$Icons$Internal$p,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10s10-4.48,10-10C22,6.48,17.52,2,12,2z M7,13.5c-0.83,0-1.5-0.67-1.5-1.5 c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5C8.5,12.83,7.83,13.5,7,13.5z M12,13.5c-0.83,0-1.5-0.67-1.5-1.5 c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5C13.5,12.83,12.83,13.5,12,13.5z M17,13.5c-0.83,0-1.5-0.67-1.5-1.5 c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5C18.5,12.83,17.83,13.5,17,13.5z')
						]),
					_List_Nil)
				]))
		]));
var $icidasset$elm_material_icons$Material$Icons$thumb_down = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm4 0v12h4V3h-4z')
				]),
			_List_Nil)
		]));
var $icidasset$elm_material_icons$Material$Icons$verified = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$b('new 0 0 24 24'),
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$rect,
					_List_fromArray(
						[
							$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$icidasset$elm_material_icons$Material$Icons$Internal$p,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M23,12l-2.44-2.79l0.34-3.69l-3.61-0.82L15.4,1.5L12,2.96L8.6,1.5L6.71,4.69L3.1,5.5L3.44,9.2L1,12l2.44,2.79l-0.34,3.7 l3.61,0.82L8.6,22.5l3.4-1.47l3.4,1.46l1.89-3.19l3.61-0.82l-0.34-3.69L23,12z M10.09,16.72l-3.8-3.81l1.48-1.48l2.32,2.33 l5.85-5.87l1.48,1.48L10.09,16.72z')
						]),
					_List_Nil)
				]))
		]));
var $author$project$Compensation$Compensation$statusView = F2(
	function (log, status) {
		var defaultStatusView = F3(
			function (description, icon, color) {
				return A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$spacing(5)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$UI$Element$coloredIconFor,
							icon(16),
							color),
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Font$color(
									$author$project$UI$Element$colorFor(color))
								]),
							$mdgriffith$elm_ui$Element$text(description))
						]));
			});
		return A2(
			$author$project$UI$Label$tagged,
			'Status',
			function () {
				var _v0 = _Utils_Tuple2(
					status,
					$author$project$Compensation$Compensation$rejectReason(log));
				switch (_v0.a) {
					case 0:
						var _v1 = _v0.a;
						return A3(defaultStatusView, 'In behandeling', $icidasset$elm_material_icons$Material$Icons$pending, $author$project$UI$Palette$base02);
					case 1:
						var _v2 = _v0.a;
						return A3(defaultStatusView, 'Goedgekeurd door OM', $icidasset$elm_material_icons$Material$Icons$verified, $author$project$UI$Palette$base01);
					case 2:
						var _v3 = _v0.a;
						return A3(defaultStatusView, 'Goedgekeurd', $icidasset$elm_material_icons$Material$Icons$check_circle, $author$project$UI$Palette$green);
					default:
						if (_v0.b.$ === 1) {
							var _v4 = _v0.a;
							var _v5 = _v0.b;
							return A3(defaultStatusView, 'Afgekeurd', $icidasset$elm_material_icons$Material$Icons$thumb_down, $author$project$UI$Palette$magenta);
						} else {
							var _v6 = _v0.a;
							var reason = _v0.b.a;
							return A2(
								$mdgriffith$elm_ui$Element$column,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$spacing(5)
									]),
								_List_fromArray(
									[
										A2(
										$mdgriffith$elm_ui$Element$row,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$spacing(5)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$UI$Element$coloredIconFor,
												$icidasset$elm_material_icons$Material$Icons$thumb_down(16),
												$author$project$UI$Palette$magenta),
												A2(
												$mdgriffith$elm_ui$Element$el,
												_List_fromArray(
													[
														$mdgriffith$elm_ui$Element$Font$color(
														$author$project$UI$Element$colorFor($author$project$UI$Palette$magenta))
													]),
												$mdgriffith$elm_ui$Element$text('Afgekeurd'))
											])),
										A2(
										$mdgriffith$elm_ui$Element$paragraph,
										_List_fromArray(
											[$mdgriffith$elm_ui$Element$Font$bold]),
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$text(reason)
											]))
									]));
						}
				}
			}());
	});
var $author$project$Compensation$Compensation$commonDetailView = F2(
	function (timeZone, _v0) {
		var on = _v0.g2;
		var reason = _v0.jL;
		var status = _v0.nS;
		var log = _v0.V;
		return _List_fromArray(
			[
				$author$project$Compensation$Compensation$reasonView(reason),
				$author$project$Compensation$Compensation$bookedOnView(on),
				A2($author$project$Compensation$Compensation$statusView, log, status),
				A2($author$project$Compensation$Compensation$historicRejectionView, log, status),
				A2($author$project$Compensation$Compensation$logView, timeZone, log)
			]);
	});
var $author$project$Compensation$Compensation$compensationTypeView = function (compensationType) {
	return A2($author$project$UI$Label$tagged, 'Vergoeding', compensationType);
};
var $icidasset$elm_material_icons$Material$Icons$autorenew = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z')
				]),
			_List_Nil)
		]));
var $author$project$Compensation$Compensation$resubmittedBadge = A3(
	$author$project$UI$Element$iconBadge,
	'Opnieuw ingediend',
	$icidasset$elm_material_icons$Material$Icons$autorenew,
	{kV: $author$project$UI$Palette$base2, k0: $author$project$UI$Palette$magenta, lZ: $author$project$UI$Palette$magenta});
var $author$project$Compensation$Compensation$delivererView = F2(
	function (log, deliverer) {
		return ($author$project$Compensation$Compensation$hasResubmittedIn(log) ? function (t) {
			return A2(
				$mdgriffith$elm_ui$Element$row,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				_List_fromArray(
					[t, $author$project$Compensation$Compensation$resubmittedBadge]));
		} : $elm$core$Basics$identity)(
			$author$project$UI$Text$elementFor(
				A2(
					$author$project$UI$Text$withLabel,
					'Bezorger',
					$author$project$UI$Text$text(
						$author$project$UI$Paradise$nameAndIdView(deliverer)))));
	});
var $author$project$Compensation$Compensation$deliverersView = F2(
	function (_v0, deliverers) {
		return A2(
			$author$project$UI$Label$tagged,
			'Bezorgers',
			$author$project$UI$Container$elementFor(
				A2(
					$author$project$UI$Container$withContent,
					A2(
						$elm$core$List$map,
						A2($elm$core$Basics$composeR, $author$project$UI$Paradise$nameAndIdView, $mdgriffith$elm_ui$Element$text),
						$author$project$Deliverer$ReferenceDict$keys(deliverers)),
					$author$project$UI$Container$container)));
	});
var $author$project$Compensation$Compensation$distributionPointView = function (distributionPoint) {
	return $author$project$UI$Text$elementFor(
		A2(
			$author$project$UI$Text$withLabel,
			'Distributiepunt',
			$author$project$UI$Text$text(
				$author$project$UI$Paradise$nameAndIdView(distributionPoint))));
};
var $author$project$Compensation$Type$codeColorFor = function (taxInclusion) {
	return $author$project$UI$Element$colorFor(
		function () {
			if (!taxInclusion) {
				return $author$project$UI$Palette$green;
			} else {
				return $author$project$UI$Palette$lightMagenta;
			}
		}());
};
var $author$project$Compensation$Type$infoView = function (_v0) {
	var code = _v0.ge;
	var description = _v0.ig;
	var taxInclusion = _v0.ae;
	return A2(
		$mdgriffith$elm_ui$Element$row,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$spacing(5),
				$mdgriffith$elm_ui$Element$Font$italic
			]),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$Font$color(
						$author$project$Compensation$Type$codeColorFor(taxInclusion))
					]),
				$mdgriffith$elm_ui$Element$text(
					$elm$core$String$fromInt(code))),
				$mdgriffith$elm_ui$Element$text(description)
			]));
};
var $author$project$Compensation$Type$forDistributionPointView = A2($elm$core$Basics$composeR, $author$project$Compensation$Type$infoOfForDistributionPoint, $author$project$Compensation$Type$infoView);
var $author$project$Compensation$Type$forSegmentView = A2($elm$core$Basics$composeR, $author$project$Compensation$Type$infoOfForSegment, $author$project$Compensation$Type$infoView);
var $author$project$Compensation$Compensation$segmentView = function (segment) {
	return $author$project$UI$Text$elementFor(
		A2(
			$author$project$UI$Text$withLabel,
			'Segment',
			$author$project$UI$Text$text(
				$author$project$UI$Paradise$nameAndIdView(segment))));
};
var $author$project$Deliverer$ReferenceDict$size = $timo_weike$generic_collections$ManualDict$size;
var $author$project$Compensation$Money$times = F2(
	function (i, _v0) {
		var m = _v0;
		return i * m;
	});
var $author$project$Compensation$Compensation$totalAmountOf = F2(
	function (count, amountForOneDeliverer) {
		return A2($author$project$Compensation$Money$times, count, amountForOneDeliverer);
	});
var $author$project$Compensation$Compensation$totalAmountView = function (_v0) {
	var deliverers = _v0.e4;
	var amountForOneDeliverer = _v0.cW;
	var count = $author$project$Deliverer$ReferenceDict$size(deliverers);
	return A2(
		$author$project$UI$Label$tagged,
		'Bedrag',
		A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(5)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					$author$project$UI$Font$heading3,
					$mdgriffith$elm_ui$Element$text(
						$elm$core$String$fromInt(count))),
					$mdgriffith$elm_ui$Element$text('x'),
					A2($author$project$Compensation$Compensation$moneyView, $author$project$UI$Font$heading3, amountForOneDeliverer),
					$mdgriffith$elm_ui$Element$text('='),
					A2(
					$author$project$Compensation$Compensation$moneyView,
					$author$project$UI$Font$heading3,
					A2($author$project$Compensation$Compensation$totalAmountOf, count, amountForOneDeliverer))
				])));
};
var $author$project$Compensation$Compensation$detailView = F2(
	function (timeZone, compensation) {
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				function () {
					switch (compensation.$) {
						case 0:
							var info = compensation.a;
							var distributionPoint = info.bn;
							var deliverer = info.bl;
							var amount = info.aa;
							var compensationType = info.M;
							var log = info.V;
							return _Utils_ap(
								_List_fromArray(
									[
										A2($author$project$Compensation$Compensation$delivererView, log, deliverer),
										$author$project$Compensation$Compensation$distributionPointView(distributionPoint),
										$author$project$Compensation$Compensation$compensationTypeView(
										$author$project$Compensation$Type$forDistributionPointView(compensationType)),
										$author$project$Compensation$Compensation$amountView(amount)
									]),
								A2($author$project$Compensation$Compensation$commonDetailView, timeZone, info));
						case 1:
							var info = compensation.a;
							var deliverer = info.bl;
							var segment = info.fO;
							var amount = info.aa;
							var compensationType = info.M;
							var log = info.V;
							return _Utils_ap(
								_List_fromArray(
									[
										A2($author$project$Compensation$Compensation$delivererView, log, deliverer),
										$author$project$Compensation$Compensation$segmentView(segment),
										$author$project$Compensation$Compensation$compensationTypeView(
										$author$project$Compensation$Type$forSegmentView(compensationType)),
										$author$project$Compensation$Compensation$amountView(amount)
									]),
								A2($author$project$Compensation$Compensation$commonDetailView, timeZone, info));
						default:
							var info = compensation.a;
							var deliverers = info.e4;
							var compensationType = info.M;
							var log = info.V;
							return _Utils_ap(
								_List_fromArray(
									[
										A2($author$project$Compensation$Compensation$deliverersView, log, deliverers),
										$author$project$Compensation$Compensation$compensationTypeView(
										$author$project$Compensation$Type$forSegmentView(compensationType)),
										$author$project$Compensation$Compensation$totalAmountView(info)
									]),
								A2($author$project$Compensation$Compensation$commonDetailView, timeZone, info));
					}
				}(),
				A2(
					$author$project$UI$Container$withWidth,
					A2(
						$mdgriffith$elm_ui$Element$maximum,
						560,
						A2($mdgriffith$elm_ui$Element$minimum, 300, $mdgriffith$elm_ui$Element$fill)),
					A2(
						$author$project$UI$Container$withSpacing,
						10,
						A2(
							$author$project$UI$Container$withTitle,
							$mdgriffith$elm_ui$Element$text('Incidentele vergoeding'),
							$author$project$UI$Container$container)))));
	});
var $author$project$Compensation$Add$returnToOverviewButton = $author$project$UI$Button$elementFor(
	A2($author$project$UI$Button$button, $author$project$Compensation$Add$UserClickedReturnToOverview, 'Naar overzicht'));
var $author$project$Compensation$Add$confirmationView = F2(
	function (timeZone, confirmation) {
		if (!confirmation.$) {
			return $mdgriffith$elm_ui$Element$none;
		} else {
			var compensation = confirmation.a;
			return $author$project$UI$Container$elementFor(
				A2(
					$author$project$UI$Container$withContent,
					_List_fromArray(
						[
							A2($author$project$Compensation$Compensation$detailView, timeZone, compensation),
							$author$project$Compensation$Add$returnToOverviewButton
						]),
					A2(
						$author$project$UI$Container$withWidth,
						$mdgriffith$elm_ui$Element$px(590),
						A2(
							$author$project$UI$Container$withTitle,
							$mdgriffith$elm_ui$Element$text('Vergoeding is aangemaakt'),
							$author$project$UI$Container$container))));
		}
	});
var $author$project$Compensation$Add$UserClickedSubmitCompensation = {$: 5};
var $author$project$Compensation$Add$submitButton = $author$project$UI$Button$elementFor(
	A2(
		$author$project$UI$Button$withRole,
		0,
		A2($author$project$UI$Button$button, $author$project$Compensation$Add$UserClickedSubmitCompensation, 'Indienen')));
var $author$project$Compensation$Form$Deliverer = 0;
var $author$project$Compensation$Form$Deliverers = 1;
var $author$project$Compensation$Form$UserChangedAmount = function (a) {
	return {$: 13, a: a};
};
var $author$project$Compensation$Form$isRestitution = function (amountInForm) {
	var _v0 = A2($arowM$elm_form_decoder$Form$Decoder$run, $author$project$Compensation$Form$amountFormDecoder, amountInForm);
	if (!_v0.$) {
		var amount = _v0.a;
		return $author$project$Compensation$Money$isNegative(amount);
	} else {
		return false;
	}
};
var $author$project$UI$Label$labeled = F2(
	function (label, element) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$spacing(3),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					$author$project$UI$Font$label,
					$mdgriffith$elm_ui$Element$text(label)),
					element
				]));
	});
var $author$project$Compensation$Form$UserChangedTaxInclusion = function (a) {
	return {$: 8, a: a};
};
var $author$project$Compensation$Form$taxInclusionView = function (taxInclusion) {
	return A3(
		$author$project$UI$MultiButton$toElement,
		function (t) {
			if (!t) {
				return $mdgriffith$elm_ui$Element$text('Belast');
			} else {
				return $mdgriffith$elm_ui$Element$text('Onbelast');
			}
		},
		$elm$core$Maybe$Just(taxInclusion),
		$author$project$UI$MultiButton$multiButton(
			{gy: 0, mD: 'Belaste of onbelaste vergoeding', gN: 1, gX: $author$project$Compensation$Form$UserChangedTaxInclusion, hf: _List_Nil}));
};
var $author$project$Compensation$Form$compensationInputView = function (model) {
	return A2(
		$author$project$UI$Label$labeled,
		'Vergoeding',
		$author$project$UI$Input$row(
			_List_fromArray(
				[
					$author$project$Compensation$Form$taxInclusionView(model.ae),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_Nil,
					function () {
						var _v0 = model.al;
						switch (_v0) {
							case 0:
								return A3($PaackEng$elm_ui_dropdown$Dropdown$view, $author$project$Compensation$Form$compensationTypeForSegmentDDConfig, model, model.c1);
							case 1:
								return A3($PaackEng$elm_ui_dropdown$Dropdown$view, $author$project$Compensation$Form$compensationTypeForDistributionPointDDConfig, model, model.dW);
							default:
								return A3($PaackEng$elm_ui_dropdown$Dropdown$view, $author$project$Compensation$Form$compensationTypeForSegmentDDConfig, model, model.c1);
						}
					}()),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$paddingEach(
							{k5: 0, mE: 8, nx: 0, ol: 0})
						]),
					$mdgriffith$elm_ui$Element$text('€')),
					A2(
					$mdgriffith$elm_ui$Element$Input$text,
					$elm_community$maybe_extra$Maybe$Extra$values(
						_List_fromArray(
							[
								$elm$core$Maybe$Just(
								$mdgriffith$elm_ui$Element$width(
									$mdgriffith$elm_ui$Element$px(90))),
								$author$project$Compensation$Form$isRestitution(model.aa) ? $elm$core$Maybe$Just($author$project$Compensation$Money$styleForNegative) : $elm$core$Maybe$Nothing
							])),
					{
						mD: $mdgriffith$elm_ui$Element$Input$labelHidden('bedrag'),
						mY: $author$project$Compensation$Form$UserChangedAmount,
						ng: $elm$core$Maybe$Nothing,
						n3: model.aa
					})
				])));
};
var $author$project$Compensation$Form$UserSelectedSegmentFromDeliverer = function (a) {
	return {$: 3, a: a};
};
var $author$project$UI$ItemList$defaultAttributes = _List_fromArray(
	[
		$mdgriffith$elm_ui$Element$padding(10),
		$mdgriffith$elm_ui$Element$Border$width(2),
		$mdgriffith$elm_ui$Element$Border$rounded(5),
		$mdgriffith$elm_ui$Element$Border$color(
		$author$project$UI$Element$colorFor($author$project$UI$Palette$base1))
	]);
var $mdgriffith$elm_ui$Element$scrollbarX = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$overflow, $mdgriffith$elm_ui$Internal$Style$classes.nC);
var $author$project$UI$ItemList$attributes = function (_v0) {
	var width = _v0.oy;
	var height = _v0.iK;
	return _Utils_ap(
		$author$project$UI$ItemList$defaultAttributes,
		_Utils_ap(
			function () {
				if (!width.$) {
					var w = width.a;
					return _List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width(w),
							$mdgriffith$elm_ui$Element$scrollbarX
						]);
				} else {
					return _List_Nil;
				}
			}(),
			function () {
				if (!height.$) {
					var h = height.a;
					return _List_fromArray(
						[
							$mdgriffith$elm_ui$Element$height(h),
							$mdgriffith$elm_ui$Element$scrollbarY
						]);
				} else {
					return _List_Nil;
				}
			}()));
};
var $author$project$UI$ItemList$mouseOverColors = {kV: $author$project$UI$Palette$base02, k0: $author$project$UI$Palette$base02, lZ: $author$project$UI$Palette$base2};
var $author$project$UI$ItemList$elementFor = function (_v0) {
	var itemToMsg = _v0.iX;
	var itemToLabel = _v0.iW;
	var sort = _v0.ho;
	var items = _v0.gL;
	var emptyListText = _v0.gs;
	var width = _v0.oy;
	var height = _v0.iK;
	var elementForItem = function (item) {
		return A2(
			$mdgriffith$elm_ui$Element$Input$button,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$padding(1),
					$mdgriffith$elm_ui$Element$mouseOver(
					$author$project$UI$Element$colors($author$project$UI$ItemList$mouseOverColors))
				]),
			{
				mD: itemToLabel(item),
				jp: $elm$core$Maybe$Just(
					itemToMsg(item))
			});
	};
	return A2(
		$mdgriffith$elm_ui$Element$column,
		$author$project$UI$ItemList$attributes(
			{iK: height, oy: width}),
		function () {
			if (!items.b) {
				return _List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[$mdgriffith$elm_ui$Element$Font$italic]),
						$mdgriffith$elm_ui$Element$text(emptyListText))
					]);
			} else {
				return A2(
					$elm$core$List$map,
					elementForItem,
					A4($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$core$Basics$identity, $elm$core$List$sortBy, sort, items));
			}
		}());
};
var $author$project$UI$ItemList$ItemList = $elm$core$Basics$identity;
var $author$project$UI$ItemList$itemList = F2(
	function (itemToMsg, itemToLabel) {
		return {gs: '', iK: $elm$core$Maybe$Nothing, iW: itemToLabel, iX: itemToMsg, gL: _List_Nil, ho: $elm$core$Maybe$Nothing, oy: $elm$core$Maybe$Nothing};
	});
var $author$project$UI$ItemList$withEmptyListText = F2(
	function (text, _v0) {
		var l = _v0;
		return _Utils_update(
			l,
			{gs: text});
	});
var $author$project$UI$ItemList$withHeight = F2(
	function (height, _v0) {
		var l = _v0;
		return _Utils_update(
			l,
			{
				iK: $elm$core$Maybe$Just(height)
			});
	});
var $author$project$UI$ItemList$withItems = F2(
	function (items, _v0) {
		var l = _v0;
		return _Utils_update(
			l,
			{gL: items});
	});
var $author$project$UI$ItemList$withSorting = F2(
	function (sorting, _v0) {
		var l = _v0;
		return _Utils_update(
			l,
			{
				ho: $elm$core$Maybe$Just(sorting)
			});
	});
var $author$project$UI$ItemList$withWidth = F2(
	function (width, _v0) {
		var l = _v0;
		return _Utils_update(
			l,
			{
				oy: $elm$core$Maybe$Just(width)
			});
	});
var $author$project$Compensation$Form$delivererSelectView = function (model) {
	var deliverer = model.bl;
	var selectedDeliverer = model.cF;
	var delivererSegments = model.e3;
	return $author$project$UI$Input$row(
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[$mdgriffith$elm_ui$Element$alignTop]),
				A3($PaackEng$elm_ui_dropdown$Dropdown$view, $author$project$Compensation$Form$delivererDDConfig, model, deliverer)),
				$author$project$UI$ItemList$elementFor(
				A2(
					$author$project$UI$ItemList$withWidth,
					$mdgriffith$elm_ui$Element$fill,
					A2(
						$author$project$UI$ItemList$withHeight,
						$mdgriffith$elm_ui$Element$px(100),
						A2(
							$author$project$UI$ItemList$withSorting,
							A2($elm$core$Basics$composeR, $author$project$DistributionPoint$DistributionPoint$segmentInfo, $author$project$UI$Paradise$nameAndIdView),
							A2(
								$author$project$UI$ItemList$withItems,
								delivererSegments,
								A4(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									$elm$core$Basics$identity,
									$elm$core$Basics$always(
										$author$project$UI$ItemList$withEmptyListText('Geen segmenten')),
									selectedDeliverer,
									A2(
										$author$project$UI$ItemList$itemList,
										$author$project$Compensation$Form$UserSelectedSegmentFromDeliverer,
										A2(
											$elm$core$Basics$composeR,
											$author$project$DistributionPoint$DistributionPoint$segmentInfo,
											A2($elm$core$Basics$composeR, $author$project$UI$Paradise$nameAndIdView, $mdgriffith$elm_ui$Element$text)))))))))
			]));
};
var $author$project$Compensation$Form$UserToggledAllDeliverers = function (a) {
	return {$: 6, a: a};
};
var $author$project$Compensation$Form$UserToggledDeliverer = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Deliverer$TypedDict$size = $timo_weike$generic_collections$ManualDict$size;
var $author$project$UI$Container$withHeight = F2(
	function (length, _v0) {
		var c = _v0;
		return _Utils_update(
			c,
			{
				iK: $elm$core$Maybe$Just(length)
			});
	});
var $author$project$Compensation$Form$deliverersSelectView = function (_v0) {
	var activeDeliverersFirstSegment = _v0.cV;
	var selectedDeliverers = _v0.ak;
	return $author$project$UI$Container$elementFor(
		A2(
			$author$project$UI$Container$withHeight,
			$mdgriffith$elm_ui$Element$px(207),
			A2(
				$author$project$UI$Container$withWidth,
				$mdgriffith$elm_ui$Element$px(400),
				A2(
					$author$project$UI$Container$withContent,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$Input$checkbox,
							_List_Nil,
							{
								lc: _Utils_eq(
									$author$project$Deliverer$TypedDict$size(activeDeliverersFirstSegment),
									$Gizra$elm_all_set$EverySet$size(selectedDeliverers)),
								mg: $mdgriffith$elm_ui$Element$Input$defaultCheckbox,
								mD: A2(
									$mdgriffith$elm_ui$Element$Input$labelRight,
									_List_Nil,
									$mdgriffith$elm_ui$Element$text('Alle active bezorgers')),
								mY: $author$project$Compensation$Form$UserToggledAllDeliverers
							}),
							A2(
							$mdgriffith$elm_ui$Element$column,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$paddingEach(
									{k5: 0, mE: 20, nx: 0, ol: 0}),
									$mdgriffith$elm_ui$Element$spacing(5)
								]),
							A2(
								$elm$core$List$map,
								function (deliverer) {
									return A2(
										$mdgriffith$elm_ui$Element$Input$checkbox,
										_List_Nil,
										{
											lc: A2($Gizra$elm_all_set$EverySet$member, deliverer, selectedDeliverers),
											mg: $mdgriffith$elm_ui$Element$Input$defaultCheckbox,
											mD: A2(
												$mdgriffith$elm_ui$Element$Input$labelRight,
												_List_Nil,
												$mdgriffith$elm_ui$Element$text(
													A2($elm$core$Basics$composeR, $author$project$Deliverer$Deliverer$fromTyped, $author$project$Deliverer$Deliverer$nameAndIdView)(deliverer))),
											mY: $author$project$Compensation$Form$UserToggledDeliverer(deliverer)
										});
								},
								A2(
									$elm$core$List$sortBy,
									A2($elm$core$Basics$composeR, $author$project$Deliverer$Deliverer$fromTyped, $author$project$Sorting$Deliverers$byName),
									$author$project$Deliverer$TypedDict$keys(activeDeliverersFirstSegment))))
						]),
					$author$project$UI$Container$container))));
};
var $author$project$Compensation$Form$distributionPointInfoView = function (distributionPoint) {
	return A2(
		$mdgriffith$elm_ui$Element$el,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$paddingEach(
				{k5: 5, mE: 0, nx: 0, ol: 0})
			]),
		A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Border$rounded(3),
					$mdgriffith$elm_ui$Element$Border$width(1),
					$mdgriffith$elm_ui$Element$Border$color(
					$author$project$UI$Element$colorFor($author$project$UI$Palette$base0)),
					A2($mdgriffith$elm_ui$Element$paddingXY, 4, 9)
				]),
			$mdgriffith$elm_ui$Element$text(
				$author$project$DistributionPoint$DistributionPoint$nameOf(distributionPoint))));
};
var $author$project$Compensation$Form$formErrorView = function (error) {
	return A2(
		$mdgriffith$elm_ui$Element$paragraph,
		_List_Nil,
		$elm$core$List$singleton(
			function () {
				switch (error) {
					case 0:
						return $mdgriffith$elm_ui$Element$text('Bezorger is verplicht');
					case 1:
						return $mdgriffith$elm_ui$Element$text('Distributiepunt is verplicht');
					case 2:
						return $mdgriffith$elm_ui$Element$text('Segment is verplicht');
					case 3:
						return $mdgriffith$elm_ui$Element$text('Vergoeding is verplicht');
					case 4:
						return $mdgriffith$elm_ui$Element$text('Bedrag is verplicht');
					case 5:
						return $mdgriffith$elm_ui$Element$text('Geldig bedrag is verplicht');
					case 6:
						return $mdgriffith$elm_ui$Element$text(
							'Bedrag is maximaal ' + $author$project$Compensation$Form$moneyView($author$project$Compensation$Compensation$maxAmount));
					case 7:
						return $mdgriffith$elm_ui$Element$text(
							'Een restitutie mag maximaal ' + ($author$project$Compensation$Form$moneyView($author$project$Compensation$Compensation$minAmount) + ' zijn'));
					case 8:
						return $mdgriffith$elm_ui$Element$text('Toelichting is verplicht');
					default:
						return $mdgriffith$elm_ui$Element$text(
							'Toelichting mag maximaal ' + ($elm$core$String$fromInt($author$project$Compensation$Compensation$maxReasonCharacters) + ' letters bevatten'));
				}
			}()));
};
var $author$project$Compensation$Form$formErrorsView = function (errors) {
	var _v0 = $elm$core$List$length(errors);
	if (!_v0) {
		return $mdgriffith$elm_ui$Element$none;
	} else {
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				A2($elm$core$List$map, $author$project$Compensation$Form$formErrorView, errors),
				A2(
					$author$project$UI$Container$withWidth,
					$mdgriffith$elm_ui$Element$px(400),
					A2(
						$author$project$UI$Container$withSpacing,
						8,
						A2($author$project$UI$Container$withVariant, 2, $author$project$UI$Container$container)))));
	}
};
var $author$project$Compensation$Form$UserChangedOneOrMoreDeliverers = function (a) {
	return {$: 15, a: a};
};
var $author$project$Compensation$Form$oneOrMoreDeliverersView = function (oneOrMore) {
	return A3(
		$author$project$UI$MultiButton$toElement,
		function (s) {
			if (!s) {
				return $mdgriffith$elm_ui$Element$text('Bezorger');
			} else {
				return $mdgriffith$elm_ui$Element$text('Bezorgers');
			}
		},
		$elm$core$Maybe$Just(oneOrMore),
		$author$project$UI$MultiButton$multiButton(
			{gy: 0, mD: 'Vergoeding voor een of meerdere bezorgers', gN: 1, gX: $author$project$Compensation$Form$UserChangedOneOrMoreDeliverers, hf: _List_Nil}));
};
var $author$project$Compensation$Form$UserChangedReason = function (a) {
	return {$: 14, a: a};
};
var $author$project$Compensation$Form$charactersLeftView = function (charactersLeft) {
	return (charactersLeft > 10) ? $elm$core$Maybe$Nothing : ((charactersLeft > 1) ? $elm$core$Maybe$Just(
		'nog plaats voor ' + ($elm$core$String$fromInt(charactersLeft) + ' letters')) : ((charactersLeft === 1) ? $elm$core$Maybe$Just('nog plaats voor 1 letter') : ((!charactersLeft) ? $elm$core$Maybe$Just('maximum aantal letters bereikt') : (_Utils_eq(charactersLeft, -1) ? $elm$core$Maybe$Just('1 letter te veel') : $elm$core$Maybe$Just(
		$elm$core$String$fromInt(-charactersLeft) + ' letters te veel')))));
};
var $author$project$Compensation$Form$reasonInputView = F2(
	function (reason, charactersLeft) {
		var label = 'Toelichting' + function () {
			var _v0 = $author$project$Compensation$Form$charactersLeftView(charactersLeft);
			if (_v0.$ === 1) {
				return '';
			} else {
				var notification = _v0.a;
				return ' (' + (notification + ')');
			}
		}();
		return $author$project$UI$Input$row(
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					A2(
						$mdgriffith$elm_ui$Element$Input$multiline,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$height(
								$mdgriffith$elm_ui$Element$px(120)),
								$mdgriffith$elm_ui$Element$width(
								A2($mdgriffith$elm_ui$Element$maximum, 566, $mdgriffith$elm_ui$Element$fill))
							]),
						{
							mD: $author$project$UI$Input$label(label),
							mY: $author$project$Compensation$Form$UserChangedReason,
							ng: $elm$core$Maybe$Nothing,
							nR: true,
							n3: reason
						}))
				]));
	});
var $author$project$Compensation$Form$segmentSelectView = function (model) {
	return A2(
		$mdgriffith$elm_ui$Element$row,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$spacing(10),
				$mdgriffith$elm_ui$Element$paddingEach(
				{k5: 5, mE: 0, nx: 0, ol: 0})
			]),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$el,
				_List_Nil,
				A3($PaackEng$elm_ui_dropdown$Dropdown$view, $author$project$Compensation$Form$segmentDDConfig, model, model.fO)),
				function () {
				var _v0 = model.d1;
				if (_v0.$ === 1) {
					return $mdgriffith$elm_ui$Element$none;
				} else {
					var deliverer = _v0.a;
					return A2(
						$mdgriffith$elm_ui$Element$paragraph,
						$author$project$UI$Font$tag,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text('Gelopen door: '),
								$mdgriffith$elm_ui$Element$text(
								$author$project$Deliverer$Deliverer$nameView(
									$author$project$Deliverer$Deliverer$fromTyped(deliverer)))
							]));
				}
			}()
			]));
};
var $author$project$Compensation$Form$UserChangedSelection = function (a) {
	return {$: 0, a: a};
};
var $author$project$Compensation$Form$selectionView = function (selection) {
	return A3(
		$author$project$UI$MultiButton$toElement,
		function (s) {
			switch (s) {
				case 0:
					return $mdgriffith$elm_ui$Element$text('Segment');
				case 1:
					return $mdgriffith$elm_ui$Element$text('Distributiepunt');
				default:
					return $mdgriffith$elm_ui$Element$none;
			}
		},
		$elm$core$Maybe$Just(selection),
		$author$project$UI$MultiButton$multiButton(
			{gy: 0, mD: 'Vergoeding op distributiepunt of op segment', gN: 1, gX: $author$project$Compensation$Form$UserChangedSelection, hf: _List_Nil}));
};
var $author$project$Compensation$Form$view = F2(
	function (_v0, model) {
		var title = _v0.oi;
		var distributionPoint = model.bn;
		var validationErrors = model.f_;
		var selection = model.al;
		var reason = model.jL;
		var reasonCharactersLeft = model.fG;
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				A2(
					$elm$core$List$cons,
					$author$project$Compensation$Form$formErrorsView(validationErrors),
					_Utils_ap(
						function () {
							switch (selection) {
								case 0:
									return _List_fromArray(
										[
											$author$project$Compensation$Form$oneOrMoreDeliverersView(0),
											$author$project$Compensation$Form$delivererSelectView(model),
											$author$project$Compensation$Form$selectionView(selection),
											$author$project$Compensation$Form$segmentSelectView(model)
										]);
								case 1:
									return _List_fromArray(
										[
											$author$project$Compensation$Form$oneOrMoreDeliverersView(0),
											$author$project$Compensation$Form$delivererSelectView(model),
											$author$project$Compensation$Form$selectionView(selection),
											$author$project$Compensation$Form$distributionPointInfoView(distributionPoint)
										]);
								default:
									return _List_fromArray(
										[
											$author$project$Compensation$Form$oneOrMoreDeliverersView(1),
											$author$project$Compensation$Form$deliverersSelectView(model)
										]);
							}
						}(),
						_List_fromArray(
							[
								$author$project$Compensation$Form$compensationInputView(model),
								A2($author$project$Compensation$Form$reasonInputView, reason, reasonCharactersLeft)
							]))),
				A2(
					$author$project$UI$Container$withSpacing,
					10,
					A2(
						$author$project$UI$Container$withTitle,
						$mdgriffith$elm_ui$Element$text(title),
						$author$project$UI$Container$container))));
	});
var $author$project$Compensation$Add$loadedView = F2(
	function (timeZone, loaded) {
		var confirmation = loaded.eW;
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$spacing(10)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$map,
					$author$project$Compensation$Add$SystemGotFormMsg,
					A2(
						$author$project$Compensation$Form$view,
						{oi: 'Incidentele vergoeding aanmaken'},
						loaded.bO)),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$alignRight]),
					$author$project$Compensation$Add$submitButton),
					A2($author$project$Compensation$Add$confirmationView, timeZone, confirmation)
				]));
	});
var $author$project$Compensation$Add$noPlanView = $author$project$UI$Container$elementFor(
	A2(
		$author$project$UI$Container$withContent,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$text('Kies een datum waarop bezorgers zijn ingepland.')
			]),
		A2(
			$author$project$UI$Container$withTitle,
			$mdgriffith$elm_ui$Element$text('Geen plan voor deze datum'),
			$author$project$UI$Container$container)));
var $author$project$Compensation$Add$view = F2(
	function (share, model) {
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$centerX,
					$mdgriffith$elm_ui$Element$padding(20)
				]),
			function () {
				switch (model.$) {
					case 0:
						return $mdgriffith$elm_ui$Element$none;
					case 1:
						var loaded = model.a;
						return A2(
							$author$project$Compensation$Add$loadedView,
							$author$project$Portal$Share$timeZone(share),
							loaded);
					case 2:
						return $author$project$Compensation$Add$noPlanView;
					default:
						return $mdgriffith$elm_ui$Element$none;
				}
			}());
	});
var $author$project$Compensation$Approve$UserClickedApproveButton = {$: 3};
var $author$project$UI$Button$withKey = F2(
	function (key, _v0) {
		var b = _v0;
		return _Utils_update(
			b,
			{
				iY: $elm$core$Maybe$Just(key)
			});
	});
var $author$project$Compensation$Approve$withKey = F2(
	function (focus, key) {
		if (!focus) {
			return $author$project$UI$Button$withKey(key);
		} else {
			return $elm$core$Basics$identity;
		}
	});
var $author$project$Compensation$Approve$buttonApprove = function (focus) {
	return $author$project$UI$Button$elementFor(
		A2(
			$author$project$UI$Button$withIcon,
			$icidasset$elm_material_icons$Material$Icons$check_circle,
			A2(
				$author$project$UI$Button$withRole,
				0,
				A3(
					$author$project$Compensation$Approve$withKey,
					focus,
					'g',
					A2($author$project$UI$Button$button, $author$project$Compensation$Approve$UserClickedApproveButton, 'Goedkeuren')))));
};
var $author$project$Compensation$Approve$UserClickedRejectButton = {$: 4};
var $author$project$Compensation$Approve$buttonReject = function (focus) {
	return $author$project$UI$Button$elementFor(
		A2(
			$author$project$UI$Button$withIcon,
			$icidasset$elm_material_icons$Material$Icons$thumb_down,
			A2(
				$author$project$UI$Button$withRole,
				1,
				A3(
					$author$project$Compensation$Approve$withKey,
					focus,
					'a',
					A2($author$project$UI$Button$button, $author$project$Compensation$Approve$UserClickedRejectButton, 'Afkeuren')))));
};
var $author$project$Compensation$Approve$UserClickedValidateButton = {$: 2};
var $author$project$Compensation$Approve$buttonValidate = function (focus) {
	return $author$project$UI$Button$elementFor(
		A2(
			$author$project$UI$Button$withIcon,
			$icidasset$elm_material_icons$Material$Icons$verified,
			A2(
				$author$project$UI$Button$withRole,
				0,
				A3(
					$author$project$Compensation$Approve$withKey,
					focus,
					'g',
					A2($author$project$UI$Button$button, $author$project$Compensation$Approve$UserClickedValidateButton, 'Goedkeuren')))));
};
var $author$project$Compensation$Approve$buttonsView = F3(
	function (security, focus, status) {
		var _v0 = A2($author$project$Compensation$Approve$can, security, status);
		switch (_v0) {
			case 0:
				return A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$author$project$UI$Spacing$large,
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					_List_fromArray(
						[
							$author$project$Compensation$Approve$buttonReject(focus),
							$author$project$Compensation$Approve$buttonValidate(focus)
						]));
			case 1:
				return A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$author$project$UI$Spacing$large,
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					_List_fromArray(
						[
							$author$project$Compensation$Approve$buttonReject(focus),
							$author$project$Compensation$Approve$buttonApprove(focus)
						]));
			default:
				return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$UI$Button$Soft = 2;
var $author$project$Compensation$Approve$UserChangedRejectReason = function (a) {
	return {$: 5, a: a};
};
var $author$project$Compensation$Approve$UserClickedCancelRejectionButton = {$: 6};
var $author$project$Compensation$Approve$UserClickedConfirmRejectionButton = {$: 7};
var $author$project$Compensation$Approve$rejectingView = F2(
	function (focus, reason) {
		return _List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				A2(
					$mdgriffith$elm_ui$Element$Input$multiline,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$height(
							$mdgriffith$elm_ui$Element$px(120)),
							$mdgriffith$elm_ui$Element$width(
							A2($mdgriffith$elm_ui$Element$maximum, 566, $mdgriffith$elm_ui$Element$fill)),
							$mdgriffith$elm_ui$Element$htmlAttribute(
							$elm$html$Html$Attributes$id($author$project$Compensation$Approve$rejectingNodeId))
						]),
					{
						mD: $author$project$UI$Input$label('Reden van afkeuring'),
						mY: $author$project$Compensation$Approve$UserChangedRejectReason,
						ng: $elm$core$Maybe$Nothing,
						nR: true,
						n3: reason
					})),
				A2(
				$mdgriffith$elm_ui$Element$row,
				_List_fromArray(
					[$author$project$UI$Spacing$large]),
				_List_fromArray(
					[
						$author$project$UI$Button$elementFor(
						A2(
							$author$project$UI$Button$withRole,
							2,
							A3(
								$author$project$Compensation$Approve$withKey,
								focus,
								'esc',
								A2($author$project$UI$Button$button, $author$project$Compensation$Approve$UserClickedCancelRejectionButton, 'Annuleren')))),
						$author$project$UI$Button$elementFor(
						A2(
							$author$project$UI$Button$withRole,
							1,
							A3(
								$author$project$Compensation$Approve$withKey,
								focus,
								'enter',
								A2($author$project$UI$Button$button, $author$project$Compensation$Approve$UserClickedConfirmRejectionButton, 'Afkeuren'))))
					]))
			]);
	});
var $author$project$Compensation$Approve$approveView = F3(
	function (share, focus, _v0) {
		var compensation = _v0.ao;
		var rejectState = _v0.bw;
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$alignTop,
					$mdgriffith$elm_ui$Element$spacing(20),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Compensation$Compensation$detailView,
					$author$project$Portal$Share$timeZone(share),
					compensation),
				function () {
					if (!rejectState.$) {
						return _List_fromArray(
							[
								A3(
								$author$project$Compensation$Approve$buttonsView,
								$author$project$Portal$Share$security(share),
								focus,
								$author$project$Compensation$Compensation$statusOf(compensation))
							]);
					} else {
						var reason = rejectState.a;
						return A2($author$project$Compensation$Approve$rejectingView, focus, reason);
					}
				}()));
	});
var $author$project$Compensation$Approve$UserChangedTextFilter = function (a) {
	return {$: 16, a: a};
};
var $author$project$Compensation$Approve$UserEnteredTextFilter = {$: 15};
var $author$project$Compensation$Approve$UserLeftTextFilter = {$: 17};
var $author$project$UI$Search$withFocus = F2(
	function (focus, _v0) {
		var input = _v0;
		return _Utils_update(
			input,
			{
				db: $elm$core$Maybe$Just(focus)
			});
	});
var $author$project$Compensation$Approve$filterView = function (filtered) {
	return $author$project$UI$Search$elementFor(
		A2(
			$author$project$UI$Search$withFocus,
			{m_: $author$project$Compensation$Approve$UserEnteredTextFilter, m0: $author$project$Compensation$Approve$UserLeftTextFilter},
			A3(
				$author$project$UI$Search$text,
				filtered.g2,
				$author$project$Compensation$Approve$UserChangedTextFilter,
				$mdgriffith$elm_ui$Element$Input$labelHidden('Zoek naar een incidentele vergoeding'))));
};
var $author$project$Compensation$Approve$UserClickedCompensationCard = function (a) {
	return {$: 1, a: a};
};
var $author$project$Compensation$Compensation$cardForAmountView = F2(
	function (_v0, typeView) {
		var deliverer = _v0.bl;
		var status = _v0.nS;
		var log = _v0.V;
		var amount = _v0.aa;
		return _List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$row,
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$author$project$UI$Font$bodyLarge),
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$text(deliverer.ft),
						$author$project$Compensation$Compensation$hasResubmittedIn(log) ? $author$project$Compensation$Compensation$resubmittedBadge : $mdgriffith$elm_ui$Element$none
					])),
				A2(
				$author$project$Compensation$Compensation$moneyView,
				A2($elm$core$List$cons, $mdgriffith$elm_ui$Element$alignRight, $author$project$UI$Font$heading3),
				amount),
				typeView
			]);
	});
var $author$project$Compensation$Compensation$cardForBulkView = function (_v0) {
	var deliverers = _v0.e4;
	var amountForOneDeliverer = _v0.cW;
	var compensationType = _v0.M;
	var status = _v0.nS;
	var log = _v0.V;
	var firstDeliverer = $elm$core$List$head(
		A2(
			$elm$core$List$sortBy,
			function ($) {
				return $.ft;
			},
			$author$project$Deliverer$ReferenceDict$keys(deliverers)));
	var count = $author$project$Deliverer$ReferenceDict$size(deliverers);
	return _List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Element$row,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$author$project$UI$Font$bodyLarge),
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$text(
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'Bulk',
						function (d) {
							return d.ft + ', ...';
						},
						firstDeliverer)),
					$author$project$Compensation$Compensation$hasResubmittedIn(log) ? $author$project$Compensation$Compensation$resubmittedBadge : $mdgriffith$elm_ui$Element$none
				])),
			A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$spacing(5),
					$mdgriffith$elm_ui$Element$alignRight
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					$author$project$UI$Font$heading3,
					$mdgriffith$elm_ui$Element$text(
						$elm$core$String$fromInt(count))),
					$mdgriffith$elm_ui$Element$text('x'),
					A2(
					$author$project$Compensation$Compensation$moneyView,
					A2($elm$core$List$cons, $mdgriffith$elm_ui$Element$alignRight, $author$project$UI$Font$heading3),
					amountForOneDeliverer),
					$mdgriffith$elm_ui$Element$text('='),
					A2(
					$author$project$Compensation$Compensation$moneyView,
					A2($elm$core$List$cons, $mdgriffith$elm_ui$Element$alignRight, $author$project$UI$Font$heading3),
					A2($author$project$Compensation$Compensation$totalAmountOf, count, amountForOneDeliverer))
				])),
			$author$project$Compensation$Type$forSegmentView(compensationType)
		]);
};
var $author$project$UI$Card$ColoredMark = function (a) {
	return {$: 1, a: a};
};
var $author$project$UI$Card$TransparentMark = {$: 0};
var $author$project$Compensation$Compensation$statusMarker = function (status) {
	switch (status) {
		case 0:
			return $author$project$UI$Card$TransparentMark;
		case 1:
			return $author$project$UI$Card$ColoredMark($author$project$UI$Palette$base01);
		case 2:
			return $author$project$UI$Card$ColoredMark($author$project$UI$Palette$green);
		default:
			return $author$project$UI$Card$ColoredMark($author$project$UI$Palette$lightMagenta);
	}
};
var $author$project$UI$Card$withColorMarker = F2(
	function (marker, _v0) {
		var c = _v0;
		return _Utils_update(
			c,
			{
				gS: $elm$core$Maybe$Just(marker)
			});
	});
var $author$project$UI$Card$withSelectedAttribute = F2(
	function (selectedAttr, _v0) {
		var c = _v0;
		return _Utils_update(
			c,
			{
				hl: $elm$core$Maybe$Just(selectedAttr)
			});
	});
var $author$project$Compensation$Compensation$cardView = F3(
	function (_v0, selected, compensation) {
		var onClickMsg = _v0.mZ;
		return $author$project$UI$Card$elementFor(
			A2(
				$author$project$UI$Card$withColorMarker,
				A2($elm$core$Basics$composeR, $author$project$Compensation$Compensation$statusOf, $author$project$Compensation$Compensation$statusMarker)(compensation),
				A2(
					$author$project$UI$Card$withContent,
					function () {
						switch (compensation.$) {
							case 0:
								var info = compensation.a;
								var amount = info.aa;
								var compensationType = info.M;
								return A2(
									$author$project$Compensation$Compensation$cardForAmountView,
									info,
									$author$project$Compensation$Type$forDistributionPointView(compensationType));
							case 1:
								var info = compensation.a;
								var amount = info.aa;
								var compensationType = info.M;
								return A2(
									$author$project$Compensation$Compensation$cardForAmountView,
									info,
									$author$project$Compensation$Type$forSegmentView(compensationType));
							default:
								var info = compensation.a;
								return $author$project$Compensation$Compensation$cardForBulkView(info);
						}
					}(),
					A2(
						$author$project$UI$Card$withSelectedAttribute,
						$mdgriffith$elm_ui$Element$htmlAttribute(
							$elm$html$Html$Attributes$id($author$project$Compensation$Compensation$selectedCardNodeId)),
						A2(
							$author$project$UI$Card$selectedIf,
							selected,
							$author$project$UI$Card$card(
								onClickMsg(compensation)))))));
	});
var $author$project$Compensation$Approve$boardColumn = F3(
	function (window, selected, compensations) {
		var selectedCompensation = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.ao;
			},
			selected);
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_Utils_ap(
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$spacing(5),
						$mdgriffith$elm_ui$Element$alignTop,
						$mdgriffith$elm_ui$Element$alignLeft,
						$mdgriffith$elm_ui$Element$paddingEach(
						{k5: 20, mE: 5, nx: 5, ol: 5}),
						$mdgriffith$elm_ui$Element$scrollbarY,
						$mdgriffith$elm_ui$Element$htmlAttribute(
						$elm$html$Html$Attributes$id($author$project$Compensation$Approve$todoColumnNodeId)),
						$mdgriffith$elm_ui$Element$width(
						$mdgriffith$elm_ui$Element$px(300)),
						$mdgriffith$elm_ui$Element$height(
						$mdgriffith$elm_ui$Element$px(window.iK))
					]),
				$author$project$UI$Element$colors(
					{kV: $author$project$UI$Palette$base1, k0: $author$project$UI$Palette$base0, lZ: $author$project$UI$Palette$base03})),
			A2(
				$elm$core$List$map,
				function (c) {
					return A3(
						$author$project$Compensation$Compensation$cardView,
						{mZ: $author$project$Compensation$Approve$UserClickedCompensationCard},
						_Utils_eq(
							$elm$core$Maybe$Just(c),
							selectedCompensation),
						c);
				},
				compensations));
	});
var $author$project$Compensation$Approve$todoColumn = F2(
	function (_v0, window) {
		var selected = _v0.nI;
		var filtered = _v0.eb;
		return A3($author$project$Compensation$Approve$boardColumn, window, selected, filtered.aD);
	});
var $author$project$UI$Columns$withMaybeColumn = F3(
	function (f, a, c) {
		return A2(
			$author$project$UI$Columns$withColumn,
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				$elm$core$Basics$always($mdgriffith$elm_ui$Element$none),
				f,
				a),
			c);
	});
var $author$project$UI$Container$withPadding = F2(
	function (padding, _v0) {
		var c = _v0;
		return _Utils_update(
			c,
			{
				g6: {k5: padding, mE: padding, nx: padding, ol: padding}
			});
	});
var $author$project$Compensation$Approve$loadedView = F2(
	function (share, loaded) {
		var _v0 = loaded.aD;
		if (!_v0.b) {
			return $author$project$UI$Container$elementFor(
				A2(
					$author$project$UI$Container$withPadding,
					$author$project$UI$Padding$largeSize,
					A2(
						$author$project$UI$Container$withWidth,
						$mdgriffith$elm_ui$Element$fill,
						A2(
							$author$project$UI$Container$withContent,
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$paragraph,
									_List_Nil,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$text('Er zijn op dit ogenblik geen vergoedingen om goed te keuren.')
										]))
								]),
							$author$project$UI$Container$container))));
		} else {
			return $author$project$UI$Columns$elementFor(
				A3(
					$author$project$UI$Columns$withMaybeColumn,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$always,
						A2($author$project$Compensation$Approve$approveView, share, loaded.db)),
					loaded.nI,
					A2(
						$author$project$UI$Columns$withColumn,
						$author$project$Compensation$Approve$todoColumn(loaded),
						A3(
							$author$project$UI$Columns$withHeader,
							$author$project$UI$Search$height,
							$author$project$Compensation$Approve$filterView(loaded.eb),
							$author$project$UI$Columns$columns(
								$author$project$Portal$Page$contentWindow(share))))));
		}
	});
var $author$project$Compensation$Approve$view = F2(
	function (share, model) {
		switch (model.$) {
			case 0:
				return $mdgriffith$elm_ui$Element$none;
			case 1:
				var loaded = model.a;
				return A2($author$project$Compensation$Approve$loadedView, share, loaded);
			default:
				return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$Compensation$Edit$UserClickedCancelEdit = {$: 5};
var $author$project$Compensation$Edit$cancelButton = $author$project$UI$Button$elementFor(
	A2(
		$author$project$UI$Button$withRole,
		2,
		A2($author$project$UI$Button$button, $author$project$Compensation$Edit$UserClickedCancelEdit, 'Annuleren')));
var $author$project$Compensation$Edit$UserClickedReturnToOverview = {$: 8};
var $author$project$Compensation$Edit$returnToOverviewButton = $author$project$UI$Button$elementFor(
	A2($author$project$UI$Button$button, $author$project$Compensation$Edit$UserClickedReturnToOverview, 'Naar overzicht'));
var $author$project$Compensation$Edit$confirmationView = F2(
	function (timeZone, compensation) {
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				_List_fromArray(
					[
						A2($author$project$Compensation$Compensation$detailView, timeZone, compensation),
						$author$project$Compensation$Edit$returnToOverviewButton
					]),
				A2(
					$author$project$UI$Container$withWidth,
					$mdgriffith$elm_ui$Element$px(590),
					A2(
						$author$project$UI$Container$withTitle,
						$mdgriffith$elm_ui$Element$text('Vergoeding is aangepast'),
						$author$project$UI$Container$container))));
	});
var $author$project$Compensation$Edit$rejectReasonView = function (compensation) {
	var _v0 = $author$project$Compensation$Compensation$rejectReason(
		$author$project$Compensation$Compensation$logOf(compensation));
	if (_v0.$ === 1) {
		return $mdgriffith$elm_ui$Element$none;
	} else {
		if (_v0.a === '') {
			return $mdgriffith$elm_ui$Element$none;
		} else {
			var reason = _v0.a;
			return $author$project$UI$Container$elementFor(
				A2(
					$author$project$UI$Container$withWidth,
					$mdgriffith$elm_ui$Element$px(590),
					A2(
						$author$project$UI$Container$withContent,
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$paragraph,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$Font$italic,
										$mdgriffith$elm_ui$Element$Border$color(
										$author$project$UI$Element$colorFor($author$project$UI$Palette$magenta)),
										$mdgriffith$elm_ui$Element$Border$widthEach(
										{k5: 0, mE: 3, nx: 0, ol: 0}),
										$mdgriffith$elm_ui$Element$paddingEach(
										{k5: 0, mE: 5, nx: 0, ol: 0})
									]),
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$text(reason)
									]))
							]),
						A2(
							$author$project$UI$Container$withTitle,
							$mdgriffith$elm_ui$Element$text('Afgekeurd omdat'),
							$author$project$UI$Container$container))));
		}
	}
};
var $author$project$Compensation$Edit$UserClickedSubmitCompensation = {$: 6};
var $author$project$Compensation$Edit$submitButton = $author$project$UI$Button$elementFor(
	A2(
		$author$project$UI$Button$withRole,
		0,
		A2($author$project$UI$Button$button, $author$project$Compensation$Edit$UserClickedSubmitCompensation, 'Indienen')));
var $author$project$Compensation$Edit$loadedView = F2(
	function (timeZone, loaded) {
		var originalCompensation = loaded.el;
		var confirmation = loaded.eW;
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$spacing(10)
				]),
			function () {
				if (!confirmation.$) {
					return _List_fromArray(
						[
							$author$project$Compensation$Edit$rejectReasonView(originalCompensation),
							A2(
							$mdgriffith$elm_ui$Element$map,
							$author$project$Compensation$Edit$SystemGotFormMsg,
							A2(
								$author$project$Compensation$Form$view,
								{oi: 'Incidentele vergoeding aanpassen'},
								loaded.bO)),
							A2(
							$mdgriffith$elm_ui$Element$row,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
								]),
							_List_fromArray(
								[
									$author$project$Compensation$Edit$cancelButton,
									A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[$mdgriffith$elm_ui$Element$alignRight]),
									$author$project$Compensation$Edit$submitButton)
								]))
						]);
				} else {
					var compensation = confirmation.a;
					return _List_fromArray(
						[
							A2($author$project$Compensation$Edit$confirmationView, timeZone, compensation)
						]);
				}
			}());
	});
var $author$project$Compensation$Edit$noPlanView = $author$project$UI$Container$elementFor(
	A2(
		$author$project$UI$Container$withContent,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$text('Kies een datum waarop bezorgers zijn ingepland.')
			]),
		A2(
			$author$project$UI$Container$withTitle,
			$mdgriffith$elm_ui$Element$text('Geen plan voor deze datum'),
			$author$project$UI$Container$container)));
var $author$project$Compensation$Edit$view = F2(
	function (share, model) {
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$centerX,
					$mdgriffith$elm_ui$Element$padding(20)
				]),
			function () {
				switch (model.$) {
					case 0:
						return $mdgriffith$elm_ui$Element$none;
					case 1:
						var loaded = model.a;
						return A2(
							$author$project$Compensation$Edit$loadedView,
							$author$project$Portal$Share$timeZone(share),
							loaded);
					case 2:
						return $author$project$Compensation$Edit$noPlanView;
					default:
						return $mdgriffith$elm_ui$Element$none;
				}
			}());
	});
var $author$project$Compensation$Overview$UserClickedCompensationCard = function (a) {
	return {$: 3, a: a};
};
var $author$project$Compensation$Overview$boardColumn = F3(
	function (className, selected, compensations) {
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$alignTop,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
				]),
			A2(
				$mdgriffith$elm_ui$Element$column,
				_Utils_ap(
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$paddingEach(
							{k5: 20, mE: 5, nx: 5, ol: 5}),
							$mdgriffith$elm_ui$Element$spacing(5),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$htmlAttribute(
							$elm$html$Html$Attributes$class('compensation-board-' + className))
						]),
					$author$project$UI$Element$colors(
						{kV: $author$project$UI$Palette$base1, k0: $author$project$UI$Palette$base0, lZ: $author$project$UI$Palette$base03})),
				A2(
					$elm$core$List$map,
					function (c) {
						return A3(
							$author$project$Compensation$Compensation$cardView,
							{mZ: $author$project$Compensation$Overview$UserClickedCompensationCard},
							_Utils_eq(
								$elm$core$Maybe$Just(c),
								selected),
							c);
					},
					compensations)));
	});
var $author$project$Compensation$Overview$approvedColumn = F2(
	function (filtered, selected) {
		return A3(
			$author$project$Compensation$Overview$boardColumn,
			'approved',
			selected,
			$elm$core$List$reverse(
				A2(
					$elm$core$List$sortBy,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Compensation$Compensation$logOf,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Compensation$Compensation$lastLogItem,
							A2($elm_community$maybe_extra$Maybe$Extra$unwrap, 0, $author$project$Compensation$Compensation$chronological))),
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Compensation$Compensation$statusOf,
							$elm$core$Basics$eq(2)),
						filtered.aD))));
	});
var $author$project$UI$Font$heading2 = _List_fromArray(
	[
		$mdgriffith$elm_ui$Element$Font$size(
		$author$project$UI$Font$scaled(4)),
		$mdgriffith$elm_ui$Element$Font$semiBold,
		$author$project$UI$Font$montserrat
	]);
var $author$project$Compensation$Overview$boardHeaderView = A2(
	$mdgriffith$elm_ui$Element$row,
	_Utils_ap(
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$spacing(20),
				$mdgriffith$elm_ui$Element$padding(2)
			]),
		$author$project$UI$Font$heading2),
	A2(
		$elm$core$List$map,
		A2(
			$elm$core$Basics$composeR,
			$mdgriffith$elm_ui$Element$text,
			A2(
				$elm$core$Basics$composeR,
				$mdgriffith$elm_ui$Element$el(
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$centerX])),
				$mdgriffith$elm_ui$Element$el(
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						])))),
		_List_fromArray(
			['Afgekeurd', 'In behandeling', 'Goedgekeurd'])));
var $author$project$Compensation$Overview$inProgressColumn = F2(
	function (filtered, selected) {
		return A3(
			$author$project$Compensation$Overview$boardColumn,
			'in-progress',
			selected,
			A2(
				$elm$core$List$sortBy,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Compensation$Compensation$logOf,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Compensation$Compensation$lastSubmitted,
						A2($elm_community$maybe_extra$Maybe$Extra$unwrap, 0, $author$project$Compensation$Compensation$chronological))),
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Compensation$Compensation$statusOf,
						function (s) {
							return (s !== 2) && (s !== 3);
						}),
					filtered.aD)));
	});
var $author$project$Compensation$Overview$rejectedColumn = F2(
	function (filtered, selected) {
		return A3(
			$author$project$Compensation$Overview$boardColumn,
			'rejected',
			selected,
			A2(
				$elm$core$List$sortBy,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Compensation$Compensation$logOf,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Compensation$Compensation$lastLogItem,
						A2($elm_community$maybe_extra$Maybe$Extra$unwrap, 0, $author$project$Compensation$Compensation$chronological))),
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Compensation$Compensation$statusOf,
						$elm$core$Basics$eq(3)),
					filtered.aD)));
	});
var $author$project$Compensation$Overview$boardView = F3(
	function (filtered, selected, window) {
		var heightWithoutHeader = window.iK - 47;
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$htmlAttribute(
					$elm$html$Html$Attributes$class('compensation-board')),
					$mdgriffith$elm_ui$Element$alignTop
				]),
			_List_fromArray(
				[
					$author$project$Compensation$Overview$boardHeaderView,
					A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$spacing(20),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$height(
							$mdgriffith$elm_ui$Element$px(heightWithoutHeader)),
							$mdgriffith$elm_ui$Element$scrollbarY
						]),
					_List_fromArray(
						[
							A2($author$project$Compensation$Overview$rejectedColumn, filtered, selected),
							A2($author$project$Compensation$Overview$inProgressColumn, filtered, selected),
							A2($author$project$Compensation$Overview$approvedColumn, filtered, selected)
						]))
				]));
	});
var $author$project$Compensation$Overview$UserChangedTextFilter = function (a) {
	return {$: 4, a: a};
};
var $author$project$Compensation$Overview$UserSelectedAddCompensation = {$: 1};
var $author$project$Compensation$Overview$buttonAddCompensation = $author$project$UI$Button$elementFor(
	A2(
		$author$project$UI$Button$withIcon,
		$icidasset$elm_material_icons$Material$Icons$add,
		A2(
			$author$project$UI$Button$withRole,
			0,
			A2($author$project$UI$Button$button, $author$project$Compensation$Overview$UserSelectedAddCompensation, 'Toevoegen'))));
var $author$project$Compensation$Overview$UserSelectedGoToApproveCompensations = {$: 2};
var $author$project$Compensation$Overview$buttonValidateCompensation = $author$project$UI$Button$elementFor(
	A2(
		$author$project$UI$Button$withIcon,
		$icidasset$elm_material_icons$Material$Icons$verified,
		A2(
			$author$project$UI$Button$withRole,
			0,
			A2($author$project$UI$Button$button, $author$project$Compensation$Overview$UserSelectedGoToApproveCompensations, 'Vergoedingen Goedkeuren'))));
var $author$project$Compensation$Overview$buttonsView = F2(
	function (security, filtered) {
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$spacing(20)
				]),
			_List_fromArray(
				[
					$author$project$UI$Search$elementFor(
					A3(
						$author$project$UI$Search$text,
						filtered.g2,
						$author$project$Compensation$Overview$UserChangedTextFilter,
						$mdgriffith$elm_ui$Element$Input$labelHidden('Zoek naar een incidentele vergoeding'))),
					$author$project$UI$Separator$vertical,
					$author$project$Compensation$Overview$buttonAddCompensation,
					(A2($author$project$Security$Security$can, $author$project$Security$Security$ValidateCompensations, security) || A2($author$project$Security$Security$can, $author$project$Security$Security$ApproveCompensations, security)) ? $author$project$Compensation$Overview$buttonValidateCompensation : $mdgriffith$elm_ui$Element$none
				]));
	});
var $author$project$Compensation$Overview$UserCanceledDelete = {$: 9};
var $author$project$Compensation$Overview$buttonCancelDelete = $author$project$UI$Button$elementFor(
	A2(
		$author$project$UI$Button$withRole,
		2,
		A2($author$project$UI$Button$button, $author$project$Compensation$Overview$UserCanceledDelete, 'Annuleren')));
var $author$project$Compensation$Overview$UserConfirmedDelete = {$: 8};
var $author$project$Compensation$Overview$buttonConfirmDelete = $author$project$UI$Button$elementFor(
	A2(
		$author$project$UI$Button$withIcon,
		$icidasset$elm_material_icons$Material$Icons$delete,
		A2(
			$author$project$UI$Button$withRole,
			1,
			A2($author$project$UI$Button$button, $author$project$Compensation$Overview$UserConfirmedDelete, 'Bevestigen'))));
var $author$project$Compensation$Overview$deleteView = _List_fromArray(
	[
		A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$spacing(10)
			]),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$paragraph,
				_List_Nil,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$text('Weet je zeker dat je deze vergoeding wil verwijderen?')
					])),
				A2(
				$mdgriffith$elm_ui$Element$row,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$spacing(20)
					]),
				_List_fromArray(
					[
						$author$project$Compensation$Overview$buttonCancelDelete,
						A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[$mdgriffith$elm_ui$Element$alignRight]),
						$author$project$Compensation$Overview$buttonConfirmDelete)
					]))
			]))
	]);
var $author$project$Compensation$Overview$UserClickedApproveOwnButton = {$: 5};
var $author$project$Compensation$Overview$buttonApprove = $author$project$UI$Button$elementFor(
	A2(
		$author$project$UI$Button$withRole,
		0,
		A2(
			$author$project$UI$Button$withIcon,
			$icidasset$elm_material_icons$Material$Icons$edit,
			A2($author$project$UI$Button$button, $author$project$Compensation$Overview$UserClickedApproveOwnButton, 'Goedkeuren'))));
var $author$project$Compensation$Overview$UserClickedDeleteButton = {$: 7};
var $author$project$Compensation$Overview$buttonDelete = $author$project$UI$Button$elementFor(
	A2(
		$author$project$UI$Button$withIcon,
		$icidasset$elm_material_icons$Material$Icons$delete,
		A2(
			$author$project$UI$Button$withRole,
			1,
			A2($author$project$UI$Button$button, $author$project$Compensation$Overview$UserClickedDeleteButton, 'Verwijderen'))));
var $author$project$Compensation$Overview$UserClickedEditButton = {$: 6};
var $author$project$Compensation$Overview$buttonEdit = $author$project$UI$Button$elementFor(
	A2(
		$author$project$UI$Button$withRole,
		0,
		A2(
			$author$project$UI$Button$withIcon,
			$icidasset$elm_material_icons$Material$Icons$edit,
			A2($author$project$UI$Button$button, $author$project$Compensation$Overview$UserClickedEditButton, 'Aanpassen'))));
var $author$project$Compensation$Compensation$regionNumberOf = function (compensation) {
	return $author$project$Compensation$Compensation$distributionPointOf(compensation).nq.bX;
};
var $author$project$Compensation$Compensation$canApproveOwn = function (compensation) {
	return (!$author$project$Compensation$Compensation$statusOf(compensation)) && (_Utils_cmp(
		$author$project$Compensation$Compensation$regionNumberOf(compensation),
		$author$project$DistributionPoint$DistributionPoint$regionNumberMinimumForEntrepreneurs) > -1);
};
var $author$project$Compensation$Compensation$canDelete = function (compensation) {
	return $author$project$Compensation$Compensation$statusOf(compensation) !== 2;
};
var $author$project$Compensation$Compensation$canEdit = function (compensation) {
	return $author$project$Compensation$Compensation$statusOf(compensation) === 3;
};
var $author$project$Compensation$Overview$selectedButtonsView = function (compensation) {
	return A2(
		$mdgriffith$elm_ui$Element$row,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$spacing(20)
			]),
		_List_fromArray(
			[
				$author$project$Compensation$Compensation$canDelete(compensation) ? $author$project$Compensation$Overview$buttonDelete : $mdgriffith$elm_ui$Element$none,
				$author$project$Compensation$Compensation$canApproveOwn(compensation) ? $author$project$Compensation$Overview$buttonApprove : $mdgriffith$elm_ui$Element$none,
				$author$project$Compensation$Compensation$canEdit(compensation) ? A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[$mdgriffith$elm_ui$Element$alignRight]),
				$author$project$Compensation$Overview$buttonEdit) : $mdgriffith$elm_ui$Element$none
			]));
};
var $author$project$Compensation$Overview$selectedView = F2(
	function (timeZone, _v0) {
		var compensation = _v0.ao;
		var deleteState = _v0.d0;
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$spacing(20),
					$mdgriffith$elm_ui$Element$alignTop,
					$mdgriffith$elm_ui$Element$paddingEach(
					{k5: 0, mE: 0, nx: 0, ol: 37})
				]),
			A2(
				$elm$core$List$cons,
				A2($author$project$Compensation$Compensation$detailView, timeZone, compensation),
				function () {
					if (!deleteState) {
						return _List_fromArray(
							[
								$author$project$Compensation$Overview$selectedButtonsView(compensation)
							]);
					} else {
						return $author$project$Compensation$Overview$deleteView;
					}
				}()));
	});
var $author$project$Compensation$Overview$loadedView = F3(
	function (share, window, _v0) {
		var filtered = _v0.eb;
		var selected = _v0.nI;
		return $author$project$UI$Columns$elementFor(
			A3(
				$author$project$UI$Columns$withMaybeColumn,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Basics$always,
					$author$project$Compensation$Overview$selectedView(
						$author$project$Portal$Share$timeZone(share))),
				selected,
				A2(
					$author$project$UI$Columns$withColumn,
					A2(
						$author$project$Compensation$Overview$boardView,
						filtered,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.ao;
							},
							selected)),
					A3(
						$author$project$UI$Columns$withHeader,
						$author$project$UI$Search$height,
						A2(
							$author$project$Compensation$Overview$buttonsView,
							$author$project$Portal$Share$security(share),
							filtered),
						$author$project$UI$Columns$columns(window)))));
	});
var $author$project$Compensation$Overview$view = F2(
	function (share, model) {
		switch (model.$) {
			case 0:
				return $mdgriffith$elm_ui$Element$none;
			case 1:
				var loaded = model.a;
				return A3(
					$author$project$Compensation$Overview$loadedView,
					share,
					$author$project$Portal$Page$contentWindow(share),
					loaded);
			default:
				return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$Complaint$Feedback$UserToggledCodeFilter = {$: 3};
var $author$project$Complaint$Feedback$UserChangedFeedbackComment = function (a) {
	return {$: 7, a: a};
};
var $author$project$Complaint$Feedback$UserClickedSendFeedback = {$: 8};
var $author$project$Complaint$Feedback$UserSelectedFeedbackCode = function (a) {
	return {$: 6, a: a};
};
var $author$project$Complaint$Feedback$UserToggledSelectAll = function (a) {
	return {$: 10, a: a};
};
var $author$project$Complaint$Feedback$selected = function (s) {
	if (!s.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Complaint$Feedback$allSelected = function (selection) {
	return _Utils_eq(
		$elm$core$List$length(selection),
		$elm$core$List$length(
			A2($elm$core$List$filter, $author$project$Complaint$Feedback$selected, selection)));
};
var $author$project$Complaint$Feedback$NoOp = {$: 13};
var $author$project$Complaint$Feedback$UserClickedComplaint = function (a) {
	return {$: 12, a: a};
};
var $author$project$Complaint$Feedback$UserToggledComplaint = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Complaint$Complaint$codeToString = function (code) {
	switch (code) {
		case 0:
			return 'OVERIG/BESCHADIGD';
		case 1:
			return 'OVERIG/STEEKTUIT';
		case 2:
			return 'BEZORGER/OVERIG';
		case 3:
			return 'BEZORGER/GEDRAG';
		case 4:
			return 'NIET/BIJLAGE';
		case 5:
			return 'OVERIG/HUISBUS';
		case 6:
			return 'VERKEERD/VERKEERD';
		case 7:
			return 'NIET/KRANT';
		case 8:
			return 'LAAT/VERTRAGING';
		default:
			return 'LAAT/LAAT';
	}
};
var $author$project$Complaint$Complaint$authorToString = function (author) {
	switch (author) {
		case 'customer':
			return 'klant';
		case 'distribution':
			return 'distributie';
		default:
			return author;
	}
};
var $author$project$Complaint$Feedback$commentView = function (comment) {
	return A2(
		$mdgriffith$elm_ui$Element$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$el,
				_List_Nil,
				$mdgriffith$elm_ui$Element$text(
					'Opmerking (' + ($author$project$Complaint$Complaint$authorToString(comment.kU) + '): '))),
				A3(
				$elm$core$Basics$composeR,
				$mdgriffith$elm_ui$Element$text,
				$mdgriffith$elm_ui$Element$el(_List_Nil),
				comment.aA)
			]));
};
var $author$project$Complaint$Complaint$feedbackCodeToString = function (feedbackCode) {
	switch (feedbackCode) {
		case 1:
			return _Utils_Tuple2('Adres niet bereikbaar', 'Adres van abonnee is niet bereikbaar (vb weg is onbegaanbaar door sneeuw of verbouwingen)');
		case 2:
			return _Utils_Tuple2('Bezorger is vertraagd', 'Bezorger is vertraagd door lopen van meerdere wijken');
		case 3:
			return _Utils_Tuple2('Bezorglocatie onduidelijk', 'Afleveradres is onduidelijk');
		case 4:
			return _Utils_Tuple2('Diefstal krant', 'Krant wordt afgeleverd en lijkt gestolen te worden');
		case 5:
			return _Utils_Tuple2('Intern klant locatie', 'Probleem onstaat (vaak in kantoor gebouw) nadat bezorger kranten heeft afgeleverd');
		case 6:
			return _Utils_Tuple2('Invaller', 'Er loopt vervangende bezorger die bezorgwijk nog niet goed genoeg kent');
		case 7:
			return _Utils_Tuple2('Mutatie gemist', 'Bezorger heeft mutatie gemist waardoor krant niet (goed) bezorgd wordt');
		case 8:
			return _Utils_Tuple2('Nieuwbouw', 'Nieuwbouw wijken waarbij locatie onduidelijk is');
		case 9:
			return _Utils_Tuple2('Nieuwe bezorger', 'Net nieuw gestarte bezorger');
		case 10:
			return _Utils_Tuple2('Onveilige afleversituatie', 'Kranten kunnen op dit adres niet veilig bezorgd worden');
		case 11:
			return _Utils_Tuple2('Geen bezorger beschikbaar', 'Op dit adres is (tijdelijk) geen bezorger beschikbaar');
		case 12:
			return _Utils_Tuple2('Weersomstandigheden', 'Door weersomstandigheden (zoals ijzel) hebben we tijdelijk niet goed kunnen bezorgen');
		default:
			return _Utils_Tuple2('', '');
	}
};
var $mdgriffith$elm_ui$Internal$Model$Padding = F5(
	function (a, b, c, d, e) {
		return {$: 0, a: a, b: b, c: c, d: d, e: e};
	});
var $mdgriffith$elm_ui$Internal$Model$Spaced = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $mdgriffith$elm_ui$Internal$Model$extractSpacingAndPadding = function (attrs) {
	return A3(
		$elm$core$List$foldr,
		F2(
			function (attr, _v0) {
				var pad = _v0.a;
				var spacing = _v0.b;
				return _Utils_Tuple2(
					function () {
						if (!pad.$) {
							var x = pad.a;
							return pad;
						} else {
							if ((attr.$ === 4) && (attr.b.$ === 7)) {
								var _v3 = attr.b;
								var name = _v3.a;
								var t = _v3.b;
								var r = _v3.c;
								var b = _v3.d;
								var l = _v3.e;
								return $elm$core$Maybe$Just(
									A5($mdgriffith$elm_ui$Internal$Model$Padding, name, t, r, b, l));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}
					}(),
					function () {
						if (!spacing.$) {
							var x = spacing.a;
							return spacing;
						} else {
							if ((attr.$ === 4) && (attr.b.$ === 5)) {
								var _v6 = attr.b;
								var name = _v6.a;
								var x = _v6.b;
								var y = _v6.c;
								return $elm$core$Maybe$Just(
									A3($mdgriffith$elm_ui$Internal$Model$Spaced, name, x, y));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}
					}());
			}),
		_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
		attrs);
};
var $mdgriffith$elm_ui$Element$wrappedRow = F2(
	function (attrs, children) {
		var _v0 = $mdgriffith$elm_ui$Internal$Model$extractSpacingAndPadding(attrs);
		var padded = _v0.a;
		var spaced = _v0.b;
		if (spaced.$ === 1) {
			return A4(
				$mdgriffith$elm_ui$Internal$Model$element,
				$mdgriffith$elm_ui$Internal$Model$asRow,
				$mdgriffith$elm_ui$Internal$Model$div,
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.dZ + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.bI + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.hL)))),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
							attrs))),
				$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
		} else {
			var _v2 = spaced.a;
			var spaceName = _v2.a;
			var x = _v2.b;
			var y = _v2.c;
			var newPadding = function () {
				if (!padded.$) {
					var _v5 = padded.a;
					var name = _v5.a;
					var t = _v5.b;
					var r = _v5.c;
					var b = _v5.d;
					var l = _v5.e;
					if ((_Utils_cmp(r, x / 2) > -1) && (_Utils_cmp(b, y / 2) > -1)) {
						var newTop = t - (y / 2);
						var newRight = r - (x / 2);
						var newLeft = l - (x / 2);
						var newBottom = b - (y / 2);
						return $elm$core$Maybe$Just(
							A2(
								$mdgriffith$elm_ui$Internal$Model$StyleClass,
								$mdgriffith$elm_ui$Internal$Flag$padding,
								A5(
									$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
									A4($mdgriffith$elm_ui$Internal$Model$paddingNameFloat, newTop, newRight, newBottom, newLeft),
									newTop,
									newRight,
									newBottom,
									newLeft)));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}();
			if (!newPadding.$) {
				var pad = newPadding.a;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$element,
					$mdgriffith$elm_ui$Internal$Model$asRow,
					$mdgriffith$elm_ui$Internal$Model$div,
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.dZ + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.bI + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.hL)))),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
								_Utils_ap(
									attrs,
									_List_fromArray(
										[pad]))))),
					$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
			} else {
				var halfY = -(y / 2);
				var halfX = -(x / 2);
				return A4(
					$mdgriffith$elm_ui$Internal$Model$element,
					$mdgriffith$elm_ui$Internal$Model$asEl,
					$mdgriffith$elm_ui$Internal$Model$div,
					attrs,
					$mdgriffith$elm_ui$Internal$Model$Unkeyed(
						_List_fromArray(
							[
								A4(
								$mdgriffith$elm_ui$Internal$Model$element,
								$mdgriffith$elm_ui$Internal$Model$asRow,
								$mdgriffith$elm_ui$Internal$Model$div,
								A2(
									$elm$core$List$cons,
									$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.dZ + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.bI + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.hL)))),
									A2(
										$elm$core$List$cons,
										$mdgriffith$elm_ui$Internal$Model$Attr(
											A2(
												$elm$html$Html$Attributes$style,
												'margin',
												$elm$core$String$fromFloat(halfY) + ('px' + (' ' + ($elm$core$String$fromFloat(halfX) + 'px'))))),
										A2(
											$elm$core$List$cons,
											$mdgriffith$elm_ui$Internal$Model$Attr(
												A2(
													$elm$html$Html$Attributes$style,
													'width',
													'calc(100% + ' + ($elm$core$String$fromInt(x) + 'px)'))),
											A2(
												$elm$core$List$cons,
												$mdgriffith$elm_ui$Internal$Model$Attr(
													A2(
														$elm$html$Html$Attributes$style,
														'height',
														'calc(100% + ' + ($elm$core$String$fromInt(y) + 'px)'))),
												A2(
													$elm$core$List$cons,
													A2(
														$mdgriffith$elm_ui$Internal$Model$StyleClass,
														$mdgriffith$elm_ui$Internal$Flag$spacing,
														A3($mdgriffith$elm_ui$Internal$Model$SpacingStyle, spaceName, x, y)),
													_List_Nil))))),
								$mdgriffith$elm_ui$Internal$Model$Unkeyed(children))
							])));
			}
		}
	});
var $author$project$Complaint$Feedback$complaintView = F2(
	function (unfolded, s) {
		var expandContainerView = function (items) {
			return A2(
				$mdgriffith$elm_ui$Element$column,
				_Utils_ap(
					$author$project$UI$Font$body,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$padding(3),
							$mdgriffith$elm_ui$Element$Border$widthEach(
							{k5: 1, mE: 1, nx: 1, ol: 0}),
							$mdgriffith$elm_ui$Element$Border$color(
							$author$project$UI$Element$colorFor($author$project$UI$Palette$base0)),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						])),
				items);
		};
		var complaint = $author$project$Complaint$Feedback$complaintOf(s);
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Border$width(1),
							$mdgriffith$elm_ui$Element$Border$color(
							$author$project$UI$Element$colorFor($author$project$UI$Palette$base0)),
							$mdgriffith$elm_ui$Element$padding(1),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$Events$onClick(
							$author$project$Complaint$Feedback$UserClickedComplaint(complaint))
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$htmlAttribute(
									A2(
										$elm$html$Html$Events$stopPropagationOn,
										'click',
										$elm$json$Json$Decode$succeed(
											_Utils_Tuple2($author$project$Complaint$Feedback$NoOp, true))))
								]),
							A2(
								$mdgriffith$elm_ui$Element$Input$checkbox,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width(
										$mdgriffith$elm_ui$Element$px(20))
									]),
								{
									lc: function () {
										if (!s.$) {
											return true;
										} else {
											return false;
										}
									}(),
									mg: $mdgriffith$elm_ui$Element$Input$defaultCheckbox,
									mD: $mdgriffith$elm_ui$Element$Input$labelHidden(''),
									mY: $author$project$Complaint$Feedback$UserToggledComplaint(complaint)
								})),
							A2(
							$mdgriffith$elm_ui$Element$wrappedRow,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$spacing(5),
									$mdgriffith$elm_ui$Element$width(
									$mdgriffith$elm_ui$Element$fillPortion(3))
								]),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$paragraph,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$width(
											$mdgriffith$elm_ui$Element$px(350))
										]),
									_List_fromArray(
										[
											A3(
											$elm$core$Basics$composeR,
											function ($) {
												return $.i7;
											},
											A2($elm$core$Basics$composeR, $author$project$UI$Paradise$nameAndIdView, $mdgriffith$elm_ui$Element$text),
											complaint)
										])),
									A2(
									$mdgriffith$elm_ui$Element$paragraph,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$width(
											$mdgriffith$elm_ui$Element$px(400))
										]),
									_List_fromArray(
										[
											A3(
											$elm$core$Basics$composeR,
											function ($) {
												return $.fO;
											},
											A2($elm$core$Basics$composeR, $author$project$UI$Paradise$nameAndIdView, $mdgriffith$elm_ui$Element$text),
											complaint)
										]))
								])),
							A2(
							$mdgriffith$elm_ui$Element$wrappedRow,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$spacing(5),
									$mdgriffith$elm_ui$Element$width(
									$mdgriffith$elm_ui$Element$fillPortion(1))
								]),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$row,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$spacing(5),
											$mdgriffith$elm_ui$Element$width(
											$mdgriffith$elm_ui$Element$px(150))
										]),
									_List_fromArray(
										[
											A3(
											$elm$core$Basics$composeR,
											function ($) {
												return $.m8;
											},
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.f1;
												},
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.cT;
													},
													$mdgriffith$elm_ui$Element$text)),
											complaint),
											$mdgriffith$elm_ui$Element$text(' - '),
											A3(
											$elm$core$Basics$composeR,
											function ($) {
												return $.m8;
											},
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.f1;
												},
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.bs;
													},
													A2($elm$core$Basics$composeR, $author$project$Address$Address$houseNumberView, $mdgriffith$elm_ui$Element$text))),
											complaint)
										])),
									A2(
									$mdgriffith$elm_ui$Element$paragraph,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$width(
											$mdgriffith$elm_ui$Element$px(150))
										]),
									_List_fromArray(
										[
											A3(
											$elm$core$Basics$composeR,
											function ($) {
												return $.m8;
											},
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.f1;
												},
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.bU;
													},
													$mdgriffith$elm_ui$Element$text)),
											complaint)
										]))
								])),
							A2(
							$mdgriffith$elm_ui$Element$row,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width(
									$mdgriffith$elm_ui$Element$fillPortion(1))
								]),
							_List_fromArray(
								[
									A3(
									$elm$core$Basics$composeR,
									function ($) {
										return $.ge;
									},
									A2(
										$elm$core$Basics$composeR,
										$author$project$Complaint$Complaint$codeToString,
										A2(
											$elm$core$Basics$composeR,
											$mdgriffith$elm_ui$Element$text,
											$mdgriffith$elm_ui$Element$el(
												_List_fromArray(
													[
														$mdgriffith$elm_ui$Element$width(
														$mdgriffith$elm_ui$Element$px(200))
													])))),
									complaint)
								]))
						])),
					function () {
					var _v1 = _Utils_Tuple2(
						_Utils_eq(
							unfolded,
							$elm$core$Maybe$Just(complaint)),
						complaint.lW);
					if (!_v1.a) {
						return $mdgriffith$elm_ui$Element$none;
					} else {
						if (!_v1.b) {
							var _v2 = _v1.b;
							return expandContainerView(
								A2($elm$core$List$map, $author$project$Complaint$Feedback$commentView, complaint.ln));
						} else {
							return expandContainerView(
								A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Element$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$mdgriffith$elm_ui$Element$el,
												_List_Nil,
												$mdgriffith$elm_ui$Element$text('Feedback: ')),
												A3(
												$elm$core$Basics$composeR,
												function ($) {
													return $.lW;
												},
												A2(
													$elm$core$Basics$composeR,
													$author$project$Complaint$Complaint$feedbackCodeToString,
													A2(
														$elm$core$Basics$composeR,
														$elm$core$Tuple$first,
														A2(
															$elm$core$Basics$composeR,
															$mdgriffith$elm_ui$Element$text,
															$mdgriffith$elm_ui$Element$el(_List_Nil)))),
												complaint)
											])),
									A2($elm$core$List$map, $author$project$Complaint$Feedback$commentView, complaint.ln)));
						}
					}
				}()
				]));
	});
var $author$project$UI$Button$disabled = F2(
	function (reason, _v0) {
		var b = _v0;
		return _Utils_update(
			b,
			{
				gX: $author$project$UI$Button$Disabled(reason)
			});
	});
var $author$project$Complaint$Complaint$feedbackCodes = _List_fromArray(
	[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);
var $author$project$Complaint$Feedback$feedbackFormErrorView = function (error) {
	if (error === 1) {
		return A2(
			$mdgriffith$elm_ui$Element$paragraph,
			_List_Nil,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$text('Er zijn geen klachten geselecteerd')
				]));
	} else {
		return A2(
			$mdgriffith$elm_ui$Element$paragraph,
			_List_Nil,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$text('Er is geen terugkoppeling opgegeven')
				]));
	}
};
var $author$project$Complaint$Feedback$feedbackFormErrorsView = function (errors) {
	if (!errors.b) {
		return $mdgriffith$elm_ui$Element$none;
	} else {
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				A2($elm$core$List$map, $author$project$Complaint$Feedback$feedbackFormErrorView, errors),
				A2($author$project$UI$Container$withVariant, 2, $author$project$UI$Container$container)));
	}
};
var $author$project$Complaint$Feedback$noComplaintsFoundView = $author$project$UI$Container$elementFor(
	A2(
		$author$project$UI$Container$withContent,
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$paragraph,
				_List_Nil,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$text('Geen klachten gevonden of geselecteerd.')
					]))
			]),
		$author$project$UI$Container$container));
var $author$project$UI$Input$radio = function (options) {
	return A2(
		$mdgriffith$elm_ui$Element$Input$radio,
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Element$paddingXY, 0, 5),
				A2($mdgriffith$elm_ui$Element$spacingXY, 0, 10),
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
			]),
		options);
};
var $icidasset$elm_material_icons$Material$Icons$sync = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z')
				]),
			_List_Nil)
		]));
var $author$project$Complaint$Complaint$toComparable = function (complaint) {
	return A2(
		$elm$core$String$join,
		'',
		_List_fromArray(
			[
				complaint.i7.ft,
				complaint.fO.ft,
				$author$project$Complaint$Complaint$codeToString(complaint.ge)
			]));
};
var $author$project$Complaint$Feedback$feedbackFormView = F4(
	function (share, unfolded, feedback, window) {
		var withWaiting = function (button) {
			return A3(
				$author$project$Portal$Waiting$map,
				button,
				$elm$core$Basics$always(
					A2($author$project$UI$Button$withIcon, $icidasset$elm_material_icons$Material$Icons$sync, button)),
				$author$project$Portal$Share$waitingStatus(share));
		};
		var heading = function (label) {
			return A2(
				$mdgriffith$elm_ui$Element$el,
				$author$project$UI$Font$heading3,
				$mdgriffith$elm_ui$Element$text(label));
		};
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			_List_fromArray(
				[
					function () {
					var _v0 = feedback.m;
					if (!_v0.b) {
						return A2(
							$mdgriffith$elm_ui$Element$column,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$alignTop,
									$mdgriffith$elm_ui$Element$alignLeft,
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									$mdgriffith$elm_ui$Element$height(
									$mdgriffith$elm_ui$Element$px(window.iK)),
									$author$project$UI$Spacing$default,
									$mdgriffith$elm_ui$Element$scrollbarY
								]),
							_List_fromArray(
								[$author$project$Complaint$Feedback$noComplaintsFoundView]));
					} else {
						return A2(
							$mdgriffith$elm_ui$Element$column,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$alignTop,
									$mdgriffith$elm_ui$Element$alignLeft,
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									$mdgriffith$elm_ui$Element$height(
									$mdgriffith$elm_ui$Element$px(window.iK)),
									$author$project$UI$Spacing$default,
									$mdgriffith$elm_ui$Element$scrollbarY
								]),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$row,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$Border$widthEach(
											{k5: 1, mE: 0, nx: 0, ol: 0}),
											$mdgriffith$elm_ui$Element$padding(1),
											$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
										]),
									_List_fromArray(
										[
											A2(
											$mdgriffith$elm_ui$Element$Input$checkbox,
											_List_fromArray(
												[
													$mdgriffith$elm_ui$Element$width(
													$mdgriffith$elm_ui$Element$px(20))
												]),
											{
												lc: $author$project$Complaint$Feedback$allSelected(feedback.m),
												mg: $mdgriffith$elm_ui$Element$Input$defaultCheckbox,
												mD: $mdgriffith$elm_ui$Element$Input$labelHidden(''),
												mY: $author$project$Complaint$Feedback$UserToggledSelectAll
											}),
											A2(
											$mdgriffith$elm_ui$Element$column,
											_List_fromArray(
												[
													$mdgriffith$elm_ui$Element$width(
													$mdgriffith$elm_ui$Element$fillPortion(3))
												]),
											_List_fromArray(
												[
													A2(
													$mdgriffith$elm_ui$Element$el,
													_List_fromArray(
														[
															$mdgriffith$elm_ui$Element$width(
															$mdgriffith$elm_ui$Element$px(400))
														]),
													heading('Kavel / Segment'))
												])),
											A2(
											$mdgriffith$elm_ui$Element$column,
											_List_fromArray(
												[
													$mdgriffith$elm_ui$Element$width(
													$mdgriffith$elm_ui$Element$fillPortion(1))
												]),
											_List_fromArray(
												[
													A2(
													$mdgriffith$elm_ui$Element$el,
													_List_fromArray(
														[
															$mdgriffith$elm_ui$Element$width(
															$mdgriffith$elm_ui$Element$px(150))
														]),
													heading('Abonnee'))
												])),
											A2(
											$mdgriffith$elm_ui$Element$column,
											_List_fromArray(
												[
													$mdgriffith$elm_ui$Element$width(
													$mdgriffith$elm_ui$Element$fillPortion(1))
												]),
											_List_fromArray(
												[
													A2(
													$mdgriffith$elm_ui$Element$el,
													_List_fromArray(
														[
															$mdgriffith$elm_ui$Element$width(
															$mdgriffith$elm_ui$Element$px(200))
														]),
													heading('Klachtsleutel'))
												]))
										])),
									A2(
									$mdgriffith$elm_ui$Element$column,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$spacing(4),
											$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
										]),
									A2(
										$elm$core$List$map,
										$author$project$Complaint$Feedback$complaintView(unfolded),
										A2(
											$elm$core$List$sortBy,
											A2($elm$core$Basics$composeR, $author$project$Complaint$Feedback$complaintOf, $author$project$Complaint$Complaint$toComparable),
											feedback.m)))
								]));
					}
				}(),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$alignTop,
							$mdgriffith$elm_ui$Element$alignLeft,
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$px(390)),
							$mdgriffith$elm_ui$Element$height(
							$mdgriffith$elm_ui$Element$px(window.iK)),
							$mdgriffith$elm_ui$Element$scrollbarY,
							$mdgriffith$elm_ui$Element$padding(1),
							$mdgriffith$elm_ui$Element$spacing(20)
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$el,
							$author$project$UI$Font$heading3,
							$mdgriffith$elm_ui$Element$text('Terugkoppeling voor geselecteerde klachten')),
							$author$project$Complaint$Feedback$feedbackFormErrorsView(feedback.f_),
							$author$project$UI$Input$radio(
							{
								mD: $author$project$UI$Input$label(''),
								mY: $author$project$Complaint$Feedback$UserSelectedFeedbackCode,
								m7: A2(
									$elm$core$List$map,
									function (c) {
										return A2(
											$mdgriffith$elm_ui$Element$Input$option,
											c,
											A3(
												$elm$core$Basics$composeR,
												$author$project$Complaint$Complaint$feedbackCodeToString,
												A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $mdgriffith$elm_ui$Element$text),
												c));
									},
									$author$project$Complaint$Complaint$feedbackCodes),
								nI: feedback.lW
							}),
							function () {
							var _v1 = feedback.lW;
							if (!_v1.$) {
								return A2(
									$mdgriffith$elm_ui$Element$Input$text,
									_List_Nil,
									{
										mD: $author$project$UI$Input$label('Toelichting'),
										mY: $author$project$Complaint$Feedback$UserChangedFeedbackComment,
										ng: $elm$core$Maybe$Nothing,
										n3: feedback.gg
									});
							} else {
								return $mdgriffith$elm_ui$Element$none;
							}
						}(),
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
								]),
							$author$project$UI$Button$elementFor(
								withWaiting(
									function () {
										var _v2 = _Utils_Tuple2(
											feedback.lW,
											A2($elm$core$List$filter, $author$project$Complaint$Feedback$selected, feedback.m));
										if ((!_v2.a.$) && _v2.b.b) {
											var _v3 = _v2.b;
											return $elm$core$Basics$identity;
										} else {
											return $author$project$UI$Button$disabled('Selecteer een code');
										}
									}()(
										A2(
											$author$project$UI$Button$withRole,
											0,
											A2($author$project$UI$Button$button, $author$project$Complaint$Feedback$UserClickedSendFeedback, 'Terugkoppeling versturen'))))))
						]))
				]));
	});
var $author$project$Complaint$Feedback$lotsOf = F2(
	function (search, complaints) {
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var lot = _v0.a;
				var lots = _v0.b;
				return _Utils_Tuple2(
					lot,
					$elm$core$List$length(lots) + 1);
			},
			A2(
				$elm_community$list_extra$List$Extra$groupWhile,
				$elm$core$Basics$eq,
				A2(
					$elm$core$List$sortBy,
					function ($) {
						return $.ft;
					},
					A2(
						$elm$core$List$map,
						function ($) {
							return $.i7;
						},
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.lW;
								},
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Basics$eq(0),
									$elm$core$Basics$neq(search.bN))),
							complaints)))));
	});
var $author$project$Complaint$Feedback$UserClickedLot = function (a) {
	return {$: 2, a: a};
};
var $author$project$Complaint$Feedback$lotSelected = F2(
	function (search, lot) {
		return A2($elm$core$List$member, lot, search.aN);
	});
var $author$project$Complaint$Feedback$lotFilterView = F2(
	function (search, _v0) {
		var lot = _v0.a;
		var amount = _v0.b;
		return $author$project$UI$Card$elementFor(
			A2(
				$author$project$UI$Card$selectedIf,
				A2($author$project$Complaint$Feedback$lotSelected, search, lot),
				A2(
					$author$project$UI$Card$withContent,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$paragraph,
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Element$width(
									$mdgriffith$elm_ui$Element$px(220)),
								$author$project$UI$Font$bodyLarge),
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text(
									lot.ft + (' (' + ($elm$core$String$fromInt(amount) + ')')))
								]))
						]),
					$author$project$UI$Card$card(
						$author$project$Complaint$Feedback$UserClickedLot(lot)))));
	});
var $author$project$Complaint$Feedback$lotsView = F3(
	function (search, lots, window) {
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$author$project$UI$Spacing$default,
					$mdgriffith$elm_ui$Element$alignTop,
					$mdgriffith$elm_ui$Element$alignLeft,
					$mdgriffith$elm_ui$Element$scrollbarY,
					$mdgriffith$elm_ui$Element$width(
					$mdgriffith$elm_ui$Element$px(250)),
					$mdgriffith$elm_ui$Element$height(
					$mdgriffith$elm_ui$Element$px(window.iK))
				]),
			A3(
				$author$project$UI$Card$column,
				{
					iK: $mdgriffith$elm_ui$Element$px(window.iK),
					oy: $mdgriffith$elm_ui$Element$px(250)
				},
				$author$project$Complaint$Feedback$lotFilterView(search),
				lots));
	});
var $author$project$Complaint$Feedback$UserChangedFeedbackGivenFilter = function (a) {
	return {$: 5, a: a};
};
var $author$project$Complaint$Feedback$UserClickedCode = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Complaint$Feedback$codeFilterView = F2(
	function (codes, _v0) {
		var code = _v0.a;
		var amount = _v0.b;
		return A2(
			$mdgriffith$elm_ui$Element$Input$checkbox,
			_List_Nil,
			{
				lc: A2($elm$core$List$member, code, codes),
				mg: $mdgriffith$elm_ui$Element$Input$defaultCheckbox,
				mD: A2(
					$mdgriffith$elm_ui$Element$Input$labelRight,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					A2(
						$elm$core$Basics$composeR,
						$author$project$Complaint$Complaint$codeToString,
						A2(
							$elm$core$Basics$composeR,
							function (c) {
								return c + (' (' + ($elm$core$String$fromInt(amount) + ')'));
							},
							$mdgriffith$elm_ui$Element$text))(code)),
				mY: $author$project$Complaint$Feedback$UserClickedCode(code)
			});
	});
var $author$project$Complaint$Feedback$codesOf = F2(
	function (search, complaints) {
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var code = _v0.a;
				var codes = _v0.b;
				return _Utils_Tuple2(
					code,
					$elm$core$List$length(codes) + 1);
			},
			A2(
				$elm_community$list_extra$List$Extra$groupWhile,
				$elm$core$Basics$eq,
				A2(
					$elm$core$List$sortBy,
					$author$project$Complaint$Complaint$codeToString,
					A2(
						$elm$core$List$map,
						function ($) {
							return $.ge;
						},
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.lW;
								},
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Basics$eq(0),
									$elm$core$Basics$neq(search.bN))),
							complaints)))));
	});
var $author$project$Complaint$Feedback$codesFilterView = F2(
	function (complaints, search) {
		var codes = search.aB;
		var _v0 = search.cd;
		if (_v0 === 1) {
			return $mdgriffith$elm_ui$Element$none;
		} else {
			return A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$Background$color(
						$author$project$UI$Element$colorFor($author$project$UI$Palette$base2)),
						$mdgriffith$elm_ui$Element$Border$color(
						$author$project$UI$Element$colorFor($author$project$UI$Palette$base0)),
						$mdgriffith$elm_ui$Element$spacing(10),
						$mdgriffith$elm_ui$Element$padding(3),
						$mdgriffith$elm_ui$Element$Border$width(1),
						$mdgriffith$elm_ui$Element$Border$rounded(3)
					]),
				A2(
					$elm$core$List$map,
					$author$project$Complaint$Feedback$codeFilterView(codes),
					A2($author$project$Complaint$Feedback$codesOf, search, complaints)));
		}
	});
var $author$project$Complaint$Feedback$selectedCodeView = function (codes) {
	return A2(
		$mdgriffith$elm_ui$Element$row,
		$author$project$UI$Font$tag,
		A2(
			$elm$core$List$intersperse,
			$mdgriffith$elm_ui$Element$text(', '),
			A2(
				$elm$core$List$map,
				function (c) {
					return A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$Events$onClick(
								A2($author$project$Complaint$Feedback$UserClickedCode, c, false))
							]),
						$mdgriffith$elm_ui$Element$text(
							$author$project$Complaint$Complaint$codeToString(c)));
				},
				codes)));
};
var $author$project$Complaint$Feedback$searchView = F2(
	function (complaints, search) {
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$spacing(20),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$below(
							A2($author$project$Complaint$Feedback$codesFilterView, complaints, search)),
							$mdgriffith$elm_ui$Element$htmlAttribute(
							A2(
								$elm$html$Html$Events$stopPropagationOn,
								'click',
								$elm$json$Json$Decode$succeed(
									_Utils_Tuple2($author$project$Complaint$Feedback$NoOp, true))))
						]),
					$author$project$UI$Button$elementFor(
						A2(
							$author$project$UI$Button$withRole,
							2,
							A2($author$project$UI$Button$button, $author$project$Complaint$Feedback$UserToggledCodeFilter, 'Klacht codes')))),
					$author$project$Complaint$Feedback$selectedCodeView(search.aB),
					A2(
					$mdgriffith$elm_ui$Element$Input$checkbox,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$alignRight,
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$px(190))
						]),
					{
						lc: search.bN,
						mg: $mdgriffith$elm_ui$Element$Input$defaultCheckbox,
						mD: A2(
							$mdgriffith$elm_ui$Element$Input$labelRight,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
								]),
							$mdgriffith$elm_ui$Element$text('Klachten met feedback')),
						mY: $author$project$Complaint$Feedback$UserChangedFeedbackGivenFilter
					})
				]));
	});
var $author$project$UI$Columns$withSpacing = F2(
	function (spacing, _v0) {
		var c = _v0;
		return _Utils_update(
			c,
			{j9: spacing});
	});
var $author$project$Complaint$Feedback$view = F2(
	function (share, model) {
		if (model.$ === 1) {
			var unfolded = model.a.b7;
			var search = model.a.aj;
			var feedback = model.a.lW;
			var complaints = model.a.m;
			return function () {
				var _v1 = search.cd;
				if (_v1 === 1) {
					return $elm$core$Basics$identity;
				} else {
					return $mdgriffith$elm_ui$Element$el(
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$Events$onClick($author$project$Complaint$Feedback$UserToggledCodeFilter),
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
							]));
				}
			}()(
				$author$project$UI$Columns$elementFor(
					A2(
						$author$project$UI$Columns$withSpacing,
						10,
						A2(
							$author$project$UI$Columns$withColumn,
							A3($author$project$Complaint$Feedback$feedbackFormView, share, unfolded, feedback),
							A2(
								$author$project$UI$Columns$withColumn,
								A2(
									$author$project$Complaint$Feedback$lotsView,
									search,
									A2($author$project$Complaint$Feedback$lotsOf, search, complaints)),
								A3(
									$author$project$UI$Columns$withHeader,
									$author$project$UI$Search$height,
									A2($author$project$Complaint$Feedback$searchView, complaints, search),
									$author$project$UI$Columns$columns(
										$author$project$Portal$Page$contentWindow(share))))))));
		} else {
			return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$Complaint$Handle$UserSetSegmentComplaintsState = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Complaint$Handle$states = function (complaints) {
	return $elm_community$list_extra$List$Extra$unique(
		A2(
			$elm$core$List$map,
			function ($) {
				return $.b4;
			},
			complaints));
};
var $author$project$Complaint$Handle$UserSetComplaintState = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Complaint$Handle$commentView = function (comment) {
	return A2(
		$mdgriffith$elm_ui$Element$paragraph,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$el,
				$author$project$UI$Font$label,
				$mdgriffith$elm_ui$Element$text(
					$author$project$Complaint$Complaint$authorToString(comment.kU) + ': ')),
				$mdgriffith$elm_ui$Element$text(comment.aA)
			]));
};
var $icidasset$elm_material_icons$Material$Icons$error = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z')
				]),
			_List_Nil)
		]));
var $icidasset$elm_material_icons$Material$Icons$warning = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z')
				]),
			_List_Nil)
		]));
var $author$project$Complaint$Handle$frequencyView = function (frequency) {
	switch (frequency) {
		case 0:
			return $mdgriffith$elm_ui$Element$text(
				$elm$core$String$fromInt(1) + 'e klacht');
		case 1:
			return $mdgriffith$elm_ui$Element$text(
				$elm$core$String$fromInt(frequency) + 'e klacht');
		case 2:
			return A2(
				$mdgriffith$elm_ui$Element$row,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$Font$bold,
						$mdgriffith$elm_ui$Element$spacing(5)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$UI$Element$coloredIconFor,
						$icidasset$elm_material_icons$Material$Icons$warning(16),
						$author$project$UI$Palette$warning.k0),
						$mdgriffith$elm_ui$Element$text(
						$elm$core$String$fromInt(frequency) + 'e klacht')
					]));
		default:
			return A2(
				$mdgriffith$elm_ui$Element$row,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$Font$bold,
						$mdgriffith$elm_ui$Element$spacing(5)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$UI$Element$coloredIconFor,
						$icidasset$elm_material_icons$Material$Icons$error(16),
						$author$project$UI$Palette$error.k0),
						$mdgriffith$elm_ui$Element$text(
						$elm$core$String$fromInt(frequency) + 'e klacht')
					]));
	}
};
var $author$project$Complaint$Handle$viewComplaint = function (_v0) {
	var state = _v0.b4;
	var complaint = _v0.dX;
	var _v1 = function () {
		if (!state) {
			return _Utils_Tuple2(1, false);
		} else {
			return _Utils_Tuple2(0, true);
		}
	}();
	var newState = _v1.a;
	var isChecked = _v1.b;
	return A2(
		$mdgriffith$elm_ui$Element$row,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$spacing(10),
				$mdgriffith$elm_ui$Element$paddingEach(
				{k5: 0, mE: 10, nx: 0, ol: 0}),
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$Events$onClick(
				A2($author$project$Complaint$Handle$UserSetComplaintState, newState, complaint))
			]),
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$Input$defaultCheckbox(isChecked),
				A2(
				$mdgriffith$elm_ui$Element$wrappedRow,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$Border$width(1),
						$mdgriffith$elm_ui$Element$Border$rounded(1),
						$mdgriffith$elm_ui$Element$Border$color(
						$author$project$UI$Element$colorFor($author$project$UI$Palette$base0)),
						$mdgriffith$elm_ui$Element$padding(2),
						$mdgriffith$elm_ui$Element$spacing(10)
					]),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$wrappedRow,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width(
								$mdgriffith$elm_ui$Element$px(300))
							]),
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text(
								complaint.m8.f1.cT + (' - ' + ($author$project$Address$Address$houseNumberView(complaint.m8.f1.bs) + ', '))),
								$mdgriffith$elm_ui$Element$text(complaint.m8.f1.bU)
							])),
						A2(
						$mdgriffith$elm_ui$Element$column,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width(
								$mdgriffith$elm_ui$Element$px(150)),
								$mdgriffith$elm_ui$Element$alignTop,
								$mdgriffith$elm_ui$Element$spacing(5)
							]),
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text(
								$author$project$Complaint$Complaint$codeToString(complaint.ge)),
								$mdgriffith$elm_ui$Element$text(complaint.m8.jJ + ('/' + complaint.m8.ir))
							])),
						A2(
						$mdgriffith$elm_ui$Element$wrappedRow,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width(
								$mdgriffith$elm_ui$Element$px(120)),
								$mdgriffith$elm_ui$Element$alignTop,
								$mdgriffith$elm_ui$Element$spacing(5)
							]),
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text(
								$author$project$Date$DeliveryDate$view(complaint.lx)),
								$author$project$Complaint$Handle$frequencyView(complaint.l1)
							])),
						A2(
						$mdgriffith$elm_ui$Element$column,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width(
								A2($mdgriffith$elm_ui$Element$minimum, 200, $mdgriffith$elm_ui$Element$fill)),
								$mdgriffith$elm_ui$Element$alignTop
							]),
						function () {
							var _v3 = complaint.ln;
							if (!_v3.b) {
								return _List_Nil;
							} else {
								return A2($elm$core$List$map, $author$project$Complaint$Handle$commentView, complaint.ln);
							}
						}())
					]))
			]));
};
var $author$project$Complaint$Handle$viewSegment = function (_v0) {
	var segment = _v0.a;
	var complaints = _v0.b;
	var _v1 = function () {
		var _v2 = $author$project$Complaint$Handle$states(complaints);
		if (_v2.b && (!_v2.b.b)) {
			var s = _v2.a;
			if (!s) {
				return _Utils_Tuple2(1, false);
			} else {
				return _Utils_Tuple2(0, true);
			}
		} else {
			return _Utils_Tuple2(1, false);
		}
	}();
	var newState = _v1.a;
	var isChecked = _v1.b;
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$spacing(10)
			]),
		A2(
			$elm$core$List$cons,
			A2(
				$mdgriffith$elm_ui$Element$row,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$spacing(15),
						A2($mdgriffith$elm_ui$Element$paddingXY, 0, 10),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$Border$color(
						$author$project$UI$Element$colorFor($author$project$UI$Palette$base0)),
						$mdgriffith$elm_ui$Element$Border$widthEach(
						{k5: 1, mE: 0, nx: 0, ol: 0}),
						$mdgriffith$elm_ui$Element$Events$onClick(
						A2($author$project$Complaint$Handle$UserSetSegmentComplaintsState, newState, segment))
					]),
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$Input$defaultCheckbox(isChecked),
						A2(
						$mdgriffith$elm_ui$Element$el,
						$author$project$UI$Font$heading3,
						$mdgriffith$elm_ui$Element$text(segment.ft))
					])),
			A2($elm$core$List$map, $author$project$Complaint$Handle$viewComplaint, complaints)));
};
var $author$project$UI$Container$withTitleSize = F2(
	function (size, _v0) {
		var c = _v0;
		var _v1 = c.oi;
		if (!_v1.$) {
			var t = _v1.a;
			return _Utils_update(
				c,
				{
					oi: $elm$core$Maybe$Just(
						{bB: size, oi: t.oi})
				});
		} else {
			return _Utils_update(
				c,
				{
					oi: $elm$core$Maybe$Just(
						{bB: $author$project$UI$Font$heading3, oi: $mdgriffith$elm_ui$Element$none})
				});
		}
	});
var $author$project$UI$Container$withoutBorder = function (_v0) {
	var c = _v0;
	return _Utils_update(
		c,
		{k0: false});
};
var $author$project$Complaint$Handle$viewDp = function (_v0) {
	var dp = _v0.a;
	var complaints = _v0.b;
	return $author$project$UI$Container$elementFor(
		A2(
			$author$project$UI$Container$withContent,
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$spacing(35)
						]),
					A2($elm$core$List$map, $author$project$Complaint$Handle$viewSegment, complaints))
				]),
			$author$project$UI$Container$withoutBorder(
				A2(
					$author$project$UI$Container$withWidth,
					$mdgriffith$elm_ui$Element$fill,
					A2(
						$author$project$UI$Container$withTitleSize,
						$author$project$UI$Font$heading2,
						A2(
							$author$project$UI$Container$withTitle,
							$mdgriffith$elm_ui$Element$text(dp),
							$author$project$UI$Container$container))))));
};
var $author$project$Complaint$Handle$UserClickedHandleComplaints = {$: 4};
var $author$project$Complaint$Handle$viewHandle = function (complaints) {
	return A2(
		$mdgriffith$elm_ui$Element$row,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$alignTop,
				$mdgriffith$elm_ui$Element$Background$color(
				$author$project$UI$Element$colorFor($author$project$UI$Palette$base2)),
				$mdgriffith$elm_ui$Element$Border$color(
				$author$project$UI$Element$colorFor($author$project$UI$Palette$base0)),
				$mdgriffith$elm_ui$Element$Border$widthEach(
				{k5: 1, mE: 0, nx: 0, ol: 0}),
				$mdgriffith$elm_ui$Element$padding(1)
			]),
		_List_fromArray(
			[
				function () {
				var _v0 = $author$project$Complaint$Handle$selectedComplaints(complaints);
				if (!_v0.b) {
					return $mdgriffith$elm_ui$Element$none;
				} else {
					var selected = _v0;
					return $author$project$UI$Button$elementFor(
						A2(
							$author$project$UI$Button$withRole,
							0,
							A2(
								$author$project$UI$Button$button,
								$author$project$Complaint$Handle$UserClickedHandleComplaints,
								'Markeren als afgehandeld (' + ($elm$core$String$fromInt(
									$elm$core$List$length(selected)) + ')'))));
				}
			}()
			]));
};
var $author$project$Complaint$Handle$view = function (model) {
	switch (model.$) {
		case 0:
			return $mdgriffith$elm_ui$Element$none;
		case 1:
			var complaints = model.a.m;
			return A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$inFront(
						$author$project$Complaint$Handle$viewHandle(complaints))
					]),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$column,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$spacing(10),
								$mdgriffith$elm_ui$Element$paddingEach(
								{k5: 5, mE: 5, nx: 5, ol: 55}),
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$scrollbarY
							]),
						A2($elm$core$List$map, $author$project$Complaint$Handle$viewDp, complaints))
					]));
		default:
			return $mdgriffith$elm_ui$Element$none;
	}
};
var $author$project$Count$Count$UserClickedDoneToggle = {$: 11};
var $author$project$Count$Count$UserClickedNextCluster = {$: 8};
var $author$project$Count$Count$UserClickedPreviousCluster = {$: 7};
var $author$project$Count$Count$UserClickedSkipToNextCluster = {$: 9};
var $author$project$Count$Count$UserClickedSkipToPreviousCluster = {$: 10};
var $author$project$Count$Count$UserWantsToSelectProduct = {$: 12};
var $author$project$Count$Count$amountButton = F3(
	function (onPress, amount, backgroundColor) {
		return A2(
			$mdgriffith$elm_ui$Element$Input$button,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$centerX,
					$mdgriffith$elm_ui$Element$Font$size(120),
					$mdgriffith$elm_ui$Element$Font$bold,
					$mdgriffith$elm_ui$Element$Border$width(4),
					$mdgriffith$elm_ui$Element$Border$rounded(12),
					$mdgriffith$elm_ui$Element$padding(40),
					$mdgriffith$elm_ui$Element$Background$color(
					$author$project$UI$Element$colorFor(backgroundColor))
				]),
			{
				mD: amount,
				jp: $elm$core$Maybe$Just(onPress)
			});
	});
var $author$project$Count$Count$moveButton = F2(
	function (msg, icon) {
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$padding(25),
					$mdgriffith$elm_ui$Element$pointer,
					$mdgriffith$elm_ui$Element$centerX,
					$mdgriffith$elm_ui$Element$centerY,
					$mdgriffith$elm_ui$Element$Border$width(4),
					$mdgriffith$elm_ui$Element$Border$color(
					$author$project$UI$Element$colorFor($author$project$UI$Palette$base02)),
					$mdgriffith$elm_ui$Element$Events$onClick(msg)
				]),
			A2(
				$author$project$UI$Element$coloredIconFor,
				icon(72),
				$author$project$UI$Palette$base02));
	});
var $author$project$Count$Count$productButton = F2(
	function (onPress, productOrInsertId) {
		return A2(
			$mdgriffith$elm_ui$Element$Input$button,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Border$color(
					$author$project$UI$Element$colorFor($author$project$UI$Palette$base03)),
					$mdgriffith$elm_ui$Element$Border$width(4),
					$mdgriffith$elm_ui$Element$padding(25),
					$mdgriffith$elm_ui$Element$Font$color(
					$author$project$UI$Element$colorFor($author$project$UI$Palette$base03))
				]),
			{
				mD: $mdgriffith$elm_ui$Element$text(productOrInsertId),
				jp: $elm$core$Maybe$Just(onPress)
			});
	});
var $mdgriffith$elm_ui$Internal$Model$Bottom = 2;
var $mdgriffith$elm_ui$Element$alignBottom = $mdgriffith$elm_ui$Internal$Model$AlignY(2);
var $author$project$Count$Count$skipButton = F2(
	function (msg, icon) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$padding(15),
					$mdgriffith$elm_ui$Element$pointer,
					$mdgriffith$elm_ui$Element$centerX,
					$mdgriffith$elm_ui$Element$centerY,
					$mdgriffith$elm_ui$Element$alignBottom,
					$mdgriffith$elm_ui$Element$Border$width(4),
					$mdgriffith$elm_ui$Element$Border$color(
					$author$project$UI$Element$colorFor($author$project$UI$Palette$base0)),
					$mdgriffith$elm_ui$Element$Font$color(
					$author$project$UI$Element$colorFor($author$project$UI$Palette$base02)),
					$mdgriffith$elm_ui$Element$Font$size(24),
					$mdgriffith$elm_ui$Element$Events$onClick(msg)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$centerX]),
					A2(
						$author$project$UI$Element$coloredIconFor,
						icon(72),
						$author$project$UI$Palette$base01)),
					$mdgriffith$elm_ui$Element$text('Overslaan')
				]));
	});
var $icidasset$elm_material_icons$Material$Icons$skip_next = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z')
				]),
			_List_Nil)
		]));
var $icidasset$elm_material_icons$Material$Icons$skip_previous = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M6 6h2v12H6zm3.5 6l8.5 6V6z')
				]),
			_List_Nil)
		]));
var $author$project$Count$Count$amountsView = F5(
	function (bundleConfig, done, productId, clusterIndex, _v0) {
		var cluster = _v0.H;
		var bundle = _v0.G;
		var backgroundColor = A4($author$project$Count$Count$isDone, done, bundleConfig, productId, clusterIndex) ? $author$project$UI$Palette$success.kV : $author$project$UI$Palette$base2;
		var _v1 = $author$project$Count$Count$clusterName(cluster);
		var delivererName = _v1.a;
		var name = _v1.b;
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$centerX,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$padding(50)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
						]),
					_List_fromArray(
						[
							A2($author$project$Count$Count$moveButton, $author$project$Count$Count$UserClickedPreviousCluster, $icidasset$elm_material_icons$Material$Icons$chevron_left),
							A2($author$project$Count$Count$skipButton, $author$project$Count$Count$UserClickedSkipToPreviousCluster, $icidasset$elm_material_icons$Material$Icons$skip_previous)
						])),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(50)
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$centerX,
									$mdgriffith$elm_ui$Element$Font$size(90),
									$mdgriffith$elm_ui$Element$Font$bold,
									$mdgriffith$elm_ui$Element$padding(40)
								]),
							A2($author$project$Count$Count$productButton, $author$project$Count$Count$UserWantsToSelectProduct, productId)),
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$centerX,
									$mdgriffith$elm_ui$Element$Font$size(48)
								]),
							$mdgriffith$elm_ui$Element$text(delivererName)),
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$centerX,
									$mdgriffith$elm_ui$Element$Font$size(48)
								]),
							$mdgriffith$elm_ui$Element$text(name)),
							A3(
							$author$project$Count$Count$amountButton,
							$author$project$Count$Count$UserClickedDoneToggle,
							A2($author$project$Demand$Bundle$view, bundleConfig, bundle),
							backgroundColor)
						])),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
						]),
					_List_fromArray(
						[
							A2($author$project$Count$Count$moveButton, $author$project$Count$Count$UserClickedNextCluster, $icidasset$elm_material_icons$Material$Icons$chevron_right),
							A2($author$project$Count$Count$skipButton, $author$project$Count$Count$UserClickedSkipToNextCluster, $icidasset$elm_material_icons$Material$Icons$skip_next)
						]))
				]));
	});
var $author$project$Count$Count$missingAmountsView = F2(
	function (options, productId) {
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$centerX,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$padding(50)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(50)
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$centerX,
									$mdgriffith$elm_ui$Element$Font$size(90),
									$mdgriffith$elm_ui$Element$Font$bold,
									$mdgriffith$elm_ui$Element$padding(40)
								]),
							A2($author$project$Count$Count$productButton, $author$project$Count$Count$UserWantsToSelectProduct, productId)),
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$centerX,
									$mdgriffith$elm_ui$Element$centerY,
									$mdgriffith$elm_ui$Element$Font$size(48)
								]),
							$mdgriffith$elm_ui$Element$text(
								function () {
									var _v0 = options.ag;
									switch (_v0.$) {
										case 1:
											return 'Geen losse exemplaren voor deze uitgave';
										case 2:
											return 'Geen exemplaren voor deze uitgave';
										default:
											return 'Geen volle pakken voor deze uitgave';
									}
								}()))
						]))
				]));
	});
var $author$project$Count$Count$missingSubDpSummaryView = function (_v0) {
	var dp = _v0.a;
	var demandSummary = _v0.b;
	if (demandSummary.$ === 1) {
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_Nil,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$text(
					$author$project$DistributionPoint$DistributionPoint$nameOf(dp))
				]));
	} else {
		return $mdgriffith$elm_ui$Element$none;
	}
};
var $author$project$Count$Count$missingSubDpSummariesView = F2(
	function (dp, demandSummaryBySubDPId) {
		var subDps = A2(
			$elm$core$List$map,
			$author$project$Count$Count$missingSubDpSummaryView,
			A2(
				$elm$core$List$map,
				function (subDp) {
					return _Utils_Tuple2(
						subDp,
						A2(
							$author$project$DistributionPoint$IdDict$get,
							$author$project$DistributionPoint$DistributionPoint$idOf(subDp),
							demandSummaryBySubDPId));
				},
				$author$project$DistributionPoint$DistributionPoint$getSubDistributionPoints(dp)));
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$centerX,
					$mdgriffith$elm_ui$Element$padding(50),
					$mdgriffith$elm_ui$Element$spacing(10)
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$row,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Element$paddingXY, 0, 0)
							]),
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$el,
								$author$project$UI$Font$heading1,
								$mdgriffith$elm_ui$Element$text('De telapplicatie is niet beschikbaar'))
							])),
						A2(
						$mdgriffith$elm_ui$Element$row,
						_Utils_ap(
							$author$project$UI$Font$bodyLarge,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$paddingEach(
									{k5: 20, mE: 0, nx: 0, ol: 0})
								])),
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text('Er is nog geen plan aangemaakt voor de volgende distrubitiepunten:')
							]))
					]),
				subDps));
	});
var $author$project$Count$Count$UserSelectedProduct = function (a) {
	return {$: 13, a: a};
};
var $author$project$Count$Count$productsView = function (productOrInsertIds) {
	return A2(
		$mdgriffith$elm_ui$Element$wrappedRow,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$padding(50),
				$mdgriffith$elm_ui$Element$spacing(30)
			]),
		A2(
			$elm$core$List$map,
			function (id) {
				return A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Font$size(90),
							$mdgriffith$elm_ui$Element$Font$bold
						]),
					A2(
						$author$project$Count$Count$productButton,
						$author$project$Count$Count$UserSelectedProduct(id),
						id));
			},
			productOrInsertIds));
};
var $author$project$Count$Count$selectedBundledClusterIn = F3(
	function (productId, clusterIndex, amountByProductOrInsert) {
		return A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.k;
				},
				$elm_community$list_extra$List$Extra$getAt(clusterIndex)),
			A2($elm$core$Dict$get, productId, amountByProductOrInsert));
	});
var $author$project$Count$Count$view = function (_v0) {
	var options = _v0.m7;
	var orderAmounts = _v0.j;
	switch (orderAmounts.$) {
		case 1:
			var distributionPoint = orderAmounts.a.bn;
			var amountByProductOrInsert = orderAmounts.a.aY;
			var demandSummaryBySubDPId = orderAmounts.a.bm;
			var subDPDemandSummaryErrors = orderAmounts.a.b6;
			var showing = orderAmounts.a.y;
			var done = orderAmounts.a.a3;
			if (subDPDemandSummaryErrors.b) {
				return A2($author$project$Count$Count$missingSubDpSummariesView, distributionPoint, demandSummaryBySubDPId);
			} else {
				if (!showing.$) {
					var productId = showing.a.av;
					var clusterIndex = showing.a.v;
					if (!clusterIndex.$) {
						var i = clusterIndex.a;
						var _v5 = A3($author$project$Count$Count$selectedBundledClusterIn, productId, i, amountByProductOrInsert);
						if (!_v5.$) {
							var selectedBundledCluster = _v5.a;
							return A5($author$project$Count$Count$amountsView, options.ag, done, productId, i, selectedBundledCluster);
						} else {
							return A2($author$project$Count$Count$missingAmountsView, options, productId);
						}
					} else {
						return A2($author$project$Count$Count$missingAmountsView, options, productId);
					}
				} else {
					return $author$project$Count$Count$productsView(
						$elm$core$Dict$keys(amountByProductOrInsert));
				}
			}
		case 3:
			return A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$centerX,
						$mdgriffith$elm_ui$Element$padding(30)
					]),
				A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$centerX,
							$mdgriffith$elm_ui$Element$padding(50),
							$mdgriffith$elm_ui$Element$spacing(10)
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$row,
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Element$paddingXY, 0, 0)
								]),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$el,
									$author$project$UI$Font$heading1,
									$mdgriffith$elm_ui$Element$text('De telapplicatie is niet beschikbaar'))
								])),
							A2(
							$mdgriffith$elm_ui$Element$row,
							_Utils_ap(
								$author$project$UI$Font$bodyLarge,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$paddingEach(
										{k5: 20, mE: 0, nx: 0, ol: 0})
									])),
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text('Er zijn geen orders gevonden')
								]))
						])));
		default:
			return $mdgriffith$elm_ui$Element$none;
	}
};
var $author$project$Portal$Share$newsOf = function (_v0) {
	var model = _v0;
	return model.fu;
};
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $mdgriffith$elm_ui$Element$image = F2(
	function (attrs, _v0) {
		var src = _v0.ka;
		var description = _v0.ig;
		var imageAttributes = A2(
			$elm$core$List$filter,
			function (a) {
				switch (a.$) {
					case 7:
						return true;
					case 8:
						return true;
					default:
						return false;
				}
			},
			attrs);
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.mh),
				attrs),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(
				_List_fromArray(
					[
						A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asEl,
						$mdgriffith$elm_ui$Internal$Model$NodeName('img'),
						_Utils_ap(
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Internal$Model$Attr(
									$elm$html$Html$Attributes$src(src)),
									$mdgriffith$elm_ui$Internal$Model$Attr(
									$elm$html$Html$Attributes$alt(description))
								]),
							imageAttributes),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_Nil))
					])));
	});
var $author$project$Dashboard$Dashboard$viewBanner = function (b) {
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$alignTop,
				$mdgriffith$elm_ui$Element$width(
				$mdgriffith$elm_ui$Element$fillPortion(1)),
				$mdgriffith$elm_ui$Element$spacing(10),
				$mdgriffith$elm_ui$Element$paddingEach(
				{k5: 0, mE: 0, nx: 0, ol: 34})
			]),
		_List_fromArray(
			[
				function () {
				if (!b.$) {
					var bb = b.a;
					return A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$alignTop,
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
							]),
						A2(
							$mdgriffith$elm_ui$Element$image,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
								]),
							{
								ig: bb.cl,
								ka: $elm$url$Url$toString(bb.aW)
							}));
				} else {
					return $mdgriffith$elm_ui$Element$none;
				}
			}()
			]));
};
var $author$project$Dashboard$Dashboard$UserChangedExpiresOnTime = function (a) {
	return {$: 11, a: a};
};
var $author$project$Dashboard$Dashboard$UserChangedPublicationDate = function (a) {
	return {$: 10, a: a};
};
var $author$project$Dashboard$Dashboard$UserClickedCreateBanner = {$: 12};
var $author$project$Dashboard$Dashboard$UserClickedSelectFile = {$: 8};
var $author$project$UI$Input$time = function (attributes) {
	return $mdgriffith$elm_ui$Element$Input$text(
		_Utils_ap(
			attributes,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$htmlAttribute(
					$elm$html$Html$Attributes$type_('time'))
				])));
};
var $author$project$Dashboard$Dashboard$formErrorView = function (error) {
	switch (error) {
		case 2:
			return A2(
				$mdgriffith$elm_ui$Element$paragraph,
				_List_Nil,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$text('Publicatiedatum is verplicht')
					]));
		case 1:
			return A2(
				$mdgriffith$elm_ui$Element$paragraph,
				_List_Nil,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$text('Publicatietijd is verplicht')
					]));
		default:
			return A2(
				$mdgriffith$elm_ui$Element$paragraph,
				_List_Nil,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$text('Bestand is verplicht')
					]));
	}
};
var $author$project$Dashboard$Dashboard$viewBannerFormErrors = function (errors) {
	var _v0 = $elm$core$List$length(errors);
	if (!_v0) {
		return $mdgriffith$elm_ui$Element$none;
	} else {
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				A2($elm$core$List$map, $author$project$Dashboard$Dashboard$formErrorView, errors),
				A2($author$project$UI$Container$withVariant, 2, $author$project$UI$Container$container)));
	}
};
var $author$project$Dashboard$Dashboard$viewBannerForm = function (form) {
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$padding(2),
				$mdgriffith$elm_ui$Element$spacing(5)
			]),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$el,
				_Utils_ap(
					$author$project$UI$Font$heading2,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$padding(0)
						])),
				$mdgriffith$elm_ui$Element$text('Banner toevoegen')),
				$author$project$Dashboard$Dashboard$viewBannerFormErrors(form.f_),
				$author$project$UI$Input$row(
				_List_fromArray(
					[
						$author$project$UI$Button$elementFor(
						A2(
							$author$project$UI$Button$withRole,
							1,
							A2($author$project$UI$Button$button, $author$project$Dashboard$Dashboard$UserClickedSelectFile, 'Bestand kiezen'))),
						function () {
						var _v0 = form.c8;
						if (!_v0.$) {
							var file = _v0.a;
							return A2(
								$mdgriffith$elm_ui$Element$el,
								_List_Nil,
								$mdgriffith$elm_ui$Element$text(
									$elm$file$File$name(file)));
						} else {
							return $mdgriffith$elm_ui$Element$none;
						}
					}()
					])),
				$author$project$UI$Input$row(
				_List_fromArray(
					[
						A2(
						$author$project$UI$Input$date,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width(
								$mdgriffith$elm_ui$Element$px(160))
							]),
						{
							mD: $author$project$UI$Input$label('Publicatiedatum'),
							mY: $author$project$Dashboard$Dashboard$UserChangedPublicationDate,
							ng: $elm$core$Maybe$Nothing,
							n3: form.lx
						}),
						A2(
						$author$project$UI$Input$time,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width(
								$mdgriffith$elm_ui$Element$px(100))
							]),
						{
							mD: $author$project$UI$Input$label(' '),
							mY: $author$project$Dashboard$Dashboard$UserChangedExpiresOnTime,
							ng: $elm$core$Maybe$Nothing,
							n3: form.dG
						})
					])),
				$author$project$UI$Button$elementFor(
				A2(
					$author$project$UI$Button$withRole,
					0,
					A2($author$project$UI$Button$button, $author$project$Dashboard$Dashboard$UserClickedCreateBanner, 'Opslaan')))
			]));
};
var $author$project$Dashboard$Dashboard$UserClickedDeleteBanner = function (a) {
	return {$: 4, a: a};
};
var $author$project$Dashboard$Dashboard$UserClickedCancel = {$: 7};
var $author$project$Dashboard$Dashboard$UserConfirmedDeleteBanner = function (a) {
	return {$: 5, a: a};
};
var $mdgriffith$elm_ui$Element$Border$glow = F2(
	function (clr, size) {
		return $mdgriffith$elm_ui$Element$Border$shadow(
			{
				c_: size * 2,
				eS: clr,
				c: _Utils_Tuple2(0, 0),
				bB: size
			});
	});
var $author$project$Style$Palet$lightGrayishBlue = A3($mdgriffith$elm_ui$Element$rgb255, 224, 230, 238);
var $author$project$Style$Palet$white = A3($mdgriffith$elm_ui$Element$rgb255, 255, 255, 255);
var $author$project$Style$Style$confirmationDialog = _List_fromArray(
	[
		$mdgriffith$elm_ui$Element$padding(2),
		$mdgriffith$elm_ui$Element$Background$color($author$project$Style$Palet$white),
		$mdgriffith$elm_ui$Element$Border$width(2),
		$mdgriffith$elm_ui$Element$Border$rounded(5),
		$mdgriffith$elm_ui$Element$Border$color($author$project$Style$Palet$gray),
		A2($mdgriffith$elm_ui$Element$Border$glow, $author$project$Style$Palet$lightGrayishBlue, 3),
		$mdgriffith$elm_ui$Element$centerX,
		$mdgriffith$elm_ui$Element$centerY,
		$mdgriffith$elm_ui$Element$width(
		A2($mdgriffith$elm_ui$Element$maximum, 400, $mdgriffith$elm_ui$Element$fill))
	]);
var $author$project$Dashboard$Dashboard$deleteDialogView = function (b) {
	return A2(
		$mdgriffith$elm_ui$Element$column,
		$author$project$Style$Style$confirmationDialog,
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$paragraph,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$padding(2)
					]),
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$text('Weet je zeker dat je ' + (b.cl + ' wilt verwijderen?'))
					])),
				A2(
				$mdgriffith$elm_ui$Element$row,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				_List_fromArray(
					[
						$author$project$UI$Button$elementFor(
						A2(
							$author$project$UI$Button$withRole,
							1,
							A2(
								$author$project$UI$Button$button,
								$author$project$Dashboard$Dashboard$UserConfirmedDeleteBanner(b),
								'Verwijderen'))),
						A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[$mdgriffith$elm_ui$Element$alignRight]),
						$author$project$UI$Button$elementFor(
							A2($author$project$UI$Button$button, $author$project$Dashboard$Dashboard$UserClickedCancel, 'Annuleren')))
					]))
			]));
};
var $author$project$Sorting$Time$posixSortDesc = F3(
	function (fn, a, b) {
		var _v0 = A2(
			$elm$core$Basics$compare,
			$elm$time$Time$posixToMillis(
				fn(a)),
			$elm$time$Time$posixToMillis(
				fn(b)));
		switch (_v0) {
			case 0:
				return 2;
			case 2:
				return 0;
			default:
				return 1;
		}
	});
var $author$project$UI$DateTime$view = F2(
	function (timeZone, posix) {
		return $author$project$Date$DeliveryDate$view(
			A2($author$project$Date$DeliveryDate$fromPosix, timeZone, posix)) + (' ' + A2($author$project$UI$DateTime$timeView, timeZone, posix));
	});
var $author$project$Dashboard$Dashboard$viewBanners = F3(
	function (zone, banners, deleting) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_Utils_ap(
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$padding(3),
						$mdgriffith$elm_ui$Element$spacing(10)
					]),
				function () {
					if (deleting.$ === 1) {
						var b = deleting.a;
						return _List_fromArray(
							[
								$mdgriffith$elm_ui$Element$inFront(
								$author$project$Dashboard$Dashboard$deleteDialogView(b))
							]);
					} else {
						return _List_Nil;
					}
				}()),
			A2(
				$elm$core$List$map,
				function (b) {
					return A2(
						$mdgriffith$elm_ui$Element$row,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$spacing(10)
							]),
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$image,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width(
										$mdgriffith$elm_ui$Element$px(80))
									]),
								{
									ig: '',
									ka: $elm$url$Url$toString(b.aW)
								}),
								A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
									]),
								$mdgriffith$elm_ui$Element$text(b.cl)),
								A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width(
										$mdgriffith$elm_ui$Element$px(200))
									]),
								$mdgriffith$elm_ui$Element$text(
									A2($author$project$UI$DateTime$view, zone, b.hd))),
								$author$project$UI$Button$elementFor(
								A2(
									$author$project$UI$Button$withIcon,
									$icidasset$elm_material_icons$Material$Icons$delete,
									A2(
										$author$project$UI$Button$withRole,
										1,
										A2(
											$author$project$UI$Button$button,
											$author$project$Dashboard$Dashboard$UserClickedDeleteBanner(b),
											'Verwijderen'))))
							]));
				},
				A2(
					$elm$core$List$sortWith,
					$author$project$Sorting$Time$posixSortDesc(
						function ($) {
							return $.hd;
						}),
					banners)));
	});
var $author$project$Dashboard$Dashboard$viewManage = F4(
	function (zone, banners, form, deleting) {
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(10)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$alignTop,
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$fillPortion(2)),
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$Background$color(
							$author$project$UI$Element$colorFor($author$project$UI$Palette$base1))
						]),
					_List_fromArray(
						[
							A3($author$project$Dashboard$Dashboard$viewBanners, zone, banners, deleting)
						])),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$alignTop,
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$fillPortion(1)),
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$Background$color(
							$author$project$UI$Element$colorFor($author$project$UI$Palette$base1))
						]),
					_List_fromArray(
						[
							$author$project$Dashboard$Dashboard$viewBannerForm(form)
						]))
				]));
	});
var $author$project$Date$DeliveryDate$viewDMY = function (deliveryDate) {
	var date = $author$project$Date$DeliveryDate$toDate(deliveryDate);
	return A2(
		$elm$core$String$join,
		'-',
		_List_fromArray(
			[
				$author$project$Date$DeliveryDate$viewDay(
				$justinmimbs$date$Date$day(date)),
				$author$project$Date$DeliveryDate$viewMonth(
				$justinmimbs$date$Date$month(date)),
				$elm$core$String$fromInt(
				$justinmimbs$date$Date$year(date))
			]));
};
var $author$project$Dashboard$News$dateView = F2(
	function (timeZone, from) {
		return $author$project$Date$DeliveryDate$viewDMY(
			A2($author$project$Date$DeliveryDate$fromPosix, timeZone, from));
	});
var $author$project$Dashboard$News$viewNewsItem = F2(
	function (timeZone, news) {
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$paragraph,
						_List_Nil,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$html(
								$author$project$UI$Html$stringToHtml(news.n3))
							]))
					]),
				A2(
					$author$project$UI$Container$withWidth,
					$mdgriffith$elm_ui$Element$fill,
					A2(
						$author$project$UI$Container$withTitle,
						A2(
							$mdgriffith$elm_ui$Element$paragraph,
							_List_Nil,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text(
									A2($author$project$Dashboard$News$dateView, timeZone, news.l2) + (' | ' + news.oi))
								])),
						$author$project$UI$Container$container))));
	});
var $author$project$Dashboard$News$newsView = F2(
	function (timeZone, news) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(10)
				]),
			A2(
				$elm$core$List$map,
				$author$project$Dashboard$News$viewNewsItem(timeZone),
				A2(
					$elm$core$List$take,
					5,
					$elm$core$List$reverse(
						A2(
							$elm$core$List$sortBy,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.l2;
								},
								$elm$time$Time$posixToMillis),
							news)))));
	});
var $author$project$Dashboard$Dashboard$viewNews = F2(
	function (timeZone, messages) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$alignTop,
					$mdgriffith$elm_ui$Element$spacing(10),
					$mdgriffith$elm_ui$Element$width(
					$mdgriffith$elm_ui$Element$fillPortion(2))
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					$author$project$UI$Font$heading2,
					$mdgriffith$elm_ui$Element$text('Nieuwsberichten')),
					A2($author$project$Dashboard$News$newsView, timeZone, messages)
				]));
	});
var $author$project$Dashboard$Dashboard$view = F2(
	function (share, model) {
		if (model.$ === 1) {
			if (!model.b.$) {
				var _v1 = model.b;
				return $mdgriffith$elm_ui$Element$none;
			} else {
				var banners = model.b.a.cZ;
				var form = model.b.a.bO;
				var deleting = model.b.a.bK;
				return A4(
					$author$project$Dashboard$Dashboard$viewManage,
					$author$project$Portal$Share$timeZone(share),
					banners,
					form,
					deleting);
			}
		} else {
			var banner = model.a;
			var _v2 = $author$project$Portal$Share$ui(share).lF.le;
			if (!_v2) {
				return A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$Background$color(
							$author$project$UI$Element$colorFor($author$project$UI$Palette$base1)),
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Dashboard$Dashboard$viewNews,
							$author$project$Portal$Share$timeZone(share),
							$author$project$Portal$Share$newsOf(share)),
							$author$project$Dashboard$Dashboard$viewBanner(banner)
						]));
			} else {
				return A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(5),
							$mdgriffith$elm_ui$Element$padding(11),
							$mdgriffith$elm_ui$Element$Background$color(
							$author$project$UI$Element$colorFor($author$project$UI$Palette$base1)),
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Dashboard$Dashboard$viewNews,
							$author$project$Portal$Share$timeZone(share),
							$author$project$Portal$Share$newsOf(share)),
							$author$project$Dashboard$Dashboard$viewBanner(banner)
						]));
			}
		}
	});
var $author$project$Delay$Delay$UserClickedAddDelay = {$: 0};
var $author$project$Delay$Delay$headerView = F2(
	function (now, form) {
		var _v0 = _Utils_Tuple2(
			$author$project$Delay$Delay$nextPossibleDelayFromNow(now),
			form);
		_v0$2:
		while (true) {
			if (!_v0.a.$) {
				if (!_v0.b.$) {
					var _v1 = _v0.b;
					return A2(
						$mdgriffith$elm_ui$Element$column,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$UI$Button$elementFor(
								$author$project$UI$Button$withAlignRight(
									A2(
										$author$project$UI$Button$withIcon,
										$icidasset$elm_material_icons$Material$Icons$add,
										A2(
											$author$project$UI$Button$withRole,
											0,
											A2($author$project$UI$Button$button, $author$project$Delay$Delay$UserClickedAddDelay, 'Vertraging aanmaken')))))
							]));
				} else {
					break _v0$2;
				}
			} else {
				if (!_v0.b.$) {
					var _v2 = _v0.a;
					var _v3 = _v0.b;
					return $mdgriffith$elm_ui$Element$none;
				} else {
					break _v0$2;
				}
			}
		}
		return $mdgriffith$elm_ui$Element$none;
	});
var $author$project$Delay$Delay$UserChangedDelayReason = function (a) {
	return {$: 5, a: a};
};
var $author$project$Delay$Delay$UserChangedDelayTime = function (a) {
	return {$: 4, a: a};
};
var $author$project$Delay$Delay$UserClickedCancelDelay = {$: 6};
var $author$project$Delay$Delay$UserClickedSaveDelay = {$: 7};
var $author$project$Delay$Delay$allReasons = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8]);
var $author$project$Delay$Delay$formErrorView = function (error) {
	return A2(
		$mdgriffith$elm_ui$Element$paragraph,
		_List_Nil,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$text('Er is geen cluster geselecteerd')
			]));
};
var $author$project$Delay$Delay$formErrorsView = function (errors) {
	if (!errors.b) {
		return $mdgriffith$elm_ui$Element$none;
	} else {
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				A2($elm$core$List$map, $author$project$Delay$Delay$formErrorView, errors),
				A2($author$project$UI$Container$withVariant, 2, $author$project$UI$Container$container)));
	}
};
var $author$project$Delay$Delay$UserSelectedCluster = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Delay$Delay$UserSelectedDeliverer = function (a) {
	return {$: 2, a: a};
};
var $author$project$Delay$Delay$clusterView = F2(
	function (dp, cluster) {
		return _List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$el,
				_List_Nil,
				$mdgriffith$elm_ui$Element$text(
					'Cluster #' + $author$project$Cluster$Number$print(cluster.bX))),
				A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				A2(
					$mdgriffith$elm_ui$Element$paragraph,
					_List_Nil,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text(
							$author$project$UI$Name$shortenedListView(
								A2(
									$elm$core$List$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$UI$Paradise$nameAndIdView,
										function (n) {
											return {ft: n};
										}),
									A2(
										$elm$core$List$map,
										$author$project$DistributionPoint$DistributionPoint$segmentInfo,
										A2($author$project$DistributionPoint$DistributionPoint$findSegmentsOnId, dp, cluster.bb)))))
						])))
			]);
	});
var $author$project$Delay$Delay$logisticalInput = F4(
	function (dp, plan, delays, form) {
		var deliverers = A2($author$project$Delay$Delay$selectableDeliverers, plan, delays);
		var delivererInput = function (delivererId) {
			return $author$project$UI$Input$row(
				_List_fromArray(
					[
						A5(
						$author$project$UI$Input$selectWithOptions,
						deliverers,
						A2(
							$elm_community$list_extra$List$Extra$find,
							function (d) {
								return _Utils_eq(
									$author$project$Deliverer$Deliverer$idFromTyped(d),
									$author$project$Deliverer$Deliverer$idFromTyped(delivererId));
							},
							deliverers),
						$author$project$Delay$Delay$UserSelectedDeliverer,
						{
							d$: A2(
								$elm$core$Basics$composeR,
								$author$project$Deliverer$Deliverer$idFromString,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Maybe$andThen(
										function (id) {
											return A2(
												$elm_community$list_extra$List$Extra$find,
												function (d) {
													return _Utils_eq(
														$author$project$Deliverer$Deliverer$idFromTyped(d),
														id);
												},
												deliverers);
										}),
									$elm_community$json_extra$Json$Decode$Extra$fromMaybe('Failed to decode deliverer'))),
							d6: A2($elm$core$Basics$composeR, $author$project$Deliverer$Deliverer$idFromTyped, $author$project$Deliverer$Deliverer$comparableId),
							eG: $author$project$Delay$Delay$delivererView
						},
						'Bezorger')
					]));
		};
		var _v0 = form.D;
		if (!_v0.$) {
			var deliverer = _v0.a;
			var cluster = _v0.b;
			return _List_fromArray(
				[
					delivererInput(deliverer),
					$author$project$UI$Input$row(
					_List_fromArray(
						[
							$author$project$UI$Input$radio(
							{
								mD: $author$project$UI$Input$label('Cluster'),
								mY: $author$project$Delay$Delay$UserSelectedCluster(deliverer),
								m7: A2(
									$elm$core$List$map,
									function (c) {
										return A2(
											$mdgriffith$elm_ui$Element$Input$option,
											c,
											A2(
												$mdgriffith$elm_ui$Element$column,
												_List_fromArray(
													[
														$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
													]),
												A2($author$project$Delay$Delay$clusterView, dp, c)));
									},
									A3($author$project$Delay$Delay$delayableCluster, plan, delays, deliverer)),
								nI: $elm$core$Maybe$Just(cluster)
							})
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Delay$Delay$logisticalView = F2(
	function (dp, form) {
		var _v0 = form.D;
		if (!_v0.$) {
			var deliverer = _v0.a;
			var cluster = _v0.b;
			return _List_fromArray(
				[
					$author$project$UI$Input$row(
					_List_fromArray(
						[
							A2(
							$author$project$UI$Label$labeled,
							'Bezorger',
							A2(
								$mdgriffith$elm_ui$Element$el,
								_List_Nil,
								$mdgriffith$elm_ui$Element$text(
									$author$project$Delay$Delay$delivererView(deliverer))))
						])),
					$author$project$UI$Input$row(
					_List_fromArray(
						[
							A2(
							$author$project$UI$Label$labeled,
							'Cluster',
							A2(
								$mdgriffith$elm_ui$Element$column,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
									]),
								A2($author$project$Delay$Delay$clusterView, dp, cluster)))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Delay$Delay$reasonView = function (delayReason) {
	switch (delayReason) {
		case 0:
			return 'Kranten te laat afgeleverd';
		case 1:
			return 'Bezorger te laat begonnen';
		case 2:
			return 'Nieuw bezorger';
		case 3:
			return 'Meerdere wijken door invaller';
		case 4:
			return 'Pech met fiets, brommer, etc';
		case 5:
			return 'Invaller';
		case 6:
			return 'Bezorger heeft zich verslapen';
		case 7:
			return 'Vaste bezorger is ziek';
		default:
			return 'Weersomstandigheden';
	}
};
var $author$project$Delay$Delay$viewDelayForm = F5(
	function (dp, plan, delays, formState, _v0) {
		var viewForm = F3(
			function (form, times, logisticalFormElement) {
				return $author$project$UI$Container$elementFor(
					A2(
						$author$project$UI$Container$withContent,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Delay$Delay$formErrorsView(form.f_)
								]),
							_Utils_ap(
								logisticalFormElement,
								_List_fromArray(
									[
										$author$project$UI$Input$row(
										_List_fromArray(
											[
												A5(
												$author$project$UI$Input$selectWithOptions,
												times,
												$elm$core$Maybe$Just(
													$author$project$Delay$Delay$timeOf(form.O)),
												$author$project$Delay$Delay$UserChangedDelayTime,
												{
													d$: $author$project$Delay$Delay$decodeTypedTime,
													d6: $jxxcarlson$elm_typed_time$TypedTime$toString(2),
													eG: $jxxcarlson$elm_typed_time$TypedTime$toString(2)
												},
												'Tijd')
											])),
										$author$project$UI$Input$row(
										_List_fromArray(
											[
												$author$project$UI$Input$radio(
												{
													mD: $author$project$UI$Input$label('Reden'),
													mY: $author$project$Delay$Delay$UserChangedDelayReason,
													m7: A2(
														$elm$core$List$map,
														function (r) {
															return A2(
																$mdgriffith$elm_ui$Element$Input$option,
																r,
																$mdgriffith$elm_ui$Element$text(
																	$author$project$Delay$Delay$reasonView(r)));
														},
														$author$project$Delay$Delay$allReasons),
													nI: $elm$core$Maybe$Just(form.jL)
												})
											])),
										$author$project$UI$Input$row(
										_List_fromArray(
											[
												A2(
												$mdgriffith$elm_ui$Element$el,
												_List_fromArray(
													[$mdgriffith$elm_ui$Element$alignLeft]),
												$author$project$UI$Button$elementFor(
													A2(
														$author$project$UI$Button$withRole,
														0,
														A2($author$project$UI$Button$button, $author$project$Delay$Delay$UserClickedSaveDelay, 'Opslaan')))),
												A2(
												$mdgriffith$elm_ui$Element$el,
												_List_fromArray(
													[$mdgriffith$elm_ui$Element$alignRight]),
												$author$project$UI$Button$elementFor(
													A2(
														$author$project$UI$Button$withRole,
														1,
														A2($author$project$UI$Button$button, $author$project$Delay$Delay$UserClickedCancelDelay, 'Annuleren'))))
											]))
									]))),
						A2(
							$author$project$UI$Container$withWidth,
							$mdgriffith$elm_ui$Element$fill,
							$author$project$UI$Container$withoutBorder($author$project$UI$Container$container))));
			});
		switch (formState.$) {
			case 1:
				var times = formState.a;
				var f = formState.b;
				return A3(
					viewForm,
					f,
					times,
					A4($author$project$Delay$Delay$logisticalInput, dp, plan, delays, f));
			case 2:
				var times = formState.a;
				var f = formState.c;
				return A3(
					viewForm,
					f,
					times,
					A2($author$project$Delay$Delay$logisticalView, dp, f));
			default:
				return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$Delay$Delay$UserClickedEditDelay = function (a) {
	return {$: 1, a: a};
};
var $author$project$Delay$Delay$viewDelay = F3(
	function (now, dp, delay) {
		var _v0 = delay.D;
		if (_v0.$ === 1) {
			var cluster = _v0.a.H;
			return $author$project$UI$Container$elementFor(
				A2(
					$author$project$UI$Container$withContent,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$wrappedRow,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									$mdgriffith$elm_ui$Element$spacing(10)
								]),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$column,
									_Utils_ap(
										$author$project$UI$Font$tag,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
												$mdgriffith$elm_ui$Element$spacing(5)
											])),
									A2($author$project$Delay$Delay$clusterView, dp, cluster)),
									function () {
									var _v1 = $author$project$Delay$Delay$nextPossibleDelayFromNow(now);
									if (!_v1.$) {
										return $author$project$UI$Button$elementFor(
											$author$project$UI$Button$withAlignRight(
												A2(
													$author$project$UI$Button$withIcon,
													$icidasset$elm_material_icons$Material$Icons$edit,
													A2(
														$author$project$UI$Button$withRole,
														0,
														A2(
															$author$project$UI$Button$button,
															$author$project$Delay$Delay$UserClickedEditDelay(delay),
															'Opnieuw vertragen')))));
									} else {
										return $mdgriffith$elm_ui$Element$none;
									}
								}()
								]))
						]),
					A2(
						$author$project$UI$Container$withTitle,
						A2(
							$mdgriffith$elm_ui$Element$column,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									$mdgriffith$elm_ui$Element$spacing(10)
								]),
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text(
									$author$project$Delay$Delay$titleFor(delay.D)),
									A2(
									$mdgriffith$elm_ui$Element$el,
									_List_Nil,
									$mdgriffith$elm_ui$Element$text(
										$author$project$Delay$Delay$viewExpectedDelivery(delay.O) + (': ' + $author$project$Delay$Delay$reasonView(delay.jL))))
								])),
						A2($author$project$UI$Container$withWidth, $mdgriffith$elm_ui$Element$fill, $author$project$UI$Container$container))));
		} else {
			return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$Delay$Delay$viewDelays = F4(
	function (now, dp, delays, window) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$height(
					$mdgriffith$elm_ui$Element$px(window.iK)),
					$mdgriffith$elm_ui$Element$scrollbarY
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$spacing(5),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					A2(
						$elm$core$List$map,
						A2($author$project$Delay$Delay$viewDelay, now, dp),
						delays))
				]));
	});
var $author$project$Delay$Delay$view = F2(
	function (share, model) {
		switch (model.$) {
			case 1:
				var m = model.a;
				return A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width(
							A2($mdgriffith$elm_ui$Element$maximum, 800, $mdgriffith$elm_ui$Element$fill)),
							$mdgriffith$elm_ui$Element$centerX
						]),
					$author$project$UI$Columns$elementFor(
						A2(
							$author$project$UI$Columns$withSpacing,
							10,
							A2(
								$author$project$UI$Columns$withColumn,
								function () {
									var _v1 = $author$project$Delay$Delay$formOf(m.bO);
									if (!_v1.$) {
										return A4($author$project$Delay$Delay$viewDelayForm, m.bn, m.fA, m.ah, m.bO);
									} else {
										return A3($author$project$Delay$Delay$viewDelays, m.W, m.bn, m.ah);
									}
								}(),
								A3(
									$author$project$UI$Columns$withHeader,
									50,
									A2($author$project$Delay$Delay$headerView, m.W, m.bO),
									$author$project$UI$Columns$columns(
										$author$project$Portal$Page$contentWindow(share)))))));
			case 0:
				return $mdgriffith$elm_ui$Element$none;
			case 2:
				return A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$padding(11),
							$mdgriffith$elm_ui$Element$centerX
						]),
					$author$project$UI$Container$elementFor(
						A2(
							$author$project$UI$Container$withContent,
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$paragraph,
									_List_Nil,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$text('Er bestaat geen plan voor deze datum.')
										]))
								]),
							A2(
								$author$project$UI$Container$withTitle,
								A2(
									$mdgriffith$elm_ui$Element$paragraph,
									_List_Nil,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$text('Vertragingen zijn niet beschikbaar')
										])),
								$author$project$UI$Container$container))));
			default:
				return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$Deliverer$Create$UserClickedCancel = {$: 6};
var $author$project$Deliverer$Create$UserClickedCreateDeliverer = {$: 4};
var $author$project$Deliverer$Create$UserClickedDocuments = {$: 8};
var $author$project$Deliverer$Create$UserChangedFamilyName = function (a) {
	return {$: 3, a: a};
};
var $author$project$Deliverer$Create$UserChangedFrom = function (a) {
	return {$: 1, a: a};
};
var $author$project$Deliverer$Create$UserChangedGivenName = function (a) {
	return {$: 2, a: a};
};
var $author$project$Deliverer$Create$validationErrorView = function (error) {
	switch (error) {
		case 0:
			return $mdgriffith$elm_ui$Element$text('Voornaam is verplicht');
		case 1:
			return $mdgriffith$elm_ui$Element$text('Achternaam is verplicht');
		case 2:
			return $mdgriffith$elm_ui$Element$text('Begin datum is verplicht');
		default:
			return $mdgriffith$elm_ui$Element$text('Begin datum moet een geldige datum zijn');
	}
};
var $author$project$Deliverer$Create$validationErrorsView = function (errors) {
	var _v0 = $elm$core$List$length(errors);
	if (!_v0) {
		return $mdgriffith$elm_ui$Element$none;
	} else {
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				A2($elm$core$List$map, $author$project$Deliverer$Create$validationErrorView, errors),
				A2($author$project$UI$Container$withVariant, 2, $author$project$UI$Container$container)));
	}
};
var $author$project$Deliverer$Create$formView = function (_v0) {
	var from = _v0.l2;
	var givenName = _v0.ed;
	var familyName = _v0.d9;
	var validationErrors = _v0.f_;
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$spacing(10)
			]),
		_List_fromArray(
			[
				$author$project$Deliverer$Create$validationErrorsView(validationErrors),
				$author$project$UI$Input$row(
				_List_fromArray(
					[
						A2(
						$author$project$UI$Input$date,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width(
								$mdgriffith$elm_ui$Element$px(180))
							]),
						{
							mD: $author$project$UI$Input$label('Ingangsdatum'),
							mY: $author$project$Deliverer$Create$UserChangedFrom,
							ng: $elm$core$Maybe$Nothing,
							n3: from
						})
					])),
				$author$project$UI$Input$row(
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$Input$text,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width(
								$mdgriffith$elm_ui$Element$px(200))
							]),
						{
							mD: $author$project$UI$Input$label('Voornaam'),
							mY: $author$project$Deliverer$Create$UserChangedGivenName,
							ng: $elm$core$Maybe$Nothing,
							n3: givenName
						}),
						A2(
						$mdgriffith$elm_ui$Element$Input$text,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width(
								$mdgriffith$elm_ui$Element$px(200))
							]),
						{
							mD: $author$project$UI$Input$label('Achternaam'),
							mY: $author$project$Deliverer$Create$UserChangedFamilyName,
							ng: $elm$core$Maybe$Nothing,
							n3: familyName
						})
					]))
			]));
};
var $author$project$Deliverer$Create$view = F2(
	function (share, model) {
		var createButton = A2(
			$author$project$UI$Button$withRole,
			0,
			A2($author$project$UI$Button$button, $author$project$Deliverer$Create$UserClickedCreateDeliverer, 'Aanmaken'));
		var cancelButton = A2(
			$author$project$UI$Button$withRole,
			1,
			A2($author$project$UI$Button$button, $author$project$Deliverer$Create$UserClickedCancel, 'Annuleren'));
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$padding(10),
					$mdgriffith$elm_ui$Element$spacing(10),
					$mdgriffith$elm_ui$Element$centerX
				]),
			_List_fromArray(
				[
					$author$project$UI$Container$elementFor(
					A2(
						$author$project$UI$Container$withContent,
						_List_fromArray(
							[
								$author$project$Deliverer$Create$formView(model.eC),
								A2(
								$mdgriffith$elm_ui$Element$column,
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Element$paddingXY, 0, 20),
										$mdgriffith$elm_ui$Element$spacing(10)
									]),
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$text('Vul, samen met de bezorger, de relevante OVO formulieren in, onderteken alle pagina\'s en email naar administratie.'),
										A2(
										$mdgriffith$elm_ui$Element$row,
										_List_Nil,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$text('De benodigde documenten (o.a. OVO\'s) kunt u vinden op de pagina '),
												A2(
												$mdgriffith$elm_ui$Element$Input$button,
												_List_fromArray(
													[
														$mdgriffith$elm_ui$Element$Font$color(
														$author$project$UI$Element$colorFor($author$project$UI$Palette$base01))
													]),
												{
													mD: $mdgriffith$elm_ui$Element$text('Documenten.'),
													jp: $elm$core$Maybe$Just($author$project$Deliverer$Create$UserClickedDocuments)
												})
											]))
									])),
								$author$project$UI$Input$row(
								A3(
									$author$project$Portal$Waiting$map,
									_List_fromArray(
										[
											A2(
											$mdgriffith$elm_ui$Element$column,
											_List_fromArray(
												[$mdgriffith$elm_ui$Element$alignLeft]),
											_List_fromArray(
												[
													$author$project$UI$Button$elementFor(cancelButton)
												])),
											A2(
											$mdgriffith$elm_ui$Element$column,
											_List_fromArray(
												[$mdgriffith$elm_ui$Element$alignRight]),
											_List_fromArray(
												[
													$author$project$UI$Button$elementFor(createButton)
												]))
										]),
									$elm$core$Basics$always(
										_List_fromArray(
											[
												A2(
												$mdgriffith$elm_ui$Element$column,
												_List_fromArray(
													[$mdgriffith$elm_ui$Element$alignLeft]),
												_List_fromArray(
													[
														$author$project$UI$Button$elementFor(
														A2($author$project$UI$Button$disabled, 'Bezig met verwerken...', cancelButton))
													])),
												A2(
												$mdgriffith$elm_ui$Element$column,
												_List_fromArray(
													[$mdgriffith$elm_ui$Element$alignRight]),
												_List_fromArray(
													[
														$author$project$UI$Button$elementFor(
														A2($author$project$UI$Button$disabled, 'Bezig met verwerken...', createButton))
													]))
											])),
									$author$project$Portal$Share$waitingStatus(share)))
							]),
						$author$project$UI$Container$container))
				]));
	});
var $author$project$Deliverer$Edit$UserClickedAddFreeMessage = {$: 8};
var $author$project$Deliverer$Edit$UserClickedAddIntentToStop = {$: 7};
var $author$project$Deliverer$Deliverer$communicatedOnOf = function (communicationItem) {
	switch (communicationItem.$) {
		case 0:
			var communicatedOn = communicationItem.a.a$;
			return communicatedOn;
		case 1:
			var communicatedOn = communicationItem.a.a$;
			return communicatedOn;
		default:
			var communicatedOn = communicationItem.a.a$;
			return communicatedOn;
	}
};
var $author$project$Deliverer$Deliverer$chronologicCommunication = A2(
	$elm$core$Basics$composeR,
	$author$project$Deliverer$Deliverer$communicatedOnOf,
	A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$core$Basics$negate));
var $author$project$UI$Text$Exceptional = 1;
var $author$project$Deliverer$Edit$UserClickedReplyOnCommunication = function (a) {
	return {$: 9, a: a};
};
var $icidasset$elm_material_icons$Material$Icons$reply = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z')
				]),
			_List_Nil)
		]));
var $author$project$UI$Text$withStyle = F2(
	function (style, _v0) {
		var t = _v0;
		return _Utils_update(
			t,
			{hu: style});
	});
var $author$project$Deliverer$Edit$communicationView = F3(
	function (timeZone, userInput, communication) {
		var title = F2(
			function (communicatedOn, txt) {
				return A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							A2($mdgriffith$elm_ui$Element$spacingXY, 10, 0)
						]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text(txt),
							function () {
							if (!userInput.$) {
								return A2(
									$mdgriffith$elm_ui$Element$el,
									A2($elm$core$List$cons, $mdgriffith$elm_ui$Element$alignRight, $author$project$UI$Font$body),
									$author$project$UI$Button$elementFor(
										A2(
											$author$project$UI$Button$withIcon,
											$icidasset$elm_material_icons$Material$Icons$reply,
											A2(
												$author$project$UI$Button$withRole,
												2,
												A2(
													$author$project$UI$Button$button,
													$author$project$Deliverer$Edit$UserClickedReplyOnCommunication(communicatedOn),
													'Antwoorden')))));
							} else {
								return $mdgriffith$elm_ui$Element$none;
							}
						}(),
							A2(
							$mdgriffith$elm_ui$Element$el,
							A2($elm$core$List$cons, $mdgriffith$elm_ui$Element$alignRight, $author$project$UI$Font$tag),
							$mdgriffith$elm_ui$Element$text(
								A2($author$project$UI$DateTime$view, timeZone, communicatedOn)))
						]));
			});
		switch (communication.$) {
			case 0:
				var communicatedOn = communication.a.a$;
				var stopOn = communication.a.hs;
				var reason = communication.a.jL;
				return $author$project$UI$Container$elementFor(
					A2(
						$author$project$UI$Container$withSpacing,
						10,
						A2(
							$author$project$UI$Container$withWidth,
							A2($mdgriffith$elm_ui$Element$minimum, 450, $mdgriffith$elm_ui$Element$fill),
							A2(
								$author$project$UI$Container$withContent,
								_List_fromArray(
									[
										$author$project$UI$Text$elementFor(
										A2(
											$author$project$UI$Text$withLabel,
											'Op',
											$author$project$UI$Text$text(
												$author$project$Date$DeliveryDate$view(stopOn)))),
										$author$project$UI$Text$elementFor(
										A2(
											$author$project$UI$Text$withStyle,
											1,
											A2(
												$author$project$UI$Text$withLabel,
												'Reden',
												$author$project$UI$Text$text(reason))))
									]),
								A2(
									$author$project$UI$Container$withTitle,
									A2(title, communicatedOn, 'Intentie om te stoppen'),
									$author$project$UI$Container$container)))));
			case 1:
				var communicatedOn = communication.a.a$;
				var message = communication.a.fq;
				return $author$project$UI$Container$elementFor(
					A2(
						$author$project$UI$Container$withSpacing,
						10,
						A2(
							$author$project$UI$Container$withWidth,
							A2($mdgriffith$elm_ui$Element$minimum, 450, $mdgriffith$elm_ui$Element$fill),
							A2(
								$author$project$UI$Container$withContent,
								_List_fromArray(
									[
										$author$project$UI$Text$elementFor(
										A2(
											$author$project$UI$Text$withStyle,
											1,
											A2(
												$author$project$UI$Text$withLabel,
												'Inhoud',
												$author$project$UI$Text$text(message))))
									]),
								A2(
									$author$project$UI$Container$withTitle,
									A2(title, communicatedOn, 'Communicatie'),
									$author$project$UI$Container$container)))));
			default:
				var replyTo = communication.a.jP;
				var communicatedOn = communication.a.a$;
				var message = communication.a.fq;
				return $author$project$UI$Container$elementFor(
					A2(
						$author$project$UI$Container$withSpacing,
						10,
						A2(
							$author$project$UI$Container$withWidth,
							A2($mdgriffith$elm_ui$Element$minimum, 450, $mdgriffith$elm_ui$Element$fill),
							A2(
								$author$project$UI$Container$withContent,
								_List_fromArray(
									[
										$author$project$UI$Text$elementFor(
										A2(
											$author$project$UI$Text$withStyle,
											1,
											A2(
												$author$project$UI$Text$withLabel,
												'Inhoud',
												$author$project$UI$Text$text(message))))
									]),
								A2(
									$author$project$UI$Container$withTitle,
									A2(
										title,
										communicatedOn,
										'Antwoord op bericht van ' + A2($author$project$UI$DateTime$view, timeZone, replyTo)),
									$author$project$UI$Container$container)))));
		}
	});
var $author$project$Deliverer$Edit$UserChangedFreeMessage = function (a) {
	return {$: 19, a: a};
};
var $author$project$Deliverer$Edit$UserClickedCancel = {$: 10};
var $author$project$Deliverer$Edit$UserClickedSaveCommunication = {$: 14};
var $author$project$Deliverer$Edit$errorsView = F2(
	function (errorView, errors) {
		if (!errors.b) {
			return $mdgriffith$elm_ui$Element$none;
		} else {
			return $author$project$UI$Container$elementFor(
				A2(
					$author$project$UI$Container$withContent,
					A2($elm$core$List$map, errorView, errors),
					A2($author$project$UI$Container$withVariant, 2, $author$project$UI$Container$container)));
		}
	});
var $author$project$Deliverer$Edit$editableFreeMessageView = function (_v0) {
	var message = _v0.fq;
	var validationErrors = _v0.f_;
	var errorView = function (error) {
		return A3(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				$mdgriffith$elm_ui$Element$paragraph(_List_Nil),
				$elm$core$List$singleton),
			$mdgriffith$elm_ui$Element$text,
			'De inhoud is verplicht');
	};
	return $author$project$UI$Container$elementFor(
		A2(
			$author$project$UI$Container$withContent,
			_List_fromArray(
				[
					A2($author$project$Deliverer$Edit$errorsView, errorView, validationErrors),
					$author$project$UI$Input$row(
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$Input$multiline,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									$mdgriffith$elm_ui$Element$height(
									$mdgriffith$elm_ui$Element$px(150))
								]),
							{
								mD: $author$project$UI$Input$label('Inhoud'),
								mY: $author$project$Deliverer$Edit$UserChangedFreeMessage,
								ng: $elm$core$Maybe$Nothing,
								nR: true,
								n3: message
							})
						])),
					$author$project$UI$Input$row(
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$column,
							_List_fromArray(
								[$mdgriffith$elm_ui$Element$alignLeft]),
							_List_fromArray(
								[
									$author$project$UI$Button$elementFor(
									A2(
										$author$project$UI$Button$withRole,
										1,
										A2($author$project$UI$Button$button, $author$project$Deliverer$Edit$UserClickedCancel, 'Annuleren')))
								])),
							A2(
							$mdgriffith$elm_ui$Element$column,
							_List_fromArray(
								[$mdgriffith$elm_ui$Element$alignRight]),
							_List_fromArray(
								[
									$author$project$UI$Button$elementFor(
									A2(
										$author$project$UI$Button$withRole,
										0,
										A2($author$project$UI$Button$button, $author$project$Deliverer$Edit$UserClickedSaveCommunication, 'Opslaan')))
								]))
						]))
				]),
			A2(
				$author$project$UI$Container$withTitle,
				$mdgriffith$elm_ui$Element$text('Communicatie'),
				A2($author$project$UI$Container$withWidth, $mdgriffith$elm_ui$Element$fill, $author$project$UI$Container$container))));
};
var $author$project$Deliverer$Edit$Reason = 1;
var $author$project$Deliverer$Edit$StopOn = 0;
var $author$project$Deliverer$Edit$UserChangedIntentToStopValue = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Deliverer$Edit$editableIntensionToStopView = function (intentToStopForm) {
	var errorView = function (error) {
		return A3(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				$mdgriffith$elm_ui$Element$paragraph(_List_Nil),
				$elm$core$List$singleton),
			$mdgriffith$elm_ui$Element$text,
			function () {
				switch (error) {
					case 0:
						return 'De einddatum is verplicht';
					case 1:
						return 'De datum moet leesbaar zijn';
					default:
						return 'De reden is verplicht';
				}
			}());
	};
	return $author$project$UI$Container$elementFor(
		A2(
			$author$project$UI$Container$withContent,
			_List_fromArray(
				[
					A2($author$project$Deliverer$Edit$errorsView, errorView, intentToStopForm.f_),
					$author$project$UI$Input$row(
					_List_fromArray(
						[
							A2(
							$author$project$UI$Input$date,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width(
									$mdgriffith$elm_ui$Element$px(180))
								]),
							{
								mD: $author$project$UI$Input$label('Einddatum'),
								mY: $author$project$Deliverer$Edit$UserChangedIntentToStopValue(0),
								ng: $elm$core$Maybe$Nothing,
								n3: intentToStopForm.hs
							})
						])),
					$author$project$UI$Input$row(
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$Input$multiline,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									$mdgriffith$elm_ui$Element$height(
									$mdgriffith$elm_ui$Element$px(150))
								]),
							{
								mD: $author$project$UI$Input$label('Reden'),
								mY: $author$project$Deliverer$Edit$UserChangedIntentToStopValue(1),
								ng: $elm$core$Maybe$Nothing,
								nR: true,
								n3: intentToStopForm.jL
							})
						])),
					$author$project$UI$Input$row(
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$column,
							_List_fromArray(
								[$mdgriffith$elm_ui$Element$alignLeft]),
							_List_fromArray(
								[
									$author$project$UI$Button$elementFor(
									A2(
										$author$project$UI$Button$withRole,
										1,
										A2($author$project$UI$Button$button, $author$project$Deliverer$Edit$UserClickedCancel, 'Annuleren')))
								])),
							A2(
							$mdgriffith$elm_ui$Element$column,
							_List_fromArray(
								[$mdgriffith$elm_ui$Element$alignRight]),
							_List_fromArray(
								[
									$author$project$UI$Button$elementFor(
									A2(
										$author$project$UI$Button$withRole,
										0,
										A2($author$project$UI$Button$button, $author$project$Deliverer$Edit$UserClickedSaveCommunication, 'Opslaan')))
								]))
						]))
				]),
			A2(
				$author$project$UI$Container$withTitle,
				$mdgriffith$elm_ui$Element$text('Intentie om te stoppen'),
				A2($author$project$UI$Container$withWidth, $mdgriffith$elm_ui$Element$fill, $author$project$UI$Container$container))));
};
var $author$project$Deliverer$Edit$UserChangedReplyMessage = function (a) {
	return {$: 20, a: a};
};
var $author$project$Deliverer$Edit$editableReplyView = F2(
	function (timeZone, _v0) {
		var replyTo = _v0.jP;
		var message = _v0.fq;
		var validationErrors = _v0.f_;
		var errorView = function (error) {
			return A3(
				$elm$core$Basics$composeL,
				A2(
					$elm$core$Basics$composeL,
					$mdgriffith$elm_ui$Element$paragraph(_List_Nil),
					$elm$core$List$singleton),
				$mdgriffith$elm_ui$Element$text,
				'De inhoud is verplicht');
		};
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				_List_fromArray(
					[
						A2($author$project$Deliverer$Edit$errorsView, errorView, validationErrors),
						$author$project$UI$Input$row(
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$Input$multiline,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
										$mdgriffith$elm_ui$Element$height(
										$mdgriffith$elm_ui$Element$px(150))
									]),
								{
									mD: $author$project$UI$Input$label('Inhoud'),
									mY: $author$project$Deliverer$Edit$UserChangedReplyMessage,
									ng: $elm$core$Maybe$Nothing,
									nR: true,
									n3: message
								})
							])),
						$author$project$UI$Input$row(
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$column,
								_List_fromArray(
									[$mdgriffith$elm_ui$Element$alignLeft]),
								_List_fromArray(
									[
										$author$project$UI$Button$elementFor(
										A2(
											$author$project$UI$Button$withRole,
											1,
											A2($author$project$UI$Button$button, $author$project$Deliverer$Edit$UserClickedCancel, 'Annuleren')))
									])),
								A2(
								$mdgriffith$elm_ui$Element$column,
								_List_fromArray(
									[$mdgriffith$elm_ui$Element$alignRight]),
								_List_fromArray(
									[
										$author$project$UI$Button$elementFor(
										A2(
											$author$project$UI$Button$withRole,
											0,
											A2($author$project$UI$Button$button, $author$project$Deliverer$Edit$UserClickedSaveCommunication, 'Opslaan')))
									]))
							]))
					]),
				A2(
					$author$project$UI$Container$withTitle,
					$mdgriffith$elm_ui$Element$text(
						'Antwoord op bericht van ' + A2($author$project$UI$DateTime$view, timeZone, replyTo)),
					A2($author$project$UI$Container$withWidth, $mdgriffith$elm_ui$Element$fill, $author$project$UI$Container$container))));
	});
var $author$project$Deliverer$Edit$communicationLogView = F3(
	function (timeZone, userInput, communicationLog) {
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				A2(
					$elm$core$List$cons,
					function () {
						switch (userInput.$) {
							case 7:
								var form = userInput.a;
								return $author$project$Deliverer$Edit$editableIntensionToStopView(form);
							case 8:
								var form = userInput.a;
								return $author$project$Deliverer$Edit$editableFreeMessageView(form);
							case 9:
								var form = userInput.a;
								return A2($author$project$Deliverer$Edit$editableReplyView, timeZone, form);
							default:
								return A2(
									$mdgriffith$elm_ui$Element$row,
									_List_fromArray(
										[$author$project$UI$Spacing$default]),
									_List_fromArray(
										[
											$author$project$UI$Button$elementFor(
											A2(
												$author$project$UI$Button$withIcon,
												$icidasset$elm_material_icons$Material$Icons$add,
												A2(
													$author$project$UI$Button$withRole,
													0,
													A2($author$project$UI$Button$button, $author$project$Deliverer$Edit$UserClickedAddFreeMessage, 'Communicatie')))),
											$author$project$UI$Button$elementFor(
											A2(
												$author$project$UI$Button$withIcon,
												$icidasset$elm_material_icons$Material$Icons$add,
												A2(
													$author$project$UI$Button$withRole,
													1,
													A2($author$project$UI$Button$button, $author$project$Deliverer$Edit$UserClickedAddIntentToStop, 'Intentie om te stoppen'))))
										]));
						}
					}(),
					function () {
						var _v1 = communicationLog.gL;
						if (!_v1.b) {
							return _List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text('Nog geen communicatie.')
								]);
						} else {
							return A2(
								$elm$core$List$map,
								A2($author$project$Deliverer$Edit$communicationView, timeZone, userInput),
								A2($elm$core$List$sortBy, $author$project$Deliverer$Deliverer$chronologicCommunication, communicationLog.gL));
						}
					}()),
				A2(
					$author$project$UI$Container$withSpacing,
					10,
					A2(
						$author$project$UI$Container$withWidth,
						$mdgriffith$elm_ui$Element$fill,
						$author$project$UI$Container$withoutBorder(
							A2(
								$author$project$UI$Container$withTitleSize,
								$author$project$UI$Font$heading2,
								A2(
									$author$project$UI$Container$withTitle,
									$mdgriffith$elm_ui$Element$text('Relatiebeheer'),
									$author$project$UI$Container$container)))))));
	});
var $author$project$Deliverer$Edit$UserClickedConfirmDelete = {$: 13};
var $author$project$Deliverer$Edit$deleteDialogView = function (message) {
	return A2(
		$mdgriffith$elm_ui$Element$column,
		$author$project$Style$Style$confirmationDialog,
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$paragraph,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$padding(2)
					]),
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$text(message)
					])),
				A2(
				$mdgriffith$elm_ui$Element$row,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				_List_fromArray(
					[
						$author$project$UI$Button$elementFor(
						A2(
							$author$project$UI$Button$withRole,
							1,
							A2($author$project$UI$Button$button, $author$project$Deliverer$Edit$UserClickedConfirmDelete, 'Verwijderen'))),
						A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[$mdgriffith$elm_ui$Element$alignRight]),
						$author$project$UI$Button$elementFor(
							A2($author$project$UI$Button$button, $author$project$Deliverer$Edit$UserClickedCancel, 'Annuleren')))
					]))
			]));
};
var $author$project$UI$Text$Emphasized = 2;
var $author$project$UI$Text$withSelectableValue = function (_v0) {
	var t = _v0;
	return _Utils_update(
		t,
		{fP: true});
};
var $author$project$Deliverer$Deliverer$relNrView = function (typedDeliverer) {
	return $author$project$UI$Text$elementFor(
		$author$project$UI$Text$withSelectableValue(
			A2(
				$author$project$UI$Text$withLabel,
				'Rel. Nr.',
				function () {
					switch (typedDeliverer.$) {
						case 0:
							var deliverer = typedDeliverer.a;
							var _v1 = $author$project$UI$Paradise$idView(deliverer);
							if (!_v1.$) {
								var t = _v1.a;
								return $author$project$UI$Text$text(t);
							} else {
								return A2(
									$author$project$UI$Text$withStyle,
									1,
									$author$project$UI$Text$text('Onbekend'));
							}
						case 2:
							return A2(
								$author$project$UI$Text$withStyle,
								1,
								$author$project$UI$Text$text('Nog niet geregistreerd'));
						default:
							if (!typedDeliverer.b.$) {
								var deliverer = typedDeliverer.b.a;
								return A2(
									$author$project$UI$Text$withStyle,
									2,
									function () {
										var _v2 = $author$project$UI$Paradise$idView(deliverer);
										if (!_v2.$) {
											var t = _v2.a;
											return $author$project$UI$Text$text(t + ' (verlopen)');
										} else {
											return $author$project$UI$Text$text('Verlopen');
										}
									}());
							} else {
								var _v3 = typedDeliverer.b;
								return A2(
									$author$project$UI$Text$withStyle,
									2,
									$author$project$UI$Text$text('Bezorger niet gekend'));
							}
					}
				}())));
};
var $author$project$Deliverer$Edit$delivererView = function (deliverer) {
	return $author$project$UI$Container$elementFor(
		A2(
			$author$project$UI$Container$withSpacing,
			10,
			$author$project$UI$Container$withoutBorder(
				A2(
					$author$project$UI$Container$withWidth,
					$mdgriffith$elm_ui$Element$fill,
					A2(
						$author$project$UI$Container$withContent,
						_List_fromArray(
							[
								$author$project$UI$Text$elementFor(
								A2(
									$author$project$UI$Text$withLabel,
									'Bezorger',
									$author$project$UI$Text$text(
										$author$project$Deliverer$Deliverer$nameView(deliverer)))),
								$author$project$Deliverer$Deliverer$relNrView(
								$author$project$Deliverer$Deliverer$Registered(deliverer))
							]),
						$author$project$UI$Container$container)))));
};
var $author$project$Deliverer$Edit$UserClickedAddLocation = {$: 1};
var $author$project$Deliverer$Edit$Comment = 1;
var $author$project$Deliverer$Edit$Name = 0;
var $author$project$Deliverer$Edit$UserChangedLocationValue = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Deliverer$Edit$UserClickedSave = {$: 11};
var $author$project$Deliverer$Edit$Number = 5;
var $author$project$Deliverer$Edit$Suffix = 6;
var $author$project$Deliverer$Edit$UserWantsToAutocompleteAddress = {$: 25};
var $author$project$Deliverer$Edit$ZipCode = 2;
var $author$project$UI$Input$inputColors = {kV: $author$project$UI$Palette$base2, k0: $author$project$UI$Palette$base0, lZ: $author$project$UI$Palette$base03};
var $author$project$UI$Input$readonly = function (_v0) {
	var title = _v0.oi;
	var value = _v0.kt;
	var empty = _v0.iw;
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$spacing(3),
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
			]),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$el,
				_List_Nil,
				$mdgriffith$elm_ui$Element$text(title)),
				A2(
				$mdgriffith$elm_ui$Element$el,
				_Utils_ap(
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Border$width(1),
							$mdgriffith$elm_ui$Element$Border$rounded(4),
							A2($mdgriffith$elm_ui$Element$paddingXY, 12, 12),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					$author$project$UI$Element$colors($author$project$UI$Input$inputColors)),
				$mdgriffith$elm_ui$Element$text(
					function () {
						if (value === '') {
							return empty;
						} else {
							return value;
						}
					}()))
			]));
};
var $author$project$Deliverer$Edit$addressFormView = function (address) {
	return _List_fromArray(
		[
			A2(
			$elm$core$Tuple$pair,
			'address-edit',
			$author$project$UI$Input$row(
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$Input$text,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$Events$onLoseFocus($author$project$Deliverer$Edit$UserWantsToAutocompleteAddress)
							]),
						{
							mD: $author$project$UI$Input$label('Postcode'),
							mY: $author$project$Deliverer$Edit$UserChangedLocationValue(2),
							ng: $elm$core$Maybe$Nothing,
							n3: address.cT
						}),
						A2(
						$mdgriffith$elm_ui$Element$Input$text,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width(
								$mdgriffith$elm_ui$Element$px(100)),
								$mdgriffith$elm_ui$Element$Events$onLoseFocus($author$project$Deliverer$Edit$UserWantsToAutocompleteAddress)
							]),
						{
							mD: $author$project$UI$Input$label('Huisnummer'),
							mY: $author$project$Deliverer$Edit$UserChangedLocationValue(5),
							ng: $elm$core$Maybe$Nothing,
							n3: address.bX
						}),
						A2(
						$mdgriffith$elm_ui$Element$Input$text,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width(
								$mdgriffith$elm_ui$Element$px(85)),
								$mdgriffith$elm_ui$Element$htmlAttribute(
								A2($elm$html$Html$Attributes$attribute, 'maxlength', '5'))
							]),
						{
							mD: $author$project$UI$Input$label('toev.'),
							mY: $author$project$Deliverer$Edit$UserChangedLocationValue(6),
							ng: $elm$core$Maybe$Nothing,
							n3: address.dE
						})
					]))),
			A2(
			$elm$core$Tuple$pair,
			'street',
			$author$project$UI$Input$row(
				_List_fromArray(
					[
						$author$project$UI$Input$readonly(
						{iw: '...', oi: 'Straat', kt: address.b5})
					]))),
			A2(
			$elm$core$Tuple$pair,
			'municipal',
			$author$project$UI$Input$row(
				_List_fromArray(
					[
						$author$project$UI$Input$readonly(
						{iw: '...', oi: 'Plaats', kt: address.bU})
					])))
		]);
};
var $author$project$Deliverer$Edit$locationValidationErrorView = function (error) {
	switch (error) {
		case 0:
			return $mdgriffith$elm_ui$Element$text('Naam is verplicht');
		case 1:
			return $mdgriffith$elm_ui$Element$text('Postcode is verplicht');
		case 3:
			return $mdgriffith$elm_ui$Element$text('Huisnummer is verplicht');
		case 4:
			return $mdgriffith$elm_ui$Element$text('Huisnummer moet een getal zijn');
		default:
			return $mdgriffith$elm_ui$Element$text('Geen geldig adres gevonden');
	}
};
var $author$project$UI$Container$Keyed = function (a) {
	return {$: 1, a: a};
};
var $author$project$UI$Container$withKeyedContent = F2(
	function (content, _v0) {
		var c = _v0;
		return _Utils_update(
			c,
			{
				d: $author$project$UI$Container$Keyed(content)
			});
	});
var $author$project$Deliverer$Edit$locationFormView = function (location) {
	return $author$project$UI$Container$elementFor(
		A2(
			$author$project$UI$Container$withKeyedContent,
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$core$Tuple$pair,
						'errors',
						A2($author$project$Deliverer$Edit$errorsView, $author$project$Deliverer$Edit$locationValidationErrorView, location.f_)),
						A2(
						$elm$core$Tuple$pair,
						'name',
						$author$project$UI$Input$row(
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$Input$text,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
										]),
									{
										mD: $author$project$UI$Input$label('Naam'),
										mY: $author$project$Deliverer$Edit$UserChangedLocationValue(0),
										ng: $elm$core$Maybe$Nothing,
										n3: location.ft
									})
								])))
					]),
				_Utils_ap(
					$author$project$Deliverer$Edit$addressFormView(location),
					_List_fromArray(
						[
							A2(
							$elm$core$Tuple$pair,
							'comment',
							$author$project$UI$Input$row(
								_List_fromArray(
									[
										A2(
										$mdgriffith$elm_ui$Element$Input$text,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
												$mdgriffith$elm_ui$Element$htmlAttribute(
												A2($elm$html$Html$Attributes$attribute, 'maxlength', '50'))
											]),
										{
											mD: $author$project$UI$Input$label('Instructies'),
											mY: $author$project$Deliverer$Edit$UserChangedLocationValue(1),
											ng: $elm$core$Maybe$Nothing,
											n3: location.gg
										})
									]))),
							A2(
							$elm$core$Tuple$pair,
							'actions',
							$author$project$UI$Input$row(
								_List_fromArray(
									[
										A2(
										$mdgriffith$elm_ui$Element$column,
										_List_fromArray(
											[$mdgriffith$elm_ui$Element$alignLeft]),
										_List_fromArray(
											[
												$author$project$UI$Button$elementFor(
												A2(
													$author$project$UI$Button$withRole,
													1,
													A2($author$project$UI$Button$button, $author$project$Deliverer$Edit$UserClickedCancel, 'Annuleren')))
											])),
										A2(
										$mdgriffith$elm_ui$Element$column,
										_List_fromArray(
											[$mdgriffith$elm_ui$Element$alignRight]),
										_List_fromArray(
											[
												$author$project$UI$Button$elementFor(
												A2(
													$author$project$UI$Button$withRole,
													0,
													A2($author$project$UI$Button$button, $author$project$Deliverer$Edit$UserClickedSave, 'Opslaan')))
											]))
									])))
						]))),
			A2($author$project$UI$Container$withWidth, $mdgriffith$elm_ui$Element$fill, $author$project$UI$Container$container)));
};
var $author$project$Deliverer$Edit$UserClickedDeleteLocation = function (a) {
	return {$: 3, a: a};
};
var $author$project$Deliverer$Edit$UserClickedEditLocation = function (a) {
	return {$: 2, a: a};
};
var $author$project$Deliverer$Edit$addressView = function (address) {
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$spacing(5)
			]),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$row,
				_List_Nil,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$text(
						A2(
							$elm$core$String$join,
							' ',
							_List_fromArray(
								[
									address.b5,
									$author$project$Address$Address$houseNumberView(address.bs)
								])))
					])),
				A2(
				$mdgriffith$elm_ui$Element$row,
				_List_Nil,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$text(
						A2(
							$elm$core$String$join,
							', ',
							_List_fromArray(
								[address.cT, address.bU])))
					]))
			]));
};
var $author$project$Deliverer$Edit$hasActiveSupplyPeriod = F3(
	function (date, location, supplyPeriods) {
		return !$elm$core$List$isEmpty(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.f5;
					},
					$elm$core$Basics$eq(location.eg)),
				A2($author$project$Deliverer$Deliverer$relevantSupplyPeriods, date, supplyPeriods)));
	});
var $author$project$Deliverer$Edit$locationInstructionsView = function (location) {
	return A2(
		$elm$core$Maybe$withDefault,
		$mdgriffith$elm_ui$Element$none,
		A2(
			$elm$core$Maybe$map,
			function (c) {
				return A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							A2($mdgriffith$elm_ui$Element$paddingXY, 0, 5)
						]),
					$author$project$UI$Text$elementFor(
						A2(
							$author$project$UI$Text$withLabel,
							'Instructies',
							$author$project$UI$Text$text(c))));
			},
			location.gg));
};
var $author$project$Deliverer$Edit$locationView = F3(
	function (date, deliverer, location) {
		var buttons = function () {
			var _v0 = _Utils_Tuple2(
				_Utils_eq(deliverer.md, location.eg),
				A3($author$project$Deliverer$Edit$hasActiveSupplyPeriod, date, location, deliverer.kk));
			if (!_v0.a) {
				if (!_v0.b) {
					return _List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$Input$button,
							_List_fromArray(
								[$mdgriffith$elm_ui$Element$pointer, $mdgriffith$elm_ui$Element$alignRight]),
							{
								mD: $author$project$UI$Element$iconFor(
									$icidasset$elm_material_icons$Material$Icons$edit(16)),
								jp: $elm$core$Maybe$Just(
									$author$project$Deliverer$Edit$UserClickedEditLocation(location))
							}),
							A2(
							$mdgriffith$elm_ui$Element$Input$button,
							_List_fromArray(
								[$mdgriffith$elm_ui$Element$pointer, $mdgriffith$elm_ui$Element$alignRight]),
							{
								mD: A2(
									$author$project$UI$Element$coloredIconFor,
									$icidasset$elm_material_icons$Material$Icons$delete(16),
									$author$project$UI$Palette$magenta),
								jp: $elm$core$Maybe$Just(
									$author$project$Deliverer$Edit$UserClickedDeleteLocation(location.eg))
							})
						]);
				} else {
					return _List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$Input$button,
							_List_fromArray(
								[$mdgriffith$elm_ui$Element$pointer, $mdgriffith$elm_ui$Element$alignRight]),
							{
								mD: $author$project$UI$Element$iconFor(
									$icidasset$elm_material_icons$Material$Icons$edit(16)),
								jp: $elm$core$Maybe$Just(
									$author$project$Deliverer$Edit$UserClickedEditLocation(location))
							})
						]);
				}
			} else {
				return _List_Nil;
			}
		}();
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				_List_fromArray(
					[
						$author$project$Deliverer$Edit$addressView(location.f1),
						$author$project$Deliverer$Edit$locationInstructionsView(location)
					]),
				A2(
					$author$project$UI$Container$withWidth,
					$mdgriffith$elm_ui$Element$fill,
					A2(
						$author$project$UI$Container$withTitle,
						A2(
							$mdgriffith$elm_ui$Element$row,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									A2($mdgriffith$elm_ui$Element$spacingXY, 10, 0)
								]),
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Element$text(location.ft),
								buttons)),
						$author$project$UI$Container$container))));
	});
var $author$project$Deliverer$Edit$userIsEditingLocation = F2(
	function (userInput, location) {
		if (userInput.$ === 5) {
			var id = userInput.a;
			var l = userInput.b;
			return _Utils_eq(id, location.eg) ? $elm$core$Maybe$Just(l) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Deliverer$Edit$locationsView = F4(
	function (date, userInput, deliverer, locations) {
		var viewOrForm = function (location) {
			var _v2 = A2($author$project$Deliverer$Edit$userIsEditingLocation, userInput, location);
			if (!_v2.$) {
				var l = _v2.a;
				return $author$project$Deliverer$Edit$locationFormView(l);
			} else {
				return A3($author$project$Deliverer$Edit$locationView, date, deliverer, location);
			}
		};
		var addForm = function () {
			if (userInput.$ === 4) {
				var location = userInput.a;
				return $author$project$Deliverer$Edit$locationFormView(location);
			} else {
				return $author$project$UI$Button$elementFor(
					A2(
						$author$project$UI$Button$withRole,
						0,
						A2($author$project$UI$Button$button, $author$project$Deliverer$Edit$UserClickedAddLocation, 'Adres toevoegen')));
			}
		}();
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				_Utils_ap(
					function () {
						if (!locations.b) {
							return _List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$el,
									_List_Nil,
									$mdgriffith$elm_ui$Element$text('Geen afleveradressen'))
								]);
						} else {
							return A2($elm$core$List$map, viewOrForm, locations);
						}
					}(),
					_List_fromArray(
						[addForm])),
				$author$project$UI$Container$withoutBorder(
					A2(
						$author$project$UI$Container$withWidth,
						A2($mdgriffith$elm_ui$Element$minimum, 450, $mdgriffith$elm_ui$Element$fill),
						A2(
							$author$project$UI$Container$withTitleSize,
							$author$project$UI$Font$heading2,
							A2(
								$author$project$UI$Container$withTitle,
								$mdgriffith$elm_ui$Element$text('Afleveradressen'),
								$author$project$UI$Container$container))))));
	});
var $author$project$Deliverer$Edit$UserClickedAddSupplyPeriod = {$: 4};
var $author$project$Deliverer$Deliverer$findLocationById = F2(
	function (locations, id) {
		return A2(
			$elm_community$list_extra$List$Extra$find,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.eg;
				},
				$elm$core$Basics$eq(id)),
			locations);
	});
var $author$project$Deliverer$Edit$At = 0;
var $author$project$Deliverer$Edit$From = 1;
var $author$project$Deliverer$Edit$UserChangedSupplyPeriodValue = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Deliverer$Edit$supplyPeriodErrorView = function (error) {
	if (!error) {
		return A2(
			$mdgriffith$elm_ui$Element$paragraph,
			_List_Nil,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$text('Locatie is verplicht')
				]));
	} else {
		return A2(
			$mdgriffith$elm_ui$Element$paragraph,
			_List_Nil,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$text('Datum moet uniek en in de toekomst zijn')
				]));
	}
};
var $author$project$Deliverer$Edit$supplyPeriodFormView = F3(
	function (date, locations, supplyPeriod) {
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				_List_fromArray(
					[
						A2($author$project$Deliverer$Edit$errorsView, $author$project$Deliverer$Edit$supplyPeriodErrorView, supplyPeriod.f_),
						$author$project$UI$Input$row(
						_List_fromArray(
							[
								A2(
								$author$project$UI$Input$date,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width(
										$mdgriffith$elm_ui$Element$px(180)),
										$mdgriffith$elm_ui$Element$htmlAttribute(
										A2(
											$elm$html$Html$Attributes$attribute,
											'min',
											$justinmimbs$date$Date$toIsoString(
												A3($justinmimbs$date$Date$add, 3, 1, date))))
									]),
								{
									mD: $author$project$UI$Input$label('Van'),
									mY: $author$project$Deliverer$Edit$UserChangedSupplyPeriodValue(1),
									ng: $elm$core$Maybe$Nothing,
									n3: supplyPeriod.l2
								})
							])),
						$author$project$UI$Input$row(
						_List_fromArray(
							[
								$author$project$UI$Input$radio(
								{
									mD: $author$project$UI$Input$label('Locatie'),
									mY: $author$project$Deliverer$Edit$UserChangedSupplyPeriodValue(0),
									m7: A2(
										$elm$core$List$map,
										function (l) {
											return A2(
												$mdgriffith$elm_ui$Element$Input$option,
												$author$project$Deliverer$Deliverer$locationIdToString(l.eg),
												$mdgriffith$elm_ui$Element$text(l.ft));
										},
										locations),
									nI: $elm$core$Maybe$Just(supplyPeriod.f5)
								})
							])),
						$author$project$UI$Input$row(
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$column,
								_List_fromArray(
									[$mdgriffith$elm_ui$Element$alignLeft]),
								_List_fromArray(
									[
										$author$project$UI$Button$elementFor(
										A2(
											$author$project$UI$Button$withRole,
											1,
											A2($author$project$UI$Button$button, $author$project$Deliverer$Edit$UserClickedCancel, 'Annuleren')))
									])),
								A2(
								$mdgriffith$elm_ui$Element$column,
								_List_fromArray(
									[$mdgriffith$elm_ui$Element$alignRight]),
								_List_fromArray(
									[
										$author$project$UI$Button$elementFor(
										A2(
											$author$project$UI$Button$withRole,
											0,
											A2($author$project$UI$Button$button, $author$project$Deliverer$Edit$UserClickedSave, 'Opslaan')))
									]))
							]))
					]),
				A2($author$project$UI$Container$withWidth, $mdgriffith$elm_ui$Element$fill, $author$project$UI$Container$container)));
	});
var $author$project$Deliverer$Edit$UserClickedDeleteSupplyPeriod = function (a) {
	return {$: 6, a: a};
};
var $author$project$Deliverer$Edit$UserClickedEditSupplyPeriod = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Deliverer$Edit$supplyPeriodColors = {kV: $author$project$UI$Palette$base0, k0: $author$project$UI$Palette$base1, lZ: $author$project$UI$Palette$base03};
var $author$project$Deliverer$Edit$supplyPeriodView = F3(
	function (date, index, _v0) {
		var supplyPeriod = _v0.a;
		var location = _v0.b;
		var colors = $author$project$Deliverer$Edit$supplyPeriodColors;
		var buttons = function () {
			var _v1 = A2(
				$justinmimbs$date$Date$compare,
				$author$project$Date$DeliveryDate$toDate(supplyPeriod.l2),
				date);
			if (_v1 === 2) {
				return _List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$Input$button,
						_List_fromArray(
							[$mdgriffith$elm_ui$Element$pointer, $mdgriffith$elm_ui$Element$alignRight]),
						{
							mD: $author$project$UI$Element$iconFor(
								$icidasset$elm_material_icons$Material$Icons$edit(16)),
							jp: $elm$core$Maybe$Just(
								A2($author$project$Deliverer$Edit$UserClickedEditSupplyPeriod, index, supplyPeriod))
						}),
						A2(
						$mdgriffith$elm_ui$Element$Input$button,
						_List_fromArray(
							[$mdgriffith$elm_ui$Element$pointer, $mdgriffith$elm_ui$Element$alignRight]),
						{
							mD: A2(
								$author$project$UI$Element$coloredIconFor,
								$icidasset$elm_material_icons$Material$Icons$delete(16),
								$author$project$UI$Palette$magenta),
							jp: $elm$core$Maybe$Just(
								$author$project$Deliverer$Edit$UserClickedDeleteSupplyPeriod(supplyPeriod))
						})
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$alignTop,
					$mdgriffith$elm_ui$Element$Border$width(2),
					$mdgriffith$elm_ui$Element$Border$rounded(5),
					$mdgriffith$elm_ui$Element$Border$color(
					$author$project$UI$Element$colorFor(colors.k0)),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							A2($mdgriffith$elm_ui$Element$spacingXY, 10, 0),
							$mdgriffith$elm_ui$Element$padding(2),
							$mdgriffith$elm_ui$Element$Background$color(
							$author$project$UI$Element$colorFor(colors.kV))
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$mdgriffith$elm_ui$Element$el,
							$author$project$UI$Font$heading3,
							$mdgriffith$elm_ui$Element$text(
								$author$project$Date$DeliveryDate$view(supplyPeriod.l2))),
						buttons)),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$padding(2),
							$mdgriffith$elm_ui$Element$height(
							A2($mdgriffith$elm_ui$Element$minimum, 50, $mdgriffith$elm_ui$Element$fill))
						]),
					$mdgriffith$elm_ui$Element$text(location.ft))
				]));
	});
var $author$project$Deliverer$Edit$userIsEditingSupplyPeriod = F2(
	function (userInput, supplyPeriod) {
		if (userInput.$ === 2) {
			var i = userInput.a;
			var p = userInput.b;
			return _Utils_eq(i, supplyPeriod) ? $elm$core$Maybe$Just(p) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Deliverer$Edit$supplyPeriodsView = F4(
	function (date, editing, locations, supplyPeriods) {
		var viewOrForm = F2(
			function (index, supplyPeriodWithLocation) {
				if (!supplyPeriodWithLocation.$) {
					var s = supplyPeriodWithLocation.a;
					var _v3 = A2($author$project$Deliverer$Edit$userIsEditingSupplyPeriod, editing, index);
					if (!_v3.$) {
						var p = _v3.a;
						return A3($author$project$Deliverer$Edit$supplyPeriodFormView, date, locations, p);
					} else {
						return A3($author$project$Deliverer$Edit$supplyPeriodView, date, index, s);
					}
				} else {
					return $mdgriffith$elm_ui$Element$none;
				}
			});
		var add = function () {
			if (editing.$ === 1) {
				var supplyPeriod = editing.a;
				return A3($author$project$Deliverer$Edit$supplyPeriodFormView, date, locations, supplyPeriod);
			} else {
				return $author$project$UI$Button$elementFor(
					A2(
						$author$project$UI$Button$withRole,
						0,
						A2($author$project$UI$Button$button, $author$project$Deliverer$Edit$UserClickedAddSupplyPeriod, 'Periode toevoegen')));
			}
		}();
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$paragraph,
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Element$paddingXY, 0, 5)
								]),
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text('Vanaf datum en locatie voor aflevering.')
								]))
						]),
					_Utils_ap(
						function () {
							if (!supplyPeriods.b) {
								return _List_fromArray(
									[
										A2(
										$mdgriffith$elm_ui$Element$el,
										_List_Nil,
										$mdgriffith$elm_ui$Element$text('Geen planning'))
									]);
							} else {
								return A2(
									$elm$core$List$indexedMap,
									viewOrForm,
									A2(
										$elm$core$List$map,
										function (supplyPeriod) {
											return A3(
												$elm$core$Maybe$map2,
												F2(
													function (p, l) {
														return _Utils_Tuple2(p, l);
													}),
												$elm$core$Maybe$Just(supplyPeriod),
												A2($author$project$Deliverer$Deliverer$findLocationById, locations, supplyPeriod.f5));
										},
										supplyPeriods));
							}
						}(),
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Element$paddingXY, 0, 5),
										$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
									]),
								add)
							]))),
				$author$project$UI$Container$withoutBorder(
					A2(
						$author$project$UI$Container$withWidth,
						A2($mdgriffith$elm_ui$Element$minimum, 225, $mdgriffith$elm_ui$Element$fill),
						A2(
							$author$project$UI$Container$withTitleSize,
							$author$project$UI$Font$heading2,
							A2(
								$author$project$UI$Container$withTitle,
								$mdgriffith$elm_ui$Element$text('Afleverschema'),
								$author$project$UI$Container$container))))));
	});
var $author$project$Deliverer$Edit$titleView = function (deliverer) {
	return A2(
		$mdgriffith$elm_ui$Element$el,
		A2(
			$elm$core$List$cons,
			$mdgriffith$elm_ui$Element$paddingEach(
				{k5: 0, mE: 10, nx: 0, ol: 15}),
			$author$project$UI$Font$heading1),
		$mdgriffith$elm_ui$Element$text(
			$author$project$Deliverer$Deliverer$nameView(deliverer)));
};
var $author$project$Deliverer$Edit$view = F2(
	function (share, _v0) {
		var userInput = _v0.ax;
		var deliverer = _v0.bl;
		var communicationLog = _v0.bi;
		var today = $author$project$Date$DeliveryDate$toDate(
			$author$project$Portal$Share$today(share));
		if (deliverer.$ === 1) {
			var d = deliverer.a;
			var _delete = function () {
				switch (userInput.$) {
					case 6:
						var id = userInput.a;
						var _v4 = A2(
							$elm_community$list_extra$List$Extra$find,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.eg;
								},
								$elm$core$Basics$eq(id)),
							d.i4);
						if (!_v4.$) {
							var l = _v4.a;
							return $author$project$Deliverer$Edit$deleteDialogView(
								A2(
									$elm$core$String$join,
									'',
									_List_fromArray(
										['Weet u zeker dat u het adres \'', l.ft, '\' wilt verwijderen?'])));
						} else {
							return $mdgriffith$elm_ui$Element$none;
						}
					case 3:
						var supplyPeriod = userInput.a;
						return $author$project$Deliverer$Edit$deleteDialogView(
							A2(
								$elm$core$String$join,
								'',
								_List_fromArray(
									[
										'Weet u zeker dat u de periode \'',
										$author$project$Date$DeliveryDate$view(supplyPeriod.l2),
										'\' wilt verwijderen?'
									])));
					default:
						return $mdgriffith$elm_ui$Element$none;
				}
			}();
			return A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$centerX,
						$mdgriffith$elm_ui$Element$spacing(10),
						$mdgriffith$elm_ui$Element$inFront(_delete)
					]),
				_List_fromArray(
					[
						$author$project$Deliverer$Edit$titleView(d),
						$author$project$Deliverer$Edit$delivererView(d),
						A2(
						$mdgriffith$elm_ui$Element$wrappedRow,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$alignTop,
								$mdgriffith$elm_ui$Element$spacing(15),
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
							]),
						_List_fromArray(
							[
								A4($author$project$Deliverer$Edit$locationsView, today, userInput, d, d.i4),
								A4($author$project$Deliverer$Edit$supplyPeriodsView, today, userInput, d.i4, d.kk)
							])),
						function () {
						if (communicationLog.$ === 1) {
							var log = communicationLog.a;
							return A3(
								$author$project$Deliverer$Edit$communicationLogView,
								$author$project$Portal$Share$timeZone(share),
								userInput,
								log);
						} else {
							return $mdgriffith$elm_ui$Element$none;
						}
					}()
					]));
		} else {
			return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$Distributor$Validate$UserChangedDistributorDate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Distributor$Validate$UserChangedOrderDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Distributor$Validate$UserClickedValidate = {$: 2};
var $author$project$Distributor$Validate$formErrorView = function (error) {
	switch (error) {
		case 0:
			return A2(
				$mdgriffith$elm_ui$Element$paragraph,
				_List_Nil,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$text('Een geldige datum voor de orders is verplicht')
					]));
		case 1:
			return A2(
				$mdgriffith$elm_ui$Element$paragraph,
				_List_Nil,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$text('Een geldige datum voor de distributeur configuratie is verplicht')
					]));
		default:
			return A2(
				$mdgriffith$elm_ui$Element$paragraph,
				_List_Nil,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$text('De ingevoerde datums zijn niet geldig')
					]));
	}
};
var $author$project$Distributor$Validate$formErrorsView = function (errors) {
	if (!errors.b) {
		return $mdgriffith$elm_ui$Element$none;
	} else {
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				A2($elm$core$List$map, $author$project$Distributor$Validate$formErrorView, errors),
				A2($author$project$UI$Container$withVariant, 2, $author$project$UI$Container$container)));
	}
};
var $author$project$Distributor$Validate$formView = F2(
	function (model, window) {
		var form = $author$project$Distributor$Validate$formOf(model);
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$height(
					$mdgriffith$elm_ui$Element$px(window.iK)),
					$mdgriffith$elm_ui$Element$width(
					$mdgriffith$elm_ui$Element$px(250))
				]),
			A2(
				$mdgriffith$elm_ui$Element$column,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$UI$Input$row(
						_List_fromArray(
							[
								A2(
								$author$project$UI$Input$date,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width(
										$mdgriffith$elm_ui$Element$px(180))
									]),
								{
									mD: $author$project$UI$Input$label('Datum orders'),
									mY: $author$project$Distributor$Validate$UserChangedOrderDate,
									ng: $elm$core$Maybe$Nothing,
									n3: form.ej
								})
							])),
						$author$project$UI$Input$row(
						_List_fromArray(
							[
								A2(
								$author$project$UI$Input$date,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width(
										$mdgriffith$elm_ui$Element$px(180))
									]),
								{
									mD: $author$project$UI$Input$label('Datum distributeur configuratie'),
									mY: $author$project$Distributor$Validate$UserChangedDistributorDate,
									ng: $elm$core$Maybe$Nothing,
									n3: form.d3
								})
							])),
						$author$project$Distributor$Validate$formErrorsView(form.f_),
						$author$project$UI$Input$row(
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$column,
								_List_fromArray(
									[$mdgriffith$elm_ui$Element$alignLeft]),
								_List_fromArray(
									[
										$author$project$UI$Button$elementFor(
										function () {
											if (model.$ === 1) {
												return $author$project$UI$Button$disabled('Bezig met laden');
											} else {
												return $elm$core$Basics$identity;
											}
										}()(
											A2(
												$author$project$UI$Button$withRole,
												0,
												A2($author$project$UI$Button$button, $author$project$Distributor$Validate$UserClickedValidate, 'Verifieren'))))
									]))
							]))
					])));
	});
var $author$project$Distributor$Validate$noReportView = A2(
	$mdgriffith$elm_ui$Element$el,
	_List_fromArray(
		[
			$mdgriffith$elm_ui$Element$padding(11),
			$mdgriffith$elm_ui$Element$alignTop,
			$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
		]),
	$mdgriffith$elm_ui$Element$text('Kies de datums links en klik op verifieer'));
var $author$project$Distributor$Validate$UserClickedDownloadMutations = {$: 4};
var $author$project$Distributor$Validate$numberView = function (_v0) {
	var distributor = _v0.a;
	var num = _v0.b;
	return A2(
		$mdgriffith$elm_ui$Element$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width(
						$mdgriffith$elm_ui$Element$px(50)),
						$mdgriffith$elm_ui$Element$alignTop
					]),
				$mdgriffith$elm_ui$Element$text(distributor)),
				$mdgriffith$elm_ui$Element$text(
				$elm$core$String$fromInt(num))
			]));
};
var $author$project$Distributor$Validate$distributorView = function (_v0) {
	var zipCode = _v0.a;
	var startstop = _v0.b;
	return A2(
		$mdgriffith$elm_ui$Element$row,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$Border$widthEach(
				{k5: 1, mE: 0, nx: 0, ol: 0}),
				$mdgriffith$elm_ui$Element$Border$color(
				$author$project$UI$Element$colorFor($author$project$UI$Palette$base0)),
				$mdgriffith$elm_ui$Element$padding(2)
			]),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width(
						$mdgriffith$elm_ui$Element$px(100)),
						$mdgriffith$elm_ui$Element$alignTop
					]),
				$mdgriffith$elm_ui$Element$text(zipCode)),
				A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width(
						$mdgriffith$elm_ui$Element$px(125)),
						$mdgriffith$elm_ui$Element$alignTop,
						$mdgriffith$elm_ui$Element$spacing(7)
					]),
				A2(
					$elm$core$List$map,
					$author$project$Distributor$Validate$numberView,
					$elm$core$Dict$toList(startstop.hr))),
				A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width(
						$mdgriffith$elm_ui$Element$px(125)),
						$mdgriffith$elm_ui$Element$alignTop,
						$mdgriffith$elm_ui$Element$spacing(7)
					]),
				A2(
					$elm$core$List$map,
					$author$project$Distributor$Validate$numberView,
					A2(
						$elm$core$List$sortBy,
						$elm$core$Tuple$first,
						$elm$core$Dict$toList(startstop.hq))))
			]));
};
var $author$project$Distributor$Validate$shopView = function (_v0) {
	var shop = _v0.a;
	var startstop = _v0.b;
	return A2(
		$mdgriffith$elm_ui$Element$row,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$Border$widthEach(
				{k5: 1, mE: 0, nx: 0, ol: 0}),
				$mdgriffith$elm_ui$Element$Border$color(
				$author$project$UI$Element$colorFor($author$project$UI$Palette$base0)),
				$mdgriffith$elm_ui$Element$padding(2)
			]),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width(
						$mdgriffith$elm_ui$Element$px(200)),
						$mdgriffith$elm_ui$Element$alignTop
					]),
				$mdgriffith$elm_ui$Element$text(shop)),
				A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width(
						$mdgriffith$elm_ui$Element$px(125)),
						$mdgriffith$elm_ui$Element$alignTop,
						$mdgriffith$elm_ui$Element$spacing(7)
					]),
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$text(
						$elm$core$String$fromInt(
							$elm$core$List$sum(
								A2(
									$elm$core$List$map,
									$elm$core$Tuple$second,
									$elm$core$Dict$toList(startstop.hr)))))
					]))
			]));
};
var $author$project$Distributor$Validate$reportView = F2(
	function (report, window) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$height(
					$mdgriffith$elm_ui$Element$px(window.iK)),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(10)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					$author$project$UI$Font$heading1,
					$mdgriffith$elm_ui$Element$text('Mutaties')),
					$author$project$UI$Button$elementFor(
					A2(
						$author$project$UI$Button$withRole,
						0,
						A2($author$project$UI$Button$button, $author$project$Distributor$Validate$UserClickedDownloadMutations, 'CSV downloaden'))),
					A2(
					$mdgriffith$elm_ui$Element$el,
					$author$project$UI$Font$heading1,
					$mdgriffith$elm_ui$Element$text('Distributeurs')),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$mdgriffith$elm_ui$Element$row,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$padding(2)
								]),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$el,
									A2(
										$elm$core$List$cons,
										$mdgriffith$elm_ui$Element$width(
											$mdgriffith$elm_ui$Element$px(100)),
										$author$project$UI$Font$label),
									$mdgriffith$elm_ui$Element$text('Postcode')),
									A2(
									$mdgriffith$elm_ui$Element$el,
									A2(
										$elm$core$List$cons,
										$mdgriffith$elm_ui$Element$width(
											$mdgriffith$elm_ui$Element$px(125)),
										$author$project$UI$Font$label),
									$mdgriffith$elm_ui$Element$text('Stop')),
									A2(
									$mdgriffith$elm_ui$Element$el,
									A2(
										$elm$core$List$cons,
										$mdgriffith$elm_ui$Element$width(
											$mdgriffith$elm_ui$Element$px(125)),
										$author$project$UI$Font$label),
									$mdgriffith$elm_ui$Element$text('Start'))
								])),
						A2(
							$elm$core$List$map,
							$author$project$Distributor$Validate$distributorView,
							$elm$core$Dict$toList(report.ij)))),
					A2(
					$mdgriffith$elm_ui$Element$el,
					$author$project$UI$Font$heading1,
					$mdgriffith$elm_ui$Element$text('Winkels')),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$mdgriffith$elm_ui$Element$row,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$padding(2)
								]),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$el,
									A2(
										$elm$core$List$cons,
										$mdgriffith$elm_ui$Element$width(
											$mdgriffith$elm_ui$Element$px(200)),
										$author$project$UI$Font$label),
									$mdgriffith$elm_ui$Element$text('Shop')),
									A2(
									$mdgriffith$elm_ui$Element$el,
									$author$project$UI$Font$label,
									$mdgriffith$elm_ui$Element$text('Stop'))
								])),
						A2(
							$elm$core$List$map,
							$author$project$Distributor$Validate$shopView,
							$elm$core$Dict$toList(report.j3))))
				]));
	});
var $author$project$Distributor$Validate$view = F2(
	function (share, model) {
		return $author$project$UI$Columns$elementFor(
			A2(
				$author$project$UI$Columns$withColumn,
				function () {
					if (model.$ === 2) {
						var report = model.b;
						return $author$project$Distributor$Validate$reportView(report);
					} else {
						return $elm$core$Basics$always($author$project$Distributor$Validate$noReportView);
					}
				}(),
				A2(
					$author$project$UI$Columns$withColumn,
					$author$project$Distributor$Validate$formView(model),
					$author$project$UI$Columns$columns(
						$author$project$Portal$Page$contentWindow(share)))));
	});
var $elm$html$Html$Attributes$download = function (fileName) {
	return A2($elm$html$Html$Attributes$stringProperty, 'download', fileName);
};
var $mdgriffith$elm_ui$Element$download = F2(
	function (attrs, _v0) {
		var url = _v0.aW;
		var label = _v0.mD;
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			$mdgriffith$elm_ui$Internal$Model$NodeName('a'),
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$Attr(
					$elm$html$Html$Attributes$href(url)),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Internal$Model$Attr(
						$elm$html$Html$Attributes$download('')),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.eZ),
								A2(
									$elm$core$List$cons,
									$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.bI),
									attrs)))))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(
				_List_fromArray(
					[label])));
	});
var $author$project$Documents$Documents$documentColors = {kV: $author$project$UI$Palette$base2, k0: $author$project$UI$Palette$base1, lZ: $author$project$UI$Palette$base03};
var $author$project$Documents$Icons$banner = function (_v0) {
	var label = _v0.mD;
	var color = _v0.eS;
	return A2(
		$elm$svg$Svg$g,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fill(color),
						$elm$svg$Svg$Attributes$d('M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$text_,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$x('28'),
						$elm$svg$Svg$Attributes$y('48.5'),
						$elm$svg$Svg$Attributes$textAnchor('middle'),
						$elm$svg$Svg$Attributes$dominantBaseline('middle'),
						$elm$svg$Svg$Attributes$fill('#ffffff'),
						$elm$svg$Svg$Attributes$fontSize('12')
					]),
				_List_fromArray(
					[
						$elm$svg$Svg$text(label)
					]))
			]));
};
var $author$project$Documents$Icons$documentOutline = A2(
	$elm$svg$Svg$path,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('#E9E9E0'),
			$elm$svg$Svg$Attributes$d('M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z')
		]),
	_List_Nil);
var $author$project$Documents$Icons$flap = A2(
	$elm$svg$Svg$polygon,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('#D9D7CA'),
			$elm$svg$Svg$Attributes$points('37.5,0.151 37.5,12 49.349,12')
		]),
	_List_Nil);
var $author$project$Documents$Icons$svg = function (children) {
	return A2(
		$mdgriffith$elm_ui$Element$el,
		_List_Nil,
		$mdgriffith$elm_ui$Element$html(
			A2(
				$elm$svg$Svg$svg,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$viewBox('0 0 56 56'),
						$elm$svg$Svg$Attributes$width('28px'),
						$elm$svg$Svg$Attributes$height('28px')
					]),
				children)));
};
var $author$project$Documents$Icons$docIcon = F2(
	function (bannerInfo, specific) {
		return $author$project$Documents$Icons$svg(
			A2(
				$elm$core$List$cons,
				$author$project$Documents$Icons$documentOutline,
				_Utils_ap(
					specific,
					_List_fromArray(
						[
							$author$project$Documents$Icons$banner(bannerInfo),
							$author$project$Documents$Icons$flap
						]))));
	});
var $author$project$Documents$Icons$doc = A2(
	$author$project$Documents$Icons$docIcon,
	{eS: '#0096E6', mD: 'DOC'},
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill('#8697CB')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M18.5,13h-6c-0.552,0-1-0.448-1-1s0.448-1,1-1h6c0.552,0,1,0.448,1,1S19.052,13,18.5,13z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M21.5,18h-9c-0.552,0-1-0.448-1-1s0.448-1,1-1h9c0.552,0,1,0.448,1,1S22.052,18,21.5,18z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M25.5,18c-0.26,0-0.52-0.11-0.71-0.29c-0.18-0.19-0.29-0.45-0.29-0.71c0-0.26,0.11-0.52,0.29-0.71c0.37-0.37,1.05-0.37,1.42,0c0.18,0.19,0.29,0.45,0.29,0.71c0,0.26-0.11,0.52-0.29,0.71C26.02,17.89,25.76,18,25.5,18z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M37.5,18h-8c-0.552,0-1-0.448-1-1s0.448-1,1-1h8c0.552,0,1,0.448,1,1S38.052,18,37.5,18z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M12.5,33c-0.26,0-0.52-0.11-0.71-0.29c-0.18-0.19-0.29-0.45-0.29-0.71c0-0.26,0.11-0.52,0.29-0.71c0.37-0.37,1.05-0.37,1.42,0c0.18,0.19,0.29,0.44,0.29,0.71c0,0.26-0.11,0.52-0.29,0.71C13.02,32.89,12.76,33,12.5,33z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M24.5,33h-8c-0.552,0-1-0.448-1-1s0.448-1,1-1h8c0.552,0,1,0.448,1,1S25.052,33,24.5,33z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M43.5,18h-2c-0.552,0-1-0.448-1-1s0.448-1,1-1h2c0.552,0,1,0.448,1,1S44.052,18,43.5,18z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M34.5,23h-22c-0.552,0-1-0.448-1-1s0.448-1,1-1h22c0.552,0,1,0.448,1,1S35.052,23,34.5,23z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M43.5,23h-6c-0.552,0-1-0.448-1-1s0.448-1,1-1h6c0.552,0,1,0.448,1,1S44.052,23,43.5,23z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M16.5,28h-4c-0.552,0-1-0.448-1-1s0.448-1,1-1h4c0.552,0,1,0.448,1,1S17.052,28,16.5,28z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M30.5,28h-10c-0.552,0-1-0.448-1-1s0.448-1,1-1h10c0.552,0,1,0.448,1,1S31.052,28,30.5,28z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M43.5,28h-9c-0.552,0-1-0.448-1-1s0.448-1,1-1h9c0.552,0,1,0.448,1,1S44.052,28,43.5,28z')
						]),
					_List_Nil)
				]))
		]));
var $author$project$Documents$Icons$html = A2(
	$author$project$Documents$Icons$docIcon,
	{eS: '#EC6630', mD: 'HTML'},
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill('#EC6630'),
					$elm$svg$Svg$Attributes$textAnchor('middle'),
					$elm$svg$Svg$Attributes$dominantBaseline('middle'),
					$elm$svg$Svg$Attributes$fontSize('16'),
					$elm$svg$Svg$Attributes$transform('scale(1,1.4)')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$text_,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$x('18'),
							$elm$svg$Svg$Attributes$y('16')
						]),
					_List_fromArray(
						[
							$elm$svg$Svg$text('<')
						])),
					A2(
					$elm$svg$Svg$text_,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$x('38'),
							$elm$svg$Svg$Attributes$y('16')
						]),
					_List_fromArray(
						[
							$elm$svg$Svg$text('>')
						]))
				]))
		]));
var $author$project$Documents$Icons$image = function (color) {
	return _List_fromArray(
		[
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill('#F3D55B'),
					$elm$svg$Svg$Attributes$cx('18.931'),
					$elm$svg$Svg$Attributes$cy('14.431'),
					$elm$svg$Svg$Attributes$r('4.569')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$polygon,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill(color),
					$elm$svg$Svg$Attributes$points('6.5,39 17.5,39 49.5,39 49.5,28 39.5,18.5 29,30 23.517,24.517')
				]),
			_List_Nil)
		]);
};
var $author$project$Documents$Icons$jpg = A2(
	$author$project$Documents$Icons$docIcon,
	{eS: '#14A085', mD: 'JPG'},
	$author$project$Documents$Icons$image('#26B99A'));
var $author$project$Documents$Icons$mp4 = A2(
	$author$project$Documents$Icons$docIcon,
	{eS: '#FF5364', mD: 'MP4'},
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill('#C8BDB8')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M24.5,28c-0.166,0-0.331-0.041-0.481-0.123C23.699,27.701,23.5,27.365,23.5,27V13c0-0.365,0.199-0.701,0.519-0.877c0.321-0.175,0.71-0.162,1.019,0.033l11,7C36.325,19.34,36.5,19.658,36.5,20s-0.175,0.66-0.463,0.844l-11,7C24.874,27.947,24.687,28,24.5,28z M25.5,14.821v10.357L33.637,20L25.5,14.821z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M28.5,35c-8.271,0-15-6.729-15-15s6.729-15,15-15s15,6.729,15,15S36.771,35,28.5,35z M28.5,7c-7.168,0-13,5.832-13,13s5.832,13,13,13s13-5.832,13-13S35.668,7,28.5,7z')
						]),
					_List_Nil)
				]))
		]));
var $author$project$Documents$Icons$pdf = A2(
	$author$project$Documents$Icons$docIcon,
	{eS: '#CC4B4C', mD: 'PDF'},
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill('#CC4B4C'),
					$elm$svg$Svg$Attributes$d('M19.514,33.324L19.514,33.324c-0.348,0-0.682-0.113-0.967-0.326c-1.041-0.781-1.181-1.65-1.115-2.242c0.182-1.628,2.195-3.332,5.985-5.068c1.504-3.296,2.935-7.357,3.788-10.75-0.998-2.172-1.968-4.99-1.261-6.643c0.248-0.579,0.557-1.023,1.134-1.215c0.228-0.076,0.804-0.172,1.016-0.172c0.504,0,0.947,0.649,1.261,1.049c0.295,0.376,0.964,1.173-0.373,6.802c1.348,2.784,3.258,5.62,5.088,7.562c1.311-0.237,2.439-0.358,3.358-0.358c1.566,0,2.515,0.365,2.902,1.117c0.32,0.622,0.189,1.349-0.39,2.16c-0.557,0.779-1.325,1.191-2.22,1.191c-1.216,0-2.632-0.768-4.211-2.285c-2.837,0.593-6.15,1.651-8.828,2.822c-0.836,1.774-1.637,3.203-2.383,4.251C21.273,32.654,20.389,33.324,19.514,33.324z M22.176,28.198c-2.137,1.201-3.008,2.188-3.071,2.744c-0.01,0.092-0.037,0.334,0.431,0.692C19.685,31.587,20.555,31.19,22.176,28.198z M35.813,23.756c0.815,0.627,1.014,0.944,1.547,0.944c0.234,0,0.901-0.01,1.21-0.441c0.149-0.209,0.207-0.343,0.23-0.415c-0.123-0.065-0.286-0.197-1.175-0.197C37.12,23.648,36.485,23.67,35.813,23.756z M28.343,17.174c-0.715,2.474-1.659,5.145-2.674,7.564c2.09-0.811,4.362-1.519,6.496-2.02C30.815,21.15,29.466,19.192,28.343,17.174z M27.736,8.712c-0.098,0.033-1.33,1.757,0.096,3.216C28.781,9.813,27.779,8.698,27.736,8.712z')
				]),
			_List_Nil)
		]));
var $author$project$Documents$Icons$png = A2(
	$author$project$Documents$Icons$docIcon,
	{eS: '#659C35', mD: 'PNG'},
	$author$project$Documents$Icons$image('#88C057'));
var $author$project$Documents$Icons$ppt = A2(
	$author$project$Documents$Icons$docIcon,
	{eS: '#F6712E', mD: 'PPT'},
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill('#C8BDB8')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M20.499,35c-0.175,0-0.353-0.046-0.514-0.143c-0.474-0.284-0.627-0.898-0.343-1.372l3-5c0.284-0.474,0.898-0.627,1.372-0.343c0.474,0.284,0.627,0.898,0.343,1.372l-3,5C21.17,34.827,20.839,35,20.499,35z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M34.501,35c-0.34,0-0.671-0.173-0.858-0.485l-3-5c-0.284-0.474-0.131-1.088,0.343-1.372c0.474-0.283,1.088-0.131,1.372,0.343l3,5c0.284,0.474,0.131,1.088-0.343,1.372C34.854,34.954,34.676,35,34.501,35z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M27.5,16c-0.552,0-1-0.447-1-1v-3c0-0.553,0.448-1,1-1s1,0.447,1,1v3C28.5,15.553,28.052,16,27.5,16z')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$rect,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill('#D3CCC9'),
					$elm$svg$Svg$Attributes$stroke('#C8BDB8'),
					$elm$svg$Svg$Attributes$strokeWidth('2'),
					$elm$svg$Svg$Attributes$x('17.5'),
					$elm$svg$Svg$Attributes$y('16'),
					$elm$svg$Svg$Attributes$width('20'),
					$elm$svg$Svg$Attributes$height('12')
				]),
			_List_Nil)
		]));
var $author$project$Documents$Icons$unknown = function (label) {
	return A2(
		$author$project$Documents$Icons$docIcon,
		{
			eS: '#999999',
			mD: $elm$core$String$toUpper(
				A2($elm$core$String$left, 3, label))
		},
		_List_Nil);
};
var $author$project$Documents$Icons$xls = A2(
	$author$project$Documents$Icons$docIcon,
	{eS: '#91CDA0', mD: 'XLS'},
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill('#C8BDB8'),
					$elm$svg$Svg$Attributes$d('M23.5,16v-4h-12v4v2v2v2v2v2v2v2v4h10h2h21v-4v-2v-2v-2v-2v-2v-4H23.5z M13.5,14h8v2h-8V14zM13.5,18h8v2h-8V18z M13.5,22h8v2h-8V22z M13.5,26h8v2h-8V26z M21.5,32h-8v-2h8V32z M42.5,32h-19v-2h19V32z M42.5,28h-19v-2h19V28z M42.5,24h-19v-2h19V24z M23.5,20v-2h19v2H23.5z')
				]),
			_List_Nil)
		]));
var $author$project$Documents$Documents$iconView = function (extension) {
	switch (extension) {
		case 'pdf':
			return $author$project$Documents$Icons$pdf;
		case 'doc':
			return $author$project$Documents$Icons$doc;
		case 'docx':
			return $author$project$Documents$Icons$doc;
		case 'xls':
			return $author$project$Documents$Icons$xls;
		case 'xlsx':
			return $author$project$Documents$Icons$xls;
		case 'ppt':
			return $author$project$Documents$Icons$ppt;
		case 'pptx':
			return $author$project$Documents$Icons$ppt;
		case 'html':
			return $author$project$Documents$Icons$html;
		case 'mp4':
			return $author$project$Documents$Icons$mp4;
		case 'jpg':
			return $author$project$Documents$Icons$jpg;
		case 'png':
			return $author$project$Documents$Icons$png;
		default:
			return $author$project$Documents$Icons$unknown(extension);
	}
};
var $author$project$Documents$Documents$prettifyName = A2($elm$core$String$replace, '_', ' ');
var $author$project$Documents$Documents$titleView = function (_v0) {
	var name = _v0.ft;
	var extension = _v0.e9;
	return A2(
		$mdgriffith$elm_ui$Element$row,
		_Utils_ap(
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$spacing(7),
					$mdgriffith$elm_ui$Element$width(
					A2($mdgriffith$elm_ui$Element$minimum, 300, $mdgriffith$elm_ui$Element$fill))
				]),
			$author$project$UI$Element$colors($author$project$Documents$Documents$documentColors)),
		_List_fromArray(
			[
				A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				$author$project$Documents$Icons$unknown('?'),
				$author$project$Documents$Documents$iconView,
				extension),
				$mdgriffith$elm_ui$Element$text(
				$author$project$Documents$Documents$prettifyName(name))
			]));
};
var $author$project$Documents$Documents$downloadView = function (document) {
	var url = document.aW;
	return A2(
		$mdgriffith$elm_ui$Element$download,
		_List_Nil,
		{
			mD: $author$project$Documents$Documents$titleView(document),
			aW: $elm$url$Url$toString(url)
		});
};
var $author$project$Documents$Documents$UserClickedFocusedDocument = {$: 2};
var $author$project$Documents$Documents$UserFocusedOnDocument = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Attributes$controls = $elm$html$Html$Attributes$boolProperty('controls');
var $elm$html$Html$source = _VirtualDom_node('source');
var $elm$html$Html$video = _VirtualDom_node('video');
var $elm$html$Html$Attributes$width = function (n) {
	return A2(
		_VirtualDom_attribute,
		'width',
		$elm$core$String$fromInt(n));
};
var $author$project$Documents$Documents$videoView = F2(
	function (isFocused, document) {
		var url = document.aW;
		return isFocused ? $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withTitleSize,
				$author$project$UI$Font$body,
				A2(
					$author$project$UI$Container$withContent,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$html(
							A2(
								$elm$html$Html$video,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$controls(true),
										$elm$html$Html$Attributes$width(400)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$source,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$src(
												$elm$url$Url$toString(url)),
												$elm$html$Html$Attributes$type_('video/mp4')
											]),
										_List_Nil)
									])))
						]),
					A2(
						$author$project$UI$Container$withTitle,
						A2(
							$mdgriffith$elm_ui$Element$Input$button,
							_List_Nil,
							{
								mD: $author$project$Documents$Documents$titleView(document),
								jp: $elm$core$Maybe$Just($author$project$Documents$Documents$UserClickedFocusedDocument)
							}),
						$author$project$UI$Container$container)))) : A2(
			$mdgriffith$elm_ui$Element$Input$button,
			_List_Nil,
			{
				mD: $author$project$Documents$Documents$titleView(document),
				jp: $elm$core$Maybe$Just(
					$author$project$Documents$Documents$UserFocusedOnDocument(document))
			});
	});
var $author$project$Documents$Documents$documentView = F2(
	function (isFocused, document) {
		var extension = document.e9;
		_v0$2:
		while (true) {
			if (!extension.$) {
				switch (extension.a) {
					case 'mp4':
						return A2($author$project$Documents$Documents$videoView, isFocused, document);
					case 'webm':
						return A2($author$project$Documents$Documents$videoView, isFocused, document);
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return $author$project$Documents$Documents$downloadView(document);
	});
var $author$project$Documents$Documents$folderView = F3(
	function (level, focused, _v0) {
		var name = _v0.ft;
		var documents = _v0.$9;
		var folders = _v0.fe;
		var titleSize = (!level) ? $author$project$UI$Font$heading2 : $author$project$UI$Font$heading3;
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withSpacing,
				15,
				$author$project$UI$Container$withoutBorder(
					A2(
						$author$project$UI$Container$withContent,
						_Utils_ap(
							A2(
								$elm$core$List$map,
								function (d) {
									return A2(
										$author$project$Documents$Documents$documentView,
										_Utils_eq(
											$elm$core$Maybe$Just(d),
											focused),
										d);
								},
								documents),
							A2(
								$elm$core$List$map,
								A2($author$project$Documents$Documents$folderView, level - 1, focused),
								folders)),
						A2(
							$author$project$UI$Container$withTitleSize,
							titleSize,
							A2(
								$author$project$UI$Container$withTitle,
								$mdgriffith$elm_ui$Element$text(name),
								$author$project$UI$Container$container))))));
	});
var $author$project$Documents$Documents$view = function (model) {
	if (model.$ === 1) {
		var folders = model.a.fe;
		var focused = model.a.fd;
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$padding(11),
					$mdgriffith$elm_ui$Element$centerX,
					$mdgriffith$elm_ui$Element$spacing(11)
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$Documents$Documents$folderView, 0, focused),
				folders));
	} else {
		return $mdgriffith$elm_ui$Element$none;
	}
};
var $author$project$Demand$SummaryView$ShowPacksWhenAtLeastOne = 1;
var $author$project$Demand$SummaryView$columnsWithLeadingTotal = function (packsVisibility) {
	return _List_fromArray(
		[
			$author$project$Demand$SummaryView$ProductCode,
			$author$project$Demand$SummaryView$Total,
			$author$project$Demand$SummaryView$Packs(packsVisibility),
			$author$project$Demand$SummaryView$Subscription,
			$author$project$Demand$SummaryView$Sale,
			$author$project$Demand$SummaryView$Extra
		]);
};
var $author$project$Lists$Distribution$ClusterView$productSummaryViewConfig = {
	h4: $author$project$Demand$SummaryView$NoSplit,
	eT: $author$project$Demand$SummaryView$columnsWithLeadingTotal(1),
	iT: 0
};
var $author$project$Lists$Distribution$ClusterView$locationViewOf = function (location) {
	var charsOnRow = 23;
	var address = _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					location.f1.b5 + (' ' + $author$project$Address$Address$houseNumberView(location.f1.bs)))
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(location.f1.cT + (' ' + location.f1.bU))
				]))
		]);
	var _v0 = location.gg;
	if (!_v0.$) {
		var comment = _v0.a;
		return A2(
			$author$project$Print$SizedHtml$withSize,
			3 + A3(
				$elm$core$Basics$composeR,
				$elm$core$String$length,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Basics$toFloat,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Basics$fdiv(charsOnRow),
						$elm$core$Basics$ceiling)),
				comment),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('cluster-address'),
						A2($elm$html$Html$Attributes$style, 'word-break', 'break-all')
					]),
				_Utils_ap(
					address,
					_List_fromArray(
						[
							$elm$html$Html$text(comment)
						]))));
	} else {
		return A2(
			$author$project$Print$SizedHtml$withSize,
			3,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('cluster-address')
					]),
				address));
	}
};
var $author$project$Lists$Distribution$ClusterView$segmentNames = F2(
	function (distributionPoint, segments) {
		return A2(
			$author$project$Print$SizedHtml$withSize,
			$elm$core$List$length(segments),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('segment-names')
					]),
				A2(
					$elm$core$List$map,
					function (name) {
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(name)
								]));
					},
					A2($author$project$DistributionPoint$DistributionPoint$sortedSegmentNames, distributionPoint, segments))));
	});
var $author$project$Lists$Distribution$ClusterView$clusterHeader = F4(
	function (distributionPoint, date, deliverer, _v0) {
		var item = _v0.gK;
		var cluster = _v0.H;
		var parents = _v0.g9;
		var _v1 = function () {
			var _v2 = _Utils_Tuple2(parents, item);
			if (_v2.a.b) {
				if (!_v2.b.$) {
					return _Utils_Tuple2(
						_Utils_Tuple2(
							$author$project$Print$Palette$iconFor(
								$icidasset$elm_material_icons$Material$Icons$directions_car(18)),
							1),
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Print$SizedHtml$none,
							A2(
								$elm$core$Maybe$map,
								$author$project$Lists$Distribution$ClusterView$locationViewOf,
								A2(
									$author$project$Deliverer$Deliverer$locationOf,
									$author$project$Date$DeliveryDate$toDate(date),
									deliverer))));
				} else {
					var _v3 = _v2.a;
					return _Utils_Tuple2(
						_Utils_Tuple2(
							$author$project$Print$Palette$iconFor(
								$icidasset$elm_material_icons$Material$Icons$location_on(18)),
							1),
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Print$SizedHtml$none,
							A2(
								$elm$core$Maybe$map,
								$author$project$Lists$Distribution$ClusterView$locationViewOf,
								A2(
									$author$project$Deliverer$Deliverer$locationOf,
									$author$project$Date$DeliveryDate$toDate(date),
									deliverer))));
				}
			} else {
				switch (_v2.b.$) {
					case 0:
						return _Utils_Tuple2(
							_Utils_Tuple2(
								$author$project$Print$Palette$iconFor(
									$icidasset$elm_material_icons$Material$Icons$directions_car(18)),
								1),
							$author$project$Print$SizedHtml$none);
					case 1:
						return _Utils_Tuple2($author$project$Print$SizedHtml$none, $author$project$Print$SizedHtml$none);
					default:
						return _Utils_Tuple2($author$project$Print$SizedHtml$none, $author$project$Print$SizedHtml$none);
				}
			}
		}();
		var clusterIcon = _v1.a;
		var addressView = _v1.b;
		return A2(
			$author$project$Print$SizedHtml$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('cluster-header')
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('cluster-name')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('')
							])),
					0),
					clusterIcon,
					_Utils_Tuple2(
					A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Deliverer$Deliverer$nameView(deliverer))
							])),
					1),
					addressView,
					A2($author$project$Lists$Distribution$ClusterView$segmentNames, distributionPoint, cluster.bb)
				]));
	});
var $author$project$Print$SizedHtml$empty = _Utils_Tuple2(_List_Nil, 0);
var $author$project$Plan$Supply$isCar = function (supplyItem) {
	switch (supplyItem.$) {
		case 0:
			return true;
		case 1:
			return false;
		default:
			return false;
	}
};
var $author$project$Demand$SummaryView$ordersSummaryView = F3(
	function (config, orders, products) {
		var rowsByProduct = A2(
			$elm$core$List$map,
			A2($author$project$Demand$SummaryView$summaryRow, config, products),
			$author$project$Demand$SummaryView$summaryByProduct(orders));
		return A2($author$project$Demand$SummaryView$summaryView, config, rowsByProduct);
	});
var $author$project$Lists$Distribution$ClusterView$view = F7(
	function (config, distributionPoint, date, deliverer, clusterWithParents, orders, products) {
		var item = clusterWithParents.gK;
		var cluster = clusterWithParents.H;
		var parents = clusterWithParents.g9;
		return A3(
			$author$project$Print$Document$toHtml,
			0,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'cluster-stop',
							!(!$elm$core$List$length(parents))),
							_Utils_Tuple2(
							'cluster-driver',
							$author$project$Plan$Supply$isCar(item)),
							_Utils_Tuple2(
							'cluster-bike',
							(!$elm$core$List$length(parents)) && $author$project$Plan$Supply$isBike(item))
						]))
				]),
			A2(
				$author$project$Print$Document$addSizedHtml,
				A3($author$project$Demand$SummaryView$ordersSummaryView, config, orders, products),
				A2(
					$author$project$Print$Document$addSizedHtml,
					A4($author$project$Lists$Distribution$ClusterView$clusterHeader, distributionPoint, date, deliverer, clusterWithParents),
					A2(
						$author$project$Print$Document$init,
						$author$project$Print$Document$defaultPageSize,
						$elm$core$Basics$always($author$project$Print$SizedHtml$empty)))));
	});
var $author$project$Lists$Distribution$ClusterView$productView = F6(
	function (distributionPoint, date, deliverer, item, products, orders) {
		return A2(
			$elm$html$Html$article,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (c) {
					var ordersOfCluster = A2(
						$elm$core$List$concatMap,
						function ($) {
							return $.Y;
						},
						A2($author$project$DistributionPoint$DistributionPoint$filterOnSegments, orders, c.bb));
					return A7(
						$author$project$Lists$Distribution$ClusterView$view,
						$author$project$Lists$Distribution$ClusterView$productSummaryViewConfig,
						distributionPoint,
						date,
						deliverer,
						{H: c, gK: item, g9: _List_Nil},
						ordersOfCluster,
						products);
				},
				$author$project$Plan$Supply$ownClustersOf(item)));
	});
var $author$project$Lists$Distribution$DistributionList$supplyItemsView = F7(
	function (distributionPoint, date, deliverers, items, orders, demandSummaryBySubDPId, products) {
		var allOrders = _Utils_ap(
			orders,
			A3($author$project$Demand$Extra$orders, items, deliverers, products));
		return A2(
			$elm$core$List$map,
			function (item) {
				switch (item.$) {
					case 0:
						var deliverer = item.a.bl;
						var cluster = item.a.H;
						var supplies = item.a.n0;
						return A3(
							$author$project$Lists$Ride$List$view,
							{df: 0, nl: 0},
							A4($author$project$Lists$Ride$List$headerForCluster, distributionPoint, date, deliverer, cluster),
							A8($author$project$Lists$Ride$List$listFromCarItem, distributionPoint, date, products, cluster, deliverer, supplies, allOrders, demandSummaryBySubDPId));
					case 1:
						var bike = item.a;
						return A6(
							$author$project$Lists$Distribution$ClusterView$productView,
							distributionPoint,
							date,
							$author$project$Deliverer$Deliverer$fromTyped(bike.bl),
							item,
							products,
							A2(
								$author$project$DistributionPoint$DistributionPoint$filterOnSegments,
								allOrders,
								$author$project$Plan$Supply$ownSegmentsOf(item)));
					default:
						return $elm$html$Html$text('');
				}
			},
			items);
	});
var $author$project$Lists$Distribution$DistributionList$view = function (model) {
	var _v0 = _Utils_Tuple3(
		model.bn,
		$author$project$Plan$PlanLoader$loadedOf(model.fB),
		_Utils_Tuple2(model.Y, model.bu));
	_v0$1:
	while (true) {
		_v0$3:
		while (true) {
			_v0$4:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.$) {
						switch (_v0.a.$) {
							case 1:
								switch (_v0.c.a.$) {
									case 1:
										switch (_v0.c.b.$) {
											case 1:
												var distributionPoint = _v0.a.a;
												var p = _v0.b.a;
												var _v1 = _v0.c;
												var orders = _v1.a.a;
												var products = _v1.b.a;
												var _v2 = _Utils_eq(
													$author$project$DistributionPoint$IdDict$size(model.bm),
													$elm$core$List$length(
														$author$project$DistributionPoint$DistributionPoint$getSubDistributionPoints(distributionPoint)));
												if (_v2) {
													return $mdgriffith$elm_ui$Element$html(
														A2(
															$elm$html$Html$article,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('distributionlist')
																]),
															A2(
																$elm$core$List$cons,
																A2($author$project$Lists$Distribution$DistributionList$title, distributionPoint, model.lx),
																A7(
																	$author$project$Lists$Distribution$DistributionList$supplyItemsView,
																	distributionPoint,
																	model.lx,
																	A3(
																		$elm$core$Basics$composeR,
																		$author$project$Deliverer$IdDict$values,
																		$elm$core$List$map($author$project$Deliverer$Deliverer$fromTyped),
																		p.e4),
																	p.fA.gL,
																	orders,
																	model.bm,
																	products))));
												} else {
													return $author$project$Lists$Distribution$DistributionList$loadingView;
												}
											case 0:
												break _v0$4;
											default:
												break _v0$5;
										}
									case 0:
										break _v0$3;
									default:
										if (!_v0.c.b.$) {
											break _v0$4;
										} else {
											break _v0$5;
										}
								}
							case 0:
								break _v0$1;
							default:
								if (!_v0.c.a.$) {
									break _v0$3;
								} else {
									if (!_v0.c.b.$) {
										break _v0$4;
									} else {
										break _v0$5;
									}
								}
						}
					} else {
						if (!_v0.a.$) {
							break _v0$1;
						} else {
							var _v3 = _v0.b;
							return $author$project$Lists$Distribution$DistributionList$loadingView;
						}
					}
				}
				return $author$project$Lists$Distribution$DistributionList$problemView;
			}
			var _v5 = _v0.c;
			return $author$project$Lists$Distribution$DistributionList$loadingView;
		}
		var _v4 = _v0.c;
		return $author$project$Lists$Distribution$DistributionList$loadingView;
	}
	return $author$project$Lists$Distribution$DistributionList$loadingView;
};
var $author$project$DistributionPoint$IdDict$filter = $timo_weike$generic_collections$ManualDict$filter;
var $author$project$Plan$Supply$findPreSuppliedBy = F2(
	function (preSupplyId, items) {
		var find = function (item) {
			var _v1 = $author$project$Plan$Supply$preSupplyOf(item);
			if (_v1.$ === 1) {
				var id = _v1.a;
				return _Utils_eq(id, preSupplyId) ? A2(
					$elm$core$List$cons,
					item,
					findInChildren(item)) : findInChildren(item);
			} else {
				return findInChildren(item);
			}
		};
		var findInChildren = function (item) {
			if (!item.$) {
				var supplies = item.a.n0;
				return A2($elm$core$List$concatMap, find, supplies);
			} else {
				return _List_Nil;
			}
		};
		return A2($elm$core$List$concatMap, find, items);
	});
var $author$project$Lists$Distribution$PreSupplyList$preSupplyHeader = F4(
	function (date, deliverer, preSupply, pageCounters) {
		return A2(
			$author$project$Print$SizedHtml$listWithSize,
			4,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							'Voordraai ' + $author$project$Date$DeliveryDate$view(date)),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('presupply-page-counter')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Print$Document$simplePageCounter(pageCounters))
								]))
						])),
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Deliverer$Deliverer$nameAndIdView(deliverer))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(preSupply.ft)
						]))
				]));
	});
var $author$project$Lists$Ride$List$ExcludeSupplies = 1;
var $author$project$Lists$Distribution$PreSupplyList$rideListForPreSupply = F7(
	function (distributionPoint, date, products, orders, summaries, preSupplyRide, stops) {
		return {
			nw: _Utils_Tuple2(
				{lE: _List_Nil, ft: preSupplyRide.ft},
				$author$project$Demand$Aggregated$empty),
			nW: A2(
				$elm$core$List$concatMap,
				A6($author$project$Lists$Ride$List$infoFromItem, distributionPoint, date, products, orders, summaries, 1),
				stops)
		};
	});
var $author$project$Lists$Distribution$PreSupplyList$preSupplyView = F8(
	function (distributionPoint, date, items, orders, demandSummaryBySubDPId, products, preSupply, preSupplyAssignment) {
		return A3(
			$author$project$Lists$Ride$List$view,
			{df: 2, nl: 0},
			A3(
				$author$project$Lists$Distribution$PreSupplyList$preSupplyHeader,
				date,
				$author$project$Deliverer$Deliverer$fromTyped(preSupplyAssignment.bl),
				preSupply),
			A7($author$project$Lists$Distribution$PreSupplyList$rideListForPreSupply, distributionPoint, date, products, orders, demandSummaryBySubDPId, preSupply, items));
	});
var $author$project$Lists$Distribution$PreSupplyList$title = F2(
	function (_v0, date) {
		var distributionPoint = _v0;
		var paradiseIdText = A2(
			$elm$core$Maybe$withDefault,
			'(onbekend nr)',
			$author$project$UI$Paradise$idView(distributionPoint));
		return A2(
			$elm$html$Html$header,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Voordraailijst ' + (paradiseIdText + (' ' + distributionPoint.ft)))
						])),
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Date$DeliveryDate$view(date))
						]))
				]));
	});
var $author$project$Lists$Distribution$PreSupplyList$loadedView = F7(
	function (distributionPoint, date, preSupply, items, orders, demandSummaryBySubDPId, products) {
		return $mdgriffith$elm_ui$Element$html(
			A2(
				$elm$html$Html$article,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('distributionlist')
					]),
				A2(
					$elm$core$List$cons,
					A2($author$project$Lists$Distribution$PreSupplyList$title, distributionPoint, date),
					A2(
						$elm$core$List$map,
						function (preSupplyRide) {
							var _v0 = A2(
								$elm_community$list_extra$List$Extra$find,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.eg;
									},
									$elm$core$Basics$eq(preSupplyRide.eg)),
								$author$project$Plan$Plan$preSupplyAssignmentsOf(preSupply));
							if (!_v0.$) {
								var assignment = _v0.a;
								var preSuppliedItems = A2($author$project$Plan$Supply$findPreSuppliedBy, preSupplyRide.eg, items);
								var relevantOrders = A2(
									$author$project$DistributionPoint$DistributionPoint$filterOnSegments,
									orders,
									A2($elm$core$List$concatMap, $author$project$Plan$Supply$ownSegmentsOf, preSuppliedItems));
								var relevantdemandSummaries = function () {
									var subDPIds = A2(
										$elm$core$List$filterMap,
										function (i) {
											if (i.$ === 2) {
												var dpId = i.a.lK;
												return $elm$core$Maybe$Just(dpId);
											} else {
												return $elm$core$Maybe$Nothing;
											}
										},
										preSuppliedItems);
									return A2(
										$author$project$DistributionPoint$IdDict$filter,
										F2(
											function (dpId, _v1) {
												return A2($elm$core$List$member, dpId, subDPIds);
											}),
										demandSummaryBySubDPId);
								}();
								return A8($author$project$Lists$Distribution$PreSupplyList$preSupplyView, distributionPoint, date, preSuppliedItems, relevantOrders, relevantdemandSummaries, products, preSupplyRide, assignment);
							} else {
								return $elm$html$Html$text('');
							}
						},
						$author$project$DistributionPoint$DistributionPoint$preSuppliesOf(distributionPoint)))));
	});
var $author$project$Lists$Distribution$PreSupplyList$loadingView = $mdgriffith$elm_ui$Element$none;
var $author$project$Lists$Distribution$PreSupplyList$problemView = $mdgriffith$elm_ui$Element$text('Er is een onvoorzien probleem opgetreden. Er is geen data om weer te geven.');
var $author$project$Lists$Distribution$PreSupplyList$view = function (model) {
	var _v0 = _Utils_Tuple3(
		model.bn,
		$author$project$Plan$PlanLoader$loadedOf(model.fB),
		_Utils_Tuple2(model.Y, model.bu));
	_v0$1:
	while (true) {
		_v0$3:
		while (true) {
			_v0$4:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.$) {
						switch (_v0.a.$) {
							case 1:
								switch (_v0.c.a.$) {
									case 1:
										switch (_v0.c.b.$) {
											case 1:
												var distributionPoint = _v0.a.a;
												var plan = _v0.b.a.fA;
												var deliverers = _v0.b.a.e4;
												var _v1 = _v0.c;
												var orders = _v1.a.a;
												var products = _v1.b.a;
												var _v2 = _Utils_eq(
													$author$project$DistributionPoint$IdDict$size(model.bm),
													$elm$core$List$length(
														$author$project$DistributionPoint$DistributionPoint$getSubDistributionPoints(distributionPoint)));
												if (_v2) {
													var dels = A3(
														$elm$core$Basics$composeR,
														$author$project$Deliverer$IdDict$values,
														$elm$core$List$map($author$project$Deliverer$Deliverer$fromTyped),
														deliverers);
													var allOrders = _Utils_ap(
														orders,
														A3($author$project$Demand$Extra$orders, plan.gL, dels, products));
													return A7($author$project$Lists$Distribution$PreSupplyList$loadedView, distributionPoint, model.lx, plan.ni, plan.gL, allOrders, model.bm, products);
												} else {
													return $author$project$Lists$Distribution$PreSupplyList$loadingView;
												}
											case 0:
												break _v0$4;
											default:
												break _v0$5;
										}
									case 0:
										break _v0$3;
									default:
										if (!_v0.c.b.$) {
											break _v0$4;
										} else {
											break _v0$5;
										}
								}
							case 0:
								break _v0$1;
							default:
								if (!_v0.c.a.$) {
									break _v0$3;
								} else {
									if (!_v0.c.b.$) {
										break _v0$4;
									} else {
										break _v0$5;
									}
								}
						}
					} else {
						if (!_v0.a.$) {
							break _v0$1;
						} else {
							var _v3 = _v0.b;
							return $author$project$Lists$Distribution$PreSupplyList$loadingView;
						}
					}
				}
				return $author$project$Lists$Distribution$PreSupplyList$problemView;
			}
			var _v5 = _v0.c;
			return $author$project$Lists$Distribution$PreSupplyList$loadingView;
		}
		var _v4 = _v0.c;
		return $author$project$Lists$Distribution$PreSupplyList$loadingView;
	}
	return $author$project$Lists$Distribution$PreSupplyList$loadingView;
};
var $elm$html$Html$Attributes$align = $elm$html$Html$Attributes$stringProperty('align');
var $elm$html$Html$th = _VirtualDom_node('th');
var $author$project$Lists$Received$CheckList$title = F2(
	function (dp, planId) {
		return $author$project$DistributionPoint$DistributionPoint$nameOf(dp) + (' - ' + ($author$project$Date$DeliveryDate$view(planId.lx) + (' - ' + 'Ontvangstcontrolelijst')));
	});
var $author$project$Lists$Received$CheckList$view = function (model) {
	var bundleConfig = A2($author$project$Demand$Bundle$IndividualsAndPacks, 1, 1);
	if (model.$ === 1) {
		var p = model.a;
		var m = model.b;
		return $mdgriffith$elm_ui$Element$html(
			A2(
				$elm$html$Html$article,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('received-checklist')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('received-checklist-print-title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Lists$Received$CheckList$title, m.bn, p.a8))
							])),
						A2(
						$elm$html$Html$table,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('received-checklist-table')
							]),
						_Utils_ap(
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Product')
												])),
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Totaal')
												])),
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Pak/Losse')
												])),
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Te verdelen')
												])),
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Werk')
												]))
										]))
								]),
							A2(
								$elm$core$List$map,
								function (_v1) {
									var name = _v1.ft;
									var total = _v1.dH;
									var bundle = _v1.G;
									var extraForDP = _v1.c7;
									return A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$align('left')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(name)
													])),
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$align('right')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$elm$core$String$fromInt(total))
													])),
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$align('right')
													]),
												A2($author$project$Demand$Bundle$print, bundleConfig, bundle)),
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$align('right')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$elm$core$String$fromInt(total - extraForDP))
													])),
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$align('right')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$elm$core$String$fromInt(extraForDP))
													]))
											]));
								},
								m.h0)))
					])));
	} else {
		return $mdgriffith$elm_ui$Element$none;
	}
};
var $author$project$Sequence$Edit$UserClickedReturn = {$: 11};
var $author$project$UI$LeafletMap$StreetParts = {$: 1};
var $author$project$Sequence$Edit$addMapToDefault = F5(
	function (model, dp, items, orders, segments) {
		return {
			lx: model.lx,
			bo: model.bo,
			fm: A2($author$project$DistributionPoint$DistributionPoint$containsCarSegments, dp, model.j0.nH),
			dg: $author$project$Sequence$Edit$WithMap(
				{w: dp, gL: items, Y: orders, bb: segments, hN: $author$project$UI$LeafletMap$StreetParts}),
			j0: model.j0
		};
	});
var $author$project$UI$Padding$defaultSize = 10;
var $author$project$UI$Padding$default = $mdgriffith$elm_ui$Element$padding($author$project$UI$Padding$defaultSize);
var $author$project$Sequence$Edit$MapMovedTo = function (a) {
	return {$: 9, a: a};
};
var $author$project$UI$LeafletMap$leafletMap = function (attrs) {
	return A3(
		$elm$html$Html$node,
		'leaflet-map',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'block'),
					A2($elm$html$Html$Attributes$style, 'z-index', '1')
				]),
			attrs),
		_List_Nil);
};
var $author$project$Address$Address$Bounds = F2(
	function (northEast, southWest) {
		return {mW: northEast, nP: southWest};
	});
var $author$project$Address$Address$boundsDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Address$Address$Bounds,
	A2($elm$json$Json$Decode$field, 'northEast', $author$project$Address$Address$coordinatesDecoder),
	A2($elm$json$Json$Decode$field, 'southWest', $author$project$Address$Address$coordinatesDecoder));
var $author$project$UI$LeafletMap$onMoved = function (toMsg) {
	return A2(
		$elm$html$Html$Events$on,
		'moved',
		A2(
			$elm$json$Json$Decode$map,
			toMsg,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['detail']),
				$author$project$Address$Address$boundsDecoder)));
};
var $author$project$Demand$Demand$demandAmount = F2(
	function (segmentId, orders) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Y;
					},
					$elm$core$List$length),
				A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.jZ;
						},
						$elm$core$Basics$eq(segmentId)),
					orders)));
	});
var $author$project$DistributionPoint$DistributionPoint$durationFor = function (segment) {
	return $author$project$DistributionPoint$DistributionPoint$segmentInfo(segment).e8;
};
var $author$project$UI$LeafletMap$constructState = F3(
	function (distributionPoint, items, orders) {
		var toState = F2(
			function (deliverer, segmentId) {
				var segment = A2($author$project$DistributionPoint$DistributionPoint$findSegmentOnId, distributionPoint, segmentId);
				return {
					bl: deliverer,
					e5: A2(
						$elm$core$Maybe$map,
						$author$project$Demand$Demand$demandAmount(segmentId),
						orders),
					e8: A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$elm$core$Maybe$map,
							$author$project$DistributionPoint$DistributionPoint$durationFor,
							A2($author$project$DistributionPoint$DistributionPoint$findSegmentOnId, distributionPoint, segmentId))),
					eg: segmentId,
					ft: A2(
						$elm$core$Maybe$withDefault,
						'-',
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.ft;
							},
							A2($elm$core$Maybe$map, $author$project$DistributionPoint$DistributionPoint$segmentInfo, segment))),
					fy: A2(
						$elm$core$Maybe$andThen,
						$author$project$UI$Paradise$idView,
						A2($elm$core$Maybe$map, $author$project$DistributionPoint$DistributionPoint$segmentInfo, segment))
				};
			});
		var openSegmentState = A2(
			$elm$core$List$map,
			function (s) {
				return {
					bl: $elm$core$Maybe$Nothing,
					e5: A2(
						$elm$core$Maybe$map,
						$author$project$Demand$Demand$demandAmount(
							$author$project$DistributionPoint$DistributionPoint$segmentId(s)),
						orders),
					e8: $author$project$DistributionPoint$DistributionPoint$durationFor(s),
					eg: $author$project$DistributionPoint$DistributionPoint$segmentId(s),
					ft: $author$project$DistributionPoint$DistributionPoint$segmentInfo(s).ft,
					fy: $author$project$UI$Paradise$idView(
						$author$project$DistributionPoint$DistributionPoint$segmentInfo(s))
				};
			},
			A2($author$project$Plan$Supply$findOpenSegments, distributionPoint, items));
		var filledSegmentState = A2(
			$elm$core$List$concatMap,
			function (i) {
				return A2(
					$elm$core$List$map,
					function (s) {
						return A2(
							toState,
							$author$project$Plan$Supply$delivererOf(i),
							s);
					},
					$author$project$Plan$Supply$ownSegmentsOf(i));
			},
			items);
		return _Utils_ap(openSegmentState, filledSegmentState);
	});
var $author$project$Deliverer$Colors$toSolidColor = function (color) {
	switch (color) {
		case 0:
			return $tesk9$palette$SolidColor$fromRGB(
				_Utils_Tuple3(74, 153, 255));
		case 1:
			return $tesk9$palette$SolidColor$fromRGB(
				_Utils_Tuple3(255, 187, 0));
		case 2:
			return $tesk9$palette$SolidColor$fromRGB(
				_Utils_Tuple3(0, 205, 116));
		case 3:
			return $tesk9$palette$SolidColor$fromRGB(
				_Utils_Tuple3(255, 112, 76));
		case 4:
			return $tesk9$palette$SolidColor$fromRGB(
				_Utils_Tuple3(148, 103, 189));
		case 5:
			return $tesk9$palette$SolidColor$fromRGB(
				_Utils_Tuple3(199, 122, 70));
		case 6:
			return $tesk9$palette$SolidColor$fromRGB(
				_Utils_Tuple3(255, 117, 177));
		case 7:
			return $tesk9$palette$SolidColor$fromRGB(
				_Utils_Tuple3(122, 134, 154));
		case 8:
			return $tesk9$palette$SolidColor$fromRGB(
				_Utils_Tuple3(188, 188, 34));
		case 9:
			return $tesk9$palette$SolidColor$fromRGB(
				_Utils_Tuple3(23, 190, 207));
		case 10:
			return $tesk9$palette$SolidColor$fromRGB(
				_Utils_Tuple3(0, 82, 204));
		case 11:
			return $tesk9$palette$SolidColor$fromRGB(
				_Utils_Tuple3(255, 121, 0));
		case 12:
			return $tesk9$palette$SolidColor$fromRGB(
				_Utils_Tuple3(0, 116, 66));
		case 13:
			return $tesk9$palette$SolidColor$fromRGB(
				_Utils_Tuple3(214, 40, 40));
		case 14:
			return $tesk9$palette$SolidColor$fromRGB(
				_Utils_Tuple3(82, 48, 138));
		case 15:
			return $tesk9$palette$SolidColor$fromRGB(
				_Utils_Tuple3(119, 70, 37));
		case 16:
			return $tesk9$palette$SolidColor$fromRGB(
				_Utils_Tuple3(204, 67, 136));
		case 19:
			return $tesk9$palette$SolidColor$fromRGB(
				_Utils_Tuple3(64, 74, 90));
		case 18:
			return $tesk9$palette$SolidColor$fromRGB(
				_Utils_Tuple3(102, 102, 0));
		default:
			return $tesk9$palette$SolidColor$fromRGB(
				_Utils_Tuple3(0, 116, 137));
	}
};
var $author$project$Deliverer$Deliverer$solidColorOf = A2($elm$core$Basics$composeR, $author$project$Deliverer$Deliverer$colorOf, $author$project$Deliverer$Colors$toSolidColor);
var $author$project$Deliverer$Colors$unassigned = $tesk9$palette$SolidColor$fromRGB(
	_Utils_Tuple3(69, 19, 18));
var $author$project$Deliverer$Deliverer$solidColorOfMaybe = function (maybeTyped) {
	return A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$Deliverer$Colors$unassigned, $author$project$Deliverer$Deliverer$solidColorOf, maybeTyped);
};
var $author$project$UI$LeafletMap$encodeState = function (_v0) {
	var id = _v0.eg;
	var name = _v0.ft;
	var duration = _v0.e8;
	var demandAmount = _v0.e5;
	var deliverer = _v0.bl;
	var paradiseId = _v0.fy;
	var delivererLabel = function () {
		if (!deliverer.$) {
			if (deliverer.a.$ === 1) {
				var _v2 = deliverer.a;
				return 'Bezorger verlopen';
			} else {
				var d = deliverer.a;
				return $author$project$Deliverer$Deliverer$nameView(
					$author$project$Deliverer$Deliverer$fromTyped(d));
			}
		} else {
			return 'Kies een bezorger';
		}
	}();
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$author$project$DistributionPoint$DistributionPoint$encodeSegmentId(id)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(name)),
				_Utils_Tuple2(
				'duration',
				$elm$json$Json$Encode$int(duration)),
				_Utils_Tuple2(
				'demandAmount',
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$int, demandAmount)),
				_Utils_Tuple2(
				'deliverer',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'id',
							A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								$elm$json$Json$Encode$null,
								A2($elm$core$Basics$composeR, $author$project$Deliverer$Deliverer$idFromTyped, $author$project$Deliverer$Deliverer$encodeId),
								deliverer)),
							_Utils_Tuple2(
							'delivererLabel',
							$elm$json$Json$Encode$string(delivererLabel)),
							_Utils_Tuple2(
							'color',
							$elm$json$Json$Encode$string(
								$tesk9$palette$SolidColor$toRGBString(
									$author$project$Deliverer$Deliverer$solidColorOfMaybe(deliverer))))
						]))),
				_Utils_Tuple2(
				'paradiseId',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, paradiseId)))
			]));
};
var $elm$html$Html$Attributes$property = $elm$virtual_dom$VirtualDom$property;
var $author$project$UI$LeafletMap$segmentState = F3(
	function (distributionPoint, items, orders) {
		return A2(
			$elm$html$Html$Attributes$property,
			'segmentState',
			A2(
				$elm$json$Json$Encode$list,
				$author$project$UI$LeafletMap$encodeState,
				A3($author$project$UI$LeafletMap$constructState, distributionPoint, items, orders)));
	});
var $author$project$DistributionPoint$DistributionPoint$segmentWithoutStreetPartsEncoder = function (segment) {
	if (!segment.$) {
		var contour = segment.a;
		var s = segment.b;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$author$project$DistributionPoint$DistributionPoint$encodeSegmentId(s.eg)),
					_Utils_Tuple2(
					'contour',
					$mgold$elm_geojson$GeoJson$encode(contour))
				]));
	} else {
		var s = segment.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$author$project$DistributionPoint$DistributionPoint$encodeSegmentId(s.eg)),
					_Utils_Tuple2('contour', $elm$json$Json$Encode$null)
				]));
	}
};
var $author$project$UI$LeafletMap$segments = function (segmentGeometries) {
	return A2(
		$elm$html$Html$Attributes$property,
		'segments',
		A2($elm$json$Json$Encode$list, $author$project$DistributionPoint$DistributionPoint$segmentWithoutStreetPartsEncoder, segmentGeometries));
};
var $author$project$Address$Address$suffixToString = function (houseNumber) {
	var _v0 = houseNumber.dE;
	if (!_v0.$) {
		var suffix = _v0.a;
		return suffix;
	} else {
		return '';
	}
};
var $author$project$Sequence$Edit$streetPartInMap = F2(
	function (i, seq) {
		var combinedParts = A2(
			$elm$core$List$sortBy,
			function (a) {
				return _Utils_Tuple2(
					a.bX.bX,
					$author$project$Address$Address$suffixToString(a.bX));
			},
			A2(
				$elm$core$List$concatMap,
				function ($) {
					return $.fD;
				},
				seq.aR));
		var sortedParts = function () {
			var _v0 = seq.cg;
			if (!_v0) {
				return combinedParts;
			} else {
				return $elm$core$List$reverse(combinedParts);
			}
		}();
		return {ml: i + 1, fD: sortedParts};
	});
var $author$project$Address$Address$encodeCoordinates = function (coordinates) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'latitude',
				$elm$json$Json$Encode$float(coordinates.gO)),
				_Utils_Tuple2(
				'longitude',
				$elm$json$Json$Encode$float(coordinates.gR))
			]));
};
var $author$project$Address$Address$encodePostalAddress = function (postalAddress) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'number',
				$author$project$Address$Address$encodeHouseNumber(postalAddress.bX)),
				_Utils_Tuple2(
				'coordinates',
				$author$project$Address$Address$encodeCoordinates(postalAddress.h7))
			]));
};
var $author$project$UI$LeafletMap$encodeStreetPartWithIndex = function (streetPart) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'index',
				$elm$json$Json$Encode$int(streetPart.ml)),
				_Utils_Tuple2(
				'postalAddresses',
				A2($elm$json$Json$Encode$list, $author$project$Address$Address$encodePostalAddress, streetPart.fD))
			]));
};
var $author$project$UI$LeafletMap$streetParts = function (indexedStreetParts) {
	return A2(
		$elm$html$Html$Attributes$property,
		'streetParts',
		A2($elm$json$Json$Encode$list, $author$project$UI$LeafletMap$encodeStreetPartWithIndex, indexedStreetParts));
};
var $author$project$UI$LeafletMap$zoom = function (zoomTo) {
	return A2(
		$elm$html$Html$Attributes$property,
		'zoom',
		function () {
			switch (zoomTo.$) {
				case 0:
					return $elm$json$Json$Encode$string('all');
				case 1:
					return $elm$json$Json$Encode$string('streets');
				default:
					var newBounds = zoomTo.a;
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'northEast',
								$author$project$Address$Address$encodeCoordinates(newBounds.mW)),
								_Utils_Tuple2(
								'southWest',
								$author$project$Address$Address$encodeCoordinates(newBounds.nP))
							]));
			}
		}());
};
var $author$project$Sequence$Edit$clusterMapView = F7(
	function (sequence, dp, items, orders, segments, zoomTo, window) {
		var height = $elm$core$String$fromInt(window.iK) + 'px';
		var filterWithAddresses = function (streetparts) {
			return A2(
				$elm$core$List$filter,
				function (i) {
					return !$elm$core$List$isEmpty(i.fD);
				},
				streetparts);
		};
		return $author$project$UI$LeafletMap$leafletMap(
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'height', height),
					$author$project$UI$LeafletMap$segments(segments),
					A3(
					$author$project$UI$LeafletMap$segmentState,
					dp,
					$author$project$Plan$Supply$flatten(items),
					$elm$core$Maybe$Just(orders)),
					$author$project$UI$LeafletMap$zoom(zoomTo),
					$author$project$UI$LeafletMap$onMoved($author$project$Sequence$Edit$MapMovedTo),
					$author$project$UI$LeafletMap$streetParts(
					filterWithAddresses(
						A2($elm$core$List$indexedMap, $author$project$Sequence$Edit$streetPartInMap, sequence.gL)))
				]));
	});
var $author$project$Sequence$Edit$contentPadding = 2;
var $ir4y$elm_dnd$DnD$px = function (number) {
	return $elm$core$String$fromInt(number) + 'px';
};
var $ir4y$elm_dnd$DnD$draggedStyle = function (position) {
	return _List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
			A2(
			$elm$html$Html$Attributes$style,
			'left',
			$ir4y$elm_dnd$DnD$px(position.ay + 10)),
			A2(
			$elm$html$Html$Attributes$style,
			'top',
			$ir4y$elm_dnd$DnD$px(position.bg + 10))
		]);
};
var $ir4y$elm_dnd$DnD$dragged = F2(
	function (_v0, view) {
		var model = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$text(''),
			A2(
				$elm$core$Maybe$map,
				function (_v1) {
					var dragMeta = _v1.e7;
					var position = _v1.fC;
					return A2(
						$elm$html$Html$div,
						$ir4y$elm_dnd$DnD$draggedStyle(position),
						_List_fromArray(
							[
								view(dragMeta)
							]));
				},
				model));
	});
var $author$project$Sequence$Edit$ReverseDirection = function (a) {
	return {$: 3, a: a};
};
var $author$project$Sequence$Edit$streetOf = function (sequenceItem) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.b5;
				},
				$elm$core$String$toLower),
			$elm$core$List$head(sequenceItem.aR)));
};
var $author$project$Sequence$Interval$Interval = F3(
	function (start, end, side) {
		return {gu: end, o: side, hq: start};
	});
var $author$project$Sequence$StreetPart$lastNumberOf = function (_v0) {
	var postalAddresses = _v0.fD;
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.bX;
		},
		$elm$core$List$head(
			$elm$core$List$reverse(postalAddresses)));
};
var $author$project$Address$Address$Both = 2;
var $author$project$Address$Address$Even = 0;
var $author$project$Address$Address$Odd = 1;
var $author$project$Address$Address$sideOf = function (houseNumber) {
	var _v0 = A2($elm$core$Basics$modBy, 2, houseNumber.bX);
	if (!_v0) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Sequence$StreetPart$streetSideOf = function (_v0) {
	var postalAddresses = _v0.fD;
	var streetSides = A2(
		$elm$core$List$map,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.bX;
			},
			$author$project$Address$Address$sideOf),
		postalAddresses);
	var _v1 = _Utils_Tuple2(
		A2($elm$core$List$member, 1, streetSides),
		A2($elm$core$List$member, 0, streetSides));
	if (!_v1.a) {
		if (!_v1.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Just(0);
		}
	} else {
		if (!_v1.b) {
			return $elm$core$Maybe$Just(1);
		} else {
			return $elm$core$Maybe$Just(2);
		}
	}
};
var $author$project$Sequence$Interval$fromStreetPart = function (streetPart) {
	var _v0 = _Utils_Tuple3(
		$author$project$Sequence$StreetPart$firstNumberOf(streetPart),
		$author$project$Sequence$StreetPart$lastNumberOf(streetPart),
		$author$project$Sequence$StreetPart$streetSideOf(streetPart));
	if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
		var firstNumber = _v0.a.a;
		var lastNumber = _v0.b.a;
		var side = _v0.c.a;
		return $elm$core$Maybe$Just(
			A3($author$project$Sequence$Interval$Interval, firstNumber, lastNumber, side));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Sequence$Interval$isAdjacentSameSide = F2(
	function (first, second) {
		var diff = function () {
			var _v0 = first.o;
			switch (_v0) {
				case 1:
					return 2;
				case 0:
					return 2;
				default:
					return 1;
			}
		}();
		return _Utils_eq(first.gu.bX + diff, second.hq.bX);
	});
var $author$project$Sequence$Interval$nextHouseNumber = function (houseNumber) {
	return A2($author$project$Address$Address$HouseNumber, houseNumber.bX + 1, $elm$core$Maybe$Nothing);
};
var $author$project$Sequence$Interval$joinIntervalDifferentSide = F2(
	function (first, second) {
		return _Utils_eq(first.gu.bX + 1, second.gu.bX) ? _Utils_Tuple2(
			_List_Nil,
			{gu: second.gu, o: 2, hq: first.hq}) : (_Utils_eq(second.gu.bX + 1, first.gu.bX) ? _Utils_Tuple2(
			_List_Nil,
			{gu: first.gu, o: 2, hq: first.hq}) : ((_Utils_cmp(first.gu.bX, second.gu.bX) < 0) ? _Utils_Tuple2(
			_List_fromArray(
				[
					{gu: first.gu, o: 2, hq: first.hq}
				]),
			{
				gu: second.gu,
				o: second.o,
				hq: $author$project$Sequence$Interval$nextHouseNumber(first.gu)
			}) : _Utils_Tuple2(
			_List_fromArray(
				[
					{gu: second.gu, o: 2, hq: first.hq}
				]),
			{
				gu: first.gu,
				o: first.o,
				hq: $author$project$Sequence$Interval$nextHouseNumber(second.gu)
			})));
	});
var $author$project$Sequence$Interval$joinInterval = F2(
	function (first, second) {
		var _v0 = _Utils_Tuple3(
			first.o,
			second.o,
			A2($author$project$Sequence$Interval$isAdjacentSameSide, first, second));
		_v0$8:
		while (true) {
			switch (_v0.a) {
				case 2:
					if (_v0.b === 2) {
						if (_v0.c) {
							var _v9 = _v0.a;
							var _v10 = _v0.b;
							return _Utils_Tuple2(
								_List_Nil,
								{gu: second.gu, o: first.o, hq: first.hq});
						} else {
							var _v11 = _v0.a;
							var _v12 = _v0.b;
							return _Utils_Tuple2(
								_List_fromArray(
									[first]),
								second);
						}
					} else {
						break _v0$8;
					}
				case 1:
					switch (_v0.b) {
						case 1:
							if (_v0.c) {
								var _v1 = _v0.a;
								var _v2 = _v0.b;
								return _Utils_Tuple2(
									_List_Nil,
									{gu: second.gu, o: first.o, hq: first.hq});
							} else {
								var _v3 = _v0.a;
								var _v4 = _v0.b;
								return _Utils_Tuple2(
									_List_fromArray(
										[first]),
									second);
							}
						case 0:
							var _v13 = _v0.a;
							var _v14 = _v0.b;
							return A2($author$project$Sequence$Interval$joinIntervalDifferentSide, first, second);
						default:
							break _v0$8;
					}
				default:
					switch (_v0.b) {
						case 0:
							if (_v0.c) {
								var _v5 = _v0.a;
								var _v6 = _v0.b;
								return _Utils_Tuple2(
									_List_Nil,
									{gu: second.gu, o: first.o, hq: first.hq});
							} else {
								var _v7 = _v0.a;
								var _v8 = _v0.b;
								return _Utils_Tuple2(
									_List_fromArray(
										[first]),
									second);
							}
						case 1:
							var _v15 = _v0.a;
							var _v16 = _v0.b;
							return A2($author$project$Sequence$Interval$joinIntervalDifferentSide, first, second);
						default:
							break _v0$8;
					}
			}
		}
		return _Utils_Tuple2(
			_List_fromArray(
				[first]),
			second);
	});
var $author$project$Sequence$Interval$secondPass = function (_v0) {
	var list = _v0.a;
	var last = _v0.b;
	return function (_v2) {
		var first = _v2.a;
		var soFar = _v2.b;
		return A2($elm$core$List$cons, first, soFar);
	}(
		A3(
			$elm$core$List$foldr,
			F2(
				function (i, _v1) {
					var first = _v1.a;
					var soFar = _v1.b;
					return (_Utils_eq(i.o, first.o) && A2($author$project$Sequence$Interval$isAdjacentSameSide, i, first)) ? _Utils_Tuple2(
						{gu: first.gu, o: i.o, hq: i.hq},
						soFar) : _Utils_Tuple2(
						i,
						A2($elm$core$List$cons, first, soFar));
				}),
			_Utils_Tuple2(last, _List_Nil),
			list));
};
var $author$project$Sequence$Interval$fromStreetParts = function (streetParts) {
	var ungrouped = A2(
		$elm$core$List$sortBy,
		function (p) {
			return _Utils_Tuple2(
				p.hq.bX,
				$author$project$Address$Address$suffixToString(p.hq));
		},
		A2($elm$core$List$filterMap, $author$project$Sequence$Interval$fromStreetPart, streetParts));
	if (!ungrouped.b) {
		return _List_Nil;
	} else {
		var head = ungrouped.a;
		var tail = ungrouped.b;
		return $author$project$Sequence$Interval$secondPass(
			A3(
				$elm$core$List$foldl,
				F2(
					function (i, _v1) {
						var soFar = _v1.a;
						var last = _v1.b;
						var _v2 = A2($author$project$Sequence$Interval$joinInterval, last, i);
						var joined = _v2.a;
						var newLast = _v2.b;
						return _Utils_Tuple2(
							_Utils_ap(soFar, joined),
							newLast);
					}),
				_Utils_Tuple2(_List_Nil, head),
				tail));
	}
};
var $author$project$Sequence$Edit$printFromTo = F3(
	function (from, to, directionIcon) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(from)
					])),
				directionIcon,
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('number-last')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(to)
					]))
			]);
	});
var $author$project$Sequence$Edit$printSingle = function (number) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('number-last')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(number)
				]))
		]);
};
var $author$project$Sequence$Interval$DoubleSides = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Sequence$Interval$SingleNumber = function (a) {
	return {$: 0, a: a};
};
var $author$project$Sequence$Interval$SingleSide = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Sequence$Interval$previousHouseNumber = function (houseNumber) {
	return A2($author$project$Address$Address$HouseNumber, houseNumber.bX - 1, $elm$core$Maybe$Nothing);
};
var $author$project$Sequence$Interval$view = function (_v0) {
	var start = _v0.hq;
	var end = _v0.gu;
	var side = _v0.o;
	if (_Utils_eq(start, end)) {
		return $author$project$Sequence$Interval$SingleNumber(start);
	} else {
		switch (side) {
			case 0:
				return A2($author$project$Sequence$Interval$SingleSide, start, end);
			case 1:
				return A2($author$project$Sequence$Interval$SingleSide, start, end);
			default:
				return A2(
					$author$project$Sequence$Interval$DoubleSides,
					_Utils_Tuple2(
						start,
						$author$project$Sequence$Interval$nextHouseNumber(start)),
					_Utils_Tuple2(
						$author$project$Sequence$Interval$previousHouseNumber(end),
						end));
		}
	}
};
var $author$project$Sequence$StreetPart$defaultWidthAndHeight = function (attributes) {
	return _Utils_ap(
		attributes,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$height('16px'),
				$elm$svg$Svg$Attributes$preserveAspectRatio('xMidYMid meet'),
				$elm$svg$Svg$Attributes$viewBox('0 0 20 20'),
				$elm$svg$Svg$Attributes$width('16px'),
				$elm$svg$Svg$Attributes$cursor('pointer')
			]));
};
var $author$project$Sequence$StreetPart$staircase = A2(
	$elm$svg$Svg$path,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$d('M2,17 l4,0 l0,-4 l4,0 l0,-4 l4,0 l0,-4 l4,0'),
			$elm$svg$Svg$Attributes$stroke('#007bff'),
			$elm$svg$Svg$Attributes$fill('white'),
			$elm$svg$Svg$Attributes$strokeWidth('1.2')
		]),
	_List_Nil);
var $author$project$Sequence$StreetPart$ascendingIcon = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		$author$project$Sequence$StreetPart$defaultWidthAndHeight(attributes),
		_List_fromArray(
			[$author$project$Sequence$StreetPart$staircase]));
};
var $author$project$Sequence$StreetPart$descendingIcon = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		$author$project$Sequence$StreetPart$defaultWidthAndHeight(attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$transform('scale(1,-1) translate(0,-21)')
					]),
				_List_fromArray(
					[$author$project$Sequence$StreetPart$staircase]))
			]));
};
var $author$project$Sequence$StreetPart$viewDirectionIcon = F2(
	function (direction, message) {
		if (!direction) {
			return $author$project$Sequence$StreetPart$ascendingIcon(
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(message)
					]));
		} else {
			return $author$project$Sequence$StreetPart$descendingIcon(
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(message)
					]));
		}
	});
var $author$project$Sequence$Edit$viewNumber = F3(
	function (direction, directionMsg, interval) {
		var viewHouseNumbers = F2(
			function (n1, n2) {
				return $author$project$Address$Address$houseNumberView(n1) + (',' + $author$project$Address$Address$houseNumberView(n2));
			});
		var _v0 = _Utils_Tuple2(
			$author$project$Sequence$Interval$view(interval),
			direction);
		switch (_v0.a.$) {
			case 0:
				var number = _v0.a.a;
				return $author$project$Sequence$Edit$printSingle(
					$author$project$Address$Address$houseNumberView(number));
			case 1:
				if (!_v0.b) {
					var _v1 = _v0.a;
					var lowest = _v1.a;
					var highest = _v1.b;
					var _v2 = _v0.b;
					return A3(
						$author$project$Sequence$Edit$printFromTo,
						$author$project$Address$Address$houseNumberView(lowest),
						$author$project$Address$Address$houseNumberView(highest),
						A2($author$project$Sequence$StreetPart$viewDirectionIcon, 0, directionMsg));
				} else {
					var _v3 = _v0.a;
					var lowest = _v3.a;
					var highest = _v3.b;
					var _v4 = _v0.b;
					return A3(
						$author$project$Sequence$Edit$printFromTo,
						$author$project$Address$Address$houseNumberView(highest),
						$author$project$Address$Address$houseNumberView(lowest),
						A2($author$project$Sequence$StreetPart$viewDirectionIcon, 1, directionMsg));
				}
			default:
				if (!_v0.b) {
					var _v5 = _v0.a;
					var _v6 = _v5.a;
					var lowest = _v6.a;
					var secondLowest = _v6.b;
					var _v7 = _v5.b;
					var secondHighest = _v7.a;
					var highest = _v7.b;
					var _v8 = _v0.b;
					return A3(
						$author$project$Sequence$Edit$printFromTo,
						A2(viewHouseNumbers, lowest, secondLowest),
						A2(viewHouseNumbers, secondHighest, highest),
						A2($author$project$Sequence$StreetPart$viewDirectionIcon, 0, directionMsg));
				} else {
					var _v9 = _v0.a;
					var _v10 = _v9.a;
					var lowest = _v10.a;
					var secondLowest = _v10.b;
					var _v11 = _v9.b;
					var secondHighest = _v11.a;
					var highest = _v11.b;
					var _v12 = _v0.b;
					return A3(
						$author$project$Sequence$Edit$printFromTo,
						A2(viewHouseNumbers, highest, secondHighest),
						A2(viewHouseNumbers, secondLowest, lowest),
						A2($author$project$Sequence$StreetPart$viewDirectionIcon, 1, directionMsg));
				}
		}
	});
var $author$project$Sequence$Edit$viewItemNumbers = F2(
	function (sequenceItem, directionMsg) {
		var intervals = $author$project$Sequence$Interval$fromStreetParts(sequenceItem.aR);
		var sortedIntervals = function () {
			var _v0 = sequenceItem.cg;
			if (!_v0) {
				return intervals;
			} else {
				return $elm$core$List$reverse(intervals);
			}
		}();
		return A2(
			$elm$core$List$concatMap,
			A2($author$project$Sequence$Edit$viewNumber, sequenceItem.cg, directionMsg),
			sortedIntervals);
	});
var $author$project$Sequence$Edit$draggedView = function (_v0) {
	var index = _v0.a;
	var sequenceItem = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('sequence-street-part sequence-street-part-dragging')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('street-part-index')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(index + 1))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Sequence$Edit$streetOf(sequenceItem))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('street-part-numbers')
					]),
				A2(
					$author$project$Sequence$Edit$viewItemNumbers,
					sequenceItem,
					$author$project$Sequence$Edit$ReverseDirection(index)))
			]));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $elm$html$Html$Keyed$ol = $elm$html$Html$Keyed$node('ol');
var $ir4y$elm_dnd$DnD$getDragMeta = function (_v0) {
	var d = _v0;
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.e7;
		},
		d);
};
var $ir4y$elm_dnd$DnD$getDropMeta = function (_v0) {
	var d = _v0;
	return A2(
		$elm$core$Maybe$andThen,
		function ($) {
			return $.d4;
		},
		d);
};
var $author$project$Sequence$Edit$htmlKey = function (sequenceItem) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (streetPart) {
				return _Utils_ap(
					streetPart.cT,
					A2(
						$elm$core$Maybe$withDefault,
						'0',
						A2(
							$elm$core$Maybe$map,
							function (postalAddress) {
								return _Utils_ap(
									$elm$core$String$fromInt(postalAddress.bX.bX),
									$author$project$Address$Address$suffixToString(postalAddress.bX));
							},
							$elm$core$List$head(streetPart.fD))));
			},
			$elm$core$List$head(sequenceItem.aR)));
};
var $author$project$Sequence$Edit$streetPartDrop = function (index) {
	return A3(
		$author$project$Sequence$Edit$dnd.iq,
		index,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('sequence-street-part-drop'),
				$elm$html$Html$Attributes$class('sequence-street-part-drop-potential')
			]),
		_List_Nil);
};
var $author$project$Sequence$Edit$JoinWithPrevious = function (a) {
	return {$: 4, a: a};
};
var $author$project$Sequence$Edit$Separate = function (a) {
	return {$: 5, a: a};
};
var $author$project$Sequence$Edit$ToggleRouteCutPoint = function (a) {
	return {$: 6, a: a};
};
var $icidasset$elm_material_icons$Material$Icons$drag_indicator = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0V0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z')
				]),
			_List_Nil)
		]));
var $author$project$Sequence$Edit$iconFor = F2(
	function (icon, color) {
		return icon(
			$icidasset$elm_material_icons$Material$Icons$Types$Color(
				function (_v0) {
					var r = _v0.a;
					var g = _v0.b;
					var b = _v0.c;
					return A3(
						$avh4$elm_color$Color$rgb255,
						$elm$core$Basics$round(r),
						$elm$core$Basics$round(g),
						$elm$core$Basics$round(b));
				}(
					$tesk9$palette$SolidColor$toRGB(color))));
	});
var $author$project$Sequence$Edit$defaultWidthAndHeight = function (attributes) {
	return _Utils_ap(
		attributes,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$height('16px'),
				$elm$svg$Svg$Attributes$preserveAspectRatio('xMidYMid meet'),
				$elm$svg$Svg$Attributes$viewBox('0 0 20 20'),
				$elm$svg$Svg$Attributes$width('16px'),
				$elm$svg$Svg$Attributes$cursor('pointer')
			]));
};
var $author$project$Sequence$Edit$iconColor = '#007bff';
var $author$project$Sequence$Edit$joinWithPreviousIcon = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		$author$project$Sequence$Edit$defaultWidthAndHeight(attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$line,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$x1('0'),
						$elm$svg$Svg$Attributes$y1('3'),
						$elm$svg$Svg$Attributes$x2('20'),
						$elm$svg$Svg$Attributes$y2('3'),
						$elm$svg$Svg$Attributes$stroke($author$project$Sequence$Edit$iconColor),
						$elm$svg$Svg$Attributes$strokeWidth('2')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M0,14 h2 c2,0 9,1 12,-9 M10,7.5 l4,-2.5 l2.5,3.5'),
						$elm$svg$Svg$Attributes$stroke($author$project$Sequence$Edit$iconColor),
						$elm$svg$Svg$Attributes$strokeWidth('2'),
						$elm$svg$Svg$Attributes$fill('none')
					]),
				_List_Nil)
			]));
};
var $author$project$Sequence$Edit$scissorsCutIcon = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		$author$project$Sequence$Edit$defaultWidthAndHeight(attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('m 17.776086,11.647333 0.01264,-0.01636 h -0.02515 C 16.847034,11.175759 15.378039,10.411938 14.775396,10.021845 14.385903,9.7781986 14.147845,9.3717446 13.984143,8.9490926 14.147721,8.5432814 14.385903,8.1368293 14.775396,7.8768204 15.378039,7.4865699 16.847034,6.7229071 17.763574,6.2676931 h 0.01264 C 18.60501,5.8288421 18.994379,4.6261666 18.66784,3.5538973 18.341052,2.4811447 17.399848,1.9608086 16.571045,2.3836224 15.742118,2.8057922 15.340233,4.0246697 15.66702,5.0974203 c 0.08762,0.309091 0.238181,0.5689381 0.401761,0.7638239 L 13.268596,7.3080473 C 11.761432,6.8204331 7.0653332,5.2924666 5.960427,5.0975808 4.6419996,4.8539337 4.0519975,5.8614035 4.0519975,5.8614035 l 6.2562075,3.0601691 v 0 L 4.0519975,12.037748 c 0,0 0.5901267,1.007309 1.9084295,0.779861 1.1049062,-0.195367 5.801005,-1.722689 7.308167,-2.226664 l 2.800187,1.446803 c -0.16358,0.211086 -0.314147,0.470933 -0.401761,0.763822 -0.326787,1.072753 0.07497,2.291628 0.904023,2.7138 0.828805,0.438852 1.770009,-0.09736 2.096797,-1.170114 0.326539,-1.056231 -0.06295,-2.275268 -0.891759,-2.697921 z M 16.834388,3.2448049 c 0.464716,-0.2438064 0.991887,0.048599 1.180625,0.6499386 0.175476,0.6013383 -0.05031,1.2839995 -0.51478,1.5279665 -0.464716,0.227286 -0.991888,-0.064802 -1.168108,-0.6662997 -0.187993,-0.6011778 0.03779,-1.2843195 0.502263,-1.5116054 z m -4.319245,5.9322157 c -0.100502,0.292248 -0.364213,0.438854 -0.590126,0.308609 -0.226284,-0.130084 -0.326539,-0.471094 -0.238925,-0.763822 0.100502,-0.2922486 0.364213,-0.4228143 0.590621,-0.3084501 0.225914,0.1299249 0.338684,0.4709341 0.23843,0.7636631 z m 5.49987,4.8270624 c -0.188738,0.601339 -0.715909,0.893586 -1.180625,0.666141 -0.464466,-0.243969 -0.690256,-0.926628 -0.502263,-1.527806 0.17622,-0.601499 0.703392,-0.893585 1.168108,-0.6501 0.464465,0.243968 0.690256,0.910428 0.51478,1.511765 z'),
						$elm$svg$Svg$Attributes$stroke($author$project$Sequence$Edit$iconColor),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fill($author$project$Sequence$Edit$iconColor)
					]),
				_List_Nil)
			]));
};
var $author$project$Sequence$Edit$scissorsPasteIcon = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		$author$project$Sequence$Edit$defaultWidthAndHeight(attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('m 18.176801,4.4335938 c 0.753173,0.093126 1.287218,0.8345288 1.236328,1.8144531 -0.05823,1.1193742 -0.833002,2.11775 -1.761719,2.2480469 l -0.01172,-0.00391 c -1.016787,0.115798 -2.657888,0.3325011 -3.357421,0.4941406 -0.02058,0.00506 -0.03839,0.015665 -0.05859,0.021484 0.01546,0.00361 0.02926,0.010504 0.04492,0.013672 0.705631,0.1325042 2.354287,0.2819178 3.375,0.3554687 l 0.01172,-0.00586 c 0.93332,0.091692 1.750892,1.0578302 1.855469,2.1738282 0.104529,1.11654 -0.568851,1.953805 -1.496094,1.876953 -0.927116,-0.07619 -1.762657,-1.051432 -1.867187,-2.167969 -0.03617,-0.319228 0.0046,-0.617006 0.08203,-0.859375 l -3.138672,-0.27539 -0.263672,-0.0293 -0.886718,0.935547 C 10.351774,10.985854 5.416945,10.823531 4.311566,10.630859 2.994624,10.395662 2.78227,9.2460938 2.78227,9.2460938 l 0.037109,-0.00391 -0.050781,-0.00391 c 0,0 0.164642,-1.1557279 1.470703,-1.4453124 1.096443,-0.2383262 6.019774,-0.6055811 7.605469,-0.7109376 l 0.929687,0.9003907 0.285156,-0.042969 3.125,-0.40625 C 16.097203,7.294252 16.044526,6.9981874 16.067426,6.6777344 c 0.05816,-1.1199112 0.85028,-2.1295678 1.773437,-2.2441406 0.115408,-0.014403 0.228342,-0.013304 0.335938,0 z m -0.38086,0.9003906 c -0.514116,0.055484 -0.960261,0.6207378 -0.988281,1.25 -0.0392,0.6255528 0.356749,1.0788395 0.871094,1.0234375 0.519794,-0.071169 0.966009,-0.6365693 1.005859,-1.2617188 0.02738,-0.629668 -0.3687,-1.0826527 -0.888672,-1.0117187 z m -6.36914,3.1914062 c -0.119098,0.01522 -0.240872,0.082856 -0.337891,0.203125 -0.08244,0.1111013 -0.126659,0.2455787 -0.140625,0.3769532 0.02599,0.1085521 0.07008,0.2150077 0.142578,0.3046874 0.135546,0.1544606 0.30796,0.2066918 0.458985,0.1738282 6.31e-4,-1.374e-4 0.0013,1.407e-4 0.002,0 0.05784,-0.035211 0.1136,-0.084397 0.162109,-0.1445313 0.08035,-0.099857 0.121016,-0.2212129 0.138672,-0.3417969 -0.0091,-0.1488973 -0.06272,-0.3016335 -0.167969,-0.421875 -0.05646,-0.064336 -0.121359,-0.1093739 -0.1875,-0.1425781 -0.02368,-0.00129 -0.0462,-0.010894 -0.07031,-0.00781 z m 6.294922,1.7324214 c -0.5162,-0.03403 -0.893223,0.437157 -0.828125,1.060547 0.05408,0.62756 0.521135,1.172907 1.037109,1.207032 0.522466,0.04932 0.899158,-0.420839 0.845703,-1.048829 -0.06573,-0.62296 -0.532389,-1.169189 -1.054687,-1.21875 z'),
						$elm$svg$Svg$Attributes$stroke($author$project$Sequence$Edit$iconColor),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fill($author$project$Sequence$Edit$iconColor)
					]),
				_List_Nil)
			]));
};
var $author$project$Sequence$Edit$separateIcon = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		$author$project$Sequence$Edit$defaultWidthAndHeight(attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$line,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$x1('0'),
						$elm$svg$Svg$Attributes$y1('10'),
						$elm$svg$Svg$Attributes$x2('7'),
						$elm$svg$Svg$Attributes$y2('10'),
						$elm$svg$Svg$Attributes$stroke($author$project$Sequence$Edit$iconColor),
						$elm$svg$Svg$Attributes$strokeWidth('2')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M7,10 c2,0 0,-5 8,-4 M13,3 l3,3 l-3,3'),
						$elm$svg$Svg$Attributes$stroke($author$project$Sequence$Edit$iconColor),
						$elm$svg$Svg$Attributes$strokeWidth('2'),
						$elm$svg$Svg$Attributes$fill('none')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M7,10 c2,0 0,5 8,4 M13,11 l3,3 l-3,3'),
						$elm$svg$Svg$Attributes$stroke($author$project$Sequence$Edit$iconColor),
						$elm$svg$Svg$Attributes$strokeWidth('2'),
						$elm$svg$Svg$Attributes$fill('none')
					]),
				_List_Nil)
			]));
};
var $author$project$Sequence$Edit$streetPartSequenceView = F5(
	function (dragging, index, dropIndex, sequenceItem, isLR) {
		var textElement = dragging ? $elm$html$Html$div : $author$project$Sequence$Edit$dnd.bo(
			_Utils_Tuple2(index, sequenceItem));
		var streetPartClass = sequenceItem.e0 ? $elm$html$Html$Attributes$class('sequence-street-part with-cut-point') : $elm$html$Html$Attributes$class('sequence-street-part');
		var scissorButton = function () {
			var _v1 = _Utils_Tuple2(isLR, sequenceItem.e0);
			if (_v1.a) {
				if (_v1.b) {
					return _List_fromArray(
						[
							$author$project$Sequence$Edit$scissorsPasteIcon(
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Sequence$Edit$ToggleRouteCutPoint(index)),
									$elm$html$Html$Attributes$title('Looplijst splitsing verwijderen')
								]))
						]);
				} else {
					return _List_fromArray(
						[
							$author$project$Sequence$Edit$scissorsCutIcon(
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Sequence$Edit$ToggleRouteCutPoint(index)),
									$elm$html$Html$Attributes$title('Looplijst splitsen')
								]))
						]);
				}
			} else {
				return _List_Nil;
			}
		}();
		var joinButton = function () {
			var _v0 = sequenceItem.mC;
			if (!_v0) {
				return _List_fromArray(
					[
						$author$project$Sequence$Edit$joinWithPreviousIcon(
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$Sequence$Edit$JoinWithPrevious(index)),
								$elm$html$Html$Attributes$title('Voeg straatdelen samen')
							]))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var grouped = $elm$core$List$length(sequenceItem.aR) > 1;
		var separateButton = grouped ? _List_fromArray(
			[
				$author$project$Sequence$Edit$separateIcon(
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$Sequence$Edit$Separate(index)),
						$elm$html$Html$Attributes$title('Splits straatdeel')
					]))
			]) : _List_Nil;
		var element = dragging ? $author$project$Sequence$Edit$dnd.iq(dropIndex) : $elm$html$Html$div;
		return A2(
			element,
			_List_fromArray(
				[streetPartClass]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						textElement,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('street-part-drag-handle')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Sequence$Edit$iconFor,
								$icidasset$elm_material_icons$Material$Icons$drag_indicator(14),
								$author$project$UI$Palette$base0)
							])),
						A2(
						textElement,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('street-part-index')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(index + 1))
							])),
						A2(
						textElement,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('street-part-name')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Sequence$Edit$streetOf(sequenceItem))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('street-part-numbers')
							]),
						A2(
							$author$project$Sequence$Edit$viewItemNumbers,
							sequenceItem,
							$author$project$Sequence$Edit$ReverseDirection(index)))
					]),
				_Utils_ap(
					separateButton,
					_Utils_ap(joinButton, scissorButton))));
	});
var $author$project$Sequence$Edit$removeDragAndAddDrop = F5(
	function (isLR, draggable, index, sequenceItem, _v0) {
		var _v1 = _v0.a;
		var dropIndex = _v1.a;
		var visitedDragging = _v1.b;
		var list = _v0.b;
		var droppingIndex = $ir4y$elm_dnd$DnD$getDropMeta(draggable);
		var draggingIndex = A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$first,
			$ir4y$elm_dnd$DnD$getDragMeta(draggable));
		var dragging = !_Utils_eq(draggingIndex, $elm$core$Maybe$Nothing);
		var itemView = function (realDropIndex) {
			return _Utils_Tuple2(
				$author$project$Sequence$Edit$htmlKey(sequenceItem),
				A5($author$project$Sequence$Edit$streetPartSequenceView, dragging, index, realDropIndex, sequenceItem, isLR));
		};
		var _v2 = _Utils_Tuple3(
			_Utils_eq(
				draggingIndex,
				$elm$core$Maybe$Just(index)),
			_Utils_eq(
				droppingIndex,
				$elm$core$Maybe$Just(index)),
			visitedDragging);
		if (!_v2.a) {
			if (!_v2.b) {
				return _Utils_Tuple2(
					_Utils_Tuple2(dropIndex - 1, visitedDragging),
					A2(
						$elm$core$List$cons,
						itemView(dropIndex),
						list));
			} else {
				if (_v2.c) {
					return _Utils_Tuple2(
						_Utils_Tuple2(dropIndex - 2, visitedDragging),
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'drop',
								$author$project$Sequence$Edit$streetPartDrop(dropIndex - 1)),
							A2(
								$elm$core$List$cons,
								itemView(dropIndex),
								list)));
				} else {
					return _Utils_Tuple2(
						_Utils_Tuple2(dropIndex - 2, visitedDragging),
						A2(
							$elm$core$List$cons,
							itemView(dropIndex - 1),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'drop',
									$author$project$Sequence$Edit$streetPartDrop(dropIndex)),
								list)));
				}
			}
		} else {
			if (!_v2.b) {
				return _Utils_eq(droppingIndex, $elm$core$Maybe$Nothing) ? _Utils_Tuple2(
					_Utils_Tuple2(dropIndex - 1, true),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'drop',
							$author$project$Sequence$Edit$streetPartDrop(dropIndex)),
						list)) : _Utils_Tuple2(
					_Utils_Tuple2(dropIndex, true),
					list);
			} else {
				return _Utils_Tuple2(
					_Utils_Tuple2(dropIndex - 1, true),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'drop',
							$author$project$Sequence$Edit$streetPartDrop(dropIndex)),
						list));
			}
		}
	});
var $author$project$Sequence$Edit$sequenceView = F4(
	function (isLR, window, sequence, draggable) {
		var streetPartViews = A3(
			$elm_community$list_extra$List$Extra$indexedFoldr,
			A2($author$project$Sequence$Edit$removeDragAndAddDrop, isLR, draggable),
			_Utils_Tuple2(
				_Utils_Tuple2(
					$elm$core$List$length(sequence.gL) - 1,
					false),
				_List_Nil),
			sequence.gL).b;
		var height = $elm$core$String$fromInt(window.iK - 32) + 'px';
		return A2(
			$elm$html$Html$Keyed$ol,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sequence'),
					A2($elm$html$Html$Attributes$style, 'width', '100%'),
					A2($elm$html$Html$Attributes$style, 'height', height),
					A2($elm$html$Html$Attributes$style, 'margin-bottom', '0')
				]),
			_Utils_ap(
				streetPartViews,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'drag',
						A2($ir4y$elm_dnd$DnD$dragged, draggable, $author$project$Sequence$Edit$draggedView))
					])));
	});
var $author$project$Sequence$Edit$view = F3(
	function (window, sequenceTitle, _v0) {
		var draggable = _v0.bo;
		var map = _v0.dg;
		var sequence = _v0.j0;
		var isLR = _v0.fm;
		if (!map.$) {
			return A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$padding($author$project$Sequence$Edit$contentPadding),
						$mdgriffith$elm_ui$Element$spacing(5),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				$mdgriffith$elm_ui$Element$html(
					A4($author$project$Sequence$Edit$sequenceView, isLR, window, sequence, draggable)));
		} else {
			var dp = map.a.w;
			var items = map.a.gL;
			var orders = map.a.Y;
			var segments = map.a.bb;
			var zoomTo = map.a.hN;
			return A2(
				$mdgriffith$elm_ui$Element$row,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$padding($author$project$Sequence$Edit$contentPadding),
						$mdgriffith$elm_ui$Element$spacing(5),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$column,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width(
								$mdgriffith$elm_ui$Element$fillPortion(1)),
								$mdgriffith$elm_ui$Element$height(
								$mdgriffith$elm_ui$Element$px(window.iK))
							]),
						_List_fromArray(
							[
								sequenceTitle,
								$mdgriffith$elm_ui$Element$html(
								A4($author$project$Sequence$Edit$sequenceView, isLR, window, sequence, draggable))
							])),
						A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width(
								$mdgriffith$elm_ui$Element$fillPortion(2))
							]),
						$mdgriffith$elm_ui$Element$html(
							A7($author$project$Sequence$Edit$clusterMapView, sequence, dp, items, orders, segments, zoomTo, window)))
					]));
		}
	});
var $author$project$Sequence$Edit$withoutPadding = function (_v0) {
	var width = _v0.oy;
	var height = _v0.iK;
	return {iK: height - (8 * $author$project$Sequence$Edit$contentPadding), oy: width};
};
var $author$project$Lists$RouteDetail$Deliverer$editSequenceView = F3(
	function (share, printItem, _default) {
		var window = $author$project$Sequence$Edit$withoutPadding(
			$author$project$Portal$Page$contentWindow(share));
		var title = $mdgriffith$elm_ui$Element$text(
			$author$project$UI$Name$shortenedListView(
				A2(
					$elm$core$List$map,
					$author$project$DistributionPoint$DistributionPoint$segmentInfo,
					A2($author$project$DistributionPoint$DistributionPoint$findSegmentsOnId, printItem.bn, printItem.H.bb))));
		var returnTitleButton = $author$project$UI$Button$elementFor(
			A2(
				$author$project$UI$Button$withIcon,
				$icidasset$elm_material_icons$Material$Icons$chevron_left,
				A2(
					$author$project$UI$Button$withRole,
					2,
					A2($author$project$UI$Button$button, $author$project$Sequence$Edit$UserClickedReturn, ''))));
		var sequenceTitle = A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[$author$project$UI$Spacing$default, $author$project$UI$Padding$default]),
			_List_fromArray(
				[returnTitleButton, title]));
		var editWithMap = A5(
			$author$project$Sequence$Edit$addMapToDefault,
			_default,
			printItem.bn,
			_List_fromArray(
				[printItem.gK]),
			printItem.Y,
			A2($author$project$DistributionPoint$DistributionPoint$findSegmentsOnId, printItem.bn, printItem.H.bb));
		return A2(
			$mdgriffith$elm_ui$Element$map,
			$author$project$Lists$RouteDetail$Deliverer$SystemGotSequenceEditMsg,
			A3($author$project$Sequence$Edit$view, window, sequenceTitle, editWithMap));
	});
var $author$project$Lists$RouteDetail$Deliverer$noOrdersView = function (date) {
	return $author$project$UI$Container$elementFor(
		A2(
			$author$project$UI$Container$withWidth,
			$mdgriffith$elm_ui$Element$fill,
			A2(
				$author$project$UI$Container$withTitle,
				A2(
					$mdgriffith$elm_ui$Element$paragraph,
					_List_Nil,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text(
							'De looplijsten voor ' + ($author$project$Date$DeliveryDate$view(date) + ' zijn (nog) niet beschikbaar.'))
						])),
				$author$project$UI$Container$container)));
};
var $author$project$Lists$RouteDetail$Deliverer$GotRouteMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Lists$RouteDetail$Route$UserClickedStart = {$: 6};
var $author$project$Lists$RouteDetail$Route$groupByStreet = function (stops) {
	return A2(
		$elm$core$List$map,
		function (_v2) {
			var _v3 = _v2.a;
			var index = _v3.a;
			var stop = _v3.b;
			var s = _v2.b;
			return _Utils_Tuple2(
				stop.f1,
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(index, stop),
					s));
		},
		A2(
			$elm_community$list_extra$List$Extra$groupWhile,
			F2(
				function (_v0, _v1) {
					var s1 = _v0.b;
					var s2 = _v1.b;
					return _Utils_eq(s1.f1.b5, s2.f1.b5);
				}),
			A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, stops)));
};
var $icidasset$elm_material_icons$Material$Icons$play_arrow = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M8 5v14l11-7z')
				]),
			_List_Nil)
		]));
var $author$project$Lists$RouteDetail$Route$UserClickedSetStop = function (a) {
	return {$: 9, a: a};
};
var $author$project$Lists$RouteDetail$Route$infoAddressView = function (info) {
	return A2(
		$mdgriffith$elm_ui$Element$paragraph,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$Font$color(
				$author$project$UI$Element$colorFor($author$project$UI$Palette$base01))
			]),
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$text(info)
			]));
};
var $author$project$UI$Element$just = F2(
	function (aMaybe, fct) {
		if (!aMaybe.$) {
			var a = aMaybe.a;
			return fct(a);
		} else {
			return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$Lists$RouteDetail$Route$mobileViewAttributes = A2(
	$elm$core$List$cons,
	$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
	A2(
		$elm$core$List$cons,
		$mdgriffith$elm_ui$Element$Border$widthEach(
			{k5: 1, mE: 0, nx: 0, ol: 0}),
		A2(
			$elm$core$List$cons,
			$mdgriffith$elm_ui$Element$Border$color(
				$author$project$UI$Element$colorFor($author$project$UI$Palette$base1)),
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$padding(2),
				$author$project$UI$Font$bodyLarge))));
var $author$project$Lists$RouteDetail$Route$productAddressView = F5(
	function (productId, amount, validDays, mutation, complaint) {
		var papers = function () {
			if (amount.$ === 1) {
				return $mdgriffith$elm_ui$Element$none;
			} else {
				if (amount.a === 1) {
					return $mdgriffith$elm_ui$Element$none;
				} else {
					var a = amount.a;
					return $mdgriffith$elm_ui$Element$text(
						$elm$core$String$fromInt(a));
				}
			}
		}();
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(15)
				]),
			_List_fromArray(
				[
					A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$mdgriffith$elm_ui$Element$none,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Lists$MutationIcon$view,
						A2(
							$elm$core$Basics$composeR,
							$mdgriffith$elm_ui$Element$html,
							$mdgriffith$elm_ui$Element$el(_List_Nil))),
					mutation),
					A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$mdgriffith$elm_ui$Element$none,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.nL;
						},
						A2(
							$elm$core$Basics$composeR,
							$author$project$Lists$SeverityIcon$view,
							A2(
								$elm$core$Basics$composeR,
								$mdgriffith$elm_ui$Element$html,
								$mdgriffith$elm_ui$Element$el(_List_Nil)))),
					complaint),
					$mdgriffith$elm_ui$Element$text(productId),
					papers,
					A2(
					$author$project$UI$Element$iff,
					!_Utils_eq(validDays, $author$project$Date$DaysInTheWeek$everyDeliveryDay),
					A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[$mdgriffith$elm_ui$Element$alignRight]),
						$mdgriffith$elm_ui$Element$html(
							$author$project$Date$DaysInTheWeek$icon(validDays))))
				]));
	});
var $mdgriffith$elm_ui$Element$Font$strike = $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.nX);
var $icidasset$elm_material_icons$Material$Icons$local_offer = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('m21.41 11.58-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z')
				]),
			_List_Nil)
		]));
var $author$project$Lists$RouteDetail$Route$tagAddressView = function (name) {
	return A2(
		$mdgriffith$elm_ui$Element$row,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$spacing(5)
			]),
		_List_fromArray(
			[
				$author$project$UI$Element$iconFor(
				$icidasset$elm_material_icons$Material$Icons$local_offer(16)),
				A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				$mdgriffith$elm_ui$Element$none,
				A2(
					$elm$core$Basics$composeR,
					$mdgriffith$elm_ui$Element$text,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$singleton,
						$mdgriffith$elm_ui$Element$paragraph(_List_Nil))),
				name)
			]));
};
var $author$project$Lists$RouteDetail$Route$stopView = F2(
	function (activeStop, _v0) {
		var stopNumber = _v0.a;
		var address = _v0.b.f1;
		var orders = _v0.b.Y;
		var complaint = _v0.b.dX;
		return A2(
			$mdgriffith$elm_ui$Element$row,
			(_Utils_eq(
				activeStop,
				$elm$core$Maybe$Just(stopNumber)) ? $elm$core$Basics$append(
				$author$project$UI$Element$colors(
					{kV: $author$project$UI$Palette$base1, k0: $author$project$UI$Palette$base2, lZ: $author$project$UI$Palette$base03})) : $elm$core$Basics$identity)($author$project$Lists$RouteDetail$Route$mobileViewAttributes),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$alignTop,
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$px(80))
						]),
					$mdgriffith$elm_ui$Element$text(
						$author$project$Address$Address$houseNumberView(address.bs))),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$spacing(10),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$Events$onClick(
							$author$project$Lists$RouteDetail$Route$UserClickedSetStop(stopNumber))
						]),
					A2(
						$elm$core$List$map,
						function (_v1) {
							var productId = _v1.av;
							var name = _v1.ft;
							var demandType = _v1.lB;
							var amount = _v1.aa;
							var info = _v1.iP;
							var validDays = _v1.hD;
							var label = _v1.mD;
							var mutation = _v1.mN;
							var additionalAddressInfo = _v1.f0;
							return A2(
								$mdgriffith$elm_ui$Element$el,
								function () {
									var _v2 = _Utils_Tuple2(mutation, complaint);
									if (!_v2.a.$) {
										switch (_v2.a.a) {
											case 1:
												var _v3 = _v2.a.a;
												return _List_fromArray(
													[
														$mdgriffith$elm_ui$Element$Font$color(
														$author$project$UI$Element$colorFor($author$project$UI$Palette$magenta)),
														$mdgriffith$elm_ui$Element$Font$strike,
														$mdgriffith$elm_ui$Element$Font$bold
													]);
											case 0:
												var _v4 = _v2.a.a;
												return _List_fromArray(
													[
														$mdgriffith$elm_ui$Element$Font$color(
														$author$project$UI$Element$colorFor($author$project$UI$Palette$green)),
														$mdgriffith$elm_ui$Element$Font$bold
													]);
											default:
												var _v5 = _v2.a.a;
												return _List_fromArray(
													[$mdgriffith$elm_ui$Element$Font$bold]);
										}
									} else {
										if (!_v2.b.$) {
											var _v6 = _v2.a;
											return _List_fromArray(
												[
													$mdgriffith$elm_ui$Element$Font$color(
													$author$project$UI$Element$colorFor($author$project$UI$Palette$magenta))
												]);
										} else {
											var _v7 = _v2.a;
											var _v8 = _v2.b;
											return _List_Nil;
										}
									}
								}(),
								function () {
									if ((!mutation.$) && (mutation.a === 1)) {
										var _v10 = mutation.a;
										return A5(
											$author$project$Lists$RouteDetail$Route$productAddressView,
											productId,
											$elm$core$Maybe$Just(amount),
											validDays,
											mutation,
											complaint);
									} else {
										return A2(
											$mdgriffith$elm_ui$Element$column,
											_List_fromArray(
												[
													$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
													$mdgriffith$elm_ui$Element$spacing(5)
												]),
											A2(
												$elm$core$List$cons,
												A5(
													$author$project$Lists$RouteDetail$Route$productAddressView,
													productId,
													$elm$core$Maybe$Just(amount),
													validDays,
													mutation,
													complaint),
												A2(
													$elm$core$List$cons,
													A2(
														$author$project$UI$Element$iff,
														label,
														$author$project$Lists$RouteDetail$Route$tagAddressView(name)),
													_Utils_ap(
														A2($elm$core$List$map, $author$project$Lists$RouteDetail$Route$infoAddressView, additionalAddressInfo),
														_List_fromArray(
															[
																A2($author$project$UI$Element$just, info, $author$project$Lists$RouteDetail$Route$infoAddressView)
															])))));
									}
								}());
						},
						orders))
				]));
	});
var $author$project$Lists$RouteDetail$Route$streetStopsView = F3(
	function (activeStop, address, stops) {
		return A2(
			$author$project$UI$Element$iff,
			$elm$core$List$length(stops) > 0,
			$author$project$UI$Container$elementFor(
				A2(
					$author$project$UI$Container$withWidth,
					$mdgriffith$elm_ui$Element$fill,
					A2(
						$author$project$UI$Container$withContent,
						A2(
							$elm$core$List$map,
							$author$project$Lists$RouteDetail$Route$stopView(activeStop),
							stops),
						A2(
							$author$project$UI$Container$withTitle,
							A2(
								$mdgriffith$elm_ui$Element$paragraph,
								_List_Nil,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$text(address.b5)
									])),
							$author$project$UI$Container$container)))));
	});
var $author$project$Lists$RouteDetail$Route$addressesView = F2(
	function (activeStop, m) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(5)
				]),
			A2(
				$elm$core$List$cons,
				$author$project$UI$Button$elementFor(
					A2(
						$author$project$UI$Button$withWidth,
						$mdgriffith$elm_ui$Element$fill,
						A2(
							$author$project$UI$Button$withIcon,
							$icidasset$elm_material_icons$Material$Icons$play_arrow,
							A2(
								$author$project$UI$Button$withRole,
								0,
								A2($author$project$UI$Button$button, $author$project$Lists$RouteDetail$Route$UserClickedStart, 'Start begeleiding'))))),
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (_v0, _v1) {
							var address = _v1.a;
							var stops = _v1.b;
							return A3($author$project$Lists$RouteDetail$Route$streetStopsView, activeStop, address, stops);
						}),
					$author$project$Lists$RouteDetail$Route$groupByStreet(m))));
	});
var $author$project$Lists$RouteDetail$Route$UserClickedAddresses = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Lists$RouteDetail$Route$UserClickedComplaints = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Lists$RouteDetail$Route$UserClickedMutations = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Lists$RouteDetail$Route$UserClickedSummary = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Lists$RouteDetail$Route$buttonOrText = F3(
	function (msg, amount, label) {
		return (!amount) ? A2(
			$mdgriffith$elm_ui$Element$paragraph,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$Border$rounded(3),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$Border$width(1),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$padding(11),
						$author$project$UI$Element$colors(
							{kV: $author$project$UI$Palette$base2, k0: $author$project$UI$Palette$base1, lZ: $author$project$UI$Palette$base02})))),
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$text(label + ' (-)')
				])) : $author$project$UI$Button$elementFor(
			A2(
				$author$project$UI$Button$withWidth,
				$mdgriffith$elm_ui$Element$fill,
				A2(
					$author$project$UI$Button$button,
					msg,
					label + (' (' + ($elm$core$String$fromInt(amount) + ')')))));
	});
var $author$project$Lists$RouteDetail$Route$mutations = function (m) {
	return A2(
		$elm$core$List$filter,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.Y;
			},
			A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)),
		A2(
			$elm$core$List$map,
			function (stop) {
				return _Utils_update(
					stop,
					{
						Y: A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.mN;
								},
								$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
							stop.Y)
					});
			},
			m));
};
var $author$project$Lists$RouteDetail$Route$numberOfComplaintsIn = function (stops) {
	return $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.dX;
				},
				$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
			stops));
};
var $author$project$Lists$RouteDetail$Route$numberOfOrdersIn = function (stops) {
	return $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Y;
				},
				$elm$core$List$length),
			stops));
};
var $author$project$Lists$RouteDetail$Route$bikeCardView = F2(
	function (cluster, route) {
		var segments = route.bb;
		var stops = route.nW;
		return A2(
			$author$project$UI$Container$withContent,
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(10)
						]),
					_List_fromArray(
						[
							$author$project$UI$Button$elementFor(
							A2(
								$author$project$UI$Button$withWidth,
								$mdgriffith$elm_ui$Element$fill,
								A2(
									$author$project$UI$Button$withRole,
									0,
									A2(
										$author$project$UI$Button$button,
										A2(
											$author$project$Lists$RouteDetail$Route$UserClickedAddresses,
											cluster,
											$author$project$Lists$RouteDetail$Route$Bike(route)),
										'Adressen')))),
							$author$project$UI$Button$elementFor(
							A2(
								$author$project$UI$Button$withWidth,
								$mdgriffith$elm_ui$Element$fill,
								A2(
									$author$project$UI$Button$button,
									A2(
										$author$project$Lists$RouteDetail$Route$UserClickedSummary,
										cluster,
										$author$project$Lists$RouteDetail$Route$Bike(route)),
									'Aantallen')))
						])),
					A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(10)
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Lists$RouteDetail$Route$buttonOrText,
							A2(
								$author$project$Lists$RouteDetail$Route$UserClickedComplaints,
								cluster,
								$author$project$Lists$RouteDetail$Route$Bike(route)),
							$author$project$Lists$RouteDetail$Route$numberOfComplaintsIn(stops),
							'Klachten'),
							A3(
							$author$project$Lists$RouteDetail$Route$buttonOrText,
							A2(
								$author$project$Lists$RouteDetail$Route$UserClickedMutations,
								cluster,
								$author$project$Lists$RouteDetail$Route$Bike(route)),
							$author$project$Lists$RouteDetail$Route$numberOfOrdersIn(
								$author$project$Lists$RouteDetail$Route$mutations(stops)),
							'Mutaties')
						]))
				]),
			A2(
				$author$project$UI$Container$withTitle,
				A2(
					$mdgriffith$elm_ui$Element$paragraph,
					_List_Nil,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text(
							$author$project$UI$Name$shortenedListView(segments))
						])),
				$author$project$UI$Container$container));
	});
var $author$project$Lists$RouteDetail$Route$cardView = F2(
	function (cluster, routeDetail) {
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withWidth,
				$mdgriffith$elm_ui$Element$fill,
				function () {
					switch (routeDetail.$) {
						case 0:
							var b = routeDetail.a;
							return A2($author$project$Lists$RouteDetail$Route$bikeCardView, cluster, b);
						case 1:
							var c = routeDetail.a;
							var _v1 = c.js;
							if (!_v1.$) {
								var b = _v1.a;
								return A2($author$project$Lists$RouteDetail$Route$bikeCardView, cluster, b);
							} else {
								return $author$project$UI$Container$container;
							}
						case 2:
							return $author$project$UI$Container$container;
						default:
							return $author$project$UI$Container$container;
					}
				}()));
	});
var $author$project$Lists$RouteDetail$Route$orderComplaintsView = F2(
	function (orders, complaint) {
		var order = A2(
			$elm_community$list_extra$List$Extra$find,
			function (o) {
				return 1 === A2(
					$author$project$Address$Address$toOrder,
					$author$project$Demand$Demand$complaintToAddress(complaint),
					o.f1);
			},
			orders);
		var additionalAddressInfo = function () {
			if (!order.$) {
				var o = order.a;
				return A2($elm$core$List$map, $author$project$Lists$RouteDetail$Route$infoAddressView, o.f0);
			} else {
				return _List_fromArray(
					[$mdgriffith$elm_ui$Element$none]);
			}
		}();
		return A2(
			$mdgriffith$elm_ui$Element$row,
			$author$project$Lists$RouteDetail$Route$mobileViewAttributes,
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$alignTop,
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$px(80))
						]),
					$mdgriffith$elm_ui$Element$text(
						$author$project$Address$Address$houseNumberView(complaint.bs))),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(5)
						]),
					A2(
						$elm$core$List$cons,
						A5(
							$author$project$Lists$RouteDetail$Route$productAddressView,
							complaint.av,
							$elm$core$Maybe$Nothing,
							complaint.hD,
							$elm$core$Maybe$Nothing,
							$elm$core$Maybe$Just(complaint)),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Element$text(complaint.lo),
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Element$text(
									$author$project$Date$DeliveryDate$view(complaint.i8)),
								A2(
									$elm$core$List$cons,
									A2(
										$author$project$UI$Element$just,
										order,
										function (o) {
											return A2(
												$author$project$UI$Element$iff,
												o.mD,
												$author$project$Lists$RouteDetail$Route$tagAddressView(o.ft));
										}),
									_Utils_ap(
										additionalAddressInfo,
										_List_fromArray(
											[
												A2(
												$author$project$UI$Element$just,
												order,
												function (o) {
													return A2($author$project$UI$Element$just, o.iP, $author$project$Lists$RouteDetail$Route$infoAddressView);
												})
											])))))))
				]));
	});
var $author$project$Lists$RouteDetail$Route$streetComplaintsView = function (_v0) {
	var stop = _v0.a;
	var complaint = _v0.b;
	return $author$project$UI$Container$elementFor(
		A2(
			$author$project$UI$Container$withWidth,
			$mdgriffith$elm_ui$Element$fill,
			A2(
				$author$project$UI$Container$withContent,
				_List_fromArray(
					[
						A2($author$project$Lists$RouteDetail$Route$orderComplaintsView, stop.Y, complaint)
					]),
				A2(
					$author$project$UI$Container$withTitle,
					A2(
						$mdgriffith$elm_ui$Element$paragraph,
						_List_Nil,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text(stop.f1.b5)
							])),
					$author$project$UI$Container$container))));
};
var $author$project$Lists$RouteDetail$Route$complaintsView = function (m) {
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$spacing(5)
			]),
		A2(
			$elm$core$List$map,
			$author$project$Lists$RouteDetail$Route$streetComplaintsView,
			A2(
				$elm$core$List$filterMap,
				function (stop) {
					var _v0 = stop.dX;
					if (!_v0.$) {
						var c = _v0.a;
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(stop, c));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				m)));
};
var $author$project$Lists$RouteDetail$Deliverer$UserClickedRouteHeader = {$: 5};
var $author$project$Lists$RouteDetail$Deliverer$frame = F2(
	function (segments, element) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(10),
					$mdgriffith$elm_ui$Element$padding(2)
				]),
			_List_fromArray(
				[
					$author$project$UI$Button$elementFor(
					A2(
						$author$project$UI$Button$withWidth,
						$mdgriffith$elm_ui$Element$fill,
						A2(
							$author$project$UI$Button$withIcon,
							$icidasset$elm_material_icons$Material$Icons$chevron_left,
							A2(
								$author$project$UI$Button$withRole,
								2,
								A2(
									$author$project$UI$Button$button,
									$author$project$Lists$RouteDetail$Deliverer$UserClickedRouteHeader,
									$author$project$UI$Name$shortenedListView(segments)))))),
					element
				]));
	});
var $author$project$Lists$RouteDetail$Route$UserClickedRestart = {$: 8};
var $author$project$Lists$RouteDetail$Route$UserClickedStop = {$: 7};
var $author$project$Lists$RouteDetail$Route$UserIsSwiping = function (a) {
	return {$: 4, a: a};
};
var $author$project$Lists$RouteDetail$Route$UserSwipedCard = function (a) {
	return {$: 5, a: a};
};
var $author$project$Style$Style$noTextSelection = A2(
	$elm$core$List$map,
	function (key) {
		return $mdgriffith$elm_ui$Element$htmlAttribute(
			A2($elm$html$Html$Attributes$style, key, 'none'));
	},
	_List_fromArray(
		['-webkit-touch-callout', '-webkit-user-select', '-khtml-user-select', '-moz-user-select', '-ms-user-select', 'user-select']));
var $author$project$Lists$RouteDetail$Route$comparableOrderInfo = function (order) {
	return $elm$core$String$concat(
		A2(
			$elm$core$List$filter,
			$elm$core$Basics$neq(''),
			_Utils_ap(
				order.f0,
				_List_fromArray(
					[
						function () {
						var _v0 = _Utils_Tuple2(order.mD, order.ft);
						if (_v0.a && (!_v0.b.$)) {
							var name = _v0.b.a;
							return name;
						} else {
							return '';
						}
					}(),
						function () {
						var _v1 = order.iP;
						if (!_v1.$) {
							var i = _v1.a;
							return i;
						} else {
							return '';
						}
					}()
					]))));
};
var $author$project$Lists$RouteDetail$Route$notesOf = function (orders) {
	return A2(
		$elm$core$List$indexedMap,
		F2(
			function (index, _v0) {
				var comp = _v0.a;
				var order = _v0.b;
				return _Utils_Tuple2(
					comp,
					A2(
						$mdgriffith$elm_ui$Element$paragraph,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$spacing(5)
							]),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Element$text(
								$elm$core$String$concat(
									_List_fromArray(
										[
											'(',
											$elm$core$String$fromInt(index + 1),
											') '
										]))),
							A2(
								$elm$core$List$intersperse,
								$mdgriffith$elm_ui$Element$text(', '),
								$elm$core$List$reverse(
									function () {
										var _v1 = order.iP;
										if (!_v1.$) {
											var info = _v1.a;
											return $elm$core$Basics$append(
												_List_fromArray(
													[
														$author$project$Lists$RouteDetail$Route$infoAddressView(info)
													]));
										} else {
											return $elm$core$Basics$identity;
										}
									}()(
										_Utils_ap(
											A2($elm$core$List$map, $author$project$Lists$RouteDetail$Route$infoAddressView, order.f0),
											(order.mD ? $elm$core$Basics$append(
												_List_fromArray(
													[
														$author$project$Lists$RouteDetail$Route$tagAddressView(order.ft)
													])) : $elm$core$Basics$identity)(_List_Nil))))))));
			}),
		A2(
			$elm_community$list_extra$List$Extra$uniqueBy,
			$elm$core$Tuple$first,
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$first,
					$elm$core$Basics$neq('')),
				A2(
					$elm$core$List$map,
					function (o) {
						return _Utils_Tuple2(
							$author$project$Lists$RouteDetail$Route$comparableOrderInfo(o),
							o);
					},
					orders))));
};
var $author$project$UI$Swipe$End = 2;
var $author$project$UI$Swipe$Touch = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$UI$Swipe$Position = F2(
	function (x, y) {
		return {ay: x, bg: y};
	});
var $author$project$UI$Swipe$decodeTouchWithOptions = F3(
	function (fieldName, options, tagger) {
		return A2(
			$elm$json$Json$Decode$map,
			function (p) {
				return {
					fq: tagger(p),
					hb: options.hb,
					ht: options.ht
				};
			},
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					[fieldName, '0']),
				A3(
					$elm$json$Json$Decode$map2,
					F2(
						function (x, y) {
							return A2($author$project$UI$Swipe$Position, x, y);
						}),
					A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float),
					A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float))));
	});
var $author$project$UI$Swipe$onEndWithOptions = F2(
	function (options, tagger) {
		return A2(
			$elm$html$Html$Events$custom,
			'touchend',
			A3(
				$author$project$UI$Swipe$decodeTouchWithOptions,
				'changedTouches',
				options,
				A2(
					$elm$core$Basics$composeR,
					$author$project$UI$Swipe$Touch(2),
					tagger)));
	});
var $author$project$UI$Swipe$onEnd = $author$project$UI$Swipe$onEndWithOptions(
	{hb: true, ht: false});
var $author$project$UI$Swipe$Move = 1;
var $author$project$UI$Swipe$decodeTouch = F2(
	function (fieldName, tagger) {
		return A2(
			$elm$json$Json$Decode$map,
			tagger,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					[fieldName, '0']),
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$UI$Swipe$Position,
					A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float),
					A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float))));
	});
var $author$project$UI$Swipe$onMove = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'touchmove',
		A2(
			$author$project$UI$Swipe$decodeTouch,
			'changedTouches',
			A2(
				$elm$core$Basics$composeR,
				$author$project$UI$Swipe$Touch(1),
				tagger)));
};
var $author$project$UI$Swipe$Start = 0;
var $author$project$UI$Swipe$onStart = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'touchstart',
		A2(
			$author$project$UI$Swipe$decodeTouch,
			'touches',
			A2(
				$elm$core$Basics$composeR,
				$author$project$UI$Swipe$Touch(0),
				tagger)));
};
var $icidasset$elm_material_icons$Material$Icons$block = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z')
				]),
			_List_Nil)
		]));
var $icidasset$elm_material_icons$Material$Icons$play_circle_outline = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z')
				]),
			_List_Nil)
		]));
var $author$project$Lists$RouteDetail$Route$productView = F2(
	function (noteIndex, order) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$centerX,
					$mdgriffith$elm_ui$Element$Font$size(60),
					$mdgriffith$elm_ui$Element$Font$center
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					_List_fromArray(
						[
							function () {
							var _v0 = order.aa;
							switch (_v0) {
								case 0:
									return $mdgriffith$elm_ui$Element$none;
								case 1:
									return $mdgriffith$elm_ui$Element$none;
								default:
									return $mdgriffith$elm_ui$Element$text(
										$elm$core$String$fromInt(order.aa));
							}
						}(),
							function () {
							var _v1 = order.mN;
							if (!_v1.$) {
								switch (_v1.a) {
									case 0:
										var _v2 = _v1.a;
										return $author$project$UI$Element$iconFor(
											$icidasset$elm_material_icons$Material$Icons$play_circle_outline(40));
									case 1:
										var _v3 = _v1.a;
										return $author$project$UI$Element$iconFor(
											$icidasset$elm_material_icons$Material$Icons$block(40));
									default:
										var _v4 = _v1.a;
										return $author$project$UI$Element$iconFor(
											$icidasset$elm_material_icons$Material$Icons$block(40));
								}
							} else {
								return $mdgriffith$elm_ui$Element$none;
							}
						}(),
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									$mdgriffith$elm_ui$Element$Font$center
								]),
							$mdgriffith$elm_ui$Element$text(order.av)),
							function () {
							if (!noteIndex.$) {
								var i = noteIndex.a;
								return A2(
									$mdgriffith$elm_ui$Element$el,
									A2($elm$core$List$cons, $mdgriffith$elm_ui$Element$alignTop, $author$project$UI$Font$label),
									$mdgriffith$elm_ui$Element$text(
										$elm$core$String$concat(
											_List_fromArray(
												[
													' (',
													$elm$core$String$fromInt(i + 1),
													')'
												]))));
							} else {
								return $mdgriffith$elm_ui$Element$none;
							}
						}()
						])),
					(!_Utils_eq(order.hD, $author$project$Date$DaysInTheWeek$everyDeliveryDay)) ? $mdgriffith$elm_ui$Element$html(
					$author$project$Date$DaysInTheWeek$icon(order.hD)) : $mdgriffith$elm_ui$Element$none
				]));
	});
var $author$project$Lists$RouteDetail$Route$stopAttributes = function (order) {
	var _v0 = order.mN;
	if (!_v0.$) {
		switch (_v0.a) {
			case 1:
				var _v1 = _v0.a;
				return _List_fromArray(
					[
						$mdgriffith$elm_ui$Element$Font$color(
						$author$project$UI$Element$colorFor($author$project$UI$Palette$magenta)),
						$mdgriffith$elm_ui$Element$Font$strike,
						$mdgriffith$elm_ui$Element$Font$bold
					]);
			case 0:
				var _v2 = _v0.a;
				return _List_fromArray(
					[
						$mdgriffith$elm_ui$Element$Font$color(
						$author$project$UI$Element$colorFor($author$project$UI$Palette$green)),
						$mdgriffith$elm_ui$Element$Font$bold
					]);
			default:
				var _v3 = _v0.a;
				return _List_fromArray(
					[$mdgriffith$elm_ui$Element$Font$bold]);
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Lists$RouteDetail$Route$ordersView = F2(
	function (notes, orders) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(15)
				]),
			A2(
				$elm$core$List$map,
				function (o) {
					return A2(
						$mdgriffith$elm_ui$Element$el,
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$author$project$Lists$RouteDetail$Route$stopAttributes(o)),
						A2(
							$author$project$Lists$RouteDetail$Route$productView,
							A2(
								$elm_community$list_extra$List$Extra$findIndex,
								function (_v0) {
									var c = _v0.a;
									return _Utils_eq(
										c,
										$author$project$Lists$RouteDetail$Route$comparableOrderInfo(o));
								},
								notes),
							o));
				},
				orders));
	});
var $icidasset$elm_material_icons$Material$Icons$refresh = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z')
				]),
			_List_Nil)
		]));
var $mdgriffith$elm_ui$Element$Font$alignLeft = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$fontAlignment, $mdgriffith$elm_ui$Internal$Style$classes.n9);
var $author$project$Lists$RouteDetail$Route$saleProductView = F2(
	function (noteIndex, _v0) {
		var productId = _v0.av;
		var amount = _v0.aa;
		var validDays = _v0.hD;
		var mutation = _v0.mN;
		var product = _List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$row,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$text(productId),
						function () {
						if (!noteIndex.$) {
							var i = noteIndex.a;
							return A2(
								$mdgriffith$elm_ui$Element$el,
								A2($elm$core$List$cons, $mdgriffith$elm_ui$Element$alignTop, $author$project$UI$Font$label),
								$mdgriffith$elm_ui$Element$text(
									$elm$core$String$concat(
										_List_fromArray(
											[
												' (',
												$elm$core$String$fromInt(i + 1),
												')'
											]))));
						} else {
							return $mdgriffith$elm_ui$Element$none;
						}
					}(),
						(!_Utils_eq(validDays, $author$project$Date$DaysInTheWeek$everyDeliveryDay)) ? $mdgriffith$elm_ui$Element$html(
						$author$project$Date$DaysInTheWeek$icon(validDays)) : $mdgriffith$elm_ui$Element$none
					])),
				function () {
				if (!mutation.$) {
					switch (mutation.a) {
						case 0:
							var _v4 = mutation.a;
							return $author$project$UI$Element$iconFor(
								$icidasset$elm_material_icons$Material$Icons$play_circle_outline(40));
						case 1:
							var _v5 = mutation.a;
							return $author$project$UI$Element$iconFor(
								$icidasset$elm_material_icons$Material$Icons$block(40));
						default:
							var _v6 = mutation.a;
							return $author$project$UI$Element$iconFor(
								$icidasset$elm_material_icons$Material$Icons$block(40));
					}
				} else {
					return $mdgriffith$elm_ui$Element$none;
				}
			}()
			]);
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$spacing(30)
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$px(60)),
							$mdgriffith$elm_ui$Element$Font$alignLeft
						]),
					$mdgriffith$elm_ui$Element$text(
						function () {
							if (!amount) {
								return '';
							} else {
								var a = amount;
								return $elm$core$String$fromInt(a);
							}
						}())),
				product));
	});
var $author$project$Lists$RouteDetail$Route$saleOrdersView = F2(
	function (notes, orders) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$spacing(5),
					$mdgriffith$elm_ui$Element$centerX,
					$mdgriffith$elm_ui$Element$Font$size(40)
				]),
			A2(
				$elm$core$List$map,
				function (o) {
					return A2(
						$mdgriffith$elm_ui$Element$el,
						$author$project$Lists$RouteDetail$Route$stopAttributes(o),
						A2(
							$author$project$Lists$RouteDetail$Route$saleProductView,
							A2(
								$elm_community$list_extra$List$Extra$findIndex,
								function (_v0) {
									var c = _v0.a;
									return _Utils_eq(
										c,
										$author$project$Lists$RouteDetail$Route$comparableOrderInfo(o));
								},
								notes),
							o));
				},
				orders));
	});
var $author$project$Lists$RouteDetail$Route$guidedOrdersView = F3(
	function (window, stops, current) {
		var navColors = {kV: $author$project$UI$Palette$base1, k0: $author$project$UI$Palette$base2, lZ: $author$project$UI$Palette$base03};
		var minSize = A2($elm$core$Basics$min, window.iK, window.oy);
		var header = function (text) {
			var usedWidth = (current > 0) ? (270 + 16) : (90 + 16);
			return A2(
				$mdgriffith$elm_ui$Element$row,
				_Utils_ap(
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$padding(2),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(5)
						]),
					$author$project$UI$Element$colors(navColors)),
				_List_fromArray(
					[
						$author$project$UI$Button$elementFor(
						A2(
							$author$project$UI$Button$withWidth,
							$mdgriffith$elm_ui$Element$px(89),
							A2(
								$author$project$UI$Button$withIcon,
								$icidasset$elm_material_icons$Material$Icons$arrow_back,
								A2(
									$author$project$UI$Button$withRole,
									1,
									A2($author$project$UI$Button$button, $author$project$Lists$RouteDetail$Route$UserClickedStop, 'Stop'))))),
						(current > 0) ? $author$project$UI$Button$elementFor(
						A2(
							$author$project$UI$Button$withWidth,
							$mdgriffith$elm_ui$Element$px(179),
							A2(
								$author$project$UI$Button$withIcon,
								$icidasset$elm_material_icons$Material$Icons$refresh,
								A2(
									$author$project$UI$Button$withRole,
									2,
									A2($author$project$UI$Button$button, $author$project$Lists$RouteDetail$Route$UserClickedRestart, 'Begin opnieuw'))))) : $mdgriffith$elm_ui$Element$none,
						function () {
						if (!text.$) {
							var t = text.a;
							return A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$alignRight,
										$mdgriffith$elm_ui$Element$Font$alignRight,
										$mdgriffith$elm_ui$Element$padding(1),
										$mdgriffith$elm_ui$Element$width(
										$mdgriffith$elm_ui$Element$px(window.oy - usedWidth)),
										$mdgriffith$elm_ui$Element$htmlAttribute(
										$elm$html$Html$Attributes$class('municipal'))
									]),
								t);
						} else {
							return $mdgriffith$elm_ui$Element$none;
						}
					}()
					]));
		};
		var _v0 = A2($elm_community$list_extra$List$Extra$getAt, current, stops);
		if (!_v0.$) {
			var address = _v0.a.f1;
			var orders = _v0.a.Y;
			var demandType = _v0.a.lB;
			var complaint = _v0.a.dX;
			var notes = $author$project$Lists$RouteDetail$Route$notesOf(orders);
			return A2(
				$mdgriffith$elm_ui$Element$column,
				_Utils_ap(
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$height(
							$mdgriffith$elm_ui$Element$px(window.iK)),
							$mdgriffith$elm_ui$Element$htmlAttribute(
							$elm$html$Html$Attributes$class('guided-orders'))
						]),
					$author$project$Style$Style$noTextSelection),
				_List_fromArray(
					[
						header(
						$elm$core$Maybe$Just(
							$mdgriffith$elm_ui$Element$text(address.bU))),
						A2(
						$mdgriffith$elm_ui$Element$column,
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Element$height(
								$mdgriffith$elm_ui$Element$px(window.iK - 60)),
							A2(
								$elm$core$List$map,
								$mdgriffith$elm_ui$Element$htmlAttribute,
								_List_fromArray(
									[
										$author$project$UI$Swipe$onStart($author$project$Lists$RouteDetail$Route$UserIsSwiping),
										$author$project$UI$Swipe$onMove($author$project$Lists$RouteDetail$Route$UserIsSwiping),
										$author$project$UI$Swipe$onEnd($author$project$Lists$RouteDetail$Route$UserSwipedCard)
									]))),
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$paragraph,
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Element$paddingXY, 0, 7),
										$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
										$mdgriffith$elm_ui$Element$Font$center,
										$mdgriffith$elm_ui$Element$Font$size(40),
										A2($mdgriffith$elm_ui$Element$Border$widthXY, 0, 1)
									]),
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$text(address.b5)
									])),
								A2(
								$mdgriffith$elm_ui$Element$wrappedRow,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
									]),
								_List_fromArray(
									[
										A2(
										$mdgriffith$elm_ui$Element$el,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$Font$size(90),
												$mdgriffith$elm_ui$Element$Font$center,
												$mdgriffith$elm_ui$Element$width(
												A2($mdgriffith$elm_ui$Element$minimum, minSize, $mdgriffith$elm_ui$Element$fill)),
												$mdgriffith$elm_ui$Element$alignTop,
												A2($mdgriffith$elm_ui$Element$paddingXY, 0, 20)
											]),
										$mdgriffith$elm_ui$Element$text(
											$author$project$Address$Address$houseNumberView(address.bs))),
										A2(
										$mdgriffith$elm_ui$Element$el,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$width(
												A2($mdgriffith$elm_ui$Element$minimum, minSize, $mdgriffith$elm_ui$Element$fill))
											]),
										function () {
											if (demandType === 1) {
												return A2($author$project$Lists$RouteDetail$Route$saleOrdersView, notes, orders);
											} else {
												return A2($author$project$Lists$RouteDetail$Route$ordersView, notes, orders);
											}
										}())
									])),
								function () {
								if (!complaint.$) {
									var c = complaint.a;
									return A2(
										$mdgriffith$elm_ui$Element$column,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$centerX,
												A2($mdgriffith$elm_ui$Element$paddingXY, 0, 20),
												$mdgriffith$elm_ui$Element$Font$color(
												$author$project$UI$Element$colorFor($author$project$UI$Palette$magenta)),
												$mdgriffith$elm_ui$Element$Font$bold
											]),
										_List_fromArray(
											[
												A2(
												$mdgriffith$elm_ui$Element$el,
												_List_fromArray(
													[$mdgriffith$elm_ui$Element$centerX]),
												$mdgriffith$elm_ui$Element$text('Klacht')),
												A2(
												$mdgriffith$elm_ui$Element$row,
												_List_fromArray(
													[
														$mdgriffith$elm_ui$Element$Font$size(40)
													]),
												_List_fromArray(
													[
														A2(
														$mdgriffith$elm_ui$Element$el,
														_List_Nil,
														$mdgriffith$elm_ui$Element$html(
															$author$project$Lists$SeverityIcon$view(c.nL))),
														$mdgriffith$elm_ui$Element$text(c.lo)
													]))
											]));
								} else {
									return $mdgriffith$elm_ui$Element$none;
								}
							}(),
								A2(
								$mdgriffith$elm_ui$Element$column,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
										$mdgriffith$elm_ui$Element$Font$center,
										$mdgriffith$elm_ui$Element$Font$size(25),
										A2($mdgriffith$elm_ui$Element$paddingXY, 0, 20)
									]),
								A2($elm$core$List$map, $elm$core$Tuple$second, notes))
							]))
					]));
		} else {
			return A2(
				$mdgriffith$elm_ui$Element$column,
				_Utils_ap(
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$height(
							$mdgriffith$elm_ui$Element$px(window.iK))
						]),
					$author$project$Style$Style$noTextSelection),
				_List_fromArray(
					[
						header($elm$core$Maybe$Nothing)
					]));
		}
	});
var $author$project$Demand$Bundle$KnownPackSize = function (a) {
	return {$: 0, a: a};
};
var $author$project$Demand$Bundle$UnknownPackSize = function (a) {
	return {$: 1, a: a};
};
var $author$project$Demand$Bundle$mobileView = function (bundle) {
	if (!bundle.$) {
		var b = bundle.a;
		var individual = b.aM;
		var packs = b.dl;
		var packSize = b.E;
		return (!packs) ? A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$centerX,
					$mdgriffith$elm_ui$Element$centerY,
					A2($mdgriffith$elm_ui$Element$paddingXY, 20, 0)
				]),
			$mdgriffith$elm_ui$Element$text(
				$elm$core$String$fromInt(individual))) : A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$centerX,
					$mdgriffith$elm_ui$Element$centerY,
					A2($mdgriffith$elm_ui$Element$paddingXY, 20, 0)
				]),
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$text(
					$elm$core$String$fromInt(packs)),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_Nil,
					$mdgriffith$elm_ui$Element$html(
						A2($author$project$Demand$PackIcon$view, 0, packSize))),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							A2($mdgriffith$elm_ui$Element$paddingXY, 5, 0)
						]),
					$mdgriffith$elm_ui$Element$text('+')),
					$mdgriffith$elm_ui$Element$text(
					$elm$core$String$fromInt(individual)),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							A2($mdgriffith$elm_ui$Element$paddingXY, 5, 0)
						]),
					$mdgriffith$elm_ui$Element$text('=')),
					$mdgriffith$elm_ui$Element$text(
					$elm$core$String$fromInt(
						$author$project$Demand$Bundle$total(b)))
				]));
	} else {
		var i = bundle.a;
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$centerX,
					$mdgriffith$elm_ui$Element$centerY,
					A2($mdgriffith$elm_ui$Element$paddingXY, 20, 0)
				]),
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$text(
					$elm$core$String$fromInt(i)),
					$mdgriffith$elm_ui$Element$text('('),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_Nil,
					$mdgriffith$elm_ui$Element$html(
						$author$project$Demand$PackIcon$viewUnknownPackSize(0))),
					$mdgriffith$elm_ui$Element$text(')')
				]));
	}
};
var $author$project$Demand$Aggregated$mobileView = function (_v0) {
	var known = _v0.a;
	var unknown = _v0.b;
	var allProducts = _Utils_ap(
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$mapSecond(
				function (b) {
					return $author$project$Demand$Bundle$KnownPackSize(b);
				}),
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapFirst(
					function ($) {
						return $.eg;
					}),
				known)),
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$mapSecond(
				function (i) {
					return $author$project$Demand$Bundle$UnknownPackSize(i);
				}),
			unknown));
	return $author$project$UI$Container$elementFor(
		A2(
			$author$project$UI$Container$withWidth,
			$mdgriffith$elm_ui$Element$fill,
			A2(
				$author$project$UI$Container$withContent,
				A2(
					$elm$core$List$concatMap,
					function (_v1) {
						var productId = _v1.a;
						var bundle = _v1.b;
						return _List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$row,
								A2(
									$elm$core$List$cons,
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									$author$project$UI$Font$heading1),
								_List_fromArray(
									[
										A2(
										$mdgriffith$elm_ui$Element$el,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
											]),
										$mdgriffith$elm_ui$Element$text(productId)),
										A2(
										$mdgriffith$elm_ui$Element$el,
										_List_fromArray(
											[$mdgriffith$elm_ui$Element$alignRight]),
										$author$project$Demand$Bundle$mobileView(bundle))
									])),
								$author$project$UI$Separator$horizontal
							]);
					},
					A2($elm$core$List$sortBy, $elm$core$Tuple$first, allProducts)),
				A2(
					$author$project$UI$Container$withTitle,
					$mdgriffith$elm_ui$Element$text('Aantallen'),
					$author$project$UI$Container$container))));
};
var $author$project$Lists$RouteDetail$Route$mutationsView = function (m) {
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$spacing(5)
			]),
		A2(
			$elm$core$List$map,
			function (_v0) {
				var address = _v0.a;
				var stops = _v0.b;
				return A3($author$project$Lists$RouteDetail$Route$streetStopsView, $elm$core$Maybe$Nothing, address, stops);
			},
			$author$project$Lists$RouteDetail$Route$groupByStreet(
				$author$project$Lists$RouteDetail$Route$mutations(m))));
};
var $author$project$Lists$RouteDetail$Deliverer$phoneView = F3(
	function (window, routes, selected) {
		if (!selected.$) {
			var route = selected.a.bx;
			var routeView = selected.a.ba;
			var activeStop = selected.a._;
			var _v1 = _Utils_Tuple2(
				$author$project$Lists$RouteDetail$Deliverer$bikeRouteDetail(route),
				routeView);
			if (!_v1.a.$) {
				switch (_v1.b) {
					case 0:
						var segments = _v1.a.a.bb;
						var summary = _v1.a.a.kj;
						var _v2 = _v1.b;
						return A2(
							$author$project$Lists$RouteDetail$Deliverer$frame,
							segments,
							$author$project$Demand$Aggregated$mobileView(summary));
					case 1:
						var segments = _v1.a.a.bb;
						var stops = _v1.a.a.nW;
						var _v3 = _v1.b;
						return A2(
							$author$project$Lists$RouteDetail$Deliverer$frame,
							segments,
							A2(
								$mdgriffith$elm_ui$Element$column,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
										$mdgriffith$elm_ui$Element$spacing(5)
									]),
								_List_fromArray(
									[
										A2(
										$mdgriffith$elm_ui$Element$map,
										$author$project$Lists$RouteDetail$Deliverer$GotRouteMsg,
										A2($author$project$Lists$RouteDetail$Route$addressesView, activeStop, stops))
									])));
					case 2:
						var segments = _v1.a.a.bb;
						var stops = _v1.a.a.nW;
						var _v4 = _v1.b;
						return A2(
							$mdgriffith$elm_ui$Element$map,
							$author$project$Lists$RouteDetail$Deliverer$GotRouteMsg,
							A3(
								$author$project$Lists$RouteDetail$Route$guidedOrdersView,
								window,
								stops,
								A2($elm$core$Maybe$withDefault, 0, activeStop)));
					case 3:
						var segments = _v1.a.a.bb;
						var stops = _v1.a.a.nW;
						var _v5 = _v1.b;
						return A2(
							$author$project$Lists$RouteDetail$Deliverer$frame,
							segments,
							A2(
								$mdgriffith$elm_ui$Element$map,
								$author$project$Lists$RouteDetail$Deliverer$GotRouteMsg,
								$author$project$Lists$RouteDetail$Route$mutationsView(stops)));
					default:
						var segments = _v1.a.a.bb;
						var stops = _v1.a.a.nW;
						var _v6 = _v1.b;
						return A2(
							$author$project$Lists$RouteDetail$Deliverer$frame,
							segments,
							$author$project$Lists$RouteDetail$Route$complaintsView(stops));
				}
			} else {
				return $mdgriffith$elm_ui$Element$none;
			}
		} else {
			return A2(
				$mdgriffith$elm_ui$Element$map,
				$author$project$Lists$RouteDetail$Deliverer$GotRouteMsg,
				A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (i, r) {
								return A2($author$project$Lists$RouteDetail$Route$cardView, i, r);
							}),
						routes)));
		}
	});
var $author$project$Lists$RouteDetail$Deliverer$UserClickedEditSequence = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Lists$RouteDetail$Deliverer$UserClickedPrintItem = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $icidasset$elm_material_icons$Material$Icons$directions_run = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M13.49 5.48c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-3.6 13.9l1-4.4 2.1 2v6h2v-7.5l-2.1-2 .6-3c1.3 1.5 3.3 2.5 5.5 2.5v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1l-5.2 2.2v4.7h2v-3.4l1.8-.7-1.6 8.1-4.9-1-.4 2 7 1.4z')
				]),
			_List_Nil)
		]));
var $author$project$UI$Font$heading3Sized = function (el) {
	return el(
		$author$project$UI$Font$scaled(2));
};
var $author$project$Lists$RouteDetail$Deliverer$itemViewSelect = function (item) {
	var distributionPoint = item.bn;
	var cluster = item.H;
	var checked = item.lc;
	var sequence = item.j0;
	var editSequenceButton = function () {
		if (!sequence.$) {
			var s = sequence.a;
			return A2(
				$mdgriffith$elm_ui$Element$Input$button,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$pointer,
						$mdgriffith$elm_ui$Element$htmlAttribute(
						$elm$html$Html$Attributes$title('Loopvolgorde'))
					]),
				{
					mD: A2(
						$author$project$UI$Element$coloredIconFor,
						$author$project$UI$Font$heading3Sized($icidasset$elm_material_icons$Material$Icons$directions_run),
						$author$project$UI$Palette$base03),
					jp: $elm$core$Maybe$Just(
						A2($author$project$Lists$RouteDetail$Deliverer$UserClickedEditSequence, item, s))
				});
		} else {
			return $mdgriffith$elm_ui$Element$none;
		}
	}();
	return A2(
		$mdgriffith$elm_ui$Element$row,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$spacing(5)
			]),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$Input$checkbox,
				_List_Nil,
				{
					lc: checked,
					mg: $mdgriffith$elm_ui$Element$Input$defaultCheckbox,
					mD: A2(
						$mdgriffith$elm_ui$Element$Input$labelRight,
						_List_Nil,
						$mdgriffith$elm_ui$Element$text(
							$author$project$UI$Name$shortenedListView(
								A2(
									$elm$core$List$map,
									$author$project$DistributionPoint$DistributionPoint$segmentInfo,
									A2($author$project$DistributionPoint$DistributionPoint$findSegmentsOnId, distributionPoint, cluster.bb))))),
					mY: $author$project$Lists$RouteDetail$Deliverer$UserClickedPrintItem(item)
				}),
				editSequenceButton
			]));
};
var $author$project$Lists$RouteDetail$Deliverer$printItemsView = function (printItems) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('route')
			]),
		A2(
			$elm$core$List$concatMap,
			$elm$core$Basics$identity,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.ef;
				},
				A2(
					$elm$core$List$filter,
					function ($) {
						return $.lc;
					},
					printItems))));
};
var $author$project$Lists$RouteDetail$Deliverer$selectPrintItemsView = function (printItems) {
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$author$project$UI$Spacing$default,
				$author$project$UI$Padding$default,
				$author$project$UI$Element$avoidPrintInterference,
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
			]),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$row,
				_List_fromArray(
					[$author$project$UI$Element$invisibleForPrint]),
				_List_fromArray(
					[
						$author$project$UI$Container$elementFor(
						A2(
							$author$project$UI$Container$withContent,
							A2($elm$core$List$map, $author$project$Lists$RouteDetail$Deliverer$itemViewSelect, printItems),
							$author$project$UI$Container$withoutBorder(
								A2(
									$author$project$UI$Container$withTitle,
									$mdgriffith$elm_ui$Element$text('Looplijsten'),
									$author$project$UI$Container$container))))
					])),
				$author$project$UI$Separator$horizontal,
				$mdgriffith$elm_ui$Element$html(
				$author$project$Lists$RouteDetail$Deliverer$printItemsView(printItems))
			]));
};
var $author$project$Lists$RouteDetail$Deliverer$view = F2(
	function (share, model) {
		switch (model.$) {
			case 0:
				return $mdgriffith$elm_ui$Element$none;
			case 1:
				var routeDetails = model.a.hh;
				var routes = model.a.fL;
				var display = model.a.N;
				var printItems = model.a.dn;
				switch (display.$) {
					case 0:
						var selected = display.a;
						return A3(
							$author$project$Lists$RouteDetail$Deliverer$phoneView,
							$author$project$Portal$Share$ui(share).oz,
							routes,
							selected);
					case 1:
						return $author$project$Lists$RouteDetail$Deliverer$selectPrintItemsView(printItems);
					default:
						var item = display.a;
						var edit = display.b;
						return A3($author$project$Lists$RouteDetail$Deliverer$editSequenceView, share, item, edit);
				}
			case 2:
				var date = model.a.lx;
				return $author$project$Lists$RouteDetail$Deliverer$noOrdersView(date);
			default:
				return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$Lists$RouteDetail$RouteDetail$loadingView = $mdgriffith$elm_ui$Element$none;
var $author$project$Lists$RouteDetail$RouteDetail$problemView = A2(
	$mdgriffith$elm_ui$Element$el,
	_List_Nil,
	$mdgriffith$elm_ui$Element$text('Er is een onvoorzien probleem opgetreden. Er is geen data om weer te geven.'));
var $author$project$Lists$RouteDetail$RouteDetail$GotPrintSelectionMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Lists$RouteDetail$RouteDetail$kioskListView = F7(
	function (distributionPoint, date, products, orders, sequenceItems, cluster, printOption) {
		var name = A2($author$project$Cluster$Cluster$longNameView, distributionPoint, cluster);
		var kioskSegments = A2(
			$elm$core$List$map,
			$author$project$DistributionPoint$DistributionPoint$segmentId,
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$author$project$DistributionPoint$DistributionPoint$segmentInfo,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.g4;
						},
						$elm$core$Basics$eq(1))),
				A2($author$project$DistributionPoint$DistributionPoint$findSegmentsOnId, distributionPoint, cluster.bb)));
		var kioskOrders = A2(
			$elm$core$List$sortBy,
			$author$project$Sorting$Orders$onRoute(sequenceItems),
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.lB;
					},
					$elm$core$Basics$neq(2)),
				A2(
					$elm$core$List$concatMap,
					function ($) {
						return $.Y;
					},
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.jZ;
							},
							function (id) {
								return A2($elm$core$List$member, id, kioskSegments);
							}),
						orders))));
		return A2(
			$elm$core$List$map,
			A2($author$project$Print$Document$toHtml, printOption, _List_Nil),
			$author$project$Lists$RouteDetail$Kiosk$view(
				{
					lx: date,
					ft: name,
					nW: A2($author$project$Lists$RouteDetail$Kiosk$stopsFor, kioskOrders, products)
				}));
	});
var $author$project$Lists$RouteDetail$RouteDetail$clusterView = function (distributionPoint) {
	return function (date) {
		return function (products) {
			return function (orders) {
				return function (complaints) {
					return function (sequences) {
						return function (printSelection) {
							return function (parents) {
								return function (deliverer) {
									return function (cluster) {
										var sequenceItems = A2(
											$elm$core$Maybe$withDefault,
											_List_Nil,
											A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.gL;
												},
												A3($author$project$Sequence$Sequence$findSequence, sequences, deliverer.eg, cluster.bb)));
										var filterOrders = $author$project$DistributionPoint$DistributionPoint$filterOnSegments(orders);
										var filterComplaints = $author$project$DistributionPoint$DistributionPoint$filterOnSegments(complaints);
										var concatOrders = $elm$core$List$concatMap(
											function ($) {
												return $.Y;
											});
										return _Utils_ap(
											$author$project$Lists$RouteDetail$ClusterView$view(distributionPoint)(printSelection)(date)(deliverer)(
												{H: cluster, g9: parents})(sequenceItems)(
												concatOrders(
													filterOrders(cluster.bb)))(products)(
												filterComplaints(cluster.bb))(printSelection.nl),
											function () {
												var _v0 = printSelection.fn;
												if (!_v0) {
													return A7(
														$author$project$Lists$RouteDetail$RouteDetail$kioskListView,
														distributionPoint,
														date,
														products,
														filterOrders(cluster.bb),
														sequenceItems,
														cluster,
														printSelection.nl);
												} else {
													return _List_Nil;
												}
											}());
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Lists$RouteDetail$ClusterSelection$isClusterSelected = F3(
	function (_v0, item, cluster) {
		var selected = _v0;
		return A2(
			$elm$core$Set$member,
			A2($author$project$Lists$RouteDetail$ClusterSelection$clusterItem, item, cluster),
			selected);
	});
var $author$project$Lists$RouteDetail$PrintSelection$onlySelectedClusters = function (_v0) {
	var selectedClusters = _v0.s;
	return $elm$core$List$filter(
		function (_v1) {
			var item = _v1.gK;
			var cluster = _v1.H;
			return A3($author$project$Lists$RouteDetail$ClusterSelection$isClusterSelected, selectedClusters, item, cluster);
		});
};
var $author$project$Lists$RouteDetail$RouteDetail$itemView = function (distributionPoint) {
	return function (date) {
		return function (products) {
			return function (orders) {
				return function (demandSummaryBySubDPId) {
					return function (complaints) {
						return function (sequences) {
							return function (printSelection) {
								return function (parents) {
									return function (item) {
										var suppliesView = function (supplies) {
											return A2(
												$elm$core$List$concatMap,
												A9(
													$author$project$Lists$RouteDetail$RouteDetail$itemView,
													distributionPoint,
													date,
													products,
													orders,
													demandSummaryBySubDPId,
													complaints,
													sequences,
													printSelection,
													A2($elm$core$List$cons, item, parents)),
												supplies);
										};
										var selectedClusters = A2(
											$author$project$Lists$RouteDetail$PrintSelection$onlySelectedClusters,
											printSelection,
											A2(
												$elm$core$List$map,
												function (c) {
													return {H: c, gK: item};
												},
												$author$project$Plan$Supply$ownClustersOf(item)));
										var clustersView = function (deliverer) {
											return A2(
												$elm$core$List$concatMap,
												A9(
													$author$project$Lists$RouteDetail$RouteDetail$clusterView,
													distributionPoint,
													date,
													products,
													orders,
													complaints,
													sequences,
													printSelection,
													parents,
													$author$project$Deliverer$Deliverer$fromTyped(deliverer)),
												A2(
													$elm$core$List$map,
													function ($) {
														return $.H;
													},
													selectedClusters));
										};
										var _v0 = _Utils_Tuple2(selectedClusters, item);
										if (_v0.a.b) {
											switch (_v0.b.$) {
												case 0:
													var _v1 = _v0.a;
													var car = _v0.b.a;
													var stops = suppliesView(car.n0);
													var carRoute = clustersView(car.bl);
													var _v2 = printSelection.fK;
													if (!_v2) {
														var rideSummary = A3(
															$author$project$Lists$Ride$List$view,
															{df: 0, nl: printSelection.nl},
															A4($author$project$Lists$Ride$List$headerForCluster, distributionPoint, date, car.bl, car.H),
															A8(
																$author$project$Lists$Ride$List$listFromCarItem,
																distributionPoint,
																date,
																products,
																car.H,
																car.bl,
																car.n0,
																A2($author$project$Lists$Ride$Summary$ordersForIncludingStops, orders, item),
																demandSummaryBySubDPId));
														return A2(
															$elm$core$List$cons,
															rideSummary,
															_Utils_ap(carRoute, stops));
													} else {
														return _Utils_ap(carRoute, stops);
													}
												case 1:
													var _v3 = _v0.a;
													var bike = _v0.b.a;
													return clustersView(bike.bl);
												default:
													var _v4 = _v0.a;
													return _List_Nil;
											}
										} else {
											if (!_v0.b.$) {
												var car = _v0.b.a;
												return suppliesView(car.n0);
											} else {
												return _List_Nil;
											}
										}
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Lists$RouteDetail$ClusterSelection$isSegmentSelected = F2(
	function (_v0, segment) {
		var selected = _v0;
		return A2(
			$elm$core$Set$member,
			$author$project$Lists$RouteDetail$ClusterSelection$segmentItem(
				$author$project$DistributionPoint$DistributionPoint$segmentId(segment)),
			selected);
	});
var $author$project$Lists$RouteDetail$PrintSelection$onlySelectedSegments = F2(
	function (_v0, segments) {
		var selectedClusters = _v0.s;
		return A2(
			$elm$core$List$filter,
			$author$project$Lists$RouteDetail$ClusterSelection$isSegmentSelected(selectedClusters),
			segments);
	});
var $author$project$DistributionPoint$DistributionPoint$filterOnSegment = F2(
	function (items, segment) {
		return A2(
			$elm$core$List$filter,
			function (s) {
				return _Utils_eq(
					$author$project$DistributionPoint$DistributionPoint$segmentId(segment),
					s.jZ);
			},
			items);
	});
var $author$project$Lists$RouteDetail$ClusterView$unassignedHeader = F3(
	function (validOn, segment, pageCounters) {
		var linesForUnassigned = 1;
		var linesForSegment = 1;
		return A2(
			$author$project$Print$SizedHtml$listWithSize,
			(($author$project$Lists$RouteDetail$ClusterView$linesForTitle + linesForUnassigned) + linesForSegment) + $author$project$Lists$RouteDetail$ClusterView$linesForBottomMargin,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							'Looplijst ' + $author$project$Date$DeliveryDate$view(validOn)),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('route-page-counter')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Print$Document$simplePageCounter(pageCounters))
								]))
						])),
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$UI$Paradise$nameAndIdView(
								$author$project$DistributionPoint$DistributionPoint$segmentInfo(segment)))
						])),
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Print$Palette$iconFor(
							$icidasset$elm_material_icons$Material$Icons$warning(32)),
							$elm$html$Html$text('Niet toebedeeld.')
						]))
				]));
	});
var $author$project$Lists$RouteDetail$ClusterView$viewUnassignedSegment = F7(
	function (validOn, segment, orders, products, complaints, printOption, _v0) {
		var complaintVisibility = _v0.h6;
		var mutationVisibility = _v0.jj;
		return A3(
			$author$project$Print$Document$toHtml,
			printOption,
			_List_Nil,
			A4(
				$author$project$Lists$RouteDetail$ClusterView$addOrders,
				_List_Nil,
				orders,
				mutationVisibility,
				A3(
					$author$project$Lists$RouteDetail$MutationSummaryView$view,
					orders,
					mutationVisibility,
					A3(
						$author$project$Lists$RouteDetail$ComplaintSummaryView$add,
						complaints,
						complaintVisibility,
						A4(
							$author$project$Demand$SummaryView$addSummary,
							$author$project$Lists$RouteDetail$ClusterView$summaryViewConfig,
							orders,
							products,
							A2(
								$author$project$Print$Document$init,
								$author$project$Print$Document$defaultPageSize,
								A2($author$project$Lists$RouteDetail$ClusterView$unassignedHeader, validOn, segment)))))));
	});
var $author$project$Lists$RouteDetail$RouteDetail$unassignedSegmentView = F7(
	function (validOn, orders, products, complaints, printOption, printSelection, segment) {
		var filteredOrders = A2(
			$elm$core$List$concatMap,
			function ($) {
				return $.Y;
			},
			A2($author$project$DistributionPoint$DistributionPoint$filterOnSegment, orders, segment));
		var filteredComplaints = A2($author$project$DistributionPoint$DistributionPoint$filterOnSegment, complaints, segment);
		return A7($author$project$Lists$RouteDetail$ClusterView$viewUnassignedSegment, validOn, segment, filteredOrders, products, filteredComplaints, printOption, printSelection);
	});
var $author$project$Lists$RouteDetail$RouteDetail$unassignedSegmentsView = F7(
	function (validOn, orders, products, complaints, printOption, printSelection, segments) {
		return A2(
			$elm$core$List$map,
			A6($author$project$Lists$RouteDetail$RouteDetail$unassignedSegmentView, validOn, orders, products, complaints, printOption, printSelection),
			segments);
	});
var $author$project$Lists$RouteDetail$RouteDetail$itemsView = F2(
	function (_v0, _v1) {
		var printSelection = _v0.$7;
		var distributionPoint = _v1.bn;
		var deliverers = _v1.e4;
		var date = _v1.lx;
		var plan = _v1.fA;
		var orders = _v1.Y;
		var demandSummaryBySubDPId = _v1.bm;
		var products = _v1.bu;
		var complaints = _v1.m;
		var sequences = _v1.hm;
		var supplyItems = $author$project$Plan$Supply$removeEmptyClusters(plan.gL).a;
		var filteredUnassignedSegments = A2(
			$author$project$Lists$RouteDetail$PrintSelection$onlySelectedSegments,
			printSelection,
			A2(
				$elm$core$List$sortBy,
				A2(
					$elm$core$Basics$composeR,
					$author$project$DistributionPoint$DistributionPoint$segmentInfo,
					function ($) {
						return $.ft;
					}),
				_Utils_ap(
					A2($author$project$Plan$Supply$findOpenSegments, distributionPoint, supplyItems),
					A3($author$project$Plan$Supply$findExpiredSegments, distributionPoint, deliverers, supplyItems))));
		var allOrders = _Utils_ap(
			orders,
			A3(
				$author$project$Demand$Extra$orders,
				supplyItems,
				A3(
					$elm$core$Basics$composeR,
					$author$project$Deliverer$IdDict$values,
					$elm$core$List$map($author$project$Deliverer$Deliverer$fromTyped),
					deliverers),
				products));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('route')
				]),
			_Utils_ap(
				A7($author$project$Lists$RouteDetail$RouteDetail$unassignedSegmentsView, date, orders, products, complaints, printSelection.nl, printSelection, filteredUnassignedSegments),
				A2(
					$elm$core$List$concatMap,
					A9($author$project$Lists$RouteDetail$RouteDetail$itemView, distributionPoint, date, products, allOrders, demandSummaryBySubDPId, complaints, sequences, printSelection, _List_Nil),
					supplyItems)));
	});
var $author$project$Lists$RouteDetail$RouteDetail$unassignedSegmentsAlertView = function (segments) {
	if (!segments.b) {
		return $mdgriffith$elm_ui$Element$none;
	} else {
		var sortedSegmentNames = $elm$core$List$sort(
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$DistributionPoint$DistributionPoint$segmentInfo,
					function ($) {
						return $.ft;
					}),
				segments));
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[$mdgriffith$elm_ui$Element$centerX, $author$project$UI$Element$invisibleForPrint]),
			$author$project$UI$Container$elementFor(
				A2(
					$author$project$UI$Container$withContent,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$row,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$spacing(5)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$UI$Element$coloredIconFor,
									$icidasset$elm_material_icons$Material$Icons$warning(32),
									$author$project$UI$Palette$warning.k0),
									$mdgriffith$elm_ui$Element$text('Er zijn segmenten niet toebedeeld aan een bezorger:')
								])),
							A2(
							$mdgriffith$elm_ui$Element$column,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$UI$Padding$default,
										$author$project$UI$Spacing$default,
										$mdgriffith$elm_ui$Element$Border$width(1),
										$mdgriffith$elm_ui$Element$Border$rounded(1),
										$mdgriffith$elm_ui$Element$centerX
									]),
								$author$project$UI$Element$colors($author$project$UI$Palette$default)),
							A2($elm$core$List$map, $mdgriffith$elm_ui$Element$text, sortedSegmentNames))
						]),
					A2($author$project$UI$Container$withVariant, 1, $author$project$UI$Container$container))));
	}
};
var $author$project$Lists$RouteDetail$PrintSelection$All = {$: 0};
var $author$project$Lists$RouteDetail$PrintSelection$DependsOn = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Lists$RouteDetail$PrintSelection$ItemSelection = F3(
	function (key, name, selected) {
		return {iY: key, ft: name, nI: selected};
	});
var $author$project$Lists$RouteDetail$PrintSelection$areAllUnassignedSegmentsSelected = F2(
	function (segments, selection) {
		return $elm$core$List$isEmpty(
			A2(
				$elm$core$List$filter,
				function (s) {
					return !A2($author$project$Lists$RouteDetail$ClusterSelection$isSegmentSelected, selection, s);
				},
				segments));
	});
var $author$project$Lists$RouteDetail$ClusterSelection$areClustersSelected = F2(
	function (_v0, itemsWithCluster) {
		var selected = _v0;
		return $elm$core$List$isEmpty(
			A2(
				$elm$core$List$filter,
				function (_v1) {
					var item = _v1.a;
					var cluster = _v1.b;
					return !A3($author$project$Lists$RouteDetail$ClusterSelection$isClusterSelected, selected, item, cluster);
				},
				itemsWithCluster));
	});
var $author$project$Lists$RouteDetail$PrintSelection$AllUnassignedSegments = {$: 4};
var $author$project$Lists$RouteDetail$PrintSelection$Segment = function (a) {
	return {$: 5, a: a};
};
var $author$project$Lists$RouteDetail$PrintSelection$Selected = function (a) {
	return {$: 0, a: a};
};
var $author$project$Lists$RouteDetail$PrintSelection$segmentItemSelection = F3(
	function (distributionPoint, selection, segment) {
		var segmentName = A2(
			$elm$core$Maybe$withDefault,
			'-',
			A2(
				$author$project$DistributionPoint$DistributionPoint$getSegmentName,
				distributionPoint,
				$author$project$DistributionPoint$DistributionPoint$segmentId(segment)));
		return A3(
			$author$project$Lists$RouteDetail$PrintSelection$ItemSelection,
			$author$project$Lists$RouteDetail$PrintSelection$Segment(
				$author$project$DistributionPoint$DistributionPoint$segmentId(segment)),
			segmentName,
			$author$project$Lists$RouteDetail$PrintSelection$Selected(
				A2($author$project$Lists$RouteDetail$ClusterSelection$isSegmentSelected, selection, segment)));
	});
var $author$project$Lists$RouteDetail$PrintSelection$segmentsItemSelection = F3(
	function (distributionPoint, selection, segments) {
		var allUnassignedSegmentsSelected = A2($author$project$Lists$RouteDetail$PrintSelection$areAllUnassignedSegmentsSelected, segments, selection);
		return A3(
			$author$project$Lists$RouteDetail$PrintSelection$ItemSelection,
			$author$project$Lists$RouteDetail$PrintSelection$AllUnassignedSegments,
			'Open segmenten',
			A2(
				$author$project$Lists$RouteDetail$PrintSelection$DependsOn,
				allUnassignedSegmentsSelected,
				A2(
					$elm$core$List$map,
					A2($author$project$Lists$RouteDetail$PrintSelection$segmentItemSelection, distributionPoint, selection),
					segments)));
	});
var $author$project$Lists$RouteDetail$PrintSelection$Deliverer = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Lists$RouteDetail$PrintSelection$Cluster = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Lists$RouteDetail$PrintSelection$clusterItemSelection = F5(
	function (planInfo, selection, item, dependsOn, cluster) {
		if (!dependsOn.$) {
			var d = dependsOn.a;
			return A3(
				$author$project$Lists$RouteDetail$PrintSelection$ItemSelection,
				A2($author$project$Lists$RouteDetail$PrintSelection$Cluster, item, cluster),
				A2($author$project$Cluster$Cluster$shortNameView, planInfo.bn, cluster),
				A2(
					$author$project$Lists$RouteDetail$PrintSelection$DependsOn,
					A3($author$project$Lists$RouteDetail$ClusterSelection$isClusterSelected, selection, item, cluster),
					d));
		} else {
			return A3(
				$author$project$Lists$RouteDetail$PrintSelection$ItemSelection,
				A2($author$project$Lists$RouteDetail$PrintSelection$Cluster, item, cluster),
				A2($author$project$Cluster$Cluster$shortNameView, planInfo.bn, cluster),
				$author$project$Lists$RouteDetail$PrintSelection$Selected(
					A3($author$project$Lists$RouteDetail$ClusterSelection$isClusterSelected, selection, item, cluster)));
		}
	});
var $author$project$Lists$RouteDetail$PrintSelection$supplyItemSelection = F4(
	function (planInfo, selection, parents, item) {
		var allClustersSelected = A2(
			$author$project$Lists$RouteDetail$ClusterSelection$areClustersSelected,
			selection,
			$author$project$Plan$Supply$allClustersByItem(
				_List_fromArray(
					[item])));
		switch (item.$) {
			case 0:
				var car = item.a;
				var deliverer = $author$project$Deliverer$Deliverer$fromTyped(car.bl);
				return $elm$core$Maybe$Just(
					A3(
						$author$project$Lists$RouteDetail$PrintSelection$ItemSelection,
						A2($author$project$Lists$RouteDetail$PrintSelection$Deliverer, item, parents),
						$author$project$Deliverer$Deliverer$nameView(deliverer),
						A2(
							$author$project$Lists$RouteDetail$PrintSelection$DependsOn,
							allClustersSelected,
							_List_fromArray(
								[
									A5(
									$author$project$Lists$RouteDetail$PrintSelection$clusterItemSelection,
									planInfo,
									selection,
									item,
									$elm$core$Maybe$Just(
										A2(
											$elm$core$List$filterMap,
											$elm$core$Basics$identity,
											A2(
												$elm$core$List$map,
												A3(
													$author$project$Lists$RouteDetail$PrintSelection$supplyItemSelection,
													planInfo,
													selection,
													A2($elm$core$List$cons, item, parents)),
												car.n0))),
									car.H)
								]))));
			case 1:
				var bike = item.a;
				var deliverer = $author$project$Deliverer$Deliverer$fromTyped(bike.bl);
				return $elm$core$Maybe$Just(
					A3(
						$author$project$Lists$RouteDetail$PrintSelection$ItemSelection,
						A2($author$project$Lists$RouteDetail$PrintSelection$Deliverer, item, parents),
						$author$project$Deliverer$Deliverer$nameView(deliverer),
						A2(
							$author$project$Lists$RouteDetail$PrintSelection$DependsOn,
							allClustersSelected,
							A2(
								$elm$core$List$map,
								A4($author$project$Lists$RouteDetail$PrintSelection$clusterItemSelection, planInfo, selection, item, $elm$core$Maybe$Nothing),
								$author$project$Plan$Supply$allClustersOf(item)))));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Lists$RouteDetail$PrintSelection$allItemSelection = F2(
	function (planInfo, selection) {
		var sortedUnassignedSegments = A2(
			$elm$core$List$sortBy,
			A2(
				$elm$core$Basics$composeR,
				$author$project$DistributionPoint$DistributionPoint$segmentInfo,
				function ($) {
					return $.ft;
				}),
			_Utils_ap(
				A2($author$project$Plan$Supply$findOpenSegments, planInfo.bn, planInfo.fA.gL),
				A3($author$project$Plan$Supply$findExpiredSegments, planInfo.bn, planInfo.e4, planInfo.fA.gL)));
		var children = function () {
			var _v0 = $elm$core$List$isEmpty(sortedUnassignedSegments);
			if (_v0) {
				return A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					A2(
						$elm$core$List$map,
						A3($author$project$Lists$RouteDetail$PrintSelection$supplyItemSelection, planInfo, selection, _List_Nil),
						planInfo.fA.gL));
			} else {
				return A2(
					$elm$core$List$cons,
					A3($author$project$Lists$RouteDetail$PrintSelection$segmentsItemSelection, planInfo.bn, selection, sortedUnassignedSegments),
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						A2(
							$elm$core$List$map,
							A3($author$project$Lists$RouteDetail$PrintSelection$supplyItemSelection, planInfo, selection, _List_Nil),
							planInfo.fA.gL)));
			}
		}();
		var allSelected = A2(
			$author$project$Lists$RouteDetail$ClusterSelection$areClustersSelected,
			selection,
			$author$project$Plan$Supply$allClustersByItem(planInfo.fA.gL)) && A2($author$project$Lists$RouteDetail$PrintSelection$areAllUnassignedSegmentsSelected, sortedUnassignedSegments, selection);
		return A3(
			$author$project$Lists$RouteDetail$PrintSelection$ItemSelection,
			$author$project$Lists$RouteDetail$PrintSelection$All,
			'Alle looplijsten',
			A2($author$project$Lists$RouteDetail$PrintSelection$DependsOn, allSelected, children));
	});
var $author$project$Lists$RouteDetail$PrintSelection$blockWithTitle = F3(
	function (attrs, title, content) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_Utils_ap(
				attrs,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$alignTop,
						$mdgriffith$elm_ui$Element$Border$solid,
						$mdgriffith$elm_ui$Element$Border$color(
						A3($mdgriffith$elm_ui$Element$rgb255, 128, 128, 128)),
						$mdgriffith$elm_ui$Element$Border$width(1)
					])),
			_List_fromArray(
				[
					title,
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$padding(10),
							$mdgriffith$elm_ui$Element$spacing(5),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$htmlAttribute(
							A2($elm$html$Html$Attributes$style, 'flex-basis', 'auto'))
						]),
					content)
				]));
	});
var $author$project$Lists$RouteDetail$PrintSelection$ChangedProductSelection = function (a) {
	return {$: 2, a: a};
};
var $author$project$UI$Print$Font$black = A3($mdgriffith$elm_ui$Element$rgb, 0, 0, 0);
var $author$project$UI$Print$Font$franklinGothic = $mdgriffith$elm_ui$Element$Font$family(
	_List_fromArray(
		[
			$mdgriffith$elm_ui$Element$Font$typeface('Franklin Gothic Std Extra Condensed'),
			$mdgriffith$elm_ui$Element$Font$sansSerif
		]));
var $mdgriffith$elm_ui$Internal$Model$VariantActive = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Element$Font$smallCaps = $mdgriffith$elm_ui$Internal$Model$VariantActive('smcp');
var $mdgriffith$elm_ui$Internal$Flag$fontVariant = $mdgriffith$elm_ui$Internal$Flag$flag(48);
var $mdgriffith$elm_ui$Element$Font$variant = function (_var) {
	switch (_var.$) {
		case 0:
			var name = _var.a;
			return A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$fontVariant, 'v-' + name);
		case 1:
			var name = _var.a;
			return A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$fontVariant, 'v-' + (name + '-off'));
		default:
			var name = _var.a;
			var index = _var.b;
			return A2(
				$mdgriffith$elm_ui$Internal$Model$StyleClass,
				$mdgriffith$elm_ui$Internal$Flag$fontVariant,
				A3(
					$mdgriffith$elm_ui$Internal$Model$Single,
					'v-' + (name + ('-' + $elm$core$String$fromInt(index))),
					'font-feature-settings',
					'\"' + (name + ('\" ' + $elm$core$String$fromInt(index)))));
	}
};
var $author$project$UI$Print$Font$white = A3($mdgriffith$elm_ui$Element$rgb, 1, 1, 1);
var $author$project$UI$Print$Font$heading2 = _List_fromArray(
	[
		$mdgriffith$elm_ui$Element$padding(2),
		$mdgriffith$elm_ui$Element$Background$color($author$project$UI$Print$Font$black),
		$mdgriffith$elm_ui$Element$Font$color($author$project$UI$Print$Font$white),
		$mdgriffith$elm_ui$Element$Font$variant($mdgriffith$elm_ui$Element$Font$smallCaps),
		$author$project$UI$Print$Font$franklinGothic,
		$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
	]);
var $author$project$Lists$RouteDetail$PrintSelection$selectedBackgroundColor = $mdgriffith$elm_ui$Element$Background$color(
	A3($mdgriffith$elm_ui$Element$rgb255, 0, 123, 255));
var $author$project$Lists$RouteDetail$PrintSelection$divisionsView = function (productsSelection) {
	var style = function (selected) {
		return selected ? _List_fromArray(
			[
				$author$project$Lists$RouteDetail$PrintSelection$selectedBackgroundColor,
				$mdgriffith$elm_ui$Element$Font$color(
				A3($mdgriffith$elm_ui$Element$rgb255, 255, 255, 255))
			]) : _List_fromArray(
			[
				$mdgriffith$elm_ui$Element$Background$color(
				A3($mdgriffith$elm_ui$Element$rgb255, 255, 255, 255))
			]);
	};
	var align = function (selected) {
		return selected ? $mdgriffith$elm_ui$Element$alignRight : $mdgriffith$elm_ui$Element$alignLeft;
	};
	return A3(
		$author$project$Lists$RouteDetail$PrintSelection$blockWithTitle,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
			]),
		A2(
			$mdgriffith$elm_ui$Element$el,
			$author$project$UI$Print$Font$heading2,
			$mdgriffith$elm_ui$Element$text('Lijst opsplitsen')),
		A2(
			$elm$core$List$map,
			function (_v0) {
				var p = _v0.a;
				var sel = _v0.b;
				return A2(
					$mdgriffith$elm_ui$Element$Input$button,
					_Utils_ap(
						style(sel),
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$padding(1),
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
							])),
					{
						mD: A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									align(sel)
								]),
							$mdgriffith$elm_ui$Element$text(p.eg)),
						jp: $elm$core$Maybe$Just(
							$author$project$Lists$RouteDetail$PrintSelection$ChangedProductSelection(p.eg))
					});
			},
			productsSelection));
};
var $author$project$Lists$RouteDetail$PrintSelection$SelectedItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Lists$RouteDetail$PrintSelection$itemView = function (_v0) {
	var key = _v0.iY;
	var name = _v0.ft;
	var selected = _v0.nI;
	var withoutIcon = A2(
		$mdgriffith$elm_ui$Element$paragraph,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$spacing(1)
			]),
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$text(name)
			]));
	var withIcon = function (icon) {
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$spacing(6)
				]),
			_List_fromArray(
				[
					$author$project$UI$Element$iconFor(
					icon(18)),
					withoutIcon
				]));
	};
	var label = function () {
		if (key.$ === 1) {
			var item = key.a;
			var parents = key.b;
			switch (item.$) {
				case 0:
					return withIcon($icidasset$elm_material_icons$Material$Icons$directions_car);
				case 1:
					if (parents.b) {
						return withIcon($icidasset$elm_material_icons$Material$Icons$location_on);
					} else {
						return withoutIcon;
					}
				default:
					return withoutIcon;
			}
		} else {
			return withoutIcon;
		}
	}();
	var checked = function () {
		if (!selected.$) {
			var bool = selected.a;
			return bool;
		} else {
			var bool = selected.a;
			return bool;
		}
	}();
	return A2(
		$mdgriffith$elm_ui$Element$Input$checkbox,
		_List_Nil,
		{
			lc: checked,
			mg: $mdgriffith$elm_ui$Element$Input$defaultCheckbox,
			mD: A2(
				$mdgriffith$elm_ui$Element$Input$labelRight,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width(
						A2($mdgriffith$elm_ui$Element$minimum, 300, $mdgriffith$elm_ui$Element$fill))
					]),
				label),
			mY: $author$project$Lists$RouteDetail$PrintSelection$SelectedItem(key)
		});
};
var $author$project$Lists$RouteDetail$PrintSelection$itemSelectionView = function (itemSelection) {
	var _v0 = itemSelection.nI;
	if (!_v0.$) {
		return _List_fromArray(
			[
				$author$project$Lists$RouteDetail$PrintSelection$itemView(itemSelection)
			]);
	} else {
		var itemSelections = _v0.b;
		return _List_fromArray(
			[
				$author$project$Lists$RouteDetail$PrintSelection$itemView(itemSelection),
				A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$paddingEach(
						{k5: 5, mE: 16, nx: 0, ol: 5}),
						$mdgriffith$elm_ui$Element$spacing(5)
					]),
				A2($elm$core$List$concatMap, $author$project$Lists$RouteDetail$PrintSelection$itemSelectionView, itemSelections))
			]);
	}
};
var $author$project$Lists$RouteDetail$PrintSelection$ChangedDoubleSidedPrintingSelection = function (a) {
	return {$: 3, a: a};
};
var $author$project$Lists$RouteDetail$PrintSelection$doubleSidedPrintingSelectionView = function (model) {
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$spacing(5),
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
			]),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$Input$checkbox,
				_List_Nil,
				{
					lc: model.nl === 1,
					mg: $mdgriffith$elm_ui$Element$Input$defaultCheckbox,
					mD: A2(
						$mdgriffith$elm_ui$Element$Input$labelRight,
						_List_Nil,
						$mdgriffith$elm_ui$Element$text('Dubbelzijdig printen')),
					mY: $author$project$Lists$RouteDetail$PrintSelection$ChangedDoubleSidedPrintingSelection
				}),
				A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$Font$size(16),
						$mdgriffith$elm_ui$Element$padding(1),
						$mdgriffith$elm_ui$Element$alignRight
					]),
				$mdgriffith$elm_ui$Element$text('Opgelet, ook instellen bij printer.'))
			]));
};
var $author$project$Lists$RouteDetail$PrintSelection$printOptionsView = function (model) {
	return A3(
		$author$project$Lists$RouteDetail$PrintSelection$blockWithTitle,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
			]),
		A2(
			$mdgriffith$elm_ui$Element$el,
			$author$project$UI$Print$Font$heading2,
			$mdgriffith$elm_ui$Element$text('Printopties')),
		_List_fromArray(
			[
				$author$project$Lists$RouteDetail$PrintSelection$doubleSidedPrintingSelectionView(model)
			]));
};
var $author$project$Lists$RouteDetail$PrintSelection$ChangedComplaintVisilitySelection = function (a) {
	return {$: 5, a: a};
};
var $author$project$Lists$RouteDetail$PrintSelection$complaintVisibilitySelectionView = function (complaintVisibility) {
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$spacing(5),
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
			]),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$Input$checkbox,
				_List_Nil,
				{
					lc: complaintVisibility === 1,
					mg: $mdgriffith$elm_ui$Element$Input$defaultCheckbox,
					mD: A2(
						$mdgriffith$elm_ui$Element$Input$labelRight,
						_List_Nil,
						$mdgriffith$elm_ui$Element$text('Klachten verbergen')),
					mY: $author$project$Lists$RouteDetail$PrintSelection$ChangedComplaintVisilitySelection
				})
			]));
};
var $author$project$Lists$RouteDetail$PrintSelection$ChangedKioskListVisibility = function (a) {
	return {$: 7, a: a};
};
var $author$project$Lists$RouteDetail$PrintSelection$kioskListVisibilitySelectionView = function (kioskListVisibility) {
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$spacing(5),
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
			]),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$Input$checkbox,
				_List_Nil,
				{
					lc: kioskListVisibility === 1,
					mg: $mdgriffith$elm_ui$Element$Input$defaultCheckbox,
					mD: A2(
						$mdgriffith$elm_ui$Element$Input$labelRight,
						_List_Nil,
						$mdgriffith$elm_ui$Element$text('Ontvangstmasker LV verbergen')),
					mY: $author$project$Lists$RouteDetail$PrintSelection$ChangedKioskListVisibility
				})
			]));
};
var $author$project$Lists$RouteDetail$PrintSelection$ChangedMutationVisilitySelection = function (a) {
	return {$: 4, a: a};
};
var $author$project$Lists$RouteDetail$PrintSelection$mutationListVisibilitySelectionView = function (mutationVisibility) {
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$spacing(5),
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
			]),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$Input$checkbox,
				_List_Nil,
				{
					lc: mutationVisibility === 1,
					mg: $mdgriffith$elm_ui$Element$Input$defaultCheckbox,
					mD: A2(
						$mdgriffith$elm_ui$Element$Input$labelRight,
						_List_Nil,
						$mdgriffith$elm_ui$Element$text('Starts/stops verbergen')),
					mY: $author$project$Lists$RouteDetail$PrintSelection$ChangedMutationVisilitySelection
				})
			]));
};
var $author$project$Lists$RouteDetail$PrintSelection$ChangedRouteListVisibility = function (a) {
	return {$: 6, a: a};
};
var $author$project$Lists$RouteDetail$PrintSelection$routeListVisibilitySelectionView = function (routeListVisibility) {
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$spacing(5),
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
			]),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$Input$checkbox,
				_List_Nil,
				{
					lc: routeListVisibility === 1,
					mg: $mdgriffith$elm_ui$Element$Input$defaultCheckbox,
					mD: A2(
						$mdgriffith$elm_ui$Element$Input$labelRight,
						_List_Nil,
						$mdgriffith$elm_ui$Element$text('Routelijst verbergen')),
					mY: $author$project$Lists$RouteDetail$PrintSelection$ChangedRouteListVisibility
				})
			]));
};
var $author$project$Lists$RouteDetail$PrintSelection$restrictionsView = function (model) {
	return A3(
		$author$project$Lists$RouteDetail$PrintSelection$blockWithTitle,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
			]),
		A2(
			$mdgriffith$elm_ui$Element$el,
			$author$project$UI$Print$Font$heading2,
			$mdgriffith$elm_ui$Element$text('Lijst beperken')),
		_List_fromArray(
			[
				$author$project$Lists$RouteDetail$PrintSelection$routeListVisibilitySelectionView(model.fK),
				$author$project$Lists$RouteDetail$PrintSelection$kioskListVisibilitySelectionView(model.fn),
				$author$project$Lists$RouteDetail$PrintSelection$mutationListVisibilitySelectionView(model.jj),
				$author$project$Lists$RouteDetail$PrintSelection$complaintVisibilitySelectionView(model.h6)
			]));
};
var $author$project$Lists$RouteDetail$PrintSelection$ChangedSubscriptionSelection = function (a) {
	return {$: 1, a: a};
};
var $author$project$Lists$RouteDetail$PrintSelection$IrregularOrders = 1;
var $author$project$Lists$RouteDetail$PrintSelection$NoPartialSubscriptions = 3;
var $author$project$Lists$RouteDetail$PrintSelection$OnlyPartialSubscriptions = 2;
var $author$project$Lists$RouteDetail$PrintSelection$subscriptionSelectionView = function (selectedSubscriptions) {
	return $author$project$UI$Input$radio(
		{
			mD: $mdgriffith$elm_ui$Element$Input$labelHidden('Abonnementen'),
			mY: $author$project$Lists$RouteDetail$PrintSelection$ChangedSubscriptionSelection,
			m7: _List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$Input$option,
					0,
					$mdgriffith$elm_ui$Element$text('Toon alle abonnementen')),
					A2(
					$mdgriffith$elm_ui$Element$Input$option,
					2,
					$mdgriffith$elm_ui$Element$text('Toon enkel de deelabonnementen')),
					A2(
					$mdgriffith$elm_ui$Element$Input$option,
					3,
					$mdgriffith$elm_ui$Element$text('Toon zonder deelabonnementen')),
					A2(
					$mdgriffith$elm_ui$Element$Input$option,
					1,
					$mdgriffith$elm_ui$Element$text('Toon alles excl MA-ZA abonnees'))
				]),
			nI: $elm$core$Maybe$Just(selectedSubscriptions)
		});
};
var $author$project$Lists$RouteDetail$PrintSelection$subscriptionsView = function (selectedSubscriptions) {
	return A3(
		$author$project$Lists$RouteDetail$PrintSelection$blockWithTitle,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
			]),
		A2(
			$mdgriffith$elm_ui$Element$el,
			$author$project$UI$Print$Font$heading2,
			$mdgriffith$elm_ui$Element$text('Abonnementen')),
		_List_fromArray(
			[
				$author$project$Lists$RouteDetail$PrintSelection$subscriptionSelectionView(selectedSubscriptions)
			]));
};
var $author$project$Lists$RouteDetail$PrintSelection$view = F2(
	function (model, planInfo) {
		var selectedClusters = model.s;
		var selectedProducts = model.dy;
		var productsSelection = A2(
			$elm$core$List$map,
			function (p) {
				return _Utils_Tuple2(
					p,
					A2($elm$core$Set$member, p.eg, selectedProducts));
			},
			planInfo.bu);
		var itemSelection = A2($author$project$Lists$RouteDetail$PrintSelection$allItemSelection, planInfo, selectedClusters);
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$spacing(10),
					$author$project$UI$Element$invisibleForPrint,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Lists$RouteDetail$PrintSelection$blockWithTitle,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$fillPortion(1))
						]),
					A2(
						$mdgriffith$elm_ui$Element$el,
						$author$project$UI$Print$Font$heading2,
						$mdgriffith$elm_ui$Element$text('Looplijsten')),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$column,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$height(
									$mdgriffith$elm_ui$Element$px(400)),
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									$mdgriffith$elm_ui$Element$scrollbarY
								]),
							$author$project$Lists$RouteDetail$PrintSelection$itemSelectionView(itemSelection))
						])),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$spacing(10),
							$mdgriffith$elm_ui$Element$alignTop,
							$mdgriffith$elm_ui$Element$width(
							A2($mdgriffith$elm_ui$Element$maximum, 300, $mdgriffith$elm_ui$Element$fill))
						]),
					_List_fromArray(
						[
							$author$project$Lists$RouteDetail$PrintSelection$restrictionsView(model),
							$author$project$Lists$RouteDetail$PrintSelection$subscriptionsView(model.ev),
							$author$project$Lists$RouteDetail$PrintSelection$printOptionsView(model),
							$author$project$Lists$RouteDetail$PrintSelection$divisionsView(productsSelection)
						]))
				]));
	});
var $author$project$Lists$RouteDetail$RouteDetail$viewCountDownToEndSupportPaperList = function (clock) {
	var twoDigits = A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			$mdgriffith$elm_ui$Element$text,
			A2($elm$core$String$padLeft, 2, '0')),
		$elm$core$String$fromInt);
	var textAttributes = A2($elm$core$List$cons, $mdgriffith$elm_ui$Element$centerX, $author$project$UI$Font$heading2);
	var digitAttributes = _List_fromArray(
		[
			$mdgriffith$elm_ui$Element$Font$color(
			$author$project$UI$Element$colorFor($author$project$UI$Palette$green)),
			$mdgriffith$elm_ui$Element$centerX,
			$mdgriffith$elm_ui$Element$Font$size(60),
			$mdgriffith$elm_ui$Element$Font$bold
		]);
	switch (clock.$) {
		case 0:
			return $mdgriffith$elm_ui$Element$none;
		case 1:
			var daysLeft = clock.a.gj;
			var hour = clock.a.me;
			var minute = clock.a.mH;
			var second = clock.a.nF;
			return A2(
				$mdgriffith$elm_ui$Element$row,
				_List_fromArray(
					[
						$author$project$UI$Element$invisibleForPrint,
						$mdgriffith$elm_ui$Element$centerX,
						$mdgriffith$elm_ui$Element$spacing(20)
					]),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$el,
						textAttributes,
						$mdgriffith$elm_ui$Element$text('De papieren looplijst wordt nog ')),
						A2(
						$mdgriffith$elm_ui$Element$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$el,
								digitAttributes,
								twoDigits(daysLeft)),
								A2(
								$mdgriffith$elm_ui$Element$el,
								textAttributes,
								$mdgriffith$elm_ui$Element$text('Dagen'))
							])),
						A2(
						$mdgriffith$elm_ui$Element$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$el,
								digitAttributes,
								twoDigits(hour)),
								A2(
								$mdgriffith$elm_ui$Element$el,
								textAttributes,
								$mdgriffith$elm_ui$Element$text('Uren'))
							])),
						A2(
						$mdgriffith$elm_ui$Element$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$el,
								digitAttributes,
								twoDigits(minute)),
								A2(
								$mdgriffith$elm_ui$Element$el,
								textAttributes,
								$mdgriffith$elm_ui$Element$text('Minuten'))
							])),
						A2(
						$mdgriffith$elm_ui$Element$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$el,
								digitAttributes,
								twoDigits(second)),
								A2(
								$mdgriffith$elm_ui$Element$el,
								textAttributes,
								$mdgriffith$elm_ui$Element$text('Seconden'))
							])),
						A2(
						$mdgriffith$elm_ui$Element$el,
						textAttributes,
						$mdgriffith$elm_ui$Element$text('ondersteund.           '))
					]));
		case 2:
			return $mdgriffith$elm_ui$Element$none;
		default:
			return A2(
				$mdgriffith$elm_ui$Element$el,
				A2($elm$core$List$cons, $author$project$UI$Element$invisibleForPrint, textAttributes),
				$mdgriffith$elm_ui$Element$text('Gelieve Embrace te gebruiken, de papieren looplijst wordt niet meer ondersteund.'));
	}
};
var $author$project$Lists$RouteDetail$RouteDetail$routeDetailView = F3(
	function (model, planInfo, unAssignedSegments) {
		return A2(
			$mdgriffith$elm_ui$Element$map,
			$author$project$Lists$RouteDetail$RouteDetail$GotPrintSelectionMsg,
			A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$author$project$UI$Element$avoidPrintInterference,
						$author$project$UI$Spacing$default,
						$author$project$UI$Padding$default,
						$mdgriffith$elm_ui$Element$htmlAttribute(
						$elm$html$Html$Attributes$class('route-detail')),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				_List_fromArray(
					[
						$author$project$Lists$RouteDetail$RouteDetail$viewCountDownToEndSupportPaperList(model.e$),
						$author$project$Lists$RouteDetail$RouteDetail$unassignedSegmentsAlertView(unAssignedSegments),
						A2($author$project$Lists$RouteDetail$PrintSelection$view, model.$7, planInfo),
						$mdgriffith$elm_ui$Element$html(
						A2($author$project$Lists$RouteDetail$RouteDetail$itemsView, model, planInfo))
					])));
	});
var $author$project$Lists$RouteDetail$RouteDetail$view = function (model) {
	var _v0 = model.h;
	switch (_v0.$) {
		case 1:
			var planInfo = _v0.a;
			var unAssignedSegments = _Utils_ap(
				A2($author$project$Plan$Supply$findOpenSegments, planInfo.bn, planInfo.fA.gL),
				A3($author$project$Plan$Supply$findExpiredSegments, planInfo.bn, planInfo.e4, planInfo.fA.gL));
			return A3($author$project$Lists$RouteDetail$RouteDetail$routeDetailView, model, planInfo, unAssignedSegments);
		case 0:
			return $author$project$Lists$RouteDetail$RouteDetail$loadingView;
		default:
			return $author$project$Lists$RouteDetail$RouteDetail$problemView;
	}
};
var $author$project$Message$Message$UserSelectedAddMessage = {$: 2};
var $author$project$Message$Message$UserClickedDelete = function (a) {
	return {$: 16, a: a};
};
var $author$project$Message$Message$UserClickedEditButton = function (a) {
	return {$: 13, a: a};
};
var $author$project$Message$Message$periodView = F2(
	function (timeZone, period) {
		var viewDateTime = A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				$mdgriffith$elm_ui$Element$el(
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$Font$italic])),
				$mdgriffith$elm_ui$Element$text),
			$author$project$UI$DateTime$view(timeZone));
		return A2(
			$mdgriffith$elm_ui$Element$paragraph,
			_List_Nil,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$text('van '),
					viewDateTime(period.l2),
					$mdgriffith$elm_ui$Element$text(' tot '),
					viewDateTime(period.oj)
				]));
	});
var $author$project$Message$Message$viewMessage = F5(
	function (disabled, security, timeZone, containerWidth, _v0) {
		var messageId = _v0.a;
		var message = _v0.b;
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				_List_fromArray(
					[
						A2($author$project$Message$Message$periodView, timeZone, message.bA),
						A2(
						$mdgriffith$elm_ui$Element$paragraph,
						_List_Nil,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$html(
								$author$project$UI$Html$stringToHtml(message.ec))
							])),
						A2(
						$mdgriffith$elm_ui$Element$row,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$spacing(10),
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$UI$Element$iff,
								A2($author$project$Security$Security$can, $author$project$Security$Security$ManageMessages, security),
								$author$project$UI$Button$elementFor(
									A3(
										$author$project$UI$Button$disabledIf,
										disabled,
										'Bewerk eerst het huidige bericht',
										A2(
											$author$project$UI$Button$withRole,
											1,
											A2(
												$author$project$UI$Button$button,
												$author$project$Message$Message$UserClickedDelete(messageId),
												'Verwijderen'))))),
								A2(
								$author$project$UI$Element$iff,
								A2($author$project$Security$Security$can, $author$project$Security$Security$ManageMessages, security),
								$author$project$UI$Button$elementFor(
									A3(
										$author$project$UI$Button$disabledIf,
										disabled,
										'Bewerk eerst het huidige bericht',
										$author$project$UI$Button$withAlignRight(
											A2(
												$author$project$UI$Button$withRole,
												0,
												A2(
													$author$project$UI$Button$button,
													$author$project$Message$Message$UserClickedEditButton(messageId),
													'Aanpassen'))))))
							]))
					]),
				A2(
					$author$project$UI$Container$withWidth,
					containerWidth,
					A2(
						$author$project$UI$Container$withTitle,
						$mdgriffith$elm_ui$Element$text(message.oi),
						$author$project$UI$Container$container))));
	});
var $author$project$Message$Message$UserChangedFromDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Message$Message$UserChangedFromTime = function (a) {
	return {$: 4, a: a};
};
var $author$project$Message$Message$UserChangedTitle = function (a) {
	return {$: 7, a: a};
};
var $author$project$Message$Message$UserChangedToDate = function (a) {
	return {$: 5, a: a};
};
var $author$project$Message$Message$UserChangedToTime = function (a) {
	return {$: 6, a: a};
};
var $author$project$Message$Message$UserClickedAddConfirmButton = {$: 9};
var $author$project$Message$Message$UserClickedCancel = {$: 10};
var $author$project$Message$Message$canAddMessage = F2(
	function (zone, _v0) {
		var fromDate = _v0.co;
		var fromTime = _v0.cp;
		var toDate = _v0.cL;
		var toTime = _v0.cM;
		var title = _v0.oi;
		var text = _v0.n3;
		var selectedPermissions = _v0.b2;
		return (!_Utils_eq(
			A3($author$project$Message$Message$toPosix, zone, fromDate, fromTime),
			$elm$core$Maybe$Nothing)) && ((!_Utils_eq(
			A3($author$project$Message$Message$toPosix, zone, toDate, toTime),
			$elm$core$Maybe$Nothing)) && ((title !== '') && ((text !== '') && (!_Utils_eq(selectedPermissions, _List_Nil)))));
	});
var $author$project$Message$Message$UserChangedType = function (a) {
	return {$: 15, a: a};
};
var $author$project$Message$Message$messageTypes = _List_fromArray(
	[1, 0]);
var $author$project$Message$Message$toTypeName = function (messageType) {
	if (messageType === 1) {
		return 'Nieuws';
	} else {
		return 'Melding';
	}
};
var $author$project$Message$Message$messageTypeFormField = function (selected) {
	return $author$project$UI$Input$radio(
		{
			mD: $author$project$UI$Input$label('Soort'),
			mY: $author$project$Message$Message$UserChangedType,
			m7: A2(
				$elm$core$List$map,
				function (k) {
					return A2(
						$mdgriffith$elm_ui$Element$Input$option,
						k,
						$mdgriffith$elm_ui$Element$text(
							$author$project$Message$Message$toTypeName(k)));
				},
				$author$project$Message$Message$messageTypes),
			nI: $elm$core$Maybe$Just(selected)
		});
};
var $author$project$Message$Message$messagePermissions = _List_fromArray(
	[0, 1, 2]);
var $author$project$Message$Message$toPermissionName = function (permission) {
	switch (permission) {
		case 0:
			return 'Bezorgers';
		case 1:
			return 'Regiodistributeurs';
		default:
			return 'Regiomanagers';
	}
};
var $author$project$Message$Message$availablePermissions = A2(
	$elm$core$List$map,
	function (p) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$author$project$Message$Message$toPermissionName,
			A2($elm$core$Tuple$pair, p, p));
	},
	$author$project$Message$Message$messagePermissions);
var $author$project$Message$Message$UserChangedPermissions = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Message$Message$permissionsCheckboxView = F2(
	function (selected, _v0) {
		var id = _v0.a;
		var name = _v0.b;
		return A2(
			$mdgriffith$elm_ui$Element$Input$checkbox,
			_List_Nil,
			{
				lc: A2($elm$core$List$member, id, selected),
				mg: $mdgriffith$elm_ui$Element$Input$defaultCheckbox,
				mD: A2(
					$mdgriffith$elm_ui$Element$Input$labelRight,
					_List_Nil,
					$mdgriffith$elm_ui$Element$text(name)),
				mY: $author$project$Message$Message$UserChangedPermissions(id)
			});
	});
var $author$project$Message$Message$permissionsFormField = function (selected) {
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$spacing(2)
			]),
		A2(
			$elm$core$List$cons,
			$mdgriffith$elm_ui$Element$text('Doelgroep'),
			A2(
				$elm$core$List$map,
				$author$project$Message$Message$permissionsCheckboxView(selected),
				$author$project$Message$Message$availablePermissions)));
};
var $author$project$Message$Message$UserChangedText = function (a) {
	return {$: 8, a: a};
};
var $author$project$UI$MarkdownEditor$MarkdownEditor$editor = {gl: false, iK: '300px', fj: ''};
var $author$project$UI$MarkdownEditor$MarkdownEditor$destroyToString = function (b) {
	return b ? 'true' : 'false';
};
var $author$project$UI$MarkdownEditor$MarkdownEditor$view = F2(
	function (onchange, options) {
		return A3(
			$elm$html$Html$node,
			'markdown-editor',
			_List_fromArray(
				[
					A2(
					$elm$html$Html$Events$on,
					'change',
					A2(
						$elm$json$Json$Decode$map,
						onchange,
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['detail']),
							$elm$json$Json$Decode$string))),
					A2($elm$html$Html$Attributes$attribute, 'initialvalue', options.fj),
					A2($elm$html$Html$Attributes$attribute, 'height', options.iK),
					A2(
					$elm$html$Html$Attributes$attribute,
					'destroy',
					$author$project$UI$MarkdownEditor$MarkdownEditor$destroyToString(options.gl))
				]),
			_List_Nil);
	});
var $author$project$UI$MarkdownEditor$MarkdownEditor$withInitialValue = F2(
	function (value, options) {
		return _Utils_update(
			options,
			{fj: value});
	});
var $author$project$Message$Message$toastEditor = function (content) {
	return A2(
		$author$project$UI$MarkdownEditor$MarkdownEditor$view,
		$author$project$Message$Message$UserChangedText,
		A2($author$project$UI$MarkdownEditor$MarkdownEditor$withInitialValue, content, $author$project$UI$MarkdownEditor$MarkdownEditor$editor));
};
var $author$project$Message$Message$viewMessageForm = F3(
	function (timeZone, message, containerWidth) {
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$column,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$spacing(10),
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
							]),
						_List_fromArray(
							[
								$author$project$UI$Input$row(
								_List_fromArray(
									[
										A2(
										$author$project$UI$Input$date,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$width(
												$mdgriffith$elm_ui$Element$px(180))
											]),
										{
											mD: $author$project$UI$Input$label('Van'),
											mY: $author$project$Message$Message$UserChangedFromDate,
											ng: $elm$core$Maybe$Nothing,
											n3: message.co
										}),
										A2(
										$mdgriffith$elm_ui$Element$Input$text,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$width(
												$mdgriffith$elm_ui$Element$px(80))
											]),
										{
											mD: $author$project$UI$Input$label(' '),
											mY: $author$project$Message$Message$UserChangedFromTime,
											ng: $elm$core$Maybe$Nothing,
											n3: message.cp
										}),
										A2(
										$author$project$UI$Input$date,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$width(
												$mdgriffith$elm_ui$Element$px(180))
											]),
										{
											mD: $author$project$UI$Input$label('Tot'),
											mY: $author$project$Message$Message$UserChangedToDate,
											ng: $elm$core$Maybe$Nothing,
											n3: message.cL
										}),
										A2(
										$mdgriffith$elm_ui$Element$Input$text,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$width(
												$mdgriffith$elm_ui$Element$px(80))
											]),
										{
											mD: $author$project$UI$Input$label(' '),
											mY: $author$project$Message$Message$UserChangedToTime,
											ng: $elm$core$Maybe$Nothing,
											n3: message.cM
										})
									])),
								$author$project$UI$Input$row(
								_List_fromArray(
									[
										A2(
										$mdgriffith$elm_ui$Element$Input$text,
										_List_Nil,
										{
											mD: $author$project$UI$Input$label('Titel'),
											mY: $author$project$Message$Message$UserChangedTitle,
											ng: $elm$core$Maybe$Nothing,
											n3: message.oi
										})
									])),
								$author$project$UI$Input$row(
								_List_fromArray(
									[
										$author$project$Message$Message$messageTypeFormField(message.dz),
										$author$project$Message$Message$permissionsFormField(message.b2)
									])),
								$author$project$UI$Input$row(
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$html(
										$author$project$Message$Message$toastEditor(message.n3))
									])),
								$author$project$UI$Input$row(
								_List_fromArray(
									[
										$author$project$UI$Button$elementFor(
										A2(
											$author$project$UI$Button$withRole,
											1,
											A2($author$project$UI$Button$button, $author$project$Message$Message$UserClickedCancel, 'Annuleren'))),
										$author$project$UI$Button$elementFor(
										A3(
											$author$project$UI$Button$disabledIf,
											!A2($author$project$Message$Message$canAddMessage, timeZone, message),
											'Ongeldige datum',
											$author$project$UI$Button$withAlignRight(
												A2(
													$author$project$UI$Button$withRole,
													0,
													A2($author$project$UI$Button$button, $author$project$Message$Message$UserClickedAddConfirmButton, 'Opslaan')))))
									]))
							]))
					]),
				A2($author$project$UI$Container$withWidth, containerWidth, $author$project$UI$Container$container)));
	});
var $author$project$Message$Message$view = F2(
	function (share, model) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$padding(10),
					$mdgriffith$elm_ui$Element$spacing(10),
					$mdgriffith$elm_ui$Element$centerX
				]),
			function () {
				var _v0 = model.di;
				switch (_v0.$) {
					case 0:
						return _List_Nil;
					case 1:
						var messages = _v0.a;
						var timeZone = $author$project$Portal$Share$timeZone(share);
						var security = $author$project$Portal$Share$security(share);
						var containerWidth = $mdgriffith$elm_ui$Element$px(580);
						var addButton = function (disabled) {
							return $author$project$UI$Button$elementFor(
								A3(
									$author$project$UI$Button$disabledIf,
									disabled,
									'Een ander bericht wordt bewerkt',
									A2(
										$author$project$UI$Button$withIcon,
										$icidasset$elm_material_icons$Material$Icons$add,
										A2(
											$author$project$UI$Button$withRole,
											0,
											A2($author$project$UI$Button$button, $author$project$Message$Message$UserSelectedAddMessage, 'Bericht toevoegen')))));
						};
						var _v1 = model.ac;
						switch (_v1.$) {
							case 1:
								var messageForm = _v1.a;
								return A2(
									$elm$core$List$cons,
									A3($author$project$Message$Message$viewMessageForm, timeZone, messageForm, containerWidth),
									A2(
										$elm$core$List$map,
										A4($author$project$Message$Message$viewMessage, true, security, timeZone, containerWidth),
										$elm$core$List$reverse(messages)));
							case 2:
								var id = _v1.a;
								var messageForm = _v1.b;
								var viewItem = function (message) {
									return _Utils_eq(id, message.a) ? A3($author$project$Message$Message$viewMessageForm, timeZone, messageForm, containerWidth) : A5($author$project$Message$Message$viewMessage, true, security, timeZone, containerWidth, message);
								};
								return A2(
									$elm$core$List$cons,
									addButton(true),
									A2(
										$elm$core$List$map,
										viewItem,
										$elm$core$List$reverse(messages)));
							default:
								return A2(
									$elm$core$List$cons,
									addButton(false),
									A2(
										$elm$core$List$map,
										A4($author$project$Message$Message$viewMessage, false, security, timeZone, containerWidth),
										$elm$core$List$reverse(messages)));
						}
					default:
						return _List_Nil;
				}
			}());
	});
var $author$project$Compensation$Money$ShowEuros = 0;
var $elm$core$String$pad = F3(
	function (n, _char, string) {
		var half = (n - $elm$core$String$length(string)) / 2;
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				$elm$core$Basics$ceiling(half),
				$elm$core$String$fromChar(_char)),
			_Utils_ap(
				string,
				A2(
					$elm$core$String$repeat,
					$elm$core$Basics$floor(half),
					$elm$core$String$fromChar(_char))));
	});
var $author$project$Date$Extra$view = function (date) {
	var viewTwoDigitNumber = function (number) {
		return A3(
			$elm$core$String$pad,
			2,
			'0',
			$elm$core$String$fromInt(number));
	};
	return A2(
		$elm$core$String$join,
		'-',
		_List_fromArray(
			[
				viewTwoDigitNumber(
				$justinmimbs$date$Date$day(date)),
				viewTwoDigitNumber(
				$justinmimbs$date$Date$monthNumber(date)),
				$elm$core$String$fromInt(
				$justinmimbs$date$Date$year(date))
			]));
};
var $author$project$Payment$AnnualDetail$tableView = F2(
	function (amount, _v0) {
		var bsn = _v0.gd;
		var birthDate = _v0.kZ;
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('payment-info')
				]),
			$elm_community$maybe_extra$Maybe$Extra$values(
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$td,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Opbrengsten')
										])),
									A2(
									$elm$html$Html$td,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($author$project$Compensation$Money$view, 0, amount))
										]))
								]))),
						A2(
						$elm$core$Maybe$map,
						function (b) {
							return A2(
								$elm$html$Html$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('BSN-nummer')
											])),
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(b)
											]))
									]));
						},
						bsn),
						$elm$core$Maybe$Just(
						A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$td,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Geboortedatum')
										])),
									A2(
									$elm$html$Html$td,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Date$Extra$view(birthDate))
										]))
								])))
					])));
	});
var $author$project$Payment$AnnualDetail$body = function (_v0) {
	var amount = _v0.aa;
	var deliverer = _v0.bl;
	var year = _v0.kC;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('body')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('id')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Relatienr: '),
						$elm$html$Html$text(
						A2(
							$elm$core$Maybe$withDefault,
							'onbekend',
							$author$project$UI$Paradise$idView(deliverer)))
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Hierbij ontvangt u uw Jaaropgaaf '),
						$elm$html$Html$text(
						$elm$core$String$fromInt(year)),
						$elm$html$Html$text(' over uw Opbrengsten uit Overige Werkzaamheden, met betrekking tot krantenbezorging, -transportactiviteiten etc.')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Bij ontvangst van meerdere opgaven geldt het gezamelijk totaalbedrag.')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Bewaar deze opgave zorgvuldig, omdat deze slechts éénmaal wordt verstrekt. Bij aanvraag kopie, kunnen wij administratiekosten in rekening brengen.')
					])),
				A2($author$project$Payment$AnnualDetail$tableView, amount, deliverer),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Wij hebben bovenstaande gegevens doorgegeven aan de belastingdienst.')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Op dit bedrag is geen loonbelasting of sociale premies ingehouden.')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('U bent zelf verantwoordelijk voor de aftrek en onderbouwing van eventueel gemaakte zakelijke kosten.')
					]))
			]));
};
var $author$project$Payment$AnnualDetail$footer = function (source) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('footer')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Afzender: ')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('entity')
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(source.ft)
							])),
					function (_v0) {
						var l1 = _v0.a;
						var l2 = _v0.b;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(l1)
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(l2)
									]))
							]);
					}(
						_Utils_Tuple2(
							source.f1,
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[source.cT, source.bU]))))))
			]));
};
var $author$project$Payment$AnnualDetail$delivererForStatementView = function (_v0) {
	var initials = _v0.gI;
	var prefix = _v0.fF;
	var lastName = _v0.fo;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2(
					$elm$core$String$join,
					' ',
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								initials,
								prefix,
								$elm$core$Maybe$Just(lastName)
							]))))
			]));
};
var $author$project$Address$Address$oneLineView = function (_v0) {
	var street = _v0.b5;
	var houseNumber = _v0.bs;
	var zipCode = _v0.cT;
	var municipal = _v0.bU;
	return A2(
		$elm$core$String$join,
		' ',
		_List_fromArray(
			[
				street,
				$author$project$Address$Address$houseNumberView(houseNumber),
				zipCode,
				municipal
			]));
};
var $author$project$Payment$AnnualDetail$header = function (deliverer) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('header')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('address')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Retouradres: '),
						$elm$html$Html$text(
						$author$project$Address$Address$oneLineView($author$project$Payment$Company$dpgMedia.nh))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('entity')
					]),
				A2(
					$elm$core$List$cons,
					$author$project$Payment$AnnualDetail$delivererForStatementView(deliverer),
					function (_v0) {
						var l1 = _v0.a;
						var l2 = _v0.b;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(l1)
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(l2)
									]))
							]);
					}(
						$author$project$Address$Address$twoLineView(deliverer.f1))))
			]));
};
var $author$project$Payment$AnnualDetail$annualStatementView = function (payment) {
	return $mdgriffith$elm_ui$Element$html(
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('annual-statement')
				]),
			_List_fromArray(
				[
					$author$project$Payment$AnnualDetail$header(payment.bl),
					$author$project$Payment$AnnualDetail$body(payment),
					$author$project$Payment$AnnualDetail$footer(payment.nO)
				])));
};
var $author$project$Payment$AnnualDetail$view = F2(
	function (_v0, model) {
		switch (model.$) {
			case 0:
				return $mdgriffith$elm_ui$Element$none;
			case 1:
				var payment = model.a;
				return A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$centerX]),
					$author$project$Payment$AnnualDetail$annualStatementView(payment));
			default:
				return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$Payment$Archive$AnnualSelection = function (a) {
	return {$: 1, a: a};
};
var $author$project$Payment$Archive$MonthlySelection = function (a) {
	return {$: 2, a: a};
};
var $author$project$Payment$Archive$NoPaymentSelection = {$: 0};
var $author$project$Payment$Archive$UserSelectedDeliverer = function (a) {
	return {$: 6, a: a};
};
var $author$project$Payment$Archive$delivererView = F2(
	function (selectedDeliverer, deliverer) {
		return $author$project$UI$Card$elementFor(
			A2(
				$author$project$UI$Card$withContent,
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$el,
						$author$project$UI$Font$tag,
						$mdgriffith$elm_ui$Element$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								$author$project$UI$Paradise$idView(deliverer)))),
						A2(
						$mdgriffith$elm_ui$Element$paragraph,
						_List_Nil,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text(
								$author$project$Deliverer$Deliverer$nameView(deliverer))
							]))
					]),
				A2(
					$author$project$UI$Card$selectedIf,
					_Utils_eq(
						selectedDeliverer,
						$elm$core$Maybe$Just(deliverer)),
					$author$project$UI$Card$card(
						$author$project$Payment$Archive$UserSelectedDeliverer(deliverer)))));
	});
var $author$project$Payment$Archive$delivererWidth = 300;
var $author$project$UI$Padding$smallSize = 5;
var $author$project$Payment$Archive$deliverersView = F3(
	function (deliverers, selectedDeliverer, window) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$paddingEach(
					{k5: $author$project$UI$Padding$smallSize, mE: 0, nx: $author$project$UI$Padding$defaultSize, ol: $author$project$UI$Padding$smallSize}),
					$author$project$UI$Spacing$default,
					$mdgriffith$elm_ui$Element$width(
					$mdgriffith$elm_ui$Element$px($author$project$Payment$Archive$delivererWidth)),
					$mdgriffith$elm_ui$Element$height(
					$mdgriffith$elm_ui$Element$px(window.iK)),
					$mdgriffith$elm_ui$Element$scrollbarY,
					$mdgriffith$elm_ui$Element$alignTop,
					$author$project$UI$Element$invisibleForPrint
				]),
			A2(
				$elm$core$List$map,
				$author$project$Payment$Archive$delivererView(selectedDeliverer),
				A2(
					$elm$core$List$sortBy,
					function ($) {
						return $.fc;
					},
					deliverers)));
	});
var $author$project$Payment$Archive$UserSelectedAnnualPayment = function (a) {
	return {$: 8, a: a};
};
var $author$project$Payment$Archive$annualCardView = F2(
	function (selected, annualSummary) {
		return $author$project$UI$Card$elementFor(
			A2(
				$author$project$UI$Card$withContent,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$text('Jaaropgaaf'),
						A2(
						$mdgriffith$elm_ui$Element$el,
						$author$project$UI$Font$heading2,
						$mdgriffith$elm_ui$Element$text(
							$elm$core$String$fromInt(annualSummary.kC)))
					]),
				A2(
					$author$project$UI$Card$selectedIf,
					_Utils_eq(
						selected,
						$author$project$Payment$Archive$AnnualSelection(annualSummary)),
					$author$project$UI$Card$card(
						$author$project$Payment$Archive$UserSelectedAnnualPayment(annualSummary)))));
	});
var $author$project$Payment$Archive$UserSelectedMonthlyPayment = function (a) {
	return {$: 7, a: a};
};
var $author$project$Date$DeliveryDate$inclusiveEndOf = function (_v0) {
	var to = _v0.oj;
	return A2(
		$author$project$Date$DeliveryDate$move,
		$author$project$Date$DeliveryDate$toDate(to),
		-1);
};
var $author$project$Date$DeliveryDate$inclusiveRangeView = function (range) {
	var from = range.l2;
	return _Utils_Tuple2(
		$author$project$Date$DeliveryDate$viewDMY(from),
		$author$project$Date$DeliveryDate$viewDMY(
			$author$project$Date$DeliveryDate$inclusiveEndOf(range)));
};
var $author$project$Compensation$WagePeriod$dateView = function (wagePeriod) {
	return function (_v0) {
		var from = _v0.a;
		var to = _v0.b;
		return '(' + (from + (' t/m ' + (to + ')')));
	}(
		$author$project$Date$DeliveryDate$inclusiveRangeView(wagePeriod));
};
var $author$project$Compensation$WagePeriod$nameView = function (_v0) {
	var year = _v0.kC;
	var period = _v0.jv;
	return $elm$core$String$fromInt(year) + ('-' + $elm$core$String$fromInt(period));
};
var $author$project$Payment$Archive$cardView = F2(
	function (selected, summary) {
		return $author$project$UI$Card$elementFor(
			A2(
				$author$project$UI$Card$withContent,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$text('Vergoedingsspecificatie'),
						A2(
						$mdgriffith$elm_ui$Element$el,
						$author$project$UI$Font$heading2,
						$mdgriffith$elm_ui$Element$text(
							$author$project$Compensation$WagePeriod$nameView(summary.dK))),
						$mdgriffith$elm_ui$Element$text(
						$author$project$Compensation$WagePeriod$dateView(summary.dK))
					]),
				A2(
					$author$project$UI$Card$selectedIf,
					_Utils_eq(
						selected,
						$author$project$Payment$Archive$MonthlySelection(summary)),
					$author$project$UI$Card$card(
						$author$project$Payment$Archive$UserSelectedMonthlyPayment(summary)))));
	});
var $author$project$Payment$Archive$loadedSummariesView = F3(
	function (selected, _v0, window) {
		var annual = _v0.bE;
		var monthly = _v0.bT;
		var summaryWidth = 260;
		var _v1 = _Utils_Tuple2(annual, monthly);
		if ((!_v1.a.b) && (!_v1.b.b)) {
			return A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Element$paddingXY, 10, 0),
						$mdgriffith$elm_ui$Element$centerX,
						$mdgriffith$elm_ui$Element$alignTop
					]),
				$author$project$UI$Container$elementFor(
					A2(
						$author$project$UI$Container$withWidth,
						$mdgriffith$elm_ui$Element$px(summaryWidth),
						A2(
							$author$project$UI$Container$withContent,
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$paragraph,
									_List_Nil,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$text('Er zijn geen vergoedingsspecificaties beschikbaar.')
										]))
								]),
							$author$project$UI$Container$container))));
		} else {
			return A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Element$paddingXY, 10, 5),
						$author$project$UI$Spacing$default,
						$mdgriffith$elm_ui$Element$width(
						$mdgriffith$elm_ui$Element$px(summaryWidth)),
						$mdgriffith$elm_ui$Element$height(
						$mdgriffith$elm_ui$Element$px(window.iK)),
						$mdgriffith$elm_ui$Element$scrollbarY,
						$mdgriffith$elm_ui$Element$alignTop,
						$author$project$UI$Element$invisibleForPrint
					]),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						$author$project$Payment$Archive$annualCardView(selected),
						A2(
							$elm$core$List$sortBy,
							function (s) {
								return -s.kC;
							},
							annual)),
					A2(
						$elm$core$List$map,
						$author$project$Payment$Archive$cardView(selected),
						A2(
							$elm$core$List$sortBy,
							function (s) {
								return _Utils_Tuple2(-s.dK.kC, -s.dK.jv);
							},
							monthly))));
		}
	});
var $author$project$Payment$Archive$noDeliverersFoundView = A2(
	$mdgriffith$elm_ui$Element$el,
	_List_fromArray(
		[
			A2($mdgriffith$elm_ui$Element$paddingXY, 10, 0),
			$mdgriffith$elm_ui$Element$alignTop
		]),
	$author$project$UI$Container$elementFor(
		A2(
			$author$project$UI$Container$withWidth,
			$mdgriffith$elm_ui$Element$px($author$project$Payment$Archive$delivererWidth),
			A2(
				$author$project$UI$Container$withContent,
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$paragraph,
						_List_Nil,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text('Geen bezorgers gevonden.')
							]))
					]),
				$author$project$UI$Container$container))));
var $elm$html$Html$br = _VirtualDom_node('br');
var $author$project$Payment$Detail$moneyView = $author$project$Compensation$Money$view(1);
var $author$project$Payment$Detail$footer = function (payment) {
	var _v0 = payment.bl;
	switch (_v0.$) {
		case 0:
			return A2(
				$author$project$Print$SizedHtml$withSize,
				4,
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$table,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('totals')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Totaal berekend deze periode')
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('number')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Payment$Detail$moneyView(payment.bD.g_))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Totaal verrekend of ingehouden')
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('number')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Payment$Detail$moneyView(
														A2(
															$elm$core$Maybe$withDefault,
															$author$project$Compensation$Money$euro(0),
															payment.bD.h1)))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('totals-bold')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Totaal uit te betalen deze periode')
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('number')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Payment$Detail$moneyView(payment.bD.ju))
												]))
										]))
								])),
							$elm$html$Html$text(
							'Wij zullen dit bedrag overmaken op uw bankrekeningnummer ' + A2($elm$core$Maybe$withDefault, '', payment.gE))
						])));
		case 1:
			return A2(
				$author$project$Print$SizedHtml$withSize,
				4,
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$table,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('totals')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('totals-bold')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Totaal berekend deze periode')
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('number')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Payment$Detail$moneyView(payment.bD.g_))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Waarvan vergoedingen')
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('number')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Payment$Detail$moneyView(payment.bD.ao))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Waarvan kostenvergoedingen')
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('number')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Payment$Detail$moneyView(
														A2(
															$elm$core$Maybe$withDefault,
															$author$project$Compensation$Money$euro(0),
															payment.bD.nt)))
												]))
										]))
								])),
							$elm$html$Html$text('Over het bedrag van de vergoedingen zullen loonheffing en premies werknemersverzekering worden berekend.')
						])));
		default:
			return A2(
				$author$project$Print$SizedHtml$withSize,
				8,
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$table,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('totals')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Totaal excl. BTW')
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('number')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Payment$Detail$moneyView(payment.bD.g_))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('BTW 21%')
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('number')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Payment$Detail$moneyView(
														A2(
															$elm$core$Maybe$withDefault,
															$author$project$Compensation$Money$euro(0),
															payment.bD.ot)))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Totaal incl. BTW')
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('number')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Payment$Detail$moneyView(
														A2(
															$elm$core$Maybe$withDefault,
															$author$project$Compensation$Money$euro(0),
															payment.bD.mk)))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2($elm$html$Html$br, _List_Nil, _List_Nil)
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2($elm$html$Html$br, _List_Nil, _List_Nil)
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Totaal verrekend of ingehouden')
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('number')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Payment$Detail$moneyView(
														A2(
															$elm$core$Maybe$withDefault,
															$author$project$Compensation$Money$euro(0),
															payment.bD.h1)))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('totals-bold')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Totaal uit te betalen deze periode')
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('number')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Payment$Detail$moneyView(payment.bD.ju))
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'Wij zullen dit bedrag overmaken op uw bankrekeningnummer ' + A2($elm$core$Maybe$withDefault, '', payment.gE))
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('* factuur uitgereikt door afnemer')
								]))
						])));
	}
};
var $author$project$Payment$Detail$frontPageGroupView = function (_v0) {
	var description = _v0.ig;
	var amount = _v0.aa;
	var payments = _v0.ep;
	var groupedPaymentView = function (payment) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(payment.ig)
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('number')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Payment$Detail$moneyView(payment.aa))
						]))
				]));
	};
	return A2(
		$author$project$Print$SizedHtml$withSize,
		4 + $elm$core$List$length(payments),
		A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('group')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$tr,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$th,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$colspan(2)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(description)
								]))
						])),
				_Utils_ap(
					A2($elm$core$List$map, groupedPaymentView, payments),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('group-total')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$td,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Totaal ' + description)
										])),
									A2(
									$elm$html$Html$td,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('number')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Payment$Detail$moneyView(amount))
										]))
								]))
						])))));
};
var $author$project$Compensation$Money$isZero = function (_v0) {
	var m = _v0;
	return !m;
};
var $author$project$Print$SizedHtml$rowDiv = F2(
	function (attrs, items) {
		return A2(
			$author$project$Print$SizedHtml$withSize,
			A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$List$maximum(
					A2($elm$core$List$map, $elm$core$Tuple$second, items))),
			A2(
				$elm$html$Html$div,
				attrs,
				A2($elm$core$List$map, $elm$core$Tuple$first, items)));
	});
var $author$project$Payment$Detail$frontPageTotals = F2(
	function (_v0, summary) {
		var totals = _v0.bD;
		var box = F3(
			function (title, subtitle, value) {
				return A2(
					$author$project$Print$SizedHtml$withSize,
					6,
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(title)
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(subtitle)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('value')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(value)
									]))
							])));
			});
		return A2(
			$author$project$Print$SizedHtml$rowDiv,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('overview-totals')
				]),
			_List_fromArray(
				[
					A3(
					box,
					'Oplage',
					' ',
					$elm$core$String$fromInt(summary.bD.Y)),
					A3(
					box,
					'Aantal',
					'bijlagen',
					$elm$core$String$fromInt(summary.bD.iT)),
					$author$project$Compensation$Money$isZero(summary.bD.iO) ? $author$project$Print$SizedHtml$none : A3(
					box,
					'Extra',
					'vergoeding',
					$author$project$Payment$Detail$moneyView(summary.bD.iO)),
					A3(
					box,
					'Totale',
					'vergoeding',
					$author$project$Payment$Detail$moneyView(summary.bD.aa))
				]));
	});
var $author$project$Payment$Detail$frontPage = F3(
	function (payment, overview, document) {
		var deliverer = payment.bl;
		var wagePeriod = payment.dK;
		return $author$project$Print$Document$nextPage(
			A2(
				$author$project$Print$Document$addSizedHtml,
				_Utils_Tuple2(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('overview-ref')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Voor specificatie van bovenstaande vergoedingen, zie de volgende pagina(\'s).')
							])),
					1),
				A2(
					$author$project$Print$Document$addSizedHtml,
					$author$project$Payment$Detail$footer(payment),
					A2(
						$author$project$Print$Document$addMultiple,
						A2(
							$elm$core$List$map,
							$author$project$Payment$Detail$frontPageGroupView,
							A2(
								$elm$core$List$sortBy,
								function ($) {
									return $.eg;
								},
								overview.l8)),
						A2(
							$author$project$Print$Document$addSizedHtml,
							A2($author$project$Payment$Detail$frontPageTotals, payment, overview),
							A2(
								$author$project$Print$Document$addSizedHtml,
								_Utils_Tuple2(
									A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('overview-title')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												'Periode ' + ($author$project$Compensation$WagePeriod$nameView(wagePeriod) + (' ' + $author$project$Compensation$WagePeriod$dateView(wagePeriod))))
											])),
									2),
								document))))));
	});
var $author$project$Print$SizedHtml$add = F2(
	function (_v0, _v1) {
		var secondHtml = _v0.a;
		var secondSize = _v0.b;
		var firstHtml = _v1.a;
		var firstSize = _v1.b;
		return _Utils_Tuple2(
			_Utils_ap(
				firstHtml,
				_List_fromArray(
					[secondHtml])),
			firstSize + secondSize);
	});
var $author$project$Payment$Payment$addressOf = function (deliverer) {
	switch (deliverer.$) {
		case 0:
			var address = deliverer.a.f1;
			return address;
		case 1:
			var address = deliverer.a.f1;
			return address;
		default:
			var address = deliverer.a.f1;
			return address;
	}
};
var $author$project$Payment$Payment$delivererNameView = function (deliverer) {
	var deliverInfoNameView = function (_v1) {
		var salutation = _v1.hi;
		var firstName = _v1.fc;
		var surname = _v1.kl;
		var lastName = _v1.fo;
		return A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						salutation,
						firstName,
						surname,
						$elm$core$Maybe$Just(lastName)
					])));
	};
	switch (deliverer.$) {
		case 0:
			var info = deliverer.a;
			return deliverInfoNameView(info);
		case 1:
			var info = deliverer.a;
			return deliverInfoNameView(info);
		default:
			var companyType = deliverer.a.h5;
			var companyName = deliverer.a.eU;
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[companyType, companyName]));
	}
};
var $author$project$Payment$Detail$entityView = function (deliverer) {
	return A2(
		$author$project$Print$SizedHtml$withSize,
		3,
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('entity')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Payment$Payment$delivererNameView(deliverer))
						])),
				function (_v0) {
					var l1 = _v0.a;
					var l2 = _v0.b;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(l1)
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(l2)
								]))
						]);
				}(
					$author$project$Address$Address$twoLineView(
						$author$project$Payment$Payment$addressOf(deliverer))))));
};
var $author$project$Payment$Detail$pageNumber = function (_v0) {
	var current = _v0.h9;
	var total = _v0.dH;
	return A2(
		$author$project$Print$SizedHtml$withSize,
		1,
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('page-number')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					'pagina ' + ($elm$core$String$fromInt(current) + (' van ' + $elm$core$String$fromInt(total))))
				])));
};
var $author$project$Payment$Payment$tagsOf = function (deliverer) {
	switch (deliverer.$) {
		case 0:
			var tags = deliverer.a.kn;
			return {kn: tags};
		case 1:
			var tags = deliverer.a.kn;
			return {kn: tags};
		default:
			var tags = deliverer.a.kn;
			return {kn: tags};
	}
};
var $author$project$Payment$Detail$paymentInfo = function (_v0) {
	var deliverer = _v0.bl;
	var wagePeriod = _v0.dK;
	var _v1 = $author$project$Date$DeliveryDate$inclusiveRangeView(wagePeriod);
	var fromView = _v1.a;
	var toView = _v1.b;
	var _v2 = function () {
		if (deliverer.$ === 2) {
			var firm = deliverer.a;
			var _v4 = firm.ou;
			if (!_v4.$) {
				var number = _v4.a;
				return _Utils_Tuple2(
					_List_fromArray(
						[
							_Utils_Tuple2('BTW nr.', number)
						]),
					'payment-info-firm');
			} else {
				return _Utils_Tuple2(_List_Nil, 'payment-info');
			}
		} else {
			return _Utils_Tuple2(_List_Nil, 'payment-info');
		}
	}();
	var vatNumberInfo = _v2.a;
	var cssClass = _v2.b;
	return A2(
		$author$project$Print$SizedHtml$listWithSize,
		2,
		function (_v7) {
			var headers = _v7.a;
			var fields = _v7.b;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(cssClass)
						]),
					_List_fromArray(
						[
							A2($elm$html$Html$tr, _List_Nil, headers),
							A2($elm$html$Html$tr, _List_Nil, fields)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('separator')
						]),
					_List_Nil)
				]);
		}(
			A3(
				$elm$core$List$foldr,
				F2(
					function (_v5, _v6) {
						var h = _v5.a;
						var f = _v5.b;
						var headers = _v6.a;
						var fields = _v6.b;
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(h)
										])),
								headers),
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$td,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(f)
										])),
								fields));
					}),
				_Utils_Tuple2(_List_Nil, _List_Nil),
				_Utils_ap(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'Periode',
							$author$project$Compensation$WagePeriod$nameView(wagePeriod)),
							_Utils_Tuple2(
							'Relatienr',
							A2(
								$elm$core$Maybe$withDefault,
								'onbekend',
								$author$project$UI$Paradise$idView(
									$author$project$Payment$Payment$tagsOf(deliverer)))),
							_Utils_Tuple2('Periode vanaf', fromView),
							_Utils_Tuple2('Periode t/m', toView)
						]),
					vatNumberInfo))));
};
var $author$project$Print$SizedHtml$reverseAppend = F2(
	function (_v0, _v1) {
		var secondHtml = _v0.a;
		var secondSize = _v0.b;
		var firstHtml = _v1.a;
		var firstSize = _v1.b;
		return _Utils_Tuple2(
			_Utils_ap(firstHtml, secondHtml),
			firstSize + secondSize);
	});
var $author$project$Payment$Detail$defaultPageHeader = F2(
	function (payment, page) {
		var deliverer = payment.bl;
		var wagePeriod = payment.dK;
		return A2(
			$author$project$Print$SizedHtml$reverseAppend,
			$author$project$Payment$Detail$paymentInfo(payment),
			A2(
				$author$project$Print$SizedHtml$add,
				A2(
					$author$project$Print$SizedHtml$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('header')
						]),
					_List_fromArray(
						[
							$author$project$Payment$Detail$entityView(deliverer)
						])),
				A2(
					$author$project$Print$SizedHtml$add,
					$author$project$Payment$Detail$pageNumber(page),
					$author$project$Print$SizedHtml$empty)));
	});
var $author$project$Print$Document$pageNumberSpecificHeader = F2(
	function (_v0, defaultHeader) {
		var pageNumber = _v0.a;
		var header = _v0.b;
		return function (page) {
			var current = page.h9;
			var total = page.dH;
			return _Utils_eq(current, pageNumber) ? header(page) : defaultHeader(page);
		};
	});
var $author$project$Payment$Detail$header = F2(
	function (firstPageHeader, payment) {
		return A2(
			$author$project$Print$Document$pageNumberSpecificHeader,
			_Utils_Tuple2(
				1,
				firstPageHeader(payment)),
			$author$project$Payment$Detail$defaultPageHeader(payment));
	});
var $author$project$Payment$Detail$companyView = function (company) {
	return A2(
		$author$project$Print$SizedHtml$withSize,
		3,
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('company')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[$author$project$Print$Logo$logo])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('address')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Retouradres: '),
							$elm$html$Html$text(
							$author$project$Address$Address$oneLineView(company.f1))
						]))
				])));
};
var $author$project$Payment$Detail$letterhead = F2(
	function (company, deliverer) {
		return A2(
			$author$project$Print$SizedHtml$rowDiv,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('letterhead')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Print$SizedHtml$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('letterhead-left')
						]),
					_List_fromArray(
						[
							$author$project$Payment$Detail$companyView(company),
							$author$project$Payment$Detail$entityView(deliverer)
						])),
					A2(
					$author$project$Print$SizedHtml$withSize,
					7,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('letterhead-right')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('title')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Vergoedingsspecificatie')
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(company.ft)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('company-bank')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(company.hY.ft),
												$elm$html$Html$text(': '),
												$elm$html$Html$text(company.hY.hX)
											])),
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('KvK '),
												$elm$html$Html$text(company.i_.bU),
												$elm$html$Html$text(' nr. '),
												$elm$html$Html$text(company.i_.bX)
											])),
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('BTW nr. '),
												$elm$html$Html$text(company.kv)
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Telefoon: '),
										$elm$html$Html$text(company.eq)
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Email: '),
										$elm$html$Html$text(company.d5)
									]))
							])))
				]));
	});
var $author$project$Payment$Detail$letterheadHeaderv2021 = F2(
	function (payment, pages) {
		var deliverer = payment.bl;
		return A2(
			$author$project$Print$SizedHtml$reverseAppend,
			$author$project$Payment$Detail$paymentInfo(payment),
			A2(
				$author$project$Print$SizedHtml$add,
				A2($author$project$Payment$Detail$letterhead, $author$project$Payment$Company$dpgMedia, deliverer),
				A2(
					$author$project$Print$SizedHtml$add,
					$author$project$Payment$Detail$pageNumber(pages),
					$author$project$Print$SizedHtml$empty)));
	});
var $author$project$Payment$Detail$letterheadHeaderv2023 = F2(
	function (_v0, pages) {
		var deliverer = _v0.bl;
		return A2(
			$author$project$Print$SizedHtml$add,
			A2($author$project$Payment$Detail$letterhead, $author$project$Payment$Company$dpgMedia, deliverer),
			A2(
				$author$project$Print$SizedHtml$add,
				$author$project$Payment$Detail$pageNumber(pages),
				$author$project$Print$SizedHtml$empty));
	});
var $author$project$Compensation$Money$ShowTenThousandths = 2;
var $author$project$Payment$Detail$unitPriceView = $author$project$Compensation$Money$view(2);
var $author$project$Payment$Detail$compensationView = function (_v0) {
	var code = _v0.ge;
	var description = _v0.ig;
	var quantity = _v0.nm;
	var unitPrice = _v0.oo;
	var amount = _v0.aa;
	return A2(
		$elm$html$Html$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(code)
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(description)
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('number')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(quantity))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('number')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Payment$Detail$unitPriceView(unitPrice))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('number')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Payment$Detail$moneyView(amount))
					]))
			]));
};
var $author$project$Payment$Detail$wordsAsTexts = F2(
	function (separator, words) {
		return $elm$html$Html$text(
			A2($elm$core$String$join, separator, words));
	});
var $author$project$Payment$Detail$segmentTitleView = F3(
	function (from, to, element) {
		var segment = A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					element.iu,
					$elm$core$String$fromInt(element.bX),
					element.ft
				]));
		var _v0 = $author$project$Date$DeliveryDate$inclusiveRangeView(
			{l2: from, oj: to});
		var fromView = _v0.a;
		var toView = _v0.b;
		var wagePeriod = A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				['van', fromView, 'tm', toView]));
		var _v1 = element.nq;
		if (!_v1.$) {
			var r = _v1.a;
			return A2(
				$author$project$Payment$Detail$wordsAsTexts,
				', ',
				_List_fromArray(
					[
						segment,
						wagePeriod,
						'regio ' + $elm$core$String$fromInt(r.bX)
					]));
		} else {
			return A2(
				$author$project$Payment$Detail$wordsAsTexts,
				', ',
				_List_fromArray(
					[segment, wagePeriod]));
		}
	});
var $author$project$Payment$Detail$segmentView = function (_v0) {
	var from = _v0.l2;
	var to = _v0.oj;
	var element = _v0.as;
	var total = _v0.dH;
	var compensations = _v0.aD;
	return A2(
		$author$project$Print$SizedHtml$listWithSize,
		4 + $elm$core$List$length(compensations),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('payment-title')
					]),
				_List_fromArray(
					[
						A3($author$project$Payment$Detail$segmentTitleView, from, to, element)
					])),
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('payment-table')
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$tr,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Code')
									])),
								A2(
								$elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Omschrijving')
									])),
								A2(
								$elm$html$Html$th,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('number')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Aantal')
									])),
								A2(
								$elm$html$Html$th,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('number')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Tarief')
									])),
								A2(
								$elm$html$Html$th,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('number')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Bedrag')
									]))
							])),
					_Utils_ap(
						A2($elm$core$List$map, $author$project$Payment$Detail$compensationView, compensations),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$colspan(4)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Payment$Detail$wordsAsTexts,
												' ',
												_List_fromArray(
													[
														'Totaal',
														element.iu,
														$elm$core$String$fromInt(element.bX),
														element.ft
													]))
											])),
										A2(
										$elm$html$Html$td,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('number')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Payment$Detail$moneyView(total))
											]))
									]))
							]))))
			]));
};
var $author$project$Payment$Detail$paymentSlipView = function (paymentSlip) {
	return $mdgriffith$elm_ui$Element$html(
		A3(
			$author$project$Print$Document$toHtml,
			0,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('payment')
				]),
			function () {
				if (!paymentSlip.$) {
					var payment = paymentSlip.a;
					return A2(
						$author$project$Print$Document$addSizedHtml,
						$author$project$Payment$Detail$footer(payment),
						function (d) {
							return A3(
								$elm$core$List$foldl,
								function (_v1) {
									var html = _v1.a;
									var size = _v1.b;
									return A2($author$project$Print$Document$addContent, size, html);
								},
								d,
								A2($elm$core$List$map, $author$project$Payment$Detail$segmentView, payment.lE));
						}(
							A2(
								$author$project$Print$Document$init,
								$author$project$Print$Document$defaultPageSize,
								A2($author$project$Payment$Detail$header, $author$project$Payment$Detail$letterheadHeaderv2021, payment))));
				} else {
					var payment = paymentSlip.a;
					var overview = paymentSlip.b;
					return A2(
						$author$project$Print$Document$addSizedHtml,
						$author$project$Payment$Detail$footer(payment),
						function (d) {
							return A3(
								$elm$core$List$foldl,
								function (_v2) {
									var html = _v2.a;
									var size = _v2.b;
									return A2($author$project$Print$Document$addContent, size, html);
								},
								d,
								A2($elm$core$List$map, $author$project$Payment$Detail$segmentView, payment.lE));
						}(
							A3(
								$author$project$Payment$Detail$frontPage,
								payment,
								overview,
								A2(
									$author$project$Print$Document$init,
									$author$project$Print$Document$defaultPageSize,
									A2($author$project$Payment$Detail$header, $author$project$Payment$Detail$letterheadHeaderv2023, payment)))));
				}
			}()));
};
var $author$project$Payment$Archive$UserChangedSearchValue = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Payment$Archive$UserPressedEnterInSearchForm = {$: 5};
var $author$project$Payment$Archive$searchFormErrorView = function (error) {
	return 'Gelieve ten minste drie karakters in te voeren.';
};
var $author$project$UI$Search$InvisibleForPrint = 1;
var $author$project$UI$Search$withPrintInvisibility = function (_v0) {
	var input = _v0;
	return _Utils_update(
		input,
		{hc: 1});
};
var $author$project$Payment$Archive$searchFormView = function (searchForm) {
	return $author$project$UI$Search$elementFor(
		$author$project$UI$Search$withPrintInvisibility(
			A2(
				$author$project$UI$Search$withErrors,
				A2($elm$core$List$map, $author$project$Payment$Archive$searchFormErrorView, searchForm.f_),
				A2(
					$author$project$UI$Search$withPlaceholder,
					A2(
						$mdgriffith$elm_ui$Element$Input$placeholder,
						_List_Nil,
						$mdgriffith$elm_ui$Element$text('Achternaam of Relatienummer')),
					A2(
						$author$project$UI$Search$withOnPressedEnter,
						$author$project$Payment$Archive$UserPressedEnterInSearchForm,
						A3(
							$author$project$UI$Search$text,
							searchForm.n3,
							$author$project$Payment$Archive$UserChangedSearchValue(searchForm),
							$mdgriffith$elm_ui$Element$Input$labelHidden('Zoek op naam of relatienummer van een gebruiker')))))));
};
var $author$project$Payment$Archive$view = F2(
	function (share, model) {
		var withSummariesColumn = F2(
			function (paymentSelection, payments) {
				return $author$project$UI$Columns$withColumn(
					A2($author$project$Payment$Archive$loadedSummariesView, paymentSelection, payments));
			});
		var withStatementColumn = function (content) {
			return $author$project$UI$Columns$withColumn(
				$elm$core$Basics$always(
					A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$paddingEach(
								{k5: 0, mE: $author$project$UI$Spacing$defaultSize, nx: 0, ol: 0}),
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$author$project$UI$Element$avoidPrintInterference
							]),
						content)));
		};
		var withDeliverersColumn = function (deliverers) {
			return $author$project$UI$Columns$withColumn(
				A2(
					$author$project$Payment$Archive$deliverersView,
					deliverers,
					$author$project$Payment$Archive$deliverersOf(model.nS).b));
		};
		return $author$project$UI$Columns$elementFor(
			function () {
				var _v0 = model.nS;
				switch (_v0.$) {
					case 0:
						return $elm$core$Basics$identity;
					case 1:
						return $elm$core$Basics$identity;
					case 2:
						if (!_v0.a.b) {
							return $author$project$UI$Columns$withColumn(
								$elm$core$Basics$always($author$project$Payment$Archive$noDeliverersFoundView));
						} else {
							var deliverers = _v0.a;
							return withDeliverersColumn(deliverers);
						}
					case 3:
						var deliverers = _v0.a.e4;
						return withDeliverersColumn(deliverers);
					case 4:
						var deliverers = _v0.a.e4;
						var payments = _v0.a.ep;
						return A2(
							$elm$core$Basics$composeR,
							withDeliverersColumn(deliverers),
							A2(withSummariesColumn, $author$project$Payment$Archive$NoPaymentSelection, payments));
					case 5:
						var deliverers = _v0.a.e4;
						var payments = _v0.a.ep;
						var selectedPayment = _v0.b.cG;
						return A2(
							$elm$core$Basics$composeR,
							withDeliverersColumn(deliverers),
							A2(
								$elm$core$Basics$composeR,
								A2(
									withSummariesColumn,
									$author$project$Payment$Archive$AnnualSelection(selectedPayment),
									payments),
								withStatementColumn(
									$author$project$Payment$AnnualDetail$annualStatementView(selectedPayment))));
					case 6:
						var deliverers = _v0.a.e4;
						var payments = _v0.a.ep;
						var selectedPayment = _v0.b.cG;
						return A2(
							$elm$core$Basics$composeR,
							withDeliverersColumn(deliverers),
							A2(
								withSummariesColumn,
								$author$project$Payment$Archive$MonthlySelection(selectedPayment),
								payments));
					case 7:
						var deliverers = _v0.a.e4;
						var payments = _v0.a.ep;
						var selectedPayment = _v0.b.cG;
						var selectedSummary = _v0.b.j_;
						return A2(
							$elm$core$Basics$composeR,
							withDeliverersColumn(deliverers),
							A2(
								$elm$core$Basics$composeR,
								A2(
									withSummariesColumn,
									$author$project$Payment$Archive$MonthlySelection(selectedSummary),
									payments),
								withStatementColumn(
									$author$project$Payment$Detail$paymentSlipView(selectedPayment))));
					default:
						return $elm$core$Basics$identity;
				}
			}()(
				A3(
					$author$project$UI$Columns$withHeader,
					$author$project$UI$Search$height,
					$author$project$Payment$Archive$searchFormView(model.cC),
					A2(
						$author$project$UI$Columns$withSpacing,
						$author$project$UI$Spacing$defaultSize,
						$author$project$UI$Columns$columns(
							$author$project$Portal$Page$contentWindow(share))))));
	});
var $author$project$Payment$DelivererOverview$Hidden = 1;
var $author$project$Payment$DelivererOverview$Shown = 0;
var $author$project$Payment$DelivererOverview$UserPressedOpenAnnual = function (a) {
	return {$: 3, a: a};
};
var $author$project$Payment$DelivererOverview$UserPressedHideAnnualAmount = function (a) {
	return {$: 7, a: a};
};
var $author$project$Payment$DelivererOverview$UserPressedShowAnnualAmount = function (a) {
	return {$: 5, a: a};
};
var $author$project$Compensation$Money$hiddenView = function (options) {
	switch (options) {
		case 0:
			return '€****';
		case 1:
			return '€****,**';
		default:
			return '€****,****';
	}
};
var $icidasset$elm_material_icons$Material$Icons$visibility = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z')
				]),
			_List_Nil)
		]));
var $icidasset$elm_material_icons$Material$Icons$visibility_off = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z')
				]),
			_List_Nil)
		]));
var $author$project$Payment$DelivererOverview$annualAmountView = F2(
	function (amountVisibility, annualSummary) {
		var _v0 = function () {
			if (!amountVisibility) {
				return _Utils_Tuple3(
					$author$project$Payment$DelivererOverview$UserPressedHideAnnualAmount(annualSummary),
					$icidasset$elm_material_icons$Material$Icons$visibility_off,
					A2($author$project$Compensation$Money$view, 0, annualSummary.aa));
			} else {
				return _Utils_Tuple3(
					$author$project$Payment$DelivererOverview$UserPressedShowAnnualAmount(annualSummary),
					$icidasset$elm_material_icons$Material$Icons$visibility,
					$author$project$Compensation$Money$hiddenView(0));
			}
		}();
		var msg = _v0.a;
		var icon = _v0.b;
		var totalView = _v0.c;
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(5)
				]),
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$text('Bedrag:'),
					A2(
					$mdgriffith$elm_ui$Element$Input$button,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$alignRight]),
					{
						mD: A2(
							$author$project$UI$Element$coloredIconFor,
							icon(16),
							$author$project$UI$Palette$base0),
						jp: $elm$core$Maybe$Just(msg)
					}),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$Font$bold, $mdgriffith$elm_ui$Element$alignRight]),
					$mdgriffith$elm_ui$Element$text(totalView))
				]));
	});
var $author$project$Payment$DelivererOverview$openButton = function (msg) {
	return $author$project$UI$Button$elementFor(
		A2(
			$author$project$UI$Button$withRole,
			0,
			A2($author$project$UI$Button$button, msg, 'Open')));
};
var $author$project$Payment$DelivererOverview$annualCardView = F3(
	function (width, visibleAnnualSummaries, annualSummary) {
		var visibility = function () {
			var _v0 = A2($Gizra$elm_all_set$EverySet$member, annualSummary, visibleAnnualSummaries);
			if (_v0) {
				return 0;
			} else {
				return 1;
			}
		}();
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withWidth,
				width,
				A2(
					$author$project$UI$Container$withSpacing,
					10,
					A2(
						$author$project$UI$Container$withContent,
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$row,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$spacing(10)
									]),
								_List_fromArray(
									[
										A2(
										$mdgriffith$elm_ui$Element$el,
										$author$project$UI$Font$heading2,
										$mdgriffith$elm_ui$Element$text(
											'Jaaropgaaf ' + $elm$core$String$fromInt(annualSummary.kC)))
									])),
								A2($author$project$Payment$DelivererOverview$annualAmountView, visibility, annualSummary),
								A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[$mdgriffith$elm_ui$Element$alignRight]),
								$author$project$Payment$DelivererOverview$openButton(
									$author$project$Payment$DelivererOverview$UserPressedOpenAnnual(annualSummary)))
							]),
						$author$project$UI$Container$container))));
	});
var $author$project$Payment$DelivererOverview$UserPressedOpen = function (a) {
	return {$: 2, a: a};
};
var $author$project$Payment$DelivererOverview$UserPressedHideAmount = function (a) {
	return {$: 6, a: a};
};
var $author$project$Payment$DelivererOverview$UserPressedShowAmount = function (a) {
	return {$: 4, a: a};
};
var $author$project$Payment$DelivererOverview$amountView = F2(
	function (amountVisibility, summary) {
		var _v0 = function () {
			if (!amountVisibility) {
				return _Utils_Tuple3(
					$author$project$Payment$DelivererOverview$UserPressedHideAmount(summary),
					$icidasset$elm_material_icons$Material$Icons$visibility_off,
					A2($author$project$Compensation$Money$view, 1, summary.dH));
			} else {
				return _Utils_Tuple3(
					$author$project$Payment$DelivererOverview$UserPressedShowAmount(summary),
					$icidasset$elm_material_icons$Material$Icons$visibility,
					$author$project$Compensation$Money$hiddenView(1));
			}
		}();
		var msg = _v0.a;
		var icon = _v0.b;
		var totalView = _v0.c;
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(5)
				]),
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$text('Bedrag:'),
					A2(
					$mdgriffith$elm_ui$Element$Input$button,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$alignRight]),
					{
						mD: A2(
							$author$project$UI$Element$coloredIconFor,
							icon(16),
							$author$project$UI$Palette$base0),
						jp: $elm$core$Maybe$Just(msg)
					}),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$Font$bold, $mdgriffith$elm_ui$Element$alignRight]),
					$mdgriffith$elm_ui$Element$text(totalView))
				]));
	});
var $author$project$Payment$DelivererOverview$cardView = F3(
	function (width, visibleSummaries, summary) {
		var visibility = function () {
			var _v0 = A2($Gizra$elm_all_set$EverySet$member, summary, visibleSummaries);
			if (_v0) {
				return 0;
			} else {
				return 1;
			}
		}();
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withWidth,
				width,
				A2(
					$author$project$UI$Container$withSpacing,
					10,
					A2(
						$author$project$UI$Container$withContent,
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$row,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$spacing(10)
									]),
								_List_fromArray(
									[
										A2(
										$mdgriffith$elm_ui$Element$el,
										$author$project$UI$Font$heading2,
										$mdgriffith$elm_ui$Element$text(
											$author$project$Compensation$WagePeriod$nameView(summary.dK))),
										$mdgriffith$elm_ui$Element$text(
										$author$project$Compensation$WagePeriod$dateView(summary.dK))
									])),
								A2($author$project$Payment$DelivererOverview$amountView, visibility, summary),
								A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[$mdgriffith$elm_ui$Element$alignRight]),
								$author$project$Payment$DelivererOverview$openButton(
									$author$project$Payment$DelivererOverview$UserPressedOpen(summary)))
							]),
						$author$project$UI$Container$container))));
	});
var $author$project$Payment$DelivererOverview$loadedView = F2(
	function (share, loaded) {
		var _v0 = loaded.cK;
		if (!_v0.b) {
			return A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$padding(11),
						$mdgriffith$elm_ui$Element$centerX
					]),
				$author$project$UI$Container$elementFor(
					A2(
						$author$project$UI$Container$withTitle,
						A2(
							$mdgriffith$elm_ui$Element$paragraph,
							_List_Nil,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text('Er zijn geen vergoedingsspecificaties beschikbaar.')
								])),
						$author$project$UI$Container$container)));
		} else {
			var padWith = 10;
			var cardWidth = function () {
				var _v1 = $author$project$Portal$Share$ui(share).lF.le;
				if (!_v1) {
					return $mdgriffith$elm_ui$Element$fill;
				} else {
					return $mdgriffith$elm_ui$Element$px(500);
				}
			}();
			return A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$padding(padWith),
						$mdgriffith$elm_ui$Element$spacing(padWith),
						$mdgriffith$elm_ui$Element$centerX
					]),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						A2($author$project$Payment$DelivererOverview$annualCardView, cardWidth, loaded.cQ),
						A2(
							$elm$core$List$sortBy,
							function (s) {
								return -s.kC;
							},
							loaded.cX)),
					A2(
						$elm$core$List$map,
						A2($author$project$Payment$DelivererOverview$cardView, cardWidth, loaded.cP),
						A2(
							$elm$core$List$sortBy,
							function (s) {
								return _Utils_Tuple2(-s.dK.kC, -s.dK.jv);
							},
							loaded.cK))));
		}
	});
var $author$project$Payment$DelivererOverview$view = F2(
	function (share, model) {
		switch (model.$) {
			case 0:
				return $mdgriffith$elm_ui$Element$none;
			case 1:
				var loaded = model.a;
				return A2($author$project$Payment$DelivererOverview$loadedView, share, loaded);
			default:
				return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$Payment$Detail$view = F2(
	function (_v0, model) {
		switch (model.$) {
			case 0:
				return $mdgriffith$elm_ui$Element$none;
			case 1:
				var paymentSlip = model.a;
				return $author$project$Payment$Detail$paymentSlipView(paymentSlip);
			default:
				return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$Payment$DistributionPointOverview$UserChangedSearch = function (a) {
	return {$: 3, a: a};
};
var $author$project$Payment$DistributionPointOverview$filterView = function (filterText) {
	return $author$project$UI$Search$elementFor(
		$author$project$UI$Search$withPrintInvisibility(
			A3(
				$author$project$UI$Search$text,
				filterText,
				$author$project$Payment$DistributionPointOverview$UserChangedSearch,
				$mdgriffith$elm_ui$Element$Input$labelHidden('Zoek naar vergoeding'))));
};
var $author$project$UI$Paradise$byParadiseId = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.kn;
	},
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Dict$get('ParadiseId'),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$andThen($elm$core$String$toInt),
			$elm$core$Maybe$withDefault(0))));
var $author$project$Payment$DistributionPointOverview$delivererNameAndIdView = function (_v0) {
	var salutation = _v0.hi;
	var firstName = _v0.fc;
	var lastName = _v0.fo;
	var tags = _v0.kn;
	return function (name) {
		return $author$project$UI$Paradise$nameAndIdView(
			{ft: name, kn: tags});
	}(
		A2(
			$elm$core$String$join,
			' ',
			$elm_community$maybe_extra$Maybe$Extra$values(
				_List_fromArray(
					[
						salutation,
						firstName,
						$elm$core$Maybe$Just(lastName)
					]))));
};
var $author$project$Payment$DistributionPointOverview$compensationView = F2(
	function (deliverer, _v0) {
		var description = _v0.ig;
		var quantity = _v0.nm;
		var unitPrice = _v0.oo;
		var amount = _v0.aa;
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('overview-compensation')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Payment$DistributionPointOverview$delivererNameAndIdView(deliverer))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(description)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(quantity))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Compensation$Money$view, 2, unitPrice))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Compensation$Money$view, 1, amount))
						]))
				]));
	});
var $author$project$Payment$DistributionPointOverview$delivererView = function (deliverer) {
	return A2(
		$elm$core$List$map,
		$author$project$Payment$DistributionPointOverview$compensationView(deliverer),
		deliverer.aD);
};
var $author$project$Compensation$Money$sum = function (list) {
	return $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			function (_v0) {
				var m = _v0;
				return m;
			},
			list));
};
var $author$project$Payment$DistributionPointOverview$total = function (_v0) {
	var deliverers = _v0.e4;
	return $author$project$Compensation$Money$sum(
		A2(
			$elm$core$List$map,
			function ($) {
				return $.aa;
			},
			A2(
				$elm$core$List$concatMap,
				function ($) {
					return $.aD;
				},
				deliverers)));
};
var $author$project$Payment$DistributionPointOverview$elementView = function (element) {
	return A2(
		$elm$html$Html$article,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('overview-element')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$UI$Paradise$nameAndIdView(element))
					])),
				A2(
				$elm$html$Html$table,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$tr,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Relatie')
									])),
								A2(
								$elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Omschrijving')
									])),
								A2(
								$elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Aantal')
									])),
								A2(
								$elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Tarief')
									])),
								A2(
								$elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Bedrag')
									]))
							])),
					A2($elm$core$List$concatMap, $author$project$Payment$DistributionPointOverview$delivererView, element.e4))),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('overview-total')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Totaal gebied: '),
						$elm$html$Html$text(
						A2(
							$author$project$Compensation$Money$view,
							1,
							$author$project$Payment$DistributionPointOverview$total(element)))
					]))
			]));
};
var $author$project$Payment$DistributionPointOverview$paymentsView = F2(
	function (selected, window) {
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$height(
					$mdgriffith$elm_ui$Element$px(window.iK)),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$scrollbarY,
					$author$project$UI$Padding$default,
					$mdgriffith$elm_ui$Element$alignTop,
					$author$project$UI$Element$avoidPrintInterference
				]),
			function () {
				if (selected.$ === 2) {
					var filtered = selected.a.eb;
					if (!filtered.b) {
						return $mdgriffith$elm_ui$Element$text('Geen relevante vergoedingen');
					} else {
						return $mdgriffith$elm_ui$Element$html(
							A2(
								$elm$html$Html$article,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('overview-payments')
									]),
								A2(
									$elm$core$List$map,
									$author$project$Payment$DistributionPointOverview$elementView,
									A2($elm$core$List$sortBy, $author$project$UI$Paradise$byParadiseId, filtered))));
					}
				} else {
					return $mdgriffith$elm_ui$Element$none;
				}
			}());
	});
var $author$project$Payment$DistributionPointOverview$UserPressedWagePeriodCard = function (a) {
	return {$: 1, a: a};
};
var $author$project$Payment$DistributionPointOverview$wagePeriodCard = F2(
	function (selected, wagePeriod) {
		return $author$project$UI$Card$elementFor(
			A2(
				$author$project$UI$Card$withContent,
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$el,
						$author$project$UI$Font$heading2,
						$mdgriffith$elm_ui$Element$text(
							$author$project$Compensation$WagePeriod$nameView(wagePeriod))),
						$mdgriffith$elm_ui$Element$text(
						$author$project$Compensation$WagePeriod$dateView(wagePeriod))
					]),
				A2(
					$author$project$UI$Card$selectedIf,
					_Utils_eq(
						selected,
						$elm$core$Maybe$Just(wagePeriod)),
					$author$project$UI$Card$card(
						$author$project$Payment$DistributionPointOverview$UserPressedWagePeriodCard(wagePeriod)))));
	});
var $author$project$Payment$DistributionPointOverview$wagePeriodsView = F3(
	function (wagePeriods, selected, window) {
		var selectedWagePeriod = function () {
			switch (selected.$) {
				case 0:
					return $elm$core$Maybe$Nothing;
				case 1:
					var wagePeriod = selected.a;
					return $elm$core$Maybe$Just(wagePeriod);
				default:
					var wagePeriod = selected.a.dK;
					return $elm$core$Maybe$Just(wagePeriod);
			}
		}();
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$height(
					$mdgriffith$elm_ui$Element$px(window.iK)),
					$mdgriffith$elm_ui$Element$width(
					$mdgriffith$elm_ui$Element$px(250)),
					$mdgriffith$elm_ui$Element$scrollbarY,
					$author$project$UI$Padding$default,
					$author$project$UI$Spacing$default,
					$mdgriffith$elm_ui$Element$alignTop,
					$author$project$UI$Element$invisibleForPrint
				]),
			A2(
				$elm$core$List$map,
				$author$project$Payment$DistributionPointOverview$wagePeriodCard(selectedWagePeriod),
				A2(
					$elm$core$List$sortBy,
					function (s) {
						return _Utils_Tuple2(-s.kC, -s.jv);
					},
					wagePeriods)));
	});
var $author$project$Payment$DistributionPointOverview$loadedView = F4(
	function (window, wagePeriods, selected, filterText) {
		return $author$project$UI$Columns$elementFor(
			A2(
				$author$project$UI$Columns$withColumn,
				$author$project$Payment$DistributionPointOverview$paymentsView(selected),
				A2(
					$author$project$UI$Columns$withColumn,
					A2($author$project$Payment$DistributionPointOverview$wagePeriodsView, wagePeriods, selected),
					A3(
						$author$project$UI$Columns$withHeader,
						$author$project$UI$Search$height,
						$author$project$Payment$DistributionPointOverview$filterView(filterText),
						$author$project$UI$Columns$columns(window)))));
	});
var $author$project$Payment$DistributionPointOverview$view = F2(
	function (share, model) {
		switch (model.$) {
			case 1:
				var wagePeriods = model.a.hG;
				var selected = model.a.nI;
				var filterText = model.a.fb;
				return A4(
					$author$project$Payment$DistributionPointOverview$loadedView,
					$author$project$Portal$Page$contentWindow(share),
					wagePeriods,
					selected,
					filterText);
			case 0:
				return $mdgriffith$elm_ui$Element$none;
			default:
				return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$Plan$CreatePlan$UserSelectedDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Plan$CreatePlan$UserClickedBasedOnPlan = {$: 5};
var $author$project$Plan$CreatePlan$basedOnPlanButtonView = function (model) {
	return $author$project$UI$Button$elementFor(
		function () {
			var _v0 = $author$project$Plan$CreatePlan$selectedDateHasPlan(model);
			if (_v0) {
				return $elm$core$Basics$identity;
			} else {
				return $author$project$UI$Button$disabled('De gekozen datum heeft geen plan.');
			}
		}()(
			A2(
				$author$project$UI$Button$withRole,
				0,
				A2($author$project$UI$Button$button, $author$project$Plan$CreatePlan$UserClickedBasedOnPlan, 'Maak plan aan'))));
};
var $author$project$Plan$CreatePlan$toDates = F2(
	function (today, _v0) {
		var selectedDate = _v0.dx;
		var existingPlanStatuses = _v0.ck;
		return function () {
			if (existingPlanStatuses.$ === 1) {
				var statuses = existingPlanStatuses.a;
				return $author$project$Date$Selector$withStatesByDate(statuses);
			} else {
				return $elm$core$Basics$identity;
			}
		}()(
			A3(
				$author$project$Date$Selector$create,
				selectedDate,
				$author$project$Plan$Plan$visibleRange(today),
				false));
	});
var $author$project$Plan$CreatePlan$basedOnPlanView = F2(
	function (today, model) {
		var dates = A2($author$project$Plan$CreatePlan$toDates, today, model);
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$spacing(10),
					$mdgriffith$elm_ui$Element$alignRight
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Border$width(1),
							$mdgriffith$elm_ui$Element$Border$color(
							$author$project$UI$Element$colorFor($author$project$UI$Palette$base1))
						]),
					A2(
						$mdgriffith$elm_ui$Element$map,
						$author$project$Plan$CreatePlan$UserSelectedDate,
						$author$project$Date$Selector$view(dates))),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$centerX]),
					$author$project$Plan$CreatePlan$basedOnPlanButtonView(model))
				]));
	});
var $author$project$Plan$CreatePlan$view = F2(
	function (share, model) {
		var _v0 = _Utils_Tuple2(model.bn, model.ck);
		_v0$2:
		while (true) {
			switch (_v0.a.$) {
				case 1:
					if (_v0.b.$ === 1) {
						return A2(
							$mdgriffith$elm_ui$Element$column,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$centerX,
									$mdgriffith$elm_ui$Element$spacing(20),
									$mdgriffith$elm_ui$Element$padding(20),
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
								]),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$el,
									_Utils_ap(
										_List_fromArray(
											[$mdgriffith$elm_ui$Element$centerX]),
										$author$project$UI$Font$heading1),
									$mdgriffith$elm_ui$Element$text('Maak een nieuw plan aan')),
									A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[$mdgriffith$elm_ui$Element$centerX]),
									$mdgriffith$elm_ui$Element$text('Selecteer een datum waarvan je het plan wilt kopiëren.')),
									A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[$mdgriffith$elm_ui$Element$centerX]),
									A2(
										$author$project$Plan$CreatePlan$basedOnPlanView,
										$author$project$Portal$Share$today(share),
										model)),
									A2(
									$mdgriffith$elm_ui$Element$el,
									_Utils_ap(
										_List_fromArray(
											[$mdgriffith$elm_ui$Element$centerX]),
										$author$project$UI$Font$heading1),
									$mdgriffith$elm_ui$Element$text('Of open een bestaand plan')),
									A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[$mdgriffith$elm_ui$Element$centerX]),
									$mdgriffith$elm_ui$Element$text('Klik op de datum bovenin de balk om een dag te kiezen en het plan te openen.'))
								]));
					} else {
						break _v0$2;
					}
				case 2:
					return A2(
						$mdgriffith$elm_ui$Element$column,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$centerX,
								$mdgriffith$elm_ui$Element$spacing(20),
								$mdgriffith$elm_ui$Element$padding(20)
							]),
						_List_fromArray(
							[
								$author$project$UI$Container$elementFor(
								A2(
									$author$project$UI$Container$withVariant,
									1,
									A2(
										$author$project$UI$Container$withContent,
										_List_fromArray(
											[
												A2(
												$mdgriffith$elm_ui$Element$column,
												_List_fromArray(
													[
														$mdgriffith$elm_ui$Element$spacing(15),
														$mdgriffith$elm_ui$Element$width(
														A2($mdgriffith$elm_ui$Element$maximum, 800, $mdgriffith$elm_ui$Element$fill))
													]),
												_List_fromArray(
													[
														A2(
														$mdgriffith$elm_ui$Element$paragraph,
														_List_Nil,
														_List_fromArray(
															[
																$mdgriffith$elm_ui$Element$text('Controleer de datum waarvoor het plan aangemaakt wordt, indien het een correcte datum betreft probeer het dan graag nogmaals. Als de fout aanhoudt neem dan contact op met je regiomanager.')
															]))
													]))
											]),
										A2(
											$author$project$UI$Container$withTitle,
											$mdgriffith$elm_ui$Element$text(
												'Probleem met het inladen van het distributiepunt voor ' + $author$project$Date$DeliveryDate$view(model.aE)),
											$author$project$UI$Container$container))))
							]));
				default:
					break _v0$2;
			}
		}
		return $mdgriffith$elm_ui$Element$none;
	});
var $author$project$UI$LeafletMap$All = {$: 0};
var $author$project$Plan$DayPlanning$GotDemandMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Plan$DayPlanning$contentPadding = 2;
var $author$project$Plan$DayPlanning$toOrders = function (orders) {
	if (orders.$ === 1) {
		var o = orders.a;
		return $elm$core$Maybe$Just(o);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Plan$DayPlanning$Demand$UserSelectedSegment = $elm$core$Basics$identity;
var $author$project$Plan$DayPlanning$Demand$findSegmentIdsToHighlight = F2(
	function (items, highlighted) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			$author$project$Plan$Supply$findItemById(items),
			highlighted);
		if (!_v0.$) {
			var item = _v0.a;
			return $author$project$Plan$Supply$ownSegmentsOf(item);
		} else {
			return _List_Nil;
		}
	});
var $author$project$UI$LeafletMap$focusedSegment = function (maybeSegmentId) {
	return A2(
		$elm$html$Html$Attributes$property,
		'focusedSegment',
		function () {
			if (!maybeSegmentId.$) {
				var segmentId = maybeSegmentId.a;
				return $author$project$DistributionPoint$DistributionPoint$encodeSegmentId(segmentId);
			} else {
				return $elm$json$Json$Encode$null;
			}
		}());
};
var $author$project$UI$LeafletMap$highlightedSegments = function (segmentIdsToHighlight) {
	return A2(
		$elm$html$Html$Attributes$property,
		'highlightedSegments',
		A2($elm$json$Json$Encode$list, $author$project$DistributionPoint$DistributionPoint$encodeSegmentId, segmentIdsToHighlight));
};
var $author$project$UI$LeafletMap$onSegmentSelected = function (toMsg) {
	return A2(
		$elm$html$Html$Events$on,
		'segmentselected',
		A2(
			$elm$json$Json$Decode$map,
			toMsg,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['detail']),
				$author$project$DistributionPoint$DistributionPoint$segmentIdDecoder)));
};
var $author$project$Plan$DayPlanning$Demand$view = F8(
	function (window, _v0, maybeItems, maybeSegmentOrders, highlighted, focusedSegment, zoomTo, shouldSelectSegment) {
		var distributionPoint = _v0;
		var maybeAddOnClick = function (attrs) {
			if (shouldSelectSegment) {
				return A2(
					$elm$core$List$cons,
					$author$project$UI$LeafletMap$onSegmentSelected($elm$core$Basics$identity),
					attrs);
			} else {
				return attrs;
			}
		};
		var height = $elm$core$String$fromInt(window.iK) + 'px';
		if (maybeItems.$ === 1) {
			return $mdgriffith$elm_ui$Element$html(
				$author$project$UI$LeafletMap$leafletMap(
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'height', height),
							$author$project$UI$LeafletMap$segments(distributionPoint.bb),
							$author$project$UI$LeafletMap$zoom($author$project$UI$LeafletMap$All)
						])));
		} else {
			var items = maybeItems.a;
			return $mdgriffith$elm_ui$Element$html(
				$author$project$UI$LeafletMap$leafletMap(
					maybeAddOnClick(
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'height', height),
								$author$project$UI$LeafletMap$segments(distributionPoint.bb),
								A3(
								$author$project$UI$LeafletMap$segmentState,
								distributionPoint,
								$author$project$Plan$Supply$flatten(items),
								maybeSegmentOrders),
								$author$project$UI$LeafletMap$highlightedSegments(
								A2($author$project$Plan$DayPlanning$Demand$findSegmentIdsToHighlight, items, highlighted)),
								$author$project$UI$LeafletMap$focusedSegment(focusedSegment),
								$author$project$UI$LeafletMap$zoom(zoomTo)
							]))));
		}
	});
var $author$project$Duration$Duration$availableTime = 120;
var $author$project$Duration$Duration$default = 20;
var $author$project$Duration$Duration$ensureDefault = function (length) {
	if (!length) {
		return $author$project$Duration$Duration$default;
	} else {
		return length;
	}
};
var $author$project$Duration$Duration$ofSegment = A2($elm$core$Basics$composeR, $author$project$DistributionPoint$DistributionPoint$durationFor, $author$project$Duration$Duration$ensureDefault);
var $author$project$Duration$Duration$ofClusterWith = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map($author$project$Duration$Duration$ofSegment),
	A2($elm$core$Basics$composeR, $elm$core$List$sum, $author$project$Duration$Duration$ensureDefault));
var $author$project$Duration$Duration$durationOfSupplyCluster = F2(
	function (distributionPoint, _v0) {
		var segments = _v0.bb;
		return $author$project$Duration$Duration$ofClusterWith(
			A2($author$project$DistributionPoint$DistributionPoint$findSegmentsOnId, distributionPoint, segments));
	});
var $author$project$Duration$Duration$durationOfSupplyItem = F2(
	function (distributionPoint, item) {
		switch (item.$) {
			case 0:
				var cluster = item.a.H;
				var supplies = item.a.n0;
				return A2(
					$elm$core$Basics$max,
					A2($author$project$Duration$Duration$durationOfSupplyCluster, distributionPoint, cluster),
					A2(
						$elm$core$Maybe$withDefault,
						0,
						$elm$core$List$maximum(
							A2(
								$elm$core$List$map,
								$author$project$Duration$Duration$durationOfSupplyItem(distributionPoint),
								supplies))));
			case 1:
				var clusters = item.a.k;
				return $elm$core$List$sum(
					A2(
						$elm$core$List$map,
						$author$project$Duration$Duration$durationOfSupplyCluster(distributionPoint),
						clusters));
			default:
				return 30;
		}
	});
var $author$project$Duration$Duration$calcMaxDuration = F2(
	function (distributionPoint, supplyItems) {
		return A2(
			$elm$core$Basics$max,
			$author$project$Duration$Duration$availableTime,
			A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$List$maximum(
					A2(
						$elm$core$List$map,
						$author$project$Duration$Duration$durationOfSupplyItem(distributionPoint),
						supplyItems))));
	});
var $author$project$Plan$DayPlanning$Supply$UserClickedCancel = {$: 39};
var $author$project$Plan$DayPlanning$Supply$UserConfirmedDeleteUnregistered = function (a) {
	return {$: 40, a: a};
};
var $author$project$Plan$DayPlanning$Supply$deleteDialogView = F2(
	function (id, message) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			$author$project$Style$Style$confirmationDialog,
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$paragraph,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$padding(2)
						]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text(message)
						])),
					A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					_List_fromArray(
						[
							$author$project$UI$Button$elementFor(
							A2(
								$author$project$UI$Button$withRole,
								1,
								A2(
									$author$project$UI$Button$button,
									$author$project$Plan$DayPlanning$Supply$UserConfirmedDeleteUnregistered(id),
									'Verwijderen'))),
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[$mdgriffith$elm_ui$Element$alignRight]),
							$author$project$UI$Button$elementFor(
								A2($author$project$UI$Button$button, $author$project$Plan$DayPlanning$Supply$UserClickedCancel, 'Annuleren')))
						]))
				]));
	});
var $author$project$Plan$DayPlanning$Supply$UserChangedDetailFolding = {$: 7};
var $author$project$Plan$DayPlanning$Supply$UserClickedAssistantPosition = function (a) {
	return {$: 15, a: a};
};
var $author$project$Plan$DayPlanning$Supply$UserSelectedDelivererToMoveAssistantPositionTo = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Plan$DayPlanning$Supply$UserToggledMovingDetailItemFolding = {$: 13};
var $icidasset$elm_material_icons$Material$Icons$unfold_less = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z')
				]),
			_List_Nil)
		]));
var $icidasset$elm_material_icons$Material$Icons$unfold_more = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z')
				]),
			_List_Nil)
		]));
var $author$project$Plan$DayPlanning$Supply$moveDetailItemView = F4(
	function (moveMsg, moveText, folding, allDeliverers) {
		var title = function (icon) {
			return A2(
				$mdgriffith$elm_ui$Element$Input$button,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				{
					mD: A2(
						$mdgriffith$elm_ui$Element$row,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
							]),
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text(moveText),
								A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[$mdgriffith$elm_ui$Element$alignRight]),
								$author$project$UI$Element$iconFor(
									$author$project$UI$Font$heading3Sized(icon)))
							])),
					jp: $elm$core$Maybe$Just($author$project$Plan$DayPlanning$Supply$UserToggledMovingDetailItemFolding)
				});
		};
		var mouseOverColors = {kV: $author$project$UI$Palette$base02, k0: $author$project$UI$Palette$base02, lZ: $author$project$UI$Palette$base2};
		var item = function (deliverer) {
			return A2(
				$mdgriffith$elm_ui$Element$Input$button,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$pointer,
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$padding(1),
						$mdgriffith$elm_ui$Element$mouseOver(
						$author$project$UI$Element$colors(mouseOverColors))
					]),
				{
					mD: $mdgriffith$elm_ui$Element$text(
						$author$project$Deliverer$Deliverer$nameView(
							$author$project$Deliverer$Deliverer$fromTyped(deliverer))),
					jp: $elm$core$Maybe$Just(
						moveMsg(deliverer))
				});
		};
		if (folding === 1) {
			return $author$project$UI$Container$elementFor(
				A2(
					$author$project$UI$Container$withContent,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$column,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									$mdgriffith$elm_ui$Element$height(
									$mdgriffith$elm_ui$Element$px(200)),
									$mdgriffith$elm_ui$Element$scrollbarY
								]),
							A2(
								$elm$core$List$map,
								item,
								A2(
									$elm$core$List$sortBy,
									A2($elm$core$Basics$composeR, $author$project$Deliverer$Deliverer$fromTyped, $author$project$Sorting$Deliverers$byName),
									$Gizra$elm_all_set$EverySet$toList(allDeliverers))))
						]),
					A2(
						$author$project$UI$Container$withTitle,
						title($icidasset$elm_material_icons$Material$Icons$unfold_less),
						A2($author$project$UI$Container$withWidth, $mdgriffith$elm_ui$Element$fill, $author$project$UI$Container$container))));
		} else {
			return $author$project$UI$Container$elementFor(
				A2(
					$author$project$UI$Container$withTitle,
					title($icidasset$elm_material_icons$Material$Icons$unfold_more),
					A2($author$project$UI$Container$withWidth, $mdgriffith$elm_ui$Element$fill, $author$project$UI$Container$container)));
		}
	});
var $author$project$Plan$DayPlanning$Supply$detailItemCardView = F4(
	function (moveMsg, moveText, folding, allDeliverers) {
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				_List_fromArray(
					[
						A4($author$project$Plan$DayPlanning$Supply$moveDetailItemView, moveMsg, moveText, folding, allDeliverers)
					]),
				A2($author$project$UI$Container$withWidth, $mdgriffith$elm_ui$Element$fill, $author$project$UI$Container$container)));
	});
var $author$project$Plan$DayPlanning$Supply$detailItemOnlyView = F4(
	function (icon, toMsg, maybeTypedDeliverer, ref) {
		var id = ref.eg;
		var name = ref.ft;
		var tooltip = $elm$html$Html$Attributes$title(
			'Element Nr: ' + A2(
				$elm$core$Maybe$withDefault,
				'onbekend',
				$author$project$UI$Paradise$idView(ref)));
		var _v0 = function () {
			if (maybeTypedDeliverer.$ === 1) {
				return _Utils_Tuple2('', '');
			} else {
				switch (maybeTypedDeliverer.a.$) {
					case 0:
						var deliverer = maybeTypedDeliverer.a.a;
						return _Utils_Tuple2(
							$author$project$Deliverer$Deliverer$nameView(deliverer),
							A2(
								$elm$core$Maybe$withDefault,
								'onbekend',
								$author$project$UI$Paradise$idView(deliverer)));
					case 1:
						if (!maybeTypedDeliverer.a.b.$) {
							var _v2 = maybeTypedDeliverer.a;
							var deliverer = _v2.b.a;
							return _Utils_Tuple2(
								$author$project$Deliverer$Deliverer$nameAndIdView(deliverer),
								A2(
									$elm$core$Maybe$withDefault,
									'onbekend',
									$author$project$UI$Paradise$idView(deliverer)));
						} else {
							var _v3 = maybeTypedDeliverer.a;
							var _v4 = _v3.b;
							return _Utils_Tuple2('ontbrekende bezorger', 'onbekend');
						}
					default:
						var _v5 = maybeTypedDeliverer.a;
						var deliverer = _v5.a;
						return _Utils_Tuple2(
							$author$project$Deliverer$Deliverer$nameView(deliverer),
							'nog niet geregistreerd');
				}
			}
		}();
		var delivererName = _v0.a;
		var delivererParadiseId = _v0.b;
		return A2(
			$mdgriffith$elm_ui$Element$Input$button,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			{
				mD: A2(
					$mdgriffith$elm_ui$Element$row,
					_Utils_ap(
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$padding(2),
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$height(
								$mdgriffith$elm_ui$Element$px(35)),
								$mdgriffith$elm_ui$Element$spacing(5),
								$mdgriffith$elm_ui$Element$Border$widthEach(
								{k5: 0, mE: 4, nx: 0, ol: 0})
							]),
						$author$project$UI$Element$colors(
							{
								kV: $author$project$UI$Palette$base2,
								k0: $author$project$Deliverer$Deliverer$solidColorOfMaybe(maybeTypedDeliverer),
								lZ: $author$project$UI$Palette$base03
							})),
					_List_fromArray(
						[
							$author$project$UI$Element$iconFor(
							icon(16)),
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width(
									$mdgriffith$elm_ui$Element$fillPortion(4)),
									$mdgriffith$elm_ui$Element$htmlAttribute(
									$elm$html$Html$Attributes$title('Rel. Nr: ' + delivererParadiseId))
								]),
							$mdgriffith$elm_ui$Element$text(delivererName)),
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width(
									$mdgriffith$elm_ui$Element$fillPortion(6)),
									$mdgriffith$elm_ui$Element$htmlAttribute(tooltip)
								]),
							$mdgriffith$elm_ui$Element$text(name))
						])),
				jp: $elm$core$Maybe$Just(
					toMsg(id))
			});
	});
var $icidasset$elm_material_icons$Material$Icons$support = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$b('new 0 0 24 24'),
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$rect,
					_List_fromArray(
						[
							$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$icidasset$elm_material_icons$Material$Icons$Internal$p,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10s10-4.48,10-10C22,6.48,17.52,2,12,2z M19.46,9.12l-2.78,1.15 c-0.51-1.36-1.58-2.44-2.95-2.94l1.15-2.78C16.98,5.35,18.65,7.02,19.46,9.12z M12,15c-1.66,0-3-1.34-3-3s1.34-3,3-3s3,1.34,3,3 S13.66,15,12,15z M9.13,4.54l1.17,2.78c-1.38,0.5-2.47,1.59-2.98,2.97L4.54,9.13C5.35,7.02,7.02,5.35,9.13,4.54z M4.54,14.87 l2.78-1.15c0.51,1.38,1.59,2.46,2.97,2.96l-1.17,2.78C7.02,18.65,5.35,16.98,4.54,14.87z M14.88,19.46l-1.15-2.78 c1.37-0.51,2.45-1.59,2.95-2.97l2.78,1.17C18.65,16.98,16.98,18.65,14.88,19.46z')
						]),
					_List_Nil)
				]))
		]));
var $author$project$Plan$DayPlanning$Supply$assistantPositionView = F5(
	function (allDeliverers, readStatus, selected, deliverer, assistantPosition) {
		return function () {
			var _v0 = _Utils_Tuple2(readStatus, selected);
			if ((_v0.a === 1) && (!_v0.b.$)) {
				var _v1 = _v0.a;
				var id = _v0.b.a.eg;
				var moveFolding = _v0.b.a.n;
				return _Utils_eq(id, assistantPosition.eg) ? function (onlyView) {
					return A2(
						$mdgriffith$elm_ui$Element$column,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
							]),
						_List_fromArray(
							[
								onlyView,
								A4(
								$author$project$Plan$DayPlanning$Supply$detailItemCardView,
								$author$project$Plan$DayPlanning$Supply$UserSelectedDelivererToMoveAssistantPositionTo(assistantPosition.eg),
								'Koppel assistent positie aan',
								moveFolding,
								A4($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$core$Basics$identity, $Gizra$elm_all_set$EverySet$remove, deliverer, allDeliverers))
							]));
				} : $elm$core$Basics$identity;
			} else {
				return $elm$core$Basics$identity;
			}
		}()(
			A4($author$project$Plan$DayPlanning$Supply$detailItemOnlyView, $icidasset$elm_material_icons$Material$Icons$support, $author$project$Plan$DayPlanning$Supply$UserClickedAssistantPosition, deliverer, assistantPosition));
	});
var $author$project$Plan$DayPlanning$Supply$assistantPositionsView = F5(
	function (dp, allDeliverers, readStatus, assignments, assistingSelection) {
		var delivererOf = function (s) {
			return A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.bl;
				},
				A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.eg;
						},
						$elm$core$Basics$eq(s.eg)),
					assignments));
		};
		var _v0 = $author$project$DistributionPoint$DistributionPoint$assistantPositionsOf(dp);
		if (!_v0.b) {
			return $mdgriffith$elm_ui$Element$none;
		} else {
			var assistantPositions = _v0;
			return $author$project$UI$Container$elementFor(
				$author$project$UI$Container$withoutBorder(
					A2(
						$author$project$UI$Container$withWidth,
						$mdgriffith$elm_ui$Element$fill,
						A2(
							$author$project$UI$Container$withContent,
							A2(
								$elm$core$List$map,
								function (s) {
									return A5(
										$author$project$Plan$DayPlanning$Supply$assistantPositionView,
										allDeliverers,
										readStatus,
										assistingSelection,
										delivererOf(s),
										s);
								},
								assistantPositions),
							A2(
								$author$project$UI$Container$withTitle,
								$mdgriffith$elm_ui$Element$text('Assistenten'),
								$author$project$UI$Container$container)))));
		}
	});
var $author$project$Plan$DayPlanning$Supply$UserClickedInserterPosition = function (a) {
	return {$: 17, a: a};
};
var $author$project$Plan$DayPlanning$Supply$UserSelectedDelivererToMoveInserterPositionTo = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $icidasset$elm_material_icons$Material$Icons$attach_file = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z')
				]),
			_List_Nil)
		]));
var $author$project$Plan$DayPlanning$Supply$inserterPositionView = F5(
	function (allDeliverers, readStatus, selected, deliverer, assistantPosition) {
		return function () {
			var _v0 = _Utils_Tuple2(readStatus, selected);
			if ((_v0.a === 1) && (!_v0.b.$)) {
				var _v1 = _v0.a;
				var id = _v0.b.a.eg;
				var moveFolding = _v0.b.a.n;
				return _Utils_eq(id, assistantPosition.eg) ? function (onlyView) {
					return A2(
						$mdgriffith$elm_ui$Element$column,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
							]),
						_List_fromArray(
							[
								onlyView,
								A4(
								$author$project$Plan$DayPlanning$Supply$detailItemCardView,
								$author$project$Plan$DayPlanning$Supply$UserSelectedDelivererToMoveInserterPositionTo(assistantPosition.eg),
								'Koppel insteker positie aan',
								moveFolding,
								A4($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$core$Basics$identity, $Gizra$elm_all_set$EverySet$remove, deliverer, allDeliverers))
							]));
				} : $elm$core$Basics$identity;
			} else {
				return $elm$core$Basics$identity;
			}
		}()(
			A4($author$project$Plan$DayPlanning$Supply$detailItemOnlyView, $icidasset$elm_material_icons$Material$Icons$attach_file, $author$project$Plan$DayPlanning$Supply$UserClickedInserterPosition, deliverer, assistantPosition));
	});
var $author$project$Plan$DayPlanning$Supply$inserterPositionsView = F5(
	function (dp, allDeliverers, readStatus, assignments, inserterPositionSelection) {
		var delivererOf = function (s) {
			return A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.bl;
				},
				A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.eg;
						},
						$elm$core$Basics$eq(s.eg)),
					assignments));
		};
		var _v0 = $author$project$DistributionPoint$DistributionPoint$inserterPositionsOf(dp);
		if (!_v0.b) {
			return $mdgriffith$elm_ui$Element$none;
		} else {
			var inserterPositions = _v0;
			return $author$project$UI$Container$elementFor(
				$author$project$UI$Container$withoutBorder(
					A2(
						$author$project$UI$Container$withWidth,
						$mdgriffith$elm_ui$Element$fill,
						A2(
							$author$project$UI$Container$withContent,
							A2(
								$elm$core$List$map,
								function (s) {
									return A5(
										$author$project$Plan$DayPlanning$Supply$inserterPositionView,
										allDeliverers,
										readStatus,
										inserterPositionSelection,
										delivererOf(s),
										s);
								},
								inserterPositions),
							A2(
								$author$project$UI$Container$withTitle,
								$mdgriffith$elm_ui$Element$text('Instekers'),
								$author$project$UI$Container$container)))));
		}
	});
var $author$project$Plan$Plan$onWriteable = F2(
	function (status, el) {
		if (!status) {
			return $mdgriffith$elm_ui$Element$none;
		} else {
			return el;
		}
	});
var $author$project$Plan$DayPlanning$Supply$UserClickedPreSupplyItem = function (a) {
	return {$: 8, a: a};
};
var $author$project$Plan$DayPlanning$Supply$UserSelectedDelivererToMovePreSupplyTo = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $icidasset$elm_material_icons$Material$Icons$local_shipping = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z')
				]),
			_List_Nil)
		]));
var $author$project$Plan$DayPlanning$Supply$preSupplyItemView = F5(
	function (allDeliverers, readStatus, selected, deliverer, preSupply) {
		return function () {
			var _v0 = _Utils_Tuple2(readStatus, selected);
			if ((_v0.a === 1) && (!_v0.b.$)) {
				var _v1 = _v0.a;
				var id = _v0.b.a.eg;
				var moveFolding = _v0.b.a.n;
				return _Utils_eq(id, preSupply.eg) ? function (onlyView) {
					return A2(
						$mdgriffith$elm_ui$Element$column,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
							]),
						_List_fromArray(
							[
								onlyView,
								A4(
								$author$project$Plan$DayPlanning$Supply$detailItemCardView,
								$author$project$Plan$DayPlanning$Supply$UserSelectedDelivererToMovePreSupplyTo(preSupply.eg),
								'Koppel voordraai rit aan',
								moveFolding,
								A4($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$core$Basics$identity, $Gizra$elm_all_set$EverySet$remove, deliverer, allDeliverers))
							]));
				} : $elm$core$Basics$identity;
			} else {
				return $elm$core$Basics$identity;
			}
		}()(
			A4($author$project$Plan$DayPlanning$Supply$detailItemOnlyView, $icidasset$elm_material_icons$Material$Icons$local_shipping, $author$project$Plan$DayPlanning$Supply$UserClickedPreSupplyItem, deliverer, preSupply));
	});
var $author$project$Plan$DayPlanning$Supply$preSupplyView = F5(
	function (dp, allDeliverers, readStatus, preSupply, preSupplySelection) {
		var assignments = $author$project$Plan$Plan$preSupplyAssignmentsOf(preSupply);
		var delivererOf = function (s) {
			return A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.bl;
				},
				A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.eg;
						},
						$elm$core$Basics$eq(s.eg)),
					assignments));
		};
		var _v0 = _Utils_Tuple2(
			$author$project$DistributionPoint$DistributionPoint$preSuppliesOf(dp),
			preSupply);
		if (!_v0.a.b) {
			return $mdgriffith$elm_ui$Element$none;
		} else {
			if (_v0.b.$ === 1) {
				return $mdgriffith$elm_ui$Element$none;
			} else {
				var preSupplies = _v0.a;
				return $author$project$UI$Container$elementFor(
					$author$project$UI$Container$withoutBorder(
						A2(
							$author$project$UI$Container$withWidth,
							$mdgriffith$elm_ui$Element$fill,
							A2(
								$author$project$UI$Container$withContent,
								A2(
									$elm$core$List$map,
									function (s) {
										return A5(
											$author$project$Plan$DayPlanning$Supply$preSupplyItemView,
											allDeliverers,
											readStatus,
											preSupplySelection,
											delivererOf(s),
											s);
									},
									preSupplies),
								A2(
									$author$project$UI$Container$withTitle,
									$mdgriffith$elm_ui$Element$text('Voordraai'),
									$author$project$UI$Container$container)))));
			}
		}
	});
var $author$project$Plan$DayPlanning$Supply$UserChangedDetailReeditFolding = {$: 20};
var $author$project$Plan$DayPlanning$Supply$UserClickedReeditPlan = {$: 22};
var $author$project$Plan$DayPlanning$Supply$reeditPlanView = function (folding) {
	var title = function (icon) {
		return A2(
			$mdgriffith$elm_ui$Element$Input$button,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			{
				mD: A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text('Plan aanpassen'),
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[$mdgriffith$elm_ui$Element$alignRight]),
							$author$project$UI$Element$iconFor(
								$author$project$UI$Font$heading3Sized(icon)))
						])),
				jp: $elm$core$Maybe$Just($author$project$Plan$DayPlanning$Supply$UserChangedDetailReeditFolding)
			});
	};
	return $author$project$UI$Container$elementFor(
		function () {
			if (folding === 2) {
				return A2(
					$elm$core$Basics$composeR,
					$author$project$UI$Container$withTitle(
						title($icidasset$elm_material_icons$Material$Icons$unfold_more)),
					$author$project$UI$Container$withContent(
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$column,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$spacing(5)
									]),
								_List_fromArray(
									[
										A2(
										$mdgriffith$elm_ui$Element$paragraph,
										_List_Nil,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$text('Weet je zeker dat je het plan opnieuw wil aanpassen? Dit moet dan later opnieuw doorgestuurd worden voor betaling.')
											])),
										$author$project$UI$Button$elementFor(
										A2(
											$author$project$UI$Button$withRole,
											1,
											A2($author$project$UI$Button$button, $author$project$Plan$DayPlanning$Supply$UserClickedReeditPlan, 'Plan aanpassen')))
									]))
							])));
			} else {
				return $author$project$UI$Container$withTitle(
					title($icidasset$elm_material_icons$Material$Icons$unfold_less));
			}
		}()(
			A2(
				$author$project$UI$Container$withSpacing,
				10,
				A2($author$project$UI$Container$withWidth, $mdgriffith$elm_ui$Element$fill, $author$project$UI$Container$container))));
};
var $author$project$Plan$DayPlanning$Supply$UserChangedDetailDeleteFolding = {$: 19};
var $author$project$Plan$DayPlanning$Supply$UserClickedDeletePlan = {$: 21};
var $author$project$Plan$DayPlanning$Supply$removePlanView = function (folding) {
	var title = function (icon) {
		return A2(
			$mdgriffith$elm_ui$Element$Input$button,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			{
				mD: A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text('Plan verwijderen'),
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[$mdgriffith$elm_ui$Element$alignRight]),
							$author$project$UI$Element$iconFor(
								$author$project$UI$Font$heading3Sized(icon)))
						])),
				jp: $elm$core$Maybe$Just($author$project$Plan$DayPlanning$Supply$UserChangedDetailDeleteFolding)
			});
	};
	return $author$project$UI$Container$elementFor(
		function () {
			if (folding === 1) {
				return A2(
					$elm$core$Basics$composeR,
					$author$project$UI$Container$withTitle(
						title($icidasset$elm_material_icons$Material$Icons$unfold_more)),
					$author$project$UI$Container$withContent(
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$column,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$spacing(5)
									]),
								_List_fromArray(
									[
										A2(
										$mdgriffith$elm_ui$Element$paragraph,
										_List_Nil,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$text('Weet je zeker dat je het plan wilt verwijderen? Alle gegevens in het plan zullen verloren gaan.')
											])),
										$author$project$UI$Button$elementFor(
										A2(
											$author$project$UI$Button$withRole,
											1,
											A2($author$project$UI$Button$button, $author$project$Plan$DayPlanning$Supply$UserClickedDeletePlan, 'Plan verwijderen')))
									]))
							])));
			} else {
				return $author$project$UI$Container$withTitle(
					title($icidasset$elm_material_icons$Material$Icons$unfold_less));
			}
		}()(
			A2(
				$author$project$UI$Container$withSpacing,
				10,
				A2($author$project$UI$Container$withWidth, $mdgriffith$elm_ui$Element$fill, $author$project$UI$Container$container))));
};
var $author$project$Plan$DayPlanning$Supply$supplyTitle = F4(
	function (background, titleText, attrs, icon) {
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_Utils_ap(
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$Background$color(
						$author$project$UI$Element$colorFor(background)),
						$mdgriffith$elm_ui$Element$Font$color(
						$author$project$UI$Element$colorFor($author$project$UI$Palette$base2)),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						A2($mdgriffith$elm_ui$Element$paddingXY, 10, 10)
					]),
				attrs),
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$text(titleText),
					icon
				]));
	});
var $author$project$Plan$DayPlanning$Supply$detailView = F7(
	function (dp, allDeliverers, readStatus, detail, preSupply, assistants, inserters) {
		var title = function (icon) {
			return A4(
				$author$project$Plan$DayPlanning$Supply$supplyTitle,
				$author$project$UI$Palette$base03,
				'Plan',
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$Events$onClick($author$project$Plan$DayPlanning$Supply$UserChangedDetailFolding),
						$mdgriffith$elm_ui$Element$pointer
					]),
				A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$alignRight]),
					icon));
		};
		if (!detail.$) {
			return title(
				A2(
					$author$project$UI$Element$coloredIconFor,
					$icidasset$elm_material_icons$Material$Icons$unfold_more(16),
					$author$project$UI$Palette$base2));
		} else {
			var planFolding = detail.a.bY;
			var selection = detail.a.al;
			var preSupplySelection = function () {
				if (selection.$ === 1) {
					var info = selection.a;
					return $elm$core$Maybe$Just(info);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}();
			var inserterSelection = function () {
				if (selection.$ === 3) {
					var info = selection.a;
					return $elm$core$Maybe$Just(info);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}();
			var assistantSelection = function () {
				if (selection.$ === 2) {
					var info = selection.a;
					return $elm$core$Maybe$Just(info);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}();
			return A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				_List_fromArray(
					[
						title(
						A2(
							$author$project$UI$Element$coloredIconFor,
							$icidasset$elm_material_icons$Material$Icons$unfold_less(16),
							$author$project$UI$Palette$base2)),
						A5($author$project$Plan$DayPlanning$Supply$preSupplyView, dp, allDeliverers, readStatus, preSupply, preSupplySelection),
						A5($author$project$Plan$DayPlanning$Supply$assistantPositionsView, dp, allDeliverers, readStatus, assistants, assistantSelection),
						A5($author$project$Plan$DayPlanning$Supply$inserterPositionsView, dp, allDeliverers, readStatus, inserters, inserterSelection),
						function () {
						if (!readStatus) {
							return $author$project$Plan$DayPlanning$Supply$reeditPlanView(planFolding);
						} else {
							return $mdgriffith$elm_ui$Element$none;
						}
					}(),
						A2(
						$author$project$Plan$Plan$onWriteable,
						readStatus,
						$author$project$Plan$DayPlanning$Supply$removePlanView(planFolding))
					]));
		}
	});
var $author$project$Plan$Selection$clusterIdFrom = function (selection) {
	switch (selection.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 2:
			var clusterNumber = selection.a.dU;
			return $elm$core$Maybe$Just(clusterNumber);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Plan$DayPlanning$Supply$EditDeliverer = function (a) {
	return {$: 5, a: a};
};
var $author$project$Plan$DayPlanning$Supply$UserSelectedDelivererColor = F2(
	function (a, b) {
		return {$: 41, a: a, b: b};
	});
var $author$project$Plan$DayPlanning$Supply$UserRemovedPreSupplyFromItem = {$: 11};
var $author$project$Plan$DayPlanning$Supply$UserToggledPreSupplyFolding = {$: 12};
var $icidasset$elm_material_icons$Material$Icons$clear = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z')
				]),
			_List_Nil)
		]));
var $author$project$UI$Util$consIf = F3(
	function (predicate, item, list) {
		return predicate ? A2($elm$core$List$cons, item, list) : list;
	});
var $author$project$Plan$DayPlanning$Supply$UserSelectedPreSupplyToPreSupplyItemFrom = function (a) {
	return {$: 10, a: a};
};
var $author$project$Plan$DayPlanning$Supply$preSupplyAssignmentView = function (preSupplies) {
	var mouseOverColors = {kV: $author$project$UI$Palette$base02, k0: $author$project$UI$Palette$base02, lZ: $author$project$UI$Palette$base2};
	var item = function (preSupply) {
		return A2(
			$mdgriffith$elm_ui$Element$Input$button,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$pointer,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$padding(1),
					$mdgriffith$elm_ui$Element$mouseOver(
					$author$project$UI$Element$colors(mouseOverColors))
				]),
			{
				mD: $mdgriffith$elm_ui$Element$text(preSupply.ft),
				jp: $elm$core$Maybe$Just(
					$author$project$Plan$DayPlanning$Supply$UserSelectedPreSupplyToPreSupplyItemFrom(preSupply.eg))
			});
	};
	return $author$project$UI$Container$elementFor(
		A2(
			$author$project$UI$Container$withContent,
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_Nil,
					A2($elm$core$List$map, item, preSupplies))
				]),
			A2(
				$author$project$UI$Container$withTitle,
				$mdgriffith$elm_ui$Element$text('Voordraai aangeleverd door'),
				A2($author$project$UI$Container$withWidth, $mdgriffith$elm_ui$Element$fill, $author$project$UI$Container$container))));
};
var $author$project$Plan$Selection$preSupplyFoldingFrom = function (selection) {
	switch (selection.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var preSupplyFolding = selection.a.fE;
			return $elm$core$Maybe$Just(preSupplyFolding);
		case 2:
			var preSupplyFolding = selection.a.fE;
			return $elm$core$Maybe$Just(preSupplyFolding);
		default:
			var preSupplyFolding = selection.a.fE;
			return $elm$core$Maybe$Just(preSupplyFolding);
	}
};
var $author$project$UI$Container$withoutPadding = function (_v0) {
	var c = _v0;
	return _Utils_update(
		c,
		{
			g6: {k5: 0, mE: 0, nx: 0, ol: 0}
		});
};
var $author$project$Plan$DayPlanning$Supply$cardPreSupplyView = F3(
	function (distributionPoint, planInfo, preSupply) {
		var onRW = function (el) {
			return A3($author$project$UI$Util$consIf, planInfo.aP === 1, el, _List_Nil);
		};
		var _v0 = _Utils_Tuple2(
			$author$project$DistributionPoint$DistributionPoint$preSuppliesOf(distributionPoint),
			planInfo.ni);
		if (!_v0.a.b) {
			return $mdgriffith$elm_ui$Element$none;
		} else {
			if (_v0.b.$ === 1) {
				return $mdgriffith$elm_ui$Element$none;
			} else {
				var preSupplies = _v0.a;
				var _v1 = function () {
					if (!preSupply.$) {
						return _Utils_Tuple2($elm$core$Maybe$Nothing, preSupplies);
					} else {
						var preSupplyId = preSupply.a;
						return A2(
							$elm$core$Tuple$mapFirst,
							$elm$core$List$head,
							A2(
								$elm$core$List$partition,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.eg;
									},
									$elm$core$Basics$eq(preSupplyId)),
								preSupplies));
					}
				}();
				var currentPreSupply = _v1.a;
				var otherPreSupplies = _v1.b;
				var title = A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(10)
						]),
					function () {
						if (!currentPreSupply.$) {
							var name = currentPreSupply.a.ft;
							return A2(
								$elm$core$List$cons,
								A2(
									$mdgriffith$elm_ui$Element$Input$button,
									_List_Nil,
									{
										mD: A2(
											$mdgriffith$elm_ui$Element$row,
											_List_fromArray(
												[
													$mdgriffith$elm_ui$Element$spacing(10)
												]),
											_List_fromArray(
												[
													$mdgriffith$elm_ui$Element$text('Voordraai door'),
													A2(
													$mdgriffith$elm_ui$Element$el,
													_List_Nil,
													$author$project$UI$Element$iconFor(
														$author$project$UI$Font$heading3Sized($icidasset$elm_material_icons$Material$Icons$local_shipping))),
													$mdgriffith$elm_ui$Element$text(name)
												])),
										jp: $elm$core$Maybe$Just($author$project$Plan$DayPlanning$Supply$UserToggledPreSupplyFolding)
									}),
								_Utils_ap(
									onRW(
										A2(
											$mdgriffith$elm_ui$Element$Input$button,
											_List_Nil,
											{
												mD: A2(
													$mdgriffith$elm_ui$Element$el,
													_List_fromArray(
														[
															$mdgriffith$elm_ui$Element$htmlAttribute(
															$elm$html$Html$Attributes$title('Verwijderen'))
														]),
													$author$project$UI$Element$iconFor(
														$author$project$UI$Font$heading3Sized($icidasset$elm_material_icons$Material$Icons$clear))),
												jp: $elm$core$Maybe$Just($author$project$Plan$DayPlanning$Supply$UserRemovedPreSupplyFromItem)
											})),
									_List_fromArray(
										[
											A2(
											$mdgriffith$elm_ui$Element$Input$button,
											_List_fromArray(
												[$mdgriffith$elm_ui$Element$alignRight]),
											{
												mD: A2(
													$mdgriffith$elm_ui$Element$el,
													_List_fromArray(
														[$mdgriffith$elm_ui$Element$alignRight]),
													$author$project$UI$Element$iconFor(
														$author$project$UI$Font$heading3Sized(
															function () {
																var _v8 = $author$project$Plan$Selection$preSupplyFoldingFrom(planInfo.nI);
																if ((!_v8.$) && (_v8.a === 1)) {
																	var _v9 = _v8.a;
																	return $icidasset$elm_material_icons$Material$Icons$unfold_less;
																} else {
																	return $icidasset$elm_material_icons$Material$Icons$unfold_more;
																}
															}()))),
												jp: $elm$core$Maybe$Just($author$project$Plan$DayPlanning$Supply$UserToggledPreSupplyFolding)
											})
										])));
						} else {
							return _List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$Input$button,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
										]),
									{
										mD: A2(
											$mdgriffith$elm_ui$Element$row,
											_List_fromArray(
												[
													$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
												]),
											_List_fromArray(
												[
													$mdgriffith$elm_ui$Element$text('Geen voordraai levering'),
													A2(
													$mdgriffith$elm_ui$Element$el,
													_List_fromArray(
														[$mdgriffith$elm_ui$Element$alignRight]),
													$author$project$UI$Element$iconFor(
														$author$project$UI$Font$heading3Sized(
															function () {
																var _v10 = $author$project$Plan$Selection$preSupplyFoldingFrom(planInfo.nI);
																if ((!_v10.$) && (_v10.a === 1)) {
																	var _v11 = _v10.a;
																	return $icidasset$elm_material_icons$Material$Icons$unfold_less;
																} else {
																	return $icidasset$elm_material_icons$Material$Icons$unfold_more;
																}
															}())))
												])),
										jp: $elm$core$Maybe$Just($author$project$Plan$DayPlanning$Supply$UserToggledPreSupplyFolding)
									})
								]);
						}
					}());
				return $author$project$UI$Container$elementFor(
					A2(
						$author$project$UI$Container$withContent,
						function () {
							var _v3 = _Utils_Tuple3(
								otherPreSupplies,
								planInfo.aP,
								$author$project$Plan$Selection$preSupplyFoldingFrom(planInfo.nI));
							if (((_v3.a.b && (_v3.b === 1)) && (!_v3.c.$)) && (_v3.c.a === 1)) {
								var _v4 = _v3.a;
								var _v5 = _v3.b;
								var _v6 = _v3.c.a;
								return _List_fromArray(
									[
										$author$project$Plan$DayPlanning$Supply$preSupplyAssignmentView(otherPreSupplies)
									]);
							} else {
								return _List_Nil;
							}
						}(),
						$author$project$UI$Container$withoutPadding(
							A2(
								$author$project$UI$Container$withSpacing,
								10,
								A2(
									$author$project$UI$Container$withTitle,
									title,
									A2($author$project$UI$Container$withWidth, $mdgriffith$elm_ui$Element$fill, $author$project$UI$Container$container))))));
			}
		}
	});
var $author$project$Plan$DayPlanning$Supply$UserSelectedAddCluster = {$: 26};
var $author$project$Plan$DayPlanning$Supply$UserSelectedClusterInInfo = function (a) {
	return {$: 25, a: a};
};
var $author$project$Plan$DayPlanning$Supply$UserStartsDragging = function (a) {
	return {$: 30, a: a};
};
var $author$project$Plan$DayPlanning$Supply$cursorOffsetDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Plan$DayPlanning$Supply$CursorCoordinates,
	A2($elm$json$Json$Decode$field, 'offsetX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'offsetY', $elm$json$Json$Decode$float));
var $author$project$Plan$DayPlanning$Supply$cursorPositionDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Plan$DayPlanning$Supply$CursorCoordinates,
	A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float));
var $phollyer$elm_cursor$Element$Cursor$cursor = $mdgriffith$elm_ui$Element$htmlAttribute;
var $phollyer$elm_cursor$Html$Cursor$cursor = $elm$html$Html$Attributes$style('cursor');
var $phollyer$elm_cursor$Html$Cursor$move = $phollyer$elm_cursor$Html$Cursor$cursor('move');
var $phollyer$elm_cursor$Element$Cursor$move = $phollyer$elm_cursor$Element$Cursor$cursor($phollyer$elm_cursor$Html$Cursor$move);
var $author$project$Plan$DayPlanning$Supply$clusterDragHandleView = F2(
	function (item, cluster) {
		var onPointerDown = $mdgriffith$elm_ui$Element$htmlAttribute(
			A2(
				$elm$html$Html$Events$on,
				'pointerdown',
				A3(
					$elm$json$Json$Decode$map2,
					F2(
						function (cursorOnScreen, cursorOffset) {
							return $author$project$Plan$DayPlanning$Supply$UserStartsDragging(
								$author$project$Plan$DayPlanning$Supply$DraggingCluster(
									{H: cluster, aF: cursorOffset, aG: cursorOnScreen, gK: item}));
						}),
					$author$project$Plan$DayPlanning$Supply$cursorPositionDecoder,
					$author$project$Plan$DayPlanning$Supply$cursorOffsetDecoder)));
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[onPointerDown, $phollyer$elm_cursor$Element$Cursor$move]),
			A2(
				$author$project$UI$Element$coloredIconFor,
				$icidasset$elm_material_icons$Material$Icons$drag_indicator(16),
				$author$project$UI$Palette$base0));
	});
var $author$project$Plan$DayPlanning$Supply$EditSequence = {$: 14};
var $author$project$Plan$DayPlanning$Supply$UserSelectedDelivererToMoveClusterTo = function (a) {
	return {$: 28, a: a};
};
var $author$project$Plan$DayPlanning$Supply$UserToggledMovingClusterFolding = {$: 27};
var $author$project$Plan$Selection$movingOf = function (selection) {
	var _v0 = $author$project$Plan$Selection$moveFoldingFrom(selection);
	if ((!_v0.$) && (_v0.a.$ === 1)) {
		var moving = _v0.a.a;
		return $elm$core$Maybe$Just(moving);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Plan$DayPlanning$Supply$moveClusterView = F2(
	function (deliverers, selection) {
		var title = function (icon) {
			return A2(
				$mdgriffith$elm_ui$Element$Input$button,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$pointer,
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				{
					mD: A2(
						$mdgriffith$elm_ui$Element$row,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
							]),
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text('Koppel cluster aan'),
								A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[$mdgriffith$elm_ui$Element$alignRight]),
								$author$project$UI$Element$iconFor(
									$author$project$UI$Font$heading3Sized(icon)))
							])),
					jp: $elm$core$Maybe$Just($author$project$Plan$DayPlanning$Supply$UserToggledMovingClusterFolding)
				});
		};
		var mouseOverColors = {kV: $author$project$UI$Palette$base02, k0: $author$project$UI$Palette$base02, lZ: $author$project$UI$Palette$base2};
		var item = function (deliverer) {
			return A2(
				$mdgriffith$elm_ui$Element$Input$button,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$pointer,
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$padding(1),
						$mdgriffith$elm_ui$Element$mouseOver(
						$author$project$UI$Element$colors(mouseOverColors))
					]),
				{
					mD: $mdgriffith$elm_ui$Element$text(
						$author$project$Deliverer$Deliverer$nameView(
							$author$project$Deliverer$Deliverer$fromTyped(deliverer))),
					jp: $elm$core$Maybe$Just(
						$author$project$Plan$DayPlanning$Supply$UserSelectedDelivererToMoveClusterTo(deliverer))
				});
		};
		var _v0 = $author$project$Plan$Selection$movingOf(selection);
		if ((!_v0.$) && (_v0.a === 1)) {
			var _v1 = _v0.a;
			return $author$project$UI$Container$elementFor(
				A2(
					$author$project$UI$Container$withContent,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$column,
							_List_Nil,
							A2(
								$elm$core$List$map,
								item,
								A2(
									$elm$core$List$sortBy,
									A2($elm$core$Basics$composeR, $author$project$Deliverer$Deliverer$fromTyped, $author$project$Sorting$Deliverers$byName),
									$Gizra$elm_all_set$EverySet$toList(deliverers))))
						]),
					A2(
						$author$project$UI$Container$withTitle,
						title($icidasset$elm_material_icons$Material$Icons$unfold_less),
						A2($author$project$UI$Container$withWidth, $mdgriffith$elm_ui$Element$fill, $author$project$UI$Container$container))));
		} else {
			return $author$project$UI$Container$elementFor(
				A2(
					$author$project$UI$Container$withTitle,
					title($icidasset$elm_material_icons$Material$Icons$unfold_more),
					A2($author$project$UI$Container$withWidth, $mdgriffith$elm_ui$Element$fill, $author$project$UI$Container$container)));
		}
	});
var $author$project$Plan$DayPlanning$Supply$clusterInfoView = F5(
	function (distributionPoint, _v0, clusters, item, cluster) {
		var allDeliverers = _v0.f4;
		var selected = _v0.nI;
		var readStatus = _v0.aP;
		var onRW = function (el) {
			return A3($author$project$UI$Util$consIf, readStatus === 1, el, _List_Nil);
		};
		var _v1 = A2($author$project$DistributionPoint$DistributionPoint$sortedSegmentNames, distributionPoint, cluster.bb);
		if (!_v1.b) {
			return A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$Font$italic,
						$mdgriffith$elm_ui$Element$Font$color(
						$author$project$UI$Element$colorFor($author$project$UI$Palette$base01))
					]),
				$mdgriffith$elm_ui$Element$text('Lege cluster'));
		} else {
			var segmentNames = _v1;
			return A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$spacing(5),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$row,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$Font$color(
								$author$project$UI$Element$colorFor($author$project$UI$Palette$base01))
							]),
						_List_fromArray(
							[
								function () {
								if (clusters.b && clusters.b.b) {
									var _v3 = clusters.b;
									return A2(
										$author$project$Plan$Plan$onWriteable,
										readStatus,
										A2($author$project$Plan$DayPlanning$Supply$clusterDragHandleView, item, cluster));
								} else {
									return $mdgriffith$elm_ui$Element$none;
								}
							}(),
								$mdgriffith$elm_ui$Element$text(
								'Cluster #' + $author$project$Cluster$Number$print(cluster.bX)),
								A2(
								$author$project$Plan$Plan$onWriteable,
								readStatus,
								A2(
									$mdgriffith$elm_ui$Element$Input$button,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$pointer,
											A2($mdgriffith$elm_ui$Element$paddingXY, 5, 0),
											$mdgriffith$elm_ui$Element$htmlAttribute(
											$elm$html$Html$Attributes$title('Loopvolgorde'))
										]),
									{
										mD: A2(
											$author$project$UI$Element$coloredIconFor,
											$author$project$UI$Font$heading3Sized($icidasset$elm_material_icons$Material$Icons$directions_run),
											$author$project$UI$Palette$base03),
										jp: $elm$core$Maybe$Just($author$project$Plan$DayPlanning$Supply$EditSequence)
									}))
							])),
						A2(
						$mdgriffith$elm_ui$Element$column,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Element$paddingXY, 10, 0),
								$mdgriffith$elm_ui$Element$spacing(5),
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
							]),
						_Utils_ap(
							A2($elm$core$List$map, $mdgriffith$elm_ui$Element$text, segmentNames),
							onRW(
								A2($author$project$Plan$DayPlanning$Supply$moveClusterView, allDeliverers, selected))))
					]));
		}
	});
var $author$project$Cluster$Cluster$viewAsTitle = F2(
	function (distributionPoint, cluster) {
		return 'Cluster #' + ($author$project$Cluster$Number$print(cluster.bX) + (': ' + function () {
			var _v0 = A2(
				$elm$core$List$sortBy,
				$author$project$UI$Name$view,
				A2(
					$elm$core$List$map,
					$author$project$DistributionPoint$DistributionPoint$segmentInfo,
					A2($author$project$DistributionPoint$DistributionPoint$findSegmentsOnId, distributionPoint, cluster.bb)));
			if (!_v0.b) {
				return 'Leeg';
			} else {
				if (!_v0.b.b) {
					var only = _v0.a;
					return $author$project$UI$Name$view(only);
				} else {
					var first = _v0.a;
					var rest = _v0.b;
					return $author$project$UI$Name$view(first) + (', ... (' + ($elm$core$String$fromInt(
						$elm$core$List$length(rest)) + ' meer)'));
				}
			}
		}()));
	});
var $author$project$Plan$DayPlanning$Supply$clustersInfoView = F5(
	function (distributionPoint, planInfo, item, clusters, selectedClusterNumber) {
		var onRW = function (el) {
			return A3($author$project$UI$Util$consIf, planInfo.aP === 1, el, _List_Nil);
		};
		var title = A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(10)
				]),
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$text('Clusters'),
				onRW(
					A2(
						$mdgriffith$elm_ui$Element$Input$button,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$pointer,
								$mdgriffith$elm_ui$Element$alignRight,
								$mdgriffith$elm_ui$Element$htmlAttribute(
								$elm$html$Html$Attributes$title('Cluster toevoegen'))
							]),
						{
							mD: $author$project$UI$Element$iconFor(
								$author$project$UI$Font$heading3Sized($icidasset$elm_material_icons$Material$Icons$add)),
							jp: $elm$core$Maybe$Just($author$project$Plan$DayPlanning$Supply$UserSelectedAddCluster)
						}))));
		var clusterView = function (cluster) {
			return _Utils_eq(cluster.bX, selectedClusterNumber) ? A5($author$project$Plan$DayPlanning$Supply$clusterInfoView, distributionPoint, planInfo, clusters, item, cluster) : A2(
				$mdgriffith$elm_ui$Element$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Plan$Plan$onWriteable,
						planInfo.aP,
						A2($author$project$Plan$DayPlanning$Supply$clusterDragHandleView, item, cluster)),
						A2(
						$mdgriffith$elm_ui$Element$Input$button,
						_List_fromArray(
							[$mdgriffith$elm_ui$Element$pointer]),
						{
							mD: $mdgriffith$elm_ui$Element$text(
								A2($author$project$Cluster$Cluster$viewAsTitle, distributionPoint, cluster)),
							jp: $elm$core$Maybe$Just(
								$author$project$Plan$DayPlanning$Supply$UserSelectedClusterInInfo(cluster.bX))
						})
					]));
		};
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				A2($elm$core$List$map, clusterView, clusters),
				A2(
					$author$project$UI$Container$withSpacing,
					10,
					A2(
						$author$project$UI$Container$withWidth,
						$mdgriffith$elm_ui$Element$fill,
						A2($author$project$UI$Container$withTitle, title, $author$project$UI$Container$container)))));
	});
var $author$project$Deliverer$Colors$colorButton = F4(
	function (selectColorMsg, borderWidth, selected, color) {
		return A2(
			$mdgriffith$elm_ui$Element$Input$button,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$Background$color(
					$author$project$UI$Element$colorFor(
						$author$project$Deliverer$Colors$toSolidColor(color))),
					$mdgriffith$elm_ui$Element$Border$color(
					$author$project$UI$Element$colorFor(
						_Utils_eq(color, selected) ? $author$project$UI$Palette$base01 : $author$project$UI$Palette$base2)),
					$mdgriffith$elm_ui$Element$Border$width(borderWidth)
				]),
			{
				mD: A2($mdgriffith$elm_ui$Element$el, _List_Nil, $mdgriffith$elm_ui$Element$none),
				jp: $elm$core$Maybe$Just(
					selectColorMsg(color))
			});
	});
var $author$project$Deliverer$Colors$colorsForPalette = _List_fromArray(
	[
		_List_fromArray(
		[0, 1, 2, 3, 4, 5, 6, 7, 8, 9]),
		_List_fromArray(
		[10, 11, 12, 13, 14, 15, 16, 19, 18, 17])
	]);
var $author$project$Deliverer$Colors$colorPickerView = F3(
	function (selectColorMsg, heightInPixels, selected) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$height(
					$mdgriffith$elm_ui$Element$px(heightInPixels))
				]),
			A2(
				$elm$core$List$map,
				function (colors) {
					return A2(
						$mdgriffith$elm_ui$Element$row,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
							]),
						A2(
							$elm$core$List$map,
							A3($author$project$Deliverer$Colors$colorButton, selectColorMsg, (heightInPixels / 10) | 0, selected),
							colors));
				},
				$author$project$Deliverer$Colors$colorsForPalette));
	});
var $icidasset$elm_material_icons$Material$Icons$account_box = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$b('new 0 0 24 24'),
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$rect,
					_List_fromArray(
						[
							$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$icidasset$elm_material_icons$Material$Icons$Internal$p,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M19,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z M12,6c1.93,0,3.5,1.57,3.5,3.5 c0,1.93-1.57,3.5-3.5,3.5s-3.5-1.57-3.5-3.5C8.5,7.57,10.07,6,12,6z M19,19H5v-0.23c0-0.62,0.28-1.2,0.76-1.58 C7.47,15.82,9.64,15,12,15s4.53,0.82,6.24,2.19c0.48,0.38,0.76,0.97,0.76,1.58V19z')
						]),
					_List_Nil)
				]))
		]));
var $author$project$Deliverer$Deliverer$detailButton = function (msg) {
	return $author$project$UI$Button$elementFor(
		A2(
			$author$project$UI$Button$withIcon,
			$icidasset$elm_material_icons$Material$Icons$account_box,
			A2(
				$author$project$UI$Button$withRole,
				2,
				A2($author$project$UI$Button$button, msg, 'Details'))));
};
var $author$project$UI$Text$withAction = F2(
	function (action, _v0) {
		var t = _v0;
		return _Utils_update(
			t,
			{
				dN: $elm$core$Maybe$Just(action)
			});
	});
var $author$project$UI$Text$maybeWithAction = F2(
	function (maybeMsg, icon) {
		if (!maybeMsg.$) {
			var msg = maybeMsg.a;
			return $author$project$UI$Text$withAction(
				{mg: icon, gX: msg});
		} else {
			return $elm$core$Basics$identity;
		}
	});
var $author$project$Deliverer$Deliverer$supplyAddressView = F3(
	function (editMsg, date, typedDeliverer) {
		switch (typedDeliverer.$) {
			case 0:
				var deliverer = typedDeliverer.a;
				var location = A2(
					$author$project$Deliverer$Deliverer$locationOf,
					$author$project$Date$DeliveryDate$toDate(date),
					deliverer);
				return $author$project$UI$Text$elementFor(
					A3(
						$author$project$UI$Text$maybeWithAction,
						editMsg,
						$icidasset$elm_material_icons$Material$Icons$edit,
						A2(
							$author$project$UI$Text$withLabel,
							'Afleveradres',
							$author$project$UI$Text$text(
								A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									'-',
									function ($) {
										return $.ft;
									},
									location)))));
			case 1:
				var delivererMaybe = typedDeliverer.b;
				var location = A2(
					$elm$core$Maybe$andThen,
					$author$project$Deliverer$Deliverer$locationOf(
						$author$project$Date$DeliveryDate$toDate(date)),
					delivererMaybe);
				return A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$spacing(4)
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$row,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Font$size(14),
									$mdgriffith$elm_ui$Element$spacing(10)
								]),
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text('Afleveradres')
								])),
							$mdgriffith$elm_ui$Element$text(
							A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								'-',
								function ($) {
									return $.ft;
								},
								location))
						]));
			default:
				return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$Deliverer$Deliverer$infoView = F5(
	function (editMsg, selectColorMsg, date, hasRide, typed) {
		var maybeWithDetailButton = function (content) {
			var _v1 = _Utils_Tuple2(editMsg, typed);
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var msg = _v1.a.a;
				return A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					_List_fromArray(
						[
							content,
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[$mdgriffith$elm_ui$Element$alignRight]),
							$author$project$Deliverer$Deliverer$detailButton(msg))
						]));
			} else {
				return content;
			}
		};
		var excludedDelivererForColorPicker = A2(
			$elm$core$List$member,
			$author$project$Deliverer$Deliverer$comparableId(
				$author$project$Deliverer$Deliverer$idFromTyped(typed)),
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$second,
				_List_fromArray(
					[
						_Utils_Tuple2('Calamiteiten bezorger', 'e6da7443-411b-486b-ab09-baaa672fb040'),
						_Utils_Tuple2('Nieuwe Bezorger - Overeenkomst volgt', '06582cae-17c0-41cb-a0d7-41a53059489a')
					])));
		var maybeWithColorPickerView = function () {
			var _v0 = _Utils_Tuple2(typed, excludedDelivererForColorPicker);
			if ((!_v0.a.$) && (!_v0.b)) {
				var id = _v0.a.a.eg;
				var color = _v0.a.a.eS;
				return A3($author$project$Deliverer$Colors$colorPickerView, selectColorMsg, 40, color);
			} else {
				return $mdgriffith$elm_ui$Element$none;
			}
		}();
		return $author$project$UI$Container$elementFor(
			$author$project$UI$Container$withoutPadding(
				A2(
					$author$project$UI$Container$withWidth,
					$mdgriffith$elm_ui$Element$fill,
					A2(
						$author$project$UI$Container$withContent,
						_List_fromArray(
							[
								maybeWithDetailButton(
								$author$project$Deliverer$Deliverer$relNrView(typed)),
								maybeWithColorPickerView,
								hasRide ? A3($author$project$Deliverer$Deliverer$supplyAddressView, editMsg, date, typed) : $mdgriffith$elm_ui$Element$none
							]),
						$author$project$UI$Container$withoutBorder($author$project$UI$Container$container)))));
	});
var $author$project$Plan$Plan$mapReadStatus = F2(
	function (onReadWrite, status) {
		if (!status) {
			return $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Just(onReadWrite);
		}
	});
var $author$project$Plan$DayPlanning$Supply$delivererCardView = F7(
	function (distributionPoint, selectedCluster, planInfo, parentSupplyItemId, clusters, deliverer, preSupply) {
		var hasParent = function () {
			if (!parentSupplyItemId.$) {
				return true;
			} else {
				return false;
			}
		}();
		var editMsg = A2(
			$author$project$Plan$Plan$mapReadStatus,
			$author$project$Plan$DayPlanning$Supply$EditDeliverer(
				$author$project$Deliverer$Deliverer$idFromTyped(deliverer)),
			planInfo.aP);
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Border$color(
					$author$project$UI$Element$colorFor(
						$author$project$Deliverer$Colors$toSolidColor(
							$author$project$Deliverer$Deliverer$colorOf(deliverer)))),
					$mdgriffith$elm_ui$Element$Border$widthEach(
					{k5: 0, mE: 4, nx: 0, ol: 0}),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$paddingEach(
						{k5: 10, mE: 25, nx: 25, ol: 10}),
						$mdgriffith$elm_ui$Element$spacing(10),
						$mdgriffith$elm_ui$Element$Font$regular,
						$mdgriffith$elm_ui$Element$Border$widthEach(
						{k5: 2, mE: 0, nx: 2, ol: 2}),
						$mdgriffith$elm_ui$Element$Border$color(
						$author$project$UI$Element$colorFor($author$project$UI$Palette$base0))
					]),
				A2(
					$elm$core$List$cons,
					A5(
						$author$project$Deliverer$Deliverer$infoView,
						editMsg,
						$author$project$Plan$DayPlanning$Supply$UserSelectedDelivererColor(deliverer),
						planInfo.lx,
						hasParent,
						deliverer),
					A2(
						$elm$core$List$cons,
						A3($author$project$Plan$DayPlanning$Supply$cardPreSupplyView, distributionPoint, planInfo, preSupply),
						A2(
							$elm$core$List$cons,
							function () {
								if (!selectedCluster.$) {
									var _v1 = selectedCluster.a;
									var supplyItem = _v1.a;
									var selectedClusterNumber = _v1.b;
									return A5($author$project$Plan$DayPlanning$Supply$clustersInfoView, distributionPoint, planInfo, supplyItem, clusters, selectedClusterNumber);
								} else {
									return $mdgriffith$elm_ui$Element$none;
								}
							}(),
							_List_Nil)))));
	});
var $author$project$Plan$DayPlanning$Supply$HighlightSegmentsOf = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$Plan$DayPlanning$Supply$SelectDeliverer = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Plan$Supply$encodeId = function (_v0) {
	var id = _v0;
	return $elm$json$Json$Encode$int(id);
};
var $author$project$Plan$DayPlanning$Supply$encodePosition = function (position) {
	var _v0 = function () {
		switch (position.$) {
			case 0:
				var id = position.a;
				return _Utils_Tuple2('before', id);
			case 1:
				var id = position.a;
				return _Utils_Tuple2('after', id);
			case 2:
				var id = position.a;
				return _Utils_Tuple2('prepended-in', id);
			case 3:
				var id = position.a;
				return _Utils_Tuple2('appended-in', id);
			default:
				var id = position.a;
				return _Utils_Tuple2('append-to', id);
		}
	}();
	var positionStr = _v0.a;
	var item = _v0.b;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'position',
				$elm$json$Json$Encode$string(positionStr)),
				_Utils_Tuple2(
				'item',
				$author$project$Plan$Supply$encodeId(item))
			]));
};
var $author$project$Plan$DayPlanning$Supply$beaconView = function (position) {
	var positionValue = $author$project$Plan$DayPlanning$Supply$encodePosition(position);
	return $mdgriffith$elm_ui$Element$html(
		A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-beacon',
					A2($elm$json$Json$Encode$encode, 0, positionValue)),
					A2($elm$html$Html$Attributes$style, 'width', '0px'),
					A2($elm$html$Html$Attributes$style, 'height', '0px')
				]),
			_List_Nil));
};
var $author$project$Plan$DayPlanning$Supply$dragHandleView = function (item) {
	var onPointerDown = $mdgriffith$elm_ui$Element$htmlAttribute(
		A2(
			$elm$html$Html$Events$on,
			'pointerdown',
			A3(
				$elm$json$Json$Decode$map2,
				F2(
					function (cursorOnScreen, cursorOffset) {
						return $author$project$Plan$DayPlanning$Supply$UserStartsDragging(
							$author$project$Plan$DayPlanning$Supply$DraggingItem(
								{bF: $elm$core$Maybe$Nothing, aF: cursorOffset, aG: cursorOnScreen, gK: item}));
					}),
				$author$project$Plan$DayPlanning$Supply$cursorPositionDecoder,
				$author$project$Plan$DayPlanning$Supply$cursorOffsetDecoder)));
	return A2(
		$mdgriffith$elm_ui$Element$el,
		_List_fromArray(
			[onPointerDown, $phollyer$elm_cursor$Element$Cursor$move]),
		A2(
			$author$project$UI$Element$coloredIconFor,
			$icidasset$elm_material_icons$Material$Icons$drag_indicator(16),
			$author$project$UI$Palette$base0));
};
var $author$project$Plan$Selection$isDelivererSelected = F3(
	function (selection, typedDeliverer, supplyItem) {
		switch (selection.$) {
			case 0:
				return false;
			case 1:
				var deliverer = selection.a.bl;
				return _Utils_eq(deliverer, typedDeliverer);
			case 2:
				var deliverer = selection.a.bl;
				var supplyItemId = selection.a.dF;
				return _Utils_eq(deliverer, typedDeliverer) && _Utils_eq(
					$elm$core$Maybe$Just(supplyItemId),
					A2($elm$core$Maybe$map, $author$project$Plan$Supply$idOf, supplyItem));
			default:
				return false;
		}
	});
var $author$project$Plan$DayPlanning$Supply$itemOf = function (draggedItem) {
	switch (draggedItem.$) {
		case 1:
			var item = draggedItem.a.gK;
			return $elm$core$Maybe$Just(item);
		case 2:
			var item = draggedItem.a.gK;
			return $elm$core$Maybe$Just(item);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Plan$DayPlanning$Supply$GotDemandMsg = function (a) {
	return {$: 34, a: a};
};
var $author$project$Plan$DayPlanning$Supply$ShowSegmentTooltip = F2(
	function (a, b) {
		return {$: 29, a: a, b: b};
	});
var $author$project$Plan$DayPlanning$Supply$mapDurationBarMsg = function (viewWithDurationBarMsg) {
	return A2(
		$mdgriffith$elm_ui$Element$map,
		function (msg) {
			if (!msg.$) {
				var id = msg.a;
				return $author$project$Plan$DayPlanning$Supply$GotDemandMsg(id);
			} else {
				var onOff = msg.a;
				var id = msg.b;
				return A2($author$project$Plan$DayPlanning$Supply$ShowSegmentTooltip, onOff, id);
			}
		},
		viewWithDurationBarMsg);
};
var $icidasset$elm_material_icons$Material$Icons$new_releases = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('m23 12-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12zm-10 5h-2v-2h2v2zm0-4h-2V7h2v6z')
				]),
			_List_Nil)
		]));
var $author$project$Plan$DayPlanning$Supply$supplyItemBackgroundColor = $author$project$UI$Palette$base2;
var $author$project$Plan$DayPlanning$Supply$supplyItemExpiredBackgroundColor = $author$project$UI$Palette$error.kV;
var $author$project$Plan$DayPlanning$Supply$supplyItemUnregisteredBackgroundColor = $author$project$Plan$DayPlanning$Supply$supplyItemExpiredBackgroundColor;
var $tesk9$palette$SolidColor$luminance = function (color) {
	var toSRBG = function (rgb8bit) {
		return rgb8bit / 255;
	};
	var fromSRGB = function (srgb) {
		return (srgb <= 0.03928) ? (srgb / 12.92) : A2($elm$core$Basics$pow, (srgb + 0.055) / 1.055, 2.4);
	};
	var _v0 = $tesk9$palette$SolidColor$toRGB(color);
	var rRaw = _v0.a;
	var gRaw = _v0.b;
	var bRaw = _v0.c;
	var blue = fromSRGB(
		toSRBG(bRaw));
	var green = fromSRGB(
		toSRBG(gRaw));
	var red = fromSRGB(
		toSRBG(rRaw));
	return ((0.2126 * red) + (0.7152 * green)) + (0.0722 * blue);
};
var $author$project$Deliverer$Colors$alternateColor = function (color) {
	return ($tesk9$palette$SolidColor$luminance(color) < 0.5) ? A2($tesk9$palette$SolidColor$addLightness, 20, color) : A2($tesk9$palette$SolidColor$addLightness, -15, color);
};
var $author$project$Duration$Duration$convert = F2(
	function (_v0, minutes) {
		var maxDuration = _v0.jd;
		var maxLength = _v0.je;
		return ((minutes * maxLength) / maxDuration) | 0;
	});
var $author$project$Duration$Duration$overTimeView = F2(
	function (scale, time) {
		return A2(
			$elm$svg$Svg$rect,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x(
					$elm$core$String$fromInt(
						A2($author$project$Duration$Duration$convert, scale, time.cc))),
					$elm$svg$Svg$Attributes$y('0'),
					$elm$svg$Svg$Attributes$width(
					$elm$core$String$fromInt(
						A2($author$project$Duration$Duration$convert, scale, -time.m5))),
					$elm$svg$Svg$Attributes$height('3'),
					$elm$svg$Svg$Attributes$class('deliverer-over-time')
				]),
			_List_Nil);
	});
var $author$project$Duration$Duration$availableTimeView = F2(
	function (scale, time) {
		var maybeShowOver = function (list) {
			var _v0 = time.m5 < 0;
			if (_v0) {
				return _Utils_ap(
					list,
					_List_fromArray(
						[
							A2($author$project$Duration$Duration$overTimeView, scale, time)
						]));
			} else {
				return list;
			}
		};
		return A2(
			$elm$svg$Svg$g,
			_List_Nil,
			maybeShowOver(
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$rect,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$x('0'),
								$elm$svg$Svg$Attributes$y('0'),
								$elm$svg$Svg$Attributes$width(
								$elm$core$String$fromInt(
									A2($author$project$Duration$Duration$convert, scale, $author$project$Duration$Duration$availableTime))),
								$elm$svg$Svg$Attributes$height('3'),
								$elm$svg$Svg$Attributes$class('deliverer-available-time')
							]),
						_List_Nil)
					])));
	});
var $author$project$Duration$Duration$canvas = {
	iK: 31,
	g6: {k5: 5, mE: 10, nx: 10, ol: 5},
	oy: 400
};
var $author$project$Duration$Duration$SelectSegment = function (a) {
	return {$: 0, a: a};
};
var $author$project$Duration$Duration$ShowSegmentTooltip = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$svg$Svg$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$svg$Svg$Events$onMouseOut = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseout',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$svg$Svg$Events$onMouseOver = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseover',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Duration$Duration$segmentView = F3(
	function (scale, segment, color) {
		var name = $author$project$DistributionPoint$DistributionPoint$segmentInfo(segment).ft;
		var length = A2(
			$author$project$Duration$Duration$convert,
			scale,
			$author$project$Duration$Duration$ofSegment(segment));
		var id = $author$project$DistributionPoint$DistributionPoint$segmentId(segment);
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('deliverer-segment'),
					$elm$svg$Svg$Events$onClick(
					$author$project$Duration$Duration$SelectSegment(id)),
					$elm$svg$Svg$Events$onMouseOver(
					A2($author$project$Duration$Duration$ShowSegmentTooltip, true, id)),
					$elm$svg$Svg$Events$onMouseOut(
					A2($author$project$Duration$Duration$ShowSegmentTooltip, false, id)),
					$elm$svg$Svg$Attributes$style(
					'fill:' + $tesk9$palette$SolidColor$toRGBString(color))
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$rect,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$x('0'),
							$elm$svg$Svg$Attributes$y('2'),
							$elm$svg$Svg$Attributes$width(
							$elm$core$String$fromInt(length)),
							$elm$svg$Svg$Attributes$height('16')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$text_,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$x(
							$elm$core$String$fromInt((length / 2) | 0)),
							$elm$svg$Svg$Attributes$y('13'),
							$elm$svg$Svg$Attributes$textAnchor('middle')
						]),
					_List_fromArray(
						[
							$elm$svg$Svg$text(name)
						]))
				]));
	});
var $author$project$Duration$Duration$translate = F2(
	function (x, y) {
		return $elm$svg$Svg$Attributes$transform(
			'translate(' + ($elm$core$String$fromFloat(x) + (',' + ($elm$core$String$fromFloat(y) + ')'))));
	});
var $author$project$Duration$Duration$clusterView = F4(
	function (scale, duration, _v0, color) {
		var segments = _v0.bb;
		var translatedSegment = F2(
			function (startPosition, segment) {
				return A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							A2($author$project$Duration$Duration$translate, startPosition, 0)
						]),
					_List_fromArray(
						[
							A3($author$project$Duration$Duration$segmentView, scale, segment, color)
						]));
			});
		var startPositions = A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Duration$Duration$convert(scale),
				$elm$core$Basics$toFloat),
			A3(
				$elm_community$list_extra$List$Extra$scanl,
				$elm$core$Basics$add,
				0,
				A2($elm$core$List$map, $author$project$Duration$Duration$ofSegment, segments)));
		var maybeEmptyClass = function (attrs) {
			var _v2 = $elm$core$List$length(segments);
			if (!_v2) {
				return A2(
					$elm$core$List$cons,
					$elm$svg$Svg$Attributes$class('deliverer-cluster-empty'),
					attrs);
			} else {
				return attrs;
			}
		};
		var emptyRect = A2(
			$elm$svg$Svg$text_,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x('20'),
					$elm$svg$Svg$Attributes$y('15'),
					$elm$svg$Svg$Attributes$textAnchor('middle'),
					$elm$svg$Svg$Attributes$stroke('white')
				]),
			_List_fromArray(
				[
					$elm$svg$Svg$text('0')
				]));
		var clusterRect = A2(
			$elm$svg$Svg$rect,
			maybeEmptyClass(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$x('0'),
						$elm$svg$Svg$Attributes$y('0'),
						$elm$svg$Svg$Attributes$width(
						$elm$core$String$fromInt(
							A2($author$project$Duration$Duration$convert, scale, duration))),
						$elm$svg$Svg$Attributes$height('20')
					])),
			_List_Nil);
		return A2(
			$elm$svg$Svg$g,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				clusterRect,
				function () {
					var _v1 = $elm$core$List$length(segments);
					if (!_v1) {
						return _List_fromArray(
							[emptyRect]);
					} else {
						return A3($elm$core$List$map2, translatedSegment, startPositions, segments);
					}
				}()));
	});
var $elm$core$List$map4 = _List_map4;
var $author$project$Duration$Duration$TimeScale = F2(
	function (maxDuration, maxLength) {
		return {jd: maxDuration, je: maxLength};
	});
var $author$project$Duration$Duration$xScale = function (maxDuration) {
	return A2($author$project$Duration$Duration$TimeScale, maxDuration, 380);
};
var $author$project$Duration$Duration$view = F4(
	function (maxDuration, typedDeliverer, clusters, selectedClusterNumber) {
		var vb = '0 0 ' + ($elm$core$String$fromFloat($author$project$Duration$Duration$canvas.oy) + (' ' + $elm$core$String$fromFloat($author$project$Duration$Duration$canvas.iK)));
		var scale = $author$project$Duration$Duration$xScale(maxDuration);
		var isSelected = function (cluster) {
			return _Utils_eq(
				$elm$core$Maybe$Just(cluster.ll),
				selectedClusterNumber);
		};
		var durations = A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.bb;
				},
				$author$project$Duration$Duration$ofClusterWith),
			clusters);
		var open = $author$project$Duration$Duration$availableTime - $elm$core$List$sum(durations);
		var startPositions = A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Duration$Duration$convert(scale),
				$elm$core$Basics$toFloat),
			A3($elm_community$list_extra$List$Extra$scanl, $elm$core$Basics$add, 0, durations));
		var colors = A2(
			$elm$core$List$indexedMap,
			F2(
				function (i, _v2) {
					var _v3 = A2($elm$core$Basics$modBy, 2, i);
					if (!_v3) {
						return $author$project$Deliverer$Deliverer$solidColorOf(typedDeliverer);
					} else {
						return $author$project$Deliverer$Colors$alternateColor(
							$author$project$Deliverer$Deliverer$solidColorOf(typedDeliverer));
					}
				}),
			clusters);
		var clusterClass = function (cluster) {
			return $elm$svg$Svg$Attributes$class(
				'deliverer-cluster' + function () {
					var _v1 = isSelected(cluster);
					if (_v1) {
						return ' deliverer-cluster-selected';
					} else {
						return '';
					}
				}());
		};
		var translatedCluster = F4(
			function (startPostion, color, duration, cluster) {
				return A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							A2($author$project$Duration$Duration$translate, startPostion, 5),
							clusterClass(cluster)
						]),
					_List_fromArray(
						[
							A4($author$project$Duration$Duration$clusterView, scale, duration, cluster, color)
						]));
			});
		var available = function () {
			if (typedDeliverer.$ === 1) {
				return 0;
			} else {
				return $author$project$Duration$Duration$availableTime;
			}
		}();
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$viewBox(vb),
					$elm$svg$Svg$Attributes$preserveAspectRatio('xMidYMid meet'),
					$elm$svg$Svg$Attributes$width('100%'),
					$elm$svg$Svg$Attributes$height('100%')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							A2($author$project$Duration$Duration$translate, $author$project$Duration$Duration$canvas.g6.mE, $author$project$Duration$Duration$canvas.g6.ol),
							$elm$svg$Svg$Attributes$class('duration-bar')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Duration$Duration$availableTimeView,
							scale,
							{cc: available, m5: open}),
						A5($elm$core$List$map4, translatedCluster, startPositions, colors, durations, clusters)))
				]));
	});
var $author$project$Plan$DayPlanning$Supply$delivererOnlyView = F6(
	function (icon, distributionPoint, _v0, typedDeliverer, clusters, supplyItem) {
		var draggedItem = _v0.C;
		var readStatus = _v0.aP;
		var selected = _v0.nI;
		var maxDuration = _v0.jd;
		var supplyItemId = A2($elm$core$Maybe$map, $author$project$Plan$Supply$idOf, supplyItem);
		var mouseEnterLeaveAttrs = function () {
			if (!supplyItemId.$) {
				var id = supplyItemId.a;
				return _List_fromArray(
					[
						$mdgriffith$elm_ui$Element$Events$onMouseEnter(
						A2($author$project$Plan$DayPlanning$Supply$HighlightSegmentsOf, id, true)),
						$mdgriffith$elm_ui$Element$Events$onMouseLeave(
						A2($author$project$Plan$DayPlanning$Supply$HighlightSegmentsOf, id, false))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var clustersWithSegments = A2(
			$elm$core$List$map,
			function (_v10) {
				var number = _v10.bX;
				var segments = _v10.bb;
				return {
					ll: number,
					bb: A2($author$project$DistributionPoint$DistributionPoint$findSegmentsOnId, distributionPoint, segments)
				};
			},
			clusters);
		var _v1 = function () {
			var _v2 = A3($author$project$Plan$Selection$isDelivererSelected, selected, typedDeliverer, supplyItem);
			if (_v2) {
				return _Utils_Tuple2(
					$author$project$UI$Palette$base01,
					$author$project$Plan$Selection$clusterIdFrom(selected));
			} else {
				return _Utils_Tuple2($author$project$UI$Palette$base03, $elm$core$Maybe$Nothing);
			}
		}();
		var fontColor = _v1.a;
		var selectedClusterNumber = _v1.b;
		var _v3 = function () {
			switch (typedDeliverer.$) {
				case 0:
					var deliverer = typedDeliverer.a;
					return _Utils_Tuple2(
						$author$project$Deliverer$Deliverer$nameView(deliverer),
						A2(
							$elm$core$Maybe$withDefault,
							'onbekend',
							$author$project$UI$Paradise$idView(deliverer)));
				case 1:
					var id = typedDeliverer.a;
					var expiredDeliverer = typedDeliverer.b;
					if (!expiredDeliverer.$) {
						var d = expiredDeliverer.a;
						return _Utils_Tuple2(
							$author$project$Deliverer$Deliverer$nameAndIdView(d),
							'verlopen ' + A2(
								$elm$core$Maybe$withDefault,
								'',
								$author$project$UI$Paradise$idView(d)));
					} else {
						return _Utils_Tuple2(
							'ontbrekende bezorger',
							$author$project$Deliverer$Deliverer$comparableId(id));
					}
				default:
					var unregisteredDeliverer = typedDeliverer.a;
					return _Utils_Tuple2(
						$author$project$Deliverer$Deliverer$nameView(unregisteredDeliverer),
						'nog niet geregistreerd');
			}
		}();
		var delivererName = _v3.a;
		var delivererParadiseId = _v3.b;
		var _v6 = function () {
			switch (typedDeliverer.$) {
				case 0:
					return _Utils_Tuple2(
						$mdgriffith$elm_ui$Element$text(delivererName),
						$author$project$Plan$DayPlanning$Supply$supplyItemBackgroundColor);
				case 1:
					return _Utils_Tuple2(
						A2(
							$mdgriffith$elm_ui$Element$row,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$spacing(5)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$UI$Element$coloredIconFor,
									$icidasset$elm_material_icons$Material$Icons$warning(16),
									$author$project$UI$Palette$error.k0),
									$mdgriffith$elm_ui$Element$text(delivererName)
								])),
						$author$project$Plan$DayPlanning$Supply$supplyItemExpiredBackgroundColor);
				default:
					return _Utils_Tuple2(
						A2(
							$mdgriffith$elm_ui$Element$row,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$spacing(5)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$UI$Element$coloredIconFor,
									$icidasset$elm_material_icons$Material$Icons$new_releases(16),
									$author$project$UI$Palette$error.k0),
									$mdgriffith$elm_ui$Element$text(delivererName)
								])),
						$author$project$Plan$DayPlanning$Supply$supplyItemUnregisteredBackgroundColor);
			}
		}();
		var nameView = _v6.a;
		var backgroundColor = _v6.b;
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_Utils_ap(
				mouseEnterLeaveAttrs,
				_Utils_ap(
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$spacing(3),
							$mdgriffith$elm_ui$Element$Border$widthEach(
							{k5: 0, mE: 4, nx: 0, ol: 0}),
							$mdgriffith$elm_ui$Element$padding(1),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					$author$project$UI$Element$colors(
						{
							kV: function () {
								var _v8 = _Utils_Tuple2(
									supplyItem,
									_Utils_eq(
										supplyItemId,
										A2(
											$elm$core$Maybe$andThen,
											A2($elm$core$Basics$composeR, $author$project$Plan$Supply$idOf, $elm$core$Maybe$Just),
											$author$project$Plan$DayPlanning$Supply$itemOf(draggedItem))));
								if ((!_v8.a.$) && _v8.b) {
									return $author$project$UI$Palette$base1;
								} else {
									return backgroundColor;
								}
							}(),
							k0: $author$project$Deliverer$Colors$toSolidColor(
								$author$project$Deliverer$Deliverer$colorOf(typedDeliverer)),
							lZ: fontColor
						}))),
			_List_fromArray(
				[
					A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$mdgriffith$elm_ui$Element$none,
					A2(
						$elm$core$Basics$composeL,
						$author$project$Plan$Plan$onWriteable(readStatus),
						$author$project$Plan$DayPlanning$Supply$dragHandleView),
					supplyItem),
					icon,
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Events$onClick(
							A2(
								$author$project$Plan$DayPlanning$Supply$SelectDeliverer,
								typedDeliverer,
								A2($elm$core$Maybe$map, $author$project$Plan$Supply$idOf, supplyItem))),
							$mdgriffith$elm_ui$Element$pointer,
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$fillPortion(4)),
							$mdgriffith$elm_ui$Element$clip,
							$mdgriffith$elm_ui$Element$paddingEach(
							{k5: 0, mE: 4, nx: 0, ol: 0}),
							$mdgriffith$elm_ui$Element$htmlAttribute(
							$elm$html$Html$Attributes$title('Rel. Nr: ' + delivererParadiseId))
						]),
					nameView),
					$author$project$Plan$DayPlanning$Supply$mapDurationBarMsg(
					A2(
						$mdgriffith$elm_ui$Element$row,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width(
								$mdgriffith$elm_ui$Element$fillPortion(6))
							]),
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$html(
								A4($author$project$Duration$Duration$view, maxDuration, typedDeliverer, clustersWithSegments, selectedClusterNumber)),
								function () {
								if ((!supplyItem.$) && (supplyItem.a.$ === 1)) {
									var id = supplyItem.a.a.eg;
									return $author$project$Plan$DayPlanning$Supply$beaconView(
										$author$project$Plan$Supply$AppendTo(id));
								} else {
									return $mdgriffith$elm_ui$Element$none;
								}
							}()
							])))
				]));
	});
var $author$project$Plan$Selection$expandedDeliverer = F3(
	function (selection, typedDeliverer, supplyItem) {
		var _v0 = _Utils_Tuple2(
			A3($author$project$Plan$Selection$isDelivererSelected, selection, typedDeliverer, supplyItem),
			selection);
		if (_v0.a) {
			if (_v0.b.$ === 2) {
				var moveFolding = _v0.b.a.n;
				if (moveFolding.$ === 1) {
					return $elm$core$Maybe$Just(typedDeliverer);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Just(typedDeliverer);
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Plan$DayPlanning$Supply$UserClickedDeleteUnregistered = function (a) {
	return {$: 37, a: a};
};
var $author$project$Plan$DayPlanning$Supply$UserClickedNoDeleteUnregistered = {$: 38};
var $author$project$Plan$DayPlanning$Supply$UserConfirmedNoUnregisteredPotential = {$: 2};
var $author$project$Plan$DayPlanning$Supply$UserConfirmedUnregisteredPotential = function (a) {
	return {$: 3, a: a};
};
var $author$project$Plan$DayPlanning$Supply$UserSelectedUnregisteredPotential = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Plan$DayPlanning$Supply$unregisteredPotentialsView = F4(
	function (_v0, deliverer, potentials, supplyItem) {
		var selectedUnregisteredPotential = _v0.bz;
		var selected = A2($author$project$Deliverer$IdDict$get, deliverer.eg, selectedUnregisteredPotential);
		var options = A2(
			$elm$core$List$map,
			function (d) {
				return A2(
					$mdgriffith$elm_ui$Element$Input$option,
					d.eg,
					$mdgriffith$elm_ui$Element$text(
						$author$project$Deliverer$Deliverer$nameAndIdView(d)));
			},
			A2($elm$core$List$sortBy, $author$project$Sorting$Deliverers$byName, potentials));
		var deleteButton = function () {
			if (!supplyItem.$) {
				return $author$project$UI$Button$elementFor(
					A2(
						$author$project$UI$Button$withRole,
						1,
						A2(
							$author$project$UI$Button$disabled,
							'Bezorger heeft een cluster',
							A2($author$project$UI$Button$button, $author$project$Plan$DayPlanning$Supply$UserClickedNoDeleteUnregistered, 'Verwijderen'))));
			} else {
				return $author$project$UI$Button$elementFor(
					A2(
						$author$project$UI$Button$withRole,
						1,
						A2(
							$author$project$UI$Button$button,
							$author$project$Plan$DayPlanning$Supply$UserClickedDeleteUnregistered(deliverer),
							'Verwijderen')));
			}
		}();
		var confirmButton = function () {
			if (!selected.$) {
				return $author$project$UI$Button$elementFor(
					A2(
						$author$project$UI$Button$withRole,
						0,
						A2(
							$author$project$UI$Button$button,
							$author$project$Plan$DayPlanning$Supply$UserConfirmedUnregisteredPotential(deliverer.eg),
							'Bevestig')));
			} else {
				return $author$project$UI$Button$elementFor(
					A2(
						$author$project$UI$Button$withRole,
						0,
						A2(
							$author$project$UI$Button$disabled,
							'Kies een bezorger',
							A2($author$project$UI$Button$button, $author$project$Plan$DayPlanning$Supply$UserConfirmedNoUnregisteredPotential, 'Bevestig'))));
			}
		}();
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					A2($mdgriffith$elm_ui$Element$paddingXY, 60, 5),
					$mdgriffith$elm_ui$Element$spacing(20),
					$mdgriffith$elm_ui$Element$Background$color(
					$author$project$UI$Element$colorFor($author$project$Plan$DayPlanning$Supply$supplyItemUnregisteredBackgroundColor))
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$Input$radio,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$spacing(5),
							$mdgriffith$elm_ui$Element$padding(2)
						]),
					{
						mD: A2(
							$mdgriffith$elm_ui$Element$Input$labelAbove,
							_List_Nil,
							$mdgriffith$elm_ui$Element$text('Welke bezorger is dit?')),
						mY: $author$project$Plan$DayPlanning$Supply$UserSelectedUnregisteredPotential(deliverer.eg),
						m7: options,
						nI: selected
					}),
					confirmButton,
					deleteButton
				]));
	});
var $author$project$Plan$DayPlanning$Supply$delivererView = F8(
	function (icon, distributionPoint, planInfo, parentSupplyItemId, typedDeliverer, clusters, supplyItem, preSupply) {
		var selectedCluster = A3(
			$elm$core$Maybe$map2,
			$elm$core$Tuple$pair,
			supplyItem,
			$author$project$Plan$Selection$clusterIdFrom(planInfo.nI));
		var _v0 = A3($author$project$Plan$Selection$expandedDeliverer, planInfo.nI, typedDeliverer, supplyItem);
		if (!_v0.$) {
			if ((_v0.a.$ === 2) && _v0.a.b.b) {
				var _v1 = _v0.a;
				var deliverer = _v1.a;
				var potentials = _v1.b;
				return A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					_List_fromArray(
						[
							A6($author$project$Plan$DayPlanning$Supply$delivererOnlyView, icon, distributionPoint, planInfo, typedDeliverer, clusters, supplyItem),
							A4($author$project$Plan$DayPlanning$Supply$unregisteredPotentialsView, planInfo, deliverer, potentials, supplyItem),
							A7($author$project$Plan$DayPlanning$Supply$delivererCardView, distributionPoint, selectedCluster, planInfo, parentSupplyItemId, clusters, typedDeliverer, preSupply)
						]));
			} else {
				return A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					_List_fromArray(
						[
							A6($author$project$Plan$DayPlanning$Supply$delivererOnlyView, icon, distributionPoint, planInfo, typedDeliverer, clusters, supplyItem),
							A7($author$project$Plan$DayPlanning$Supply$delivererCardView, distributionPoint, selectedCluster, planInfo, parentSupplyItemId, clusters, typedDeliverer, preSupply)
						]));
			}
		} else {
			return A6($author$project$Plan$DayPlanning$Supply$delivererOnlyView, icon, distributionPoint, planInfo, typedDeliverer, clusters, supplyItem);
		}
	});
var $author$project$Plan$DayPlanning$Supply$dragInfoOf = function (draggedItem) {
	var _v0 = _Utils_Tuple2(
		draggedItem,
		$author$project$Plan$DayPlanning$Supply$itemOf(draggedItem));
	_v0$2:
	while (true) {
		if (!_v0.b.$) {
			switch (_v0.a.$) {
				case 1:
					var cursorOnScreen = _v0.a.a.aG;
					var cursorOnDraggable = _v0.a.a.aF;
					var item = _v0.b.a;
					return $elm$core$Maybe$Just(
						{H: $elm$core$Maybe$Nothing, aF: cursorOnDraggable, aG: cursorOnScreen, gK: item});
				case 2:
					var cursorOnScreen = _v0.a.a.aG;
					var cursorOnDraggable = _v0.a.a.aF;
					var cluster = _v0.a.a.H;
					var item = _v0.b.a;
					return $elm$core$Maybe$Just(
						{
							H: $elm$core$Maybe$Just(cluster.bX),
							aF: cursorOnDraggable,
							aG: cursorOnScreen,
							gK: item
						});
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Plan$DayPlanning$Supply$SelectSubDistributionPoint = function (a) {
	return {$: 23, a: a};
};
var $icidasset$elm_material_icons$Material$Icons$gite = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$b('new 0 0 24 24'),
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$rect,
			_List_fromArray(
				[
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M18,6H9V4H7v2H6l-4,4v9h20v-9L18,6z M4,12h10v5H4V12z M20,17h-4v-6.17l2-2v0l2,2V17z')
				]),
			_List_Nil)
		]));
var $author$project$Plan$Selection$isSupplyItemSelected = F2(
	function (selection, id) {
		switch (selection.$) {
			case 0:
				return false;
			case 1:
				var deliverer = selection.a.bl;
				return false;
			case 2:
				var deliverer = selection.a.bl;
				var supplyItemId = selection.a.dF;
				return _Utils_eq(supplyItemId, id);
			default:
				var supplyItemId = selection.a.dF;
				return _Utils_eq(supplyItemId, id);
		}
	});
var $author$project$DistributionPoint$DistributionPoint$addressView = function (_v0) {
	var address = _v0.f1;
	return $author$project$UI$Text$elementFor(
		A2(
			$author$project$UI$Text$withLabel,
			'Adres',
			$author$project$UI$Text$text(
				$author$project$Address$Address$oneLineView(address))));
};
var $author$project$DistributionPoint$DistributionPoint$infoView = function (distributionPoint) {
	return $author$project$UI$Container$elementFor(
		A2(
			$author$project$UI$Container$withContent,
			_List_fromArray(
				[
					$author$project$DistributionPoint$DistributionPoint$addressView(distributionPoint)
				]),
			$author$project$UI$Container$withoutBorder($author$project$UI$Container$container)));
};
var $author$project$Plan$DayPlanning$Supply$subDistributionPointCardView = F4(
	function (dp, planInfo, subDp, preSupply) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$paddingEach(
					{k5: 15, mE: 25, nx: 25, ol: 5}),
					$mdgriffith$elm_ui$Element$spacing(5),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$Border$widthEach(
					{k5: 2, mE: 0, nx: 0, ol: 0}),
					$mdgriffith$elm_ui$Element$Border$color(
					$author$project$UI$Element$colorFor($author$project$UI$Palette$base0))
				]),
			$elm_community$maybe_extra$Maybe$Extra$values(
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						$author$project$DistributionPoint$DistributionPoint$infoView(subDp)),
						function () {
						var _v0 = planInfo.ni;
						if (!_v0.$) {
							return $elm$core$Maybe$Just(
								A3($author$project$Plan$DayPlanning$Supply$cardPreSupplyView, dp, planInfo, preSupply));
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}()
					])));
	});
var $author$project$Plan$DayPlanning$Supply$subDistributionPointView = F5(
	function (distributionPoint, planInfo, subDpId, item, preSupply) {
		var readStatus = planInfo.aP;
		var selected = planInfo.nI;
		var id = $author$project$Plan$Supply$idOf(item);
		var _v0 = A2(
			$elm_community$list_extra$List$Extra$find,
			function (_v1) {
				var dp = _v1;
				return _Utils_eq(dp.eg, subDpId);
			},
			$author$project$DistributionPoint$DistributionPoint$getSubDistributionPoints(distributionPoint));
		if (_v0.$ === 1) {
			return $mdgriffith$elm_ui$Element$none;
		} else {
			var subDp = _v0.a;
			var fontColor = A2($author$project$Plan$Selection$isSupplyItemSelected, selected, id) ? $author$project$UI$Palette$base01 : $author$project$UI$Palette$base03;
			return function (l) {
				if (!l.b) {
					return $mdgriffith$elm_ui$Element$none;
				} else {
					if (!l.b.b) {
						var head = l.a;
						return head;
					} else {
						return A2(
							$mdgriffith$elm_ui$Element$column,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
								]),
							l);
					}
				}
			}(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					A2(
						$elm$core$List$cons,
						$elm$core$Maybe$Just(
							A2(
								$mdgriffith$elm_ui$Element$row,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$Events$onClick(
										$author$project$Plan$DayPlanning$Supply$SelectSubDistributionPoint(id)),
										$mdgriffith$elm_ui$Element$pointer,
										$mdgriffith$elm_ui$Element$spacing(5),
										$mdgriffith$elm_ui$Element$paddingEach(
										{k5: 4, mE: 8, nx: 0, ol: 4}),
										$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
										$mdgriffith$elm_ui$Element$Background$color(
										$author$project$UI$Element$colorFor($author$project$Plan$DayPlanning$Supply$supplyItemBackgroundColor)),
										$mdgriffith$elm_ui$Element$Font$color(
										$author$project$UI$Element$colorFor(fontColor))
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Plan$Plan$onWriteable,
										readStatus,
										$author$project$Plan$DayPlanning$Supply$dragHandleView(item)),
										$author$project$UI$Element$iconFor(
										$icidasset$elm_material_icons$Material$Icons$gite(16)),
										$mdgriffith$elm_ui$Element$text(
										$author$project$DistributionPoint$DistributionPoint$nameOf(subDp))
									]))),
						A2(
							$elm$core$List$cons,
							function () {
								if (selected.$ === 3) {
									var selection = selected.a;
									var supplyItemId = selection.dF;
									var folding = selection.ff;
									return ((folding === 1) && _Utils_eq(selection.dF, id)) ? $elm$core$Maybe$Just(
										A4($author$project$Plan$DayPlanning$Supply$subDistributionPointCardView, distributionPoint, planInfo, subDp, preSupply)) : $elm$core$Maybe$Nothing;
								} else {
									return $elm$core$Maybe$Nothing;
								}
							}(),
							_List_Nil))));
		}
	});
var $author$project$Plan$DayPlanning$Supply$ghostSupplyItemView = F3(
	function (distributionPoint, planInfo, draggedItem) {
		var _v0 = $author$project$Plan$DayPlanning$Supply$dragInfoOf(draggedItem);
		if (!_v0.$) {
			var item = _v0.a.gK;
			var cluster = _v0.a.H;
			var cursorOnScreen = _v0.a.aG;
			var cursorOnDraggable = _v0.a.aF;
			return A2(
				$mdgriffith$elm_ui$Element$el,
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$alpha(0.4),
					A2(
						$elm$core$List$map,
						$mdgriffith$elm_ui$Element$htmlAttribute,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'position', 'fixed'),
								A2(
								$elm$html$Html$Attributes$style,
								'top',
								$elm$core$String$fromFloat(cursorOnScreen.bg - cursorOnDraggable.bg) + 'px'),
								A2(
								$elm$html$Html$Attributes$style,
								'left',
								$elm$core$String$fromFloat(cursorOnScreen.ay - cursorOnDraggable.ay) + 'px')
							]))),
				function () {
					switch (item.$) {
						case 0:
							var car = item.a;
							return A8(
								$author$project$Plan$DayPlanning$Supply$delivererView,
								$mdgriffith$elm_ui$Element$none,
								distributionPoint,
								planInfo,
								$elm$core$Maybe$Nothing,
								car.bl,
								_List_fromArray(
									[car.H]),
								$elm$core$Maybe$Just(item),
								car.ni);
						case 1:
							var bike = item.a;
							var _v2 = A2(
								$elm$core$Maybe$andThen,
								function (n) {
									return A2($author$project$Plan$Supply$findClusterIn, n, item);
								},
								cluster);
							if (!_v2.$) {
								var c = _v2.a;
								return A8(
									$author$project$Plan$DayPlanning$Supply$delivererView,
									$mdgriffith$elm_ui$Element$none,
									distributionPoint,
									planInfo,
									$elm$core$Maybe$Nothing,
									bike.bl,
									_List_fromArray(
										[c]),
									$elm$core$Maybe$Just(item),
									bike.ni);
							} else {
								return A8(
									$author$project$Plan$DayPlanning$Supply$delivererView,
									$mdgriffith$elm_ui$Element$none,
									distributionPoint,
									planInfo,
									$elm$core$Maybe$Nothing,
									bike.bl,
									bike.k,
									$elm$core$Maybe$Just(item),
									bike.ni);
							}
						default:
							var subDP = item.a;
							return A5($author$project$Plan$DayPlanning$Supply$subDistributionPointView, distributionPoint, planInfo, subDP.lK, item, subDP.ni);
					}
				}());
		} else {
			return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$Plan$DayPlanning$Supply$UserChangedReserveFolding = {$: 6};
var $author$project$Plan$DayPlanning$Supply$sortByTypedDelivererNameUnregisteredFirst = function (typedDeliverer) {
	switch (typedDeliverer.$) {
		case 0:
			var deliverer = typedDeliverer.a;
			return _Utils_Tuple2(
				2,
				$author$project$Sorting$Deliverers$byName(deliverer));
		case 1:
			var deliverer = typedDeliverer.b;
			if (!deliverer.$) {
				var d = deliverer.a;
				return _Utils_Tuple2(
					0,
					$author$project$Sorting$Deliverers$byName(d));
			} else {
				return _Utils_Tuple2(
					3,
					_Utils_Tuple2('', ''));
			}
		default:
			var deliverer = typedDeliverer.a;
			return _Utils_Tuple2(
				1,
				$author$project$Sorting$Deliverers$byName(deliverer));
	}
};
var $author$project$Plan$DayPlanning$Supply$spareDeliverersId = 'spare-deliverers';
var $author$project$Plan$DayPlanning$Supply$supplyBackgroundColor = $author$project$UI$Palette$base2;
var $author$project$Plan$DayPlanning$Supply$reserveSupplyView = F5(
	function (window, distributionPoint, reserveDeliverers, planInfo, folding) {
		var title = function (icon) {
			return A4(
				$author$project$Plan$DayPlanning$Supply$supplyTitle,
				$author$project$UI$Palette$base03,
				'Reservelijst',
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$Events$onClick($author$project$Plan$DayPlanning$Supply$UserChangedReserveFolding),
						$mdgriffith$elm_ui$Element$pointer
					]),
				A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$alignRight]),
					icon));
		};
		var sortedDeliverers = A2(
			$elm$core$List$sortBy,
			$author$project$Plan$DayPlanning$Supply$sortByTypedDelivererNameUnregisteredFirst,
			$Gizra$elm_all_set$EverySet$toList(reserveDeliverers));
		var _v0 = _Utils_Tuple2(
			$elm$core$List$isEmpty(sortedDeliverers),
			folding);
		if (_v0.a) {
			return $mdgriffith$elm_ui$Element$none;
		} else {
			if (!_v0.b) {
				var _v1 = _v0.b;
				return title(
					A2(
						$author$project$UI$Element$coloredIconFor,
						$icidasset$elm_material_icons$Material$Icons$unfold_more(16),
						$author$project$UI$Palette$base2));
			} else {
				var _v2 = _v0.b;
				return A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Background$color(
							$author$project$UI$Element$colorFor($author$project$Plan$DayPlanning$Supply$supplyBackgroundColor)),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$height(
							$mdgriffith$elm_ui$Element$px(window.iK)),
							$mdgriffith$elm_ui$Element$alignBottom
						]),
					_List_fromArray(
						[
							title(
							A2(
								$author$project$UI$Element$coloredIconFor,
								$icidasset$elm_material_icons$Material$Icons$unfold_less(16),
								$author$project$UI$Palette$base2)),
							A2(
							$mdgriffith$elm_ui$Element$column,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Background$color(
									$author$project$UI$Element$colorFor($author$project$Plan$DayPlanning$Supply$supplyBackgroundColor)),
									$mdgriffith$elm_ui$Element$spacing(2),
									A2($mdgriffith$elm_ui$Element$paddingXY, 0, 2),
									$mdgriffith$elm_ui$Element$scrollbarY,
									$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									$mdgriffith$elm_ui$Element$htmlAttribute(
									$elm$html$Html$Attributes$id($author$project$Plan$DayPlanning$Supply$spareDeliverersId))
								]),
							A2(
								$elm$core$List$map,
								function (d) {
									return A8($author$project$Plan$DayPlanning$Supply$delivererView, $mdgriffith$elm_ui$Element$none, distributionPoint, planInfo, $elm$core$Maybe$Nothing, d, _List_Nil, $elm$core$Maybe$Nothing, $author$project$Plan$Supply$NotPreSupplied);
								},
								sortedDeliverers))
						]));
			}
		}
	});
var $author$project$Plan$DayPlanning$Supply$UserClickedAddDeliverer = {$: 0};
var $author$project$Plan$Supply$idToInt = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$Plan$Supply$keyOf = function (item) {
	return $elm$core$String$fromInt(
		$author$project$Plan$Supply$idToInt(
			$author$project$Plan$Supply$idOf(item)));
};
var $author$project$Plan$DayPlanning$Supply$rideView = F4(
	function (distributionPoint, planInfo, _v1, attrs) {
		var item = _v1.gK;
		var deliverer = _v1.bl;
		var cluster = _v1.H;
		var supplies = _v1.n0;
		var preSupply = _v1.ni;
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_Utils_ap(
				attrs,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$Background$color(
						$author$project$UI$Element$colorFor($author$project$Plan$DayPlanning$Supply$supplyBackgroundColor)),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$Border$color(
						$author$project$UI$Element$colorFor($author$project$UI$Palette$base0)),
						$mdgriffith$elm_ui$Element$Border$width(1),
						$mdgriffith$elm_ui$Element$spacing(2)
					])),
			_List_fromArray(
				[
					A8(
					$author$project$Plan$DayPlanning$Supply$delivererView,
					$author$project$UI$Element$iconFor(
						$icidasset$elm_material_icons$Material$Icons$directions_car(16)),
					distributionPoint,
					planInfo,
					$elm$core$Maybe$Nothing,
					deliverer,
					_List_fromArray(
						[cluster]),
					$elm$core$Maybe$Just(item),
					preSupply),
					function () {
					if (!supplies.b) {
						return A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									A2($mdgriffith$elm_ui$Element$paddingXY, 15, 0)
								]),
							$author$project$Plan$DayPlanning$Supply$beaconView(
								$author$project$Plan$Supply$AppendedIn(
									$author$project$Plan$Supply$idOf(item))));
					} else {
						return A2(
							$mdgriffith$elm_ui$Element$row,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
								]),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$width(
											$mdgriffith$elm_ui$Element$px(15)),
											$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
										]),
									$mdgriffith$elm_ui$Element$none),
									A2(
									$mdgriffith$elm_ui$Element$Keyed$column,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
											$mdgriffith$elm_ui$Element$spacing(2)
										]),
									A2(
										$elm$core$List$map,
										A3(
											$author$project$Plan$DayPlanning$Supply$supplyItemView,
											distributionPoint,
											planInfo,
											$elm$core$Maybe$Just(
												$author$project$Plan$Supply$idOf(item))),
										supplies))
								]));
					}
				}()
				]));
	});
var $author$project$Plan$DayPlanning$Supply$supplyItemView = F4(
	function (distributionPoint, planInfo, parentSupplyItem, supplyItem) {
		return A2(
			$elm$core$Tuple$pair,
			$author$project$Plan$Supply$keyOf(supplyItem),
			function () {
				switch (supplyItem.$) {
					case 0:
						var id = supplyItem.a.eg;
						var deliverer = supplyItem.a.bl;
						var cluster = supplyItem.a.H;
						var supplies = supplyItem.a.n0;
						var preSupply = supplyItem.a.ni;
						return A2(
							$mdgriffith$elm_ui$Element$column,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
								]),
							_List_fromArray(
								[
									$author$project$Plan$DayPlanning$Supply$beaconView(
									$author$project$Plan$Supply$Before(id)),
									A4(
									$author$project$Plan$DayPlanning$Supply$rideView,
									distributionPoint,
									planInfo,
									{H: cluster, bl: deliverer, gK: supplyItem, ni: preSupply, n0: supplies},
									_List_Nil),
									$author$project$Plan$DayPlanning$Supply$beaconView(
									$author$project$Plan$Supply$After(id))
								]));
					case 1:
						var id = supplyItem.a.eg;
						var deliverer = supplyItem.a.bl;
						var clusters = supplyItem.a.k;
						var preSupply = supplyItem.a.ni;
						return A2(
							$mdgriffith$elm_ui$Element$column,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
								]),
							_List_fromArray(
								[
									$author$project$Plan$DayPlanning$Supply$beaconView(
									$author$project$Plan$Supply$Before(id)),
									A8(
									$author$project$Plan$DayPlanning$Supply$delivererView,
									$mdgriffith$elm_ui$Element$none,
									distributionPoint,
									planInfo,
									parentSupplyItem,
									deliverer,
									clusters,
									$elm$core$Maybe$Just(supplyItem),
									preSupply),
									$author$project$Plan$DayPlanning$Supply$beaconView(
									$author$project$Plan$Supply$After(id))
								]));
					default:
						var id = supplyItem.a.eg;
						var dpId = supplyItem.a.lK;
						var preSupply = supplyItem.a.ni;
						return A2(
							$mdgriffith$elm_ui$Element$column,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
								]),
							_List_fromArray(
								[
									$author$project$Plan$DayPlanning$Supply$beaconView(
									$author$project$Plan$Supply$Before(id)),
									A5($author$project$Plan$DayPlanning$Supply$subDistributionPointView, distributionPoint, planInfo, dpId, supplyItem, preSupply),
									$author$project$Plan$DayPlanning$Supply$beaconView(
									$author$project$Plan$Supply$After(id))
								]));
				}
			}());
	});
var $author$project$Plan$DayPlanning$Supply$supplyItemsView = F3(
	function (dp, planInfo, items) {
		var beaconTop = A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Font$size(0),
					$mdgriffith$elm_ui$Element$htmlAttribute(
					A2($elm$html$Html$Attributes$attribute, 'scroll-beacon', 'top'))
				]),
			$mdgriffith$elm_ui$Element$none);
		var beaconBottom = A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Font$size(0),
					$mdgriffith$elm_ui$Element$htmlAttribute(
					A2($elm$html$Html$Attributes$attribute, 'scroll-beacon', 'bottom'))
				]),
			$mdgriffith$elm_ui$Element$none);
		var addDelivererButton = A2(
			$mdgriffith$elm_ui$Element$Input$button,
			_List_fromArray(
				[$mdgriffith$elm_ui$Element$alignRight]),
			{
				mD: A2(
					$author$project$UI$Element$coloredIconFor,
					$icidasset$elm_material_icons$Material$Icons$add(16),
					$author$project$UI$Palette$base2),
				jp: $elm$core$Maybe$Just($author$project$Plan$DayPlanning$Supply$UserClickedAddDeliverer)
			});
		return A2(
			$mdgriffith$elm_ui$Element$Keyed$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$height(
					$mdgriffith$elm_ui$Element$fillPortion(2)),
					$mdgriffith$elm_ui$Element$spacing(3)
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'active-deliverers-title',
					A4($author$project$Plan$DayPlanning$Supply$supplyTitle, $author$project$UI$Palette$base03, 'Actieve bezorgers', _List_Nil, addDelivererButton)),
					_Utils_Tuple2('active-deliverers-top', beaconTop),
					_Utils_Tuple2(
					'active-deliverers-items',
					A2(
						$mdgriffith$elm_ui$Element$Keyed$column,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$spacing(3),
								$mdgriffith$elm_ui$Element$scrollbarY,
								$mdgriffith$elm_ui$Element$htmlAttribute(
								$elm$html$Html$Attributes$id($author$project$Plan$DayPlanning$Supply$supplyItemsId)),
								$mdgriffith$elm_ui$Element$htmlAttribute(
								A2($elm$html$Html$Attributes$style, 'overflow-anchor', 'none'))
							]),
						A2(
							$elm$core$List$map,
							A3($author$project$Plan$DayPlanning$Supply$supplyItemView, dp, planInfo, $elm$core$Maybe$Nothing),
							items))),
					_Utils_Tuple2('active-deliverers-bottom', beaconBottom)
				]));
	});
var $pzp1997$assoc_list$AssocList$union = F2(
	function (_v0, rightDict) {
		var leftAlist = _v0;
		return A3(
			$elm$core$List$foldr,
			F2(
				function (_v1, result) {
					var lKey = _v1.a;
					var lValue = _v1.b;
					return A3($pzp1997$assoc_list$AssocList$insert, lKey, lValue, result);
				}),
			rightDict,
			leftAlist);
	});
var $Gizra$elm_all_set$EverySet$union = F2(
	function (_v0, _v1) {
		var d1 = _v0;
		var d2 = _v1;
		return A2($pzp1997$assoc_list$AssocList$union, d1, d2);
	});
var $author$project$Plan$DayPlanning$Supply$view = F6(
	function (window, model, date, distributionPoint, plan, passive) {
		var planInfo = {
			f4: A2(
				$Gizra$elm_all_set$EverySet$union,
				passive,
				$author$project$Plan$Supply$allDeliverersOf(plan.gL)),
			lx: date,
			C: model.C,
			jd: A2($author$project$Duration$Duration$calcMaxDuration, distributionPoint, plan.gL),
			ni: plan.ni,
			aP: $author$project$Plan$Plan$toReadStatus(plan.nS),
			nI: model.nI,
			bz: model.bz
		};
		var ghostItem = A3($author$project$Plan$DayPlanning$Supply$ghostSupplyItemView, distributionPoint, planInfo, model.C);
		var _delete = function () {
			var _v0 = model.ax;
			if (_v0.$ === 1) {
				var deliverer = _v0.a;
				return A2(
					$author$project$Plan$DayPlanning$Supply$deleteDialogView,
					deliverer.eg,
					A2(
						$elm$core$String$join,
						' ',
						_List_fromArray(
							[
								'Weet u zeker dat u de tijdelijke bezorger',
								$author$project$Deliverer$Deliverer$nameView(deliverer),
								'wilt verwijderen?'
							])));
			} else {
				return $mdgriffith$elm_ui$Element$none;
			}
		}();
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_Utils_ap(
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$height(
						$mdgriffith$elm_ui$Element$px(window.iK)),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$inFront(ghostItem),
						$mdgriffith$elm_ui$Element$spacing(3),
						$mdgriffith$elm_ui$Element$inFront(_delete)
					]),
				$author$project$Style$Style$noTextSelection),
			_List_fromArray(
				[
					A7($author$project$Plan$DayPlanning$Supply$detailView, distributionPoint, planInfo.f4, planInfo.aP, model.lD, plan.ni, plan.kT, plan.ms),
					A3($author$project$Plan$DayPlanning$Supply$supplyItemsView, distributionPoint, planInfo, plan.gL),
					A5(
					$author$project$Plan$DayPlanning$Supply$reserveSupplyView,
					_Utils_update(
						window,
						{iK: (window.iK / 3) | 0}),
					distributionPoint,
					passive,
					planInfo,
					model.dt)
				]));
	});
var $author$project$Plan$DayPlanning$view = F2(
	function (share, model) {
		var window = A2(
			$author$project$UI$Window$reducedHeight,
			8 * $author$project$Plan$DayPlanning$contentPadding,
			$author$project$Portal$Page$contentWindow(share));
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(
				model.bn,
				$author$project$Plan$PlanLoader$loadedOf(model.fB));
			if (_v1.a.$ === 1) {
				if (!_v1.b.$) {
					var distributionPoint = _v1.a.a;
					var plan = _v1.b.a.fA;
					var deliverers = _v1.b.a.e4;
					var passive = A2($author$project$Plan$Plan$deliverersNotInPlan, plan, deliverers);
					return _Utils_Tuple2(
						A6($author$project$Plan$DayPlanning$Supply$view, window, model.z, model.lx, distributionPoint, plan, passive),
						A8(
							$author$project$Plan$DayPlanning$Demand$view,
							window,
							distributionPoint,
							$elm$core$Maybe$Just(plan.gL),
							$author$project$Plan$DayPlanning$toOrders(model.Y),
							model.de,
							model.dc,
							$author$project$UI$LeafletMap$All,
							true));
				} else {
					var distributionPoint = _v1.a.a;
					var _v2 = _v1.b;
					return _Utils_Tuple2(
						$mdgriffith$elm_ui$Element$none,
						A8(
							$author$project$Plan$DayPlanning$Demand$view,
							window,
							distributionPoint,
							$elm$core$Maybe$Nothing,
							$author$project$Plan$DayPlanning$toOrders(model.Y),
							model.de,
							model.dc,
							$author$project$UI$LeafletMap$All,
							true));
				}
			} else {
				return _Utils_Tuple2($mdgriffith$elm_ui$Element$none, $mdgriffith$elm_ui$Element$none);
			}
		}();
		var supply = _v0.a;
		var demand = _v0.b;
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$padding($author$project$Plan$DayPlanning$contentPadding),
					$mdgriffith$elm_ui$Element$spacing(5),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$fillPortion(1)),
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
						]),
					A2($mdgriffith$elm_ui$Element$map, $author$project$Plan$DayPlanning$GotSupplyMsg, supply)),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$fillPortion(2))
						]),
					A2($mdgriffith$elm_ui$Element$map, $author$project$Plan$DayPlanning$GotDemandMsg, demand))
				]));
	});
var $author$project$Plan$NotFinalized$nonFinalizedPlanView = F2(
	function (dpName, dates) {
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$paragraph,
						_List_Nil,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text(
								A2(
									$elm$core$String$join,
									', ',
									A2($elm$core$List$map, $author$project$Date$DeliveryDate$view, dates)))
							]))
					]),
				A2(
					$author$project$UI$Container$withTitle,
					$mdgriffith$elm_ui$Element$text(dpName),
					$author$project$UI$Container$container)));
	});
var $author$project$Plan$NotFinalized$nonFinalizedPlansView = F2(
	function (distributionPoints, nonFinalizedPlans) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$spacing(10),
					$mdgriffith$elm_ui$Element$width(
					A2(
						$mdgriffith$elm_ui$Element$maximum,
						750,
						A2($mdgriffith$elm_ui$Element$minimum, 500, $mdgriffith$elm_ui$Element$fill)))
				]),
			A2(
				$elm$core$List$filterMap,
				function (_v0) {
					var id = _v0.eg;
					var name = _v0.ft;
					var _v1 = A2($author$project$DistributionPoint$IdDict$get, id, nonFinalizedPlans);
					if (!_v1.$) {
						var dates = _v1.a;
						return $elm$core$Maybe$Just(
							A2($author$project$Plan$NotFinalized$nonFinalizedPlanView, name, dates));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				A2(
					$elm$core$List$sortBy,
					function ($) {
						return $.ft;
					},
					distributionPoints)));
	});
var $author$project$Plan$NotFinalized$EndDate = 1;
var $author$project$Plan$NotFinalized$StartDate = 0;
var $author$project$Plan$NotFinalized$UserChangedSearchFormValue = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Plan$NotFinalized$UserSubmittedSearchForm = {$: 1};
var $author$project$Plan$NotFinalized$searchFormErrorView = function (error) {
	switch (error) {
		case 0:
			return A2(
				$mdgriffith$elm_ui$Element$paragraph,
				_List_Nil,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$text('Begindatum is verplicht')
					]));
		case 1:
			return A2(
				$mdgriffith$elm_ui$Element$paragraph,
				_List_Nil,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$text('Einddatum is verplicht')
					]));
		default:
			return A2(
				$mdgriffith$elm_ui$Element$paragraph,
				_List_Nil,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$text('Einddatum moet na begindatum liggen')
					]));
	}
};
var $author$project$Plan$NotFinalized$searchFormErrorsView = function (errors) {
	var _v0 = $elm$core$List$length(errors);
	if (!_v0) {
		return $mdgriffith$elm_ui$Element$none;
	} else {
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				A2($elm$core$List$map, $author$project$Plan$NotFinalized$searchFormErrorView, errors),
				A2($author$project$UI$Container$withVariant, 2, $author$project$UI$Container$container)));
	}
};
var $author$project$Plan$NotFinalized$searchFormView = function (searchForm) {
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$spacing(10)
			]),
		_List_fromArray(
			[
				$author$project$Plan$NotFinalized$searchFormErrorsView(searchForm.f_),
				$author$project$UI$Input$row(
				_List_fromArray(
					[
						A2(
						$author$project$UI$Input$date,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width(
								$mdgriffith$elm_ui$Element$px(180))
							]),
						{
							mD: $author$project$UI$Input$label('Van'),
							mY: $author$project$Plan$NotFinalized$UserChangedSearchFormValue(0),
							ng: $elm$core$Maybe$Nothing,
							n3: searchForm.hq
						})
					])),
				$author$project$UI$Input$row(
				_List_fromArray(
					[
						A2(
						$author$project$UI$Input$date,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width(
								$mdgriffith$elm_ui$Element$px(180))
							]),
						{
							mD: $author$project$UI$Input$label('Tot en met'),
							mY: $author$project$Plan$NotFinalized$UserChangedSearchFormValue(1),
							ng: $elm$core$Maybe$Nothing,
							n3: searchForm.gu
						})
					])),
				$author$project$UI$Button$elementFor(
				A2(
					$author$project$UI$Button$withRole,
					0,
					A2($author$project$UI$Button$button, $author$project$Plan$NotFinalized$UserSubmittedSearchForm, 'Opvragen')))
			]));
};
var $author$project$Plan$NotFinalized$view = function (model) {
	return A2(
		$mdgriffith$elm_ui$Element$wrappedRow,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$centerX,
				$mdgriffith$elm_ui$Element$alignTop,
				$mdgriffith$elm_ui$Element$spacing(15),
				$mdgriffith$elm_ui$Element$padding(2)
			]),
		_List_fromArray(
			[
				$author$project$Plan$NotFinalized$searchFormView(model.aj),
				function () {
				var _v0 = _Utils_Tuple2(model.A, model.cs);
				if ((_v0.a.$ === 1) && (_v0.b.$ === 1)) {
					var d = _v0.a.a;
					var nonFinalizedPlans = _v0.b.a;
					return A2($author$project$Plan$NotFinalized$nonFinalizedPlansView, d, nonFinalizedPlans);
				} else {
					return $mdgriffith$elm_ui$Element$none;
				}
			}()
			]));
};
var $author$project$Publications$ClosingCalendar$UserClickedAddException = {$: 2};
var $author$project$Publications$ClosingCalendar$UserClickedEditException = function (a) {
	return {$: 3, a: a};
};
var $author$project$Publications$ClosingCalendar$UserClickedRemoveException = function (a) {
	return {$: 15, a: a};
};
var $author$project$Publications$ClosingCalendar$scopeView = function (scope) {
	switch (scope.$) {
		case 0:
			var e = scope.a;
			return 'Editie: ' + e;
		case 1:
			return 'NL Edities';
		default:
			return 'BE Edities';
	}
};
var $author$project$Publications$ClosingCalendar$updatesInDateView = F2(
	function (day, daysBefore) {
		return $author$project$Date$DeliveryDate$view(
			$author$project$Date$DeliveryDate$fromDate(
				A3(
					$justinmimbs$date$Date$add,
					3,
					daysBefore * (-1),
					$author$project$Date$DeliveryDate$toDate(day))));
	});
var $author$project$Publications$ClosingCalendar$updatesInView = F2(
	function (date, updatesIn) {
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_List_Nil,
			$mdgriffith$elm_ui$Element$text(
				A2($author$project$Publications$ClosingCalendar$updatesInDateView, date, updatesIn.aH) + (' ' + function () {
					var _v0 = updatesIn.by;
					switch (_v0.$) {
						case 0:
							return '- run 1';
						case 1:
							return '- run 2';
						case 2:
							return '- run 3';
						default:
							var hours = _v0.a;
							var minutes = _v0.b;
							return A3(
								$elm$core$String$padLeft,
								2,
								'0',
								$elm$core$String$fromInt(hours)) + (':' + A3(
								$elm$core$String$padLeft,
								2,
								'0',
								$elm$core$String$fromInt(minutes)));
					}
				}())));
	});
var $author$project$Publications$ClosingCalendar$exceptionView = F3(
	function (share, selectedException, exception) {
		var withWaiting = function (button) {
			return A3(
				$author$project$Portal$Waiting$map,
				button,
				$elm$core$Basics$always(
					A2($author$project$UI$Button$withIcon, $icidasset$elm_material_icons$Material$Icons$sync, button)),
				$author$project$Portal$Share$waitingStatus(share));
		};
		var selectedAttributes = _Utils_eq(
			A2($elm$core$Maybe$map, $author$project$Publications$ClosingCalendar$toComparable, selectedException),
			$elm$core$Maybe$Just(
				$author$project$Publications$ClosingCalendar$toComparable(exception))) ? _List_fromArray(
			[
				$mdgriffith$elm_ui$Element$Background$color(
				$author$project$UI$Element$colorFor($author$project$UI$Palette$error.kV))
			]) : _List_Nil;
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_Utils_ap(
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Element$paddingXY, 2, 10),
						$mdgriffith$elm_ui$Element$Border$widthEach(
						{k5: 1, mE: 0, nx: 0, ol: 0}),
						$mdgriffith$elm_ui$Element$Border$color(
						$author$project$UI$Element$colorFor($author$project$UI$Palette$base0))
					]),
				selectedAttributes),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$px(150))
						]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text(
							$author$project$Date$DeliveryDate$view(exception.a2))
						])),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$px(150))
						]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text(
							$author$project$Publications$ClosingCalendar$scopeView(exception.hj))
						])),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$px(200))
						]),
					_List_fromArray(
						[
							function () {
							var _v0 = exception.u;
							if (!_v0.$) {
								var updatesIn = _v0.a;
								return A2($author$project$Publications$ClosingCalendar$updatesInView, exception.a2, updatesIn);
							} else {
								return $mdgriffith$elm_ui$Element$text('Geen bezorging');
							}
						}()
						])),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$px(300))
						]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text(exception.a9)
						])),
					A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$px(300)),
							$mdgriffith$elm_ui$Element$spacing(10)
						]),
					_List_fromArray(
						[
							$author$project$UI$Button$elementFor(
							withWaiting(
								A2(
									$author$project$UI$Button$withIcon,
									$icidasset$elm_material_icons$Material$Icons$edit,
									A2(
										$author$project$UI$Button$withRole,
										0,
										A2(
											$author$project$UI$Button$button,
											$author$project$Publications$ClosingCalendar$UserClickedEditException(exception),
											'Aanpassen'))))),
							$author$project$UI$Button$elementFor(
							withWaiting(
								A2(
									$author$project$UI$Button$withIcon,
									$icidasset$elm_material_icons$Material$Icons$delete,
									A2(
										$author$project$UI$Button$withRole,
										1,
										A2(
											$author$project$UI$Button$button,
											$author$project$Publications$ClosingCalendar$UserClickedRemoveException(exception),
											'Verwijderen')))))
						]))
				]));
	});
var $author$project$Publications$ClosingCalendar$noYearSelectedView = A2(
	$mdgriffith$elm_ui$Element$el,
	_List_fromArray(
		[
			$mdgriffith$elm_ui$Element$padding(11),
			$mdgriffith$elm_ui$Element$alignTop,
			$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
		]),
	$mdgriffith$elm_ui$Element$text('Selecteer eerst een jaar.'));
var $author$project$Publications$ClosingCalendar$UserClickedYear = function (a) {
	return {$: 1, a: a};
};
var $author$project$Publications$ClosingCalendar$yearCardView = F2(
	function (selected, year) {
		return $author$project$UI$Card$elementFor(
			A2(
				$author$project$UI$Card$selectedIf,
				_Utils_eq(
					selected,
					$author$project$Publications$ClosingCalendar$YearSelected(year)),
				A2(
					$author$project$UI$Card$withContent,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$el,
							_Utils_ap(
								$author$project$UI$Font$heading3,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$padding(1)
									])),
							$mdgriffith$elm_ui$Element$text(
								$elm$core$String$fromInt(year)))
						]),
					$author$project$UI$Card$card(
						$author$project$Publications$ClosingCalendar$UserClickedYear(year)))));
	});
var $author$project$Publications$ClosingCalendar$years = function (currentYear) {
	return _List_fromArray(
		[currentYear - 1, currentYear, currentYear + 1, currentYear + 2]);
};
var $author$project$Publications$ClosingCalendar$yearsView = F3(
	function (currentYear, selected, window) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_Utils_ap(
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$spacing(5),
						$mdgriffith$elm_ui$Element$alignTop,
						$mdgriffith$elm_ui$Element$alignLeft,
						$mdgriffith$elm_ui$Element$height(
						$mdgriffith$elm_ui$Element$px(window.iK)),
						$mdgriffith$elm_ui$Element$width(
						$mdgriffith$elm_ui$Element$px(150)),
						$mdgriffith$elm_ui$Element$paddingEach(
						{k5: 20, mE: 5, nx: 5, ol: 5}),
						$mdgriffith$elm_ui$Element$scrollbarY
					]),
				$author$project$UI$Element$colors(
					{kV: $author$project$UI$Palette$base1, k0: $author$project$UI$Palette$base0, lZ: $author$project$UI$Palette$base03})),
			A2(
				$elm$core$List$map,
				$author$project$Publications$ClosingCalendar$yearCardView(selected),
				$author$project$Publications$ClosingCalendar$years(currentYear)));
	});
var $author$project$Publications$ClosingCalendar$exceptionsView = F3(
	function (share, model, selectedException) {
		return $author$project$UI$Columns$elementFor(
			A2(
				$author$project$UI$Columns$withColumn,
				function () {
					var _v0 = model.nI;
					if (!_v0.$) {
						return $elm$core$Basics$always($author$project$Publications$ClosingCalendar$noYearSelectedView);
					} else {
						return function (window) {
							var heading = function (label) {
								return A2(
									$mdgriffith$elm_ui$Element$el,
									$author$project$UI$Font$heading3,
									$mdgriffith$elm_ui$Element$text(label));
							};
							return A2(
								$mdgriffith$elm_ui$Element$column,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$alignTop,
										$mdgriffith$elm_ui$Element$alignLeft,
										$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
										$mdgriffith$elm_ui$Element$height(
										$mdgriffith$elm_ui$Element$px(window.iK)),
										$author$project$UI$Spacing$default,
										$mdgriffith$elm_ui$Element$scrollbarY
									]),
								_List_fromArray(
									[
										A2(
										$mdgriffith$elm_ui$Element$el,
										$author$project$UI$Font$heading3,
										$mdgriffith$elm_ui$Element$text('Uitzonderingen')),
										A2(
										$mdgriffith$elm_ui$Element$row,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$Border$widthEach(
												{k5: 1, mE: 0, nx: 0, ol: 0}),
												A2($mdgriffith$elm_ui$Element$paddingXY, 2, 10)
											]),
										_List_fromArray(
											[
												A2(
												$mdgriffith$elm_ui$Element$column,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$mdgriffith$elm_ui$Element$el,
														_List_fromArray(
															[
																$mdgriffith$elm_ui$Element$width(
																$mdgriffith$elm_ui$Element$px(150))
															]),
														heading('Datum'))
													])),
												A2(
												$mdgriffith$elm_ui$Element$column,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$mdgriffith$elm_ui$Element$el,
														_List_fromArray(
															[
																$mdgriffith$elm_ui$Element$width(
																$mdgriffith$elm_ui$Element$px(150))
															]),
														heading('Editie'))
													])),
												A2(
												$mdgriffith$elm_ui$Element$column,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$mdgriffith$elm_ui$Element$el,
														_List_fromArray(
															[
																$mdgriffith$elm_ui$Element$width(
																$mdgriffith$elm_ui$Element$px(200))
															]),
														heading('Deadline'))
													])),
												A2(
												$mdgriffith$elm_ui$Element$column,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$mdgriffith$elm_ui$Element$el,
														_List_fromArray(
															[
																$mdgriffith$elm_ui$Element$width(
																$mdgriffith$elm_ui$Element$px(300))
															]),
														heading('Opmerking'))
													])),
												A2(
												$mdgriffith$elm_ui$Element$column,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$mdgriffith$elm_ui$Element$el,
														_List_fromArray(
															[
																$mdgriffith$elm_ui$Element$width(
																$mdgriffith$elm_ui$Element$px(300))
															]),
														heading(''))
													]))
											])),
										A2(
										$mdgriffith$elm_ui$Element$column,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$spacing(4),
												$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
											]),
										A2(
											$elm$core$List$map,
											A2($author$project$Publications$ClosingCalendar$exceptionView, share, selectedException),
											A2($elm$core$List$sortBy, $author$project$Publications$ClosingCalendar$toComparable, model.bM)))
									]));
						};
					}
				}(),
				A2(
					$author$project$UI$Columns$withColumn,
					A2(
						$author$project$Publications$ClosingCalendar$yearsView,
						$justinmimbs$date$Date$year(
							$author$project$Date$DeliveryDate$toDate(
								$author$project$Portal$Share$today(share))),
						model.nI),
					A3(
						$author$project$UI$Columns$withHeader,
						$author$project$UI$Search$height,
						A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[$mdgriffith$elm_ui$Element$alignRight]),
							$author$project$UI$Button$elementFor(
								A2(
									$author$project$UI$Button$withRole,
									0,
									A2($author$project$UI$Button$button, $author$project$Publications$ClosingCalendar$UserClickedAddException, 'Uitzondering toevoegen')))),
						$author$project$UI$Columns$columns(
							$author$project$Portal$Page$contentWindow(share))))));
	});
var $author$project$Publications$ClosingCalendar$UserChangedDay = function (a) {
	return {$: 4, a: a};
};
var $author$project$Publications$ClosingCalendar$UserChangedEdition = function (a) {
	return {$: 8, a: a};
};
var $author$project$Publications$ClosingCalendar$UserChangedScope = function (a) {
	return {$: 7, a: a};
};
var $author$project$Publications$ClosingCalendar$UserClickedCancel = {$: 12};
var $author$project$Publications$ClosingCalendar$UserClickedSaveException = {$: 13};
var $author$project$Publications$ClosingCalendar$UserChangedDaysBefore = function (a) {
	return {$: 6, a: a};
};
var $author$project$Publications$ClosingCalendar$UserChangedDelivery = function (a) {
	return {$: 5, a: a};
};
var $author$project$Publications$ClosingCalendar$UserChangedRun = function (a) {
	return {$: 9, a: a};
};
var $author$project$Publications$ClosingCalendar$UserChangedTime = function (a) {
	return {$: 10, a: a};
};
var $author$project$Publications$ClosingCalendar$deliveryFormView = function (form) {
	var deliveredOption = function () {
		var _v4 = form.u;
		if (!_v4.$) {
			return form.u;
		} else {
			return $author$project$Publications$ClosingCalendar$Delivered(
				{aH: 0, by: $author$project$Publications$ClosingCalendar$Run1});
		}
	}();
	return A2(
		$elm$core$List$cons,
		$author$project$UI$Input$row(
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$Input$radio,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$spacing(10)
						]),
					{
						mD: $author$project$UI$Input$label('Bezorging'),
						mY: $author$project$Publications$ClosingCalendar$UserChangedDelivery,
						m7: _List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$Input$option,
								deliveredOption,
								$mdgriffith$elm_ui$Element$text('Krant wordt bezorgd')),
								A2(
								$mdgriffith$elm_ui$Element$Input$option,
								$author$project$Publications$ClosingCalendar$NotDelivered,
								$mdgriffith$elm_ui$Element$text('Krant wordt niet bezorgd'))
							]),
						nI: $elm$core$Maybe$Just(form.u)
					})
				])),
		function () {
			var _v0 = form.u;
			if (!_v0.$) {
				var run = _v0.a.by;
				var daysBefore = _v0.a.aH;
				var runCustom = function () {
					if (run.$ === 3) {
						var h = run.a;
						var m = run.b;
						return A2($author$project$Publications$ClosingCalendar$RunCustom, h, m);
					} else {
						return A2($author$project$Publications$ClosingCalendar$RunCustom, 0, 0);
					}
				}();
				return _List_fromArray(
					[
						$author$project$UI$Input$row(
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$Input$text,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width(
										$mdgriffith$elm_ui$Element$px(50))
									]),
								{
									mD: $author$project$UI$Input$label('Aantal dagen van te voren aanleveren'),
									mY: $author$project$Publications$ClosingCalendar$UserChangedDaysBefore,
									ng: $elm$core$Maybe$Nothing,
									n3: $elm$core$String$fromInt(daysBefore)
								}),
								function () {
								var _v1 = $author$project$Date$DeliveryDate$fromString(form.a2);
								if (!_v1.$) {
									var day = _v1.a;
									return A2(
										$mdgriffith$elm_ui$Element$el,
										_List_Nil,
										$mdgriffith$elm_ui$Element$text(
											A2($author$project$Publications$ClosingCalendar$updatesInDateView, day, daysBefore)));
								} else {
									return $mdgriffith$elm_ui$Element$none;
								}
							}()
							])),
						$author$project$UI$Input$row(
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$Input$radio,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$spacing(10)
									]),
								{
									mD: $author$project$UI$Input$label('Run'),
									mY: $author$project$Publications$ClosingCalendar$UserChangedRun,
									m7: _List_fromArray(
										[
											A2(
											$mdgriffith$elm_ui$Element$Input$option,
											$author$project$Publications$ClosingCalendar$Run1,
											$mdgriffith$elm_ui$Element$text('Run 1')),
											A2(
											$mdgriffith$elm_ui$Element$Input$option,
											$author$project$Publications$ClosingCalendar$Run2,
											$mdgriffith$elm_ui$Element$text('Run 2')),
											A2(
											$mdgriffith$elm_ui$Element$Input$option,
											$author$project$Publications$ClosingCalendar$Run3,
											$mdgriffith$elm_ui$Element$text('Run 3')),
											A2(
											$mdgriffith$elm_ui$Element$Input$option,
											runCustom,
											$mdgriffith$elm_ui$Element$text('Andere tijd'))
										]),
									nI: $elm$core$Maybe$Just(run)
								})
							])),
						function () {
						if (run.$ === 3) {
							var hours = run.a;
							var minutes = run.b;
							return $author$project$UI$Input$row(
								_List_fromArray(
									[
										A2(
										$author$project$UI$Input$time,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$width(
												$mdgriffith$elm_ui$Element$px(100))
											]),
										{
											mD: $author$project$UI$Input$label('Tijd'),
											mY: $author$project$Publications$ClosingCalendar$UserChangedTime,
											ng: $elm$core$Maybe$Nothing,
											n3: A3(
												$elm$core$String$padLeft,
												2,
												'0',
												$elm$core$String$fromInt(hours)) + (':' + A3(
												$elm$core$String$padLeft,
												2,
												'0',
												$elm$core$String$fromInt(minutes)))
										})
									]));
						} else {
							return $mdgriffith$elm_ui$Element$none;
						}
					}()
					]);
			} else {
				return _List_Nil;
			}
		}());
};
var $author$project$Publications$ClosingCalendar$formErrorView = function (error) {
	return A2(
		$mdgriffith$elm_ui$Element$paragraph,
		_List_Nil,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$text('Een geldige datum voor de uitzonderingsdag is verplicht')
			]));
};
var $author$project$Publications$ClosingCalendar$formErrorsView = function (errors) {
	if (!errors.b) {
		return $mdgriffith$elm_ui$Element$none;
	} else {
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				A2($elm$core$List$map, $author$project$Publications$ClosingCalendar$formErrorView, errors),
				A2($author$project$UI$Container$withVariant, 2, $author$project$UI$Container$container)));
	}
};
var $author$project$Publications$ClosingCalendar$publishingEditions = _List_fromArray(
	['PLV', 'TLV', 'PVK', 'PHP', 'DGDT', 'DGAR', 'DGBT', 'DGLI', 'DGML', 'DGMW', 'DGNY', 'DGRL', 'DGRN', 'DGVA', 'BSBR', 'BSBZ', 'BSEL', 'BSOH', 'BSRD', 'BSZE', 'PZBV', 'PZSV', 'PZWA', 'PZZV', 'STAP', 'STDS', 'STFL', 'STNW', 'STNV', 'STSA', 'STVH', 'STWV', 'STZP', 'STZW', 'PTR', 'ADL', 'ADUA', 'ADDD', 'ADDG', 'ADGA', 'ADGG', 'ADGW', 'ADHS', 'ADHD', 'ADHW', 'ADHZ', 'ADRS', 'ADRO', 'ADRH', 'ADRV', 'ADRW', 'ADUS', 'ADUO', 'ADUZ', 'BDBN', 'BDME', 'BDOE', 'BDTS', 'BDUD', 'BDWL', 'EDHL', 'EDNO', 'EDOO', 'EDWE', 'EDWO', 'EDZD', 'TTAT', 'TTAM', 'TTEN', 'TTHE', 'TTOL', 'TTWT', 'ZVK', 'DMO', 'HLNWL', 'HLNWI', 'HLNLI', 'HLNGW', 'HLNBA', 'HLNLE', 'HLNKP', 'HLNOK', 'HLNME', 'HLNPA', 'HLNOU', 'HLNMS', 'HLNGE', 'HLNAN', 'HLNWR', 'NRC', 'NRA', 'NRR', 'NRL', 'RFD', 'ROT', 'AMS', 'UTR', 'DEH', 'LAN', 'ALP', 'LLD', 'LRV', 'EEM', 'GOO', 'ND', 'KW', 'HFD', 'WDW', 'WDN', 'ZDO', 'FRD', 'ZUI', 'NWC', 'NWA', 'NWL', 'NWR', 'NYT']);
var $author$project$Publications$ClosingCalendar$UserChangedRemark = function (a) {
	return {$: 11, a: a};
};
var $author$project$Publications$ClosingCalendar$remarkFormView = function (form) {
	return _List_fromArray(
		[
			$author$project$UI$Input$row(
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$Input$text,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$px(300))
						]),
					{
						mD: $author$project$UI$Input$label('Opmerking'),
						mY: $author$project$Publications$ClosingCalendar$UserChangedRemark,
						ng: $elm$core$Maybe$Nothing,
						n3: form.a9
					})
				]))
		]);
};
var $author$project$Publications$ClosingCalendar$addFormView = function (form) {
	var editionOption = function () {
		var _v2 = _Utils_Tuple2(
			form.hj,
			$elm$core$List$head($author$project$Publications$ClosingCalendar$publishingEditions));
		if (!_v2.a.$) {
			var e = _v2.a.a;
			return $author$project$Publications$ClosingCalendar$Edition(e);
		} else {
			if (!_v2.b.$) {
				var e = _v2.b.a;
				return $author$project$Publications$ClosingCalendar$Edition(e);
			} else {
				return $author$project$Publications$ClosingCalendar$DutchTitles;
			}
		}
	}();
	return _Utils_ap(
		_List_fromArray(
			[
				$author$project$Publications$ClosingCalendar$formErrorsView(form.f_),
				$author$project$UI$Input$row(
				_List_fromArray(
					[
						A2(
						$author$project$UI$Input$date,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width(
								$mdgriffith$elm_ui$Element$px(180))
							]),
						{
							mD: $author$project$UI$Input$label('Datum bezorging'),
							mY: $author$project$Publications$ClosingCalendar$UserChangedDay,
							ng: $elm$core$Maybe$Nothing,
							n3: form.a2
						}),
						function () {
						var _v0 = $author$project$Date$DeliveryDate$fromString(form.a2);
						if (!_v0.$) {
							var day = _v0.a;
							return $mdgriffith$elm_ui$Element$text(
								$author$project$Date$DeliveryDate$view(day));
						} else {
							return $mdgriffith$elm_ui$Element$none;
						}
					}()
					])),
				$author$project$UI$Input$row(
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$Input$radio,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$spacing(10)
							]),
						{
							mD: $author$project$UI$Input$label('Scope'),
							mY: $author$project$Publications$ClosingCalendar$UserChangedScope,
							m7: _List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$Input$option,
									$author$project$Publications$ClosingCalendar$DutchTitles,
									$mdgriffith$elm_ui$Element$text(
										$author$project$Publications$ClosingCalendar$scopeView($author$project$Publications$ClosingCalendar$DutchTitles))),
									A2(
									$mdgriffith$elm_ui$Element$Input$option,
									$author$project$Publications$ClosingCalendar$BelgianTitles,
									$mdgriffith$elm_ui$Element$text(
										$author$project$Publications$ClosingCalendar$scopeView($author$project$Publications$ClosingCalendar$BelgianTitles))),
									A2(
									$mdgriffith$elm_ui$Element$Input$option,
									editionOption,
									$mdgriffith$elm_ui$Element$text('Editie specifieke uitzondering (overschrijft eventuele algemene uitzondering)'))
								]),
							nI: $elm$core$Maybe$Just(form.hj)
						})
					])),
				function () {
				var _v1 = form.hj;
				if (!_v1.$) {
					var edition = _v1.a;
					return $author$project$UI$Input$row(
						_List_fromArray(
							[
								A5(
								$author$project$UI$Input$selectWithOptions,
								$author$project$Publications$ClosingCalendar$publishingEditions,
								$elm$core$Maybe$Just(edition),
								$author$project$Publications$ClosingCalendar$UserChangedEdition,
								{d$: $elm$json$Json$Decode$succeed, d6: $elm$core$Basics$identity, eG: $elm$core$Basics$identity},
								'Editie')
							]));
				} else {
					return $mdgriffith$elm_ui$Element$none;
				}
			}()
			]),
		_Utils_ap(
			$author$project$Publications$ClosingCalendar$deliveryFormView(form),
			_Utils_ap(
				$author$project$Publications$ClosingCalendar$remarkFormView(form),
				_List_fromArray(
					[
						$author$project$UI$Input$row(
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$column,
								_List_fromArray(
									[$mdgriffith$elm_ui$Element$alignLeft]),
								_List_fromArray(
									[
										$author$project$UI$Button$elementFor(
										A2(
											$author$project$UI$Button$withRole,
											1,
											A2($author$project$UI$Button$button, $author$project$Publications$ClosingCalendar$UserClickedCancel, 'Annuleren')))
									])),
								A2(
								$mdgriffith$elm_ui$Element$column,
								_List_fromArray(
									[$mdgriffith$elm_ui$Element$alignRight]),
								_List_fromArray(
									[
										$author$project$UI$Button$elementFor(
										A2(
											$author$project$UI$Button$withRole,
											0,
											A2($author$project$UI$Button$button, $author$project$Publications$ClosingCalendar$UserClickedSaveException, 'Opslaan')))
									]))
							]))
					]))));
};
var $author$project$Publications$ClosingCalendar$editFormView = F2(
	function (form, exception) {
		return _Utils_ap(
			_List_fromArray(
				[
					$author$project$Publications$ClosingCalendar$formErrorsView(form.f_),
					$author$project$UI$Input$row(
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$column,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$spacing(3),
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
								]),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$el,
									$author$project$UI$Font$label,
									$mdgriffith$elm_ui$Element$text('Datum bezorging')),
									A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Element$paddingXY, 12, 12),
											$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
										]),
									$mdgriffith$elm_ui$Element$text(
										$author$project$Date$DeliveryDate$view(exception.a2)))
								]))
						])),
					$author$project$UI$Input$row(
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$column,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$spacing(3),
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
								]),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$el,
									$author$project$UI$Font$label,
									$mdgriffith$elm_ui$Element$text('Scope')),
									A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Element$paddingXY, 12, 12),
											$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
										]),
									$mdgriffith$elm_ui$Element$text(
										$author$project$Publications$ClosingCalendar$scopeView(exception.hj)))
								]))
						]))
				]),
			_Utils_ap(
				$author$project$Publications$ClosingCalendar$deliveryFormView(form),
				_Utils_ap(
					$author$project$Publications$ClosingCalendar$remarkFormView(form),
					_List_fromArray(
						[
							$author$project$UI$Input$row(
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$column,
									_List_fromArray(
										[$mdgriffith$elm_ui$Element$alignLeft]),
									_List_fromArray(
										[
											$author$project$UI$Button$elementFor(
											A2(
												$author$project$UI$Button$withRole,
												1,
												A2($author$project$UI$Button$button, $author$project$Publications$ClosingCalendar$UserClickedCancel, 'Annuleren')))
										])),
									A2(
									$mdgriffith$elm_ui$Element$column,
									_List_fromArray(
										[$mdgriffith$elm_ui$Element$alignRight]),
									_List_fromArray(
										[
											$author$project$UI$Button$elementFor(
											A2(
												$author$project$UI$Button$withRole,
												0,
												A2($author$project$UI$Button$button, $author$project$Publications$ClosingCalendar$UserClickedSaveException, 'Opslaan')))
										]))
								]))
						]))));
	});
var $author$project$Publications$ClosingCalendar$formView = function (formState) {
	return A2(
		$mdgriffith$elm_ui$Element$el,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$centerX,
				$mdgriffith$elm_ui$Element$padding(3)
			]),
		$author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				function () {
					switch (formState.$) {
						case 2:
							var form = formState.a;
							return $author$project$Publications$ClosingCalendar$addFormView(form);
						case 3:
							var form = formState.a;
							var e = formState.b;
							return A2($author$project$Publications$ClosingCalendar$editFormView, form, e);
						default:
							return _List_Nil;
					}
				}(),
				A2(
					$author$project$UI$Container$withTitle,
					$mdgriffith$elm_ui$Element$text('Uitzondering'),
					$author$project$UI$Container$container))));
};
var $author$project$Publications$ClosingCalendar$UserClickedCancelRemove = {$: 18};
var $author$project$Publications$ClosingCalendar$UserClickedConfirmedRemove = function (a) {
	return {$: 16, a: a};
};
var $author$project$Publications$ClosingCalendar$removeView = function (exception) {
	return A2(
		$mdgriffith$elm_ui$Element$column,
		$author$project$Style$Style$confirmationDialog,
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$paragraph,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$padding(2)
					]),
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$text('Weet je zeker dat je deze uitzondering wilt verwijderen?')
					])),
				A2(
				$mdgriffith$elm_ui$Element$row,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				_List_fromArray(
					[
						$author$project$UI$Button$elementFor(
						A2(
							$author$project$UI$Button$withRole,
							1,
							A2(
								$author$project$UI$Button$button,
								$author$project$Publications$ClosingCalendar$UserClickedConfirmedRemove(exception),
								'Verwijderen'))),
						A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[$mdgriffith$elm_ui$Element$alignRight]),
						$author$project$UI$Button$elementFor(
							A2($author$project$UI$Button$button, $author$project$Publications$ClosingCalendar$UserClickedCancelRemove, 'Annuleren')))
					]))
			]));
};
var $author$project$Publications$ClosingCalendar$view = F2(
	function (share, model) {
		var _v0 = model.P;
		switch (_v0.$) {
			case 0:
				return A3($author$project$Publications$ClosingCalendar$exceptionsView, share, model, $elm$core$Maybe$Nothing);
			case 1:
				var e = _v0.a;
				return A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$inFront(
							$author$project$Publications$ClosingCalendar$removeView(e))
						]),
					A3(
						$author$project$Publications$ClosingCalendar$exceptionsView,
						share,
						model,
						$elm$core$Maybe$Just(e)));
			case 2:
				return $author$project$Publications$ClosingCalendar$formView(model.P);
			default:
				return $author$project$Publications$ClosingCalendar$formView(model.P);
		}
	});
var $author$project$Publications$Publications$noPublicationsView = A2(
	$mdgriffith$elm_ui$Element$el,
	_List_fromArray(
		[
			$mdgriffith$elm_ui$Element$padding(11),
			$mdgriffith$elm_ui$Element$centerX
		]),
	$author$project$UI$Container$elementFor(
		A2(
			$author$project$UI$Container$withTitle,
			A2(
				$mdgriffith$elm_ui$Element$paragraph,
				_List_Nil,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$text('Er zijn geen publicaties beschikbaar.')
					])),
			$author$project$UI$Container$container)));
var $author$project$Publications$Publications$numberView = F2(
	function (color, number) {
		return A2(
			$mdgriffith$elm_ui$Element$el,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$Font$color(
					$author$project$UI$Element$colorFor(color)),
				$author$project$UI$Font$bodyLarge),
			$mdgriffith$elm_ui$Element$text(
				$elm$core$String$fromInt(number)));
	});
var $author$project$Publications$Publications$statisticsView = F2(
	function (title, statistics) {
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$px(125))
						]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text(title)
						])),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$px(100))
						]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text(
							$elm$core$String$fromInt(statistics.jG))
						])),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$px(100))
						]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text(
							$elm$core$String$fromInt(statistics.Y))
						])),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$px(75))
						]),
					_List_fromArray(
						[
							A2($author$project$Publications$Publications$numberView, $author$project$UI$Palette$green, statistics.kb)
						])),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$px(75))
						]),
					_List_fromArray(
						[
							A2($author$project$Publications$Publications$numberView, $author$project$UI$Palette$magenta, statistics.nW)
						])),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$px(75))
						]),
					_List_fromArray(
						[
							A2($author$project$Publications$Publications$numberView, $author$project$UI$Palette$orange, statistics.jk)
						]))
				]));
	});
var $author$project$Publications$Publications$editionsView = function (publication) {
	return A2(
		$elm$core$List$map,
		function (e) {
			return A2(
				$elm$core$Maybe$withDefault,
				$mdgriffith$elm_ui$Element$none,
				A2(
					$elm$core$Maybe$map,
					$author$project$Publications$Publications$statisticsView(e),
					A2($elm$core$Dict$get, e, publication.ke)));
		},
		$elm$core$List$sort(publication.oi.it));
};
var $author$project$Publications$Publications$statisticsHeaderView = A2(
	$mdgriffith$elm_ui$Element$row,
	_List_fromArray(
		[$mdgriffith$elm_ui$Element$Font$semiBold]),
	_List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width(
					$mdgriffith$elm_ui$Element$px(125))
				]),
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$text('Titel')
				])),
			A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width(
					$mdgriffith$elm_ui$Element$px(100))
				]),
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$text('Oplage')
				])),
			A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width(
					$mdgriffith$elm_ui$Element$px(100))
				]),
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$text('Orders')
				])),
			A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width(
					$mdgriffith$elm_ui$Element$px(75))
				]),
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$text('Starts')
				])),
			A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width(
					$mdgriffith$elm_ui$Element$px(75))
				]),
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$text('Stops')
				])),
			A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width(
					$mdgriffith$elm_ui$Element$px(75))
				]),
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$text('Mutaties')
				]))
		]));
var $author$project$Publications$Publications$publicationView = function (selected) {
	if (!selected.$) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width(
					$mdgriffith$elm_ui$Element$fillPortion(3))
				]),
			_List_Nil);
	} else {
		var publication = selected.a;
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withWidth,
				$mdgriffith$elm_ui$Element$fillPortion(3),
				A2(
					$author$project$UI$Container$withContent,
					A2(
						$elm$core$List$cons,
						A2($author$project$Publications$Publications$statisticsView, publication.oi.cU, publication.kd),
						$author$project$Publications$Publications$editionsView(publication)),
					A2(
						$author$project$UI$Container$withTitle,
						A2(
							$mdgriffith$elm_ui$Element$row,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
								]),
							_List_fromArray(
								[$author$project$Publications$Publications$statisticsHeaderView])),
						$author$project$UI$Container$container))));
	}
};
var $author$project$Publications$Publications$UserClickedPublication = function (a) {
	return {$: 1, a: a};
};
var $author$project$Publications$Publications$UserClickedDownload = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $icidasset$elm_material_icons$Material$Icons$check_circle_outline = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0V0zm0 0h24v24H0V0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M16.59 7.58L10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z')
				]),
			_List_Nil)
		]));
var $icidasset$elm_material_icons$Material$Icons$download = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$b('new 0 0 24 24'),
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$rect,
					_List_fromArray(
						[
							$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$icidasset$elm_material_icons$Material$Icons$Internal$p,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M5,20h14v-2H5V20z M19,9h-4V3H9v6H5l7,7L19,9z')
						]),
					_List_Nil)
				]))
		]));
var $author$project$Publications$Publications$fileTypeView = function (fileType) {
	switch (fileType) {
		case 0:
			return 'HF';
		case 1:
			return 'LF';
		case 2:
			return 'AM';
		case 3:
			return 'PPP';
		case 4:
			return 'DI';
		case 5:
			return 'WA';
		case 6:
			return 'BD';
		default:
			return 'Oplage';
	}
};
var $author$project$Publications$Publications$fileView = F2(
	function (publication, file) {
		var icon = function () {
			var _v1 = file.gp;
			if (!_v1.$) {
				return $icidasset$elm_material_icons$Material$Icons$download;
			} else {
				return $icidasset$elm_material_icons$Material$Icons$check_circle_outline;
			}
		}();
		var buttonRole = function () {
			var _v0 = file.c9;
			switch (_v0) {
				case 0:
					return 0;
				case 1:
					return 1;
				case 2:
					return 0;
				case 3:
					return 0;
				case 4:
					return 0;
				case 5:
					return 0;
				case 6:
					return 0;
				default:
					return 0;
			}
		}();
		return $author$project$UI$Button$elementFor(
			A2(
				$author$project$UI$Button$withRole,
				buttonRole,
				A2(
					$author$project$UI$Button$withIcon,
					icon,
					A2(
						$author$project$UI$Button$button,
						A2($author$project$Publications$Publications$UserClickedDownload, publication, file),
						$author$project$Publications$Publications$fileTypeView(file.c9)))));
	});
var $icidasset$elm_material_icons$Material$Icons$lock_clock = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0V0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M14.5 14.2l2.9 1.7-.8 1.3L13 15v-5h1.5v4.2zM22 14c0 4.41-3.59 8-8 8-2.02 0-3.86-.76-5.27-2H4c-1.15 0-2-.85-2-2V9c0-1.12.89-1.96 2-2v-.5C4 4.01 6.01 2 8.5 2c2.34 0 4.24 1.79 4.46 4.08.34-.05.69-.08 1.04-.08 4.41 0 8 3.59 8 8zM6 7h5v-.74C10.88 4.99 9.8 4 8.5 4 7.12 4 6 5.12 6 6.5V7zm14 7c0-3.31-2.69-6-6-6s-6 2.69-6 6 2.69 6 6 6 6-2.69 6-6z')
				]),
			_List_Nil)
		]));
var $author$project$Publications$Publications$publicationStatusView = F2(
	function (tz, publication) {
		var attr = _List_fromArray(
			[
				$mdgriffith$elm_ui$Element$padding(3),
				$mdgriffith$elm_ui$Element$spacing(5),
				$mdgriffith$elm_ui$Element$Border$width(1),
				$mdgriffith$elm_ui$Element$Border$rounded(5)
			]);
		var _v0 = publication.nS;
		switch (_v0) {
			case 0:
				return A2(
					$mdgriffith$elm_ui$Element$row,
					_Utils_ap(
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$Background$color(
								$author$project$UI$Element$colorFor($author$project$UI$Palette$base2)),
								$mdgriffith$elm_ui$Element$Border$color(
								$author$project$UI$Element$colorFor($author$project$UI$Palette$base0))
							]),
						attr),
					_List_fromArray(
						[
							A2(
							$author$project$UI$Element$coloredIconFor,
							$icidasset$elm_material_icons$Material$Icons$lock_clock(20),
							$author$project$UI$Palette$base03),
							A2(
							$mdgriffith$elm_ui$Element$el,
							$author$project$UI$Font$body,
							$mdgriffith$elm_ui$Element$text(
								A2($author$project$UI$DateTime$view, tz, publication.eD)))
						]));
			case 1:
				return A2(
					$mdgriffith$elm_ui$Element$row,
					_Utils_ap(
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$Background$color(
								$author$project$UI$Element$colorFor($author$project$UI$Palette$success.kV)),
								$mdgriffith$elm_ui$Element$Border$color(
								$author$project$UI$Element$colorFor($author$project$UI$Palette$success.k0))
							]),
						attr),
					_List_fromArray(
						[
							A2(
							$author$project$UI$Element$coloredIconFor,
							$icidasset$elm_material_icons$Material$Icons$check_circle(20),
							$author$project$UI$Palette$success.k0),
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_Nil,
							$mdgriffith$elm_ui$Element$text('compleet'))
						]));
			case 2:
				return A2(
					$mdgriffith$elm_ui$Element$row,
					_Utils_ap(
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$Background$color(
								$author$project$UI$Element$colorFor($author$project$UI$Palette$warning.kV)),
								$mdgriffith$elm_ui$Element$Border$color(
								$author$project$UI$Element$colorFor($author$project$UI$Palette$warning.k0))
							]),
						attr),
					_List_fromArray(
						[
							A2(
							$author$project$UI$Element$coloredIconFor,
							$icidasset$elm_material_icons$Material$Icons$error(20),
							$author$project$UI$Palette$warning.k0),
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Font$color(
									$author$project$UI$Element$colorFor($author$project$UI$Palette$warning.lZ))
								]),
							$mdgriffith$elm_ui$Element$text(
								A2($author$project$UI$DateTime$view, tz, publication.eD)))
						]));
			default:
				return A2(
					$mdgriffith$elm_ui$Element$row,
					_Utils_ap(
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$Background$color(
								$author$project$UI$Element$colorFor($author$project$UI$Palette$error.kV)),
								$mdgriffith$elm_ui$Element$Border$color(
								$author$project$UI$Element$colorFor($author$project$UI$Palette$error.k0))
							]),
						attr),
					_List_fromArray(
						[
							A2(
							$author$project$UI$Element$coloredIconFor,
							$icidasset$elm_material_icons$Material$Icons$error(20),
							$author$project$UI$Palette$error.k0),
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Font$color(
									$author$project$UI$Element$colorFor($author$project$UI$Palette$error.lZ))
								]),
							$mdgriffith$elm_ui$Element$text(
								A2($author$project$UI$DateTime$view, tz, publication.eD)))
						]));
		}
	});
var $author$project$Publications$Publications$publicationCardView = F3(
	function (tz, selected, publication) {
		return $author$project$UI$Card$elementFor(
			A2(
				$author$project$UI$Card$selectedIf,
				_Utils_eq(
					$author$project$Publications$Publications$selectedPublication(selected),
					$elm$core$Maybe$Just(publication)),
				A2(
					$author$project$UI$Card$withContent,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$row,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
								]),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$el,
									_Utils_ap(
										$author$project$UI$Font$heading3,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$width(
												$mdgriffith$elm_ui$Element$px(150))
											])),
									$mdgriffith$elm_ui$Element$text(publication.oi.cU)),
									A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$width(
											$mdgriffith$elm_ui$Element$px(200))
										]),
									A2($author$project$Publications$Publications$publicationStatusView, tz, publication)),
									A2(
									$mdgriffith$elm_ui$Element$row,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$alignRight,
											$mdgriffith$elm_ui$Element$spacing(20)
										]),
									A2(
										$elm$core$List$map,
										$author$project$Publications$Publications$fileView(publication),
										publication.fa))
								]))
						]),
					$author$project$UI$Card$card(
						$author$project$Publications$Publications$UserClickedPublication(publication)))));
	});
var $NoRedInk$elm_compare$Compare$by = F3(
	function (fn, a, b) {
		return A2(
			$elm$core$Basics$compare,
			fn(a),
			fn(b));
	});
var $NoRedInk$elm_compare$Compare$concat = F3(
	function (comparators, a, b) {
		concat:
		while (true) {
			if (!comparators.b) {
				return 1;
			} else {
				var comparator = comparators.a;
				var rest = comparators.b;
				var _v1 = A2(comparator, a, b);
				if (_v1 === 1) {
					var $temp$comparators = rest,
						$temp$a = a,
						$temp$b = b;
					comparators = $temp$comparators;
					a = $temp$a;
					b = $temp$b;
					continue concat;
				} else {
					var order = _v1;
					return order;
				}
			}
		}
	});
var $author$project$Publications$Publications$publicationsSort = $NoRedInk$elm_compare$Compare$concat(
	_List_fromArray(
		[
			$NoRedInk$elm_compare$Compare$by(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.eD;
				},
				$elm$time$Time$posixToMillis)),
			$NoRedInk$elm_compare$Compare$by(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.oi;
				},
				function ($) {
					return $.cU;
				}))
		]));
var $author$project$Publications$Publications$publicationsView = F5(
	function (tz, search, selected, publications, window) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_Utils_ap(
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$spacing(5),
						$mdgriffith$elm_ui$Element$alignTop,
						$mdgriffith$elm_ui$Element$alignLeft,
						$mdgriffith$elm_ui$Element$height(
						$mdgriffith$elm_ui$Element$px(window.iK)),
						$mdgriffith$elm_ui$Element$width(
						$mdgriffith$elm_ui$Element$fillPortion(2)),
						$mdgriffith$elm_ui$Element$paddingEach(
						{k5: 20, mE: 5, nx: 5, ol: 5}),
						$mdgriffith$elm_ui$Element$scrollbarY
					]),
				$author$project$UI$Element$colors(
					{kV: $author$project$UI$Palette$base1, k0: $author$project$UI$Palette$base0, lZ: $author$project$UI$Palette$base03})),
			A2(
				$elm$core$List$map,
				A2($author$project$Publications$Publications$publicationCardView, tz, selected),
				A2(
					$elm$core$List$sortWith,
					$author$project$Publications$Publications$publicationsSort,
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.oi;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.cU;
								},
								A2(
									$elm$core$Basics$composeR,
									$elm$core$String$toLower,
									$elm$core$String$startsWith(
										$elm$core$String$toLower(search.dC))))),
						publications))));
	});
var $author$project$Publications$Publications$UserChangedSearch = function (a) {
	return {$: 6, a: a};
};
var $author$project$Publications$Publications$searchView = function (_v0) {
	var startsWith = _v0.dC;
	return $author$project$UI$Search$elementFor(
		A2(
			$author$project$UI$Search$withPlaceholder,
			A2(
				$mdgriffith$elm_ui$Element$Input$placeholder,
				_List_Nil,
				$mdgriffith$elm_ui$Element$text('Titel')),
			A3(
				$author$project$UI$Search$text,
				startsWith,
				$author$project$Publications$Publications$UserChangedSearch,
				$mdgriffith$elm_ui$Element$Input$labelHidden('Zoek op het begin van een titel'))));
};
var $author$project$Publications$Publications$loadedView = F2(
	function (share, loaded) {
		var tz = $author$project$Portal$Share$timeZone(share);
		return $author$project$UI$Columns$elementFor(
			function () {
				var _v0 = loaded.ds;
				if (!_v0.b) {
					return $author$project$UI$Columns$withColumn(
						$elm$core$Basics$always($author$project$Publications$Publications$noPublicationsView));
				} else {
					return A2(
						$elm$core$Basics$composeR,
						$author$project$UI$Columns$withColumn(
							A4($author$project$Publications$Publications$publicationsView, tz, loaded.aj, loaded.nI, loaded.ds)),
						$author$project$UI$Columns$withColumn(
							$elm$core$Basics$always(
								$author$project$Publications$Publications$publicationView(loaded.nI))));
				}
			}()(
				A3(
					$author$project$UI$Columns$withHeader,
					$author$project$UI$Search$height,
					A2(
						$mdgriffith$elm_ui$Element$row,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$author$project$UI$Spacing$large
							]),
						_List_fromArray(
							[
								$author$project$Publications$Publications$searchView(loaded.aj)
							])),
					$author$project$UI$Columns$columns(
						$author$project$Portal$Page$contentWindow(share)))));
	});
var $author$project$Publications$Publications$view = F2(
	function (share, model) {
		if (model.$ === 1) {
			var loaded = model.a;
			return A2($author$project$Publications$Publications$loadedView, share, loaded);
		} else {
			return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$Report$Report$UserChangedExpiresOnDate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Report$Report$UserChangedValidOnDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Report$Report$UserClickedDownloadComplaints = function (a) {
	return {$: 5, a: a};
};
var $author$project$Report$Report$UserClickedDownloadFeedback = function (a) {
	return {$: 6, a: a};
};
var $author$project$Report$Report$UserClickedDownloadSubscription = function (a) {
	return {$: 7, a: a};
};
var $author$project$Report$Report$UserClickedPrepareComplaints = function (a) {
	return {$: 2, a: a};
};
var $author$project$Report$Report$UserClickedPrepareFeedback = function (a) {
	return {$: 3, a: a};
};
var $author$project$Report$Report$UserClickedPrepareSubscriptions = function (a) {
	return {$: 4, a: a};
};
var $author$project$Report$Report$validationErrorView = function (error) {
	switch (error) {
		case 0:
			return $mdgriffith$elm_ui$Element$text('Begin datum is verplicht');
		case 1:
			return $mdgriffith$elm_ui$Element$text('Begin datum moet een geldige datum zijn');
		case 2:
			return $mdgriffith$elm_ui$Element$text('Eind datum is verplicht');
		default:
			return $mdgriffith$elm_ui$Element$text('Eind datum moet een geldige datum zijn');
	}
};
var $author$project$Report$Report$validationErrorsView = function (errors) {
	var _v0 = $elm$core$List$length(errors);
	if (!_v0) {
		return $mdgriffith$elm_ui$Element$none;
	} else {
		return $author$project$UI$Container$elementFor(
			A2(
				$author$project$UI$Container$withContent,
				A2($elm$core$List$map, $author$project$Report$Report$validationErrorView, errors),
				A2($author$project$UI$Container$withVariant, 2, $author$project$UI$Container$container)));
	}
};
var $author$project$Report$Report$formView = F4(
	function (form, complaintReport, feedbackReport, subscriptionsReport) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$centerX,
					$mdgriffith$elm_ui$Element$width(
					$mdgriffith$elm_ui$Element$px(250)),
					$mdgriffith$elm_ui$Element$spacing(10)
				]),
			_List_fromArray(
				[
					$author$project$Report$Report$validationErrorsView(form.f_),
					$author$project$UI$Input$row(
					_List_fromArray(
						[
							A2(
							$author$project$UI$Input$date,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
								]),
							{
								mD: $author$project$UI$Input$label('Vanaf'),
								mY: $author$project$Report$Report$UserChangedValidOnDate,
								ng: $elm$core$Maybe$Nothing,
								n3: form.eE
							})
						])),
					$author$project$UI$Input$row(
					_List_fromArray(
						[
							A2(
							$author$project$UI$Input$date,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
								]),
							{
								mD: $author$project$UI$Input$label('Tot'),
								mY: $author$project$Report$Report$UserChangedExpiresOnDate,
								ng: $elm$core$Maybe$Nothing,
								n3: form.eF
							})
						])),
					A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$spacing(2)
						]),
					_List_fromArray(
						[
							$author$project$UI$Button$elementFor(
							A2(
								$author$project$UI$Button$button,
								$author$project$Report$Report$UserClickedPrepareComplaints(form),
								'Genereer klachten rapportage')),
							function () {
							if (!complaintReport.$) {
								var link = complaintReport.a;
								return $author$project$UI$Button$elementFor(
									A2(
										$author$project$UI$Button$withRole,
										0,
										A2(
											$author$project$UI$Button$button,
											$author$project$Report$Report$UserClickedDownloadComplaints(link),
											'Download')));
							} else {
								return $mdgriffith$elm_ui$Element$none;
							}
						}()
						])),
					A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$spacing(2)
						]),
					_List_fromArray(
						[
							$author$project$UI$Button$elementFor(
							A2(
								$author$project$UI$Button$button,
								$author$project$Report$Report$UserClickedPrepareFeedback(form),
								'Genereer terugkoppeling rapportage')),
							function () {
							if (!feedbackReport.$) {
								var link = feedbackReport.a;
								return $author$project$UI$Button$elementFor(
									A2(
										$author$project$UI$Button$withRole,
										0,
										A2(
											$author$project$UI$Button$button,
											$author$project$Report$Report$UserClickedDownloadFeedback(link),
											'Download')));
							} else {
								return $mdgriffith$elm_ui$Element$none;
							}
						}()
						])),
					A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$spacing(2)
						]),
					_List_fromArray(
						[
							$author$project$UI$Button$elementFor(
							A2(
								$author$project$UI$Button$button,
								$author$project$Report$Report$UserClickedPrepareSubscriptions(form),
								'Genereer abonnementen rapportage')),
							function () {
							if (!subscriptionsReport.$) {
								var link = subscriptionsReport.a;
								return $author$project$UI$Button$elementFor(
									A2(
										$author$project$UI$Button$withRole,
										0,
										A2(
											$author$project$UI$Button$button,
											$author$project$Report$Report$UserClickedDownloadSubscription(link),
											'Download')));
							} else {
								return $mdgriffith$elm_ui$Element$none;
							}
						}()
						]))
				]));
	});
var $author$project$Report$Report$view = F2(
	function (_v0, _v1) {
		var form = _v1.bO;
		var complaintsReport = _v1.dY;
		var feedbackReport = _v1.ea;
		var subscriptionsReport = _v1.ew;
		return A4($author$project$Report$Report$formView, form, complaintsReport, feedbackReport, subscriptionsReport);
	});
var $author$project$Sequence$Edit$NoOp = {$: 0};
var $author$project$Sequence$Edit$SortOnZipCodeHouseNumber = {$: 7};
var $author$project$Sequence$Plan$activeDelivererColors = function (color) {
	return {kV: $author$project$UI$Palette$base2, k0: color, lZ: $author$project$UI$Palette$base01};
};
var $mdgriffith$elm_ui$Element$clipY = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$overflow, $mdgriffith$elm_ui$Internal$Style$classes.li);
var $author$project$Duration$Duration$ofCluster = F2(
	function (distributionPoint, cluster) {
		return $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				$author$project$DistributionPoint$DistributionPoint$durationFor,
				A2($author$project$DistributionPoint$DistributionPoint$findSegmentsOnId, distributionPoint, cluster.bb)));
	});
var $author$project$Duration$Duration$maxFor = F2(
	function (distributionPoint, clusters) {
		return A2(
			$elm$core$Basics$max,
			A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$List$maximum(
					A2(
						$elm$core$List$map,
						$author$project$Duration$Duration$ofCluster(distributionPoint),
						clusters))),
			$author$project$Duration$Duration$availableTime);
	});
var $author$project$Sequence$Edit$sortZipCodeHouseNumberIcon = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$height('16px'),
			$elm$svg$Svg$Attributes$preserveAspectRatio('xMidYMid meet'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$width('16px'),
			$elm$svg$Svg$Attributes$cursor('pointer')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0V0zm0 0h24v24H0V0zm.75.75h22.5v22.5H.75z'),
					$elm$svg$Svg$Attributes$fill('none')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M14.94 4.66h-4.72l2.36-2.36zm-4.69 14.71h4.66l-2.33 2.33z'),
					$elm$svg$Svg$Attributes$fill('none'),
					$elm$svg$Svg$Attributes$fill($author$project$Sequence$Edit$iconColor)
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$text_,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x('12'),
					$elm$svg$Svg$Attributes$y('17.75'),
					$elm$svg$Svg$Attributes$textAnchor('middle'),
					$elm$svg$Svg$Attributes$fontSize('16px'),
					$elm$svg$Svg$Attributes$fill($author$project$Sequence$Edit$iconColor)
				]),
			_List_fromArray(
				[
					$elm$svg$Svg$text('P#')
				]))
		]));
var $author$project$Sequence$Plan$viewSequenceTitle = F3(
	function (typedDeliverer, distributionPoint, clusters) {
		var maxDuration = A2($author$project$Duration$Duration$maxFor, distributionPoint, clusters);
		var deliverer = $author$project$Deliverer$Deliverer$fromTyped(typedDeliverer);
		var clustersWithSegments = A2(
			$elm$core$List$map,
			function (_v1) {
				var number = _v1.bX;
				var segments = _v1.bb;
				return {
					ll: number,
					bb: A2($author$project$DistributionPoint$DistributionPoint$findSegmentsOnId, distributionPoint, segments)
				};
			},
			clusters);
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_Utils_ap(
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$spacing(3),
						$mdgriffith$elm_ui$Element$Border$widthEach(
						{k5: 0, mE: 4, nx: 0, ol: 0}),
						$mdgriffith$elm_ui$Element$padding(1),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				$author$project$UI$Element$colors(
					$author$project$Sequence$Plan$activeDelivererColors(
						$author$project$Deliverer$Deliverer$solidColorOf(typedDeliverer)))),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$fillPortion(4)),
							$mdgriffith$elm_ui$Element$clipY,
							$mdgriffith$elm_ui$Element$paddingEach(
							{k5: 0, mE: 10, nx: 0, ol: 0})
						]),
					$mdgriffith$elm_ui$Element$text(
						$author$project$Deliverer$Deliverer$nameView(deliverer))),
					A2(
					$mdgriffith$elm_ui$Element$map,
					function (_v0) {
						return $author$project$Sequence$Edit$NoOp;
					},
					A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width(
								$mdgriffith$elm_ui$Element$fillPortion(6))
							]),
						$mdgriffith$elm_ui$Element$html(
							A4($author$project$Duration$Duration$view, maxDuration, typedDeliverer, clustersWithSegments, $elm$core$Maybe$Nothing)))),
					A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$alignRight,
							$mdgriffith$elm_ui$Element$centerY,
							$mdgriffith$elm_ui$Element$spacing(3),
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$fillPortion(2))
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$Input$button,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$alignRight,
									$mdgriffith$elm_ui$Element$htmlAttribute(
									$elm$html$Html$Attributes$title('Sorteren op postcode en huisnummer'))
								]),
							{
								mD: A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$paddingEach(
											{k5: 2, mE: 0, nx: 0, ol: 0})
										]),
									$mdgriffith$elm_ui$Element$html($author$project$Sequence$Edit$sortZipCodeHouseNumberIcon)),
								jp: $elm$core$Maybe$Just($author$project$Sequence$Edit$SortOnZipCodeHouseNumber)
							})
						]))
				]));
	});
var $author$project$Sequence$Plan$view = F2(
	function (share, model) {
		var window = $author$project$Sequence$Edit$withoutPadding(
			$author$project$Portal$Page$contentWindow(share));
		var _v0 = _Utils_Tuple3(
			model.bn,
			model.lD,
			_Utils_Tuple2(
				$author$project$Plan$PlanLoader$loadedOf(model.fB),
				model.Y));
		if ((((_v0.a.$ === 1) && (_v0.b.$ === 1)) && (!_v0.c.a.$)) && (_v0.c.b.$ === 1)) {
			var dp = _v0.a.a;
			var _default = _v0.b.a;
			var _v1 = _v0.c;
			var p = _v1.a.a;
			var orders = _v1.b.a;
			var delivererItems = A2($author$project$Plan$Supply$findByDeliverer, _default.j0.lA, p.fA.gL);
			if (delivererItems.b) {
				var head = delivererItems.a;
				var _v3 = $author$project$Plan$Supply$delivererOf(head);
				if (!_v3.$) {
					var deliverer = _v3.a;
					var sequenceTitle = A3(
						$author$project$Sequence$Plan$viewSequenceTitle,
						deliverer,
						dp,
						A2($elm$core$List$concatMap, $author$project$Plan$Supply$ownClustersOf, delivererItems));
					return A2(
						$mdgriffith$elm_ui$Element$map,
						$author$project$Sequence$Plan$SystemGotEditMsg,
						A3(
							$author$project$Sequence$Edit$view,
							window,
							sequenceTitle,
							A5(
								$author$project$Sequence$Edit$addMapToDefault,
								_default,
								dp,
								p.fA.gL,
								orders,
								$author$project$DistributionPoint$DistributionPoint$segmentsOf(dp))));
				} else {
					return $mdgriffith$elm_ui$Element$text('Kan geen loopvolgorde tonen zonder cluster of bezorger.');
				}
			} else {
				return $mdgriffith$elm_ui$Element$text('Kan geen loopvolgorde tonen zonder cluster of bezorger.');
			}
		} else {
			return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$Main$initializedView = function (model) {
	var frame = $author$project$Main$frameFor(model);
	var body = A2(
		$mdgriffith$elm_ui$Element$layout,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
				$author$project$UI$Element$avoidPrintInterference
			]),
		function () {
			var _v0 = model.cv;
			switch (_v0.$) {
				case 0:
					return A2(
						frame,
						$author$project$Main$GotDashboardMsg,
						{d: $mdgriffith$elm_ui$Element$none, e: $author$project$Portal$Subheader$empty});
				case 11:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotDashboardMsg,
						{
							d: A2($author$project$Dashboard$Dashboard$view, model.fQ, pageModel),
							e: A2($author$project$Dashboard$Dashboard$menu, model.fQ, pageModel)
						});
				case 12:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotPublicationsMsg,
						{
							d: A2($author$project$Publications$Publications$view, model.fQ, pageModel),
							e: $author$project$Publications$Publications$menu(pageModel)
						});
				case 1:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotCreatePlanMsg,
						{
							d: A2($author$project$Plan$CreatePlan$view, model.fQ, pageModel),
							e: $author$project$Plan$CreatePlan$menu(pageModel)
						});
				case 2:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotDayPlanningMsg,
						{
							d: A2($author$project$Plan$DayPlanning$view, model.fQ, pageModel),
							e: A2($author$project$Plan$DayPlanning$menu, model.fQ, pageModel)
						});
				case 3:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotPlanNotFinalizedMsg,
						{
							d: $author$project$Plan$NotFinalized$view(pageModel),
							e: $author$project$Plan$NotFinalized$menu(pageModel)
						});
				case 4:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotDistributionListMsg,
						{
							d: $author$project$Lists$Distribution$DistributionList$view(pageModel),
							e: $author$project$Lists$Distribution$DistributionList$menu(pageModel)
						});
				case 5:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotDistributionListMsg,
						{
							d: $author$project$Lists$Distribution$DistributionList$alternateView(pageModel),
							e: $author$project$Lists$Distribution$DistributionList$menu(pageModel)
						});
				case 6:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotPreSupplyListMsg,
						{
							d: $author$project$Lists$Distribution$PreSupplyList$view(pageModel),
							e: $author$project$Lists$Distribution$PreSupplyList$menu(pageModel)
						});
				case 7:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotCountMsg,
						{
							d: $author$project$Count$Count$listView(pageModel),
							e: $author$project$Count$Count$hubPackListMenu(pageModel)
						});
				case 8:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotReceivedCheckListMsg,
						{
							d: $author$project$Lists$Received$CheckList$view(pageModel),
							e: $author$project$Lists$Received$CheckList$menu(pageModel)
						});
				case 9:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotRouteDetailMsg,
						{
							d: $author$project$Lists$RouteDetail$RouteDetail$view(pageModel),
							e: $author$project$Lists$RouteDetail$RouteDetail$menu(pageModel)
						});
				case 10:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotSequenceMsg,
						{
							d: A2($author$project$Sequence$Plan$view, model.fQ, pageModel),
							e: $author$project$Sequence$Plan$menu(pageModel)
						});
				case 30:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotCreateDelivererMsg,
						{
							d: A2($author$project$Deliverer$Create$view, model.fQ, pageModel),
							e: $author$project$Deliverer$Create$menu(pageModel)
						});
				case 31:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotEditDelivererMsg,
						{
							d: A2($author$project$Deliverer$Edit$view, model.fQ, pageModel),
							e: A2($author$project$Deliverer$Edit$menu, model.fQ, pageModel)
						});
				case 13:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotCountMsg,
						{
							d: $author$project$Count$Count$view(pageModel),
							e: $author$project$Count$Count$countMenu(pageModel)
						});
				case 14:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotDelayMsg,
						{
							d: A2($author$project$Delay$Delay$view, model.fQ, pageModel),
							e: $author$project$Delay$Delay$menu(pageModel)
						});
				case 15:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotDelivererRouteDetailMsg,
						{
							d: A2($author$project$Lists$RouteDetail$Deliverer$view, model.fQ, pageModel),
							e: $author$project$Lists$RouteDetail$Deliverer$menu(pageModel)
						});
				case 26:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotDocumentsMsg,
						{
							d: $author$project$Documents$Documents$view(pageModel),
							e: $author$project$Documents$Documents$menu(pageModel)
						});
				case 27:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotAccountsMsg,
						{
							d: A2($author$project$Accounts$Overview$view, model.fQ, pageModel),
							e: $author$project$Accounts$Overview$menu(pageModel)
						});
				case 29:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotAccountAddMsg,
						{
							d: $author$project$Accounts$Add$view(pageModel),
							e: $author$project$Accounts$Add$menu
						});
				case 28:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotAccountEditMsg,
						{
							d: A2($author$project$Accounts$Edit$view, model.fQ, pageModel),
							e: $author$project$Accounts$Edit$menu(pageModel)
						});
				case 16:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotMessageMsg,
						{
							d: A2($author$project$Message$Message$view, model.fQ, pageModel),
							e: A2($author$project$Message$Message$menu, model.fQ, pageModel)
						});
				case 17:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotCompensationOverviewMsg,
						{
							d: A2($author$project$Compensation$Overview$view, model.fQ, pageModel),
							e: A2($author$project$Compensation$Overview$menu, model.fQ, pageModel)
						});
				case 18:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotCreateCompensationMsg,
						{
							d: A2($author$project$Compensation$Add$view, model.fQ, pageModel),
							e: A2($author$project$Compensation$Add$menu, model.fQ, pageModel)
						});
				case 19:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotEditCompensationMsg,
						{
							d: A2($author$project$Compensation$Edit$view, model.fQ, pageModel),
							e: A2($author$project$Compensation$Edit$menu, model.fQ, pageModel)
						});
				case 20:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotApproveCompensationMsg,
						{
							d: A2($author$project$Compensation$Approve$view, model.fQ, pageModel),
							e: A2($author$project$Compensation$Approve$menu, model.fQ, pageModel)
						});
				case 21:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotPaymentDelivererOverviewMsg,
						{
							d: A2($author$project$Payment$DelivererOverview$view, model.fQ, pageModel),
							e: A2($author$project$Payment$DelivererOverview$menu, model.fQ, pageModel)
						});
				case 22:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotPaymentDistributionPointOverviewMsg,
						{
							d: A2($author$project$Payment$DistributionPointOverview$view, model.fQ, pageModel),
							e: A2($author$project$Payment$DistributionPointOverview$menu, model.fQ, pageModel)
						});
				case 23:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotPaymentDetailMsg,
						{
							d: A2($author$project$Payment$Detail$view, model.fQ, pageModel),
							e: A2($author$project$Payment$Detail$menu, model.fQ, pageModel)
						});
				case 24:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotAnnualPaymentDetailMsg,
						{
							d: A2($author$project$Payment$AnnualDetail$view, model.fQ, pageModel),
							e: A2($author$project$Payment$AnnualDetail$menu, model.fQ, pageModel)
						});
				case 25:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotPaymentArchiveMsg,
						{
							d: A2($author$project$Payment$Archive$view, model.fQ, pageModel),
							e: A2($author$project$Payment$Archive$menu, model.fQ, pageModel)
						});
				case 32:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotApplicantsMsg,
						{
							d: A2($author$project$Applicant$Overview$view, model.fQ, pageModel),
							e: A2($author$project$Applicant$Overview$menu, model.fQ, pageModel)
						});
				case 33:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotComplaintHandleMsg,
						{
							d: $author$project$Complaint$Handle$view(pageModel),
							e: $author$project$Complaint$Handle$menu(pageModel)
						});
				case 34:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotComplaintFeedbackMsg,
						{
							d: A2($author$project$Complaint$Feedback$view, model.fQ, pageModel),
							e: $author$project$Complaint$Feedback$menu(pageModel)
						});
				case 35:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotReportMsg,
						{
							d: A2($author$project$Report$Report$view, model.fQ, pageModel),
							e: $author$project$Report$Report$menu(pageModel)
						});
				case 36:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotClosingCalendarMsg,
						{
							d: A2($author$project$Publications$ClosingCalendar$view, model.fQ, pageModel),
							e: $author$project$Publications$ClosingCalendar$menu(pageModel)
						});
				default:
					var pageModel = _v0.a;
					return A2(
						frame,
						$author$project$Main$GotDistributorValidateMsg,
						{
							d: A2($author$project$Distributor$Validate$view, model.fQ, pageModel),
							e: $author$project$Distributor$Validate$menu
						});
			}
		}());
	return {
		aA: _List_fromArray(
			[body]),
		oi: 'Distributie Portaal'
	};
};
var $author$project$Main$view = function (model) {
	if (!model.$) {
		var security = model.a.et;
		return {
			aA: _List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$layout,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$padding(20),
							$author$project$UI$Element$avoidPrintInterference
						]),
					function () {
						if (security.$ === 5) {
							var message = security.a;
							return A2(
								$mdgriffith$elm_ui$Element$column,
								_List_Nil,
								A2(
									$author$project$Portal$Message$view,
									$author$project$Main$UserClosedMessage,
									_List_fromArray(
										[message])));
						} else {
							return $mdgriffith$elm_ui$Element$none;
						}
					}())
				]),
			oi: 'Distributie Portaal'
		};
	} else {
		var initializedModel = model.a;
		return $author$project$Main$initializedView(initializedModel);
	}
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{mm: $author$project$Main$init, m3: $author$project$Main$UrlChanged, m4: $author$project$Main$UserClickedLink, nZ: $author$project$Main$subscriptions, or: $author$project$Main$update, eG: $author$project$Main$view});
_Platform_export({'Main':{'init':$author$project$Main$main($elm$json$Json$Decode$value)(0)}});}(this));